/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ServerHeartBeatReq = $root.ServerHeartBeatReq = (() => {

    /**
     * Properties of a ServerHeartBeatReq.
     * @exports IServerHeartBeatReq
     * @interface IServerHeartBeatReq
     * @property {number|null} [Data] ServerHeartBeatReq Data
     */

    /**
     * Constructs a new ServerHeartBeatReq.
     * @exports ServerHeartBeatReq
     * @classdesc Represents a ServerHeartBeatReq.
     * @implements IServerHeartBeatReq
     * @constructor
     * @param {IServerHeartBeatReq=} [properties] Properties to set
     */
    function ServerHeartBeatReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ServerHeartBeatReq Data.
     * @member {number} Data
     * @memberof ServerHeartBeatReq
     * @instance
     */
    ServerHeartBeatReq.prototype.Data = 0;

    /**
     * Creates a new ServerHeartBeatReq instance using the specified properties.
     * @function create
     * @memberof ServerHeartBeatReq
     * @static
     * @param {IServerHeartBeatReq=} [properties] Properties to set
     * @returns {ServerHeartBeatReq} ServerHeartBeatReq instance
     */
    ServerHeartBeatReq.create = function create(properties) {
        return new ServerHeartBeatReq(properties);
    };

    /**
     * Encodes the specified ServerHeartBeatReq message. Does not implicitly {@link ServerHeartBeatReq.verify|verify} messages.
     * @function encode
     * @memberof ServerHeartBeatReq
     * @static
     * @param {IServerHeartBeatReq} message ServerHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ServerHeartBeatReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Data);
        return writer;
    };

    /**
     * Encodes the specified ServerHeartBeatReq message, length delimited. Does not implicitly {@link ServerHeartBeatReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ServerHeartBeatReq
     * @static
     * @param {IServerHeartBeatReq} message ServerHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ServerHeartBeatReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ServerHeartBeatReq message from the specified reader or buffer.
     * @function decode
     * @memberof ServerHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ServerHeartBeatReq} ServerHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ServerHeartBeatReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServerHeartBeatReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Data = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ServerHeartBeatReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ServerHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ServerHeartBeatReq} ServerHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ServerHeartBeatReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ServerHeartBeatReq message.
     * @function verify
     * @memberof ServerHeartBeatReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ServerHeartBeatReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Data != null && message.hasOwnProperty("Data"))
            if (!$util.isInteger(message.Data))
                return "Data: integer expected";
        return null;
    };

    /**
     * Creates a ServerHeartBeatReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ServerHeartBeatReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ServerHeartBeatReq} ServerHeartBeatReq
     */
    ServerHeartBeatReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ServerHeartBeatReq)
            return object;
        let message = new $root.ServerHeartBeatReq();
        if (object.Data != null)
            message.Data = object.Data >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ServerHeartBeatReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ServerHeartBeatReq
     * @static
     * @param {ServerHeartBeatReq} message ServerHeartBeatReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ServerHeartBeatReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.Data = 0;
        if (message.Data != null && message.hasOwnProperty("Data"))
            object.Data = message.Data;
        return object;
    };

    /**
     * Converts this ServerHeartBeatReq to JSON.
     * @function toJSON
     * @memberof ServerHeartBeatReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ServerHeartBeatReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ServerHeartBeatReq
     * @function getTypeUrl
     * @memberof ServerHeartBeatReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ServerHeartBeatReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ServerHeartBeatReq";
    };

    return ServerHeartBeatReq;
})();

export const ServerHeartBeatAck = $root.ServerHeartBeatAck = (() => {

    /**
     * Properties of a ServerHeartBeatAck.
     * @exports IServerHeartBeatAck
     * @interface IServerHeartBeatAck
     * @property {number|null} [RetCode] ServerHeartBeatAck RetCode
     */

    /**
     * Constructs a new ServerHeartBeatAck.
     * @exports ServerHeartBeatAck
     * @classdesc Represents a ServerHeartBeatAck.
     * @implements IServerHeartBeatAck
     * @constructor
     * @param {IServerHeartBeatAck=} [properties] Properties to set
     */
    function ServerHeartBeatAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ServerHeartBeatAck RetCode.
     * @member {number} RetCode
     * @memberof ServerHeartBeatAck
     * @instance
     */
    ServerHeartBeatAck.prototype.RetCode = 0;

    /**
     * Creates a new ServerHeartBeatAck instance using the specified properties.
     * @function create
     * @memberof ServerHeartBeatAck
     * @static
     * @param {IServerHeartBeatAck=} [properties] Properties to set
     * @returns {ServerHeartBeatAck} ServerHeartBeatAck instance
     */
    ServerHeartBeatAck.create = function create(properties) {
        return new ServerHeartBeatAck(properties);
    };

    /**
     * Encodes the specified ServerHeartBeatAck message. Does not implicitly {@link ServerHeartBeatAck.verify|verify} messages.
     * @function encode
     * @memberof ServerHeartBeatAck
     * @static
     * @param {IServerHeartBeatAck} message ServerHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ServerHeartBeatAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RetCode != null && Object.hasOwnProperty.call(message, "RetCode"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RetCode);
        return writer;
    };

    /**
     * Encodes the specified ServerHeartBeatAck message, length delimited. Does not implicitly {@link ServerHeartBeatAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ServerHeartBeatAck
     * @static
     * @param {IServerHeartBeatAck} message ServerHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ServerHeartBeatAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ServerHeartBeatAck message from the specified reader or buffer.
     * @function decode
     * @memberof ServerHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ServerHeartBeatAck} ServerHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ServerHeartBeatAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServerHeartBeatAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RetCode = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ServerHeartBeatAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ServerHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ServerHeartBeatAck} ServerHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ServerHeartBeatAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ServerHeartBeatAck message.
     * @function verify
     * @memberof ServerHeartBeatAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ServerHeartBeatAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            if (!$util.isInteger(message.RetCode))
                return "RetCode: integer expected";
        return null;
    };

    /**
     * Creates a ServerHeartBeatAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ServerHeartBeatAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ServerHeartBeatAck} ServerHeartBeatAck
     */
    ServerHeartBeatAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ServerHeartBeatAck)
            return object;
        let message = new $root.ServerHeartBeatAck();
        if (object.RetCode != null)
            message.RetCode = object.RetCode >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ServerHeartBeatAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ServerHeartBeatAck
     * @static
     * @param {ServerHeartBeatAck} message ServerHeartBeatAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ServerHeartBeatAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.RetCode = 0;
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            object.RetCode = message.RetCode;
        return object;
    };

    /**
     * Converts this ServerHeartBeatAck to JSON.
     * @function toJSON
     * @memberof ServerHeartBeatAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ServerHeartBeatAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ServerHeartBeatAck
     * @function getTypeUrl
     * @memberof ServerHeartBeatAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ServerHeartBeatAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ServerHeartBeatAck";
    };

    return ServerHeartBeatAck;
})();

export const WatchHeartBeatReq = $root.WatchHeartBeatReq = (() => {

    /**
     * Properties of a WatchHeartBeatReq.
     * @exports IWatchHeartBeatReq
     * @interface IWatchHeartBeatReq
     * @property {number|null} [Data] WatchHeartBeatReq Data
     * @property {number|Long|null} [ProcessID] WatchHeartBeatReq ProcessID
     */

    /**
     * Constructs a new WatchHeartBeatReq.
     * @exports WatchHeartBeatReq
     * @classdesc Represents a WatchHeartBeatReq.
     * @implements IWatchHeartBeatReq
     * @constructor
     * @param {IWatchHeartBeatReq=} [properties] Properties to set
     */
    function WatchHeartBeatReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WatchHeartBeatReq Data.
     * @member {number} Data
     * @memberof WatchHeartBeatReq
     * @instance
     */
    WatchHeartBeatReq.prototype.Data = 0;

    /**
     * WatchHeartBeatReq ProcessID.
     * @member {number|Long} ProcessID
     * @memberof WatchHeartBeatReq
     * @instance
     */
    WatchHeartBeatReq.prototype.ProcessID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new WatchHeartBeatReq instance using the specified properties.
     * @function create
     * @memberof WatchHeartBeatReq
     * @static
     * @param {IWatchHeartBeatReq=} [properties] Properties to set
     * @returns {WatchHeartBeatReq} WatchHeartBeatReq instance
     */
    WatchHeartBeatReq.create = function create(properties) {
        return new WatchHeartBeatReq(properties);
    };

    /**
     * Encodes the specified WatchHeartBeatReq message. Does not implicitly {@link WatchHeartBeatReq.verify|verify} messages.
     * @function encode
     * @memberof WatchHeartBeatReq
     * @static
     * @param {IWatchHeartBeatReq} message WatchHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchHeartBeatReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Data);
        if (message.ProcessID != null && Object.hasOwnProperty.call(message, "ProcessID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.ProcessID);
        return writer;
    };

    /**
     * Encodes the specified WatchHeartBeatReq message, length delimited. Does not implicitly {@link WatchHeartBeatReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WatchHeartBeatReq
     * @static
     * @param {IWatchHeartBeatReq} message WatchHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchHeartBeatReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WatchHeartBeatReq message from the specified reader or buffer.
     * @function decode
     * @memberof WatchHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WatchHeartBeatReq} WatchHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchHeartBeatReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WatchHeartBeatReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Data = reader.uint32();
                    break;
                }
            case 2: {
                    message.ProcessID = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WatchHeartBeatReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WatchHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WatchHeartBeatReq} WatchHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchHeartBeatReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WatchHeartBeatReq message.
     * @function verify
     * @memberof WatchHeartBeatReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WatchHeartBeatReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Data != null && message.hasOwnProperty("Data"))
            if (!$util.isInteger(message.Data))
                return "Data: integer expected";
        if (message.ProcessID != null && message.hasOwnProperty("ProcessID"))
            if (!$util.isInteger(message.ProcessID) && !(message.ProcessID && $util.isInteger(message.ProcessID.low) && $util.isInteger(message.ProcessID.high)))
                return "ProcessID: integer|Long expected";
        return null;
    };

    /**
     * Creates a WatchHeartBeatReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WatchHeartBeatReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WatchHeartBeatReq} WatchHeartBeatReq
     */
    WatchHeartBeatReq.fromObject = function fromObject(object) {
        if (object instanceof $root.WatchHeartBeatReq)
            return object;
        let message = new $root.WatchHeartBeatReq();
        if (object.Data != null)
            message.Data = object.Data >>> 0;
        if (object.ProcessID != null)
            if ($util.Long)
                (message.ProcessID = $util.Long.fromValue(object.ProcessID)).unsigned = true;
            else if (typeof object.ProcessID === "string")
                message.ProcessID = parseInt(object.ProcessID, 10);
            else if (typeof object.ProcessID === "number")
                message.ProcessID = object.ProcessID;
            else if (typeof object.ProcessID === "object")
                message.ProcessID = new $util.LongBits(object.ProcessID.low >>> 0, object.ProcessID.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a WatchHeartBeatReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WatchHeartBeatReq
     * @static
     * @param {WatchHeartBeatReq} message WatchHeartBeatReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WatchHeartBeatReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Data = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ProcessID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ProcessID = options.longs === String ? "0" : 0;
        }
        if (message.Data != null && message.hasOwnProperty("Data"))
            object.Data = message.Data;
        if (message.ProcessID != null && message.hasOwnProperty("ProcessID"))
            if (typeof message.ProcessID === "number")
                object.ProcessID = options.longs === String ? String(message.ProcessID) : message.ProcessID;
            else
                object.ProcessID = options.longs === String ? $util.Long.prototype.toString.call(message.ProcessID) : options.longs === Number ? new $util.LongBits(message.ProcessID.low >>> 0, message.ProcessID.high >>> 0).toNumber(true) : message.ProcessID;
        return object;
    };

    /**
     * Converts this WatchHeartBeatReq to JSON.
     * @function toJSON
     * @memberof WatchHeartBeatReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WatchHeartBeatReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WatchHeartBeatReq
     * @function getTypeUrl
     * @memberof WatchHeartBeatReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WatchHeartBeatReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WatchHeartBeatReq";
    };

    return WatchHeartBeatReq;
})();

export const WatchHeartBeatAck = $root.WatchHeartBeatAck = (() => {

    /**
     * Properties of a WatchHeartBeatAck.
     * @exports IWatchHeartBeatAck
     * @interface IWatchHeartBeatAck
     * @property {number|null} [RetCode] WatchHeartBeatAck RetCode
     * @property {number|null} [Data] WatchHeartBeatAck Data
     * @property {number|Long|null} [ProcessID] WatchHeartBeatAck ProcessID
     */

    /**
     * Constructs a new WatchHeartBeatAck.
     * @exports WatchHeartBeatAck
     * @classdesc Represents a WatchHeartBeatAck.
     * @implements IWatchHeartBeatAck
     * @constructor
     * @param {IWatchHeartBeatAck=} [properties] Properties to set
     */
    function WatchHeartBeatAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WatchHeartBeatAck RetCode.
     * @member {number} RetCode
     * @memberof WatchHeartBeatAck
     * @instance
     */
    WatchHeartBeatAck.prototype.RetCode = 0;

    /**
     * WatchHeartBeatAck Data.
     * @member {number} Data
     * @memberof WatchHeartBeatAck
     * @instance
     */
    WatchHeartBeatAck.prototype.Data = 0;

    /**
     * WatchHeartBeatAck ProcessID.
     * @member {number|Long} ProcessID
     * @memberof WatchHeartBeatAck
     * @instance
     */
    WatchHeartBeatAck.prototype.ProcessID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new WatchHeartBeatAck instance using the specified properties.
     * @function create
     * @memberof WatchHeartBeatAck
     * @static
     * @param {IWatchHeartBeatAck=} [properties] Properties to set
     * @returns {WatchHeartBeatAck} WatchHeartBeatAck instance
     */
    WatchHeartBeatAck.create = function create(properties) {
        return new WatchHeartBeatAck(properties);
    };

    /**
     * Encodes the specified WatchHeartBeatAck message. Does not implicitly {@link WatchHeartBeatAck.verify|verify} messages.
     * @function encode
     * @memberof WatchHeartBeatAck
     * @static
     * @param {IWatchHeartBeatAck} message WatchHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchHeartBeatAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RetCode != null && Object.hasOwnProperty.call(message, "RetCode"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RetCode);
        if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Data);
        if (message.ProcessID != null && Object.hasOwnProperty.call(message, "ProcessID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.ProcessID);
        return writer;
    };

    /**
     * Encodes the specified WatchHeartBeatAck message, length delimited. Does not implicitly {@link WatchHeartBeatAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WatchHeartBeatAck
     * @static
     * @param {IWatchHeartBeatAck} message WatchHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchHeartBeatAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WatchHeartBeatAck message from the specified reader or buffer.
     * @function decode
     * @memberof WatchHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WatchHeartBeatAck} WatchHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchHeartBeatAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WatchHeartBeatAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RetCode = reader.uint32();
                    break;
                }
            case 2: {
                    message.Data = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProcessID = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WatchHeartBeatAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WatchHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WatchHeartBeatAck} WatchHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchHeartBeatAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WatchHeartBeatAck message.
     * @function verify
     * @memberof WatchHeartBeatAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WatchHeartBeatAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            if (!$util.isInteger(message.RetCode))
                return "RetCode: integer expected";
        if (message.Data != null && message.hasOwnProperty("Data"))
            if (!$util.isInteger(message.Data))
                return "Data: integer expected";
        if (message.ProcessID != null && message.hasOwnProperty("ProcessID"))
            if (!$util.isInteger(message.ProcessID) && !(message.ProcessID && $util.isInteger(message.ProcessID.low) && $util.isInteger(message.ProcessID.high)))
                return "ProcessID: integer|Long expected";
        return null;
    };

    /**
     * Creates a WatchHeartBeatAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WatchHeartBeatAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WatchHeartBeatAck} WatchHeartBeatAck
     */
    WatchHeartBeatAck.fromObject = function fromObject(object) {
        if (object instanceof $root.WatchHeartBeatAck)
            return object;
        let message = new $root.WatchHeartBeatAck();
        if (object.RetCode != null)
            message.RetCode = object.RetCode >>> 0;
        if (object.Data != null)
            message.Data = object.Data >>> 0;
        if (object.ProcessID != null)
            if ($util.Long)
                (message.ProcessID = $util.Long.fromValue(object.ProcessID)).unsigned = true;
            else if (typeof object.ProcessID === "string")
                message.ProcessID = parseInt(object.ProcessID, 10);
            else if (typeof object.ProcessID === "number")
                message.ProcessID = object.ProcessID;
            else if (typeof object.ProcessID === "object")
                message.ProcessID = new $util.LongBits(object.ProcessID.low >>> 0, object.ProcessID.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a WatchHeartBeatAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WatchHeartBeatAck
     * @static
     * @param {WatchHeartBeatAck} message WatchHeartBeatAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WatchHeartBeatAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.RetCode = 0;
            object.Data = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ProcessID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ProcessID = options.longs === String ? "0" : 0;
        }
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            object.RetCode = message.RetCode;
        if (message.Data != null && message.hasOwnProperty("Data"))
            object.Data = message.Data;
        if (message.ProcessID != null && message.hasOwnProperty("ProcessID"))
            if (typeof message.ProcessID === "number")
                object.ProcessID = options.longs === String ? String(message.ProcessID) : message.ProcessID;
            else
                object.ProcessID = options.longs === String ? $util.Long.prototype.toString.call(message.ProcessID) : options.longs === Number ? new $util.LongBits(message.ProcessID.low >>> 0, message.ProcessID.high >>> 0).toNumber(true) : message.ProcessID;
        return object;
    };

    /**
     * Converts this WatchHeartBeatAck to JSON.
     * @function toJSON
     * @memberof WatchHeartBeatAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WatchHeartBeatAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WatchHeartBeatAck
     * @function getTypeUrl
     * @memberof WatchHeartBeatAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WatchHeartBeatAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WatchHeartBeatAck";
    };

    return WatchHeartBeatAck;
})();

export const Client2SrvHeartBeatReq = $root.Client2SrvHeartBeatReq = (() => {

    /**
     * Properties of a Client2SrvHeartBeatReq.
     * @exports IClient2SrvHeartBeatReq
     * @interface IClient2SrvHeartBeatReq
     * @property {number|null} [UserID] Client2SrvHeartBeatReq UserID
     */

    /**
     * Constructs a new Client2SrvHeartBeatReq.
     * @exports Client2SrvHeartBeatReq
     * @classdesc Represents a Client2SrvHeartBeatReq.
     * @implements IClient2SrvHeartBeatReq
     * @constructor
     * @param {IClient2SrvHeartBeatReq=} [properties] Properties to set
     */
    function Client2SrvHeartBeatReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2SrvHeartBeatReq UserID.
     * @member {number} UserID
     * @memberof Client2SrvHeartBeatReq
     * @instance
     */
    Client2SrvHeartBeatReq.prototype.UserID = 0;

    /**
     * Creates a new Client2SrvHeartBeatReq instance using the specified properties.
     * @function create
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {IClient2SrvHeartBeatReq=} [properties] Properties to set
     * @returns {Client2SrvHeartBeatReq} Client2SrvHeartBeatReq instance
     */
    Client2SrvHeartBeatReq.create = function create(properties) {
        return new Client2SrvHeartBeatReq(properties);
    };

    /**
     * Encodes the specified Client2SrvHeartBeatReq message. Does not implicitly {@link Client2SrvHeartBeatReq.verify|verify} messages.
     * @function encode
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {IClient2SrvHeartBeatReq} message Client2SrvHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2SrvHeartBeatReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2SrvHeartBeatReq message, length delimited. Does not implicitly {@link Client2SrvHeartBeatReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {IClient2SrvHeartBeatReq} message Client2SrvHeartBeatReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2SrvHeartBeatReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2SrvHeartBeatReq message from the specified reader or buffer.
     * @function decode
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2SrvHeartBeatReq} Client2SrvHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2SrvHeartBeatReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2SrvHeartBeatReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2SrvHeartBeatReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2SrvHeartBeatReq} Client2SrvHeartBeatReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2SrvHeartBeatReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2SrvHeartBeatReq message.
     * @function verify
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2SrvHeartBeatReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2SrvHeartBeatReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2SrvHeartBeatReq} Client2SrvHeartBeatReq
     */
    Client2SrvHeartBeatReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2SrvHeartBeatReq)
            return object;
        let message = new $root.Client2SrvHeartBeatReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2SrvHeartBeatReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {Client2SrvHeartBeatReq} message Client2SrvHeartBeatReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2SrvHeartBeatReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2SrvHeartBeatReq to JSON.
     * @function toJSON
     * @memberof Client2SrvHeartBeatReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2SrvHeartBeatReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2SrvHeartBeatReq
     * @function getTypeUrl
     * @memberof Client2SrvHeartBeatReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2SrvHeartBeatReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2SrvHeartBeatReq";
    };

    return Client2SrvHeartBeatReq;
})();

export const Client2SrvHeartBeatAck = $root.Client2SrvHeartBeatAck = (() => {

    /**
     * Properties of a Client2SrvHeartBeatAck.
     * @exports IClient2SrvHeartBeatAck
     * @interface IClient2SrvHeartBeatAck
     * @property {number|null} [RetCode] Client2SrvHeartBeatAck RetCode
     * @property {number|null} [UserID] Client2SrvHeartBeatAck UserID
     */

    /**
     * Constructs a new Client2SrvHeartBeatAck.
     * @exports Client2SrvHeartBeatAck
     * @classdesc Represents a Client2SrvHeartBeatAck.
     * @implements IClient2SrvHeartBeatAck
     * @constructor
     * @param {IClient2SrvHeartBeatAck=} [properties] Properties to set
     */
    function Client2SrvHeartBeatAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2SrvHeartBeatAck RetCode.
     * @member {number} RetCode
     * @memberof Client2SrvHeartBeatAck
     * @instance
     */
    Client2SrvHeartBeatAck.prototype.RetCode = 0;

    /**
     * Client2SrvHeartBeatAck UserID.
     * @member {number} UserID
     * @memberof Client2SrvHeartBeatAck
     * @instance
     */
    Client2SrvHeartBeatAck.prototype.UserID = 0;

    /**
     * Creates a new Client2SrvHeartBeatAck instance using the specified properties.
     * @function create
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {IClient2SrvHeartBeatAck=} [properties] Properties to set
     * @returns {Client2SrvHeartBeatAck} Client2SrvHeartBeatAck instance
     */
    Client2SrvHeartBeatAck.create = function create(properties) {
        return new Client2SrvHeartBeatAck(properties);
    };

    /**
     * Encodes the specified Client2SrvHeartBeatAck message. Does not implicitly {@link Client2SrvHeartBeatAck.verify|verify} messages.
     * @function encode
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {IClient2SrvHeartBeatAck} message Client2SrvHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2SrvHeartBeatAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RetCode != null && Object.hasOwnProperty.call(message, "RetCode"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RetCode);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2SrvHeartBeatAck message, length delimited. Does not implicitly {@link Client2SrvHeartBeatAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {IClient2SrvHeartBeatAck} message Client2SrvHeartBeatAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2SrvHeartBeatAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2SrvHeartBeatAck message from the specified reader or buffer.
     * @function decode
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2SrvHeartBeatAck} Client2SrvHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2SrvHeartBeatAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2SrvHeartBeatAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RetCode = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2SrvHeartBeatAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2SrvHeartBeatAck} Client2SrvHeartBeatAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2SrvHeartBeatAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2SrvHeartBeatAck message.
     * @function verify
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2SrvHeartBeatAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            if (!$util.isInteger(message.RetCode))
                return "RetCode: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2SrvHeartBeatAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2SrvHeartBeatAck} Client2SrvHeartBeatAck
     */
    Client2SrvHeartBeatAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2SrvHeartBeatAck)
            return object;
        let message = new $root.Client2SrvHeartBeatAck();
        if (object.RetCode != null)
            message.RetCode = object.RetCode >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2SrvHeartBeatAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {Client2SrvHeartBeatAck} message Client2SrvHeartBeatAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2SrvHeartBeatAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.RetCode = 0;
            object.UserID = 0;
        }
        if (message.RetCode != null && message.hasOwnProperty("RetCode"))
            object.RetCode = message.RetCode;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2SrvHeartBeatAck to JSON.
     * @function toJSON
     * @memberof Client2SrvHeartBeatAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2SrvHeartBeatAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2SrvHeartBeatAck
     * @function getTypeUrl
     * @memberof Client2SrvHeartBeatAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2SrvHeartBeatAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2SrvHeartBeatAck";
    };

    return Client2SrvHeartBeatAck;
})();

export const PlayerLBS = $root.PlayerLBS = (() => {

    /**
     * Properties of a PlayerLBS.
     * @exports IPlayerLBS
     * @interface IPlayerLBS
     * @property {string|null} [longitude] PlayerLBS longitude
     * @property {string|null} [latitude] PlayerLBS latitude
     * @property {string|null} [IP] PlayerLBS IP
     */

    /**
     * Constructs a new PlayerLBS.
     * @exports PlayerLBS
     * @classdesc Represents a PlayerLBS.
     * @implements IPlayerLBS
     * @constructor
     * @param {IPlayerLBS=} [properties] Properties to set
     */
    function PlayerLBS(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerLBS longitude.
     * @member {string} longitude
     * @memberof PlayerLBS
     * @instance
     */
    PlayerLBS.prototype.longitude = "";

    /**
     * PlayerLBS latitude.
     * @member {string} latitude
     * @memberof PlayerLBS
     * @instance
     */
    PlayerLBS.prototype.latitude = "";

    /**
     * PlayerLBS IP.
     * @member {string} IP
     * @memberof PlayerLBS
     * @instance
     */
    PlayerLBS.prototype.IP = "";

    /**
     * Creates a new PlayerLBS instance using the specified properties.
     * @function create
     * @memberof PlayerLBS
     * @static
     * @param {IPlayerLBS=} [properties] Properties to set
     * @returns {PlayerLBS} PlayerLBS instance
     */
    PlayerLBS.create = function create(properties) {
        return new PlayerLBS(properties);
    };

    /**
     * Encodes the specified PlayerLBS message. Does not implicitly {@link PlayerLBS.verify|verify} messages.
     * @function encode
     * @memberof PlayerLBS
     * @static
     * @param {IPlayerLBS} message PlayerLBS message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerLBS.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.longitude != null && Object.hasOwnProperty.call(message, "longitude"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.longitude);
        if (message.latitude != null && Object.hasOwnProperty.call(message, "latitude"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.latitude);
        if (message.IP != null && Object.hasOwnProperty.call(message, "IP"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.IP);
        return writer;
    };

    /**
     * Encodes the specified PlayerLBS message, length delimited. Does not implicitly {@link PlayerLBS.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerLBS
     * @static
     * @param {IPlayerLBS} message PlayerLBS message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerLBS.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerLBS message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerLBS
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerLBS} PlayerLBS
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerLBS.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerLBS();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.longitude = reader.string();
                    break;
                }
            case 2: {
                    message.latitude = reader.string();
                    break;
                }
            case 3: {
                    message.IP = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerLBS message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerLBS
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerLBS} PlayerLBS
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerLBS.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerLBS message.
     * @function verify
     * @memberof PlayerLBS
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerLBS.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.longitude != null && message.hasOwnProperty("longitude"))
            if (!$util.isString(message.longitude))
                return "longitude: string expected";
        if (message.latitude != null && message.hasOwnProperty("latitude"))
            if (!$util.isString(message.latitude))
                return "latitude: string expected";
        if (message.IP != null && message.hasOwnProperty("IP"))
            if (!$util.isString(message.IP))
                return "IP: string expected";
        return null;
    };

    /**
     * Creates a PlayerLBS message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerLBS
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerLBS} PlayerLBS
     */
    PlayerLBS.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerLBS)
            return object;
        let message = new $root.PlayerLBS();
        if (object.longitude != null)
            message.longitude = String(object.longitude);
        if (object.latitude != null)
            message.latitude = String(object.latitude);
        if (object.IP != null)
            message.IP = String(object.IP);
        return message;
    };

    /**
     * Creates a plain object from a PlayerLBS message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerLBS
     * @static
     * @param {PlayerLBS} message PlayerLBS
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerLBS.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.longitude = "";
            object.latitude = "";
            object.IP = "";
        }
        if (message.longitude != null && message.hasOwnProperty("longitude"))
            object.longitude = message.longitude;
        if (message.latitude != null && message.hasOwnProperty("latitude"))
            object.latitude = message.latitude;
        if (message.IP != null && message.hasOwnProperty("IP"))
            object.IP = message.IP;
        return object;
    };

    /**
     * Converts this PlayerLBS to JSON.
     * @function toJSON
     * @memberof PlayerLBS
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerLBS.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerLBS
     * @function getTypeUrl
     * @memberof PlayerLBS
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerLBS.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerLBS";
    };

    return PlayerLBS;
})();

export const PlayerPosInfo = $root.PlayerPosInfo = (() => {

    /**
     * Properties of a PlayerPosInfo.
     * @exports IPlayerPosInfo
     * @interface IPlayerPosInfo
     * @property {number|null} [UserID] PlayerPosInfo UserID
     * @property {number|null} [GameID] PlayerPosInfo GameID
     * @property {number|null} [ProductID] PlayerPosInfo ProductID
     * @property {number|null} [DeskNo] PlayerPosInfo DeskNo
     */

    /**
     * Constructs a new PlayerPosInfo.
     * @exports PlayerPosInfo
     * @classdesc Represents a PlayerPosInfo.
     * @implements IPlayerPosInfo
     * @constructor
     * @param {IPlayerPosInfo=} [properties] Properties to set
     */
    function PlayerPosInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerPosInfo UserID.
     * @member {number} UserID
     * @memberof PlayerPosInfo
     * @instance
     */
    PlayerPosInfo.prototype.UserID = 0;

    /**
     * PlayerPosInfo GameID.
     * @member {number} GameID
     * @memberof PlayerPosInfo
     * @instance
     */
    PlayerPosInfo.prototype.GameID = 0;

    /**
     * PlayerPosInfo ProductID.
     * @member {number} ProductID
     * @memberof PlayerPosInfo
     * @instance
     */
    PlayerPosInfo.prototype.ProductID = 0;

    /**
     * PlayerPosInfo DeskNo.
     * @member {number} DeskNo
     * @memberof PlayerPosInfo
     * @instance
     */
    PlayerPosInfo.prototype.DeskNo = 0;

    /**
     * Creates a new PlayerPosInfo instance using the specified properties.
     * @function create
     * @memberof PlayerPosInfo
     * @static
     * @param {IPlayerPosInfo=} [properties] Properties to set
     * @returns {PlayerPosInfo} PlayerPosInfo instance
     */
    PlayerPosInfo.create = function create(properties) {
        return new PlayerPosInfo(properties);
    };

    /**
     * Encodes the specified PlayerPosInfo message. Does not implicitly {@link PlayerPosInfo.verify|verify} messages.
     * @function encode
     * @memberof PlayerPosInfo
     * @static
     * @param {IPlayerPosInfo} message PlayerPosInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerPosInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        return writer;
    };

    /**
     * Encodes the specified PlayerPosInfo message, length delimited. Does not implicitly {@link PlayerPosInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerPosInfo
     * @static
     * @param {IPlayerPosInfo} message PlayerPosInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerPosInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerPosInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerPosInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerPosInfo} PlayerPosInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerPosInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerPosInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerPosInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerPosInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerPosInfo} PlayerPosInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerPosInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerPosInfo message.
     * @function verify
     * @memberof PlayerPosInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerPosInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        return null;
    };

    /**
     * Creates a PlayerPosInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerPosInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerPosInfo} PlayerPosInfo
     */
    PlayerPosInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerPosInfo)
            return object;
        let message = new $root.PlayerPosInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PlayerPosInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerPosInfo
     * @static
     * @param {PlayerPosInfo} message PlayerPosInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerPosInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        return object;
    };

    /**
     * Converts this PlayerPosInfo to JSON.
     * @function toJSON
     * @memberof PlayerPosInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerPosInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerPosInfo
     * @function getTypeUrl
     * @memberof PlayerPosInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerPosInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerPosInfo";
    };

    return PlayerPosInfo;
})();

export const RegisterSrv = $root.RegisterSrv = (() => {

    /**
     * Properties of a RegisterSrv.
     * @exports IRegisterSrv
     * @interface IRegisterSrv
     * @property {number|null} [SrvConnID] RegisterSrv SrvConnID
     * @property {number|null} [SvrID] RegisterSrv SvrID
     * @property {number|null} [Origin] RegisterSrv Origin
     */

    /**
     * Constructs a new RegisterSrv.
     * @exports RegisterSrv
     * @classdesc Represents a RegisterSrv.
     * @implements IRegisterSrv
     * @constructor
     * @param {IRegisterSrv=} [properties] Properties to set
     */
    function RegisterSrv(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RegisterSrv SrvConnID.
     * @member {number} SrvConnID
     * @memberof RegisterSrv
     * @instance
     */
    RegisterSrv.prototype.SrvConnID = 0;

    /**
     * RegisterSrv SvrID.
     * @member {number} SvrID
     * @memberof RegisterSrv
     * @instance
     */
    RegisterSrv.prototype.SvrID = 0;

    /**
     * RegisterSrv Origin.
     * @member {number} Origin
     * @memberof RegisterSrv
     * @instance
     */
    RegisterSrv.prototype.Origin = 0;

    /**
     * Creates a new RegisterSrv instance using the specified properties.
     * @function create
     * @memberof RegisterSrv
     * @static
     * @param {IRegisterSrv=} [properties] Properties to set
     * @returns {RegisterSrv} RegisterSrv instance
     */
    RegisterSrv.create = function create(properties) {
        return new RegisterSrv(properties);
    };

    /**
     * Encodes the specified RegisterSrv message. Does not implicitly {@link RegisterSrv.verify|verify} messages.
     * @function encode
     * @memberof RegisterSrv
     * @static
     * @param {IRegisterSrv} message RegisterSrv message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RegisterSrv.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SrvConnID != null && Object.hasOwnProperty.call(message, "SrvConnID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.SrvConnID);
        if (message.SvrID != null && Object.hasOwnProperty.call(message, "SvrID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SvrID);
        if (message.Origin != null && Object.hasOwnProperty.call(message, "Origin"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Origin);
        return writer;
    };

    /**
     * Encodes the specified RegisterSrv message, length delimited. Does not implicitly {@link RegisterSrv.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RegisterSrv
     * @static
     * @param {IRegisterSrv} message RegisterSrv message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RegisterSrv.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RegisterSrv message from the specified reader or buffer.
     * @function decode
     * @memberof RegisterSrv
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RegisterSrv} RegisterSrv
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RegisterSrv.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RegisterSrv();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.SrvConnID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SvrID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Origin = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RegisterSrv message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RegisterSrv
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RegisterSrv} RegisterSrv
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RegisterSrv.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RegisterSrv message.
     * @function verify
     * @memberof RegisterSrv
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RegisterSrv.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SrvConnID != null && message.hasOwnProperty("SrvConnID"))
            if (!$util.isInteger(message.SrvConnID))
                return "SrvConnID: integer expected";
        if (message.SvrID != null && message.hasOwnProperty("SvrID"))
            if (!$util.isInteger(message.SvrID))
                return "SvrID: integer expected";
        if (message.Origin != null && message.hasOwnProperty("Origin"))
            if (!$util.isInteger(message.Origin))
                return "Origin: integer expected";
        return null;
    };

    /**
     * Creates a RegisterSrv message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RegisterSrv
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RegisterSrv} RegisterSrv
     */
    RegisterSrv.fromObject = function fromObject(object) {
        if (object instanceof $root.RegisterSrv)
            return object;
        let message = new $root.RegisterSrv();
        if (object.SrvConnID != null)
            message.SrvConnID = object.SrvConnID >>> 0;
        if (object.SvrID != null)
            message.SvrID = object.SvrID >>> 0;
        if (object.Origin != null)
            message.Origin = object.Origin >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RegisterSrv message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RegisterSrv
     * @static
     * @param {RegisterSrv} message RegisterSrv
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RegisterSrv.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.SrvConnID = 0;
            object.SvrID = 0;
            object.Origin = 0;
        }
        if (message.SrvConnID != null && message.hasOwnProperty("SrvConnID"))
            object.SrvConnID = message.SrvConnID;
        if (message.SvrID != null && message.hasOwnProperty("SvrID"))
            object.SvrID = message.SvrID;
        if (message.Origin != null && message.hasOwnProperty("Origin"))
            object.Origin = message.Origin;
        return object;
    };

    /**
     * Converts this RegisterSrv to JSON.
     * @function toJSON
     * @memberof RegisterSrv
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RegisterSrv.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RegisterSrv
     * @function getTypeUrl
     * @memberof RegisterSrv
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RegisterSrv.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RegisterSrv";
    };

    return RegisterSrv;
})();

export const UserInfo = $root.UserInfo = (() => {

    /**
     * Properties of a UserInfo.
     * @exports IUserInfo
     * @interface IUserInfo
     * @property {number|null} [UserID] UserInfo UserID
     * @property {Uint8Array|null} [NickName] UserInfo NickName
     * @property {string|null} [HeaderURL] UserInfo HeaderURL
     * @property {string|null} [GoldCoin] UserInfo GoldCoin
     * @property {number|null} [Diamond] UserInfo Diamond
     * @property {number|null} [Sex] UserInfo Sex
     * @property {number|null} [Free] UserInfo Free
     * @property {number|null} [Channel] UserInfo Channel
     * @property {string|null} [BonusCoin] UserInfo BonusCoin
     * @property {string|null} [Mobile] UserInfo Mobile
     * @property {string|null} [DepositCoin] UserInfo DepositCoin
     * @property {string|null} [WithdrawCoin] UserInfo WithdrawCoin
     * @property {string|null} [strDiamond] UserInfo strDiamond
     */

    /**
     * Constructs a new UserInfo.
     * @exports UserInfo
     * @classdesc Represents a UserInfo.
     * @implements IUserInfo
     * @constructor
     * @param {IUserInfo=} [properties] Properties to set
     */
    function UserInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserInfo UserID.
     * @member {number} UserID
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.UserID = 0;

    /**
     * UserInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * UserInfo HeaderURL.
     * @member {string} HeaderURL
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.HeaderURL = "";

    /**
     * UserInfo GoldCoin.
     * @member {string} GoldCoin
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.GoldCoin = "";

    /**
     * UserInfo Diamond.
     * @member {number} Diamond
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.Diamond = 0;

    /**
     * UserInfo Sex.
     * @member {number} Sex
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.Sex = 0;

    /**
     * UserInfo Free.
     * @member {number} Free
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.Free = 0;

    /**
     * UserInfo Channel.
     * @member {number} Channel
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.Channel = 0;

    /**
     * UserInfo BonusCoin.
     * @member {string} BonusCoin
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.BonusCoin = "";

    /**
     * UserInfo Mobile.
     * @member {string} Mobile
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.Mobile = "";

    /**
     * UserInfo DepositCoin.
     * @member {string} DepositCoin
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.DepositCoin = "";

    /**
     * UserInfo WithdrawCoin.
     * @member {string} WithdrawCoin
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.WithdrawCoin = "";

    /**
     * UserInfo strDiamond.
     * @member {string} strDiamond
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.strDiamond = "";

    /**
     * Creates a new UserInfo instance using the specified properties.
     * @function create
     * @memberof UserInfo
     * @static
     * @param {IUserInfo=} [properties] Properties to set
     * @returns {UserInfo} UserInfo instance
     */
    UserInfo.create = function create(properties) {
        return new UserInfo(properties);
    };

    /**
     * Encodes the specified UserInfo message. Does not implicitly {@link UserInfo.verify|verify} messages.
     * @function encode
     * @memberof UserInfo
     * @static
     * @param {IUserInfo} message UserInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.GoldCoin != null && Object.hasOwnProperty.call(message, "GoldCoin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GoldCoin);
        if (message.Diamond != null && Object.hasOwnProperty.call(message, "Diamond"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Diamond);
        if (message.Sex != null && Object.hasOwnProperty.call(message, "Sex"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.Sex);
        if (message.Free != null && Object.hasOwnProperty.call(message, "Free"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.Free);
        if (message.Channel != null && Object.hasOwnProperty.call(message, "Channel"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Channel);
        if (message.BonusCoin != null && Object.hasOwnProperty.call(message, "BonusCoin"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.BonusCoin);
        if (message.Mobile != null && Object.hasOwnProperty.call(message, "Mobile"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.Mobile);
        if (message.DepositCoin != null && Object.hasOwnProperty.call(message, "DepositCoin"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.DepositCoin);
        if (message.WithdrawCoin != null && Object.hasOwnProperty.call(message, "WithdrawCoin"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.WithdrawCoin);
        if (message.strDiamond != null && Object.hasOwnProperty.call(message, "strDiamond"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.strDiamond);
        return writer;
    };

    /**
     * Encodes the specified UserInfo message, length delimited. Does not implicitly {@link UserInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserInfo
     * @static
     * @param {IUserInfo} message UserInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserInfo message from the specified reader or buffer.
     * @function decode
     * @memberof UserInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserInfo} UserInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.GoldCoin = reader.string();
                    break;
                }
            case 5: {
                    message.Diamond = reader.int32();
                    break;
                }
            case 6: {
                    message.Sex = reader.int32();
                    break;
                }
            case 7: {
                    message.Free = reader.int32();
                    break;
                }
            case 8: {
                    message.Channel = reader.int32();
                    break;
                }
            case 9: {
                    message.BonusCoin = reader.string();
                    break;
                }
            case 10: {
                    message.Mobile = reader.string();
                    break;
                }
            case 11: {
                    message.DepositCoin = reader.string();
                    break;
                }
            case 12: {
                    message.WithdrawCoin = reader.string();
                    break;
                }
            case 13: {
                    message.strDiamond = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserInfo} UserInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserInfo message.
     * @function verify
     * @memberof UserInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            if (!$util.isString(message.GoldCoin))
                return "GoldCoin: string expected";
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            if (!$util.isInteger(message.Diamond))
                return "Diamond: integer expected";
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            if (!$util.isInteger(message.Sex))
                return "Sex: integer expected";
        if (message.Free != null && message.hasOwnProperty("Free"))
            if (!$util.isInteger(message.Free))
                return "Free: integer expected";
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            if (!$util.isInteger(message.Channel))
                return "Channel: integer expected";
        if (message.BonusCoin != null && message.hasOwnProperty("BonusCoin"))
            if (!$util.isString(message.BonusCoin))
                return "BonusCoin: string expected";
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            if (!$util.isString(message.Mobile))
                return "Mobile: string expected";
        if (message.DepositCoin != null && message.hasOwnProperty("DepositCoin"))
            if (!$util.isString(message.DepositCoin))
                return "DepositCoin: string expected";
        if (message.WithdrawCoin != null && message.hasOwnProperty("WithdrawCoin"))
            if (!$util.isString(message.WithdrawCoin))
                return "WithdrawCoin: string expected";
        if (message.strDiamond != null && message.hasOwnProperty("strDiamond"))
            if (!$util.isString(message.strDiamond))
                return "strDiamond: string expected";
        return null;
    };

    /**
     * Creates a UserInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserInfo} UserInfo
     */
    UserInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.UserInfo)
            return object;
        let message = new $root.UserInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.GoldCoin != null)
            message.GoldCoin = String(object.GoldCoin);
        if (object.Diamond != null)
            message.Diamond = object.Diamond | 0;
        if (object.Sex != null)
            message.Sex = object.Sex | 0;
        if (object.Free != null)
            message.Free = object.Free | 0;
        if (object.Channel != null)
            message.Channel = object.Channel | 0;
        if (object.BonusCoin != null)
            message.BonusCoin = String(object.BonusCoin);
        if (object.Mobile != null)
            message.Mobile = String(object.Mobile);
        if (object.DepositCoin != null)
            message.DepositCoin = String(object.DepositCoin);
        if (object.WithdrawCoin != null)
            message.WithdrawCoin = String(object.WithdrawCoin);
        if (object.strDiamond != null)
            message.strDiamond = String(object.strDiamond);
        return message;
    };

    /**
     * Creates a plain object from a UserInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserInfo
     * @static
     * @param {UserInfo} message UserInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.GoldCoin = "";
            object.Diamond = 0;
            object.Sex = 0;
            object.Free = 0;
            object.Channel = 0;
            object.BonusCoin = "";
            object.Mobile = "";
            object.DepositCoin = "";
            object.WithdrawCoin = "";
            object.strDiamond = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            object.GoldCoin = message.GoldCoin;
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            object.Diamond = message.Diamond;
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            object.Sex = message.Sex;
        if (message.Free != null && message.hasOwnProperty("Free"))
            object.Free = message.Free;
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            object.Channel = message.Channel;
        if (message.BonusCoin != null && message.hasOwnProperty("BonusCoin"))
            object.BonusCoin = message.BonusCoin;
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            object.Mobile = message.Mobile;
        if (message.DepositCoin != null && message.hasOwnProperty("DepositCoin"))
            object.DepositCoin = message.DepositCoin;
        if (message.WithdrawCoin != null && message.hasOwnProperty("WithdrawCoin"))
            object.WithdrawCoin = message.WithdrawCoin;
        if (message.strDiamond != null && message.hasOwnProperty("strDiamond"))
            object.strDiamond = message.strDiamond;
        return object;
    };

    /**
     * Converts this UserInfo to JSON.
     * @function toJSON
     * @memberof UserInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserInfo
     * @function getTypeUrl
     * @memberof UserInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserInfo";
    };

    return UserInfo;
})();

export const ControlInfo = $root.ControlInfo = (() => {

    /**
     * Properties of a ControlInfo.
     * @exports IControlInfo
     * @interface IControlInfo
     * @property {number|null} [Status] ControlInfo Status
     * @property {number|null} [Stage] ControlInfo Stage
     * @property {number|null} [StageWinLimit] ControlInfo StageWinLimit
     * @property {number|null} [GoldLimit] ControlInfo GoldLimit
     * @property {number|null} [WinGold] ControlInfo WinGold
     * @property {number|null} [LoseGold] ControlInfo LoseGold
     * @property {number|null} [BetGold] ControlInfo BetGold
     * @property {number|null} [PrizeGold] ControlInfo PrizeGold
     * @property {number|null} [CareerBet] ControlInfo CareerBet
     * @property {number|null} [CareerPrize] ControlInfo CareerPrize
     * @property {number|null} [ChargeInduce] ControlInfo ChargeInduce
     * @property {number|null} [DayWinLos] ControlInfo DayWinLos
     * @property {number|null} [AddTop] ControlInfo AddTop
     * @property {number|null} [PlayerChannel] ControlInfo PlayerChannel
     */

    /**
     * Constructs a new ControlInfo.
     * @exports ControlInfo
     * @classdesc Represents a ControlInfo.
     * @implements IControlInfo
     * @constructor
     * @param {IControlInfo=} [properties] Properties to set
     */
    function ControlInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ControlInfo Status.
     * @member {number} Status
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.Status = 0;

    /**
     * ControlInfo Stage.
     * @member {number} Stage
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.Stage = 0;

    /**
     * ControlInfo StageWinLimit.
     * @member {number} StageWinLimit
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.StageWinLimit = 0;

    /**
     * ControlInfo GoldLimit.
     * @member {number} GoldLimit
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.GoldLimit = 0;

    /**
     * ControlInfo WinGold.
     * @member {number} WinGold
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.WinGold = 0;

    /**
     * ControlInfo LoseGold.
     * @member {number} LoseGold
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.LoseGold = 0;

    /**
     * ControlInfo BetGold.
     * @member {number} BetGold
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.BetGold = 0;

    /**
     * ControlInfo PrizeGold.
     * @member {number} PrizeGold
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.PrizeGold = 0;

    /**
     * ControlInfo CareerBet.
     * @member {number} CareerBet
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.CareerBet = 0;

    /**
     * ControlInfo CareerPrize.
     * @member {number} CareerPrize
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.CareerPrize = 0;

    /**
     * ControlInfo ChargeInduce.
     * @member {number} ChargeInduce
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.ChargeInduce = 0;

    /**
     * ControlInfo DayWinLos.
     * @member {number} DayWinLos
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.DayWinLos = 0;

    /**
     * ControlInfo AddTop.
     * @member {number} AddTop
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.AddTop = 0;

    /**
     * ControlInfo PlayerChannel.
     * @member {number} PlayerChannel
     * @memberof ControlInfo
     * @instance
     */
    ControlInfo.prototype.PlayerChannel = 0;

    /**
     * Creates a new ControlInfo instance using the specified properties.
     * @function create
     * @memberof ControlInfo
     * @static
     * @param {IControlInfo=} [properties] Properties to set
     * @returns {ControlInfo} ControlInfo instance
     */
    ControlInfo.create = function create(properties) {
        return new ControlInfo(properties);
    };

    /**
     * Encodes the specified ControlInfo message. Does not implicitly {@link ControlInfo.verify|verify} messages.
     * @function encode
     * @memberof ControlInfo
     * @static
     * @param {IControlInfo} message ControlInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ControlInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Status);
        if (message.Stage != null && Object.hasOwnProperty.call(message, "Stage"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Stage);
        if (message.StageWinLimit != null && Object.hasOwnProperty.call(message, "StageWinLimit"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.StageWinLimit);
        if (message.GoldLimit != null && Object.hasOwnProperty.call(message, "GoldLimit"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GoldLimit);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.WinGold);
        if (message.LoseGold != null && Object.hasOwnProperty.call(message, "LoseGold"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.LoseGold);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.BetGold);
        if (message.PrizeGold != null && Object.hasOwnProperty.call(message, "PrizeGold"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.PrizeGold);
        if (message.CareerBet != null && Object.hasOwnProperty.call(message, "CareerBet"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.CareerBet);
        if (message.CareerPrize != null && Object.hasOwnProperty.call(message, "CareerPrize"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.CareerPrize);
        if (message.ChargeInduce != null && Object.hasOwnProperty.call(message, "ChargeInduce"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.ChargeInduce);
        if (message.DayWinLos != null && Object.hasOwnProperty.call(message, "DayWinLos"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.DayWinLos);
        if (message.AddTop != null && Object.hasOwnProperty.call(message, "AddTop"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.AddTop);
        if (message.PlayerChannel != null && Object.hasOwnProperty.call(message, "PlayerChannel"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.PlayerChannel);
        return writer;
    };

    /**
     * Encodes the specified ControlInfo message, length delimited. Does not implicitly {@link ControlInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ControlInfo
     * @static
     * @param {IControlInfo} message ControlInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ControlInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ControlInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ControlInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ControlInfo} ControlInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ControlInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ControlInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Status = reader.uint32();
                    break;
                }
            case 2: {
                    message.Stage = reader.uint32();
                    break;
                }
            case 3: {
                    message.StageWinLimit = reader.uint32();
                    break;
                }
            case 4: {
                    message.GoldLimit = reader.uint32();
                    break;
                }
            case 5: {
                    message.WinGold = reader.int32();
                    break;
                }
            case 6: {
                    message.LoseGold = reader.int32();
                    break;
                }
            case 7: {
                    message.BetGold = reader.uint32();
                    break;
                }
            case 8: {
                    message.PrizeGold = reader.uint32();
                    break;
                }
            case 9: {
                    message.CareerBet = reader.uint32();
                    break;
                }
            case 10: {
                    message.CareerPrize = reader.uint32();
                    break;
                }
            case 11: {
                    message.ChargeInduce = reader.uint32();
                    break;
                }
            case 12: {
                    message.DayWinLos = reader.int32();
                    break;
                }
            case 13: {
                    message.AddTop = reader.uint32();
                    break;
                }
            case 14: {
                    message.PlayerChannel = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ControlInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ControlInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ControlInfo} ControlInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ControlInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ControlInfo message.
     * @function verify
     * @memberof ControlInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ControlInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isInteger(message.Status))
                return "Status: integer expected";
        if (message.Stage != null && message.hasOwnProperty("Stage"))
            if (!$util.isInteger(message.Stage))
                return "Stage: integer expected";
        if (message.StageWinLimit != null && message.hasOwnProperty("StageWinLimit"))
            if (!$util.isInteger(message.StageWinLimit))
                return "StageWinLimit: integer expected";
        if (message.GoldLimit != null && message.hasOwnProperty("GoldLimit"))
            if (!$util.isInteger(message.GoldLimit))
                return "GoldLimit: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isInteger(message.WinGold))
                return "WinGold: integer expected";
        if (message.LoseGold != null && message.hasOwnProperty("LoseGold"))
            if (!$util.isInteger(message.LoseGold))
                return "LoseGold: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold))
                return "BetGold: integer expected";
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (!$util.isInteger(message.PrizeGold))
                return "PrizeGold: integer expected";
        if (message.CareerBet != null && message.hasOwnProperty("CareerBet"))
            if (!$util.isInteger(message.CareerBet))
                return "CareerBet: integer expected";
        if (message.CareerPrize != null && message.hasOwnProperty("CareerPrize"))
            if (!$util.isInteger(message.CareerPrize))
                return "CareerPrize: integer expected";
        if (message.ChargeInduce != null && message.hasOwnProperty("ChargeInduce"))
            if (!$util.isInteger(message.ChargeInduce))
                return "ChargeInduce: integer expected";
        if (message.DayWinLos != null && message.hasOwnProperty("DayWinLos"))
            if (!$util.isInteger(message.DayWinLos))
                return "DayWinLos: integer expected";
        if (message.AddTop != null && message.hasOwnProperty("AddTop"))
            if (!$util.isInteger(message.AddTop))
                return "AddTop: integer expected";
        if (message.PlayerChannel != null && message.hasOwnProperty("PlayerChannel"))
            if (!$util.isInteger(message.PlayerChannel))
                return "PlayerChannel: integer expected";
        return null;
    };

    /**
     * Creates a ControlInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ControlInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ControlInfo} ControlInfo
     */
    ControlInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ControlInfo)
            return object;
        let message = new $root.ControlInfo();
        if (object.Status != null)
            message.Status = object.Status >>> 0;
        if (object.Stage != null)
            message.Stage = object.Stage >>> 0;
        if (object.StageWinLimit != null)
            message.StageWinLimit = object.StageWinLimit >>> 0;
        if (object.GoldLimit != null)
            message.GoldLimit = object.GoldLimit >>> 0;
        if (object.WinGold != null)
            message.WinGold = object.WinGold | 0;
        if (object.LoseGold != null)
            message.LoseGold = object.LoseGold | 0;
        if (object.BetGold != null)
            message.BetGold = object.BetGold >>> 0;
        if (object.PrizeGold != null)
            message.PrizeGold = object.PrizeGold >>> 0;
        if (object.CareerBet != null)
            message.CareerBet = object.CareerBet >>> 0;
        if (object.CareerPrize != null)
            message.CareerPrize = object.CareerPrize >>> 0;
        if (object.ChargeInduce != null)
            message.ChargeInduce = object.ChargeInduce >>> 0;
        if (object.DayWinLos != null)
            message.DayWinLos = object.DayWinLos | 0;
        if (object.AddTop != null)
            message.AddTop = object.AddTop >>> 0;
        if (object.PlayerChannel != null)
            message.PlayerChannel = object.PlayerChannel >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ControlInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ControlInfo
     * @static
     * @param {ControlInfo} message ControlInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ControlInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Status = 0;
            object.Stage = 0;
            object.StageWinLimit = 0;
            object.GoldLimit = 0;
            object.WinGold = 0;
            object.LoseGold = 0;
            object.BetGold = 0;
            object.PrizeGold = 0;
            object.CareerBet = 0;
            object.CareerPrize = 0;
            object.ChargeInduce = 0;
            object.DayWinLos = 0;
            object.AddTop = 0;
            object.PlayerChannel = 0;
        }
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        if (message.Stage != null && message.hasOwnProperty("Stage"))
            object.Stage = message.Stage;
        if (message.StageWinLimit != null && message.hasOwnProperty("StageWinLimit"))
            object.StageWinLimit = message.StageWinLimit;
        if (message.GoldLimit != null && message.hasOwnProperty("GoldLimit"))
            object.GoldLimit = message.GoldLimit;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.LoseGold != null && message.hasOwnProperty("LoseGold"))
            object.LoseGold = message.LoseGold;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            object.BetGold = message.BetGold;
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            object.PrizeGold = message.PrizeGold;
        if (message.CareerBet != null && message.hasOwnProperty("CareerBet"))
            object.CareerBet = message.CareerBet;
        if (message.CareerPrize != null && message.hasOwnProperty("CareerPrize"))
            object.CareerPrize = message.CareerPrize;
        if (message.ChargeInduce != null && message.hasOwnProperty("ChargeInduce"))
            object.ChargeInduce = message.ChargeInduce;
        if (message.DayWinLos != null && message.hasOwnProperty("DayWinLos"))
            object.DayWinLos = message.DayWinLos;
        if (message.AddTop != null && message.hasOwnProperty("AddTop"))
            object.AddTop = message.AddTop;
        if (message.PlayerChannel != null && message.hasOwnProperty("PlayerChannel"))
            object.PlayerChannel = message.PlayerChannel;
        return object;
    };

    /**
     * Converts this ControlInfo to JSON.
     * @function toJSON
     * @memberof ControlInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ControlInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ControlInfo
     * @function getTypeUrl
     * @memberof ControlInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ControlInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ControlInfo";
    };

    return ControlInfo;
})();

export const BaseCGamePlayer = $root.BaseCGamePlayer = (() => {

    /**
     * Properties of a BaseCGamePlayer.
     * @exports IBaseCGamePlayer
     * @interface IBaseCGamePlayer
     * @property {number|null} [UserID] BaseCGamePlayer UserID
     * @property {number|null} [SeatNo] BaseCGamePlayer SeatNo
     * @property {number|null} [DeskID] BaseCGamePlayer DeskID
     * @property {number|null} [ProductID] BaseCGamePlayer ProductID
     * @property {number|null} [GameID] BaseCGamePlayer GameID
     * @property {number|null} [GameSvrID] BaseCGamePlayer GameSvrID
     * @property {number|null} [ProxyConnID] BaseCGamePlayer ProxyConnID
     * @property {number|null} [BotSvrConnID] BaseCGamePlayer BotSvrConnID
     * @property {number|null} [Diamond] BaseCGamePlayer Diamond
     * @property {string|null} [Chip] BaseCGamePlayer Chip
     * @property {string|null} [Deposit] BaseCGamePlayer Deposit
     * @property {string|null} [Withdraw] BaseCGamePlayer Withdraw
     * @property {string|null} [Bonus] BaseCGamePlayer Bonus
     * @property {number|null} [Sex] BaseCGamePlayer Sex
     * @property {string|null} [NickName] BaseCGamePlayer NickName
     * @property {string|null} [HeadImg] BaseCGamePlayer HeadImg
     * @property {number|Long|null} [EnterDeskTime] BaseCGamePlayer EnterDeskTime
     * @property {number|Long|null} [BreakTime] BaseCGamePlayer BreakTime
     * @property {boolean|null} [CanLeave] BaseCGamePlayer CanLeave
     * @property {boolean|null} [SealUser] BaseCGamePlayer SealUser
     * @property {number|null} [Ip] BaseCGamePlayer Ip
     * @property {string|null} [Longitude] BaseCGamePlayer Longitude
     * @property {string|null} [Latitude] BaseCGamePlayer Latitude
     * @property {number|null} [ChannelID] BaseCGamePlayer ChannelID
     */

    /**
     * Constructs a new BaseCGamePlayer.
     * @exports BaseCGamePlayer
     * @classdesc Represents a BaseCGamePlayer.
     * @implements IBaseCGamePlayer
     * @constructor
     * @param {IBaseCGamePlayer=} [properties] Properties to set
     */
    function BaseCGamePlayer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BaseCGamePlayer UserID.
     * @member {number} UserID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.UserID = 0;

    /**
     * BaseCGamePlayer SeatNo.
     * @member {number} SeatNo
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.SeatNo = 0;

    /**
     * BaseCGamePlayer DeskID.
     * @member {number} DeskID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.DeskID = 0;

    /**
     * BaseCGamePlayer ProductID.
     * @member {number} ProductID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.ProductID = 0;

    /**
     * BaseCGamePlayer GameID.
     * @member {number} GameID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.GameID = 0;

    /**
     * BaseCGamePlayer GameSvrID.
     * @member {number} GameSvrID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.GameSvrID = 0;

    /**
     * BaseCGamePlayer ProxyConnID.
     * @member {number} ProxyConnID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.ProxyConnID = 0;

    /**
     * BaseCGamePlayer BotSvrConnID.
     * @member {number} BotSvrConnID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.BotSvrConnID = 0;

    /**
     * BaseCGamePlayer Diamond.
     * @member {number} Diamond
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Diamond = 0;

    /**
     * BaseCGamePlayer Chip.
     * @member {string} Chip
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Chip = "";

    /**
     * BaseCGamePlayer Deposit.
     * @member {string} Deposit
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Deposit = "";

    /**
     * BaseCGamePlayer Withdraw.
     * @member {string} Withdraw
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Withdraw = "";

    /**
     * BaseCGamePlayer Bonus.
     * @member {string} Bonus
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Bonus = "";

    /**
     * BaseCGamePlayer Sex.
     * @member {number} Sex
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Sex = 0;

    /**
     * BaseCGamePlayer NickName.
     * @member {string} NickName
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.NickName = "";

    /**
     * BaseCGamePlayer HeadImg.
     * @member {string} HeadImg
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.HeadImg = "";

    /**
     * BaseCGamePlayer EnterDeskTime.
     * @member {number|Long} EnterDeskTime
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.EnterDeskTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BaseCGamePlayer BreakTime.
     * @member {number|Long} BreakTime
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.BreakTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BaseCGamePlayer CanLeave.
     * @member {boolean} CanLeave
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.CanLeave = false;

    /**
     * BaseCGamePlayer SealUser.
     * @member {boolean} SealUser
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.SealUser = false;

    /**
     * BaseCGamePlayer Ip.
     * @member {number} Ip
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Ip = 0;

    /**
     * BaseCGamePlayer Longitude.
     * @member {string} Longitude
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Longitude = "";

    /**
     * BaseCGamePlayer Latitude.
     * @member {string} Latitude
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.Latitude = "";

    /**
     * BaseCGamePlayer ChannelID.
     * @member {number} ChannelID
     * @memberof BaseCGamePlayer
     * @instance
     */
    BaseCGamePlayer.prototype.ChannelID = 0;

    /**
     * Creates a new BaseCGamePlayer instance using the specified properties.
     * @function create
     * @memberof BaseCGamePlayer
     * @static
     * @param {IBaseCGamePlayer=} [properties] Properties to set
     * @returns {BaseCGamePlayer} BaseCGamePlayer instance
     */
    BaseCGamePlayer.create = function create(properties) {
        return new BaseCGamePlayer(properties);
    };

    /**
     * Encodes the specified BaseCGamePlayer message. Does not implicitly {@link BaseCGamePlayer.verify|verify} messages.
     * @function encode
     * @memberof BaseCGamePlayer
     * @static
     * @param {IBaseCGamePlayer} message BaseCGamePlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BaseCGamePlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.SeatNo);
        if (message.DeskID != null && Object.hasOwnProperty.call(message, "DeskID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DeskID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.GameID);
        if (message.GameSvrID != null && Object.hasOwnProperty.call(message, "GameSvrID"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.GameSvrID);
        if (message.ProxyConnID != null && Object.hasOwnProperty.call(message, "ProxyConnID"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.ProxyConnID);
        if (message.BotSvrConnID != null && Object.hasOwnProperty.call(message, "BotSvrConnID"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.BotSvrConnID);
        if (message.Diamond != null && Object.hasOwnProperty.call(message, "Diamond"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.Diamond);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.Chip);
        if (message.Deposit != null && Object.hasOwnProperty.call(message, "Deposit"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.Deposit);
        if (message.Withdraw != null && Object.hasOwnProperty.call(message, "Withdraw"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.Withdraw);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.Bonus);
        if (message.Sex != null && Object.hasOwnProperty.call(message, "Sex"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.Sex);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.NickName);
        if (message.HeadImg != null && Object.hasOwnProperty.call(message, "HeadImg"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.HeadImg);
        if (message.EnterDeskTime != null && Object.hasOwnProperty.call(message, "EnterDeskTime"))
            writer.uint32(/* id 17, wireType 0 =*/136).uint64(message.EnterDeskTime);
        if (message.BreakTime != null && Object.hasOwnProperty.call(message, "BreakTime"))
            writer.uint32(/* id 18, wireType 0 =*/144).uint64(message.BreakTime);
        if (message.CanLeave != null && Object.hasOwnProperty.call(message, "CanLeave"))
            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.CanLeave);
        if (message.SealUser != null && Object.hasOwnProperty.call(message, "SealUser"))
            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.SealUser);
        if (message.Ip != null && Object.hasOwnProperty.call(message, "Ip"))
            writer.uint32(/* id 21, wireType 0 =*/168).uint32(message.Ip);
        if (message.Longitude != null && Object.hasOwnProperty.call(message, "Longitude"))
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.Longitude);
        if (message.Latitude != null && Object.hasOwnProperty.call(message, "Latitude"))
            writer.uint32(/* id 23, wireType 2 =*/186).string(message.Latitude);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 24, wireType 0 =*/192).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified BaseCGamePlayer message, length delimited. Does not implicitly {@link BaseCGamePlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BaseCGamePlayer
     * @static
     * @param {IBaseCGamePlayer} message BaseCGamePlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BaseCGamePlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BaseCGamePlayer message from the specified reader or buffer.
     * @function decode
     * @memberof BaseCGamePlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BaseCGamePlayer} BaseCGamePlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BaseCGamePlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BaseCGamePlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 3: {
                    message.DeskID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 6: {
                    message.GameSvrID = reader.uint32();
                    break;
                }
            case 7: {
                    message.ProxyConnID = reader.uint32();
                    break;
                }
            case 8: {
                    message.BotSvrConnID = reader.uint32();
                    break;
                }
            case 9: {
                    message.Diamond = reader.int32();
                    break;
                }
            case 10: {
                    message.Chip = reader.string();
                    break;
                }
            case 11: {
                    message.Deposit = reader.string();
                    break;
                }
            case 12: {
                    message.Withdraw = reader.string();
                    break;
                }
            case 13: {
                    message.Bonus = reader.string();
                    break;
                }
            case 14: {
                    message.Sex = reader.uint32();
                    break;
                }
            case 15: {
                    message.NickName = reader.string();
                    break;
                }
            case 16: {
                    message.HeadImg = reader.string();
                    break;
                }
            case 17: {
                    message.EnterDeskTime = reader.uint64();
                    break;
                }
            case 18: {
                    message.BreakTime = reader.uint64();
                    break;
                }
            case 19: {
                    message.CanLeave = reader.bool();
                    break;
                }
            case 20: {
                    message.SealUser = reader.bool();
                    break;
                }
            case 21: {
                    message.Ip = reader.uint32();
                    break;
                }
            case 22: {
                    message.Longitude = reader.string();
                    break;
                }
            case 23: {
                    message.Latitude = reader.string();
                    break;
                }
            case 24: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BaseCGamePlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BaseCGamePlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BaseCGamePlayer} BaseCGamePlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BaseCGamePlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BaseCGamePlayer message.
     * @function verify
     * @memberof BaseCGamePlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BaseCGamePlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.DeskID != null && message.hasOwnProperty("DeskID"))
            if (!$util.isInteger(message.DeskID))
                return "DeskID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.GameSvrID != null && message.hasOwnProperty("GameSvrID"))
            if (!$util.isInteger(message.GameSvrID))
                return "GameSvrID: integer expected";
        if (message.ProxyConnID != null && message.hasOwnProperty("ProxyConnID"))
            if (!$util.isInteger(message.ProxyConnID))
                return "ProxyConnID: integer expected";
        if (message.BotSvrConnID != null && message.hasOwnProperty("BotSvrConnID"))
            if (!$util.isInteger(message.BotSvrConnID))
                return "BotSvrConnID: integer expected";
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            if (!$util.isInteger(message.Diamond))
                return "Diamond: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            if (!$util.isString(message.Deposit))
                return "Deposit: string expected";
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            if (!$util.isString(message.Withdraw))
                return "Withdraw: string expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            if (!$util.isInteger(message.Sex))
                return "Sex: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!$util.isString(message.NickName))
                return "NickName: string expected";
        if (message.HeadImg != null && message.hasOwnProperty("HeadImg"))
            if (!$util.isString(message.HeadImg))
                return "HeadImg: string expected";
        if (message.EnterDeskTime != null && message.hasOwnProperty("EnterDeskTime"))
            if (!$util.isInteger(message.EnterDeskTime) && !(message.EnterDeskTime && $util.isInteger(message.EnterDeskTime.low) && $util.isInteger(message.EnterDeskTime.high)))
                return "EnterDeskTime: integer|Long expected";
        if (message.BreakTime != null && message.hasOwnProperty("BreakTime"))
            if (!$util.isInteger(message.BreakTime) && !(message.BreakTime && $util.isInteger(message.BreakTime.low) && $util.isInteger(message.BreakTime.high)))
                return "BreakTime: integer|Long expected";
        if (message.CanLeave != null && message.hasOwnProperty("CanLeave"))
            if (typeof message.CanLeave !== "boolean")
                return "CanLeave: boolean expected";
        if (message.SealUser != null && message.hasOwnProperty("SealUser"))
            if (typeof message.SealUser !== "boolean")
                return "SealUser: boolean expected";
        if (message.Ip != null && message.hasOwnProperty("Ip"))
            if (!$util.isInteger(message.Ip))
                return "Ip: integer expected";
        if (message.Longitude != null && message.hasOwnProperty("Longitude"))
            if (!$util.isString(message.Longitude))
                return "Longitude: string expected";
        if (message.Latitude != null && message.hasOwnProperty("Latitude"))
            if (!$util.isString(message.Latitude))
                return "Latitude: string expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a BaseCGamePlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BaseCGamePlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BaseCGamePlayer} BaseCGamePlayer
     */
    BaseCGamePlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.BaseCGamePlayer)
            return object;
        let message = new $root.BaseCGamePlayer();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.DeskID != null)
            message.DeskID = object.DeskID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.GameSvrID != null)
            message.GameSvrID = object.GameSvrID >>> 0;
        if (object.ProxyConnID != null)
            message.ProxyConnID = object.ProxyConnID >>> 0;
        if (object.BotSvrConnID != null)
            message.BotSvrConnID = object.BotSvrConnID >>> 0;
        if (object.Diamond != null)
            message.Diamond = object.Diamond | 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.Deposit != null)
            message.Deposit = String(object.Deposit);
        if (object.Withdraw != null)
            message.Withdraw = String(object.Withdraw);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        if (object.Sex != null)
            message.Sex = object.Sex >>> 0;
        if (object.NickName != null)
            message.NickName = String(object.NickName);
        if (object.HeadImg != null)
            message.HeadImg = String(object.HeadImg);
        if (object.EnterDeskTime != null)
            if ($util.Long)
                (message.EnterDeskTime = $util.Long.fromValue(object.EnterDeskTime)).unsigned = true;
            else if (typeof object.EnterDeskTime === "string")
                message.EnterDeskTime = parseInt(object.EnterDeskTime, 10);
            else if (typeof object.EnterDeskTime === "number")
                message.EnterDeskTime = object.EnterDeskTime;
            else if (typeof object.EnterDeskTime === "object")
                message.EnterDeskTime = new $util.LongBits(object.EnterDeskTime.low >>> 0, object.EnterDeskTime.high >>> 0).toNumber(true);
        if (object.BreakTime != null)
            if ($util.Long)
                (message.BreakTime = $util.Long.fromValue(object.BreakTime)).unsigned = true;
            else if (typeof object.BreakTime === "string")
                message.BreakTime = parseInt(object.BreakTime, 10);
            else if (typeof object.BreakTime === "number")
                message.BreakTime = object.BreakTime;
            else if (typeof object.BreakTime === "object")
                message.BreakTime = new $util.LongBits(object.BreakTime.low >>> 0, object.BreakTime.high >>> 0).toNumber(true);
        if (object.CanLeave != null)
            message.CanLeave = Boolean(object.CanLeave);
        if (object.SealUser != null)
            message.SealUser = Boolean(object.SealUser);
        if (object.Ip != null)
            message.Ip = object.Ip >>> 0;
        if (object.Longitude != null)
            message.Longitude = String(object.Longitude);
        if (object.Latitude != null)
            message.Latitude = String(object.Latitude);
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a BaseCGamePlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BaseCGamePlayer
     * @static
     * @param {BaseCGamePlayer} message BaseCGamePlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BaseCGamePlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.SeatNo = 0;
            object.DeskID = 0;
            object.ProductID = 0;
            object.GameID = 0;
            object.GameSvrID = 0;
            object.ProxyConnID = 0;
            object.BotSvrConnID = 0;
            object.Diamond = 0;
            object.Chip = "";
            object.Deposit = "";
            object.Withdraw = "";
            object.Bonus = "";
            object.Sex = 0;
            object.NickName = "";
            object.HeadImg = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EnterDeskTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EnterDeskTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BreakTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BreakTime = options.longs === String ? "0" : 0;
            object.CanLeave = false;
            object.SealUser = false;
            object.Ip = 0;
            object.Longitude = "";
            object.Latitude = "";
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.DeskID != null && message.hasOwnProperty("DeskID"))
            object.DeskID = message.DeskID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.GameSvrID != null && message.hasOwnProperty("GameSvrID"))
            object.GameSvrID = message.GameSvrID;
        if (message.ProxyConnID != null && message.hasOwnProperty("ProxyConnID"))
            object.ProxyConnID = message.ProxyConnID;
        if (message.BotSvrConnID != null && message.hasOwnProperty("BotSvrConnID"))
            object.BotSvrConnID = message.BotSvrConnID;
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            object.Diamond = message.Diamond;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            object.Deposit = message.Deposit;
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            object.Withdraw = message.Withdraw;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            object.Sex = message.Sex;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = message.NickName;
        if (message.HeadImg != null && message.hasOwnProperty("HeadImg"))
            object.HeadImg = message.HeadImg;
        if (message.EnterDeskTime != null && message.hasOwnProperty("EnterDeskTime"))
            if (typeof message.EnterDeskTime === "number")
                object.EnterDeskTime = options.longs === String ? String(message.EnterDeskTime) : message.EnterDeskTime;
            else
                object.EnterDeskTime = options.longs === String ? $util.Long.prototype.toString.call(message.EnterDeskTime) : options.longs === Number ? new $util.LongBits(message.EnterDeskTime.low >>> 0, message.EnterDeskTime.high >>> 0).toNumber(true) : message.EnterDeskTime;
        if (message.BreakTime != null && message.hasOwnProperty("BreakTime"))
            if (typeof message.BreakTime === "number")
                object.BreakTime = options.longs === String ? String(message.BreakTime) : message.BreakTime;
            else
                object.BreakTime = options.longs === String ? $util.Long.prototype.toString.call(message.BreakTime) : options.longs === Number ? new $util.LongBits(message.BreakTime.low >>> 0, message.BreakTime.high >>> 0).toNumber(true) : message.BreakTime;
        if (message.CanLeave != null && message.hasOwnProperty("CanLeave"))
            object.CanLeave = message.CanLeave;
        if (message.SealUser != null && message.hasOwnProperty("SealUser"))
            object.SealUser = message.SealUser;
        if (message.Ip != null && message.hasOwnProperty("Ip"))
            object.Ip = message.Ip;
        if (message.Longitude != null && message.hasOwnProperty("Longitude"))
            object.Longitude = message.Longitude;
        if (message.Latitude != null && message.hasOwnProperty("Latitude"))
            object.Latitude = message.Latitude;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this BaseCGamePlayer to JSON.
     * @function toJSON
     * @memberof BaseCGamePlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BaseCGamePlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BaseCGamePlayer
     * @function getTypeUrl
     * @memberof BaseCGamePlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BaseCGamePlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BaseCGamePlayer";
    };

    return BaseCGamePlayer;
})();

export const AccountInfo = $root.AccountInfo = (() => {

    /**
     * Properties of an AccountInfo.
     * @exports IAccountInfo
     * @interface IAccountInfo
     * @property {number|null} [UserID] AccountInfo UserID
     * @property {number|null} [ChargeTotal] AccountInfo ChargeTotal
     * @property {number|null} [ChargeNum] AccountInfo ChargeNum
     * @property {number|null} [Withdrawtotal] AccountInfo Withdrawtotal
     */

    /**
     * Constructs a new AccountInfo.
     * @exports AccountInfo
     * @classdesc Represents an AccountInfo.
     * @implements IAccountInfo
     * @constructor
     * @param {IAccountInfo=} [properties] Properties to set
     */
    function AccountInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountInfo UserID.
     * @member {number} UserID
     * @memberof AccountInfo
     * @instance
     */
    AccountInfo.prototype.UserID = 0;

    /**
     * AccountInfo ChargeTotal.
     * @member {number} ChargeTotal
     * @memberof AccountInfo
     * @instance
     */
    AccountInfo.prototype.ChargeTotal = 0;

    /**
     * AccountInfo ChargeNum.
     * @member {number} ChargeNum
     * @memberof AccountInfo
     * @instance
     */
    AccountInfo.prototype.ChargeNum = 0;

    /**
     * AccountInfo Withdrawtotal.
     * @member {number} Withdrawtotal
     * @memberof AccountInfo
     * @instance
     */
    AccountInfo.prototype.Withdrawtotal = 0;

    /**
     * Creates a new AccountInfo instance using the specified properties.
     * @function create
     * @memberof AccountInfo
     * @static
     * @param {IAccountInfo=} [properties] Properties to set
     * @returns {AccountInfo} AccountInfo instance
     */
    AccountInfo.create = function create(properties) {
        return new AccountInfo(properties);
    };

    /**
     * Encodes the specified AccountInfo message. Does not implicitly {@link AccountInfo.verify|verify} messages.
     * @function encode
     * @memberof AccountInfo
     * @static
     * @param {IAccountInfo} message AccountInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChargeTotal != null && Object.hasOwnProperty.call(message, "ChargeTotal"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChargeTotal);
        if (message.ChargeNum != null && Object.hasOwnProperty.call(message, "ChargeNum"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChargeNum);
        if (message.Withdrawtotal != null && Object.hasOwnProperty.call(message, "Withdrawtotal"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Withdrawtotal);
        return writer;
    };

    /**
     * Encodes the specified AccountInfo message, length delimited. Does not implicitly {@link AccountInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountInfo
     * @static
     * @param {IAccountInfo} message AccountInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountInfo message from the specified reader or buffer.
     * @function decode
     * @memberof AccountInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountInfo} AccountInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChargeTotal = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChargeNum = reader.uint32();
                    break;
                }
            case 4: {
                    message.Withdrawtotal = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountInfo} AccountInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountInfo message.
     * @function verify
     * @memberof AccountInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChargeTotal != null && message.hasOwnProperty("ChargeTotal"))
            if (!$util.isInteger(message.ChargeTotal))
                return "ChargeTotal: integer expected";
        if (message.ChargeNum != null && message.hasOwnProperty("ChargeNum"))
            if (!$util.isInteger(message.ChargeNum))
                return "ChargeNum: integer expected";
        if (message.Withdrawtotal != null && message.hasOwnProperty("Withdrawtotal"))
            if (!$util.isInteger(message.Withdrawtotal))
                return "Withdrawtotal: integer expected";
        return null;
    };

    /**
     * Creates an AccountInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountInfo} AccountInfo
     */
    AccountInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountInfo)
            return object;
        let message = new $root.AccountInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChargeTotal != null)
            message.ChargeTotal = object.ChargeTotal >>> 0;
        if (object.ChargeNum != null)
            message.ChargeNum = object.ChargeNum >>> 0;
        if (object.Withdrawtotal != null)
            message.Withdrawtotal = object.Withdrawtotal >>> 0;
        return message;
    };

    /**
     * Creates a plain object from an AccountInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountInfo
     * @static
     * @param {AccountInfo} message AccountInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChargeTotal = 0;
            object.ChargeNum = 0;
            object.Withdrawtotal = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChargeTotal != null && message.hasOwnProperty("ChargeTotal"))
            object.ChargeTotal = message.ChargeTotal;
        if (message.ChargeNum != null && message.hasOwnProperty("ChargeNum"))
            object.ChargeNum = message.ChargeNum;
        if (message.Withdrawtotal != null && message.hasOwnProperty("Withdrawtotal"))
            object.Withdrawtotal = message.Withdrawtotal;
        return object;
    };

    /**
     * Converts this AccountInfo to JSON.
     * @function toJSON
     * @memberof AccountInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AccountInfo
     * @function getTypeUrl
     * @memberof AccountInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AccountInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AccountInfo";
    };

    return AccountInfo;
})();

export const GamePosInfo = $root.GamePosInfo = (() => {

    /**
     * Properties of a GamePosInfo.
     * @exports IGamePosInfo
     * @interface IGamePosInfo
     * @property {number|null} [GameSrvID] GamePosInfo GameSrvID
     * @property {number|null} [GameID] GamePosInfo GameID
     * @property {number|null} [Pid] GamePosInfo Pid
     * @property {number|null} [DeskNo] GamePosInfo DeskNo
     */

    /**
     * Constructs a new GamePosInfo.
     * @exports GamePosInfo
     * @classdesc Represents a GamePosInfo.
     * @implements IGamePosInfo
     * @constructor
     * @param {IGamePosInfo=} [properties] Properties to set
     */
    function GamePosInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GamePosInfo GameSrvID.
     * @member {number} GameSrvID
     * @memberof GamePosInfo
     * @instance
     */
    GamePosInfo.prototype.GameSrvID = 0;

    /**
     * GamePosInfo GameID.
     * @member {number} GameID
     * @memberof GamePosInfo
     * @instance
     */
    GamePosInfo.prototype.GameID = 0;

    /**
     * GamePosInfo Pid.
     * @member {number} Pid
     * @memberof GamePosInfo
     * @instance
     */
    GamePosInfo.prototype.Pid = 0;

    /**
     * GamePosInfo DeskNo.
     * @member {number} DeskNo
     * @memberof GamePosInfo
     * @instance
     */
    GamePosInfo.prototype.DeskNo = 0;

    /**
     * Creates a new GamePosInfo instance using the specified properties.
     * @function create
     * @memberof GamePosInfo
     * @static
     * @param {IGamePosInfo=} [properties] Properties to set
     * @returns {GamePosInfo} GamePosInfo instance
     */
    GamePosInfo.create = function create(properties) {
        return new GamePosInfo(properties);
    };

    /**
     * Encodes the specified GamePosInfo message. Does not implicitly {@link GamePosInfo.verify|verify} messages.
     * @function encode
     * @memberof GamePosInfo
     * @static
     * @param {IGamePosInfo} message GamePosInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamePosInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GameSrvID != null && Object.hasOwnProperty.call(message, "GameSrvID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GameSrvID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.Pid != null && Object.hasOwnProperty.call(message, "Pid"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Pid);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        return writer;
    };

    /**
     * Encodes the specified GamePosInfo message, length delimited. Does not implicitly {@link GamePosInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GamePosInfo
     * @static
     * @param {IGamePosInfo} message GamePosInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamePosInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GamePosInfo message from the specified reader or buffer.
     * @function decode
     * @memberof GamePosInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GamePosInfo} GamePosInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamePosInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GamePosInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.GameSrvID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Pid = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GamePosInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GamePosInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GamePosInfo} GamePosInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamePosInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GamePosInfo message.
     * @function verify
     * @memberof GamePosInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GamePosInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GameSrvID != null && message.hasOwnProperty("GameSrvID"))
            if (!$util.isInteger(message.GameSrvID))
                return "GameSrvID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            if (!$util.isInteger(message.Pid))
                return "Pid: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        return null;
    };

    /**
     * Creates a GamePosInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GamePosInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GamePosInfo} GamePosInfo
     */
    GamePosInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GamePosInfo)
            return object;
        let message = new $root.GamePosInfo();
        if (object.GameSrvID != null)
            message.GameSrvID = object.GameSrvID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.Pid != null)
            message.Pid = object.Pid >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GamePosInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GamePosInfo
     * @static
     * @param {GamePosInfo} message GamePosInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GamePosInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.GameSrvID = 0;
            object.GameID = 0;
            object.Pid = 0;
            object.DeskNo = 0;
        }
        if (message.GameSrvID != null && message.hasOwnProperty("GameSrvID"))
            object.GameSrvID = message.GameSrvID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            object.Pid = message.Pid;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        return object;
    };

    /**
     * Converts this GamePosInfo to JSON.
     * @function toJSON
     * @memberof GamePosInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GamePosInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GamePosInfo
     * @function getTypeUrl
     * @memberof GamePosInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GamePosInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GamePosInfo";
    };

    return GamePosInfo;
})();

export const WithDrawRecord = $root.WithDrawRecord = (() => {

    /**
     * Properties of a WithDrawRecord.
     * @exports IWithDrawRecord
     * @interface IWithDrawRecord
     * @property {string|null} [Order] WithDrawRecord Order
     * @property {string|null} [Time] WithDrawRecord Time
     * @property {string|null} [Amount] WithDrawRecord Amount
     * @property {string|null} [PayTmID] WithDrawRecord PayTmID
     * @property {string|null} [Status] WithDrawRecord Status
     * @property {string|null} [Reason] WithDrawRecord Reason
     */

    /**
     * Constructs a new WithDrawRecord.
     * @exports WithDrawRecord
     * @classdesc Represents a WithDrawRecord.
     * @implements IWithDrawRecord
     * @constructor
     * @param {IWithDrawRecord=} [properties] Properties to set
     */
    function WithDrawRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WithDrawRecord Order.
     * @member {string} Order
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.Order = "";

    /**
     * WithDrawRecord Time.
     * @member {string} Time
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.Time = "";

    /**
     * WithDrawRecord Amount.
     * @member {string} Amount
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.Amount = "";

    /**
     * WithDrawRecord PayTmID.
     * @member {string} PayTmID
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.PayTmID = "";

    /**
     * WithDrawRecord Status.
     * @member {string} Status
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.Status = "";

    /**
     * WithDrawRecord Reason.
     * @member {string} Reason
     * @memberof WithDrawRecord
     * @instance
     */
    WithDrawRecord.prototype.Reason = "";

    /**
     * Creates a new WithDrawRecord instance using the specified properties.
     * @function create
     * @memberof WithDrawRecord
     * @static
     * @param {IWithDrawRecord=} [properties] Properties to set
     * @returns {WithDrawRecord} WithDrawRecord instance
     */
    WithDrawRecord.create = function create(properties) {
        return new WithDrawRecord(properties);
    };

    /**
     * Encodes the specified WithDrawRecord message. Does not implicitly {@link WithDrawRecord.verify|verify} messages.
     * @function encode
     * @memberof WithDrawRecord
     * @static
     * @param {IWithDrawRecord} message WithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WithDrawRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Order != null && Object.hasOwnProperty.call(message, "Order"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Order);
        if (message.Time != null && Object.hasOwnProperty.call(message, "Time"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Time);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Amount);
        if (message.PayTmID != null && Object.hasOwnProperty.call(message, "PayTmID"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.PayTmID);
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Status);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified WithDrawRecord message, length delimited. Does not implicitly {@link WithDrawRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WithDrawRecord
     * @static
     * @param {IWithDrawRecord} message WithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WithDrawRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WithDrawRecord message from the specified reader or buffer.
     * @function decode
     * @memberof WithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WithDrawRecord} WithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WithDrawRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WithDrawRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Order = reader.string();
                    break;
                }
            case 2: {
                    message.Time = reader.string();
                    break;
                }
            case 3: {
                    message.Amount = reader.string();
                    break;
                }
            case 4: {
                    message.PayTmID = reader.string();
                    break;
                }
            case 5: {
                    message.Status = reader.string();
                    break;
                }
            case 6: {
                    message.Reason = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WithDrawRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WithDrawRecord} WithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WithDrawRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WithDrawRecord message.
     * @function verify
     * @memberof WithDrawRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WithDrawRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Order != null && message.hasOwnProperty("Order"))
            if (!$util.isString(message.Order))
                return "Order: string expected";
        if (message.Time != null && message.hasOwnProperty("Time"))
            if (!$util.isString(message.Time))
                return "Time: string expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.PayTmID != null && message.hasOwnProperty("PayTmID"))
            if (!$util.isString(message.PayTmID))
                return "PayTmID: string expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isString(message.Status))
                return "Status: string expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a WithDrawRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WithDrawRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WithDrawRecord} WithDrawRecord
     */
    WithDrawRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.WithDrawRecord)
            return object;
        let message = new $root.WithDrawRecord();
        if (object.Order != null)
            message.Order = String(object.Order);
        if (object.Time != null)
            message.Time = String(object.Time);
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.PayTmID != null)
            message.PayTmID = String(object.PayTmID);
        if (object.Status != null)
            message.Status = String(object.Status);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a WithDrawRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WithDrawRecord
     * @static
     * @param {WithDrawRecord} message WithDrawRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WithDrawRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Order = "";
            object.Time = "";
            object.Amount = "";
            object.PayTmID = "";
            object.Status = "";
            object.Reason = "";
        }
        if (message.Order != null && message.hasOwnProperty("Order"))
            object.Order = message.Order;
        if (message.Time != null && message.hasOwnProperty("Time"))
            object.Time = message.Time;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.PayTmID != null && message.hasOwnProperty("PayTmID"))
            object.PayTmID = message.PayTmID;
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this WithDrawRecord to JSON.
     * @function toJSON
     * @memberof WithDrawRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WithDrawRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WithDrawRecord
     * @function getTypeUrl
     * @memberof WithDrawRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WithDrawRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WithDrawRecord";
    };

    return WithDrawRecord;
})();

export const PageInfo = $root.PageInfo = (() => {

    /**
     * Properties of a PageInfo.
     * @exports IPageInfo
     * @interface IPageInfo
     * @property {number|null} [Page] PageInfo Page
     * @property {number|null} [PageSize] PageInfo PageSize
     */

    /**
     * Constructs a new PageInfo.
     * @exports PageInfo
     * @classdesc Represents a PageInfo.
     * @implements IPageInfo
     * @constructor
     * @param {IPageInfo=} [properties] Properties to set
     */
    function PageInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PageInfo Page.
     * @member {number} Page
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.Page = 0;

    /**
     * PageInfo PageSize.
     * @member {number} PageSize
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.PageSize = 0;

    /**
     * Creates a new PageInfo instance using the specified properties.
     * @function create
     * @memberof PageInfo
     * @static
     * @param {IPageInfo=} [properties] Properties to set
     * @returns {PageInfo} PageInfo instance
     */
    PageInfo.create = function create(properties) {
        return new PageInfo(properties);
    };

    /**
     * Encodes the specified PageInfo message. Does not implicitly {@link PageInfo.verify|verify} messages.
     * @function encode
     * @memberof PageInfo
     * @static
     * @param {IPageInfo} message PageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Page);
        if (message.PageSize != null && Object.hasOwnProperty.call(message, "PageSize"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.PageSize);
        return writer;
    };

    /**
     * Encodes the specified PageInfo message, length delimited. Does not implicitly {@link PageInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PageInfo
     * @static
     * @param {IPageInfo} message PageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PageInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageInfo} PageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PageInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Page = reader.uint32();
                    break;
                }
            case 2: {
                    message.PageSize = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PageInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PageInfo} PageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PageInfo message.
     * @function verify
     * @memberof PageInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PageInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Page != null && message.hasOwnProperty("Page"))
            if (!$util.isInteger(message.Page))
                return "Page: integer expected";
        if (message.PageSize != null && message.hasOwnProperty("PageSize"))
            if (!$util.isInteger(message.PageSize))
                return "PageSize: integer expected";
        return null;
    };

    /**
     * Creates a PageInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageInfo} PageInfo
     */
    PageInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PageInfo)
            return object;
        let message = new $root.PageInfo();
        if (object.Page != null)
            message.Page = object.Page >>> 0;
        if (object.PageSize != null)
            message.PageSize = object.PageSize >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PageInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageInfo
     * @static
     * @param {PageInfo} message PageInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Page = 0;
            object.PageSize = 0;
        }
        if (message.Page != null && message.hasOwnProperty("Page"))
            object.Page = message.Page;
        if (message.PageSize != null && message.hasOwnProperty("PageSize"))
            object.PageSize = message.PageSize;
        return object;
    };

    /**
     * Converts this PageInfo to JSON.
     * @function toJSON
     * @memberof PageInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PageInfo
     * @function getTypeUrl
     * @memberof PageInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PageInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PageInfo";
    };

    return PageInfo;
})();

export const RebateInfo = $root.RebateInfo = (() => {

    /**
     * Properties of a RebateInfo.
     * @exports IRebateInfo
     * @interface IRebateInfo
     * @property {number|null} [UserID] RebateInfo UserID
     * @property {number|Long|null} [LoginTime] RebateInfo LoginTime
     * @property {string|null} [RegisterReb] RebateInfo RegisterReb
     * @property {string|null} [GameReb] RebateInfo GameReb
     * @property {string|null} [CashReb] RebateInfo CashReb
     */

    /**
     * Constructs a new RebateInfo.
     * @exports RebateInfo
     * @classdesc Represents a RebateInfo.
     * @implements IRebateInfo
     * @constructor
     * @param {IRebateInfo=} [properties] Properties to set
     */
    function RebateInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RebateInfo UserID.
     * @member {number} UserID
     * @memberof RebateInfo
     * @instance
     */
    RebateInfo.prototype.UserID = 0;

    /**
     * RebateInfo LoginTime.
     * @member {number|Long} LoginTime
     * @memberof RebateInfo
     * @instance
     */
    RebateInfo.prototype.LoginTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * RebateInfo RegisterReb.
     * @member {string} RegisterReb
     * @memberof RebateInfo
     * @instance
     */
    RebateInfo.prototype.RegisterReb = "";

    /**
     * RebateInfo GameReb.
     * @member {string} GameReb
     * @memberof RebateInfo
     * @instance
     */
    RebateInfo.prototype.GameReb = "";

    /**
     * RebateInfo CashReb.
     * @member {string} CashReb
     * @memberof RebateInfo
     * @instance
     */
    RebateInfo.prototype.CashReb = "";

    /**
     * Creates a new RebateInfo instance using the specified properties.
     * @function create
     * @memberof RebateInfo
     * @static
     * @param {IRebateInfo=} [properties] Properties to set
     * @returns {RebateInfo} RebateInfo instance
     */
    RebateInfo.create = function create(properties) {
        return new RebateInfo(properties);
    };

    /**
     * Encodes the specified RebateInfo message. Does not implicitly {@link RebateInfo.verify|verify} messages.
     * @function encode
     * @memberof RebateInfo
     * @static
     * @param {IRebateInfo} message RebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RebateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.LoginTime != null && Object.hasOwnProperty.call(message, "LoginTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.LoginTime);
        if (message.RegisterReb != null && Object.hasOwnProperty.call(message, "RegisterReb"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.RegisterReb);
        if (message.GameReb != null && Object.hasOwnProperty.call(message, "GameReb"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GameReb);
        if (message.CashReb != null && Object.hasOwnProperty.call(message, "CashReb"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.CashReb);
        return writer;
    };

    /**
     * Encodes the specified RebateInfo message, length delimited. Does not implicitly {@link RebateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RebateInfo
     * @static
     * @param {IRebateInfo} message RebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RebateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RebateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RebateInfo} RebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RebateInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RebateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.LoginTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.RegisterReb = reader.string();
                    break;
                }
            case 4: {
                    message.GameReb = reader.string();
                    break;
                }
            case 5: {
                    message.CashReb = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RebateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RebateInfo} RebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RebateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RebateInfo message.
     * @function verify
     * @memberof RebateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RebateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.LoginTime != null && message.hasOwnProperty("LoginTime"))
            if (!$util.isInteger(message.LoginTime) && !(message.LoginTime && $util.isInteger(message.LoginTime.low) && $util.isInteger(message.LoginTime.high)))
                return "LoginTime: integer|Long expected";
        if (message.RegisterReb != null && message.hasOwnProperty("RegisterReb"))
            if (!$util.isString(message.RegisterReb))
                return "RegisterReb: string expected";
        if (message.GameReb != null && message.hasOwnProperty("GameReb"))
            if (!$util.isString(message.GameReb))
                return "GameReb: string expected";
        if (message.CashReb != null && message.hasOwnProperty("CashReb"))
            if (!$util.isString(message.CashReb))
                return "CashReb: string expected";
        return null;
    };

    /**
     * Creates a RebateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RebateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RebateInfo} RebateInfo
     */
    RebateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RebateInfo)
            return object;
        let message = new $root.RebateInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.LoginTime != null)
            if ($util.Long)
                (message.LoginTime = $util.Long.fromValue(object.LoginTime)).unsigned = true;
            else if (typeof object.LoginTime === "string")
                message.LoginTime = parseInt(object.LoginTime, 10);
            else if (typeof object.LoginTime === "number")
                message.LoginTime = object.LoginTime;
            else if (typeof object.LoginTime === "object")
                message.LoginTime = new $util.LongBits(object.LoginTime.low >>> 0, object.LoginTime.high >>> 0).toNumber(true);
        if (object.RegisterReb != null)
            message.RegisterReb = String(object.RegisterReb);
        if (object.GameReb != null)
            message.GameReb = String(object.GameReb);
        if (object.CashReb != null)
            message.CashReb = String(object.CashReb);
        return message;
    };

    /**
     * Creates a plain object from a RebateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RebateInfo
     * @static
     * @param {RebateInfo} message RebateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RebateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LoginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LoginTime = options.longs === String ? "0" : 0;
            object.RegisterReb = "";
            object.GameReb = "";
            object.CashReb = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.LoginTime != null && message.hasOwnProperty("LoginTime"))
            if (typeof message.LoginTime === "number")
                object.LoginTime = options.longs === String ? String(message.LoginTime) : message.LoginTime;
            else
                object.LoginTime = options.longs === String ? $util.Long.prototype.toString.call(message.LoginTime) : options.longs === Number ? new $util.LongBits(message.LoginTime.low >>> 0, message.LoginTime.high >>> 0).toNumber(true) : message.LoginTime;
        if (message.RegisterReb != null && message.hasOwnProperty("RegisterReb"))
            object.RegisterReb = message.RegisterReb;
        if (message.GameReb != null && message.hasOwnProperty("GameReb"))
            object.GameReb = message.GameReb;
        if (message.CashReb != null && message.hasOwnProperty("CashReb"))
            object.CashReb = message.CashReb;
        return object;
    };

    /**
     * Converts this RebateInfo to JSON.
     * @function toJSON
     * @memberof RebateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RebateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RebateInfo
     * @function getTypeUrl
     * @memberof RebateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RebateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RebateInfo";
    };

    return RebateInfo;
})();

export const ChargeActivity = $root.ChargeActivity = (() => {

    /**
     * Properties of a ChargeActivity.
     * @exports IChargeActivity
     * @interface IChargeActivity
     * @property {number|null} [type] ChargeActivity type
     * @property {number|Long|null} [StartTime] ChargeActivity StartTime
     * @property {number|Long|null} [EndTime] ChargeActivity EndTime
     * @property {number|null} [Ratio] ChargeActivity Ratio
     * @property {number|null} [MaxBouns] ChargeActivity MaxBouns
     * @property {number|null} [DepositTotalStart] ChargeActivity DepositTotalStart
     * @property {number|null} [DepositTotalEnd] ChargeActivity DepositTotalEnd
     * @property {number|null} [WithdrawTotalStart] ChargeActivity WithdrawTotalStart
     * @property {number|null} [WithdrawTotalEnd] ChargeActivity WithdrawTotalEnd
     * @property {number|null} [DepositTimesStart] ChargeActivity DepositTimesStart
     * @property {number|null} [DepositTimesEnd] ChargeActivity DepositTimesEnd
     * @property {number|null} [DiffAmountStart] ChargeActivity DiffAmountStart
     * @property {number|null} [DiffAmountEnd] ChargeActivity DiffAmountEnd
     * @property {number|null} [TimeInterval] ChargeActivity TimeInterval
     * @property {number|null} [Duration] ChargeActivity Duration
     * @property {number|null} [LastChargeTimes] ChargeActivity LastChargeTimes
     * @property {number|null} [LastChargeAvg] ChargeActivity LastChargeAvg
     * @property {number|null} [JoinTimes] ChargeActivity JoinTimes
     * @property {number|null} [status] ChargeActivity status
     */

    /**
     * Constructs a new ChargeActivity.
     * @exports ChargeActivity
     * @classdesc Represents a ChargeActivity.
     * @implements IChargeActivity
     * @constructor
     * @param {IChargeActivity=} [properties] Properties to set
     */
    function ChargeActivity(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ChargeActivity type.
     * @member {number} type
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.type = 0;

    /**
     * ChargeActivity StartTime.
     * @member {number|Long} StartTime
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.StartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ChargeActivity EndTime.
     * @member {number|Long} EndTime
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ChargeActivity Ratio.
     * @member {number} Ratio
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.Ratio = 0;

    /**
     * ChargeActivity MaxBouns.
     * @member {number} MaxBouns
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.MaxBouns = 0;

    /**
     * ChargeActivity DepositTotalStart.
     * @member {number} DepositTotalStart
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DepositTotalStart = 0;

    /**
     * ChargeActivity DepositTotalEnd.
     * @member {number} DepositTotalEnd
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DepositTotalEnd = 0;

    /**
     * ChargeActivity WithdrawTotalStart.
     * @member {number} WithdrawTotalStart
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.WithdrawTotalStart = 0;

    /**
     * ChargeActivity WithdrawTotalEnd.
     * @member {number} WithdrawTotalEnd
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.WithdrawTotalEnd = 0;

    /**
     * ChargeActivity DepositTimesStart.
     * @member {number} DepositTimesStart
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DepositTimesStart = 0;

    /**
     * ChargeActivity DepositTimesEnd.
     * @member {number} DepositTimesEnd
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DepositTimesEnd = 0;

    /**
     * ChargeActivity DiffAmountStart.
     * @member {number} DiffAmountStart
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DiffAmountStart = 0;

    /**
     * ChargeActivity DiffAmountEnd.
     * @member {number} DiffAmountEnd
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.DiffAmountEnd = 0;

    /**
     * ChargeActivity TimeInterval.
     * @member {number} TimeInterval
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.TimeInterval = 0;

    /**
     * ChargeActivity Duration.
     * @member {number} Duration
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.Duration = 0;

    /**
     * ChargeActivity LastChargeTimes.
     * @member {number} LastChargeTimes
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.LastChargeTimes = 0;

    /**
     * ChargeActivity LastChargeAvg.
     * @member {number} LastChargeAvg
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.LastChargeAvg = 0;

    /**
     * ChargeActivity JoinTimes.
     * @member {number} JoinTimes
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.JoinTimes = 0;

    /**
     * ChargeActivity status.
     * @member {number} status
     * @memberof ChargeActivity
     * @instance
     */
    ChargeActivity.prototype.status = 0;

    /**
     * Creates a new ChargeActivity instance using the specified properties.
     * @function create
     * @memberof ChargeActivity
     * @static
     * @param {IChargeActivity=} [properties] Properties to set
     * @returns {ChargeActivity} ChargeActivity instance
     */
    ChargeActivity.create = function create(properties) {
        return new ChargeActivity(properties);
    };

    /**
     * Encodes the specified ChargeActivity message. Does not implicitly {@link ChargeActivity.verify|verify} messages.
     * @function encode
     * @memberof ChargeActivity
     * @static
     * @param {IChargeActivity} message ChargeActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChargeActivity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.type);
        if (message.StartTime != null && Object.hasOwnProperty.call(message, "StartTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StartTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.EndTime);
        if (message.Ratio != null && Object.hasOwnProperty.call(message, "Ratio"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Ratio);
        if (message.MaxBouns != null && Object.hasOwnProperty.call(message, "MaxBouns"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.MaxBouns);
        if (message.DepositTotalStart != null && Object.hasOwnProperty.call(message, "DepositTotalStart"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.DepositTotalStart);
        if (message.DepositTotalEnd != null && Object.hasOwnProperty.call(message, "DepositTotalEnd"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.DepositTotalEnd);
        if (message.WithdrawTotalStart != null && Object.hasOwnProperty.call(message, "WithdrawTotalStart"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.WithdrawTotalStart);
        if (message.WithdrawTotalEnd != null && Object.hasOwnProperty.call(message, "WithdrawTotalEnd"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.WithdrawTotalEnd);
        if (message.DepositTimesStart != null && Object.hasOwnProperty.call(message, "DepositTimesStart"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.DepositTimesStart);
        if (message.DepositTimesEnd != null && Object.hasOwnProperty.call(message, "DepositTimesEnd"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.DepositTimesEnd);
        if (message.DiffAmountStart != null && Object.hasOwnProperty.call(message, "DiffAmountStart"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.DiffAmountStart);
        if (message.DiffAmountEnd != null && Object.hasOwnProperty.call(message, "DiffAmountEnd"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.DiffAmountEnd);
        if (message.TimeInterval != null && Object.hasOwnProperty.call(message, "TimeInterval"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.TimeInterval);
        if (message.Duration != null && Object.hasOwnProperty.call(message, "Duration"))
            writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.Duration);
        if (message.LastChargeTimes != null && Object.hasOwnProperty.call(message, "LastChargeTimes"))
            writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.LastChargeTimes);
        if (message.LastChargeAvg != null && Object.hasOwnProperty.call(message, "LastChargeAvg"))
            writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.LastChargeAvg);
        if (message.JoinTimes != null && Object.hasOwnProperty.call(message, "JoinTimes"))
            writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.JoinTimes);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.status);
        return writer;
    };

    /**
     * Encodes the specified ChargeActivity message, length delimited. Does not implicitly {@link ChargeActivity.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ChargeActivity
     * @static
     * @param {IChargeActivity} message ChargeActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChargeActivity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChargeActivity message from the specified reader or buffer.
     * @function decode
     * @memberof ChargeActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChargeActivity} ChargeActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChargeActivity.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChargeActivity();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.uint32();
                    break;
                }
            case 2: {
                    message.StartTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.Ratio = reader.uint32();
                    break;
                }
            case 5: {
                    message.MaxBouns = reader.uint32();
                    break;
                }
            case 6: {
                    message.DepositTotalStart = reader.uint32();
                    break;
                }
            case 7: {
                    message.DepositTotalEnd = reader.uint32();
                    break;
                }
            case 8: {
                    message.WithdrawTotalStart = reader.uint32();
                    break;
                }
            case 9: {
                    message.WithdrawTotalEnd = reader.uint32();
                    break;
                }
            case 10: {
                    message.DepositTimesStart = reader.uint32();
                    break;
                }
            case 11: {
                    message.DepositTimesEnd = reader.uint32();
                    break;
                }
            case 12: {
                    message.DiffAmountStart = reader.uint32();
                    break;
                }
            case 13: {
                    message.DiffAmountEnd = reader.uint32();
                    break;
                }
            case 14: {
                    message.TimeInterval = reader.uint32();
                    break;
                }
            case 15: {
                    message.Duration = reader.uint32();
                    break;
                }
            case 16: {
                    message.LastChargeTimes = reader.uint32();
                    break;
                }
            case 17: {
                    message.LastChargeAvg = reader.uint32();
                    break;
                }
            case 18: {
                    message.JoinTimes = reader.uint32();
                    break;
                }
            case 19: {
                    message.status = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ChargeActivity message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ChargeActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ChargeActivity} ChargeActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChargeActivity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChargeActivity message.
     * @function verify
     * @memberof ChargeActivity
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChargeActivity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isInteger(message.type))
                return "type: integer expected";
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (!$util.isInteger(message.StartTime) && !(message.StartTime && $util.isInteger(message.StartTime.low) && $util.isInteger(message.StartTime.high)))
                return "StartTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.Ratio != null && message.hasOwnProperty("Ratio"))
            if (!$util.isInteger(message.Ratio))
                return "Ratio: integer expected";
        if (message.MaxBouns != null && message.hasOwnProperty("MaxBouns"))
            if (!$util.isInteger(message.MaxBouns))
                return "MaxBouns: integer expected";
        if (message.DepositTotalStart != null && message.hasOwnProperty("DepositTotalStart"))
            if (!$util.isInteger(message.DepositTotalStart))
                return "DepositTotalStart: integer expected";
        if (message.DepositTotalEnd != null && message.hasOwnProperty("DepositTotalEnd"))
            if (!$util.isInteger(message.DepositTotalEnd))
                return "DepositTotalEnd: integer expected";
        if (message.WithdrawTotalStart != null && message.hasOwnProperty("WithdrawTotalStart"))
            if (!$util.isInteger(message.WithdrawTotalStart))
                return "WithdrawTotalStart: integer expected";
        if (message.WithdrawTotalEnd != null && message.hasOwnProperty("WithdrawTotalEnd"))
            if (!$util.isInteger(message.WithdrawTotalEnd))
                return "WithdrawTotalEnd: integer expected";
        if (message.DepositTimesStart != null && message.hasOwnProperty("DepositTimesStart"))
            if (!$util.isInteger(message.DepositTimesStart))
                return "DepositTimesStart: integer expected";
        if (message.DepositTimesEnd != null && message.hasOwnProperty("DepositTimesEnd"))
            if (!$util.isInteger(message.DepositTimesEnd))
                return "DepositTimesEnd: integer expected";
        if (message.DiffAmountStart != null && message.hasOwnProperty("DiffAmountStart"))
            if (!$util.isInteger(message.DiffAmountStart))
                return "DiffAmountStart: integer expected";
        if (message.DiffAmountEnd != null && message.hasOwnProperty("DiffAmountEnd"))
            if (!$util.isInteger(message.DiffAmountEnd))
                return "DiffAmountEnd: integer expected";
        if (message.TimeInterval != null && message.hasOwnProperty("TimeInterval"))
            if (!$util.isInteger(message.TimeInterval))
                return "TimeInterval: integer expected";
        if (message.Duration != null && message.hasOwnProperty("Duration"))
            if (!$util.isInteger(message.Duration))
                return "Duration: integer expected";
        if (message.LastChargeTimes != null && message.hasOwnProperty("LastChargeTimes"))
            if (!$util.isInteger(message.LastChargeTimes))
                return "LastChargeTimes: integer expected";
        if (message.LastChargeAvg != null && message.hasOwnProperty("LastChargeAvg"))
            if (!$util.isInteger(message.LastChargeAvg))
                return "LastChargeAvg: integer expected";
        if (message.JoinTimes != null && message.hasOwnProperty("JoinTimes"))
            if (!$util.isInteger(message.JoinTimes))
                return "JoinTimes: integer expected";
        if (message.status != null && message.hasOwnProperty("status"))
            if (!$util.isInteger(message.status))
                return "status: integer expected";
        return null;
    };

    /**
     * Creates a ChargeActivity message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChargeActivity
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChargeActivity} ChargeActivity
     */
    ChargeActivity.fromObject = function fromObject(object) {
        if (object instanceof $root.ChargeActivity)
            return object;
        let message = new $root.ChargeActivity();
        if (object.type != null)
            message.type = object.type >>> 0;
        if (object.StartTime != null)
            if ($util.Long)
                (message.StartTime = $util.Long.fromValue(object.StartTime)).unsigned = true;
            else if (typeof object.StartTime === "string")
                message.StartTime = parseInt(object.StartTime, 10);
            else if (typeof object.StartTime === "number")
                message.StartTime = object.StartTime;
            else if (typeof object.StartTime === "object")
                message.StartTime = new $util.LongBits(object.StartTime.low >>> 0, object.StartTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.Ratio != null)
            message.Ratio = object.Ratio >>> 0;
        if (object.MaxBouns != null)
            message.MaxBouns = object.MaxBouns >>> 0;
        if (object.DepositTotalStart != null)
            message.DepositTotalStart = object.DepositTotalStart >>> 0;
        if (object.DepositTotalEnd != null)
            message.DepositTotalEnd = object.DepositTotalEnd >>> 0;
        if (object.WithdrawTotalStart != null)
            message.WithdrawTotalStart = object.WithdrawTotalStart >>> 0;
        if (object.WithdrawTotalEnd != null)
            message.WithdrawTotalEnd = object.WithdrawTotalEnd >>> 0;
        if (object.DepositTimesStart != null)
            message.DepositTimesStart = object.DepositTimesStart >>> 0;
        if (object.DepositTimesEnd != null)
            message.DepositTimesEnd = object.DepositTimesEnd >>> 0;
        if (object.DiffAmountStart != null)
            message.DiffAmountStart = object.DiffAmountStart >>> 0;
        if (object.DiffAmountEnd != null)
            message.DiffAmountEnd = object.DiffAmountEnd >>> 0;
        if (object.TimeInterval != null)
            message.TimeInterval = object.TimeInterval >>> 0;
        if (object.Duration != null)
            message.Duration = object.Duration >>> 0;
        if (object.LastChargeTimes != null)
            message.LastChargeTimes = object.LastChargeTimes >>> 0;
        if (object.LastChargeAvg != null)
            message.LastChargeAvg = object.LastChargeAvg >>> 0;
        if (object.JoinTimes != null)
            message.JoinTimes = object.JoinTimes >>> 0;
        if (object.status != null)
            message.status = object.status >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ChargeActivity message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChargeActivity
     * @static
     * @param {ChargeActivity} message ChargeActivity
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChargeActivity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            object.Ratio = 0;
            object.MaxBouns = 0;
            object.DepositTotalStart = 0;
            object.DepositTotalEnd = 0;
            object.WithdrawTotalStart = 0;
            object.WithdrawTotalEnd = 0;
            object.DepositTimesStart = 0;
            object.DepositTimesEnd = 0;
            object.DiffAmountStart = 0;
            object.DiffAmountEnd = 0;
            object.TimeInterval = 0;
            object.Duration = 0;
            object.LastChargeTimes = 0;
            object.LastChargeAvg = 0;
            object.JoinTimes = 0;
            object.status = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (typeof message.StartTime === "number")
                object.StartTime = options.longs === String ? String(message.StartTime) : message.StartTime;
            else
                object.StartTime = options.longs === String ? $util.Long.prototype.toString.call(message.StartTime) : options.longs === Number ? new $util.LongBits(message.StartTime.low >>> 0, message.StartTime.high >>> 0).toNumber(true) : message.StartTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.Ratio != null && message.hasOwnProperty("Ratio"))
            object.Ratio = message.Ratio;
        if (message.MaxBouns != null && message.hasOwnProperty("MaxBouns"))
            object.MaxBouns = message.MaxBouns;
        if (message.DepositTotalStart != null && message.hasOwnProperty("DepositTotalStart"))
            object.DepositTotalStart = message.DepositTotalStart;
        if (message.DepositTotalEnd != null && message.hasOwnProperty("DepositTotalEnd"))
            object.DepositTotalEnd = message.DepositTotalEnd;
        if (message.WithdrawTotalStart != null && message.hasOwnProperty("WithdrawTotalStart"))
            object.WithdrawTotalStart = message.WithdrawTotalStart;
        if (message.WithdrawTotalEnd != null && message.hasOwnProperty("WithdrawTotalEnd"))
            object.WithdrawTotalEnd = message.WithdrawTotalEnd;
        if (message.DepositTimesStart != null && message.hasOwnProperty("DepositTimesStart"))
            object.DepositTimesStart = message.DepositTimesStart;
        if (message.DepositTimesEnd != null && message.hasOwnProperty("DepositTimesEnd"))
            object.DepositTimesEnd = message.DepositTimesEnd;
        if (message.DiffAmountStart != null && message.hasOwnProperty("DiffAmountStart"))
            object.DiffAmountStart = message.DiffAmountStart;
        if (message.DiffAmountEnd != null && message.hasOwnProperty("DiffAmountEnd"))
            object.DiffAmountEnd = message.DiffAmountEnd;
        if (message.TimeInterval != null && message.hasOwnProperty("TimeInterval"))
            object.TimeInterval = message.TimeInterval;
        if (message.Duration != null && message.hasOwnProperty("Duration"))
            object.Duration = message.Duration;
        if (message.LastChargeTimes != null && message.hasOwnProperty("LastChargeTimes"))
            object.LastChargeTimes = message.LastChargeTimes;
        if (message.LastChargeAvg != null && message.hasOwnProperty("LastChargeAvg"))
            object.LastChargeAvg = message.LastChargeAvg;
        if (message.JoinTimes != null && message.hasOwnProperty("JoinTimes"))
            object.JoinTimes = message.JoinTimes;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
        return object;
    };

    /**
     * Converts this ChargeActivity to JSON.
     * @function toJSON
     * @memberof ChargeActivity
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChargeActivity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ChargeActivity
     * @function getTypeUrl
     * @memberof ChargeActivity
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ChargeActivity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ChargeActivity";
    };

    return ChargeActivity;
})();

export const ClientActivity = $root.ClientActivity = (() => {

    /**
     * Properties of a ClientActivity.
     * @exports IClientActivity
     * @interface IClientActivity
     * @property {number|null} [type] ClientActivity type
     * @property {number|Long|null} [LeftTime] ClientActivity LeftTime
     * @property {number|null} [Ratio] ClientActivity Ratio
     * @property {number|null} [MaxBouns] ClientActivity MaxBouns
     * @property {number|null} [Avg] ClientActivity Avg
     */

    /**
     * Constructs a new ClientActivity.
     * @exports ClientActivity
     * @classdesc Represents a ClientActivity.
     * @implements IClientActivity
     * @constructor
     * @param {IClientActivity=} [properties] Properties to set
     */
    function ClientActivity(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientActivity type.
     * @member {number} type
     * @memberof ClientActivity
     * @instance
     */
    ClientActivity.prototype.type = 0;

    /**
     * ClientActivity LeftTime.
     * @member {number|Long} LeftTime
     * @memberof ClientActivity
     * @instance
     */
    ClientActivity.prototype.LeftTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientActivity Ratio.
     * @member {number} Ratio
     * @memberof ClientActivity
     * @instance
     */
    ClientActivity.prototype.Ratio = 0;

    /**
     * ClientActivity MaxBouns.
     * @member {number} MaxBouns
     * @memberof ClientActivity
     * @instance
     */
    ClientActivity.prototype.MaxBouns = 0;

    /**
     * ClientActivity Avg.
     * @member {number} Avg
     * @memberof ClientActivity
     * @instance
     */
    ClientActivity.prototype.Avg = 0;

    /**
     * Creates a new ClientActivity instance using the specified properties.
     * @function create
     * @memberof ClientActivity
     * @static
     * @param {IClientActivity=} [properties] Properties to set
     * @returns {ClientActivity} ClientActivity instance
     */
    ClientActivity.create = function create(properties) {
        return new ClientActivity(properties);
    };

    /**
     * Encodes the specified ClientActivity message. Does not implicitly {@link ClientActivity.verify|verify} messages.
     * @function encode
     * @memberof ClientActivity
     * @static
     * @param {IClientActivity} message ClientActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientActivity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.type);
        if (message.LeftTime != null && Object.hasOwnProperty.call(message, "LeftTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.LeftTime);
        if (message.Ratio != null && Object.hasOwnProperty.call(message, "Ratio"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Ratio);
        if (message.MaxBouns != null && Object.hasOwnProperty.call(message, "MaxBouns"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MaxBouns);
        if (message.Avg != null && Object.hasOwnProperty.call(message, "Avg"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Avg);
        return writer;
    };

    /**
     * Encodes the specified ClientActivity message, length delimited. Does not implicitly {@link ClientActivity.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientActivity
     * @static
     * @param {IClientActivity} message ClientActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientActivity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientActivity message from the specified reader or buffer.
     * @function decode
     * @memberof ClientActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientActivity} ClientActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientActivity.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientActivity();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.uint32();
                    break;
                }
            case 2: {
                    message.LeftTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.Ratio = reader.uint32();
                    break;
                }
            case 4: {
                    message.MaxBouns = reader.uint32();
                    break;
                }
            case 5: {
                    message.Avg = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientActivity message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientActivity} ClientActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientActivity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientActivity message.
     * @function verify
     * @memberof ClientActivity
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientActivity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isInteger(message.type))
                return "type: integer expected";
        if (message.LeftTime != null && message.hasOwnProperty("LeftTime"))
            if (!$util.isInteger(message.LeftTime) && !(message.LeftTime && $util.isInteger(message.LeftTime.low) && $util.isInteger(message.LeftTime.high)))
                return "LeftTime: integer|Long expected";
        if (message.Ratio != null && message.hasOwnProperty("Ratio"))
            if (!$util.isInteger(message.Ratio))
                return "Ratio: integer expected";
        if (message.MaxBouns != null && message.hasOwnProperty("MaxBouns"))
            if (!$util.isInteger(message.MaxBouns))
                return "MaxBouns: integer expected";
        if (message.Avg != null && message.hasOwnProperty("Avg"))
            if (!$util.isInteger(message.Avg))
                return "Avg: integer expected";
        return null;
    };

    /**
     * Creates a ClientActivity message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientActivity
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientActivity} ClientActivity
     */
    ClientActivity.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientActivity)
            return object;
        let message = new $root.ClientActivity();
        if (object.type != null)
            message.type = object.type >>> 0;
        if (object.LeftTime != null)
            if ($util.Long)
                (message.LeftTime = $util.Long.fromValue(object.LeftTime)).unsigned = true;
            else if (typeof object.LeftTime === "string")
                message.LeftTime = parseInt(object.LeftTime, 10);
            else if (typeof object.LeftTime === "number")
                message.LeftTime = object.LeftTime;
            else if (typeof object.LeftTime === "object")
                message.LeftTime = new $util.LongBits(object.LeftTime.low >>> 0, object.LeftTime.high >>> 0).toNumber(true);
        if (object.Ratio != null)
            message.Ratio = object.Ratio >>> 0;
        if (object.MaxBouns != null)
            message.MaxBouns = object.MaxBouns >>> 0;
        if (object.Avg != null)
            message.Avg = object.Avg >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientActivity message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientActivity
     * @static
     * @param {ClientActivity} message ClientActivity
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientActivity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeftTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeftTime = options.longs === String ? "0" : 0;
            object.Ratio = 0;
            object.MaxBouns = 0;
            object.Avg = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.LeftTime != null && message.hasOwnProperty("LeftTime"))
            if (typeof message.LeftTime === "number")
                object.LeftTime = options.longs === String ? String(message.LeftTime) : message.LeftTime;
            else
                object.LeftTime = options.longs === String ? $util.Long.prototype.toString.call(message.LeftTime) : options.longs === Number ? new $util.LongBits(message.LeftTime.low >>> 0, message.LeftTime.high >>> 0).toNumber(true) : message.LeftTime;
        if (message.Ratio != null && message.hasOwnProperty("Ratio"))
            object.Ratio = message.Ratio;
        if (message.MaxBouns != null && message.hasOwnProperty("MaxBouns"))
            object.MaxBouns = message.MaxBouns;
        if (message.Avg != null && message.hasOwnProperty("Avg"))
            object.Avg = message.Avg;
        return object;
    };

    /**
     * Converts this ClientActivity to JSON.
     * @function toJSON
     * @memberof ClientActivity
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientActivity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientActivity
     * @function getTypeUrl
     * @memberof ClientActivity
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientActivity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientActivity";
    };

    return ClientActivity;
})();

export const UserJoinActivity = $root.UserJoinActivity = (() => {

    /**
     * Properties of a UserJoinActivity.
     * @exports IUserJoinActivity
     * @interface IUserJoinActivity
     * @property {number|null} [UserID] UserJoinActivity UserID
     * @property {number|Long|null} [StartTime] UserJoinActivity StartTime
     * @property {number|Long|null} [EndTime] UserJoinActivity EndTime
     * @property {number|Long|null} [RestartTime] UserJoinActivity RestartTime
     * @property {number|null} [Status] UserJoinActivity Status
     */

    /**
     * Constructs a new UserJoinActivity.
     * @exports UserJoinActivity
     * @classdesc Represents a UserJoinActivity.
     * @implements IUserJoinActivity
     * @constructor
     * @param {IUserJoinActivity=} [properties] Properties to set
     */
    function UserJoinActivity(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserJoinActivity UserID.
     * @member {number} UserID
     * @memberof UserJoinActivity
     * @instance
     */
    UserJoinActivity.prototype.UserID = 0;

    /**
     * UserJoinActivity StartTime.
     * @member {number|Long} StartTime
     * @memberof UserJoinActivity
     * @instance
     */
    UserJoinActivity.prototype.StartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * UserJoinActivity EndTime.
     * @member {number|Long} EndTime
     * @memberof UserJoinActivity
     * @instance
     */
    UserJoinActivity.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * UserJoinActivity RestartTime.
     * @member {number|Long} RestartTime
     * @memberof UserJoinActivity
     * @instance
     */
    UserJoinActivity.prototype.RestartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * UserJoinActivity Status.
     * @member {number} Status
     * @memberof UserJoinActivity
     * @instance
     */
    UserJoinActivity.prototype.Status = 0;

    /**
     * Creates a new UserJoinActivity instance using the specified properties.
     * @function create
     * @memberof UserJoinActivity
     * @static
     * @param {IUserJoinActivity=} [properties] Properties to set
     * @returns {UserJoinActivity} UserJoinActivity instance
     */
    UserJoinActivity.create = function create(properties) {
        return new UserJoinActivity(properties);
    };

    /**
     * Encodes the specified UserJoinActivity message. Does not implicitly {@link UserJoinActivity.verify|verify} messages.
     * @function encode
     * @memberof UserJoinActivity
     * @static
     * @param {IUserJoinActivity} message UserJoinActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserJoinActivity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StartTime != null && Object.hasOwnProperty.call(message, "StartTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StartTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.EndTime);
        if (message.RestartTime != null && Object.hasOwnProperty.call(message, "RestartTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.RestartTime);
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Status);
        return writer;
    };

    /**
     * Encodes the specified UserJoinActivity message, length delimited. Does not implicitly {@link UserJoinActivity.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserJoinActivity
     * @static
     * @param {IUserJoinActivity} message UserJoinActivity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserJoinActivity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserJoinActivity message from the specified reader or buffer.
     * @function decode
     * @memberof UserJoinActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserJoinActivity} UserJoinActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserJoinActivity.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserJoinActivity();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StartTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.RestartTime = reader.uint64();
                    break;
                }
            case 5: {
                    message.Status = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserJoinActivity message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserJoinActivity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserJoinActivity} UserJoinActivity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserJoinActivity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserJoinActivity message.
     * @function verify
     * @memberof UserJoinActivity
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserJoinActivity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (!$util.isInteger(message.StartTime) && !(message.StartTime && $util.isInteger(message.StartTime.low) && $util.isInteger(message.StartTime.high)))
                return "StartTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.RestartTime != null && message.hasOwnProperty("RestartTime"))
            if (!$util.isInteger(message.RestartTime) && !(message.RestartTime && $util.isInteger(message.RestartTime.low) && $util.isInteger(message.RestartTime.high)))
                return "RestartTime: integer|Long expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isInteger(message.Status))
                return "Status: integer expected";
        return null;
    };

    /**
     * Creates a UserJoinActivity message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserJoinActivity
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserJoinActivity} UserJoinActivity
     */
    UserJoinActivity.fromObject = function fromObject(object) {
        if (object instanceof $root.UserJoinActivity)
            return object;
        let message = new $root.UserJoinActivity();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StartTime != null)
            if ($util.Long)
                (message.StartTime = $util.Long.fromValue(object.StartTime)).unsigned = true;
            else if (typeof object.StartTime === "string")
                message.StartTime = parseInt(object.StartTime, 10);
            else if (typeof object.StartTime === "number")
                message.StartTime = object.StartTime;
            else if (typeof object.StartTime === "object")
                message.StartTime = new $util.LongBits(object.StartTime.low >>> 0, object.StartTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.RestartTime != null)
            if ($util.Long)
                (message.RestartTime = $util.Long.fromValue(object.RestartTime)).unsigned = true;
            else if (typeof object.RestartTime === "string")
                message.RestartTime = parseInt(object.RestartTime, 10);
            else if (typeof object.RestartTime === "number")
                message.RestartTime = object.RestartTime;
            else if (typeof object.RestartTime === "object")
                message.RestartTime = new $util.LongBits(object.RestartTime.low >>> 0, object.RestartTime.high >>> 0).toNumber(true);
        if (object.Status != null)
            message.Status = object.Status >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a UserJoinActivity message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserJoinActivity
     * @static
     * @param {UserJoinActivity} message UserJoinActivity
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserJoinActivity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.RestartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.RestartTime = options.longs === String ? "0" : 0;
            object.Status = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (typeof message.StartTime === "number")
                object.StartTime = options.longs === String ? String(message.StartTime) : message.StartTime;
            else
                object.StartTime = options.longs === String ? $util.Long.prototype.toString.call(message.StartTime) : options.longs === Number ? new $util.LongBits(message.StartTime.low >>> 0, message.StartTime.high >>> 0).toNumber(true) : message.StartTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.RestartTime != null && message.hasOwnProperty("RestartTime"))
            if (typeof message.RestartTime === "number")
                object.RestartTime = options.longs === String ? String(message.RestartTime) : message.RestartTime;
            else
                object.RestartTime = options.longs === String ? $util.Long.prototype.toString.call(message.RestartTime) : options.longs === Number ? new $util.LongBits(message.RestartTime.low >>> 0, message.RestartTime.high >>> 0).toNumber(true) : message.RestartTime;
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        return object;
    };

    /**
     * Converts this UserJoinActivity to JSON.
     * @function toJSON
     * @memberof UserJoinActivity
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserJoinActivity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserJoinActivity
     * @function getTypeUrl
     * @memberof UserJoinActivity
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserJoinActivity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserJoinActivity";
    };

    return UserJoinActivity;
})();

export const UserPayRecord = $root.UserPayRecord = (() => {

    /**
     * Properties of a UserPayRecord.
     * @exports IUserPayRecord
     * @interface IUserPayRecord
     * @property {string|null} [Order] UserPayRecord Order
     * @property {string|null} [BeiginTime] UserPayRecord BeiginTime
     * @property {string|null} [EndTime] UserPayRecord EndTime
     * @property {string|null} [Amount] UserPayRecord Amount
     * @property {string|null} [Status] UserPayRecord Status
     */

    /**
     * Constructs a new UserPayRecord.
     * @exports UserPayRecord
     * @classdesc Represents a UserPayRecord.
     * @implements IUserPayRecord
     * @constructor
     * @param {IUserPayRecord=} [properties] Properties to set
     */
    function UserPayRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserPayRecord Order.
     * @member {string} Order
     * @memberof UserPayRecord
     * @instance
     */
    UserPayRecord.prototype.Order = "";

    /**
     * UserPayRecord BeiginTime.
     * @member {string} BeiginTime
     * @memberof UserPayRecord
     * @instance
     */
    UserPayRecord.prototype.BeiginTime = "";

    /**
     * UserPayRecord EndTime.
     * @member {string} EndTime
     * @memberof UserPayRecord
     * @instance
     */
    UserPayRecord.prototype.EndTime = "";

    /**
     * UserPayRecord Amount.
     * @member {string} Amount
     * @memberof UserPayRecord
     * @instance
     */
    UserPayRecord.prototype.Amount = "";

    /**
     * UserPayRecord Status.
     * @member {string} Status
     * @memberof UserPayRecord
     * @instance
     */
    UserPayRecord.prototype.Status = "";

    /**
     * Creates a new UserPayRecord instance using the specified properties.
     * @function create
     * @memberof UserPayRecord
     * @static
     * @param {IUserPayRecord=} [properties] Properties to set
     * @returns {UserPayRecord} UserPayRecord instance
     */
    UserPayRecord.create = function create(properties) {
        return new UserPayRecord(properties);
    };

    /**
     * Encodes the specified UserPayRecord message. Does not implicitly {@link UserPayRecord.verify|verify} messages.
     * @function encode
     * @memberof UserPayRecord
     * @static
     * @param {IUserPayRecord} message UserPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserPayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Order != null && Object.hasOwnProperty.call(message, "Order"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Order);
        if (message.BeiginTime != null && Object.hasOwnProperty.call(message, "BeiginTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.BeiginTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.EndTime);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Amount);
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Status);
        return writer;
    };

    /**
     * Encodes the specified UserPayRecord message, length delimited. Does not implicitly {@link UserPayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserPayRecord
     * @static
     * @param {IUserPayRecord} message UserPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserPayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserPayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof UserPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserPayRecord} UserPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserPayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserPayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Order = reader.string();
                    break;
                }
            case 2: {
                    message.BeiginTime = reader.string();
                    break;
                }
            case 3: {
                    message.EndTime = reader.string();
                    break;
                }
            case 4: {
                    message.Amount = reader.string();
                    break;
                }
            case 5: {
                    message.Status = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserPayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserPayRecord} UserPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserPayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserPayRecord message.
     * @function verify
     * @memberof UserPayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserPayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Order != null && message.hasOwnProperty("Order"))
            if (!$util.isString(message.Order))
                return "Order: string expected";
        if (message.BeiginTime != null && message.hasOwnProperty("BeiginTime"))
            if (!$util.isString(message.BeiginTime))
                return "BeiginTime: string expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isString(message.EndTime))
                return "EndTime: string expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isString(message.Status))
                return "Status: string expected";
        return null;
    };

    /**
     * Creates a UserPayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserPayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserPayRecord} UserPayRecord
     */
    UserPayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.UserPayRecord)
            return object;
        let message = new $root.UserPayRecord();
        if (object.Order != null)
            message.Order = String(object.Order);
        if (object.BeiginTime != null)
            message.BeiginTime = String(object.BeiginTime);
        if (object.EndTime != null)
            message.EndTime = String(object.EndTime);
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Status != null)
            message.Status = String(object.Status);
        return message;
    };

    /**
     * Creates a plain object from a UserPayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserPayRecord
     * @static
     * @param {UserPayRecord} message UserPayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserPayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Order = "";
            object.BeiginTime = "";
            object.EndTime = "";
            object.Amount = "";
            object.Status = "";
        }
        if (message.Order != null && message.hasOwnProperty("Order"))
            object.Order = message.Order;
        if (message.BeiginTime != null && message.hasOwnProperty("BeiginTime"))
            object.BeiginTime = message.BeiginTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            object.EndTime = message.EndTime;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        return object;
    };

    /**
     * Converts this UserPayRecord to JSON.
     * @function toJSON
     * @memberof UserPayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserPayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserPayRecord
     * @function getTypeUrl
     * @memberof UserPayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserPayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserPayRecord";
    };

    return UserPayRecord;
})();

export const RankingStu = $root.RankingStu = (() => {

    /**
     * Properties of a RankingStu.
     * @exports IRankingStu
     * @interface IRankingStu
     * @property {number|null} [Ranking] RankingStu Ranking
     * @property {number|null} [UserID] RankingStu UserID
     * @property {string|null} [NickName] RankingStu NickName
     * @property {string|null} [HeaderURL] RankingStu HeaderURL
     * @property {number|Long|null} [ActBetGold] RankingStu ActBetGold
     * @property {number|Long|null} [Prize] RankingStu Prize
     */

    /**
     * Constructs a new RankingStu.
     * @exports RankingStu
     * @classdesc Represents a RankingStu.
     * @implements IRankingStu
     * @constructor
     * @param {IRankingStu=} [properties] Properties to set
     */
    function RankingStu(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RankingStu Ranking.
     * @member {number} Ranking
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.Ranking = 0;

    /**
     * RankingStu UserID.
     * @member {number} UserID
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.UserID = 0;

    /**
     * RankingStu NickName.
     * @member {string} NickName
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.NickName = "";

    /**
     * RankingStu HeaderURL.
     * @member {string} HeaderURL
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.HeaderURL = "";

    /**
     * RankingStu ActBetGold.
     * @member {number|Long} ActBetGold
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.ActBetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * RankingStu Prize.
     * @member {number|Long} Prize
     * @memberof RankingStu
     * @instance
     */
    RankingStu.prototype.Prize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new RankingStu instance using the specified properties.
     * @function create
     * @memberof RankingStu
     * @static
     * @param {IRankingStu=} [properties] Properties to set
     * @returns {RankingStu} RankingStu instance
     */
    RankingStu.create = function create(properties) {
        return new RankingStu(properties);
    };

    /**
     * Encodes the specified RankingStu message. Does not implicitly {@link RankingStu.verify|verify} messages.
     * @function encode
     * @memberof RankingStu
     * @static
     * @param {IRankingStu} message RankingStu message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RankingStu.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ranking != null && Object.hasOwnProperty.call(message, "Ranking"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ranking);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.HeaderURL);
        if (message.ActBetGold != null && Object.hasOwnProperty.call(message, "ActBetGold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.ActBetGold);
        if (message.Prize != null && Object.hasOwnProperty.call(message, "Prize"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.Prize);
        return writer;
    };

    /**
     * Encodes the specified RankingStu message, length delimited. Does not implicitly {@link RankingStu.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RankingStu
     * @static
     * @param {IRankingStu} message RankingStu message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RankingStu.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RankingStu message from the specified reader or buffer.
     * @function decode
     * @memberof RankingStu
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RankingStu} RankingStu
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RankingStu.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RankingStu();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ranking = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NickName = reader.string();
                    break;
                }
            case 4: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 5: {
                    message.ActBetGold = reader.uint64();
                    break;
                }
            case 6: {
                    message.Prize = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RankingStu message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RankingStu
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RankingStu} RankingStu
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RankingStu.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RankingStu message.
     * @function verify
     * @memberof RankingStu
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RankingStu.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ranking != null && message.hasOwnProperty("Ranking"))
            if (!$util.isInteger(message.Ranking))
                return "Ranking: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!$util.isString(message.NickName))
                return "NickName: string expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.ActBetGold != null && message.hasOwnProperty("ActBetGold"))
            if (!$util.isInteger(message.ActBetGold) && !(message.ActBetGold && $util.isInteger(message.ActBetGold.low) && $util.isInteger(message.ActBetGold.high)))
                return "ActBetGold: integer|Long expected";
        if (message.Prize != null && message.hasOwnProperty("Prize"))
            if (!$util.isInteger(message.Prize) && !(message.Prize && $util.isInteger(message.Prize.low) && $util.isInteger(message.Prize.high)))
                return "Prize: integer|Long expected";
        return null;
    };

    /**
     * Creates a RankingStu message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RankingStu
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RankingStu} RankingStu
     */
    RankingStu.fromObject = function fromObject(object) {
        if (object instanceof $root.RankingStu)
            return object;
        let message = new $root.RankingStu();
        if (object.Ranking != null)
            message.Ranking = object.Ranking >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            message.NickName = String(object.NickName);
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.ActBetGold != null)
            if ($util.Long)
                (message.ActBetGold = $util.Long.fromValue(object.ActBetGold)).unsigned = true;
            else if (typeof object.ActBetGold === "string")
                message.ActBetGold = parseInt(object.ActBetGold, 10);
            else if (typeof object.ActBetGold === "number")
                message.ActBetGold = object.ActBetGold;
            else if (typeof object.ActBetGold === "object")
                message.ActBetGold = new $util.LongBits(object.ActBetGold.low >>> 0, object.ActBetGold.high >>> 0).toNumber(true);
        if (object.Prize != null)
            if ($util.Long)
                (message.Prize = $util.Long.fromValue(object.Prize)).unsigned = true;
            else if (typeof object.Prize === "string")
                message.Prize = parseInt(object.Prize, 10);
            else if (typeof object.Prize === "number")
                message.Prize = object.Prize;
            else if (typeof object.Prize === "object")
                message.Prize = new $util.LongBits(object.Prize.low >>> 0, object.Prize.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a RankingStu message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RankingStu
     * @static
     * @param {RankingStu} message RankingStu
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RankingStu.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ranking = 0;
            object.UserID = 0;
            object.NickName = "";
            object.HeaderURL = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ActBetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ActBetGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Prize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Prize = options.longs === String ? "0" : 0;
        }
        if (message.Ranking != null && message.hasOwnProperty("Ranking"))
            object.Ranking = message.Ranking;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.ActBetGold != null && message.hasOwnProperty("ActBetGold"))
            if (typeof message.ActBetGold === "number")
                object.ActBetGold = options.longs === String ? String(message.ActBetGold) : message.ActBetGold;
            else
                object.ActBetGold = options.longs === String ? $util.Long.prototype.toString.call(message.ActBetGold) : options.longs === Number ? new $util.LongBits(message.ActBetGold.low >>> 0, message.ActBetGold.high >>> 0).toNumber(true) : message.ActBetGold;
        if (message.Prize != null && message.hasOwnProperty("Prize"))
            if (typeof message.Prize === "number")
                object.Prize = options.longs === String ? String(message.Prize) : message.Prize;
            else
                object.Prize = options.longs === String ? $util.Long.prototype.toString.call(message.Prize) : options.longs === Number ? new $util.LongBits(message.Prize.low >>> 0, message.Prize.high >>> 0).toNumber(true) : message.Prize;
        return object;
    };

    /**
     * Converts this RankingStu to JSON.
     * @function toJSON
     * @memberof RankingStu
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RankingStu.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RankingStu
     * @function getTypeUrl
     * @memberof RankingStu
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RankingStu.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RankingStu";
    };

    return RankingStu;
})();

export const PlayerInfo = $root.PlayerInfo = (() => {

    /**
     * Properties of a PlayerInfo.
     * @exports IPlayerInfo
     * @interface IPlayerInfo
     * @property {number|null} [UserID] PlayerInfo UserID
     * @property {Uint8Array|null} [NickName] PlayerInfo NickName
     * @property {string|null} [HeaderURL] PlayerInfo HeaderURL
     * @property {string|null} [Chip] PlayerInfo Chip
     * @property {number|null} [Diamond] PlayerInfo Diamond
     * @property {number|null} [Sex] PlayerInfo Sex
     * @property {number|null} [SeatNo] PlayerInfo SeatNo
     * @property {number|null} [FrontConnID] PlayerInfo FrontConnID
     * @property {number|null} [PlayStatus] PlayerInfo PlayStatus
     * @property {number|null} [SofaStatus] PlayerInfo SofaStatus
     * @property {string|null} [Bonus] PlayerInfo Bonus
     * @property {boolean|null} [NewPlayer] PlayerInfo NewPlayer
     * @property {number|null} [IP] PlayerInfo IP
     * @property {boolean|null} [IsPay] PlayerInfo IsPay
     * @property {string|null} [Deposit] PlayerInfo Deposit
     * @property {string|null} [Withdraw] PlayerInfo Withdraw
     */

    /**
     * Constructs a new PlayerInfo.
     * @exports PlayerInfo
     * @classdesc Represents a PlayerInfo.
     * @implements IPlayerInfo
     * @constructor
     * @param {IPlayerInfo=} [properties] Properties to set
     */
    function PlayerInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerInfo UserID.
     * @member {number} UserID
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.UserID = 0;

    /**
     * PlayerInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * PlayerInfo HeaderURL.
     * @member {string} HeaderURL
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.HeaderURL = "";

    /**
     * PlayerInfo Chip.
     * @member {string} Chip
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Chip = "";

    /**
     * PlayerInfo Diamond.
     * @member {number} Diamond
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Diamond = 0;

    /**
     * PlayerInfo Sex.
     * @member {number} Sex
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Sex = 0;

    /**
     * PlayerInfo SeatNo.
     * @member {number} SeatNo
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.SeatNo = 0;

    /**
     * PlayerInfo FrontConnID.
     * @member {number} FrontConnID
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.FrontConnID = 0;

    /**
     * PlayerInfo PlayStatus.
     * @member {number} PlayStatus
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.PlayStatus = 0;

    /**
     * PlayerInfo SofaStatus.
     * @member {number} SofaStatus
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.SofaStatus = 0;

    /**
     * PlayerInfo Bonus.
     * @member {string} Bonus
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Bonus = "";

    /**
     * PlayerInfo NewPlayer.
     * @member {boolean} NewPlayer
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.NewPlayer = false;

    /**
     * PlayerInfo IP.
     * @member {number} IP
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.IP = 0;

    /**
     * PlayerInfo IsPay.
     * @member {boolean} IsPay
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.IsPay = false;

    /**
     * PlayerInfo Deposit.
     * @member {string} Deposit
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Deposit = "";

    /**
     * PlayerInfo Withdraw.
     * @member {string} Withdraw
     * @memberof PlayerInfo
     * @instance
     */
    PlayerInfo.prototype.Withdraw = "";

    /**
     * Creates a new PlayerInfo instance using the specified properties.
     * @function create
     * @memberof PlayerInfo
     * @static
     * @param {IPlayerInfo=} [properties] Properties to set
     * @returns {PlayerInfo} PlayerInfo instance
     */
    PlayerInfo.create = function create(properties) {
        return new PlayerInfo(properties);
    };

    /**
     * Encodes the specified PlayerInfo message. Does not implicitly {@link PlayerInfo.verify|verify} messages.
     * @function encode
     * @memberof PlayerInfo
     * @static
     * @param {IPlayerInfo} message PlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.Diamond != null && Object.hasOwnProperty.call(message, "Diamond"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Diamond);
        if (message.Sex != null && Object.hasOwnProperty.call(message, "Sex"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.Sex);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.SeatNo);
        if (message.FrontConnID != null && Object.hasOwnProperty.call(message, "FrontConnID"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.FrontConnID);
        if (message.PlayStatus != null && Object.hasOwnProperty.call(message, "PlayStatus"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.PlayStatus);
        if (message.SofaStatus != null && Object.hasOwnProperty.call(message, "SofaStatus"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.SofaStatus);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.Bonus);
        if (message.NewPlayer != null && Object.hasOwnProperty.call(message, "NewPlayer"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.NewPlayer);
        if (message.IP != null && Object.hasOwnProperty.call(message, "IP"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.IP);
        if (message.IsPay != null && Object.hasOwnProperty.call(message, "IsPay"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.IsPay);
        if (message.Deposit != null && Object.hasOwnProperty.call(message, "Deposit"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.Deposit);
        if (message.Withdraw != null && Object.hasOwnProperty.call(message, "Withdraw"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.Withdraw);
        return writer;
    };

    /**
     * Encodes the specified PlayerInfo message, length delimited. Does not implicitly {@link PlayerInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerInfo
     * @static
     * @param {IPlayerInfo} message PlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerInfo} PlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.Diamond = reader.int32();
                    break;
                }
            case 6: {
                    message.Sex = reader.int32();
                    break;
                }
            case 7: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 8: {
                    message.FrontConnID = reader.uint32();
                    break;
                }
            case 9: {
                    message.PlayStatus = reader.uint32();
                    break;
                }
            case 10: {
                    message.SofaStatus = reader.uint32();
                    break;
                }
            case 11: {
                    message.Bonus = reader.string();
                    break;
                }
            case 12: {
                    message.NewPlayer = reader.bool();
                    break;
                }
            case 13: {
                    message.IP = reader.uint32();
                    break;
                }
            case 14: {
                    message.IsPay = reader.bool();
                    break;
                }
            case 15: {
                    message.Deposit = reader.string();
                    break;
                }
            case 16: {
                    message.Withdraw = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerInfo} PlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerInfo message.
     * @function verify
     * @memberof PlayerInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            if (!$util.isInteger(message.Diamond))
                return "Diamond: integer expected";
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            if (!$util.isInteger(message.Sex))
                return "Sex: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.FrontConnID != null && message.hasOwnProperty("FrontConnID"))
            if (!$util.isInteger(message.FrontConnID))
                return "FrontConnID: integer expected";
        if (message.PlayStatus != null && message.hasOwnProperty("PlayStatus"))
            if (!$util.isInteger(message.PlayStatus))
                return "PlayStatus: integer expected";
        if (message.SofaStatus != null && message.hasOwnProperty("SofaStatus"))
            if (!$util.isInteger(message.SofaStatus))
                return "SofaStatus: integer expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        if (message.NewPlayer != null && message.hasOwnProperty("NewPlayer"))
            if (typeof message.NewPlayer !== "boolean")
                return "NewPlayer: boolean expected";
        if (message.IP != null && message.hasOwnProperty("IP"))
            if (!$util.isInteger(message.IP))
                return "IP: integer expected";
        if (message.IsPay != null && message.hasOwnProperty("IsPay"))
            if (typeof message.IsPay !== "boolean")
                return "IsPay: boolean expected";
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            if (!$util.isString(message.Deposit))
                return "Deposit: string expected";
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            if (!$util.isString(message.Withdraw))
                return "Withdraw: string expected";
        return null;
    };

    /**
     * Creates a PlayerInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerInfo} PlayerInfo
     */
    PlayerInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerInfo)
            return object;
        let message = new $root.PlayerInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.Diamond != null)
            message.Diamond = object.Diamond | 0;
        if (object.Sex != null)
            message.Sex = object.Sex | 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.FrontConnID != null)
            message.FrontConnID = object.FrontConnID >>> 0;
        if (object.PlayStatus != null)
            message.PlayStatus = object.PlayStatus >>> 0;
        if (object.SofaStatus != null)
            message.SofaStatus = object.SofaStatus >>> 0;
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        if (object.NewPlayer != null)
            message.NewPlayer = Boolean(object.NewPlayer);
        if (object.IP != null)
            message.IP = object.IP >>> 0;
        if (object.IsPay != null)
            message.IsPay = Boolean(object.IsPay);
        if (object.Deposit != null)
            message.Deposit = String(object.Deposit);
        if (object.Withdraw != null)
            message.Withdraw = String(object.Withdraw);
        return message;
    };

    /**
     * Creates a plain object from a PlayerInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerInfo
     * @static
     * @param {PlayerInfo} message PlayerInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.Chip = "";
            object.Diamond = 0;
            object.Sex = 0;
            object.SeatNo = 0;
            object.FrontConnID = 0;
            object.PlayStatus = 0;
            object.SofaStatus = 0;
            object.Bonus = "";
            object.NewPlayer = false;
            object.IP = 0;
            object.IsPay = false;
            object.Deposit = "";
            object.Withdraw = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            object.Diamond = message.Diamond;
        if (message.Sex != null && message.hasOwnProperty("Sex"))
            object.Sex = message.Sex;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.FrontConnID != null && message.hasOwnProperty("FrontConnID"))
            object.FrontConnID = message.FrontConnID;
        if (message.PlayStatus != null && message.hasOwnProperty("PlayStatus"))
            object.PlayStatus = message.PlayStatus;
        if (message.SofaStatus != null && message.hasOwnProperty("SofaStatus"))
            object.SofaStatus = message.SofaStatus;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        if (message.NewPlayer != null && message.hasOwnProperty("NewPlayer"))
            object.NewPlayer = message.NewPlayer;
        if (message.IP != null && message.hasOwnProperty("IP"))
            object.IP = message.IP;
        if (message.IsPay != null && message.hasOwnProperty("IsPay"))
            object.IsPay = message.IsPay;
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            object.Deposit = message.Deposit;
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            object.Withdraw = message.Withdraw;
        return object;
    };

    /**
     * Converts this PlayerInfo to JSON.
     * @function toJSON
     * @memberof PlayerInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerInfo
     * @function getTypeUrl
     * @memberof PlayerInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerInfo";
    };

    return PlayerInfo;
})();

export const JackPotData = $root.JackPotData = (() => {

    /**
     * Properties of a JackPotData.
     * @exports IJackPotData
     * @interface IJackPotData
     * @property {number|null} [UserID] JackPotData UserID
     * @property {number|null} [DataTime] JackPotData DataTime
     * @property {number|null} [Rewards] JackPotData Rewards
     * @property {number|null} [Totalbet] JackPotData Totalbet
     * @property {number|null} [Typenum] JackPotData Typenum
     * @property {string|null} [NickName] JackPotData NickName
     * @property {string|null} [Headimg] JackPotData Headimg
     */

    /**
     * Constructs a new JackPotData.
     * @exports JackPotData
     * @classdesc Represents a JackPotData.
     * @implements IJackPotData
     * @constructor
     * @param {IJackPotData=} [properties] Properties to set
     */
    function JackPotData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * JackPotData UserID.
     * @member {number} UserID
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.UserID = 0;

    /**
     * JackPotData DataTime.
     * @member {number} DataTime
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.DataTime = 0;

    /**
     * JackPotData Rewards.
     * @member {number} Rewards
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.Rewards = 0;

    /**
     * JackPotData Totalbet.
     * @member {number} Totalbet
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.Totalbet = 0;

    /**
     * JackPotData Typenum.
     * @member {number} Typenum
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.Typenum = 0;

    /**
     * JackPotData NickName.
     * @member {string} NickName
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.NickName = "";

    /**
     * JackPotData Headimg.
     * @member {string} Headimg
     * @memberof JackPotData
     * @instance
     */
    JackPotData.prototype.Headimg = "";

    /**
     * Creates a new JackPotData instance using the specified properties.
     * @function create
     * @memberof JackPotData
     * @static
     * @param {IJackPotData=} [properties] Properties to set
     * @returns {JackPotData} JackPotData instance
     */
    JackPotData.create = function create(properties) {
        return new JackPotData(properties);
    };

    /**
     * Encodes the specified JackPotData message. Does not implicitly {@link JackPotData.verify|verify} messages.
     * @function encode
     * @memberof JackPotData
     * @static
     * @param {IJackPotData} message JackPotData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JackPotData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.DataTime != null && Object.hasOwnProperty.call(message, "DataTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DataTime);
        if (message.Rewards != null && Object.hasOwnProperty.call(message, "Rewards"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Rewards);
        if (message.Totalbet != null && Object.hasOwnProperty.call(message, "Totalbet"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Totalbet);
        if (message.Typenum != null && Object.hasOwnProperty.call(message, "Typenum"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Typenum);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.NickName);
        if (message.Headimg != null && Object.hasOwnProperty.call(message, "Headimg"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Headimg);
        return writer;
    };

    /**
     * Encodes the specified JackPotData message, length delimited. Does not implicitly {@link JackPotData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof JackPotData
     * @static
     * @param {IJackPotData} message JackPotData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JackPotData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a JackPotData message from the specified reader or buffer.
     * @function decode
     * @memberof JackPotData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {JackPotData} JackPotData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JackPotData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.JackPotData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.DataTime = reader.uint32();
                    break;
                }
            case 3: {
                    message.Rewards = reader.uint32();
                    break;
                }
            case 4: {
                    message.Totalbet = reader.uint32();
                    break;
                }
            case 5: {
                    message.Typenum = reader.uint32();
                    break;
                }
            case 6: {
                    message.NickName = reader.string();
                    break;
                }
            case 7: {
                    message.Headimg = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a JackPotData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof JackPotData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {JackPotData} JackPotData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JackPotData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a JackPotData message.
     * @function verify
     * @memberof JackPotData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    JackPotData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DataTime != null && message.hasOwnProperty("DataTime"))
            if (!$util.isInteger(message.DataTime))
                return "DataTime: integer expected";
        if (message.Rewards != null && message.hasOwnProperty("Rewards"))
            if (!$util.isInteger(message.Rewards))
                return "Rewards: integer expected";
        if (message.Totalbet != null && message.hasOwnProperty("Totalbet"))
            if (!$util.isInteger(message.Totalbet))
                return "Totalbet: integer expected";
        if (message.Typenum != null && message.hasOwnProperty("Typenum"))
            if (!$util.isInteger(message.Typenum))
                return "Typenum: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!$util.isString(message.NickName))
                return "NickName: string expected";
        if (message.Headimg != null && message.hasOwnProperty("Headimg"))
            if (!$util.isString(message.Headimg))
                return "Headimg: string expected";
        return null;
    };

    /**
     * Creates a JackPotData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof JackPotData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {JackPotData} JackPotData
     */
    JackPotData.fromObject = function fromObject(object) {
        if (object instanceof $root.JackPotData)
            return object;
        let message = new $root.JackPotData();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DataTime != null)
            message.DataTime = object.DataTime >>> 0;
        if (object.Rewards != null)
            message.Rewards = object.Rewards >>> 0;
        if (object.Totalbet != null)
            message.Totalbet = object.Totalbet >>> 0;
        if (object.Typenum != null)
            message.Typenum = object.Typenum >>> 0;
        if (object.NickName != null)
            message.NickName = String(object.NickName);
        if (object.Headimg != null)
            message.Headimg = String(object.Headimg);
        return message;
    };

    /**
     * Creates a plain object from a JackPotData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof JackPotData
     * @static
     * @param {JackPotData} message JackPotData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    JackPotData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.DataTime = 0;
            object.Rewards = 0;
            object.Totalbet = 0;
            object.Typenum = 0;
            object.NickName = "";
            object.Headimg = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DataTime != null && message.hasOwnProperty("DataTime"))
            object.DataTime = message.DataTime;
        if (message.Rewards != null && message.hasOwnProperty("Rewards"))
            object.Rewards = message.Rewards;
        if (message.Totalbet != null && message.hasOwnProperty("Totalbet"))
            object.Totalbet = message.Totalbet;
        if (message.Typenum != null && message.hasOwnProperty("Typenum"))
            object.Typenum = message.Typenum;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = message.NickName;
        if (message.Headimg != null && message.hasOwnProperty("Headimg"))
            object.Headimg = message.Headimg;
        return object;
    };

    /**
     * Converts this JackPotData to JSON.
     * @function toJSON
     * @memberof JackPotData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    JackPotData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for JackPotData
     * @function getTypeUrl
     * @memberof JackPotData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    JackPotData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/JackPotData";
    };

    return JackPotData;
})();

export const InviteUserAvatar = $root.InviteUserAvatar = (() => {

    /**
     * Properties of an InviteUserAvatar.
     * @exports IInviteUserAvatar
     * @interface IInviteUserAvatar
     * @property {number|null} [UserID] InviteUserAvatar UserID
     * @property {string|null} [Avatar] InviteUserAvatar Avatar
     */

    /**
     * Constructs a new InviteUserAvatar.
     * @exports InviteUserAvatar
     * @classdesc Represents an InviteUserAvatar.
     * @implements IInviteUserAvatar
     * @constructor
     * @param {IInviteUserAvatar=} [properties] Properties to set
     */
    function InviteUserAvatar(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InviteUserAvatar UserID.
     * @member {number} UserID
     * @memberof InviteUserAvatar
     * @instance
     */
    InviteUserAvatar.prototype.UserID = 0;

    /**
     * InviteUserAvatar Avatar.
     * @member {string} Avatar
     * @memberof InviteUserAvatar
     * @instance
     */
    InviteUserAvatar.prototype.Avatar = "";

    /**
     * Creates a new InviteUserAvatar instance using the specified properties.
     * @function create
     * @memberof InviteUserAvatar
     * @static
     * @param {IInviteUserAvatar=} [properties] Properties to set
     * @returns {InviteUserAvatar} InviteUserAvatar instance
     */
    InviteUserAvatar.create = function create(properties) {
        return new InviteUserAvatar(properties);
    };

    /**
     * Encodes the specified InviteUserAvatar message. Does not implicitly {@link InviteUserAvatar.verify|verify} messages.
     * @function encode
     * @memberof InviteUserAvatar
     * @static
     * @param {IInviteUserAvatar} message InviteUserAvatar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteUserAvatar.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Avatar != null && Object.hasOwnProperty.call(message, "Avatar"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Avatar);
        return writer;
    };

    /**
     * Encodes the specified InviteUserAvatar message, length delimited. Does not implicitly {@link InviteUserAvatar.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InviteUserAvatar
     * @static
     * @param {IInviteUserAvatar} message InviteUserAvatar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteUserAvatar.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InviteUserAvatar message from the specified reader or buffer.
     * @function decode
     * @memberof InviteUserAvatar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InviteUserAvatar} InviteUserAvatar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteUserAvatar.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InviteUserAvatar();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Avatar = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InviteUserAvatar message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InviteUserAvatar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InviteUserAvatar} InviteUserAvatar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteUserAvatar.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InviteUserAvatar message.
     * @function verify
     * @memberof InviteUserAvatar
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InviteUserAvatar.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Avatar != null && message.hasOwnProperty("Avatar"))
            if (!$util.isString(message.Avatar))
                return "Avatar: string expected";
        return null;
    };

    /**
     * Creates an InviteUserAvatar message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InviteUserAvatar
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InviteUserAvatar} InviteUserAvatar
     */
    InviteUserAvatar.fromObject = function fromObject(object) {
        if (object instanceof $root.InviteUserAvatar)
            return object;
        let message = new $root.InviteUserAvatar();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Avatar != null)
            message.Avatar = String(object.Avatar);
        return message;
    };

    /**
     * Creates a plain object from an InviteUserAvatar message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InviteUserAvatar
     * @static
     * @param {InviteUserAvatar} message InviteUserAvatar
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InviteUserAvatar.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Avatar = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Avatar != null && message.hasOwnProperty("Avatar"))
            object.Avatar = message.Avatar;
        return object;
    };

    /**
     * Converts this InviteUserAvatar to JSON.
     * @function toJSON
     * @memberof InviteUserAvatar
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InviteUserAvatar.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InviteUserAvatar
     * @function getTypeUrl
     * @memberof InviteUserAvatar
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InviteUserAvatar.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InviteUserAvatar";
    };

    return InviteUserAvatar;
})();

export const CP2dBetData = $root.CP2dBetData = (() => {

    /**
     * Properties of a CP2dBetData.
     * @exports ICP2dBetData
     * @interface ICP2dBetData
     * @property {number|null} [BetNum] CP2dBetData BetNum
     * @property {number|Long|null} [BetGold] CP2dBetData BetGold
     */

    /**
     * Constructs a new CP2dBetData.
     * @exports CP2dBetData
     * @classdesc Represents a CP2dBetData.
     * @implements ICP2dBetData
     * @constructor
     * @param {ICP2dBetData=} [properties] Properties to set
     */
    function CP2dBetData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CP2dBetData BetNum.
     * @member {number} BetNum
     * @memberof CP2dBetData
     * @instance
     */
    CP2dBetData.prototype.BetNum = 0;

    /**
     * CP2dBetData BetGold.
     * @member {number|Long} BetGold
     * @memberof CP2dBetData
     * @instance
     */
    CP2dBetData.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new CP2dBetData instance using the specified properties.
     * @function create
     * @memberof CP2dBetData
     * @static
     * @param {ICP2dBetData=} [properties] Properties to set
     * @returns {CP2dBetData} CP2dBetData instance
     */
    CP2dBetData.create = function create(properties) {
        return new CP2dBetData(properties);
    };

    /**
     * Encodes the specified CP2dBetData message. Does not implicitly {@link CP2dBetData.verify|verify} messages.
     * @function encode
     * @memberof CP2dBetData
     * @static
     * @param {ICP2dBetData} message CP2dBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP2dBetData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetNum != null && Object.hasOwnProperty.call(message, "BetNum"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetNum);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        return writer;
    };

    /**
     * Encodes the specified CP2dBetData message, length delimited. Does not implicitly {@link CP2dBetData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CP2dBetData
     * @static
     * @param {ICP2dBetData} message CP2dBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP2dBetData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CP2dBetData message from the specified reader or buffer.
     * @function decode
     * @memberof CP2dBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CP2dBetData} CP2dBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP2dBetData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CP2dBetData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 3: {
                    message.BetNum = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CP2dBetData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CP2dBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CP2dBetData} CP2dBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP2dBetData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CP2dBetData message.
     * @function verify
     * @memberof CP2dBetData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CP2dBetData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            if (!$util.isInteger(message.BetNum))
                return "BetNum: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a CP2dBetData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CP2dBetData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CP2dBetData} CP2dBetData
     */
    CP2dBetData.fromObject = function fromObject(object) {
        if (object instanceof $root.CP2dBetData)
            return object;
        let message = new $root.CP2dBetData();
        if (object.BetNum != null)
            message.BetNum = object.BetNum >>> 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a CP2dBetData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CP2dBetData
     * @static
     * @param {CP2dBetData} message CP2dBetData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CP2dBetData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetNum = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
        }
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            object.BetNum = message.BetNum;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        return object;
    };

    /**
     * Converts this CP2dBetData to JSON.
     * @function toJSON
     * @memberof CP2dBetData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CP2dBetData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CP2dBetData
     * @function getTypeUrl
     * @memberof CP2dBetData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CP2dBetData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CP2dBetData";
    };

    return CP2dBetData;
})();

export const CP2dNumRecordData = $root.CP2dNumRecordData = (() => {

    /**
     * Properties of a CP2dNumRecordData.
     * @exports ICP2dNumRecordData
     * @interface ICP2dNumRecordData
     * @property {number|null} [BetNum] CP2dNumRecordData BetNum
     * @property {number|Long|null} [NumStatus] CP2dNumRecordData NumStatus
     */

    /**
     * Constructs a new CP2dNumRecordData.
     * @exports CP2dNumRecordData
     * @classdesc Represents a CP2dNumRecordData.
     * @implements ICP2dNumRecordData
     * @constructor
     * @param {ICP2dNumRecordData=} [properties] Properties to set
     */
    function CP2dNumRecordData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CP2dNumRecordData BetNum.
     * @member {number} BetNum
     * @memberof CP2dNumRecordData
     * @instance
     */
    CP2dNumRecordData.prototype.BetNum = 0;

    /**
     * CP2dNumRecordData NumStatus.
     * @member {number|Long} NumStatus
     * @memberof CP2dNumRecordData
     * @instance
     */
    CP2dNumRecordData.prototype.NumStatus = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new CP2dNumRecordData instance using the specified properties.
     * @function create
     * @memberof CP2dNumRecordData
     * @static
     * @param {ICP2dNumRecordData=} [properties] Properties to set
     * @returns {CP2dNumRecordData} CP2dNumRecordData instance
     */
    CP2dNumRecordData.create = function create(properties) {
        return new CP2dNumRecordData(properties);
    };

    /**
     * Encodes the specified CP2dNumRecordData message. Does not implicitly {@link CP2dNumRecordData.verify|verify} messages.
     * @function encode
     * @memberof CP2dNumRecordData
     * @static
     * @param {ICP2dNumRecordData} message CP2dNumRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP2dNumRecordData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetNum != null && Object.hasOwnProperty.call(message, "BetNum"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.BetNum);
        if (message.NumStatus != null && Object.hasOwnProperty.call(message, "NumStatus"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.NumStatus);
        return writer;
    };

    /**
     * Encodes the specified CP2dNumRecordData message, length delimited. Does not implicitly {@link CP2dNumRecordData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CP2dNumRecordData
     * @static
     * @param {ICP2dNumRecordData} message CP2dNumRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP2dNumRecordData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CP2dNumRecordData message from the specified reader or buffer.
     * @function decode
     * @memberof CP2dNumRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CP2dNumRecordData} CP2dNumRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP2dNumRecordData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CP2dNumRecordData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetNum = reader.uint32();
                    break;
                }
            case 2: {
                    message.NumStatus = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CP2dNumRecordData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CP2dNumRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CP2dNumRecordData} CP2dNumRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP2dNumRecordData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CP2dNumRecordData message.
     * @function verify
     * @memberof CP2dNumRecordData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CP2dNumRecordData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            if (!$util.isInteger(message.BetNum))
                return "BetNum: integer expected";
        if (message.NumStatus != null && message.hasOwnProperty("NumStatus"))
            if (!$util.isInteger(message.NumStatus) && !(message.NumStatus && $util.isInteger(message.NumStatus.low) && $util.isInteger(message.NumStatus.high)))
                return "NumStatus: integer|Long expected";
        return null;
    };

    /**
     * Creates a CP2dNumRecordData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CP2dNumRecordData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CP2dNumRecordData} CP2dNumRecordData
     */
    CP2dNumRecordData.fromObject = function fromObject(object) {
        if (object instanceof $root.CP2dNumRecordData)
            return object;
        let message = new $root.CP2dNumRecordData();
        if (object.BetNum != null)
            message.BetNum = object.BetNum >>> 0;
        if (object.NumStatus != null)
            if ($util.Long)
                (message.NumStatus = $util.Long.fromValue(object.NumStatus)).unsigned = true;
            else if (typeof object.NumStatus === "string")
                message.NumStatus = parseInt(object.NumStatus, 10);
            else if (typeof object.NumStatus === "number")
                message.NumStatus = object.NumStatus;
            else if (typeof object.NumStatus === "object")
                message.NumStatus = new $util.LongBits(object.NumStatus.low >>> 0, object.NumStatus.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a CP2dNumRecordData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CP2dNumRecordData
     * @static
     * @param {CP2dNumRecordData} message CP2dNumRecordData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CP2dNumRecordData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetNum = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NumStatus = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NumStatus = options.longs === String ? "0" : 0;
        }
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            object.BetNum = message.BetNum;
        if (message.NumStatus != null && message.hasOwnProperty("NumStatus"))
            if (typeof message.NumStatus === "number")
                object.NumStatus = options.longs === String ? String(message.NumStatus) : message.NumStatus;
            else
                object.NumStatus = options.longs === String ? $util.Long.prototype.toString.call(message.NumStatus) : options.longs === Number ? new $util.LongBits(message.NumStatus.low >>> 0, message.NumStatus.high >>> 0).toNumber(true) : message.NumStatus;
        return object;
    };

    /**
     * Converts this CP2dNumRecordData to JSON.
     * @function toJSON
     * @memberof CP2dNumRecordData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CP2dNumRecordData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CP2dNumRecordData
     * @function getTypeUrl
     * @memberof CP2dNumRecordData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CP2dNumRecordData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CP2dNumRecordData";
    };

    return CP2dNumRecordData;
})();

export const CP3dBetData = $root.CP3dBetData = (() => {

    /**
     * Properties of a CP3dBetData.
     * @exports ICP3dBetData
     * @interface ICP3dBetData
     * @property {number|null} [BetNum] CP3dBetData BetNum
     * @property {number|Long|null} [BetGold] CP3dBetData BetGold
     */

    /**
     * Constructs a new CP3dBetData.
     * @exports CP3dBetData
     * @classdesc Represents a CP3dBetData.
     * @implements ICP3dBetData
     * @constructor
     * @param {ICP3dBetData=} [properties] Properties to set
     */
    function CP3dBetData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CP3dBetData BetNum.
     * @member {number} BetNum
     * @memberof CP3dBetData
     * @instance
     */
    CP3dBetData.prototype.BetNum = 0;

    /**
     * CP3dBetData BetGold.
     * @member {number|Long} BetGold
     * @memberof CP3dBetData
     * @instance
     */
    CP3dBetData.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new CP3dBetData instance using the specified properties.
     * @function create
     * @memberof CP3dBetData
     * @static
     * @param {ICP3dBetData=} [properties] Properties to set
     * @returns {CP3dBetData} CP3dBetData instance
     */
    CP3dBetData.create = function create(properties) {
        return new CP3dBetData(properties);
    };

    /**
     * Encodes the specified CP3dBetData message. Does not implicitly {@link CP3dBetData.verify|verify} messages.
     * @function encode
     * @memberof CP3dBetData
     * @static
     * @param {ICP3dBetData} message CP3dBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP3dBetData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetNum != null && Object.hasOwnProperty.call(message, "BetNum"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetNum);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        return writer;
    };

    /**
     * Encodes the specified CP3dBetData message, length delimited. Does not implicitly {@link CP3dBetData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CP3dBetData
     * @static
     * @param {ICP3dBetData} message CP3dBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP3dBetData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CP3dBetData message from the specified reader or buffer.
     * @function decode
     * @memberof CP3dBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CP3dBetData} CP3dBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP3dBetData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CP3dBetData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 3: {
                    message.BetNum = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CP3dBetData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CP3dBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CP3dBetData} CP3dBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP3dBetData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CP3dBetData message.
     * @function verify
     * @memberof CP3dBetData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CP3dBetData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            if (!$util.isInteger(message.BetNum))
                return "BetNum: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a CP3dBetData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CP3dBetData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CP3dBetData} CP3dBetData
     */
    CP3dBetData.fromObject = function fromObject(object) {
        if (object instanceof $root.CP3dBetData)
            return object;
        let message = new $root.CP3dBetData();
        if (object.BetNum != null)
            message.BetNum = object.BetNum >>> 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a CP3dBetData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CP3dBetData
     * @static
     * @param {CP3dBetData} message CP3dBetData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CP3dBetData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetNum = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
        }
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            object.BetNum = message.BetNum;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        return object;
    };

    /**
     * Converts this CP3dBetData to JSON.
     * @function toJSON
     * @memberof CP3dBetData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CP3dBetData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CP3dBetData
     * @function getTypeUrl
     * @memberof CP3dBetData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CP3dBetData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CP3dBetData";
    };

    return CP3dBetData;
})();

export const CP3dNumRecordData = $root.CP3dNumRecordData = (() => {

    /**
     * Properties of a CP3dNumRecordData.
     * @exports ICP3dNumRecordData
     * @interface ICP3dNumRecordData
     * @property {number|null} [BetNum] CP3dNumRecordData BetNum
     * @property {number|Long|null} [NumStatus] CP3dNumRecordData NumStatus
     */

    /**
     * Constructs a new CP3dNumRecordData.
     * @exports CP3dNumRecordData
     * @classdesc Represents a CP3dNumRecordData.
     * @implements ICP3dNumRecordData
     * @constructor
     * @param {ICP3dNumRecordData=} [properties] Properties to set
     */
    function CP3dNumRecordData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CP3dNumRecordData BetNum.
     * @member {number} BetNum
     * @memberof CP3dNumRecordData
     * @instance
     */
    CP3dNumRecordData.prototype.BetNum = 0;

    /**
     * CP3dNumRecordData NumStatus.
     * @member {number|Long} NumStatus
     * @memberof CP3dNumRecordData
     * @instance
     */
    CP3dNumRecordData.prototype.NumStatus = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new CP3dNumRecordData instance using the specified properties.
     * @function create
     * @memberof CP3dNumRecordData
     * @static
     * @param {ICP3dNumRecordData=} [properties] Properties to set
     * @returns {CP3dNumRecordData} CP3dNumRecordData instance
     */
    CP3dNumRecordData.create = function create(properties) {
        return new CP3dNumRecordData(properties);
    };

    /**
     * Encodes the specified CP3dNumRecordData message. Does not implicitly {@link CP3dNumRecordData.verify|verify} messages.
     * @function encode
     * @memberof CP3dNumRecordData
     * @static
     * @param {ICP3dNumRecordData} message CP3dNumRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP3dNumRecordData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetNum != null && Object.hasOwnProperty.call(message, "BetNum"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.BetNum);
        if (message.NumStatus != null && Object.hasOwnProperty.call(message, "NumStatus"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.NumStatus);
        return writer;
    };

    /**
     * Encodes the specified CP3dNumRecordData message, length delimited. Does not implicitly {@link CP3dNumRecordData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CP3dNumRecordData
     * @static
     * @param {ICP3dNumRecordData} message CP3dNumRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CP3dNumRecordData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CP3dNumRecordData message from the specified reader or buffer.
     * @function decode
     * @memberof CP3dNumRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CP3dNumRecordData} CP3dNumRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP3dNumRecordData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CP3dNumRecordData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetNum = reader.uint32();
                    break;
                }
            case 2: {
                    message.NumStatus = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CP3dNumRecordData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CP3dNumRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CP3dNumRecordData} CP3dNumRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CP3dNumRecordData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CP3dNumRecordData message.
     * @function verify
     * @memberof CP3dNumRecordData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CP3dNumRecordData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            if (!$util.isInteger(message.BetNum))
                return "BetNum: integer expected";
        if (message.NumStatus != null && message.hasOwnProperty("NumStatus"))
            if (!$util.isInteger(message.NumStatus) && !(message.NumStatus && $util.isInteger(message.NumStatus.low) && $util.isInteger(message.NumStatus.high)))
                return "NumStatus: integer|Long expected";
        return null;
    };

    /**
     * Creates a CP3dNumRecordData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CP3dNumRecordData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CP3dNumRecordData} CP3dNumRecordData
     */
    CP3dNumRecordData.fromObject = function fromObject(object) {
        if (object instanceof $root.CP3dNumRecordData)
            return object;
        let message = new $root.CP3dNumRecordData();
        if (object.BetNum != null)
            message.BetNum = object.BetNum >>> 0;
        if (object.NumStatus != null)
            if ($util.Long)
                (message.NumStatus = $util.Long.fromValue(object.NumStatus)).unsigned = true;
            else if (typeof object.NumStatus === "string")
                message.NumStatus = parseInt(object.NumStatus, 10);
            else if (typeof object.NumStatus === "number")
                message.NumStatus = object.NumStatus;
            else if (typeof object.NumStatus === "object")
                message.NumStatus = new $util.LongBits(object.NumStatus.low >>> 0, object.NumStatus.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a CP3dNumRecordData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CP3dNumRecordData
     * @static
     * @param {CP3dNumRecordData} message CP3dNumRecordData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CP3dNumRecordData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetNum = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NumStatus = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NumStatus = options.longs === String ? "0" : 0;
        }
        if (message.BetNum != null && message.hasOwnProperty("BetNum"))
            object.BetNum = message.BetNum;
        if (message.NumStatus != null && message.hasOwnProperty("NumStatus"))
            if (typeof message.NumStatus === "number")
                object.NumStatus = options.longs === String ? String(message.NumStatus) : message.NumStatus;
            else
                object.NumStatus = options.longs === String ? $util.Long.prototype.toString.call(message.NumStatus) : options.longs === Number ? new $util.LongBits(message.NumStatus.low >>> 0, message.NumStatus.high >>> 0).toNumber(true) : message.NumStatus;
        return object;
    };

    /**
     * Converts this CP3dNumRecordData to JSON.
     * @function toJSON
     * @memberof CP3dNumRecordData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CP3dNumRecordData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CP3dNumRecordData
     * @function getTypeUrl
     * @memberof CP3dNumRecordData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CP3dNumRecordData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CP3dNumRecordData";
    };

    return CP3dNumRecordData;
})();

export const Turn3GetGoldData = $root.Turn3GetGoldData = (() => {

    /**
     * Properties of a Turn3GetGoldData.
     * @exports ITurn3GetGoldData
     * @interface ITurn3GetGoldData
     * @property {number|Long|null} [PrizeTime] Turn3GetGoldData PrizeTime
     * @property {string|null} [strNowGiftGold] Turn3GetGoldData strNowGiftGold
     * @property {string|null} [strPlayGiftGold] Turn3GetGoldData strPlayGiftGold
     */

    /**
     * Constructs a new Turn3GetGoldData.
     * @exports Turn3GetGoldData
     * @classdesc Represents a Turn3GetGoldData.
     * @implements ITurn3GetGoldData
     * @constructor
     * @param {ITurn3GetGoldData=} [properties] Properties to set
     */
    function Turn3GetGoldData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Turn3GetGoldData PrizeTime.
     * @member {number|Long} PrizeTime
     * @memberof Turn3GetGoldData
     * @instance
     */
    Turn3GetGoldData.prototype.PrizeTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Turn3GetGoldData strNowGiftGold.
     * @member {string} strNowGiftGold
     * @memberof Turn3GetGoldData
     * @instance
     */
    Turn3GetGoldData.prototype.strNowGiftGold = "";

    /**
     * Turn3GetGoldData strPlayGiftGold.
     * @member {string} strPlayGiftGold
     * @memberof Turn3GetGoldData
     * @instance
     */
    Turn3GetGoldData.prototype.strPlayGiftGold = "";

    /**
     * Creates a new Turn3GetGoldData instance using the specified properties.
     * @function create
     * @memberof Turn3GetGoldData
     * @static
     * @param {ITurn3GetGoldData=} [properties] Properties to set
     * @returns {Turn3GetGoldData} Turn3GetGoldData instance
     */
    Turn3GetGoldData.create = function create(properties) {
        return new Turn3GetGoldData(properties);
    };

    /**
     * Encodes the specified Turn3GetGoldData message. Does not implicitly {@link Turn3GetGoldData.verify|verify} messages.
     * @function encode
     * @memberof Turn3GetGoldData
     * @static
     * @param {ITurn3GetGoldData} message Turn3GetGoldData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3GetGoldData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PrizeTime != null && Object.hasOwnProperty.call(message, "PrizeTime"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PrizeTime);
        if (message.strNowGiftGold != null && Object.hasOwnProperty.call(message, "strNowGiftGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.strNowGiftGold);
        if (message.strPlayGiftGold != null && Object.hasOwnProperty.call(message, "strPlayGiftGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strPlayGiftGold);
        return writer;
    };

    /**
     * Encodes the specified Turn3GetGoldData message, length delimited. Does not implicitly {@link Turn3GetGoldData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Turn3GetGoldData
     * @static
     * @param {ITurn3GetGoldData} message Turn3GetGoldData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3GetGoldData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Turn3GetGoldData message from the specified reader or buffer.
     * @function decode
     * @memberof Turn3GetGoldData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Turn3GetGoldData} Turn3GetGoldData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3GetGoldData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Turn3GetGoldData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PrizeTime = reader.uint64();
                    break;
                }
            case 2: {
                    message.strNowGiftGold = reader.string();
                    break;
                }
            case 3: {
                    message.strPlayGiftGold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Turn3GetGoldData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Turn3GetGoldData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Turn3GetGoldData} Turn3GetGoldData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3GetGoldData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Turn3GetGoldData message.
     * @function verify
     * @memberof Turn3GetGoldData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Turn3GetGoldData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PrizeTime != null && message.hasOwnProperty("PrizeTime"))
            if (!$util.isInteger(message.PrizeTime) && !(message.PrizeTime && $util.isInteger(message.PrizeTime.low) && $util.isInteger(message.PrizeTime.high)))
                return "PrizeTime: integer|Long expected";
        if (message.strNowGiftGold != null && message.hasOwnProperty("strNowGiftGold"))
            if (!$util.isString(message.strNowGiftGold))
                return "strNowGiftGold: string expected";
        if (message.strPlayGiftGold != null && message.hasOwnProperty("strPlayGiftGold"))
            if (!$util.isString(message.strPlayGiftGold))
                return "strPlayGiftGold: string expected";
        return null;
    };

    /**
     * Creates a Turn3GetGoldData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Turn3GetGoldData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Turn3GetGoldData} Turn3GetGoldData
     */
    Turn3GetGoldData.fromObject = function fromObject(object) {
        if (object instanceof $root.Turn3GetGoldData)
            return object;
        let message = new $root.Turn3GetGoldData();
        if (object.PrizeTime != null)
            if ($util.Long)
                (message.PrizeTime = $util.Long.fromValue(object.PrizeTime)).unsigned = true;
            else if (typeof object.PrizeTime === "string")
                message.PrizeTime = parseInt(object.PrizeTime, 10);
            else if (typeof object.PrizeTime === "number")
                message.PrizeTime = object.PrizeTime;
            else if (typeof object.PrizeTime === "object")
                message.PrizeTime = new $util.LongBits(object.PrizeTime.low >>> 0, object.PrizeTime.high >>> 0).toNumber(true);
        if (object.strNowGiftGold != null)
            message.strNowGiftGold = String(object.strNowGiftGold);
        if (object.strPlayGiftGold != null)
            message.strPlayGiftGold = String(object.strPlayGiftGold);
        return message;
    };

    /**
     * Creates a plain object from a Turn3GetGoldData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Turn3GetGoldData
     * @static
     * @param {Turn3GetGoldData} message Turn3GetGoldData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Turn3GetGoldData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeTime = options.longs === String ? "0" : 0;
            object.strNowGiftGold = "";
            object.strPlayGiftGold = "";
        }
        if (message.PrizeTime != null && message.hasOwnProperty("PrizeTime"))
            if (typeof message.PrizeTime === "number")
                object.PrizeTime = options.longs === String ? String(message.PrizeTime) : message.PrizeTime;
            else
                object.PrizeTime = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeTime) : options.longs === Number ? new $util.LongBits(message.PrizeTime.low >>> 0, message.PrizeTime.high >>> 0).toNumber(true) : message.PrizeTime;
        if (message.strNowGiftGold != null && message.hasOwnProperty("strNowGiftGold"))
            object.strNowGiftGold = message.strNowGiftGold;
        if (message.strPlayGiftGold != null && message.hasOwnProperty("strPlayGiftGold"))
            object.strPlayGiftGold = message.strPlayGiftGold;
        return object;
    };

    /**
     * Converts this Turn3GetGoldData to JSON.
     * @function toJSON
     * @memberof Turn3GetGoldData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Turn3GetGoldData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Turn3GetGoldData
     * @function getTypeUrl
     * @memberof Turn3GetGoldData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Turn3GetGoldData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Turn3GetGoldData";
    };

    return Turn3GetGoldData;
})();

export const Turn3GetWinRecordData = $root.Turn3GetWinRecordData = (() => {

    /**
     * Properties of a Turn3GetWinRecordData.
     * @exports ITurn3GetWinRecordData
     * @interface ITurn3GetWinRecordData
     * @property {number|Long|null} [ActBTime] Turn3GetWinRecordData ActBTime
     * @property {string|null} [strGiftGold] Turn3GetWinRecordData strGiftGold
     * @property {number|null} [ActType] Turn3GetWinRecordData ActType
     */

    /**
     * Constructs a new Turn3GetWinRecordData.
     * @exports Turn3GetWinRecordData
     * @classdesc Represents a Turn3GetWinRecordData.
     * @implements ITurn3GetWinRecordData
     * @constructor
     * @param {ITurn3GetWinRecordData=} [properties] Properties to set
     */
    function Turn3GetWinRecordData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Turn3GetWinRecordData ActBTime.
     * @member {number|Long} ActBTime
     * @memberof Turn3GetWinRecordData
     * @instance
     */
    Turn3GetWinRecordData.prototype.ActBTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Turn3GetWinRecordData strGiftGold.
     * @member {string} strGiftGold
     * @memberof Turn3GetWinRecordData
     * @instance
     */
    Turn3GetWinRecordData.prototype.strGiftGold = "";

    /**
     * Turn3GetWinRecordData ActType.
     * @member {number} ActType
     * @memberof Turn3GetWinRecordData
     * @instance
     */
    Turn3GetWinRecordData.prototype.ActType = 0;

    /**
     * Creates a new Turn3GetWinRecordData instance using the specified properties.
     * @function create
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {ITurn3GetWinRecordData=} [properties] Properties to set
     * @returns {Turn3GetWinRecordData} Turn3GetWinRecordData instance
     */
    Turn3GetWinRecordData.create = function create(properties) {
        return new Turn3GetWinRecordData(properties);
    };

    /**
     * Encodes the specified Turn3GetWinRecordData message. Does not implicitly {@link Turn3GetWinRecordData.verify|verify} messages.
     * @function encode
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {ITurn3GetWinRecordData} message Turn3GetWinRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3GetWinRecordData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ActBTime != null && Object.hasOwnProperty.call(message, "ActBTime"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.ActBTime);
        if (message.strGiftGold != null && Object.hasOwnProperty.call(message, "strGiftGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.strGiftGold);
        if (message.ActType != null && Object.hasOwnProperty.call(message, "ActType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ActType);
        return writer;
    };

    /**
     * Encodes the specified Turn3GetWinRecordData message, length delimited. Does not implicitly {@link Turn3GetWinRecordData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {ITurn3GetWinRecordData} message Turn3GetWinRecordData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3GetWinRecordData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Turn3GetWinRecordData message from the specified reader or buffer.
     * @function decode
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Turn3GetWinRecordData} Turn3GetWinRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3GetWinRecordData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Turn3GetWinRecordData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ActBTime = reader.uint64();
                    break;
                }
            case 2: {
                    message.strGiftGold = reader.string();
                    break;
                }
            case 3: {
                    message.ActType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Turn3GetWinRecordData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Turn3GetWinRecordData} Turn3GetWinRecordData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3GetWinRecordData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Turn3GetWinRecordData message.
     * @function verify
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Turn3GetWinRecordData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ActBTime != null && message.hasOwnProperty("ActBTime"))
            if (!$util.isInteger(message.ActBTime) && !(message.ActBTime && $util.isInteger(message.ActBTime.low) && $util.isInteger(message.ActBTime.high)))
                return "ActBTime: integer|Long expected";
        if (message.strGiftGold != null && message.hasOwnProperty("strGiftGold"))
            if (!$util.isString(message.strGiftGold))
                return "strGiftGold: string expected";
        if (message.ActType != null && message.hasOwnProperty("ActType"))
            if (!$util.isInteger(message.ActType))
                return "ActType: integer expected";
        return null;
    };

    /**
     * Creates a Turn3GetWinRecordData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Turn3GetWinRecordData} Turn3GetWinRecordData
     */
    Turn3GetWinRecordData.fromObject = function fromObject(object) {
        if (object instanceof $root.Turn3GetWinRecordData)
            return object;
        let message = new $root.Turn3GetWinRecordData();
        if (object.ActBTime != null)
            if ($util.Long)
                (message.ActBTime = $util.Long.fromValue(object.ActBTime)).unsigned = true;
            else if (typeof object.ActBTime === "string")
                message.ActBTime = parseInt(object.ActBTime, 10);
            else if (typeof object.ActBTime === "number")
                message.ActBTime = object.ActBTime;
            else if (typeof object.ActBTime === "object")
                message.ActBTime = new $util.LongBits(object.ActBTime.low >>> 0, object.ActBTime.high >>> 0).toNumber(true);
        if (object.strGiftGold != null)
            message.strGiftGold = String(object.strGiftGold);
        if (object.ActType != null)
            message.ActType = object.ActType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Turn3GetWinRecordData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {Turn3GetWinRecordData} message Turn3GetWinRecordData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Turn3GetWinRecordData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ActBTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ActBTime = options.longs === String ? "0" : 0;
            object.strGiftGold = "";
            object.ActType = 0;
        }
        if (message.ActBTime != null && message.hasOwnProperty("ActBTime"))
            if (typeof message.ActBTime === "number")
                object.ActBTime = options.longs === String ? String(message.ActBTime) : message.ActBTime;
            else
                object.ActBTime = options.longs === String ? $util.Long.prototype.toString.call(message.ActBTime) : options.longs === Number ? new $util.LongBits(message.ActBTime.low >>> 0, message.ActBTime.high >>> 0).toNumber(true) : message.ActBTime;
        if (message.strGiftGold != null && message.hasOwnProperty("strGiftGold"))
            object.strGiftGold = message.strGiftGold;
        if (message.ActType != null && message.hasOwnProperty("ActType"))
            object.ActType = message.ActType;
        return object;
    };

    /**
     * Converts this Turn3GetWinRecordData to JSON.
     * @function toJSON
     * @memberof Turn3GetWinRecordData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Turn3GetWinRecordData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Turn3GetWinRecordData
     * @function getTypeUrl
     * @memberof Turn3GetWinRecordData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Turn3GetWinRecordData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Turn3GetWinRecordData";
    };

    return Turn3GetWinRecordData;
})();

export const Turn3CellGold = $root.Turn3CellGold = (() => {

    /**
     * Properties of a Turn3CellGold.
     * @exports ITurn3CellGold
     * @interface ITurn3CellGold
     * @property {number|null} [CellID] Turn3CellGold CellID
     * @property {number|null} [CellGoldMin] Turn3CellGold CellGoldMin
     * @property {number|null} [CellGoldMax] Turn3CellGold CellGoldMax
     */

    /**
     * Constructs a new Turn3CellGold.
     * @exports Turn3CellGold
     * @classdesc Represents a Turn3CellGold.
     * @implements ITurn3CellGold
     * @constructor
     * @param {ITurn3CellGold=} [properties] Properties to set
     */
    function Turn3CellGold(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Turn3CellGold CellID.
     * @member {number} CellID
     * @memberof Turn3CellGold
     * @instance
     */
    Turn3CellGold.prototype.CellID = 0;

    /**
     * Turn3CellGold CellGoldMin.
     * @member {number} CellGoldMin
     * @memberof Turn3CellGold
     * @instance
     */
    Turn3CellGold.prototype.CellGoldMin = 0;

    /**
     * Turn3CellGold CellGoldMax.
     * @member {number} CellGoldMax
     * @memberof Turn3CellGold
     * @instance
     */
    Turn3CellGold.prototype.CellGoldMax = 0;

    /**
     * Creates a new Turn3CellGold instance using the specified properties.
     * @function create
     * @memberof Turn3CellGold
     * @static
     * @param {ITurn3CellGold=} [properties] Properties to set
     * @returns {Turn3CellGold} Turn3CellGold instance
     */
    Turn3CellGold.create = function create(properties) {
        return new Turn3CellGold(properties);
    };

    /**
     * Encodes the specified Turn3CellGold message. Does not implicitly {@link Turn3CellGold.verify|verify} messages.
     * @function encode
     * @memberof Turn3CellGold
     * @static
     * @param {ITurn3CellGold} message Turn3CellGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3CellGold.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CellID != null && Object.hasOwnProperty.call(message, "CellID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CellID);
        if (message.CellGoldMin != null && Object.hasOwnProperty.call(message, "CellGoldMin"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CellGoldMin);
        if (message.CellGoldMax != null && Object.hasOwnProperty.call(message, "CellGoldMax"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CellGoldMax);
        return writer;
    };

    /**
     * Encodes the specified Turn3CellGold message, length delimited. Does not implicitly {@link Turn3CellGold.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Turn3CellGold
     * @static
     * @param {ITurn3CellGold} message Turn3CellGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Turn3CellGold.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Turn3CellGold message from the specified reader or buffer.
     * @function decode
     * @memberof Turn3CellGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Turn3CellGold} Turn3CellGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3CellGold.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Turn3CellGold();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CellID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CellGoldMin = reader.uint32();
                    break;
                }
            case 3: {
                    message.CellGoldMax = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Turn3CellGold message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Turn3CellGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Turn3CellGold} Turn3CellGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Turn3CellGold.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Turn3CellGold message.
     * @function verify
     * @memberof Turn3CellGold
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Turn3CellGold.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CellID != null && message.hasOwnProperty("CellID"))
            if (!$util.isInteger(message.CellID))
                return "CellID: integer expected";
        if (message.CellGoldMin != null && message.hasOwnProperty("CellGoldMin"))
            if (!$util.isInteger(message.CellGoldMin))
                return "CellGoldMin: integer expected";
        if (message.CellGoldMax != null && message.hasOwnProperty("CellGoldMax"))
            if (!$util.isInteger(message.CellGoldMax))
                return "CellGoldMax: integer expected";
        return null;
    };

    /**
     * Creates a Turn3CellGold message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Turn3CellGold
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Turn3CellGold} Turn3CellGold
     */
    Turn3CellGold.fromObject = function fromObject(object) {
        if (object instanceof $root.Turn3CellGold)
            return object;
        let message = new $root.Turn3CellGold();
        if (object.CellID != null)
            message.CellID = object.CellID >>> 0;
        if (object.CellGoldMin != null)
            message.CellGoldMin = object.CellGoldMin >>> 0;
        if (object.CellGoldMax != null)
            message.CellGoldMax = object.CellGoldMax >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Turn3CellGold message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Turn3CellGold
     * @static
     * @param {Turn3CellGold} message Turn3CellGold
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Turn3CellGold.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CellID = 0;
            object.CellGoldMin = 0;
            object.CellGoldMax = 0;
        }
        if (message.CellID != null && message.hasOwnProperty("CellID"))
            object.CellID = message.CellID;
        if (message.CellGoldMin != null && message.hasOwnProperty("CellGoldMin"))
            object.CellGoldMin = message.CellGoldMin;
        if (message.CellGoldMax != null && message.hasOwnProperty("CellGoldMax"))
            object.CellGoldMax = message.CellGoldMax;
        return object;
    };

    /**
     * Converts this Turn3CellGold to JSON.
     * @function toJSON
     * @memberof Turn3CellGold
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Turn3CellGold.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Turn3CellGold
     * @function getTypeUrl
     * @memberof Turn3CellGold
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Turn3CellGold.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Turn3CellGold";
    };

    return Turn3CellGold;
})();

export const LuckySpinLevelInfo = $root.LuckySpinLevelInfo = (() => {

    /**
     * Properties of a LuckySpinLevelInfo.
     * @exports ILuckySpinLevelInfo
     * @interface ILuckySpinLevelInfo
     * @property {number|null} [SpinLevel] LuckySpinLevelInfo SpinLevel
     * @property {string|null} [SpinBetsLimit] LuckySpinLevelInfo SpinBetsLimit
     * @property {boolean|null} [AlreadySpin] LuckySpinLevelInfo AlreadySpin
     * @property {string|null} [SpinPrize] LuckySpinLevelInfo SpinPrize
     * @property {Array.<string>|null} [SpinCells] LuckySpinLevelInfo SpinCells
     */

    /**
     * Constructs a new LuckySpinLevelInfo.
     * @exports LuckySpinLevelInfo
     * @classdesc Represents a LuckySpinLevelInfo.
     * @implements ILuckySpinLevelInfo
     * @constructor
     * @param {ILuckySpinLevelInfo=} [properties] Properties to set
     */
    function LuckySpinLevelInfo(properties) {
        this.SpinCells = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LuckySpinLevelInfo SpinLevel.
     * @member {number} SpinLevel
     * @memberof LuckySpinLevelInfo
     * @instance
     */
    LuckySpinLevelInfo.prototype.SpinLevel = 0;

    /**
     * LuckySpinLevelInfo SpinBetsLimit.
     * @member {string} SpinBetsLimit
     * @memberof LuckySpinLevelInfo
     * @instance
     */
    LuckySpinLevelInfo.prototype.SpinBetsLimit = "";

    /**
     * LuckySpinLevelInfo AlreadySpin.
     * @member {boolean} AlreadySpin
     * @memberof LuckySpinLevelInfo
     * @instance
     */
    LuckySpinLevelInfo.prototype.AlreadySpin = false;

    /**
     * LuckySpinLevelInfo SpinPrize.
     * @member {string} SpinPrize
     * @memberof LuckySpinLevelInfo
     * @instance
     */
    LuckySpinLevelInfo.prototype.SpinPrize = "";

    /**
     * LuckySpinLevelInfo SpinCells.
     * @member {Array.<string>} SpinCells
     * @memberof LuckySpinLevelInfo
     * @instance
     */
    LuckySpinLevelInfo.prototype.SpinCells = $util.emptyArray;

    /**
     * Creates a new LuckySpinLevelInfo instance using the specified properties.
     * @function create
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {ILuckySpinLevelInfo=} [properties] Properties to set
     * @returns {LuckySpinLevelInfo} LuckySpinLevelInfo instance
     */
    LuckySpinLevelInfo.create = function create(properties) {
        return new LuckySpinLevelInfo(properties);
    };

    /**
     * Encodes the specified LuckySpinLevelInfo message. Does not implicitly {@link LuckySpinLevelInfo.verify|verify} messages.
     * @function encode
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {ILuckySpinLevelInfo} message LuckySpinLevelInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LuckySpinLevelInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SpinLevel != null && Object.hasOwnProperty.call(message, "SpinLevel"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.SpinLevel);
        if (message.SpinBetsLimit != null && Object.hasOwnProperty.call(message, "SpinBetsLimit"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SpinBetsLimit);
        if (message.AlreadySpin != null && Object.hasOwnProperty.call(message, "AlreadySpin"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.AlreadySpin);
        if (message.SpinPrize != null && Object.hasOwnProperty.call(message, "SpinPrize"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.SpinPrize);
        if (message.SpinCells != null && message.SpinCells.length)
            for (let i = 0; i < message.SpinCells.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.SpinCells[i]);
        return writer;
    };

    /**
     * Encodes the specified LuckySpinLevelInfo message, length delimited. Does not implicitly {@link LuckySpinLevelInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {ILuckySpinLevelInfo} message LuckySpinLevelInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LuckySpinLevelInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LuckySpinLevelInfo message from the specified reader or buffer.
     * @function decode
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LuckySpinLevelInfo} LuckySpinLevelInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LuckySpinLevelInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LuckySpinLevelInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.SpinLevel = reader.uint32();
                    break;
                }
            case 2: {
                    message.SpinBetsLimit = reader.string();
                    break;
                }
            case 3: {
                    message.AlreadySpin = reader.bool();
                    break;
                }
            case 4: {
                    message.SpinPrize = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.SpinCells && message.SpinCells.length))
                        message.SpinCells = [];
                    message.SpinCells.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LuckySpinLevelInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LuckySpinLevelInfo} LuckySpinLevelInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LuckySpinLevelInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LuckySpinLevelInfo message.
     * @function verify
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LuckySpinLevelInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            if (!$util.isInteger(message.SpinLevel))
                return "SpinLevel: integer expected";
        if (message.SpinBetsLimit != null && message.hasOwnProperty("SpinBetsLimit"))
            if (!$util.isString(message.SpinBetsLimit))
                return "SpinBetsLimit: string expected";
        if (message.AlreadySpin != null && message.hasOwnProperty("AlreadySpin"))
            if (typeof message.AlreadySpin !== "boolean")
                return "AlreadySpin: boolean expected";
        if (message.SpinPrize != null && message.hasOwnProperty("SpinPrize"))
            if (!$util.isString(message.SpinPrize))
                return "SpinPrize: string expected";
        if (message.SpinCells != null && message.hasOwnProperty("SpinCells")) {
            if (!Array.isArray(message.SpinCells))
                return "SpinCells: array expected";
            for (let i = 0; i < message.SpinCells.length; ++i)
                if (!$util.isString(message.SpinCells[i]))
                    return "SpinCells: string[] expected";
        }
        return null;
    };

    /**
     * Creates a LuckySpinLevelInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LuckySpinLevelInfo} LuckySpinLevelInfo
     */
    LuckySpinLevelInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.LuckySpinLevelInfo)
            return object;
        let message = new $root.LuckySpinLevelInfo();
        if (object.SpinLevel != null)
            message.SpinLevel = object.SpinLevel >>> 0;
        if (object.SpinBetsLimit != null)
            message.SpinBetsLimit = String(object.SpinBetsLimit);
        if (object.AlreadySpin != null)
            message.AlreadySpin = Boolean(object.AlreadySpin);
        if (object.SpinPrize != null)
            message.SpinPrize = String(object.SpinPrize);
        if (object.SpinCells) {
            if (!Array.isArray(object.SpinCells))
                throw TypeError(".LuckySpinLevelInfo.SpinCells: array expected");
            message.SpinCells = [];
            for (let i = 0; i < object.SpinCells.length; ++i)
                message.SpinCells[i] = String(object.SpinCells[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a LuckySpinLevelInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {LuckySpinLevelInfo} message LuckySpinLevelInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LuckySpinLevelInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.SpinCells = [];
        if (options.defaults) {
            object.SpinLevel = 0;
            object.SpinBetsLimit = "";
            object.AlreadySpin = false;
            object.SpinPrize = "";
        }
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            object.SpinLevel = message.SpinLevel;
        if (message.SpinBetsLimit != null && message.hasOwnProperty("SpinBetsLimit"))
            object.SpinBetsLimit = message.SpinBetsLimit;
        if (message.AlreadySpin != null && message.hasOwnProperty("AlreadySpin"))
            object.AlreadySpin = message.AlreadySpin;
        if (message.SpinPrize != null && message.hasOwnProperty("SpinPrize"))
            object.SpinPrize = message.SpinPrize;
        if (message.SpinCells && message.SpinCells.length) {
            object.SpinCells = [];
            for (let j = 0; j < message.SpinCells.length; ++j)
                object.SpinCells[j] = message.SpinCells[j];
        }
        return object;
    };

    /**
     * Converts this LuckySpinLevelInfo to JSON.
     * @function toJSON
     * @memberof LuckySpinLevelInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LuckySpinLevelInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LuckySpinLevelInfo
     * @function getTypeUrl
     * @memberof LuckySpinLevelInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LuckySpinLevelInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LuckySpinLevelInfo";
    };

    return LuckySpinLevelInfo;
})();

export const BoxInfo = $root.BoxInfo = (() => {

    /**
     * Properties of a BoxInfo.
     * @exports IBoxInfo
     * @interface IBoxInfo
     * @property {number|null} [CellID] BoxInfo CellID
     * @property {number|Long|null} [BoxBeginTime] BoxInfo BoxBeginTime
     * @property {number|Long|null} [BoxEndTime] BoxInfo BoxEndTime
     * @property {boolean|null} [LookBox] BoxInfo LookBox
     */

    /**
     * Constructs a new BoxInfo.
     * @exports BoxInfo
     * @classdesc Represents a BoxInfo.
     * @implements IBoxInfo
     * @constructor
     * @param {IBoxInfo=} [properties] Properties to set
     */
    function BoxInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BoxInfo CellID.
     * @member {number} CellID
     * @memberof BoxInfo
     * @instance
     */
    BoxInfo.prototype.CellID = 0;

    /**
     * BoxInfo BoxBeginTime.
     * @member {number|Long} BoxBeginTime
     * @memberof BoxInfo
     * @instance
     */
    BoxInfo.prototype.BoxBeginTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BoxInfo BoxEndTime.
     * @member {number|Long} BoxEndTime
     * @memberof BoxInfo
     * @instance
     */
    BoxInfo.prototype.BoxEndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BoxInfo LookBox.
     * @member {boolean} LookBox
     * @memberof BoxInfo
     * @instance
     */
    BoxInfo.prototype.LookBox = false;

    /**
     * Creates a new BoxInfo instance using the specified properties.
     * @function create
     * @memberof BoxInfo
     * @static
     * @param {IBoxInfo=} [properties] Properties to set
     * @returns {BoxInfo} BoxInfo instance
     */
    BoxInfo.create = function create(properties) {
        return new BoxInfo(properties);
    };

    /**
     * Encodes the specified BoxInfo message. Does not implicitly {@link BoxInfo.verify|verify} messages.
     * @function encode
     * @memberof BoxInfo
     * @static
     * @param {IBoxInfo} message BoxInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BoxInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CellID != null && Object.hasOwnProperty.call(message, "CellID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CellID);
        if (message.BoxBeginTime != null && Object.hasOwnProperty.call(message, "BoxBeginTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.BoxBeginTime);
        if (message.BoxEndTime != null && Object.hasOwnProperty.call(message, "BoxEndTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.BoxEndTime);
        if (message.LookBox != null && Object.hasOwnProperty.call(message, "LookBox"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.LookBox);
        return writer;
    };

    /**
     * Encodes the specified BoxInfo message, length delimited. Does not implicitly {@link BoxInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BoxInfo
     * @static
     * @param {IBoxInfo} message BoxInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BoxInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BoxInfo message from the specified reader or buffer.
     * @function decode
     * @memberof BoxInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BoxInfo} BoxInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BoxInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BoxInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CellID = reader.uint32();
                    break;
                }
            case 2: {
                    message.BoxBeginTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.BoxEndTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.LookBox = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BoxInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BoxInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BoxInfo} BoxInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BoxInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BoxInfo message.
     * @function verify
     * @memberof BoxInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BoxInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CellID != null && message.hasOwnProperty("CellID"))
            if (!$util.isInteger(message.CellID))
                return "CellID: integer expected";
        if (message.BoxBeginTime != null && message.hasOwnProperty("BoxBeginTime"))
            if (!$util.isInteger(message.BoxBeginTime) && !(message.BoxBeginTime && $util.isInteger(message.BoxBeginTime.low) && $util.isInteger(message.BoxBeginTime.high)))
                return "BoxBeginTime: integer|Long expected";
        if (message.BoxEndTime != null && message.hasOwnProperty("BoxEndTime"))
            if (!$util.isInteger(message.BoxEndTime) && !(message.BoxEndTime && $util.isInteger(message.BoxEndTime.low) && $util.isInteger(message.BoxEndTime.high)))
                return "BoxEndTime: integer|Long expected";
        if (message.LookBox != null && message.hasOwnProperty("LookBox"))
            if (typeof message.LookBox !== "boolean")
                return "LookBox: boolean expected";
        return null;
    };

    /**
     * Creates a BoxInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BoxInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BoxInfo} BoxInfo
     */
    BoxInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.BoxInfo)
            return object;
        let message = new $root.BoxInfo();
        if (object.CellID != null)
            message.CellID = object.CellID >>> 0;
        if (object.BoxBeginTime != null)
            if ($util.Long)
                (message.BoxBeginTime = $util.Long.fromValue(object.BoxBeginTime)).unsigned = true;
            else if (typeof object.BoxBeginTime === "string")
                message.BoxBeginTime = parseInt(object.BoxBeginTime, 10);
            else if (typeof object.BoxBeginTime === "number")
                message.BoxBeginTime = object.BoxBeginTime;
            else if (typeof object.BoxBeginTime === "object")
                message.BoxBeginTime = new $util.LongBits(object.BoxBeginTime.low >>> 0, object.BoxBeginTime.high >>> 0).toNumber(true);
        if (object.BoxEndTime != null)
            if ($util.Long)
                (message.BoxEndTime = $util.Long.fromValue(object.BoxEndTime)).unsigned = true;
            else if (typeof object.BoxEndTime === "string")
                message.BoxEndTime = parseInt(object.BoxEndTime, 10);
            else if (typeof object.BoxEndTime === "number")
                message.BoxEndTime = object.BoxEndTime;
            else if (typeof object.BoxEndTime === "object")
                message.BoxEndTime = new $util.LongBits(object.BoxEndTime.low >>> 0, object.BoxEndTime.high >>> 0).toNumber(true);
        if (object.LookBox != null)
            message.LookBox = Boolean(object.LookBox);
        return message;
    };

    /**
     * Creates a plain object from a BoxInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BoxInfo
     * @static
     * @param {BoxInfo} message BoxInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BoxInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CellID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BoxBeginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BoxBeginTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BoxEndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BoxEndTime = options.longs === String ? "0" : 0;
            object.LookBox = false;
        }
        if (message.CellID != null && message.hasOwnProperty("CellID"))
            object.CellID = message.CellID;
        if (message.BoxBeginTime != null && message.hasOwnProperty("BoxBeginTime"))
            if (typeof message.BoxBeginTime === "number")
                object.BoxBeginTime = options.longs === String ? String(message.BoxBeginTime) : message.BoxBeginTime;
            else
                object.BoxBeginTime = options.longs === String ? $util.Long.prototype.toString.call(message.BoxBeginTime) : options.longs === Number ? new $util.LongBits(message.BoxBeginTime.low >>> 0, message.BoxBeginTime.high >>> 0).toNumber(true) : message.BoxBeginTime;
        if (message.BoxEndTime != null && message.hasOwnProperty("BoxEndTime"))
            if (typeof message.BoxEndTime === "number")
                object.BoxEndTime = options.longs === String ? String(message.BoxEndTime) : message.BoxEndTime;
            else
                object.BoxEndTime = options.longs === String ? $util.Long.prototype.toString.call(message.BoxEndTime) : options.longs === Number ? new $util.LongBits(message.BoxEndTime.low >>> 0, message.BoxEndTime.high >>> 0).toNumber(true) : message.BoxEndTime;
        if (message.LookBox != null && message.hasOwnProperty("LookBox"))
            object.LookBox = message.LookBox;
        return object;
    };

    /**
     * Converts this BoxInfo to JSON.
     * @function toJSON
     * @memberof BoxInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BoxInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BoxInfo
     * @function getTypeUrl
     * @memberof BoxInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BoxInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BoxInfo";
    };

    return BoxInfo;
})();

export const AgentChildInfo = $root.AgentChildInfo = (() => {

    /**
     * Properties of an AgentChildInfo.
     * @exports IAgentChildInfo
     * @interface IAgentChildInfo
     * @property {number|null} [UserID] AgentChildInfo UserID
     * @property {Uint8Array|null} [NickName] AgentChildInfo NickName
     * @property {string|null} [HeaderURL] AgentChildInfo HeaderURL
     * @property {string|null} [Moblie] AgentChildInfo Moblie
     * @property {number|Long|null} [CreateTime] AgentChildInfo CreateTime
     */

    /**
     * Constructs a new AgentChildInfo.
     * @exports AgentChildInfo
     * @classdesc Represents an AgentChildInfo.
     * @implements IAgentChildInfo
     * @constructor
     * @param {IAgentChildInfo=} [properties] Properties to set
     */
    function AgentChildInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AgentChildInfo UserID.
     * @member {number} UserID
     * @memberof AgentChildInfo
     * @instance
     */
    AgentChildInfo.prototype.UserID = 0;

    /**
     * AgentChildInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof AgentChildInfo
     * @instance
     */
    AgentChildInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * AgentChildInfo HeaderURL.
     * @member {string} HeaderURL
     * @memberof AgentChildInfo
     * @instance
     */
    AgentChildInfo.prototype.HeaderURL = "";

    /**
     * AgentChildInfo Moblie.
     * @member {string} Moblie
     * @memberof AgentChildInfo
     * @instance
     */
    AgentChildInfo.prototype.Moblie = "";

    /**
     * AgentChildInfo CreateTime.
     * @member {number|Long} CreateTime
     * @memberof AgentChildInfo
     * @instance
     */
    AgentChildInfo.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new AgentChildInfo instance using the specified properties.
     * @function create
     * @memberof AgentChildInfo
     * @static
     * @param {IAgentChildInfo=} [properties] Properties to set
     * @returns {AgentChildInfo} AgentChildInfo instance
     */
    AgentChildInfo.create = function create(properties) {
        return new AgentChildInfo(properties);
    };

    /**
     * Encodes the specified AgentChildInfo message. Does not implicitly {@link AgentChildInfo.verify|verify} messages.
     * @function encode
     * @memberof AgentChildInfo
     * @static
     * @param {IAgentChildInfo} message AgentChildInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AgentChildInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Moblie);
        if (message.CreateTime != null && Object.hasOwnProperty.call(message, "CreateTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.CreateTime);
        return writer;
    };

    /**
     * Encodes the specified AgentChildInfo message, length delimited. Does not implicitly {@link AgentChildInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AgentChildInfo
     * @static
     * @param {IAgentChildInfo} message AgentChildInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AgentChildInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AgentChildInfo message from the specified reader or buffer.
     * @function decode
     * @memberof AgentChildInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AgentChildInfo} AgentChildInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AgentChildInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AgentChildInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.Moblie = reader.string();
                    break;
                }
            case 5: {
                    message.CreateTime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AgentChildInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AgentChildInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AgentChildInfo} AgentChildInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AgentChildInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AgentChildInfo message.
     * @function verify
     * @memberof AgentChildInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AgentChildInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!$util.isString(message.Moblie))
                return "Moblie: string expected";
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (!$util.isInteger(message.CreateTime) && !(message.CreateTime && $util.isInteger(message.CreateTime.low) && $util.isInteger(message.CreateTime.high)))
                return "CreateTime: integer|Long expected";
        return null;
    };

    /**
     * Creates an AgentChildInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AgentChildInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AgentChildInfo} AgentChildInfo
     */
    AgentChildInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.AgentChildInfo)
            return object;
        let message = new $root.AgentChildInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.Moblie != null)
            message.Moblie = String(object.Moblie);
        if (object.CreateTime != null)
            if ($util.Long)
                (message.CreateTime = $util.Long.fromValue(object.CreateTime)).unsigned = true;
            else if (typeof object.CreateTime === "string")
                message.CreateTime = parseInt(object.CreateTime, 10);
            else if (typeof object.CreateTime === "number")
                message.CreateTime = object.CreateTime;
            else if (typeof object.CreateTime === "object")
                message.CreateTime = new $util.LongBits(object.CreateTime.low >>> 0, object.CreateTime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from an AgentChildInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AgentChildInfo
     * @static
     * @param {AgentChildInfo} message AgentChildInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AgentChildInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.Moblie = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.CreateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.CreateTime = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = message.Moblie;
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (typeof message.CreateTime === "number")
                object.CreateTime = options.longs === String ? String(message.CreateTime) : message.CreateTime;
            else
                object.CreateTime = options.longs === String ? $util.Long.prototype.toString.call(message.CreateTime) : options.longs === Number ? new $util.LongBits(message.CreateTime.low >>> 0, message.CreateTime.high >>> 0).toNumber(true) : message.CreateTime;
        return object;
    };

    /**
     * Converts this AgentChildInfo to JSON.
     * @function toJSON
     * @memberof AgentChildInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AgentChildInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AgentChildInfo
     * @function getTypeUrl
     * @memberof AgentChildInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AgentChildInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AgentChildInfo";
    };

    return AgentChildInfo;
})();

export const AgentRebate = $root.AgentRebate = (() => {

    /**
     * Properties of an AgentRebate.
     * @exports IAgentRebate
     * @interface IAgentRebate
     * @property {number|null} [ChildID] AgentRebate ChildID
     * @property {number|null} [GameID] AgentRebate GameID
     * @property {number|null} [ProductID] AgentRebate ProductID
     * @property {number|null} [DeskNo] AgentRebate DeskNo
     * @property {number|null} [Rebate] AgentRebate Rebate
     * @property {string|null} [Time] AgentRebate Time
     */

    /**
     * Constructs a new AgentRebate.
     * @exports AgentRebate
     * @classdesc Represents an AgentRebate.
     * @implements IAgentRebate
     * @constructor
     * @param {IAgentRebate=} [properties] Properties to set
     */
    function AgentRebate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AgentRebate ChildID.
     * @member {number} ChildID
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.ChildID = 0;

    /**
     * AgentRebate GameID.
     * @member {number} GameID
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.GameID = 0;

    /**
     * AgentRebate ProductID.
     * @member {number} ProductID
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.ProductID = 0;

    /**
     * AgentRebate DeskNo.
     * @member {number} DeskNo
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.DeskNo = 0;

    /**
     * AgentRebate Rebate.
     * @member {number} Rebate
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.Rebate = 0;

    /**
     * AgentRebate Time.
     * @member {string} Time
     * @memberof AgentRebate
     * @instance
     */
    AgentRebate.prototype.Time = "";

    /**
     * Creates a new AgentRebate instance using the specified properties.
     * @function create
     * @memberof AgentRebate
     * @static
     * @param {IAgentRebate=} [properties] Properties to set
     * @returns {AgentRebate} AgentRebate instance
     */
    AgentRebate.create = function create(properties) {
        return new AgentRebate(properties);
    };

    /**
     * Encodes the specified AgentRebate message. Does not implicitly {@link AgentRebate.verify|verify} messages.
     * @function encode
     * @memberof AgentRebate
     * @static
     * @param {IAgentRebate} message AgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AgentRebate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ChildID != null && Object.hasOwnProperty.call(message, "ChildID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ChildID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        if (message.Rebate != null && Object.hasOwnProperty.call(message, "Rebate"))
            writer.uint32(/* id 5, wireType 5 =*/45).float(message.Rebate);
        if (message.Time != null && Object.hasOwnProperty.call(message, "Time"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Time);
        return writer;
    };

    /**
     * Encodes the specified AgentRebate message, length delimited. Does not implicitly {@link AgentRebate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AgentRebate
     * @static
     * @param {IAgentRebate} message AgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AgentRebate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AgentRebate message from the specified reader or buffer.
     * @function decode
     * @memberof AgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AgentRebate} AgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AgentRebate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AgentRebate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ChildID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 5: {
                    message.Rebate = reader.float();
                    break;
                }
            case 6: {
                    message.Time = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AgentRebate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AgentRebate} AgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AgentRebate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AgentRebate message.
     * @function verify
     * @memberof AgentRebate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AgentRebate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ChildID != null && message.hasOwnProperty("ChildID"))
            if (!$util.isInteger(message.ChildID))
                return "ChildID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.Rebate != null && message.hasOwnProperty("Rebate"))
            if (typeof message.Rebate !== "number")
                return "Rebate: number expected";
        if (message.Time != null && message.hasOwnProperty("Time"))
            if (!$util.isString(message.Time))
                return "Time: string expected";
        return null;
    };

    /**
     * Creates an AgentRebate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AgentRebate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AgentRebate} AgentRebate
     */
    AgentRebate.fromObject = function fromObject(object) {
        if (object instanceof $root.AgentRebate)
            return object;
        let message = new $root.AgentRebate();
        if (object.ChildID != null)
            message.ChildID = object.ChildID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.Rebate != null)
            message.Rebate = Number(object.Rebate);
        if (object.Time != null)
            message.Time = String(object.Time);
        return message;
    };

    /**
     * Creates a plain object from an AgentRebate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AgentRebate
     * @static
     * @param {AgentRebate} message AgentRebate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AgentRebate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ChildID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.Rebate = 0;
            object.Time = "";
        }
        if (message.ChildID != null && message.hasOwnProperty("ChildID"))
            object.ChildID = message.ChildID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.Rebate != null && message.hasOwnProperty("Rebate"))
            object.Rebate = options.json && !isFinite(message.Rebate) ? String(message.Rebate) : message.Rebate;
        if (message.Time != null && message.hasOwnProperty("Time"))
            object.Time = message.Time;
        return object;
    };

    /**
     * Converts this AgentRebate to JSON.
     * @function toJSON
     * @memberof AgentRebate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AgentRebate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AgentRebate
     * @function getTypeUrl
     * @memberof AgentRebate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AgentRebate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AgentRebate";
    };

    return AgentRebate;
})();

export const UserStatement = $root.UserStatement = (() => {

    /**
     * Properties of a UserStatement.
     * @exports IUserStatement
     * @interface IUserStatement
     * @property {number|null} [ID] UserStatement ID
     * @property {number|null} [GameID] UserStatement GameID
     * @property {number|null} [ProductID] UserStatement ProductID
     * @property {number|null} [DeskNo] UserStatement DeskNo
     * @property {string|null} [GoldChange] UserStatement GoldChange
     * @property {number|Long|null} [CreateTime] UserStatement CreateTime
     * @property {number|Long|null} [EndTime] UserStatement EndTime
     */

    /**
     * Constructs a new UserStatement.
     * @exports UserStatement
     * @classdesc Represents a UserStatement.
     * @implements IUserStatement
     * @constructor
     * @param {IUserStatement=} [properties] Properties to set
     */
    function UserStatement(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserStatement ID.
     * @member {number} ID
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.ID = 0;

    /**
     * UserStatement GameID.
     * @member {number} GameID
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.GameID = 0;

    /**
     * UserStatement ProductID.
     * @member {number} ProductID
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.ProductID = 0;

    /**
     * UserStatement DeskNo.
     * @member {number} DeskNo
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.DeskNo = 0;

    /**
     * UserStatement GoldChange.
     * @member {string} GoldChange
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.GoldChange = "";

    /**
     * UserStatement CreateTime.
     * @member {number|Long} CreateTime
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * UserStatement EndTime.
     * @member {number|Long} EndTime
     * @memberof UserStatement
     * @instance
     */
    UserStatement.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new UserStatement instance using the specified properties.
     * @function create
     * @memberof UserStatement
     * @static
     * @param {IUserStatement=} [properties] Properties to set
     * @returns {UserStatement} UserStatement instance
     */
    UserStatement.create = function create(properties) {
        return new UserStatement(properties);
    };

    /**
     * Encodes the specified UserStatement message. Does not implicitly {@link UserStatement.verify|verify} messages.
     * @function encode
     * @memberof UserStatement
     * @static
     * @param {IUserStatement} message UserStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserStatement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GoldChange);
        if (message.CreateTime != null && Object.hasOwnProperty.call(message, "CreateTime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.CreateTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.EndTime);
        return writer;
    };

    /**
     * Encodes the specified UserStatement message, length delimited. Does not implicitly {@link UserStatement.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserStatement
     * @static
     * @param {IUserStatement} message UserStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserStatement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserStatement message from the specified reader or buffer.
     * @function decode
     * @memberof UserStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserStatement} UserStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserStatement.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserStatement();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 5: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 6: {
                    message.CreateTime = reader.uint64();
                    break;
                }
            case 7: {
                    message.EndTime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserStatement message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserStatement} UserStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserStatement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserStatement message.
     * @function verify
     * @memberof UserStatement
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserStatement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (!$util.isInteger(message.CreateTime) && !(message.CreateTime && $util.isInteger(message.CreateTime.low) && $util.isInteger(message.CreateTime.high)))
                return "CreateTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        return null;
    };

    /**
     * Creates a UserStatement message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserStatement
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserStatement} UserStatement
     */
    UserStatement.fromObject = function fromObject(object) {
        if (object instanceof $root.UserStatement)
            return object;
        let message = new $root.UserStatement();
        if (object.ID != null)
            message.ID = object.ID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.CreateTime != null)
            if ($util.Long)
                (message.CreateTime = $util.Long.fromValue(object.CreateTime)).unsigned = true;
            else if (typeof object.CreateTime === "string")
                message.CreateTime = parseInt(object.CreateTime, 10);
            else if (typeof object.CreateTime === "number")
                message.CreateTime = object.CreateTime;
            else if (typeof object.CreateTime === "object")
                message.CreateTime = new $util.LongBits(object.CreateTime.low >>> 0, object.CreateTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a UserStatement message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserStatement
     * @static
     * @param {UserStatement} message UserStatement
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserStatement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.GoldChange = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.CreateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.CreateTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
        }
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (typeof message.CreateTime === "number")
                object.CreateTime = options.longs === String ? String(message.CreateTime) : message.CreateTime;
            else
                object.CreateTime = options.longs === String ? $util.Long.prototype.toString.call(message.CreateTime) : options.longs === Number ? new $util.LongBits(message.CreateTime.low >>> 0, message.CreateTime.high >>> 0).toNumber(true) : message.CreateTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        return object;
    };

    /**
     * Converts this UserStatement to JSON.
     * @function toJSON
     * @memberof UserStatement
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserStatement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserStatement
     * @function getTypeUrl
     * @memberof UserStatement
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserStatement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserStatement";
    };

    return UserStatement;
})();

export const PorkerProudct = $root.PorkerProudct = (() => {

    /**
     * Properties of a PorkerProudct.
     * @exports IPorkerProudct
     * @interface IPorkerProudct
     * @property {number|null} [PID] PorkerProudct PID
     * @property {number|null} [Mode] PorkerProudct Mode
     * @property {string|null} [SB] PorkerProudct SB
     * @property {string|null} [BB] PorkerProudct BB
     * @property {string|null} [Carry] PorkerProudct Carry
     * @property {string|null} [MaxCarry] PorkerProudct MaxCarry
     */

    /**
     * Constructs a new PorkerProudct.
     * @exports PorkerProudct
     * @classdesc Represents a PorkerProudct.
     * @implements IPorkerProudct
     * @constructor
     * @param {IPorkerProudct=} [properties] Properties to set
     */
    function PorkerProudct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PorkerProudct PID.
     * @member {number} PID
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.PID = 0;

    /**
     * PorkerProudct Mode.
     * @member {number} Mode
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.Mode = 0;

    /**
     * PorkerProudct SB.
     * @member {string} SB
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.SB = "";

    /**
     * PorkerProudct BB.
     * @member {string} BB
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.BB = "";

    /**
     * PorkerProudct Carry.
     * @member {string} Carry
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.Carry = "";

    /**
     * PorkerProudct MaxCarry.
     * @member {string} MaxCarry
     * @memberof PorkerProudct
     * @instance
     */
    PorkerProudct.prototype.MaxCarry = "";

    /**
     * Creates a new PorkerProudct instance using the specified properties.
     * @function create
     * @memberof PorkerProudct
     * @static
     * @param {IPorkerProudct=} [properties] Properties to set
     * @returns {PorkerProudct} PorkerProudct instance
     */
    PorkerProudct.create = function create(properties) {
        return new PorkerProudct(properties);
    };

    /**
     * Encodes the specified PorkerProudct message. Does not implicitly {@link PorkerProudct.verify|verify} messages.
     * @function encode
     * @memberof PorkerProudct
     * @static
     * @param {IPorkerProudct} message PorkerProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PorkerProudct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.SB != null && Object.hasOwnProperty.call(message, "SB"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.SB);
        if (message.BB != null && Object.hasOwnProperty.call(message, "BB"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BB);
        if (message.Carry != null && Object.hasOwnProperty.call(message, "Carry"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Carry);
        if (message.MaxCarry != null && Object.hasOwnProperty.call(message, "MaxCarry"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.MaxCarry);
        return writer;
    };

    /**
     * Encodes the specified PorkerProudct message, length delimited. Does not implicitly {@link PorkerProudct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PorkerProudct
     * @static
     * @param {IPorkerProudct} message PorkerProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PorkerProudct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PorkerProudct message from the specified reader or buffer.
     * @function decode
     * @memberof PorkerProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PorkerProudct} PorkerProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PorkerProudct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PorkerProudct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.SB = reader.string();
                    break;
                }
            case 4: {
                    message.BB = reader.string();
                    break;
                }
            case 5: {
                    message.Carry = reader.string();
                    break;
                }
            case 6: {
                    message.MaxCarry = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PorkerProudct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PorkerProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PorkerProudct} PorkerProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PorkerProudct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PorkerProudct message.
     * @function verify
     * @memberof PorkerProudct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PorkerProudct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.SB != null && message.hasOwnProperty("SB"))
            if (!$util.isString(message.SB))
                return "SB: string expected";
        if (message.BB != null && message.hasOwnProperty("BB"))
            if (!$util.isString(message.BB))
                return "BB: string expected";
        if (message.Carry != null && message.hasOwnProperty("Carry"))
            if (!$util.isString(message.Carry))
                return "Carry: string expected";
        if (message.MaxCarry != null && message.hasOwnProperty("MaxCarry"))
            if (!$util.isString(message.MaxCarry))
                return "MaxCarry: string expected";
        return null;
    };

    /**
     * Creates a PorkerProudct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PorkerProudct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PorkerProudct} PorkerProudct
     */
    PorkerProudct.fromObject = function fromObject(object) {
        if (object instanceof $root.PorkerProudct)
            return object;
        let message = new $root.PorkerProudct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.SB != null)
            message.SB = String(object.SB);
        if (object.BB != null)
            message.BB = String(object.BB);
        if (object.Carry != null)
            message.Carry = String(object.Carry);
        if (object.MaxCarry != null)
            message.MaxCarry = String(object.MaxCarry);
        return message;
    };

    /**
     * Creates a plain object from a PorkerProudct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PorkerProudct
     * @static
     * @param {PorkerProudct} message PorkerProudct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PorkerProudct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.SB = "";
            object.BB = "";
            object.Carry = "";
            object.MaxCarry = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.SB != null && message.hasOwnProperty("SB"))
            object.SB = message.SB;
        if (message.BB != null && message.hasOwnProperty("BB"))
            object.BB = message.BB;
        if (message.Carry != null && message.hasOwnProperty("Carry"))
            object.Carry = message.Carry;
        if (message.MaxCarry != null && message.hasOwnProperty("MaxCarry"))
            object.MaxCarry = message.MaxCarry;
        return object;
    };

    /**
     * Converts this PorkerProudct to JSON.
     * @function toJSON
     * @memberof PorkerProudct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PorkerProudct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PorkerProudct
     * @function getTypeUrl
     * @memberof PorkerProudct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PorkerProudct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PorkerProudct";
    };

    return PorkerProudct;
})();

export const TeenPattiProudct = $root.TeenPattiProudct = (() => {

    /**
     * Properties of a TeenPattiProudct.
     * @exports ITeenPattiProudct
     * @interface ITeenPattiProudct
     * @property {number|null} [PID] TeenPattiProudct PID
     * @property {number|null} [Mode] TeenPattiProudct Mode
     * @property {number|null} [MaxBlinds] TeenPattiProudct MaxBlinds
     * @property {string|null} [Boot] TeenPattiProudct Boot
     * @property {string|null} [ChaalLimit] TeenPattiProudct ChaalLimit
     * @property {string|null} [MinCarry] TeenPattiProudct MinCarry
     * @property {string|null} [PotLimit] TeenPattiProudct PotLimit
     * @property {number|null} [ReCharge] TeenPattiProudct ReCharge
     */

    /**
     * Constructs a new TeenPattiProudct.
     * @exports TeenPattiProudct
     * @classdesc Represents a TeenPattiProudct.
     * @implements ITeenPattiProudct
     * @constructor
     * @param {ITeenPattiProudct=} [properties] Properties to set
     */
    function TeenPattiProudct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiProudct PID.
     * @member {number} PID
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.PID = 0;

    /**
     * TeenPattiProudct Mode.
     * @member {number} Mode
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.Mode = 0;

    /**
     * TeenPattiProudct MaxBlinds.
     * @member {number} MaxBlinds
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.MaxBlinds = 0;

    /**
     * TeenPattiProudct Boot.
     * @member {string} Boot
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.Boot = "";

    /**
     * TeenPattiProudct ChaalLimit.
     * @member {string} ChaalLimit
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.ChaalLimit = "";

    /**
     * TeenPattiProudct MinCarry.
     * @member {string} MinCarry
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.MinCarry = "";

    /**
     * TeenPattiProudct PotLimit.
     * @member {string} PotLimit
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.PotLimit = "";

    /**
     * TeenPattiProudct ReCharge.
     * @member {number} ReCharge
     * @memberof TeenPattiProudct
     * @instance
     */
    TeenPattiProudct.prototype.ReCharge = 0;

    /**
     * Creates a new TeenPattiProudct instance using the specified properties.
     * @function create
     * @memberof TeenPattiProudct
     * @static
     * @param {ITeenPattiProudct=} [properties] Properties to set
     * @returns {TeenPattiProudct} TeenPattiProudct instance
     */
    TeenPattiProudct.create = function create(properties) {
        return new TeenPattiProudct(properties);
    };

    /**
     * Encodes the specified TeenPattiProudct message. Does not implicitly {@link TeenPattiProudct.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiProudct
     * @static
     * @param {ITeenPattiProudct} message TeenPattiProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiProudct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.MaxBlinds != null && Object.hasOwnProperty.call(message, "MaxBlinds"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MaxBlinds);
        if (message.Boot != null && Object.hasOwnProperty.call(message, "Boot"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Boot);
        if (message.ChaalLimit != null && Object.hasOwnProperty.call(message, "ChaalLimit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ChaalLimit);
        if (message.MinCarry != null && Object.hasOwnProperty.call(message, "MinCarry"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.MinCarry);
        if (message.PotLimit != null && Object.hasOwnProperty.call(message, "PotLimit"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.PotLimit);
        if (message.ReCharge != null && Object.hasOwnProperty.call(message, "ReCharge"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.ReCharge);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiProudct message, length delimited. Does not implicitly {@link TeenPattiProudct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiProudct
     * @static
     * @param {ITeenPattiProudct} message TeenPattiProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiProudct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiProudct message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiProudct} TeenPattiProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiProudct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiProudct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.MaxBlinds = reader.uint32();
                    break;
                }
            case 4: {
                    message.Boot = reader.string();
                    break;
                }
            case 5: {
                    message.ChaalLimit = reader.string();
                    break;
                }
            case 6: {
                    message.MinCarry = reader.string();
                    break;
                }
            case 7: {
                    message.PotLimit = reader.string();
                    break;
                }
            case 8: {
                    message.ReCharge = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiProudct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiProudct} TeenPattiProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiProudct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiProudct message.
     * @function verify
     * @memberof TeenPattiProudct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiProudct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.MaxBlinds != null && message.hasOwnProperty("MaxBlinds"))
            if (!$util.isInteger(message.MaxBlinds))
                return "MaxBlinds: integer expected";
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            if (!$util.isString(message.Boot))
                return "Boot: string expected";
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            if (!$util.isString(message.ChaalLimit))
                return "ChaalLimit: string expected";
        if (message.MinCarry != null && message.hasOwnProperty("MinCarry"))
            if (!$util.isString(message.MinCarry))
                return "MinCarry: string expected";
        if (message.PotLimit != null && message.hasOwnProperty("PotLimit"))
            if (!$util.isString(message.PotLimit))
                return "PotLimit: string expected";
        if (message.ReCharge != null && message.hasOwnProperty("ReCharge"))
            if (!$util.isInteger(message.ReCharge))
                return "ReCharge: integer expected";
        return null;
    };

    /**
     * Creates a TeenPattiProudct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiProudct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiProudct} TeenPattiProudct
     */
    TeenPattiProudct.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiProudct)
            return object;
        let message = new $root.TeenPattiProudct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.MaxBlinds != null)
            message.MaxBlinds = object.MaxBlinds >>> 0;
        if (object.Boot != null)
            message.Boot = String(object.Boot);
        if (object.ChaalLimit != null)
            message.ChaalLimit = String(object.ChaalLimit);
        if (object.MinCarry != null)
            message.MinCarry = String(object.MinCarry);
        if (object.PotLimit != null)
            message.PotLimit = String(object.PotLimit);
        if (object.ReCharge != null)
            message.ReCharge = object.ReCharge >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiProudct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiProudct
     * @static
     * @param {TeenPattiProudct} message TeenPattiProudct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiProudct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.MaxBlinds = 0;
            object.Boot = "";
            object.ChaalLimit = "";
            object.MinCarry = "";
            object.PotLimit = "";
            object.ReCharge = 0;
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.MaxBlinds != null && message.hasOwnProperty("MaxBlinds"))
            object.MaxBlinds = message.MaxBlinds;
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            object.Boot = message.Boot;
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            object.ChaalLimit = message.ChaalLimit;
        if (message.MinCarry != null && message.hasOwnProperty("MinCarry"))
            object.MinCarry = message.MinCarry;
        if (message.PotLimit != null && message.hasOwnProperty("PotLimit"))
            object.PotLimit = message.PotLimit;
        if (message.ReCharge != null && message.hasOwnProperty("ReCharge"))
            object.ReCharge = message.ReCharge;
        return object;
    };

    /**
     * Converts this TeenPattiProudct to JSON.
     * @function toJSON
     * @memberof TeenPattiProudct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiProudct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiProudct
     * @function getTypeUrl
     * @memberof TeenPattiProudct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiProudct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiProudct";
    };

    return TeenPattiProudct;
})();

export const RummyPoolProudct = $root.RummyPoolProudct = (() => {

    /**
     * Properties of a RummyPoolProudct.
     * @exports IRummyPoolProudct
     * @interface IRummyPoolProudct
     * @property {number|null} [PID] RummyPoolProudct PID
     * @property {number|null} [Mode] RummyPoolProudct Mode
     * @property {number|null} [MaxPlayerCnt] RummyPoolProudct MaxPlayerCnt
     * @property {string|null} [Boot] RummyPoolProudct Boot
     * @property {string|null} [ChaalLimit] RummyPoolProudct ChaalLimit
     * @property {string|null} [MinCarry] RummyPoolProudct MinCarry
     * @property {string|null} [PoolType] RummyPoolProudct PoolType
     */

    /**
     * Constructs a new RummyPoolProudct.
     * @exports RummyPoolProudct
     * @classdesc Represents a RummyPoolProudct.
     * @implements IRummyPoolProudct
     * @constructor
     * @param {IRummyPoolProudct=} [properties] Properties to set
     */
    function RummyPoolProudct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolProudct PID.
     * @member {number} PID
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.PID = 0;

    /**
     * RummyPoolProudct Mode.
     * @member {number} Mode
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.Mode = 0;

    /**
     * RummyPoolProudct MaxPlayerCnt.
     * @member {number} MaxPlayerCnt
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.MaxPlayerCnt = 0;

    /**
     * RummyPoolProudct Boot.
     * @member {string} Boot
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.Boot = "";

    /**
     * RummyPoolProudct ChaalLimit.
     * @member {string} ChaalLimit
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.ChaalLimit = "";

    /**
     * RummyPoolProudct MinCarry.
     * @member {string} MinCarry
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.MinCarry = "";

    /**
     * RummyPoolProudct PoolType.
     * @member {string} PoolType
     * @memberof RummyPoolProudct
     * @instance
     */
    RummyPoolProudct.prototype.PoolType = "";

    /**
     * Creates a new RummyPoolProudct instance using the specified properties.
     * @function create
     * @memberof RummyPoolProudct
     * @static
     * @param {IRummyPoolProudct=} [properties] Properties to set
     * @returns {RummyPoolProudct} RummyPoolProudct instance
     */
    RummyPoolProudct.create = function create(properties) {
        return new RummyPoolProudct(properties);
    };

    /**
     * Encodes the specified RummyPoolProudct message. Does not implicitly {@link RummyPoolProudct.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolProudct
     * @static
     * @param {IRummyPoolProudct} message RummyPoolProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolProudct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.MaxPlayerCnt != null && Object.hasOwnProperty.call(message, "MaxPlayerCnt"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MaxPlayerCnt);
        if (message.Boot != null && Object.hasOwnProperty.call(message, "Boot"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Boot);
        if (message.ChaalLimit != null && Object.hasOwnProperty.call(message, "ChaalLimit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ChaalLimit);
        if (message.MinCarry != null && Object.hasOwnProperty.call(message, "MinCarry"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.MinCarry);
        if (message.PoolType != null && Object.hasOwnProperty.call(message, "PoolType"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.PoolType);
        return writer;
    };

    /**
     * Encodes the specified RummyPoolProudct message, length delimited. Does not implicitly {@link RummyPoolProudct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolProudct
     * @static
     * @param {IRummyPoolProudct} message RummyPoolProudct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolProudct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolProudct message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolProudct} RummyPoolProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolProudct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolProudct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.MaxPlayerCnt = reader.uint32();
                    break;
                }
            case 4: {
                    message.Boot = reader.string();
                    break;
                }
            case 5: {
                    message.ChaalLimit = reader.string();
                    break;
                }
            case 6: {
                    message.MinCarry = reader.string();
                    break;
                }
            case 7: {
                    message.PoolType = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolProudct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolProudct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolProudct} RummyPoolProudct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolProudct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolProudct message.
     * @function verify
     * @memberof RummyPoolProudct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolProudct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.MaxPlayerCnt != null && message.hasOwnProperty("MaxPlayerCnt"))
            if (!$util.isInteger(message.MaxPlayerCnt))
                return "MaxPlayerCnt: integer expected";
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            if (!$util.isString(message.Boot))
                return "Boot: string expected";
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            if (!$util.isString(message.ChaalLimit))
                return "ChaalLimit: string expected";
        if (message.MinCarry != null && message.hasOwnProperty("MinCarry"))
            if (!$util.isString(message.MinCarry))
                return "MinCarry: string expected";
        if (message.PoolType != null && message.hasOwnProperty("PoolType"))
            if (!$util.isString(message.PoolType))
                return "PoolType: string expected";
        return null;
    };

    /**
     * Creates a RummyPoolProudct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolProudct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolProudct} RummyPoolProudct
     */
    RummyPoolProudct.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolProudct)
            return object;
        let message = new $root.RummyPoolProudct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.MaxPlayerCnt != null)
            message.MaxPlayerCnt = object.MaxPlayerCnt >>> 0;
        if (object.Boot != null)
            message.Boot = String(object.Boot);
        if (object.ChaalLimit != null)
            message.ChaalLimit = String(object.ChaalLimit);
        if (object.MinCarry != null)
            message.MinCarry = String(object.MinCarry);
        if (object.PoolType != null)
            message.PoolType = String(object.PoolType);
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolProudct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolProudct
     * @static
     * @param {RummyPoolProudct} message RummyPoolProudct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolProudct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.MaxPlayerCnt = 0;
            object.Boot = "";
            object.ChaalLimit = "";
            object.MinCarry = "";
            object.PoolType = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.MaxPlayerCnt != null && message.hasOwnProperty("MaxPlayerCnt"))
            object.MaxPlayerCnt = message.MaxPlayerCnt;
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            object.Boot = message.Boot;
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            object.ChaalLimit = message.ChaalLimit;
        if (message.MinCarry != null && message.hasOwnProperty("MinCarry"))
            object.MinCarry = message.MinCarry;
        if (message.PoolType != null && message.hasOwnProperty("PoolType"))
            object.PoolType = message.PoolType;
        return object;
    };

    /**
     * Converts this RummyPoolProudct to JSON.
     * @function toJSON
     * @memberof RummyPoolProudct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolProudct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolProudct
     * @function getTypeUrl
     * @memberof RummyPoolProudct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolProudct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolProudct";
    };

    return RummyPoolProudct;
})();

export const BigBattleProduct = $root.BigBattleProduct = (() => {

    /**
     * Properties of a BigBattleProduct.
     * @exports IBigBattleProduct
     * @interface IBigBattleProduct
     * @property {number|null} [PID] BigBattleProduct PID
     * @property {number|null} [Mode] BigBattleProduct Mode
     * @property {number|null} [BetSecond] BigBattleProduct BetSecond
     * @property {string|null} [BetList] BigBattleProduct BetList
     * @property {string|null} [ChaalLimit] BigBattleProduct ChaalLimit
     */

    /**
     * Constructs a new BigBattleProduct.
     * @exports BigBattleProduct
     * @classdesc Represents a BigBattleProduct.
     * @implements IBigBattleProduct
     * @constructor
     * @param {IBigBattleProduct=} [properties] Properties to set
     */
    function BigBattleProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleProduct PID.
     * @member {number} PID
     * @memberof BigBattleProduct
     * @instance
     */
    BigBattleProduct.prototype.PID = 0;

    /**
     * BigBattleProduct Mode.
     * @member {number} Mode
     * @memberof BigBattleProduct
     * @instance
     */
    BigBattleProduct.prototype.Mode = 0;

    /**
     * BigBattleProduct BetSecond.
     * @member {number} BetSecond
     * @memberof BigBattleProduct
     * @instance
     */
    BigBattleProduct.prototype.BetSecond = 0;

    /**
     * BigBattleProduct BetList.
     * @member {string} BetList
     * @memberof BigBattleProduct
     * @instance
     */
    BigBattleProduct.prototype.BetList = "";

    /**
     * BigBattleProduct ChaalLimit.
     * @member {string} ChaalLimit
     * @memberof BigBattleProduct
     * @instance
     */
    BigBattleProduct.prototype.ChaalLimit = "";

    /**
     * Creates a new BigBattleProduct instance using the specified properties.
     * @function create
     * @memberof BigBattleProduct
     * @static
     * @param {IBigBattleProduct=} [properties] Properties to set
     * @returns {BigBattleProduct} BigBattleProduct instance
     */
    BigBattleProduct.create = function create(properties) {
        return new BigBattleProduct(properties);
    };

    /**
     * Encodes the specified BigBattleProduct message. Does not implicitly {@link BigBattleProduct.verify|verify} messages.
     * @function encode
     * @memberof BigBattleProduct
     * @static
     * @param {IBigBattleProduct} message BigBattleProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetSecond != null && Object.hasOwnProperty.call(message, "BetSecond"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetSecond);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BetList);
        if (message.ChaalLimit != null && Object.hasOwnProperty.call(message, "ChaalLimit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ChaalLimit);
        return writer;
    };

    /**
     * Encodes the specified BigBattleProduct message, length delimited. Does not implicitly {@link BigBattleProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleProduct
     * @static
     * @param {IBigBattleProduct} message BigBattleProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleProduct message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleProduct} BigBattleProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetSecond = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetList = reader.string();
                    break;
                }
            case 5: {
                    message.ChaalLimit = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleProduct} BigBattleProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleProduct message.
     * @function verify
     * @memberof BigBattleProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetSecond != null && message.hasOwnProperty("BetSecond"))
            if (!$util.isInteger(message.BetSecond))
                return "BetSecond: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            if (!$util.isString(message.ChaalLimit))
                return "ChaalLimit: string expected";
        return null;
    };

    /**
     * Creates a BigBattleProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleProduct} BigBattleProduct
     */
    BigBattleProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleProduct)
            return object;
        let message = new $root.BigBattleProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetSecond != null)
            message.BetSecond = object.BetSecond >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.ChaalLimit != null)
            message.ChaalLimit = String(object.ChaalLimit);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleProduct
     * @static
     * @param {BigBattleProduct} message BigBattleProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetSecond = 0;
            object.BetList = "";
            object.ChaalLimit = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetSecond != null && message.hasOwnProperty("BetSecond"))
            object.BetSecond = message.BetSecond;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            object.ChaalLimit = message.ChaalLimit;
        return object;
    };

    /**
     * Converts this BigBattleProduct to JSON.
     * @function toJSON
     * @memberof BigBattleProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleProduct
     * @function getTypeUrl
     * @memberof BigBattleProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleProduct";
    };

    return BigBattleProduct;
})();

export const UserBank = $root.UserBank = (() => {

    /**
     * Properties of a UserBank.
     * @exports IUserBank
     * @interface IUserBank
     * @property {number|null} [Diamond] UserBank Diamond
     * @property {string|null} [GoldCoin] UserBank GoldCoin
     * @property {string|null} [DepositCoin] UserBank DepositCoin
     * @property {string|null} [WithdrawCoin] UserBank WithdrawCoin
     * @property {string|null} [BonusCoin] UserBank BonusCoin
     */

    /**
     * Constructs a new UserBank.
     * @exports UserBank
     * @classdesc Represents a UserBank.
     * @implements IUserBank
     * @constructor
     * @param {IUserBank=} [properties] Properties to set
     */
    function UserBank(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserBank Diamond.
     * @member {number} Diamond
     * @memberof UserBank
     * @instance
     */
    UserBank.prototype.Diamond = 0;

    /**
     * UserBank GoldCoin.
     * @member {string} GoldCoin
     * @memberof UserBank
     * @instance
     */
    UserBank.prototype.GoldCoin = "";

    /**
     * UserBank DepositCoin.
     * @member {string} DepositCoin
     * @memberof UserBank
     * @instance
     */
    UserBank.prototype.DepositCoin = "";

    /**
     * UserBank WithdrawCoin.
     * @member {string} WithdrawCoin
     * @memberof UserBank
     * @instance
     */
    UserBank.prototype.WithdrawCoin = "";

    /**
     * UserBank BonusCoin.
     * @member {string} BonusCoin
     * @memberof UserBank
     * @instance
     */
    UserBank.prototype.BonusCoin = "";

    /**
     * Creates a new UserBank instance using the specified properties.
     * @function create
     * @memberof UserBank
     * @static
     * @param {IUserBank=} [properties] Properties to set
     * @returns {UserBank} UserBank instance
     */
    UserBank.create = function create(properties) {
        return new UserBank(properties);
    };

    /**
     * Encodes the specified UserBank message. Does not implicitly {@link UserBank.verify|verify} messages.
     * @function encode
     * @memberof UserBank
     * @static
     * @param {IUserBank} message UserBank message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBank.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Diamond != null && Object.hasOwnProperty.call(message, "Diamond"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Diamond);
        if (message.GoldCoin != null && Object.hasOwnProperty.call(message, "GoldCoin"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.GoldCoin);
        if (message.DepositCoin != null && Object.hasOwnProperty.call(message, "DepositCoin"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.DepositCoin);
        if (message.WithdrawCoin != null && Object.hasOwnProperty.call(message, "WithdrawCoin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.WithdrawCoin);
        if (message.BonusCoin != null && Object.hasOwnProperty.call(message, "BonusCoin"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BonusCoin);
        return writer;
    };

    /**
     * Encodes the specified UserBank message, length delimited. Does not implicitly {@link UserBank.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserBank
     * @static
     * @param {IUserBank} message UserBank message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBank.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserBank message from the specified reader or buffer.
     * @function decode
     * @memberof UserBank
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserBank} UserBank
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBank.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserBank();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Diamond = reader.int32();
                    break;
                }
            case 2: {
                    message.GoldCoin = reader.string();
                    break;
                }
            case 3: {
                    message.DepositCoin = reader.string();
                    break;
                }
            case 4: {
                    message.WithdrawCoin = reader.string();
                    break;
                }
            case 5: {
                    message.BonusCoin = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserBank message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserBank
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserBank} UserBank
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBank.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserBank message.
     * @function verify
     * @memberof UserBank
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserBank.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            if (!$util.isInteger(message.Diamond))
                return "Diamond: integer expected";
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            if (!$util.isString(message.GoldCoin))
                return "GoldCoin: string expected";
        if (message.DepositCoin != null && message.hasOwnProperty("DepositCoin"))
            if (!$util.isString(message.DepositCoin))
                return "DepositCoin: string expected";
        if (message.WithdrawCoin != null && message.hasOwnProperty("WithdrawCoin"))
            if (!$util.isString(message.WithdrawCoin))
                return "WithdrawCoin: string expected";
        if (message.BonusCoin != null && message.hasOwnProperty("BonusCoin"))
            if (!$util.isString(message.BonusCoin))
                return "BonusCoin: string expected";
        return null;
    };

    /**
     * Creates a UserBank message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserBank
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserBank} UserBank
     */
    UserBank.fromObject = function fromObject(object) {
        if (object instanceof $root.UserBank)
            return object;
        let message = new $root.UserBank();
        if (object.Diamond != null)
            message.Diamond = object.Diamond | 0;
        if (object.GoldCoin != null)
            message.GoldCoin = String(object.GoldCoin);
        if (object.DepositCoin != null)
            message.DepositCoin = String(object.DepositCoin);
        if (object.WithdrawCoin != null)
            message.WithdrawCoin = String(object.WithdrawCoin);
        if (object.BonusCoin != null)
            message.BonusCoin = String(object.BonusCoin);
        return message;
    };

    /**
     * Creates a plain object from a UserBank message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserBank
     * @static
     * @param {UserBank} message UserBank
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserBank.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Diamond = 0;
            object.GoldCoin = "";
            object.DepositCoin = "";
            object.WithdrawCoin = "";
            object.BonusCoin = "";
        }
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            object.Diamond = message.Diamond;
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            object.GoldCoin = message.GoldCoin;
        if (message.DepositCoin != null && message.hasOwnProperty("DepositCoin"))
            object.DepositCoin = message.DepositCoin;
        if (message.WithdrawCoin != null && message.hasOwnProperty("WithdrawCoin"))
            object.WithdrawCoin = message.WithdrawCoin;
        if (message.BonusCoin != null && message.hasOwnProperty("BonusCoin"))
            object.BonusCoin = message.BonusCoin;
        return object;
    };

    /**
     * Converts this UserBank to JSON.
     * @function toJSON
     * @memberof UserBank
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserBank.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserBank
     * @function getTypeUrl
     * @memberof UserBank
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserBank.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserBank";
    };

    return UserBank;
})();

export const GamerSrvRegisterDeskReq = $root.GamerSrvRegisterDeskReq = (() => {

    /**
     * Properties of a GamerSrvRegisterDeskReq.
     * @exports IGamerSrvRegisterDeskReq
     * @interface IGamerSrvRegisterDeskReq
     * @property {number|null} [GameID] GamerSrvRegisterDeskReq GameID
     * @property {number|null} [SrvID] GamerSrvRegisterDeskReq SrvID
     */

    /**
     * Constructs a new GamerSrvRegisterDeskReq.
     * @exports GamerSrvRegisterDeskReq
     * @classdesc Represents a GamerSrvRegisterDeskReq.
     * @implements IGamerSrvRegisterDeskReq
     * @constructor
     * @param {IGamerSrvRegisterDeskReq=} [properties] Properties to set
     */
    function GamerSrvRegisterDeskReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GamerSrvRegisterDeskReq GameID.
     * @member {number} GameID
     * @memberof GamerSrvRegisterDeskReq
     * @instance
     */
    GamerSrvRegisterDeskReq.prototype.GameID = 0;

    /**
     * GamerSrvRegisterDeskReq SrvID.
     * @member {number} SrvID
     * @memberof GamerSrvRegisterDeskReq
     * @instance
     */
    GamerSrvRegisterDeskReq.prototype.SrvID = 0;

    /**
     * Creates a new GamerSrvRegisterDeskReq instance using the specified properties.
     * @function create
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {IGamerSrvRegisterDeskReq=} [properties] Properties to set
     * @returns {GamerSrvRegisterDeskReq} GamerSrvRegisterDeskReq instance
     */
    GamerSrvRegisterDeskReq.create = function create(properties) {
        return new GamerSrvRegisterDeskReq(properties);
    };

    /**
     * Encodes the specified GamerSrvRegisterDeskReq message. Does not implicitly {@link GamerSrvRegisterDeskReq.verify|verify} messages.
     * @function encode
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {IGamerSrvRegisterDeskReq} message GamerSrvRegisterDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamerSrvRegisterDeskReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GameID);
        if (message.SrvID != null && Object.hasOwnProperty.call(message, "SrvID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SrvID);
        return writer;
    };

    /**
     * Encodes the specified GamerSrvRegisterDeskReq message, length delimited. Does not implicitly {@link GamerSrvRegisterDeskReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {IGamerSrvRegisterDeskReq} message GamerSrvRegisterDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamerSrvRegisterDeskReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GamerSrvRegisterDeskReq message from the specified reader or buffer.
     * @function decode
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GamerSrvRegisterDeskReq} GamerSrvRegisterDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamerSrvRegisterDeskReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GamerSrvRegisterDeskReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SrvID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GamerSrvRegisterDeskReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GamerSrvRegisterDeskReq} GamerSrvRegisterDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamerSrvRegisterDeskReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GamerSrvRegisterDeskReq message.
     * @function verify
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GamerSrvRegisterDeskReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            if (!$util.isInteger(message.SrvID))
                return "SrvID: integer expected";
        return null;
    };

    /**
     * Creates a GamerSrvRegisterDeskReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GamerSrvRegisterDeskReq} GamerSrvRegisterDeskReq
     */
    GamerSrvRegisterDeskReq.fromObject = function fromObject(object) {
        if (object instanceof $root.GamerSrvRegisterDeskReq)
            return object;
        let message = new $root.GamerSrvRegisterDeskReq();
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.SrvID != null)
            message.SrvID = object.SrvID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GamerSrvRegisterDeskReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {GamerSrvRegisterDeskReq} message GamerSrvRegisterDeskReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GamerSrvRegisterDeskReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.GameID = 0;
            object.SrvID = 0;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            object.SrvID = message.SrvID;
        return object;
    };

    /**
     * Converts this GamerSrvRegisterDeskReq to JSON.
     * @function toJSON
     * @memberof GamerSrvRegisterDeskReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GamerSrvRegisterDeskReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GamerSrvRegisterDeskReq
     * @function getTypeUrl
     * @memberof GamerSrvRegisterDeskReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GamerSrvRegisterDeskReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GamerSrvRegisterDeskReq";
    };

    return GamerSrvRegisterDeskReq;
})();

export const GamerSrvRegisterDeskAck = $root.GamerSrvRegisterDeskAck = (() => {

    /**
     * Properties of a GamerSrvRegisterDeskAck.
     * @exports IGamerSrvRegisterDeskAck
     * @interface IGamerSrvRegisterDeskAck
     * @property {number|null} [Res] GamerSrvRegisterDeskAck Res
     * @property {number|null} [GameID] GamerSrvRegisterDeskAck GameID
     * @property {number|null} [SrvID] GamerSrvRegisterDeskAck SrvID
     */

    /**
     * Constructs a new GamerSrvRegisterDeskAck.
     * @exports GamerSrvRegisterDeskAck
     * @classdesc Represents a GamerSrvRegisterDeskAck.
     * @implements IGamerSrvRegisterDeskAck
     * @constructor
     * @param {IGamerSrvRegisterDeskAck=} [properties] Properties to set
     */
    function GamerSrvRegisterDeskAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GamerSrvRegisterDeskAck Res.
     * @member {number} Res
     * @memberof GamerSrvRegisterDeskAck
     * @instance
     */
    GamerSrvRegisterDeskAck.prototype.Res = 0;

    /**
     * GamerSrvRegisterDeskAck GameID.
     * @member {number} GameID
     * @memberof GamerSrvRegisterDeskAck
     * @instance
     */
    GamerSrvRegisterDeskAck.prototype.GameID = 0;

    /**
     * GamerSrvRegisterDeskAck SrvID.
     * @member {number} SrvID
     * @memberof GamerSrvRegisterDeskAck
     * @instance
     */
    GamerSrvRegisterDeskAck.prototype.SrvID = 0;

    /**
     * Creates a new GamerSrvRegisterDeskAck instance using the specified properties.
     * @function create
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {IGamerSrvRegisterDeskAck=} [properties] Properties to set
     * @returns {GamerSrvRegisterDeskAck} GamerSrvRegisterDeskAck instance
     */
    GamerSrvRegisterDeskAck.create = function create(properties) {
        return new GamerSrvRegisterDeskAck(properties);
    };

    /**
     * Encodes the specified GamerSrvRegisterDeskAck message. Does not implicitly {@link GamerSrvRegisterDeskAck.verify|verify} messages.
     * @function encode
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {IGamerSrvRegisterDeskAck} message GamerSrvRegisterDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamerSrvRegisterDeskAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.SrvID != null && Object.hasOwnProperty.call(message, "SrvID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.SrvID);
        return writer;
    };

    /**
     * Encodes the specified GamerSrvRegisterDeskAck message, length delimited. Does not implicitly {@link GamerSrvRegisterDeskAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {IGamerSrvRegisterDeskAck} message GamerSrvRegisterDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GamerSrvRegisterDeskAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GamerSrvRegisterDeskAck message from the specified reader or buffer.
     * @function decode
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GamerSrvRegisterDeskAck} GamerSrvRegisterDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamerSrvRegisterDeskAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GamerSrvRegisterDeskAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SrvID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GamerSrvRegisterDeskAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GamerSrvRegisterDeskAck} GamerSrvRegisterDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GamerSrvRegisterDeskAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GamerSrvRegisterDeskAck message.
     * @function verify
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GamerSrvRegisterDeskAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            if (!$util.isInteger(message.SrvID))
                return "SrvID: integer expected";
        return null;
    };

    /**
     * Creates a GamerSrvRegisterDeskAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GamerSrvRegisterDeskAck} GamerSrvRegisterDeskAck
     */
    GamerSrvRegisterDeskAck.fromObject = function fromObject(object) {
        if (object instanceof $root.GamerSrvRegisterDeskAck)
            return object;
        let message = new $root.GamerSrvRegisterDeskAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.SrvID != null)
            message.SrvID = object.SrvID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GamerSrvRegisterDeskAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {GamerSrvRegisterDeskAck} message GamerSrvRegisterDeskAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GamerSrvRegisterDeskAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.GameID = 0;
            object.SrvID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            object.SrvID = message.SrvID;
        return object;
    };

    /**
     * Converts this GamerSrvRegisterDeskAck to JSON.
     * @function toJSON
     * @memberof GamerSrvRegisterDeskAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GamerSrvRegisterDeskAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GamerSrvRegisterDeskAck
     * @function getTypeUrl
     * @memberof GamerSrvRegisterDeskAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GamerSrvRegisterDeskAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GamerSrvRegisterDeskAck";
    };

    return GamerSrvRegisterDeskAck;
})();

export const ProxySrvRegisterDeskReq = $root.ProxySrvRegisterDeskReq = (() => {

    /**
     * Properties of a ProxySrvRegisterDeskReq.
     * @exports IProxySrvRegisterDeskReq
     * @interface IProxySrvRegisterDeskReq
     * @property {number|null} [GameID] ProxySrvRegisterDeskReq GameID
     * @property {number|null} [ProductID] ProxySrvRegisterDeskReq ProductID
     * @property {number|null} [SrvID] ProxySrvRegisterDeskReq SrvID
     */

    /**
     * Constructs a new ProxySrvRegisterDeskReq.
     * @exports ProxySrvRegisterDeskReq
     * @classdesc Represents a ProxySrvRegisterDeskReq.
     * @implements IProxySrvRegisterDeskReq
     * @constructor
     * @param {IProxySrvRegisterDeskReq=} [properties] Properties to set
     */
    function ProxySrvRegisterDeskReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ProxySrvRegisterDeskReq GameID.
     * @member {number} GameID
     * @memberof ProxySrvRegisterDeskReq
     * @instance
     */
    ProxySrvRegisterDeskReq.prototype.GameID = 0;

    /**
     * ProxySrvRegisterDeskReq ProductID.
     * @member {number} ProductID
     * @memberof ProxySrvRegisterDeskReq
     * @instance
     */
    ProxySrvRegisterDeskReq.prototype.ProductID = 0;

    /**
     * ProxySrvRegisterDeskReq SrvID.
     * @member {number} SrvID
     * @memberof ProxySrvRegisterDeskReq
     * @instance
     */
    ProxySrvRegisterDeskReq.prototype.SrvID = 0;

    /**
     * Creates a new ProxySrvRegisterDeskReq instance using the specified properties.
     * @function create
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {IProxySrvRegisterDeskReq=} [properties] Properties to set
     * @returns {ProxySrvRegisterDeskReq} ProxySrvRegisterDeskReq instance
     */
    ProxySrvRegisterDeskReq.create = function create(properties) {
        return new ProxySrvRegisterDeskReq(properties);
    };

    /**
     * Encodes the specified ProxySrvRegisterDeskReq message. Does not implicitly {@link ProxySrvRegisterDeskReq.verify|verify} messages.
     * @function encode
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {IProxySrvRegisterDeskReq} message ProxySrvRegisterDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProxySrvRegisterDeskReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ProductID);
        if (message.SrvID != null && Object.hasOwnProperty.call(message, "SrvID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.SrvID);
        return writer;
    };

    /**
     * Encodes the specified ProxySrvRegisterDeskReq message, length delimited. Does not implicitly {@link ProxySrvRegisterDeskReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {IProxySrvRegisterDeskReq} message ProxySrvRegisterDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProxySrvRegisterDeskReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProxySrvRegisterDeskReq message from the specified reader or buffer.
     * @function decode
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProxySrvRegisterDeskReq} ProxySrvRegisterDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProxySrvRegisterDeskReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProxySrvRegisterDeskReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SrvID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProxySrvRegisterDeskReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProxySrvRegisterDeskReq} ProxySrvRegisterDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProxySrvRegisterDeskReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProxySrvRegisterDeskReq message.
     * @function verify
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProxySrvRegisterDeskReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            if (!$util.isInteger(message.SrvID))
                return "SrvID: integer expected";
        return null;
    };

    /**
     * Creates a ProxySrvRegisterDeskReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProxySrvRegisterDeskReq} ProxySrvRegisterDeskReq
     */
    ProxySrvRegisterDeskReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ProxySrvRegisterDeskReq)
            return object;
        let message = new $root.ProxySrvRegisterDeskReq();
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.SrvID != null)
            message.SrvID = object.SrvID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ProxySrvRegisterDeskReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {ProxySrvRegisterDeskReq} message ProxySrvRegisterDeskReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProxySrvRegisterDeskReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.GameID = 0;
            object.ProductID = 0;
            object.SrvID = 0;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            object.SrvID = message.SrvID;
        return object;
    };

    /**
     * Converts this ProxySrvRegisterDeskReq to JSON.
     * @function toJSON
     * @memberof ProxySrvRegisterDeskReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProxySrvRegisterDeskReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ProxySrvRegisterDeskReq
     * @function getTypeUrl
     * @memberof ProxySrvRegisterDeskReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ProxySrvRegisterDeskReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProxySrvRegisterDeskReq";
    };

    return ProxySrvRegisterDeskReq;
})();

export const ProxySrvRegisterDeskAck = $root.ProxySrvRegisterDeskAck = (() => {

    /**
     * Properties of a ProxySrvRegisterDeskAck.
     * @exports IProxySrvRegisterDeskAck
     * @interface IProxySrvRegisterDeskAck
     * @property {number|null} [Res] ProxySrvRegisterDeskAck Res
     * @property {number|null} [GameID] ProxySrvRegisterDeskAck GameID
     * @property {number|null} [ProductID] ProxySrvRegisterDeskAck ProductID
     * @property {number|null} [SrvID] ProxySrvRegisterDeskAck SrvID
     */

    /**
     * Constructs a new ProxySrvRegisterDeskAck.
     * @exports ProxySrvRegisterDeskAck
     * @classdesc Represents a ProxySrvRegisterDeskAck.
     * @implements IProxySrvRegisterDeskAck
     * @constructor
     * @param {IProxySrvRegisterDeskAck=} [properties] Properties to set
     */
    function ProxySrvRegisterDeskAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ProxySrvRegisterDeskAck Res.
     * @member {number} Res
     * @memberof ProxySrvRegisterDeskAck
     * @instance
     */
    ProxySrvRegisterDeskAck.prototype.Res = 0;

    /**
     * ProxySrvRegisterDeskAck GameID.
     * @member {number} GameID
     * @memberof ProxySrvRegisterDeskAck
     * @instance
     */
    ProxySrvRegisterDeskAck.prototype.GameID = 0;

    /**
     * ProxySrvRegisterDeskAck ProductID.
     * @member {number} ProductID
     * @memberof ProxySrvRegisterDeskAck
     * @instance
     */
    ProxySrvRegisterDeskAck.prototype.ProductID = 0;

    /**
     * ProxySrvRegisterDeskAck SrvID.
     * @member {number} SrvID
     * @memberof ProxySrvRegisterDeskAck
     * @instance
     */
    ProxySrvRegisterDeskAck.prototype.SrvID = 0;

    /**
     * Creates a new ProxySrvRegisterDeskAck instance using the specified properties.
     * @function create
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {IProxySrvRegisterDeskAck=} [properties] Properties to set
     * @returns {ProxySrvRegisterDeskAck} ProxySrvRegisterDeskAck instance
     */
    ProxySrvRegisterDeskAck.create = function create(properties) {
        return new ProxySrvRegisterDeskAck(properties);
    };

    /**
     * Encodes the specified ProxySrvRegisterDeskAck message. Does not implicitly {@link ProxySrvRegisterDeskAck.verify|verify} messages.
     * @function encode
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {IProxySrvRegisterDeskAck} message ProxySrvRegisterDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProxySrvRegisterDeskAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.SrvID != null && Object.hasOwnProperty.call(message, "SrvID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SrvID);
        return writer;
    };

    /**
     * Encodes the specified ProxySrvRegisterDeskAck message, length delimited. Does not implicitly {@link ProxySrvRegisterDeskAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {IProxySrvRegisterDeskAck} message ProxySrvRegisterDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProxySrvRegisterDeskAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProxySrvRegisterDeskAck message from the specified reader or buffer.
     * @function decode
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProxySrvRegisterDeskAck} ProxySrvRegisterDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProxySrvRegisterDeskAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProxySrvRegisterDeskAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SrvID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProxySrvRegisterDeskAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProxySrvRegisterDeskAck} ProxySrvRegisterDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProxySrvRegisterDeskAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProxySrvRegisterDeskAck message.
     * @function verify
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProxySrvRegisterDeskAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            if (!$util.isInteger(message.SrvID))
                return "SrvID: integer expected";
        return null;
    };

    /**
     * Creates a ProxySrvRegisterDeskAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProxySrvRegisterDeskAck} ProxySrvRegisterDeskAck
     */
    ProxySrvRegisterDeskAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ProxySrvRegisterDeskAck)
            return object;
        let message = new $root.ProxySrvRegisterDeskAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.SrvID != null)
            message.SrvID = object.SrvID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ProxySrvRegisterDeskAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {ProxySrvRegisterDeskAck} message ProxySrvRegisterDeskAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProxySrvRegisterDeskAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.SrvID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.SrvID != null && message.hasOwnProperty("SrvID"))
            object.SrvID = message.SrvID;
        return object;
    };

    /**
     * Converts this ProxySrvRegisterDeskAck to JSON.
     * @function toJSON
     * @memberof ProxySrvRegisterDeskAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProxySrvRegisterDeskAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ProxySrvRegisterDeskAck
     * @function getTypeUrl
     * @memberof ProxySrvRegisterDeskAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ProxySrvRegisterDeskAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProxySrvRegisterDeskAck";
    };

    return ProxySrvRegisterDeskAck;
})();

export const DeskToGameSrvPubLicInfo = $root.DeskToGameSrvPubLicInfo = (() => {

    /**
     * Properties of a DeskToGameSrvPubLicInfo.
     * @exports IDeskToGameSrvPubLicInfo
     * @interface IDeskToGameSrvPubLicInfo
     * @property {number|null} [DeskNo] DeskToGameSrvPubLicInfo DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPubLicInfo UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPubLicInfo SeatNo
     */

    /**
     * Constructs a new DeskToGameSrvPubLicInfo.
     * @exports DeskToGameSrvPubLicInfo
     * @classdesc Represents a DeskToGameSrvPubLicInfo.
     * @implements IDeskToGameSrvPubLicInfo
     * @constructor
     * @param {IDeskToGameSrvPubLicInfo=} [properties] Properties to set
     */
    function DeskToGameSrvPubLicInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPubLicInfo DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPubLicInfo
     * @instance
     */
    DeskToGameSrvPubLicInfo.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPubLicInfo UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPubLicInfo
     * @instance
     */
    DeskToGameSrvPubLicInfo.prototype.UserID = 0;

    /**
     * DeskToGameSrvPubLicInfo SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPubLicInfo
     * @instance
     */
    DeskToGameSrvPubLicInfo.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToGameSrvPubLicInfo instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {IDeskToGameSrvPubLicInfo=} [properties] Properties to set
     * @returns {DeskToGameSrvPubLicInfo} DeskToGameSrvPubLicInfo instance
     */
    DeskToGameSrvPubLicInfo.create = function create(properties) {
        return new DeskToGameSrvPubLicInfo(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPubLicInfo message. Does not implicitly {@link DeskToGameSrvPubLicInfo.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {IDeskToGameSrvPubLicInfo} message DeskToGameSrvPubLicInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPubLicInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPubLicInfo message, length delimited. Does not implicitly {@link DeskToGameSrvPubLicInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {IDeskToGameSrvPubLicInfo} message DeskToGameSrvPubLicInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPubLicInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPubLicInfo message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPubLicInfo} DeskToGameSrvPubLicInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPubLicInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPubLicInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPubLicInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPubLicInfo} DeskToGameSrvPubLicInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPubLicInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPubLicInfo message.
     * @function verify
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPubLicInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPubLicInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPubLicInfo} DeskToGameSrvPubLicInfo
     */
    DeskToGameSrvPubLicInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPubLicInfo)
            return object;
        let message = new $root.DeskToGameSrvPubLicInfo();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPubLicInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {DeskToGameSrvPubLicInfo} message DeskToGameSrvPubLicInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPubLicInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPubLicInfo to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPubLicInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPubLicInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPubLicInfo
     * @function getTypeUrl
     * @memberof DeskToGameSrvPubLicInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPubLicInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPubLicInfo";
    };

    return DeskToGameSrvPubLicInfo;
})();

export const DeskToGameSrvCreatDeskReq = $root.DeskToGameSrvCreatDeskReq = (() => {

    /**
     * Properties of a DeskToGameSrvCreatDeskReq.
     * @exports IDeskToGameSrvCreatDeskReq
     * @interface IDeskToGameSrvCreatDeskReq
     * @property {number|null} [DeskNo] DeskToGameSrvCreatDeskReq DeskNo
     * @property {number|null} [GameID] DeskToGameSrvCreatDeskReq GameID
     * @property {number|null} [ProductID] DeskToGameSrvCreatDeskReq ProductID
     * @property {number|null} [ChannelID] DeskToGameSrvCreatDeskReq ChannelID
     * @property {string|null} [GameRule] DeskToGameSrvCreatDeskReq GameRule
     */

    /**
     * Constructs a new DeskToGameSrvCreatDeskReq.
     * @exports DeskToGameSrvCreatDeskReq
     * @classdesc Represents a DeskToGameSrvCreatDeskReq.
     * @implements IDeskToGameSrvCreatDeskReq
     * @constructor
     * @param {IDeskToGameSrvCreatDeskReq=} [properties] Properties to set
     */
    function DeskToGameSrvCreatDeskReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvCreatDeskReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     */
    DeskToGameSrvCreatDeskReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvCreatDeskReq GameID.
     * @member {number} GameID
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     */
    DeskToGameSrvCreatDeskReq.prototype.GameID = 0;

    /**
     * DeskToGameSrvCreatDeskReq ProductID.
     * @member {number} ProductID
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     */
    DeskToGameSrvCreatDeskReq.prototype.ProductID = 0;

    /**
     * DeskToGameSrvCreatDeskReq ChannelID.
     * @member {number} ChannelID
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     */
    DeskToGameSrvCreatDeskReq.prototype.ChannelID = 0;

    /**
     * DeskToGameSrvCreatDeskReq GameRule.
     * @member {string} GameRule
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     */
    DeskToGameSrvCreatDeskReq.prototype.GameRule = "";

    /**
     * Creates a new DeskToGameSrvCreatDeskReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {IDeskToGameSrvCreatDeskReq=} [properties] Properties to set
     * @returns {DeskToGameSrvCreatDeskReq} DeskToGameSrvCreatDeskReq instance
     */
    DeskToGameSrvCreatDeskReq.create = function create(properties) {
        return new DeskToGameSrvCreatDeskReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvCreatDeskReq message. Does not implicitly {@link DeskToGameSrvCreatDeskReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {IDeskToGameSrvCreatDeskReq} message DeskToGameSrvCreatDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvCreatDeskReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ChannelID);
        if (message.GameRule != null && Object.hasOwnProperty.call(message, "GameRule"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GameRule);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvCreatDeskReq message, length delimited. Does not implicitly {@link DeskToGameSrvCreatDeskReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {IDeskToGameSrvCreatDeskReq} message DeskToGameSrvCreatDeskReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvCreatDeskReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvCreatDeskReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvCreatDeskReq} DeskToGameSrvCreatDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvCreatDeskReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvCreatDeskReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 5: {
                    message.GameRule = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvCreatDeskReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvCreatDeskReq} DeskToGameSrvCreatDeskReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvCreatDeskReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvCreatDeskReq message.
     * @function verify
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvCreatDeskReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.GameRule != null && message.hasOwnProperty("GameRule"))
            if (!$util.isString(message.GameRule))
                return "GameRule: string expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvCreatDeskReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvCreatDeskReq} DeskToGameSrvCreatDeskReq
     */
    DeskToGameSrvCreatDeskReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvCreatDeskReq)
            return object;
        let message = new $root.DeskToGameSrvCreatDeskReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.GameRule != null)
            message.GameRule = String(object.GameRule);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvCreatDeskReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {DeskToGameSrvCreatDeskReq} message DeskToGameSrvCreatDeskReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvCreatDeskReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.ChannelID = 0;
            object.GameRule = "";
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.GameRule != null && message.hasOwnProperty("GameRule"))
            object.GameRule = message.GameRule;
        return object;
    };

    /**
     * Converts this DeskToGameSrvCreatDeskReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvCreatDeskReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvCreatDeskReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvCreatDeskReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvCreatDeskReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvCreatDeskReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvCreatDeskReq";
    };

    return DeskToGameSrvCreatDeskReq;
})();

export const DeskToGameSrvCreatDeskAck = $root.DeskToGameSrvCreatDeskAck = (() => {

    /**
     * Properties of a DeskToGameSrvCreatDeskAck.
     * @exports IDeskToGameSrvCreatDeskAck
     * @interface IDeskToGameSrvCreatDeskAck
     * @property {number|null} [Res] DeskToGameSrvCreatDeskAck Res
     * @property {number|null} [DeskNo] DeskToGameSrvCreatDeskAck DeskNo
     * @property {number|null} [GameID] DeskToGameSrvCreatDeskAck GameID
     */

    /**
     * Constructs a new DeskToGameSrvCreatDeskAck.
     * @exports DeskToGameSrvCreatDeskAck
     * @classdesc Represents a DeskToGameSrvCreatDeskAck.
     * @implements IDeskToGameSrvCreatDeskAck
     * @constructor
     * @param {IDeskToGameSrvCreatDeskAck=} [properties] Properties to set
     */
    function DeskToGameSrvCreatDeskAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvCreatDeskAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvCreatDeskAck
     * @instance
     */
    DeskToGameSrvCreatDeskAck.prototype.Res = 0;

    /**
     * DeskToGameSrvCreatDeskAck DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvCreatDeskAck
     * @instance
     */
    DeskToGameSrvCreatDeskAck.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvCreatDeskAck GameID.
     * @member {number} GameID
     * @memberof DeskToGameSrvCreatDeskAck
     * @instance
     */
    DeskToGameSrvCreatDeskAck.prototype.GameID = 0;

    /**
     * Creates a new DeskToGameSrvCreatDeskAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {IDeskToGameSrvCreatDeskAck=} [properties] Properties to set
     * @returns {DeskToGameSrvCreatDeskAck} DeskToGameSrvCreatDeskAck instance
     */
    DeskToGameSrvCreatDeskAck.create = function create(properties) {
        return new DeskToGameSrvCreatDeskAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvCreatDeskAck message. Does not implicitly {@link DeskToGameSrvCreatDeskAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {IDeskToGameSrvCreatDeskAck} message DeskToGameSrvCreatDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvCreatDeskAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvCreatDeskAck message, length delimited. Does not implicitly {@link DeskToGameSrvCreatDeskAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {IDeskToGameSrvCreatDeskAck} message DeskToGameSrvCreatDeskAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvCreatDeskAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvCreatDeskAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvCreatDeskAck} DeskToGameSrvCreatDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvCreatDeskAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvCreatDeskAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvCreatDeskAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvCreatDeskAck} DeskToGameSrvCreatDeskAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvCreatDeskAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvCreatDeskAck message.
     * @function verify
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvCreatDeskAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvCreatDeskAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvCreatDeskAck} DeskToGameSrvCreatDeskAck
     */
    DeskToGameSrvCreatDeskAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvCreatDeskAck)
            return object;
        let message = new $root.DeskToGameSrvCreatDeskAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvCreatDeskAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {DeskToGameSrvCreatDeskAck} message DeskToGameSrvCreatDeskAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvCreatDeskAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.GameID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this DeskToGameSrvCreatDeskAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvCreatDeskAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvCreatDeskAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvCreatDeskAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvCreatDeskAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvCreatDeskAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvCreatDeskAck";
    };

    return DeskToGameSrvCreatDeskAck;
})();

export const DeskToGameSrvPlayerArriveReq = $root.DeskToGameSrvPlayerArriveReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerArriveReq.
     * @exports IDeskToGameSrvPlayerArriveReq
     * @interface IDeskToGameSrvPlayerArriveReq
     * @property {IBaseCGamePlayer|null} [CGamePlayer] DeskToGameSrvPlayerArriveReq CGamePlayer
     */

    /**
     * Constructs a new DeskToGameSrvPlayerArriveReq.
     * @exports DeskToGameSrvPlayerArriveReq
     * @classdesc Represents a DeskToGameSrvPlayerArriveReq.
     * @implements IDeskToGameSrvPlayerArriveReq
     * @constructor
     * @param {IDeskToGameSrvPlayerArriveReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerArriveReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerArriveReq CGamePlayer.
     * @member {IBaseCGamePlayer|null|undefined} CGamePlayer
     * @memberof DeskToGameSrvPlayerArriveReq
     * @instance
     */
    DeskToGameSrvPlayerArriveReq.prototype.CGamePlayer = null;

    /**
     * Creates a new DeskToGameSrvPlayerArriveReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {IDeskToGameSrvPlayerArriveReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerArriveReq} DeskToGameSrvPlayerArriveReq instance
     */
    DeskToGameSrvPlayerArriveReq.create = function create(properties) {
        return new DeskToGameSrvPlayerArriveReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerArriveReq message. Does not implicitly {@link DeskToGameSrvPlayerArriveReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {IDeskToGameSrvPlayerArriveReq} message DeskToGameSrvPlayerArriveReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerArriveReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CGamePlayer != null && Object.hasOwnProperty.call(message, "CGamePlayer"))
            $root.BaseCGamePlayer.encode(message.CGamePlayer, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerArriveReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerArriveReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {IDeskToGameSrvPlayerArriveReq} message DeskToGameSrvPlayerArriveReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerArriveReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerArriveReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerArriveReq} DeskToGameSrvPlayerArriveReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerArriveReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerArriveReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CGamePlayer = $root.BaseCGamePlayer.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerArriveReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerArriveReq} DeskToGameSrvPlayerArriveReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerArriveReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerArriveReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerArriveReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CGamePlayer != null && message.hasOwnProperty("CGamePlayer")) {
            let error = $root.BaseCGamePlayer.verify(message.CGamePlayer);
            if (error)
                return "CGamePlayer." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerArriveReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerArriveReq} DeskToGameSrvPlayerArriveReq
     */
    DeskToGameSrvPlayerArriveReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerArriveReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerArriveReq();
        if (object.CGamePlayer != null) {
            if (typeof object.CGamePlayer !== "object")
                throw TypeError(".DeskToGameSrvPlayerArriveReq.CGamePlayer: object expected");
            message.CGamePlayer = $root.BaseCGamePlayer.fromObject(object.CGamePlayer);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerArriveReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {DeskToGameSrvPlayerArriveReq} message DeskToGameSrvPlayerArriveReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerArriveReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.CGamePlayer = null;
        if (message.CGamePlayer != null && message.hasOwnProperty("CGamePlayer"))
            object.CGamePlayer = $root.BaseCGamePlayer.toObject(message.CGamePlayer, options);
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerArriveReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerArriveReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerArriveReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerArriveReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerArriveReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerArriveReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerArriveReq";
    };

    return DeskToGameSrvPlayerArriveReq;
})();

export const DeskToGameSrvPlayerArriveAck = $root.DeskToGameSrvPlayerArriveAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerArriveAck.
     * @exports IDeskToGameSrvPlayerArriveAck
     * @interface IDeskToGameSrvPlayerArriveAck
     * @property {number|null} [Res] DeskToGameSrvPlayerArriveAck Res
     * @property {number|null} [UserID] DeskToGameSrvPlayerArriveAck UserID
     * @property {number|null} [NewPlayerID] DeskToGameSrvPlayerArriveAck NewPlayerID
     * @property {Array.<IPlayerInfo>|null} [DeskPlayer] DeskToGameSrvPlayerArriveAck DeskPlayer
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerArriveAck DeskNo
     * @property {number|null} [GameID] DeskToGameSrvPlayerArriveAck GameID
     * @property {number|null} [ProductID] DeskToGameSrvPlayerArriveAck ProductID
     * @property {string|null} [GameRule] DeskToGameSrvPlayerArriveAck GameRule
     */

    /**
     * Constructs a new DeskToGameSrvPlayerArriveAck.
     * @exports DeskToGameSrvPlayerArriveAck
     * @classdesc Represents a DeskToGameSrvPlayerArriveAck.
     * @implements IDeskToGameSrvPlayerArriveAck
     * @constructor
     * @param {IDeskToGameSrvPlayerArriveAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerArriveAck(properties) {
        this.DeskPlayer = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerArriveAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerArriveAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerArriveAck NewPlayerID.
     * @member {number} NewPlayerID
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.NewPlayerID = 0;

    /**
     * DeskToGameSrvPlayerArriveAck DeskPlayer.
     * @member {Array.<IPlayerInfo>} DeskPlayer
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.DeskPlayer = $util.emptyArray;

    /**
     * DeskToGameSrvPlayerArriveAck DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerArriveAck GameID.
     * @member {number} GameID
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.GameID = 0;

    /**
     * DeskToGameSrvPlayerArriveAck ProductID.
     * @member {number} ProductID
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.ProductID = 0;

    /**
     * DeskToGameSrvPlayerArriveAck GameRule.
     * @member {string} GameRule
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     */
    DeskToGameSrvPlayerArriveAck.prototype.GameRule = "";

    /**
     * Creates a new DeskToGameSrvPlayerArriveAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {IDeskToGameSrvPlayerArriveAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerArriveAck} DeskToGameSrvPlayerArriveAck instance
     */
    DeskToGameSrvPlayerArriveAck.create = function create(properties) {
        return new DeskToGameSrvPlayerArriveAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerArriveAck message. Does not implicitly {@link DeskToGameSrvPlayerArriveAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {IDeskToGameSrvPlayerArriveAck} message DeskToGameSrvPlayerArriveAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerArriveAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NewPlayerID != null && Object.hasOwnProperty.call(message, "NewPlayerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.NewPlayerID);
        if (message.DeskPlayer != null && message.DeskPlayer.length)
            for (let i = 0; i < message.DeskPlayer.length; ++i)
                $root.PlayerInfo.encode(message.DeskPlayer[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.ProductID);
        if (message.GameRule != null && Object.hasOwnProperty.call(message, "GameRule"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.GameRule);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerArriveAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerArriveAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {IDeskToGameSrvPlayerArriveAck} message DeskToGameSrvPlayerArriveAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerArriveAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerArriveAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerArriveAck} DeskToGameSrvPlayerArriveAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerArriveAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerArriveAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NewPlayerID = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.DeskPlayer && message.DeskPlayer.length))
                        message.DeskPlayer = [];
                    message.DeskPlayer.push($root.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 6: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 7: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 8: {
                    message.GameRule = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerArriveAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerArriveAck} DeskToGameSrvPlayerArriveAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerArriveAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerArriveAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerArriveAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewPlayerID != null && message.hasOwnProperty("NewPlayerID"))
            if (!$util.isInteger(message.NewPlayerID))
                return "NewPlayerID: integer expected";
        if (message.DeskPlayer != null && message.hasOwnProperty("DeskPlayer")) {
            if (!Array.isArray(message.DeskPlayer))
                return "DeskPlayer: array expected";
            for (let i = 0; i < message.DeskPlayer.length; ++i) {
                let error = $root.PlayerInfo.verify(message.DeskPlayer[i]);
                if (error)
                    return "DeskPlayer." + error;
            }
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.GameRule != null && message.hasOwnProperty("GameRule"))
            if (!$util.isString(message.GameRule))
                return "GameRule: string expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerArriveAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerArriveAck} DeskToGameSrvPlayerArriveAck
     */
    DeskToGameSrvPlayerArriveAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerArriveAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerArriveAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewPlayerID != null)
            message.NewPlayerID = object.NewPlayerID >>> 0;
        if (object.DeskPlayer) {
            if (!Array.isArray(object.DeskPlayer))
                throw TypeError(".DeskToGameSrvPlayerArriveAck.DeskPlayer: array expected");
            message.DeskPlayer = [];
            for (let i = 0; i < object.DeskPlayer.length; ++i) {
                if (typeof object.DeskPlayer[i] !== "object")
                    throw TypeError(".DeskToGameSrvPlayerArriveAck.DeskPlayer: object expected");
                message.DeskPlayer[i] = $root.PlayerInfo.fromObject(object.DeskPlayer[i]);
            }
        }
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.GameRule != null)
            message.GameRule = String(object.GameRule);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerArriveAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {DeskToGameSrvPlayerArriveAck} message DeskToGameSrvPlayerArriveAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerArriveAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.DeskPlayer = [];
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.NewPlayerID = 0;
            object.DeskNo = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.GameRule = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewPlayerID != null && message.hasOwnProperty("NewPlayerID"))
            object.NewPlayerID = message.NewPlayerID;
        if (message.DeskPlayer && message.DeskPlayer.length) {
            object.DeskPlayer = [];
            for (let j = 0; j < message.DeskPlayer.length; ++j)
                object.DeskPlayer[j] = $root.PlayerInfo.toObject(message.DeskPlayer[j], options);
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.GameRule != null && message.hasOwnProperty("GameRule"))
            object.GameRule = message.GameRule;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerArriveAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerArriveAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerArriveAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerArriveAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerArriveAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerArriveAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerArriveAck";
    };

    return DeskToGameSrvPlayerArriveAck;
})();

export const DeskToGameSrvPlayerLeaveReq = $root.DeskToGameSrvPlayerLeaveReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerLeaveReq.
     * @exports IDeskToGameSrvPlayerLeaveReq
     * @interface IDeskToGameSrvPlayerLeaveReq
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerLeaveReq DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerLeaveReq UserID
     * @property {number|null} [ChangeDeask] DeskToGameSrvPlayerLeaveReq ChangeDeask
     */

    /**
     * Constructs a new DeskToGameSrvPlayerLeaveReq.
     * @exports DeskToGameSrvPlayerLeaveReq
     * @classdesc Represents a DeskToGameSrvPlayerLeaveReq.
     * @implements IDeskToGameSrvPlayerLeaveReq
     * @constructor
     * @param {IDeskToGameSrvPlayerLeaveReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerLeaveReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerLeaveReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @instance
     */
    DeskToGameSrvPlayerLeaveReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerLeaveReq UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @instance
     */
    DeskToGameSrvPlayerLeaveReq.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerLeaveReq ChangeDeask.
     * @member {number} ChangeDeask
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @instance
     */
    DeskToGameSrvPlayerLeaveReq.prototype.ChangeDeask = 0;

    /**
     * Creates a new DeskToGameSrvPlayerLeaveReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {IDeskToGameSrvPlayerLeaveReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerLeaveReq} DeskToGameSrvPlayerLeaveReq instance
     */
    DeskToGameSrvPlayerLeaveReq.create = function create(properties) {
        return new DeskToGameSrvPlayerLeaveReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerLeaveReq message. Does not implicitly {@link DeskToGameSrvPlayerLeaveReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {IDeskToGameSrvPlayerLeaveReq} message DeskToGameSrvPlayerLeaveReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerLeaveReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChangeDeask != null && Object.hasOwnProperty.call(message, "ChangeDeask"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChangeDeask);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerLeaveReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerLeaveReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {IDeskToGameSrvPlayerLeaveReq} message DeskToGameSrvPlayerLeaveReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerLeaveReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerLeaveReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerLeaveReq} DeskToGameSrvPlayerLeaveReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerLeaveReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerLeaveReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChangeDeask = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerLeaveReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerLeaveReq} DeskToGameSrvPlayerLeaveReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerLeaveReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerLeaveReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerLeaveReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChangeDeask != null && message.hasOwnProperty("ChangeDeask"))
            if (!$util.isInteger(message.ChangeDeask))
                return "ChangeDeask: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerLeaveReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerLeaveReq} DeskToGameSrvPlayerLeaveReq
     */
    DeskToGameSrvPlayerLeaveReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerLeaveReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerLeaveReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChangeDeask != null)
            message.ChangeDeask = object.ChangeDeask >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerLeaveReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {DeskToGameSrvPlayerLeaveReq} message DeskToGameSrvPlayerLeaveReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerLeaveReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.ChangeDeask = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChangeDeask != null && message.hasOwnProperty("ChangeDeask"))
            object.ChangeDeask = message.ChangeDeask;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerLeaveReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerLeaveReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerLeaveReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerLeaveReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerLeaveReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerLeaveReq";
    };

    return DeskToGameSrvPlayerLeaveReq;
})();

export const DeskToGameSrvPlayerLeaveAck = $root.DeskToGameSrvPlayerLeaveAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerLeaveAck.
     * @exports IDeskToGameSrvPlayerLeaveAck
     * @interface IDeskToGameSrvPlayerLeaveAck
     * @property {number|null} [Res] DeskToGameSrvPlayerLeaveAck Res
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerLeaveAck DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerLeaveAck UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerLeaveAck SeatNo
     * @property {number|null} [Receiver] DeskToGameSrvPlayerLeaveAck Receiver
     * @property {number|null} [ChangeDeask] DeskToGameSrvPlayerLeaveAck ChangeDeask
     * @property {number|null} [Sign] DeskToGameSrvPlayerLeaveAck Sign
     */

    /**
     * Constructs a new DeskToGameSrvPlayerLeaveAck.
     * @exports DeskToGameSrvPlayerLeaveAck
     * @classdesc Represents a DeskToGameSrvPlayerLeaveAck.
     * @implements IDeskToGameSrvPlayerLeaveAck
     * @constructor
     * @param {IDeskToGameSrvPlayerLeaveAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerLeaveAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerLeaveAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.SeatNo = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck Receiver.
     * @member {number} Receiver
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.Receiver = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck ChangeDeask.
     * @member {number} ChangeDeask
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.ChangeDeask = 0;

    /**
     * DeskToGameSrvPlayerLeaveAck Sign.
     * @member {number} Sign
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     */
    DeskToGameSrvPlayerLeaveAck.prototype.Sign = 0;

    /**
     * Creates a new DeskToGameSrvPlayerLeaveAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {IDeskToGameSrvPlayerLeaveAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerLeaveAck} DeskToGameSrvPlayerLeaveAck instance
     */
    DeskToGameSrvPlayerLeaveAck.create = function create(properties) {
        return new DeskToGameSrvPlayerLeaveAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerLeaveAck message. Does not implicitly {@link DeskToGameSrvPlayerLeaveAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {IDeskToGameSrvPlayerLeaveAck} message DeskToGameSrvPlayerLeaveAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerLeaveAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Receiver != null && Object.hasOwnProperty.call(message, "Receiver"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Receiver);
        if (message.ChangeDeask != null && Object.hasOwnProperty.call(message, "ChangeDeask"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.ChangeDeask);
        if (message.Sign != null && Object.hasOwnProperty.call(message, "Sign"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Sign);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerLeaveAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerLeaveAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {IDeskToGameSrvPlayerLeaveAck} message DeskToGameSrvPlayerLeaveAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerLeaveAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerLeaveAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerLeaveAck} DeskToGameSrvPlayerLeaveAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerLeaveAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerLeaveAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Receiver = reader.uint32();
                    break;
                }
            case 6: {
                    message.ChangeDeask = reader.uint32();
                    break;
                }
            case 7: {
                    message.Sign = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerLeaveAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerLeaveAck} DeskToGameSrvPlayerLeaveAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerLeaveAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerLeaveAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerLeaveAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            if (!$util.isInteger(message.Receiver))
                return "Receiver: integer expected";
        if (message.ChangeDeask != null && message.hasOwnProperty("ChangeDeask"))
            if (!$util.isInteger(message.ChangeDeask))
                return "ChangeDeask: integer expected";
        if (message.Sign != null && message.hasOwnProperty("Sign"))
            if (!$util.isInteger(message.Sign))
                return "Sign: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerLeaveAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerLeaveAck} DeskToGameSrvPlayerLeaveAck
     */
    DeskToGameSrvPlayerLeaveAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerLeaveAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerLeaveAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Receiver != null)
            message.Receiver = object.Receiver >>> 0;
        if (object.ChangeDeask != null)
            message.ChangeDeask = object.ChangeDeask >>> 0;
        if (object.Sign != null)
            message.Sign = object.Sign >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerLeaveAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {DeskToGameSrvPlayerLeaveAck} message DeskToGameSrvPlayerLeaveAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerLeaveAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Receiver = 0;
            object.ChangeDeask = 0;
            object.Sign = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            object.Receiver = message.Receiver;
        if (message.ChangeDeask != null && message.hasOwnProperty("ChangeDeask"))
            object.ChangeDeask = message.ChangeDeask;
        if (message.Sign != null && message.hasOwnProperty("Sign"))
            object.Sign = message.Sign;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerLeaveAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerLeaveAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerLeaveAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerLeaveAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerLeaveAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerLeaveAck";
    };

    return DeskToGameSrvPlayerLeaveAck;
})();

export const DeskToGameSrvPlayerSitDownReq = $root.DeskToGameSrvPlayerSitDownReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerSitDownReq.
     * @exports IDeskToGameSrvPlayerSitDownReq
     * @interface IDeskToGameSrvPlayerSitDownReq
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerSitDownReq DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerSitDownReq UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerSitDownReq SeatNo
     */

    /**
     * Constructs a new DeskToGameSrvPlayerSitDownReq.
     * @exports DeskToGameSrvPlayerSitDownReq
     * @classdesc Represents a DeskToGameSrvPlayerSitDownReq.
     * @implements IDeskToGameSrvPlayerSitDownReq
     * @constructor
     * @param {IDeskToGameSrvPlayerSitDownReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerSitDownReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerSitDownReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @instance
     */
    DeskToGameSrvPlayerSitDownReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerSitDownReq UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @instance
     */
    DeskToGameSrvPlayerSitDownReq.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerSitDownReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @instance
     */
    DeskToGameSrvPlayerSitDownReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToGameSrvPlayerSitDownReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {IDeskToGameSrvPlayerSitDownReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerSitDownReq} DeskToGameSrvPlayerSitDownReq instance
     */
    DeskToGameSrvPlayerSitDownReq.create = function create(properties) {
        return new DeskToGameSrvPlayerSitDownReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerSitDownReq message. Does not implicitly {@link DeskToGameSrvPlayerSitDownReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {IDeskToGameSrvPlayerSitDownReq} message DeskToGameSrvPlayerSitDownReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerSitDownReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerSitDownReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerSitDownReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {IDeskToGameSrvPlayerSitDownReq} message DeskToGameSrvPlayerSitDownReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerSitDownReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerSitDownReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerSitDownReq} DeskToGameSrvPlayerSitDownReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerSitDownReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerSitDownReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerSitDownReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerSitDownReq} DeskToGameSrvPlayerSitDownReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerSitDownReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerSitDownReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerSitDownReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerSitDownReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerSitDownReq} DeskToGameSrvPlayerSitDownReq
     */
    DeskToGameSrvPlayerSitDownReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerSitDownReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerSitDownReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerSitDownReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {DeskToGameSrvPlayerSitDownReq} message DeskToGameSrvPlayerSitDownReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerSitDownReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerSitDownReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerSitDownReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerSitDownReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerSitDownReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerSitDownReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerSitDownReq";
    };

    return DeskToGameSrvPlayerSitDownReq;
})();

export const DeskToGameSrvPlayerSitDownAck = $root.DeskToGameSrvPlayerSitDownAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerSitDownAck.
     * @exports IDeskToGameSrvPlayerSitDownAck
     * @interface IDeskToGameSrvPlayerSitDownAck
     * @property {number|null} [Res] DeskToGameSrvPlayerSitDownAck Res
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerSitDownAck DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerSitDownAck UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerSitDownAck SeatNo
     * @property {number|null} [Receiver] DeskToGameSrvPlayerSitDownAck Receiver
     */

    /**
     * Constructs a new DeskToGameSrvPlayerSitDownAck.
     * @exports DeskToGameSrvPlayerSitDownAck
     * @classdesc Represents a DeskToGameSrvPlayerSitDownAck.
     * @implements IDeskToGameSrvPlayerSitDownAck
     * @constructor
     * @param {IDeskToGameSrvPlayerSitDownAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerSitDownAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerSitDownAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     */
    DeskToGameSrvPlayerSitDownAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerSitDownAck DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     */
    DeskToGameSrvPlayerSitDownAck.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerSitDownAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     */
    DeskToGameSrvPlayerSitDownAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerSitDownAck SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     */
    DeskToGameSrvPlayerSitDownAck.prototype.SeatNo = 0;

    /**
     * DeskToGameSrvPlayerSitDownAck Receiver.
     * @member {number} Receiver
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     */
    DeskToGameSrvPlayerSitDownAck.prototype.Receiver = 0;

    /**
     * Creates a new DeskToGameSrvPlayerSitDownAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {IDeskToGameSrvPlayerSitDownAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerSitDownAck} DeskToGameSrvPlayerSitDownAck instance
     */
    DeskToGameSrvPlayerSitDownAck.create = function create(properties) {
        return new DeskToGameSrvPlayerSitDownAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerSitDownAck message. Does not implicitly {@link DeskToGameSrvPlayerSitDownAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {IDeskToGameSrvPlayerSitDownAck} message DeskToGameSrvPlayerSitDownAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerSitDownAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Receiver != null && Object.hasOwnProperty.call(message, "Receiver"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Receiver);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerSitDownAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerSitDownAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {IDeskToGameSrvPlayerSitDownAck} message DeskToGameSrvPlayerSitDownAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerSitDownAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerSitDownAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerSitDownAck} DeskToGameSrvPlayerSitDownAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerSitDownAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerSitDownAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Receiver = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerSitDownAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerSitDownAck} DeskToGameSrvPlayerSitDownAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerSitDownAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerSitDownAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerSitDownAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            if (!$util.isInteger(message.Receiver))
                return "Receiver: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerSitDownAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerSitDownAck} DeskToGameSrvPlayerSitDownAck
     */
    DeskToGameSrvPlayerSitDownAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerSitDownAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerSitDownAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Receiver != null)
            message.Receiver = object.Receiver >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerSitDownAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {DeskToGameSrvPlayerSitDownAck} message DeskToGameSrvPlayerSitDownAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerSitDownAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Receiver = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            object.Receiver = message.Receiver;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerSitDownAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerSitDownAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerSitDownAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerSitDownAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerSitDownAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerSitDownAck";
    };

    return DeskToGameSrvPlayerSitDownAck;
})();

export const DeskToGameSrvPlayerStandUpReq = $root.DeskToGameSrvPlayerStandUpReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerStandUpReq.
     * @exports IDeskToGameSrvPlayerStandUpReq
     * @interface IDeskToGameSrvPlayerStandUpReq
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerStandUpReq DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerStandUpReq UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerStandUpReq SeatNo
     */

    /**
     * Constructs a new DeskToGameSrvPlayerStandUpReq.
     * @exports DeskToGameSrvPlayerStandUpReq
     * @classdesc Represents a DeskToGameSrvPlayerStandUpReq.
     * @implements IDeskToGameSrvPlayerStandUpReq
     * @constructor
     * @param {IDeskToGameSrvPlayerStandUpReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerStandUpReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerStandUpReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @instance
     */
    DeskToGameSrvPlayerStandUpReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerStandUpReq UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @instance
     */
    DeskToGameSrvPlayerStandUpReq.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerStandUpReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @instance
     */
    DeskToGameSrvPlayerStandUpReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToGameSrvPlayerStandUpReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {IDeskToGameSrvPlayerStandUpReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerStandUpReq} DeskToGameSrvPlayerStandUpReq instance
     */
    DeskToGameSrvPlayerStandUpReq.create = function create(properties) {
        return new DeskToGameSrvPlayerStandUpReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerStandUpReq message. Does not implicitly {@link DeskToGameSrvPlayerStandUpReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {IDeskToGameSrvPlayerStandUpReq} message DeskToGameSrvPlayerStandUpReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerStandUpReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerStandUpReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerStandUpReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {IDeskToGameSrvPlayerStandUpReq} message DeskToGameSrvPlayerStandUpReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerStandUpReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerStandUpReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerStandUpReq} DeskToGameSrvPlayerStandUpReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerStandUpReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerStandUpReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerStandUpReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerStandUpReq} DeskToGameSrvPlayerStandUpReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerStandUpReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerStandUpReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerStandUpReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerStandUpReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerStandUpReq} DeskToGameSrvPlayerStandUpReq
     */
    DeskToGameSrvPlayerStandUpReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerStandUpReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerStandUpReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerStandUpReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {DeskToGameSrvPlayerStandUpReq} message DeskToGameSrvPlayerStandUpReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerStandUpReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerStandUpReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerStandUpReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerStandUpReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerStandUpReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerStandUpReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerStandUpReq";
    };

    return DeskToGameSrvPlayerStandUpReq;
})();

export const DeskToGameSrvPlayerStandUpAck = $root.DeskToGameSrvPlayerStandUpAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerStandUpAck.
     * @exports IDeskToGameSrvPlayerStandUpAck
     * @interface IDeskToGameSrvPlayerStandUpAck
     * @property {number|null} [Res] DeskToGameSrvPlayerStandUpAck Res
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerStandUpAck DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerStandUpAck UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerStandUpAck SeatNo
     * @property {number|null} [Receiver] DeskToGameSrvPlayerStandUpAck Receiver
     */

    /**
     * Constructs a new DeskToGameSrvPlayerStandUpAck.
     * @exports DeskToGameSrvPlayerStandUpAck
     * @classdesc Represents a DeskToGameSrvPlayerStandUpAck.
     * @implements IDeskToGameSrvPlayerStandUpAck
     * @constructor
     * @param {IDeskToGameSrvPlayerStandUpAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerStandUpAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerStandUpAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     */
    DeskToGameSrvPlayerStandUpAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerStandUpAck DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     */
    DeskToGameSrvPlayerStandUpAck.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerStandUpAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     */
    DeskToGameSrvPlayerStandUpAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerStandUpAck SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     */
    DeskToGameSrvPlayerStandUpAck.prototype.SeatNo = 0;

    /**
     * DeskToGameSrvPlayerStandUpAck Receiver.
     * @member {number} Receiver
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     */
    DeskToGameSrvPlayerStandUpAck.prototype.Receiver = 0;

    /**
     * Creates a new DeskToGameSrvPlayerStandUpAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {IDeskToGameSrvPlayerStandUpAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerStandUpAck} DeskToGameSrvPlayerStandUpAck instance
     */
    DeskToGameSrvPlayerStandUpAck.create = function create(properties) {
        return new DeskToGameSrvPlayerStandUpAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerStandUpAck message. Does not implicitly {@link DeskToGameSrvPlayerStandUpAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {IDeskToGameSrvPlayerStandUpAck} message DeskToGameSrvPlayerStandUpAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerStandUpAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Receiver != null && Object.hasOwnProperty.call(message, "Receiver"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Receiver);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerStandUpAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerStandUpAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {IDeskToGameSrvPlayerStandUpAck} message DeskToGameSrvPlayerStandUpAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerStandUpAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerStandUpAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerStandUpAck} DeskToGameSrvPlayerStandUpAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerStandUpAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerStandUpAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Receiver = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerStandUpAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerStandUpAck} DeskToGameSrvPlayerStandUpAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerStandUpAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerStandUpAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerStandUpAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            if (!$util.isInteger(message.Receiver))
                return "Receiver: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerStandUpAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerStandUpAck} DeskToGameSrvPlayerStandUpAck
     */
    DeskToGameSrvPlayerStandUpAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerStandUpAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerStandUpAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Receiver != null)
            message.Receiver = object.Receiver >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerStandUpAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {DeskToGameSrvPlayerStandUpAck} message DeskToGameSrvPlayerStandUpAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerStandUpAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Receiver = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Receiver != null && message.hasOwnProperty("Receiver"))
            object.Receiver = message.Receiver;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerStandUpAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerStandUpAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerStandUpAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerStandUpAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerStandUpAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerStandUpAck";
    };

    return DeskToGameSrvPlayerStandUpAck;
})();

export const DeskToGameSrvPlayerResume = $root.DeskToGameSrvPlayerResume = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerResume.
     * @exports IDeskToGameSrvPlayerResume
     * @interface IDeskToGameSrvPlayerResume
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerResume DeskNo
     * @property {IPlayerInfo|null} [PlayerInfo] DeskToGameSrvPlayerResume PlayerInfo
     */

    /**
     * Constructs a new DeskToGameSrvPlayerResume.
     * @exports DeskToGameSrvPlayerResume
     * @classdesc Represents a DeskToGameSrvPlayerResume.
     * @implements IDeskToGameSrvPlayerResume
     * @constructor
     * @param {IDeskToGameSrvPlayerResume=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerResume(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerResume DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerResume
     * @instance
     */
    DeskToGameSrvPlayerResume.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerResume PlayerInfo.
     * @member {IPlayerInfo|null|undefined} PlayerInfo
     * @memberof DeskToGameSrvPlayerResume
     * @instance
     */
    DeskToGameSrvPlayerResume.prototype.PlayerInfo = null;

    /**
     * Creates a new DeskToGameSrvPlayerResume instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {IDeskToGameSrvPlayerResume=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerResume} DeskToGameSrvPlayerResume instance
     */
    DeskToGameSrvPlayerResume.create = function create(properties) {
        return new DeskToGameSrvPlayerResume(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerResume message. Does not implicitly {@link DeskToGameSrvPlayerResume.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {IDeskToGameSrvPlayerResume} message DeskToGameSrvPlayerResume message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerResume.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.PlayerInfo != null && Object.hasOwnProperty.call(message, "PlayerInfo"))
            $root.PlayerInfo.encode(message.PlayerInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerResume message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerResume.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {IDeskToGameSrvPlayerResume} message DeskToGameSrvPlayerResume message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerResume.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerResume message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerResume} DeskToGameSrvPlayerResume
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerResume.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerResume();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.PlayerInfo = $root.PlayerInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerResume message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerResume} DeskToGameSrvPlayerResume
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerResume.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerResume message.
     * @function verify
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerResume.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.PlayerInfo != null && message.hasOwnProperty("PlayerInfo")) {
            let error = $root.PlayerInfo.verify(message.PlayerInfo);
            if (error)
                return "PlayerInfo." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerResume message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerResume} DeskToGameSrvPlayerResume
     */
    DeskToGameSrvPlayerResume.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerResume)
            return object;
        let message = new $root.DeskToGameSrvPlayerResume();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.PlayerInfo != null) {
            if (typeof object.PlayerInfo !== "object")
                throw TypeError(".DeskToGameSrvPlayerResume.PlayerInfo: object expected");
            message.PlayerInfo = $root.PlayerInfo.fromObject(object.PlayerInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerResume message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {DeskToGameSrvPlayerResume} message DeskToGameSrvPlayerResume
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerResume.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.PlayerInfo = null;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.PlayerInfo != null && message.hasOwnProperty("PlayerInfo"))
            object.PlayerInfo = $root.PlayerInfo.toObject(message.PlayerInfo, options);
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerResume to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerResume
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerResume.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerResume
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerResume
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerResume.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerResume";
    };

    return DeskToGameSrvPlayerResume;
})();

export const DeskToGameSrvPlayerBreak = $root.DeskToGameSrvPlayerBreak = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerBreak.
     * @exports IDeskToGameSrvPlayerBreak
     * @interface IDeskToGameSrvPlayerBreak
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerBreak DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerBreak UserID
     */

    /**
     * Constructs a new DeskToGameSrvPlayerBreak.
     * @exports DeskToGameSrvPlayerBreak
     * @classdesc Represents a DeskToGameSrvPlayerBreak.
     * @implements IDeskToGameSrvPlayerBreak
     * @constructor
     * @param {IDeskToGameSrvPlayerBreak=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerBreak(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerBreak DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerBreak
     * @instance
     */
    DeskToGameSrvPlayerBreak.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerBreak UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerBreak
     * @instance
     */
    DeskToGameSrvPlayerBreak.prototype.UserID = 0;

    /**
     * Creates a new DeskToGameSrvPlayerBreak instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {IDeskToGameSrvPlayerBreak=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerBreak} DeskToGameSrvPlayerBreak instance
     */
    DeskToGameSrvPlayerBreak.create = function create(properties) {
        return new DeskToGameSrvPlayerBreak(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerBreak message. Does not implicitly {@link DeskToGameSrvPlayerBreak.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {IDeskToGameSrvPlayerBreak} message DeskToGameSrvPlayerBreak message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerBreak.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerBreak message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerBreak.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {IDeskToGameSrvPlayerBreak} message DeskToGameSrvPlayerBreak message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerBreak.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerBreak message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerBreak} DeskToGameSrvPlayerBreak
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerBreak.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerBreak();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerBreak message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerBreak} DeskToGameSrvPlayerBreak
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerBreak.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerBreak message.
     * @function verify
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerBreak.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerBreak message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerBreak} DeskToGameSrvPlayerBreak
     */
    DeskToGameSrvPlayerBreak.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerBreak)
            return object;
        let message = new $root.DeskToGameSrvPlayerBreak();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerBreak message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {DeskToGameSrvPlayerBreak} message DeskToGameSrvPlayerBreak
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerBreak.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerBreak to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerBreak
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerBreak.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerBreak
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerBreak
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerBreak.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerBreak";
    };

    return DeskToGameSrvPlayerBreak;
})();

export const GameSrvToDeskCancelCharge = $root.GameSrvToDeskCancelCharge = (() => {

    /**
     * Properties of a GameSrvToDeskCancelCharge.
     * @exports IGameSrvToDeskCancelCharge
     * @interface IGameSrvToDeskCancelCharge
     * @property {number|null} [DeskNo] GameSrvToDeskCancelCharge DeskNo
     * @property {number|null} [UserID] GameSrvToDeskCancelCharge UserID
     * @property {number|null} [SeatNo] GameSrvToDeskCancelCharge SeatNo
     */

    /**
     * Constructs a new GameSrvToDeskCancelCharge.
     * @exports GameSrvToDeskCancelCharge
     * @classdesc Represents a GameSrvToDeskCancelCharge.
     * @implements IGameSrvToDeskCancelCharge
     * @constructor
     * @param {IGameSrvToDeskCancelCharge=} [properties] Properties to set
     */
    function GameSrvToDeskCancelCharge(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskCancelCharge DeskNo.
     * @member {number} DeskNo
     * @memberof GameSrvToDeskCancelCharge
     * @instance
     */
    GameSrvToDeskCancelCharge.prototype.DeskNo = 0;

    /**
     * GameSrvToDeskCancelCharge UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskCancelCharge
     * @instance
     */
    GameSrvToDeskCancelCharge.prototype.UserID = 0;

    /**
     * GameSrvToDeskCancelCharge SeatNo.
     * @member {number} SeatNo
     * @memberof GameSrvToDeskCancelCharge
     * @instance
     */
    GameSrvToDeskCancelCharge.prototype.SeatNo = 0;

    /**
     * Creates a new GameSrvToDeskCancelCharge instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {IGameSrvToDeskCancelCharge=} [properties] Properties to set
     * @returns {GameSrvToDeskCancelCharge} GameSrvToDeskCancelCharge instance
     */
    GameSrvToDeskCancelCharge.create = function create(properties) {
        return new GameSrvToDeskCancelCharge(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskCancelCharge message. Does not implicitly {@link GameSrvToDeskCancelCharge.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {IGameSrvToDeskCancelCharge} message GameSrvToDeskCancelCharge message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskCancelCharge.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskCancelCharge message, length delimited. Does not implicitly {@link GameSrvToDeskCancelCharge.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {IGameSrvToDeskCancelCharge} message GameSrvToDeskCancelCharge message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskCancelCharge.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskCancelCharge message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskCancelCharge} GameSrvToDeskCancelCharge
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskCancelCharge.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskCancelCharge();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskCancelCharge message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskCancelCharge} GameSrvToDeskCancelCharge
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskCancelCharge.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskCancelCharge message.
     * @function verify
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskCancelCharge.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskCancelCharge message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskCancelCharge} GameSrvToDeskCancelCharge
     */
    GameSrvToDeskCancelCharge.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskCancelCharge)
            return object;
        let message = new $root.GameSrvToDeskCancelCharge();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskCancelCharge message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {GameSrvToDeskCancelCharge} message GameSrvToDeskCancelCharge
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskCancelCharge.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this GameSrvToDeskCancelCharge to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskCancelCharge
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskCancelCharge.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskCancelCharge
     * @function getTypeUrl
     * @memberof GameSrvToDeskCancelCharge
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskCancelCharge.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskCancelCharge";
    };

    return GameSrvToDeskCancelCharge;
})();

export const GameSrvToDeskPushTimer = $root.GameSrvToDeskPushTimer = (() => {

    /**
     * Properties of a GameSrvToDeskPushTimer.
     * @exports IGameSrvToDeskPushTimer
     * @interface IGameSrvToDeskPushTimer
     * @property {number|null} [SeatNo] GameSrvToDeskPushTimer SeatNo
     * @property {number|Long|null} [TimerID] GameSrvToDeskPushTimer TimerID
     * @property {number|Long|null} [Duration] GameSrvToDeskPushTimer Duration
     * @property {number|Long|null} [Elapsed] GameSrvToDeskPushTimer Elapsed
     * @property {GameSrvToDeskPushTimer.OperType|null} [Operation] GameSrvToDeskPushTimer Operation
     * @property {GameSrvToDeskPushTimer.ShowType|null} [Show] GameSrvToDeskPushTimer Show
     * @property {number|Long|null} [Delay] GameSrvToDeskPushTimer Delay
     */

    /**
     * Constructs a new GameSrvToDeskPushTimer.
     * @exports GameSrvToDeskPushTimer
     * @classdesc Represents a GameSrvToDeskPushTimer.
     * @implements IGameSrvToDeskPushTimer
     * @constructor
     * @param {IGameSrvToDeskPushTimer=} [properties] Properties to set
     */
    function GameSrvToDeskPushTimer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushTimer SeatNo.
     * @member {number} SeatNo
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.SeatNo = 0;

    /**
     * GameSrvToDeskPushTimer TimerID.
     * @member {number|Long} TimerID
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.TimerID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameSrvToDeskPushTimer Duration.
     * @member {number|Long} Duration
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.Duration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameSrvToDeskPushTimer Elapsed.
     * @member {number|Long} Elapsed
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.Elapsed = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameSrvToDeskPushTimer Operation.
     * @member {GameSrvToDeskPushTimer.OperType} Operation
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.Operation = 0;

    /**
     * GameSrvToDeskPushTimer Show.
     * @member {GameSrvToDeskPushTimer.ShowType} Show
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.Show = 0;

    /**
     * GameSrvToDeskPushTimer Delay.
     * @member {number|Long} Delay
     * @memberof GameSrvToDeskPushTimer
     * @instance
     */
    GameSrvToDeskPushTimer.prototype.Delay = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new GameSrvToDeskPushTimer instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {IGameSrvToDeskPushTimer=} [properties] Properties to set
     * @returns {GameSrvToDeskPushTimer} GameSrvToDeskPushTimer instance
     */
    GameSrvToDeskPushTimer.create = function create(properties) {
        return new GameSrvToDeskPushTimer(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushTimer message. Does not implicitly {@link GameSrvToDeskPushTimer.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {IGameSrvToDeskPushTimer} message GameSrvToDeskPushTimer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushTimer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.SeatNo);
        if (message.TimerID != null && Object.hasOwnProperty.call(message, "TimerID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.TimerID);
        if (message.Duration != null && Object.hasOwnProperty.call(message, "Duration"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.Duration);
        if (message.Elapsed != null && Object.hasOwnProperty.call(message, "Elapsed"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Elapsed);
        if (message.Operation != null && Object.hasOwnProperty.call(message, "Operation"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Operation);
        if (message.Show != null && Object.hasOwnProperty.call(message, "Show"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.Show);
        if (message.Delay != null && Object.hasOwnProperty.call(message, "Delay"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.Delay);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushTimer message, length delimited. Does not implicitly {@link GameSrvToDeskPushTimer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {IGameSrvToDeskPushTimer} message GameSrvToDeskPushTimer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushTimer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushTimer message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushTimer} GameSrvToDeskPushTimer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushTimer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushTimer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 2: {
                    message.TimerID = reader.uint64();
                    break;
                }
            case 3: {
                    message.Duration = reader.uint64();
                    break;
                }
            case 4: {
                    message.Elapsed = reader.uint64();
                    break;
                }
            case 5: {
                    message.Operation = reader.int32();
                    break;
                }
            case 6: {
                    message.Show = reader.int32();
                    break;
                }
            case 7: {
                    message.Delay = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushTimer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushTimer} GameSrvToDeskPushTimer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushTimer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushTimer message.
     * @function verify
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushTimer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.TimerID != null && message.hasOwnProperty("TimerID"))
            if (!$util.isInteger(message.TimerID) && !(message.TimerID && $util.isInteger(message.TimerID.low) && $util.isInteger(message.TimerID.high)))
                return "TimerID: integer|Long expected";
        if (message.Duration != null && message.hasOwnProperty("Duration"))
            if (!$util.isInteger(message.Duration) && !(message.Duration && $util.isInteger(message.Duration.low) && $util.isInteger(message.Duration.high)))
                return "Duration: integer|Long expected";
        if (message.Elapsed != null && message.hasOwnProperty("Elapsed"))
            if (!$util.isInteger(message.Elapsed) && !(message.Elapsed && $util.isInteger(message.Elapsed.low) && $util.isInteger(message.Elapsed.high)))
                return "Elapsed: integer|Long expected";
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            switch (message.Operation) {
            default:
                return "Operation: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Show != null && message.hasOwnProperty("Show"))
            switch (message.Show) {
            default:
                return "Show: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.Delay != null && message.hasOwnProperty("Delay"))
            if (!$util.isInteger(message.Delay) && !(message.Delay && $util.isInteger(message.Delay.low) && $util.isInteger(message.Delay.high)))
                return "Delay: integer|Long expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushTimer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushTimer} GameSrvToDeskPushTimer
     */
    GameSrvToDeskPushTimer.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushTimer)
            return object;
        let message = new $root.GameSrvToDeskPushTimer();
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.TimerID != null)
            if ($util.Long)
                (message.TimerID = $util.Long.fromValue(object.TimerID)).unsigned = true;
            else if (typeof object.TimerID === "string")
                message.TimerID = parseInt(object.TimerID, 10);
            else if (typeof object.TimerID === "number")
                message.TimerID = object.TimerID;
            else if (typeof object.TimerID === "object")
                message.TimerID = new $util.LongBits(object.TimerID.low >>> 0, object.TimerID.high >>> 0).toNumber(true);
        if (object.Duration != null)
            if ($util.Long)
                (message.Duration = $util.Long.fromValue(object.Duration)).unsigned = true;
            else if (typeof object.Duration === "string")
                message.Duration = parseInt(object.Duration, 10);
            else if (typeof object.Duration === "number")
                message.Duration = object.Duration;
            else if (typeof object.Duration === "object")
                message.Duration = new $util.LongBits(object.Duration.low >>> 0, object.Duration.high >>> 0).toNumber(true);
        if (object.Elapsed != null)
            if ($util.Long)
                (message.Elapsed = $util.Long.fromValue(object.Elapsed)).unsigned = true;
            else if (typeof object.Elapsed === "string")
                message.Elapsed = parseInt(object.Elapsed, 10);
            else if (typeof object.Elapsed === "number")
                message.Elapsed = object.Elapsed;
            else if (typeof object.Elapsed === "object")
                message.Elapsed = new $util.LongBits(object.Elapsed.low >>> 0, object.Elapsed.high >>> 0).toNumber(true);
        switch (object.Operation) {
        default:
            if (typeof object.Operation === "number") {
                message.Operation = object.Operation;
                break;
            }
            break;
        case "CLOSE":
        case 0:
            message.Operation = 0;
            break;
        case "OPEN":
        case 1:
            message.Operation = 1;
            break;
        }
        switch (object.Show) {
        default:
            if (typeof object.Show === "number") {
                message.Show = object.Show;
                break;
            }
            break;
        case "HIDDEN":
        case 0:
            message.Show = 0;
            break;
        case "SHOW":
        case 1:
            message.Show = 1;
            break;
        case "WAIT":
        case 2:
            message.Show = 2;
            break;
        case "POOLOUT":
        case 3:
            message.Show = 3;
            break;
        case "CHARGE":
        case 4:
            message.Show = 4;
            break;
        case "WAITORDER":
        case 5:
            message.Show = 5;
            break;
        }
        if (object.Delay != null)
            if ($util.Long)
                (message.Delay = $util.Long.fromValue(object.Delay)).unsigned = true;
            else if (typeof object.Delay === "string")
                message.Delay = parseInt(object.Delay, 10);
            else if (typeof object.Delay === "number")
                message.Delay = object.Delay;
            else if (typeof object.Delay === "object")
                message.Delay = new $util.LongBits(object.Delay.low >>> 0, object.Delay.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushTimer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {GameSrvToDeskPushTimer} message GameSrvToDeskPushTimer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushTimer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TimerID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TimerID = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Duration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Duration = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Elapsed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Elapsed = options.longs === String ? "0" : 0;
            object.Operation = options.enums === String ? "CLOSE" : 0;
            object.Show = options.enums === String ? "HIDDEN" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Delay = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Delay = options.longs === String ? "0" : 0;
        }
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.TimerID != null && message.hasOwnProperty("TimerID"))
            if (typeof message.TimerID === "number")
                object.TimerID = options.longs === String ? String(message.TimerID) : message.TimerID;
            else
                object.TimerID = options.longs === String ? $util.Long.prototype.toString.call(message.TimerID) : options.longs === Number ? new $util.LongBits(message.TimerID.low >>> 0, message.TimerID.high >>> 0).toNumber(true) : message.TimerID;
        if (message.Duration != null && message.hasOwnProperty("Duration"))
            if (typeof message.Duration === "number")
                object.Duration = options.longs === String ? String(message.Duration) : message.Duration;
            else
                object.Duration = options.longs === String ? $util.Long.prototype.toString.call(message.Duration) : options.longs === Number ? new $util.LongBits(message.Duration.low >>> 0, message.Duration.high >>> 0).toNumber(true) : message.Duration;
        if (message.Elapsed != null && message.hasOwnProperty("Elapsed"))
            if (typeof message.Elapsed === "number")
                object.Elapsed = options.longs === String ? String(message.Elapsed) : message.Elapsed;
            else
                object.Elapsed = options.longs === String ? $util.Long.prototype.toString.call(message.Elapsed) : options.longs === Number ? new $util.LongBits(message.Elapsed.low >>> 0, message.Elapsed.high >>> 0).toNumber(true) : message.Elapsed;
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            object.Operation = options.enums === String ? $root.GameSrvToDeskPushTimer.OperType[message.Operation] === undefined ? message.Operation : $root.GameSrvToDeskPushTimer.OperType[message.Operation] : message.Operation;
        if (message.Show != null && message.hasOwnProperty("Show"))
            object.Show = options.enums === String ? $root.GameSrvToDeskPushTimer.ShowType[message.Show] === undefined ? message.Show : $root.GameSrvToDeskPushTimer.ShowType[message.Show] : message.Show;
        if (message.Delay != null && message.hasOwnProperty("Delay"))
            if (typeof message.Delay === "number")
                object.Delay = options.longs === String ? String(message.Delay) : message.Delay;
            else
                object.Delay = options.longs === String ? $util.Long.prototype.toString.call(message.Delay) : options.longs === Number ? new $util.LongBits(message.Delay.low >>> 0, message.Delay.high >>> 0).toNumber(true) : message.Delay;
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushTimer to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushTimer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushTimer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushTimer
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushTimer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushTimer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushTimer";
    };

    /**
     * OperType enum.
     * @name GameSrvToDeskPushTimer.OperType
     * @enum {number}
     * @property {number} CLOSE=0 CLOSE value
     * @property {number} OPEN=1 OPEN value
     */
    GameSrvToDeskPushTimer.OperType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CLOSE"] = 0;
        values[valuesById[1] = "OPEN"] = 1;
        return values;
    })();

    /**
     * ShowType enum.
     * @name GameSrvToDeskPushTimer.ShowType
     * @enum {number}
     * @property {number} HIDDEN=0 HIDDEN value
     * @property {number} SHOW=1 SHOW value
     * @property {number} WAIT=2 WAIT value
     * @property {number} POOLOUT=3 POOLOUT value
     * @property {number} CHARGE=4 CHARGE value
     * @property {number} WAITORDER=5 WAITORDER value
     */
    GameSrvToDeskPushTimer.ShowType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "HIDDEN"] = 0;
        values[valuesById[1] = "SHOW"] = 1;
        values[valuesById[2] = "WAIT"] = 2;
        values[valuesById[3] = "POOLOUT"] = 3;
        values[valuesById[4] = "CHARGE"] = 4;
        values[valuesById[5] = "WAITORDER"] = 5;
        return values;
    })();

    return GameSrvToDeskPushTimer;
})();

export const DeskToGameSrvPlayerShowCardReq = $root.DeskToGameSrvPlayerShowCardReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerShowCardReq.
     * @exports IDeskToGameSrvPlayerShowCardReq
     * @interface IDeskToGameSrvPlayerShowCardReq
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerShowCardReq DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerShowCardReq UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerShowCardReq SeatNo
     */

    /**
     * Constructs a new DeskToGameSrvPlayerShowCardReq.
     * @exports DeskToGameSrvPlayerShowCardReq
     * @classdesc Represents a DeskToGameSrvPlayerShowCardReq.
     * @implements IDeskToGameSrvPlayerShowCardReq
     * @constructor
     * @param {IDeskToGameSrvPlayerShowCardReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerShowCardReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerShowCardReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @instance
     */
    DeskToGameSrvPlayerShowCardReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerShowCardReq UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @instance
     */
    DeskToGameSrvPlayerShowCardReq.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerShowCardReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @instance
     */
    DeskToGameSrvPlayerShowCardReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToGameSrvPlayerShowCardReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {IDeskToGameSrvPlayerShowCardReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerShowCardReq} DeskToGameSrvPlayerShowCardReq instance
     */
    DeskToGameSrvPlayerShowCardReq.create = function create(properties) {
        return new DeskToGameSrvPlayerShowCardReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerShowCardReq message. Does not implicitly {@link DeskToGameSrvPlayerShowCardReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {IDeskToGameSrvPlayerShowCardReq} message DeskToGameSrvPlayerShowCardReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerShowCardReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerShowCardReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerShowCardReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {IDeskToGameSrvPlayerShowCardReq} message DeskToGameSrvPlayerShowCardReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerShowCardReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerShowCardReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerShowCardReq} DeskToGameSrvPlayerShowCardReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerShowCardReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerShowCardReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerShowCardReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerShowCardReq} DeskToGameSrvPlayerShowCardReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerShowCardReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerShowCardReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerShowCardReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerShowCardReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerShowCardReq} DeskToGameSrvPlayerShowCardReq
     */
    DeskToGameSrvPlayerShowCardReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerShowCardReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerShowCardReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerShowCardReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {DeskToGameSrvPlayerShowCardReq} message DeskToGameSrvPlayerShowCardReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerShowCardReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerShowCardReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerShowCardReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerShowCardReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerShowCardReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerShowCardReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerShowCardReq";
    };

    return DeskToGameSrvPlayerShowCardReq;
})();

export const DeskToGameSrvPlayerShowCardAck = $root.DeskToGameSrvPlayerShowCardAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerShowCardAck.
     * @exports IDeskToGameSrvPlayerShowCardAck
     * @interface IDeskToGameSrvPlayerShowCardAck
     * @property {number|null} [Res] DeskToGameSrvPlayerShowCardAck Res
     * @property {number|null} [UserID] DeskToGameSrvPlayerShowCardAck UserID
     * @property {Array.<number>|null} [HandCard] DeskToGameSrvPlayerShowCardAck HandCard
     */

    /**
     * Constructs a new DeskToGameSrvPlayerShowCardAck.
     * @exports DeskToGameSrvPlayerShowCardAck
     * @classdesc Represents a DeskToGameSrvPlayerShowCardAck.
     * @implements IDeskToGameSrvPlayerShowCardAck
     * @constructor
     * @param {IDeskToGameSrvPlayerShowCardAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerShowCardAck(properties) {
        this.HandCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerShowCardAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @instance
     */
    DeskToGameSrvPlayerShowCardAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerShowCardAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @instance
     */
    DeskToGameSrvPlayerShowCardAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerShowCardAck HandCard.
     * @member {Array.<number>} HandCard
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @instance
     */
    DeskToGameSrvPlayerShowCardAck.prototype.HandCard = $util.emptyArray;

    /**
     * Creates a new DeskToGameSrvPlayerShowCardAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {IDeskToGameSrvPlayerShowCardAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerShowCardAck} DeskToGameSrvPlayerShowCardAck instance
     */
    DeskToGameSrvPlayerShowCardAck.create = function create(properties) {
        return new DeskToGameSrvPlayerShowCardAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerShowCardAck message. Does not implicitly {@link DeskToGameSrvPlayerShowCardAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {IDeskToGameSrvPlayerShowCardAck} message DeskToGameSrvPlayerShowCardAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerShowCardAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerShowCardAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerShowCardAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {IDeskToGameSrvPlayerShowCardAck} message DeskToGameSrvPlayerShowCardAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerShowCardAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerShowCardAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerShowCardAck} DeskToGameSrvPlayerShowCardAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerShowCardAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerShowCardAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerShowCardAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerShowCardAck} DeskToGameSrvPlayerShowCardAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerShowCardAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerShowCardAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerShowCardAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerShowCardAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerShowCardAck} DeskToGameSrvPlayerShowCardAck
     */
    DeskToGameSrvPlayerShowCardAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerShowCardAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerShowCardAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".DeskToGameSrvPlayerShowCardAck.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerShowCardAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {DeskToGameSrvPlayerShowCardAck} message DeskToGameSrvPlayerShowCardAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerShowCardAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.HandCard = [];
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerShowCardAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerShowCardAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerShowCardAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerShowCardAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerShowCardAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerShowCardAck";
    };

    return DeskToGameSrvPlayerShowCardAck;
})();

export const GameSrvToDeskPushStateMachine = $root.GameSrvToDeskPushStateMachine = (() => {

    /**
     * Properties of a GameSrvToDeskPushStateMachine.
     * @exports IGameSrvToDeskPushStateMachine
     * @interface IGameSrvToDeskPushStateMachine
     * @property {number|null} [UserID] GameSrvToDeskPushStateMachine UserID
     * @property {number|null} [StateID] GameSrvToDeskPushStateMachine StateID
     * @property {number|null} [Utype] GameSrvToDeskPushStateMachine Utype
     */

    /**
     * Constructs a new GameSrvToDeskPushStateMachine.
     * @exports GameSrvToDeskPushStateMachine
     * @classdesc Represents a GameSrvToDeskPushStateMachine.
     * @implements IGameSrvToDeskPushStateMachine
     * @constructor
     * @param {IGameSrvToDeskPushStateMachine=} [properties] Properties to set
     */
    function GameSrvToDeskPushStateMachine(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushStateMachine UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushStateMachine
     * @instance
     */
    GameSrvToDeskPushStateMachine.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushStateMachine StateID.
     * @member {number} StateID
     * @memberof GameSrvToDeskPushStateMachine
     * @instance
     */
    GameSrvToDeskPushStateMachine.prototype.StateID = 0;

    /**
     * GameSrvToDeskPushStateMachine Utype.
     * @member {number} Utype
     * @memberof GameSrvToDeskPushStateMachine
     * @instance
     */
    GameSrvToDeskPushStateMachine.prototype.Utype = 0;

    /**
     * Creates a new GameSrvToDeskPushStateMachine instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {IGameSrvToDeskPushStateMachine=} [properties] Properties to set
     * @returns {GameSrvToDeskPushStateMachine} GameSrvToDeskPushStateMachine instance
     */
    GameSrvToDeskPushStateMachine.create = function create(properties) {
        return new GameSrvToDeskPushStateMachine(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushStateMachine message. Does not implicitly {@link GameSrvToDeskPushStateMachine.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {IGameSrvToDeskPushStateMachine} message GameSrvToDeskPushStateMachine message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushStateMachine.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.Utype != null && Object.hasOwnProperty.call(message, "Utype"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Utype);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushStateMachine message, length delimited. Does not implicitly {@link GameSrvToDeskPushStateMachine.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {IGameSrvToDeskPushStateMachine} message GameSrvToDeskPushStateMachine message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushStateMachine.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushStateMachine message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushStateMachine} GameSrvToDeskPushStateMachine
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushStateMachine.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushStateMachine();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Utype = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushStateMachine message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushStateMachine} GameSrvToDeskPushStateMachine
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushStateMachine.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushStateMachine message.
     * @function verify
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushStateMachine.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.Utype != null && message.hasOwnProperty("Utype"))
            if (!$util.isInteger(message.Utype))
                return "Utype: integer expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushStateMachine message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushStateMachine} GameSrvToDeskPushStateMachine
     */
    GameSrvToDeskPushStateMachine.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushStateMachine)
            return object;
        let message = new $root.GameSrvToDeskPushStateMachine();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.Utype != null)
            message.Utype = object.Utype >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushStateMachine message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {GameSrvToDeskPushStateMachine} message GameSrvToDeskPushStateMachine
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushStateMachine.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.Utype = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.Utype != null && message.hasOwnProperty("Utype"))
            object.Utype = message.Utype;
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushStateMachine to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushStateMachine
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushStateMachine.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushStateMachine
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushStateMachine
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushStateMachine.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushStateMachine";
    };

    return GameSrvToDeskPushStateMachine;
})();

export const GameSrvToClientHandGroupData = $root.GameSrvToClientHandGroupData = (() => {

    /**
     * Properties of a GameSrvToClientHandGroupData.
     * @exports IGameSrvToClientHandGroupData
     * @interface IGameSrvToClientHandGroupData
     * @property {number|null} [UserID] GameSrvToClientHandGroupData UserID
     */

    /**
     * Constructs a new GameSrvToClientHandGroupData.
     * @exports GameSrvToClientHandGroupData
     * @classdesc Represents a GameSrvToClientHandGroupData.
     * @implements IGameSrvToClientHandGroupData
     * @constructor
     * @param {IGameSrvToClientHandGroupData=} [properties] Properties to set
     */
    function GameSrvToClientHandGroupData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToClientHandGroupData UserID.
     * @member {number} UserID
     * @memberof GameSrvToClientHandGroupData
     * @instance
     */
    GameSrvToClientHandGroupData.prototype.UserID = 0;

    /**
     * Creates a new GameSrvToClientHandGroupData instance using the specified properties.
     * @function create
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {IGameSrvToClientHandGroupData=} [properties] Properties to set
     * @returns {GameSrvToClientHandGroupData} GameSrvToClientHandGroupData instance
     */
    GameSrvToClientHandGroupData.create = function create(properties) {
        return new GameSrvToClientHandGroupData(properties);
    };

    /**
     * Encodes the specified GameSrvToClientHandGroupData message. Does not implicitly {@link GameSrvToClientHandGroupData.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {IGameSrvToClientHandGroupData} message GameSrvToClientHandGroupData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToClientHandGroupData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToClientHandGroupData message, length delimited. Does not implicitly {@link GameSrvToClientHandGroupData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {IGameSrvToClientHandGroupData} message GameSrvToClientHandGroupData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToClientHandGroupData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToClientHandGroupData message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToClientHandGroupData} GameSrvToClientHandGroupData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToClientHandGroupData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToClientHandGroupData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToClientHandGroupData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToClientHandGroupData} GameSrvToClientHandGroupData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToClientHandGroupData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToClientHandGroupData message.
     * @function verify
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToClientHandGroupData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a GameSrvToClientHandGroupData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToClientHandGroupData} GameSrvToClientHandGroupData
     */
    GameSrvToClientHandGroupData.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToClientHandGroupData)
            return object;
        let message = new $root.GameSrvToClientHandGroupData();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToClientHandGroupData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {GameSrvToClientHandGroupData} message GameSrvToClientHandGroupData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToClientHandGroupData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this GameSrvToClientHandGroupData to JSON.
     * @function toJSON
     * @memberof GameSrvToClientHandGroupData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToClientHandGroupData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToClientHandGroupData
     * @function getTypeUrl
     * @memberof GameSrvToClientHandGroupData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToClientHandGroupData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToClientHandGroupData";
    };

    return GameSrvToClientHandGroupData;
})();

export const GameSrvToDeskPushDeskStatus = $root.GameSrvToDeskPushDeskStatus = (() => {

    /**
     * Properties of a GameSrvToDeskPushDeskStatus.
     * @exports IGameSrvToDeskPushDeskStatus
     * @interface IGameSrvToDeskPushDeskStatus
     * @property {number|null} [GameID] GameSrvToDeskPushDeskStatus GameID
     * @property {number|null} [ProductID] GameSrvToDeskPushDeskStatus ProductID
     * @property {number|null} [DeskNo] GameSrvToDeskPushDeskStatus DeskNo
     * @property {number|null} [DeskSign] GameSrvToDeskPushDeskStatus DeskSign
     * @property {number|Long|null} [DeskValue] GameSrvToDeskPushDeskStatus DeskValue
     */

    /**
     * Constructs a new GameSrvToDeskPushDeskStatus.
     * @exports GameSrvToDeskPushDeskStatus
     * @classdesc Represents a GameSrvToDeskPushDeskStatus.
     * @implements IGameSrvToDeskPushDeskStatus
     * @constructor
     * @param {IGameSrvToDeskPushDeskStatus=} [properties] Properties to set
     */
    function GameSrvToDeskPushDeskStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushDeskStatus GameID.
     * @member {number} GameID
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     */
    GameSrvToDeskPushDeskStatus.prototype.GameID = 0;

    /**
     * GameSrvToDeskPushDeskStatus ProductID.
     * @member {number} ProductID
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     */
    GameSrvToDeskPushDeskStatus.prototype.ProductID = 0;

    /**
     * GameSrvToDeskPushDeskStatus DeskNo.
     * @member {number} DeskNo
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     */
    GameSrvToDeskPushDeskStatus.prototype.DeskNo = 0;

    /**
     * GameSrvToDeskPushDeskStatus DeskSign.
     * @member {number} DeskSign
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     */
    GameSrvToDeskPushDeskStatus.prototype.DeskSign = 0;

    /**
     * GameSrvToDeskPushDeskStatus DeskValue.
     * @member {number|Long} DeskValue
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     */
    GameSrvToDeskPushDeskStatus.prototype.DeskValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new GameSrvToDeskPushDeskStatus instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {IGameSrvToDeskPushDeskStatus=} [properties] Properties to set
     * @returns {GameSrvToDeskPushDeskStatus} GameSrvToDeskPushDeskStatus instance
     */
    GameSrvToDeskPushDeskStatus.create = function create(properties) {
        return new GameSrvToDeskPushDeskStatus(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushDeskStatus message. Does not implicitly {@link GameSrvToDeskPushDeskStatus.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {IGameSrvToDeskPushDeskStatus} message GameSrvToDeskPushDeskStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushDeskStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DeskNo);
        if (message.DeskSign != null && Object.hasOwnProperty.call(message, "DeskSign"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskSign);
        if (message.DeskValue != null && Object.hasOwnProperty.call(message, "DeskValue"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.DeskValue);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushDeskStatus message, length delimited. Does not implicitly {@link GameSrvToDeskPushDeskStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {IGameSrvToDeskPushDeskStatus} message GameSrvToDeskPushDeskStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushDeskStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushDeskStatus message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushDeskStatus} GameSrvToDeskPushDeskStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushDeskStatus.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushDeskStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskSign = reader.uint32();
                    break;
                }
            case 5: {
                    message.DeskValue = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushDeskStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushDeskStatus} GameSrvToDeskPushDeskStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushDeskStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushDeskStatus message.
     * @function verify
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushDeskStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.DeskSign != null && message.hasOwnProperty("DeskSign"))
            if (!$util.isInteger(message.DeskSign))
                return "DeskSign: integer expected";
        if (message.DeskValue != null && message.hasOwnProperty("DeskValue"))
            if (!$util.isInteger(message.DeskValue) && !(message.DeskValue && $util.isInteger(message.DeskValue.low) && $util.isInteger(message.DeskValue.high)))
                return "DeskValue: integer|Long expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushDeskStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushDeskStatus} GameSrvToDeskPushDeskStatus
     */
    GameSrvToDeskPushDeskStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushDeskStatus)
            return object;
        let message = new $root.GameSrvToDeskPushDeskStatus();
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.DeskSign != null)
            message.DeskSign = object.DeskSign >>> 0;
        if (object.DeskValue != null)
            if ($util.Long)
                (message.DeskValue = $util.Long.fromValue(object.DeskValue)).unsigned = false;
            else if (typeof object.DeskValue === "string")
                message.DeskValue = parseInt(object.DeskValue, 10);
            else if (typeof object.DeskValue === "number")
                message.DeskValue = object.DeskValue;
            else if (typeof object.DeskValue === "object")
                message.DeskValue = new $util.LongBits(object.DeskValue.low >>> 0, object.DeskValue.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushDeskStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {GameSrvToDeskPushDeskStatus} message GameSrvToDeskPushDeskStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushDeskStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.DeskSign = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.DeskValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.DeskValue = options.longs === String ? "0" : 0;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.DeskSign != null && message.hasOwnProperty("DeskSign"))
            object.DeskSign = message.DeskSign;
        if (message.DeskValue != null && message.hasOwnProperty("DeskValue"))
            if (typeof message.DeskValue === "number")
                object.DeskValue = options.longs === String ? String(message.DeskValue) : message.DeskValue;
            else
                object.DeskValue = options.longs === String ? $util.Long.prototype.toString.call(message.DeskValue) : options.longs === Number ? new $util.LongBits(message.DeskValue.low >>> 0, message.DeskValue.high >>> 0).toNumber() : message.DeskValue;
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushDeskStatus to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushDeskStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushDeskStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushDeskStatus
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushDeskStatus
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushDeskStatus.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushDeskStatus";
    };

    return GameSrvToDeskPushDeskStatus;
})();

export const GameToAccSrvReqGoldNewChange = $root.GameToAccSrvReqGoldNewChange = (() => {

    /**
     * Properties of a GameToAccSrvReqGoldNewChange.
     * @exports IGameToAccSrvReqGoldNewChange
     * @interface IGameToAccSrvReqGoldNewChange
     * @property {number|null} [UserID] GameToAccSrvReqGoldNewChange UserID
     * @property {number|null} [GameID] GameToAccSrvReqGoldNewChange GameID
     * @property {number|null} [ProductID] GameToAccSrvReqGoldNewChange ProductID
     * @property {number|null} [DeskNo] GameToAccSrvReqGoldNewChange DeskNo
     * @property {string|null} [GoldChange] GameToAccSrvReqGoldNewChange GoldChange
     * @property {string|null} [Tax] GameToAccSrvReqGoldNewChange Tax
     * @property {number|Long|null} [StartTime] GameToAccSrvReqGoldNewChange StartTime
     * @property {number|Long|null} [EndTime] GameToAccSrvReqGoldNewChange EndTime
     * @property {number|Long|null} [BetGold] GameToAccSrvReqGoldNewChange BetGold
     * @property {number|Long|null} [PrizeGold] GameToAccSrvReqGoldNewChange PrizeGold
     * @property {number|null} [LoseBonus] GameToAccSrvReqGoldNewChange LoseBonus
     * @property {number|null} [LoseDeposit] GameToAccSrvReqGoldNewChange LoseDeposit
     * @property {number|null} [WinBonus] GameToAccSrvReqGoldNewChange WinBonus
     * @property {number|null} [WinDeposit] GameToAccSrvReqGoldNewChange WinDeposit
     * @property {number|null} [WinWithdraw] GameToAccSrvReqGoldNewChange WinWithdraw
     */

    /**
     * Constructs a new GameToAccSrvReqGoldNewChange.
     * @exports GameToAccSrvReqGoldNewChange
     * @classdesc Represents a GameToAccSrvReqGoldNewChange.
     * @implements IGameToAccSrvReqGoldNewChange
     * @constructor
     * @param {IGameToAccSrvReqGoldNewChange=} [properties] Properties to set
     */
    function GameToAccSrvReqGoldNewChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqGoldNewChange UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.UserID = 0;

    /**
     * GameToAccSrvReqGoldNewChange GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.GameID = 0;

    /**
     * GameToAccSrvReqGoldNewChange ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqGoldNewChange DeskNo.
     * @member {number} DeskNo
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.DeskNo = 0;

    /**
     * GameToAccSrvReqGoldNewChange GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.GoldChange = "";

    /**
     * GameToAccSrvReqGoldNewChange Tax.
     * @member {string} Tax
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.Tax = "";

    /**
     * GameToAccSrvReqGoldNewChange StartTime.
     * @member {number|Long} StartTime
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.StartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldNewChange EndTime.
     * @member {number|Long} EndTime
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldNewChange BetGold.
     * @member {number|Long} BetGold
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldNewChange PrizeGold.
     * @member {number|Long} PrizeGold
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.PrizeGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldNewChange LoseBonus.
     * @member {number} LoseBonus
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.LoseBonus = 0;

    /**
     * GameToAccSrvReqGoldNewChange LoseDeposit.
     * @member {number} LoseDeposit
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.LoseDeposit = 0;

    /**
     * GameToAccSrvReqGoldNewChange WinBonus.
     * @member {number} WinBonus
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.WinBonus = 0;

    /**
     * GameToAccSrvReqGoldNewChange WinDeposit.
     * @member {number} WinDeposit
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.WinDeposit = 0;

    /**
     * GameToAccSrvReqGoldNewChange WinWithdraw.
     * @member {number} WinWithdraw
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     */
    GameToAccSrvReqGoldNewChange.prototype.WinWithdraw = 0;

    /**
     * Creates a new GameToAccSrvReqGoldNewChange instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {IGameToAccSrvReqGoldNewChange=} [properties] Properties to set
     * @returns {GameToAccSrvReqGoldNewChange} GameToAccSrvReqGoldNewChange instance
     */
    GameToAccSrvReqGoldNewChange.create = function create(properties) {
        return new GameToAccSrvReqGoldNewChange(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldNewChange message. Does not implicitly {@link GameToAccSrvReqGoldNewChange.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {IGameToAccSrvReqGoldNewChange} message GameToAccSrvReqGoldNewChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldNewChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GoldChange);
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Tax);
        if (message.StartTime != null && Object.hasOwnProperty.call(message, "StartTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.StartTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.EndTime);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.BetGold);
        if (message.PrizeGold != null && Object.hasOwnProperty.call(message, "PrizeGold"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.PrizeGold);
        if (message.LoseBonus != null && Object.hasOwnProperty.call(message, "LoseBonus"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.LoseBonus);
        if (message.LoseDeposit != null && Object.hasOwnProperty.call(message, "LoseDeposit"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.LoseDeposit);
        if (message.WinBonus != null && Object.hasOwnProperty.call(message, "WinBonus"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.WinBonus);
        if (message.WinDeposit != null && Object.hasOwnProperty.call(message, "WinDeposit"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.WinDeposit);
        if (message.WinWithdraw != null && Object.hasOwnProperty.call(message, "WinWithdraw"))
            writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.WinWithdraw);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldNewChange message, length delimited. Does not implicitly {@link GameToAccSrvReqGoldNewChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {IGameToAccSrvReqGoldNewChange} message GameToAccSrvReqGoldNewChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldNewChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqGoldNewChange message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqGoldNewChange} GameToAccSrvReqGoldNewChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldNewChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqGoldNewChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 5: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 6: {
                    message.Tax = reader.string();
                    break;
                }
            case 7: {
                    message.StartTime = reader.uint64();
                    break;
                }
            case 8: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 9: {
                    message.BetGold = reader.uint64();
                    break;
                }
            case 10: {
                    message.PrizeGold = reader.uint64();
                    break;
                }
            case 11: {
                    message.LoseBonus = reader.uint32();
                    break;
                }
            case 12: {
                    message.LoseDeposit = reader.uint32();
                    break;
                }
            case 13: {
                    message.WinBonus = reader.uint32();
                    break;
                }
            case 14: {
                    message.WinDeposit = reader.uint32();
                    break;
                }
            case 15: {
                    message.WinWithdraw = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqGoldNewChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqGoldNewChange} GameToAccSrvReqGoldNewChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldNewChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqGoldNewChange message.
     * @function verify
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqGoldNewChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (!$util.isInteger(message.StartTime) && !(message.StartTime && $util.isInteger(message.StartTime.low) && $util.isInteger(message.StartTime.high)))
                return "StartTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (!$util.isInteger(message.PrizeGold) && !(message.PrizeGold && $util.isInteger(message.PrizeGold.low) && $util.isInteger(message.PrizeGold.high)))
                return "PrizeGold: integer|Long expected";
        if (message.LoseBonus != null && message.hasOwnProperty("LoseBonus"))
            if (!$util.isInteger(message.LoseBonus))
                return "LoseBonus: integer expected";
        if (message.LoseDeposit != null && message.hasOwnProperty("LoseDeposit"))
            if (!$util.isInteger(message.LoseDeposit))
                return "LoseDeposit: integer expected";
        if (message.WinBonus != null && message.hasOwnProperty("WinBonus"))
            if (!$util.isInteger(message.WinBonus))
                return "WinBonus: integer expected";
        if (message.WinDeposit != null && message.hasOwnProperty("WinDeposit"))
            if (!$util.isInteger(message.WinDeposit))
                return "WinDeposit: integer expected";
        if (message.WinWithdraw != null && message.hasOwnProperty("WinWithdraw"))
            if (!$util.isInteger(message.WinWithdraw))
                return "WinWithdraw: integer expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqGoldNewChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqGoldNewChange} GameToAccSrvReqGoldNewChange
     */
    GameToAccSrvReqGoldNewChange.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqGoldNewChange)
            return object;
        let message = new $root.GameToAccSrvReqGoldNewChange();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        if (object.StartTime != null)
            if ($util.Long)
                (message.StartTime = $util.Long.fromValue(object.StartTime)).unsigned = true;
            else if (typeof object.StartTime === "string")
                message.StartTime = parseInt(object.StartTime, 10);
            else if (typeof object.StartTime === "number")
                message.StartTime = object.StartTime;
            else if (typeof object.StartTime === "object")
                message.StartTime = new $util.LongBits(object.StartTime.low >>> 0, object.StartTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        if (object.PrizeGold != null)
            if ($util.Long)
                (message.PrizeGold = $util.Long.fromValue(object.PrizeGold)).unsigned = true;
            else if (typeof object.PrizeGold === "string")
                message.PrizeGold = parseInt(object.PrizeGold, 10);
            else if (typeof object.PrizeGold === "number")
                message.PrizeGold = object.PrizeGold;
            else if (typeof object.PrizeGold === "object")
                message.PrizeGold = new $util.LongBits(object.PrizeGold.low >>> 0, object.PrizeGold.high >>> 0).toNumber(true);
        if (object.LoseBonus != null)
            message.LoseBonus = object.LoseBonus >>> 0;
        if (object.LoseDeposit != null)
            message.LoseDeposit = object.LoseDeposit >>> 0;
        if (object.WinBonus != null)
            message.WinBonus = object.WinBonus >>> 0;
        if (object.WinDeposit != null)
            message.WinDeposit = object.WinDeposit >>> 0;
        if (object.WinWithdraw != null)
            message.WinWithdraw = object.WinWithdraw >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqGoldNewChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {GameToAccSrvReqGoldNewChange} message GameToAccSrvReqGoldNewChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqGoldNewChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.GoldChange = "";
            object.Tax = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeGold = options.longs === String ? "0" : 0;
            object.LoseBonus = 0;
            object.LoseDeposit = 0;
            object.WinBonus = 0;
            object.WinDeposit = 0;
            object.WinWithdraw = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (typeof message.StartTime === "number")
                object.StartTime = options.longs === String ? String(message.StartTime) : message.StartTime;
            else
                object.StartTime = options.longs === String ? $util.Long.prototype.toString.call(message.StartTime) : options.longs === Number ? new $util.LongBits(message.StartTime.low >>> 0, message.StartTime.high >>> 0).toNumber(true) : message.StartTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (typeof message.PrizeGold === "number")
                object.PrizeGold = options.longs === String ? String(message.PrizeGold) : message.PrizeGold;
            else
                object.PrizeGold = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeGold) : options.longs === Number ? new $util.LongBits(message.PrizeGold.low >>> 0, message.PrizeGold.high >>> 0).toNumber(true) : message.PrizeGold;
        if (message.LoseBonus != null && message.hasOwnProperty("LoseBonus"))
            object.LoseBonus = message.LoseBonus;
        if (message.LoseDeposit != null && message.hasOwnProperty("LoseDeposit"))
            object.LoseDeposit = message.LoseDeposit;
        if (message.WinBonus != null && message.hasOwnProperty("WinBonus"))
            object.WinBonus = message.WinBonus;
        if (message.WinDeposit != null && message.hasOwnProperty("WinDeposit"))
            object.WinDeposit = message.WinDeposit;
        if (message.WinWithdraw != null && message.hasOwnProperty("WinWithdraw"))
            object.WinWithdraw = message.WinWithdraw;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqGoldNewChange to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqGoldNewChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqGoldNewChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqGoldNewChange
     * @function getTypeUrl
     * @memberof GameToAccSrvReqGoldNewChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqGoldNewChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqGoldNewChange";
    };

    return GameToAccSrvReqGoldNewChange;
})();

export const GameToAccSrvReqGoldChange = $root.GameToAccSrvReqGoldChange = (() => {

    /**
     * Properties of a GameToAccSrvReqGoldChange.
     * @exports IGameToAccSrvReqGoldChange
     * @interface IGameToAccSrvReqGoldChange
     * @property {number|null} [UserID] GameToAccSrvReqGoldChange UserID
     * @property {number|null} [GameID] GameToAccSrvReqGoldChange GameID
     * @property {number|null} [ProductID] GameToAccSrvReqGoldChange ProductID
     * @property {number|null} [DeskNo] GameToAccSrvReqGoldChange DeskNo
     * @property {string|null} [GoldChange] GameToAccSrvReqGoldChange GoldChange
     * @property {string|null} [Tax] GameToAccSrvReqGoldChange Tax
     * @property {number|Long|null} [StartTime] GameToAccSrvReqGoldChange StartTime
     * @property {number|Long|null} [EndTime] GameToAccSrvReqGoldChange EndTime
     * @property {string|null} [Bonus] GameToAccSrvReqGoldChange Bonus
     * @property {boolean|null} [WinBonus] GameToAccSrvReqGoldChange WinBonus
     */

    /**
     * Constructs a new GameToAccSrvReqGoldChange.
     * @exports GameToAccSrvReqGoldChange
     * @classdesc Represents a GameToAccSrvReqGoldChange.
     * @implements IGameToAccSrvReqGoldChange
     * @constructor
     * @param {IGameToAccSrvReqGoldChange=} [properties] Properties to set
     */
    function GameToAccSrvReqGoldChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqGoldChange UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.UserID = 0;

    /**
     * GameToAccSrvReqGoldChange GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.GameID = 0;

    /**
     * GameToAccSrvReqGoldChange ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqGoldChange DeskNo.
     * @member {number} DeskNo
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.DeskNo = 0;

    /**
     * GameToAccSrvReqGoldChange GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.GoldChange = "";

    /**
     * GameToAccSrvReqGoldChange Tax.
     * @member {string} Tax
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.Tax = "";

    /**
     * GameToAccSrvReqGoldChange StartTime.
     * @member {number|Long} StartTime
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.StartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldChange EndTime.
     * @member {number|Long} EndTime
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldChange Bonus.
     * @member {string} Bonus
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.Bonus = "";

    /**
     * GameToAccSrvReqGoldChange WinBonus.
     * @member {boolean} WinBonus
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     */
    GameToAccSrvReqGoldChange.prototype.WinBonus = false;

    /**
     * Creates a new GameToAccSrvReqGoldChange instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {IGameToAccSrvReqGoldChange=} [properties] Properties to set
     * @returns {GameToAccSrvReqGoldChange} GameToAccSrvReqGoldChange instance
     */
    GameToAccSrvReqGoldChange.create = function create(properties) {
        return new GameToAccSrvReqGoldChange(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldChange message. Does not implicitly {@link GameToAccSrvReqGoldChange.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {IGameToAccSrvReqGoldChange} message GameToAccSrvReqGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GoldChange);
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Tax);
        if (message.StartTime != null && Object.hasOwnProperty.call(message, "StartTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.StartTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.EndTime);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Bonus);
        if (message.WinBonus != null && Object.hasOwnProperty.call(message, "WinBonus"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.WinBonus);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldChange message, length delimited. Does not implicitly {@link GameToAccSrvReqGoldChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {IGameToAccSrvReqGoldChange} message GameToAccSrvReqGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqGoldChange message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqGoldChange} GameToAccSrvReqGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqGoldChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 5: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 6: {
                    message.Tax = reader.string();
                    break;
                }
            case 7: {
                    message.StartTime = reader.uint64();
                    break;
                }
            case 8: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 9: {
                    message.Bonus = reader.string();
                    break;
                }
            case 10: {
                    message.WinBonus = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqGoldChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqGoldChange} GameToAccSrvReqGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqGoldChange message.
     * @function verify
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqGoldChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (!$util.isInteger(message.StartTime) && !(message.StartTime && $util.isInteger(message.StartTime.low) && $util.isInteger(message.StartTime.high)))
                return "StartTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        if (message.WinBonus != null && message.hasOwnProperty("WinBonus"))
            if (typeof message.WinBonus !== "boolean")
                return "WinBonus: boolean expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqGoldChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqGoldChange} GameToAccSrvReqGoldChange
     */
    GameToAccSrvReqGoldChange.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqGoldChange)
            return object;
        let message = new $root.GameToAccSrvReqGoldChange();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        if (object.StartTime != null)
            if ($util.Long)
                (message.StartTime = $util.Long.fromValue(object.StartTime)).unsigned = true;
            else if (typeof object.StartTime === "string")
                message.StartTime = parseInt(object.StartTime, 10);
            else if (typeof object.StartTime === "number")
                message.StartTime = object.StartTime;
            else if (typeof object.StartTime === "object")
                message.StartTime = new $util.LongBits(object.StartTime.low >>> 0, object.StartTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        if (object.WinBonus != null)
            message.WinBonus = Boolean(object.WinBonus);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqGoldChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {GameToAccSrvReqGoldChange} message GameToAccSrvReqGoldChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqGoldChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.GoldChange = "";
            object.Tax = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            object.Bonus = "";
            object.WinBonus = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (typeof message.StartTime === "number")
                object.StartTime = options.longs === String ? String(message.StartTime) : message.StartTime;
            else
                object.StartTime = options.longs === String ? $util.Long.prototype.toString.call(message.StartTime) : options.longs === Number ? new $util.LongBits(message.StartTime.low >>> 0, message.StartTime.high >>> 0).toNumber(true) : message.StartTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        if (message.WinBonus != null && message.hasOwnProperty("WinBonus"))
            object.WinBonus = message.WinBonus;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqGoldChange to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqGoldChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqGoldChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqGoldChange
     * @function getTypeUrl
     * @memberof GameToAccSrvReqGoldChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqGoldChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqGoldChange";
    };

    return GameToAccSrvReqGoldChange;
})();

export const GameToAccSrvReqGamePlayRecord = $root.GameToAccSrvReqGamePlayRecord = (() => {

    /**
     * Properties of a GameToAccSrvReqGamePlayRecord.
     * @exports IGameToAccSrvReqGamePlayRecord
     * @interface IGameToAccSrvReqGamePlayRecord
     * @property {number|null} [UserID] GameToAccSrvReqGamePlayRecord UserID
     * @property {number|null} [UserIDType] GameToAccSrvReqGamePlayRecord UserIDType
     * @property {string|null} [SoleID] GameToAccSrvReqGamePlayRecord SoleID
     * @property {number|null} [GameID] GameToAccSrvReqGamePlayRecord GameID
     * @property {number|null} [ProductID] GameToAccSrvReqGamePlayRecord ProductID
     * @property {number|null} [MaxPlayer] GameToAccSrvReqGamePlayRecord MaxPlayer
     * @property {number|null} [DeskID] GameToAccSrvReqGamePlayRecord DeskID
     * @property {number|null} [Goldb] GameToAccSrvReqGamePlayRecord Goldb
     * @property {number|Long|null} [Goldc] GameToAccSrvReqGamePlayRecord Goldc
     * @property {number|null} [Tax] GameToAccSrvReqGamePlayRecord Tax
     * @property {number|null} [Battle] GameToAccSrvReqGamePlayRecord Battle
     * @property {number|Long|null} [BeginTime] GameToAccSrvReqGamePlayRecord BeginTime
     * @property {number|Long|null} [EndTime] GameToAccSrvReqGamePlayRecord EndTime
     * @property {string|null} [strJson] GameToAccSrvReqGamePlayRecord strJson
     */

    /**
     * Constructs a new GameToAccSrvReqGamePlayRecord.
     * @exports GameToAccSrvReqGamePlayRecord
     * @classdesc Represents a GameToAccSrvReqGamePlayRecord.
     * @implements IGameToAccSrvReqGamePlayRecord
     * @constructor
     * @param {IGameToAccSrvReqGamePlayRecord=} [properties] Properties to set
     */
    function GameToAccSrvReqGamePlayRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqGamePlayRecord UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.UserID = 0;

    /**
     * GameToAccSrvReqGamePlayRecord UserIDType.
     * @member {number} UserIDType
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.UserIDType = 0;

    /**
     * GameToAccSrvReqGamePlayRecord SoleID.
     * @member {string} SoleID
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.SoleID = "";

    /**
     * GameToAccSrvReqGamePlayRecord GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.GameID = 0;

    /**
     * GameToAccSrvReqGamePlayRecord ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqGamePlayRecord MaxPlayer.
     * @member {number} MaxPlayer
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.MaxPlayer = 0;

    /**
     * GameToAccSrvReqGamePlayRecord DeskID.
     * @member {number} DeskID
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.DeskID = 0;

    /**
     * GameToAccSrvReqGamePlayRecord Goldb.
     * @member {number} Goldb
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.Goldb = 0;

    /**
     * GameToAccSrvReqGamePlayRecord Goldc.
     * @member {number|Long} Goldc
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.Goldc = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * GameToAccSrvReqGamePlayRecord Tax.
     * @member {number} Tax
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.Tax = 0;

    /**
     * GameToAccSrvReqGamePlayRecord Battle.
     * @member {number} Battle
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.Battle = 0;

    /**
     * GameToAccSrvReqGamePlayRecord BeginTime.
     * @member {number|Long} BeginTime
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.BeginTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGamePlayRecord EndTime.
     * @member {number|Long} EndTime
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGamePlayRecord strJson.
     * @member {string} strJson
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     */
    GameToAccSrvReqGamePlayRecord.prototype.strJson = "";

    /**
     * Creates a new GameToAccSrvReqGamePlayRecord instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {IGameToAccSrvReqGamePlayRecord=} [properties] Properties to set
     * @returns {GameToAccSrvReqGamePlayRecord} GameToAccSrvReqGamePlayRecord instance
     */
    GameToAccSrvReqGamePlayRecord.create = function create(properties) {
        return new GameToAccSrvReqGamePlayRecord(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqGamePlayRecord message. Does not implicitly {@link GameToAccSrvReqGamePlayRecord.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {IGameToAccSrvReqGamePlayRecord} message GameToAccSrvReqGamePlayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGamePlayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.UserIDType != null && Object.hasOwnProperty.call(message, "UserIDType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserIDType);
        if (message.SoleID != null && Object.hasOwnProperty.call(message, "SoleID"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.SoleID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.ProductID);
        if (message.MaxPlayer != null && Object.hasOwnProperty.call(message, "MaxPlayer"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.MaxPlayer);
        if (message.DeskID != null && Object.hasOwnProperty.call(message, "DeskID"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.DeskID);
        if (message.Goldb != null && Object.hasOwnProperty.call(message, "Goldb"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Goldb);
        if (message.Goldc != null && Object.hasOwnProperty.call(message, "Goldc"))
            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.Goldc);
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.Tax);
        if (message.Battle != null && Object.hasOwnProperty.call(message, "Battle"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Battle);
        if (message.BeginTime != null && Object.hasOwnProperty.call(message, "BeginTime"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.BeginTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint64(message.EndTime);
        if (message.strJson != null && Object.hasOwnProperty.call(message, "strJson"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.strJson);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqGamePlayRecord message, length delimited. Does not implicitly {@link GameToAccSrvReqGamePlayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {IGameToAccSrvReqGamePlayRecord} message GameToAccSrvReqGamePlayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGamePlayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqGamePlayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqGamePlayRecord} GameToAccSrvReqGamePlayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGamePlayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqGamePlayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserIDType = reader.uint32();
                    break;
                }
            case 3: {
                    message.SoleID = reader.string();
                    break;
                }
            case 4: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 5: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 6: {
                    message.MaxPlayer = reader.int32();
                    break;
                }
            case 7: {
                    message.DeskID = reader.uint32();
                    break;
                }
            case 8: {
                    message.Goldb = reader.int32();
                    break;
                }
            case 9: {
                    message.Goldc = reader.int64();
                    break;
                }
            case 10: {
                    message.Tax = reader.int32();
                    break;
                }
            case 11: {
                    message.Battle = reader.uint32();
                    break;
                }
            case 12: {
                    message.BeginTime = reader.uint64();
                    break;
                }
            case 13: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 14: {
                    message.strJson = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqGamePlayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqGamePlayRecord} GameToAccSrvReqGamePlayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGamePlayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqGamePlayRecord message.
     * @function verify
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqGamePlayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.UserIDType != null && message.hasOwnProperty("UserIDType"))
            if (!$util.isInteger(message.UserIDType))
                return "UserIDType: integer expected";
        if (message.SoleID != null && message.hasOwnProperty("SoleID"))
            if (!$util.isString(message.SoleID))
                return "SoleID: string expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.MaxPlayer != null && message.hasOwnProperty("MaxPlayer"))
            if (!$util.isInteger(message.MaxPlayer))
                return "MaxPlayer: integer expected";
        if (message.DeskID != null && message.hasOwnProperty("DeskID"))
            if (!$util.isInteger(message.DeskID))
                return "DeskID: integer expected";
        if (message.Goldb != null && message.hasOwnProperty("Goldb"))
            if (!$util.isInteger(message.Goldb))
                return "Goldb: integer expected";
        if (message.Goldc != null && message.hasOwnProperty("Goldc"))
            if (!$util.isInteger(message.Goldc) && !(message.Goldc && $util.isInteger(message.Goldc.low) && $util.isInteger(message.Goldc.high)))
                return "Goldc: integer|Long expected";
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isInteger(message.Tax))
                return "Tax: integer expected";
        if (message.Battle != null && message.hasOwnProperty("Battle"))
            if (!$util.isInteger(message.Battle))
                return "Battle: integer expected";
        if (message.BeginTime != null && message.hasOwnProperty("BeginTime"))
            if (!$util.isInteger(message.BeginTime) && !(message.BeginTime && $util.isInteger(message.BeginTime.low) && $util.isInteger(message.BeginTime.high)))
                return "BeginTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.strJson != null && message.hasOwnProperty("strJson"))
            if (!$util.isString(message.strJson))
                return "strJson: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqGamePlayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqGamePlayRecord} GameToAccSrvReqGamePlayRecord
     */
    GameToAccSrvReqGamePlayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqGamePlayRecord)
            return object;
        let message = new $root.GameToAccSrvReqGamePlayRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.UserIDType != null)
            message.UserIDType = object.UserIDType >>> 0;
        if (object.SoleID != null)
            message.SoleID = String(object.SoleID);
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.MaxPlayer != null)
            message.MaxPlayer = object.MaxPlayer | 0;
        if (object.DeskID != null)
            message.DeskID = object.DeskID >>> 0;
        if (object.Goldb != null)
            message.Goldb = object.Goldb | 0;
        if (object.Goldc != null)
            if ($util.Long)
                (message.Goldc = $util.Long.fromValue(object.Goldc)).unsigned = false;
            else if (typeof object.Goldc === "string")
                message.Goldc = parseInt(object.Goldc, 10);
            else if (typeof object.Goldc === "number")
                message.Goldc = object.Goldc;
            else if (typeof object.Goldc === "object")
                message.Goldc = new $util.LongBits(object.Goldc.low >>> 0, object.Goldc.high >>> 0).toNumber();
        if (object.Tax != null)
            message.Tax = object.Tax | 0;
        if (object.Battle != null)
            message.Battle = object.Battle >>> 0;
        if (object.BeginTime != null)
            if ($util.Long)
                (message.BeginTime = $util.Long.fromValue(object.BeginTime)).unsigned = true;
            else if (typeof object.BeginTime === "string")
                message.BeginTime = parseInt(object.BeginTime, 10);
            else if (typeof object.BeginTime === "number")
                message.BeginTime = object.BeginTime;
            else if (typeof object.BeginTime === "object")
                message.BeginTime = new $util.LongBits(object.BeginTime.low >>> 0, object.BeginTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.strJson != null)
            message.strJson = String(object.strJson);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqGamePlayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {GameToAccSrvReqGamePlayRecord} message GameToAccSrvReqGamePlayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqGamePlayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.UserIDType = 0;
            object.SoleID = "";
            object.GameID = 0;
            object.ProductID = 0;
            object.MaxPlayer = 0;
            object.DeskID = 0;
            object.Goldb = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.Goldc = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Goldc = options.longs === String ? "0" : 0;
            object.Tax = 0;
            object.Battle = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BeginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BeginTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            object.strJson = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.UserIDType != null && message.hasOwnProperty("UserIDType"))
            object.UserIDType = message.UserIDType;
        if (message.SoleID != null && message.hasOwnProperty("SoleID"))
            object.SoleID = message.SoleID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.MaxPlayer != null && message.hasOwnProperty("MaxPlayer"))
            object.MaxPlayer = message.MaxPlayer;
        if (message.DeskID != null && message.hasOwnProperty("DeskID"))
            object.DeskID = message.DeskID;
        if (message.Goldb != null && message.hasOwnProperty("Goldb"))
            object.Goldb = message.Goldb;
        if (message.Goldc != null && message.hasOwnProperty("Goldc"))
            if (typeof message.Goldc === "number")
                object.Goldc = options.longs === String ? String(message.Goldc) : message.Goldc;
            else
                object.Goldc = options.longs === String ? $util.Long.prototype.toString.call(message.Goldc) : options.longs === Number ? new $util.LongBits(message.Goldc.low >>> 0, message.Goldc.high >>> 0).toNumber() : message.Goldc;
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        if (message.Battle != null && message.hasOwnProperty("Battle"))
            object.Battle = message.Battle;
        if (message.BeginTime != null && message.hasOwnProperty("BeginTime"))
            if (typeof message.BeginTime === "number")
                object.BeginTime = options.longs === String ? String(message.BeginTime) : message.BeginTime;
            else
                object.BeginTime = options.longs === String ? $util.Long.prototype.toString.call(message.BeginTime) : options.longs === Number ? new $util.LongBits(message.BeginTime.low >>> 0, message.BeginTime.high >>> 0).toNumber(true) : message.BeginTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.strJson != null && message.hasOwnProperty("strJson"))
            object.strJson = message.strJson;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqGamePlayRecord to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqGamePlayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqGamePlayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqGamePlayRecord
     * @function getTypeUrl
     * @memberof GameToAccSrvReqGamePlayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqGamePlayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqGamePlayRecord";
    };

    return GameToAccSrvReqGamePlayRecord;
})();

export const GameToAccSrvAckGoldChange = $root.GameToAccSrvAckGoldChange = (() => {

    /**
     * Properties of a GameToAccSrvAckGoldChange.
     * @exports IGameToAccSrvAckGoldChange
     * @interface IGameToAccSrvAckGoldChange
     * @property {number|null} [Res] GameToAccSrvAckGoldChange Res
     * @property {number|null} [UserID] GameToAccSrvAckGoldChange UserID
     * @property {number|null} [GameID] GameToAccSrvAckGoldChange GameID
     * @property {number|null} [ProductID] GameToAccSrvAckGoldChange ProductID
     * @property {number|null} [DeskNo] GameToAccSrvAckGoldChange DeskNo
     * @property {string|null} [GoldChange] GameToAccSrvAckGoldChange GoldChange
     */

    /**
     * Constructs a new GameToAccSrvAckGoldChange.
     * @exports GameToAccSrvAckGoldChange
     * @classdesc Represents a GameToAccSrvAckGoldChange.
     * @implements IGameToAccSrvAckGoldChange
     * @constructor
     * @param {IGameToAccSrvAckGoldChange=} [properties] Properties to set
     */
    function GameToAccSrvAckGoldChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvAckGoldChange Res.
     * @member {number} Res
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.Res = 0;

    /**
     * GameToAccSrvAckGoldChange UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.UserID = 0;

    /**
     * GameToAccSrvAckGoldChange GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.GameID = 0;

    /**
     * GameToAccSrvAckGoldChange ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.ProductID = 0;

    /**
     * GameToAccSrvAckGoldChange DeskNo.
     * @member {number} DeskNo
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.DeskNo = 0;

    /**
     * GameToAccSrvAckGoldChange GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     */
    GameToAccSrvAckGoldChange.prototype.GoldChange = "";

    /**
     * Creates a new GameToAccSrvAckGoldChange instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {IGameToAccSrvAckGoldChange=} [properties] Properties to set
     * @returns {GameToAccSrvAckGoldChange} GameToAccSrvAckGoldChange instance
     */
    GameToAccSrvAckGoldChange.create = function create(properties) {
        return new GameToAccSrvAckGoldChange(properties);
    };

    /**
     * Encodes the specified GameToAccSrvAckGoldChange message. Does not implicitly {@link GameToAccSrvAckGoldChange.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {IGameToAccSrvAckGoldChange} message GameToAccSrvAckGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckGoldChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.DeskNo);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.GoldChange);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvAckGoldChange message, length delimited. Does not implicitly {@link GameToAccSrvAckGoldChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {IGameToAccSrvAckGoldChange} message GameToAccSrvAckGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckGoldChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvAckGoldChange message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvAckGoldChange} GameToAccSrvAckGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckGoldChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvAckGoldChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 6: {
                    message.GoldChange = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvAckGoldChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvAckGoldChange} GameToAccSrvAckGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckGoldChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvAckGoldChange message.
     * @function verify
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvAckGoldChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvAckGoldChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvAckGoldChange} GameToAccSrvAckGoldChange
     */
    GameToAccSrvAckGoldChange.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvAckGoldChange)
            return object;
        let message = new $root.GameToAccSrvAckGoldChange();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvAckGoldChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {GameToAccSrvAckGoldChange} message GameToAccSrvAckGoldChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvAckGoldChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.GoldChange = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        return object;
    };

    /**
     * Converts this GameToAccSrvAckGoldChange to JSON.
     * @function toJSON
     * @memberof GameToAccSrvAckGoldChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvAckGoldChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvAckGoldChange
     * @function getTypeUrl
     * @memberof GameToAccSrvAckGoldChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvAckGoldChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvAckGoldChange";
    };

    return GameToAccSrvAckGoldChange;
})();

export const GameToAccSrvPushLight = $root.GameToAccSrvPushLight = (() => {

    /**
     * Properties of a GameToAccSrvPushLight.
     * @exports IGameToAccSrvPushLight
     * @interface IGameToAccSrvPushLight
     * @property {Uint8Array|null} [NotiyMsg] GameToAccSrvPushLight NotiyMsg
     */

    /**
     * Constructs a new GameToAccSrvPushLight.
     * @exports GameToAccSrvPushLight
     * @classdesc Represents a GameToAccSrvPushLight.
     * @implements IGameToAccSrvPushLight
     * @constructor
     * @param {IGameToAccSrvPushLight=} [properties] Properties to set
     */
    function GameToAccSrvPushLight(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvPushLight NotiyMsg.
     * @member {Uint8Array} NotiyMsg
     * @memberof GameToAccSrvPushLight
     * @instance
     */
    GameToAccSrvPushLight.prototype.NotiyMsg = $util.newBuffer([]);

    /**
     * Creates a new GameToAccSrvPushLight instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {IGameToAccSrvPushLight=} [properties] Properties to set
     * @returns {GameToAccSrvPushLight} GameToAccSrvPushLight instance
     */
    GameToAccSrvPushLight.create = function create(properties) {
        return new GameToAccSrvPushLight(properties);
    };

    /**
     * Encodes the specified GameToAccSrvPushLight message. Does not implicitly {@link GameToAccSrvPushLight.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {IGameToAccSrvPushLight} message GameToAccSrvPushLight message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvPushLight.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.NotiyMsg != null && Object.hasOwnProperty.call(message, "NotiyMsg"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.NotiyMsg);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvPushLight message, length delimited. Does not implicitly {@link GameToAccSrvPushLight.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {IGameToAccSrvPushLight} message GameToAccSrvPushLight message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvPushLight.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvPushLight message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvPushLight} GameToAccSrvPushLight
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvPushLight.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvPushLight();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.NotiyMsg = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvPushLight message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvPushLight} GameToAccSrvPushLight
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvPushLight.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvPushLight message.
     * @function verify
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvPushLight.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.NotiyMsg != null && message.hasOwnProperty("NotiyMsg"))
            if (!(message.NotiyMsg && typeof message.NotiyMsg.length === "number" || $util.isString(message.NotiyMsg)))
                return "NotiyMsg: buffer expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvPushLight message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvPushLight} GameToAccSrvPushLight
     */
    GameToAccSrvPushLight.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvPushLight)
            return object;
        let message = new $root.GameToAccSrvPushLight();
        if (object.NotiyMsg != null)
            if (typeof object.NotiyMsg === "string")
                $util.base64.decode(object.NotiyMsg, message.NotiyMsg = $util.newBuffer($util.base64.length(object.NotiyMsg)), 0);
            else if (object.NotiyMsg.length >= 0)
                message.NotiyMsg = object.NotiyMsg;
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvPushLight message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {GameToAccSrvPushLight} message GameToAccSrvPushLight
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvPushLight.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.NotiyMsg = "";
            else {
                object.NotiyMsg = [];
                if (options.bytes !== Array)
                    object.NotiyMsg = $util.newBuffer(object.NotiyMsg);
            }
        if (message.NotiyMsg != null && message.hasOwnProperty("NotiyMsg"))
            object.NotiyMsg = options.bytes === String ? $util.base64.encode(message.NotiyMsg, 0, message.NotiyMsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.NotiyMsg) : message.NotiyMsg;
        return object;
    };

    /**
     * Converts this GameToAccSrvPushLight to JSON.
     * @function toJSON
     * @memberof GameToAccSrvPushLight
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvPushLight.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvPushLight
     * @function getTypeUrl
     * @memberof GameToAccSrvPushLight
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvPushLight.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvPushLight";
    };

    return GameToAccSrvPushLight;
})();

export const GameToAccSrvReqUserCashGold = $root.GameToAccSrvReqUserCashGold = (() => {

    /**
     * Properties of a GameToAccSrvReqUserCashGold.
     * @exports IGameToAccSrvReqUserCashGold
     * @interface IGameToAccSrvReqUserCashGold
     * @property {number|null} [UserID] GameToAccSrvReqUserCashGold UserID
     * @property {number|null} [GameID] GameToAccSrvReqUserCashGold GameID
     * @property {number|null} [ProductID] GameToAccSrvReqUserCashGold ProductID
     * @property {number|null} [DeskNo] GameToAccSrvReqUserCashGold DeskNo
     */

    /**
     * Constructs a new GameToAccSrvReqUserCashGold.
     * @exports GameToAccSrvReqUserCashGold
     * @classdesc Represents a GameToAccSrvReqUserCashGold.
     * @implements IGameToAccSrvReqUserCashGold
     * @constructor
     * @param {IGameToAccSrvReqUserCashGold=} [properties] Properties to set
     */
    function GameToAccSrvReqUserCashGold(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqUserCashGold UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqUserCashGold
     * @instance
     */
    GameToAccSrvReqUserCashGold.prototype.UserID = 0;

    /**
     * GameToAccSrvReqUserCashGold GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqUserCashGold
     * @instance
     */
    GameToAccSrvReqUserCashGold.prototype.GameID = 0;

    /**
     * GameToAccSrvReqUserCashGold ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqUserCashGold
     * @instance
     */
    GameToAccSrvReqUserCashGold.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqUserCashGold DeskNo.
     * @member {number} DeskNo
     * @memberof GameToAccSrvReqUserCashGold
     * @instance
     */
    GameToAccSrvReqUserCashGold.prototype.DeskNo = 0;

    /**
     * Creates a new GameToAccSrvReqUserCashGold instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {IGameToAccSrvReqUserCashGold=} [properties] Properties to set
     * @returns {GameToAccSrvReqUserCashGold} GameToAccSrvReqUserCashGold instance
     */
    GameToAccSrvReqUserCashGold.create = function create(properties) {
        return new GameToAccSrvReqUserCashGold(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqUserCashGold message. Does not implicitly {@link GameToAccSrvReqUserCashGold.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {IGameToAccSrvReqUserCashGold} message GameToAccSrvReqUserCashGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqUserCashGold.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqUserCashGold message, length delimited. Does not implicitly {@link GameToAccSrvReqUserCashGold.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {IGameToAccSrvReqUserCashGold} message GameToAccSrvReqUserCashGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqUserCashGold.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqUserCashGold message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqUserCashGold} GameToAccSrvReqUserCashGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqUserCashGold.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqUserCashGold();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqUserCashGold message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqUserCashGold} GameToAccSrvReqUserCashGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqUserCashGold.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqUserCashGold message.
     * @function verify
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqUserCashGold.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqUserCashGold message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqUserCashGold} GameToAccSrvReqUserCashGold
     */
    GameToAccSrvReqUserCashGold.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqUserCashGold)
            return object;
        let message = new $root.GameToAccSrvReqUserCashGold();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqUserCashGold message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {GameToAccSrvReqUserCashGold} message GameToAccSrvReqUserCashGold
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqUserCashGold.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqUserCashGold to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqUserCashGold
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqUserCashGold.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqUserCashGold
     * @function getTypeUrl
     * @memberof GameToAccSrvReqUserCashGold
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqUserCashGold.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqUserCashGold";
    };

    return GameToAccSrvReqUserCashGold;
})();

export const GameToAccSrvAckUserCashGold = $root.GameToAccSrvAckUserCashGold = (() => {

    /**
     * Properties of a GameToAccSrvAckUserCashGold.
     * @exports IGameToAccSrvAckUserCashGold
     * @interface IGameToAccSrvAckUserCashGold
     * @property {number|null} [Res] GameToAccSrvAckUserCashGold Res
     * @property {number|null} [UserID] GameToAccSrvAckUserCashGold UserID
     * @property {number|null} [GameID] GameToAccSrvAckUserCashGold GameID
     * @property {number|null} [ProductID] GameToAccSrvAckUserCashGold ProductID
     * @property {number|null} [DeskNo] GameToAccSrvAckUserCashGold DeskNo
     * @property {string|null} [CashGold] GameToAccSrvAckUserCashGold CashGold
     * @property {string|null} [WinningRate] GameToAccSrvAckUserCashGold WinningRate
     * @property {string|null} [WithDrawGold] GameToAccSrvAckUserCashGold WithDrawGold
     * @property {string|null} [TopTotal] GameToAccSrvAckUserCashGold TopTotal
     * @property {string|null} [Gold] GameToAccSrvAckUserCashGold Gold
     * @property {string|null} [RebateGold] GameToAccSrvAckUserCashGold RebateGold
     * @property {number|null} [WinRepTimes] GameToAccSrvAckUserCashGold WinRepTimes
     */

    /**
     * Constructs a new GameToAccSrvAckUserCashGold.
     * @exports GameToAccSrvAckUserCashGold
     * @classdesc Represents a GameToAccSrvAckUserCashGold.
     * @implements IGameToAccSrvAckUserCashGold
     * @constructor
     * @param {IGameToAccSrvAckUserCashGold=} [properties] Properties to set
     */
    function GameToAccSrvAckUserCashGold(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvAckUserCashGold Res.
     * @member {number} Res
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.Res = 0;

    /**
     * GameToAccSrvAckUserCashGold UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.UserID = 0;

    /**
     * GameToAccSrvAckUserCashGold GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.GameID = 0;

    /**
     * GameToAccSrvAckUserCashGold ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.ProductID = 0;

    /**
     * GameToAccSrvAckUserCashGold DeskNo.
     * @member {number} DeskNo
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.DeskNo = 0;

    /**
     * GameToAccSrvAckUserCashGold CashGold.
     * @member {string} CashGold
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.CashGold = "";

    /**
     * GameToAccSrvAckUserCashGold WinningRate.
     * @member {string} WinningRate
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.WinningRate = "";

    /**
     * GameToAccSrvAckUserCashGold WithDrawGold.
     * @member {string} WithDrawGold
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.WithDrawGold = "";

    /**
     * GameToAccSrvAckUserCashGold TopTotal.
     * @member {string} TopTotal
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.TopTotal = "";

    /**
     * GameToAccSrvAckUserCashGold Gold.
     * @member {string} Gold
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.Gold = "";

    /**
     * GameToAccSrvAckUserCashGold RebateGold.
     * @member {string} RebateGold
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.RebateGold = "";

    /**
     * GameToAccSrvAckUserCashGold WinRepTimes.
     * @member {number} WinRepTimes
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     */
    GameToAccSrvAckUserCashGold.prototype.WinRepTimes = 0;

    /**
     * Creates a new GameToAccSrvAckUserCashGold instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {IGameToAccSrvAckUserCashGold=} [properties] Properties to set
     * @returns {GameToAccSrvAckUserCashGold} GameToAccSrvAckUserCashGold instance
     */
    GameToAccSrvAckUserCashGold.create = function create(properties) {
        return new GameToAccSrvAckUserCashGold(properties);
    };

    /**
     * Encodes the specified GameToAccSrvAckUserCashGold message. Does not implicitly {@link GameToAccSrvAckUserCashGold.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {IGameToAccSrvAckUserCashGold} message GameToAccSrvAckUserCashGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckUserCashGold.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.DeskNo);
        if (message.CashGold != null && Object.hasOwnProperty.call(message, "CashGold"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.CashGold);
        if (message.WinningRate != null && Object.hasOwnProperty.call(message, "WinningRate"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.WinningRate);
        if (message.WithDrawGold != null && Object.hasOwnProperty.call(message, "WithDrawGold"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.WithDrawGold);
        if (message.TopTotal != null && Object.hasOwnProperty.call(message, "TopTotal"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.TopTotal);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.Gold);
        if (message.RebateGold != null && Object.hasOwnProperty.call(message, "RebateGold"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.RebateGold);
        if (message.WinRepTimes != null && Object.hasOwnProperty.call(message, "WinRepTimes"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.WinRepTimes);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvAckUserCashGold message, length delimited. Does not implicitly {@link GameToAccSrvAckUserCashGold.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {IGameToAccSrvAckUserCashGold} message GameToAccSrvAckUserCashGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckUserCashGold.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvAckUserCashGold message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvAckUserCashGold} GameToAccSrvAckUserCashGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckUserCashGold.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvAckUserCashGold();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 6: {
                    message.CashGold = reader.string();
                    break;
                }
            case 7: {
                    message.WinningRate = reader.string();
                    break;
                }
            case 8: {
                    message.WithDrawGold = reader.string();
                    break;
                }
            case 9: {
                    message.TopTotal = reader.string();
                    break;
                }
            case 10: {
                    message.Gold = reader.string();
                    break;
                }
            case 11: {
                    message.RebateGold = reader.string();
                    break;
                }
            case 12: {
                    message.WinRepTimes = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvAckUserCashGold message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvAckUserCashGold} GameToAccSrvAckUserCashGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckUserCashGold.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvAckUserCashGold message.
     * @function verify
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvAckUserCashGold.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.CashGold != null && message.hasOwnProperty("CashGold"))
            if (!$util.isString(message.CashGold))
                return "CashGold: string expected";
        if (message.WinningRate != null && message.hasOwnProperty("WinningRate"))
            if (!$util.isString(message.WinningRate))
                return "WinningRate: string expected";
        if (message.WithDrawGold != null && message.hasOwnProperty("WithDrawGold"))
            if (!$util.isString(message.WithDrawGold))
                return "WithDrawGold: string expected";
        if (message.TopTotal != null && message.hasOwnProperty("TopTotal"))
            if (!$util.isString(message.TopTotal))
                return "TopTotal: string expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isString(message.Gold))
                return "Gold: string expected";
        if (message.RebateGold != null && message.hasOwnProperty("RebateGold"))
            if (!$util.isString(message.RebateGold))
                return "RebateGold: string expected";
        if (message.WinRepTimes != null && message.hasOwnProperty("WinRepTimes"))
            if (!$util.isInteger(message.WinRepTimes))
                return "WinRepTimes: integer expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvAckUserCashGold message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvAckUserCashGold} GameToAccSrvAckUserCashGold
     */
    GameToAccSrvAckUserCashGold.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvAckUserCashGold)
            return object;
        let message = new $root.GameToAccSrvAckUserCashGold();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.CashGold != null)
            message.CashGold = String(object.CashGold);
        if (object.WinningRate != null)
            message.WinningRate = String(object.WinningRate);
        if (object.WithDrawGold != null)
            message.WithDrawGold = String(object.WithDrawGold);
        if (object.TopTotal != null)
            message.TopTotal = String(object.TopTotal);
        if (object.Gold != null)
            message.Gold = String(object.Gold);
        if (object.RebateGold != null)
            message.RebateGold = String(object.RebateGold);
        if (object.WinRepTimes != null)
            message.WinRepTimes = object.WinRepTimes | 0;
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvAckUserCashGold message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {GameToAccSrvAckUserCashGold} message GameToAccSrvAckUserCashGold
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvAckUserCashGold.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.CashGold = "";
            object.WinningRate = "";
            object.WithDrawGold = "";
            object.TopTotal = "";
            object.Gold = "";
            object.RebateGold = "";
            object.WinRepTimes = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.CashGold != null && message.hasOwnProperty("CashGold"))
            object.CashGold = message.CashGold;
        if (message.WinningRate != null && message.hasOwnProperty("WinningRate"))
            object.WinningRate = message.WinningRate;
        if (message.WithDrawGold != null && message.hasOwnProperty("WithDrawGold"))
            object.WithDrawGold = message.WithDrawGold;
        if (message.TopTotal != null && message.hasOwnProperty("TopTotal"))
            object.TopTotal = message.TopTotal;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        if (message.RebateGold != null && message.hasOwnProperty("RebateGold"))
            object.RebateGold = message.RebateGold;
        if (message.WinRepTimes != null && message.hasOwnProperty("WinRepTimes"))
            object.WinRepTimes = message.WinRepTimes;
        return object;
    };

    /**
     * Converts this GameToAccSrvAckUserCashGold to JSON.
     * @function toJSON
     * @memberof GameToAccSrvAckUserCashGold
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvAckUserCashGold.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvAckUserCashGold
     * @function getTypeUrl
     * @memberof GameToAccSrvAckUserCashGold
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvAckUserCashGold.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvAckUserCashGold";
    };

    return GameToAccSrvAckUserCashGold;
})();

export const DeskToGamSrvPushPay = $root.DeskToGamSrvPushPay = (() => {

    /**
     * Properties of a DeskToGamSrvPushPay.
     * @exports IDeskToGamSrvPushPay
     * @interface IDeskToGamSrvPushPay
     * @property {number|null} [UserID] DeskToGamSrvPushPay UserID
     * @property {number|null} [DeskNo] DeskToGamSrvPushPay DeskNo
     * @property {string|null} [Amount] DeskToGamSrvPushPay Amount
     * @property {string|null} [Gold] DeskToGamSrvPushPay Gold
     */

    /**
     * Constructs a new DeskToGamSrvPushPay.
     * @exports DeskToGamSrvPushPay
     * @classdesc Represents a DeskToGamSrvPushPay.
     * @implements IDeskToGamSrvPushPay
     * @constructor
     * @param {IDeskToGamSrvPushPay=} [properties] Properties to set
     */
    function DeskToGamSrvPushPay(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvPushPay UserID.
     * @member {number} UserID
     * @memberof DeskToGamSrvPushPay
     * @instance
     */
    DeskToGamSrvPushPay.prototype.UserID = 0;

    /**
     * DeskToGamSrvPushPay DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGamSrvPushPay
     * @instance
     */
    DeskToGamSrvPushPay.prototype.DeskNo = 0;

    /**
     * DeskToGamSrvPushPay Amount.
     * @member {string} Amount
     * @memberof DeskToGamSrvPushPay
     * @instance
     */
    DeskToGamSrvPushPay.prototype.Amount = "";

    /**
     * DeskToGamSrvPushPay Gold.
     * @member {string} Gold
     * @memberof DeskToGamSrvPushPay
     * @instance
     */
    DeskToGamSrvPushPay.prototype.Gold = "";

    /**
     * Creates a new DeskToGamSrvPushPay instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {IDeskToGamSrvPushPay=} [properties] Properties to set
     * @returns {DeskToGamSrvPushPay} DeskToGamSrvPushPay instance
     */
    DeskToGamSrvPushPay.create = function create(properties) {
        return new DeskToGamSrvPushPay(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvPushPay message. Does not implicitly {@link DeskToGamSrvPushPay.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {IDeskToGamSrvPushPay} message DeskToGamSrvPushPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvPushPay.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Amount);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Gold);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvPushPay message, length delimited. Does not implicitly {@link DeskToGamSrvPushPay.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {IDeskToGamSrvPushPay} message DeskToGamSrvPushPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvPushPay.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvPushPay message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvPushPay} DeskToGamSrvPushPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvPushPay.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvPushPay();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.Amount = reader.string();
                    break;
                }
            case 4: {
                    message.Gold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvPushPay message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvPushPay} DeskToGamSrvPushPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvPushPay.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvPushPay message.
     * @function verify
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvPushPay.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isString(message.Gold))
                return "Gold: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvPushPay message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvPushPay} DeskToGamSrvPushPay
     */
    DeskToGamSrvPushPay.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvPushPay)
            return object;
        let message = new $root.DeskToGamSrvPushPay();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Gold != null)
            message.Gold = String(object.Gold);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvPushPay message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {DeskToGamSrvPushPay} message DeskToGamSrvPushPay
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvPushPay.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.DeskNo = 0;
            object.Amount = "";
            object.Gold = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        return object;
    };

    /**
     * Converts this DeskToGamSrvPushPay to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvPushPay
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvPushPay.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvPushPay
     * @function getTypeUrl
     * @memberof DeskToGamSrvPushPay
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvPushPay.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvPushPay";
    };

    return DeskToGamSrvPushPay;
})();

export const DeskToGamSrvReqSwithTable = $root.DeskToGamSrvReqSwithTable = (() => {

    /**
     * Properties of a DeskToGamSrvReqSwithTable.
     * @exports IDeskToGamSrvReqSwithTable
     * @interface IDeskToGamSrvReqSwithTable
     * @property {number|null} [UserID] DeskToGamSrvReqSwithTable UserID
     * @property {number|null} [DeskNo] DeskToGamSrvReqSwithTable DeskNo
     * @property {number|null} [GameID] DeskToGamSrvReqSwithTable GameID
     * @property {number|null} [ProductID] DeskToGamSrvReqSwithTable ProductID
     * @property {boolean|null} [FeelTable] DeskToGamSrvReqSwithTable FeelTable
     * @property {string|null} [ClientMark] DeskToGamSrvReqSwithTable ClientMark
     */

    /**
     * Constructs a new DeskToGamSrvReqSwithTable.
     * @exports DeskToGamSrvReqSwithTable
     * @classdesc Represents a DeskToGamSrvReqSwithTable.
     * @implements IDeskToGamSrvReqSwithTable
     * @constructor
     * @param {IDeskToGamSrvReqSwithTable=} [properties] Properties to set
     */
    function DeskToGamSrvReqSwithTable(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvReqSwithTable UserID.
     * @member {number} UserID
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.UserID = 0;

    /**
     * DeskToGamSrvReqSwithTable DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.DeskNo = 0;

    /**
     * DeskToGamSrvReqSwithTable GameID.
     * @member {number} GameID
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.GameID = 0;

    /**
     * DeskToGamSrvReqSwithTable ProductID.
     * @member {number} ProductID
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.ProductID = 0;

    /**
     * DeskToGamSrvReqSwithTable FeelTable.
     * @member {boolean} FeelTable
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.FeelTable = false;

    /**
     * DeskToGamSrvReqSwithTable ClientMark.
     * @member {string} ClientMark
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     */
    DeskToGamSrvReqSwithTable.prototype.ClientMark = "";

    /**
     * Creates a new DeskToGamSrvReqSwithTable instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {IDeskToGamSrvReqSwithTable=} [properties] Properties to set
     * @returns {DeskToGamSrvReqSwithTable} DeskToGamSrvReqSwithTable instance
     */
    DeskToGamSrvReqSwithTable.create = function create(properties) {
        return new DeskToGamSrvReqSwithTable(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvReqSwithTable message. Does not implicitly {@link DeskToGamSrvReqSwithTable.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {IDeskToGamSrvReqSwithTable} message DeskToGamSrvReqSwithTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvReqSwithTable.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.FeelTable != null && Object.hasOwnProperty.call(message, "FeelTable"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.FeelTable);
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ClientMark);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvReqSwithTable message, length delimited. Does not implicitly {@link DeskToGamSrvReqSwithTable.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {IDeskToGamSrvReqSwithTable} message DeskToGamSrvReqSwithTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvReqSwithTable.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvReqSwithTable message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvReqSwithTable} DeskToGamSrvReqSwithTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvReqSwithTable.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvReqSwithTable();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.FeelTable = reader.bool();
                    break;
                }
            case 6: {
                    message.ClientMark = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvReqSwithTable message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvReqSwithTable} DeskToGamSrvReqSwithTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvReqSwithTable.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvReqSwithTable message.
     * @function verify
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvReqSwithTable.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            if (typeof message.FeelTable !== "boolean")
                return "FeelTable: boolean expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvReqSwithTable message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvReqSwithTable} DeskToGamSrvReqSwithTable
     */
    DeskToGamSrvReqSwithTable.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvReqSwithTable)
            return object;
        let message = new $root.DeskToGamSrvReqSwithTable();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.FeelTable != null)
            message.FeelTable = Boolean(object.FeelTable);
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvReqSwithTable message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {DeskToGamSrvReqSwithTable} message DeskToGamSrvReqSwithTable
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvReqSwithTable.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.DeskNo = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.FeelTable = false;
            object.ClientMark = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            object.FeelTable = message.FeelTable;
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        return object;
    };

    /**
     * Converts this DeskToGamSrvReqSwithTable to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvReqSwithTable
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvReqSwithTable.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvReqSwithTable
     * @function getTypeUrl
     * @memberof DeskToGamSrvReqSwithTable
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvReqSwithTable.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvReqSwithTable";
    };

    return DeskToGamSrvReqSwithTable;
})();

export const DeskToGamSrvAckSwithTable = $root.DeskToGamSrvAckSwithTable = (() => {

    /**
     * Properties of a DeskToGamSrvAckSwithTable.
     * @exports IDeskToGamSrvAckSwithTable
     * @interface IDeskToGamSrvAckSwithTable
     * @property {number|null} [Res] DeskToGamSrvAckSwithTable Res
     * @property {number|null} [UserID] DeskToGamSrvAckSwithTable UserID
     * @property {number|null} [DeskNo] DeskToGamSrvAckSwithTable DeskNo
     * @property {number|null} [GameID] DeskToGamSrvAckSwithTable GameID
     * @property {number|null} [ProductID] DeskToGamSrvAckSwithTable ProductID
     * @property {string|null} [Gold] DeskToGamSrvAckSwithTable Gold
     * @property {string|null} [Deposit] DeskToGamSrvAckSwithTable Deposit
     * @property {string|null} [Withdraw] DeskToGamSrvAckSwithTable Withdraw
     * @property {string|null} [Bonus] DeskToGamSrvAckSwithTable Bonus
     * @property {boolean|null} [FeelTable] DeskToGamSrvAckSwithTable FeelTable
     * @property {string|null} [ClientMark] DeskToGamSrvAckSwithTable ClientMark
     */

    /**
     * Constructs a new DeskToGamSrvAckSwithTable.
     * @exports DeskToGamSrvAckSwithTable
     * @classdesc Represents a DeskToGamSrvAckSwithTable.
     * @implements IDeskToGamSrvAckSwithTable
     * @constructor
     * @param {IDeskToGamSrvAckSwithTable=} [properties] Properties to set
     */
    function DeskToGamSrvAckSwithTable(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvAckSwithTable Res.
     * @member {number} Res
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.Res = 0;

    /**
     * DeskToGamSrvAckSwithTable UserID.
     * @member {number} UserID
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.UserID = 0;

    /**
     * DeskToGamSrvAckSwithTable DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.DeskNo = 0;

    /**
     * DeskToGamSrvAckSwithTable GameID.
     * @member {number} GameID
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.GameID = 0;

    /**
     * DeskToGamSrvAckSwithTable ProductID.
     * @member {number} ProductID
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.ProductID = 0;

    /**
     * DeskToGamSrvAckSwithTable Gold.
     * @member {string} Gold
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.Gold = "";

    /**
     * DeskToGamSrvAckSwithTable Deposit.
     * @member {string} Deposit
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.Deposit = "";

    /**
     * DeskToGamSrvAckSwithTable Withdraw.
     * @member {string} Withdraw
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.Withdraw = "";

    /**
     * DeskToGamSrvAckSwithTable Bonus.
     * @member {string} Bonus
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.Bonus = "";

    /**
     * DeskToGamSrvAckSwithTable FeelTable.
     * @member {boolean} FeelTable
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.FeelTable = false;

    /**
     * DeskToGamSrvAckSwithTable ClientMark.
     * @member {string} ClientMark
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     */
    DeskToGamSrvAckSwithTable.prototype.ClientMark = "";

    /**
     * Creates a new DeskToGamSrvAckSwithTable instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {IDeskToGamSrvAckSwithTable=} [properties] Properties to set
     * @returns {DeskToGamSrvAckSwithTable} DeskToGamSrvAckSwithTable instance
     */
    DeskToGamSrvAckSwithTable.create = function create(properties) {
        return new DeskToGamSrvAckSwithTable(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvAckSwithTable message. Does not implicitly {@link DeskToGamSrvAckSwithTable.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {IDeskToGamSrvAckSwithTable} message DeskToGamSrvAckSwithTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvAckSwithTable.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.ProductID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Gold);
        if (message.Deposit != null && Object.hasOwnProperty.call(message, "Deposit"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Deposit);
        if (message.Withdraw != null && Object.hasOwnProperty.call(message, "Withdraw"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.Withdraw);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Bonus);
        if (message.FeelTable != null && Object.hasOwnProperty.call(message, "FeelTable"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.FeelTable);
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.ClientMark);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvAckSwithTable message, length delimited. Does not implicitly {@link DeskToGamSrvAckSwithTable.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {IDeskToGamSrvAckSwithTable} message DeskToGamSrvAckSwithTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvAckSwithTable.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvAckSwithTable message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvAckSwithTable} DeskToGamSrvAckSwithTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvAckSwithTable.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvAckSwithTable();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 4: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 5: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 6: {
                    message.Gold = reader.string();
                    break;
                }
            case 7: {
                    message.Deposit = reader.string();
                    break;
                }
            case 8: {
                    message.Withdraw = reader.string();
                    break;
                }
            case 9: {
                    message.Bonus = reader.string();
                    break;
                }
            case 10: {
                    message.FeelTable = reader.bool();
                    break;
                }
            case 11: {
                    message.ClientMark = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvAckSwithTable message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvAckSwithTable} DeskToGamSrvAckSwithTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvAckSwithTable.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvAckSwithTable message.
     * @function verify
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvAckSwithTable.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isString(message.Gold))
                return "Gold: string expected";
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            if (!$util.isString(message.Deposit))
                return "Deposit: string expected";
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            if (!$util.isString(message.Withdraw))
                return "Withdraw: string expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            if (typeof message.FeelTable !== "boolean")
                return "FeelTable: boolean expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvAckSwithTable message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvAckSwithTable} DeskToGamSrvAckSwithTable
     */
    DeskToGamSrvAckSwithTable.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvAckSwithTable)
            return object;
        let message = new $root.DeskToGamSrvAckSwithTable();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.Gold != null)
            message.Gold = String(object.Gold);
        if (object.Deposit != null)
            message.Deposit = String(object.Deposit);
        if (object.Withdraw != null)
            message.Withdraw = String(object.Withdraw);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        if (object.FeelTable != null)
            message.FeelTable = Boolean(object.FeelTable);
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvAckSwithTable message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {DeskToGamSrvAckSwithTable} message DeskToGamSrvAckSwithTable
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvAckSwithTable.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.DeskNo = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.Gold = "";
            object.Deposit = "";
            object.Withdraw = "";
            object.Bonus = "";
            object.FeelTable = false;
            object.ClientMark = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            object.Deposit = message.Deposit;
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            object.Withdraw = message.Withdraw;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            object.FeelTable = message.FeelTable;
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        return object;
    };

    /**
     * Converts this DeskToGamSrvAckSwithTable to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvAckSwithTable
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvAckSwithTable.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvAckSwithTable
     * @function getTypeUrl
     * @memberof DeskToGamSrvAckSwithTable
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvAckSwithTable.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvAckSwithTable";
    };

    return DeskToGamSrvAckSwithTable;
})();

export const DeskToGamSrvReqEmoji = $root.DeskToGamSrvReqEmoji = (() => {

    /**
     * Properties of a DeskToGamSrvReqEmoji.
     * @exports IDeskToGamSrvReqEmoji
     * @interface IDeskToGamSrvReqEmoji
     * @property {number|null} [DeskNo] DeskToGamSrvReqEmoji DeskNo
     * @property {number|null} [UserID] DeskToGamSrvReqEmoji UserID
     * @property {number|null} [SeatNo] DeskToGamSrvReqEmoji SeatNo
     * @property {number|null} [Recevier] DeskToGamSrvReqEmoji Recevier
     * @property {string|null} [EmojiID] DeskToGamSrvReqEmoji EmojiID
     */

    /**
     * Constructs a new DeskToGamSrvReqEmoji.
     * @exports DeskToGamSrvReqEmoji
     * @classdesc Represents a DeskToGamSrvReqEmoji.
     * @implements IDeskToGamSrvReqEmoji
     * @constructor
     * @param {IDeskToGamSrvReqEmoji=} [properties] Properties to set
     */
    function DeskToGamSrvReqEmoji(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvReqEmoji DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     */
    DeskToGamSrvReqEmoji.prototype.DeskNo = 0;

    /**
     * DeskToGamSrvReqEmoji UserID.
     * @member {number} UserID
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     */
    DeskToGamSrvReqEmoji.prototype.UserID = 0;

    /**
     * DeskToGamSrvReqEmoji SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     */
    DeskToGamSrvReqEmoji.prototype.SeatNo = 0;

    /**
     * DeskToGamSrvReqEmoji Recevier.
     * @member {number} Recevier
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     */
    DeskToGamSrvReqEmoji.prototype.Recevier = 0;

    /**
     * DeskToGamSrvReqEmoji EmojiID.
     * @member {string} EmojiID
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     */
    DeskToGamSrvReqEmoji.prototype.EmojiID = "";

    /**
     * Creates a new DeskToGamSrvReqEmoji instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {IDeskToGamSrvReqEmoji=} [properties] Properties to set
     * @returns {DeskToGamSrvReqEmoji} DeskToGamSrvReqEmoji instance
     */
    DeskToGamSrvReqEmoji.create = function create(properties) {
        return new DeskToGamSrvReqEmoji(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvReqEmoji message. Does not implicitly {@link DeskToGamSrvReqEmoji.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {IDeskToGamSrvReqEmoji} message DeskToGamSrvReqEmoji message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvReqEmoji.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Recevier != null && Object.hasOwnProperty.call(message, "Recevier"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Recevier);
        if (message.EmojiID != null && Object.hasOwnProperty.call(message, "EmojiID"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.EmojiID);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvReqEmoji message, length delimited. Does not implicitly {@link DeskToGamSrvReqEmoji.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {IDeskToGamSrvReqEmoji} message DeskToGamSrvReqEmoji message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvReqEmoji.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvReqEmoji message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvReqEmoji} DeskToGamSrvReqEmoji
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvReqEmoji.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvReqEmoji();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Recevier = reader.uint32();
                    break;
                }
            case 5: {
                    message.EmojiID = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvReqEmoji message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvReqEmoji} DeskToGamSrvReqEmoji
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvReqEmoji.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvReqEmoji message.
     * @function verify
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvReqEmoji.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Recevier != null && message.hasOwnProperty("Recevier"))
            if (!$util.isInteger(message.Recevier))
                return "Recevier: integer expected";
        if (message.EmojiID != null && message.hasOwnProperty("EmojiID"))
            if (!$util.isString(message.EmojiID))
                return "EmojiID: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvReqEmoji message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvReqEmoji} DeskToGamSrvReqEmoji
     */
    DeskToGamSrvReqEmoji.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvReqEmoji)
            return object;
        let message = new $root.DeskToGamSrvReqEmoji();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Recevier != null)
            message.Recevier = object.Recevier >>> 0;
        if (object.EmojiID != null)
            message.EmojiID = String(object.EmojiID);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvReqEmoji message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {DeskToGamSrvReqEmoji} message DeskToGamSrvReqEmoji
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvReqEmoji.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Recevier = 0;
            object.EmojiID = "";
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Recevier != null && message.hasOwnProperty("Recevier"))
            object.Recevier = message.Recevier;
        if (message.EmojiID != null && message.hasOwnProperty("EmojiID"))
            object.EmojiID = message.EmojiID;
        return object;
    };

    /**
     * Converts this DeskToGamSrvReqEmoji to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvReqEmoji
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvReqEmoji.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvReqEmoji
     * @function getTypeUrl
     * @memberof DeskToGamSrvReqEmoji
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvReqEmoji.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvReqEmoji";
    };

    return DeskToGamSrvReqEmoji;
})();

export const DeskToGamSrvAckEmoji = $root.DeskToGamSrvAckEmoji = (() => {

    /**
     * Properties of a DeskToGamSrvAckEmoji.
     * @exports IDeskToGamSrvAckEmoji
     * @interface IDeskToGamSrvAckEmoji
     * @property {number|null} [Ret] DeskToGamSrvAckEmoji Ret
     * @property {number|null} [GameID] DeskToGamSrvAckEmoji GameID
     * @property {number|null} [PID] DeskToGamSrvAckEmoji PID
     * @property {number|null} [Sender] DeskToGamSrvAckEmoji Sender
     * @property {number|null} [Recevier] DeskToGamSrvAckEmoji Recevier
     * @property {string|null} [EmojiID] DeskToGamSrvAckEmoji EmojiID
     * @property {string|null} [Cost] DeskToGamSrvAckEmoji Cost
     */

    /**
     * Constructs a new DeskToGamSrvAckEmoji.
     * @exports DeskToGamSrvAckEmoji
     * @classdesc Represents a DeskToGamSrvAckEmoji.
     * @implements IDeskToGamSrvAckEmoji
     * @constructor
     * @param {IDeskToGamSrvAckEmoji=} [properties] Properties to set
     */
    function DeskToGamSrvAckEmoji(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvAckEmoji Ret.
     * @member {number} Ret
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.Ret = 0;

    /**
     * DeskToGamSrvAckEmoji GameID.
     * @member {number} GameID
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.GameID = 0;

    /**
     * DeskToGamSrvAckEmoji PID.
     * @member {number} PID
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.PID = 0;

    /**
     * DeskToGamSrvAckEmoji Sender.
     * @member {number} Sender
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.Sender = 0;

    /**
     * DeskToGamSrvAckEmoji Recevier.
     * @member {number} Recevier
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.Recevier = 0;

    /**
     * DeskToGamSrvAckEmoji EmojiID.
     * @member {string} EmojiID
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.EmojiID = "";

    /**
     * DeskToGamSrvAckEmoji Cost.
     * @member {string} Cost
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     */
    DeskToGamSrvAckEmoji.prototype.Cost = "";

    /**
     * Creates a new DeskToGamSrvAckEmoji instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {IDeskToGamSrvAckEmoji=} [properties] Properties to set
     * @returns {DeskToGamSrvAckEmoji} DeskToGamSrvAckEmoji instance
     */
    DeskToGamSrvAckEmoji.create = function create(properties) {
        return new DeskToGamSrvAckEmoji(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvAckEmoji message. Does not implicitly {@link DeskToGamSrvAckEmoji.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {IDeskToGamSrvAckEmoji} message DeskToGamSrvAckEmoji message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvAckEmoji.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.PID);
        if (message.Sender != null && Object.hasOwnProperty.call(message, "Sender"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Sender);
        if (message.Recevier != null && Object.hasOwnProperty.call(message, "Recevier"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Recevier);
        if (message.EmojiID != null && Object.hasOwnProperty.call(message, "EmojiID"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.EmojiID);
        if (message.Cost != null && Object.hasOwnProperty.call(message, "Cost"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Cost);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvAckEmoji message, length delimited. Does not implicitly {@link DeskToGamSrvAckEmoji.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {IDeskToGamSrvAckEmoji} message DeskToGamSrvAckEmoji message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvAckEmoji.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvAckEmoji message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvAckEmoji} DeskToGamSrvAckEmoji
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvAckEmoji.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvAckEmoji();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.PID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Sender = reader.uint32();
                    break;
                }
            case 5: {
                    message.Recevier = reader.uint32();
                    break;
                }
            case 6: {
                    message.EmojiID = reader.string();
                    break;
                }
            case 7: {
                    message.Cost = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvAckEmoji message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvAckEmoji} DeskToGamSrvAckEmoji
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvAckEmoji.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvAckEmoji message.
     * @function verify
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvAckEmoji.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Sender != null && message.hasOwnProperty("Sender"))
            if (!$util.isInteger(message.Sender))
                return "Sender: integer expected";
        if (message.Recevier != null && message.hasOwnProperty("Recevier"))
            if (!$util.isInteger(message.Recevier))
                return "Recevier: integer expected";
        if (message.EmojiID != null && message.hasOwnProperty("EmojiID"))
            if (!$util.isString(message.EmojiID))
                return "EmojiID: string expected";
        if (message.Cost != null && message.hasOwnProperty("Cost"))
            if (!$util.isString(message.Cost))
                return "Cost: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvAckEmoji message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvAckEmoji} DeskToGamSrvAckEmoji
     */
    DeskToGamSrvAckEmoji.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvAckEmoji)
            return object;
        let message = new $root.DeskToGamSrvAckEmoji();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Sender != null)
            message.Sender = object.Sender >>> 0;
        if (object.Recevier != null)
            message.Recevier = object.Recevier >>> 0;
        if (object.EmojiID != null)
            message.EmojiID = String(object.EmojiID);
        if (object.Cost != null)
            message.Cost = String(object.Cost);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvAckEmoji message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {DeskToGamSrvAckEmoji} message DeskToGamSrvAckEmoji
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvAckEmoji.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.GameID = 0;
            object.PID = 0;
            object.Sender = 0;
            object.Recevier = 0;
            object.EmojiID = "";
            object.Cost = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Sender != null && message.hasOwnProperty("Sender"))
            object.Sender = message.Sender;
        if (message.Recevier != null && message.hasOwnProperty("Recevier"))
            object.Recevier = message.Recevier;
        if (message.EmojiID != null && message.hasOwnProperty("EmojiID"))
            object.EmojiID = message.EmojiID;
        if (message.Cost != null && message.hasOwnProperty("Cost"))
            object.Cost = message.Cost;
        return object;
    };

    /**
     * Converts this DeskToGamSrvAckEmoji to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvAckEmoji
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvAckEmoji.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvAckEmoji
     * @function getTypeUrl
     * @memberof DeskToGamSrvAckEmoji
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvAckEmoji.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvAckEmoji";
    };

    return DeskToGamSrvAckEmoji;
})();

export const DeskToGamSrvPushSysMain = $root.DeskToGamSrvPushSysMain = (() => {

    /**
     * Properties of a DeskToGamSrvPushSysMain.
     * @exports IDeskToGamSrvPushSysMain
     * @interface IDeskToGamSrvPushSysMain
     * @property {number|null} [UserID] DeskToGamSrvPushSysMain UserID
     * @property {number|null} [GameID] DeskToGamSrvPushSysMain GameID
     * @property {string|null} [Msg] DeskToGamSrvPushSysMain Msg
     */

    /**
     * Constructs a new DeskToGamSrvPushSysMain.
     * @exports DeskToGamSrvPushSysMain
     * @classdesc Represents a DeskToGamSrvPushSysMain.
     * @implements IDeskToGamSrvPushSysMain
     * @constructor
     * @param {IDeskToGamSrvPushSysMain=} [properties] Properties to set
     */
    function DeskToGamSrvPushSysMain(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvPushSysMain UserID.
     * @member {number} UserID
     * @memberof DeskToGamSrvPushSysMain
     * @instance
     */
    DeskToGamSrvPushSysMain.prototype.UserID = 0;

    /**
     * DeskToGamSrvPushSysMain GameID.
     * @member {number} GameID
     * @memberof DeskToGamSrvPushSysMain
     * @instance
     */
    DeskToGamSrvPushSysMain.prototype.GameID = 0;

    /**
     * DeskToGamSrvPushSysMain Msg.
     * @member {string} Msg
     * @memberof DeskToGamSrvPushSysMain
     * @instance
     */
    DeskToGamSrvPushSysMain.prototype.Msg = "";

    /**
     * Creates a new DeskToGamSrvPushSysMain instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {IDeskToGamSrvPushSysMain=} [properties] Properties to set
     * @returns {DeskToGamSrvPushSysMain} DeskToGamSrvPushSysMain instance
     */
    DeskToGamSrvPushSysMain.create = function create(properties) {
        return new DeskToGamSrvPushSysMain(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvPushSysMain message. Does not implicitly {@link DeskToGamSrvPushSysMain.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {IDeskToGamSrvPushSysMain} message DeskToGamSrvPushSysMain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvPushSysMain.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.Msg != null && Object.hasOwnProperty.call(message, "Msg"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Msg);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvPushSysMain message, length delimited. Does not implicitly {@link DeskToGamSrvPushSysMain.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {IDeskToGamSrvPushSysMain} message DeskToGamSrvPushSysMain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvPushSysMain.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvPushSysMain message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvPushSysMain} DeskToGamSrvPushSysMain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvPushSysMain.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvPushSysMain();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Msg = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvPushSysMain message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvPushSysMain} DeskToGamSrvPushSysMain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvPushSysMain.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvPushSysMain message.
     * @function verify
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvPushSysMain.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.Msg != null && message.hasOwnProperty("Msg"))
            if (!$util.isString(message.Msg))
                return "Msg: string expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvPushSysMain message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvPushSysMain} DeskToGamSrvPushSysMain
     */
    DeskToGamSrvPushSysMain.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvPushSysMain)
            return object;
        let message = new $root.DeskToGamSrvPushSysMain();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.Msg != null)
            message.Msg = String(object.Msg);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvPushSysMain message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {DeskToGamSrvPushSysMain} message DeskToGamSrvPushSysMain
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvPushSysMain.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.Msg = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.Msg != null && message.hasOwnProperty("Msg"))
            object.Msg = message.Msg;
        return object;
    };

    /**
     * Converts this DeskToGamSrvPushSysMain to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvPushSysMain
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvPushSysMain.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvPushSysMain
     * @function getTypeUrl
     * @memberof DeskToGamSrvPushSysMain
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvPushSysMain.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvPushSysMain";
    };

    return DeskToGamSrvPushSysMain;
})();

export const DeskToGamSrvRecycleDesk = $root.DeskToGamSrvRecycleDesk = (() => {

    /**
     * Properties of a DeskToGamSrvRecycleDesk.
     * @exports IDeskToGamSrvRecycleDesk
     * @interface IDeskToGamSrvRecycleDesk
     * @property {number|null} [DeskNo] DeskToGamSrvRecycleDesk DeskNo
     * @property {number|null} [GameID] DeskToGamSrvRecycleDesk GameID
     * @property {number|null} [ProductID] DeskToGamSrvRecycleDesk ProductID
     */

    /**
     * Constructs a new DeskToGamSrvRecycleDesk.
     * @exports DeskToGamSrvRecycleDesk
     * @classdesc Represents a DeskToGamSrvRecycleDesk.
     * @implements IDeskToGamSrvRecycleDesk
     * @constructor
     * @param {IDeskToGamSrvRecycleDesk=} [properties] Properties to set
     */
    function DeskToGamSrvRecycleDesk(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGamSrvRecycleDesk DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGamSrvRecycleDesk
     * @instance
     */
    DeskToGamSrvRecycleDesk.prototype.DeskNo = 0;

    /**
     * DeskToGamSrvRecycleDesk GameID.
     * @member {number} GameID
     * @memberof DeskToGamSrvRecycleDesk
     * @instance
     */
    DeskToGamSrvRecycleDesk.prototype.GameID = 0;

    /**
     * DeskToGamSrvRecycleDesk ProductID.
     * @member {number} ProductID
     * @memberof DeskToGamSrvRecycleDesk
     * @instance
     */
    DeskToGamSrvRecycleDesk.prototype.ProductID = 0;

    /**
     * Creates a new DeskToGamSrvRecycleDesk instance using the specified properties.
     * @function create
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {IDeskToGamSrvRecycleDesk=} [properties] Properties to set
     * @returns {DeskToGamSrvRecycleDesk} DeskToGamSrvRecycleDesk instance
     */
    DeskToGamSrvRecycleDesk.create = function create(properties) {
        return new DeskToGamSrvRecycleDesk(properties);
    };

    /**
     * Encodes the specified DeskToGamSrvRecycleDesk message. Does not implicitly {@link DeskToGamSrvRecycleDesk.verify|verify} messages.
     * @function encode
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {IDeskToGamSrvRecycleDesk} message DeskToGamSrvRecycleDesk message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvRecycleDesk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        return writer;
    };

    /**
     * Encodes the specified DeskToGamSrvRecycleDesk message, length delimited. Does not implicitly {@link DeskToGamSrvRecycleDesk.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {IDeskToGamSrvRecycleDesk} message DeskToGamSrvRecycleDesk message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGamSrvRecycleDesk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGamSrvRecycleDesk message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGamSrvRecycleDesk} DeskToGamSrvRecycleDesk
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvRecycleDesk.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGamSrvRecycleDesk();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGamSrvRecycleDesk message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGamSrvRecycleDesk} DeskToGamSrvRecycleDesk
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGamSrvRecycleDesk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGamSrvRecycleDesk message.
     * @function verify
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGamSrvRecycleDesk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        return null;
    };

    /**
     * Creates a DeskToGamSrvRecycleDesk message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGamSrvRecycleDesk} DeskToGamSrvRecycleDesk
     */
    DeskToGamSrvRecycleDesk.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGamSrvRecycleDesk)
            return object;
        let message = new $root.DeskToGamSrvRecycleDesk();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToGamSrvRecycleDesk message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {DeskToGamSrvRecycleDesk} message DeskToGamSrvRecycleDesk
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGamSrvRecycleDesk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.GameID = 0;
            object.ProductID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        return object;
    };

    /**
     * Converts this DeskToGamSrvRecycleDesk to JSON.
     * @function toJSON
     * @memberof DeskToGamSrvRecycleDesk
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGamSrvRecycleDesk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGamSrvRecycleDesk
     * @function getTypeUrl
     * @memberof DeskToGamSrvRecycleDesk
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGamSrvRecycleDesk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGamSrvRecycleDesk";
    };

    return DeskToGamSrvRecycleDesk;
})();

export const GameToAccSrvReqGoldChangeEx = $root.GameToAccSrvReqGoldChangeEx = (() => {

    /**
     * Properties of a GameToAccSrvReqGoldChangeEx.
     * @exports IGameToAccSrvReqGoldChangeEx
     * @interface IGameToAccSrvReqGoldChangeEx
     * @property {number|null} [UserID] GameToAccSrvReqGoldChangeEx UserID
     * @property {number|null} [GameID] GameToAccSrvReqGoldChangeEx GameID
     * @property {number|null} [ProductID] GameToAccSrvReqGoldChangeEx ProductID
     * @property {number|null} [TreasureID] GameToAccSrvReqGoldChangeEx TreasureID
     * @property {string|null} [GoldChange] GameToAccSrvReqGoldChangeEx GoldChange
     * @property {number|null} [changeType] GameToAccSrvReqGoldChangeEx changeType
     * @property {number|Long|null} [CreateTime] GameToAccSrvReqGoldChangeEx CreateTime
     * @property {number|Long|null} [EndTime] GameToAccSrvReqGoldChangeEx EndTime
     * @property {string|null} [Bonus] GameToAccSrvReqGoldChangeEx Bonus
     */

    /**
     * Constructs a new GameToAccSrvReqGoldChangeEx.
     * @exports GameToAccSrvReqGoldChangeEx
     * @classdesc Represents a GameToAccSrvReqGoldChangeEx.
     * @implements IGameToAccSrvReqGoldChangeEx
     * @constructor
     * @param {IGameToAccSrvReqGoldChangeEx=} [properties] Properties to set
     */
    function GameToAccSrvReqGoldChangeEx(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqGoldChangeEx UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.UserID = 0;

    /**
     * GameToAccSrvReqGoldChangeEx GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.GameID = 0;

    /**
     * GameToAccSrvReqGoldChangeEx ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqGoldChangeEx TreasureID.
     * @member {number} TreasureID
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.TreasureID = 0;

    /**
     * GameToAccSrvReqGoldChangeEx GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.GoldChange = "";

    /**
     * GameToAccSrvReqGoldChangeEx changeType.
     * @member {number} changeType
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.changeType = 0;

    /**
     * GameToAccSrvReqGoldChangeEx CreateTime.
     * @member {number|Long} CreateTime
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldChangeEx EndTime.
     * @member {number|Long} EndTime
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameToAccSrvReqGoldChangeEx Bonus.
     * @member {string} Bonus
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     */
    GameToAccSrvReqGoldChangeEx.prototype.Bonus = "";

    /**
     * Creates a new GameToAccSrvReqGoldChangeEx instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {IGameToAccSrvReqGoldChangeEx=} [properties] Properties to set
     * @returns {GameToAccSrvReqGoldChangeEx} GameToAccSrvReqGoldChangeEx instance
     */
    GameToAccSrvReqGoldChangeEx.create = function create(properties) {
        return new GameToAccSrvReqGoldChangeEx(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldChangeEx message. Does not implicitly {@link GameToAccSrvReqGoldChangeEx.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {IGameToAccSrvReqGoldChangeEx} message GameToAccSrvReqGoldChangeEx message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldChangeEx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.TreasureID != null && Object.hasOwnProperty.call(message, "TreasureID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.TreasureID);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GoldChange);
        if (message.changeType != null && Object.hasOwnProperty.call(message, "changeType"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.changeType);
        if (message.CreateTime != null && Object.hasOwnProperty.call(message, "CreateTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.CreateTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.EndTime);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Bonus);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqGoldChangeEx message, length delimited. Does not implicitly {@link GameToAccSrvReqGoldChangeEx.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {IGameToAccSrvReqGoldChangeEx} message GameToAccSrvReqGoldChangeEx message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqGoldChangeEx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqGoldChangeEx message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqGoldChangeEx} GameToAccSrvReqGoldChangeEx
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldChangeEx.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqGoldChangeEx();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.TreasureID = reader.uint32();
                    break;
                }
            case 5: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 6: {
                    message.changeType = reader.uint32();
                    break;
                }
            case 7: {
                    message.CreateTime = reader.uint64();
                    break;
                }
            case 8: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 9: {
                    message.Bonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqGoldChangeEx message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqGoldChangeEx} GameToAccSrvReqGoldChangeEx
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqGoldChangeEx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqGoldChangeEx message.
     * @function verify
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqGoldChangeEx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.TreasureID != null && message.hasOwnProperty("TreasureID"))
            if (!$util.isInteger(message.TreasureID))
                return "TreasureID: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.changeType != null && message.hasOwnProperty("changeType"))
            if (!$util.isInteger(message.changeType))
                return "changeType: integer expected";
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (!$util.isInteger(message.CreateTime) && !(message.CreateTime && $util.isInteger(message.CreateTime.low) && $util.isInteger(message.CreateTime.high)))
                return "CreateTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqGoldChangeEx message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqGoldChangeEx} GameToAccSrvReqGoldChangeEx
     */
    GameToAccSrvReqGoldChangeEx.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqGoldChangeEx)
            return object;
        let message = new $root.GameToAccSrvReqGoldChangeEx();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.TreasureID != null)
            message.TreasureID = object.TreasureID >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.changeType != null)
            message.changeType = object.changeType >>> 0;
        if (object.CreateTime != null)
            if ($util.Long)
                (message.CreateTime = $util.Long.fromValue(object.CreateTime)).unsigned = true;
            else if (typeof object.CreateTime === "string")
                message.CreateTime = parseInt(object.CreateTime, 10);
            else if (typeof object.CreateTime === "number")
                message.CreateTime = object.CreateTime;
            else if (typeof object.CreateTime === "object")
                message.CreateTime = new $util.LongBits(object.CreateTime.low >>> 0, object.CreateTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqGoldChangeEx message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {GameToAccSrvReqGoldChangeEx} message GameToAccSrvReqGoldChangeEx
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqGoldChangeEx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.TreasureID = 0;
            object.GoldChange = "";
            object.changeType = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.CreateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.CreateTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            object.Bonus = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.TreasureID != null && message.hasOwnProperty("TreasureID"))
            object.TreasureID = message.TreasureID;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.changeType != null && message.hasOwnProperty("changeType"))
            object.changeType = message.changeType;
        if (message.CreateTime != null && message.hasOwnProperty("CreateTime"))
            if (typeof message.CreateTime === "number")
                object.CreateTime = options.longs === String ? String(message.CreateTime) : message.CreateTime;
            else
                object.CreateTime = options.longs === String ? $util.Long.prototype.toString.call(message.CreateTime) : options.longs === Number ? new $util.LongBits(message.CreateTime.low >>> 0, message.CreateTime.high >>> 0).toNumber(true) : message.CreateTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqGoldChangeEx to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqGoldChangeEx
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqGoldChangeEx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqGoldChangeEx
     * @function getTypeUrl
     * @memberof GameToAccSrvReqGoldChangeEx
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqGoldChangeEx.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqGoldChangeEx";
    };

    return GameToAccSrvReqGoldChangeEx;
})();

export const GameToAccSrvAckGoldChangeEx = $root.GameToAccSrvAckGoldChangeEx = (() => {

    /**
     * Properties of a GameToAccSrvAckGoldChangeEx.
     * @exports IGameToAccSrvAckGoldChangeEx
     * @interface IGameToAccSrvAckGoldChangeEx
     * @property {number|null} [Res] GameToAccSrvAckGoldChangeEx Res
     * @property {number|null} [UserID] GameToAccSrvAckGoldChangeEx UserID
     * @property {number|null} [GameID] GameToAccSrvAckGoldChangeEx GameID
     * @property {number|null} [ProductID] GameToAccSrvAckGoldChangeEx ProductID
     * @property {number|null} [TreasureID] GameToAccSrvAckGoldChangeEx TreasureID
     * @property {string|null} [GoldChange] GameToAccSrvAckGoldChangeEx GoldChange
     */

    /**
     * Constructs a new GameToAccSrvAckGoldChangeEx.
     * @exports GameToAccSrvAckGoldChangeEx
     * @classdesc Represents a GameToAccSrvAckGoldChangeEx.
     * @implements IGameToAccSrvAckGoldChangeEx
     * @constructor
     * @param {IGameToAccSrvAckGoldChangeEx=} [properties] Properties to set
     */
    function GameToAccSrvAckGoldChangeEx(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvAckGoldChangeEx Res.
     * @member {number} Res
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.Res = 0;

    /**
     * GameToAccSrvAckGoldChangeEx UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.UserID = 0;

    /**
     * GameToAccSrvAckGoldChangeEx GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.GameID = 0;

    /**
     * GameToAccSrvAckGoldChangeEx ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.ProductID = 0;

    /**
     * GameToAccSrvAckGoldChangeEx TreasureID.
     * @member {number} TreasureID
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.TreasureID = 0;

    /**
     * GameToAccSrvAckGoldChangeEx GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     */
    GameToAccSrvAckGoldChangeEx.prototype.GoldChange = "";

    /**
     * Creates a new GameToAccSrvAckGoldChangeEx instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {IGameToAccSrvAckGoldChangeEx=} [properties] Properties to set
     * @returns {GameToAccSrvAckGoldChangeEx} GameToAccSrvAckGoldChangeEx instance
     */
    GameToAccSrvAckGoldChangeEx.create = function create(properties) {
        return new GameToAccSrvAckGoldChangeEx(properties);
    };

    /**
     * Encodes the specified GameToAccSrvAckGoldChangeEx message. Does not implicitly {@link GameToAccSrvAckGoldChangeEx.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {IGameToAccSrvAckGoldChangeEx} message GameToAccSrvAckGoldChangeEx message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckGoldChangeEx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.TreasureID != null && Object.hasOwnProperty.call(message, "TreasureID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.TreasureID);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.GoldChange);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvAckGoldChangeEx message, length delimited. Does not implicitly {@link GameToAccSrvAckGoldChangeEx.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {IGameToAccSrvAckGoldChangeEx} message GameToAccSrvAckGoldChangeEx message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckGoldChangeEx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvAckGoldChangeEx message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvAckGoldChangeEx} GameToAccSrvAckGoldChangeEx
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckGoldChangeEx.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvAckGoldChangeEx();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.TreasureID = reader.uint32();
                    break;
                }
            case 6: {
                    message.GoldChange = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvAckGoldChangeEx message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvAckGoldChangeEx} GameToAccSrvAckGoldChangeEx
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckGoldChangeEx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvAckGoldChangeEx message.
     * @function verify
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvAckGoldChangeEx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.TreasureID != null && message.hasOwnProperty("TreasureID"))
            if (!$util.isInteger(message.TreasureID))
                return "TreasureID: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvAckGoldChangeEx message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvAckGoldChangeEx} GameToAccSrvAckGoldChangeEx
     */
    GameToAccSrvAckGoldChangeEx.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvAckGoldChangeEx)
            return object;
        let message = new $root.GameToAccSrvAckGoldChangeEx();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.TreasureID != null)
            message.TreasureID = object.TreasureID >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvAckGoldChangeEx message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {GameToAccSrvAckGoldChangeEx} message GameToAccSrvAckGoldChangeEx
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvAckGoldChangeEx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.TreasureID = 0;
            object.GoldChange = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.TreasureID != null && message.hasOwnProperty("TreasureID"))
            object.TreasureID = message.TreasureID;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        return object;
    };

    /**
     * Converts this GameToAccSrvAckGoldChangeEx to JSON.
     * @function toJSON
     * @memberof GameToAccSrvAckGoldChangeEx
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvAckGoldChangeEx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvAckGoldChangeEx
     * @function getTypeUrl
     * @memberof GameToAccSrvAckGoldChangeEx
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvAckGoldChangeEx.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvAckGoldChangeEx";
    };

    return GameToAccSrvAckGoldChangeEx;
})();

export const BigBattleToGameDataSrvReqStockChange = $root.BigBattleToGameDataSrvReqStockChange = (() => {

    /**
     * Properties of a BigBattleToGameDataSrvReqStockChange.
     * @exports IBigBattleToGameDataSrvReqStockChange
     * @interface IBigBattleToGameDataSrvReqStockChange
     * @property {number|null} [Pid] BigBattleToGameDataSrvReqStockChange Pid
     * @property {number|null} [Result] BigBattleToGameDataSrvReqStockChange Result
     * @property {number|Long|null} [SettleTime] BigBattleToGameDataSrvReqStockChange SettleTime
     * @property {string|null} [PlayerDragonBet] BigBattleToGameDataSrvReqStockChange PlayerDragonBet
     * @property {string|null} [PlayerTigerBet] BigBattleToGameDataSrvReqStockChange PlayerTigerBet
     * @property {string|null} [PlayerDrawBet] BigBattleToGameDataSrvReqStockChange PlayerDrawBet
     * @property {number|null} [PlayerDragonNumber] BigBattleToGameDataSrvReqStockChange PlayerDragonNumber
     * @property {number|null} [PlayerTigerNumber] BigBattleToGameDataSrvReqStockChange PlayerTigerNumber
     * @property {number|null} [PlayerDrawNumber] BigBattleToGameDataSrvReqStockChange PlayerDrawNumber
     * @property {string|null} [PlayerSettleGold] BigBattleToGameDataSrvReqStockChange PlayerSettleGold
     * @property {string|null} [PlayerTax] BigBattleToGameDataSrvReqStockChange PlayerTax
     * @property {string|null} [CurStock] BigBattleToGameDataSrvReqStockChange CurStock
     */

    /**
     * Constructs a new BigBattleToGameDataSrvReqStockChange.
     * @exports BigBattleToGameDataSrvReqStockChange
     * @classdesc Represents a BigBattleToGameDataSrvReqStockChange.
     * @implements IBigBattleToGameDataSrvReqStockChange
     * @constructor
     * @param {IBigBattleToGameDataSrvReqStockChange=} [properties] Properties to set
     */
    function BigBattleToGameDataSrvReqStockChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleToGameDataSrvReqStockChange Pid.
     * @member {number} Pid
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.Pid = 0;

    /**
     * BigBattleToGameDataSrvReqStockChange Result.
     * @member {number} Result
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.Result = 0;

    /**
     * BigBattleToGameDataSrvReqStockChange SettleTime.
     * @member {number|Long} SettleTime
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.SettleTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerDragonBet.
     * @member {string} PlayerDragonBet
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerDragonBet = "";

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerTigerBet.
     * @member {string} PlayerTigerBet
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerTigerBet = "";

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerDrawBet.
     * @member {string} PlayerDrawBet
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerDrawBet = "";

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerDragonNumber.
     * @member {number} PlayerDragonNumber
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerDragonNumber = 0;

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerTigerNumber.
     * @member {number} PlayerTigerNumber
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerTigerNumber = 0;

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerDrawNumber.
     * @member {number} PlayerDrawNumber
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerDrawNumber = 0;

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerSettleGold.
     * @member {string} PlayerSettleGold
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerSettleGold = "";

    /**
     * BigBattleToGameDataSrvReqStockChange PlayerTax.
     * @member {string} PlayerTax
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.PlayerTax = "";

    /**
     * BigBattleToGameDataSrvReqStockChange CurStock.
     * @member {string} CurStock
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     */
    BigBattleToGameDataSrvReqStockChange.prototype.CurStock = "";

    /**
     * Creates a new BigBattleToGameDataSrvReqStockChange instance using the specified properties.
     * @function create
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {IBigBattleToGameDataSrvReqStockChange=} [properties] Properties to set
     * @returns {BigBattleToGameDataSrvReqStockChange} BigBattleToGameDataSrvReqStockChange instance
     */
    BigBattleToGameDataSrvReqStockChange.create = function create(properties) {
        return new BigBattleToGameDataSrvReqStockChange(properties);
    };

    /**
     * Encodes the specified BigBattleToGameDataSrvReqStockChange message. Does not implicitly {@link BigBattleToGameDataSrvReqStockChange.verify|verify} messages.
     * @function encode
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {IBigBattleToGameDataSrvReqStockChange} message BigBattleToGameDataSrvReqStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleToGameDataSrvReqStockChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Pid != null && Object.hasOwnProperty.call(message, "Pid"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Pid);
        if (message.Result != null && Object.hasOwnProperty.call(message, "Result"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Result);
        if (message.SettleTime != null && Object.hasOwnProperty.call(message, "SettleTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.SettleTime);
        if (message.PlayerDragonBet != null && Object.hasOwnProperty.call(message, "PlayerDragonBet"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.PlayerDragonBet);
        if (message.PlayerTigerBet != null && Object.hasOwnProperty.call(message, "PlayerTigerBet"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.PlayerTigerBet);
        if (message.PlayerDrawBet != null && Object.hasOwnProperty.call(message, "PlayerDrawBet"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.PlayerDrawBet);
        if (message.PlayerDragonNumber != null && Object.hasOwnProperty.call(message, "PlayerDragonNumber"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PlayerDragonNumber);
        if (message.PlayerTigerNumber != null && Object.hasOwnProperty.call(message, "PlayerTigerNumber"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.PlayerTigerNumber);
        if (message.PlayerDrawNumber != null && Object.hasOwnProperty.call(message, "PlayerDrawNumber"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.PlayerDrawNumber);
        if (message.PlayerSettleGold != null && Object.hasOwnProperty.call(message, "PlayerSettleGold"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.PlayerSettleGold);
        if (message.PlayerTax != null && Object.hasOwnProperty.call(message, "PlayerTax"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.PlayerTax);
        if (message.CurStock != null && Object.hasOwnProperty.call(message, "CurStock"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.CurStock);
        return writer;
    };

    /**
     * Encodes the specified BigBattleToGameDataSrvReqStockChange message, length delimited. Does not implicitly {@link BigBattleToGameDataSrvReqStockChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {IBigBattleToGameDataSrvReqStockChange} message BigBattleToGameDataSrvReqStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleToGameDataSrvReqStockChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleToGameDataSrvReqStockChange message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleToGameDataSrvReqStockChange} BigBattleToGameDataSrvReqStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleToGameDataSrvReqStockChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleToGameDataSrvReqStockChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Pid = reader.uint32();
                    break;
                }
            case 2: {
                    message.Result = reader.uint32();
                    break;
                }
            case 3: {
                    message.SettleTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.PlayerDragonBet = reader.string();
                    break;
                }
            case 5: {
                    message.PlayerTigerBet = reader.string();
                    break;
                }
            case 6: {
                    message.PlayerDrawBet = reader.string();
                    break;
                }
            case 7: {
                    message.PlayerDragonNumber = reader.uint32();
                    break;
                }
            case 8: {
                    message.PlayerTigerNumber = reader.uint32();
                    break;
                }
            case 9: {
                    message.PlayerDrawNumber = reader.uint32();
                    break;
                }
            case 10: {
                    message.PlayerSettleGold = reader.string();
                    break;
                }
            case 11: {
                    message.PlayerTax = reader.string();
                    break;
                }
            case 12: {
                    message.CurStock = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleToGameDataSrvReqStockChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleToGameDataSrvReqStockChange} BigBattleToGameDataSrvReqStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleToGameDataSrvReqStockChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleToGameDataSrvReqStockChange message.
     * @function verify
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleToGameDataSrvReqStockChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            if (!$util.isInteger(message.Pid))
                return "Pid: integer expected";
        if (message.Result != null && message.hasOwnProperty("Result"))
            if (!$util.isInteger(message.Result))
                return "Result: integer expected";
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (!$util.isInteger(message.SettleTime) && !(message.SettleTime && $util.isInteger(message.SettleTime.low) && $util.isInteger(message.SettleTime.high)))
                return "SettleTime: integer|Long expected";
        if (message.PlayerDragonBet != null && message.hasOwnProperty("PlayerDragonBet"))
            if (!$util.isString(message.PlayerDragonBet))
                return "PlayerDragonBet: string expected";
        if (message.PlayerTigerBet != null && message.hasOwnProperty("PlayerTigerBet"))
            if (!$util.isString(message.PlayerTigerBet))
                return "PlayerTigerBet: string expected";
        if (message.PlayerDrawBet != null && message.hasOwnProperty("PlayerDrawBet"))
            if (!$util.isString(message.PlayerDrawBet))
                return "PlayerDrawBet: string expected";
        if (message.PlayerDragonNumber != null && message.hasOwnProperty("PlayerDragonNumber"))
            if (!$util.isInteger(message.PlayerDragonNumber))
                return "PlayerDragonNumber: integer expected";
        if (message.PlayerTigerNumber != null && message.hasOwnProperty("PlayerTigerNumber"))
            if (!$util.isInteger(message.PlayerTigerNumber))
                return "PlayerTigerNumber: integer expected";
        if (message.PlayerDrawNumber != null && message.hasOwnProperty("PlayerDrawNumber"))
            if (!$util.isInteger(message.PlayerDrawNumber))
                return "PlayerDrawNumber: integer expected";
        if (message.PlayerSettleGold != null && message.hasOwnProperty("PlayerSettleGold"))
            if (!$util.isString(message.PlayerSettleGold))
                return "PlayerSettleGold: string expected";
        if (message.PlayerTax != null && message.hasOwnProperty("PlayerTax"))
            if (!$util.isString(message.PlayerTax))
                return "PlayerTax: string expected";
        if (message.CurStock != null && message.hasOwnProperty("CurStock"))
            if (!$util.isString(message.CurStock))
                return "CurStock: string expected";
        return null;
    };

    /**
     * Creates a BigBattleToGameDataSrvReqStockChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleToGameDataSrvReqStockChange} BigBattleToGameDataSrvReqStockChange
     */
    BigBattleToGameDataSrvReqStockChange.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleToGameDataSrvReqStockChange)
            return object;
        let message = new $root.BigBattleToGameDataSrvReqStockChange();
        if (object.Pid != null)
            message.Pid = object.Pid >>> 0;
        if (object.Result != null)
            message.Result = object.Result >>> 0;
        if (object.SettleTime != null)
            if ($util.Long)
                (message.SettleTime = $util.Long.fromValue(object.SettleTime)).unsigned = true;
            else if (typeof object.SettleTime === "string")
                message.SettleTime = parseInt(object.SettleTime, 10);
            else if (typeof object.SettleTime === "number")
                message.SettleTime = object.SettleTime;
            else if (typeof object.SettleTime === "object")
                message.SettleTime = new $util.LongBits(object.SettleTime.low >>> 0, object.SettleTime.high >>> 0).toNumber(true);
        if (object.PlayerDragonBet != null)
            message.PlayerDragonBet = String(object.PlayerDragonBet);
        if (object.PlayerTigerBet != null)
            message.PlayerTigerBet = String(object.PlayerTigerBet);
        if (object.PlayerDrawBet != null)
            message.PlayerDrawBet = String(object.PlayerDrawBet);
        if (object.PlayerDragonNumber != null)
            message.PlayerDragonNumber = object.PlayerDragonNumber >>> 0;
        if (object.PlayerTigerNumber != null)
            message.PlayerTigerNumber = object.PlayerTigerNumber >>> 0;
        if (object.PlayerDrawNumber != null)
            message.PlayerDrawNumber = object.PlayerDrawNumber >>> 0;
        if (object.PlayerSettleGold != null)
            message.PlayerSettleGold = String(object.PlayerSettleGold);
        if (object.PlayerTax != null)
            message.PlayerTax = String(object.PlayerTax);
        if (object.CurStock != null)
            message.CurStock = String(object.CurStock);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleToGameDataSrvReqStockChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {BigBattleToGameDataSrvReqStockChange} message BigBattleToGameDataSrvReqStockChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleToGameDataSrvReqStockChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Pid = 0;
            object.Result = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.SettleTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SettleTime = options.longs === String ? "0" : 0;
            object.PlayerDragonBet = "";
            object.PlayerTigerBet = "";
            object.PlayerDrawBet = "";
            object.PlayerDragonNumber = 0;
            object.PlayerTigerNumber = 0;
            object.PlayerDrawNumber = 0;
            object.PlayerSettleGold = "";
            object.PlayerTax = "";
            object.CurStock = "";
        }
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            object.Pid = message.Pid;
        if (message.Result != null && message.hasOwnProperty("Result"))
            object.Result = message.Result;
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (typeof message.SettleTime === "number")
                object.SettleTime = options.longs === String ? String(message.SettleTime) : message.SettleTime;
            else
                object.SettleTime = options.longs === String ? $util.Long.prototype.toString.call(message.SettleTime) : options.longs === Number ? new $util.LongBits(message.SettleTime.low >>> 0, message.SettleTime.high >>> 0).toNumber(true) : message.SettleTime;
        if (message.PlayerDragonBet != null && message.hasOwnProperty("PlayerDragonBet"))
            object.PlayerDragonBet = message.PlayerDragonBet;
        if (message.PlayerTigerBet != null && message.hasOwnProperty("PlayerTigerBet"))
            object.PlayerTigerBet = message.PlayerTigerBet;
        if (message.PlayerDrawBet != null && message.hasOwnProperty("PlayerDrawBet"))
            object.PlayerDrawBet = message.PlayerDrawBet;
        if (message.PlayerDragonNumber != null && message.hasOwnProperty("PlayerDragonNumber"))
            object.PlayerDragonNumber = message.PlayerDragonNumber;
        if (message.PlayerTigerNumber != null && message.hasOwnProperty("PlayerTigerNumber"))
            object.PlayerTigerNumber = message.PlayerTigerNumber;
        if (message.PlayerDrawNumber != null && message.hasOwnProperty("PlayerDrawNumber"))
            object.PlayerDrawNumber = message.PlayerDrawNumber;
        if (message.PlayerSettleGold != null && message.hasOwnProperty("PlayerSettleGold"))
            object.PlayerSettleGold = message.PlayerSettleGold;
        if (message.PlayerTax != null && message.hasOwnProperty("PlayerTax"))
            object.PlayerTax = message.PlayerTax;
        if (message.CurStock != null && message.hasOwnProperty("CurStock"))
            object.CurStock = message.CurStock;
        return object;
    };

    /**
     * Converts this BigBattleToGameDataSrvReqStockChange to JSON.
     * @function toJSON
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleToGameDataSrvReqStockChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleToGameDataSrvReqStockChange
     * @function getTypeUrl
     * @memberof BigBattleToGameDataSrvReqStockChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleToGameDataSrvReqStockChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleToGameDataSrvReqStockChange";
    };

    return BigBattleToGameDataSrvReqStockChange;
})();

export const BigBattleToGameDataSrvAckStockChange = $root.BigBattleToGameDataSrvAckStockChange = (() => {

    /**
     * Properties of a BigBattleToGameDataSrvAckStockChange.
     * @exports IBigBattleToGameDataSrvAckStockChange
     * @interface IBigBattleToGameDataSrvAckStockChange
     * @property {number|null} [Ret] BigBattleToGameDataSrvAckStockChange Ret
     * @property {IBigBattleToGameDataSrvReqStockChange|null} [StockChangeMsg] BigBattleToGameDataSrvAckStockChange StockChangeMsg
     */

    /**
     * Constructs a new BigBattleToGameDataSrvAckStockChange.
     * @exports BigBattleToGameDataSrvAckStockChange
     * @classdesc Represents a BigBattleToGameDataSrvAckStockChange.
     * @implements IBigBattleToGameDataSrvAckStockChange
     * @constructor
     * @param {IBigBattleToGameDataSrvAckStockChange=} [properties] Properties to set
     */
    function BigBattleToGameDataSrvAckStockChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleToGameDataSrvAckStockChange Ret.
     * @member {number} Ret
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @instance
     */
    BigBattleToGameDataSrvAckStockChange.prototype.Ret = 0;

    /**
     * BigBattleToGameDataSrvAckStockChange StockChangeMsg.
     * @member {IBigBattleToGameDataSrvReqStockChange|null|undefined} StockChangeMsg
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @instance
     */
    BigBattleToGameDataSrvAckStockChange.prototype.StockChangeMsg = null;

    /**
     * Creates a new BigBattleToGameDataSrvAckStockChange instance using the specified properties.
     * @function create
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {IBigBattleToGameDataSrvAckStockChange=} [properties] Properties to set
     * @returns {BigBattleToGameDataSrvAckStockChange} BigBattleToGameDataSrvAckStockChange instance
     */
    BigBattleToGameDataSrvAckStockChange.create = function create(properties) {
        return new BigBattleToGameDataSrvAckStockChange(properties);
    };

    /**
     * Encodes the specified BigBattleToGameDataSrvAckStockChange message. Does not implicitly {@link BigBattleToGameDataSrvAckStockChange.verify|verify} messages.
     * @function encode
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {IBigBattleToGameDataSrvAckStockChange} message BigBattleToGameDataSrvAckStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleToGameDataSrvAckStockChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.StockChangeMsg != null && Object.hasOwnProperty.call(message, "StockChangeMsg"))
            $root.BigBattleToGameDataSrvReqStockChange.encode(message.StockChangeMsg, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BigBattleToGameDataSrvAckStockChange message, length delimited. Does not implicitly {@link BigBattleToGameDataSrvAckStockChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {IBigBattleToGameDataSrvAckStockChange} message BigBattleToGameDataSrvAckStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleToGameDataSrvAckStockChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleToGameDataSrvAckStockChange message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleToGameDataSrvAckStockChange} BigBattleToGameDataSrvAckStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleToGameDataSrvAckStockChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleToGameDataSrvAckStockChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.StockChangeMsg = $root.BigBattleToGameDataSrvReqStockChange.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleToGameDataSrvAckStockChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleToGameDataSrvAckStockChange} BigBattleToGameDataSrvAckStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleToGameDataSrvAckStockChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleToGameDataSrvAckStockChange message.
     * @function verify
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleToGameDataSrvAckStockChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.StockChangeMsg != null && message.hasOwnProperty("StockChangeMsg")) {
            let error = $root.BigBattleToGameDataSrvReqStockChange.verify(message.StockChangeMsg);
            if (error)
                return "StockChangeMsg." + error;
        }
        return null;
    };

    /**
     * Creates a BigBattleToGameDataSrvAckStockChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleToGameDataSrvAckStockChange} BigBattleToGameDataSrvAckStockChange
     */
    BigBattleToGameDataSrvAckStockChange.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleToGameDataSrvAckStockChange)
            return object;
        let message = new $root.BigBattleToGameDataSrvAckStockChange();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.StockChangeMsg != null) {
            if (typeof object.StockChangeMsg !== "object")
                throw TypeError(".BigBattleToGameDataSrvAckStockChange.StockChangeMsg: object expected");
            message.StockChangeMsg = $root.BigBattleToGameDataSrvReqStockChange.fromObject(object.StockChangeMsg);
        }
        return message;
    };

    /**
     * Creates a plain object from a BigBattleToGameDataSrvAckStockChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {BigBattleToGameDataSrvAckStockChange} message BigBattleToGameDataSrvAckStockChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleToGameDataSrvAckStockChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.StockChangeMsg = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.StockChangeMsg != null && message.hasOwnProperty("StockChangeMsg"))
            object.StockChangeMsg = $root.BigBattleToGameDataSrvReqStockChange.toObject(message.StockChangeMsg, options);
        return object;
    };

    /**
     * Converts this BigBattleToGameDataSrvAckStockChange to JSON.
     * @function toJSON
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleToGameDataSrvAckStockChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleToGameDataSrvAckStockChange
     * @function getTypeUrl
     * @memberof BigBattleToGameDataSrvAckStockChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleToGameDataSrvAckStockChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleToGameDataSrvAckStockChange";
    };

    return BigBattleToGameDataSrvAckStockChange;
})();

export const PokerWarToGameDataSrvReqStockChange = $root.PokerWarToGameDataSrvReqStockChange = (() => {

    /**
     * Properties of a PokerWarToGameDataSrvReqStockChange.
     * @exports IPokerWarToGameDataSrvReqStockChange
     * @interface IPokerWarToGameDataSrvReqStockChange
     * @property {number|null} [Pid] PokerWarToGameDataSrvReqStockChange Pid
     * @property {number|null} [Result] PokerWarToGameDataSrvReqStockChange Result
     * @property {number|Long|null} [SettleTime] PokerWarToGameDataSrvReqStockChange SettleTime
     * @property {string|null} [PlayerRedBet] PokerWarToGameDataSrvReqStockChange PlayerRedBet
     * @property {string|null} [PlayerBlackBet] PokerWarToGameDataSrvReqStockChange PlayerBlackBet
     * @property {string|null} [PlayerLuckyBet] PokerWarToGameDataSrvReqStockChange PlayerLuckyBet
     * @property {number|null} [PlayerRedNumber] PokerWarToGameDataSrvReqStockChange PlayerRedNumber
     * @property {number|null} [PlayerBlackNumber] PokerWarToGameDataSrvReqStockChange PlayerBlackNumber
     * @property {number|null} [PlayerLuckyNumber] PokerWarToGameDataSrvReqStockChange PlayerLuckyNumber
     * @property {string|null} [PlayerSettleGold] PokerWarToGameDataSrvReqStockChange PlayerSettleGold
     * @property {string|null} [PlayerTax] PokerWarToGameDataSrvReqStockChange PlayerTax
     * @property {string|null} [CurStock] PokerWarToGameDataSrvReqStockChange CurStock
     * @property {number|null} [RedCardType] PokerWarToGameDataSrvReqStockChange RedCardType
     * @property {number|null} [BlackCardType] PokerWarToGameDataSrvReqStockChange BlackCardType
     */

    /**
     * Constructs a new PokerWarToGameDataSrvReqStockChange.
     * @exports PokerWarToGameDataSrvReqStockChange
     * @classdesc Represents a PokerWarToGameDataSrvReqStockChange.
     * @implements IPokerWarToGameDataSrvReqStockChange
     * @constructor
     * @param {IPokerWarToGameDataSrvReqStockChange=} [properties] Properties to set
     */
    function PokerWarToGameDataSrvReqStockChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarToGameDataSrvReqStockChange Pid.
     * @member {number} Pid
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.Pid = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange Result.
     * @member {number} Result
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.Result = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange SettleTime.
     * @member {number|Long} SettleTime
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.SettleTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerRedBet.
     * @member {string} PlayerRedBet
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerRedBet = "";

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerBlackBet.
     * @member {string} PlayerBlackBet
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerBlackBet = "";

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerLuckyBet.
     * @member {string} PlayerLuckyBet
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerLuckyBet = "";

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerRedNumber.
     * @member {number} PlayerRedNumber
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerRedNumber = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerBlackNumber.
     * @member {number} PlayerBlackNumber
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerBlackNumber = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerLuckyNumber.
     * @member {number} PlayerLuckyNumber
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerLuckyNumber = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerSettleGold.
     * @member {string} PlayerSettleGold
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerSettleGold = "";

    /**
     * PokerWarToGameDataSrvReqStockChange PlayerTax.
     * @member {string} PlayerTax
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.PlayerTax = "";

    /**
     * PokerWarToGameDataSrvReqStockChange CurStock.
     * @member {string} CurStock
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.CurStock = "";

    /**
     * PokerWarToGameDataSrvReqStockChange RedCardType.
     * @member {number} RedCardType
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.RedCardType = 0;

    /**
     * PokerWarToGameDataSrvReqStockChange BlackCardType.
     * @member {number} BlackCardType
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     */
    PokerWarToGameDataSrvReqStockChange.prototype.BlackCardType = 0;

    /**
     * Creates a new PokerWarToGameDataSrvReqStockChange instance using the specified properties.
     * @function create
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {IPokerWarToGameDataSrvReqStockChange=} [properties] Properties to set
     * @returns {PokerWarToGameDataSrvReqStockChange} PokerWarToGameDataSrvReqStockChange instance
     */
    PokerWarToGameDataSrvReqStockChange.create = function create(properties) {
        return new PokerWarToGameDataSrvReqStockChange(properties);
    };

    /**
     * Encodes the specified PokerWarToGameDataSrvReqStockChange message. Does not implicitly {@link PokerWarToGameDataSrvReqStockChange.verify|verify} messages.
     * @function encode
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {IPokerWarToGameDataSrvReqStockChange} message PokerWarToGameDataSrvReqStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarToGameDataSrvReqStockChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Pid != null && Object.hasOwnProperty.call(message, "Pid"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Pid);
        if (message.Result != null && Object.hasOwnProperty.call(message, "Result"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Result);
        if (message.SettleTime != null && Object.hasOwnProperty.call(message, "SettleTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.SettleTime);
        if (message.PlayerRedBet != null && Object.hasOwnProperty.call(message, "PlayerRedBet"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.PlayerRedBet);
        if (message.PlayerBlackBet != null && Object.hasOwnProperty.call(message, "PlayerBlackBet"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.PlayerBlackBet);
        if (message.PlayerLuckyBet != null && Object.hasOwnProperty.call(message, "PlayerLuckyBet"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.PlayerLuckyBet);
        if (message.PlayerRedNumber != null && Object.hasOwnProperty.call(message, "PlayerRedNumber"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PlayerRedNumber);
        if (message.PlayerBlackNumber != null && Object.hasOwnProperty.call(message, "PlayerBlackNumber"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.PlayerBlackNumber);
        if (message.PlayerLuckyNumber != null && Object.hasOwnProperty.call(message, "PlayerLuckyNumber"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.PlayerLuckyNumber);
        if (message.PlayerSettleGold != null && Object.hasOwnProperty.call(message, "PlayerSettleGold"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.PlayerSettleGold);
        if (message.PlayerTax != null && Object.hasOwnProperty.call(message, "PlayerTax"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.PlayerTax);
        if (message.CurStock != null && Object.hasOwnProperty.call(message, "CurStock"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.CurStock);
        if (message.RedCardType != null && Object.hasOwnProperty.call(message, "RedCardType"))
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.RedCardType);
        if (message.BlackCardType != null && Object.hasOwnProperty.call(message, "BlackCardType"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.BlackCardType);
        return writer;
    };

    /**
     * Encodes the specified PokerWarToGameDataSrvReqStockChange message, length delimited. Does not implicitly {@link PokerWarToGameDataSrvReqStockChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {IPokerWarToGameDataSrvReqStockChange} message PokerWarToGameDataSrvReqStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarToGameDataSrvReqStockChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarToGameDataSrvReqStockChange message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarToGameDataSrvReqStockChange} PokerWarToGameDataSrvReqStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarToGameDataSrvReqStockChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarToGameDataSrvReqStockChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Pid = reader.uint32();
                    break;
                }
            case 2: {
                    message.Result = reader.uint32();
                    break;
                }
            case 3: {
                    message.SettleTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.PlayerRedBet = reader.string();
                    break;
                }
            case 5: {
                    message.PlayerBlackBet = reader.string();
                    break;
                }
            case 6: {
                    message.PlayerLuckyBet = reader.string();
                    break;
                }
            case 7: {
                    message.PlayerRedNumber = reader.uint32();
                    break;
                }
            case 8: {
                    message.PlayerBlackNumber = reader.uint32();
                    break;
                }
            case 9: {
                    message.PlayerLuckyNumber = reader.uint32();
                    break;
                }
            case 10: {
                    message.PlayerSettleGold = reader.string();
                    break;
                }
            case 11: {
                    message.PlayerTax = reader.string();
                    break;
                }
            case 12: {
                    message.CurStock = reader.string();
                    break;
                }
            case 13: {
                    message.RedCardType = reader.int32();
                    break;
                }
            case 14: {
                    message.BlackCardType = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarToGameDataSrvReqStockChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarToGameDataSrvReqStockChange} PokerWarToGameDataSrvReqStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarToGameDataSrvReqStockChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarToGameDataSrvReqStockChange message.
     * @function verify
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarToGameDataSrvReqStockChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            if (!$util.isInteger(message.Pid))
                return "Pid: integer expected";
        if (message.Result != null && message.hasOwnProperty("Result"))
            if (!$util.isInteger(message.Result))
                return "Result: integer expected";
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (!$util.isInteger(message.SettleTime) && !(message.SettleTime && $util.isInteger(message.SettleTime.low) && $util.isInteger(message.SettleTime.high)))
                return "SettleTime: integer|Long expected";
        if (message.PlayerRedBet != null && message.hasOwnProperty("PlayerRedBet"))
            if (!$util.isString(message.PlayerRedBet))
                return "PlayerRedBet: string expected";
        if (message.PlayerBlackBet != null && message.hasOwnProperty("PlayerBlackBet"))
            if (!$util.isString(message.PlayerBlackBet))
                return "PlayerBlackBet: string expected";
        if (message.PlayerLuckyBet != null && message.hasOwnProperty("PlayerLuckyBet"))
            if (!$util.isString(message.PlayerLuckyBet))
                return "PlayerLuckyBet: string expected";
        if (message.PlayerRedNumber != null && message.hasOwnProperty("PlayerRedNumber"))
            if (!$util.isInteger(message.PlayerRedNumber))
                return "PlayerRedNumber: integer expected";
        if (message.PlayerBlackNumber != null && message.hasOwnProperty("PlayerBlackNumber"))
            if (!$util.isInteger(message.PlayerBlackNumber))
                return "PlayerBlackNumber: integer expected";
        if (message.PlayerLuckyNumber != null && message.hasOwnProperty("PlayerLuckyNumber"))
            if (!$util.isInteger(message.PlayerLuckyNumber))
                return "PlayerLuckyNumber: integer expected";
        if (message.PlayerSettleGold != null && message.hasOwnProperty("PlayerSettleGold"))
            if (!$util.isString(message.PlayerSettleGold))
                return "PlayerSettleGold: string expected";
        if (message.PlayerTax != null && message.hasOwnProperty("PlayerTax"))
            if (!$util.isString(message.PlayerTax))
                return "PlayerTax: string expected";
        if (message.CurStock != null && message.hasOwnProperty("CurStock"))
            if (!$util.isString(message.CurStock))
                return "CurStock: string expected";
        if (message.RedCardType != null && message.hasOwnProperty("RedCardType"))
            if (!$util.isInteger(message.RedCardType))
                return "RedCardType: integer expected";
        if (message.BlackCardType != null && message.hasOwnProperty("BlackCardType"))
            if (!$util.isInteger(message.BlackCardType))
                return "BlackCardType: integer expected";
        return null;
    };

    /**
     * Creates a PokerWarToGameDataSrvReqStockChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarToGameDataSrvReqStockChange} PokerWarToGameDataSrvReqStockChange
     */
    PokerWarToGameDataSrvReqStockChange.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarToGameDataSrvReqStockChange)
            return object;
        let message = new $root.PokerWarToGameDataSrvReqStockChange();
        if (object.Pid != null)
            message.Pid = object.Pid >>> 0;
        if (object.Result != null)
            message.Result = object.Result >>> 0;
        if (object.SettleTime != null)
            if ($util.Long)
                (message.SettleTime = $util.Long.fromValue(object.SettleTime)).unsigned = true;
            else if (typeof object.SettleTime === "string")
                message.SettleTime = parseInt(object.SettleTime, 10);
            else if (typeof object.SettleTime === "number")
                message.SettleTime = object.SettleTime;
            else if (typeof object.SettleTime === "object")
                message.SettleTime = new $util.LongBits(object.SettleTime.low >>> 0, object.SettleTime.high >>> 0).toNumber(true);
        if (object.PlayerRedBet != null)
            message.PlayerRedBet = String(object.PlayerRedBet);
        if (object.PlayerBlackBet != null)
            message.PlayerBlackBet = String(object.PlayerBlackBet);
        if (object.PlayerLuckyBet != null)
            message.PlayerLuckyBet = String(object.PlayerLuckyBet);
        if (object.PlayerRedNumber != null)
            message.PlayerRedNumber = object.PlayerRedNumber >>> 0;
        if (object.PlayerBlackNumber != null)
            message.PlayerBlackNumber = object.PlayerBlackNumber >>> 0;
        if (object.PlayerLuckyNumber != null)
            message.PlayerLuckyNumber = object.PlayerLuckyNumber >>> 0;
        if (object.PlayerSettleGold != null)
            message.PlayerSettleGold = String(object.PlayerSettleGold);
        if (object.PlayerTax != null)
            message.PlayerTax = String(object.PlayerTax);
        if (object.CurStock != null)
            message.CurStock = String(object.CurStock);
        if (object.RedCardType != null)
            message.RedCardType = object.RedCardType | 0;
        if (object.BlackCardType != null)
            message.BlackCardType = object.BlackCardType | 0;
        return message;
    };

    /**
     * Creates a plain object from a PokerWarToGameDataSrvReqStockChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {PokerWarToGameDataSrvReqStockChange} message PokerWarToGameDataSrvReqStockChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarToGameDataSrvReqStockChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Pid = 0;
            object.Result = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.SettleTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SettleTime = options.longs === String ? "0" : 0;
            object.PlayerRedBet = "";
            object.PlayerBlackBet = "";
            object.PlayerLuckyBet = "";
            object.PlayerRedNumber = 0;
            object.PlayerBlackNumber = 0;
            object.PlayerLuckyNumber = 0;
            object.PlayerSettleGold = "";
            object.PlayerTax = "";
            object.CurStock = "";
            object.RedCardType = 0;
            object.BlackCardType = 0;
        }
        if (message.Pid != null && message.hasOwnProperty("Pid"))
            object.Pid = message.Pid;
        if (message.Result != null && message.hasOwnProperty("Result"))
            object.Result = message.Result;
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (typeof message.SettleTime === "number")
                object.SettleTime = options.longs === String ? String(message.SettleTime) : message.SettleTime;
            else
                object.SettleTime = options.longs === String ? $util.Long.prototype.toString.call(message.SettleTime) : options.longs === Number ? new $util.LongBits(message.SettleTime.low >>> 0, message.SettleTime.high >>> 0).toNumber(true) : message.SettleTime;
        if (message.PlayerRedBet != null && message.hasOwnProperty("PlayerRedBet"))
            object.PlayerRedBet = message.PlayerRedBet;
        if (message.PlayerBlackBet != null && message.hasOwnProperty("PlayerBlackBet"))
            object.PlayerBlackBet = message.PlayerBlackBet;
        if (message.PlayerLuckyBet != null && message.hasOwnProperty("PlayerLuckyBet"))
            object.PlayerLuckyBet = message.PlayerLuckyBet;
        if (message.PlayerRedNumber != null && message.hasOwnProperty("PlayerRedNumber"))
            object.PlayerRedNumber = message.PlayerRedNumber;
        if (message.PlayerBlackNumber != null && message.hasOwnProperty("PlayerBlackNumber"))
            object.PlayerBlackNumber = message.PlayerBlackNumber;
        if (message.PlayerLuckyNumber != null && message.hasOwnProperty("PlayerLuckyNumber"))
            object.PlayerLuckyNumber = message.PlayerLuckyNumber;
        if (message.PlayerSettleGold != null && message.hasOwnProperty("PlayerSettleGold"))
            object.PlayerSettleGold = message.PlayerSettleGold;
        if (message.PlayerTax != null && message.hasOwnProperty("PlayerTax"))
            object.PlayerTax = message.PlayerTax;
        if (message.CurStock != null && message.hasOwnProperty("CurStock"))
            object.CurStock = message.CurStock;
        if (message.RedCardType != null && message.hasOwnProperty("RedCardType"))
            object.RedCardType = message.RedCardType;
        if (message.BlackCardType != null && message.hasOwnProperty("BlackCardType"))
            object.BlackCardType = message.BlackCardType;
        return object;
    };

    /**
     * Converts this PokerWarToGameDataSrvReqStockChange to JSON.
     * @function toJSON
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarToGameDataSrvReqStockChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarToGameDataSrvReqStockChange
     * @function getTypeUrl
     * @memberof PokerWarToGameDataSrvReqStockChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarToGameDataSrvReqStockChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarToGameDataSrvReqStockChange";
    };

    return PokerWarToGameDataSrvReqStockChange;
})();

export const PokerWarToGameDataSrvAckStockChange = $root.PokerWarToGameDataSrvAckStockChange = (() => {

    /**
     * Properties of a PokerWarToGameDataSrvAckStockChange.
     * @exports IPokerWarToGameDataSrvAckStockChange
     * @interface IPokerWarToGameDataSrvAckStockChange
     * @property {number|null} [Ret] PokerWarToGameDataSrvAckStockChange Ret
     * @property {IPokerWarToGameDataSrvReqStockChange|null} [StockChangeMsg] PokerWarToGameDataSrvAckStockChange StockChangeMsg
     */

    /**
     * Constructs a new PokerWarToGameDataSrvAckStockChange.
     * @exports PokerWarToGameDataSrvAckStockChange
     * @classdesc Represents a PokerWarToGameDataSrvAckStockChange.
     * @implements IPokerWarToGameDataSrvAckStockChange
     * @constructor
     * @param {IPokerWarToGameDataSrvAckStockChange=} [properties] Properties to set
     */
    function PokerWarToGameDataSrvAckStockChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarToGameDataSrvAckStockChange Ret.
     * @member {number} Ret
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @instance
     */
    PokerWarToGameDataSrvAckStockChange.prototype.Ret = 0;

    /**
     * PokerWarToGameDataSrvAckStockChange StockChangeMsg.
     * @member {IPokerWarToGameDataSrvReqStockChange|null|undefined} StockChangeMsg
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @instance
     */
    PokerWarToGameDataSrvAckStockChange.prototype.StockChangeMsg = null;

    /**
     * Creates a new PokerWarToGameDataSrvAckStockChange instance using the specified properties.
     * @function create
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {IPokerWarToGameDataSrvAckStockChange=} [properties] Properties to set
     * @returns {PokerWarToGameDataSrvAckStockChange} PokerWarToGameDataSrvAckStockChange instance
     */
    PokerWarToGameDataSrvAckStockChange.create = function create(properties) {
        return new PokerWarToGameDataSrvAckStockChange(properties);
    };

    /**
     * Encodes the specified PokerWarToGameDataSrvAckStockChange message. Does not implicitly {@link PokerWarToGameDataSrvAckStockChange.verify|verify} messages.
     * @function encode
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {IPokerWarToGameDataSrvAckStockChange} message PokerWarToGameDataSrvAckStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarToGameDataSrvAckStockChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.StockChangeMsg != null && Object.hasOwnProperty.call(message, "StockChangeMsg"))
            $root.PokerWarToGameDataSrvReqStockChange.encode(message.StockChangeMsg, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PokerWarToGameDataSrvAckStockChange message, length delimited. Does not implicitly {@link PokerWarToGameDataSrvAckStockChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {IPokerWarToGameDataSrvAckStockChange} message PokerWarToGameDataSrvAckStockChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarToGameDataSrvAckStockChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarToGameDataSrvAckStockChange message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarToGameDataSrvAckStockChange} PokerWarToGameDataSrvAckStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarToGameDataSrvAckStockChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarToGameDataSrvAckStockChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.StockChangeMsg = $root.PokerWarToGameDataSrvReqStockChange.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarToGameDataSrvAckStockChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarToGameDataSrvAckStockChange} PokerWarToGameDataSrvAckStockChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarToGameDataSrvAckStockChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarToGameDataSrvAckStockChange message.
     * @function verify
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarToGameDataSrvAckStockChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.StockChangeMsg != null && message.hasOwnProperty("StockChangeMsg")) {
            let error = $root.PokerWarToGameDataSrvReqStockChange.verify(message.StockChangeMsg);
            if (error)
                return "StockChangeMsg." + error;
        }
        return null;
    };

    /**
     * Creates a PokerWarToGameDataSrvAckStockChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarToGameDataSrvAckStockChange} PokerWarToGameDataSrvAckStockChange
     */
    PokerWarToGameDataSrvAckStockChange.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarToGameDataSrvAckStockChange)
            return object;
        let message = new $root.PokerWarToGameDataSrvAckStockChange();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.StockChangeMsg != null) {
            if (typeof object.StockChangeMsg !== "object")
                throw TypeError(".PokerWarToGameDataSrvAckStockChange.StockChangeMsg: object expected");
            message.StockChangeMsg = $root.PokerWarToGameDataSrvReqStockChange.fromObject(object.StockChangeMsg);
        }
        return message;
    };

    /**
     * Creates a plain object from a PokerWarToGameDataSrvAckStockChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {PokerWarToGameDataSrvAckStockChange} message PokerWarToGameDataSrvAckStockChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarToGameDataSrvAckStockChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.StockChangeMsg = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.StockChangeMsg != null && message.hasOwnProperty("StockChangeMsg"))
            object.StockChangeMsg = $root.PokerWarToGameDataSrvReqStockChange.toObject(message.StockChangeMsg, options);
        return object;
    };

    /**
     * Converts this PokerWarToGameDataSrvAckStockChange to JSON.
     * @function toJSON
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarToGameDataSrvAckStockChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarToGameDataSrvAckStockChange
     * @function getTypeUrl
     * @memberof PokerWarToGameDataSrvAckStockChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarToGameDataSrvAckStockChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarToGameDataSrvAckStockChange";
    };

    return PokerWarToGameDataSrvAckStockChange;
})();

export const AccountBalanceDetail = $root.AccountBalanceDetail = (() => {

    /**
     * Properties of an AccountBalanceDetail.
     * @exports IAccountBalanceDetail
     * @interface IAccountBalanceDetail
     * @property {string|null} [OrderId] AccountBalanceDetail OrderId
     * @property {string|null} [BalanceType] AccountBalanceDetail BalanceType
     * @property {number|Long|null} [SettleTime] AccountBalanceDetail SettleTime
     * @property {string|null} [Amount] AccountBalanceDetail Amount
     * @property {string|null} [Status] AccountBalanceDetail Status
     */

    /**
     * Constructs a new AccountBalanceDetail.
     * @exports AccountBalanceDetail
     * @classdesc Represents an AccountBalanceDetail.
     * @implements IAccountBalanceDetail
     * @constructor
     * @param {IAccountBalanceDetail=} [properties] Properties to set
     */
    function AccountBalanceDetail(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountBalanceDetail OrderId.
     * @member {string} OrderId
     * @memberof AccountBalanceDetail
     * @instance
     */
    AccountBalanceDetail.prototype.OrderId = "";

    /**
     * AccountBalanceDetail BalanceType.
     * @member {string} BalanceType
     * @memberof AccountBalanceDetail
     * @instance
     */
    AccountBalanceDetail.prototype.BalanceType = "";

    /**
     * AccountBalanceDetail SettleTime.
     * @member {number|Long} SettleTime
     * @memberof AccountBalanceDetail
     * @instance
     */
    AccountBalanceDetail.prototype.SettleTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * AccountBalanceDetail Amount.
     * @member {string} Amount
     * @memberof AccountBalanceDetail
     * @instance
     */
    AccountBalanceDetail.prototype.Amount = "";

    /**
     * AccountBalanceDetail Status.
     * @member {string} Status
     * @memberof AccountBalanceDetail
     * @instance
     */
    AccountBalanceDetail.prototype.Status = "";

    /**
     * Creates a new AccountBalanceDetail instance using the specified properties.
     * @function create
     * @memberof AccountBalanceDetail
     * @static
     * @param {IAccountBalanceDetail=} [properties] Properties to set
     * @returns {AccountBalanceDetail} AccountBalanceDetail instance
     */
    AccountBalanceDetail.create = function create(properties) {
        return new AccountBalanceDetail(properties);
    };

    /**
     * Encodes the specified AccountBalanceDetail message. Does not implicitly {@link AccountBalanceDetail.verify|verify} messages.
     * @function encode
     * @memberof AccountBalanceDetail
     * @static
     * @param {IAccountBalanceDetail} message AccountBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountBalanceDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OrderId != null && Object.hasOwnProperty.call(message, "OrderId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.OrderId);
        if (message.BalanceType != null && Object.hasOwnProperty.call(message, "BalanceType"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.BalanceType);
        if (message.SettleTime != null && Object.hasOwnProperty.call(message, "SettleTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.SettleTime);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Amount);
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Status);
        return writer;
    };

    /**
     * Encodes the specified AccountBalanceDetail message, length delimited. Does not implicitly {@link AccountBalanceDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountBalanceDetail
     * @static
     * @param {IAccountBalanceDetail} message AccountBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountBalanceDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountBalanceDetail message from the specified reader or buffer.
     * @function decode
     * @memberof AccountBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountBalanceDetail} AccountBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountBalanceDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountBalanceDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.OrderId = reader.string();
                    break;
                }
            case 2: {
                    message.BalanceType = reader.string();
                    break;
                }
            case 3: {
                    message.SettleTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.Amount = reader.string();
                    break;
                }
            case 5: {
                    message.Status = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountBalanceDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountBalanceDetail} AccountBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountBalanceDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountBalanceDetail message.
     * @function verify
     * @memberof AccountBalanceDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountBalanceDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            if (!$util.isString(message.OrderId))
                return "OrderId: string expected";
        if (message.BalanceType != null && message.hasOwnProperty("BalanceType"))
            if (!$util.isString(message.BalanceType))
                return "BalanceType: string expected";
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (!$util.isInteger(message.SettleTime) && !(message.SettleTime && $util.isInteger(message.SettleTime.low) && $util.isInteger(message.SettleTime.high)))
                return "SettleTime: integer|Long expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isString(message.Status))
                return "Status: string expected";
        return null;
    };

    /**
     * Creates an AccountBalanceDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountBalanceDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountBalanceDetail} AccountBalanceDetail
     */
    AccountBalanceDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountBalanceDetail)
            return object;
        let message = new $root.AccountBalanceDetail();
        if (object.OrderId != null)
            message.OrderId = String(object.OrderId);
        if (object.BalanceType != null)
            message.BalanceType = String(object.BalanceType);
        if (object.SettleTime != null)
            if ($util.Long)
                (message.SettleTime = $util.Long.fromValue(object.SettleTime)).unsigned = true;
            else if (typeof object.SettleTime === "string")
                message.SettleTime = parseInt(object.SettleTime, 10);
            else if (typeof object.SettleTime === "number")
                message.SettleTime = object.SettleTime;
            else if (typeof object.SettleTime === "object")
                message.SettleTime = new $util.LongBits(object.SettleTime.low >>> 0, object.SettleTime.high >>> 0).toNumber(true);
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Status != null)
            message.Status = String(object.Status);
        return message;
    };

    /**
     * Creates a plain object from an AccountBalanceDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountBalanceDetail
     * @static
     * @param {AccountBalanceDetail} message AccountBalanceDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountBalanceDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.OrderId = "";
            object.BalanceType = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.SettleTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SettleTime = options.longs === String ? "0" : 0;
            object.Amount = "";
            object.Status = "";
        }
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            object.OrderId = message.OrderId;
        if (message.BalanceType != null && message.hasOwnProperty("BalanceType"))
            object.BalanceType = message.BalanceType;
        if (message.SettleTime != null && message.hasOwnProperty("SettleTime"))
            if (typeof message.SettleTime === "number")
                object.SettleTime = options.longs === String ? String(message.SettleTime) : message.SettleTime;
            else
                object.SettleTime = options.longs === String ? $util.Long.prototype.toString.call(message.SettleTime) : options.longs === Number ? new $util.LongBits(message.SettleTime.low >>> 0, message.SettleTime.high >>> 0).toNumber(true) : message.SettleTime;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        return object;
    };

    /**
     * Converts this AccountBalanceDetail to JSON.
     * @function toJSON
     * @memberof AccountBalanceDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountBalanceDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AccountBalanceDetail
     * @function getTypeUrl
     * @memberof AccountBalanceDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AccountBalanceDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AccountBalanceDetail";
    };

    return AccountBalanceDetail;
})();

export const MatchAwardInfo = $root.MatchAwardInfo = (() => {

    /**
     * Properties of a MatchAwardInfo.
     * @exports IMatchAwardInfo
     * @interface IMatchAwardInfo
     * @property {number|null} [AwardId] MatchAwardInfo AwardId
     * @property {string|null} [AwardDescribe] MatchAwardInfo AwardDescribe
     * @property {number|null} [RangeStart] MatchAwardInfo RangeStart
     * @property {number|null} [RangeEnd] MatchAwardInfo RangeEnd
     * @property {number|null} [PropertyAmt] MatchAwardInfo PropertyAmt
     * @property {number|null} [CashAmt] MatchAwardInfo CashAmt
     * @property {number|null} [PropertyType] MatchAwardInfo PropertyType
     */

    /**
     * Constructs a new MatchAwardInfo.
     * @exports MatchAwardInfo
     * @classdesc Represents a MatchAwardInfo.
     * @implements IMatchAwardInfo
     * @constructor
     * @param {IMatchAwardInfo=} [properties] Properties to set
     */
    function MatchAwardInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MatchAwardInfo AwardId.
     * @member {number} AwardId
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.AwardId = 0;

    /**
     * MatchAwardInfo AwardDescribe.
     * @member {string} AwardDescribe
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.AwardDescribe = "";

    /**
     * MatchAwardInfo RangeStart.
     * @member {number} RangeStart
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.RangeStart = 0;

    /**
     * MatchAwardInfo RangeEnd.
     * @member {number} RangeEnd
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.RangeEnd = 0;

    /**
     * MatchAwardInfo PropertyAmt.
     * @member {number} PropertyAmt
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.PropertyAmt = 0;

    /**
     * MatchAwardInfo CashAmt.
     * @member {number} CashAmt
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.CashAmt = 0;

    /**
     * MatchAwardInfo PropertyType.
     * @member {number} PropertyType
     * @memberof MatchAwardInfo
     * @instance
     */
    MatchAwardInfo.prototype.PropertyType = 0;

    /**
     * Creates a new MatchAwardInfo instance using the specified properties.
     * @function create
     * @memberof MatchAwardInfo
     * @static
     * @param {IMatchAwardInfo=} [properties] Properties to set
     * @returns {MatchAwardInfo} MatchAwardInfo instance
     */
    MatchAwardInfo.create = function create(properties) {
        return new MatchAwardInfo(properties);
    };

    /**
     * Encodes the specified MatchAwardInfo message. Does not implicitly {@link MatchAwardInfo.verify|verify} messages.
     * @function encode
     * @memberof MatchAwardInfo
     * @static
     * @param {IMatchAwardInfo} message MatchAwardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MatchAwardInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.AwardId != null && Object.hasOwnProperty.call(message, "AwardId"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.AwardId);
        if (message.AwardDescribe != null && Object.hasOwnProperty.call(message, "AwardDescribe"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.AwardDescribe);
        if (message.RangeStart != null && Object.hasOwnProperty.call(message, "RangeStart"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.RangeStart);
        if (message.RangeEnd != null && Object.hasOwnProperty.call(message, "RangeEnd"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.RangeEnd);
        if (message.PropertyAmt != null && Object.hasOwnProperty.call(message, "PropertyAmt"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.PropertyAmt);
        if (message.CashAmt != null && Object.hasOwnProperty.call(message, "CashAmt"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.CashAmt);
        if (message.PropertyType != null && Object.hasOwnProperty.call(message, "PropertyType"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PropertyType);
        return writer;
    };

    /**
     * Encodes the specified MatchAwardInfo message, length delimited. Does not implicitly {@link MatchAwardInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MatchAwardInfo
     * @static
     * @param {IMatchAwardInfo} message MatchAwardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MatchAwardInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MatchAwardInfo message from the specified reader or buffer.
     * @function decode
     * @memberof MatchAwardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MatchAwardInfo} MatchAwardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MatchAwardInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MatchAwardInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.AwardId = reader.uint32();
                    break;
                }
            case 2: {
                    message.AwardDescribe = reader.string();
                    break;
                }
            case 3: {
                    message.RangeStart = reader.uint32();
                    break;
                }
            case 4: {
                    message.RangeEnd = reader.uint32();
                    break;
                }
            case 5: {
                    message.PropertyAmt = reader.uint32();
                    break;
                }
            case 6: {
                    message.CashAmt = reader.uint32();
                    break;
                }
            case 7: {
                    message.PropertyType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MatchAwardInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MatchAwardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MatchAwardInfo} MatchAwardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MatchAwardInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MatchAwardInfo message.
     * @function verify
     * @memberof MatchAwardInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MatchAwardInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.AwardId != null && message.hasOwnProperty("AwardId"))
            if (!$util.isInteger(message.AwardId))
                return "AwardId: integer expected";
        if (message.AwardDescribe != null && message.hasOwnProperty("AwardDescribe"))
            if (!$util.isString(message.AwardDescribe))
                return "AwardDescribe: string expected";
        if (message.RangeStart != null && message.hasOwnProperty("RangeStart"))
            if (!$util.isInteger(message.RangeStart))
                return "RangeStart: integer expected";
        if (message.RangeEnd != null && message.hasOwnProperty("RangeEnd"))
            if (!$util.isInteger(message.RangeEnd))
                return "RangeEnd: integer expected";
        if (message.PropertyAmt != null && message.hasOwnProperty("PropertyAmt"))
            if (!$util.isInteger(message.PropertyAmt))
                return "PropertyAmt: integer expected";
        if (message.CashAmt != null && message.hasOwnProperty("CashAmt"))
            if (!$util.isInteger(message.CashAmt))
                return "CashAmt: integer expected";
        if (message.PropertyType != null && message.hasOwnProperty("PropertyType"))
            if (!$util.isInteger(message.PropertyType))
                return "PropertyType: integer expected";
        return null;
    };

    /**
     * Creates a MatchAwardInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MatchAwardInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MatchAwardInfo} MatchAwardInfo
     */
    MatchAwardInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.MatchAwardInfo)
            return object;
        let message = new $root.MatchAwardInfo();
        if (object.AwardId != null)
            message.AwardId = object.AwardId >>> 0;
        if (object.AwardDescribe != null)
            message.AwardDescribe = String(object.AwardDescribe);
        if (object.RangeStart != null)
            message.RangeStart = object.RangeStart >>> 0;
        if (object.RangeEnd != null)
            message.RangeEnd = object.RangeEnd >>> 0;
        if (object.PropertyAmt != null)
            message.PropertyAmt = object.PropertyAmt >>> 0;
        if (object.CashAmt != null)
            message.CashAmt = object.CashAmt >>> 0;
        if (object.PropertyType != null)
            message.PropertyType = object.PropertyType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a MatchAwardInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MatchAwardInfo
     * @static
     * @param {MatchAwardInfo} message MatchAwardInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MatchAwardInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.AwardId = 0;
            object.AwardDescribe = "";
            object.RangeStart = 0;
            object.RangeEnd = 0;
            object.PropertyAmt = 0;
            object.CashAmt = 0;
            object.PropertyType = 0;
        }
        if (message.AwardId != null && message.hasOwnProperty("AwardId"))
            object.AwardId = message.AwardId;
        if (message.AwardDescribe != null && message.hasOwnProperty("AwardDescribe"))
            object.AwardDescribe = message.AwardDescribe;
        if (message.RangeStart != null && message.hasOwnProperty("RangeStart"))
            object.RangeStart = message.RangeStart;
        if (message.RangeEnd != null && message.hasOwnProperty("RangeEnd"))
            object.RangeEnd = message.RangeEnd;
        if (message.PropertyAmt != null && message.hasOwnProperty("PropertyAmt"))
            object.PropertyAmt = message.PropertyAmt;
        if (message.CashAmt != null && message.hasOwnProperty("CashAmt"))
            object.CashAmt = message.CashAmt;
        if (message.PropertyType != null && message.hasOwnProperty("PropertyType"))
            object.PropertyType = message.PropertyType;
        return object;
    };

    /**
     * Converts this MatchAwardInfo to JSON.
     * @function toJSON
     * @memberof MatchAwardInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MatchAwardInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MatchAwardInfo
     * @function getTypeUrl
     * @memberof MatchAwardInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MatchAwardInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MatchAwardInfo";
    };

    return MatchAwardInfo;
})();

export const UserMatchInfo = $root.UserMatchInfo = (() => {

    /**
     * Properties of a UserMatchInfo.
     * @exports IUserMatchInfo
     * @interface IUserMatchInfo
     * @property {number|null} [UserID] UserMatchInfo UserID
     * @property {number|null} [MatchID] UserMatchInfo MatchID
     * @property {number|null} [KickOutFlag] UserMatchInfo KickOutFlag
     * @property {number|null} [Ranking] UserMatchInfo Ranking
     * @property {number|null} [PropertyAmt] UserMatchInfo PropertyAmt
     * @property {number|null} [CashAmt] UserMatchInfo CashAmt
     * @property {number|null} [AwardFlag] UserMatchInfo AwardFlag
     * @property {number|null} [ReSignFlag] UserMatchInfo ReSignFlag
     * @property {number|null} [PropertyType] UserMatchInfo PropertyType
     */

    /**
     * Constructs a new UserMatchInfo.
     * @exports UserMatchInfo
     * @classdesc Represents a UserMatchInfo.
     * @implements IUserMatchInfo
     * @constructor
     * @param {IUserMatchInfo=} [properties] Properties to set
     */
    function UserMatchInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserMatchInfo UserID.
     * @member {number} UserID
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.UserID = 0;

    /**
     * UserMatchInfo MatchID.
     * @member {number} MatchID
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.MatchID = 0;

    /**
     * UserMatchInfo KickOutFlag.
     * @member {number} KickOutFlag
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.KickOutFlag = 0;

    /**
     * UserMatchInfo Ranking.
     * @member {number} Ranking
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.Ranking = 0;

    /**
     * UserMatchInfo PropertyAmt.
     * @member {number} PropertyAmt
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.PropertyAmt = 0;

    /**
     * UserMatchInfo CashAmt.
     * @member {number} CashAmt
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.CashAmt = 0;

    /**
     * UserMatchInfo AwardFlag.
     * @member {number} AwardFlag
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.AwardFlag = 0;

    /**
     * UserMatchInfo ReSignFlag.
     * @member {number} ReSignFlag
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.ReSignFlag = 0;

    /**
     * UserMatchInfo PropertyType.
     * @member {number} PropertyType
     * @memberof UserMatchInfo
     * @instance
     */
    UserMatchInfo.prototype.PropertyType = 0;

    /**
     * Creates a new UserMatchInfo instance using the specified properties.
     * @function create
     * @memberof UserMatchInfo
     * @static
     * @param {IUserMatchInfo=} [properties] Properties to set
     * @returns {UserMatchInfo} UserMatchInfo instance
     */
    UserMatchInfo.create = function create(properties) {
        return new UserMatchInfo(properties);
    };

    /**
     * Encodes the specified UserMatchInfo message. Does not implicitly {@link UserMatchInfo.verify|verify} messages.
     * @function encode
     * @memberof UserMatchInfo
     * @static
     * @param {IUserMatchInfo} message UserMatchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserMatchInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MatchID);
        if (message.KickOutFlag != null && Object.hasOwnProperty.call(message, "KickOutFlag"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.KickOutFlag);
        if (message.Ranking != null && Object.hasOwnProperty.call(message, "Ranking"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Ranking);
        if (message.PropertyAmt != null && Object.hasOwnProperty.call(message, "PropertyAmt"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.PropertyAmt);
        if (message.CashAmt != null && Object.hasOwnProperty.call(message, "CashAmt"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.CashAmt);
        if (message.AwardFlag != null && Object.hasOwnProperty.call(message, "AwardFlag"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.AwardFlag);
        if (message.ReSignFlag != null && Object.hasOwnProperty.call(message, "ReSignFlag"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.ReSignFlag);
        if (message.PropertyType != null && Object.hasOwnProperty.call(message, "PropertyType"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.PropertyType);
        return writer;
    };

    /**
     * Encodes the specified UserMatchInfo message, length delimited. Does not implicitly {@link UserMatchInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserMatchInfo
     * @static
     * @param {IUserMatchInfo} message UserMatchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserMatchInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserMatchInfo message from the specified reader or buffer.
     * @function decode
     * @memberof UserMatchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserMatchInfo} UserMatchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserMatchInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserMatchInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.MatchID = reader.uint32();
                    break;
                }
            case 3: {
                    message.KickOutFlag = reader.uint32();
                    break;
                }
            case 4: {
                    message.Ranking = reader.uint32();
                    break;
                }
            case 5: {
                    message.PropertyAmt = reader.uint32();
                    break;
                }
            case 6: {
                    message.CashAmt = reader.uint32();
                    break;
                }
            case 7: {
                    message.AwardFlag = reader.uint32();
                    break;
                }
            case 8: {
                    message.ReSignFlag = reader.uint32();
                    break;
                }
            case 9: {
                    message.PropertyType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserMatchInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserMatchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserMatchInfo} UserMatchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserMatchInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserMatchInfo message.
     * @function verify
     * @memberof UserMatchInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserMatchInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        if (message.KickOutFlag != null && message.hasOwnProperty("KickOutFlag"))
            if (!$util.isInteger(message.KickOutFlag))
                return "KickOutFlag: integer expected";
        if (message.Ranking != null && message.hasOwnProperty("Ranking"))
            if (!$util.isInteger(message.Ranking))
                return "Ranking: integer expected";
        if (message.PropertyAmt != null && message.hasOwnProperty("PropertyAmt"))
            if (!$util.isInteger(message.PropertyAmt))
                return "PropertyAmt: integer expected";
        if (message.CashAmt != null && message.hasOwnProperty("CashAmt"))
            if (!$util.isInteger(message.CashAmt))
                return "CashAmt: integer expected";
        if (message.AwardFlag != null && message.hasOwnProperty("AwardFlag"))
            if (!$util.isInteger(message.AwardFlag))
                return "AwardFlag: integer expected";
        if (message.ReSignFlag != null && message.hasOwnProperty("ReSignFlag"))
            if (!$util.isInteger(message.ReSignFlag))
                return "ReSignFlag: integer expected";
        if (message.PropertyType != null && message.hasOwnProperty("PropertyType"))
            if (!$util.isInteger(message.PropertyType))
                return "PropertyType: integer expected";
        return null;
    };

    /**
     * Creates a UserMatchInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserMatchInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserMatchInfo} UserMatchInfo
     */
    UserMatchInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.UserMatchInfo)
            return object;
        let message = new $root.UserMatchInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        if (object.KickOutFlag != null)
            message.KickOutFlag = object.KickOutFlag >>> 0;
        if (object.Ranking != null)
            message.Ranking = object.Ranking >>> 0;
        if (object.PropertyAmt != null)
            message.PropertyAmt = object.PropertyAmt >>> 0;
        if (object.CashAmt != null)
            message.CashAmt = object.CashAmt >>> 0;
        if (object.AwardFlag != null)
            message.AwardFlag = object.AwardFlag >>> 0;
        if (object.ReSignFlag != null)
            message.ReSignFlag = object.ReSignFlag >>> 0;
        if (object.PropertyType != null)
            message.PropertyType = object.PropertyType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a UserMatchInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserMatchInfo
     * @static
     * @param {UserMatchInfo} message UserMatchInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserMatchInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.MatchID = 0;
            object.KickOutFlag = 0;
            object.Ranking = 0;
            object.PropertyAmt = 0;
            object.CashAmt = 0;
            object.AwardFlag = 0;
            object.ReSignFlag = 0;
            object.PropertyType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        if (message.KickOutFlag != null && message.hasOwnProperty("KickOutFlag"))
            object.KickOutFlag = message.KickOutFlag;
        if (message.Ranking != null && message.hasOwnProperty("Ranking"))
            object.Ranking = message.Ranking;
        if (message.PropertyAmt != null && message.hasOwnProperty("PropertyAmt"))
            object.PropertyAmt = message.PropertyAmt;
        if (message.CashAmt != null && message.hasOwnProperty("CashAmt"))
            object.CashAmt = message.CashAmt;
        if (message.AwardFlag != null && message.hasOwnProperty("AwardFlag"))
            object.AwardFlag = message.AwardFlag;
        if (message.ReSignFlag != null && message.hasOwnProperty("ReSignFlag"))
            object.ReSignFlag = message.ReSignFlag;
        if (message.PropertyType != null && message.hasOwnProperty("PropertyType"))
            object.PropertyType = message.PropertyType;
        return object;
    };

    /**
     * Converts this UserMatchInfo to JSON.
     * @function toJSON
     * @memberof UserMatchInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserMatchInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UserMatchInfo
     * @function getTypeUrl
     * @memberof UserMatchInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UserMatchInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserMatchInfo";
    };

    return UserMatchInfo;
})();

export const MatchScheduleInfo = $root.MatchScheduleInfo = (() => {

    /**
     * Properties of a MatchScheduleInfo.
     * @exports IMatchScheduleInfo
     * @interface IMatchScheduleInfo
     * @property {number|null} [MatchID] MatchScheduleInfo MatchID
     * @property {number|null} [SignedPlayer] MatchScheduleInfo SignedPlayer
     * @property {number|null} [LeftPlayer] MatchScheduleInfo LeftPlayer
     * @property {number|null} [MatchStatus] MatchScheduleInfo MatchStatus
     * @property {number|null} [BootRound] MatchScheduleInfo BootRound
     * @property {number|null} [GameRound] MatchScheduleInfo GameRound
     */

    /**
     * Constructs a new MatchScheduleInfo.
     * @exports MatchScheduleInfo
     * @classdesc Represents a MatchScheduleInfo.
     * @implements IMatchScheduleInfo
     * @constructor
     * @param {IMatchScheduleInfo=} [properties] Properties to set
     */
    function MatchScheduleInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MatchScheduleInfo MatchID.
     * @member {number} MatchID
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.MatchID = 0;

    /**
     * MatchScheduleInfo SignedPlayer.
     * @member {number} SignedPlayer
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.SignedPlayer = 0;

    /**
     * MatchScheduleInfo LeftPlayer.
     * @member {number} LeftPlayer
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.LeftPlayer = 0;

    /**
     * MatchScheduleInfo MatchStatus.
     * @member {number} MatchStatus
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.MatchStatus = 0;

    /**
     * MatchScheduleInfo BootRound.
     * @member {number} BootRound
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.BootRound = 0;

    /**
     * MatchScheduleInfo GameRound.
     * @member {number} GameRound
     * @memberof MatchScheduleInfo
     * @instance
     */
    MatchScheduleInfo.prototype.GameRound = 0;

    /**
     * Creates a new MatchScheduleInfo instance using the specified properties.
     * @function create
     * @memberof MatchScheduleInfo
     * @static
     * @param {IMatchScheduleInfo=} [properties] Properties to set
     * @returns {MatchScheduleInfo} MatchScheduleInfo instance
     */
    MatchScheduleInfo.create = function create(properties) {
        return new MatchScheduleInfo(properties);
    };

    /**
     * Encodes the specified MatchScheduleInfo message. Does not implicitly {@link MatchScheduleInfo.verify|verify} messages.
     * @function encode
     * @memberof MatchScheduleInfo
     * @static
     * @param {IMatchScheduleInfo} message MatchScheduleInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MatchScheduleInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MatchID);
        if (message.SignedPlayer != null && Object.hasOwnProperty.call(message, "SignedPlayer"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SignedPlayer);
        if (message.LeftPlayer != null && Object.hasOwnProperty.call(message, "LeftPlayer"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.LeftPlayer);
        if (message.MatchStatus != null && Object.hasOwnProperty.call(message, "MatchStatus"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MatchStatus);
        if (message.BootRound != null && Object.hasOwnProperty.call(message, "BootRound"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BootRound);
        if (message.GameRound != null && Object.hasOwnProperty.call(message, "GameRound"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.GameRound);
        return writer;
    };

    /**
     * Encodes the specified MatchScheduleInfo message, length delimited. Does not implicitly {@link MatchScheduleInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MatchScheduleInfo
     * @static
     * @param {IMatchScheduleInfo} message MatchScheduleInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MatchScheduleInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MatchScheduleInfo message from the specified reader or buffer.
     * @function decode
     * @memberof MatchScheduleInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MatchScheduleInfo} MatchScheduleInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MatchScheduleInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MatchScheduleInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.MatchID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SignedPlayer = reader.uint32();
                    break;
                }
            case 3: {
                    message.LeftPlayer = reader.uint32();
                    break;
                }
            case 4: {
                    message.MatchStatus = reader.uint32();
                    break;
                }
            case 5: {
                    message.BootRound = reader.uint32();
                    break;
                }
            case 6: {
                    message.GameRound = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MatchScheduleInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MatchScheduleInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MatchScheduleInfo} MatchScheduleInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MatchScheduleInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MatchScheduleInfo message.
     * @function verify
     * @memberof MatchScheduleInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MatchScheduleInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        if (message.SignedPlayer != null && message.hasOwnProperty("SignedPlayer"))
            if (!$util.isInteger(message.SignedPlayer))
                return "SignedPlayer: integer expected";
        if (message.LeftPlayer != null && message.hasOwnProperty("LeftPlayer"))
            if (!$util.isInteger(message.LeftPlayer))
                return "LeftPlayer: integer expected";
        if (message.MatchStatus != null && message.hasOwnProperty("MatchStatus"))
            if (!$util.isInteger(message.MatchStatus))
                return "MatchStatus: integer expected";
        if (message.BootRound != null && message.hasOwnProperty("BootRound"))
            if (!$util.isInteger(message.BootRound))
                return "BootRound: integer expected";
        if (message.GameRound != null && message.hasOwnProperty("GameRound"))
            if (!$util.isInteger(message.GameRound))
                return "GameRound: integer expected";
        return null;
    };

    /**
     * Creates a MatchScheduleInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MatchScheduleInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MatchScheduleInfo} MatchScheduleInfo
     */
    MatchScheduleInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.MatchScheduleInfo)
            return object;
        let message = new $root.MatchScheduleInfo();
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        if (object.SignedPlayer != null)
            message.SignedPlayer = object.SignedPlayer >>> 0;
        if (object.LeftPlayer != null)
            message.LeftPlayer = object.LeftPlayer >>> 0;
        if (object.MatchStatus != null)
            message.MatchStatus = object.MatchStatus >>> 0;
        if (object.BootRound != null)
            message.BootRound = object.BootRound >>> 0;
        if (object.GameRound != null)
            message.GameRound = object.GameRound >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a MatchScheduleInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MatchScheduleInfo
     * @static
     * @param {MatchScheduleInfo} message MatchScheduleInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MatchScheduleInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.MatchID = 0;
            object.SignedPlayer = 0;
            object.LeftPlayer = 0;
            object.MatchStatus = 0;
            object.BootRound = 0;
            object.GameRound = 0;
        }
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        if (message.SignedPlayer != null && message.hasOwnProperty("SignedPlayer"))
            object.SignedPlayer = message.SignedPlayer;
        if (message.LeftPlayer != null && message.hasOwnProperty("LeftPlayer"))
            object.LeftPlayer = message.LeftPlayer;
        if (message.MatchStatus != null && message.hasOwnProperty("MatchStatus"))
            object.MatchStatus = message.MatchStatus;
        if (message.BootRound != null && message.hasOwnProperty("BootRound"))
            object.BootRound = message.BootRound;
        if (message.GameRound != null && message.hasOwnProperty("GameRound"))
            object.GameRound = message.GameRound;
        return object;
    };

    /**
     * Converts this MatchScheduleInfo to JSON.
     * @function toJSON
     * @memberof MatchScheduleInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MatchScheduleInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MatchScheduleInfo
     * @function getTypeUrl
     * @memberof MatchScheduleInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MatchScheduleInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MatchScheduleInfo";
    };

    return MatchScheduleInfo;
})();

export const GameMatchInfo = $root.GameMatchInfo = (() => {

    /**
     * Properties of a GameMatchInfo.
     * @exports IGameMatchInfo
     * @interface IGameMatchInfo
     * @property {number|null} [GameID] GameMatchInfo GameID
     * @property {number|null} [ProductID] GameMatchInfo ProductID
     * @property {number|null} [MatchID] GameMatchInfo MatchID
     * @property {string|null} [MatchName] GameMatchInfo MatchName
     * @property {number|null} [SignProAmt] GameMatchInfo SignProAmt
     * @property {number|null} [SignProType] GameMatchInfo SignProType
     * @property {number|null} [SignCashAmt] GameMatchInfo SignCashAmt
     * @property {number|null} [MaxPlayerAmt] GameMatchInfo MaxPlayerAmt
     * @property {string|null} [MatchDescribe] GameMatchInfo MatchDescribe
     * @property {Array.<IMatchAwardInfo>|null} [AwardList] GameMatchInfo AwardList
     * @property {number|Long|null} [SignEndTime] GameMatchInfo SignEndTime
     * @property {number|Long|null} [MatchStartTime] GameMatchInfo MatchStartTime
     * @property {number|null} [EnterPeriod] GameMatchInfo EnterPeriod
     * @property {number|null} [ReSignPeriod] GameMatchInfo ReSignPeriod
     * @property {number|null} [AddBootPeriod] GameMatchInfo AddBootPeriod
     * @property {number|null} [KickOutPlayer] GameMatchInfo KickOutPlayer
     * @property {IMatchScheduleInfo|null} [MatchSchedule] GameMatchInfo MatchSchedule
     * @property {number|null} [SignFlag] GameMatchInfo SignFlag
     * @property {IUserMatchInfo|null} [UserMatch] GameMatchInfo UserMatch
     */

    /**
     * Constructs a new GameMatchInfo.
     * @exports GameMatchInfo
     * @classdesc Represents a GameMatchInfo.
     * @implements IGameMatchInfo
     * @constructor
     * @param {IGameMatchInfo=} [properties] Properties to set
     */
    function GameMatchInfo(properties) {
        this.AwardList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameMatchInfo GameID.
     * @member {number} GameID
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.GameID = 0;

    /**
     * GameMatchInfo ProductID.
     * @member {number} ProductID
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.ProductID = 0;

    /**
     * GameMatchInfo MatchID.
     * @member {number} MatchID
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MatchID = 0;

    /**
     * GameMatchInfo MatchName.
     * @member {string} MatchName
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MatchName = "";

    /**
     * GameMatchInfo SignProAmt.
     * @member {number} SignProAmt
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.SignProAmt = 0;

    /**
     * GameMatchInfo SignProType.
     * @member {number} SignProType
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.SignProType = 0;

    /**
     * GameMatchInfo SignCashAmt.
     * @member {number} SignCashAmt
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.SignCashAmt = 0;

    /**
     * GameMatchInfo MaxPlayerAmt.
     * @member {number} MaxPlayerAmt
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MaxPlayerAmt = 0;

    /**
     * GameMatchInfo MatchDescribe.
     * @member {string} MatchDescribe
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MatchDescribe = "";

    /**
     * GameMatchInfo AwardList.
     * @member {Array.<IMatchAwardInfo>} AwardList
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.AwardList = $util.emptyArray;

    /**
     * GameMatchInfo SignEndTime.
     * @member {number|Long} SignEndTime
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.SignEndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameMatchInfo MatchStartTime.
     * @member {number|Long} MatchStartTime
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MatchStartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameMatchInfo EnterPeriod.
     * @member {number} EnterPeriod
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.EnterPeriod = 0;

    /**
     * GameMatchInfo ReSignPeriod.
     * @member {number} ReSignPeriod
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.ReSignPeriod = 0;

    /**
     * GameMatchInfo AddBootPeriod.
     * @member {number} AddBootPeriod
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.AddBootPeriod = 0;

    /**
     * GameMatchInfo KickOutPlayer.
     * @member {number} KickOutPlayer
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.KickOutPlayer = 0;

    /**
     * GameMatchInfo MatchSchedule.
     * @member {IMatchScheduleInfo|null|undefined} MatchSchedule
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.MatchSchedule = null;

    /**
     * GameMatchInfo SignFlag.
     * @member {number} SignFlag
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.SignFlag = 0;

    /**
     * GameMatchInfo UserMatch.
     * @member {IUserMatchInfo|null|undefined} UserMatch
     * @memberof GameMatchInfo
     * @instance
     */
    GameMatchInfo.prototype.UserMatch = null;

    /**
     * Creates a new GameMatchInfo instance using the specified properties.
     * @function create
     * @memberof GameMatchInfo
     * @static
     * @param {IGameMatchInfo=} [properties] Properties to set
     * @returns {GameMatchInfo} GameMatchInfo instance
     */
    GameMatchInfo.create = function create(properties) {
        return new GameMatchInfo(properties);
    };

    /**
     * Encodes the specified GameMatchInfo message. Does not implicitly {@link GameMatchInfo.verify|verify} messages.
     * @function encode
     * @memberof GameMatchInfo
     * @static
     * @param {IGameMatchInfo} message GameMatchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameMatchInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ProductID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MatchID);
        if (message.MatchName != null && Object.hasOwnProperty.call(message, "MatchName"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.MatchName);
        if (message.SignProAmt != null && Object.hasOwnProperty.call(message, "SignProAmt"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.SignProAmt);
        if (message.SignProType != null && Object.hasOwnProperty.call(message, "SignProType"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.SignProType);
        if (message.SignCashAmt != null && Object.hasOwnProperty.call(message, "SignCashAmt"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.SignCashAmt);
        if (message.MaxPlayerAmt != null && Object.hasOwnProperty.call(message, "MaxPlayerAmt"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.MaxPlayerAmt);
        if (message.MatchDescribe != null && Object.hasOwnProperty.call(message, "MatchDescribe"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.MatchDescribe);
        if (message.AwardList != null && message.AwardList.length)
            for (let i = 0; i < message.AwardList.length; ++i)
                $root.MatchAwardInfo.encode(message.AwardList[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.SignEndTime != null && Object.hasOwnProperty.call(message, "SignEndTime"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.SignEndTime);
        if (message.MatchStartTime != null && Object.hasOwnProperty.call(message, "MatchStartTime"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.MatchStartTime);
        if (message.EnterPeriod != null && Object.hasOwnProperty.call(message, "EnterPeriod"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.EnterPeriod);
        if (message.ReSignPeriod != null && Object.hasOwnProperty.call(message, "ReSignPeriod"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.ReSignPeriod);
        if (message.AddBootPeriod != null && Object.hasOwnProperty.call(message, "AddBootPeriod"))
            writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.AddBootPeriod);
        if (message.KickOutPlayer != null && Object.hasOwnProperty.call(message, "KickOutPlayer"))
            writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.KickOutPlayer);
        if (message.MatchSchedule != null && Object.hasOwnProperty.call(message, "MatchSchedule"))
            $root.MatchScheduleInfo.encode(message.MatchSchedule, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
        if (message.SignFlag != null && Object.hasOwnProperty.call(message, "SignFlag"))
            writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.SignFlag);
        if (message.UserMatch != null && Object.hasOwnProperty.call(message, "UserMatch"))
            $root.UserMatchInfo.encode(message.UserMatch, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GameMatchInfo message, length delimited. Does not implicitly {@link GameMatchInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameMatchInfo
     * @static
     * @param {IGameMatchInfo} message GameMatchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameMatchInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameMatchInfo message from the specified reader or buffer.
     * @function decode
     * @memberof GameMatchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameMatchInfo} GameMatchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameMatchInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameMatchInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 3: {
                    message.MatchID = reader.uint32();
                    break;
                }
            case 4: {
                    message.MatchName = reader.string();
                    break;
                }
            case 5: {
                    message.SignProAmt = reader.uint32();
                    break;
                }
            case 6: {
                    message.SignProType = reader.uint32();
                    break;
                }
            case 7: {
                    message.SignCashAmt = reader.uint32();
                    break;
                }
            case 8: {
                    message.MaxPlayerAmt = reader.uint32();
                    break;
                }
            case 9: {
                    message.MatchDescribe = reader.string();
                    break;
                }
            case 10: {
                    if (!(message.AwardList && message.AwardList.length))
                        message.AwardList = [];
                    message.AwardList.push($root.MatchAwardInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    message.SignEndTime = reader.uint64();
                    break;
                }
            case 12: {
                    message.MatchStartTime = reader.uint64();
                    break;
                }
            case 13: {
                    message.EnterPeriod = reader.uint32();
                    break;
                }
            case 14: {
                    message.ReSignPeriod = reader.uint32();
                    break;
                }
            case 15: {
                    message.AddBootPeriod = reader.uint32();
                    break;
                }
            case 16: {
                    message.KickOutPlayer = reader.uint32();
                    break;
                }
            case 17: {
                    message.MatchSchedule = $root.MatchScheduleInfo.decode(reader, reader.uint32());
                    break;
                }
            case 18: {
                    message.SignFlag = reader.uint32();
                    break;
                }
            case 19: {
                    message.UserMatch = $root.UserMatchInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameMatchInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameMatchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameMatchInfo} GameMatchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameMatchInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameMatchInfo message.
     * @function verify
     * @memberof GameMatchInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameMatchInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        if (message.MatchName != null && message.hasOwnProperty("MatchName"))
            if (!$util.isString(message.MatchName))
                return "MatchName: string expected";
        if (message.SignProAmt != null && message.hasOwnProperty("SignProAmt"))
            if (!$util.isInteger(message.SignProAmt))
                return "SignProAmt: integer expected";
        if (message.SignProType != null && message.hasOwnProperty("SignProType"))
            if (!$util.isInteger(message.SignProType))
                return "SignProType: integer expected";
        if (message.SignCashAmt != null && message.hasOwnProperty("SignCashAmt"))
            if (!$util.isInteger(message.SignCashAmt))
                return "SignCashAmt: integer expected";
        if (message.MaxPlayerAmt != null && message.hasOwnProperty("MaxPlayerAmt"))
            if (!$util.isInteger(message.MaxPlayerAmt))
                return "MaxPlayerAmt: integer expected";
        if (message.MatchDescribe != null && message.hasOwnProperty("MatchDescribe"))
            if (!$util.isString(message.MatchDescribe))
                return "MatchDescribe: string expected";
        if (message.AwardList != null && message.hasOwnProperty("AwardList")) {
            if (!Array.isArray(message.AwardList))
                return "AwardList: array expected";
            for (let i = 0; i < message.AwardList.length; ++i) {
                let error = $root.MatchAwardInfo.verify(message.AwardList[i]);
                if (error)
                    return "AwardList." + error;
            }
        }
        if (message.SignEndTime != null && message.hasOwnProperty("SignEndTime"))
            if (!$util.isInteger(message.SignEndTime) && !(message.SignEndTime && $util.isInteger(message.SignEndTime.low) && $util.isInteger(message.SignEndTime.high)))
                return "SignEndTime: integer|Long expected";
        if (message.MatchStartTime != null && message.hasOwnProperty("MatchStartTime"))
            if (!$util.isInteger(message.MatchStartTime) && !(message.MatchStartTime && $util.isInteger(message.MatchStartTime.low) && $util.isInteger(message.MatchStartTime.high)))
                return "MatchStartTime: integer|Long expected";
        if (message.EnterPeriod != null && message.hasOwnProperty("EnterPeriod"))
            if (!$util.isInteger(message.EnterPeriod))
                return "EnterPeriod: integer expected";
        if (message.ReSignPeriod != null && message.hasOwnProperty("ReSignPeriod"))
            if (!$util.isInteger(message.ReSignPeriod))
                return "ReSignPeriod: integer expected";
        if (message.AddBootPeriod != null && message.hasOwnProperty("AddBootPeriod"))
            if (!$util.isInteger(message.AddBootPeriod))
                return "AddBootPeriod: integer expected";
        if (message.KickOutPlayer != null && message.hasOwnProperty("KickOutPlayer"))
            if (!$util.isInteger(message.KickOutPlayer))
                return "KickOutPlayer: integer expected";
        if (message.MatchSchedule != null && message.hasOwnProperty("MatchSchedule")) {
            let error = $root.MatchScheduleInfo.verify(message.MatchSchedule);
            if (error)
                return "MatchSchedule." + error;
        }
        if (message.SignFlag != null && message.hasOwnProperty("SignFlag"))
            if (!$util.isInteger(message.SignFlag))
                return "SignFlag: integer expected";
        if (message.UserMatch != null && message.hasOwnProperty("UserMatch")) {
            let error = $root.UserMatchInfo.verify(message.UserMatch);
            if (error)
                return "UserMatch." + error;
        }
        return null;
    };

    /**
     * Creates a GameMatchInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameMatchInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameMatchInfo} GameMatchInfo
     */
    GameMatchInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GameMatchInfo)
            return object;
        let message = new $root.GameMatchInfo();
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        if (object.MatchName != null)
            message.MatchName = String(object.MatchName);
        if (object.SignProAmt != null)
            message.SignProAmt = object.SignProAmt >>> 0;
        if (object.SignProType != null)
            message.SignProType = object.SignProType >>> 0;
        if (object.SignCashAmt != null)
            message.SignCashAmt = object.SignCashAmt >>> 0;
        if (object.MaxPlayerAmt != null)
            message.MaxPlayerAmt = object.MaxPlayerAmt >>> 0;
        if (object.MatchDescribe != null)
            message.MatchDescribe = String(object.MatchDescribe);
        if (object.AwardList) {
            if (!Array.isArray(object.AwardList))
                throw TypeError(".GameMatchInfo.AwardList: array expected");
            message.AwardList = [];
            for (let i = 0; i < object.AwardList.length; ++i) {
                if (typeof object.AwardList[i] !== "object")
                    throw TypeError(".GameMatchInfo.AwardList: object expected");
                message.AwardList[i] = $root.MatchAwardInfo.fromObject(object.AwardList[i]);
            }
        }
        if (object.SignEndTime != null)
            if ($util.Long)
                (message.SignEndTime = $util.Long.fromValue(object.SignEndTime)).unsigned = true;
            else if (typeof object.SignEndTime === "string")
                message.SignEndTime = parseInt(object.SignEndTime, 10);
            else if (typeof object.SignEndTime === "number")
                message.SignEndTime = object.SignEndTime;
            else if (typeof object.SignEndTime === "object")
                message.SignEndTime = new $util.LongBits(object.SignEndTime.low >>> 0, object.SignEndTime.high >>> 0).toNumber(true);
        if (object.MatchStartTime != null)
            if ($util.Long)
                (message.MatchStartTime = $util.Long.fromValue(object.MatchStartTime)).unsigned = true;
            else if (typeof object.MatchStartTime === "string")
                message.MatchStartTime = parseInt(object.MatchStartTime, 10);
            else if (typeof object.MatchStartTime === "number")
                message.MatchStartTime = object.MatchStartTime;
            else if (typeof object.MatchStartTime === "object")
                message.MatchStartTime = new $util.LongBits(object.MatchStartTime.low >>> 0, object.MatchStartTime.high >>> 0).toNumber(true);
        if (object.EnterPeriod != null)
            message.EnterPeriod = object.EnterPeriod >>> 0;
        if (object.ReSignPeriod != null)
            message.ReSignPeriod = object.ReSignPeriod >>> 0;
        if (object.AddBootPeriod != null)
            message.AddBootPeriod = object.AddBootPeriod >>> 0;
        if (object.KickOutPlayer != null)
            message.KickOutPlayer = object.KickOutPlayer >>> 0;
        if (object.MatchSchedule != null) {
            if (typeof object.MatchSchedule !== "object")
                throw TypeError(".GameMatchInfo.MatchSchedule: object expected");
            message.MatchSchedule = $root.MatchScheduleInfo.fromObject(object.MatchSchedule);
        }
        if (object.SignFlag != null)
            message.SignFlag = object.SignFlag >>> 0;
        if (object.UserMatch != null) {
            if (typeof object.UserMatch !== "object")
                throw TypeError(".GameMatchInfo.UserMatch: object expected");
            message.UserMatch = $root.UserMatchInfo.fromObject(object.UserMatch);
        }
        return message;
    };

    /**
     * Creates a plain object from a GameMatchInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameMatchInfo
     * @static
     * @param {GameMatchInfo} message GameMatchInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameMatchInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.AwardList = [];
        if (options.defaults) {
            object.GameID = 0;
            object.ProductID = 0;
            object.MatchID = 0;
            object.MatchName = "";
            object.SignProAmt = 0;
            object.SignProType = 0;
            object.SignCashAmt = 0;
            object.MaxPlayerAmt = 0;
            object.MatchDescribe = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.SignEndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SignEndTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.MatchStartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.MatchStartTime = options.longs === String ? "0" : 0;
            object.EnterPeriod = 0;
            object.ReSignPeriod = 0;
            object.AddBootPeriod = 0;
            object.KickOutPlayer = 0;
            object.MatchSchedule = null;
            object.SignFlag = 0;
            object.UserMatch = null;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        if (message.MatchName != null && message.hasOwnProperty("MatchName"))
            object.MatchName = message.MatchName;
        if (message.SignProAmt != null && message.hasOwnProperty("SignProAmt"))
            object.SignProAmt = message.SignProAmt;
        if (message.SignProType != null && message.hasOwnProperty("SignProType"))
            object.SignProType = message.SignProType;
        if (message.SignCashAmt != null && message.hasOwnProperty("SignCashAmt"))
            object.SignCashAmt = message.SignCashAmt;
        if (message.MaxPlayerAmt != null && message.hasOwnProperty("MaxPlayerAmt"))
            object.MaxPlayerAmt = message.MaxPlayerAmt;
        if (message.MatchDescribe != null && message.hasOwnProperty("MatchDescribe"))
            object.MatchDescribe = message.MatchDescribe;
        if (message.AwardList && message.AwardList.length) {
            object.AwardList = [];
            for (let j = 0; j < message.AwardList.length; ++j)
                object.AwardList[j] = $root.MatchAwardInfo.toObject(message.AwardList[j], options);
        }
        if (message.SignEndTime != null && message.hasOwnProperty("SignEndTime"))
            if (typeof message.SignEndTime === "number")
                object.SignEndTime = options.longs === String ? String(message.SignEndTime) : message.SignEndTime;
            else
                object.SignEndTime = options.longs === String ? $util.Long.prototype.toString.call(message.SignEndTime) : options.longs === Number ? new $util.LongBits(message.SignEndTime.low >>> 0, message.SignEndTime.high >>> 0).toNumber(true) : message.SignEndTime;
        if (message.MatchStartTime != null && message.hasOwnProperty("MatchStartTime"))
            if (typeof message.MatchStartTime === "number")
                object.MatchStartTime = options.longs === String ? String(message.MatchStartTime) : message.MatchStartTime;
            else
                object.MatchStartTime = options.longs === String ? $util.Long.prototype.toString.call(message.MatchStartTime) : options.longs === Number ? new $util.LongBits(message.MatchStartTime.low >>> 0, message.MatchStartTime.high >>> 0).toNumber(true) : message.MatchStartTime;
        if (message.EnterPeriod != null && message.hasOwnProperty("EnterPeriod"))
            object.EnterPeriod = message.EnterPeriod;
        if (message.ReSignPeriod != null && message.hasOwnProperty("ReSignPeriod"))
            object.ReSignPeriod = message.ReSignPeriod;
        if (message.AddBootPeriod != null && message.hasOwnProperty("AddBootPeriod"))
            object.AddBootPeriod = message.AddBootPeriod;
        if (message.KickOutPlayer != null && message.hasOwnProperty("KickOutPlayer"))
            object.KickOutPlayer = message.KickOutPlayer;
        if (message.MatchSchedule != null && message.hasOwnProperty("MatchSchedule"))
            object.MatchSchedule = $root.MatchScheduleInfo.toObject(message.MatchSchedule, options);
        if (message.SignFlag != null && message.hasOwnProperty("SignFlag"))
            object.SignFlag = message.SignFlag;
        if (message.UserMatch != null && message.hasOwnProperty("UserMatch"))
            object.UserMatch = $root.UserMatchInfo.toObject(message.UserMatch, options);
        return object;
    };

    /**
     * Converts this GameMatchInfo to JSON.
     * @function toJSON
     * @memberof GameMatchInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameMatchInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameMatchInfo
     * @function getTypeUrl
     * @memberof GameMatchInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameMatchInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameMatchInfo";
    };

    return GameMatchInfo;
})();

export const GameToAccSrvReqMatchGoldChange = $root.GameToAccSrvReqMatchGoldChange = (() => {

    /**
     * Properties of a GameToAccSrvReqMatchGoldChange.
     * @exports IGameToAccSrvReqMatchGoldChange
     * @interface IGameToAccSrvReqMatchGoldChange
     * @property {number|null} [UserID] GameToAccSrvReqMatchGoldChange UserID
     * @property {number|null} [GameID] GameToAccSrvReqMatchGoldChange GameID
     * @property {number|null} [ProductID] GameToAccSrvReqMatchGoldChange ProductID
     * @property {number|null} [MatchId] GameToAccSrvReqMatchGoldChange MatchId
     * @property {string|null} [GoldChange] GameToAccSrvReqMatchGoldChange GoldChange
     * @property {string|null} [ProChange] GameToAccSrvReqMatchGoldChange ProChange
     * @property {number|null} [ProType] GameToAccSrvReqMatchGoldChange ProType
     * @property {number|null} [ChangeType] GameToAccSrvReqMatchGoldChange ChangeType
     * @property {string|null} [BonusChange] GameToAccSrvReqMatchGoldChange BonusChange
     * @property {string|null} [DepositChange] GameToAccSrvReqMatchGoldChange DepositChange
     * @property {string|null} [WithdrawChange] GameToAccSrvReqMatchGoldChange WithdrawChange
     */

    /**
     * Constructs a new GameToAccSrvReqMatchGoldChange.
     * @exports GameToAccSrvReqMatchGoldChange
     * @classdesc Represents a GameToAccSrvReqMatchGoldChange.
     * @implements IGameToAccSrvReqMatchGoldChange
     * @constructor
     * @param {IGameToAccSrvReqMatchGoldChange=} [properties] Properties to set
     */
    function GameToAccSrvReqMatchGoldChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvReqMatchGoldChange UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.UserID = 0;

    /**
     * GameToAccSrvReqMatchGoldChange GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.GameID = 0;

    /**
     * GameToAccSrvReqMatchGoldChange ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.ProductID = 0;

    /**
     * GameToAccSrvReqMatchGoldChange MatchId.
     * @member {number} MatchId
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.MatchId = 0;

    /**
     * GameToAccSrvReqMatchGoldChange GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.GoldChange = "";

    /**
     * GameToAccSrvReqMatchGoldChange ProChange.
     * @member {string} ProChange
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.ProChange = "";

    /**
     * GameToAccSrvReqMatchGoldChange ProType.
     * @member {number} ProType
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.ProType = 0;

    /**
     * GameToAccSrvReqMatchGoldChange ChangeType.
     * @member {number} ChangeType
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.ChangeType = 0;

    /**
     * GameToAccSrvReqMatchGoldChange BonusChange.
     * @member {string} BonusChange
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.BonusChange = "";

    /**
     * GameToAccSrvReqMatchGoldChange DepositChange.
     * @member {string} DepositChange
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.DepositChange = "";

    /**
     * GameToAccSrvReqMatchGoldChange WithdrawChange.
     * @member {string} WithdrawChange
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     */
    GameToAccSrvReqMatchGoldChange.prototype.WithdrawChange = "";

    /**
     * Creates a new GameToAccSrvReqMatchGoldChange instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {IGameToAccSrvReqMatchGoldChange=} [properties] Properties to set
     * @returns {GameToAccSrvReqMatchGoldChange} GameToAccSrvReqMatchGoldChange instance
     */
    GameToAccSrvReqMatchGoldChange.create = function create(properties) {
        return new GameToAccSrvReqMatchGoldChange(properties);
    };

    /**
     * Encodes the specified GameToAccSrvReqMatchGoldChange message. Does not implicitly {@link GameToAccSrvReqMatchGoldChange.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {IGameToAccSrvReqMatchGoldChange} message GameToAccSrvReqMatchGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqMatchGoldChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.MatchId != null && Object.hasOwnProperty.call(message, "MatchId"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MatchId);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.GoldChange);
        if (message.ProChange != null && Object.hasOwnProperty.call(message, "ProChange"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ProChange);
        if (message.ProType != null && Object.hasOwnProperty.call(message, "ProType"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.ProType);
        if (message.ChangeType != null && Object.hasOwnProperty.call(message, "ChangeType"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.ChangeType);
        if (message.BonusChange != null && Object.hasOwnProperty.call(message, "BonusChange"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.BonusChange);
        if (message.DepositChange != null && Object.hasOwnProperty.call(message, "DepositChange"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.DepositChange);
        if (message.WithdrawChange != null && Object.hasOwnProperty.call(message, "WithdrawChange"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.WithdrawChange);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvReqMatchGoldChange message, length delimited. Does not implicitly {@link GameToAccSrvReqMatchGoldChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {IGameToAccSrvReqMatchGoldChange} message GameToAccSrvReqMatchGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvReqMatchGoldChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvReqMatchGoldChange message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvReqMatchGoldChange} GameToAccSrvReqMatchGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqMatchGoldChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvReqMatchGoldChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.MatchId = reader.uint32();
                    break;
                }
            case 5: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 6: {
                    message.ProChange = reader.string();
                    break;
                }
            case 7: {
                    message.ProType = reader.uint32();
                    break;
                }
            case 8: {
                    message.ChangeType = reader.uint32();
                    break;
                }
            case 9: {
                    message.BonusChange = reader.string();
                    break;
                }
            case 10: {
                    message.DepositChange = reader.string();
                    break;
                }
            case 11: {
                    message.WithdrawChange = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvReqMatchGoldChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvReqMatchGoldChange} GameToAccSrvReqMatchGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvReqMatchGoldChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvReqMatchGoldChange message.
     * @function verify
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvReqMatchGoldChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.MatchId != null && message.hasOwnProperty("MatchId"))
            if (!$util.isInteger(message.MatchId))
                return "MatchId: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.ProChange != null && message.hasOwnProperty("ProChange"))
            if (!$util.isString(message.ProChange))
                return "ProChange: string expected";
        if (message.ProType != null && message.hasOwnProperty("ProType"))
            if (!$util.isInteger(message.ProType))
                return "ProType: integer expected";
        if (message.ChangeType != null && message.hasOwnProperty("ChangeType"))
            if (!$util.isInteger(message.ChangeType))
                return "ChangeType: integer expected";
        if (message.BonusChange != null && message.hasOwnProperty("BonusChange"))
            if (!$util.isString(message.BonusChange))
                return "BonusChange: string expected";
        if (message.DepositChange != null && message.hasOwnProperty("DepositChange"))
            if (!$util.isString(message.DepositChange))
                return "DepositChange: string expected";
        if (message.WithdrawChange != null && message.hasOwnProperty("WithdrawChange"))
            if (!$util.isString(message.WithdrawChange))
                return "WithdrawChange: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvReqMatchGoldChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvReqMatchGoldChange} GameToAccSrvReqMatchGoldChange
     */
    GameToAccSrvReqMatchGoldChange.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvReqMatchGoldChange)
            return object;
        let message = new $root.GameToAccSrvReqMatchGoldChange();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.MatchId != null)
            message.MatchId = object.MatchId >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.ProChange != null)
            message.ProChange = String(object.ProChange);
        if (object.ProType != null)
            message.ProType = object.ProType >>> 0;
        if (object.ChangeType != null)
            message.ChangeType = object.ChangeType >>> 0;
        if (object.BonusChange != null)
            message.BonusChange = String(object.BonusChange);
        if (object.DepositChange != null)
            message.DepositChange = String(object.DepositChange);
        if (object.WithdrawChange != null)
            message.WithdrawChange = String(object.WithdrawChange);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvReqMatchGoldChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {GameToAccSrvReqMatchGoldChange} message GameToAccSrvReqMatchGoldChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvReqMatchGoldChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.MatchId = 0;
            object.GoldChange = "";
            object.ProChange = "";
            object.ProType = 0;
            object.ChangeType = 0;
            object.BonusChange = "";
            object.DepositChange = "";
            object.WithdrawChange = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.MatchId != null && message.hasOwnProperty("MatchId"))
            object.MatchId = message.MatchId;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.ProChange != null && message.hasOwnProperty("ProChange"))
            object.ProChange = message.ProChange;
        if (message.ProType != null && message.hasOwnProperty("ProType"))
            object.ProType = message.ProType;
        if (message.ChangeType != null && message.hasOwnProperty("ChangeType"))
            object.ChangeType = message.ChangeType;
        if (message.BonusChange != null && message.hasOwnProperty("BonusChange"))
            object.BonusChange = message.BonusChange;
        if (message.DepositChange != null && message.hasOwnProperty("DepositChange"))
            object.DepositChange = message.DepositChange;
        if (message.WithdrawChange != null && message.hasOwnProperty("WithdrawChange"))
            object.WithdrawChange = message.WithdrawChange;
        return object;
    };

    /**
     * Converts this GameToAccSrvReqMatchGoldChange to JSON.
     * @function toJSON
     * @memberof GameToAccSrvReqMatchGoldChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvReqMatchGoldChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvReqMatchGoldChange
     * @function getTypeUrl
     * @memberof GameToAccSrvReqMatchGoldChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvReqMatchGoldChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvReqMatchGoldChange";
    };

    return GameToAccSrvReqMatchGoldChange;
})();

export const PushPlayerStatus = $root.PushPlayerStatus = (() => {

    /**
     * Properties of a PushPlayerStatus.
     * @exports IPushPlayerStatus
     * @interface IPushPlayerStatus
     * @property {number|null} [UserID] PushPlayerStatus UserID
     * @property {number|null} [GameID] PushPlayerStatus GameID
     * @property {number|null} [Status] PushPlayerStatus Status
     */

    /**
     * Constructs a new PushPlayerStatus.
     * @exports PushPlayerStatus
     * @classdesc Represents a PushPlayerStatus.
     * @implements IPushPlayerStatus
     * @constructor
     * @param {IPushPlayerStatus=} [properties] Properties to set
     */
    function PushPlayerStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PushPlayerStatus UserID.
     * @member {number} UserID
     * @memberof PushPlayerStatus
     * @instance
     */
    PushPlayerStatus.prototype.UserID = 0;

    /**
     * PushPlayerStatus GameID.
     * @member {number} GameID
     * @memberof PushPlayerStatus
     * @instance
     */
    PushPlayerStatus.prototype.GameID = 0;

    /**
     * PushPlayerStatus Status.
     * @member {number} Status
     * @memberof PushPlayerStatus
     * @instance
     */
    PushPlayerStatus.prototype.Status = 0;

    /**
     * Creates a new PushPlayerStatus instance using the specified properties.
     * @function create
     * @memberof PushPlayerStatus
     * @static
     * @param {IPushPlayerStatus=} [properties] Properties to set
     * @returns {PushPlayerStatus} PushPlayerStatus instance
     */
    PushPlayerStatus.create = function create(properties) {
        return new PushPlayerStatus(properties);
    };

    /**
     * Encodes the specified PushPlayerStatus message. Does not implicitly {@link PushPlayerStatus.verify|verify} messages.
     * @function encode
     * @memberof PushPlayerStatus
     * @static
     * @param {IPushPlayerStatus} message PushPlayerStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushPlayerStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Status);
        return writer;
    };

    /**
     * Encodes the specified PushPlayerStatus message, length delimited. Does not implicitly {@link PushPlayerStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PushPlayerStatus
     * @static
     * @param {IPushPlayerStatus} message PushPlayerStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushPlayerStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PushPlayerStatus message from the specified reader or buffer.
     * @function decode
     * @memberof PushPlayerStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PushPlayerStatus} PushPlayerStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushPlayerStatus.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PushPlayerStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Status = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PushPlayerStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PushPlayerStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PushPlayerStatus} PushPlayerStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushPlayerStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PushPlayerStatus message.
     * @function verify
     * @memberof PushPlayerStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PushPlayerStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.Status != null && message.hasOwnProperty("Status"))
            if (!$util.isInteger(message.Status))
                return "Status: integer expected";
        return null;
    };

    /**
     * Creates a PushPlayerStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PushPlayerStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PushPlayerStatus} PushPlayerStatus
     */
    PushPlayerStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.PushPlayerStatus)
            return object;
        let message = new $root.PushPlayerStatus();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.Status != null)
            message.Status = object.Status >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PushPlayerStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PushPlayerStatus
     * @static
     * @param {PushPlayerStatus} message PushPlayerStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PushPlayerStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.Status = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.Status != null && message.hasOwnProperty("Status"))
            object.Status = message.Status;
        return object;
    };

    /**
     * Converts this PushPlayerStatus to JSON.
     * @function toJSON
     * @memberof PushPlayerStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PushPlayerStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PushPlayerStatus
     * @function getTypeUrl
     * @memberof PushPlayerStatus
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PushPlayerStatus.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PushPlayerStatus";
    };

    return PushPlayerStatus;
})();

export const PushGameJackPot = $root.PushGameJackPot = (() => {

    /**
     * Properties of a PushGameJackPot.
     * @exports IPushGameJackPot
     * @interface IPushGameJackPot
     * @property {number|null} [UserID] PushGameJackPot UserID
     * @property {number|null} [GameID] PushGameJackPot GameID
     * @property {number|Long|null} [JackPot] PushGameJackPot JackPot
     */

    /**
     * Constructs a new PushGameJackPot.
     * @exports PushGameJackPot
     * @classdesc Represents a PushGameJackPot.
     * @implements IPushGameJackPot
     * @constructor
     * @param {IPushGameJackPot=} [properties] Properties to set
     */
    function PushGameJackPot(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PushGameJackPot UserID.
     * @member {number} UserID
     * @memberof PushGameJackPot
     * @instance
     */
    PushGameJackPot.prototype.UserID = 0;

    /**
     * PushGameJackPot GameID.
     * @member {number} GameID
     * @memberof PushGameJackPot
     * @instance
     */
    PushGameJackPot.prototype.GameID = 0;

    /**
     * PushGameJackPot JackPot.
     * @member {number|Long} JackPot
     * @memberof PushGameJackPot
     * @instance
     */
    PushGameJackPot.prototype.JackPot = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new PushGameJackPot instance using the specified properties.
     * @function create
     * @memberof PushGameJackPot
     * @static
     * @param {IPushGameJackPot=} [properties] Properties to set
     * @returns {PushGameJackPot} PushGameJackPot instance
     */
    PushGameJackPot.create = function create(properties) {
        return new PushGameJackPot(properties);
    };

    /**
     * Encodes the specified PushGameJackPot message. Does not implicitly {@link PushGameJackPot.verify|verify} messages.
     * @function encode
     * @memberof PushGameJackPot
     * @static
     * @param {IPushGameJackPot} message PushGameJackPot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushGameJackPot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.JackPot != null && Object.hasOwnProperty.call(message, "JackPot"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.JackPot);
        return writer;
    };

    /**
     * Encodes the specified PushGameJackPot message, length delimited. Does not implicitly {@link PushGameJackPot.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PushGameJackPot
     * @static
     * @param {IPushGameJackPot} message PushGameJackPot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushGameJackPot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PushGameJackPot message from the specified reader or buffer.
     * @function decode
     * @memberof PushGameJackPot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PushGameJackPot} PushGameJackPot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushGameJackPot.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PushGameJackPot();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.JackPot = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PushGameJackPot message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PushGameJackPot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PushGameJackPot} PushGameJackPot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushGameJackPot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PushGameJackPot message.
     * @function verify
     * @memberof PushGameJackPot
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PushGameJackPot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.JackPot != null && message.hasOwnProperty("JackPot"))
            if (!$util.isInteger(message.JackPot) && !(message.JackPot && $util.isInteger(message.JackPot.low) && $util.isInteger(message.JackPot.high)))
                return "JackPot: integer|Long expected";
        return null;
    };

    /**
     * Creates a PushGameJackPot message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PushGameJackPot
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PushGameJackPot} PushGameJackPot
     */
    PushGameJackPot.fromObject = function fromObject(object) {
        if (object instanceof $root.PushGameJackPot)
            return object;
        let message = new $root.PushGameJackPot();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.JackPot != null)
            if ($util.Long)
                (message.JackPot = $util.Long.fromValue(object.JackPot)).unsigned = false;
            else if (typeof object.JackPot === "string")
                message.JackPot = parseInt(object.JackPot, 10);
            else if (typeof object.JackPot === "number")
                message.JackPot = object.JackPot;
            else if (typeof object.JackPot === "object")
                message.JackPot = new $util.LongBits(object.JackPot.low >>> 0, object.JackPot.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a PushGameJackPot message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PushGameJackPot
     * @static
     * @param {PushGameJackPot} message PushGameJackPot
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PushGameJackPot.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.JackPot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.JackPot = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.JackPot != null && message.hasOwnProperty("JackPot"))
            if (typeof message.JackPot === "number")
                object.JackPot = options.longs === String ? String(message.JackPot) : message.JackPot;
            else
                object.JackPot = options.longs === String ? $util.Long.prototype.toString.call(message.JackPot) : options.longs === Number ? new $util.LongBits(message.JackPot.low >>> 0, message.JackPot.high >>> 0).toNumber() : message.JackPot;
        return object;
    };

    /**
     * Converts this PushGameJackPot to JSON.
     * @function toJSON
     * @memberof PushGameJackPot
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PushGameJackPot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PushGameJackPot
     * @function getTypeUrl
     * @memberof PushGameJackPot
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PushGameJackPot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PushGameJackPot";
    };

    return PushGameJackPot;
})();

export const GameToAccSrvAckMatchGoldChange = $root.GameToAccSrvAckMatchGoldChange = (() => {

    /**
     * Properties of a GameToAccSrvAckMatchGoldChange.
     * @exports IGameToAccSrvAckMatchGoldChange
     * @interface IGameToAccSrvAckMatchGoldChange
     * @property {number|null} [Res] GameToAccSrvAckMatchGoldChange Res
     * @property {number|null} [UserID] GameToAccSrvAckMatchGoldChange UserID
     * @property {number|null} [GameID] GameToAccSrvAckMatchGoldChange GameID
     * @property {number|null} [ProductID] GameToAccSrvAckMatchGoldChange ProductID
     * @property {number|null} [MatchId] GameToAccSrvAckMatchGoldChange MatchId
     * @property {string|null} [GoldChange] GameToAccSrvAckMatchGoldChange GoldChange
     * @property {string|null} [ProChange] GameToAccSrvAckMatchGoldChange ProChange
     * @property {number|null} [ProType] GameToAccSrvAckMatchGoldChange ProType
     * @property {number|null} [ChangeType] GameToAccSrvAckMatchGoldChange ChangeType
     * @property {string|null} [BonusChange] GameToAccSrvAckMatchGoldChange BonusChange
     * @property {string|null} [DepositChange] GameToAccSrvAckMatchGoldChange DepositChange
     * @property {string|null} [WithdrawChange] GameToAccSrvAckMatchGoldChange WithdrawChange
     */

    /**
     * Constructs a new GameToAccSrvAckMatchGoldChange.
     * @exports GameToAccSrvAckMatchGoldChange
     * @classdesc Represents a GameToAccSrvAckMatchGoldChange.
     * @implements IGameToAccSrvAckMatchGoldChange
     * @constructor
     * @param {IGameToAccSrvAckMatchGoldChange=} [properties] Properties to set
     */
    function GameToAccSrvAckMatchGoldChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameToAccSrvAckMatchGoldChange Res.
     * @member {number} Res
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.Res = 0;

    /**
     * GameToAccSrvAckMatchGoldChange UserID.
     * @member {number} UserID
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.UserID = 0;

    /**
     * GameToAccSrvAckMatchGoldChange GameID.
     * @member {number} GameID
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.GameID = 0;

    /**
     * GameToAccSrvAckMatchGoldChange ProductID.
     * @member {number} ProductID
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.ProductID = 0;

    /**
     * GameToAccSrvAckMatchGoldChange MatchId.
     * @member {number} MatchId
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.MatchId = 0;

    /**
     * GameToAccSrvAckMatchGoldChange GoldChange.
     * @member {string} GoldChange
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.GoldChange = "";

    /**
     * GameToAccSrvAckMatchGoldChange ProChange.
     * @member {string} ProChange
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.ProChange = "";

    /**
     * GameToAccSrvAckMatchGoldChange ProType.
     * @member {number} ProType
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.ProType = 0;

    /**
     * GameToAccSrvAckMatchGoldChange ChangeType.
     * @member {number} ChangeType
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.ChangeType = 0;

    /**
     * GameToAccSrvAckMatchGoldChange BonusChange.
     * @member {string} BonusChange
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.BonusChange = "";

    /**
     * GameToAccSrvAckMatchGoldChange DepositChange.
     * @member {string} DepositChange
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.DepositChange = "";

    /**
     * GameToAccSrvAckMatchGoldChange WithdrawChange.
     * @member {string} WithdrawChange
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     */
    GameToAccSrvAckMatchGoldChange.prototype.WithdrawChange = "";

    /**
     * Creates a new GameToAccSrvAckMatchGoldChange instance using the specified properties.
     * @function create
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {IGameToAccSrvAckMatchGoldChange=} [properties] Properties to set
     * @returns {GameToAccSrvAckMatchGoldChange} GameToAccSrvAckMatchGoldChange instance
     */
    GameToAccSrvAckMatchGoldChange.create = function create(properties) {
        return new GameToAccSrvAckMatchGoldChange(properties);
    };

    /**
     * Encodes the specified GameToAccSrvAckMatchGoldChange message. Does not implicitly {@link GameToAccSrvAckMatchGoldChange.verify|verify} messages.
     * @function encode
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {IGameToAccSrvAckMatchGoldChange} message GameToAccSrvAckMatchGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckMatchGoldChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.MatchId != null && Object.hasOwnProperty.call(message, "MatchId"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.MatchId);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.GoldChange);
        if (message.ProChange != null && Object.hasOwnProperty.call(message, "ProChange"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ProChange);
        if (message.ProType != null && Object.hasOwnProperty.call(message, "ProType"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.ProType);
        if (message.ChangeType != null && Object.hasOwnProperty.call(message, "ChangeType"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.ChangeType);
        if (message.BonusChange != null && Object.hasOwnProperty.call(message, "BonusChange"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.BonusChange);
        if (message.DepositChange != null && Object.hasOwnProperty.call(message, "DepositChange"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.DepositChange);
        if (message.WithdrawChange != null && Object.hasOwnProperty.call(message, "WithdrawChange"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.WithdrawChange);
        return writer;
    };

    /**
     * Encodes the specified GameToAccSrvAckMatchGoldChange message, length delimited. Does not implicitly {@link GameToAccSrvAckMatchGoldChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {IGameToAccSrvAckMatchGoldChange} message GameToAccSrvAckMatchGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameToAccSrvAckMatchGoldChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameToAccSrvAckMatchGoldChange message from the specified reader or buffer.
     * @function decode
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameToAccSrvAckMatchGoldChange} GameToAccSrvAckMatchGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckMatchGoldChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameToAccSrvAckMatchGoldChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.MatchId = reader.uint32();
                    break;
                }
            case 6: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 7: {
                    message.ProChange = reader.string();
                    break;
                }
            case 8: {
                    message.ProType = reader.uint32();
                    break;
                }
            case 9: {
                    message.ChangeType = reader.uint32();
                    break;
                }
            case 10: {
                    message.BonusChange = reader.string();
                    break;
                }
            case 11: {
                    message.DepositChange = reader.string();
                    break;
                }
            case 12: {
                    message.WithdrawChange = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameToAccSrvAckMatchGoldChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameToAccSrvAckMatchGoldChange} GameToAccSrvAckMatchGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameToAccSrvAckMatchGoldChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameToAccSrvAckMatchGoldChange message.
     * @function verify
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameToAccSrvAckMatchGoldChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.MatchId != null && message.hasOwnProperty("MatchId"))
            if (!$util.isInteger(message.MatchId))
                return "MatchId: integer expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.ProChange != null && message.hasOwnProperty("ProChange"))
            if (!$util.isString(message.ProChange))
                return "ProChange: string expected";
        if (message.ProType != null && message.hasOwnProperty("ProType"))
            if (!$util.isInteger(message.ProType))
                return "ProType: integer expected";
        if (message.ChangeType != null && message.hasOwnProperty("ChangeType"))
            if (!$util.isInteger(message.ChangeType))
                return "ChangeType: integer expected";
        if (message.BonusChange != null && message.hasOwnProperty("BonusChange"))
            if (!$util.isString(message.BonusChange))
                return "BonusChange: string expected";
        if (message.DepositChange != null && message.hasOwnProperty("DepositChange"))
            if (!$util.isString(message.DepositChange))
                return "DepositChange: string expected";
        if (message.WithdrawChange != null && message.hasOwnProperty("WithdrawChange"))
            if (!$util.isString(message.WithdrawChange))
                return "WithdrawChange: string expected";
        return null;
    };

    /**
     * Creates a GameToAccSrvAckMatchGoldChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameToAccSrvAckMatchGoldChange} GameToAccSrvAckMatchGoldChange
     */
    GameToAccSrvAckMatchGoldChange.fromObject = function fromObject(object) {
        if (object instanceof $root.GameToAccSrvAckMatchGoldChange)
            return object;
        let message = new $root.GameToAccSrvAckMatchGoldChange();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.MatchId != null)
            message.MatchId = object.MatchId >>> 0;
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.ProChange != null)
            message.ProChange = String(object.ProChange);
        if (object.ProType != null)
            message.ProType = object.ProType >>> 0;
        if (object.ChangeType != null)
            message.ChangeType = object.ChangeType >>> 0;
        if (object.BonusChange != null)
            message.BonusChange = String(object.BonusChange);
        if (object.DepositChange != null)
            message.DepositChange = String(object.DepositChange);
        if (object.WithdrawChange != null)
            message.WithdrawChange = String(object.WithdrawChange);
        return message;
    };

    /**
     * Creates a plain object from a GameToAccSrvAckMatchGoldChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {GameToAccSrvAckMatchGoldChange} message GameToAccSrvAckMatchGoldChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameToAccSrvAckMatchGoldChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.MatchId = 0;
            object.GoldChange = "";
            object.ProChange = "";
            object.ProType = 0;
            object.ChangeType = 0;
            object.BonusChange = "";
            object.DepositChange = "";
            object.WithdrawChange = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.MatchId != null && message.hasOwnProperty("MatchId"))
            object.MatchId = message.MatchId;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.ProChange != null && message.hasOwnProperty("ProChange"))
            object.ProChange = message.ProChange;
        if (message.ProType != null && message.hasOwnProperty("ProType"))
            object.ProType = message.ProType;
        if (message.ChangeType != null && message.hasOwnProperty("ChangeType"))
            object.ChangeType = message.ChangeType;
        if (message.BonusChange != null && message.hasOwnProperty("BonusChange"))
            object.BonusChange = message.BonusChange;
        if (message.DepositChange != null && message.hasOwnProperty("DepositChange"))
            object.DepositChange = message.DepositChange;
        if (message.WithdrawChange != null && message.hasOwnProperty("WithdrawChange"))
            object.WithdrawChange = message.WithdrawChange;
        return object;
    };

    /**
     * Converts this GameToAccSrvAckMatchGoldChange to JSON.
     * @function toJSON
     * @memberof GameToAccSrvAckMatchGoldChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameToAccSrvAckMatchGoldChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameToAccSrvAckMatchGoldChange
     * @function getTypeUrl
     * @memberof GameToAccSrvAckMatchGoldChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameToAccSrvAckMatchGoldChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameToAccSrvAckMatchGoldChange";
    };

    return GameToAccSrvAckMatchGoldChange;
})();

export const DeskToGameSrvMatchParam = $root.DeskToGameSrvMatchParam = (() => {

    /**
     * Properties of a DeskToGameSrvMatchParam.
     * @exports IDeskToGameSrvMatchParam
     * @interface IDeskToGameSrvMatchParam
     * @property {number|null} [DeskNo] DeskToGameSrvMatchParam DeskNo
     * @property {number|null} [BootScore] DeskToGameSrvMatchParam BootScore
     * @property {number|null} [WinBot] DeskToGameSrvMatchParam WinBot
     * @property {string|null} [UserList] DeskToGameSrvMatchParam UserList
     */

    /**
     * Constructs a new DeskToGameSrvMatchParam.
     * @exports DeskToGameSrvMatchParam
     * @classdesc Represents a DeskToGameSrvMatchParam.
     * @implements IDeskToGameSrvMatchParam
     * @constructor
     * @param {IDeskToGameSrvMatchParam=} [properties] Properties to set
     */
    function DeskToGameSrvMatchParam(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvMatchParam DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvMatchParam
     * @instance
     */
    DeskToGameSrvMatchParam.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvMatchParam BootScore.
     * @member {number} BootScore
     * @memberof DeskToGameSrvMatchParam
     * @instance
     */
    DeskToGameSrvMatchParam.prototype.BootScore = 0;

    /**
     * DeskToGameSrvMatchParam WinBot.
     * @member {number} WinBot
     * @memberof DeskToGameSrvMatchParam
     * @instance
     */
    DeskToGameSrvMatchParam.prototype.WinBot = 0;

    /**
     * DeskToGameSrvMatchParam UserList.
     * @member {string} UserList
     * @memberof DeskToGameSrvMatchParam
     * @instance
     */
    DeskToGameSrvMatchParam.prototype.UserList = "";

    /**
     * Creates a new DeskToGameSrvMatchParam instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {IDeskToGameSrvMatchParam=} [properties] Properties to set
     * @returns {DeskToGameSrvMatchParam} DeskToGameSrvMatchParam instance
     */
    DeskToGameSrvMatchParam.create = function create(properties) {
        return new DeskToGameSrvMatchParam(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvMatchParam message. Does not implicitly {@link DeskToGameSrvMatchParam.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {IDeskToGameSrvMatchParam} message DeskToGameSrvMatchParam message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvMatchParam.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.BootScore != null && Object.hasOwnProperty.call(message, "BootScore"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.BootScore);
        if (message.WinBot != null && Object.hasOwnProperty.call(message, "WinBot"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.WinBot);
        if (message.UserList != null && Object.hasOwnProperty.call(message, "UserList"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.UserList);
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvMatchParam message, length delimited. Does not implicitly {@link DeskToGameSrvMatchParam.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {IDeskToGameSrvMatchParam} message DeskToGameSrvMatchParam message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvMatchParam.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvMatchParam message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvMatchParam} DeskToGameSrvMatchParam
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvMatchParam.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvMatchParam();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.BootScore = reader.uint32();
                    break;
                }
            case 3: {
                    message.WinBot = reader.uint32();
                    break;
                }
            case 4: {
                    message.UserList = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvMatchParam message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvMatchParam} DeskToGameSrvMatchParam
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvMatchParam.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvMatchParam message.
     * @function verify
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvMatchParam.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.BootScore != null && message.hasOwnProperty("BootScore"))
            if (!$util.isInteger(message.BootScore))
                return "BootScore: integer expected";
        if (message.WinBot != null && message.hasOwnProperty("WinBot"))
            if (!$util.isInteger(message.WinBot))
                return "WinBot: integer expected";
        if (message.UserList != null && message.hasOwnProperty("UserList"))
            if (!$util.isString(message.UserList))
                return "UserList: string expected";
        return null;
    };

    /**
     * Creates a DeskToGameSrvMatchParam message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvMatchParam} DeskToGameSrvMatchParam
     */
    DeskToGameSrvMatchParam.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvMatchParam)
            return object;
        let message = new $root.DeskToGameSrvMatchParam();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.BootScore != null)
            message.BootScore = object.BootScore >>> 0;
        if (object.WinBot != null)
            message.WinBot = object.WinBot >>> 0;
        if (object.UserList != null)
            message.UserList = String(object.UserList);
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvMatchParam message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {DeskToGameSrvMatchParam} message DeskToGameSrvMatchParam
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvMatchParam.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.BootScore = 0;
            object.WinBot = 0;
            object.UserList = "";
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.BootScore != null && message.hasOwnProperty("BootScore"))
            object.BootScore = message.BootScore;
        if (message.WinBot != null && message.hasOwnProperty("WinBot"))
            object.WinBot = message.WinBot;
        if (message.UserList != null && message.hasOwnProperty("UserList"))
            object.UserList = message.UserList;
        return object;
    };

    /**
     * Converts this DeskToGameSrvMatchParam to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvMatchParam
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvMatchParam.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvMatchParam
     * @function getTypeUrl
     * @memberof DeskToGameSrvMatchParam
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvMatchParam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvMatchParam";
    };

    return DeskToGameSrvMatchParam;
})();

export const RummyPlaySuperData = $root.RummyPlaySuperData = (() => {

    /**
     * Properties of a RummyPlaySuperData.
     * @exports IRummyPlaySuperData
     * @interface IRummyPlaySuperData
     * @property {string|null} [RummyGameUserDataInfo] RummyPlaySuperData RummyGameUserDataInfo
     * @property {Array.<number>|null} [HandCard] RummyPlaySuperData HandCard
     */

    /**
     * Constructs a new RummyPlaySuperData.
     * @exports RummyPlaySuperData
     * @classdesc Represents a RummyPlaySuperData.
     * @implements IRummyPlaySuperData
     * @constructor
     * @param {IRummyPlaySuperData=} [properties] Properties to set
     */
    function RummyPlaySuperData(properties) {
        this.HandCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPlaySuperData RummyGameUserDataInfo.
     * @member {string} RummyGameUserDataInfo
     * @memberof RummyPlaySuperData
     * @instance
     */
    RummyPlaySuperData.prototype.RummyGameUserDataInfo = "";

    /**
     * RummyPlaySuperData HandCard.
     * @member {Array.<number>} HandCard
     * @memberof RummyPlaySuperData
     * @instance
     */
    RummyPlaySuperData.prototype.HandCard = $util.emptyArray;

    /**
     * Creates a new RummyPlaySuperData instance using the specified properties.
     * @function create
     * @memberof RummyPlaySuperData
     * @static
     * @param {IRummyPlaySuperData=} [properties] Properties to set
     * @returns {RummyPlaySuperData} RummyPlaySuperData instance
     */
    RummyPlaySuperData.create = function create(properties) {
        return new RummyPlaySuperData(properties);
    };

    /**
     * Encodes the specified RummyPlaySuperData message. Does not implicitly {@link RummyPlaySuperData.verify|verify} messages.
     * @function encode
     * @memberof RummyPlaySuperData
     * @static
     * @param {IRummyPlaySuperData} message RummyPlaySuperData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPlaySuperData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RummyGameUserDataInfo != null && Object.hasOwnProperty.call(message, "RummyGameUserDataInfo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.RummyGameUserDataInfo);
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified RummyPlaySuperData message, length delimited. Does not implicitly {@link RummyPlaySuperData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPlaySuperData
     * @static
     * @param {IRummyPlaySuperData} message RummyPlaySuperData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPlaySuperData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPlaySuperData message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPlaySuperData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPlaySuperData} RummyPlaySuperData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPlaySuperData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPlaySuperData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RummyGameUserDataInfo = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPlaySuperData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPlaySuperData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPlaySuperData} RummyPlaySuperData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPlaySuperData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPlaySuperData message.
     * @function verify
     * @memberof RummyPlaySuperData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPlaySuperData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RummyGameUserDataInfo != null && message.hasOwnProperty("RummyGameUserDataInfo"))
            if (!$util.isString(message.RummyGameUserDataInfo))
                return "RummyGameUserDataInfo: string expected";
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a RummyPlaySuperData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPlaySuperData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPlaySuperData} RummyPlaySuperData
     */
    RummyPlaySuperData.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPlaySuperData)
            return object;
        let message = new $root.RummyPlaySuperData();
        if (object.RummyGameUserDataInfo != null)
            message.RummyGameUserDataInfo = String(object.RummyGameUserDataInfo);
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".RummyPlaySuperData.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyPlaySuperData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPlaySuperData
     * @static
     * @param {RummyPlaySuperData} message RummyPlaySuperData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPlaySuperData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.HandCard = [];
        if (options.defaults)
            object.RummyGameUserDataInfo = "";
        if (message.RummyGameUserDataInfo != null && message.hasOwnProperty("RummyGameUserDataInfo"))
            object.RummyGameUserDataInfo = message.RummyGameUserDataInfo;
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        return object;
    };

    /**
     * Converts this RummyPlaySuperData to JSON.
     * @function toJSON
     * @memberof RummyPlaySuperData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPlaySuperData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPlaySuperData
     * @function getTypeUrl
     * @memberof RummyPlaySuperData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPlaySuperData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPlaySuperData";
    };

    return RummyPlaySuperData;
})();

export const RummySrvToDeskSuperDataReq = $root.RummySrvToDeskSuperDataReq = (() => {

    /**
     * Properties of a RummySrvToDeskSuperDataReq.
     * @exports IRummySrvToDeskSuperDataReq
     * @interface IRummySrvToDeskSuperDataReq
     * @property {number|null} [DeskNo] RummySrvToDeskSuperDataReq DeskNo
     * @property {number|null} [UserID] RummySrvToDeskSuperDataReq UserID
     */

    /**
     * Constructs a new RummySrvToDeskSuperDataReq.
     * @exports RummySrvToDeskSuperDataReq
     * @classdesc Represents a RummySrvToDeskSuperDataReq.
     * @implements IRummySrvToDeskSuperDataReq
     * @constructor
     * @param {IRummySrvToDeskSuperDataReq=} [properties] Properties to set
     */
    function RummySrvToDeskSuperDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskSuperDataReq DeskNo.
     * @member {number} DeskNo
     * @memberof RummySrvToDeskSuperDataReq
     * @instance
     */
    RummySrvToDeskSuperDataReq.prototype.DeskNo = 0;

    /**
     * RummySrvToDeskSuperDataReq UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskSuperDataReq
     * @instance
     */
    RummySrvToDeskSuperDataReq.prototype.UserID = 0;

    /**
     * Creates a new RummySrvToDeskSuperDataReq instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {IRummySrvToDeskSuperDataReq=} [properties] Properties to set
     * @returns {RummySrvToDeskSuperDataReq} RummySrvToDeskSuperDataReq instance
     */
    RummySrvToDeskSuperDataReq.create = function create(properties) {
        return new RummySrvToDeskSuperDataReq(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskSuperDataReq message. Does not implicitly {@link RummySrvToDeskSuperDataReq.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {IRummySrvToDeskSuperDataReq} message RummySrvToDeskSuperDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskSuperDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskSuperDataReq message, length delimited. Does not implicitly {@link RummySrvToDeskSuperDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {IRummySrvToDeskSuperDataReq} message RummySrvToDeskSuperDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskSuperDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskSuperDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskSuperDataReq} RummySrvToDeskSuperDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskSuperDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskSuperDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskSuperDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskSuperDataReq} RummySrvToDeskSuperDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskSuperDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskSuperDataReq message.
     * @function verify
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskSuperDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskSuperDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskSuperDataReq} RummySrvToDeskSuperDataReq
     */
    RummySrvToDeskSuperDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskSuperDataReq)
            return object;
        let message = new $root.RummySrvToDeskSuperDataReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskSuperDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {RummySrvToDeskSuperDataReq} message RummySrvToDeskSuperDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskSuperDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this RummySrvToDeskSuperDataReq to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskSuperDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskSuperDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskSuperDataReq
     * @function getTypeUrl
     * @memberof RummySrvToDeskSuperDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskSuperDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskSuperDataReq";
    };

    return RummySrvToDeskSuperDataReq;
})();

export const RummySrvToDeskSuperDataAck = $root.RummySrvToDeskSuperDataAck = (() => {

    /**
     * Properties of a RummySrvToDeskSuperDataAck.
     * @exports IRummySrvToDeskSuperDataAck
     * @interface IRummySrvToDeskSuperDataAck
     * @property {string|null} [sDeskSuperData] RummySrvToDeskSuperDataAck sDeskSuperData
     * @property {Array.<IRummyPlaySuperData>|null} [PlaySuperData] RummySrvToDeskSuperDataAck PlaySuperData
     * @property {number|null} [GameID] RummySrvToDeskSuperDataAck GameID
     */

    /**
     * Constructs a new RummySrvToDeskSuperDataAck.
     * @exports RummySrvToDeskSuperDataAck
     * @classdesc Represents a RummySrvToDeskSuperDataAck.
     * @implements IRummySrvToDeskSuperDataAck
     * @constructor
     * @param {IRummySrvToDeskSuperDataAck=} [properties] Properties to set
     */
    function RummySrvToDeskSuperDataAck(properties) {
        this.PlaySuperData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskSuperDataAck sDeskSuperData.
     * @member {string} sDeskSuperData
     * @memberof RummySrvToDeskSuperDataAck
     * @instance
     */
    RummySrvToDeskSuperDataAck.prototype.sDeskSuperData = "";

    /**
     * RummySrvToDeskSuperDataAck PlaySuperData.
     * @member {Array.<IRummyPlaySuperData>} PlaySuperData
     * @memberof RummySrvToDeskSuperDataAck
     * @instance
     */
    RummySrvToDeskSuperDataAck.prototype.PlaySuperData = $util.emptyArray;

    /**
     * RummySrvToDeskSuperDataAck GameID.
     * @member {number} GameID
     * @memberof RummySrvToDeskSuperDataAck
     * @instance
     */
    RummySrvToDeskSuperDataAck.prototype.GameID = 0;

    /**
     * Creates a new RummySrvToDeskSuperDataAck instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {IRummySrvToDeskSuperDataAck=} [properties] Properties to set
     * @returns {RummySrvToDeskSuperDataAck} RummySrvToDeskSuperDataAck instance
     */
    RummySrvToDeskSuperDataAck.create = function create(properties) {
        return new RummySrvToDeskSuperDataAck(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskSuperDataAck message. Does not implicitly {@link RummySrvToDeskSuperDataAck.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {IRummySrvToDeskSuperDataAck} message RummySrvToDeskSuperDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskSuperDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sDeskSuperData != null && Object.hasOwnProperty.call(message, "sDeskSuperData"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sDeskSuperData);
        if (message.PlaySuperData != null && message.PlaySuperData.length)
            for (let i = 0; i < message.PlaySuperData.length; ++i)
                $root.RummyPlaySuperData.encode(message.PlaySuperData[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskSuperDataAck message, length delimited. Does not implicitly {@link RummySrvToDeskSuperDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {IRummySrvToDeskSuperDataAck} message RummySrvToDeskSuperDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskSuperDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskSuperDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskSuperDataAck} RummySrvToDeskSuperDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskSuperDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskSuperDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.sDeskSuperData = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.PlaySuperData && message.PlaySuperData.length))
                        message.PlaySuperData = [];
                    message.PlaySuperData.push($root.RummyPlaySuperData.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskSuperDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskSuperDataAck} RummySrvToDeskSuperDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskSuperDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskSuperDataAck message.
     * @function verify
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskSuperDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sDeskSuperData != null && message.hasOwnProperty("sDeskSuperData"))
            if (!$util.isString(message.sDeskSuperData))
                return "sDeskSuperData: string expected";
        if (message.PlaySuperData != null && message.hasOwnProperty("PlaySuperData")) {
            if (!Array.isArray(message.PlaySuperData))
                return "PlaySuperData: array expected";
            for (let i = 0; i < message.PlaySuperData.length; ++i) {
                let error = $root.RummyPlaySuperData.verify(message.PlaySuperData[i]);
                if (error)
                    return "PlaySuperData." + error;
            }
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskSuperDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskSuperDataAck} RummySrvToDeskSuperDataAck
     */
    RummySrvToDeskSuperDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskSuperDataAck)
            return object;
        let message = new $root.RummySrvToDeskSuperDataAck();
        if (object.sDeskSuperData != null)
            message.sDeskSuperData = String(object.sDeskSuperData);
        if (object.PlaySuperData) {
            if (!Array.isArray(object.PlaySuperData))
                throw TypeError(".RummySrvToDeskSuperDataAck.PlaySuperData: array expected");
            message.PlaySuperData = [];
            for (let i = 0; i < object.PlaySuperData.length; ++i) {
                if (typeof object.PlaySuperData[i] !== "object")
                    throw TypeError(".RummySrvToDeskSuperDataAck.PlaySuperData: object expected");
                message.PlaySuperData[i] = $root.RummyPlaySuperData.fromObject(object.PlaySuperData[i]);
            }
        }
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskSuperDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {RummySrvToDeskSuperDataAck} message RummySrvToDeskSuperDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskSuperDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PlaySuperData = [];
        if (options.defaults) {
            object.sDeskSuperData = "";
            object.GameID = 0;
        }
        if (message.sDeskSuperData != null && message.hasOwnProperty("sDeskSuperData"))
            object.sDeskSuperData = message.sDeskSuperData;
        if (message.PlaySuperData && message.PlaySuperData.length) {
            object.PlaySuperData = [];
            for (let j = 0; j < message.PlaySuperData.length; ++j)
                object.PlaySuperData[j] = $root.RummyPlaySuperData.toObject(message.PlaySuperData[j], options);
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this RummySrvToDeskSuperDataAck to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskSuperDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskSuperDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskSuperDataAck
     * @function getTypeUrl
     * @memberof RummySrvToDeskSuperDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskSuperDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskSuperDataAck";
    };

    return RummySrvToDeskSuperDataAck;
})();

export const GameBotSrvSuperDataReq = $root.GameBotSrvSuperDataReq = (() => {

    /**
     * Properties of a GameBotSrvSuperDataReq.
     * @exports IGameBotSrvSuperDataReq
     * @interface IGameBotSrvSuperDataReq
     * @property {number|null} [DeskNo] GameBotSrvSuperDataReq DeskNo
     * @property {number|null} [UserID] GameBotSrvSuperDataReq UserID
     */

    /**
     * Constructs a new GameBotSrvSuperDataReq.
     * @exports GameBotSrvSuperDataReq
     * @classdesc Represents a GameBotSrvSuperDataReq.
     * @implements IGameBotSrvSuperDataReq
     * @constructor
     * @param {IGameBotSrvSuperDataReq=} [properties] Properties to set
     */
    function GameBotSrvSuperDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameBotSrvSuperDataReq DeskNo.
     * @member {number} DeskNo
     * @memberof GameBotSrvSuperDataReq
     * @instance
     */
    GameBotSrvSuperDataReq.prototype.DeskNo = 0;

    /**
     * GameBotSrvSuperDataReq UserID.
     * @member {number} UserID
     * @memberof GameBotSrvSuperDataReq
     * @instance
     */
    GameBotSrvSuperDataReq.prototype.UserID = 0;

    /**
     * Creates a new GameBotSrvSuperDataReq instance using the specified properties.
     * @function create
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {IGameBotSrvSuperDataReq=} [properties] Properties to set
     * @returns {GameBotSrvSuperDataReq} GameBotSrvSuperDataReq instance
     */
    GameBotSrvSuperDataReq.create = function create(properties) {
        return new GameBotSrvSuperDataReq(properties);
    };

    /**
     * Encodes the specified GameBotSrvSuperDataReq message. Does not implicitly {@link GameBotSrvSuperDataReq.verify|verify} messages.
     * @function encode
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {IGameBotSrvSuperDataReq} message GameBotSrvSuperDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameBotSrvSuperDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified GameBotSrvSuperDataReq message, length delimited. Does not implicitly {@link GameBotSrvSuperDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {IGameBotSrvSuperDataReq} message GameBotSrvSuperDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameBotSrvSuperDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameBotSrvSuperDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameBotSrvSuperDataReq} GameBotSrvSuperDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameBotSrvSuperDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameBotSrvSuperDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameBotSrvSuperDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameBotSrvSuperDataReq} GameBotSrvSuperDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameBotSrvSuperDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameBotSrvSuperDataReq message.
     * @function verify
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameBotSrvSuperDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a GameBotSrvSuperDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameBotSrvSuperDataReq} GameBotSrvSuperDataReq
     */
    GameBotSrvSuperDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.GameBotSrvSuperDataReq)
            return object;
        let message = new $root.GameBotSrvSuperDataReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameBotSrvSuperDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {GameBotSrvSuperDataReq} message GameBotSrvSuperDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameBotSrvSuperDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this GameBotSrvSuperDataReq to JSON.
     * @function toJSON
     * @memberof GameBotSrvSuperDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameBotSrvSuperDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameBotSrvSuperDataReq
     * @function getTypeUrl
     * @memberof GameBotSrvSuperDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameBotSrvSuperDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameBotSrvSuperDataReq";
    };

    return GameBotSrvSuperDataReq;
})();

export const GameBotSrvSuperDataAck = $root.GameBotSrvSuperDataAck = (() => {

    /**
     * Properties of a GameBotSrvSuperDataAck.
     * @exports IGameBotSrvSuperDataAck
     * @interface IGameBotSrvSuperDataAck
     * @property {number|null} [DeskNo] GameBotSrvSuperDataAck DeskNo
     * @property {number|null} [UserID] GameBotSrvSuperDataAck UserID
     * @property {string|null} [sDeskSuperData] GameBotSrvSuperDataAck sDeskSuperData
     * @property {Array.<IRummyPlaySuperData>|null} [PlaySuperData] GameBotSrvSuperDataAck PlaySuperData
     * @property {number|null} [GameID] GameBotSrvSuperDataAck GameID
     */

    /**
     * Constructs a new GameBotSrvSuperDataAck.
     * @exports GameBotSrvSuperDataAck
     * @classdesc Represents a GameBotSrvSuperDataAck.
     * @implements IGameBotSrvSuperDataAck
     * @constructor
     * @param {IGameBotSrvSuperDataAck=} [properties] Properties to set
     */
    function GameBotSrvSuperDataAck(properties) {
        this.PlaySuperData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameBotSrvSuperDataAck DeskNo.
     * @member {number} DeskNo
     * @memberof GameBotSrvSuperDataAck
     * @instance
     */
    GameBotSrvSuperDataAck.prototype.DeskNo = 0;

    /**
     * GameBotSrvSuperDataAck UserID.
     * @member {number} UserID
     * @memberof GameBotSrvSuperDataAck
     * @instance
     */
    GameBotSrvSuperDataAck.prototype.UserID = 0;

    /**
     * GameBotSrvSuperDataAck sDeskSuperData.
     * @member {string} sDeskSuperData
     * @memberof GameBotSrvSuperDataAck
     * @instance
     */
    GameBotSrvSuperDataAck.prototype.sDeskSuperData = "";

    /**
     * GameBotSrvSuperDataAck PlaySuperData.
     * @member {Array.<IRummyPlaySuperData>} PlaySuperData
     * @memberof GameBotSrvSuperDataAck
     * @instance
     */
    GameBotSrvSuperDataAck.prototype.PlaySuperData = $util.emptyArray;

    /**
     * GameBotSrvSuperDataAck GameID.
     * @member {number} GameID
     * @memberof GameBotSrvSuperDataAck
     * @instance
     */
    GameBotSrvSuperDataAck.prototype.GameID = 0;

    /**
     * Creates a new GameBotSrvSuperDataAck instance using the specified properties.
     * @function create
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {IGameBotSrvSuperDataAck=} [properties] Properties to set
     * @returns {GameBotSrvSuperDataAck} GameBotSrvSuperDataAck instance
     */
    GameBotSrvSuperDataAck.create = function create(properties) {
        return new GameBotSrvSuperDataAck(properties);
    };

    /**
     * Encodes the specified GameBotSrvSuperDataAck message. Does not implicitly {@link GameBotSrvSuperDataAck.verify|verify} messages.
     * @function encode
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {IGameBotSrvSuperDataAck} message GameBotSrvSuperDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameBotSrvSuperDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.sDeskSuperData != null && Object.hasOwnProperty.call(message, "sDeskSuperData"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sDeskSuperData);
        if (message.PlaySuperData != null && message.PlaySuperData.length)
            for (let i = 0; i < message.PlaySuperData.length; ++i)
                $root.RummyPlaySuperData.encode(message.PlaySuperData[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified GameBotSrvSuperDataAck message, length delimited. Does not implicitly {@link GameBotSrvSuperDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {IGameBotSrvSuperDataAck} message GameBotSrvSuperDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameBotSrvSuperDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameBotSrvSuperDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameBotSrvSuperDataAck} GameBotSrvSuperDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameBotSrvSuperDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameBotSrvSuperDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.sDeskSuperData = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.PlaySuperData && message.PlaySuperData.length))
                        message.PlaySuperData = [];
                    message.PlaySuperData.push($root.RummyPlaySuperData.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameBotSrvSuperDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameBotSrvSuperDataAck} GameBotSrvSuperDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameBotSrvSuperDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameBotSrvSuperDataAck message.
     * @function verify
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameBotSrvSuperDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.sDeskSuperData != null && message.hasOwnProperty("sDeskSuperData"))
            if (!$util.isString(message.sDeskSuperData))
                return "sDeskSuperData: string expected";
        if (message.PlaySuperData != null && message.hasOwnProperty("PlaySuperData")) {
            if (!Array.isArray(message.PlaySuperData))
                return "PlaySuperData: array expected";
            for (let i = 0; i < message.PlaySuperData.length; ++i) {
                let error = $root.RummyPlaySuperData.verify(message.PlaySuperData[i]);
                if (error)
                    return "PlaySuperData." + error;
            }
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a GameBotSrvSuperDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameBotSrvSuperDataAck} GameBotSrvSuperDataAck
     */
    GameBotSrvSuperDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.GameBotSrvSuperDataAck)
            return object;
        let message = new $root.GameBotSrvSuperDataAck();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.sDeskSuperData != null)
            message.sDeskSuperData = String(object.sDeskSuperData);
        if (object.PlaySuperData) {
            if (!Array.isArray(object.PlaySuperData))
                throw TypeError(".GameBotSrvSuperDataAck.PlaySuperData: array expected");
            message.PlaySuperData = [];
            for (let i = 0; i < object.PlaySuperData.length; ++i) {
                if (typeof object.PlaySuperData[i] !== "object")
                    throw TypeError(".GameBotSrvSuperDataAck.PlaySuperData: object expected");
                message.PlaySuperData[i] = $root.RummyPlaySuperData.fromObject(object.PlaySuperData[i]);
            }
        }
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameBotSrvSuperDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {GameBotSrvSuperDataAck} message GameBotSrvSuperDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameBotSrvSuperDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PlaySuperData = [];
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.sDeskSuperData = "";
            object.GameID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.sDeskSuperData != null && message.hasOwnProperty("sDeskSuperData"))
            object.sDeskSuperData = message.sDeskSuperData;
        if (message.PlaySuperData && message.PlaySuperData.length) {
            object.PlaySuperData = [];
            for (let j = 0; j < message.PlaySuperData.length; ++j)
                object.PlaySuperData[j] = $root.RummyPlaySuperData.toObject(message.PlaySuperData[j], options);
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this GameBotSrvSuperDataAck to JSON.
     * @function toJSON
     * @memberof GameBotSrvSuperDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameBotSrvSuperDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameBotSrvSuperDataAck
     * @function getTypeUrl
     * @memberof GameBotSrvSuperDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameBotSrvSuperDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameBotSrvSuperDataAck";
    };

    return GameBotSrvSuperDataAck;
})();

export const ClientBonusSigningReq = $root.ClientBonusSigningReq = (() => {

    /**
     * Properties of a ClientBonusSigningReq.
     * @exports IClientBonusSigningReq
     * @interface IClientBonusSigningReq
     * @property {number|null} [UserID] ClientBonusSigningReq UserID
     * @property {number|null} [CID] ClientBonusSigningReq CID
     */

    /**
     * Constructs a new ClientBonusSigningReq.
     * @exports ClientBonusSigningReq
     * @classdesc Represents a ClientBonusSigningReq.
     * @implements IClientBonusSigningReq
     * @constructor
     * @param {IClientBonusSigningReq=} [properties] Properties to set
     */
    function ClientBonusSigningReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBonusSigningReq UserID.
     * @member {number} UserID
     * @memberof ClientBonusSigningReq
     * @instance
     */
    ClientBonusSigningReq.prototype.UserID = 0;

    /**
     * ClientBonusSigningReq CID.
     * @member {number} CID
     * @memberof ClientBonusSigningReq
     * @instance
     */
    ClientBonusSigningReq.prototype.CID = 0;

    /**
     * Creates a new ClientBonusSigningReq instance using the specified properties.
     * @function create
     * @memberof ClientBonusSigningReq
     * @static
     * @param {IClientBonusSigningReq=} [properties] Properties to set
     * @returns {ClientBonusSigningReq} ClientBonusSigningReq instance
     */
    ClientBonusSigningReq.create = function create(properties) {
        return new ClientBonusSigningReq(properties);
    };

    /**
     * Encodes the specified ClientBonusSigningReq message. Does not implicitly {@link ClientBonusSigningReq.verify|verify} messages.
     * @function encode
     * @memberof ClientBonusSigningReq
     * @static
     * @param {IClientBonusSigningReq} message ClientBonusSigningReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSigningReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        return writer;
    };

    /**
     * Encodes the specified ClientBonusSigningReq message, length delimited. Does not implicitly {@link ClientBonusSigningReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBonusSigningReq
     * @static
     * @param {IClientBonusSigningReq} message ClientBonusSigningReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSigningReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBonusSigningReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBonusSigningReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBonusSigningReq} ClientBonusSigningReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSigningReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBonusSigningReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBonusSigningReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBonusSigningReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBonusSigningReq} ClientBonusSigningReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSigningReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBonusSigningReq message.
     * @function verify
     * @memberof ClientBonusSigningReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBonusSigningReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        return null;
    };

    /**
     * Creates a ClientBonusSigningReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBonusSigningReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBonusSigningReq} ClientBonusSigningReq
     */
    ClientBonusSigningReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBonusSigningReq)
            return object;
        let message = new $root.ClientBonusSigningReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBonusSigningReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBonusSigningReq
     * @static
     * @param {ClientBonusSigningReq} message ClientBonusSigningReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBonusSigningReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        return object;
    };

    /**
     * Converts this ClientBonusSigningReq to JSON.
     * @function toJSON
     * @memberof ClientBonusSigningReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBonusSigningReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBonusSigningReq
     * @function getTypeUrl
     * @memberof ClientBonusSigningReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBonusSigningReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBonusSigningReq";
    };

    return ClientBonusSigningReq;
})();

export const ClientBonusSigningAck = $root.ClientBonusSigningAck = (() => {

    /**
     * Properties of a ClientBonusSigningAck.
     * @exports IClientBonusSigningAck
     * @interface IClientBonusSigningAck
     * @property {number|null} [Res] ClientBonusSigningAck Res
     * @property {number|null} [UserID] ClientBonusSigningAck UserID
     * @property {number|null} [CID] ClientBonusSigningAck CID
     * @property {number|null} [GoldType] ClientBonusSigningAck GoldType
     * @property {string|null} [strConfig] ClientBonusSigningAck strConfig
     * @property {string|null} [strBox] ClientBonusSigningAck strBox
     * @property {number|null} [Signdate] ClientBonusSigningAck Signdate
     * @property {number|null} [Signmax] ClientBonusSigningAck Signmax
     * @property {number|null} [Apply] ClientBonusSigningAck Apply
     * @property {boolean|null} [bSigning] ClientBonusSigningAck bSigning
     * @property {number|null} [uStatus] ClientBonusSigningAck uStatus
     */

    /**
     * Constructs a new ClientBonusSigningAck.
     * @exports ClientBonusSigningAck
     * @classdesc Represents a ClientBonusSigningAck.
     * @implements IClientBonusSigningAck
     * @constructor
     * @param {IClientBonusSigningAck=} [properties] Properties to set
     */
    function ClientBonusSigningAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBonusSigningAck Res.
     * @member {number} Res
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.Res = 0;

    /**
     * ClientBonusSigningAck UserID.
     * @member {number} UserID
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.UserID = 0;

    /**
     * ClientBonusSigningAck CID.
     * @member {number} CID
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.CID = 0;

    /**
     * ClientBonusSigningAck GoldType.
     * @member {number} GoldType
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.GoldType = 0;

    /**
     * ClientBonusSigningAck strConfig.
     * @member {string} strConfig
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.strConfig = "";

    /**
     * ClientBonusSigningAck strBox.
     * @member {string} strBox
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.strBox = "";

    /**
     * ClientBonusSigningAck Signdate.
     * @member {number} Signdate
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.Signdate = 0;

    /**
     * ClientBonusSigningAck Signmax.
     * @member {number} Signmax
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.Signmax = 0;

    /**
     * ClientBonusSigningAck Apply.
     * @member {number} Apply
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.Apply = 0;

    /**
     * ClientBonusSigningAck bSigning.
     * @member {boolean} bSigning
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.bSigning = false;

    /**
     * ClientBonusSigningAck uStatus.
     * @member {number} uStatus
     * @memberof ClientBonusSigningAck
     * @instance
     */
    ClientBonusSigningAck.prototype.uStatus = 0;

    /**
     * Creates a new ClientBonusSigningAck instance using the specified properties.
     * @function create
     * @memberof ClientBonusSigningAck
     * @static
     * @param {IClientBonusSigningAck=} [properties] Properties to set
     * @returns {ClientBonusSigningAck} ClientBonusSigningAck instance
     */
    ClientBonusSigningAck.create = function create(properties) {
        return new ClientBonusSigningAck(properties);
    };

    /**
     * Encodes the specified ClientBonusSigningAck message. Does not implicitly {@link ClientBonusSigningAck.verify|verify} messages.
     * @function encode
     * @memberof ClientBonusSigningAck
     * @static
     * @param {IClientBonusSigningAck} message ClientBonusSigningAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSigningAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CID);
        if (message.GoldType != null && Object.hasOwnProperty.call(message, "GoldType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GoldType);
        if (message.strConfig != null && Object.hasOwnProperty.call(message, "strConfig"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.strConfig);
        if (message.strBox != null && Object.hasOwnProperty.call(message, "strBox"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.strBox);
        if (message.Signdate != null && Object.hasOwnProperty.call(message, "Signdate"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Signdate);
        if (message.Signmax != null && Object.hasOwnProperty.call(message, "Signmax"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Signmax);
        if (message.Apply != null && Object.hasOwnProperty.call(message, "Apply"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.Apply);
        if (message.bSigning != null && Object.hasOwnProperty.call(message, "bSigning"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.bSigning);
        if (message.uStatus != null && Object.hasOwnProperty.call(message, "uStatus"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.uStatus);
        return writer;
    };

    /**
     * Encodes the specified ClientBonusSigningAck message, length delimited. Does not implicitly {@link ClientBonusSigningAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBonusSigningAck
     * @static
     * @param {IClientBonusSigningAck} message ClientBonusSigningAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSigningAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBonusSigningAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBonusSigningAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBonusSigningAck} ClientBonusSigningAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSigningAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBonusSigningAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CID = reader.uint32();
                    break;
                }
            case 4: {
                    message.GoldType = reader.uint32();
                    break;
                }
            case 5: {
                    message.strConfig = reader.string();
                    break;
                }
            case 6: {
                    message.strBox = reader.string();
                    break;
                }
            case 7: {
                    message.Signdate = reader.uint32();
                    break;
                }
            case 8: {
                    message.Signmax = reader.uint32();
                    break;
                }
            case 9: {
                    message.Apply = reader.uint32();
                    break;
                }
            case 10: {
                    message.bSigning = reader.bool();
                    break;
                }
            case 11: {
                    message.uStatus = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBonusSigningAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBonusSigningAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBonusSigningAck} ClientBonusSigningAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSigningAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBonusSigningAck message.
     * @function verify
     * @memberof ClientBonusSigningAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBonusSigningAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.GoldType != null && message.hasOwnProperty("GoldType"))
            if (!$util.isInteger(message.GoldType))
                return "GoldType: integer expected";
        if (message.strConfig != null && message.hasOwnProperty("strConfig"))
            if (!$util.isString(message.strConfig))
                return "strConfig: string expected";
        if (message.strBox != null && message.hasOwnProperty("strBox"))
            if (!$util.isString(message.strBox))
                return "strBox: string expected";
        if (message.Signdate != null && message.hasOwnProperty("Signdate"))
            if (!$util.isInteger(message.Signdate))
                return "Signdate: integer expected";
        if (message.Signmax != null && message.hasOwnProperty("Signmax"))
            if (!$util.isInteger(message.Signmax))
                return "Signmax: integer expected";
        if (message.Apply != null && message.hasOwnProperty("Apply"))
            if (!$util.isInteger(message.Apply))
                return "Apply: integer expected";
        if (message.bSigning != null && message.hasOwnProperty("bSigning"))
            if (typeof message.bSigning !== "boolean")
                return "bSigning: boolean expected";
        if (message.uStatus != null && message.hasOwnProperty("uStatus"))
            if (!$util.isInteger(message.uStatus))
                return "uStatus: integer expected";
        return null;
    };

    /**
     * Creates a ClientBonusSigningAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBonusSigningAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBonusSigningAck} ClientBonusSigningAck
     */
    ClientBonusSigningAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBonusSigningAck)
            return object;
        let message = new $root.ClientBonusSigningAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.GoldType != null)
            message.GoldType = object.GoldType >>> 0;
        if (object.strConfig != null)
            message.strConfig = String(object.strConfig);
        if (object.strBox != null)
            message.strBox = String(object.strBox);
        if (object.Signdate != null)
            message.Signdate = object.Signdate >>> 0;
        if (object.Signmax != null)
            message.Signmax = object.Signmax >>> 0;
        if (object.Apply != null)
            message.Apply = object.Apply >>> 0;
        if (object.bSigning != null)
            message.bSigning = Boolean(object.bSigning);
        if (object.uStatus != null)
            message.uStatus = object.uStatus >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBonusSigningAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBonusSigningAck
     * @static
     * @param {ClientBonusSigningAck} message ClientBonusSigningAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBonusSigningAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.CID = 0;
            object.GoldType = 0;
            object.strConfig = "";
            object.strBox = "";
            object.Signdate = 0;
            object.Signmax = 0;
            object.Apply = 0;
            object.bSigning = false;
            object.uStatus = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.GoldType != null && message.hasOwnProperty("GoldType"))
            object.GoldType = message.GoldType;
        if (message.strConfig != null && message.hasOwnProperty("strConfig"))
            object.strConfig = message.strConfig;
        if (message.strBox != null && message.hasOwnProperty("strBox"))
            object.strBox = message.strBox;
        if (message.Signdate != null && message.hasOwnProperty("Signdate"))
            object.Signdate = message.Signdate;
        if (message.Signmax != null && message.hasOwnProperty("Signmax"))
            object.Signmax = message.Signmax;
        if (message.Apply != null && message.hasOwnProperty("Apply"))
            object.Apply = message.Apply;
        if (message.bSigning != null && message.hasOwnProperty("bSigning"))
            object.bSigning = message.bSigning;
        if (message.uStatus != null && message.hasOwnProperty("uStatus"))
            object.uStatus = message.uStatus;
        return object;
    };

    /**
     * Converts this ClientBonusSigningAck to JSON.
     * @function toJSON
     * @memberof ClientBonusSigningAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBonusSigningAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBonusSigningAck
     * @function getTypeUrl
     * @memberof ClientBonusSigningAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBonusSigningAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBonusSigningAck";
    };

    return ClientBonusSigningAck;
})();

export const ClientBonusSignSuccedReq = $root.ClientBonusSignSuccedReq = (() => {

    /**
     * Properties of a ClientBonusSignSuccedReq.
     * @exports IClientBonusSignSuccedReq
     * @interface IClientBonusSignSuccedReq
     * @property {number|null} [UserID] ClientBonusSignSuccedReq UserID
     * @property {number|null} [CID] ClientBonusSignSuccedReq CID
     * @property {string|null} [strBox] ClientBonusSignSuccedReq strBox
     * @property {number|null} [GoldType] ClientBonusSignSuccedReq GoldType
     * @property {number|null} [Gold] ClientBonusSignSuccedReq Gold
     * @property {number|null} [Signdate] ClientBonusSignSuccedReq Signdate
     * @property {number|null} [Signmax] ClientBonusSignSuccedReq Signmax
     * @property {number|null} [Apply] ClientBonusSignSuccedReq Apply
     */

    /**
     * Constructs a new ClientBonusSignSuccedReq.
     * @exports ClientBonusSignSuccedReq
     * @classdesc Represents a ClientBonusSignSuccedReq.
     * @implements IClientBonusSignSuccedReq
     * @constructor
     * @param {IClientBonusSignSuccedReq=} [properties] Properties to set
     */
    function ClientBonusSignSuccedReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBonusSignSuccedReq UserID.
     * @member {number} UserID
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.UserID = 0;

    /**
     * ClientBonusSignSuccedReq CID.
     * @member {number} CID
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.CID = 0;

    /**
     * ClientBonusSignSuccedReq strBox.
     * @member {string} strBox
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.strBox = "";

    /**
     * ClientBonusSignSuccedReq GoldType.
     * @member {number} GoldType
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.GoldType = 0;

    /**
     * ClientBonusSignSuccedReq Gold.
     * @member {number} Gold
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.Gold = 0;

    /**
     * ClientBonusSignSuccedReq Signdate.
     * @member {number} Signdate
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.Signdate = 0;

    /**
     * ClientBonusSignSuccedReq Signmax.
     * @member {number} Signmax
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.Signmax = 0;

    /**
     * ClientBonusSignSuccedReq Apply.
     * @member {number} Apply
     * @memberof ClientBonusSignSuccedReq
     * @instance
     */
    ClientBonusSignSuccedReq.prototype.Apply = 0;

    /**
     * Creates a new ClientBonusSignSuccedReq instance using the specified properties.
     * @function create
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {IClientBonusSignSuccedReq=} [properties] Properties to set
     * @returns {ClientBonusSignSuccedReq} ClientBonusSignSuccedReq instance
     */
    ClientBonusSignSuccedReq.create = function create(properties) {
        return new ClientBonusSignSuccedReq(properties);
    };

    /**
     * Encodes the specified ClientBonusSignSuccedReq message. Does not implicitly {@link ClientBonusSignSuccedReq.verify|verify} messages.
     * @function encode
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {IClientBonusSignSuccedReq} message ClientBonusSignSuccedReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSignSuccedReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        if (message.strBox != null && Object.hasOwnProperty.call(message, "strBox"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strBox);
        if (message.GoldType != null && Object.hasOwnProperty.call(message, "GoldType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GoldType);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Gold);
        if (message.Signdate != null && Object.hasOwnProperty.call(message, "Signdate"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Signdate);
        if (message.Signmax != null && Object.hasOwnProperty.call(message, "Signmax"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Signmax);
        if (message.Apply != null && Object.hasOwnProperty.call(message, "Apply"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Apply);
        return writer;
    };

    /**
     * Encodes the specified ClientBonusSignSuccedReq message, length delimited. Does not implicitly {@link ClientBonusSignSuccedReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {IClientBonusSignSuccedReq} message ClientBonusSignSuccedReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSignSuccedReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBonusSignSuccedReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBonusSignSuccedReq} ClientBonusSignSuccedReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSignSuccedReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBonusSignSuccedReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            case 3: {
                    message.strBox = reader.string();
                    break;
                }
            case 4: {
                    message.GoldType = reader.uint32();
                    break;
                }
            case 5: {
                    message.Gold = reader.uint32();
                    break;
                }
            case 6: {
                    message.Signdate = reader.uint32();
                    break;
                }
            case 7: {
                    message.Signmax = reader.uint32();
                    break;
                }
            case 8: {
                    message.Apply = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBonusSignSuccedReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBonusSignSuccedReq} ClientBonusSignSuccedReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSignSuccedReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBonusSignSuccedReq message.
     * @function verify
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBonusSignSuccedReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.strBox != null && message.hasOwnProperty("strBox"))
            if (!$util.isString(message.strBox))
                return "strBox: string expected";
        if (message.GoldType != null && message.hasOwnProperty("GoldType"))
            if (!$util.isInteger(message.GoldType))
                return "GoldType: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold))
                return "Gold: integer expected";
        if (message.Signdate != null && message.hasOwnProperty("Signdate"))
            if (!$util.isInteger(message.Signdate))
                return "Signdate: integer expected";
        if (message.Signmax != null && message.hasOwnProperty("Signmax"))
            if (!$util.isInteger(message.Signmax))
                return "Signmax: integer expected";
        if (message.Apply != null && message.hasOwnProperty("Apply"))
            if (!$util.isInteger(message.Apply))
                return "Apply: integer expected";
        return null;
    };

    /**
     * Creates a ClientBonusSignSuccedReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBonusSignSuccedReq} ClientBonusSignSuccedReq
     */
    ClientBonusSignSuccedReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBonusSignSuccedReq)
            return object;
        let message = new $root.ClientBonusSignSuccedReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.strBox != null)
            message.strBox = String(object.strBox);
        if (object.GoldType != null)
            message.GoldType = object.GoldType >>> 0;
        if (object.Gold != null)
            message.Gold = object.Gold >>> 0;
        if (object.Signdate != null)
            message.Signdate = object.Signdate >>> 0;
        if (object.Signmax != null)
            message.Signmax = object.Signmax >>> 0;
        if (object.Apply != null)
            message.Apply = object.Apply >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBonusSignSuccedReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {ClientBonusSignSuccedReq} message ClientBonusSignSuccedReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBonusSignSuccedReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
            object.strBox = "";
            object.GoldType = 0;
            object.Gold = 0;
            object.Signdate = 0;
            object.Signmax = 0;
            object.Apply = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.strBox != null && message.hasOwnProperty("strBox"))
            object.strBox = message.strBox;
        if (message.GoldType != null && message.hasOwnProperty("GoldType"))
            object.GoldType = message.GoldType;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        if (message.Signdate != null && message.hasOwnProperty("Signdate"))
            object.Signdate = message.Signdate;
        if (message.Signmax != null && message.hasOwnProperty("Signmax"))
            object.Signmax = message.Signmax;
        if (message.Apply != null && message.hasOwnProperty("Apply"))
            object.Apply = message.Apply;
        return object;
    };

    /**
     * Converts this ClientBonusSignSuccedReq to JSON.
     * @function toJSON
     * @memberof ClientBonusSignSuccedReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBonusSignSuccedReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBonusSignSuccedReq
     * @function getTypeUrl
     * @memberof ClientBonusSignSuccedReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBonusSignSuccedReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBonusSignSuccedReq";
    };

    return ClientBonusSignSuccedReq;
})();

export const ClientBonusSignSuccedAck = $root.ClientBonusSignSuccedAck = (() => {

    /**
     * Properties of a ClientBonusSignSuccedAck.
     * @exports IClientBonusSignSuccedAck
     * @interface IClientBonusSignSuccedAck
     * @property {number|null} [Res] ClientBonusSignSuccedAck Res
     * @property {number|null} [UserID] ClientBonusSignSuccedAck UserID
     */

    /**
     * Constructs a new ClientBonusSignSuccedAck.
     * @exports ClientBonusSignSuccedAck
     * @classdesc Represents a ClientBonusSignSuccedAck.
     * @implements IClientBonusSignSuccedAck
     * @constructor
     * @param {IClientBonusSignSuccedAck=} [properties] Properties to set
     */
    function ClientBonusSignSuccedAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBonusSignSuccedAck Res.
     * @member {number} Res
     * @memberof ClientBonusSignSuccedAck
     * @instance
     */
    ClientBonusSignSuccedAck.prototype.Res = 0;

    /**
     * ClientBonusSignSuccedAck UserID.
     * @member {number} UserID
     * @memberof ClientBonusSignSuccedAck
     * @instance
     */
    ClientBonusSignSuccedAck.prototype.UserID = 0;

    /**
     * Creates a new ClientBonusSignSuccedAck instance using the specified properties.
     * @function create
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {IClientBonusSignSuccedAck=} [properties] Properties to set
     * @returns {ClientBonusSignSuccedAck} ClientBonusSignSuccedAck instance
     */
    ClientBonusSignSuccedAck.create = function create(properties) {
        return new ClientBonusSignSuccedAck(properties);
    };

    /**
     * Encodes the specified ClientBonusSignSuccedAck message. Does not implicitly {@link ClientBonusSignSuccedAck.verify|verify} messages.
     * @function encode
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {IClientBonusSignSuccedAck} message ClientBonusSignSuccedAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSignSuccedAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientBonusSignSuccedAck message, length delimited. Does not implicitly {@link ClientBonusSignSuccedAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {IClientBonusSignSuccedAck} message ClientBonusSignSuccedAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBonusSignSuccedAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBonusSignSuccedAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBonusSignSuccedAck} ClientBonusSignSuccedAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSignSuccedAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBonusSignSuccedAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBonusSignSuccedAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBonusSignSuccedAck} ClientBonusSignSuccedAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBonusSignSuccedAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBonusSignSuccedAck message.
     * @function verify
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBonusSignSuccedAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientBonusSignSuccedAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBonusSignSuccedAck} ClientBonusSignSuccedAck
     */
    ClientBonusSignSuccedAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBonusSignSuccedAck)
            return object;
        let message = new $root.ClientBonusSignSuccedAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBonusSignSuccedAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {ClientBonusSignSuccedAck} message ClientBonusSignSuccedAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBonusSignSuccedAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientBonusSignSuccedAck to JSON.
     * @function toJSON
     * @memberof ClientBonusSignSuccedAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBonusSignSuccedAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBonusSignSuccedAck
     * @function getTypeUrl
     * @memberof ClientBonusSignSuccedAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBonusSignSuccedAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBonusSignSuccedAck";
    };

    return ClientBonusSignSuccedAck;
})();

/**
 * KYC_INFO_TYPE enum.
 * @exports KYC_INFO_TYPE
 * @enum {number}
 * @property {number} KYC_INFO_TYPE_DEFAULT=0 KYC_INFO_TYPE_DEFAULT value
 * @property {number} KYC_INFO_TYPE_CHECK_MOBLIE=1 KYC_INFO_TYPE_CHECK_MOBLIE value
 * @property {number} KYC_INFO_TYPE_CHECK_MAIL=2 KYC_INFO_TYPE_CHECK_MAIL value
 * @property {number} KYC_INFO_TYPE_PUSH_INFO=3 KYC_INFO_TYPE_PUSH_INFO value
 * @property {number} KYC_INFO_TYPE_MODIFY_MOBLE=4 KYC_INFO_TYPE_MODIFY_MOBLE value
 * @property {number} KYC_INFO_TYPE_MODIFY_MAIL=5 KYC_INFO_TYPE_MODIFY_MAIL value
 */
export const KYC_INFO_TYPE = $root.KYC_INFO_TYPE = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KYC_INFO_TYPE_DEFAULT"] = 0;
    values[valuesById[1] = "KYC_INFO_TYPE_CHECK_MOBLIE"] = 1;
    values[valuesById[2] = "KYC_INFO_TYPE_CHECK_MAIL"] = 2;
    values[valuesById[3] = "KYC_INFO_TYPE_PUSH_INFO"] = 3;
    values[valuesById[4] = "KYC_INFO_TYPE_MODIFY_MOBLE"] = 4;
    values[valuesById[5] = "KYC_INFO_TYPE_MODIFY_MAIL"] = 5;
    return values;
})();

export const BigBattleSrvToDeskPushAssetInfo = $root.BigBattleSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a BigBattleSrvToDeskPushAssetInfo.
     * @exports IBigBattleSrvToDeskPushAssetInfo
     * @interface IBigBattleSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] BigBattleSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] BigBattleSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] BigBattleSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] BigBattleSrvToDeskPushAssetInfo Chip
     */

    /**
     * Constructs a new BigBattleSrvToDeskPushAssetInfo.
     * @exports BigBattleSrvToDeskPushAssetInfo
     * @classdesc Represents a BigBattleSrvToDeskPushAssetInfo.
     * @implements IBigBattleSrvToDeskPushAssetInfo
     * @constructor
     * @param {IBigBattleSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function BigBattleSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @instance
     */
    BigBattleSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * BigBattleSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @instance
     */
    BigBattleSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * BigBattleSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @instance
     */
    BigBattleSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * BigBattleSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @instance
     */
    BigBattleSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * Creates a new BigBattleSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {IBigBattleSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {BigBattleSrvToDeskPushAssetInfo} BigBattleSrvToDeskPushAssetInfo instance
     */
    BigBattleSrvToDeskPushAssetInfo.create = function create(properties) {
        return new BigBattleSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified BigBattleSrvToDeskPushAssetInfo message. Does not implicitly {@link BigBattleSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {IBigBattleSrvToDeskPushAssetInfo} message BigBattleSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified BigBattleSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link BigBattleSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {IBigBattleSrvToDeskPushAssetInfo} message BigBattleSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleSrvToDeskPushAssetInfo} BigBattleSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleSrvToDeskPushAssetInfo} BigBattleSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a BigBattleSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleSrvToDeskPushAssetInfo} BigBattleSrvToDeskPushAssetInfo
     */
    BigBattleSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.BigBattleSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {BigBattleSrvToDeskPushAssetInfo} message BigBattleSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this BigBattleSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof BigBattleSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleSrvToDeskPushAssetInfo";
    };

    return BigBattleSrvToDeskPushAssetInfo;
})();

export const BigBattleSrvToDeskPushDeskInfo = $root.BigBattleSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a BigBattleSrvToDeskPushDeskInfo.
     * @exports IBigBattleSrvToDeskPushDeskInfo
     * @interface IBigBattleSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] BigBattleSrvToDeskPushDeskInfo UserID
     * @property {IBigBattleProduct|null} [Product] BigBattleSrvToDeskPushDeskInfo Product
     * @property {string|null} [Tax] BigBattleSrvToDeskPushDeskInfo Tax
     */

    /**
     * Constructs a new BigBattleSrvToDeskPushDeskInfo.
     * @exports BigBattleSrvToDeskPushDeskInfo
     * @classdesc Represents a BigBattleSrvToDeskPushDeskInfo.
     * @implements IBigBattleSrvToDeskPushDeskInfo
     * @constructor
     * @param {IBigBattleSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function BigBattleSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @instance
     */
    BigBattleSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * BigBattleSrvToDeskPushDeskInfo Product.
     * @member {IBigBattleProduct|null|undefined} Product
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @instance
     */
    BigBattleSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * BigBattleSrvToDeskPushDeskInfo Tax.
     * @member {string} Tax
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @instance
     */
    BigBattleSrvToDeskPushDeskInfo.prototype.Tax = "";

    /**
     * Creates a new BigBattleSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {IBigBattleSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {BigBattleSrvToDeskPushDeskInfo} BigBattleSrvToDeskPushDeskInfo instance
     */
    BigBattleSrvToDeskPushDeskInfo.create = function create(properties) {
        return new BigBattleSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified BigBattleSrvToDeskPushDeskInfo message. Does not implicitly {@link BigBattleSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {IBigBattleSrvToDeskPushDeskInfo} message BigBattleSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.BigBattleProduct.encode(message.Product, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Tax);
        return writer;
    };

    /**
     * Encodes the specified BigBattleSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link BigBattleSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {IBigBattleSrvToDeskPushDeskInfo} message BigBattleSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleSrvToDeskPushDeskInfo} BigBattleSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Product = $root.BigBattleProduct.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.Tax = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleSrvToDeskPushDeskInfo} BigBattleSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.BigBattleProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        return null;
    };

    /**
     * Creates a BigBattleSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleSrvToDeskPushDeskInfo} BigBattleSrvToDeskPushDeskInfo
     */
    BigBattleSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.BigBattleSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".BigBattleSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.BigBattleProduct.fromObject(object.Product);
        }
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {BigBattleSrvToDeskPushDeskInfo} message BigBattleSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Product = null;
            object.Tax = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.BigBattleProduct.toObject(message.Product, options);
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        return object;
    };

    /**
     * Converts this BigBattleSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof BigBattleSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleSrvToDeskPushDeskInfo";
    };

    return BigBattleSrvToDeskPushDeskInfo;
})();

export const BigBattleBetInfo = $root.BigBattleBetInfo = (() => {

    /**
     * Properties of a BigBattleBetInfo.
     * @exports IBigBattleBetInfo
     * @interface IBigBattleBetInfo
     * @property {number|Long|null} [DragonTotalBetChip] BigBattleBetInfo DragonTotalBetChip
     * @property {number|Long|null} [TigerTotalBetChip] BigBattleBetInfo TigerTotalBetChip
     * @property {number|Long|null} [DrawTotalBetChip] BigBattleBetInfo DrawTotalBetChip
     * @property {number|Long|null} [PlayerDragonTotalChip] BigBattleBetInfo PlayerDragonTotalChip
     * @property {number|Long|null} [PlayerTigerTotalChip] BigBattleBetInfo PlayerTigerTotalChip
     * @property {number|Long|null} [PlayerDrawTotalChip] BigBattleBetInfo PlayerDrawTotalChip
     */

    /**
     * Constructs a new BigBattleBetInfo.
     * @exports BigBattleBetInfo
     * @classdesc Represents a BigBattleBetInfo.
     * @implements IBigBattleBetInfo
     * @constructor
     * @param {IBigBattleBetInfo=} [properties] Properties to set
     */
    function BigBattleBetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleBetInfo DragonTotalBetChip.
     * @member {number|Long} DragonTotalBetChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.DragonTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleBetInfo TigerTotalBetChip.
     * @member {number|Long} TigerTotalBetChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.TigerTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleBetInfo DrawTotalBetChip.
     * @member {number|Long} DrawTotalBetChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.DrawTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleBetInfo PlayerDragonTotalChip.
     * @member {number|Long} PlayerDragonTotalChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.PlayerDragonTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleBetInfo PlayerTigerTotalChip.
     * @member {number|Long} PlayerTigerTotalChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.PlayerTigerTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * BigBattleBetInfo PlayerDrawTotalChip.
     * @member {number|Long} PlayerDrawTotalChip
     * @memberof BigBattleBetInfo
     * @instance
     */
    BigBattleBetInfo.prototype.PlayerDrawTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new BigBattleBetInfo instance using the specified properties.
     * @function create
     * @memberof BigBattleBetInfo
     * @static
     * @param {IBigBattleBetInfo=} [properties] Properties to set
     * @returns {BigBattleBetInfo} BigBattleBetInfo instance
     */
    BigBattleBetInfo.create = function create(properties) {
        return new BigBattleBetInfo(properties);
    };

    /**
     * Encodes the specified BigBattleBetInfo message. Does not implicitly {@link BigBattleBetInfo.verify|verify} messages.
     * @function encode
     * @memberof BigBattleBetInfo
     * @static
     * @param {IBigBattleBetInfo} message BigBattleBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleBetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DragonTotalBetChip != null && Object.hasOwnProperty.call(message, "DragonTotalBetChip"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.DragonTotalBetChip);
        if (message.TigerTotalBetChip != null && Object.hasOwnProperty.call(message, "TigerTotalBetChip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.TigerTotalBetChip);
        if (message.DrawTotalBetChip != null && Object.hasOwnProperty.call(message, "DrawTotalBetChip"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.DrawTotalBetChip);
        if (message.PlayerDragonTotalChip != null && Object.hasOwnProperty.call(message, "PlayerDragonTotalChip"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.PlayerDragonTotalChip);
        if (message.PlayerTigerTotalChip != null && Object.hasOwnProperty.call(message, "PlayerTigerTotalChip"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.PlayerTigerTotalChip);
        if (message.PlayerDrawTotalChip != null && Object.hasOwnProperty.call(message, "PlayerDrawTotalChip"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.PlayerDrawTotalChip);
        return writer;
    };

    /**
     * Encodes the specified BigBattleBetInfo message, length delimited. Does not implicitly {@link BigBattleBetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleBetInfo
     * @static
     * @param {IBigBattleBetInfo} message BigBattleBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleBetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleBetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleBetInfo} BigBattleBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleBetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleBetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DragonTotalBetChip = reader.uint64();
                    break;
                }
            case 2: {
                    message.TigerTotalBetChip = reader.uint64();
                    break;
                }
            case 3: {
                    message.DrawTotalBetChip = reader.uint64();
                    break;
                }
            case 4: {
                    message.PlayerDragonTotalChip = reader.uint64();
                    break;
                }
            case 5: {
                    message.PlayerTigerTotalChip = reader.uint64();
                    break;
                }
            case 6: {
                    message.PlayerDrawTotalChip = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleBetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleBetInfo} BigBattleBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleBetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleBetInfo message.
     * @function verify
     * @memberof BigBattleBetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleBetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DragonTotalBetChip != null && message.hasOwnProperty("DragonTotalBetChip"))
            if (!$util.isInteger(message.DragonTotalBetChip) && !(message.DragonTotalBetChip && $util.isInteger(message.DragonTotalBetChip.low) && $util.isInteger(message.DragonTotalBetChip.high)))
                return "DragonTotalBetChip: integer|Long expected";
        if (message.TigerTotalBetChip != null && message.hasOwnProperty("TigerTotalBetChip"))
            if (!$util.isInteger(message.TigerTotalBetChip) && !(message.TigerTotalBetChip && $util.isInteger(message.TigerTotalBetChip.low) && $util.isInteger(message.TigerTotalBetChip.high)))
                return "TigerTotalBetChip: integer|Long expected";
        if (message.DrawTotalBetChip != null && message.hasOwnProperty("DrawTotalBetChip"))
            if (!$util.isInteger(message.DrawTotalBetChip) && !(message.DrawTotalBetChip && $util.isInteger(message.DrawTotalBetChip.low) && $util.isInteger(message.DrawTotalBetChip.high)))
                return "DrawTotalBetChip: integer|Long expected";
        if (message.PlayerDragonTotalChip != null && message.hasOwnProperty("PlayerDragonTotalChip"))
            if (!$util.isInteger(message.PlayerDragonTotalChip) && !(message.PlayerDragonTotalChip && $util.isInteger(message.PlayerDragonTotalChip.low) && $util.isInteger(message.PlayerDragonTotalChip.high)))
                return "PlayerDragonTotalChip: integer|Long expected";
        if (message.PlayerTigerTotalChip != null && message.hasOwnProperty("PlayerTigerTotalChip"))
            if (!$util.isInteger(message.PlayerTigerTotalChip) && !(message.PlayerTigerTotalChip && $util.isInteger(message.PlayerTigerTotalChip.low) && $util.isInteger(message.PlayerTigerTotalChip.high)))
                return "PlayerTigerTotalChip: integer|Long expected";
        if (message.PlayerDrawTotalChip != null && message.hasOwnProperty("PlayerDrawTotalChip"))
            if (!$util.isInteger(message.PlayerDrawTotalChip) && !(message.PlayerDrawTotalChip && $util.isInteger(message.PlayerDrawTotalChip.low) && $util.isInteger(message.PlayerDrawTotalChip.high)))
                return "PlayerDrawTotalChip: integer|Long expected";
        return null;
    };

    /**
     * Creates a BigBattleBetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleBetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleBetInfo} BigBattleBetInfo
     */
    BigBattleBetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleBetInfo)
            return object;
        let message = new $root.BigBattleBetInfo();
        if (object.DragonTotalBetChip != null)
            if ($util.Long)
                (message.DragonTotalBetChip = $util.Long.fromValue(object.DragonTotalBetChip)).unsigned = true;
            else if (typeof object.DragonTotalBetChip === "string")
                message.DragonTotalBetChip = parseInt(object.DragonTotalBetChip, 10);
            else if (typeof object.DragonTotalBetChip === "number")
                message.DragonTotalBetChip = object.DragonTotalBetChip;
            else if (typeof object.DragonTotalBetChip === "object")
                message.DragonTotalBetChip = new $util.LongBits(object.DragonTotalBetChip.low >>> 0, object.DragonTotalBetChip.high >>> 0).toNumber(true);
        if (object.TigerTotalBetChip != null)
            if ($util.Long)
                (message.TigerTotalBetChip = $util.Long.fromValue(object.TigerTotalBetChip)).unsigned = true;
            else if (typeof object.TigerTotalBetChip === "string")
                message.TigerTotalBetChip = parseInt(object.TigerTotalBetChip, 10);
            else if (typeof object.TigerTotalBetChip === "number")
                message.TigerTotalBetChip = object.TigerTotalBetChip;
            else if (typeof object.TigerTotalBetChip === "object")
                message.TigerTotalBetChip = new $util.LongBits(object.TigerTotalBetChip.low >>> 0, object.TigerTotalBetChip.high >>> 0).toNumber(true);
        if (object.DrawTotalBetChip != null)
            if ($util.Long)
                (message.DrawTotalBetChip = $util.Long.fromValue(object.DrawTotalBetChip)).unsigned = true;
            else if (typeof object.DrawTotalBetChip === "string")
                message.DrawTotalBetChip = parseInt(object.DrawTotalBetChip, 10);
            else if (typeof object.DrawTotalBetChip === "number")
                message.DrawTotalBetChip = object.DrawTotalBetChip;
            else if (typeof object.DrawTotalBetChip === "object")
                message.DrawTotalBetChip = new $util.LongBits(object.DrawTotalBetChip.low >>> 0, object.DrawTotalBetChip.high >>> 0).toNumber(true);
        if (object.PlayerDragonTotalChip != null)
            if ($util.Long)
                (message.PlayerDragonTotalChip = $util.Long.fromValue(object.PlayerDragonTotalChip)).unsigned = true;
            else if (typeof object.PlayerDragonTotalChip === "string")
                message.PlayerDragonTotalChip = parseInt(object.PlayerDragonTotalChip, 10);
            else if (typeof object.PlayerDragonTotalChip === "number")
                message.PlayerDragonTotalChip = object.PlayerDragonTotalChip;
            else if (typeof object.PlayerDragonTotalChip === "object")
                message.PlayerDragonTotalChip = new $util.LongBits(object.PlayerDragonTotalChip.low >>> 0, object.PlayerDragonTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerTigerTotalChip != null)
            if ($util.Long)
                (message.PlayerTigerTotalChip = $util.Long.fromValue(object.PlayerTigerTotalChip)).unsigned = true;
            else if (typeof object.PlayerTigerTotalChip === "string")
                message.PlayerTigerTotalChip = parseInt(object.PlayerTigerTotalChip, 10);
            else if (typeof object.PlayerTigerTotalChip === "number")
                message.PlayerTigerTotalChip = object.PlayerTigerTotalChip;
            else if (typeof object.PlayerTigerTotalChip === "object")
                message.PlayerTigerTotalChip = new $util.LongBits(object.PlayerTigerTotalChip.low >>> 0, object.PlayerTigerTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerDrawTotalChip != null)
            if ($util.Long)
                (message.PlayerDrawTotalChip = $util.Long.fromValue(object.PlayerDrawTotalChip)).unsigned = true;
            else if (typeof object.PlayerDrawTotalChip === "string")
                message.PlayerDrawTotalChip = parseInt(object.PlayerDrawTotalChip, 10);
            else if (typeof object.PlayerDrawTotalChip === "number")
                message.PlayerDrawTotalChip = object.PlayerDrawTotalChip;
            else if (typeof object.PlayerDrawTotalChip === "object")
                message.PlayerDrawTotalChip = new $util.LongBits(object.PlayerDrawTotalChip.low >>> 0, object.PlayerDrawTotalChip.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleBetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleBetInfo
     * @static
     * @param {BigBattleBetInfo} message BigBattleBetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleBetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.DragonTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.DragonTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TigerTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TigerTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.DrawTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.DrawTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerDragonTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerDragonTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerTigerTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerTigerTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerDrawTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerDrawTotalChip = options.longs === String ? "0" : 0;
        }
        if (message.DragonTotalBetChip != null && message.hasOwnProperty("DragonTotalBetChip"))
            if (typeof message.DragonTotalBetChip === "number")
                object.DragonTotalBetChip = options.longs === String ? String(message.DragonTotalBetChip) : message.DragonTotalBetChip;
            else
                object.DragonTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.DragonTotalBetChip) : options.longs === Number ? new $util.LongBits(message.DragonTotalBetChip.low >>> 0, message.DragonTotalBetChip.high >>> 0).toNumber(true) : message.DragonTotalBetChip;
        if (message.TigerTotalBetChip != null && message.hasOwnProperty("TigerTotalBetChip"))
            if (typeof message.TigerTotalBetChip === "number")
                object.TigerTotalBetChip = options.longs === String ? String(message.TigerTotalBetChip) : message.TigerTotalBetChip;
            else
                object.TigerTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.TigerTotalBetChip) : options.longs === Number ? new $util.LongBits(message.TigerTotalBetChip.low >>> 0, message.TigerTotalBetChip.high >>> 0).toNumber(true) : message.TigerTotalBetChip;
        if (message.DrawTotalBetChip != null && message.hasOwnProperty("DrawTotalBetChip"))
            if (typeof message.DrawTotalBetChip === "number")
                object.DrawTotalBetChip = options.longs === String ? String(message.DrawTotalBetChip) : message.DrawTotalBetChip;
            else
                object.DrawTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.DrawTotalBetChip) : options.longs === Number ? new $util.LongBits(message.DrawTotalBetChip.low >>> 0, message.DrawTotalBetChip.high >>> 0).toNumber(true) : message.DrawTotalBetChip;
        if (message.PlayerDragonTotalChip != null && message.hasOwnProperty("PlayerDragonTotalChip"))
            if (typeof message.PlayerDragonTotalChip === "number")
                object.PlayerDragonTotalChip = options.longs === String ? String(message.PlayerDragonTotalChip) : message.PlayerDragonTotalChip;
            else
                object.PlayerDragonTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerDragonTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerDragonTotalChip.low >>> 0, message.PlayerDragonTotalChip.high >>> 0).toNumber(true) : message.PlayerDragonTotalChip;
        if (message.PlayerTigerTotalChip != null && message.hasOwnProperty("PlayerTigerTotalChip"))
            if (typeof message.PlayerTigerTotalChip === "number")
                object.PlayerTigerTotalChip = options.longs === String ? String(message.PlayerTigerTotalChip) : message.PlayerTigerTotalChip;
            else
                object.PlayerTigerTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerTigerTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerTigerTotalChip.low >>> 0, message.PlayerTigerTotalChip.high >>> 0).toNumber(true) : message.PlayerTigerTotalChip;
        if (message.PlayerDrawTotalChip != null && message.hasOwnProperty("PlayerDrawTotalChip"))
            if (typeof message.PlayerDrawTotalChip === "number")
                object.PlayerDrawTotalChip = options.longs === String ? String(message.PlayerDrawTotalChip) : message.PlayerDrawTotalChip;
            else
                object.PlayerDrawTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerDrawTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerDrawTotalChip.low >>> 0, message.PlayerDrawTotalChip.high >>> 0).toNumber(true) : message.PlayerDrawTotalChip;
        return object;
    };

    /**
     * Converts this BigBattleBetInfo to JSON.
     * @function toJSON
     * @memberof BigBattleBetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleBetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleBetInfo
     * @function getTypeUrl
     * @memberof BigBattleBetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleBetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleBetInfo";
    };

    return BigBattleBetInfo;
})();

export const Desk2BigBattleSrvPushPlayingInfo = $root.Desk2BigBattleSrvPushPlayingInfo = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushPlayingInfo.
     * @exports IDesk2BigBattleSrvPushPlayingInfo
     * @interface IDesk2BigBattleSrvPushPlayingInfo
     * @property {number|null} [UserID] Desk2BigBattleSrvPushPlayingInfo UserID
     * @property {number|null} [StateID] Desk2BigBattleSrvPushPlayingInfo StateID
     * @property {Array.<number>|null} [GamingIDs] Desk2BigBattleSrvPushPlayingInfo GamingIDs
     * @property {Array.<number>|null} [PlayerBetIDs] Desk2BigBattleSrvPushPlayingInfo PlayerBetIDs
     * @property {IBigBattleBetInfo|null} [RoundBetInfo] Desk2BigBattleSrvPushPlayingInfo RoundBetInfo
     * @property {Array.<IBigBattleGameCard>|null} [GameCard] Desk2BigBattleSrvPushPlayingInfo GameCard
     * @property {number|null} [CardResult] Desk2BigBattleSrvPushPlayingInfo CardResult
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushPlayingInfo.
     * @exports Desk2BigBattleSrvPushPlayingInfo
     * @classdesc Represents a Desk2BigBattleSrvPushPlayingInfo.
     * @implements IDesk2BigBattleSrvPushPlayingInfo
     * @constructor
     * @param {IDesk2BigBattleSrvPushPlayingInfo=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushPlayingInfo(properties) {
        this.GamingIDs = [];
        this.PlayerBetIDs = [];
        this.GameCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.UserID = 0;

    /**
     * Desk2BigBattleSrvPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.StateID = 0;

    /**
     * Desk2BigBattleSrvPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * Desk2BigBattleSrvPushPlayingInfo PlayerBetIDs.
     * @member {Array.<number>} PlayerBetIDs
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.PlayerBetIDs = $util.emptyArray;

    /**
     * Desk2BigBattleSrvPushPlayingInfo RoundBetInfo.
     * @member {IBigBattleBetInfo|null|undefined} RoundBetInfo
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.RoundBetInfo = null;

    /**
     * Desk2BigBattleSrvPushPlayingInfo GameCard.
     * @member {Array.<IBigBattleGameCard>} GameCard
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.GameCard = $util.emptyArray;

    /**
     * Desk2BigBattleSrvPushPlayingInfo CardResult.
     * @member {number} CardResult
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.CardResult = 0;

    /**
     * Creates a new Desk2BigBattleSrvPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {IDesk2BigBattleSrvPushPlayingInfo=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushPlayingInfo} Desk2BigBattleSrvPushPlayingInfo instance
     */
    Desk2BigBattleSrvPushPlayingInfo.create = function create(properties) {
        return new Desk2BigBattleSrvPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushPlayingInfo message. Does not implicitly {@link Desk2BigBattleSrvPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {IDesk2BigBattleSrvPushPlayingInfo} message Desk2BigBattleSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.PlayerBetIDs != null && message.PlayerBetIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                writer.uint32(message.PlayerBetIDs[i]);
            writer.ldelim();
        }
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.BigBattleBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.GameCard != null && message.GameCard.length)
            for (let i = 0; i < message.GameCard.length; ++i)
                $root.BigBattleGameCard.encode(message.GameCard[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.CardResult != null && Object.hasOwnProperty.call(message, "CardResult"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.CardResult);
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushPlayingInfo message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {IDesk2BigBattleSrvPushPlayingInfo} message Desk2BigBattleSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushPlayingInfo} Desk2BigBattleSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.PlayerBetIDs && message.PlayerBetIDs.length))
                        message.PlayerBetIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PlayerBetIDs.push(reader.uint32());
                    } else
                        message.PlayerBetIDs.push(reader.uint32());
                    break;
                }
            case 5: {
                    message.RoundBetInfo = $root.BigBattleBetInfo.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.GameCard && message.GameCard.length))
                        message.GameCard = [];
                    message.GameCard.push($root.BigBattleGameCard.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.CardResult = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushPlayingInfo} Desk2BigBattleSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushPlayingInfo message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.PlayerBetIDs != null && message.hasOwnProperty("PlayerBetIDs")) {
            if (!Array.isArray(message.PlayerBetIDs))
                return "PlayerBetIDs: array expected";
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                if (!$util.isInteger(message.PlayerBetIDs[i]))
                    return "PlayerBetIDs: integer[] expected";
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.BigBattleBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        if (message.GameCard != null && message.hasOwnProperty("GameCard")) {
            if (!Array.isArray(message.GameCard))
                return "GameCard: array expected";
            for (let i = 0; i < message.GameCard.length; ++i) {
                let error = $root.BigBattleGameCard.verify(message.GameCard[i]);
                if (error)
                    return "GameCard." + error;
            }
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult"))
            if (!$util.isInteger(message.CardResult))
                return "CardResult: integer expected";
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushPlayingInfo} Desk2BigBattleSrvPushPlayingInfo
     */
    Desk2BigBattleSrvPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushPlayingInfo)
            return object;
        let message = new $root.Desk2BigBattleSrvPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".Desk2BigBattleSrvPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.PlayerBetIDs) {
            if (!Array.isArray(object.PlayerBetIDs))
                throw TypeError(".Desk2BigBattleSrvPushPlayingInfo.PlayerBetIDs: array expected");
            message.PlayerBetIDs = [];
            for (let i = 0; i < object.PlayerBetIDs.length; ++i)
                message.PlayerBetIDs[i] = object.PlayerBetIDs[i] >>> 0;
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Desk2BigBattleSrvPushPlayingInfo.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.BigBattleBetInfo.fromObject(object.RoundBetInfo);
        }
        if (object.GameCard) {
            if (!Array.isArray(object.GameCard))
                throw TypeError(".Desk2BigBattleSrvPushPlayingInfo.GameCard: array expected");
            message.GameCard = [];
            for (let i = 0; i < object.GameCard.length; ++i) {
                if (typeof object.GameCard[i] !== "object")
                    throw TypeError(".Desk2BigBattleSrvPushPlayingInfo.GameCard: object expected");
                message.GameCard[i] = $root.BigBattleGameCard.fromObject(object.GameCard[i]);
            }
        }
        if (object.CardResult != null)
            message.CardResult = object.CardResult >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {Desk2BigBattleSrvPushPlayingInfo} message Desk2BigBattleSrvPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.PlayerBetIDs = [];
            object.GameCard = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.RoundBetInfo = null;
            object.CardResult = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.PlayerBetIDs && message.PlayerBetIDs.length) {
            object.PlayerBetIDs = [];
            for (let j = 0; j < message.PlayerBetIDs.length; ++j)
                object.PlayerBetIDs[j] = message.PlayerBetIDs[j];
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.BigBattleBetInfo.toObject(message.RoundBetInfo, options);
        if (message.GameCard && message.GameCard.length) {
            object.GameCard = [];
            for (let j = 0; j < message.GameCard.length; ++j)
                object.GameCard[j] = $root.BigBattleGameCard.toObject(message.GameCard[j], options);
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult"))
            object.CardResult = message.CardResult;
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushPlayingInfo
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushPlayingInfo";
    };

    return Desk2BigBattleSrvPushPlayingInfo;
})();

/**
 * BigBattleBetType enum.
 * @exports BigBattleBetType
 * @enum {number}
 * @property {number} Bet_Type_NULL=0 Bet_Type_NULL value
 * @property {number} Bet_Type_Dragon=1 Bet_Type_Dragon value
 * @property {number} Bet_Type_Tiger=2 Bet_Type_Tiger value
 * @property {number} Bet_Type_Draw=3 Bet_Type_Draw value
 */
export const BigBattleBetType = $root.BigBattleBetType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bet_Type_NULL"] = 0;
    values[valuesById[1] = "Bet_Type_Dragon"] = 1;
    values[valuesById[2] = "Bet_Type_Tiger"] = 2;
    values[valuesById[3] = "Bet_Type_Draw"] = 3;
    return values;
})();

export const PlayerBigBattleBet = $root.PlayerBigBattleBet = (() => {

    /**
     * Properties of a PlayerBigBattleBet.
     * @exports IPlayerBigBattleBet
     * @interface IPlayerBigBattleBet
     * @property {number|null} [BetType] PlayerBigBattleBet BetType
     * @property {number|null} [Chip] PlayerBigBattleBet Chip
     */

    /**
     * Constructs a new PlayerBigBattleBet.
     * @exports PlayerBigBattleBet
     * @classdesc Represents a PlayerBigBattleBet.
     * @implements IPlayerBigBattleBet
     * @constructor
     * @param {IPlayerBigBattleBet=} [properties] Properties to set
     */
    function PlayerBigBattleBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerBigBattleBet BetType.
     * @member {number} BetType
     * @memberof PlayerBigBattleBet
     * @instance
     */
    PlayerBigBattleBet.prototype.BetType = 0;

    /**
     * PlayerBigBattleBet Chip.
     * @member {number} Chip
     * @memberof PlayerBigBattleBet
     * @instance
     */
    PlayerBigBattleBet.prototype.Chip = 0;

    /**
     * Creates a new PlayerBigBattleBet instance using the specified properties.
     * @function create
     * @memberof PlayerBigBattleBet
     * @static
     * @param {IPlayerBigBattleBet=} [properties] Properties to set
     * @returns {PlayerBigBattleBet} PlayerBigBattleBet instance
     */
    PlayerBigBattleBet.create = function create(properties) {
        return new PlayerBigBattleBet(properties);
    };

    /**
     * Encodes the specified PlayerBigBattleBet message. Does not implicitly {@link PlayerBigBattleBet.verify|verify} messages.
     * @function encode
     * @memberof PlayerBigBattleBet
     * @static
     * @param {IPlayerBigBattleBet} message PlayerBigBattleBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerBigBattleBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.BetType);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified PlayerBigBattleBet message, length delimited. Does not implicitly {@link PlayerBigBattleBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerBigBattleBet
     * @static
     * @param {IPlayerBigBattleBet} message PlayerBigBattleBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerBigBattleBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerBigBattleBet message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerBigBattleBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerBigBattleBet} PlayerBigBattleBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerBigBattleBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerBigBattleBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetType = reader.uint32();
                    break;
                }
            case 2: {
                    message.Chip = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerBigBattleBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerBigBattleBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerBigBattleBet} PlayerBigBattleBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerBigBattleBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerBigBattleBet message.
     * @function verify
     * @memberof PlayerBigBattleBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerBigBattleBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isInteger(message.Chip))
                return "Chip: integer expected";
        return null;
    };

    /**
     * Creates a PlayerBigBattleBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerBigBattleBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerBigBattleBet} PlayerBigBattleBet
     */
    PlayerBigBattleBet.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerBigBattleBet)
            return object;
        let message = new $root.PlayerBigBattleBet();
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        if (object.Chip != null)
            message.Chip = object.Chip >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PlayerBigBattleBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerBigBattleBet
     * @static
     * @param {PlayerBigBattleBet} message PlayerBigBattleBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerBigBattleBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetType = 0;
            object.Chip = 0;
        }
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this PlayerBigBattleBet to JSON.
     * @function toJSON
     * @memberof PlayerBigBattleBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerBigBattleBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerBigBattleBet
     * @function getTypeUrl
     * @memberof PlayerBigBattleBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerBigBattleBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerBigBattleBet";
    };

    return PlayerBigBattleBet;
})();

export const Client2BattleSrvReqBet = $root.Client2BattleSrvReqBet = (() => {

    /**
     * Properties of a Client2BattleSrvReqBet.
     * @exports IClient2BattleSrvReqBet
     * @interface IClient2BattleSrvReqBet
     * @property {number|null} [DeskNo] Client2BattleSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2BattleSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2BattleSrvReqBet SeatNo
     * @property {Array.<IPlayerBigBattleBet>|null} [BetList] Client2BattleSrvReqBet BetList
     */

    /**
     * Constructs a new Client2BattleSrvReqBet.
     * @exports Client2BattleSrvReqBet
     * @classdesc Represents a Client2BattleSrvReqBet.
     * @implements IClient2BattleSrvReqBet
     * @constructor
     * @param {IClient2BattleSrvReqBet=} [properties] Properties to set
     */
    function Client2BattleSrvReqBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2BattleSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2BattleSrvReqBet
     * @instance
     */
    Client2BattleSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2BattleSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2BattleSrvReqBet
     * @instance
     */
    Client2BattleSrvReqBet.prototype.UserID = 0;

    /**
     * Client2BattleSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2BattleSrvReqBet
     * @instance
     */
    Client2BattleSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2BattleSrvReqBet BetList.
     * @member {Array.<IPlayerBigBattleBet>} BetList
     * @memberof Client2BattleSrvReqBet
     * @instance
     */
    Client2BattleSrvReqBet.prototype.BetList = $util.emptyArray;

    /**
     * Creates a new Client2BattleSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {IClient2BattleSrvReqBet=} [properties] Properties to set
     * @returns {Client2BattleSrvReqBet} Client2BattleSrvReqBet instance
     */
    Client2BattleSrvReqBet.create = function create(properties) {
        return new Client2BattleSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2BattleSrvReqBet message. Does not implicitly {@link Client2BattleSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {IClient2BattleSrvReqBet} message Client2BattleSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2BattleSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerBigBattleBet.encode(message.BetList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2BattleSrvReqBet message, length delimited. Does not implicitly {@link Client2BattleSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {IClient2BattleSrvReqBet} message Client2BattleSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2BattleSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2BattleSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2BattleSrvReqBet} Client2BattleSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2BattleSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2BattleSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerBigBattleBet.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2BattleSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2BattleSrvReqBet} Client2BattleSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2BattleSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2BattleSrvReqBet message.
     * @function verify
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2BattleSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerBigBattleBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2BattleSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2BattleSrvReqBet} Client2BattleSrvReqBet
     */
    Client2BattleSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2BattleSrvReqBet)
            return object;
        let message = new $root.Client2BattleSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2BattleSrvReqBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2BattleSrvReqBet.BetList: object expected");
                message.BetList[i] = $root.PlayerBigBattleBet.fromObject(object.BetList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2BattleSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {Client2BattleSrvReqBet} message Client2BattleSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2BattleSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerBigBattleBet.toObject(message.BetList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2BattleSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2BattleSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2BattleSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2BattleSrvReqBet
     * @function getTypeUrl
     * @memberof Client2BattleSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2BattleSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2BattleSrvReqBet";
    };

    return Client2BattleSrvReqBet;
})();

export const Client2BattleSrvAckBet = $root.Client2BattleSrvAckBet = (() => {

    /**
     * Properties of a Client2BattleSrvAckBet.
     * @exports IClient2BattleSrvAckBet
     * @interface IClient2BattleSrvAckBet
     * @property {number|null} [Ret] Client2BattleSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2BattleSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2BattleSrvAckBet UserID
     * @property {string|null} [Chip] Client2BattleSrvAckBet Chip
     * @property {number|null} [SeatNo] Client2BattleSrvAckBet SeatNo
     * @property {Array.<IPlayerBigBattleBet>|null} [BetList] Client2BattleSrvAckBet BetList
     * @property {IBigBattleBetInfo|null} [RoundBetInfo] Client2BattleSrvAckBet RoundBetInfo
     */

    /**
     * Constructs a new Client2BattleSrvAckBet.
     * @exports Client2BattleSrvAckBet
     * @classdesc Represents a Client2BattleSrvAckBet.
     * @implements IClient2BattleSrvAckBet
     * @constructor
     * @param {IClient2BattleSrvAckBet=} [properties] Properties to set
     */
    function Client2BattleSrvAckBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2BattleSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.Ret = 0;

    /**
     * Client2BattleSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2BattleSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.UserID = 0;

    /**
     * Client2BattleSrvAckBet Chip.
     * @member {string} Chip
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.Chip = "";

    /**
     * Client2BattleSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2BattleSrvAckBet BetList.
     * @member {Array.<IPlayerBigBattleBet>} BetList
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.BetList = $util.emptyArray;

    /**
     * Client2BattleSrvAckBet RoundBetInfo.
     * @member {IBigBattleBetInfo|null|undefined} RoundBetInfo
     * @memberof Client2BattleSrvAckBet
     * @instance
     */
    Client2BattleSrvAckBet.prototype.RoundBetInfo = null;

    /**
     * Creates a new Client2BattleSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {IClient2BattleSrvAckBet=} [properties] Properties to set
     * @returns {Client2BattleSrvAckBet} Client2BattleSrvAckBet instance
     */
    Client2BattleSrvAckBet.create = function create(properties) {
        return new Client2BattleSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2BattleSrvAckBet message. Does not implicitly {@link Client2BattleSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {IClient2BattleSrvAckBet} message Client2BattleSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2BattleSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerBigBattleBet.encode(message.BetList[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.BigBattleBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2BattleSrvAckBet message, length delimited. Does not implicitly {@link Client2BattleSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {IClient2BattleSrvAckBet} message Client2BattleSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2BattleSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2BattleSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2BattleSrvAckBet} Client2BattleSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2BattleSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2BattleSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 6: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerBigBattleBet.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.RoundBetInfo = $root.BigBattleBetInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2BattleSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2BattleSrvAckBet} Client2BattleSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2BattleSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2BattleSrvAckBet message.
     * @function verify
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2BattleSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerBigBattleBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.BigBattleBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        return null;
    };

    /**
     * Creates a Client2BattleSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2BattleSrvAckBet} Client2BattleSrvAckBet
     */
    Client2BattleSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2BattleSrvAckBet)
            return object;
        let message = new $root.Client2BattleSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2BattleSrvAckBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2BattleSrvAckBet.BetList: object expected");
                message.BetList[i] = $root.PlayerBigBattleBet.fromObject(object.BetList[i]);
            }
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Client2BattleSrvAckBet.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.BigBattleBetInfo.fromObject(object.RoundBetInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2BattleSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {Client2BattleSrvAckBet} message Client2BattleSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2BattleSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.Chip = "";
            object.SeatNo = 0;
            object.RoundBetInfo = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerBigBattleBet.toObject(message.BetList[j], options);
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.BigBattleBetInfo.toObject(message.RoundBetInfo, options);
        return object;
    };

    /**
     * Converts this Client2BattleSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2BattleSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2BattleSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2BattleSrvAckBet
     * @function getTypeUrl
     * @memberof Client2BattleSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2BattleSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2BattleSrvAckBet";
    };

    return Client2BattleSrvAckBet;
})();

export const BigBattleCard = $root.BigBattleCard = (() => {

    /**
     * Properties of a BigBattleCard.
     * @exports IBigBattleCard
     * @interface IBigBattleCard
     * @property {number|null} [ID] BigBattleCard ID
     */

    /**
     * Constructs a new BigBattleCard.
     * @exports BigBattleCard
     * @classdesc Represents a BigBattleCard.
     * @implements IBigBattleCard
     * @constructor
     * @param {IBigBattleCard=} [properties] Properties to set
     */
    function BigBattleCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleCard ID.
     * @member {number} ID
     * @memberof BigBattleCard
     * @instance
     */
    BigBattleCard.prototype.ID = 0;

    /**
     * Creates a new BigBattleCard instance using the specified properties.
     * @function create
     * @memberof BigBattleCard
     * @static
     * @param {IBigBattleCard=} [properties] Properties to set
     * @returns {BigBattleCard} BigBattleCard instance
     */
    BigBattleCard.create = function create(properties) {
        return new BigBattleCard(properties);
    };

    /**
     * Encodes the specified BigBattleCard message. Does not implicitly {@link BigBattleCard.verify|verify} messages.
     * @function encode
     * @memberof BigBattleCard
     * @static
     * @param {IBigBattleCard} message BigBattleCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
        return writer;
    };

    /**
     * Encodes the specified BigBattleCard message, length delimited. Does not implicitly {@link BigBattleCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleCard
     * @static
     * @param {IBigBattleCard} message BigBattleCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleCard message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleCard} BigBattleCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleCard} BigBattleCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleCard message.
     * @function verify
     * @memberof BigBattleCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        return null;
    };

    /**
     * Creates a BigBattleCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleCard} BigBattleCard
     */
    BigBattleCard.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleCard)
            return object;
        let message = new $root.BigBattleCard();
        if (object.ID != null)
            message.ID = object.ID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a BigBattleCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleCard
     * @static
     * @param {BigBattleCard} message BigBattleCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.ID = 0;
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        return object;
    };

    /**
     * Converts this BigBattleCard to JSON.
     * @function toJSON
     * @memberof BigBattleCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleCard
     * @function getTypeUrl
     * @memberof BigBattleCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleCard";
    };

    return BigBattleCard;
})();

export const BigBattleGameCard = $root.BigBattleGameCard = (() => {

    /**
     * Properties of a BigBattleGameCard.
     * @exports IBigBattleGameCard
     * @interface IBigBattleGameCard
     * @property {IBigBattleCard|null} [Card] BigBattleGameCard Card
     * @property {number|null} [Type] BigBattleGameCard Type
     */

    /**
     * Constructs a new BigBattleGameCard.
     * @exports BigBattleGameCard
     * @classdesc Represents a BigBattleGameCard.
     * @implements IBigBattleGameCard
     * @constructor
     * @param {IBigBattleGameCard=} [properties] Properties to set
     */
    function BigBattleGameCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleGameCard Card.
     * @member {IBigBattleCard|null|undefined} Card
     * @memberof BigBattleGameCard
     * @instance
     */
    BigBattleGameCard.prototype.Card = null;

    /**
     * BigBattleGameCard Type.
     * @member {number} Type
     * @memberof BigBattleGameCard
     * @instance
     */
    BigBattleGameCard.prototype.Type = 0;

    /**
     * Creates a new BigBattleGameCard instance using the specified properties.
     * @function create
     * @memberof BigBattleGameCard
     * @static
     * @param {IBigBattleGameCard=} [properties] Properties to set
     * @returns {BigBattleGameCard} BigBattleGameCard instance
     */
    BigBattleGameCard.create = function create(properties) {
        return new BigBattleGameCard(properties);
    };

    /**
     * Encodes the specified BigBattleGameCard message. Does not implicitly {@link BigBattleGameCard.verify|verify} messages.
     * @function encode
     * @memberof BigBattleGameCard
     * @static
     * @param {IBigBattleGameCard} message BigBattleGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleGameCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Card != null && Object.hasOwnProperty.call(message, "Card"))
            $root.BigBattleCard.encode(message.Card, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified BigBattleGameCard message, length delimited. Does not implicitly {@link BigBattleGameCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleGameCard
     * @static
     * @param {IBigBattleGameCard} message BigBattleGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleGameCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleGameCard message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleGameCard} BigBattleGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleGameCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleGameCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Card = $root.BigBattleCard.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleGameCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleGameCard} BigBattleGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleGameCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleGameCard message.
     * @function verify
     * @memberof BigBattleGameCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleGameCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Card != null && message.hasOwnProperty("Card")) {
            let error = $root.BigBattleCard.verify(message.Card);
            if (error)
                return "Card." + error;
        }
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a BigBattleGameCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleGameCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleGameCard} BigBattleGameCard
     */
    BigBattleGameCard.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleGameCard)
            return object;
        let message = new $root.BigBattleGameCard();
        if (object.Card != null) {
            if (typeof object.Card !== "object")
                throw TypeError(".BigBattleGameCard.Card: object expected");
            message.Card = $root.BigBattleCard.fromObject(object.Card);
        }
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a BigBattleGameCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleGameCard
     * @static
     * @param {BigBattleGameCard} message BigBattleGameCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleGameCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Card = null;
            object.Type = 0;
        }
        if (message.Card != null && message.hasOwnProperty("Card"))
            object.Card = $root.BigBattleCard.toObject(message.Card, options);
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this BigBattleGameCard to JSON.
     * @function toJSON
     * @memberof BigBattleGameCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleGameCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleGameCard
     * @function getTypeUrl
     * @memberof BigBattleGameCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleGameCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleGameCard";
    };

    return BigBattleGameCard;
})();

export const Desk2BigBattleSrvPushGameCard = $root.Desk2BigBattleSrvPushGameCard = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushGameCard.
     * @exports IDesk2BigBattleSrvPushGameCard
     * @interface IDesk2BigBattleSrvPushGameCard
     * @property {number|null} [UserID] Desk2BigBattleSrvPushGameCard UserID
     * @property {number|null} [Result] Desk2BigBattleSrvPushGameCard Result
     * @property {Array.<IBigBattleGameCard>|null} [GameCard] Desk2BigBattleSrvPushGameCard GameCard
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushGameCard.
     * @exports Desk2BigBattleSrvPushGameCard
     * @classdesc Represents a Desk2BigBattleSrvPushGameCard.
     * @implements IDesk2BigBattleSrvPushGameCard
     * @constructor
     * @param {IDesk2BigBattleSrvPushGameCard=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushGameCard(properties) {
        this.GameCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushGameCard UserID.
     * @member {number} UserID
     * @memberof Desk2BigBattleSrvPushGameCard
     * @instance
     */
    Desk2BigBattleSrvPushGameCard.prototype.UserID = 0;

    /**
     * Desk2BigBattleSrvPushGameCard Result.
     * @member {number} Result
     * @memberof Desk2BigBattleSrvPushGameCard
     * @instance
     */
    Desk2BigBattleSrvPushGameCard.prototype.Result = 0;

    /**
     * Desk2BigBattleSrvPushGameCard GameCard.
     * @member {Array.<IBigBattleGameCard>} GameCard
     * @memberof Desk2BigBattleSrvPushGameCard
     * @instance
     */
    Desk2BigBattleSrvPushGameCard.prototype.GameCard = $util.emptyArray;

    /**
     * Creates a new Desk2BigBattleSrvPushGameCard instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {IDesk2BigBattleSrvPushGameCard=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushGameCard} Desk2BigBattleSrvPushGameCard instance
     */
    Desk2BigBattleSrvPushGameCard.create = function create(properties) {
        return new Desk2BigBattleSrvPushGameCard(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushGameCard message. Does not implicitly {@link Desk2BigBattleSrvPushGameCard.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {IDesk2BigBattleSrvPushGameCard} message Desk2BigBattleSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushGameCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Result != null && Object.hasOwnProperty.call(message, "Result"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Result);
        if (message.GameCard != null && message.GameCard.length)
            for (let i = 0; i < message.GameCard.length; ++i)
                $root.BigBattleGameCard.encode(message.GameCard[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushGameCard message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushGameCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {IDesk2BigBattleSrvPushGameCard} message Desk2BigBattleSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushGameCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushGameCard message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushGameCard} Desk2BigBattleSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushGameCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushGameCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Result = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GameCard && message.GameCard.length))
                        message.GameCard = [];
                    message.GameCard.push($root.BigBattleGameCard.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushGameCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushGameCard} Desk2BigBattleSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushGameCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushGameCard message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushGameCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Result != null && message.hasOwnProperty("Result"))
            if (!$util.isInteger(message.Result))
                return "Result: integer expected";
        if (message.GameCard != null && message.hasOwnProperty("GameCard")) {
            if (!Array.isArray(message.GameCard))
                return "GameCard: array expected";
            for (let i = 0; i < message.GameCard.length; ++i) {
                let error = $root.BigBattleGameCard.verify(message.GameCard[i]);
                if (error)
                    return "GameCard." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushGameCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushGameCard} Desk2BigBattleSrvPushGameCard
     */
    Desk2BigBattleSrvPushGameCard.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushGameCard)
            return object;
        let message = new $root.Desk2BigBattleSrvPushGameCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Result != null)
            message.Result = object.Result >>> 0;
        if (object.GameCard) {
            if (!Array.isArray(object.GameCard))
                throw TypeError(".Desk2BigBattleSrvPushGameCard.GameCard: array expected");
            message.GameCard = [];
            for (let i = 0; i < object.GameCard.length; ++i) {
                if (typeof object.GameCard[i] !== "object")
                    throw TypeError(".Desk2BigBattleSrvPushGameCard.GameCard: object expected");
                message.GameCard[i] = $root.BigBattleGameCard.fromObject(object.GameCard[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushGameCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {Desk2BigBattleSrvPushGameCard} message Desk2BigBattleSrvPushGameCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushGameCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GameCard = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Result = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Result != null && message.hasOwnProperty("Result"))
            object.Result = message.Result;
        if (message.GameCard && message.GameCard.length) {
            object.GameCard = [];
            for (let j = 0; j < message.GameCard.length; ++j)
                object.GameCard[j] = $root.BigBattleGameCard.toObject(message.GameCard[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushGameCard to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushGameCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushGameCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushGameCard
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushGameCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushGameCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushGameCard";
    };

    return Desk2BigBattleSrvPushGameCard;
})();

export const BigBattleGoldRes = $root.BigBattleGoldRes = (() => {

    /**
     * Properties of a BigBattleGoldRes.
     * @exports IBigBattleGoldRes
     * @interface IBigBattleGoldRes
     * @property {number|null} [UserID] BigBattleGoldRes UserID
     * @property {string|null} [WinGold] BigBattleGoldRes WinGold
     * @property {string|null} [ChangeGold] BigBattleGoldRes ChangeGold
     * @property {string|null} [TotalEnterChip] BigBattleGoldRes TotalEnterChip
     */

    /**
     * Constructs a new BigBattleGoldRes.
     * @exports BigBattleGoldRes
     * @classdesc Represents a BigBattleGoldRes.
     * @implements IBigBattleGoldRes
     * @constructor
     * @param {IBigBattleGoldRes=} [properties] Properties to set
     */
    function BigBattleGoldRes(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleGoldRes UserID.
     * @member {number} UserID
     * @memberof BigBattleGoldRes
     * @instance
     */
    BigBattleGoldRes.prototype.UserID = 0;

    /**
     * BigBattleGoldRes WinGold.
     * @member {string} WinGold
     * @memberof BigBattleGoldRes
     * @instance
     */
    BigBattleGoldRes.prototype.WinGold = "";

    /**
     * BigBattleGoldRes ChangeGold.
     * @member {string} ChangeGold
     * @memberof BigBattleGoldRes
     * @instance
     */
    BigBattleGoldRes.prototype.ChangeGold = "";

    /**
     * BigBattleGoldRes TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof BigBattleGoldRes
     * @instance
     */
    BigBattleGoldRes.prototype.TotalEnterChip = "";

    /**
     * Creates a new BigBattleGoldRes instance using the specified properties.
     * @function create
     * @memberof BigBattleGoldRes
     * @static
     * @param {IBigBattleGoldRes=} [properties] Properties to set
     * @returns {BigBattleGoldRes} BigBattleGoldRes instance
     */
    BigBattleGoldRes.create = function create(properties) {
        return new BigBattleGoldRes(properties);
    };

    /**
     * Encodes the specified BigBattleGoldRes message. Does not implicitly {@link BigBattleGoldRes.verify|verify} messages.
     * @function encode
     * @memberof BigBattleGoldRes
     * @static
     * @param {IBigBattleGoldRes} message BigBattleGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleGoldRes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.WinGold);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        return writer;
    };

    /**
     * Encodes the specified BigBattleGoldRes message, length delimited. Does not implicitly {@link BigBattleGoldRes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleGoldRes
     * @static
     * @param {IBigBattleGoldRes} message BigBattleGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleGoldRes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleGoldRes message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleGoldRes} BigBattleGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleGoldRes.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleGoldRes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinGold = reader.string();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleGoldRes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleGoldRes} BigBattleGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleGoldRes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleGoldRes message.
     * @function verify
     * @memberof BigBattleGoldRes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleGoldRes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isString(message.WinGold))
                return "WinGold: string expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        return null;
    };

    /**
     * Creates a BigBattleGoldRes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleGoldRes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleGoldRes} BigBattleGoldRes
     */
    BigBattleGoldRes.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleGoldRes)
            return object;
        let message = new $root.BigBattleGoldRes();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinGold != null)
            message.WinGold = String(object.WinGold);
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a BigBattleGoldRes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleGoldRes
     * @static
     * @param {BigBattleGoldRes} message BigBattleGoldRes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleGoldRes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.WinGold = "";
            object.ChangeGold = "";
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        return object;
    };

    /**
     * Converts this BigBattleGoldRes to JSON.
     * @function toJSON
     * @memberof BigBattleGoldRes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleGoldRes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleGoldRes
     * @function getTypeUrl
     * @memberof BigBattleGoldRes
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleGoldRes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleGoldRes";
    };

    return BigBattleGoldRes;
})();

export const Desk2BigBattleSrvPushGameResult = $root.Desk2BigBattleSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushGameResult.
     * @exports IDesk2BigBattleSrvPushGameResult
     * @interface IDesk2BigBattleSrvPushGameResult
     * @property {number|null} [UserID] Desk2BigBattleSrvPushGameResult UserID
     * @property {Array.<IBigBattleGoldRes>|null} [GoldResult] Desk2BigBattleSrvPushGameResult GoldResult
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushGameResult.
     * @exports Desk2BigBattleSrvPushGameResult
     * @classdesc Represents a Desk2BigBattleSrvPushGameResult.
     * @implements IDesk2BigBattleSrvPushGameResult
     * @constructor
     * @param {IDesk2BigBattleSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushGameResult(properties) {
        this.GoldResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2BigBattleSrvPushGameResult
     * @instance
     */
    Desk2BigBattleSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2BigBattleSrvPushGameResult GoldResult.
     * @member {Array.<IBigBattleGoldRes>} GoldResult
     * @memberof Desk2BigBattleSrvPushGameResult
     * @instance
     */
    Desk2BigBattleSrvPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Creates a new Desk2BigBattleSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {IDesk2BigBattleSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushGameResult} Desk2BigBattleSrvPushGameResult instance
     */
    Desk2BigBattleSrvPushGameResult.create = function create(properties) {
        return new Desk2BigBattleSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushGameResult message. Does not implicitly {@link Desk2BigBattleSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {IDesk2BigBattleSrvPushGameResult} message Desk2BigBattleSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.BigBattleGoldRes.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {IDesk2BigBattleSrvPushGameResult} message Desk2BigBattleSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushGameResult} Desk2BigBattleSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.BigBattleGoldRes.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushGameResult} Desk2BigBattleSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushGameResult message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.BigBattleGoldRes.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushGameResult} Desk2BigBattleSrvPushGameResult
     */
    Desk2BigBattleSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushGameResult)
            return object;
        let message = new $root.Desk2BigBattleSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".Desk2BigBattleSrvPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".Desk2BigBattleSrvPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.BigBattleGoldRes.fromObject(object.GoldResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {Desk2BigBattleSrvPushGameResult} message Desk2BigBattleSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GoldResult = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.BigBattleGoldRes.toObject(message.GoldResult[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushGameResult";
    };

    return Desk2BigBattleSrvPushGameResult;
})();

/**
 * BigBattleRandPlayerType enum.
 * @exports BigBattleRandPlayerType
 * @enum {number}
 * @property {number} BigBattleRandPlayerType_NULL=0 BigBattleRandPlayerType_NULL value
 * @property {number} BigBattleRandPlayerType_RICH=1 BigBattleRandPlayerType_RICH value
 * @property {number} BigBattleRandPlayerType_LUCK=2 BigBattleRandPlayerType_LUCK value
 * @property {number} BigBattleRandPlayerType_NORMAL=3 BigBattleRandPlayerType_NORMAL value
 */
export const BigBattleRandPlayerType = $root.BigBattleRandPlayerType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BigBattleRandPlayerType_NULL"] = 0;
    values[valuesById[1] = "BigBattleRandPlayerType_RICH"] = 1;
    values[valuesById[2] = "BigBattleRandPlayerType_LUCK"] = 2;
    values[valuesById[3] = "BigBattleRandPlayerType_NORMAL"] = 3;
    return values;
})();

export const BigBattleRandPlayer = $root.BigBattleRandPlayer = (() => {

    /**
     * Properties of a BigBattleRandPlayer.
     * @exports IBigBattleRandPlayer
     * @interface IBigBattleRandPlayer
     * @property {number|null} [UserID] BigBattleRandPlayer UserID
     * @property {Uint8Array|null} [NickName] BigBattleRandPlayer NickName
     * @property {string|null} [HeaderURL] BigBattleRandPlayer HeaderURL
     * @property {string|null} [GoldCoin] BigBattleRandPlayer GoldCoin
     * @property {number|null} [Type] BigBattleRandPlayer Type
     */

    /**
     * Constructs a new BigBattleRandPlayer.
     * @exports BigBattleRandPlayer
     * @classdesc Represents a BigBattleRandPlayer.
     * @implements IBigBattleRandPlayer
     * @constructor
     * @param {IBigBattleRandPlayer=} [properties] Properties to set
     */
    function BigBattleRandPlayer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BigBattleRandPlayer UserID.
     * @member {number} UserID
     * @memberof BigBattleRandPlayer
     * @instance
     */
    BigBattleRandPlayer.prototype.UserID = 0;

    /**
     * BigBattleRandPlayer NickName.
     * @member {Uint8Array} NickName
     * @memberof BigBattleRandPlayer
     * @instance
     */
    BigBattleRandPlayer.prototype.NickName = $util.newBuffer([]);

    /**
     * BigBattleRandPlayer HeaderURL.
     * @member {string} HeaderURL
     * @memberof BigBattleRandPlayer
     * @instance
     */
    BigBattleRandPlayer.prototype.HeaderURL = "";

    /**
     * BigBattleRandPlayer GoldCoin.
     * @member {string} GoldCoin
     * @memberof BigBattleRandPlayer
     * @instance
     */
    BigBattleRandPlayer.prototype.GoldCoin = "";

    /**
     * BigBattleRandPlayer Type.
     * @member {number} Type
     * @memberof BigBattleRandPlayer
     * @instance
     */
    BigBattleRandPlayer.prototype.Type = 0;

    /**
     * Creates a new BigBattleRandPlayer instance using the specified properties.
     * @function create
     * @memberof BigBattleRandPlayer
     * @static
     * @param {IBigBattleRandPlayer=} [properties] Properties to set
     * @returns {BigBattleRandPlayer} BigBattleRandPlayer instance
     */
    BigBattleRandPlayer.create = function create(properties) {
        return new BigBattleRandPlayer(properties);
    };

    /**
     * Encodes the specified BigBattleRandPlayer message. Does not implicitly {@link BigBattleRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof BigBattleRandPlayer
     * @static
     * @param {IBigBattleRandPlayer} message BigBattleRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.GoldCoin != null && Object.hasOwnProperty.call(message, "GoldCoin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GoldCoin);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified BigBattleRandPlayer message, length delimited. Does not implicitly {@link BigBattleRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BigBattleRandPlayer
     * @static
     * @param {IBigBattleRandPlayer} message BigBattleRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BigBattleRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BigBattleRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof BigBattleRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BigBattleRandPlayer} BigBattleRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BigBattleRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.GoldCoin = reader.string();
                    break;
                }
            case 5: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BigBattleRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BigBattleRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BigBattleRandPlayer} BigBattleRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BigBattleRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BigBattleRandPlayer message.
     * @function verify
     * @memberof BigBattleRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BigBattleRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            if (!$util.isString(message.GoldCoin))
                return "GoldCoin: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a BigBattleRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BigBattleRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BigBattleRandPlayer} BigBattleRandPlayer
     */
    BigBattleRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.BigBattleRandPlayer)
            return object;
        let message = new $root.BigBattleRandPlayer();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.GoldCoin != null)
            message.GoldCoin = String(object.GoldCoin);
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a BigBattleRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BigBattleRandPlayer
     * @static
     * @param {BigBattleRandPlayer} message BigBattleRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BigBattleRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.GoldCoin = "";
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            object.GoldCoin = message.GoldCoin;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this BigBattleRandPlayer to JSON.
     * @function toJSON
     * @memberof BigBattleRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BigBattleRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BigBattleRandPlayer
     * @function getTypeUrl
     * @memberof BigBattleRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BigBattleRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BigBattleRandPlayer";
    };

    return BigBattleRandPlayer;
})();

export const Desk2BigBattleSrvPushRandPlayer = $root.Desk2BigBattleSrvPushRandPlayer = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushRandPlayer.
     * @exports IDesk2BigBattleSrvPushRandPlayer
     * @interface IDesk2BigBattleSrvPushRandPlayer
     * @property {Array.<IBigBattleRandPlayer>|null} [RandPlayer] Desk2BigBattleSrvPushRandPlayer RandPlayer
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushRandPlayer.
     * @exports Desk2BigBattleSrvPushRandPlayer
     * @classdesc Represents a Desk2BigBattleSrvPushRandPlayer.
     * @implements IDesk2BigBattleSrvPushRandPlayer
     * @constructor
     * @param {IDesk2BigBattleSrvPushRandPlayer=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushRandPlayer(properties) {
        this.RandPlayer = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushRandPlayer RandPlayer.
     * @member {Array.<IBigBattleRandPlayer>} RandPlayer
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @instance
     */
    Desk2BigBattleSrvPushRandPlayer.prototype.RandPlayer = $util.emptyArray;

    /**
     * Creates a new Desk2BigBattleSrvPushRandPlayer instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {IDesk2BigBattleSrvPushRandPlayer=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushRandPlayer} Desk2BigBattleSrvPushRandPlayer instance
     */
    Desk2BigBattleSrvPushRandPlayer.create = function create(properties) {
        return new Desk2BigBattleSrvPushRandPlayer(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushRandPlayer message. Does not implicitly {@link Desk2BigBattleSrvPushRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {IDesk2BigBattleSrvPushRandPlayer} message Desk2BigBattleSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RandPlayer != null && message.RandPlayer.length)
            for (let i = 0; i < message.RandPlayer.length; ++i)
                $root.BigBattleRandPlayer.encode(message.RandPlayer[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushRandPlayer message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {IDesk2BigBattleSrvPushRandPlayer} message Desk2BigBattleSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushRandPlayer} Desk2BigBattleSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.RandPlayer && message.RandPlayer.length))
                        message.RandPlayer = [];
                    message.RandPlayer.push($root.BigBattleRandPlayer.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushRandPlayer} Desk2BigBattleSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushRandPlayer message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RandPlayer != null && message.hasOwnProperty("RandPlayer")) {
            if (!Array.isArray(message.RandPlayer))
                return "RandPlayer: array expected";
            for (let i = 0; i < message.RandPlayer.length; ++i) {
                let error = $root.BigBattleRandPlayer.verify(message.RandPlayer[i]);
                if (error)
                    return "RandPlayer." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushRandPlayer} Desk2BigBattleSrvPushRandPlayer
     */
    Desk2BigBattleSrvPushRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushRandPlayer)
            return object;
        let message = new $root.Desk2BigBattleSrvPushRandPlayer();
        if (object.RandPlayer) {
            if (!Array.isArray(object.RandPlayer))
                throw TypeError(".Desk2BigBattleSrvPushRandPlayer.RandPlayer: array expected");
            message.RandPlayer = [];
            for (let i = 0; i < object.RandPlayer.length; ++i) {
                if (typeof object.RandPlayer[i] !== "object")
                    throw TypeError(".Desk2BigBattleSrvPushRandPlayer.RandPlayer: object expected");
                message.RandPlayer[i] = $root.BigBattleRandPlayer.fromObject(object.RandPlayer[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {Desk2BigBattleSrvPushRandPlayer} message Desk2BigBattleSrvPushRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RandPlayer = [];
        if (message.RandPlayer && message.RandPlayer.length) {
            object.RandPlayer = [];
            for (let j = 0; j < message.RandPlayer.length; ++j)
                object.RandPlayer[j] = $root.BigBattleRandPlayer.toObject(message.RandPlayer[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushRandPlayer to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushRandPlayer
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushRandPlayer";
    };

    return Desk2BigBattleSrvPushRandPlayer;
})();

export const Desk2BigBattleSrvPushTrend = $root.Desk2BigBattleSrvPushTrend = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushTrend.
     * @exports IDesk2BigBattleSrvPushTrend
     * @interface IDesk2BigBattleSrvPushTrend
     * @property {number|null} [UserID] Desk2BigBattleSrvPushTrend UserID
     * @property {Uint8Array|null} [Trend] Desk2BigBattleSrvPushTrend Trend
     * @property {Uint8Array|null} [Record] Desk2BigBattleSrvPushTrend Record
     * @property {Uint8Array|null} [Forecast1] Desk2BigBattleSrvPushTrend Forecast1
     * @property {Uint8Array|null} [Forecast2] Desk2BigBattleSrvPushTrend Forecast2
     * @property {Uint8Array|null} [Forecast3] Desk2BigBattleSrvPushTrend Forecast3
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushTrend.
     * @exports Desk2BigBattleSrvPushTrend
     * @classdesc Represents a Desk2BigBattleSrvPushTrend.
     * @implements IDesk2BigBattleSrvPushTrend
     * @constructor
     * @param {IDesk2BigBattleSrvPushTrend=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushTrend(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushTrend UserID.
     * @member {number} UserID
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.UserID = 0;

    /**
     * Desk2BigBattleSrvPushTrend Trend.
     * @member {Uint8Array} Trend
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.Trend = $util.newBuffer([]);

    /**
     * Desk2BigBattleSrvPushTrend Record.
     * @member {Uint8Array} Record
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.Record = $util.newBuffer([]);

    /**
     * Desk2BigBattleSrvPushTrend Forecast1.
     * @member {Uint8Array} Forecast1
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.Forecast1 = $util.newBuffer([]);

    /**
     * Desk2BigBattleSrvPushTrend Forecast2.
     * @member {Uint8Array} Forecast2
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.Forecast2 = $util.newBuffer([]);

    /**
     * Desk2BigBattleSrvPushTrend Forecast3.
     * @member {Uint8Array} Forecast3
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     */
    Desk2BigBattleSrvPushTrend.prototype.Forecast3 = $util.newBuffer([]);

    /**
     * Creates a new Desk2BigBattleSrvPushTrend instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {IDesk2BigBattleSrvPushTrend=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushTrend} Desk2BigBattleSrvPushTrend instance
     */
    Desk2BigBattleSrvPushTrend.create = function create(properties) {
        return new Desk2BigBattleSrvPushTrend(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushTrend message. Does not implicitly {@link Desk2BigBattleSrvPushTrend.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {IDesk2BigBattleSrvPushTrend} message Desk2BigBattleSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushTrend.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Trend != null && Object.hasOwnProperty.call(message, "Trend"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Trend);
        if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Record);
        if (message.Forecast1 != null && Object.hasOwnProperty.call(message, "Forecast1"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.Forecast1);
        if (message.Forecast2 != null && Object.hasOwnProperty.call(message, "Forecast2"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.Forecast2);
        if (message.Forecast3 != null && Object.hasOwnProperty.call(message, "Forecast3"))
            writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.Forecast3);
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushTrend message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushTrend.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {IDesk2BigBattleSrvPushTrend} message Desk2BigBattleSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushTrend.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushTrend message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushTrend} Desk2BigBattleSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushTrend.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushTrend();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Trend = reader.bytes();
                    break;
                }
            case 3: {
                    message.Record = reader.bytes();
                    break;
                }
            case 4: {
                    message.Forecast1 = reader.bytes();
                    break;
                }
            case 5: {
                    message.Forecast2 = reader.bytes();
                    break;
                }
            case 6: {
                    message.Forecast3 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushTrend message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushTrend} Desk2BigBattleSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushTrend.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushTrend message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushTrend.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            if (!(message.Trend && typeof message.Trend.length === "number" || $util.isString(message.Trend)))
                return "Trend: buffer expected";
        if (message.Record != null && message.hasOwnProperty("Record"))
            if (!(message.Record && typeof message.Record.length === "number" || $util.isString(message.Record)))
                return "Record: buffer expected";
        if (message.Forecast1 != null && message.hasOwnProperty("Forecast1"))
            if (!(message.Forecast1 && typeof message.Forecast1.length === "number" || $util.isString(message.Forecast1)))
                return "Forecast1: buffer expected";
        if (message.Forecast2 != null && message.hasOwnProperty("Forecast2"))
            if (!(message.Forecast2 && typeof message.Forecast2.length === "number" || $util.isString(message.Forecast2)))
                return "Forecast2: buffer expected";
        if (message.Forecast3 != null && message.hasOwnProperty("Forecast3"))
            if (!(message.Forecast3 && typeof message.Forecast3.length === "number" || $util.isString(message.Forecast3)))
                return "Forecast3: buffer expected";
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushTrend message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushTrend} Desk2BigBattleSrvPushTrend
     */
    Desk2BigBattleSrvPushTrend.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushTrend)
            return object;
        let message = new $root.Desk2BigBattleSrvPushTrend();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Trend != null)
            if (typeof object.Trend === "string")
                $util.base64.decode(object.Trend, message.Trend = $util.newBuffer($util.base64.length(object.Trend)), 0);
            else if (object.Trend.length >= 0)
                message.Trend = object.Trend;
        if (object.Record != null)
            if (typeof object.Record === "string")
                $util.base64.decode(object.Record, message.Record = $util.newBuffer($util.base64.length(object.Record)), 0);
            else if (object.Record.length >= 0)
                message.Record = object.Record;
        if (object.Forecast1 != null)
            if (typeof object.Forecast1 === "string")
                $util.base64.decode(object.Forecast1, message.Forecast1 = $util.newBuffer($util.base64.length(object.Forecast1)), 0);
            else if (object.Forecast1.length >= 0)
                message.Forecast1 = object.Forecast1;
        if (object.Forecast2 != null)
            if (typeof object.Forecast2 === "string")
                $util.base64.decode(object.Forecast2, message.Forecast2 = $util.newBuffer($util.base64.length(object.Forecast2)), 0);
            else if (object.Forecast2.length >= 0)
                message.Forecast2 = object.Forecast2;
        if (object.Forecast3 != null)
            if (typeof object.Forecast3 === "string")
                $util.base64.decode(object.Forecast3, message.Forecast3 = $util.newBuffer($util.base64.length(object.Forecast3)), 0);
            else if (object.Forecast3.length >= 0)
                message.Forecast3 = object.Forecast3;
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushTrend message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {Desk2BigBattleSrvPushTrend} message Desk2BigBattleSrvPushTrend
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushTrend.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Trend = "";
            else {
                object.Trend = [];
                if (options.bytes !== Array)
                    object.Trend = $util.newBuffer(object.Trend);
            }
            if (options.bytes === String)
                object.Record = "";
            else {
                object.Record = [];
                if (options.bytes !== Array)
                    object.Record = $util.newBuffer(object.Record);
            }
            if (options.bytes === String)
                object.Forecast1 = "";
            else {
                object.Forecast1 = [];
                if (options.bytes !== Array)
                    object.Forecast1 = $util.newBuffer(object.Forecast1);
            }
            if (options.bytes === String)
                object.Forecast2 = "";
            else {
                object.Forecast2 = [];
                if (options.bytes !== Array)
                    object.Forecast2 = $util.newBuffer(object.Forecast2);
            }
            if (options.bytes === String)
                object.Forecast3 = "";
            else {
                object.Forecast3 = [];
                if (options.bytes !== Array)
                    object.Forecast3 = $util.newBuffer(object.Forecast3);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            object.Trend = options.bytes === String ? $util.base64.encode(message.Trend, 0, message.Trend.length) : options.bytes === Array ? Array.prototype.slice.call(message.Trend) : message.Trend;
        if (message.Record != null && message.hasOwnProperty("Record"))
            object.Record = options.bytes === String ? $util.base64.encode(message.Record, 0, message.Record.length) : options.bytes === Array ? Array.prototype.slice.call(message.Record) : message.Record;
        if (message.Forecast1 != null && message.hasOwnProperty("Forecast1"))
            object.Forecast1 = options.bytes === String ? $util.base64.encode(message.Forecast1, 0, message.Forecast1.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast1) : message.Forecast1;
        if (message.Forecast2 != null && message.hasOwnProperty("Forecast2"))
            object.Forecast2 = options.bytes === String ? $util.base64.encode(message.Forecast2, 0, message.Forecast2.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast2) : message.Forecast2;
        if (message.Forecast3 != null && message.hasOwnProperty("Forecast3"))
            object.Forecast3 = options.bytes === String ? $util.base64.encode(message.Forecast3, 0, message.Forecast3.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast3) : message.Forecast3;
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushTrend to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushTrend
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushTrend.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushTrend
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushTrend
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushTrend.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushTrend";
    };

    return Desk2BigBattleSrvPushTrend;
})();

export const Desk2BigBattleSrvPushLuckyStar = $root.Desk2BigBattleSrvPushLuckyStar = (() => {

    /**
     * Properties of a Desk2BigBattleSrvPushLuckyStar.
     * @exports IDesk2BigBattleSrvPushLuckyStar
     * @interface IDesk2BigBattleSrvPushLuckyStar
     * @property {number|null} [UserID] Desk2BigBattleSrvPushLuckyStar UserID
     * @property {number|null} [StarUserID] Desk2BigBattleSrvPushLuckyStar StarUserID
     * @property {Array.<number>|null} [Section] Desk2BigBattleSrvPushLuckyStar Section
     */

    /**
     * Constructs a new Desk2BigBattleSrvPushLuckyStar.
     * @exports Desk2BigBattleSrvPushLuckyStar
     * @classdesc Represents a Desk2BigBattleSrvPushLuckyStar.
     * @implements IDesk2BigBattleSrvPushLuckyStar
     * @constructor
     * @param {IDesk2BigBattleSrvPushLuckyStar=} [properties] Properties to set
     */
    function Desk2BigBattleSrvPushLuckyStar(properties) {
        this.Section = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2BigBattleSrvPushLuckyStar UserID.
     * @member {number} UserID
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @instance
     */
    Desk2BigBattleSrvPushLuckyStar.prototype.UserID = 0;

    /**
     * Desk2BigBattleSrvPushLuckyStar StarUserID.
     * @member {number} StarUserID
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @instance
     */
    Desk2BigBattleSrvPushLuckyStar.prototype.StarUserID = 0;

    /**
     * Desk2BigBattleSrvPushLuckyStar Section.
     * @member {Array.<number>} Section
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @instance
     */
    Desk2BigBattleSrvPushLuckyStar.prototype.Section = $util.emptyArray;

    /**
     * Creates a new Desk2BigBattleSrvPushLuckyStar instance using the specified properties.
     * @function create
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {IDesk2BigBattleSrvPushLuckyStar=} [properties] Properties to set
     * @returns {Desk2BigBattleSrvPushLuckyStar} Desk2BigBattleSrvPushLuckyStar instance
     */
    Desk2BigBattleSrvPushLuckyStar.create = function create(properties) {
        return new Desk2BigBattleSrvPushLuckyStar(properties);
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushLuckyStar message. Does not implicitly {@link Desk2BigBattleSrvPushLuckyStar.verify|verify} messages.
     * @function encode
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {IDesk2BigBattleSrvPushLuckyStar} message Desk2BigBattleSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushLuckyStar.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StarUserID != null && Object.hasOwnProperty.call(message, "StarUserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StarUserID);
        if (message.Section != null && message.Section.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.Section.length; ++i)
                writer.uint32(message.Section[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2BigBattleSrvPushLuckyStar message, length delimited. Does not implicitly {@link Desk2BigBattleSrvPushLuckyStar.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {IDesk2BigBattleSrvPushLuckyStar} message Desk2BigBattleSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2BigBattleSrvPushLuckyStar.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2BigBattleSrvPushLuckyStar message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2BigBattleSrvPushLuckyStar} Desk2BigBattleSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushLuckyStar.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2BigBattleSrvPushLuckyStar();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StarUserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Section && message.Section.length))
                        message.Section = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Section.push(reader.uint32());
                    } else
                        message.Section.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2BigBattleSrvPushLuckyStar message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2BigBattleSrvPushLuckyStar} Desk2BigBattleSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2BigBattleSrvPushLuckyStar.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2BigBattleSrvPushLuckyStar message.
     * @function verify
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2BigBattleSrvPushLuckyStar.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            if (!$util.isInteger(message.StarUserID))
                return "StarUserID: integer expected";
        if (message.Section != null && message.hasOwnProperty("Section")) {
            if (!Array.isArray(message.Section))
                return "Section: array expected";
            for (let i = 0; i < message.Section.length; ++i)
                if (!$util.isInteger(message.Section[i]))
                    return "Section: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2BigBattleSrvPushLuckyStar message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2BigBattleSrvPushLuckyStar} Desk2BigBattleSrvPushLuckyStar
     */
    Desk2BigBattleSrvPushLuckyStar.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2BigBattleSrvPushLuckyStar)
            return object;
        let message = new $root.Desk2BigBattleSrvPushLuckyStar();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StarUserID != null)
            message.StarUserID = object.StarUserID >>> 0;
        if (object.Section) {
            if (!Array.isArray(object.Section))
                throw TypeError(".Desk2BigBattleSrvPushLuckyStar.Section: array expected");
            message.Section = [];
            for (let i = 0; i < object.Section.length; ++i)
                message.Section[i] = object.Section[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2BigBattleSrvPushLuckyStar message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {Desk2BigBattleSrvPushLuckyStar} message Desk2BigBattleSrvPushLuckyStar
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2BigBattleSrvPushLuckyStar.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Section = [];
        if (options.defaults) {
            object.UserID = 0;
            object.StarUserID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            object.StarUserID = message.StarUserID;
        if (message.Section && message.Section.length) {
            object.Section = [];
            for (let j = 0; j < message.Section.length; ++j)
                object.Section[j] = message.Section[j];
        }
        return object;
    };

    /**
     * Converts this Desk2BigBattleSrvPushLuckyStar to JSON.
     * @function toJSON
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2BigBattleSrvPushLuckyStar.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2BigBattleSrvPushLuckyStar
     * @function getTypeUrl
     * @memberof Desk2BigBattleSrvPushLuckyStar
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2BigBattleSrvPushLuckyStar.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2BigBattleSrvPushLuckyStar";
    };

    return Desk2BigBattleSrvPushLuckyStar;
})();

export const CashWheelProduct = $root.CashWheelProduct = (() => {

    /**
     * Properties of a CashWheelProduct.
     * @exports ICashWheelProduct
     * @interface ICashWheelProduct
     * @property {number|null} [PID] CashWheelProduct PID
     * @property {number|null} [Mode] CashWheelProduct Mode
     * @property {string|null} [BetList] CashWheelProduct BetList
     * @property {string|null} [AutoBet] CashWheelProduct AutoBet
     * @property {string|null} [PrizeList1] CashWheelProduct PrizeList1
     * @property {string|null} [PrizeList2] CashWheelProduct PrizeList2
     */

    /**
     * Constructs a new CashWheelProduct.
     * @exports CashWheelProduct
     * @classdesc Represents a CashWheelProduct.
     * @implements ICashWheelProduct
     * @constructor
     * @param {ICashWheelProduct=} [properties] Properties to set
     */
    function CashWheelProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CashWheelProduct PID.
     * @member {number} PID
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.PID = 0;

    /**
     * CashWheelProduct Mode.
     * @member {number} Mode
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.Mode = 0;

    /**
     * CashWheelProduct BetList.
     * @member {string} BetList
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.BetList = "";

    /**
     * CashWheelProduct AutoBet.
     * @member {string} AutoBet
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.AutoBet = "";

    /**
     * CashWheelProduct PrizeList1.
     * @member {string} PrizeList1
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.PrizeList1 = "";

    /**
     * CashWheelProduct PrizeList2.
     * @member {string} PrizeList2
     * @memberof CashWheelProduct
     * @instance
     */
    CashWheelProduct.prototype.PrizeList2 = "";

    /**
     * Creates a new CashWheelProduct instance using the specified properties.
     * @function create
     * @memberof CashWheelProduct
     * @static
     * @param {ICashWheelProduct=} [properties] Properties to set
     * @returns {CashWheelProduct} CashWheelProduct instance
     */
    CashWheelProduct.create = function create(properties) {
        return new CashWheelProduct(properties);
    };

    /**
     * Encodes the specified CashWheelProduct message. Does not implicitly {@link CashWheelProduct.verify|verify} messages.
     * @function encode
     * @memberof CashWheelProduct
     * @static
     * @param {ICashWheelProduct} message CashWheelProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CashWheelProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetList);
        if (message.AutoBet != null && Object.hasOwnProperty.call(message, "AutoBet"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.AutoBet);
        if (message.PrizeList1 != null && Object.hasOwnProperty.call(message, "PrizeList1"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.PrizeList1);
        if (message.PrizeList2 != null && Object.hasOwnProperty.call(message, "PrizeList2"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.PrizeList2);
        return writer;
    };

    /**
     * Encodes the specified CashWheelProduct message, length delimited. Does not implicitly {@link CashWheelProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CashWheelProduct
     * @static
     * @param {ICashWheelProduct} message CashWheelProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CashWheelProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CashWheelProduct message from the specified reader or buffer.
     * @function decode
     * @memberof CashWheelProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CashWheelProduct} CashWheelProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CashWheelProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CashWheelProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetList = reader.string();
                    break;
                }
            case 4: {
                    message.AutoBet = reader.string();
                    break;
                }
            case 5: {
                    message.PrizeList1 = reader.string();
                    break;
                }
            case 6: {
                    message.PrizeList2 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CashWheelProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CashWheelProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CashWheelProduct} CashWheelProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CashWheelProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CashWheelProduct message.
     * @function verify
     * @memberof CashWheelProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CashWheelProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            if (!$util.isString(message.AutoBet))
                return "AutoBet: string expected";
        if (message.PrizeList1 != null && message.hasOwnProperty("PrizeList1"))
            if (!$util.isString(message.PrizeList1))
                return "PrizeList1: string expected";
        if (message.PrizeList2 != null && message.hasOwnProperty("PrizeList2"))
            if (!$util.isString(message.PrizeList2))
                return "PrizeList2: string expected";
        return null;
    };

    /**
     * Creates a CashWheelProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CashWheelProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CashWheelProduct} CashWheelProduct
     */
    CashWheelProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.CashWheelProduct)
            return object;
        let message = new $root.CashWheelProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.AutoBet != null)
            message.AutoBet = String(object.AutoBet);
        if (object.PrizeList1 != null)
            message.PrizeList1 = String(object.PrizeList1);
        if (object.PrizeList2 != null)
            message.PrizeList2 = String(object.PrizeList2);
        return message;
    };

    /**
     * Creates a plain object from a CashWheelProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CashWheelProduct
     * @static
     * @param {CashWheelProduct} message CashWheelProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CashWheelProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetList = "";
            object.AutoBet = "";
            object.PrizeList1 = "";
            object.PrizeList2 = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            object.AutoBet = message.AutoBet;
        if (message.PrizeList1 != null && message.hasOwnProperty("PrizeList1"))
            object.PrizeList1 = message.PrizeList1;
        if (message.PrizeList2 != null && message.hasOwnProperty("PrizeList2"))
            object.PrizeList2 = message.PrizeList2;
        return object;
    };

    /**
     * Converts this CashWheelProduct to JSON.
     * @function toJSON
     * @memberof CashWheelProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CashWheelProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CashWheelProduct
     * @function getTypeUrl
     * @memberof CashWheelProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CashWheelProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CashWheelProduct";
    };

    return CashWheelProduct;
})();

export const CashWheelSrvToDeskPushDeskInfo = $root.CashWheelSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a CashWheelSrvToDeskPushDeskInfo.
     * @exports ICashWheelSrvToDeskPushDeskInfo
     * @interface ICashWheelSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] CashWheelSrvToDeskPushDeskInfo UserID
     * @property {number|Long|null} [Gold] CashWheelSrvToDeskPushDeskInfo Gold
     * @property {ICashWheelProduct|null} [Product] CashWheelSrvToDeskPushDeskInfo Product
     */

    /**
     * Constructs a new CashWheelSrvToDeskPushDeskInfo.
     * @exports CashWheelSrvToDeskPushDeskInfo
     * @classdesc Represents a CashWheelSrvToDeskPushDeskInfo.
     * @implements ICashWheelSrvToDeskPushDeskInfo
     * @constructor
     * @param {ICashWheelSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function CashWheelSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CashWheelSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @instance
     */
    CashWheelSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * CashWheelSrvToDeskPushDeskInfo Gold.
     * @member {number|Long} Gold
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @instance
     */
    CashWheelSrvToDeskPushDeskInfo.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * CashWheelSrvToDeskPushDeskInfo Product.
     * @member {ICashWheelProduct|null|undefined} Product
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @instance
     */
    CashWheelSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * Creates a new CashWheelSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {ICashWheelSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {CashWheelSrvToDeskPushDeskInfo} CashWheelSrvToDeskPushDeskInfo instance
     */
    CashWheelSrvToDeskPushDeskInfo.create = function create(properties) {
        return new CashWheelSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified CashWheelSrvToDeskPushDeskInfo message. Does not implicitly {@link CashWheelSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {ICashWheelSrvToDeskPushDeskInfo} message CashWheelSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CashWheelSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.Gold);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.CashWheelProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CashWheelSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link CashWheelSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {ICashWheelSrvToDeskPushDeskInfo} message CashWheelSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CashWheelSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CashWheelSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CashWheelSrvToDeskPushDeskInfo} CashWheelSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CashWheelSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CashWheelSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Gold = reader.uint64();
                    break;
                }
            case 3: {
                    message.Product = $root.CashWheelProduct.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CashWheelSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CashWheelSrvToDeskPushDeskInfo} CashWheelSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CashWheelSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CashWheelSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CashWheelSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.CashWheelProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        return null;
    };

    /**
     * Creates a CashWheelSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CashWheelSrvToDeskPushDeskInfo} CashWheelSrvToDeskPushDeskInfo
     */
    CashWheelSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.CashWheelSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.CashWheelSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".CashWheelSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.CashWheelProduct.fromObject(object.Product);
        }
        return message;
    };

    /**
     * Creates a plain object from a CashWheelSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {CashWheelSrvToDeskPushDeskInfo} message CashWheelSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CashWheelSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.CashWheelProduct.toObject(message.Product, options);
        return object;
    };

    /**
     * Converts this CashWheelSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CashWheelSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CashWheelSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof CashWheelSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CashWheelSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CashWheelSrvToDeskPushDeskInfo";
    };

    return CashWheelSrvToDeskPushDeskInfo;
})();

export const Client2CashWheelSrvReqBet = $root.Client2CashWheelSrvReqBet = (() => {

    /**
     * Properties of a Client2CashWheelSrvReqBet.
     * @exports IClient2CashWheelSrvReqBet
     * @interface IClient2CashWheelSrvReqBet
     * @property {number|null} [DeskNo] Client2CashWheelSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2CashWheelSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2CashWheelSrvReqBet SeatNo
     * @property {number|Long|null} [BetGold] Client2CashWheelSrvReqBet BetGold
     */

    /**
     * Constructs a new Client2CashWheelSrvReqBet.
     * @exports Client2CashWheelSrvReqBet
     * @classdesc Represents a Client2CashWheelSrvReqBet.
     * @implements IClient2CashWheelSrvReqBet
     * @constructor
     * @param {IClient2CashWheelSrvReqBet=} [properties] Properties to set
     */
    function Client2CashWheelSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2CashWheelSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2CashWheelSrvReqBet
     * @instance
     */
    Client2CashWheelSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2CashWheelSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2CashWheelSrvReqBet
     * @instance
     */
    Client2CashWheelSrvReqBet.prototype.UserID = 0;

    /**
     * Client2CashWheelSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2CashWheelSrvReqBet
     * @instance
     */
    Client2CashWheelSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2CashWheelSrvReqBet BetGold.
     * @member {number|Long} BetGold
     * @memberof Client2CashWheelSrvReqBet
     * @instance
     */
    Client2CashWheelSrvReqBet.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2CashWheelSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {IClient2CashWheelSrvReqBet=} [properties] Properties to set
     * @returns {Client2CashWheelSrvReqBet} Client2CashWheelSrvReqBet instance
     */
    Client2CashWheelSrvReqBet.create = function create(properties) {
        return new Client2CashWheelSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2CashWheelSrvReqBet message. Does not implicitly {@link Client2CashWheelSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {IClient2CashWheelSrvReqBet} message Client2CashWheelSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2CashWheelSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        return writer;
    };

    /**
     * Encodes the specified Client2CashWheelSrvReqBet message, length delimited. Does not implicitly {@link Client2CashWheelSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {IClient2CashWheelSrvReqBet} message Client2CashWheelSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2CashWheelSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2CashWheelSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2CashWheelSrvReqBet} Client2CashWheelSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2CashWheelSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2CashWheelSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2CashWheelSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2CashWheelSrvReqBet} Client2CashWheelSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2CashWheelSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2CashWheelSrvReqBet message.
     * @function verify
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2CashWheelSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2CashWheelSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2CashWheelSrvReqBet} Client2CashWheelSrvReqBet
     */
    Client2CashWheelSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2CashWheelSrvReqBet)
            return object;
        let message = new $root.Client2CashWheelSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2CashWheelSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {Client2CashWheelSrvReqBet} message Client2CashWheelSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2CashWheelSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        return object;
    };

    /**
     * Converts this Client2CashWheelSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2CashWheelSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2CashWheelSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2CashWheelSrvReqBet
     * @function getTypeUrl
     * @memberof Client2CashWheelSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2CashWheelSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2CashWheelSrvReqBet";
    };

    return Client2CashWheelSrvReqBet;
})();

export const Client2CashWheelSrvAckBet = $root.Client2CashWheelSrvAckBet = (() => {

    /**
     * Properties of a Client2CashWheelSrvAckBet.
     * @exports IClient2CashWheelSrvAckBet
     * @interface IClient2CashWheelSrvAckBet
     * @property {number|null} [Ret] Client2CashWheelSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2CashWheelSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2CashWheelSrvAckBet UserID
     * @property {number|null} [SeatNo] Client2CashWheelSrvAckBet SeatNo
     * @property {number|Long|null} [Gold] Client2CashWheelSrvAckBet Gold
     */

    /**
     * Constructs a new Client2CashWheelSrvAckBet.
     * @exports Client2CashWheelSrvAckBet
     * @classdesc Represents a Client2CashWheelSrvAckBet.
     * @implements IClient2CashWheelSrvAckBet
     * @constructor
     * @param {IClient2CashWheelSrvAckBet=} [properties] Properties to set
     */
    function Client2CashWheelSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2CashWheelSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     */
    Client2CashWheelSrvAckBet.prototype.Ret = 0;

    /**
     * Client2CashWheelSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     */
    Client2CashWheelSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2CashWheelSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     */
    Client2CashWheelSrvAckBet.prototype.UserID = 0;

    /**
     * Client2CashWheelSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     */
    Client2CashWheelSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2CashWheelSrvAckBet Gold.
     * @member {number|Long} Gold
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     */
    Client2CashWheelSrvAckBet.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2CashWheelSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {IClient2CashWheelSrvAckBet=} [properties] Properties to set
     * @returns {Client2CashWheelSrvAckBet} Client2CashWheelSrvAckBet instance
     */
    Client2CashWheelSrvAckBet.create = function create(properties) {
        return new Client2CashWheelSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2CashWheelSrvAckBet message. Does not implicitly {@link Client2CashWheelSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {IClient2CashWheelSrvAckBet} message Client2CashWheelSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2CashWheelSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Gold);
        return writer;
    };

    /**
     * Encodes the specified Client2CashWheelSrvAckBet message, length delimited. Does not implicitly {@link Client2CashWheelSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {IClient2CashWheelSrvAckBet} message Client2CashWheelSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2CashWheelSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2CashWheelSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2CashWheelSrvAckBet} Client2CashWheelSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2CashWheelSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2CashWheelSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Gold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2CashWheelSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2CashWheelSrvAckBet} Client2CashWheelSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2CashWheelSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2CashWheelSrvAckBet message.
     * @function verify
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2CashWheelSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2CashWheelSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2CashWheelSrvAckBet} Client2CashWheelSrvAckBet
     */
    Client2CashWheelSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2CashWheelSrvAckBet)
            return object;
        let message = new $root.Client2CashWheelSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2CashWheelSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {Client2CashWheelSrvAckBet} message Client2CashWheelSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2CashWheelSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        return object;
    };

    /**
     * Converts this Client2CashWheelSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2CashWheelSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2CashWheelSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2CashWheelSrvAckBet
     * @function getTypeUrl
     * @memberof Client2CashWheelSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2CashWheelSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2CashWheelSrvAckBet";
    };

    return Client2CashWheelSrvAckBet;
})();

export const ClientCashWheelPushBetDate = $root.ClientCashWheelPushBetDate = (() => {

    /**
     * Properties of a ClientCashWheelPushBetDate.
     * @exports IClientCashWheelPushBetDate
     * @interface IClientCashWheelPushBetDate
     * @property {Array.<number>|null} [PrizeNum] ClientCashWheelPushBetDate PrizeNum
     */

    /**
     * Constructs a new ClientCashWheelPushBetDate.
     * @exports ClientCashWheelPushBetDate
     * @classdesc Represents a ClientCashWheelPushBetDate.
     * @implements IClientCashWheelPushBetDate
     * @constructor
     * @param {IClientCashWheelPushBetDate=} [properties] Properties to set
     */
    function ClientCashWheelPushBetDate(properties) {
        this.PrizeNum = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCashWheelPushBetDate PrizeNum.
     * @member {Array.<number>} PrizeNum
     * @memberof ClientCashWheelPushBetDate
     * @instance
     */
    ClientCashWheelPushBetDate.prototype.PrizeNum = $util.emptyArray;

    /**
     * Creates a new ClientCashWheelPushBetDate instance using the specified properties.
     * @function create
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {IClientCashWheelPushBetDate=} [properties] Properties to set
     * @returns {ClientCashWheelPushBetDate} ClientCashWheelPushBetDate instance
     */
    ClientCashWheelPushBetDate.create = function create(properties) {
        return new ClientCashWheelPushBetDate(properties);
    };

    /**
     * Encodes the specified ClientCashWheelPushBetDate message. Does not implicitly {@link ClientCashWheelPushBetDate.verify|verify} messages.
     * @function encode
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {IClientCashWheelPushBetDate} message ClientCashWheelPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelPushBetDate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PrizeNum != null && message.PrizeNum.length) {
            writer.uint32(/* id 1, wireType 2 =*/10).fork();
            for (let i = 0; i < message.PrizeNum.length; ++i)
                writer.uint32(message.PrizeNum[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified ClientCashWheelPushBetDate message, length delimited. Does not implicitly {@link ClientCashWheelPushBetDate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {IClientCashWheelPushBetDate} message ClientCashWheelPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelPushBetDate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCashWheelPushBetDate message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCashWheelPushBetDate} ClientCashWheelPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelPushBetDate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCashWheelPushBetDate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.PrizeNum && message.PrizeNum.length))
                        message.PrizeNum = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PrizeNum.push(reader.uint32());
                    } else
                        message.PrizeNum.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCashWheelPushBetDate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCashWheelPushBetDate} ClientCashWheelPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelPushBetDate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCashWheelPushBetDate message.
     * @function verify
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCashWheelPushBetDate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PrizeNum != null && message.hasOwnProperty("PrizeNum")) {
            if (!Array.isArray(message.PrizeNum))
                return "PrizeNum: array expected";
            for (let i = 0; i < message.PrizeNum.length; ++i)
                if (!$util.isInteger(message.PrizeNum[i]))
                    return "PrizeNum: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a ClientCashWheelPushBetDate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCashWheelPushBetDate} ClientCashWheelPushBetDate
     */
    ClientCashWheelPushBetDate.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCashWheelPushBetDate)
            return object;
        let message = new $root.ClientCashWheelPushBetDate();
        if (object.PrizeNum) {
            if (!Array.isArray(object.PrizeNum))
                throw TypeError(".ClientCashWheelPushBetDate.PrizeNum: array expected");
            message.PrizeNum = [];
            for (let i = 0; i < object.PrizeNum.length; ++i)
                message.PrizeNum[i] = object.PrizeNum[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientCashWheelPushBetDate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {ClientCashWheelPushBetDate} message ClientCashWheelPushBetDate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCashWheelPushBetDate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PrizeNum = [];
        if (message.PrizeNum && message.PrizeNum.length) {
            object.PrizeNum = [];
            for (let j = 0; j < message.PrizeNum.length; ++j)
                object.PrizeNum[j] = message.PrizeNum[j];
        }
        return object;
    };

    /**
     * Converts this ClientCashWheelPushBetDate to JSON.
     * @function toJSON
     * @memberof ClientCashWheelPushBetDate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCashWheelPushBetDate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCashWheelPushBetDate
     * @function getTypeUrl
     * @memberof ClientCashWheelPushBetDate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCashWheelPushBetDate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCashWheelPushBetDate";
    };

    return ClientCashWheelPushBetDate;
})();

export const ClientCashWheelCartoonReq = $root.ClientCashWheelCartoonReq = (() => {

    /**
     * Properties of a ClientCashWheelCartoonReq.
     * @exports IClientCashWheelCartoonReq
     * @interface IClientCashWheelCartoonReq
     * @property {number|null} [DeskNo] ClientCashWheelCartoonReq DeskNo
     * @property {number|null} [UserID] ClientCashWheelCartoonReq UserID
     */

    /**
     * Constructs a new ClientCashWheelCartoonReq.
     * @exports ClientCashWheelCartoonReq
     * @classdesc Represents a ClientCashWheelCartoonReq.
     * @implements IClientCashWheelCartoonReq
     * @constructor
     * @param {IClientCashWheelCartoonReq=} [properties] Properties to set
     */
    function ClientCashWheelCartoonReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCashWheelCartoonReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientCashWheelCartoonReq
     * @instance
     */
    ClientCashWheelCartoonReq.prototype.DeskNo = 0;

    /**
     * ClientCashWheelCartoonReq UserID.
     * @member {number} UserID
     * @memberof ClientCashWheelCartoonReq
     * @instance
     */
    ClientCashWheelCartoonReq.prototype.UserID = 0;

    /**
     * Creates a new ClientCashWheelCartoonReq instance using the specified properties.
     * @function create
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {IClientCashWheelCartoonReq=} [properties] Properties to set
     * @returns {ClientCashWheelCartoonReq} ClientCashWheelCartoonReq instance
     */
    ClientCashWheelCartoonReq.create = function create(properties) {
        return new ClientCashWheelCartoonReq(properties);
    };

    /**
     * Encodes the specified ClientCashWheelCartoonReq message. Does not implicitly {@link ClientCashWheelCartoonReq.verify|verify} messages.
     * @function encode
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {IClientCashWheelCartoonReq} message ClientCashWheelCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelCartoonReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientCashWheelCartoonReq message, length delimited. Does not implicitly {@link ClientCashWheelCartoonReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {IClientCashWheelCartoonReq} message ClientCashWheelCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelCartoonReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCashWheelCartoonReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCashWheelCartoonReq} ClientCashWheelCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelCartoonReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCashWheelCartoonReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCashWheelCartoonReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCashWheelCartoonReq} ClientCashWheelCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelCartoonReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCashWheelCartoonReq message.
     * @function verify
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCashWheelCartoonReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientCashWheelCartoonReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCashWheelCartoonReq} ClientCashWheelCartoonReq
     */
    ClientCashWheelCartoonReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCashWheelCartoonReq)
            return object;
        let message = new $root.ClientCashWheelCartoonReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientCashWheelCartoonReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {ClientCashWheelCartoonReq} message ClientCashWheelCartoonReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCashWheelCartoonReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientCashWheelCartoonReq to JSON.
     * @function toJSON
     * @memberof ClientCashWheelCartoonReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCashWheelCartoonReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCashWheelCartoonReq
     * @function getTypeUrl
     * @memberof ClientCashWheelCartoonReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCashWheelCartoonReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCashWheelCartoonReq";
    };

    return ClientCashWheelCartoonReq;
})();

export const ClientCashWheelPushGameEndData = $root.ClientCashWheelPushGameEndData = (() => {

    /**
     * Properties of a ClientCashWheelPushGameEndData.
     * @exports IClientCashWheelPushGameEndData
     * @interface IClientCashWheelPushGameEndData
     * @property {number|Long|null} [PlayerGold] ClientCashWheelPushGameEndData PlayerGold
     */

    /**
     * Constructs a new ClientCashWheelPushGameEndData.
     * @exports ClientCashWheelPushGameEndData
     * @classdesc Represents a ClientCashWheelPushGameEndData.
     * @implements IClientCashWheelPushGameEndData
     * @constructor
     * @param {IClientCashWheelPushGameEndData=} [properties] Properties to set
     */
    function ClientCashWheelPushGameEndData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCashWheelPushGameEndData PlayerGold.
     * @member {number|Long} PlayerGold
     * @memberof ClientCashWheelPushGameEndData
     * @instance
     */
    ClientCashWheelPushGameEndData.prototype.PlayerGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientCashWheelPushGameEndData instance using the specified properties.
     * @function create
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {IClientCashWheelPushGameEndData=} [properties] Properties to set
     * @returns {ClientCashWheelPushGameEndData} ClientCashWheelPushGameEndData instance
     */
    ClientCashWheelPushGameEndData.create = function create(properties) {
        return new ClientCashWheelPushGameEndData(properties);
    };

    /**
     * Encodes the specified ClientCashWheelPushGameEndData message. Does not implicitly {@link ClientCashWheelPushGameEndData.verify|verify} messages.
     * @function encode
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {IClientCashWheelPushGameEndData} message ClientCashWheelPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelPushGameEndData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PlayerGold != null && Object.hasOwnProperty.call(message, "PlayerGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PlayerGold);
        return writer;
    };

    /**
     * Encodes the specified ClientCashWheelPushGameEndData message, length delimited. Does not implicitly {@link ClientCashWheelPushGameEndData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {IClientCashWheelPushGameEndData} message ClientCashWheelPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCashWheelPushGameEndData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCashWheelPushGameEndData message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCashWheelPushGameEndData} ClientCashWheelPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelPushGameEndData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCashWheelPushGameEndData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PlayerGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCashWheelPushGameEndData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCashWheelPushGameEndData} ClientCashWheelPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCashWheelPushGameEndData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCashWheelPushGameEndData message.
     * @function verify
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCashWheelPushGameEndData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (!$util.isInteger(message.PlayerGold) && !(message.PlayerGold && $util.isInteger(message.PlayerGold.low) && $util.isInteger(message.PlayerGold.high)))
                return "PlayerGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientCashWheelPushGameEndData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCashWheelPushGameEndData} ClientCashWheelPushGameEndData
     */
    ClientCashWheelPushGameEndData.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCashWheelPushGameEndData)
            return object;
        let message = new $root.ClientCashWheelPushGameEndData();
        if (object.PlayerGold != null)
            if ($util.Long)
                (message.PlayerGold = $util.Long.fromValue(object.PlayerGold)).unsigned = true;
            else if (typeof object.PlayerGold === "string")
                message.PlayerGold = parseInt(object.PlayerGold, 10);
            else if (typeof object.PlayerGold === "number")
                message.PlayerGold = object.PlayerGold;
            else if (typeof object.PlayerGold === "object")
                message.PlayerGold = new $util.LongBits(object.PlayerGold.low >>> 0, object.PlayerGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientCashWheelPushGameEndData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {ClientCashWheelPushGameEndData} message ClientCashWheelPushGameEndData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCashWheelPushGameEndData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerGold = options.longs === String ? "0" : 0;
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (typeof message.PlayerGold === "number")
                object.PlayerGold = options.longs === String ? String(message.PlayerGold) : message.PlayerGold;
            else
                object.PlayerGold = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerGold) : options.longs === Number ? new $util.LongBits(message.PlayerGold.low >>> 0, message.PlayerGold.high >>> 0).toNumber(true) : message.PlayerGold;
        return object;
    };

    /**
     * Converts this ClientCashWheelPushGameEndData to JSON.
     * @function toJSON
     * @memberof ClientCashWheelPushGameEndData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCashWheelPushGameEndData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCashWheelPushGameEndData
     * @function getTypeUrl
     * @memberof ClientCashWheelPushGameEndData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCashWheelPushGameEndData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCashWheelPushGameEndData";
    };

    return ClientCashWheelPushGameEndData;
})();

export const FortuneGems3Product = $root.FortuneGems3Product = (() => {

    /**
     * Properties of a FortuneGems3Product.
     * @exports IFortuneGems3Product
     * @interface IFortuneGems3Product
     * @property {number|null} [PID] FortuneGems3Product PID
     * @property {number|null} [Mode] FortuneGems3Product Mode
     * @property {string|null} [BetList] FortuneGems3Product BetList
     * @property {string|null} [AutoBet] FortuneGems3Product AutoBet
     * @property {string|null} [PrizeMult] FortuneGems3Product PrizeMult
     */

    /**
     * Constructs a new FortuneGems3Product.
     * @exports FortuneGems3Product
     * @classdesc Represents a FortuneGems3Product.
     * @implements IFortuneGems3Product
     * @constructor
     * @param {IFortuneGems3Product=} [properties] Properties to set
     */
    function FortuneGems3Product(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FortuneGems3Product PID.
     * @member {number} PID
     * @memberof FortuneGems3Product
     * @instance
     */
    FortuneGems3Product.prototype.PID = 0;

    /**
     * FortuneGems3Product Mode.
     * @member {number} Mode
     * @memberof FortuneGems3Product
     * @instance
     */
    FortuneGems3Product.prototype.Mode = 0;

    /**
     * FortuneGems3Product BetList.
     * @member {string} BetList
     * @memberof FortuneGems3Product
     * @instance
     */
    FortuneGems3Product.prototype.BetList = "";

    /**
     * FortuneGems3Product AutoBet.
     * @member {string} AutoBet
     * @memberof FortuneGems3Product
     * @instance
     */
    FortuneGems3Product.prototype.AutoBet = "";

    /**
     * FortuneGems3Product PrizeMult.
     * @member {string} PrizeMult
     * @memberof FortuneGems3Product
     * @instance
     */
    FortuneGems3Product.prototype.PrizeMult = "";

    /**
     * Creates a new FortuneGems3Product instance using the specified properties.
     * @function create
     * @memberof FortuneGems3Product
     * @static
     * @param {IFortuneGems3Product=} [properties] Properties to set
     * @returns {FortuneGems3Product} FortuneGems3Product instance
     */
    FortuneGems3Product.create = function create(properties) {
        return new FortuneGems3Product(properties);
    };

    /**
     * Encodes the specified FortuneGems3Product message. Does not implicitly {@link FortuneGems3Product.verify|verify} messages.
     * @function encode
     * @memberof FortuneGems3Product
     * @static
     * @param {IFortuneGems3Product} message FortuneGems3Product message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneGems3Product.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetList);
        if (message.AutoBet != null && Object.hasOwnProperty.call(message, "AutoBet"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.AutoBet);
        if (message.PrizeMult != null && Object.hasOwnProperty.call(message, "PrizeMult"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.PrizeMult);
        return writer;
    };

    /**
     * Encodes the specified FortuneGems3Product message, length delimited. Does not implicitly {@link FortuneGems3Product.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FortuneGems3Product
     * @static
     * @param {IFortuneGems3Product} message FortuneGems3Product message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneGems3Product.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FortuneGems3Product message from the specified reader or buffer.
     * @function decode
     * @memberof FortuneGems3Product
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FortuneGems3Product} FortuneGems3Product
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneGems3Product.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FortuneGems3Product();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetList = reader.string();
                    break;
                }
            case 4: {
                    message.AutoBet = reader.string();
                    break;
                }
            case 5: {
                    message.PrizeMult = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FortuneGems3Product message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FortuneGems3Product
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FortuneGems3Product} FortuneGems3Product
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneGems3Product.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FortuneGems3Product message.
     * @function verify
     * @memberof FortuneGems3Product
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FortuneGems3Product.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            if (!$util.isString(message.AutoBet))
                return "AutoBet: string expected";
        if (message.PrizeMult != null && message.hasOwnProperty("PrizeMult"))
            if (!$util.isString(message.PrizeMult))
                return "PrizeMult: string expected";
        return null;
    };

    /**
     * Creates a FortuneGems3Product message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FortuneGems3Product
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FortuneGems3Product} FortuneGems3Product
     */
    FortuneGems3Product.fromObject = function fromObject(object) {
        if (object instanceof $root.FortuneGems3Product)
            return object;
        let message = new $root.FortuneGems3Product();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.AutoBet != null)
            message.AutoBet = String(object.AutoBet);
        if (object.PrizeMult != null)
            message.PrizeMult = String(object.PrizeMult);
        return message;
    };

    /**
     * Creates a plain object from a FortuneGems3Product message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FortuneGems3Product
     * @static
     * @param {FortuneGems3Product} message FortuneGems3Product
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FortuneGems3Product.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetList = "";
            object.AutoBet = "";
            object.PrizeMult = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            object.AutoBet = message.AutoBet;
        if (message.PrizeMult != null && message.hasOwnProperty("PrizeMult"))
            object.PrizeMult = message.PrizeMult;
        return object;
    };

    /**
     * Converts this FortuneGems3Product to JSON.
     * @function toJSON
     * @memberof FortuneGems3Product
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FortuneGems3Product.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FortuneGems3Product
     * @function getTypeUrl
     * @memberof FortuneGems3Product
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FortuneGems3Product.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FortuneGems3Product";
    };

    return FortuneGems3Product;
})();

export const FortuneGems3SrvToDeskPushDeskInfo = $root.FortuneGems3SrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a FortuneGems3SrvToDeskPushDeskInfo.
     * @exports IFortuneGems3SrvToDeskPushDeskInfo
     * @interface IFortuneGems3SrvToDeskPushDeskInfo
     * @property {number|null} [UserID] FortuneGems3SrvToDeskPushDeskInfo UserID
     * @property {number|Long|null} [Gold] FortuneGems3SrvToDeskPushDeskInfo Gold
     * @property {IFortuneGems3Product|null} [Product] FortuneGems3SrvToDeskPushDeskInfo Product
     */

    /**
     * Constructs a new FortuneGems3SrvToDeskPushDeskInfo.
     * @exports FortuneGems3SrvToDeskPushDeskInfo
     * @classdesc Represents a FortuneGems3SrvToDeskPushDeskInfo.
     * @implements IFortuneGems3SrvToDeskPushDeskInfo
     * @constructor
     * @param {IFortuneGems3SrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function FortuneGems3SrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FortuneGems3SrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @instance
     */
    FortuneGems3SrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * FortuneGems3SrvToDeskPushDeskInfo Gold.
     * @member {number|Long} Gold
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @instance
     */
    FortuneGems3SrvToDeskPushDeskInfo.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * FortuneGems3SrvToDeskPushDeskInfo Product.
     * @member {IFortuneGems3Product|null|undefined} Product
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @instance
     */
    FortuneGems3SrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * Creates a new FortuneGems3SrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneGems3SrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {FortuneGems3SrvToDeskPushDeskInfo} FortuneGems3SrvToDeskPushDeskInfo instance
     */
    FortuneGems3SrvToDeskPushDeskInfo.create = function create(properties) {
        return new FortuneGems3SrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified FortuneGems3SrvToDeskPushDeskInfo message. Does not implicitly {@link FortuneGems3SrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneGems3SrvToDeskPushDeskInfo} message FortuneGems3SrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneGems3SrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.Gold);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.FortuneGems3Product.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FortuneGems3SrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link FortuneGems3SrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneGems3SrvToDeskPushDeskInfo} message FortuneGems3SrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneGems3SrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FortuneGems3SrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FortuneGems3SrvToDeskPushDeskInfo} FortuneGems3SrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneGems3SrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FortuneGems3SrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Gold = reader.uint64();
                    break;
                }
            case 3: {
                    message.Product = $root.FortuneGems3Product.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FortuneGems3SrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FortuneGems3SrvToDeskPushDeskInfo} FortuneGems3SrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneGems3SrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FortuneGems3SrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FortuneGems3SrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.FortuneGems3Product.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        return null;
    };

    /**
     * Creates a FortuneGems3SrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FortuneGems3SrvToDeskPushDeskInfo} FortuneGems3SrvToDeskPushDeskInfo
     */
    FortuneGems3SrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.FortuneGems3SrvToDeskPushDeskInfo)
            return object;
        let message = new $root.FortuneGems3SrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".FortuneGems3SrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.FortuneGems3Product.fromObject(object.Product);
        }
        return message;
    };

    /**
     * Creates a plain object from a FortuneGems3SrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {FortuneGems3SrvToDeskPushDeskInfo} message FortuneGems3SrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FortuneGems3SrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.FortuneGems3Product.toObject(message.Product, options);
        return object;
    };

    /**
     * Converts this FortuneGems3SrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FortuneGems3SrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FortuneGems3SrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof FortuneGems3SrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FortuneGems3SrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FortuneGems3SrvToDeskPushDeskInfo";
    };

    return FortuneGems3SrvToDeskPushDeskInfo;
})();

export const Client2FortuneGems3SrvReqBet = $root.Client2FortuneGems3SrvReqBet = (() => {

    /**
     * Properties of a Client2FortuneGems3SrvReqBet.
     * @exports IClient2FortuneGems3SrvReqBet
     * @interface IClient2FortuneGems3SrvReqBet
     * @property {number|null} [DeskNo] Client2FortuneGems3SrvReqBet DeskNo
     * @property {number|null} [UserID] Client2FortuneGems3SrvReqBet UserID
     * @property {number|null} [SeatNo] Client2FortuneGems3SrvReqBet SeatNo
     * @property {number|Long|null} [BetGold] Client2FortuneGems3SrvReqBet BetGold
     * @property {number|Long|null} [LineBet] Client2FortuneGems3SrvReqBet LineBet
     * @property {boolean|null} [BAddBet] Client2FortuneGems3SrvReqBet BAddBet
     */

    /**
     * Constructs a new Client2FortuneGems3SrvReqBet.
     * @exports Client2FortuneGems3SrvReqBet
     * @classdesc Represents a Client2FortuneGems3SrvReqBet.
     * @implements IClient2FortuneGems3SrvReqBet
     * @constructor
     * @param {IClient2FortuneGems3SrvReqBet=} [properties] Properties to set
     */
    function Client2FortuneGems3SrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2FortuneGems3SrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2FortuneGems3SrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.UserID = 0;

    /**
     * Client2FortuneGems3SrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2FortuneGems3SrvReqBet BetGold.
     * @member {number|Long} BetGold
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2FortuneGems3SrvReqBet LineBet.
     * @member {number|Long} LineBet
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.LineBet = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2FortuneGems3SrvReqBet BAddBet.
     * @member {boolean} BAddBet
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     */
    Client2FortuneGems3SrvReqBet.prototype.BAddBet = false;

    /**
     * Creates a new Client2FortuneGems3SrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {IClient2FortuneGems3SrvReqBet=} [properties] Properties to set
     * @returns {Client2FortuneGems3SrvReqBet} Client2FortuneGems3SrvReqBet instance
     */
    Client2FortuneGems3SrvReqBet.create = function create(properties) {
        return new Client2FortuneGems3SrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2FortuneGems3SrvReqBet message. Does not implicitly {@link Client2FortuneGems3SrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {IClient2FortuneGems3SrvReqBet} message Client2FortuneGems3SrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneGems3SrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        if (message.LineBet != null && Object.hasOwnProperty.call(message, "LineBet"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.LineBet);
        if (message.BAddBet != null && Object.hasOwnProperty.call(message, "BAddBet"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.BAddBet);
        return writer;
    };

    /**
     * Encodes the specified Client2FortuneGems3SrvReqBet message, length delimited. Does not implicitly {@link Client2FortuneGems3SrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {IClient2FortuneGems3SrvReqBet} message Client2FortuneGems3SrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneGems3SrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2FortuneGems3SrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2FortuneGems3SrvReqBet} Client2FortuneGems3SrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneGems3SrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2FortuneGems3SrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            case 5: {
                    message.LineBet = reader.uint64();
                    break;
                }
            case 6: {
                    message.BAddBet = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2FortuneGems3SrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2FortuneGems3SrvReqBet} Client2FortuneGems3SrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneGems3SrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2FortuneGems3SrvReqBet message.
     * @function verify
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2FortuneGems3SrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        if (message.LineBet != null && message.hasOwnProperty("LineBet"))
            if (!$util.isInteger(message.LineBet) && !(message.LineBet && $util.isInteger(message.LineBet.low) && $util.isInteger(message.LineBet.high)))
                return "LineBet: integer|Long expected";
        if (message.BAddBet != null && message.hasOwnProperty("BAddBet"))
            if (typeof message.BAddBet !== "boolean")
                return "BAddBet: boolean expected";
        return null;
    };

    /**
     * Creates a Client2FortuneGems3SrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2FortuneGems3SrvReqBet} Client2FortuneGems3SrvReqBet
     */
    Client2FortuneGems3SrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2FortuneGems3SrvReqBet)
            return object;
        let message = new $root.Client2FortuneGems3SrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        if (object.LineBet != null)
            if ($util.Long)
                (message.LineBet = $util.Long.fromValue(object.LineBet)).unsigned = true;
            else if (typeof object.LineBet === "string")
                message.LineBet = parseInt(object.LineBet, 10);
            else if (typeof object.LineBet === "number")
                message.LineBet = object.LineBet;
            else if (typeof object.LineBet === "object")
                message.LineBet = new $util.LongBits(object.LineBet.low >>> 0, object.LineBet.high >>> 0).toNumber(true);
        if (object.BAddBet != null)
            message.BAddBet = Boolean(object.BAddBet);
        return message;
    };

    /**
     * Creates a plain object from a Client2FortuneGems3SrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {Client2FortuneGems3SrvReqBet} message Client2FortuneGems3SrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2FortuneGems3SrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LineBet = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LineBet = options.longs === String ? "0" : 0;
            object.BAddBet = false;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        if (message.LineBet != null && message.hasOwnProperty("LineBet"))
            if (typeof message.LineBet === "number")
                object.LineBet = options.longs === String ? String(message.LineBet) : message.LineBet;
            else
                object.LineBet = options.longs === String ? $util.Long.prototype.toString.call(message.LineBet) : options.longs === Number ? new $util.LongBits(message.LineBet.low >>> 0, message.LineBet.high >>> 0).toNumber(true) : message.LineBet;
        if (message.BAddBet != null && message.hasOwnProperty("BAddBet"))
            object.BAddBet = message.BAddBet;
        return object;
    };

    /**
     * Converts this Client2FortuneGems3SrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2FortuneGems3SrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2FortuneGems3SrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2FortuneGems3SrvReqBet
     * @function getTypeUrl
     * @memberof Client2FortuneGems3SrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2FortuneGems3SrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2FortuneGems3SrvReqBet";
    };

    return Client2FortuneGems3SrvReqBet;
})();

export const Client2FortuneGems3SrvAckBet = $root.Client2FortuneGems3SrvAckBet = (() => {

    /**
     * Properties of a Client2FortuneGems3SrvAckBet.
     * @exports IClient2FortuneGems3SrvAckBet
     * @interface IClient2FortuneGems3SrvAckBet
     * @property {number|null} [Ret] Client2FortuneGems3SrvAckBet Ret
     * @property {number|null} [DeskNo] Client2FortuneGems3SrvAckBet DeskNo
     * @property {number|null} [UserID] Client2FortuneGems3SrvAckBet UserID
     * @property {number|null} [SeatNo] Client2FortuneGems3SrvAckBet SeatNo
     * @property {number|Long|null} [Gold] Client2FortuneGems3SrvAckBet Gold
     */

    /**
     * Constructs a new Client2FortuneGems3SrvAckBet.
     * @exports Client2FortuneGems3SrvAckBet
     * @classdesc Represents a Client2FortuneGems3SrvAckBet.
     * @implements IClient2FortuneGems3SrvAckBet
     * @constructor
     * @param {IClient2FortuneGems3SrvAckBet=} [properties] Properties to set
     */
    function Client2FortuneGems3SrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2FortuneGems3SrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     */
    Client2FortuneGems3SrvAckBet.prototype.Ret = 0;

    /**
     * Client2FortuneGems3SrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     */
    Client2FortuneGems3SrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2FortuneGems3SrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     */
    Client2FortuneGems3SrvAckBet.prototype.UserID = 0;

    /**
     * Client2FortuneGems3SrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     */
    Client2FortuneGems3SrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2FortuneGems3SrvAckBet Gold.
     * @member {number|Long} Gold
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     */
    Client2FortuneGems3SrvAckBet.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2FortuneGems3SrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {IClient2FortuneGems3SrvAckBet=} [properties] Properties to set
     * @returns {Client2FortuneGems3SrvAckBet} Client2FortuneGems3SrvAckBet instance
     */
    Client2FortuneGems3SrvAckBet.create = function create(properties) {
        return new Client2FortuneGems3SrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2FortuneGems3SrvAckBet message. Does not implicitly {@link Client2FortuneGems3SrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {IClient2FortuneGems3SrvAckBet} message Client2FortuneGems3SrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneGems3SrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Gold);
        return writer;
    };

    /**
     * Encodes the specified Client2FortuneGems3SrvAckBet message, length delimited. Does not implicitly {@link Client2FortuneGems3SrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {IClient2FortuneGems3SrvAckBet} message Client2FortuneGems3SrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneGems3SrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2FortuneGems3SrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2FortuneGems3SrvAckBet} Client2FortuneGems3SrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneGems3SrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2FortuneGems3SrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Gold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2FortuneGems3SrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2FortuneGems3SrvAckBet} Client2FortuneGems3SrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneGems3SrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2FortuneGems3SrvAckBet message.
     * @function verify
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2FortuneGems3SrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2FortuneGems3SrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2FortuneGems3SrvAckBet} Client2FortuneGems3SrvAckBet
     */
    Client2FortuneGems3SrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2FortuneGems3SrvAckBet)
            return object;
        let message = new $root.Client2FortuneGems3SrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2FortuneGems3SrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {Client2FortuneGems3SrvAckBet} message Client2FortuneGems3SrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2FortuneGems3SrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        return object;
    };

    /**
     * Converts this Client2FortuneGems3SrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2FortuneGems3SrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2FortuneGems3SrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2FortuneGems3SrvAckBet
     * @function getTypeUrl
     * @memberof Client2FortuneGems3SrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2FortuneGems3SrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2FortuneGems3SrvAckBet";
    };

    return Client2FortuneGems3SrvAckBet;
})();

export const ClientFortuneGems3PushBetDate = $root.ClientFortuneGems3PushBetDate = (() => {

    /**
     * Properties of a ClientFortuneGems3PushBetDate.
     * @exports IClientFortuneGems3PushBetDate
     * @interface IClientFortuneGems3PushBetDate
     * @property {Array.<number>|null} [card] ClientFortuneGems3PushBetDate card
     * @property {number|Long|null} [basegold] ClientFortuneGems3PushBetDate basegold
     * @property {number|Long|null} [segmgold] ClientFortuneGems3PushBetDate segmgold
     * @property {number|Long|null} [prizegold] ClientFortuneGems3PushBetDate prizegold
     * @property {number|null} [prizemult] ClientFortuneGems3PushBetDate prizemult
     */

    /**
     * Constructs a new ClientFortuneGems3PushBetDate.
     * @exports ClientFortuneGems3PushBetDate
     * @classdesc Represents a ClientFortuneGems3PushBetDate.
     * @implements IClientFortuneGems3PushBetDate
     * @constructor
     * @param {IClientFortuneGems3PushBetDate=} [properties] Properties to set
     */
    function ClientFortuneGems3PushBetDate(properties) {
        this.card = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneGems3PushBetDate card.
     * @member {Array.<number>} card
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     */
    ClientFortuneGems3PushBetDate.prototype.card = $util.emptyArray;

    /**
     * ClientFortuneGems3PushBetDate basegold.
     * @member {number|Long} basegold
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     */
    ClientFortuneGems3PushBetDate.prototype.basegold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientFortuneGems3PushBetDate segmgold.
     * @member {number|Long} segmgold
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     */
    ClientFortuneGems3PushBetDate.prototype.segmgold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientFortuneGems3PushBetDate prizegold.
     * @member {number|Long} prizegold
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     */
    ClientFortuneGems3PushBetDate.prototype.prizegold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientFortuneGems3PushBetDate prizemult.
     * @member {number} prizemult
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     */
    ClientFortuneGems3PushBetDate.prototype.prizemult = 0;

    /**
     * Creates a new ClientFortuneGems3PushBetDate instance using the specified properties.
     * @function create
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {IClientFortuneGems3PushBetDate=} [properties] Properties to set
     * @returns {ClientFortuneGems3PushBetDate} ClientFortuneGems3PushBetDate instance
     */
    ClientFortuneGems3PushBetDate.create = function create(properties) {
        return new ClientFortuneGems3PushBetDate(properties);
    };

    /**
     * Encodes the specified ClientFortuneGems3PushBetDate message. Does not implicitly {@link ClientFortuneGems3PushBetDate.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {IClientFortuneGems3PushBetDate} message ClientFortuneGems3PushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGems3PushBetDate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.card != null && message.card.length) {
            writer.uint32(/* id 1, wireType 2 =*/10).fork();
            for (let i = 0; i < message.card.length; ++i)
                writer.uint32(message.card[i]);
            writer.ldelim();
        }
        if (message.basegold != null && Object.hasOwnProperty.call(message, "basegold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.basegold);
        if (message.segmgold != null && Object.hasOwnProperty.call(message, "segmgold"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.segmgold);
        if (message.prizegold != null && Object.hasOwnProperty.call(message, "prizegold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.prizegold);
        if (message.prizemult != null && Object.hasOwnProperty.call(message, "prizemult"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.prizemult);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneGems3PushBetDate message, length delimited. Does not implicitly {@link ClientFortuneGems3PushBetDate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {IClientFortuneGems3PushBetDate} message ClientFortuneGems3PushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGems3PushBetDate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneGems3PushBetDate message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneGems3PushBetDate} ClientFortuneGems3PushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGems3PushBetDate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneGems3PushBetDate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.card && message.card.length))
                        message.card = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.card.push(reader.uint32());
                    } else
                        message.card.push(reader.uint32());
                    break;
                }
            case 2: {
                    message.basegold = reader.uint64();
                    break;
                }
            case 3: {
                    message.segmgold = reader.uint64();
                    break;
                }
            case 4: {
                    message.prizegold = reader.uint64();
                    break;
                }
            case 5: {
                    message.prizemult = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneGems3PushBetDate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneGems3PushBetDate} ClientFortuneGems3PushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGems3PushBetDate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneGems3PushBetDate message.
     * @function verify
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneGems3PushBetDate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.card != null && message.hasOwnProperty("card")) {
            if (!Array.isArray(message.card))
                return "card: array expected";
            for (let i = 0; i < message.card.length; ++i)
                if (!$util.isInteger(message.card[i]))
                    return "card: integer[] expected";
        }
        if (message.basegold != null && message.hasOwnProperty("basegold"))
            if (!$util.isInteger(message.basegold) && !(message.basegold && $util.isInteger(message.basegold.low) && $util.isInteger(message.basegold.high)))
                return "basegold: integer|Long expected";
        if (message.segmgold != null && message.hasOwnProperty("segmgold"))
            if (!$util.isInteger(message.segmgold) && !(message.segmgold && $util.isInteger(message.segmgold.low) && $util.isInteger(message.segmgold.high)))
                return "segmgold: integer|Long expected";
        if (message.prizegold != null && message.hasOwnProperty("prizegold"))
            if (!$util.isInteger(message.prizegold) && !(message.prizegold && $util.isInteger(message.prizegold.low) && $util.isInteger(message.prizegold.high)))
                return "prizegold: integer|Long expected";
        if (message.prizemult != null && message.hasOwnProperty("prizemult"))
            if (!$util.isInteger(message.prizemult))
                return "prizemult: integer expected";
        return null;
    };

    /**
     * Creates a ClientFortuneGems3PushBetDate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneGems3PushBetDate} ClientFortuneGems3PushBetDate
     */
    ClientFortuneGems3PushBetDate.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneGems3PushBetDate)
            return object;
        let message = new $root.ClientFortuneGems3PushBetDate();
        if (object.card) {
            if (!Array.isArray(object.card))
                throw TypeError(".ClientFortuneGems3PushBetDate.card: array expected");
            message.card = [];
            for (let i = 0; i < object.card.length; ++i)
                message.card[i] = object.card[i] >>> 0;
        }
        if (object.basegold != null)
            if ($util.Long)
                (message.basegold = $util.Long.fromValue(object.basegold)).unsigned = true;
            else if (typeof object.basegold === "string")
                message.basegold = parseInt(object.basegold, 10);
            else if (typeof object.basegold === "number")
                message.basegold = object.basegold;
            else if (typeof object.basegold === "object")
                message.basegold = new $util.LongBits(object.basegold.low >>> 0, object.basegold.high >>> 0).toNumber(true);
        if (object.segmgold != null)
            if ($util.Long)
                (message.segmgold = $util.Long.fromValue(object.segmgold)).unsigned = true;
            else if (typeof object.segmgold === "string")
                message.segmgold = parseInt(object.segmgold, 10);
            else if (typeof object.segmgold === "number")
                message.segmgold = object.segmgold;
            else if (typeof object.segmgold === "object")
                message.segmgold = new $util.LongBits(object.segmgold.low >>> 0, object.segmgold.high >>> 0).toNumber(true);
        if (object.prizegold != null)
            if ($util.Long)
                (message.prizegold = $util.Long.fromValue(object.prizegold)).unsigned = true;
            else if (typeof object.prizegold === "string")
                message.prizegold = parseInt(object.prizegold, 10);
            else if (typeof object.prizegold === "number")
                message.prizegold = object.prizegold;
            else if (typeof object.prizegold === "object")
                message.prizegold = new $util.LongBits(object.prizegold.low >>> 0, object.prizegold.high >>> 0).toNumber(true);
        if (object.prizemult != null)
            message.prizemult = object.prizemult >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneGems3PushBetDate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {ClientFortuneGems3PushBetDate} message ClientFortuneGems3PushBetDate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneGems3PushBetDate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.card = [];
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.basegold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.basegold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.segmgold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.segmgold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.prizegold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.prizegold = options.longs === String ? "0" : 0;
            object.prizemult = 0;
        }
        if (message.card && message.card.length) {
            object.card = [];
            for (let j = 0; j < message.card.length; ++j)
                object.card[j] = message.card[j];
        }
        if (message.basegold != null && message.hasOwnProperty("basegold"))
            if (typeof message.basegold === "number")
                object.basegold = options.longs === String ? String(message.basegold) : message.basegold;
            else
                object.basegold = options.longs === String ? $util.Long.prototype.toString.call(message.basegold) : options.longs === Number ? new $util.LongBits(message.basegold.low >>> 0, message.basegold.high >>> 0).toNumber(true) : message.basegold;
        if (message.segmgold != null && message.hasOwnProperty("segmgold"))
            if (typeof message.segmgold === "number")
                object.segmgold = options.longs === String ? String(message.segmgold) : message.segmgold;
            else
                object.segmgold = options.longs === String ? $util.Long.prototype.toString.call(message.segmgold) : options.longs === Number ? new $util.LongBits(message.segmgold.low >>> 0, message.segmgold.high >>> 0).toNumber(true) : message.segmgold;
        if (message.prizegold != null && message.hasOwnProperty("prizegold"))
            if (typeof message.prizegold === "number")
                object.prizegold = options.longs === String ? String(message.prizegold) : message.prizegold;
            else
                object.prizegold = options.longs === String ? $util.Long.prototype.toString.call(message.prizegold) : options.longs === Number ? new $util.LongBits(message.prizegold.low >>> 0, message.prizegold.high >>> 0).toNumber(true) : message.prizegold;
        if (message.prizemult != null && message.hasOwnProperty("prizemult"))
            object.prizemult = message.prizemult;
        return object;
    };

    /**
     * Converts this ClientFortuneGems3PushBetDate to JSON.
     * @function toJSON
     * @memberof ClientFortuneGems3PushBetDate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneGems3PushBetDate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneGems3PushBetDate
     * @function getTypeUrl
     * @memberof ClientFortuneGems3PushBetDate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneGems3PushBetDate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneGems3PushBetDate";
    };

    return ClientFortuneGems3PushBetDate;
})();

export const ClientFortuneGems3CartoonReq = $root.ClientFortuneGems3CartoonReq = (() => {

    /**
     * Properties of a ClientFortuneGems3CartoonReq.
     * @exports IClientFortuneGems3CartoonReq
     * @interface IClientFortuneGems3CartoonReq
     * @property {number|null} [DeskNo] ClientFortuneGems3CartoonReq DeskNo
     * @property {number|null} [UserID] ClientFortuneGems3CartoonReq UserID
     */

    /**
     * Constructs a new ClientFortuneGems3CartoonReq.
     * @exports ClientFortuneGems3CartoonReq
     * @classdesc Represents a ClientFortuneGems3CartoonReq.
     * @implements IClientFortuneGems3CartoonReq
     * @constructor
     * @param {IClientFortuneGems3CartoonReq=} [properties] Properties to set
     */
    function ClientFortuneGems3CartoonReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneGems3CartoonReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientFortuneGems3CartoonReq
     * @instance
     */
    ClientFortuneGems3CartoonReq.prototype.DeskNo = 0;

    /**
     * ClientFortuneGems3CartoonReq UserID.
     * @member {number} UserID
     * @memberof ClientFortuneGems3CartoonReq
     * @instance
     */
    ClientFortuneGems3CartoonReq.prototype.UserID = 0;

    /**
     * Creates a new ClientFortuneGems3CartoonReq instance using the specified properties.
     * @function create
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {IClientFortuneGems3CartoonReq=} [properties] Properties to set
     * @returns {ClientFortuneGems3CartoonReq} ClientFortuneGems3CartoonReq instance
     */
    ClientFortuneGems3CartoonReq.create = function create(properties) {
        return new ClientFortuneGems3CartoonReq(properties);
    };

    /**
     * Encodes the specified ClientFortuneGems3CartoonReq message. Does not implicitly {@link ClientFortuneGems3CartoonReq.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {IClientFortuneGems3CartoonReq} message ClientFortuneGems3CartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGems3CartoonReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneGems3CartoonReq message, length delimited. Does not implicitly {@link ClientFortuneGems3CartoonReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {IClientFortuneGems3CartoonReq} message ClientFortuneGems3CartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGems3CartoonReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneGems3CartoonReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneGems3CartoonReq} ClientFortuneGems3CartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGems3CartoonReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneGems3CartoonReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneGems3CartoonReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneGems3CartoonReq} ClientFortuneGems3CartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGems3CartoonReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneGems3CartoonReq message.
     * @function verify
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneGems3CartoonReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientFortuneGems3CartoonReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneGems3CartoonReq} ClientFortuneGems3CartoonReq
     */
    ClientFortuneGems3CartoonReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneGems3CartoonReq)
            return object;
        let message = new $root.ClientFortuneGems3CartoonReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneGems3CartoonReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {ClientFortuneGems3CartoonReq} message ClientFortuneGems3CartoonReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneGems3CartoonReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientFortuneGems3CartoonReq to JSON.
     * @function toJSON
     * @memberof ClientFortuneGems3CartoonReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneGems3CartoonReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneGems3CartoonReq
     * @function getTypeUrl
     * @memberof ClientFortuneGems3CartoonReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneGems3CartoonReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneGems3CartoonReq";
    };

    return ClientFortuneGems3CartoonReq;
})();

export const ClientFortuneGemsPushGameEndData = $root.ClientFortuneGemsPushGameEndData = (() => {

    /**
     * Properties of a ClientFortuneGemsPushGameEndData.
     * @exports IClientFortuneGemsPushGameEndData
     * @interface IClientFortuneGemsPushGameEndData
     * @property {number|Long|null} [PlayerGold] ClientFortuneGemsPushGameEndData PlayerGold
     */

    /**
     * Constructs a new ClientFortuneGemsPushGameEndData.
     * @exports ClientFortuneGemsPushGameEndData
     * @classdesc Represents a ClientFortuneGemsPushGameEndData.
     * @implements IClientFortuneGemsPushGameEndData
     * @constructor
     * @param {IClientFortuneGemsPushGameEndData=} [properties] Properties to set
     */
    function ClientFortuneGemsPushGameEndData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneGemsPushGameEndData PlayerGold.
     * @member {number|Long} PlayerGold
     * @memberof ClientFortuneGemsPushGameEndData
     * @instance
     */
    ClientFortuneGemsPushGameEndData.prototype.PlayerGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientFortuneGemsPushGameEndData instance using the specified properties.
     * @function create
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {IClientFortuneGemsPushGameEndData=} [properties] Properties to set
     * @returns {ClientFortuneGemsPushGameEndData} ClientFortuneGemsPushGameEndData instance
     */
    ClientFortuneGemsPushGameEndData.create = function create(properties) {
        return new ClientFortuneGemsPushGameEndData(properties);
    };

    /**
     * Encodes the specified ClientFortuneGemsPushGameEndData message. Does not implicitly {@link ClientFortuneGemsPushGameEndData.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {IClientFortuneGemsPushGameEndData} message ClientFortuneGemsPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGemsPushGameEndData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PlayerGold != null && Object.hasOwnProperty.call(message, "PlayerGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PlayerGold);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneGemsPushGameEndData message, length delimited. Does not implicitly {@link ClientFortuneGemsPushGameEndData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {IClientFortuneGemsPushGameEndData} message ClientFortuneGemsPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneGemsPushGameEndData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneGemsPushGameEndData message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneGemsPushGameEndData} ClientFortuneGemsPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGemsPushGameEndData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneGemsPushGameEndData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PlayerGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneGemsPushGameEndData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneGemsPushGameEndData} ClientFortuneGemsPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneGemsPushGameEndData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneGemsPushGameEndData message.
     * @function verify
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneGemsPushGameEndData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (!$util.isInteger(message.PlayerGold) && !(message.PlayerGold && $util.isInteger(message.PlayerGold.low) && $util.isInteger(message.PlayerGold.high)))
                return "PlayerGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientFortuneGemsPushGameEndData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneGemsPushGameEndData} ClientFortuneGemsPushGameEndData
     */
    ClientFortuneGemsPushGameEndData.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneGemsPushGameEndData)
            return object;
        let message = new $root.ClientFortuneGemsPushGameEndData();
        if (object.PlayerGold != null)
            if ($util.Long)
                (message.PlayerGold = $util.Long.fromValue(object.PlayerGold)).unsigned = true;
            else if (typeof object.PlayerGold === "string")
                message.PlayerGold = parseInt(object.PlayerGold, 10);
            else if (typeof object.PlayerGold === "number")
                message.PlayerGold = object.PlayerGold;
            else if (typeof object.PlayerGold === "object")
                message.PlayerGold = new $util.LongBits(object.PlayerGold.low >>> 0, object.PlayerGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneGemsPushGameEndData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {ClientFortuneGemsPushGameEndData} message ClientFortuneGemsPushGameEndData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneGemsPushGameEndData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerGold = options.longs === String ? "0" : 0;
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (typeof message.PlayerGold === "number")
                object.PlayerGold = options.longs === String ? String(message.PlayerGold) : message.PlayerGold;
            else
                object.PlayerGold = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerGold) : options.longs === Number ? new $util.LongBits(message.PlayerGold.low >>> 0, message.PlayerGold.high >>> 0).toNumber(true) : message.PlayerGold;
        return object;
    };

    /**
     * Converts this ClientFortuneGemsPushGameEndData to JSON.
     * @function toJSON
     * @memberof ClientFortuneGemsPushGameEndData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneGemsPushGameEndData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneGemsPushGameEndData
     * @function getTypeUrl
     * @memberof ClientFortuneGemsPushGameEndData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneGemsPushGameEndData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneGemsPushGameEndData";
    };

    return ClientFortuneGemsPushGameEndData;
})();

export const FortuneTigerProduct = $root.FortuneTigerProduct = (() => {

    /**
     * Properties of a FortuneTigerProduct.
     * @exports IFortuneTigerProduct
     * @interface IFortuneTigerProduct
     * @property {number|null} [PID] FortuneTigerProduct PID
     * @property {number|null} [Mode] FortuneTigerProduct Mode
     * @property {number|null} [GameLine] FortuneTigerProduct GameLine
     * @property {string|null} [BetList] FortuneTigerProduct BetList
     * @property {string|null} [AutoBet] FortuneTigerProduct AutoBet
     * @property {Array.<number>|null} [OddsPrize] FortuneTigerProduct OddsPrize
     */

    /**
     * Constructs a new FortuneTigerProduct.
     * @exports FortuneTigerProduct
     * @classdesc Represents a FortuneTigerProduct.
     * @implements IFortuneTigerProduct
     * @constructor
     * @param {IFortuneTigerProduct=} [properties] Properties to set
     */
    function FortuneTigerProduct(properties) {
        this.OddsPrize = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FortuneTigerProduct PID.
     * @member {number} PID
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.PID = 0;

    /**
     * FortuneTigerProduct Mode.
     * @member {number} Mode
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.Mode = 0;

    /**
     * FortuneTigerProduct GameLine.
     * @member {number} GameLine
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.GameLine = 0;

    /**
     * FortuneTigerProduct BetList.
     * @member {string} BetList
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.BetList = "";

    /**
     * FortuneTigerProduct AutoBet.
     * @member {string} AutoBet
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.AutoBet = "";

    /**
     * FortuneTigerProduct OddsPrize.
     * @member {Array.<number>} OddsPrize
     * @memberof FortuneTigerProduct
     * @instance
     */
    FortuneTigerProduct.prototype.OddsPrize = $util.emptyArray;

    /**
     * Creates a new FortuneTigerProduct instance using the specified properties.
     * @function create
     * @memberof FortuneTigerProduct
     * @static
     * @param {IFortuneTigerProduct=} [properties] Properties to set
     * @returns {FortuneTigerProduct} FortuneTigerProduct instance
     */
    FortuneTigerProduct.create = function create(properties) {
        return new FortuneTigerProduct(properties);
    };

    /**
     * Encodes the specified FortuneTigerProduct message. Does not implicitly {@link FortuneTigerProduct.verify|verify} messages.
     * @function encode
     * @memberof FortuneTigerProduct
     * @static
     * @param {IFortuneTigerProduct} message FortuneTigerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneTigerProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.GameLine != null && Object.hasOwnProperty.call(message, "GameLine"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameLine);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BetList);
        if (message.AutoBet != null && Object.hasOwnProperty.call(message, "AutoBet"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.AutoBet);
        if (message.OddsPrize != null && message.OddsPrize.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.OddsPrize.length; ++i)
                writer.uint32(message.OddsPrize[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified FortuneTigerProduct message, length delimited. Does not implicitly {@link FortuneTigerProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FortuneTigerProduct
     * @static
     * @param {IFortuneTigerProduct} message FortuneTigerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneTigerProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FortuneTigerProduct message from the specified reader or buffer.
     * @function decode
     * @memberof FortuneTigerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FortuneTigerProduct} FortuneTigerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneTigerProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FortuneTigerProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameLine = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetList = reader.string();
                    break;
                }
            case 5: {
                    message.AutoBet = reader.string();
                    break;
                }
            case 6: {
                    if (!(message.OddsPrize && message.OddsPrize.length))
                        message.OddsPrize = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.OddsPrize.push(reader.uint32());
                    } else
                        message.OddsPrize.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FortuneTigerProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FortuneTigerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FortuneTigerProduct} FortuneTigerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneTigerProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FortuneTigerProduct message.
     * @function verify
     * @memberof FortuneTigerProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FortuneTigerProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.GameLine != null && message.hasOwnProperty("GameLine"))
            if (!$util.isInteger(message.GameLine))
                return "GameLine: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            if (!$util.isString(message.AutoBet))
                return "AutoBet: string expected";
        if (message.OddsPrize != null && message.hasOwnProperty("OddsPrize")) {
            if (!Array.isArray(message.OddsPrize))
                return "OddsPrize: array expected";
            for (let i = 0; i < message.OddsPrize.length; ++i)
                if (!$util.isInteger(message.OddsPrize[i]))
                    return "OddsPrize: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a FortuneTigerProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FortuneTigerProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FortuneTigerProduct} FortuneTigerProduct
     */
    FortuneTigerProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.FortuneTigerProduct)
            return object;
        let message = new $root.FortuneTigerProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.GameLine != null)
            message.GameLine = object.GameLine >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.AutoBet != null)
            message.AutoBet = String(object.AutoBet);
        if (object.OddsPrize) {
            if (!Array.isArray(object.OddsPrize))
                throw TypeError(".FortuneTigerProduct.OddsPrize: array expected");
            message.OddsPrize = [];
            for (let i = 0; i < object.OddsPrize.length; ++i)
                message.OddsPrize[i] = object.OddsPrize[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a FortuneTigerProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FortuneTigerProduct
     * @static
     * @param {FortuneTigerProduct} message FortuneTigerProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FortuneTigerProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.OddsPrize = [];
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.GameLine = 0;
            object.BetList = "";
            object.AutoBet = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.GameLine != null && message.hasOwnProperty("GameLine"))
            object.GameLine = message.GameLine;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            object.AutoBet = message.AutoBet;
        if (message.OddsPrize && message.OddsPrize.length) {
            object.OddsPrize = [];
            for (let j = 0; j < message.OddsPrize.length; ++j)
                object.OddsPrize[j] = message.OddsPrize[j];
        }
        return object;
    };

    /**
     * Converts this FortuneTigerProduct to JSON.
     * @function toJSON
     * @memberof FortuneTigerProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FortuneTigerProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FortuneTigerProduct
     * @function getTypeUrl
     * @memberof FortuneTigerProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FortuneTigerProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FortuneTigerProduct";
    };

    return FortuneTigerProduct;
})();

export const FortuneTigerSrvToDeskPushDeskInfo = $root.FortuneTigerSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a FortuneTigerSrvToDeskPushDeskInfo.
     * @exports IFortuneTigerSrvToDeskPushDeskInfo
     * @interface IFortuneTigerSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] FortuneTigerSrvToDeskPushDeskInfo UserID
     * @property {number|Long|null} [Gold] FortuneTigerSrvToDeskPushDeskInfo Gold
     * @property {IFortuneTigerProduct|null} [Product] FortuneTigerSrvToDeskPushDeskInfo Product
     */

    /**
     * Constructs a new FortuneTigerSrvToDeskPushDeskInfo.
     * @exports FortuneTigerSrvToDeskPushDeskInfo
     * @classdesc Represents a FortuneTigerSrvToDeskPushDeskInfo.
     * @implements IFortuneTigerSrvToDeskPushDeskInfo
     * @constructor
     * @param {IFortuneTigerSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function FortuneTigerSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FortuneTigerSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @instance
     */
    FortuneTigerSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * FortuneTigerSrvToDeskPushDeskInfo Gold.
     * @member {number|Long} Gold
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @instance
     */
    FortuneTigerSrvToDeskPushDeskInfo.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * FortuneTigerSrvToDeskPushDeskInfo Product.
     * @member {IFortuneTigerProduct|null|undefined} Product
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @instance
     */
    FortuneTigerSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * Creates a new FortuneTigerSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneTigerSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {FortuneTigerSrvToDeskPushDeskInfo} FortuneTigerSrvToDeskPushDeskInfo instance
     */
    FortuneTigerSrvToDeskPushDeskInfo.create = function create(properties) {
        return new FortuneTigerSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified FortuneTigerSrvToDeskPushDeskInfo message. Does not implicitly {@link FortuneTigerSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneTigerSrvToDeskPushDeskInfo} message FortuneTigerSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneTigerSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.Gold);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.FortuneTigerProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FortuneTigerSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link FortuneTigerSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {IFortuneTigerSrvToDeskPushDeskInfo} message FortuneTigerSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FortuneTigerSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FortuneTigerSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FortuneTigerSrvToDeskPushDeskInfo} FortuneTigerSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneTigerSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FortuneTigerSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Gold = reader.uint64();
                    break;
                }
            case 3: {
                    message.Product = $root.FortuneTigerProduct.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FortuneTigerSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FortuneTigerSrvToDeskPushDeskInfo} FortuneTigerSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FortuneTigerSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FortuneTigerSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FortuneTigerSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.FortuneTigerProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        return null;
    };

    /**
     * Creates a FortuneTigerSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FortuneTigerSrvToDeskPushDeskInfo} FortuneTigerSrvToDeskPushDeskInfo
     */
    FortuneTigerSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.FortuneTigerSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.FortuneTigerSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".FortuneTigerSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.FortuneTigerProduct.fromObject(object.Product);
        }
        return message;
    };

    /**
     * Creates a plain object from a FortuneTigerSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {FortuneTigerSrvToDeskPushDeskInfo} message FortuneTigerSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FortuneTigerSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.FortuneTigerProduct.toObject(message.Product, options);
        return object;
    };

    /**
     * Converts this FortuneTigerSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FortuneTigerSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FortuneTigerSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof FortuneTigerSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FortuneTigerSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FortuneTigerSrvToDeskPushDeskInfo";
    };

    return FortuneTigerSrvToDeskPushDeskInfo;
})();

export const Client2FortuneTigerSrvReqBet = $root.Client2FortuneTigerSrvReqBet = (() => {

    /**
     * Properties of a Client2FortuneTigerSrvReqBet.
     * @exports IClient2FortuneTigerSrvReqBet
     * @interface IClient2FortuneTigerSrvReqBet
     * @property {number|null} [DeskNo] Client2FortuneTigerSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2FortuneTigerSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2FortuneTigerSrvReqBet SeatNo
     * @property {number|Long|null} [BetGold] Client2FortuneTigerSrvReqBet BetGold
     */

    /**
     * Constructs a new Client2FortuneTigerSrvReqBet.
     * @exports Client2FortuneTigerSrvReqBet
     * @classdesc Represents a Client2FortuneTigerSrvReqBet.
     * @implements IClient2FortuneTigerSrvReqBet
     * @constructor
     * @param {IClient2FortuneTigerSrvReqBet=} [properties] Properties to set
     */
    function Client2FortuneTigerSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2FortuneTigerSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2FortuneTigerSrvReqBet
     * @instance
     */
    Client2FortuneTigerSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2FortuneTigerSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2FortuneTigerSrvReqBet
     * @instance
     */
    Client2FortuneTigerSrvReqBet.prototype.UserID = 0;

    /**
     * Client2FortuneTigerSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2FortuneTigerSrvReqBet
     * @instance
     */
    Client2FortuneTigerSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2FortuneTigerSrvReqBet BetGold.
     * @member {number|Long} BetGold
     * @memberof Client2FortuneTigerSrvReqBet
     * @instance
     */
    Client2FortuneTigerSrvReqBet.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2FortuneTigerSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {IClient2FortuneTigerSrvReqBet=} [properties] Properties to set
     * @returns {Client2FortuneTigerSrvReqBet} Client2FortuneTigerSrvReqBet instance
     */
    Client2FortuneTigerSrvReqBet.create = function create(properties) {
        return new Client2FortuneTigerSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2FortuneTigerSrvReqBet message. Does not implicitly {@link Client2FortuneTigerSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {IClient2FortuneTigerSrvReqBet} message Client2FortuneTigerSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneTigerSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        return writer;
    };

    /**
     * Encodes the specified Client2FortuneTigerSrvReqBet message, length delimited. Does not implicitly {@link Client2FortuneTigerSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {IClient2FortuneTigerSrvReqBet} message Client2FortuneTigerSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneTigerSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2FortuneTigerSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2FortuneTigerSrvReqBet} Client2FortuneTigerSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneTigerSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2FortuneTigerSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2FortuneTigerSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2FortuneTigerSrvReqBet} Client2FortuneTigerSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneTigerSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2FortuneTigerSrvReqBet message.
     * @function verify
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2FortuneTigerSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2FortuneTigerSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2FortuneTigerSrvReqBet} Client2FortuneTigerSrvReqBet
     */
    Client2FortuneTigerSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2FortuneTigerSrvReqBet)
            return object;
        let message = new $root.Client2FortuneTigerSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2FortuneTigerSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {Client2FortuneTigerSrvReqBet} message Client2FortuneTigerSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2FortuneTigerSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        return object;
    };

    /**
     * Converts this Client2FortuneTigerSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2FortuneTigerSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2FortuneTigerSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2FortuneTigerSrvReqBet
     * @function getTypeUrl
     * @memberof Client2FortuneTigerSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2FortuneTigerSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2FortuneTigerSrvReqBet";
    };

    return Client2FortuneTigerSrvReqBet;
})();

export const Client2FortuneTigerSrvAckBet = $root.Client2FortuneTigerSrvAckBet = (() => {

    /**
     * Properties of a Client2FortuneTigerSrvAckBet.
     * @exports IClient2FortuneTigerSrvAckBet
     * @interface IClient2FortuneTigerSrvAckBet
     * @property {number|null} [Ret] Client2FortuneTigerSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2FortuneTigerSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2FortuneTigerSrvAckBet UserID
     * @property {number|null} [SeatNo] Client2FortuneTigerSrvAckBet SeatNo
     * @property {number|Long|null} [Gold] Client2FortuneTigerSrvAckBet Gold
     */

    /**
     * Constructs a new Client2FortuneTigerSrvAckBet.
     * @exports Client2FortuneTigerSrvAckBet
     * @classdesc Represents a Client2FortuneTigerSrvAckBet.
     * @implements IClient2FortuneTigerSrvAckBet
     * @constructor
     * @param {IClient2FortuneTigerSrvAckBet=} [properties] Properties to set
     */
    function Client2FortuneTigerSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2FortuneTigerSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     */
    Client2FortuneTigerSrvAckBet.prototype.Ret = 0;

    /**
     * Client2FortuneTigerSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     */
    Client2FortuneTigerSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2FortuneTigerSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     */
    Client2FortuneTigerSrvAckBet.prototype.UserID = 0;

    /**
     * Client2FortuneTigerSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     */
    Client2FortuneTigerSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2FortuneTigerSrvAckBet Gold.
     * @member {number|Long} Gold
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     */
    Client2FortuneTigerSrvAckBet.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2FortuneTigerSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {IClient2FortuneTigerSrvAckBet=} [properties] Properties to set
     * @returns {Client2FortuneTigerSrvAckBet} Client2FortuneTigerSrvAckBet instance
     */
    Client2FortuneTigerSrvAckBet.create = function create(properties) {
        return new Client2FortuneTigerSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2FortuneTigerSrvAckBet message. Does not implicitly {@link Client2FortuneTigerSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {IClient2FortuneTigerSrvAckBet} message Client2FortuneTigerSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneTigerSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Gold);
        return writer;
    };

    /**
     * Encodes the specified Client2FortuneTigerSrvAckBet message, length delimited. Does not implicitly {@link Client2FortuneTigerSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {IClient2FortuneTigerSrvAckBet} message Client2FortuneTigerSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2FortuneTigerSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2FortuneTigerSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2FortuneTigerSrvAckBet} Client2FortuneTigerSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneTigerSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2FortuneTigerSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Gold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2FortuneTigerSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2FortuneTigerSrvAckBet} Client2FortuneTigerSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2FortuneTigerSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2FortuneTigerSrvAckBet message.
     * @function verify
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2FortuneTigerSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2FortuneTigerSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2FortuneTigerSrvAckBet} Client2FortuneTigerSrvAckBet
     */
    Client2FortuneTigerSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2FortuneTigerSrvAckBet)
            return object;
        let message = new $root.Client2FortuneTigerSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2FortuneTigerSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {Client2FortuneTigerSrvAckBet} message Client2FortuneTigerSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2FortuneTigerSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        return object;
    };

    /**
     * Converts this Client2FortuneTigerSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2FortuneTigerSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2FortuneTigerSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2FortuneTigerSrvAckBet
     * @function getTypeUrl
     * @memberof Client2FortuneTigerSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2FortuneTigerSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2FortuneTigerSrvAckBet";
    };

    return Client2FortuneTigerSrvAckBet;
})();

export const ClientFortuneTigerPushBetDate = $root.ClientFortuneTigerPushBetDate = (() => {

    /**
     * Properties of a ClientFortuneTigerPushBetDate.
     * @exports IClientFortuneTigerPushBetDate
     * @interface IClientFortuneTigerPushBetDate
     * @property {number|null} [PrizeType] ClientFortuneTigerPushBetDate PrizeType
     * @property {number|Long|null} [PrizeGold] ClientFortuneTigerPushBetDate PrizeGold
     * @property {number|Long|null} [PrizePot] ClientFortuneTigerPushBetDate PrizePot
     * @property {number|null} [CardType] ClientFortuneTigerPushBetDate CardType
     * @property {Array.<number>|null} [CardNum] ClientFortuneTigerPushBetDate CardNum
     */

    /**
     * Constructs a new ClientFortuneTigerPushBetDate.
     * @exports ClientFortuneTigerPushBetDate
     * @classdesc Represents a ClientFortuneTigerPushBetDate.
     * @implements IClientFortuneTigerPushBetDate
     * @constructor
     * @param {IClientFortuneTigerPushBetDate=} [properties] Properties to set
     */
    function ClientFortuneTigerPushBetDate(properties) {
        this.CardNum = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneTigerPushBetDate PrizeType.
     * @member {number} PrizeType
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     */
    ClientFortuneTigerPushBetDate.prototype.PrizeType = 0;

    /**
     * ClientFortuneTigerPushBetDate PrizeGold.
     * @member {number|Long} PrizeGold
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     */
    ClientFortuneTigerPushBetDate.prototype.PrizeGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientFortuneTigerPushBetDate PrizePot.
     * @member {number|Long} PrizePot
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     */
    ClientFortuneTigerPushBetDate.prototype.PrizePot = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientFortuneTigerPushBetDate CardType.
     * @member {number} CardType
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     */
    ClientFortuneTigerPushBetDate.prototype.CardType = 0;

    /**
     * ClientFortuneTigerPushBetDate CardNum.
     * @member {Array.<number>} CardNum
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     */
    ClientFortuneTigerPushBetDate.prototype.CardNum = $util.emptyArray;

    /**
     * Creates a new ClientFortuneTigerPushBetDate instance using the specified properties.
     * @function create
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {IClientFortuneTigerPushBetDate=} [properties] Properties to set
     * @returns {ClientFortuneTigerPushBetDate} ClientFortuneTigerPushBetDate instance
     */
    ClientFortuneTigerPushBetDate.create = function create(properties) {
        return new ClientFortuneTigerPushBetDate(properties);
    };

    /**
     * Encodes the specified ClientFortuneTigerPushBetDate message. Does not implicitly {@link ClientFortuneTigerPushBetDate.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {IClientFortuneTigerPushBetDate} message ClientFortuneTigerPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerPushBetDate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PrizeType != null && Object.hasOwnProperty.call(message, "PrizeType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PrizeType);
        if (message.PrizeGold != null && Object.hasOwnProperty.call(message, "PrizeGold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.PrizeGold);
        if (message.PrizePot != null && Object.hasOwnProperty.call(message, "PrizePot"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.PrizePot);
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.CardType);
        if (message.CardNum != null && message.CardNum.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.CardNum.length; ++i)
                writer.uint32(message.CardNum[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneTigerPushBetDate message, length delimited. Does not implicitly {@link ClientFortuneTigerPushBetDate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {IClientFortuneTigerPushBetDate} message ClientFortuneTigerPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerPushBetDate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneTigerPushBetDate message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneTigerPushBetDate} ClientFortuneTigerPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerPushBetDate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneTigerPushBetDate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PrizeType = reader.uint32();
                    break;
                }
            case 2: {
                    message.PrizeGold = reader.uint64();
                    break;
                }
            case 3: {
                    message.PrizePot = reader.uint64();
                    break;
                }
            case 4: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 5: {
                    if (!(message.CardNum && message.CardNum.length))
                        message.CardNum = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardNum.push(reader.uint32());
                    } else
                        message.CardNum.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneTigerPushBetDate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneTigerPushBetDate} ClientFortuneTigerPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerPushBetDate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneTigerPushBetDate message.
     * @function verify
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneTigerPushBetDate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PrizeType != null && message.hasOwnProperty("PrizeType"))
            if (!$util.isInteger(message.PrizeType))
                return "PrizeType: integer expected";
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (!$util.isInteger(message.PrizeGold) && !(message.PrizeGold && $util.isInteger(message.PrizeGold.low) && $util.isInteger(message.PrizeGold.high)))
                return "PrizeGold: integer|Long expected";
        if (message.PrizePot != null && message.hasOwnProperty("PrizePot"))
            if (!$util.isInteger(message.PrizePot) && !(message.PrizePot && $util.isInteger(message.PrizePot.low) && $util.isInteger(message.PrizePot.high)))
                return "PrizePot: integer|Long expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.CardNum != null && message.hasOwnProperty("CardNum")) {
            if (!Array.isArray(message.CardNum))
                return "CardNum: array expected";
            for (let i = 0; i < message.CardNum.length; ++i)
                if (!$util.isInteger(message.CardNum[i]))
                    return "CardNum: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a ClientFortuneTigerPushBetDate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneTigerPushBetDate} ClientFortuneTigerPushBetDate
     */
    ClientFortuneTigerPushBetDate.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneTigerPushBetDate)
            return object;
        let message = new $root.ClientFortuneTigerPushBetDate();
        if (object.PrizeType != null)
            message.PrizeType = object.PrizeType >>> 0;
        if (object.PrizeGold != null)
            if ($util.Long)
                (message.PrizeGold = $util.Long.fromValue(object.PrizeGold)).unsigned = true;
            else if (typeof object.PrizeGold === "string")
                message.PrizeGold = parseInt(object.PrizeGold, 10);
            else if (typeof object.PrizeGold === "number")
                message.PrizeGold = object.PrizeGold;
            else if (typeof object.PrizeGold === "object")
                message.PrizeGold = new $util.LongBits(object.PrizeGold.low >>> 0, object.PrizeGold.high >>> 0).toNumber(true);
        if (object.PrizePot != null)
            if ($util.Long)
                (message.PrizePot = $util.Long.fromValue(object.PrizePot)).unsigned = true;
            else if (typeof object.PrizePot === "string")
                message.PrizePot = parseInt(object.PrizePot, 10);
            else if (typeof object.PrizePot === "number")
                message.PrizePot = object.PrizePot;
            else if (typeof object.PrizePot === "object")
                message.PrizePot = new $util.LongBits(object.PrizePot.low >>> 0, object.PrizePot.high >>> 0).toNumber(true);
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.CardNum) {
            if (!Array.isArray(object.CardNum))
                throw TypeError(".ClientFortuneTigerPushBetDate.CardNum: array expected");
            message.CardNum = [];
            for (let i = 0; i < object.CardNum.length; ++i)
                message.CardNum[i] = object.CardNum[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneTigerPushBetDate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {ClientFortuneTigerPushBetDate} message ClientFortuneTigerPushBetDate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneTigerPushBetDate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.CardNum = [];
        if (options.defaults) {
            object.PrizeType = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizePot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizePot = options.longs === String ? "0" : 0;
            object.CardType = 0;
        }
        if (message.PrizeType != null && message.hasOwnProperty("PrizeType"))
            object.PrizeType = message.PrizeType;
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (typeof message.PrizeGold === "number")
                object.PrizeGold = options.longs === String ? String(message.PrizeGold) : message.PrizeGold;
            else
                object.PrizeGold = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeGold) : options.longs === Number ? new $util.LongBits(message.PrizeGold.low >>> 0, message.PrizeGold.high >>> 0).toNumber(true) : message.PrizeGold;
        if (message.PrizePot != null && message.hasOwnProperty("PrizePot"))
            if (typeof message.PrizePot === "number")
                object.PrizePot = options.longs === String ? String(message.PrizePot) : message.PrizePot;
            else
                object.PrizePot = options.longs === String ? $util.Long.prototype.toString.call(message.PrizePot) : options.longs === Number ? new $util.LongBits(message.PrizePot.low >>> 0, message.PrizePot.high >>> 0).toNumber(true) : message.PrizePot;
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.CardNum && message.CardNum.length) {
            object.CardNum = [];
            for (let j = 0; j < message.CardNum.length; ++j)
                object.CardNum[j] = message.CardNum[j];
        }
        return object;
    };

    /**
     * Converts this ClientFortuneTigerPushBetDate to JSON.
     * @function toJSON
     * @memberof ClientFortuneTigerPushBetDate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneTigerPushBetDate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneTigerPushBetDate
     * @function getTypeUrl
     * @memberof ClientFortuneTigerPushBetDate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneTigerPushBetDate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneTigerPushBetDate";
    };

    return ClientFortuneTigerPushBetDate;
})();

export const ClientFortuneTigerCartoonReq = $root.ClientFortuneTigerCartoonReq = (() => {

    /**
     * Properties of a ClientFortuneTigerCartoonReq.
     * @exports IClientFortuneTigerCartoonReq
     * @interface IClientFortuneTigerCartoonReq
     * @property {number|null} [DeskNo] ClientFortuneTigerCartoonReq DeskNo
     * @property {number|null} [UserID] ClientFortuneTigerCartoonReq UserID
     */

    /**
     * Constructs a new ClientFortuneTigerCartoonReq.
     * @exports ClientFortuneTigerCartoonReq
     * @classdesc Represents a ClientFortuneTigerCartoonReq.
     * @implements IClientFortuneTigerCartoonReq
     * @constructor
     * @param {IClientFortuneTigerCartoonReq=} [properties] Properties to set
     */
    function ClientFortuneTigerCartoonReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneTigerCartoonReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientFortuneTigerCartoonReq
     * @instance
     */
    ClientFortuneTigerCartoonReq.prototype.DeskNo = 0;

    /**
     * ClientFortuneTigerCartoonReq UserID.
     * @member {number} UserID
     * @memberof ClientFortuneTigerCartoonReq
     * @instance
     */
    ClientFortuneTigerCartoonReq.prototype.UserID = 0;

    /**
     * Creates a new ClientFortuneTigerCartoonReq instance using the specified properties.
     * @function create
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {IClientFortuneTigerCartoonReq=} [properties] Properties to set
     * @returns {ClientFortuneTigerCartoonReq} ClientFortuneTigerCartoonReq instance
     */
    ClientFortuneTigerCartoonReq.create = function create(properties) {
        return new ClientFortuneTigerCartoonReq(properties);
    };

    /**
     * Encodes the specified ClientFortuneTigerCartoonReq message. Does not implicitly {@link ClientFortuneTigerCartoonReq.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {IClientFortuneTigerCartoonReq} message ClientFortuneTigerCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerCartoonReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneTigerCartoonReq message, length delimited. Does not implicitly {@link ClientFortuneTigerCartoonReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {IClientFortuneTigerCartoonReq} message ClientFortuneTigerCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerCartoonReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneTigerCartoonReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneTigerCartoonReq} ClientFortuneTigerCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerCartoonReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneTigerCartoonReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneTigerCartoonReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneTigerCartoonReq} ClientFortuneTigerCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerCartoonReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneTigerCartoonReq message.
     * @function verify
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneTigerCartoonReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientFortuneTigerCartoonReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneTigerCartoonReq} ClientFortuneTigerCartoonReq
     */
    ClientFortuneTigerCartoonReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneTigerCartoonReq)
            return object;
        let message = new $root.ClientFortuneTigerCartoonReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneTigerCartoonReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {ClientFortuneTigerCartoonReq} message ClientFortuneTigerCartoonReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneTigerCartoonReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientFortuneTigerCartoonReq to JSON.
     * @function toJSON
     * @memberof ClientFortuneTigerCartoonReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneTigerCartoonReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneTigerCartoonReq
     * @function getTypeUrl
     * @memberof ClientFortuneTigerCartoonReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneTigerCartoonReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneTigerCartoonReq";
    };

    return ClientFortuneTigerCartoonReq;
})();

export const ClientFortuneTigerPushGameEndData = $root.ClientFortuneTigerPushGameEndData = (() => {

    /**
     * Properties of a ClientFortuneTigerPushGameEndData.
     * @exports IClientFortuneTigerPushGameEndData
     * @interface IClientFortuneTigerPushGameEndData
     * @property {number|Long|null} [PlayerGold] ClientFortuneTigerPushGameEndData PlayerGold
     */

    /**
     * Constructs a new ClientFortuneTigerPushGameEndData.
     * @exports ClientFortuneTigerPushGameEndData
     * @classdesc Represents a ClientFortuneTigerPushGameEndData.
     * @implements IClientFortuneTigerPushGameEndData
     * @constructor
     * @param {IClientFortuneTigerPushGameEndData=} [properties] Properties to set
     */
    function ClientFortuneTigerPushGameEndData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneTigerPushGameEndData PlayerGold.
     * @member {number|Long} PlayerGold
     * @memberof ClientFortuneTigerPushGameEndData
     * @instance
     */
    ClientFortuneTigerPushGameEndData.prototype.PlayerGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientFortuneTigerPushGameEndData instance using the specified properties.
     * @function create
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {IClientFortuneTigerPushGameEndData=} [properties] Properties to set
     * @returns {ClientFortuneTigerPushGameEndData} ClientFortuneTigerPushGameEndData instance
     */
    ClientFortuneTigerPushGameEndData.create = function create(properties) {
        return new ClientFortuneTigerPushGameEndData(properties);
    };

    /**
     * Encodes the specified ClientFortuneTigerPushGameEndData message. Does not implicitly {@link ClientFortuneTigerPushGameEndData.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {IClientFortuneTigerPushGameEndData} message ClientFortuneTigerPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerPushGameEndData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PlayerGold != null && Object.hasOwnProperty.call(message, "PlayerGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PlayerGold);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneTigerPushGameEndData message, length delimited. Does not implicitly {@link ClientFortuneTigerPushGameEndData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {IClientFortuneTigerPushGameEndData} message ClientFortuneTigerPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerPushGameEndData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneTigerPushGameEndData message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneTigerPushGameEndData} ClientFortuneTigerPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerPushGameEndData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneTigerPushGameEndData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PlayerGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneTigerPushGameEndData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneTigerPushGameEndData} ClientFortuneTigerPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerPushGameEndData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneTigerPushGameEndData message.
     * @function verify
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneTigerPushGameEndData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (!$util.isInteger(message.PlayerGold) && !(message.PlayerGold && $util.isInteger(message.PlayerGold.low) && $util.isInteger(message.PlayerGold.high)))
                return "PlayerGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientFortuneTigerPushGameEndData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneTigerPushGameEndData} ClientFortuneTigerPushGameEndData
     */
    ClientFortuneTigerPushGameEndData.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneTigerPushGameEndData)
            return object;
        let message = new $root.ClientFortuneTigerPushGameEndData();
        if (object.PlayerGold != null)
            if ($util.Long)
                (message.PlayerGold = $util.Long.fromValue(object.PlayerGold)).unsigned = true;
            else if (typeof object.PlayerGold === "string")
                message.PlayerGold = parseInt(object.PlayerGold, 10);
            else if (typeof object.PlayerGold === "number")
                message.PlayerGold = object.PlayerGold;
            else if (typeof object.PlayerGold === "object")
                message.PlayerGold = new $util.LongBits(object.PlayerGold.low >>> 0, object.PlayerGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneTigerPushGameEndData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {ClientFortuneTigerPushGameEndData} message ClientFortuneTigerPushGameEndData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneTigerPushGameEndData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerGold = options.longs === String ? "0" : 0;
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (typeof message.PlayerGold === "number")
                object.PlayerGold = options.longs === String ? String(message.PlayerGold) : message.PlayerGold;
            else
                object.PlayerGold = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerGold) : options.longs === Number ? new $util.LongBits(message.PlayerGold.low >>> 0, message.PlayerGold.high >>> 0).toNumber(true) : message.PlayerGold;
        return object;
    };

    /**
     * Converts this ClientFortuneTigerPushGameEndData to JSON.
     * @function toJSON
     * @memberof ClientFortuneTigerPushGameEndData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneTigerPushGameEndData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneTigerPushGameEndData
     * @function getTypeUrl
     * @memberof ClientFortuneTigerPushGameEndData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneTigerPushGameEndData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneTigerPushGameEndData";
    };

    return ClientFortuneTigerPushGameEndData;
})();

export const ClientFortuneTigerJackPotReq = $root.ClientFortuneTigerJackPotReq = (() => {

    /**
     * Properties of a ClientFortuneTigerJackPotReq.
     * @exports IClientFortuneTigerJackPotReq
     * @interface IClientFortuneTigerJackPotReq
     * @property {number|null} [DeskNo] ClientFortuneTigerJackPotReq DeskNo
     * @property {number|null} [UserID] ClientFortuneTigerJackPotReq UserID
     */

    /**
     * Constructs a new ClientFortuneTigerJackPotReq.
     * @exports ClientFortuneTigerJackPotReq
     * @classdesc Represents a ClientFortuneTigerJackPotReq.
     * @implements IClientFortuneTigerJackPotReq
     * @constructor
     * @param {IClientFortuneTigerJackPotReq=} [properties] Properties to set
     */
    function ClientFortuneTigerJackPotReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFortuneTigerJackPotReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientFortuneTigerJackPotReq
     * @instance
     */
    ClientFortuneTigerJackPotReq.prototype.DeskNo = 0;

    /**
     * ClientFortuneTigerJackPotReq UserID.
     * @member {number} UserID
     * @memberof ClientFortuneTigerJackPotReq
     * @instance
     */
    ClientFortuneTigerJackPotReq.prototype.UserID = 0;

    /**
     * Creates a new ClientFortuneTigerJackPotReq instance using the specified properties.
     * @function create
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {IClientFortuneTigerJackPotReq=} [properties] Properties to set
     * @returns {ClientFortuneTigerJackPotReq} ClientFortuneTigerJackPotReq instance
     */
    ClientFortuneTigerJackPotReq.create = function create(properties) {
        return new ClientFortuneTigerJackPotReq(properties);
    };

    /**
     * Encodes the specified ClientFortuneTigerJackPotReq message. Does not implicitly {@link ClientFortuneTigerJackPotReq.verify|verify} messages.
     * @function encode
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {IClientFortuneTigerJackPotReq} message ClientFortuneTigerJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerJackPotReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientFortuneTigerJackPotReq message, length delimited. Does not implicitly {@link ClientFortuneTigerJackPotReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {IClientFortuneTigerJackPotReq} message ClientFortuneTigerJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFortuneTigerJackPotReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFortuneTigerJackPotReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFortuneTigerJackPotReq} ClientFortuneTigerJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerJackPotReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFortuneTigerJackPotReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFortuneTigerJackPotReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFortuneTigerJackPotReq} ClientFortuneTigerJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFortuneTigerJackPotReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFortuneTigerJackPotReq message.
     * @function verify
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFortuneTigerJackPotReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientFortuneTigerJackPotReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFortuneTigerJackPotReq} ClientFortuneTigerJackPotReq
     */
    ClientFortuneTigerJackPotReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFortuneTigerJackPotReq)
            return object;
        let message = new $root.ClientFortuneTigerJackPotReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientFortuneTigerJackPotReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {ClientFortuneTigerJackPotReq} message ClientFortuneTigerJackPotReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFortuneTigerJackPotReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientFortuneTigerJackPotReq to JSON.
     * @function toJSON
     * @memberof ClientFortuneTigerJackPotReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFortuneTigerJackPotReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFortuneTigerJackPotReq
     * @function getTypeUrl
     * @memberof ClientFortuneTigerJackPotReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFortuneTigerJackPotReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFortuneTigerJackPotReq";
    };

    return ClientFortuneTigerJackPotReq;
})();

export const OlympusCardOdd = $root.OlympusCardOdd = (() => {

    /**
     * Properties of an OlympusCardOdd.
     * @exports IOlympusCardOdd
     * @interface IOlympusCardOdd
     * @property {number|null} [CardType] OlympusCardOdd CardType
     * @property {string|null} [CardAmt] OlympusCardOdd CardAmt
     * @property {string|null} [OddValue] OlympusCardOdd OddValue
     */

    /**
     * Constructs a new OlympusCardOdd.
     * @exports OlympusCardOdd
     * @classdesc Represents an OlympusCardOdd.
     * @implements IOlympusCardOdd
     * @constructor
     * @param {IOlympusCardOdd=} [properties] Properties to set
     */
    function OlympusCardOdd(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OlympusCardOdd CardType.
     * @member {number} CardType
     * @memberof OlympusCardOdd
     * @instance
     */
    OlympusCardOdd.prototype.CardType = 0;

    /**
     * OlympusCardOdd CardAmt.
     * @member {string} CardAmt
     * @memberof OlympusCardOdd
     * @instance
     */
    OlympusCardOdd.prototype.CardAmt = "";

    /**
     * OlympusCardOdd OddValue.
     * @member {string} OddValue
     * @memberof OlympusCardOdd
     * @instance
     */
    OlympusCardOdd.prototype.OddValue = "";

    /**
     * Creates a new OlympusCardOdd instance using the specified properties.
     * @function create
     * @memberof OlympusCardOdd
     * @static
     * @param {IOlympusCardOdd=} [properties] Properties to set
     * @returns {OlympusCardOdd} OlympusCardOdd instance
     */
    OlympusCardOdd.create = function create(properties) {
        return new OlympusCardOdd(properties);
    };

    /**
     * Encodes the specified OlympusCardOdd message. Does not implicitly {@link OlympusCardOdd.verify|verify} messages.
     * @function encode
     * @memberof OlympusCardOdd
     * @static
     * @param {IOlympusCardOdd} message OlympusCardOdd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardOdd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CardType);
        if (message.CardAmt != null && Object.hasOwnProperty.call(message, "CardAmt"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.CardAmt);
        if (message.OddValue != null && Object.hasOwnProperty.call(message, "OddValue"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.OddValue);
        return writer;
    };

    /**
     * Encodes the specified OlympusCardOdd message, length delimited. Does not implicitly {@link OlympusCardOdd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OlympusCardOdd
     * @static
     * @param {IOlympusCardOdd} message OlympusCardOdd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardOdd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OlympusCardOdd message from the specified reader or buffer.
     * @function decode
     * @memberof OlympusCardOdd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OlympusCardOdd} OlympusCardOdd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardOdd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OlympusCardOdd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 2: {
                    message.CardAmt = reader.string();
                    break;
                }
            case 3: {
                    message.OddValue = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OlympusCardOdd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OlympusCardOdd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OlympusCardOdd} OlympusCardOdd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardOdd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OlympusCardOdd message.
     * @function verify
     * @memberof OlympusCardOdd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OlympusCardOdd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.CardAmt != null && message.hasOwnProperty("CardAmt"))
            if (!$util.isString(message.CardAmt))
                return "CardAmt: string expected";
        if (message.OddValue != null && message.hasOwnProperty("OddValue"))
            if (!$util.isString(message.OddValue))
                return "OddValue: string expected";
        return null;
    };

    /**
     * Creates an OlympusCardOdd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OlympusCardOdd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OlympusCardOdd} OlympusCardOdd
     */
    OlympusCardOdd.fromObject = function fromObject(object) {
        if (object instanceof $root.OlympusCardOdd)
            return object;
        let message = new $root.OlympusCardOdd();
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.CardAmt != null)
            message.CardAmt = String(object.CardAmt);
        if (object.OddValue != null)
            message.OddValue = String(object.OddValue);
        return message;
    };

    /**
     * Creates a plain object from an OlympusCardOdd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OlympusCardOdd
     * @static
     * @param {OlympusCardOdd} message OlympusCardOdd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OlympusCardOdd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CardType = 0;
            object.CardAmt = "";
            object.OddValue = "";
        }
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.CardAmt != null && message.hasOwnProperty("CardAmt"))
            object.CardAmt = message.CardAmt;
        if (message.OddValue != null && message.hasOwnProperty("OddValue"))
            object.OddValue = message.OddValue;
        return object;
    };

    /**
     * Converts this OlympusCardOdd to JSON.
     * @function toJSON
     * @memberof OlympusCardOdd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OlympusCardOdd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OlympusCardOdd
     * @function getTypeUrl
     * @memberof OlympusCardOdd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OlympusCardOdd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OlympusCardOdd";
    };

    return OlympusCardOdd;
})();

export const GatesOfOlympusProduct = $root.GatesOfOlympusProduct = (() => {

    /**
     * Properties of a GatesOfOlympusProduct.
     * @exports IGatesOfOlympusProduct
     * @interface IGatesOfOlympusProduct
     * @property {number|null} [PID] GatesOfOlympusProduct PID
     * @property {number|null} [Mode] GatesOfOlympusProduct Mode
     * @property {string|null} [BetList] GatesOfOlympusProduct BetList
     * @property {string|null} [AutoList] GatesOfOlympusProduct AutoList
     * @property {number|null} [FreePrice] GatesOfOlympusProduct FreePrice
     * @property {Array.<IOlympusCardOdd>|null} [BaseOdds] GatesOfOlympusProduct BaseOdds
     */

    /**
     * Constructs a new GatesOfOlympusProduct.
     * @exports GatesOfOlympusProduct
     * @classdesc Represents a GatesOfOlympusProduct.
     * @implements IGatesOfOlympusProduct
     * @constructor
     * @param {IGatesOfOlympusProduct=} [properties] Properties to set
     */
    function GatesOfOlympusProduct(properties) {
        this.BaseOdds = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GatesOfOlympusProduct PID.
     * @member {number} PID
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.PID = 0;

    /**
     * GatesOfOlympusProduct Mode.
     * @member {number} Mode
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.Mode = 0;

    /**
     * GatesOfOlympusProduct BetList.
     * @member {string} BetList
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.BetList = "";

    /**
     * GatesOfOlympusProduct AutoList.
     * @member {string} AutoList
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.AutoList = "";

    /**
     * GatesOfOlympusProduct FreePrice.
     * @member {number} FreePrice
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.FreePrice = 0;

    /**
     * GatesOfOlympusProduct BaseOdds.
     * @member {Array.<IOlympusCardOdd>} BaseOdds
     * @memberof GatesOfOlympusProduct
     * @instance
     */
    GatesOfOlympusProduct.prototype.BaseOdds = $util.emptyArray;

    /**
     * Creates a new GatesOfOlympusProduct instance using the specified properties.
     * @function create
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {IGatesOfOlympusProduct=} [properties] Properties to set
     * @returns {GatesOfOlympusProduct} GatesOfOlympusProduct instance
     */
    GatesOfOlympusProduct.create = function create(properties) {
        return new GatesOfOlympusProduct(properties);
    };

    /**
     * Encodes the specified GatesOfOlympusProduct message. Does not implicitly {@link GatesOfOlympusProduct.verify|verify} messages.
     * @function encode
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {IGatesOfOlympusProduct} message GatesOfOlympusProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GatesOfOlympusProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetList);
        if (message.AutoList != null && Object.hasOwnProperty.call(message, "AutoList"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.AutoList);
        if (message.FreePrice != null && Object.hasOwnProperty.call(message, "FreePrice"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.FreePrice);
        if (message.BaseOdds != null && message.BaseOdds.length)
            for (let i = 0; i < message.BaseOdds.length; ++i)
                $root.OlympusCardOdd.encode(message.BaseOdds[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GatesOfOlympusProduct message, length delimited. Does not implicitly {@link GatesOfOlympusProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {IGatesOfOlympusProduct} message GatesOfOlympusProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GatesOfOlympusProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GatesOfOlympusProduct message from the specified reader or buffer.
     * @function decode
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GatesOfOlympusProduct} GatesOfOlympusProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GatesOfOlympusProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GatesOfOlympusProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetList = reader.string();
                    break;
                }
            case 4: {
                    message.AutoList = reader.string();
                    break;
                }
            case 5: {
                    message.FreePrice = reader.uint32();
                    break;
                }
            case 6: {
                    if (!(message.BaseOdds && message.BaseOdds.length))
                        message.BaseOdds = [];
                    message.BaseOdds.push($root.OlympusCardOdd.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GatesOfOlympusProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GatesOfOlympusProduct} GatesOfOlympusProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GatesOfOlympusProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GatesOfOlympusProduct message.
     * @function verify
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GatesOfOlympusProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.AutoList != null && message.hasOwnProperty("AutoList"))
            if (!$util.isString(message.AutoList))
                return "AutoList: string expected";
        if (message.FreePrice != null && message.hasOwnProperty("FreePrice"))
            if (!$util.isInteger(message.FreePrice))
                return "FreePrice: integer expected";
        if (message.BaseOdds != null && message.hasOwnProperty("BaseOdds")) {
            if (!Array.isArray(message.BaseOdds))
                return "BaseOdds: array expected";
            for (let i = 0; i < message.BaseOdds.length; ++i) {
                let error = $root.OlympusCardOdd.verify(message.BaseOdds[i]);
                if (error)
                    return "BaseOdds." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GatesOfOlympusProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GatesOfOlympusProduct} GatesOfOlympusProduct
     */
    GatesOfOlympusProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.GatesOfOlympusProduct)
            return object;
        let message = new $root.GatesOfOlympusProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.AutoList != null)
            message.AutoList = String(object.AutoList);
        if (object.FreePrice != null)
            message.FreePrice = object.FreePrice >>> 0;
        if (object.BaseOdds) {
            if (!Array.isArray(object.BaseOdds))
                throw TypeError(".GatesOfOlympusProduct.BaseOdds: array expected");
            message.BaseOdds = [];
            for (let i = 0; i < object.BaseOdds.length; ++i) {
                if (typeof object.BaseOdds[i] !== "object")
                    throw TypeError(".GatesOfOlympusProduct.BaseOdds: object expected");
                message.BaseOdds[i] = $root.OlympusCardOdd.fromObject(object.BaseOdds[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GatesOfOlympusProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {GatesOfOlympusProduct} message GatesOfOlympusProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GatesOfOlympusProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BaseOdds = [];
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetList = "";
            object.AutoList = "";
            object.FreePrice = 0;
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.AutoList != null && message.hasOwnProperty("AutoList"))
            object.AutoList = message.AutoList;
        if (message.FreePrice != null && message.hasOwnProperty("FreePrice"))
            object.FreePrice = message.FreePrice;
        if (message.BaseOdds && message.BaseOdds.length) {
            object.BaseOdds = [];
            for (let j = 0; j < message.BaseOdds.length; ++j)
                object.BaseOdds[j] = $root.OlympusCardOdd.toObject(message.BaseOdds[j], options);
        }
        return object;
    };

    /**
     * Converts this GatesOfOlympusProduct to JSON.
     * @function toJSON
     * @memberof GatesOfOlympusProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GatesOfOlympusProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GatesOfOlympusProduct
     * @function getTypeUrl
     * @memberof GatesOfOlympusProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GatesOfOlympusProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GatesOfOlympusProduct";
    };

    return GatesOfOlympusProduct;
})();

export const OlympusSrvToDeskPushDeskInfo = $root.OlympusSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of an OlympusSrvToDeskPushDeskInfo.
     * @exports IOlympusSrvToDeskPushDeskInfo
     * @interface IOlympusSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] OlympusSrvToDeskPushDeskInfo UserID
     * @property {string|null} [Chip] OlympusSrvToDeskPushDeskInfo Chip
     * @property {IGatesOfOlympusProduct|null} [Product] OlympusSrvToDeskPushDeskInfo Product
     */

    /**
     * Constructs a new OlympusSrvToDeskPushDeskInfo.
     * @exports OlympusSrvToDeskPushDeskInfo
     * @classdesc Represents an OlympusSrvToDeskPushDeskInfo.
     * @implements IOlympusSrvToDeskPushDeskInfo
     * @constructor
     * @param {IOlympusSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function OlympusSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OlympusSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @instance
     */
    OlympusSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * OlympusSrvToDeskPushDeskInfo Chip.
     * @member {string} Chip
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @instance
     */
    OlympusSrvToDeskPushDeskInfo.prototype.Chip = "";

    /**
     * OlympusSrvToDeskPushDeskInfo Product.
     * @member {IGatesOfOlympusProduct|null|undefined} Product
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @instance
     */
    OlympusSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * Creates a new OlympusSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {IOlympusSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {OlympusSrvToDeskPushDeskInfo} OlympusSrvToDeskPushDeskInfo instance
     */
    OlympusSrvToDeskPushDeskInfo.create = function create(properties) {
        return new OlympusSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified OlympusSrvToDeskPushDeskInfo message. Does not implicitly {@link OlympusSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {IOlympusSrvToDeskPushDeskInfo} message OlympusSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Chip);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.GatesOfOlympusProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified OlympusSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link OlympusSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {IOlympusSrvToDeskPushDeskInfo} message OlympusSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OlympusSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OlympusSrvToDeskPushDeskInfo} OlympusSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OlympusSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Chip = reader.string();
                    break;
                }
            case 3: {
                    message.Product = $root.GatesOfOlympusProduct.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OlympusSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OlympusSrvToDeskPushDeskInfo} OlympusSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OlympusSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OlympusSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.GatesOfOlympusProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        return null;
    };

    /**
     * Creates an OlympusSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OlympusSrvToDeskPushDeskInfo} OlympusSrvToDeskPushDeskInfo
     */
    OlympusSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.OlympusSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.OlympusSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".OlympusSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.GatesOfOlympusProduct.fromObject(object.Product);
        }
        return message;
    };

    /**
     * Creates a plain object from an OlympusSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {OlympusSrvToDeskPushDeskInfo} message OlympusSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OlympusSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Chip = "";
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.GatesOfOlympusProduct.toObject(message.Product, options);
        return object;
    };

    /**
     * Converts this OlympusSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OlympusSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OlympusSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof OlympusSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OlympusSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OlympusSrvToDeskPushDeskInfo";
    };

    return OlympusSrvToDeskPushDeskInfo;
})();

export const Client2OlympusSrvReqBet = $root.Client2OlympusSrvReqBet = (() => {

    /**
     * Properties of a Client2OlympusSrvReqBet.
     * @exports IClient2OlympusSrvReqBet
     * @interface IClient2OlympusSrvReqBet
     * @property {number|null} [DeskNo] Client2OlympusSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2OlympusSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2OlympusSrvReqBet SeatNo
     * @property {number|null} [BetType] Client2OlympusSrvReqBet BetType
     * @property {number|null} [BetAmt] Client2OlympusSrvReqBet BetAmt
     */

    /**
     * Constructs a new Client2OlympusSrvReqBet.
     * @exports Client2OlympusSrvReqBet
     * @classdesc Represents a Client2OlympusSrvReqBet.
     * @implements IClient2OlympusSrvReqBet
     * @constructor
     * @param {IClient2OlympusSrvReqBet=} [properties] Properties to set
     */
    function Client2OlympusSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2OlympusSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2OlympusSrvReqBet
     * @instance
     */
    Client2OlympusSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2OlympusSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2OlympusSrvReqBet
     * @instance
     */
    Client2OlympusSrvReqBet.prototype.UserID = 0;

    /**
     * Client2OlympusSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2OlympusSrvReqBet
     * @instance
     */
    Client2OlympusSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2OlympusSrvReqBet BetType.
     * @member {number} BetType
     * @memberof Client2OlympusSrvReqBet
     * @instance
     */
    Client2OlympusSrvReqBet.prototype.BetType = 0;

    /**
     * Client2OlympusSrvReqBet BetAmt.
     * @member {number} BetAmt
     * @memberof Client2OlympusSrvReqBet
     * @instance
     */
    Client2OlympusSrvReqBet.prototype.BetAmt = 0;

    /**
     * Creates a new Client2OlympusSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {IClient2OlympusSrvReqBet=} [properties] Properties to set
     * @returns {Client2OlympusSrvReqBet} Client2OlympusSrvReqBet instance
     */
    Client2OlympusSrvReqBet.create = function create(properties) {
        return new Client2OlympusSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2OlympusSrvReqBet message. Does not implicitly {@link Client2OlympusSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {IClient2OlympusSrvReqBet} message Client2OlympusSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2OlympusSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.BetType);
        if (message.BetAmt != null && Object.hasOwnProperty.call(message, "BetAmt"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BetAmt);
        return writer;
    };

    /**
     * Encodes the specified Client2OlympusSrvReqBet message, length delimited. Does not implicitly {@link Client2OlympusSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {IClient2OlympusSrvReqBet} message Client2OlympusSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2OlympusSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2OlympusSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2OlympusSrvReqBet} Client2OlympusSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2OlympusSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2OlympusSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetType = reader.uint32();
                    break;
                }
            case 5: {
                    message.BetAmt = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2OlympusSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2OlympusSrvReqBet} Client2OlympusSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2OlympusSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2OlympusSrvReqBet message.
     * @function verify
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2OlympusSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        if (message.BetAmt != null && message.hasOwnProperty("BetAmt"))
            if (!$util.isInteger(message.BetAmt))
                return "BetAmt: integer expected";
        return null;
    };

    /**
     * Creates a Client2OlympusSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2OlympusSrvReqBet} Client2OlympusSrvReqBet
     */
    Client2OlympusSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2OlympusSrvReqBet)
            return object;
        let message = new $root.Client2OlympusSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        if (object.BetAmt != null)
            message.BetAmt = object.BetAmt >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2OlympusSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {Client2OlympusSrvReqBet} message Client2OlympusSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2OlympusSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.BetType = 0;
            object.BetAmt = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        if (message.BetAmt != null && message.hasOwnProperty("BetAmt"))
            object.BetAmt = message.BetAmt;
        return object;
    };

    /**
     * Converts this Client2OlympusSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2OlympusSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2OlympusSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2OlympusSrvReqBet
     * @function getTypeUrl
     * @memberof Client2OlympusSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2OlympusSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2OlympusSrvReqBet";
    };

    return Client2OlympusSrvReqBet;
})();

export const Client2OlympusSrvAckBet = $root.Client2OlympusSrvAckBet = (() => {

    /**
     * Properties of a Client2OlympusSrvAckBet.
     * @exports IClient2OlympusSrvAckBet
     * @interface IClient2OlympusSrvAckBet
     * @property {number|null} [Ret] Client2OlympusSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2OlympusSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2OlympusSrvAckBet UserID
     * @property {number|null} [SeatNo] Client2OlympusSrvAckBet SeatNo
     * @property {string|null} [Chip] Client2OlympusSrvAckBet Chip
     */

    /**
     * Constructs a new Client2OlympusSrvAckBet.
     * @exports Client2OlympusSrvAckBet
     * @classdesc Represents a Client2OlympusSrvAckBet.
     * @implements IClient2OlympusSrvAckBet
     * @constructor
     * @param {IClient2OlympusSrvAckBet=} [properties] Properties to set
     */
    function Client2OlympusSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2OlympusSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2OlympusSrvAckBet
     * @instance
     */
    Client2OlympusSrvAckBet.prototype.Ret = 0;

    /**
     * Client2OlympusSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2OlympusSrvAckBet
     * @instance
     */
    Client2OlympusSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2OlympusSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2OlympusSrvAckBet
     * @instance
     */
    Client2OlympusSrvAckBet.prototype.UserID = 0;

    /**
     * Client2OlympusSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2OlympusSrvAckBet
     * @instance
     */
    Client2OlympusSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2OlympusSrvAckBet Chip.
     * @member {string} Chip
     * @memberof Client2OlympusSrvAckBet
     * @instance
     */
    Client2OlympusSrvAckBet.prototype.Chip = "";

    /**
     * Creates a new Client2OlympusSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {IClient2OlympusSrvAckBet=} [properties] Properties to set
     * @returns {Client2OlympusSrvAckBet} Client2OlympusSrvAckBet instance
     */
    Client2OlympusSrvAckBet.create = function create(properties) {
        return new Client2OlympusSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2OlympusSrvAckBet message. Does not implicitly {@link Client2OlympusSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {IClient2OlympusSrvAckBet} message Client2OlympusSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2OlympusSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified Client2OlympusSrvAckBet message, length delimited. Does not implicitly {@link Client2OlympusSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {IClient2OlympusSrvAckBet} message Client2OlympusSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2OlympusSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2OlympusSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2OlympusSrvAckBet} Client2OlympusSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2OlympusSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2OlympusSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2OlympusSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2OlympusSrvAckBet} Client2OlympusSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2OlympusSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2OlympusSrvAckBet message.
     * @function verify
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2OlympusSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a Client2OlympusSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2OlympusSrvAckBet} Client2OlympusSrvAckBet
     */
    Client2OlympusSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2OlympusSrvAckBet)
            return object;
        let message = new $root.Client2OlympusSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a Client2OlympusSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {Client2OlympusSrvAckBet} message Client2OlympusSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2OlympusSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Chip = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this Client2OlympusSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2OlympusSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2OlympusSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2OlympusSrvAckBet
     * @function getTypeUrl
     * @memberof Client2OlympusSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2OlympusSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2OlympusSrvAckBet";
    };

    return Client2OlympusSrvAckBet;
})();

export const OlympusCardInfo = $root.OlympusCardInfo = (() => {

    /**
     * Properties of an OlympusCardInfo.
     * @exports IOlympusCardInfo
     * @interface IOlympusCardInfo
     * @property {number|null} [CardType] OlympusCardInfo CardType
     * @property {number|null} [CardValue] OlympusCardInfo CardValue
     * @property {number|null} [CardLocateX] OlympusCardInfo CardLocateX
     * @property {number|null} [CardLocateY] OlympusCardInfo CardLocateY
     */

    /**
     * Constructs a new OlympusCardInfo.
     * @exports OlympusCardInfo
     * @classdesc Represents an OlympusCardInfo.
     * @implements IOlympusCardInfo
     * @constructor
     * @param {IOlympusCardInfo=} [properties] Properties to set
     */
    function OlympusCardInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OlympusCardInfo CardType.
     * @member {number} CardType
     * @memberof OlympusCardInfo
     * @instance
     */
    OlympusCardInfo.prototype.CardType = 0;

    /**
     * OlympusCardInfo CardValue.
     * @member {number} CardValue
     * @memberof OlympusCardInfo
     * @instance
     */
    OlympusCardInfo.prototype.CardValue = 0;

    /**
     * OlympusCardInfo CardLocateX.
     * @member {number} CardLocateX
     * @memberof OlympusCardInfo
     * @instance
     */
    OlympusCardInfo.prototype.CardLocateX = 0;

    /**
     * OlympusCardInfo CardLocateY.
     * @member {number} CardLocateY
     * @memberof OlympusCardInfo
     * @instance
     */
    OlympusCardInfo.prototype.CardLocateY = 0;

    /**
     * Creates a new OlympusCardInfo instance using the specified properties.
     * @function create
     * @memberof OlympusCardInfo
     * @static
     * @param {IOlympusCardInfo=} [properties] Properties to set
     * @returns {OlympusCardInfo} OlympusCardInfo instance
     */
    OlympusCardInfo.create = function create(properties) {
        return new OlympusCardInfo(properties);
    };

    /**
     * Encodes the specified OlympusCardInfo message. Does not implicitly {@link OlympusCardInfo.verify|verify} messages.
     * @function encode
     * @memberof OlympusCardInfo
     * @static
     * @param {IOlympusCardInfo} message OlympusCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CardType);
        if (message.CardValue != null && Object.hasOwnProperty.call(message, "CardValue"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CardValue);
        if (message.CardLocateX != null && Object.hasOwnProperty.call(message, "CardLocateX"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CardLocateX);
        if (message.CardLocateY != null && Object.hasOwnProperty.call(message, "CardLocateY"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.CardLocateY);
        return writer;
    };

    /**
     * Encodes the specified OlympusCardInfo message, length delimited. Does not implicitly {@link OlympusCardInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OlympusCardInfo
     * @static
     * @param {IOlympusCardInfo} message OlympusCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OlympusCardInfo message from the specified reader or buffer.
     * @function decode
     * @memberof OlympusCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OlympusCardInfo} OlympusCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OlympusCardInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 2: {
                    message.CardValue = reader.uint32();
                    break;
                }
            case 3: {
                    message.CardLocateX = reader.uint32();
                    break;
                }
            case 4: {
                    message.CardLocateY = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OlympusCardInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OlympusCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OlympusCardInfo} OlympusCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OlympusCardInfo message.
     * @function verify
     * @memberof OlympusCardInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OlympusCardInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.CardValue != null && message.hasOwnProperty("CardValue"))
            if (!$util.isInteger(message.CardValue))
                return "CardValue: integer expected";
        if (message.CardLocateX != null && message.hasOwnProperty("CardLocateX"))
            if (!$util.isInteger(message.CardLocateX))
                return "CardLocateX: integer expected";
        if (message.CardLocateY != null && message.hasOwnProperty("CardLocateY"))
            if (!$util.isInteger(message.CardLocateY))
                return "CardLocateY: integer expected";
        return null;
    };

    /**
     * Creates an OlympusCardInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OlympusCardInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OlympusCardInfo} OlympusCardInfo
     */
    OlympusCardInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.OlympusCardInfo)
            return object;
        let message = new $root.OlympusCardInfo();
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.CardValue != null)
            message.CardValue = object.CardValue >>> 0;
        if (object.CardLocateX != null)
            message.CardLocateX = object.CardLocateX >>> 0;
        if (object.CardLocateY != null)
            message.CardLocateY = object.CardLocateY >>> 0;
        return message;
    };

    /**
     * Creates a plain object from an OlympusCardInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OlympusCardInfo
     * @static
     * @param {OlympusCardInfo} message OlympusCardInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OlympusCardInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CardType = 0;
            object.CardValue = 0;
            object.CardLocateX = 0;
            object.CardLocateY = 0;
        }
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.CardValue != null && message.hasOwnProperty("CardValue"))
            object.CardValue = message.CardValue;
        if (message.CardLocateX != null && message.hasOwnProperty("CardLocateX"))
            object.CardLocateX = message.CardLocateX;
        if (message.CardLocateY != null && message.hasOwnProperty("CardLocateY"))
            object.CardLocateY = message.CardLocateY;
        return object;
    };

    /**
     * Converts this OlympusCardInfo to JSON.
     * @function toJSON
     * @memberof OlympusCardInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OlympusCardInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OlympusCardInfo
     * @function getTypeUrl
     * @memberof OlympusCardInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OlympusCardInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OlympusCardInfo";
    };

    return OlympusCardInfo;
})();

export const OlympusCardAwardInfo = $root.OlympusCardAwardInfo = (() => {

    /**
     * Properties of an OlympusCardAwardInfo.
     * @exports IOlympusCardAwardInfo
     * @interface IOlympusCardAwardInfo
     * @property {number|null} [CardType] OlympusCardAwardInfo CardType
     * @property {number|null} [AwardAmt] OlympusCardAwardInfo AwardAmt
     * @property {string|null} [AwardValue] OlympusCardAwardInfo AwardValue
     */

    /**
     * Constructs a new OlympusCardAwardInfo.
     * @exports OlympusCardAwardInfo
     * @classdesc Represents an OlympusCardAwardInfo.
     * @implements IOlympusCardAwardInfo
     * @constructor
     * @param {IOlympusCardAwardInfo=} [properties] Properties to set
     */
    function OlympusCardAwardInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OlympusCardAwardInfo CardType.
     * @member {number} CardType
     * @memberof OlympusCardAwardInfo
     * @instance
     */
    OlympusCardAwardInfo.prototype.CardType = 0;

    /**
     * OlympusCardAwardInfo AwardAmt.
     * @member {number} AwardAmt
     * @memberof OlympusCardAwardInfo
     * @instance
     */
    OlympusCardAwardInfo.prototype.AwardAmt = 0;

    /**
     * OlympusCardAwardInfo AwardValue.
     * @member {string} AwardValue
     * @memberof OlympusCardAwardInfo
     * @instance
     */
    OlympusCardAwardInfo.prototype.AwardValue = "";

    /**
     * Creates a new OlympusCardAwardInfo instance using the specified properties.
     * @function create
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {IOlympusCardAwardInfo=} [properties] Properties to set
     * @returns {OlympusCardAwardInfo} OlympusCardAwardInfo instance
     */
    OlympusCardAwardInfo.create = function create(properties) {
        return new OlympusCardAwardInfo(properties);
    };

    /**
     * Encodes the specified OlympusCardAwardInfo message. Does not implicitly {@link OlympusCardAwardInfo.verify|verify} messages.
     * @function encode
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {IOlympusCardAwardInfo} message OlympusCardAwardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardAwardInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CardType);
        if (message.AwardAmt != null && Object.hasOwnProperty.call(message, "AwardAmt"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.AwardAmt);
        if (message.AwardValue != null && Object.hasOwnProperty.call(message, "AwardValue"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.AwardValue);
        return writer;
    };

    /**
     * Encodes the specified OlympusCardAwardInfo message, length delimited. Does not implicitly {@link OlympusCardAwardInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {IOlympusCardAwardInfo} message OlympusCardAwardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OlympusCardAwardInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OlympusCardAwardInfo message from the specified reader or buffer.
     * @function decode
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OlympusCardAwardInfo} OlympusCardAwardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardAwardInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OlympusCardAwardInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 2: {
                    message.AwardAmt = reader.uint32();
                    break;
                }
            case 3: {
                    message.AwardValue = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OlympusCardAwardInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OlympusCardAwardInfo} OlympusCardAwardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OlympusCardAwardInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OlympusCardAwardInfo message.
     * @function verify
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OlympusCardAwardInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.AwardAmt != null && message.hasOwnProperty("AwardAmt"))
            if (!$util.isInteger(message.AwardAmt))
                return "AwardAmt: integer expected";
        if (message.AwardValue != null && message.hasOwnProperty("AwardValue"))
            if (!$util.isString(message.AwardValue))
                return "AwardValue: string expected";
        return null;
    };

    /**
     * Creates an OlympusCardAwardInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OlympusCardAwardInfo} OlympusCardAwardInfo
     */
    OlympusCardAwardInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.OlympusCardAwardInfo)
            return object;
        let message = new $root.OlympusCardAwardInfo();
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.AwardAmt != null)
            message.AwardAmt = object.AwardAmt >>> 0;
        if (object.AwardValue != null)
            message.AwardValue = String(object.AwardValue);
        return message;
    };

    /**
     * Creates a plain object from an OlympusCardAwardInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {OlympusCardAwardInfo} message OlympusCardAwardInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OlympusCardAwardInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CardType = 0;
            object.AwardAmt = 0;
            object.AwardValue = "";
        }
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.AwardAmt != null && message.hasOwnProperty("AwardAmt"))
            object.AwardAmt = message.AwardAmt;
        if (message.AwardValue != null && message.hasOwnProperty("AwardValue"))
            object.AwardValue = message.AwardValue;
        return object;
    };

    /**
     * Converts this OlympusCardAwardInfo to JSON.
     * @function toJSON
     * @memberof OlympusCardAwardInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OlympusCardAwardInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OlympusCardAwardInfo
     * @function getTypeUrl
     * @memberof OlympusCardAwardInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OlympusCardAwardInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OlympusCardAwardInfo";
    };

    return OlympusCardAwardInfo;
})();

export const Desk2OlympusSrvPushGameResult = $root.Desk2OlympusSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2OlympusSrvPushGameResult.
     * @exports IDesk2OlympusSrvPushGameResult
     * @interface IDesk2OlympusSrvPushGameResult
     * @property {number|null} [UserID] Desk2OlympusSrvPushGameResult UserID
     * @property {number|null} [WinType] Desk2OlympusSrvPushGameResult WinType
     * @property {string|null} [Change] Desk2OlympusSrvPushGameResult Change
     * @property {number|null} [Multiple] Desk2OlympusSrvPushGameResult Multiple
     * @property {string|null} [SpinChange] Desk2OlympusSrvPushGameResult SpinChange
     * @property {number|null} [FreeGame] Desk2OlympusSrvPushGameResult FreeGame
     * @property {string|null} [TotalChange] Desk2OlympusSrvPushGameResult TotalChange
     * @property {number|null} [TotalMulti] Desk2OlympusSrvPushGameResult TotalMulti
     * @property {string|null} [TotalChip] Desk2OlympusSrvPushGameResult TotalChip
     * @property {Array.<IOlympusCardInfo>|null} [CardList] Desk2OlympusSrvPushGameResult CardList
     * @property {Array.<IOlympusCardAwardInfo>|null} [AwardList] Desk2OlympusSrvPushGameResult AwardList
     */

    /**
     * Constructs a new Desk2OlympusSrvPushGameResult.
     * @exports Desk2OlympusSrvPushGameResult
     * @classdesc Represents a Desk2OlympusSrvPushGameResult.
     * @implements IDesk2OlympusSrvPushGameResult
     * @constructor
     * @param {IDesk2OlympusSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2OlympusSrvPushGameResult(properties) {
        this.CardList = [];
        this.AwardList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2OlympusSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2OlympusSrvPushGameResult WinType.
     * @member {number} WinType
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.WinType = 0;

    /**
     * Desk2OlympusSrvPushGameResult Change.
     * @member {string} Change
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.Change = "";

    /**
     * Desk2OlympusSrvPushGameResult Multiple.
     * @member {number} Multiple
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.Multiple = 0;

    /**
     * Desk2OlympusSrvPushGameResult SpinChange.
     * @member {string} SpinChange
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.SpinChange = "";

    /**
     * Desk2OlympusSrvPushGameResult FreeGame.
     * @member {number} FreeGame
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.FreeGame = 0;

    /**
     * Desk2OlympusSrvPushGameResult TotalChange.
     * @member {string} TotalChange
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.TotalChange = "";

    /**
     * Desk2OlympusSrvPushGameResult TotalMulti.
     * @member {number} TotalMulti
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.TotalMulti = 0;

    /**
     * Desk2OlympusSrvPushGameResult TotalChip.
     * @member {string} TotalChip
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.TotalChip = "";

    /**
     * Desk2OlympusSrvPushGameResult CardList.
     * @member {Array.<IOlympusCardInfo>} CardList
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.CardList = $util.emptyArray;

    /**
     * Desk2OlympusSrvPushGameResult AwardList.
     * @member {Array.<IOlympusCardAwardInfo>} AwardList
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     */
    Desk2OlympusSrvPushGameResult.prototype.AwardList = $util.emptyArray;

    /**
     * Creates a new Desk2OlympusSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {IDesk2OlympusSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2OlympusSrvPushGameResult} Desk2OlympusSrvPushGameResult instance
     */
    Desk2OlympusSrvPushGameResult.create = function create(properties) {
        return new Desk2OlympusSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2OlympusSrvPushGameResult message. Does not implicitly {@link Desk2OlympusSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {IDesk2OlympusSrvPushGameResult} message Desk2OlympusSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2OlympusSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinType != null && Object.hasOwnProperty.call(message, "WinType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.WinType);
        if (message.Change != null && Object.hasOwnProperty.call(message, "Change"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Change);
        if (message.Multiple != null && Object.hasOwnProperty.call(message, "Multiple"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Multiple);
        if (message.SpinChange != null && Object.hasOwnProperty.call(message, "SpinChange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.SpinChange);
        if (message.FreeGame != null && Object.hasOwnProperty.call(message, "FreeGame"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.FreeGame);
        if (message.TotalChange != null && Object.hasOwnProperty.call(message, "TotalChange"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.TotalChange);
        if (message.TotalMulti != null && Object.hasOwnProperty.call(message, "TotalMulti"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.TotalMulti);
        if (message.TotalChip != null && Object.hasOwnProperty.call(message, "TotalChip"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.TotalChip);
        if (message.CardList != null && message.CardList.length)
            for (let i = 0; i < message.CardList.length; ++i)
                $root.OlympusCardInfo.encode(message.CardList[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.AwardList != null && message.AwardList.length)
            for (let i = 0; i < message.AwardList.length; ++i)
                $root.OlympusCardAwardInfo.encode(message.AwardList[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2OlympusSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2OlympusSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {IDesk2OlympusSrvPushGameResult} message Desk2OlympusSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2OlympusSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2OlympusSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2OlympusSrvPushGameResult} Desk2OlympusSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2OlympusSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2OlympusSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinType = reader.uint32();
                    break;
                }
            case 3: {
                    message.Change = reader.string();
                    break;
                }
            case 4: {
                    message.Multiple = reader.uint32();
                    break;
                }
            case 5: {
                    message.SpinChange = reader.string();
                    break;
                }
            case 6: {
                    message.FreeGame = reader.uint32();
                    break;
                }
            case 7: {
                    message.TotalChange = reader.string();
                    break;
                }
            case 8: {
                    message.TotalMulti = reader.uint32();
                    break;
                }
            case 9: {
                    message.TotalChip = reader.string();
                    break;
                }
            case 10: {
                    if (!(message.CardList && message.CardList.length))
                        message.CardList = [];
                    message.CardList.push($root.OlympusCardInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    if (!(message.AwardList && message.AwardList.length))
                        message.AwardList = [];
                    message.AwardList.push($root.OlympusCardAwardInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2OlympusSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2OlympusSrvPushGameResult} Desk2OlympusSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2OlympusSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2OlympusSrvPushGameResult message.
     * @function verify
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2OlympusSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinType != null && message.hasOwnProperty("WinType"))
            if (!$util.isInteger(message.WinType))
                return "WinType: integer expected";
        if (message.Change != null && message.hasOwnProperty("Change"))
            if (!$util.isString(message.Change))
                return "Change: string expected";
        if (message.Multiple != null && message.hasOwnProperty("Multiple"))
            if (!$util.isInteger(message.Multiple))
                return "Multiple: integer expected";
        if (message.SpinChange != null && message.hasOwnProperty("SpinChange"))
            if (!$util.isString(message.SpinChange))
                return "SpinChange: string expected";
        if (message.FreeGame != null && message.hasOwnProperty("FreeGame"))
            if (!$util.isInteger(message.FreeGame))
                return "FreeGame: integer expected";
        if (message.TotalChange != null && message.hasOwnProperty("TotalChange"))
            if (!$util.isString(message.TotalChange))
                return "TotalChange: string expected";
        if (message.TotalMulti != null && message.hasOwnProperty("TotalMulti"))
            if (!$util.isInteger(message.TotalMulti))
                return "TotalMulti: integer expected";
        if (message.TotalChip != null && message.hasOwnProperty("TotalChip"))
            if (!$util.isString(message.TotalChip))
                return "TotalChip: string expected";
        if (message.CardList != null && message.hasOwnProperty("CardList")) {
            if (!Array.isArray(message.CardList))
                return "CardList: array expected";
            for (let i = 0; i < message.CardList.length; ++i) {
                let error = $root.OlympusCardInfo.verify(message.CardList[i]);
                if (error)
                    return "CardList." + error;
            }
        }
        if (message.AwardList != null && message.hasOwnProperty("AwardList")) {
            if (!Array.isArray(message.AwardList))
                return "AwardList: array expected";
            for (let i = 0; i < message.AwardList.length; ++i) {
                let error = $root.OlympusCardAwardInfo.verify(message.AwardList[i]);
                if (error)
                    return "AwardList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2OlympusSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2OlympusSrvPushGameResult} Desk2OlympusSrvPushGameResult
     */
    Desk2OlympusSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2OlympusSrvPushGameResult)
            return object;
        let message = new $root.Desk2OlympusSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinType != null)
            message.WinType = object.WinType >>> 0;
        if (object.Change != null)
            message.Change = String(object.Change);
        if (object.Multiple != null)
            message.Multiple = object.Multiple >>> 0;
        if (object.SpinChange != null)
            message.SpinChange = String(object.SpinChange);
        if (object.FreeGame != null)
            message.FreeGame = object.FreeGame >>> 0;
        if (object.TotalChange != null)
            message.TotalChange = String(object.TotalChange);
        if (object.TotalMulti != null)
            message.TotalMulti = object.TotalMulti >>> 0;
        if (object.TotalChip != null)
            message.TotalChip = String(object.TotalChip);
        if (object.CardList) {
            if (!Array.isArray(object.CardList))
                throw TypeError(".Desk2OlympusSrvPushGameResult.CardList: array expected");
            message.CardList = [];
            for (let i = 0; i < object.CardList.length; ++i) {
                if (typeof object.CardList[i] !== "object")
                    throw TypeError(".Desk2OlympusSrvPushGameResult.CardList: object expected");
                message.CardList[i] = $root.OlympusCardInfo.fromObject(object.CardList[i]);
            }
        }
        if (object.AwardList) {
            if (!Array.isArray(object.AwardList))
                throw TypeError(".Desk2OlympusSrvPushGameResult.AwardList: array expected");
            message.AwardList = [];
            for (let i = 0; i < object.AwardList.length; ++i) {
                if (typeof object.AwardList[i] !== "object")
                    throw TypeError(".Desk2OlympusSrvPushGameResult.AwardList: object expected");
                message.AwardList[i] = $root.OlympusCardAwardInfo.fromObject(object.AwardList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2OlympusSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {Desk2OlympusSrvPushGameResult} message Desk2OlympusSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2OlympusSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.CardList = [];
            object.AwardList = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.WinType = 0;
            object.Change = "";
            object.Multiple = 0;
            object.SpinChange = "";
            object.FreeGame = 0;
            object.TotalChange = "";
            object.TotalMulti = 0;
            object.TotalChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinType != null && message.hasOwnProperty("WinType"))
            object.WinType = message.WinType;
        if (message.Change != null && message.hasOwnProperty("Change"))
            object.Change = message.Change;
        if (message.Multiple != null && message.hasOwnProperty("Multiple"))
            object.Multiple = message.Multiple;
        if (message.SpinChange != null && message.hasOwnProperty("SpinChange"))
            object.SpinChange = message.SpinChange;
        if (message.FreeGame != null && message.hasOwnProperty("FreeGame"))
            object.FreeGame = message.FreeGame;
        if (message.TotalChange != null && message.hasOwnProperty("TotalChange"))
            object.TotalChange = message.TotalChange;
        if (message.TotalMulti != null && message.hasOwnProperty("TotalMulti"))
            object.TotalMulti = message.TotalMulti;
        if (message.TotalChip != null && message.hasOwnProperty("TotalChip"))
            object.TotalChip = message.TotalChip;
        if (message.CardList && message.CardList.length) {
            object.CardList = [];
            for (let j = 0; j < message.CardList.length; ++j)
                object.CardList[j] = $root.OlympusCardInfo.toObject(message.CardList[j], options);
        }
        if (message.AwardList && message.AwardList.length) {
            object.AwardList = [];
            for (let j = 0; j < message.AwardList.length; ++j)
                object.AwardList[j] = $root.OlympusCardAwardInfo.toObject(message.AwardList[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2OlympusSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2OlympusSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2OlympusSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2OlympusSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2OlympusSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2OlympusSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2OlympusSrvPushGameResult";
    };

    return Desk2OlympusSrvPushGameResult;
})();

export const MineSweeperProduct = $root.MineSweeperProduct = (() => {

    /**
     * Properties of a MineSweeperProduct.
     * @exports IMineSweeperProduct
     * @interface IMineSweeperProduct
     * @property {number|null} [PID] MineSweeperProduct PID
     * @property {number|null} [Mode] MineSweeperProduct Mode
     * @property {number|null} [MinMulti] MineSweeperProduct MinMulti
     * @property {number|null} [MaxMulti] MineSweeperProduct MaxMulti
     * @property {number|null} [Sweep1] MineSweeperProduct Sweep1
     * @property {number|null} [Sweep2] MineSweeperProduct Sweep2
     * @property {number|null} [Sweep3] MineSweeperProduct Sweep3
     * @property {number|null} [Sweep4] MineSweeperProduct Sweep4
     * @property {Array.<number>|null} [Sweep] MineSweeperProduct Sweep
     */

    /**
     * Constructs a new MineSweeperProduct.
     * @exports MineSweeperProduct
     * @classdesc Represents a MineSweeperProduct.
     * @implements IMineSweeperProduct
     * @constructor
     * @param {IMineSweeperProduct=} [properties] Properties to set
     */
    function MineSweeperProduct(properties) {
        this.Sweep = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MineSweeperProduct PID.
     * @member {number} PID
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.PID = 0;

    /**
     * MineSweeperProduct Mode.
     * @member {number} Mode
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Mode = 0;

    /**
     * MineSweeperProduct MinMulti.
     * @member {number} MinMulti
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.MinMulti = 0;

    /**
     * MineSweeperProduct MaxMulti.
     * @member {number} MaxMulti
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.MaxMulti = 0;

    /**
     * MineSweeperProduct Sweep1.
     * @member {number} Sweep1
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Sweep1 = 0;

    /**
     * MineSweeperProduct Sweep2.
     * @member {number} Sweep2
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Sweep2 = 0;

    /**
     * MineSweeperProduct Sweep3.
     * @member {number} Sweep3
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Sweep3 = 0;

    /**
     * MineSweeperProduct Sweep4.
     * @member {number} Sweep4
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Sweep4 = 0;

    /**
     * MineSweeperProduct Sweep.
     * @member {Array.<number>} Sweep
     * @memberof MineSweeperProduct
     * @instance
     */
    MineSweeperProduct.prototype.Sweep = $util.emptyArray;

    /**
     * Creates a new MineSweeperProduct instance using the specified properties.
     * @function create
     * @memberof MineSweeperProduct
     * @static
     * @param {IMineSweeperProduct=} [properties] Properties to set
     * @returns {MineSweeperProduct} MineSweeperProduct instance
     */
    MineSweeperProduct.create = function create(properties) {
        return new MineSweeperProduct(properties);
    };

    /**
     * Encodes the specified MineSweeperProduct message. Does not implicitly {@link MineSweeperProduct.verify|verify} messages.
     * @function encode
     * @memberof MineSweeperProduct
     * @static
     * @param {IMineSweeperProduct} message MineSweeperProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MineSweeperProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.MinMulti != null && Object.hasOwnProperty.call(message, "MinMulti"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MinMulti);
        if (message.MaxMulti != null && Object.hasOwnProperty.call(message, "MaxMulti"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MaxMulti);
        if (message.Sweep1 != null && Object.hasOwnProperty.call(message, "Sweep1"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Sweep1);
        if (message.Sweep2 != null && Object.hasOwnProperty.call(message, "Sweep2"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Sweep2);
        if (message.Sweep3 != null && Object.hasOwnProperty.call(message, "Sweep3"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Sweep3);
        if (message.Sweep4 != null && Object.hasOwnProperty.call(message, "Sweep4"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Sweep4);
        if (message.Sweep != null && message.Sweep.length) {
            writer.uint32(/* id 9, wireType 2 =*/74).fork();
            for (let i = 0; i < message.Sweep.length; ++i)
                writer.uint32(message.Sweep[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified MineSweeperProduct message, length delimited. Does not implicitly {@link MineSweeperProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MineSweeperProduct
     * @static
     * @param {IMineSweeperProduct} message MineSweeperProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MineSweeperProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MineSweeperProduct message from the specified reader or buffer.
     * @function decode
     * @memberof MineSweeperProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MineSweeperProduct} MineSweeperProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MineSweeperProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MineSweeperProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.MinMulti = reader.uint32();
                    break;
                }
            case 4: {
                    message.MaxMulti = reader.uint32();
                    break;
                }
            case 5: {
                    message.Sweep1 = reader.uint32();
                    break;
                }
            case 6: {
                    message.Sweep2 = reader.uint32();
                    break;
                }
            case 7: {
                    message.Sweep3 = reader.uint32();
                    break;
                }
            case 8: {
                    message.Sweep4 = reader.uint32();
                    break;
                }
            case 9: {
                    if (!(message.Sweep && message.Sweep.length))
                        message.Sweep = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Sweep.push(reader.uint32());
                    } else
                        message.Sweep.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MineSweeperProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MineSweeperProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MineSweeperProduct} MineSweeperProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MineSweeperProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MineSweeperProduct message.
     * @function verify
     * @memberof MineSweeperProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MineSweeperProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.MinMulti != null && message.hasOwnProperty("MinMulti"))
            if (!$util.isInteger(message.MinMulti))
                return "MinMulti: integer expected";
        if (message.MaxMulti != null && message.hasOwnProperty("MaxMulti"))
            if (!$util.isInteger(message.MaxMulti))
                return "MaxMulti: integer expected";
        if (message.Sweep1 != null && message.hasOwnProperty("Sweep1"))
            if (!$util.isInteger(message.Sweep1))
                return "Sweep1: integer expected";
        if (message.Sweep2 != null && message.hasOwnProperty("Sweep2"))
            if (!$util.isInteger(message.Sweep2))
                return "Sweep2: integer expected";
        if (message.Sweep3 != null && message.hasOwnProperty("Sweep3"))
            if (!$util.isInteger(message.Sweep3))
                return "Sweep3: integer expected";
        if (message.Sweep4 != null && message.hasOwnProperty("Sweep4"))
            if (!$util.isInteger(message.Sweep4))
                return "Sweep4: integer expected";
        if (message.Sweep != null && message.hasOwnProperty("Sweep")) {
            if (!Array.isArray(message.Sweep))
                return "Sweep: array expected";
            for (let i = 0; i < message.Sweep.length; ++i)
                if (!$util.isInteger(message.Sweep[i]))
                    return "Sweep: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a MineSweeperProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MineSweeperProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MineSweeperProduct} MineSweeperProduct
     */
    MineSweeperProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.MineSweeperProduct)
            return object;
        let message = new $root.MineSweeperProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.MinMulti != null)
            message.MinMulti = object.MinMulti >>> 0;
        if (object.MaxMulti != null)
            message.MaxMulti = object.MaxMulti >>> 0;
        if (object.Sweep1 != null)
            message.Sweep1 = object.Sweep1 >>> 0;
        if (object.Sweep2 != null)
            message.Sweep2 = object.Sweep2 >>> 0;
        if (object.Sweep3 != null)
            message.Sweep3 = object.Sweep3 >>> 0;
        if (object.Sweep4 != null)
            message.Sweep4 = object.Sweep4 >>> 0;
        if (object.Sweep) {
            if (!Array.isArray(object.Sweep))
                throw TypeError(".MineSweeperProduct.Sweep: array expected");
            message.Sweep = [];
            for (let i = 0; i < object.Sweep.length; ++i)
                message.Sweep[i] = object.Sweep[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a MineSweeperProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MineSweeperProduct
     * @static
     * @param {MineSweeperProduct} message MineSweeperProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MineSweeperProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Sweep = [];
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.MinMulti = 0;
            object.MaxMulti = 0;
            object.Sweep1 = 0;
            object.Sweep2 = 0;
            object.Sweep3 = 0;
            object.Sweep4 = 0;
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.MinMulti != null && message.hasOwnProperty("MinMulti"))
            object.MinMulti = message.MinMulti;
        if (message.MaxMulti != null && message.hasOwnProperty("MaxMulti"))
            object.MaxMulti = message.MaxMulti;
        if (message.Sweep1 != null && message.hasOwnProperty("Sweep1"))
            object.Sweep1 = message.Sweep1;
        if (message.Sweep2 != null && message.hasOwnProperty("Sweep2"))
            object.Sweep2 = message.Sweep2;
        if (message.Sweep3 != null && message.hasOwnProperty("Sweep3"))
            object.Sweep3 = message.Sweep3;
        if (message.Sweep4 != null && message.hasOwnProperty("Sweep4"))
            object.Sweep4 = message.Sweep4;
        if (message.Sweep && message.Sweep.length) {
            object.Sweep = [];
            for (let j = 0; j < message.Sweep.length; ++j)
                object.Sweep[j] = message.Sweep[j];
        }
        return object;
    };

    /**
     * Converts this MineSweeperProduct to JSON.
     * @function toJSON
     * @memberof MineSweeperProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MineSweeperProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MineSweeperProduct
     * @function getTypeUrl
     * @memberof MineSweeperProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MineSweeperProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MineSweeperProduct";
    };

    return MineSweeperProduct;
})();

export const MineSweeperSrvToDeskPushDeskInfo = $root.MineSweeperSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a MineSweeperSrvToDeskPushDeskInfo.
     * @exports IMineSweeperSrvToDeskPushDeskInfo
     * @interface IMineSweeperSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] MineSweeperSrvToDeskPushDeskInfo UserID
     * @property {string|null} [Chip] MineSweeperSrvToDeskPushDeskInfo Chip
     * @property {IMineSweeperProduct|null} [Product] MineSweeperSrvToDeskPushDeskInfo Product
     */

    /**
     * Constructs a new MineSweeperSrvToDeskPushDeskInfo.
     * @exports MineSweeperSrvToDeskPushDeskInfo
     * @classdesc Represents a MineSweeperSrvToDeskPushDeskInfo.
     * @implements IMineSweeperSrvToDeskPushDeskInfo
     * @constructor
     * @param {IMineSweeperSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function MineSweeperSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MineSweeperSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @instance
     */
    MineSweeperSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * MineSweeperSrvToDeskPushDeskInfo Chip.
     * @member {string} Chip
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @instance
     */
    MineSweeperSrvToDeskPushDeskInfo.prototype.Chip = "";

    /**
     * MineSweeperSrvToDeskPushDeskInfo Product.
     * @member {IMineSweeperProduct|null|undefined} Product
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @instance
     */
    MineSweeperSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * Creates a new MineSweeperSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {IMineSweeperSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {MineSweeperSrvToDeskPushDeskInfo} MineSweeperSrvToDeskPushDeskInfo instance
     */
    MineSweeperSrvToDeskPushDeskInfo.create = function create(properties) {
        return new MineSweeperSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified MineSweeperSrvToDeskPushDeskInfo message. Does not implicitly {@link MineSweeperSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {IMineSweeperSrvToDeskPushDeskInfo} message MineSweeperSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MineSweeperSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Chip);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.MineSweeperProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MineSweeperSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link MineSweeperSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {IMineSweeperSrvToDeskPushDeskInfo} message MineSweeperSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MineSweeperSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MineSweeperSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MineSweeperSrvToDeskPushDeskInfo} MineSweeperSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MineSweeperSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MineSweeperSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Chip = reader.string();
                    break;
                }
            case 3: {
                    message.Product = $root.MineSweeperProduct.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MineSweeperSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MineSweeperSrvToDeskPushDeskInfo} MineSweeperSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MineSweeperSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MineSweeperSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MineSweeperSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.MineSweeperProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        return null;
    };

    /**
     * Creates a MineSweeperSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MineSweeperSrvToDeskPushDeskInfo} MineSweeperSrvToDeskPushDeskInfo
     */
    MineSweeperSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.MineSweeperSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.MineSweeperSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".MineSweeperSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.MineSweeperProduct.fromObject(object.Product);
        }
        return message;
    };

    /**
     * Creates a plain object from a MineSweeperSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {MineSweeperSrvToDeskPushDeskInfo} message MineSweeperSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MineSweeperSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Chip = "";
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.MineSweeperProduct.toObject(message.Product, options);
        return object;
    };

    /**
     * Converts this MineSweeperSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MineSweeperSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MineSweeperSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof MineSweeperSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MineSweeperSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MineSweeperSrvToDeskPushDeskInfo";
    };

    return MineSweeperSrvToDeskPushDeskInfo;
})();

export const Client2MineSweeperSrvReqBet = $root.Client2MineSweeperSrvReqBet = (() => {

    /**
     * Properties of a Client2MineSweeperSrvReqBet.
     * @exports IClient2MineSweeperSrvReqBet
     * @interface IClient2MineSweeperSrvReqBet
     * @property {number|null} [DeskNo] Client2MineSweeperSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2MineSweeperSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2MineSweeperSrvReqBet SeatNo
     * @property {number|null} [Mines] Client2MineSweeperSrvReqBet Mines
     * @property {number|null} [Multi] Client2MineSweeperSrvReqBet Multi
     */

    /**
     * Constructs a new Client2MineSweeperSrvReqBet.
     * @exports Client2MineSweeperSrvReqBet
     * @classdesc Represents a Client2MineSweeperSrvReqBet.
     * @implements IClient2MineSweeperSrvReqBet
     * @constructor
     * @param {IClient2MineSweeperSrvReqBet=} [properties] Properties to set
     */
    function Client2MineSweeperSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     */
    Client2MineSweeperSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2MineSweeperSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     */
    Client2MineSweeperSrvReqBet.prototype.UserID = 0;

    /**
     * Client2MineSweeperSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     */
    Client2MineSweeperSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2MineSweeperSrvReqBet Mines.
     * @member {number} Mines
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     */
    Client2MineSweeperSrvReqBet.prototype.Mines = 0;

    /**
     * Client2MineSweeperSrvReqBet Multi.
     * @member {number} Multi
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     */
    Client2MineSweeperSrvReqBet.prototype.Multi = 0;

    /**
     * Creates a new Client2MineSweeperSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {IClient2MineSweeperSrvReqBet=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvReqBet} Client2MineSweeperSrvReqBet instance
     */
    Client2MineSweeperSrvReqBet.create = function create(properties) {
        return new Client2MineSweeperSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqBet message. Does not implicitly {@link Client2MineSweeperSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {IClient2MineSweeperSrvReqBet} message Client2MineSweeperSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Mines != null && Object.hasOwnProperty.call(message, "Mines"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Mines);
        if (message.Multi != null && Object.hasOwnProperty.call(message, "Multi"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Multi);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqBet message, length delimited. Does not implicitly {@link Client2MineSweeperSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {IClient2MineSweeperSrvReqBet} message Client2MineSweeperSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvReqBet} Client2MineSweeperSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Mines = reader.uint32();
                    break;
                }
            case 5: {
                    message.Multi = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvReqBet} Client2MineSweeperSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvReqBet message.
     * @function verify
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Mines != null && message.hasOwnProperty("Mines"))
            if (!$util.isInteger(message.Mines))
                return "Mines: integer expected";
        if (message.Multi != null && message.hasOwnProperty("Multi"))
            if (!$util.isInteger(message.Multi))
                return "Multi: integer expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvReqBet} Client2MineSweeperSrvReqBet
     */
    Client2MineSweeperSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvReqBet)
            return object;
        let message = new $root.Client2MineSweeperSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Mines != null)
            message.Mines = object.Mines >>> 0;
        if (object.Multi != null)
            message.Multi = object.Multi >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {Client2MineSweeperSrvReqBet} message Client2MineSweeperSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Mines = 0;
            object.Multi = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Mines != null && message.hasOwnProperty("Mines"))
            object.Mines = message.Mines;
        if (message.Multi != null && message.hasOwnProperty("Multi"))
            object.Multi = message.Multi;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvReqBet
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvReqBet";
    };

    return Client2MineSweeperSrvReqBet;
})();

export const Client2MineSweeperSrvAckBet = $root.Client2MineSweeperSrvAckBet = (() => {

    /**
     * Properties of a Client2MineSweeperSrvAckBet.
     * @exports IClient2MineSweeperSrvAckBet
     * @interface IClient2MineSweeperSrvAckBet
     * @property {number|null} [Ret] Client2MineSweeperSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2MineSweeperSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2MineSweeperSrvAckBet UserID
     * @property {number|null} [SeatNo] Client2MineSweeperSrvAckBet SeatNo
     * @property {string|null} [Chip] Client2MineSweeperSrvAckBet Chip
     */

    /**
     * Constructs a new Client2MineSweeperSrvAckBet.
     * @exports Client2MineSweeperSrvAckBet
     * @classdesc Represents a Client2MineSweeperSrvAckBet.
     * @implements IClient2MineSweeperSrvAckBet
     * @constructor
     * @param {IClient2MineSweeperSrvAckBet=} [properties] Properties to set
     */
    function Client2MineSweeperSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     */
    Client2MineSweeperSrvAckBet.prototype.Ret = 0;

    /**
     * Client2MineSweeperSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     */
    Client2MineSweeperSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2MineSweeperSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     */
    Client2MineSweeperSrvAckBet.prototype.UserID = 0;

    /**
     * Client2MineSweeperSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     */
    Client2MineSweeperSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2MineSweeperSrvAckBet Chip.
     * @member {string} Chip
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     */
    Client2MineSweeperSrvAckBet.prototype.Chip = "";

    /**
     * Creates a new Client2MineSweeperSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {IClient2MineSweeperSrvAckBet=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvAckBet} Client2MineSweeperSrvAckBet instance
     */
    Client2MineSweeperSrvAckBet.create = function create(properties) {
        return new Client2MineSweeperSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckBet message. Does not implicitly {@link Client2MineSweeperSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {IClient2MineSweeperSrvAckBet} message Client2MineSweeperSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckBet message, length delimited. Does not implicitly {@link Client2MineSweeperSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {IClient2MineSweeperSrvAckBet} message Client2MineSweeperSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvAckBet} Client2MineSweeperSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvAckBet} Client2MineSweeperSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvAckBet message.
     * @function verify
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvAckBet} Client2MineSweeperSrvAckBet
     */
    Client2MineSweeperSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvAckBet)
            return object;
        let message = new $root.Client2MineSweeperSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {Client2MineSweeperSrvAckBet} message Client2MineSweeperSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Chip = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvAckBet
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvAckBet";
    };

    return Client2MineSweeperSrvAckBet;
})();

export const Client2MineSweeperSrvReqFlop = $root.Client2MineSweeperSrvReqFlop = (() => {

    /**
     * Properties of a Client2MineSweeperSrvReqFlop.
     * @exports IClient2MineSweeperSrvReqFlop
     * @interface IClient2MineSweeperSrvReqFlop
     * @property {number|null} [DeskNo] Client2MineSweeperSrvReqFlop DeskNo
     * @property {number|null} [UserID] Client2MineSweeperSrvReqFlop UserID
     * @property {number|null} [SeatNo] Client2MineSweeperSrvReqFlop SeatNo
     * @property {number|null} [GridId] Client2MineSweeperSrvReqFlop GridId
     */

    /**
     * Constructs a new Client2MineSweeperSrvReqFlop.
     * @exports Client2MineSweeperSrvReqFlop
     * @classdesc Represents a Client2MineSweeperSrvReqFlop.
     * @implements IClient2MineSweeperSrvReqFlop
     * @constructor
     * @param {IClient2MineSweeperSrvReqFlop=} [properties] Properties to set
     */
    function Client2MineSweeperSrvReqFlop(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvReqFlop DeskNo.
     * @member {number} DeskNo
     * @memberof Client2MineSweeperSrvReqFlop
     * @instance
     */
    Client2MineSweeperSrvReqFlop.prototype.DeskNo = 0;

    /**
     * Client2MineSweeperSrvReqFlop UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvReqFlop
     * @instance
     */
    Client2MineSweeperSrvReqFlop.prototype.UserID = 0;

    /**
     * Client2MineSweeperSrvReqFlop SeatNo.
     * @member {number} SeatNo
     * @memberof Client2MineSweeperSrvReqFlop
     * @instance
     */
    Client2MineSweeperSrvReqFlop.prototype.SeatNo = 0;

    /**
     * Client2MineSweeperSrvReqFlop GridId.
     * @member {number} GridId
     * @memberof Client2MineSweeperSrvReqFlop
     * @instance
     */
    Client2MineSweeperSrvReqFlop.prototype.GridId = 0;

    /**
     * Creates a new Client2MineSweeperSrvReqFlop instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {IClient2MineSweeperSrvReqFlop=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvReqFlop} Client2MineSweeperSrvReqFlop instance
     */
    Client2MineSweeperSrvReqFlop.create = function create(properties) {
        return new Client2MineSweeperSrvReqFlop(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqFlop message. Does not implicitly {@link Client2MineSweeperSrvReqFlop.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {IClient2MineSweeperSrvReqFlop} message Client2MineSweeperSrvReqFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqFlop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.GridId != null && Object.hasOwnProperty.call(message, "GridId"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.GridId);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqFlop message, length delimited. Does not implicitly {@link Client2MineSweeperSrvReqFlop.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {IClient2MineSweeperSrvReqFlop} message Client2MineSweeperSrvReqFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqFlop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvReqFlop message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvReqFlop} Client2MineSweeperSrvReqFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqFlop.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvReqFlop();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.GridId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvReqFlop message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvReqFlop} Client2MineSweeperSrvReqFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqFlop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvReqFlop message.
     * @function verify
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvReqFlop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.GridId != null && message.hasOwnProperty("GridId"))
            if (!$util.isInteger(message.GridId))
                return "GridId: integer expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvReqFlop message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvReqFlop} Client2MineSweeperSrvReqFlop
     */
    Client2MineSweeperSrvReqFlop.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvReqFlop)
            return object;
        let message = new $root.Client2MineSweeperSrvReqFlop();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.GridId != null)
            message.GridId = object.GridId | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvReqFlop message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {Client2MineSweeperSrvReqFlop} message Client2MineSweeperSrvReqFlop
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvReqFlop.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.GridId = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.GridId != null && message.hasOwnProperty("GridId"))
            object.GridId = message.GridId;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvReqFlop to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvReqFlop
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvReqFlop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvReqFlop
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvReqFlop
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvReqFlop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvReqFlop";
    };

    return Client2MineSweeperSrvReqFlop;
})();

export const Client2MineSweeperSrvAckFlop = $root.Client2MineSweeperSrvAckFlop = (() => {

    /**
     * Properties of a Client2MineSweeperSrvAckFlop.
     * @exports IClient2MineSweeperSrvAckFlop
     * @interface IClient2MineSweeperSrvAckFlop
     * @property {number|null} [Ret] Client2MineSweeperSrvAckFlop Ret
     * @property {number|null} [DeskNo] Client2MineSweeperSrvAckFlop DeskNo
     * @property {number|null} [UserID] Client2MineSweeperSrvAckFlop UserID
     * @property {number|null} [SeatNo] Client2MineSweeperSrvAckFlop SeatNo
     * @property {number|null} [GridId] Client2MineSweeperSrvAckFlop GridId
     * @property {number|null} [GridType] Client2MineSweeperSrvAckFlop GridType
     * @property {number|null} [BoxChip] Client2MineSweeperSrvAckFlop BoxChip
     * @property {number|null} [EarnChipX] Client2MineSweeperSrvAckFlop EarnChipX
     * @property {number|null} [NextChipX] Client2MineSweeperSrvAckFlop NextChipX
     * @property {number|null} [EarnChip] Client2MineSweeperSrvAckFlop EarnChip
     * @property {number|null} [NextChip] Client2MineSweeperSrvAckFlop NextChip
     */

    /**
     * Constructs a new Client2MineSweeperSrvAckFlop.
     * @exports Client2MineSweeperSrvAckFlop
     * @classdesc Represents a Client2MineSweeperSrvAckFlop.
     * @implements IClient2MineSweeperSrvAckFlop
     * @constructor
     * @param {IClient2MineSweeperSrvAckFlop=} [properties] Properties to set
     */
    function Client2MineSweeperSrvAckFlop(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvAckFlop Ret.
     * @member {number} Ret
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.Ret = 0;

    /**
     * Client2MineSweeperSrvAckFlop DeskNo.
     * @member {number} DeskNo
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.DeskNo = 0;

    /**
     * Client2MineSweeperSrvAckFlop UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.UserID = 0;

    /**
     * Client2MineSweeperSrvAckFlop SeatNo.
     * @member {number} SeatNo
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.SeatNo = 0;

    /**
     * Client2MineSweeperSrvAckFlop GridId.
     * @member {number} GridId
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.GridId = 0;

    /**
     * Client2MineSweeperSrvAckFlop GridType.
     * @member {number} GridType
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.GridType = 0;

    /**
     * Client2MineSweeperSrvAckFlop BoxChip.
     * @member {number} BoxChip
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.BoxChip = 0;

    /**
     * Client2MineSweeperSrvAckFlop EarnChipX.
     * @member {number} EarnChipX
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.EarnChipX = 0;

    /**
     * Client2MineSweeperSrvAckFlop NextChipX.
     * @member {number} NextChipX
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.NextChipX = 0;

    /**
     * Client2MineSweeperSrvAckFlop EarnChip.
     * @member {number} EarnChip
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.EarnChip = 0;

    /**
     * Client2MineSweeperSrvAckFlop NextChip.
     * @member {number} NextChip
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     */
    Client2MineSweeperSrvAckFlop.prototype.NextChip = 0;

    /**
     * Creates a new Client2MineSweeperSrvAckFlop instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {IClient2MineSweeperSrvAckFlop=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvAckFlop} Client2MineSweeperSrvAckFlop instance
     */
    Client2MineSweeperSrvAckFlop.create = function create(properties) {
        return new Client2MineSweeperSrvAckFlop(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckFlop message. Does not implicitly {@link Client2MineSweeperSrvAckFlop.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {IClient2MineSweeperSrvAckFlop} message Client2MineSweeperSrvAckFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckFlop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.GridId != null && Object.hasOwnProperty.call(message, "GridId"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.GridId);
        if (message.GridType != null && Object.hasOwnProperty.call(message, "GridType"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.GridType);
        if (message.BoxChip != null && Object.hasOwnProperty.call(message, "BoxChip"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.BoxChip);
        if (message.EarnChipX != null && Object.hasOwnProperty.call(message, "EarnChipX"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.EarnChipX);
        if (message.NextChipX != null && Object.hasOwnProperty.call(message, "NextChipX"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.NextChipX);
        if (message.EarnChip != null && Object.hasOwnProperty.call(message, "EarnChip"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.EarnChip);
        if (message.NextChip != null && Object.hasOwnProperty.call(message, "NextChip"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.NextChip);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckFlop message, length delimited. Does not implicitly {@link Client2MineSweeperSrvAckFlop.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {IClient2MineSweeperSrvAckFlop} message Client2MineSweeperSrvAckFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckFlop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvAckFlop message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvAckFlop} Client2MineSweeperSrvAckFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckFlop.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvAckFlop();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.GridId = reader.int32();
                    break;
                }
            case 6: {
                    message.GridType = reader.int32();
                    break;
                }
            case 7: {
                    message.BoxChip = reader.uint32();
                    break;
                }
            case 8: {
                    message.EarnChipX = reader.uint32();
                    break;
                }
            case 9: {
                    message.NextChipX = reader.uint32();
                    break;
                }
            case 10: {
                    message.EarnChip = reader.uint32();
                    break;
                }
            case 11: {
                    message.NextChip = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvAckFlop message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvAckFlop} Client2MineSweeperSrvAckFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckFlop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvAckFlop message.
     * @function verify
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvAckFlop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.GridId != null && message.hasOwnProperty("GridId"))
            if (!$util.isInteger(message.GridId))
                return "GridId: integer expected";
        if (message.GridType != null && message.hasOwnProperty("GridType"))
            if (!$util.isInteger(message.GridType))
                return "GridType: integer expected";
        if (message.BoxChip != null && message.hasOwnProperty("BoxChip"))
            if (!$util.isInteger(message.BoxChip))
                return "BoxChip: integer expected";
        if (message.EarnChipX != null && message.hasOwnProperty("EarnChipX"))
            if (!$util.isInteger(message.EarnChipX))
                return "EarnChipX: integer expected";
        if (message.NextChipX != null && message.hasOwnProperty("NextChipX"))
            if (!$util.isInteger(message.NextChipX))
                return "NextChipX: integer expected";
        if (message.EarnChip != null && message.hasOwnProperty("EarnChip"))
            if (!$util.isInteger(message.EarnChip))
                return "EarnChip: integer expected";
        if (message.NextChip != null && message.hasOwnProperty("NextChip"))
            if (!$util.isInteger(message.NextChip))
                return "NextChip: integer expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvAckFlop message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvAckFlop} Client2MineSweeperSrvAckFlop
     */
    Client2MineSweeperSrvAckFlop.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvAckFlop)
            return object;
        let message = new $root.Client2MineSweeperSrvAckFlop();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.GridId != null)
            message.GridId = object.GridId | 0;
        if (object.GridType != null)
            message.GridType = object.GridType | 0;
        if (object.BoxChip != null)
            message.BoxChip = object.BoxChip >>> 0;
        if (object.EarnChipX != null)
            message.EarnChipX = object.EarnChipX >>> 0;
        if (object.NextChipX != null)
            message.NextChipX = object.NextChipX >>> 0;
        if (object.EarnChip != null)
            message.EarnChip = object.EarnChip >>> 0;
        if (object.NextChip != null)
            message.NextChip = object.NextChip >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvAckFlop message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {Client2MineSweeperSrvAckFlop} message Client2MineSweeperSrvAckFlop
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvAckFlop.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.GridId = 0;
            object.GridType = 0;
            object.BoxChip = 0;
            object.EarnChipX = 0;
            object.NextChipX = 0;
            object.EarnChip = 0;
            object.NextChip = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.GridId != null && message.hasOwnProperty("GridId"))
            object.GridId = message.GridId;
        if (message.GridType != null && message.hasOwnProperty("GridType"))
            object.GridType = message.GridType;
        if (message.BoxChip != null && message.hasOwnProperty("BoxChip"))
            object.BoxChip = message.BoxChip;
        if (message.EarnChipX != null && message.hasOwnProperty("EarnChipX"))
            object.EarnChipX = message.EarnChipX;
        if (message.NextChipX != null && message.hasOwnProperty("NextChipX"))
            object.NextChipX = message.NextChipX;
        if (message.EarnChip != null && message.hasOwnProperty("EarnChip"))
            object.EarnChip = message.EarnChip;
        if (message.NextChip != null && message.hasOwnProperty("NextChip"))
            object.NextChip = message.NextChip;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvAckFlop to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvAckFlop
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvAckFlop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvAckFlop
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvAckFlop
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvAckFlop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvAckFlop";
    };

    return Client2MineSweeperSrvAckFlop;
})();

export const Client2MineSweeperSrvReqEndFlop = $root.Client2MineSweeperSrvReqEndFlop = (() => {

    /**
     * Properties of a Client2MineSweeperSrvReqEndFlop.
     * @exports IClient2MineSweeperSrvReqEndFlop
     * @interface IClient2MineSweeperSrvReqEndFlop
     * @property {number|null} [DeskNo] Client2MineSweeperSrvReqEndFlop DeskNo
     * @property {number|null} [UserID] Client2MineSweeperSrvReqEndFlop UserID
     * @property {number|null} [SeatNo] Client2MineSweeperSrvReqEndFlop SeatNo
     */

    /**
     * Constructs a new Client2MineSweeperSrvReqEndFlop.
     * @exports Client2MineSweeperSrvReqEndFlop
     * @classdesc Represents a Client2MineSweeperSrvReqEndFlop.
     * @implements IClient2MineSweeperSrvReqEndFlop
     * @constructor
     * @param {IClient2MineSweeperSrvReqEndFlop=} [properties] Properties to set
     */
    function Client2MineSweeperSrvReqEndFlop(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvReqEndFlop DeskNo.
     * @member {number} DeskNo
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @instance
     */
    Client2MineSweeperSrvReqEndFlop.prototype.DeskNo = 0;

    /**
     * Client2MineSweeperSrvReqEndFlop UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @instance
     */
    Client2MineSweeperSrvReqEndFlop.prototype.UserID = 0;

    /**
     * Client2MineSweeperSrvReqEndFlop SeatNo.
     * @member {number} SeatNo
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @instance
     */
    Client2MineSweeperSrvReqEndFlop.prototype.SeatNo = 0;

    /**
     * Creates a new Client2MineSweeperSrvReqEndFlop instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {IClient2MineSweeperSrvReqEndFlop=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvReqEndFlop} Client2MineSweeperSrvReqEndFlop instance
     */
    Client2MineSweeperSrvReqEndFlop.create = function create(properties) {
        return new Client2MineSweeperSrvReqEndFlop(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqEndFlop message. Does not implicitly {@link Client2MineSweeperSrvReqEndFlop.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {IClient2MineSweeperSrvReqEndFlop} message Client2MineSweeperSrvReqEndFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqEndFlop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvReqEndFlop message, length delimited. Does not implicitly {@link Client2MineSweeperSrvReqEndFlop.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {IClient2MineSweeperSrvReqEndFlop} message Client2MineSweeperSrvReqEndFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvReqEndFlop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvReqEndFlop message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvReqEndFlop} Client2MineSweeperSrvReqEndFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqEndFlop.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvReqEndFlop();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvReqEndFlop message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvReqEndFlop} Client2MineSweeperSrvReqEndFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvReqEndFlop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvReqEndFlop message.
     * @function verify
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvReqEndFlop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvReqEndFlop message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvReqEndFlop} Client2MineSweeperSrvReqEndFlop
     */
    Client2MineSweeperSrvReqEndFlop.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvReqEndFlop)
            return object;
        let message = new $root.Client2MineSweeperSrvReqEndFlop();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvReqEndFlop message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {Client2MineSweeperSrvReqEndFlop} message Client2MineSweeperSrvReqEndFlop
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvReqEndFlop.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvReqEndFlop to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvReqEndFlop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvReqEndFlop
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvReqEndFlop
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvReqEndFlop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvReqEndFlop";
    };

    return Client2MineSweeperSrvReqEndFlop;
})();

export const Client2MineSweeperSrvAckEndFlop = $root.Client2MineSweeperSrvAckEndFlop = (() => {

    /**
     * Properties of a Client2MineSweeperSrvAckEndFlop.
     * @exports IClient2MineSweeperSrvAckEndFlop
     * @interface IClient2MineSweeperSrvAckEndFlop
     * @property {number|null} [Ret] Client2MineSweeperSrvAckEndFlop Ret
     * @property {number|null} [UserID] Client2MineSweeperSrvAckEndFlop UserID
     */

    /**
     * Constructs a new Client2MineSweeperSrvAckEndFlop.
     * @exports Client2MineSweeperSrvAckEndFlop
     * @classdesc Represents a Client2MineSweeperSrvAckEndFlop.
     * @implements IClient2MineSweeperSrvAckEndFlop
     * @constructor
     * @param {IClient2MineSweeperSrvAckEndFlop=} [properties] Properties to set
     */
    function Client2MineSweeperSrvAckEndFlop(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2MineSweeperSrvAckEndFlop Ret.
     * @member {number} Ret
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @instance
     */
    Client2MineSweeperSrvAckEndFlop.prototype.Ret = 0;

    /**
     * Client2MineSweeperSrvAckEndFlop UserID.
     * @member {number} UserID
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @instance
     */
    Client2MineSweeperSrvAckEndFlop.prototype.UserID = 0;

    /**
     * Creates a new Client2MineSweeperSrvAckEndFlop instance using the specified properties.
     * @function create
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {IClient2MineSweeperSrvAckEndFlop=} [properties] Properties to set
     * @returns {Client2MineSweeperSrvAckEndFlop} Client2MineSweeperSrvAckEndFlop instance
     */
    Client2MineSweeperSrvAckEndFlop.create = function create(properties) {
        return new Client2MineSweeperSrvAckEndFlop(properties);
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckEndFlop message. Does not implicitly {@link Client2MineSweeperSrvAckEndFlop.verify|verify} messages.
     * @function encode
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {IClient2MineSweeperSrvAckEndFlop} message Client2MineSweeperSrvAckEndFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckEndFlop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2MineSweeperSrvAckEndFlop message, length delimited. Does not implicitly {@link Client2MineSweeperSrvAckEndFlop.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {IClient2MineSweeperSrvAckEndFlop} message Client2MineSweeperSrvAckEndFlop message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2MineSweeperSrvAckEndFlop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2MineSweeperSrvAckEndFlop message from the specified reader or buffer.
     * @function decode
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2MineSweeperSrvAckEndFlop} Client2MineSweeperSrvAckEndFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckEndFlop.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2MineSweeperSrvAckEndFlop();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2MineSweeperSrvAckEndFlop message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2MineSweeperSrvAckEndFlop} Client2MineSweeperSrvAckEndFlop
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2MineSweeperSrvAckEndFlop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2MineSweeperSrvAckEndFlop message.
     * @function verify
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2MineSweeperSrvAckEndFlop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2MineSweeperSrvAckEndFlop message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2MineSweeperSrvAckEndFlop} Client2MineSweeperSrvAckEndFlop
     */
    Client2MineSweeperSrvAckEndFlop.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2MineSweeperSrvAckEndFlop)
            return object;
        let message = new $root.Client2MineSweeperSrvAckEndFlop();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2MineSweeperSrvAckEndFlop message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {Client2MineSweeperSrvAckEndFlop} message Client2MineSweeperSrvAckEndFlop
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2MineSweeperSrvAckEndFlop.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2MineSweeperSrvAckEndFlop to JSON.
     * @function toJSON
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2MineSweeperSrvAckEndFlop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2MineSweeperSrvAckEndFlop
     * @function getTypeUrl
     * @memberof Client2MineSweeperSrvAckEndFlop
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2MineSweeperSrvAckEndFlop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2MineSweeperSrvAckEndFlop";
    };

    return Client2MineSweeperSrvAckEndFlop;
})();

export const Desk2MineSweeperSrvPushGameResult = $root.Desk2MineSweeperSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2MineSweeperSrvPushGameResult.
     * @exports IDesk2MineSweeperSrvPushGameResult
     * @interface IDesk2MineSweeperSrvPushGameResult
     * @property {number|null} [UserID] Desk2MineSweeperSrvPushGameResult UserID
     * @property {number|null} [ChangeGold] Desk2MineSweeperSrvPushGameResult ChangeGold
     * @property {string|null} [TotalEnterChip] Desk2MineSweeperSrvPushGameResult TotalEnterChip
     * @property {Array.<number>|null} [GridsArr] Desk2MineSweeperSrvPushGameResult GridsArr
     */

    /**
     * Constructs a new Desk2MineSweeperSrvPushGameResult.
     * @exports Desk2MineSweeperSrvPushGameResult
     * @classdesc Represents a Desk2MineSweeperSrvPushGameResult.
     * @implements IDesk2MineSweeperSrvPushGameResult
     * @constructor
     * @param {IDesk2MineSweeperSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2MineSweeperSrvPushGameResult(properties) {
        this.GridsArr = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2MineSweeperSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @instance
     */
    Desk2MineSweeperSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2MineSweeperSrvPushGameResult ChangeGold.
     * @member {number} ChangeGold
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @instance
     */
    Desk2MineSweeperSrvPushGameResult.prototype.ChangeGold = 0;

    /**
     * Desk2MineSweeperSrvPushGameResult TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @instance
     */
    Desk2MineSweeperSrvPushGameResult.prototype.TotalEnterChip = "";

    /**
     * Desk2MineSweeperSrvPushGameResult GridsArr.
     * @member {Array.<number>} GridsArr
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @instance
     */
    Desk2MineSweeperSrvPushGameResult.prototype.GridsArr = $util.emptyArray;

    /**
     * Creates a new Desk2MineSweeperSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {IDesk2MineSweeperSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2MineSweeperSrvPushGameResult} Desk2MineSweeperSrvPushGameResult instance
     */
    Desk2MineSweeperSrvPushGameResult.create = function create(properties) {
        return new Desk2MineSweeperSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2MineSweeperSrvPushGameResult message. Does not implicitly {@link Desk2MineSweeperSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {IDesk2MineSweeperSrvPushGameResult} message Desk2MineSweeperSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2MineSweeperSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.TotalEnterChip);
        if (message.GridsArr != null && message.GridsArr.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.GridsArr.length; ++i)
                writer.int32(message.GridsArr[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2MineSweeperSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2MineSweeperSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {IDesk2MineSweeperSrvPushGameResult} message Desk2MineSweeperSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2MineSweeperSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2MineSweeperSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2MineSweeperSrvPushGameResult} Desk2MineSweeperSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2MineSweeperSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2MineSweeperSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChangeGold = reader.uint32();
                    break;
                }
            case 3: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.GridsArr && message.GridsArr.length))
                        message.GridsArr = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GridsArr.push(reader.int32());
                    } else
                        message.GridsArr.push(reader.int32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2MineSweeperSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2MineSweeperSrvPushGameResult} Desk2MineSweeperSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2MineSweeperSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2MineSweeperSrvPushGameResult message.
     * @function verify
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2MineSweeperSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isInteger(message.ChangeGold))
                return "ChangeGold: integer expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        if (message.GridsArr != null && message.hasOwnProperty("GridsArr")) {
            if (!Array.isArray(message.GridsArr))
                return "GridsArr: array expected";
            for (let i = 0; i < message.GridsArr.length; ++i)
                if (!$util.isInteger(message.GridsArr[i]))
                    return "GridsArr: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2MineSweeperSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2MineSweeperSrvPushGameResult} Desk2MineSweeperSrvPushGameResult
     */
    Desk2MineSweeperSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2MineSweeperSrvPushGameResult)
            return object;
        let message = new $root.Desk2MineSweeperSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChangeGold != null)
            message.ChangeGold = object.ChangeGold >>> 0;
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        if (object.GridsArr) {
            if (!Array.isArray(object.GridsArr))
                throw TypeError(".Desk2MineSweeperSrvPushGameResult.GridsArr: array expected");
            message.GridsArr = [];
            for (let i = 0; i < object.GridsArr.length; ++i)
                message.GridsArr[i] = object.GridsArr[i] | 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2MineSweeperSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {Desk2MineSweeperSrvPushGameResult} message Desk2MineSweeperSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2MineSweeperSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GridsArr = [];
        if (options.defaults) {
            object.UserID = 0;
            object.ChangeGold = 0;
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        if (message.GridsArr && message.GridsArr.length) {
            object.GridsArr = [];
            for (let j = 0; j < message.GridsArr.length; ++j)
                object.GridsArr[j] = message.GridsArr[j];
        }
        return object;
    };

    /**
     * Converts this Desk2MineSweeperSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2MineSweeperSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2MineSweeperSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2MineSweeperSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2MineSweeperSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2MineSweeperSrvPushGameResult";
    };

    return Desk2MineSweeperSrvPushGameResult;
})();

export const Desk2MineSweeperSrvPushPlayingInfo = $root.Desk2MineSweeperSrvPushPlayingInfo = (() => {

    /**
     * Properties of a Desk2MineSweeperSrvPushPlayingInfo.
     * @exports IDesk2MineSweeperSrvPushPlayingInfo
     * @interface IDesk2MineSweeperSrvPushPlayingInfo
     * @property {number|null} [UserID] Desk2MineSweeperSrvPushPlayingInfo UserID
     * @property {number|null} [StateId] Desk2MineSweeperSrvPushPlayingInfo StateId
     * @property {number|null} [Mines] Desk2MineSweeperSrvPushPlayingInfo Mines
     * @property {number|null} [Multi] Desk2MineSweeperSrvPushPlayingInfo Multi
     * @property {number|null} [EarnChipX] Desk2MineSweeperSrvPushPlayingInfo EarnChipX
     * @property {number|null} [NextChipX] Desk2MineSweeperSrvPushPlayingInfo NextChipX
     * @property {number|null} [EarnChip] Desk2MineSweeperSrvPushPlayingInfo EarnChip
     * @property {number|null} [NextChip] Desk2MineSweeperSrvPushPlayingInfo NextChip
     * @property {Array.<number>|null} [GridsArr] Desk2MineSweeperSrvPushPlayingInfo GridsArr
     */

    /**
     * Constructs a new Desk2MineSweeperSrvPushPlayingInfo.
     * @exports Desk2MineSweeperSrvPushPlayingInfo
     * @classdesc Represents a Desk2MineSweeperSrvPushPlayingInfo.
     * @implements IDesk2MineSweeperSrvPushPlayingInfo
     * @constructor
     * @param {IDesk2MineSweeperSrvPushPlayingInfo=} [properties] Properties to set
     */
    function Desk2MineSweeperSrvPushPlayingInfo(properties) {
        this.GridsArr = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2MineSweeperSrvPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.UserID = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo StateId.
     * @member {number} StateId
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.StateId = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo Mines.
     * @member {number} Mines
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.Mines = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo Multi.
     * @member {number} Multi
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.Multi = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo EarnChipX.
     * @member {number} EarnChipX
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.EarnChipX = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo NextChipX.
     * @member {number} NextChipX
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.NextChipX = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo EarnChip.
     * @member {number} EarnChip
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.EarnChip = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo NextChip.
     * @member {number} NextChip
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.NextChip = 0;

    /**
     * Desk2MineSweeperSrvPushPlayingInfo GridsArr.
     * @member {Array.<number>} GridsArr
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.GridsArr = $util.emptyArray;

    /**
     * Creates a new Desk2MineSweeperSrvPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {IDesk2MineSweeperSrvPushPlayingInfo=} [properties] Properties to set
     * @returns {Desk2MineSweeperSrvPushPlayingInfo} Desk2MineSweeperSrvPushPlayingInfo instance
     */
    Desk2MineSweeperSrvPushPlayingInfo.create = function create(properties) {
        return new Desk2MineSweeperSrvPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified Desk2MineSweeperSrvPushPlayingInfo message. Does not implicitly {@link Desk2MineSweeperSrvPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {IDesk2MineSweeperSrvPushPlayingInfo} message Desk2MineSweeperSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2MineSweeperSrvPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateId != null && Object.hasOwnProperty.call(message, "StateId"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateId);
        if (message.Mines != null && Object.hasOwnProperty.call(message, "Mines"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Mines);
        if (message.Multi != null && Object.hasOwnProperty.call(message, "Multi"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Multi);
        if (message.EarnChipX != null && Object.hasOwnProperty.call(message, "EarnChipX"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.EarnChipX);
        if (message.NextChipX != null && Object.hasOwnProperty.call(message, "NextChipX"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.NextChipX);
        if (message.EarnChip != null && Object.hasOwnProperty.call(message, "EarnChip"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.EarnChip);
        if (message.NextChip != null && Object.hasOwnProperty.call(message, "NextChip"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.NextChip);
        if (message.GridsArr != null && message.GridsArr.length) {
            writer.uint32(/* id 9, wireType 2 =*/74).fork();
            for (let i = 0; i < message.GridsArr.length; ++i)
                writer.int32(message.GridsArr[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2MineSweeperSrvPushPlayingInfo message, length delimited. Does not implicitly {@link Desk2MineSweeperSrvPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {IDesk2MineSweeperSrvPushPlayingInfo} message Desk2MineSweeperSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2MineSweeperSrvPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2MineSweeperSrvPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2MineSweeperSrvPushPlayingInfo} Desk2MineSweeperSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2MineSweeperSrvPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2MineSweeperSrvPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateId = reader.uint32();
                    break;
                }
            case 3: {
                    message.Mines = reader.uint32();
                    break;
                }
            case 4: {
                    message.Multi = reader.uint32();
                    break;
                }
            case 5: {
                    message.EarnChipX = reader.uint32();
                    break;
                }
            case 6: {
                    message.NextChipX = reader.uint32();
                    break;
                }
            case 7: {
                    message.EarnChip = reader.uint32();
                    break;
                }
            case 8: {
                    message.NextChip = reader.uint32();
                    break;
                }
            case 9: {
                    if (!(message.GridsArr && message.GridsArr.length))
                        message.GridsArr = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GridsArr.push(reader.int32());
                    } else
                        message.GridsArr.push(reader.int32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2MineSweeperSrvPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2MineSweeperSrvPushPlayingInfo} Desk2MineSweeperSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2MineSweeperSrvPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2MineSweeperSrvPushPlayingInfo message.
     * @function verify
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2MineSweeperSrvPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateId != null && message.hasOwnProperty("StateId"))
            if (!$util.isInteger(message.StateId))
                return "StateId: integer expected";
        if (message.Mines != null && message.hasOwnProperty("Mines"))
            if (!$util.isInteger(message.Mines))
                return "Mines: integer expected";
        if (message.Multi != null && message.hasOwnProperty("Multi"))
            if (!$util.isInteger(message.Multi))
                return "Multi: integer expected";
        if (message.EarnChipX != null && message.hasOwnProperty("EarnChipX"))
            if (!$util.isInteger(message.EarnChipX))
                return "EarnChipX: integer expected";
        if (message.NextChipX != null && message.hasOwnProperty("NextChipX"))
            if (!$util.isInteger(message.NextChipX))
                return "NextChipX: integer expected";
        if (message.EarnChip != null && message.hasOwnProperty("EarnChip"))
            if (!$util.isInteger(message.EarnChip))
                return "EarnChip: integer expected";
        if (message.NextChip != null && message.hasOwnProperty("NextChip"))
            if (!$util.isInteger(message.NextChip))
                return "NextChip: integer expected";
        if (message.GridsArr != null && message.hasOwnProperty("GridsArr")) {
            if (!Array.isArray(message.GridsArr))
                return "GridsArr: array expected";
            for (let i = 0; i < message.GridsArr.length; ++i)
                if (!$util.isInteger(message.GridsArr[i]))
                    return "GridsArr: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2MineSweeperSrvPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2MineSweeperSrvPushPlayingInfo} Desk2MineSweeperSrvPushPlayingInfo
     */
    Desk2MineSweeperSrvPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2MineSweeperSrvPushPlayingInfo)
            return object;
        let message = new $root.Desk2MineSweeperSrvPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateId != null)
            message.StateId = object.StateId >>> 0;
        if (object.Mines != null)
            message.Mines = object.Mines >>> 0;
        if (object.Multi != null)
            message.Multi = object.Multi >>> 0;
        if (object.EarnChipX != null)
            message.EarnChipX = object.EarnChipX >>> 0;
        if (object.NextChipX != null)
            message.NextChipX = object.NextChipX >>> 0;
        if (object.EarnChip != null)
            message.EarnChip = object.EarnChip >>> 0;
        if (object.NextChip != null)
            message.NextChip = object.NextChip >>> 0;
        if (object.GridsArr) {
            if (!Array.isArray(object.GridsArr))
                throw TypeError(".Desk2MineSweeperSrvPushPlayingInfo.GridsArr: array expected");
            message.GridsArr = [];
            for (let i = 0; i < object.GridsArr.length; ++i)
                message.GridsArr[i] = object.GridsArr[i] | 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2MineSweeperSrvPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {Desk2MineSweeperSrvPushPlayingInfo} message Desk2MineSweeperSrvPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2MineSweeperSrvPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GridsArr = [];
        if (options.defaults) {
            object.UserID = 0;
            object.StateId = 0;
            object.Mines = 0;
            object.Multi = 0;
            object.EarnChipX = 0;
            object.NextChipX = 0;
            object.EarnChip = 0;
            object.NextChip = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateId != null && message.hasOwnProperty("StateId"))
            object.StateId = message.StateId;
        if (message.Mines != null && message.hasOwnProperty("Mines"))
            object.Mines = message.Mines;
        if (message.Multi != null && message.hasOwnProperty("Multi"))
            object.Multi = message.Multi;
        if (message.EarnChipX != null && message.hasOwnProperty("EarnChipX"))
            object.EarnChipX = message.EarnChipX;
        if (message.NextChipX != null && message.hasOwnProperty("NextChipX"))
            object.NextChipX = message.NextChipX;
        if (message.EarnChip != null && message.hasOwnProperty("EarnChip"))
            object.EarnChip = message.EarnChip;
        if (message.NextChip != null && message.hasOwnProperty("NextChip"))
            object.NextChip = message.NextChip;
        if (message.GridsArr && message.GridsArr.length) {
            object.GridsArr = [];
            for (let j = 0; j < message.GridsArr.length; ++j)
                object.GridsArr[j] = message.GridsArr[j];
        }
        return object;
    };

    /**
     * Converts this Desk2MineSweeperSrvPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2MineSweeperSrvPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2MineSweeperSrvPushPlayingInfo
     * @function getTypeUrl
     * @memberof Desk2MineSweeperSrvPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2MineSweeperSrvPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2MineSweeperSrvPushPlayingInfo";
    };

    return Desk2MineSweeperSrvPushPlayingInfo;
})();

export const PoolInfo = $root.PoolInfo = (() => {

    /**
     * Properties of a PoolInfo.
     * @exports IPoolInfo
     * @interface IPoolInfo
     * @property {string|null} [Color] PoolInfo Color
     * @property {string|null} [Main] PoolInfo Main
     * @property {Array.<string>|null} [Edge] PoolInfo Edge
     */

    /**
     * Constructs a new PoolInfo.
     * @exports PoolInfo
     * @classdesc Represents a PoolInfo.
     * @implements IPoolInfo
     * @constructor
     * @param {IPoolInfo=} [properties] Properties to set
     */
    function PoolInfo(properties) {
        this.Edge = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PoolInfo Color.
     * @member {string} Color
     * @memberof PoolInfo
     * @instance
     */
    PoolInfo.prototype.Color = "";

    /**
     * PoolInfo Main.
     * @member {string} Main
     * @memberof PoolInfo
     * @instance
     */
    PoolInfo.prototype.Main = "";

    /**
     * PoolInfo Edge.
     * @member {Array.<string>} Edge
     * @memberof PoolInfo
     * @instance
     */
    PoolInfo.prototype.Edge = $util.emptyArray;

    /**
     * Creates a new PoolInfo instance using the specified properties.
     * @function create
     * @memberof PoolInfo
     * @static
     * @param {IPoolInfo=} [properties] Properties to set
     * @returns {PoolInfo} PoolInfo instance
     */
    PoolInfo.create = function create(properties) {
        return new PoolInfo(properties);
    };

    /**
     * Encodes the specified PoolInfo message. Does not implicitly {@link PoolInfo.verify|verify} messages.
     * @function encode
     * @memberof PoolInfo
     * @static
     * @param {IPoolInfo} message PoolInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PoolInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Color != null && Object.hasOwnProperty.call(message, "Color"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Color);
        if (message.Main != null && Object.hasOwnProperty.call(message, "Main"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Main);
        if (message.Edge != null && message.Edge.length)
            for (let i = 0; i < message.Edge.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Edge[i]);
        return writer;
    };

    /**
     * Encodes the specified PoolInfo message, length delimited. Does not implicitly {@link PoolInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PoolInfo
     * @static
     * @param {IPoolInfo} message PoolInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PoolInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PoolInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PoolInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PoolInfo} PoolInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PoolInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PoolInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Color = reader.string();
                    break;
                }
            case 2: {
                    message.Main = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.Edge && message.Edge.length))
                        message.Edge = [];
                    message.Edge.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PoolInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PoolInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PoolInfo} PoolInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PoolInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PoolInfo message.
     * @function verify
     * @memberof PoolInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PoolInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Color != null && message.hasOwnProperty("Color"))
            if (!$util.isString(message.Color))
                return "Color: string expected";
        if (message.Main != null && message.hasOwnProperty("Main"))
            if (!$util.isString(message.Main))
                return "Main: string expected";
        if (message.Edge != null && message.hasOwnProperty("Edge")) {
            if (!Array.isArray(message.Edge))
                return "Edge: array expected";
            for (let i = 0; i < message.Edge.length; ++i)
                if (!$util.isString(message.Edge[i]))
                    return "Edge: string[] expected";
        }
        return null;
    };

    /**
     * Creates a PoolInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PoolInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PoolInfo} PoolInfo
     */
    PoolInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PoolInfo)
            return object;
        let message = new $root.PoolInfo();
        if (object.Color != null)
            message.Color = String(object.Color);
        if (object.Main != null)
            message.Main = String(object.Main);
        if (object.Edge) {
            if (!Array.isArray(object.Edge))
                throw TypeError(".PoolInfo.Edge: array expected");
            message.Edge = [];
            for (let i = 0; i < object.Edge.length; ++i)
                message.Edge[i] = String(object.Edge[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a PoolInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PoolInfo
     * @static
     * @param {PoolInfo} message PoolInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PoolInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Edge = [];
        if (options.defaults) {
            object.Color = "";
            object.Main = "";
        }
        if (message.Color != null && message.hasOwnProperty("Color"))
            object.Color = message.Color;
        if (message.Main != null && message.hasOwnProperty("Main"))
            object.Main = message.Main;
        if (message.Edge && message.Edge.length) {
            object.Edge = [];
            for (let j = 0; j < message.Edge.length; ++j)
                object.Edge[j] = message.Edge[j];
        }
        return object;
    };

    /**
     * Converts this PoolInfo to JSON.
     * @function toJSON
     * @memberof PoolInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PoolInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PoolInfo
     * @function getTypeUrl
     * @memberof PoolInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PoolInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PoolInfo";
    };

    return PoolInfo;
})();

export const GameSrvToDeskPushStartGame = $root.GameSrvToDeskPushStartGame = (() => {

    /**
     * Properties of a GameSrvToDeskPushStartGame.
     * @exports IGameSrvToDeskPushStartGame
     * @interface IGameSrvToDeskPushStartGame
     * @property {number|null} [DealerID] GameSrvToDeskPushStartGame DealerID
     * @property {number|null} [SBID] GameSrvToDeskPushStartGame SBID
     * @property {number|null} [BBID] GameSrvToDeskPushStartGame BBID
     * @property {string|null} [SBChip] GameSrvToDeskPushStartGame SBChip
     * @property {string|null} [BBChip] GameSrvToDeskPushStartGame BBChip
     * @property {IPoolInfo|null} [Pool] GameSrvToDeskPushStartGame Pool
     * @property {Array.<number>|null} [GamingIDs] GameSrvToDeskPushStartGame GamingIDs
     * @property {Array.<number>|null} [WatchingIDs] GameSrvToDeskPushStartGame WatchingIDs
     * @property {string|null} [CurSBEnterChip] GameSrvToDeskPushStartGame CurSBEnterChip
     * @property {string|null} [CurBBEnterChip] GameSrvToDeskPushStartGame CurBBEnterChip
     */

    /**
     * Constructs a new GameSrvToDeskPushStartGame.
     * @exports GameSrvToDeskPushStartGame
     * @classdesc Represents a GameSrvToDeskPushStartGame.
     * @implements IGameSrvToDeskPushStartGame
     * @constructor
     * @param {IGameSrvToDeskPushStartGame=} [properties] Properties to set
     */
    function GameSrvToDeskPushStartGame(properties) {
        this.GamingIDs = [];
        this.WatchingIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushStartGame DealerID.
     * @member {number} DealerID
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.DealerID = 0;

    /**
     * GameSrvToDeskPushStartGame SBID.
     * @member {number} SBID
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.SBID = 0;

    /**
     * GameSrvToDeskPushStartGame BBID.
     * @member {number} BBID
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.BBID = 0;

    /**
     * GameSrvToDeskPushStartGame SBChip.
     * @member {string} SBChip
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.SBChip = "";

    /**
     * GameSrvToDeskPushStartGame BBChip.
     * @member {string} BBChip
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.BBChip = "";

    /**
     * GameSrvToDeskPushStartGame Pool.
     * @member {IPoolInfo|null|undefined} Pool
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.Pool = null;

    /**
     * GameSrvToDeskPushStartGame GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.GamingIDs = $util.emptyArray;

    /**
     * GameSrvToDeskPushStartGame WatchingIDs.
     * @member {Array.<number>} WatchingIDs
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.WatchingIDs = $util.emptyArray;

    /**
     * GameSrvToDeskPushStartGame CurSBEnterChip.
     * @member {string} CurSBEnterChip
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.CurSBEnterChip = "";

    /**
     * GameSrvToDeskPushStartGame CurBBEnterChip.
     * @member {string} CurBBEnterChip
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     */
    GameSrvToDeskPushStartGame.prototype.CurBBEnterChip = "";

    /**
     * Creates a new GameSrvToDeskPushStartGame instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {IGameSrvToDeskPushStartGame=} [properties] Properties to set
     * @returns {GameSrvToDeskPushStartGame} GameSrvToDeskPushStartGame instance
     */
    GameSrvToDeskPushStartGame.create = function create(properties) {
        return new GameSrvToDeskPushStartGame(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushStartGame message. Does not implicitly {@link GameSrvToDeskPushStartGame.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {IGameSrvToDeskPushStartGame} message GameSrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushStartGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DealerID);
        if (message.SBID != null && Object.hasOwnProperty.call(message, "SBID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SBID);
        if (message.BBID != null && Object.hasOwnProperty.call(message, "BBID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BBID);
        if (message.SBChip != null && Object.hasOwnProperty.call(message, "SBChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.SBChip);
        if (message.BBChip != null && Object.hasOwnProperty.call(message, "BBChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BBChip);
        if (message.Pool != null && Object.hasOwnProperty.call(message, "Pool"))
            $root.PoolInfo.encode(message.Pool, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.WatchingIDs != null && message.WatchingIDs.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                writer.uint32(message.WatchingIDs[i]);
            writer.ldelim();
        }
        if (message.CurSBEnterChip != null && Object.hasOwnProperty.call(message, "CurSBEnterChip"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.CurSBEnterChip);
        if (message.CurBBEnterChip != null && Object.hasOwnProperty.call(message, "CurBBEnterChip"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.CurBBEnterChip);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushStartGame message, length delimited. Does not implicitly {@link GameSrvToDeskPushStartGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {IGameSrvToDeskPushStartGame} message GameSrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushStartGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushStartGame message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushStartGame} GameSrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushStartGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushStartGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SBID = reader.uint32();
                    break;
                }
            case 3: {
                    message.BBID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SBChip = reader.string();
                    break;
                }
            case 5: {
                    message.BBChip = reader.string();
                    break;
                }
            case 6: {
                    message.Pool = $root.PoolInfo.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.WatchingIDs && message.WatchingIDs.length))
                        message.WatchingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.WatchingIDs.push(reader.uint32());
                    } else
                        message.WatchingIDs.push(reader.uint32());
                    break;
                }
            case 9: {
                    message.CurSBEnterChip = reader.string();
                    break;
                }
            case 10: {
                    message.CurBBEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushStartGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushStartGame} GameSrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushStartGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushStartGame message.
     * @function verify
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushStartGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.SBID != null && message.hasOwnProperty("SBID"))
            if (!$util.isInteger(message.SBID))
                return "SBID: integer expected";
        if (message.BBID != null && message.hasOwnProperty("BBID"))
            if (!$util.isInteger(message.BBID))
                return "BBID: integer expected";
        if (message.SBChip != null && message.hasOwnProperty("SBChip"))
            if (!$util.isString(message.SBChip))
                return "SBChip: string expected";
        if (message.BBChip != null && message.hasOwnProperty("BBChip"))
            if (!$util.isString(message.BBChip))
                return "BBChip: string expected";
        if (message.Pool != null && message.hasOwnProperty("Pool")) {
            let error = $root.PoolInfo.verify(message.Pool);
            if (error)
                return "Pool." + error;
        }
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.WatchingIDs != null && message.hasOwnProperty("WatchingIDs")) {
            if (!Array.isArray(message.WatchingIDs))
                return "WatchingIDs: array expected";
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                if (!$util.isInteger(message.WatchingIDs[i]))
                    return "WatchingIDs: integer[] expected";
        }
        if (message.CurSBEnterChip != null && message.hasOwnProperty("CurSBEnterChip"))
            if (!$util.isString(message.CurSBEnterChip))
                return "CurSBEnterChip: string expected";
        if (message.CurBBEnterChip != null && message.hasOwnProperty("CurBBEnterChip"))
            if (!$util.isString(message.CurBBEnterChip))
                return "CurBBEnterChip: string expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushStartGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushStartGame} GameSrvToDeskPushStartGame
     */
    GameSrvToDeskPushStartGame.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushStartGame)
            return object;
        let message = new $root.GameSrvToDeskPushStartGame();
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.SBID != null)
            message.SBID = object.SBID >>> 0;
        if (object.BBID != null)
            message.BBID = object.BBID >>> 0;
        if (object.SBChip != null)
            message.SBChip = String(object.SBChip);
        if (object.BBChip != null)
            message.BBChip = String(object.BBChip);
        if (object.Pool != null) {
            if (typeof object.Pool !== "object")
                throw TypeError(".GameSrvToDeskPushStartGame.Pool: object expected");
            message.Pool = $root.PoolInfo.fromObject(object.Pool);
        }
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".GameSrvToDeskPushStartGame.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.WatchingIDs) {
            if (!Array.isArray(object.WatchingIDs))
                throw TypeError(".GameSrvToDeskPushStartGame.WatchingIDs: array expected");
            message.WatchingIDs = [];
            for (let i = 0; i < object.WatchingIDs.length; ++i)
                message.WatchingIDs[i] = object.WatchingIDs[i] >>> 0;
        }
        if (object.CurSBEnterChip != null)
            message.CurSBEnterChip = String(object.CurSBEnterChip);
        if (object.CurBBEnterChip != null)
            message.CurBBEnterChip = String(object.CurBBEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushStartGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {GameSrvToDeskPushStartGame} message GameSrvToDeskPushStartGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushStartGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.WatchingIDs = [];
        }
        if (options.defaults) {
            object.DealerID = 0;
            object.SBID = 0;
            object.BBID = 0;
            object.SBChip = "";
            object.BBChip = "";
            object.Pool = null;
            object.CurSBEnterChip = "";
            object.CurBBEnterChip = "";
        }
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.SBID != null && message.hasOwnProperty("SBID"))
            object.SBID = message.SBID;
        if (message.BBID != null && message.hasOwnProperty("BBID"))
            object.BBID = message.BBID;
        if (message.SBChip != null && message.hasOwnProperty("SBChip"))
            object.SBChip = message.SBChip;
        if (message.BBChip != null && message.hasOwnProperty("BBChip"))
            object.BBChip = message.BBChip;
        if (message.Pool != null && message.hasOwnProperty("Pool"))
            object.Pool = $root.PoolInfo.toObject(message.Pool, options);
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.WatchingIDs && message.WatchingIDs.length) {
            object.WatchingIDs = [];
            for (let j = 0; j < message.WatchingIDs.length; ++j)
                object.WatchingIDs[j] = message.WatchingIDs[j];
        }
        if (message.CurSBEnterChip != null && message.hasOwnProperty("CurSBEnterChip"))
            object.CurSBEnterChip = message.CurSBEnterChip;
        if (message.CurBBEnterChip != null && message.hasOwnProperty("CurBBEnterChip"))
            object.CurBBEnterChip = message.CurBBEnterChip;
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushStartGame to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushStartGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushStartGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushStartGame
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushStartGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushStartGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushStartGame";
    };

    return GameSrvToDeskPushStartGame;
})();

export const OperCmdTip = $root.OperCmdTip = (() => {

    /**
     * Properties of an OperCmdTip.
     * @exports IOperCmdTip
     * @interface IOperCmdTip
     * @property {number|null} [OperType] OperCmdTip OperType
     * @property {string|null} [MinBet] OperCmdTip MinBet
     * @property {string|null} [MaxBet] OperCmdTip MaxBet
     */

    /**
     * Constructs a new OperCmdTip.
     * @exports OperCmdTip
     * @classdesc Represents an OperCmdTip.
     * @implements IOperCmdTip
     * @constructor
     * @param {IOperCmdTip=} [properties] Properties to set
     */
    function OperCmdTip(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OperCmdTip OperType.
     * @member {number} OperType
     * @memberof OperCmdTip
     * @instance
     */
    OperCmdTip.prototype.OperType = 0;

    /**
     * OperCmdTip MinBet.
     * @member {string} MinBet
     * @memberof OperCmdTip
     * @instance
     */
    OperCmdTip.prototype.MinBet = "";

    /**
     * OperCmdTip MaxBet.
     * @member {string} MaxBet
     * @memberof OperCmdTip
     * @instance
     */
    OperCmdTip.prototype.MaxBet = "";

    /**
     * Creates a new OperCmdTip instance using the specified properties.
     * @function create
     * @memberof OperCmdTip
     * @static
     * @param {IOperCmdTip=} [properties] Properties to set
     * @returns {OperCmdTip} OperCmdTip instance
     */
    OperCmdTip.create = function create(properties) {
        return new OperCmdTip(properties);
    };

    /**
     * Encodes the specified OperCmdTip message. Does not implicitly {@link OperCmdTip.verify|verify} messages.
     * @function encode
     * @memberof OperCmdTip
     * @static
     * @param {IOperCmdTip} message OperCmdTip message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmdTip.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OperType != null && Object.hasOwnProperty.call(message, "OperType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.OperType);
        if (message.MinBet != null && Object.hasOwnProperty.call(message, "MinBet"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.MinBet);
        if (message.MaxBet != null && Object.hasOwnProperty.call(message, "MaxBet"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.MaxBet);
        return writer;
    };

    /**
     * Encodes the specified OperCmdTip message, length delimited. Does not implicitly {@link OperCmdTip.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OperCmdTip
     * @static
     * @param {IOperCmdTip} message OperCmdTip message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmdTip.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OperCmdTip message from the specified reader or buffer.
     * @function decode
     * @memberof OperCmdTip
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OperCmdTip} OperCmdTip
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmdTip.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OperCmdTip();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.OperType = reader.uint32();
                    break;
                }
            case 2: {
                    message.MinBet = reader.string();
                    break;
                }
            case 3: {
                    message.MaxBet = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OperCmdTip message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OperCmdTip
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OperCmdTip} OperCmdTip
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmdTip.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OperCmdTip message.
     * @function verify
     * @memberof OperCmdTip
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OperCmdTip.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OperType != null && message.hasOwnProperty("OperType"))
            if (!$util.isInteger(message.OperType))
                return "OperType: integer expected";
        if (message.MinBet != null && message.hasOwnProperty("MinBet"))
            if (!$util.isString(message.MinBet))
                return "MinBet: string expected";
        if (message.MaxBet != null && message.hasOwnProperty("MaxBet"))
            if (!$util.isString(message.MaxBet))
                return "MaxBet: string expected";
        return null;
    };

    /**
     * Creates an OperCmdTip message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OperCmdTip
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OperCmdTip} OperCmdTip
     */
    OperCmdTip.fromObject = function fromObject(object) {
        if (object instanceof $root.OperCmdTip)
            return object;
        let message = new $root.OperCmdTip();
        if (object.OperType != null)
            message.OperType = object.OperType >>> 0;
        if (object.MinBet != null)
            message.MinBet = String(object.MinBet);
        if (object.MaxBet != null)
            message.MaxBet = String(object.MaxBet);
        return message;
    };

    /**
     * Creates a plain object from an OperCmdTip message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OperCmdTip
     * @static
     * @param {OperCmdTip} message OperCmdTip
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OperCmdTip.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.OperType = 0;
            object.MinBet = "";
            object.MaxBet = "";
        }
        if (message.OperType != null && message.hasOwnProperty("OperType"))
            object.OperType = message.OperType;
        if (message.MinBet != null && message.hasOwnProperty("MinBet"))
            object.MinBet = message.MinBet;
        if (message.MaxBet != null && message.hasOwnProperty("MaxBet"))
            object.MaxBet = message.MaxBet;
        return object;
    };

    /**
     * Converts this OperCmdTip to JSON.
     * @function toJSON
     * @memberof OperCmdTip
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OperCmdTip.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OperCmdTip
     * @function getTypeUrl
     * @memberof OperCmdTip
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OperCmdTip.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OperCmdTip";
    };

    return OperCmdTip;
})();

export const GameSrvToDeskPushCommand = $root.GameSrvToDeskPushCommand = (() => {

    /**
     * Properties of a GameSrvToDeskPushCommand.
     * @exports IGameSrvToDeskPushCommand
     * @interface IGameSrvToDeskPushCommand
     * @property {number|null} [UserID] GameSrvToDeskPushCommand UserID
     * @property {number|null} [Practitioner] GameSrvToDeskPushCommand Practitioner
     * @property {string|null} [Balance] GameSrvToDeskPushCommand Balance
     * @property {IPoolInfo|null} [Pool] GameSrvToDeskPushCommand Pool
     * @property {Array.<IOperCmdTip>|null} [Operation] GameSrvToDeskPushCommand Operation
     */

    /**
     * Constructs a new GameSrvToDeskPushCommand.
     * @exports GameSrvToDeskPushCommand
     * @classdesc Represents a GameSrvToDeskPushCommand.
     * @implements IGameSrvToDeskPushCommand
     * @constructor
     * @param {IGameSrvToDeskPushCommand=} [properties] Properties to set
     */
    function GameSrvToDeskPushCommand(properties) {
        this.Operation = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushCommand UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushCommand
     * @instance
     */
    GameSrvToDeskPushCommand.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushCommand Practitioner.
     * @member {number} Practitioner
     * @memberof GameSrvToDeskPushCommand
     * @instance
     */
    GameSrvToDeskPushCommand.prototype.Practitioner = 0;

    /**
     * GameSrvToDeskPushCommand Balance.
     * @member {string} Balance
     * @memberof GameSrvToDeskPushCommand
     * @instance
     */
    GameSrvToDeskPushCommand.prototype.Balance = "";

    /**
     * GameSrvToDeskPushCommand Pool.
     * @member {IPoolInfo|null|undefined} Pool
     * @memberof GameSrvToDeskPushCommand
     * @instance
     */
    GameSrvToDeskPushCommand.prototype.Pool = null;

    /**
     * GameSrvToDeskPushCommand Operation.
     * @member {Array.<IOperCmdTip>} Operation
     * @memberof GameSrvToDeskPushCommand
     * @instance
     */
    GameSrvToDeskPushCommand.prototype.Operation = $util.emptyArray;

    /**
     * Creates a new GameSrvToDeskPushCommand instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {IGameSrvToDeskPushCommand=} [properties] Properties to set
     * @returns {GameSrvToDeskPushCommand} GameSrvToDeskPushCommand instance
     */
    GameSrvToDeskPushCommand.create = function create(properties) {
        return new GameSrvToDeskPushCommand(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushCommand message. Does not implicitly {@link GameSrvToDeskPushCommand.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {IGameSrvToDeskPushCommand} message GameSrvToDeskPushCommand message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushCommand.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Practitioner);
        if (message.Balance != null && Object.hasOwnProperty.call(message, "Balance"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Balance);
        if (message.Pool != null && Object.hasOwnProperty.call(message, "Pool"))
            $root.PoolInfo.encode(message.Pool, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.Operation != null && message.Operation.length)
            for (let i = 0; i < message.Operation.length; ++i)
                $root.OperCmdTip.encode(message.Operation[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushCommand message, length delimited. Does not implicitly {@link GameSrvToDeskPushCommand.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {IGameSrvToDeskPushCommand} message GameSrvToDeskPushCommand message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushCommand.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushCommand message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushCommand} GameSrvToDeskPushCommand
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushCommand.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushCommand();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 3: {
                    message.Balance = reader.string();
                    break;
                }
            case 4: {
                    message.Pool = $root.PoolInfo.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    if (!(message.Operation && message.Operation.length))
                        message.Operation = [];
                    message.Operation.push($root.OperCmdTip.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushCommand message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushCommand} GameSrvToDeskPushCommand
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushCommand.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushCommand message.
     * @function verify
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushCommand.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.Balance != null && message.hasOwnProperty("Balance"))
            if (!$util.isString(message.Balance))
                return "Balance: string expected";
        if (message.Pool != null && message.hasOwnProperty("Pool")) {
            let error = $root.PoolInfo.verify(message.Pool);
            if (error)
                return "Pool." + error;
        }
        if (message.Operation != null && message.hasOwnProperty("Operation")) {
            if (!Array.isArray(message.Operation))
                return "Operation: array expected";
            for (let i = 0; i < message.Operation.length; ++i) {
                let error = $root.OperCmdTip.verify(message.Operation[i]);
                if (error)
                    return "Operation." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushCommand message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushCommand} GameSrvToDeskPushCommand
     */
    GameSrvToDeskPushCommand.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushCommand)
            return object;
        let message = new $root.GameSrvToDeskPushCommand();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.Balance != null)
            message.Balance = String(object.Balance);
        if (object.Pool != null) {
            if (typeof object.Pool !== "object")
                throw TypeError(".GameSrvToDeskPushCommand.Pool: object expected");
            message.Pool = $root.PoolInfo.fromObject(object.Pool);
        }
        if (object.Operation) {
            if (!Array.isArray(object.Operation))
                throw TypeError(".GameSrvToDeskPushCommand.Operation: array expected");
            message.Operation = [];
            for (let i = 0; i < object.Operation.length; ++i) {
                if (typeof object.Operation[i] !== "object")
                    throw TypeError(".GameSrvToDeskPushCommand.Operation: object expected");
                message.Operation[i] = $root.OperCmdTip.fromObject(object.Operation[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushCommand message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {GameSrvToDeskPushCommand} message GameSrvToDeskPushCommand
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushCommand.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Operation = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Practitioner = 0;
            object.Balance = "";
            object.Pool = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.Balance != null && message.hasOwnProperty("Balance"))
            object.Balance = message.Balance;
        if (message.Pool != null && message.hasOwnProperty("Pool"))
            object.Pool = $root.PoolInfo.toObject(message.Pool, options);
        if (message.Operation && message.Operation.length) {
            object.Operation = [];
            for (let j = 0; j < message.Operation.length; ++j)
                object.Operation[j] = $root.OperCmdTip.toObject(message.Operation[j], options);
        }
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushCommand to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushCommand
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushCommand.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushCommand
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushCommand
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushCommand.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushCommand";
    };

    return GameSrvToDeskPushCommand;
})();

export const OperCmd = $root.OperCmd = (() => {

    /**
     * Properties of an OperCmd.
     * @exports IOperCmd
     * @interface IOperCmd
     * @property {number|null} [Practitioner] OperCmd Practitioner
     * @property {number|null} [Operation] OperCmd Operation
     * @property {string|null} [BetChip] OperCmd BetChip
     * @property {number|null} [AllIn] OperCmd AllIn
     * @property {string|null} [CurEnterChip] OperCmd CurEnterChip
     */

    /**
     * Constructs a new OperCmd.
     * @exports OperCmd
     * @classdesc Represents an OperCmd.
     * @implements IOperCmd
     * @constructor
     * @param {IOperCmd=} [properties] Properties to set
     */
    function OperCmd(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OperCmd Practitioner.
     * @member {number} Practitioner
     * @memberof OperCmd
     * @instance
     */
    OperCmd.prototype.Practitioner = 0;

    /**
     * OperCmd Operation.
     * @member {number} Operation
     * @memberof OperCmd
     * @instance
     */
    OperCmd.prototype.Operation = 0;

    /**
     * OperCmd BetChip.
     * @member {string} BetChip
     * @memberof OperCmd
     * @instance
     */
    OperCmd.prototype.BetChip = "";

    /**
     * OperCmd AllIn.
     * @member {number} AllIn
     * @memberof OperCmd
     * @instance
     */
    OperCmd.prototype.AllIn = 0;

    /**
     * OperCmd CurEnterChip.
     * @member {string} CurEnterChip
     * @memberof OperCmd
     * @instance
     */
    OperCmd.prototype.CurEnterChip = "";

    /**
     * Creates a new OperCmd instance using the specified properties.
     * @function create
     * @memberof OperCmd
     * @static
     * @param {IOperCmd=} [properties] Properties to set
     * @returns {OperCmd} OperCmd instance
     */
    OperCmd.create = function create(properties) {
        return new OperCmd(properties);
    };

    /**
     * Encodes the specified OperCmd message. Does not implicitly {@link OperCmd.verify|verify} messages.
     * @function encode
     * @memberof OperCmd
     * @static
     * @param {IOperCmd} message OperCmd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Practitioner);
        if (message.Operation != null && Object.hasOwnProperty.call(message, "Operation"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Operation);
        if (message.BetChip != null && Object.hasOwnProperty.call(message, "BetChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetChip);
        if (message.AllIn != null && Object.hasOwnProperty.call(message, "AllIn"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.AllIn);
        if (message.CurEnterChip != null && Object.hasOwnProperty.call(message, "CurEnterChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.CurEnterChip);
        return writer;
    };

    /**
     * Encodes the specified OperCmd message, length delimited. Does not implicitly {@link OperCmd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OperCmd
     * @static
     * @param {IOperCmd} message OperCmd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OperCmd message from the specified reader or buffer.
     * @function decode
     * @memberof OperCmd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OperCmd} OperCmd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OperCmd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 2: {
                    message.Operation = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetChip = reader.string();
                    break;
                }
            case 4: {
                    message.AllIn = reader.uint32();
                    break;
                }
            case 5: {
                    message.CurEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OperCmd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OperCmd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OperCmd} OperCmd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OperCmd message.
     * @function verify
     * @memberof OperCmd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OperCmd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            if (!$util.isInteger(message.Operation))
                return "Operation: integer expected";
        if (message.BetChip != null && message.hasOwnProperty("BetChip"))
            if (!$util.isString(message.BetChip))
                return "BetChip: string expected";
        if (message.AllIn != null && message.hasOwnProperty("AllIn"))
            if (!$util.isInteger(message.AllIn))
                return "AllIn: integer expected";
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            if (!$util.isString(message.CurEnterChip))
                return "CurEnterChip: string expected";
        return null;
    };

    /**
     * Creates an OperCmd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OperCmd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OperCmd} OperCmd
     */
    OperCmd.fromObject = function fromObject(object) {
        if (object instanceof $root.OperCmd)
            return object;
        let message = new $root.OperCmd();
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.Operation != null)
            message.Operation = object.Operation >>> 0;
        if (object.BetChip != null)
            message.BetChip = String(object.BetChip);
        if (object.AllIn != null)
            message.AllIn = object.AllIn >>> 0;
        if (object.CurEnterChip != null)
            message.CurEnterChip = String(object.CurEnterChip);
        return message;
    };

    /**
     * Creates a plain object from an OperCmd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OperCmd
     * @static
     * @param {OperCmd} message OperCmd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OperCmd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Practitioner = 0;
            object.Operation = 0;
            object.BetChip = "";
            object.AllIn = 0;
            object.CurEnterChip = "";
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            object.Operation = message.Operation;
        if (message.BetChip != null && message.hasOwnProperty("BetChip"))
            object.BetChip = message.BetChip;
        if (message.AllIn != null && message.hasOwnProperty("AllIn"))
            object.AllIn = message.AllIn;
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            object.CurEnterChip = message.CurEnterChip;
        return object;
    };

    /**
     * Converts this OperCmd to JSON.
     * @function toJSON
     * @memberof OperCmd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OperCmd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OperCmd
     * @function getTypeUrl
     * @memberof OperCmd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OperCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OperCmd";
    };

    return OperCmd;
})();

export const DeskToGameSrvPlayerCommandReq = $root.DeskToGameSrvPlayerCommandReq = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerCommandReq.
     * @exports IDeskToGameSrvPlayerCommandReq
     * @interface IDeskToGameSrvPlayerCommandReq
     * @property {number|null} [DeskNo] DeskToGameSrvPlayerCommandReq DeskNo
     * @property {number|null} [UserID] DeskToGameSrvPlayerCommandReq UserID
     * @property {number|null} [SeatNo] DeskToGameSrvPlayerCommandReq SeatNo
     * @property {IOperCmd|null} [Command] DeskToGameSrvPlayerCommandReq Command
     */

    /**
     * Constructs a new DeskToGameSrvPlayerCommandReq.
     * @exports DeskToGameSrvPlayerCommandReq
     * @classdesc Represents a DeskToGameSrvPlayerCommandReq.
     * @implements IDeskToGameSrvPlayerCommandReq
     * @constructor
     * @param {IDeskToGameSrvPlayerCommandReq=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerCommandReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerCommandReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToGameSrvPlayerCommandReq
     * @instance
     */
    DeskToGameSrvPlayerCommandReq.prototype.DeskNo = 0;

    /**
     * DeskToGameSrvPlayerCommandReq UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerCommandReq
     * @instance
     */
    DeskToGameSrvPlayerCommandReq.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerCommandReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToGameSrvPlayerCommandReq
     * @instance
     */
    DeskToGameSrvPlayerCommandReq.prototype.SeatNo = 0;

    /**
     * DeskToGameSrvPlayerCommandReq Command.
     * @member {IOperCmd|null|undefined} Command
     * @memberof DeskToGameSrvPlayerCommandReq
     * @instance
     */
    DeskToGameSrvPlayerCommandReq.prototype.Command = null;

    /**
     * Creates a new DeskToGameSrvPlayerCommandReq instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {IDeskToGameSrvPlayerCommandReq=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerCommandReq} DeskToGameSrvPlayerCommandReq instance
     */
    DeskToGameSrvPlayerCommandReq.create = function create(properties) {
        return new DeskToGameSrvPlayerCommandReq(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerCommandReq message. Does not implicitly {@link DeskToGameSrvPlayerCommandReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {IDeskToGameSrvPlayerCommandReq} message DeskToGameSrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerCommandReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Command != null && Object.hasOwnProperty.call(message, "Command"))
            $root.OperCmd.encode(message.Command, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerCommandReq message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerCommandReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {IDeskToGameSrvPlayerCommandReq} message DeskToGameSrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerCommandReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerCommandReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerCommandReq} DeskToGameSrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerCommandReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerCommandReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Command = $root.OperCmd.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerCommandReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerCommandReq} DeskToGameSrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerCommandReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerCommandReq message.
     * @function verify
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerCommandReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Command != null && message.hasOwnProperty("Command")) {
            let error = $root.OperCmd.verify(message.Command);
            if (error)
                return "Command." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerCommandReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerCommandReq} DeskToGameSrvPlayerCommandReq
     */
    DeskToGameSrvPlayerCommandReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerCommandReq)
            return object;
        let message = new $root.DeskToGameSrvPlayerCommandReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Command != null) {
            if (typeof object.Command !== "object")
                throw TypeError(".DeskToGameSrvPlayerCommandReq.Command: object expected");
            message.Command = $root.OperCmd.fromObject(object.Command);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerCommandReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {DeskToGameSrvPlayerCommandReq} message DeskToGameSrvPlayerCommandReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerCommandReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Command = null;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Command != null && message.hasOwnProperty("Command"))
            object.Command = $root.OperCmd.toObject(message.Command, options);
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerCommandReq to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerCommandReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerCommandReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerCommandReq
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerCommandReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerCommandReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerCommandReq";
    };

    return DeskToGameSrvPlayerCommandReq;
})();

export const DeskToGameSrvPlayerCommandAck = $root.DeskToGameSrvPlayerCommandAck = (() => {

    /**
     * Properties of a DeskToGameSrvPlayerCommandAck.
     * @exports IDeskToGameSrvPlayerCommandAck
     * @interface IDeskToGameSrvPlayerCommandAck
     * @property {number|null} [Res] DeskToGameSrvPlayerCommandAck Res
     * @property {number|null} [UserID] DeskToGameSrvPlayerCommandAck UserID
     * @property {IOperCmd|null} [Command] DeskToGameSrvPlayerCommandAck Command
     */

    /**
     * Constructs a new DeskToGameSrvPlayerCommandAck.
     * @exports DeskToGameSrvPlayerCommandAck
     * @classdesc Represents a DeskToGameSrvPlayerCommandAck.
     * @implements IDeskToGameSrvPlayerCommandAck
     * @constructor
     * @param {IDeskToGameSrvPlayerCommandAck=} [properties] Properties to set
     */
    function DeskToGameSrvPlayerCommandAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToGameSrvPlayerCommandAck Res.
     * @member {number} Res
     * @memberof DeskToGameSrvPlayerCommandAck
     * @instance
     */
    DeskToGameSrvPlayerCommandAck.prototype.Res = 0;

    /**
     * DeskToGameSrvPlayerCommandAck UserID.
     * @member {number} UserID
     * @memberof DeskToGameSrvPlayerCommandAck
     * @instance
     */
    DeskToGameSrvPlayerCommandAck.prototype.UserID = 0;

    /**
     * DeskToGameSrvPlayerCommandAck Command.
     * @member {IOperCmd|null|undefined} Command
     * @memberof DeskToGameSrvPlayerCommandAck
     * @instance
     */
    DeskToGameSrvPlayerCommandAck.prototype.Command = null;

    /**
     * Creates a new DeskToGameSrvPlayerCommandAck instance using the specified properties.
     * @function create
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {IDeskToGameSrvPlayerCommandAck=} [properties] Properties to set
     * @returns {DeskToGameSrvPlayerCommandAck} DeskToGameSrvPlayerCommandAck instance
     */
    DeskToGameSrvPlayerCommandAck.create = function create(properties) {
        return new DeskToGameSrvPlayerCommandAck(properties);
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerCommandAck message. Does not implicitly {@link DeskToGameSrvPlayerCommandAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {IDeskToGameSrvPlayerCommandAck} message DeskToGameSrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerCommandAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Command != null && Object.hasOwnProperty.call(message, "Command"))
            $root.OperCmd.encode(message.Command, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToGameSrvPlayerCommandAck message, length delimited. Does not implicitly {@link DeskToGameSrvPlayerCommandAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {IDeskToGameSrvPlayerCommandAck} message DeskToGameSrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToGameSrvPlayerCommandAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToGameSrvPlayerCommandAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToGameSrvPlayerCommandAck} DeskToGameSrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerCommandAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToGameSrvPlayerCommandAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Command = $root.OperCmd.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToGameSrvPlayerCommandAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToGameSrvPlayerCommandAck} DeskToGameSrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToGameSrvPlayerCommandAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToGameSrvPlayerCommandAck message.
     * @function verify
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToGameSrvPlayerCommandAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Command != null && message.hasOwnProperty("Command")) {
            let error = $root.OperCmd.verify(message.Command);
            if (error)
                return "Command." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToGameSrvPlayerCommandAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToGameSrvPlayerCommandAck} DeskToGameSrvPlayerCommandAck
     */
    DeskToGameSrvPlayerCommandAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToGameSrvPlayerCommandAck)
            return object;
        let message = new $root.DeskToGameSrvPlayerCommandAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Command != null) {
            if (typeof object.Command !== "object")
                throw TypeError(".DeskToGameSrvPlayerCommandAck.Command: object expected");
            message.Command = $root.OperCmd.fromObject(object.Command);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToGameSrvPlayerCommandAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {DeskToGameSrvPlayerCommandAck} message DeskToGameSrvPlayerCommandAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToGameSrvPlayerCommandAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.Command = null;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Command != null && message.hasOwnProperty("Command"))
            object.Command = $root.OperCmd.toObject(message.Command, options);
        return object;
    };

    /**
     * Converts this DeskToGameSrvPlayerCommandAck to JSON.
     * @function toJSON
     * @memberof DeskToGameSrvPlayerCommandAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToGameSrvPlayerCommandAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToGameSrvPlayerCommandAck
     * @function getTypeUrl
     * @memberof DeskToGameSrvPlayerCommandAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToGameSrvPlayerCommandAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToGameSrvPlayerCommandAck";
    };

    return DeskToGameSrvPlayerCommandAck;
})();

export const GameSrvToDeskPushDealCard = $root.GameSrvToDeskPushDealCard = (() => {

    /**
     * Properties of a GameSrvToDeskPushDealCard.
     * @exports IGameSrvToDeskPushDealCard
     * @interface IGameSrvToDeskPushDealCard
     * @property {number|null} [UserID] GameSrvToDeskPushDealCard UserID
     * @property {Array.<number>|null} [NewCard] GameSrvToDeskPushDealCard NewCard
     */

    /**
     * Constructs a new GameSrvToDeskPushDealCard.
     * @exports GameSrvToDeskPushDealCard
     * @classdesc Represents a GameSrvToDeskPushDealCard.
     * @implements IGameSrvToDeskPushDealCard
     * @constructor
     * @param {IGameSrvToDeskPushDealCard=} [properties] Properties to set
     */
    function GameSrvToDeskPushDealCard(properties) {
        this.NewCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushDealCard UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushDealCard
     * @instance
     */
    GameSrvToDeskPushDealCard.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushDealCard NewCard.
     * @member {Array.<number>} NewCard
     * @memberof GameSrvToDeskPushDealCard
     * @instance
     */
    GameSrvToDeskPushDealCard.prototype.NewCard = $util.emptyArray;

    /**
     * Creates a new GameSrvToDeskPushDealCard instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {IGameSrvToDeskPushDealCard=} [properties] Properties to set
     * @returns {GameSrvToDeskPushDealCard} GameSrvToDeskPushDealCard instance
     */
    GameSrvToDeskPushDealCard.create = function create(properties) {
        return new GameSrvToDeskPushDealCard(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushDealCard message. Does not implicitly {@link GameSrvToDeskPushDealCard.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {IGameSrvToDeskPushDealCard} message GameSrvToDeskPushDealCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushDealCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NewCard != null && message.NewCard.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.NewCard.length; ++i)
                writer.uint32(message.NewCard[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushDealCard message, length delimited. Does not implicitly {@link GameSrvToDeskPushDealCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {IGameSrvToDeskPushDealCard} message GameSrvToDeskPushDealCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushDealCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushDealCard message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushDealCard} GameSrvToDeskPushDealCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushDealCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushDealCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.NewCard && message.NewCard.length))
                        message.NewCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.NewCard.push(reader.uint32());
                    } else
                        message.NewCard.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushDealCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushDealCard} GameSrvToDeskPushDealCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushDealCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushDealCard message.
     * @function verify
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushDealCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewCard != null && message.hasOwnProperty("NewCard")) {
            if (!Array.isArray(message.NewCard))
                return "NewCard: array expected";
            for (let i = 0; i < message.NewCard.length; ++i)
                if (!$util.isInteger(message.NewCard[i]))
                    return "NewCard: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushDealCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushDealCard} GameSrvToDeskPushDealCard
     */
    GameSrvToDeskPushDealCard.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushDealCard)
            return object;
        let message = new $root.GameSrvToDeskPushDealCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewCard) {
            if (!Array.isArray(object.NewCard))
                throw TypeError(".GameSrvToDeskPushDealCard.NewCard: array expected");
            message.NewCard = [];
            for (let i = 0; i < object.NewCard.length; ++i)
                message.NewCard[i] = object.NewCard[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushDealCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {GameSrvToDeskPushDealCard} message GameSrvToDeskPushDealCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushDealCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.NewCard = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewCard && message.NewCard.length) {
            object.NewCard = [];
            for (let j = 0; j < message.NewCard.length; ++j)
                object.NewCard[j] = message.NewCard[j];
        }
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushDealCard to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushDealCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushDealCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushDealCard
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushDealCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushDealCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushDealCard";
    };

    return GameSrvToDeskPushDealCard;
})();

export const PlayerTotalBet = $root.PlayerTotalBet = (() => {

    /**
     * Properties of a PlayerTotalBet.
     * @exports IPlayerTotalBet
     * @interface IPlayerTotalBet
     * @property {number|null} [UserID] PlayerTotalBet UserID
     * @property {string|null} [TotalBetChip] PlayerTotalBet TotalBetChip
     * @property {string|null} [CurBetChip] PlayerTotalBet CurBetChip
     * @property {string|null} [CurEnterChip] PlayerTotalBet CurEnterChip
     */

    /**
     * Constructs a new PlayerTotalBet.
     * @exports PlayerTotalBet
     * @classdesc Represents a PlayerTotalBet.
     * @implements IPlayerTotalBet
     * @constructor
     * @param {IPlayerTotalBet=} [properties] Properties to set
     */
    function PlayerTotalBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerTotalBet UserID.
     * @member {number} UserID
     * @memberof PlayerTotalBet
     * @instance
     */
    PlayerTotalBet.prototype.UserID = 0;

    /**
     * PlayerTotalBet TotalBetChip.
     * @member {string} TotalBetChip
     * @memberof PlayerTotalBet
     * @instance
     */
    PlayerTotalBet.prototype.TotalBetChip = "";

    /**
     * PlayerTotalBet CurBetChip.
     * @member {string} CurBetChip
     * @memberof PlayerTotalBet
     * @instance
     */
    PlayerTotalBet.prototype.CurBetChip = "";

    /**
     * PlayerTotalBet CurEnterChip.
     * @member {string} CurEnterChip
     * @memberof PlayerTotalBet
     * @instance
     */
    PlayerTotalBet.prototype.CurEnterChip = "";

    /**
     * Creates a new PlayerTotalBet instance using the specified properties.
     * @function create
     * @memberof PlayerTotalBet
     * @static
     * @param {IPlayerTotalBet=} [properties] Properties to set
     * @returns {PlayerTotalBet} PlayerTotalBet instance
     */
    PlayerTotalBet.create = function create(properties) {
        return new PlayerTotalBet(properties);
    };

    /**
     * Encodes the specified PlayerTotalBet message. Does not implicitly {@link PlayerTotalBet.verify|verify} messages.
     * @function encode
     * @memberof PlayerTotalBet
     * @static
     * @param {IPlayerTotalBet} message PlayerTotalBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerTotalBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TotalBetChip != null && Object.hasOwnProperty.call(message, "TotalBetChip"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.TotalBetChip);
        if (message.CurBetChip != null && Object.hasOwnProperty.call(message, "CurBetChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.CurBetChip);
        if (message.CurEnterChip != null && Object.hasOwnProperty.call(message, "CurEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.CurEnterChip);
        return writer;
    };

    /**
     * Encodes the specified PlayerTotalBet message, length delimited. Does not implicitly {@link PlayerTotalBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerTotalBet
     * @static
     * @param {IPlayerTotalBet} message PlayerTotalBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerTotalBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerTotalBet message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerTotalBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerTotalBet} PlayerTotalBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerTotalBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerTotalBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TotalBetChip = reader.string();
                    break;
                }
            case 3: {
                    message.CurBetChip = reader.string();
                    break;
                }
            case 4: {
                    message.CurEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerTotalBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerTotalBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerTotalBet} PlayerTotalBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerTotalBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerTotalBet message.
     * @function verify
     * @memberof PlayerTotalBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerTotalBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TotalBetChip != null && message.hasOwnProperty("TotalBetChip"))
            if (!$util.isString(message.TotalBetChip))
                return "TotalBetChip: string expected";
        if (message.CurBetChip != null && message.hasOwnProperty("CurBetChip"))
            if (!$util.isString(message.CurBetChip))
                return "CurBetChip: string expected";
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            if (!$util.isString(message.CurEnterChip))
                return "CurEnterChip: string expected";
        return null;
    };

    /**
     * Creates a PlayerTotalBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerTotalBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerTotalBet} PlayerTotalBet
     */
    PlayerTotalBet.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerTotalBet)
            return object;
        let message = new $root.PlayerTotalBet();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TotalBetChip != null)
            message.TotalBetChip = String(object.TotalBetChip);
        if (object.CurBetChip != null)
            message.CurBetChip = String(object.CurBetChip);
        if (object.CurEnterChip != null)
            message.CurEnterChip = String(object.CurEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a PlayerTotalBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerTotalBet
     * @static
     * @param {PlayerTotalBet} message PlayerTotalBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerTotalBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.TotalBetChip = "";
            object.CurBetChip = "";
            object.CurEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TotalBetChip != null && message.hasOwnProperty("TotalBetChip"))
            object.TotalBetChip = message.TotalBetChip;
        if (message.CurBetChip != null && message.hasOwnProperty("CurBetChip"))
            object.CurBetChip = message.CurBetChip;
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            object.CurEnterChip = message.CurEnterChip;
        return object;
    };

    /**
     * Converts this PlayerTotalBet to JSON.
     * @function toJSON
     * @memberof PlayerTotalBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerTotalBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerTotalBet
     * @function getTypeUrl
     * @memberof PlayerTotalBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerTotalBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerTotalBet";
    };

    return PlayerTotalBet;
})();

export const GameSrvToDeskPushPlayingInfo = $root.GameSrvToDeskPushPlayingInfo = (() => {

    /**
     * Properties of a GameSrvToDeskPushPlayingInfo.
     * @exports IGameSrvToDeskPushPlayingInfo
     * @interface IGameSrvToDeskPushPlayingInfo
     * @property {number|null} [UserID] GameSrvToDeskPushPlayingInfo UserID
     * @property {number|null} [StateID] GameSrvToDeskPushPlayingInfo StateID
     * @property {number|null} [DealerID] GameSrvToDeskPushPlayingInfo DealerID
     * @property {number|null} [SBID] GameSrvToDeskPushPlayingInfo SBID
     * @property {number|null} [BBID] GameSrvToDeskPushPlayingInfo BBID
     * @property {number|null} [Practitioner] GameSrvToDeskPushPlayingInfo Practitioner
     * @property {string|null} [BBChip] GameSrvToDeskPushPlayingInfo BBChip
     * @property {Array.<IPlayerTotalBet>|null} [PlayerBet] GameSrvToDeskPushPlayingInfo PlayerBet
     * @property {Array.<IOperCmdTip>|null} [Operation] GameSrvToDeskPushPlayingInfo Operation
     * @property {IPoolInfo|null} [Pool] GameSrvToDeskPushPlayingInfo Pool
     * @property {Array.<number>|null} [PublicCard] GameSrvToDeskPushPlayingInfo PublicCard
     * @property {Array.<number>|null} [HandCard] GameSrvToDeskPushPlayingInfo HandCard
     * @property {Array.<number>|null} [FoldPlayerIDs] GameSrvToDeskPushPlayingInfo FoldPlayerIDs
     * @property {Array.<number>|null} [AllInPlayerIDs] GameSrvToDeskPushPlayingInfo AllInPlayerIDs
     * @property {Array.<number>|null} [GamingIDs] GameSrvToDeskPushPlayingInfo GamingIDs
     * @property {Array.<number>|null} [WatchingIDs] GameSrvToDeskPushPlayingInfo WatchingIDs
     */

    /**
     * Constructs a new GameSrvToDeskPushPlayingInfo.
     * @exports GameSrvToDeskPushPlayingInfo
     * @classdesc Represents a GameSrvToDeskPushPlayingInfo.
     * @implements IGameSrvToDeskPushPlayingInfo
     * @constructor
     * @param {IGameSrvToDeskPushPlayingInfo=} [properties] Properties to set
     */
    function GameSrvToDeskPushPlayingInfo(properties) {
        this.PlayerBet = [];
        this.Operation = [];
        this.PublicCard = [];
        this.HandCard = [];
        this.FoldPlayerIDs = [];
        this.AllInPlayerIDs = [];
        this.GamingIDs = [];
        this.WatchingIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.StateID = 0;

    /**
     * GameSrvToDeskPushPlayingInfo DealerID.
     * @member {number} DealerID
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.DealerID = 0;

    /**
     * GameSrvToDeskPushPlayingInfo SBID.
     * @member {number} SBID
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.SBID = 0;

    /**
     * GameSrvToDeskPushPlayingInfo BBID.
     * @member {number} BBID
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.BBID = 0;

    /**
     * GameSrvToDeskPushPlayingInfo Practitioner.
     * @member {number} Practitioner
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.Practitioner = 0;

    /**
     * GameSrvToDeskPushPlayingInfo BBChip.
     * @member {string} BBChip
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.BBChip = "";

    /**
     * GameSrvToDeskPushPlayingInfo PlayerBet.
     * @member {Array.<IPlayerTotalBet>} PlayerBet
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.PlayerBet = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo Operation.
     * @member {Array.<IOperCmdTip>} Operation
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.Operation = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo Pool.
     * @member {IPoolInfo|null|undefined} Pool
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.Pool = null;

    /**
     * GameSrvToDeskPushPlayingInfo PublicCard.
     * @member {Array.<number>} PublicCard
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.PublicCard = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo HandCard.
     * @member {Array.<number>} HandCard
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.HandCard = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo FoldPlayerIDs.
     * @member {Array.<number>} FoldPlayerIDs
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.FoldPlayerIDs = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo AllInPlayerIDs.
     * @member {Array.<number>} AllInPlayerIDs
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.AllInPlayerIDs = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * GameSrvToDeskPushPlayingInfo WatchingIDs.
     * @member {Array.<number>} WatchingIDs
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     */
    GameSrvToDeskPushPlayingInfo.prototype.WatchingIDs = $util.emptyArray;

    /**
     * Creates a new GameSrvToDeskPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {IGameSrvToDeskPushPlayingInfo=} [properties] Properties to set
     * @returns {GameSrvToDeskPushPlayingInfo} GameSrvToDeskPushPlayingInfo instance
     */
    GameSrvToDeskPushPlayingInfo.create = function create(properties) {
        return new GameSrvToDeskPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushPlayingInfo message. Does not implicitly {@link GameSrvToDeskPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {IGameSrvToDeskPushPlayingInfo} message GameSrvToDeskPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DealerID);
        if (message.SBID != null && Object.hasOwnProperty.call(message, "SBID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SBID);
        if (message.BBID != null && Object.hasOwnProperty.call(message, "BBID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BBID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Practitioner);
        if (message.BBChip != null && Object.hasOwnProperty.call(message, "BBChip"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.BBChip);
        if (message.PlayerBet != null && message.PlayerBet.length)
            for (let i = 0; i < message.PlayerBet.length; ++i)
                $root.PlayerTotalBet.encode(message.PlayerBet[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.Operation != null && message.Operation.length)
            for (let i = 0; i < message.Operation.length; ++i)
                $root.OperCmdTip.encode(message.Operation[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.Pool != null && Object.hasOwnProperty.call(message, "Pool"))
            $root.PoolInfo.encode(message.Pool, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.PublicCard != null && message.PublicCard.length) {
            writer.uint32(/* id 11, wireType 2 =*/90).fork();
            for (let i = 0; i < message.PublicCard.length; ++i)
                writer.uint32(message.PublicCard[i]);
            writer.ldelim();
        }
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 12, wireType 2 =*/98).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        if (message.FoldPlayerIDs != null && message.FoldPlayerIDs.length) {
            writer.uint32(/* id 13, wireType 2 =*/106).fork();
            for (let i = 0; i < message.FoldPlayerIDs.length; ++i)
                writer.uint32(message.FoldPlayerIDs[i]);
            writer.ldelim();
        }
        if (message.AllInPlayerIDs != null && message.AllInPlayerIDs.length) {
            writer.uint32(/* id 14, wireType 2 =*/114).fork();
            for (let i = 0; i < message.AllInPlayerIDs.length; ++i)
                writer.uint32(message.AllInPlayerIDs[i]);
            writer.ldelim();
        }
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 15, wireType 2 =*/122).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.WatchingIDs != null && message.WatchingIDs.length) {
            writer.uint32(/* id 16, wireType 2 =*/130).fork();
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                writer.uint32(message.WatchingIDs[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushPlayingInfo message, length delimited. Does not implicitly {@link GameSrvToDeskPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {IGameSrvToDeskPushPlayingInfo} message GameSrvToDeskPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushPlayingInfo} GameSrvToDeskPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SBID = reader.uint32();
                    break;
                }
            case 5: {
                    message.BBID = reader.uint32();
                    break;
                }
            case 6: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 7: {
                    message.BBChip = reader.string();
                    break;
                }
            case 8: {
                    if (!(message.PlayerBet && message.PlayerBet.length))
                        message.PlayerBet = [];
                    message.PlayerBet.push($root.PlayerTotalBet.decode(reader, reader.uint32()));
                    break;
                }
            case 9: {
                    if (!(message.Operation && message.Operation.length))
                        message.Operation = [];
                    message.Operation.push($root.OperCmdTip.decode(reader, reader.uint32()));
                    break;
                }
            case 10: {
                    message.Pool = $root.PoolInfo.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    if (!(message.PublicCard && message.PublicCard.length))
                        message.PublicCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PublicCard.push(reader.uint32());
                    } else
                        message.PublicCard.push(reader.uint32());
                    break;
                }
            case 12: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            case 13: {
                    if (!(message.FoldPlayerIDs && message.FoldPlayerIDs.length))
                        message.FoldPlayerIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.FoldPlayerIDs.push(reader.uint32());
                    } else
                        message.FoldPlayerIDs.push(reader.uint32());
                    break;
                }
            case 14: {
                    if (!(message.AllInPlayerIDs && message.AllInPlayerIDs.length))
                        message.AllInPlayerIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AllInPlayerIDs.push(reader.uint32());
                    } else
                        message.AllInPlayerIDs.push(reader.uint32());
                    break;
                }
            case 15: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 16: {
                    if (!(message.WatchingIDs && message.WatchingIDs.length))
                        message.WatchingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.WatchingIDs.push(reader.uint32());
                    } else
                        message.WatchingIDs.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushPlayingInfo} GameSrvToDeskPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushPlayingInfo message.
     * @function verify
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.SBID != null && message.hasOwnProperty("SBID"))
            if (!$util.isInteger(message.SBID))
                return "SBID: integer expected";
        if (message.BBID != null && message.hasOwnProperty("BBID"))
            if (!$util.isInteger(message.BBID))
                return "BBID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.BBChip != null && message.hasOwnProperty("BBChip"))
            if (!$util.isString(message.BBChip))
                return "BBChip: string expected";
        if (message.PlayerBet != null && message.hasOwnProperty("PlayerBet")) {
            if (!Array.isArray(message.PlayerBet))
                return "PlayerBet: array expected";
            for (let i = 0; i < message.PlayerBet.length; ++i) {
                let error = $root.PlayerTotalBet.verify(message.PlayerBet[i]);
                if (error)
                    return "PlayerBet." + error;
            }
        }
        if (message.Operation != null && message.hasOwnProperty("Operation")) {
            if (!Array.isArray(message.Operation))
                return "Operation: array expected";
            for (let i = 0; i < message.Operation.length; ++i) {
                let error = $root.OperCmdTip.verify(message.Operation[i]);
                if (error)
                    return "Operation." + error;
            }
        }
        if (message.Pool != null && message.hasOwnProperty("Pool")) {
            let error = $root.PoolInfo.verify(message.Pool);
            if (error)
                return "Pool." + error;
        }
        if (message.PublicCard != null && message.hasOwnProperty("PublicCard")) {
            if (!Array.isArray(message.PublicCard))
                return "PublicCard: array expected";
            for (let i = 0; i < message.PublicCard.length; ++i)
                if (!$util.isInteger(message.PublicCard[i]))
                    return "PublicCard: integer[] expected";
        }
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        if (message.FoldPlayerIDs != null && message.hasOwnProperty("FoldPlayerIDs")) {
            if (!Array.isArray(message.FoldPlayerIDs))
                return "FoldPlayerIDs: array expected";
            for (let i = 0; i < message.FoldPlayerIDs.length; ++i)
                if (!$util.isInteger(message.FoldPlayerIDs[i]))
                    return "FoldPlayerIDs: integer[] expected";
        }
        if (message.AllInPlayerIDs != null && message.hasOwnProperty("AllInPlayerIDs")) {
            if (!Array.isArray(message.AllInPlayerIDs))
                return "AllInPlayerIDs: array expected";
            for (let i = 0; i < message.AllInPlayerIDs.length; ++i)
                if (!$util.isInteger(message.AllInPlayerIDs[i]))
                    return "AllInPlayerIDs: integer[] expected";
        }
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.WatchingIDs != null && message.hasOwnProperty("WatchingIDs")) {
            if (!Array.isArray(message.WatchingIDs))
                return "WatchingIDs: array expected";
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                if (!$util.isInteger(message.WatchingIDs[i]))
                    return "WatchingIDs: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushPlayingInfo} GameSrvToDeskPushPlayingInfo
     */
    GameSrvToDeskPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushPlayingInfo)
            return object;
        let message = new $root.GameSrvToDeskPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.SBID != null)
            message.SBID = object.SBID >>> 0;
        if (object.BBID != null)
            message.BBID = object.BBID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.BBChip != null)
            message.BBChip = String(object.BBChip);
        if (object.PlayerBet) {
            if (!Array.isArray(object.PlayerBet))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.PlayerBet: array expected");
            message.PlayerBet = [];
            for (let i = 0; i < object.PlayerBet.length; ++i) {
                if (typeof object.PlayerBet[i] !== "object")
                    throw TypeError(".GameSrvToDeskPushPlayingInfo.PlayerBet: object expected");
                message.PlayerBet[i] = $root.PlayerTotalBet.fromObject(object.PlayerBet[i]);
            }
        }
        if (object.Operation) {
            if (!Array.isArray(object.Operation))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.Operation: array expected");
            message.Operation = [];
            for (let i = 0; i < object.Operation.length; ++i) {
                if (typeof object.Operation[i] !== "object")
                    throw TypeError(".GameSrvToDeskPushPlayingInfo.Operation: object expected");
                message.Operation[i] = $root.OperCmdTip.fromObject(object.Operation[i]);
            }
        }
        if (object.Pool != null) {
            if (typeof object.Pool !== "object")
                throw TypeError(".GameSrvToDeskPushPlayingInfo.Pool: object expected");
            message.Pool = $root.PoolInfo.fromObject(object.Pool);
        }
        if (object.PublicCard) {
            if (!Array.isArray(object.PublicCard))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.PublicCard: array expected");
            message.PublicCard = [];
            for (let i = 0; i < object.PublicCard.length; ++i)
                message.PublicCard[i] = object.PublicCard[i] >>> 0;
        }
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        if (object.FoldPlayerIDs) {
            if (!Array.isArray(object.FoldPlayerIDs))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.FoldPlayerIDs: array expected");
            message.FoldPlayerIDs = [];
            for (let i = 0; i < object.FoldPlayerIDs.length; ++i)
                message.FoldPlayerIDs[i] = object.FoldPlayerIDs[i] >>> 0;
        }
        if (object.AllInPlayerIDs) {
            if (!Array.isArray(object.AllInPlayerIDs))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.AllInPlayerIDs: array expected");
            message.AllInPlayerIDs = [];
            for (let i = 0; i < object.AllInPlayerIDs.length; ++i)
                message.AllInPlayerIDs[i] = object.AllInPlayerIDs[i] >>> 0;
        }
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.WatchingIDs) {
            if (!Array.isArray(object.WatchingIDs))
                throw TypeError(".GameSrvToDeskPushPlayingInfo.WatchingIDs: array expected");
            message.WatchingIDs = [];
            for (let i = 0; i < object.WatchingIDs.length; ++i)
                message.WatchingIDs[i] = object.WatchingIDs[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {GameSrvToDeskPushPlayingInfo} message GameSrvToDeskPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.PlayerBet = [];
            object.Operation = [];
            object.PublicCard = [];
            object.HandCard = [];
            object.FoldPlayerIDs = [];
            object.AllInPlayerIDs = [];
            object.GamingIDs = [];
            object.WatchingIDs = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.DealerID = 0;
            object.SBID = 0;
            object.BBID = 0;
            object.Practitioner = 0;
            object.BBChip = "";
            object.Pool = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.SBID != null && message.hasOwnProperty("SBID"))
            object.SBID = message.SBID;
        if (message.BBID != null && message.hasOwnProperty("BBID"))
            object.BBID = message.BBID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.BBChip != null && message.hasOwnProperty("BBChip"))
            object.BBChip = message.BBChip;
        if (message.PlayerBet && message.PlayerBet.length) {
            object.PlayerBet = [];
            for (let j = 0; j < message.PlayerBet.length; ++j)
                object.PlayerBet[j] = $root.PlayerTotalBet.toObject(message.PlayerBet[j], options);
        }
        if (message.Operation && message.Operation.length) {
            object.Operation = [];
            for (let j = 0; j < message.Operation.length; ++j)
                object.Operation[j] = $root.OperCmdTip.toObject(message.Operation[j], options);
        }
        if (message.Pool != null && message.hasOwnProperty("Pool"))
            object.Pool = $root.PoolInfo.toObject(message.Pool, options);
        if (message.PublicCard && message.PublicCard.length) {
            object.PublicCard = [];
            for (let j = 0; j < message.PublicCard.length; ++j)
                object.PublicCard[j] = message.PublicCard[j];
        }
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        if (message.FoldPlayerIDs && message.FoldPlayerIDs.length) {
            object.FoldPlayerIDs = [];
            for (let j = 0; j < message.FoldPlayerIDs.length; ++j)
                object.FoldPlayerIDs[j] = message.FoldPlayerIDs[j];
        }
        if (message.AllInPlayerIDs && message.AllInPlayerIDs.length) {
            object.AllInPlayerIDs = [];
            for (let j = 0; j < message.AllInPlayerIDs.length; ++j)
                object.AllInPlayerIDs[j] = message.AllInPlayerIDs[j];
        }
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.WatchingIDs && message.WatchingIDs.length) {
            object.WatchingIDs = [];
            for (let j = 0; j < message.WatchingIDs.length; ++j)
                object.WatchingIDs[j] = message.WatchingIDs[j];
        }
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushPlayingInfo
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushPlayingInfo";
    };

    return GameSrvToDeskPushPlayingInfo;
})();

export const PlayerCardResult = $root.PlayerCardResult = (() => {

    /**
     * Properties of a PlayerCardResult.
     * @exports IPlayerCardResult
     * @interface IPlayerCardResult
     * @property {number|null} [UserID] PlayerCardResult UserID
     * @property {number|null} [CardType] PlayerCardResult CardType
     * @property {Array.<number>|null} [Combination] PlayerCardResult Combination
     * @property {Array.<number>|null} [HandCard] PlayerCardResult HandCard
     */

    /**
     * Constructs a new PlayerCardResult.
     * @exports PlayerCardResult
     * @classdesc Represents a PlayerCardResult.
     * @implements IPlayerCardResult
     * @constructor
     * @param {IPlayerCardResult=} [properties] Properties to set
     */
    function PlayerCardResult(properties) {
        this.Combination = [];
        this.HandCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerCardResult UserID.
     * @member {number} UserID
     * @memberof PlayerCardResult
     * @instance
     */
    PlayerCardResult.prototype.UserID = 0;

    /**
     * PlayerCardResult CardType.
     * @member {number} CardType
     * @memberof PlayerCardResult
     * @instance
     */
    PlayerCardResult.prototype.CardType = 0;

    /**
     * PlayerCardResult Combination.
     * @member {Array.<number>} Combination
     * @memberof PlayerCardResult
     * @instance
     */
    PlayerCardResult.prototype.Combination = $util.emptyArray;

    /**
     * PlayerCardResult HandCard.
     * @member {Array.<number>} HandCard
     * @memberof PlayerCardResult
     * @instance
     */
    PlayerCardResult.prototype.HandCard = $util.emptyArray;

    /**
     * Creates a new PlayerCardResult instance using the specified properties.
     * @function create
     * @memberof PlayerCardResult
     * @static
     * @param {IPlayerCardResult=} [properties] Properties to set
     * @returns {PlayerCardResult} PlayerCardResult instance
     */
    PlayerCardResult.create = function create(properties) {
        return new PlayerCardResult(properties);
    };

    /**
     * Encodes the specified PlayerCardResult message. Does not implicitly {@link PlayerCardResult.verify|verify} messages.
     * @function encode
     * @memberof PlayerCardResult
     * @static
     * @param {IPlayerCardResult} message PlayerCardResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerCardResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CardType);
        if (message.Combination != null && message.Combination.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.Combination.length; ++i)
                writer.uint32(message.Combination[i]);
            writer.ldelim();
        }
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified PlayerCardResult message, length delimited. Does not implicitly {@link PlayerCardResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerCardResult
     * @static
     * @param {IPlayerCardResult} message PlayerCardResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerCardResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerCardResult message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerCardResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerCardResult} PlayerCardResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerCardResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerCardResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Combination && message.Combination.length))
                        message.Combination = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Combination.push(reader.uint32());
                    } else
                        message.Combination.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerCardResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerCardResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerCardResult} PlayerCardResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerCardResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerCardResult message.
     * @function verify
     * @memberof PlayerCardResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerCardResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.Combination != null && message.hasOwnProperty("Combination")) {
            if (!Array.isArray(message.Combination))
                return "Combination: array expected";
            for (let i = 0; i < message.Combination.length; ++i)
                if (!$util.isInteger(message.Combination[i]))
                    return "Combination: integer[] expected";
        }
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a PlayerCardResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerCardResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerCardResult} PlayerCardResult
     */
    PlayerCardResult.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerCardResult)
            return object;
        let message = new $root.PlayerCardResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.Combination) {
            if (!Array.isArray(object.Combination))
                throw TypeError(".PlayerCardResult.Combination: array expected");
            message.Combination = [];
            for (let i = 0; i < object.Combination.length; ++i)
                message.Combination[i] = object.Combination[i] >>> 0;
        }
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".PlayerCardResult.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a PlayerCardResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerCardResult
     * @static
     * @param {PlayerCardResult} message PlayerCardResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerCardResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.Combination = [];
            object.HandCard = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.CardType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.Combination && message.Combination.length) {
            object.Combination = [];
            for (let j = 0; j < message.Combination.length; ++j)
                object.Combination[j] = message.Combination[j];
        }
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        return object;
    };

    /**
     * Converts this PlayerCardResult to JSON.
     * @function toJSON
     * @memberof PlayerCardResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerCardResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerCardResult
     * @function getTypeUrl
     * @memberof PlayerCardResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerCardResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerCardResult";
    };

    return PlayerCardResult;
})();

export const WinDetail = $root.WinDetail = (() => {

    /**
     * Properties of a WinDetail.
     * @exports IWinDetail
     * @interface IWinDetail
     * @property {number|null} [PoolIndex] WinDetail PoolIndex
     * @property {string|null} [Count] WinDetail Count
     */

    /**
     * Constructs a new WinDetail.
     * @exports WinDetail
     * @classdesc Represents a WinDetail.
     * @implements IWinDetail
     * @constructor
     * @param {IWinDetail=} [properties] Properties to set
     */
    function WinDetail(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WinDetail PoolIndex.
     * @member {number} PoolIndex
     * @memberof WinDetail
     * @instance
     */
    WinDetail.prototype.PoolIndex = 0;

    /**
     * WinDetail Count.
     * @member {string} Count
     * @memberof WinDetail
     * @instance
     */
    WinDetail.prototype.Count = "";

    /**
     * Creates a new WinDetail instance using the specified properties.
     * @function create
     * @memberof WinDetail
     * @static
     * @param {IWinDetail=} [properties] Properties to set
     * @returns {WinDetail} WinDetail instance
     */
    WinDetail.create = function create(properties) {
        return new WinDetail(properties);
    };

    /**
     * Encodes the specified WinDetail message. Does not implicitly {@link WinDetail.verify|verify} messages.
     * @function encode
     * @memberof WinDetail
     * @static
     * @param {IWinDetail} message WinDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WinDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PoolIndex != null && Object.hasOwnProperty.call(message, "PoolIndex"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.PoolIndex);
        if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Count);
        return writer;
    };

    /**
     * Encodes the specified WinDetail message, length delimited. Does not implicitly {@link WinDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WinDetail
     * @static
     * @param {IWinDetail} message WinDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WinDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WinDetail message from the specified reader or buffer.
     * @function decode
     * @memberof WinDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WinDetail} WinDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WinDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WinDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PoolIndex = reader.int32();
                    break;
                }
            case 2: {
                    message.Count = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WinDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WinDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WinDetail} WinDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WinDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WinDetail message.
     * @function verify
     * @memberof WinDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WinDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PoolIndex != null && message.hasOwnProperty("PoolIndex"))
            if (!$util.isInteger(message.PoolIndex))
                return "PoolIndex: integer expected";
        if (message.Count != null && message.hasOwnProperty("Count"))
            if (!$util.isString(message.Count))
                return "Count: string expected";
        return null;
    };

    /**
     * Creates a WinDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WinDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WinDetail} WinDetail
     */
    WinDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.WinDetail)
            return object;
        let message = new $root.WinDetail();
        if (object.PoolIndex != null)
            message.PoolIndex = object.PoolIndex | 0;
        if (object.Count != null)
            message.Count = String(object.Count);
        return message;
    };

    /**
     * Creates a plain object from a WinDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WinDetail
     * @static
     * @param {WinDetail} message WinDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WinDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PoolIndex = 0;
            object.Count = "";
        }
        if (message.PoolIndex != null && message.hasOwnProperty("PoolIndex"))
            object.PoolIndex = message.PoolIndex;
        if (message.Count != null && message.hasOwnProperty("Count"))
            object.Count = message.Count;
        return object;
    };

    /**
     * Converts this WinDetail to JSON.
     * @function toJSON
     * @memberof WinDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WinDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WinDetail
     * @function getTypeUrl
     * @memberof WinDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WinDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WinDetail";
    };

    return WinDetail;
})();

export const PlayerGoldResult = $root.PlayerGoldResult = (() => {

    /**
     * Properties of a PlayerGoldResult.
     * @exports IPlayerGoldResult
     * @interface IPlayerGoldResult
     * @property {number|null} [UserID] PlayerGoldResult UserID
     * @property {string|null} [WinGold] PlayerGoldResult WinGold
     * @property {string|null} [ChangeGold] PlayerGoldResult ChangeGold
     * @property {string|null} [TotalEnterChip] PlayerGoldResult TotalEnterChip
     * @property {Array.<IWinDetail>|null} [Detail] PlayerGoldResult Detail
     */

    /**
     * Constructs a new PlayerGoldResult.
     * @exports PlayerGoldResult
     * @classdesc Represents a PlayerGoldResult.
     * @implements IPlayerGoldResult
     * @constructor
     * @param {IPlayerGoldResult=} [properties] Properties to set
     */
    function PlayerGoldResult(properties) {
        this.Detail = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerGoldResult UserID.
     * @member {number} UserID
     * @memberof PlayerGoldResult
     * @instance
     */
    PlayerGoldResult.prototype.UserID = 0;

    /**
     * PlayerGoldResult WinGold.
     * @member {string} WinGold
     * @memberof PlayerGoldResult
     * @instance
     */
    PlayerGoldResult.prototype.WinGold = "";

    /**
     * PlayerGoldResult ChangeGold.
     * @member {string} ChangeGold
     * @memberof PlayerGoldResult
     * @instance
     */
    PlayerGoldResult.prototype.ChangeGold = "";

    /**
     * PlayerGoldResult TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof PlayerGoldResult
     * @instance
     */
    PlayerGoldResult.prototype.TotalEnterChip = "";

    /**
     * PlayerGoldResult Detail.
     * @member {Array.<IWinDetail>} Detail
     * @memberof PlayerGoldResult
     * @instance
     */
    PlayerGoldResult.prototype.Detail = $util.emptyArray;

    /**
     * Creates a new PlayerGoldResult instance using the specified properties.
     * @function create
     * @memberof PlayerGoldResult
     * @static
     * @param {IPlayerGoldResult=} [properties] Properties to set
     * @returns {PlayerGoldResult} PlayerGoldResult instance
     */
    PlayerGoldResult.create = function create(properties) {
        return new PlayerGoldResult(properties);
    };

    /**
     * Encodes the specified PlayerGoldResult message. Does not implicitly {@link PlayerGoldResult.verify|verify} messages.
     * @function encode
     * @memberof PlayerGoldResult
     * @static
     * @param {IPlayerGoldResult} message PlayerGoldResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerGoldResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.WinGold);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        if (message.Detail != null && message.Detail.length)
            for (let i = 0; i < message.Detail.length; ++i)
                $root.WinDetail.encode(message.Detail[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PlayerGoldResult message, length delimited. Does not implicitly {@link PlayerGoldResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerGoldResult
     * @static
     * @param {IPlayerGoldResult} message PlayerGoldResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerGoldResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerGoldResult message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerGoldResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerGoldResult} PlayerGoldResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerGoldResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerGoldResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinGold = reader.string();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.Detail && message.Detail.length))
                        message.Detail = [];
                    message.Detail.push($root.WinDetail.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerGoldResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerGoldResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerGoldResult} PlayerGoldResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerGoldResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerGoldResult message.
     * @function verify
     * @memberof PlayerGoldResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerGoldResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isString(message.WinGold))
                return "WinGold: string expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        if (message.Detail != null && message.hasOwnProperty("Detail")) {
            if (!Array.isArray(message.Detail))
                return "Detail: array expected";
            for (let i = 0; i < message.Detail.length; ++i) {
                let error = $root.WinDetail.verify(message.Detail[i]);
                if (error)
                    return "Detail." + error;
            }
        }
        return null;
    };

    /**
     * Creates a PlayerGoldResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerGoldResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerGoldResult} PlayerGoldResult
     */
    PlayerGoldResult.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerGoldResult)
            return object;
        let message = new $root.PlayerGoldResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinGold != null)
            message.WinGold = String(object.WinGold);
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        if (object.Detail) {
            if (!Array.isArray(object.Detail))
                throw TypeError(".PlayerGoldResult.Detail: array expected");
            message.Detail = [];
            for (let i = 0; i < object.Detail.length; ++i) {
                if (typeof object.Detail[i] !== "object")
                    throw TypeError(".PlayerGoldResult.Detail: object expected");
                message.Detail[i] = $root.WinDetail.fromObject(object.Detail[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a PlayerGoldResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerGoldResult
     * @static
     * @param {PlayerGoldResult} message PlayerGoldResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerGoldResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Detail = [];
        if (options.defaults) {
            object.UserID = 0;
            object.WinGold = "";
            object.ChangeGold = "";
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        if (message.Detail && message.Detail.length) {
            object.Detail = [];
            for (let j = 0; j < message.Detail.length; ++j)
                object.Detail[j] = $root.WinDetail.toObject(message.Detail[j], options);
        }
        return object;
    };

    /**
     * Converts this PlayerGoldResult to JSON.
     * @function toJSON
     * @memberof PlayerGoldResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerGoldResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerGoldResult
     * @function getTypeUrl
     * @memberof PlayerGoldResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerGoldResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerGoldResult";
    };

    return PlayerGoldResult;
})();

export const GameSrvToDeskPushGameResult = $root.GameSrvToDeskPushGameResult = (() => {

    /**
     * Properties of a GameSrvToDeskPushGameResult.
     * @exports IGameSrvToDeskPushGameResult
     * @interface IGameSrvToDeskPushGameResult
     * @property {number|null} [UserID] GameSrvToDeskPushGameResult UserID
     * @property {IPoolInfo|null} [Pool] GameSrvToDeskPushGameResult Pool
     * @property {Array.<IPlayerGoldResult>|null} [GoldResult] GameSrvToDeskPushGameResult GoldResult
     * @property {Array.<IPlayerCardResult>|null} [CardResult] GameSrvToDeskPushGameResult CardResult
     */

    /**
     * Constructs a new GameSrvToDeskPushGameResult.
     * @exports GameSrvToDeskPushGameResult
     * @classdesc Represents a GameSrvToDeskPushGameResult.
     * @implements IGameSrvToDeskPushGameResult
     * @constructor
     * @param {IGameSrvToDeskPushGameResult=} [properties] Properties to set
     */
    function GameSrvToDeskPushGameResult(properties) {
        this.GoldResult = [];
        this.CardResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushGameResult UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushGameResult
     * @instance
     */
    GameSrvToDeskPushGameResult.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushGameResult Pool.
     * @member {IPoolInfo|null|undefined} Pool
     * @memberof GameSrvToDeskPushGameResult
     * @instance
     */
    GameSrvToDeskPushGameResult.prototype.Pool = null;

    /**
     * GameSrvToDeskPushGameResult GoldResult.
     * @member {Array.<IPlayerGoldResult>} GoldResult
     * @memberof GameSrvToDeskPushGameResult
     * @instance
     */
    GameSrvToDeskPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * GameSrvToDeskPushGameResult CardResult.
     * @member {Array.<IPlayerCardResult>} CardResult
     * @memberof GameSrvToDeskPushGameResult
     * @instance
     */
    GameSrvToDeskPushGameResult.prototype.CardResult = $util.emptyArray;

    /**
     * Creates a new GameSrvToDeskPushGameResult instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {IGameSrvToDeskPushGameResult=} [properties] Properties to set
     * @returns {GameSrvToDeskPushGameResult} GameSrvToDeskPushGameResult instance
     */
    GameSrvToDeskPushGameResult.create = function create(properties) {
        return new GameSrvToDeskPushGameResult(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushGameResult message. Does not implicitly {@link GameSrvToDeskPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {IGameSrvToDeskPushGameResult} message GameSrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Pool != null && Object.hasOwnProperty.call(message, "Pool"))
            $root.PoolInfo.encode(message.Pool, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.PlayerGoldResult.encode(message.GoldResult[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.CardResult != null && message.CardResult.length)
            for (let i = 0; i < message.CardResult.length; ++i)
                $root.PlayerCardResult.encode(message.CardResult[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushGameResult message, length delimited. Does not implicitly {@link GameSrvToDeskPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {IGameSrvToDeskPushGameResult} message GameSrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushGameResult} GameSrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Pool = $root.PoolInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.PlayerGoldResult.decode(reader, reader.uint32()));
                    break;
                }
            case 4: {
                    if (!(message.CardResult && message.CardResult.length))
                        message.CardResult = [];
                    message.CardResult.push($root.PlayerCardResult.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushGameResult} GameSrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushGameResult message.
     * @function verify
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Pool != null && message.hasOwnProperty("Pool")) {
            let error = $root.PoolInfo.verify(message.Pool);
            if (error)
                return "Pool." + error;
        }
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.PlayerGoldResult.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult")) {
            if (!Array.isArray(message.CardResult))
                return "CardResult: array expected";
            for (let i = 0; i < message.CardResult.length; ++i) {
                let error = $root.PlayerCardResult.verify(message.CardResult[i]);
                if (error)
                    return "CardResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushGameResult} GameSrvToDeskPushGameResult
     */
    GameSrvToDeskPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushGameResult)
            return object;
        let message = new $root.GameSrvToDeskPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Pool != null) {
            if (typeof object.Pool !== "object")
                throw TypeError(".GameSrvToDeskPushGameResult.Pool: object expected");
            message.Pool = $root.PoolInfo.fromObject(object.Pool);
        }
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".GameSrvToDeskPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".GameSrvToDeskPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.PlayerGoldResult.fromObject(object.GoldResult[i]);
            }
        }
        if (object.CardResult) {
            if (!Array.isArray(object.CardResult))
                throw TypeError(".GameSrvToDeskPushGameResult.CardResult: array expected");
            message.CardResult = [];
            for (let i = 0; i < object.CardResult.length; ++i) {
                if (typeof object.CardResult[i] !== "object")
                    throw TypeError(".GameSrvToDeskPushGameResult.CardResult: object expected");
                message.CardResult[i] = $root.PlayerCardResult.fromObject(object.CardResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {GameSrvToDeskPushGameResult} message GameSrvToDeskPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GoldResult = [];
            object.CardResult = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.Pool = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Pool != null && message.hasOwnProperty("Pool"))
            object.Pool = $root.PoolInfo.toObject(message.Pool, options);
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.PlayerGoldResult.toObject(message.GoldResult[j], options);
        }
        if (message.CardResult && message.CardResult.length) {
            object.CardResult = [];
            for (let j = 0; j < message.CardResult.length; ++j)
                object.CardResult[j] = $root.PlayerCardResult.toObject(message.CardResult[j], options);
        }
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushGameResult to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushGameResult
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushGameResult";
    };

    return GameSrvToDeskPushGameResult;
})();

export const GameSrvToDeskPushKickPlayer = $root.GameSrvToDeskPushKickPlayer = (() => {

    /**
     * Properties of a GameSrvToDeskPushKickPlayer.
     * @exports IGameSrvToDeskPushKickPlayer
     * @interface IGameSrvToDeskPushKickPlayer
     * @property {number|null} [UserID] GameSrvToDeskPushKickPlayer UserID
     * @property {number|null} [Reason] GameSrvToDeskPushKickPlayer Reason
     */

    /**
     * Constructs a new GameSrvToDeskPushKickPlayer.
     * @exports GameSrvToDeskPushKickPlayer
     * @classdesc Represents a GameSrvToDeskPushKickPlayer.
     * @implements IGameSrvToDeskPushKickPlayer
     * @constructor
     * @param {IGameSrvToDeskPushKickPlayer=} [properties] Properties to set
     */
    function GameSrvToDeskPushKickPlayer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameSrvToDeskPushKickPlayer UserID.
     * @member {number} UserID
     * @memberof GameSrvToDeskPushKickPlayer
     * @instance
     */
    GameSrvToDeskPushKickPlayer.prototype.UserID = 0;

    /**
     * GameSrvToDeskPushKickPlayer Reason.
     * @member {number} Reason
     * @memberof GameSrvToDeskPushKickPlayer
     * @instance
     */
    GameSrvToDeskPushKickPlayer.prototype.Reason = 0;

    /**
     * Creates a new GameSrvToDeskPushKickPlayer instance using the specified properties.
     * @function create
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {IGameSrvToDeskPushKickPlayer=} [properties] Properties to set
     * @returns {GameSrvToDeskPushKickPlayer} GameSrvToDeskPushKickPlayer instance
     */
    GameSrvToDeskPushKickPlayer.create = function create(properties) {
        return new GameSrvToDeskPushKickPlayer(properties);
    };

    /**
     * Encodes the specified GameSrvToDeskPushKickPlayer message. Does not implicitly {@link GameSrvToDeskPushKickPlayer.verify|verify} messages.
     * @function encode
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {IGameSrvToDeskPushKickPlayer} message GameSrvToDeskPushKickPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushKickPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified GameSrvToDeskPushKickPlayer message, length delimited. Does not implicitly {@link GameSrvToDeskPushKickPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {IGameSrvToDeskPushKickPlayer} message GameSrvToDeskPushKickPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameSrvToDeskPushKickPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameSrvToDeskPushKickPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameSrvToDeskPushKickPlayer} GameSrvToDeskPushKickPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushKickPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameSrvToDeskPushKickPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Reason = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameSrvToDeskPushKickPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameSrvToDeskPushKickPlayer} GameSrvToDeskPushKickPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameSrvToDeskPushKickPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameSrvToDeskPushKickPlayer message.
     * @function verify
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameSrvToDeskPushKickPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        return null;
    };

    /**
     * Creates a GameSrvToDeskPushKickPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameSrvToDeskPushKickPlayer} GameSrvToDeskPushKickPlayer
     */
    GameSrvToDeskPushKickPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.GameSrvToDeskPushKickPlayer)
            return object;
        let message = new $root.GameSrvToDeskPushKickPlayer();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Reason != null)
            message.Reason = object.Reason >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a GameSrvToDeskPushKickPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {GameSrvToDeskPushKickPlayer} message GameSrvToDeskPushKickPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameSrvToDeskPushKickPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Reason = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this GameSrvToDeskPushKickPlayer to JSON.
     * @function toJSON
     * @memberof GameSrvToDeskPushKickPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameSrvToDeskPushKickPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameSrvToDeskPushKickPlayer
     * @function getTypeUrl
     * @memberof GameSrvToDeskPushKickPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameSrvToDeskPushKickPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameSrvToDeskPushKickPlayer";
    };

    /**
     * KickReason enum.
     * @name GameSrvToDeskPushKickPlayer.KickReason
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} SYSTEM_MAINTEN=1 SYSTEM_MAINTEN value
     * @property {number} GOLD_LACK=2 GOLD_LACK value
     * @property {number} BREAKED=3 BREAKED value
     * @property {number} DONT_NEED_ROBOT=4 DONT_NEED_ROBOT value
     */
    GameSrvToDeskPushKickPlayer.KickReason = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "SYSTEM_MAINTEN"] = 1;
        values[valuesById[2] = "GOLD_LACK"] = 2;
        values[valuesById[3] = "BREAKED"] = 3;
        values[valuesById[4] = "DONT_NEED_ROBOT"] = 4;
        return values;
    })();

    return GameSrvToDeskPushKickPlayer;
})();

export const PokerSrvToDeskPushAssetInfo = $root.PokerSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a PokerSrvToDeskPushAssetInfo.
     * @exports IPokerSrvToDeskPushAssetInfo
     * @interface IPokerSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] PokerSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] PokerSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] PokerSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] PokerSrvToDeskPushAssetInfo Chip
     * @property {string|null} [EnterChip] PokerSrvToDeskPushAssetInfo EnterChip
     */

    /**
     * Constructs a new PokerSrvToDeskPushAssetInfo.
     * @exports PokerSrvToDeskPushAssetInfo
     * @classdesc Represents a PokerSrvToDeskPushAssetInfo.
     * @implements IPokerSrvToDeskPushAssetInfo
     * @constructor
     * @param {IPokerSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function PokerSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     */
    PokerSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * PokerSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     */
    PokerSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * PokerSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     */
    PokerSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * PokerSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     */
    PokerSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * PokerSrvToDeskPushAssetInfo EnterChip.
     * @member {string} EnterChip
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     */
    PokerSrvToDeskPushAssetInfo.prototype.EnterChip = "";

    /**
     * Creates a new PokerSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {PokerSrvToDeskPushAssetInfo} PokerSrvToDeskPushAssetInfo instance
     */
    PokerSrvToDeskPushAssetInfo.create = function create(properties) {
        return new PokerSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified PokerSrvToDeskPushAssetInfo message. Does not implicitly {@link PokerSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerSrvToDeskPushAssetInfo} message PokerSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.EnterChip != null && Object.hasOwnProperty.call(message, "EnterChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.EnterChip);
        return writer;
    };

    /**
     * Encodes the specified PokerSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link PokerSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerSrvToDeskPushAssetInfo} message PokerSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerSrvToDeskPushAssetInfo} PokerSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.EnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerSrvToDeskPushAssetInfo} PokerSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            if (!$util.isString(message.EnterChip))
                return "EnterChip: string expected";
        return null;
    };

    /**
     * Creates a PokerSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerSrvToDeskPushAssetInfo} PokerSrvToDeskPushAssetInfo
     */
    PokerSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.PokerSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.EnterChip != null)
            message.EnterChip = String(object.EnterChip);
        return message;
    };

    /**
     * Creates a plain object from a PokerSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {PokerSrvToDeskPushAssetInfo} message PokerSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
            object.EnterChip = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            object.EnterChip = message.EnterChip;
        return object;
    };

    /**
     * Converts this PokerSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof PokerSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof PokerSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerSrvToDeskPushAssetInfo";
    };

    return PokerSrvToDeskPushAssetInfo;
})();

export const PokerWarSrvToDeskPushAssetInfo = $root.PokerWarSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a PokerWarSrvToDeskPushAssetInfo.
     * @exports IPokerWarSrvToDeskPushAssetInfo
     * @interface IPokerWarSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] PokerWarSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] PokerWarSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] PokerWarSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] PokerWarSrvToDeskPushAssetInfo Chip
     */

    /**
     * Constructs a new PokerWarSrvToDeskPushAssetInfo.
     * @exports PokerWarSrvToDeskPushAssetInfo
     * @classdesc Represents a PokerWarSrvToDeskPushAssetInfo.
     * @implements IPokerWarSrvToDeskPushAssetInfo
     * @constructor
     * @param {IPokerWarSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function PokerWarSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @instance
     */
    PokerWarSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * PokerWarSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @instance
     */
    PokerWarSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * PokerWarSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @instance
     */
    PokerWarSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * PokerWarSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @instance
     */
    PokerWarSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * Creates a new PokerWarSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerWarSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {PokerWarSrvToDeskPushAssetInfo} PokerWarSrvToDeskPushAssetInfo instance
     */
    PokerWarSrvToDeskPushAssetInfo.create = function create(properties) {
        return new PokerWarSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified PokerWarSrvToDeskPushAssetInfo message. Does not implicitly {@link PokerWarSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerWarSrvToDeskPushAssetInfo} message PokerWarSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified PokerWarSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link PokerWarSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {IPokerWarSrvToDeskPushAssetInfo} message PokerWarSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarSrvToDeskPushAssetInfo} PokerWarSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarSrvToDeskPushAssetInfo} PokerWarSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a PokerWarSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarSrvToDeskPushAssetInfo} PokerWarSrvToDeskPushAssetInfo
     */
    PokerWarSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.PokerWarSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a PokerWarSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {PokerWarSrvToDeskPushAssetInfo} message PokerWarSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this PokerWarSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof PokerWarSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarSrvToDeskPushAssetInfo";
    };

    return PokerWarSrvToDeskPushAssetInfo;
})();

export const PokerWarSrvToDeskPushDeskInfo = $root.PokerWarSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a PokerWarSrvToDeskPushDeskInfo.
     * @exports IPokerWarSrvToDeskPushDeskInfo
     * @interface IPokerWarSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] PokerWarSrvToDeskPushDeskInfo UserID
     * @property {IBigBattleProduct|null} [Product] PokerWarSrvToDeskPushDeskInfo Product
     * @property {string|null} [Tax] PokerWarSrvToDeskPushDeskInfo Tax
     */

    /**
     * Constructs a new PokerWarSrvToDeskPushDeskInfo.
     * @exports PokerWarSrvToDeskPushDeskInfo
     * @classdesc Represents a PokerWarSrvToDeskPushDeskInfo.
     * @implements IPokerWarSrvToDeskPushDeskInfo
     * @constructor
     * @param {IPokerWarSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function PokerWarSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @instance
     */
    PokerWarSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * PokerWarSrvToDeskPushDeskInfo Product.
     * @member {IBigBattleProduct|null|undefined} Product
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @instance
     */
    PokerWarSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * PokerWarSrvToDeskPushDeskInfo Tax.
     * @member {string} Tax
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @instance
     */
    PokerWarSrvToDeskPushDeskInfo.prototype.Tax = "";

    /**
     * Creates a new PokerWarSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {IPokerWarSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {PokerWarSrvToDeskPushDeskInfo} PokerWarSrvToDeskPushDeskInfo instance
     */
    PokerWarSrvToDeskPushDeskInfo.create = function create(properties) {
        return new PokerWarSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified PokerWarSrvToDeskPushDeskInfo message. Does not implicitly {@link PokerWarSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {IPokerWarSrvToDeskPushDeskInfo} message PokerWarSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.BigBattleProduct.encode(message.Product, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Tax);
        return writer;
    };

    /**
     * Encodes the specified PokerWarSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link PokerWarSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {IPokerWarSrvToDeskPushDeskInfo} message PokerWarSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarSrvToDeskPushDeskInfo} PokerWarSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Product = $root.BigBattleProduct.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.Tax = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarSrvToDeskPushDeskInfo} PokerWarSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.BigBattleProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        return null;
    };

    /**
     * Creates a PokerWarSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarSrvToDeskPushDeskInfo} PokerWarSrvToDeskPushDeskInfo
     */
    PokerWarSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.PokerWarSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".PokerWarSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.BigBattleProduct.fromObject(object.Product);
        }
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        return message;
    };

    /**
     * Creates a plain object from a PokerWarSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {PokerWarSrvToDeskPushDeskInfo} message PokerWarSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Product = null;
            object.Tax = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.BigBattleProduct.toObject(message.Product, options);
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        return object;
    };

    /**
     * Converts this PokerWarSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof PokerWarSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarSrvToDeskPushDeskInfo";
    };

    return PokerWarSrvToDeskPushDeskInfo;
})();

export const PokerWarBetInfo = $root.PokerWarBetInfo = (() => {

    /**
     * Properties of a PokerWarBetInfo.
     * @exports IPokerWarBetInfo
     * @interface IPokerWarBetInfo
     * @property {number|Long|null} [RedTotalBetChip] PokerWarBetInfo RedTotalBetChip
     * @property {number|Long|null} [BlackTotalBetChip] PokerWarBetInfo BlackTotalBetChip
     * @property {number|Long|null} [LuckyTotalBetChip] PokerWarBetInfo LuckyTotalBetChip
     * @property {number|Long|null} [PlayerRedTotalChip] PokerWarBetInfo PlayerRedTotalChip
     * @property {number|Long|null} [PlayerBlackTotalChip] PokerWarBetInfo PlayerBlackTotalChip
     * @property {number|Long|null} [PlayerLuckyTotalChip] PokerWarBetInfo PlayerLuckyTotalChip
     */

    /**
     * Constructs a new PokerWarBetInfo.
     * @exports PokerWarBetInfo
     * @classdesc Represents a PokerWarBetInfo.
     * @implements IPokerWarBetInfo
     * @constructor
     * @param {IPokerWarBetInfo=} [properties] Properties to set
     */
    function PokerWarBetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarBetInfo RedTotalBetChip.
     * @member {number|Long} RedTotalBetChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.RedTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarBetInfo BlackTotalBetChip.
     * @member {number|Long} BlackTotalBetChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.BlackTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarBetInfo LuckyTotalBetChip.
     * @member {number|Long} LuckyTotalBetChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.LuckyTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarBetInfo PlayerRedTotalChip.
     * @member {number|Long} PlayerRedTotalChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.PlayerRedTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarBetInfo PlayerBlackTotalChip.
     * @member {number|Long} PlayerBlackTotalChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.PlayerBlackTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * PokerWarBetInfo PlayerLuckyTotalChip.
     * @member {number|Long} PlayerLuckyTotalChip
     * @memberof PokerWarBetInfo
     * @instance
     */
    PokerWarBetInfo.prototype.PlayerLuckyTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new PokerWarBetInfo instance using the specified properties.
     * @function create
     * @memberof PokerWarBetInfo
     * @static
     * @param {IPokerWarBetInfo=} [properties] Properties to set
     * @returns {PokerWarBetInfo} PokerWarBetInfo instance
     */
    PokerWarBetInfo.create = function create(properties) {
        return new PokerWarBetInfo(properties);
    };

    /**
     * Encodes the specified PokerWarBetInfo message. Does not implicitly {@link PokerWarBetInfo.verify|verify} messages.
     * @function encode
     * @memberof PokerWarBetInfo
     * @static
     * @param {IPokerWarBetInfo} message PokerWarBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarBetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RedTotalBetChip != null && Object.hasOwnProperty.call(message, "RedTotalBetChip"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.RedTotalBetChip);
        if (message.BlackTotalBetChip != null && Object.hasOwnProperty.call(message, "BlackTotalBetChip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.BlackTotalBetChip);
        if (message.LuckyTotalBetChip != null && Object.hasOwnProperty.call(message, "LuckyTotalBetChip"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.LuckyTotalBetChip);
        if (message.PlayerRedTotalChip != null && Object.hasOwnProperty.call(message, "PlayerRedTotalChip"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.PlayerRedTotalChip);
        if (message.PlayerBlackTotalChip != null && Object.hasOwnProperty.call(message, "PlayerBlackTotalChip"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.PlayerBlackTotalChip);
        if (message.PlayerLuckyTotalChip != null && Object.hasOwnProperty.call(message, "PlayerLuckyTotalChip"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.PlayerLuckyTotalChip);
        return writer;
    };

    /**
     * Encodes the specified PokerWarBetInfo message, length delimited. Does not implicitly {@link PokerWarBetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarBetInfo
     * @static
     * @param {IPokerWarBetInfo} message PokerWarBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarBetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarBetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarBetInfo} PokerWarBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarBetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarBetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RedTotalBetChip = reader.uint64();
                    break;
                }
            case 2: {
                    message.BlackTotalBetChip = reader.uint64();
                    break;
                }
            case 3: {
                    message.LuckyTotalBetChip = reader.uint64();
                    break;
                }
            case 4: {
                    message.PlayerRedTotalChip = reader.uint64();
                    break;
                }
            case 5: {
                    message.PlayerBlackTotalChip = reader.uint64();
                    break;
                }
            case 6: {
                    message.PlayerLuckyTotalChip = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarBetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarBetInfo} PokerWarBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarBetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarBetInfo message.
     * @function verify
     * @memberof PokerWarBetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarBetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RedTotalBetChip != null && message.hasOwnProperty("RedTotalBetChip"))
            if (!$util.isInteger(message.RedTotalBetChip) && !(message.RedTotalBetChip && $util.isInteger(message.RedTotalBetChip.low) && $util.isInteger(message.RedTotalBetChip.high)))
                return "RedTotalBetChip: integer|Long expected";
        if (message.BlackTotalBetChip != null && message.hasOwnProperty("BlackTotalBetChip"))
            if (!$util.isInteger(message.BlackTotalBetChip) && !(message.BlackTotalBetChip && $util.isInteger(message.BlackTotalBetChip.low) && $util.isInteger(message.BlackTotalBetChip.high)))
                return "BlackTotalBetChip: integer|Long expected";
        if (message.LuckyTotalBetChip != null && message.hasOwnProperty("LuckyTotalBetChip"))
            if (!$util.isInteger(message.LuckyTotalBetChip) && !(message.LuckyTotalBetChip && $util.isInteger(message.LuckyTotalBetChip.low) && $util.isInteger(message.LuckyTotalBetChip.high)))
                return "LuckyTotalBetChip: integer|Long expected";
        if (message.PlayerRedTotalChip != null && message.hasOwnProperty("PlayerRedTotalChip"))
            if (!$util.isInteger(message.PlayerRedTotalChip) && !(message.PlayerRedTotalChip && $util.isInteger(message.PlayerRedTotalChip.low) && $util.isInteger(message.PlayerRedTotalChip.high)))
                return "PlayerRedTotalChip: integer|Long expected";
        if (message.PlayerBlackTotalChip != null && message.hasOwnProperty("PlayerBlackTotalChip"))
            if (!$util.isInteger(message.PlayerBlackTotalChip) && !(message.PlayerBlackTotalChip && $util.isInteger(message.PlayerBlackTotalChip.low) && $util.isInteger(message.PlayerBlackTotalChip.high)))
                return "PlayerBlackTotalChip: integer|Long expected";
        if (message.PlayerLuckyTotalChip != null && message.hasOwnProperty("PlayerLuckyTotalChip"))
            if (!$util.isInteger(message.PlayerLuckyTotalChip) && !(message.PlayerLuckyTotalChip && $util.isInteger(message.PlayerLuckyTotalChip.low) && $util.isInteger(message.PlayerLuckyTotalChip.high)))
                return "PlayerLuckyTotalChip: integer|Long expected";
        return null;
    };

    /**
     * Creates a PokerWarBetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarBetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarBetInfo} PokerWarBetInfo
     */
    PokerWarBetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarBetInfo)
            return object;
        let message = new $root.PokerWarBetInfo();
        if (object.RedTotalBetChip != null)
            if ($util.Long)
                (message.RedTotalBetChip = $util.Long.fromValue(object.RedTotalBetChip)).unsigned = true;
            else if (typeof object.RedTotalBetChip === "string")
                message.RedTotalBetChip = parseInt(object.RedTotalBetChip, 10);
            else if (typeof object.RedTotalBetChip === "number")
                message.RedTotalBetChip = object.RedTotalBetChip;
            else if (typeof object.RedTotalBetChip === "object")
                message.RedTotalBetChip = new $util.LongBits(object.RedTotalBetChip.low >>> 0, object.RedTotalBetChip.high >>> 0).toNumber(true);
        if (object.BlackTotalBetChip != null)
            if ($util.Long)
                (message.BlackTotalBetChip = $util.Long.fromValue(object.BlackTotalBetChip)).unsigned = true;
            else if (typeof object.BlackTotalBetChip === "string")
                message.BlackTotalBetChip = parseInt(object.BlackTotalBetChip, 10);
            else if (typeof object.BlackTotalBetChip === "number")
                message.BlackTotalBetChip = object.BlackTotalBetChip;
            else if (typeof object.BlackTotalBetChip === "object")
                message.BlackTotalBetChip = new $util.LongBits(object.BlackTotalBetChip.low >>> 0, object.BlackTotalBetChip.high >>> 0).toNumber(true);
        if (object.LuckyTotalBetChip != null)
            if ($util.Long)
                (message.LuckyTotalBetChip = $util.Long.fromValue(object.LuckyTotalBetChip)).unsigned = true;
            else if (typeof object.LuckyTotalBetChip === "string")
                message.LuckyTotalBetChip = parseInt(object.LuckyTotalBetChip, 10);
            else if (typeof object.LuckyTotalBetChip === "number")
                message.LuckyTotalBetChip = object.LuckyTotalBetChip;
            else if (typeof object.LuckyTotalBetChip === "object")
                message.LuckyTotalBetChip = new $util.LongBits(object.LuckyTotalBetChip.low >>> 0, object.LuckyTotalBetChip.high >>> 0).toNumber(true);
        if (object.PlayerRedTotalChip != null)
            if ($util.Long)
                (message.PlayerRedTotalChip = $util.Long.fromValue(object.PlayerRedTotalChip)).unsigned = true;
            else if (typeof object.PlayerRedTotalChip === "string")
                message.PlayerRedTotalChip = parseInt(object.PlayerRedTotalChip, 10);
            else if (typeof object.PlayerRedTotalChip === "number")
                message.PlayerRedTotalChip = object.PlayerRedTotalChip;
            else if (typeof object.PlayerRedTotalChip === "object")
                message.PlayerRedTotalChip = new $util.LongBits(object.PlayerRedTotalChip.low >>> 0, object.PlayerRedTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerBlackTotalChip != null)
            if ($util.Long)
                (message.PlayerBlackTotalChip = $util.Long.fromValue(object.PlayerBlackTotalChip)).unsigned = true;
            else if (typeof object.PlayerBlackTotalChip === "string")
                message.PlayerBlackTotalChip = parseInt(object.PlayerBlackTotalChip, 10);
            else if (typeof object.PlayerBlackTotalChip === "number")
                message.PlayerBlackTotalChip = object.PlayerBlackTotalChip;
            else if (typeof object.PlayerBlackTotalChip === "object")
                message.PlayerBlackTotalChip = new $util.LongBits(object.PlayerBlackTotalChip.low >>> 0, object.PlayerBlackTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerLuckyTotalChip != null)
            if ($util.Long)
                (message.PlayerLuckyTotalChip = $util.Long.fromValue(object.PlayerLuckyTotalChip)).unsigned = true;
            else if (typeof object.PlayerLuckyTotalChip === "string")
                message.PlayerLuckyTotalChip = parseInt(object.PlayerLuckyTotalChip, 10);
            else if (typeof object.PlayerLuckyTotalChip === "number")
                message.PlayerLuckyTotalChip = object.PlayerLuckyTotalChip;
            else if (typeof object.PlayerLuckyTotalChip === "object")
                message.PlayerLuckyTotalChip = new $util.LongBits(object.PlayerLuckyTotalChip.low >>> 0, object.PlayerLuckyTotalChip.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a PokerWarBetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarBetInfo
     * @static
     * @param {PokerWarBetInfo} message PokerWarBetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarBetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.RedTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.RedTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BlackTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BlackTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LuckyTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LuckyTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerRedTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerRedTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerBlackTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerBlackTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerLuckyTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerLuckyTotalChip = options.longs === String ? "0" : 0;
        }
        if (message.RedTotalBetChip != null && message.hasOwnProperty("RedTotalBetChip"))
            if (typeof message.RedTotalBetChip === "number")
                object.RedTotalBetChip = options.longs === String ? String(message.RedTotalBetChip) : message.RedTotalBetChip;
            else
                object.RedTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.RedTotalBetChip) : options.longs === Number ? new $util.LongBits(message.RedTotalBetChip.low >>> 0, message.RedTotalBetChip.high >>> 0).toNumber(true) : message.RedTotalBetChip;
        if (message.BlackTotalBetChip != null && message.hasOwnProperty("BlackTotalBetChip"))
            if (typeof message.BlackTotalBetChip === "number")
                object.BlackTotalBetChip = options.longs === String ? String(message.BlackTotalBetChip) : message.BlackTotalBetChip;
            else
                object.BlackTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.BlackTotalBetChip) : options.longs === Number ? new $util.LongBits(message.BlackTotalBetChip.low >>> 0, message.BlackTotalBetChip.high >>> 0).toNumber(true) : message.BlackTotalBetChip;
        if (message.LuckyTotalBetChip != null && message.hasOwnProperty("LuckyTotalBetChip"))
            if (typeof message.LuckyTotalBetChip === "number")
                object.LuckyTotalBetChip = options.longs === String ? String(message.LuckyTotalBetChip) : message.LuckyTotalBetChip;
            else
                object.LuckyTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.LuckyTotalBetChip) : options.longs === Number ? new $util.LongBits(message.LuckyTotalBetChip.low >>> 0, message.LuckyTotalBetChip.high >>> 0).toNumber(true) : message.LuckyTotalBetChip;
        if (message.PlayerRedTotalChip != null && message.hasOwnProperty("PlayerRedTotalChip"))
            if (typeof message.PlayerRedTotalChip === "number")
                object.PlayerRedTotalChip = options.longs === String ? String(message.PlayerRedTotalChip) : message.PlayerRedTotalChip;
            else
                object.PlayerRedTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerRedTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerRedTotalChip.low >>> 0, message.PlayerRedTotalChip.high >>> 0).toNumber(true) : message.PlayerRedTotalChip;
        if (message.PlayerBlackTotalChip != null && message.hasOwnProperty("PlayerBlackTotalChip"))
            if (typeof message.PlayerBlackTotalChip === "number")
                object.PlayerBlackTotalChip = options.longs === String ? String(message.PlayerBlackTotalChip) : message.PlayerBlackTotalChip;
            else
                object.PlayerBlackTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerBlackTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerBlackTotalChip.low >>> 0, message.PlayerBlackTotalChip.high >>> 0).toNumber(true) : message.PlayerBlackTotalChip;
        if (message.PlayerLuckyTotalChip != null && message.hasOwnProperty("PlayerLuckyTotalChip"))
            if (typeof message.PlayerLuckyTotalChip === "number")
                object.PlayerLuckyTotalChip = options.longs === String ? String(message.PlayerLuckyTotalChip) : message.PlayerLuckyTotalChip;
            else
                object.PlayerLuckyTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerLuckyTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerLuckyTotalChip.low >>> 0, message.PlayerLuckyTotalChip.high >>> 0).toNumber(true) : message.PlayerLuckyTotalChip;
        return object;
    };

    /**
     * Converts this PokerWarBetInfo to JSON.
     * @function toJSON
     * @memberof PokerWarBetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarBetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarBetInfo
     * @function getTypeUrl
     * @memberof PokerWarBetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarBetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarBetInfo";
    };

    return PokerWarBetInfo;
})();

export const Desk2PokerWarSrvPushPlayingInfo = $root.Desk2PokerWarSrvPushPlayingInfo = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushPlayingInfo.
     * @exports IDesk2PokerWarSrvPushPlayingInfo
     * @interface IDesk2PokerWarSrvPushPlayingInfo
     * @property {number|null} [UserID] Desk2PokerWarSrvPushPlayingInfo UserID
     * @property {number|null} [StateID] Desk2PokerWarSrvPushPlayingInfo StateID
     * @property {Array.<number>|null} [GamingIDs] Desk2PokerWarSrvPushPlayingInfo GamingIDs
     * @property {Array.<number>|null} [PlayerBetIDs] Desk2PokerWarSrvPushPlayingInfo PlayerBetIDs
     * @property {IPokerWarBetInfo|null} [RoundBetInfo] Desk2PokerWarSrvPushPlayingInfo RoundBetInfo
     * @property {Array.<IPokerWarGameCard>|null} [GameCard] Desk2PokerWarSrvPushPlayingInfo GameCard
     * @property {number|null} [CardResult] Desk2PokerWarSrvPushPlayingInfo CardResult
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushPlayingInfo.
     * @exports Desk2PokerWarSrvPushPlayingInfo
     * @classdesc Represents a Desk2PokerWarSrvPushPlayingInfo.
     * @implements IDesk2PokerWarSrvPushPlayingInfo
     * @constructor
     * @param {IDesk2PokerWarSrvPushPlayingInfo=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushPlayingInfo(properties) {
        this.GamingIDs = [];
        this.PlayerBetIDs = [];
        this.GameCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.UserID = 0;

    /**
     * Desk2PokerWarSrvPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.StateID = 0;

    /**
     * Desk2PokerWarSrvPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * Desk2PokerWarSrvPushPlayingInfo PlayerBetIDs.
     * @member {Array.<number>} PlayerBetIDs
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.PlayerBetIDs = $util.emptyArray;

    /**
     * Desk2PokerWarSrvPushPlayingInfo RoundBetInfo.
     * @member {IPokerWarBetInfo|null|undefined} RoundBetInfo
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.RoundBetInfo = null;

    /**
     * Desk2PokerWarSrvPushPlayingInfo GameCard.
     * @member {Array.<IPokerWarGameCard>} GameCard
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.GameCard = $util.emptyArray;

    /**
     * Desk2PokerWarSrvPushPlayingInfo CardResult.
     * @member {number} CardResult
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.CardResult = 0;

    /**
     * Creates a new Desk2PokerWarSrvPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {IDesk2PokerWarSrvPushPlayingInfo=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushPlayingInfo} Desk2PokerWarSrvPushPlayingInfo instance
     */
    Desk2PokerWarSrvPushPlayingInfo.create = function create(properties) {
        return new Desk2PokerWarSrvPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushPlayingInfo message. Does not implicitly {@link Desk2PokerWarSrvPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {IDesk2PokerWarSrvPushPlayingInfo} message Desk2PokerWarSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.PlayerBetIDs != null && message.PlayerBetIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                writer.uint32(message.PlayerBetIDs[i]);
            writer.ldelim();
        }
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.PokerWarBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.GameCard != null && message.GameCard.length)
            for (let i = 0; i < message.GameCard.length; ++i)
                $root.PokerWarGameCard.encode(message.GameCard[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.CardResult != null && Object.hasOwnProperty.call(message, "CardResult"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.CardResult);
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushPlayingInfo message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {IDesk2PokerWarSrvPushPlayingInfo} message Desk2PokerWarSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushPlayingInfo} Desk2PokerWarSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.PlayerBetIDs && message.PlayerBetIDs.length))
                        message.PlayerBetIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PlayerBetIDs.push(reader.uint32());
                    } else
                        message.PlayerBetIDs.push(reader.uint32());
                    break;
                }
            case 5: {
                    message.RoundBetInfo = $root.PokerWarBetInfo.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.GameCard && message.GameCard.length))
                        message.GameCard = [];
                    message.GameCard.push($root.PokerWarGameCard.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.CardResult = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushPlayingInfo} Desk2PokerWarSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushPlayingInfo message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.PlayerBetIDs != null && message.hasOwnProperty("PlayerBetIDs")) {
            if (!Array.isArray(message.PlayerBetIDs))
                return "PlayerBetIDs: array expected";
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                if (!$util.isInteger(message.PlayerBetIDs[i]))
                    return "PlayerBetIDs: integer[] expected";
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.PokerWarBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        if (message.GameCard != null && message.hasOwnProperty("GameCard")) {
            if (!Array.isArray(message.GameCard))
                return "GameCard: array expected";
            for (let i = 0; i < message.GameCard.length; ++i) {
                let error = $root.PokerWarGameCard.verify(message.GameCard[i]);
                if (error)
                    return "GameCard." + error;
            }
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult"))
            if (!$util.isInteger(message.CardResult))
                return "CardResult: integer expected";
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushPlayingInfo} Desk2PokerWarSrvPushPlayingInfo
     */
    Desk2PokerWarSrvPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushPlayingInfo)
            return object;
        let message = new $root.Desk2PokerWarSrvPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".Desk2PokerWarSrvPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.PlayerBetIDs) {
            if (!Array.isArray(object.PlayerBetIDs))
                throw TypeError(".Desk2PokerWarSrvPushPlayingInfo.PlayerBetIDs: array expected");
            message.PlayerBetIDs = [];
            for (let i = 0; i < object.PlayerBetIDs.length; ++i)
                message.PlayerBetIDs[i] = object.PlayerBetIDs[i] >>> 0;
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Desk2PokerWarSrvPushPlayingInfo.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.PokerWarBetInfo.fromObject(object.RoundBetInfo);
        }
        if (object.GameCard) {
            if (!Array.isArray(object.GameCard))
                throw TypeError(".Desk2PokerWarSrvPushPlayingInfo.GameCard: array expected");
            message.GameCard = [];
            for (let i = 0; i < object.GameCard.length; ++i) {
                if (typeof object.GameCard[i] !== "object")
                    throw TypeError(".Desk2PokerWarSrvPushPlayingInfo.GameCard: object expected");
                message.GameCard[i] = $root.PokerWarGameCard.fromObject(object.GameCard[i]);
            }
        }
        if (object.CardResult != null)
            message.CardResult = object.CardResult >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {Desk2PokerWarSrvPushPlayingInfo} message Desk2PokerWarSrvPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.PlayerBetIDs = [];
            object.GameCard = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.RoundBetInfo = null;
            object.CardResult = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.PlayerBetIDs && message.PlayerBetIDs.length) {
            object.PlayerBetIDs = [];
            for (let j = 0; j < message.PlayerBetIDs.length; ++j)
                object.PlayerBetIDs[j] = message.PlayerBetIDs[j];
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.PokerWarBetInfo.toObject(message.RoundBetInfo, options);
        if (message.GameCard && message.GameCard.length) {
            object.GameCard = [];
            for (let j = 0; j < message.GameCard.length; ++j)
                object.GameCard[j] = $root.PokerWarGameCard.toObject(message.GameCard[j], options);
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult"))
            object.CardResult = message.CardResult;
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushPlayingInfo
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushPlayingInfo";
    };

    return Desk2PokerWarSrvPushPlayingInfo;
})();

/**
 * PokerWarBetType enum.
 * @exports PokerWarBetType
 * @enum {number}
 * @property {number} Bet_Type_NULL=0 Bet_Type_NULL value
 * @property {number} Bet_Type_Red=1 Bet_Type_Red value
 * @property {number} Bet_Type_Black=2 Bet_Type_Black value
 * @property {number} Bet_Type_Lucky=3 Bet_Type_Lucky value
 */
export const PokerWarBetType = $root.PokerWarBetType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bet_Type_NULL"] = 0;
    values[valuesById[1] = "Bet_Type_Red"] = 1;
    values[valuesById[2] = "Bet_Type_Black"] = 2;
    values[valuesById[3] = "Bet_Type_Lucky"] = 3;
    return values;
})();

export const PlayerPokerWarBet = $root.PlayerPokerWarBet = (() => {

    /**
     * Properties of a PlayerPokerWarBet.
     * @exports IPlayerPokerWarBet
     * @interface IPlayerPokerWarBet
     * @property {number|null} [BetType] PlayerPokerWarBet BetType
     * @property {number|null} [Chip] PlayerPokerWarBet Chip
     */

    /**
     * Constructs a new PlayerPokerWarBet.
     * @exports PlayerPokerWarBet
     * @classdesc Represents a PlayerPokerWarBet.
     * @implements IPlayerPokerWarBet
     * @constructor
     * @param {IPlayerPokerWarBet=} [properties] Properties to set
     */
    function PlayerPokerWarBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerPokerWarBet BetType.
     * @member {number} BetType
     * @memberof PlayerPokerWarBet
     * @instance
     */
    PlayerPokerWarBet.prototype.BetType = 0;

    /**
     * PlayerPokerWarBet Chip.
     * @member {number} Chip
     * @memberof PlayerPokerWarBet
     * @instance
     */
    PlayerPokerWarBet.prototype.Chip = 0;

    /**
     * Creates a new PlayerPokerWarBet instance using the specified properties.
     * @function create
     * @memberof PlayerPokerWarBet
     * @static
     * @param {IPlayerPokerWarBet=} [properties] Properties to set
     * @returns {PlayerPokerWarBet} PlayerPokerWarBet instance
     */
    PlayerPokerWarBet.create = function create(properties) {
        return new PlayerPokerWarBet(properties);
    };

    /**
     * Encodes the specified PlayerPokerWarBet message. Does not implicitly {@link PlayerPokerWarBet.verify|verify} messages.
     * @function encode
     * @memberof PlayerPokerWarBet
     * @static
     * @param {IPlayerPokerWarBet} message PlayerPokerWarBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerPokerWarBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.BetType);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified PlayerPokerWarBet message, length delimited. Does not implicitly {@link PlayerPokerWarBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerPokerWarBet
     * @static
     * @param {IPlayerPokerWarBet} message PlayerPokerWarBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerPokerWarBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerPokerWarBet message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerPokerWarBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerPokerWarBet} PlayerPokerWarBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerPokerWarBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerPokerWarBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetType = reader.uint32();
                    break;
                }
            case 2: {
                    message.Chip = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerPokerWarBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerPokerWarBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerPokerWarBet} PlayerPokerWarBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerPokerWarBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerPokerWarBet message.
     * @function verify
     * @memberof PlayerPokerWarBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerPokerWarBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isInteger(message.Chip))
                return "Chip: integer expected";
        return null;
    };

    /**
     * Creates a PlayerPokerWarBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerPokerWarBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerPokerWarBet} PlayerPokerWarBet
     */
    PlayerPokerWarBet.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerPokerWarBet)
            return object;
        let message = new $root.PlayerPokerWarBet();
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        if (object.Chip != null)
            message.Chip = object.Chip >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PlayerPokerWarBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerPokerWarBet
     * @static
     * @param {PlayerPokerWarBet} message PlayerPokerWarBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerPokerWarBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetType = 0;
            object.Chip = 0;
        }
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this PlayerPokerWarBet to JSON.
     * @function toJSON
     * @memberof PlayerPokerWarBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerPokerWarBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerPokerWarBet
     * @function getTypeUrl
     * @memberof PlayerPokerWarBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerPokerWarBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerPokerWarBet";
    };

    return PlayerPokerWarBet;
})();

export const Client2PokerWarSrvReqBet = $root.Client2PokerWarSrvReqBet = (() => {

    /**
     * Properties of a Client2PokerWarSrvReqBet.
     * @exports IClient2PokerWarSrvReqBet
     * @interface IClient2PokerWarSrvReqBet
     * @property {number|null} [DeskNo] Client2PokerWarSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2PokerWarSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2PokerWarSrvReqBet SeatNo
     * @property {Array.<IPlayerPokerWarBet>|null} [BetList] Client2PokerWarSrvReqBet BetList
     */

    /**
     * Constructs a new Client2PokerWarSrvReqBet.
     * @exports Client2PokerWarSrvReqBet
     * @classdesc Represents a Client2PokerWarSrvReqBet.
     * @implements IClient2PokerWarSrvReqBet
     * @constructor
     * @param {IClient2PokerWarSrvReqBet=} [properties] Properties to set
     */
    function Client2PokerWarSrvReqBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2PokerWarSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2PokerWarSrvReqBet
     * @instance
     */
    Client2PokerWarSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2PokerWarSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2PokerWarSrvReqBet
     * @instance
     */
    Client2PokerWarSrvReqBet.prototype.UserID = 0;

    /**
     * Client2PokerWarSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2PokerWarSrvReqBet
     * @instance
     */
    Client2PokerWarSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2PokerWarSrvReqBet BetList.
     * @member {Array.<IPlayerPokerWarBet>} BetList
     * @memberof Client2PokerWarSrvReqBet
     * @instance
     */
    Client2PokerWarSrvReqBet.prototype.BetList = $util.emptyArray;

    /**
     * Creates a new Client2PokerWarSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {IClient2PokerWarSrvReqBet=} [properties] Properties to set
     * @returns {Client2PokerWarSrvReqBet} Client2PokerWarSrvReqBet instance
     */
    Client2PokerWarSrvReqBet.create = function create(properties) {
        return new Client2PokerWarSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2PokerWarSrvReqBet message. Does not implicitly {@link Client2PokerWarSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {IClient2PokerWarSrvReqBet} message Client2PokerWarSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerWarSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerPokerWarBet.encode(message.BetList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2PokerWarSrvReqBet message, length delimited. Does not implicitly {@link Client2PokerWarSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {IClient2PokerWarSrvReqBet} message Client2PokerWarSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerWarSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2PokerWarSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2PokerWarSrvReqBet} Client2PokerWarSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerWarSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2PokerWarSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerPokerWarBet.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2PokerWarSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2PokerWarSrvReqBet} Client2PokerWarSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerWarSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2PokerWarSrvReqBet message.
     * @function verify
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2PokerWarSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerPokerWarBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2PokerWarSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2PokerWarSrvReqBet} Client2PokerWarSrvReqBet
     */
    Client2PokerWarSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2PokerWarSrvReqBet)
            return object;
        let message = new $root.Client2PokerWarSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2PokerWarSrvReqBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2PokerWarSrvReqBet.BetList: object expected");
                message.BetList[i] = $root.PlayerPokerWarBet.fromObject(object.BetList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2PokerWarSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {Client2PokerWarSrvReqBet} message Client2PokerWarSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2PokerWarSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerPokerWarBet.toObject(message.BetList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2PokerWarSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2PokerWarSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2PokerWarSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2PokerWarSrvReqBet
     * @function getTypeUrl
     * @memberof Client2PokerWarSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2PokerWarSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2PokerWarSrvReqBet";
    };

    return Client2PokerWarSrvReqBet;
})();

export const Client2PokerWarSrvAckBet = $root.Client2PokerWarSrvAckBet = (() => {

    /**
     * Properties of a Client2PokerWarSrvAckBet.
     * @exports IClient2PokerWarSrvAckBet
     * @interface IClient2PokerWarSrvAckBet
     * @property {number|null} [Ret] Client2PokerWarSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2PokerWarSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2PokerWarSrvAckBet UserID
     * @property {string|null} [Chip] Client2PokerWarSrvAckBet Chip
     * @property {number|null} [SeatNo] Client2PokerWarSrvAckBet SeatNo
     * @property {Array.<IPlayerPokerWarBet>|null} [BetList] Client2PokerWarSrvAckBet BetList
     * @property {IPokerWarBetInfo|null} [RoundBetInfo] Client2PokerWarSrvAckBet RoundBetInfo
     */

    /**
     * Constructs a new Client2PokerWarSrvAckBet.
     * @exports Client2PokerWarSrvAckBet
     * @classdesc Represents a Client2PokerWarSrvAckBet.
     * @implements IClient2PokerWarSrvAckBet
     * @constructor
     * @param {IClient2PokerWarSrvAckBet=} [properties] Properties to set
     */
    function Client2PokerWarSrvAckBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2PokerWarSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.Ret = 0;

    /**
     * Client2PokerWarSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2PokerWarSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.UserID = 0;

    /**
     * Client2PokerWarSrvAckBet Chip.
     * @member {string} Chip
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.Chip = "";

    /**
     * Client2PokerWarSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2PokerWarSrvAckBet BetList.
     * @member {Array.<IPlayerPokerWarBet>} BetList
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.BetList = $util.emptyArray;

    /**
     * Client2PokerWarSrvAckBet RoundBetInfo.
     * @member {IPokerWarBetInfo|null|undefined} RoundBetInfo
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     */
    Client2PokerWarSrvAckBet.prototype.RoundBetInfo = null;

    /**
     * Creates a new Client2PokerWarSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {IClient2PokerWarSrvAckBet=} [properties] Properties to set
     * @returns {Client2PokerWarSrvAckBet} Client2PokerWarSrvAckBet instance
     */
    Client2PokerWarSrvAckBet.create = function create(properties) {
        return new Client2PokerWarSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2PokerWarSrvAckBet message. Does not implicitly {@link Client2PokerWarSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {IClient2PokerWarSrvAckBet} message Client2PokerWarSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerWarSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerPokerWarBet.encode(message.BetList[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.PokerWarBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2PokerWarSrvAckBet message, length delimited. Does not implicitly {@link Client2PokerWarSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {IClient2PokerWarSrvAckBet} message Client2PokerWarSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerWarSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2PokerWarSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2PokerWarSrvAckBet} Client2PokerWarSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerWarSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2PokerWarSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 6: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerPokerWarBet.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.RoundBetInfo = $root.PokerWarBetInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2PokerWarSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2PokerWarSrvAckBet} Client2PokerWarSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerWarSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2PokerWarSrvAckBet message.
     * @function verify
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2PokerWarSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerPokerWarBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.PokerWarBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        return null;
    };

    /**
     * Creates a Client2PokerWarSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2PokerWarSrvAckBet} Client2PokerWarSrvAckBet
     */
    Client2PokerWarSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2PokerWarSrvAckBet)
            return object;
        let message = new $root.Client2PokerWarSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2PokerWarSrvAckBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2PokerWarSrvAckBet.BetList: object expected");
                message.BetList[i] = $root.PlayerPokerWarBet.fromObject(object.BetList[i]);
            }
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Client2PokerWarSrvAckBet.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.PokerWarBetInfo.fromObject(object.RoundBetInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2PokerWarSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {Client2PokerWarSrvAckBet} message Client2PokerWarSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2PokerWarSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.Chip = "";
            object.SeatNo = 0;
            object.RoundBetInfo = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerPokerWarBet.toObject(message.BetList[j], options);
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.PokerWarBetInfo.toObject(message.RoundBetInfo, options);
        return object;
    };

    /**
     * Converts this Client2PokerWarSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2PokerWarSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2PokerWarSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2PokerWarSrvAckBet
     * @function getTypeUrl
     * @memberof Client2PokerWarSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2PokerWarSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2PokerWarSrvAckBet";
    };

    return Client2PokerWarSrvAckBet;
})();

export const PokerWarCard = $root.PokerWarCard = (() => {

    /**
     * Properties of a PokerWarCard.
     * @exports IPokerWarCard
     * @interface IPokerWarCard
     * @property {number|null} [ID] PokerWarCard ID
     */

    /**
     * Constructs a new PokerWarCard.
     * @exports PokerWarCard
     * @classdesc Represents a PokerWarCard.
     * @implements IPokerWarCard
     * @constructor
     * @param {IPokerWarCard=} [properties] Properties to set
     */
    function PokerWarCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarCard ID.
     * @member {number} ID
     * @memberof PokerWarCard
     * @instance
     */
    PokerWarCard.prototype.ID = 0;

    /**
     * Creates a new PokerWarCard instance using the specified properties.
     * @function create
     * @memberof PokerWarCard
     * @static
     * @param {IPokerWarCard=} [properties] Properties to set
     * @returns {PokerWarCard} PokerWarCard instance
     */
    PokerWarCard.create = function create(properties) {
        return new PokerWarCard(properties);
    };

    /**
     * Encodes the specified PokerWarCard message. Does not implicitly {@link PokerWarCard.verify|verify} messages.
     * @function encode
     * @memberof PokerWarCard
     * @static
     * @param {IPokerWarCard} message PokerWarCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
        return writer;
    };

    /**
     * Encodes the specified PokerWarCard message, length delimited. Does not implicitly {@link PokerWarCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarCard
     * @static
     * @param {IPokerWarCard} message PokerWarCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarCard message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarCard} PokerWarCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarCard} PokerWarCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarCard message.
     * @function verify
     * @memberof PokerWarCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        return null;
    };

    /**
     * Creates a PokerWarCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarCard} PokerWarCard
     */
    PokerWarCard.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarCard)
            return object;
        let message = new $root.PokerWarCard();
        if (object.ID != null)
            message.ID = object.ID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PokerWarCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarCard
     * @static
     * @param {PokerWarCard} message PokerWarCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.ID = 0;
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        return object;
    };

    /**
     * Converts this PokerWarCard to JSON.
     * @function toJSON
     * @memberof PokerWarCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarCard
     * @function getTypeUrl
     * @memberof PokerWarCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarCard";
    };

    return PokerWarCard;
})();

export const PokerWarGameCard = $root.PokerWarGameCard = (() => {

    /**
     * Properties of a PokerWarGameCard.
     * @exports IPokerWarGameCard
     * @interface IPokerWarGameCard
     * @property {Array.<IPokerWarCard>|null} [Card] PokerWarGameCard Card
     * @property {number|null} [Type] PokerWarGameCard Type
     * @property {number|null} [CardType] PokerWarGameCard CardType
     */

    /**
     * Constructs a new PokerWarGameCard.
     * @exports PokerWarGameCard
     * @classdesc Represents a PokerWarGameCard.
     * @implements IPokerWarGameCard
     * @constructor
     * @param {IPokerWarGameCard=} [properties] Properties to set
     */
    function PokerWarGameCard(properties) {
        this.Card = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarGameCard Card.
     * @member {Array.<IPokerWarCard>} Card
     * @memberof PokerWarGameCard
     * @instance
     */
    PokerWarGameCard.prototype.Card = $util.emptyArray;

    /**
     * PokerWarGameCard Type.
     * @member {number} Type
     * @memberof PokerWarGameCard
     * @instance
     */
    PokerWarGameCard.prototype.Type = 0;

    /**
     * PokerWarGameCard CardType.
     * @member {number} CardType
     * @memberof PokerWarGameCard
     * @instance
     */
    PokerWarGameCard.prototype.CardType = 0;

    /**
     * Creates a new PokerWarGameCard instance using the specified properties.
     * @function create
     * @memberof PokerWarGameCard
     * @static
     * @param {IPokerWarGameCard=} [properties] Properties to set
     * @returns {PokerWarGameCard} PokerWarGameCard instance
     */
    PokerWarGameCard.create = function create(properties) {
        return new PokerWarGameCard(properties);
    };

    /**
     * Encodes the specified PokerWarGameCard message. Does not implicitly {@link PokerWarGameCard.verify|verify} messages.
     * @function encode
     * @memberof PokerWarGameCard
     * @static
     * @param {IPokerWarGameCard} message PokerWarGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarGameCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Card != null && message.Card.length)
            for (let i = 0; i < message.Card.length; ++i)
                $root.PokerWarCard.encode(message.Card[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.CardType);
        return writer;
    };

    /**
     * Encodes the specified PokerWarGameCard message, length delimited. Does not implicitly {@link PokerWarGameCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarGameCard
     * @static
     * @param {IPokerWarGameCard} message PokerWarGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarGameCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarGameCard message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarGameCard} PokerWarGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarGameCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarGameCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.Card && message.Card.length))
                        message.Card = [];
                    message.Card.push($root.PokerWarCard.decode(reader, reader.uint32()));
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            case 3: {
                    message.CardType = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarGameCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarGameCard} PokerWarGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarGameCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarGameCard message.
     * @function verify
     * @memberof PokerWarGameCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarGameCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Card != null && message.hasOwnProperty("Card")) {
            if (!Array.isArray(message.Card))
                return "Card: array expected";
            for (let i = 0; i < message.Card.length; ++i) {
                let error = $root.PokerWarCard.verify(message.Card[i]);
                if (error)
                    return "Card." + error;
            }
        }
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        return null;
    };

    /**
     * Creates a PokerWarGameCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarGameCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarGameCard} PokerWarGameCard
     */
    PokerWarGameCard.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarGameCard)
            return object;
        let message = new $root.PokerWarGameCard();
        if (object.Card) {
            if (!Array.isArray(object.Card))
                throw TypeError(".PokerWarGameCard.Card: array expected");
            message.Card = [];
            for (let i = 0; i < object.Card.length; ++i) {
                if (typeof object.Card[i] !== "object")
                    throw TypeError(".PokerWarGameCard.Card: object expected");
                message.Card[i] = $root.PokerWarCard.fromObject(object.Card[i]);
            }
        }
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.CardType != null)
            message.CardType = object.CardType | 0;
        return message;
    };

    /**
     * Creates a plain object from a PokerWarGameCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarGameCard
     * @static
     * @param {PokerWarGameCard} message PokerWarGameCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarGameCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Card = [];
        if (options.defaults) {
            object.Type = 0;
            object.CardType = 0;
        }
        if (message.Card && message.Card.length) {
            object.Card = [];
            for (let j = 0; j < message.Card.length; ++j)
                object.Card[j] = $root.PokerWarCard.toObject(message.Card[j], options);
        }
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        return object;
    };

    /**
     * Converts this PokerWarGameCard to JSON.
     * @function toJSON
     * @memberof PokerWarGameCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarGameCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarGameCard
     * @function getTypeUrl
     * @memberof PokerWarGameCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarGameCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarGameCard";
    };

    return PokerWarGameCard;
})();

export const Desk2PokerWarSrvPushGameCard = $root.Desk2PokerWarSrvPushGameCard = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushGameCard.
     * @exports IDesk2PokerWarSrvPushGameCard
     * @interface IDesk2PokerWarSrvPushGameCard
     * @property {number|null} [UserID] Desk2PokerWarSrvPushGameCard UserID
     * @property {number|null} [Result] Desk2PokerWarSrvPushGameCard Result
     * @property {Array.<IPokerWarGameCard>|null} [GameCard] Desk2PokerWarSrvPushGameCard GameCard
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushGameCard.
     * @exports Desk2PokerWarSrvPushGameCard
     * @classdesc Represents a Desk2PokerWarSrvPushGameCard.
     * @implements IDesk2PokerWarSrvPushGameCard
     * @constructor
     * @param {IDesk2PokerWarSrvPushGameCard=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushGameCard(properties) {
        this.GameCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushGameCard UserID.
     * @member {number} UserID
     * @memberof Desk2PokerWarSrvPushGameCard
     * @instance
     */
    Desk2PokerWarSrvPushGameCard.prototype.UserID = 0;

    /**
     * Desk2PokerWarSrvPushGameCard Result.
     * @member {number} Result
     * @memberof Desk2PokerWarSrvPushGameCard
     * @instance
     */
    Desk2PokerWarSrvPushGameCard.prototype.Result = 0;

    /**
     * Desk2PokerWarSrvPushGameCard GameCard.
     * @member {Array.<IPokerWarGameCard>} GameCard
     * @memberof Desk2PokerWarSrvPushGameCard
     * @instance
     */
    Desk2PokerWarSrvPushGameCard.prototype.GameCard = $util.emptyArray;

    /**
     * Creates a new Desk2PokerWarSrvPushGameCard instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {IDesk2PokerWarSrvPushGameCard=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushGameCard} Desk2PokerWarSrvPushGameCard instance
     */
    Desk2PokerWarSrvPushGameCard.create = function create(properties) {
        return new Desk2PokerWarSrvPushGameCard(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushGameCard message. Does not implicitly {@link Desk2PokerWarSrvPushGameCard.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {IDesk2PokerWarSrvPushGameCard} message Desk2PokerWarSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushGameCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Result != null && Object.hasOwnProperty.call(message, "Result"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Result);
        if (message.GameCard != null && message.GameCard.length)
            for (let i = 0; i < message.GameCard.length; ++i)
                $root.PokerWarGameCard.encode(message.GameCard[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushGameCard message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushGameCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {IDesk2PokerWarSrvPushGameCard} message Desk2PokerWarSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushGameCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushGameCard message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushGameCard} Desk2PokerWarSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushGameCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushGameCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Result = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GameCard && message.GameCard.length))
                        message.GameCard = [];
                    message.GameCard.push($root.PokerWarGameCard.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushGameCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushGameCard} Desk2PokerWarSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushGameCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushGameCard message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushGameCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Result != null && message.hasOwnProperty("Result"))
            if (!$util.isInteger(message.Result))
                return "Result: integer expected";
        if (message.GameCard != null && message.hasOwnProperty("GameCard")) {
            if (!Array.isArray(message.GameCard))
                return "GameCard: array expected";
            for (let i = 0; i < message.GameCard.length; ++i) {
                let error = $root.PokerWarGameCard.verify(message.GameCard[i]);
                if (error)
                    return "GameCard." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushGameCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushGameCard} Desk2PokerWarSrvPushGameCard
     */
    Desk2PokerWarSrvPushGameCard.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushGameCard)
            return object;
        let message = new $root.Desk2PokerWarSrvPushGameCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Result != null)
            message.Result = object.Result >>> 0;
        if (object.GameCard) {
            if (!Array.isArray(object.GameCard))
                throw TypeError(".Desk2PokerWarSrvPushGameCard.GameCard: array expected");
            message.GameCard = [];
            for (let i = 0; i < object.GameCard.length; ++i) {
                if (typeof object.GameCard[i] !== "object")
                    throw TypeError(".Desk2PokerWarSrvPushGameCard.GameCard: object expected");
                message.GameCard[i] = $root.PokerWarGameCard.fromObject(object.GameCard[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushGameCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {Desk2PokerWarSrvPushGameCard} message Desk2PokerWarSrvPushGameCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushGameCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GameCard = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Result = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Result != null && message.hasOwnProperty("Result"))
            object.Result = message.Result;
        if (message.GameCard && message.GameCard.length) {
            object.GameCard = [];
            for (let j = 0; j < message.GameCard.length; ++j)
                object.GameCard[j] = $root.PokerWarGameCard.toObject(message.GameCard[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushGameCard to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushGameCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushGameCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushGameCard
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushGameCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushGameCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushGameCard";
    };

    return Desk2PokerWarSrvPushGameCard;
})();

export const PokerWarGoldRes = $root.PokerWarGoldRes = (() => {

    /**
     * Properties of a PokerWarGoldRes.
     * @exports IPokerWarGoldRes
     * @interface IPokerWarGoldRes
     * @property {number|null} [UserID] PokerWarGoldRes UserID
     * @property {string|null} [WinGold] PokerWarGoldRes WinGold
     * @property {string|null} [ChangeGold] PokerWarGoldRes ChangeGold
     * @property {string|null} [TotalEnterChip] PokerWarGoldRes TotalEnterChip
     */

    /**
     * Constructs a new PokerWarGoldRes.
     * @exports PokerWarGoldRes
     * @classdesc Represents a PokerWarGoldRes.
     * @implements IPokerWarGoldRes
     * @constructor
     * @param {IPokerWarGoldRes=} [properties] Properties to set
     */
    function PokerWarGoldRes(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarGoldRes UserID.
     * @member {number} UserID
     * @memberof PokerWarGoldRes
     * @instance
     */
    PokerWarGoldRes.prototype.UserID = 0;

    /**
     * PokerWarGoldRes WinGold.
     * @member {string} WinGold
     * @memberof PokerWarGoldRes
     * @instance
     */
    PokerWarGoldRes.prototype.WinGold = "";

    /**
     * PokerWarGoldRes ChangeGold.
     * @member {string} ChangeGold
     * @memberof PokerWarGoldRes
     * @instance
     */
    PokerWarGoldRes.prototype.ChangeGold = "";

    /**
     * PokerWarGoldRes TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof PokerWarGoldRes
     * @instance
     */
    PokerWarGoldRes.prototype.TotalEnterChip = "";

    /**
     * Creates a new PokerWarGoldRes instance using the specified properties.
     * @function create
     * @memberof PokerWarGoldRes
     * @static
     * @param {IPokerWarGoldRes=} [properties] Properties to set
     * @returns {PokerWarGoldRes} PokerWarGoldRes instance
     */
    PokerWarGoldRes.create = function create(properties) {
        return new PokerWarGoldRes(properties);
    };

    /**
     * Encodes the specified PokerWarGoldRes message. Does not implicitly {@link PokerWarGoldRes.verify|verify} messages.
     * @function encode
     * @memberof PokerWarGoldRes
     * @static
     * @param {IPokerWarGoldRes} message PokerWarGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarGoldRes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.WinGold);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        return writer;
    };

    /**
     * Encodes the specified PokerWarGoldRes message, length delimited. Does not implicitly {@link PokerWarGoldRes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarGoldRes
     * @static
     * @param {IPokerWarGoldRes} message PokerWarGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarGoldRes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarGoldRes message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarGoldRes} PokerWarGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarGoldRes.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarGoldRes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinGold = reader.string();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarGoldRes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarGoldRes} PokerWarGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarGoldRes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarGoldRes message.
     * @function verify
     * @memberof PokerWarGoldRes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarGoldRes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isString(message.WinGold))
                return "WinGold: string expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        return null;
    };

    /**
     * Creates a PokerWarGoldRes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarGoldRes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarGoldRes} PokerWarGoldRes
     */
    PokerWarGoldRes.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarGoldRes)
            return object;
        let message = new $root.PokerWarGoldRes();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinGold != null)
            message.WinGold = String(object.WinGold);
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a PokerWarGoldRes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarGoldRes
     * @static
     * @param {PokerWarGoldRes} message PokerWarGoldRes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarGoldRes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.WinGold = "";
            object.ChangeGold = "";
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        return object;
    };

    /**
     * Converts this PokerWarGoldRes to JSON.
     * @function toJSON
     * @memberof PokerWarGoldRes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarGoldRes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarGoldRes
     * @function getTypeUrl
     * @memberof PokerWarGoldRes
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarGoldRes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarGoldRes";
    };

    return PokerWarGoldRes;
})();

export const Desk2PokerWarSrvPushGameResult = $root.Desk2PokerWarSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushGameResult.
     * @exports IDesk2PokerWarSrvPushGameResult
     * @interface IDesk2PokerWarSrvPushGameResult
     * @property {number|null} [UserID] Desk2PokerWarSrvPushGameResult UserID
     * @property {Array.<IPokerWarGoldRes>|null} [GoldResult] Desk2PokerWarSrvPushGameResult GoldResult
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushGameResult.
     * @exports Desk2PokerWarSrvPushGameResult
     * @classdesc Represents a Desk2PokerWarSrvPushGameResult.
     * @implements IDesk2PokerWarSrvPushGameResult
     * @constructor
     * @param {IDesk2PokerWarSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushGameResult(properties) {
        this.GoldResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2PokerWarSrvPushGameResult
     * @instance
     */
    Desk2PokerWarSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2PokerWarSrvPushGameResult GoldResult.
     * @member {Array.<IPokerWarGoldRes>} GoldResult
     * @memberof Desk2PokerWarSrvPushGameResult
     * @instance
     */
    Desk2PokerWarSrvPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Creates a new Desk2PokerWarSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {IDesk2PokerWarSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushGameResult} Desk2PokerWarSrvPushGameResult instance
     */
    Desk2PokerWarSrvPushGameResult.create = function create(properties) {
        return new Desk2PokerWarSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushGameResult message. Does not implicitly {@link Desk2PokerWarSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {IDesk2PokerWarSrvPushGameResult} message Desk2PokerWarSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.PokerWarGoldRes.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {IDesk2PokerWarSrvPushGameResult} message Desk2PokerWarSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushGameResult} Desk2PokerWarSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.PokerWarGoldRes.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushGameResult} Desk2PokerWarSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushGameResult message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.PokerWarGoldRes.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushGameResult} Desk2PokerWarSrvPushGameResult
     */
    Desk2PokerWarSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushGameResult)
            return object;
        let message = new $root.Desk2PokerWarSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".Desk2PokerWarSrvPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".Desk2PokerWarSrvPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.PokerWarGoldRes.fromObject(object.GoldResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {Desk2PokerWarSrvPushGameResult} message Desk2PokerWarSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GoldResult = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.PokerWarGoldRes.toObject(message.GoldResult[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushGameResult";
    };

    return Desk2PokerWarSrvPushGameResult;
})();

/**
 * PokerWarRandPlayerType enum.
 * @exports PokerWarRandPlayerType
 * @enum {number}
 * @property {number} PokerWarRandPlayerType_NULL=0 PokerWarRandPlayerType_NULL value
 * @property {number} PokerWarRandPlayerType_RICH=1 PokerWarRandPlayerType_RICH value
 * @property {number} PokerWarRandPlayerType_LUCK=2 PokerWarRandPlayerType_LUCK value
 * @property {number} PokerWarRandPlayerType_NORMAL=3 PokerWarRandPlayerType_NORMAL value
 */
export const PokerWarRandPlayerType = $root.PokerWarRandPlayerType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PokerWarRandPlayerType_NULL"] = 0;
    values[valuesById[1] = "PokerWarRandPlayerType_RICH"] = 1;
    values[valuesById[2] = "PokerWarRandPlayerType_LUCK"] = 2;
    values[valuesById[3] = "PokerWarRandPlayerType_NORMAL"] = 3;
    return values;
})();

export const PokerWarRandPlayer = $root.PokerWarRandPlayer = (() => {

    /**
     * Properties of a PokerWarRandPlayer.
     * @exports IPokerWarRandPlayer
     * @interface IPokerWarRandPlayer
     * @property {number|null} [UserID] PokerWarRandPlayer UserID
     * @property {Uint8Array|null} [NickName] PokerWarRandPlayer NickName
     * @property {string|null} [HeaderURL] PokerWarRandPlayer HeaderURL
     * @property {string|null} [GoldCoin] PokerWarRandPlayer GoldCoin
     * @property {number|null} [Type] PokerWarRandPlayer Type
     */

    /**
     * Constructs a new PokerWarRandPlayer.
     * @exports PokerWarRandPlayer
     * @classdesc Represents a PokerWarRandPlayer.
     * @implements IPokerWarRandPlayer
     * @constructor
     * @param {IPokerWarRandPlayer=} [properties] Properties to set
     */
    function PokerWarRandPlayer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PokerWarRandPlayer UserID.
     * @member {number} UserID
     * @memberof PokerWarRandPlayer
     * @instance
     */
    PokerWarRandPlayer.prototype.UserID = 0;

    /**
     * PokerWarRandPlayer NickName.
     * @member {Uint8Array} NickName
     * @memberof PokerWarRandPlayer
     * @instance
     */
    PokerWarRandPlayer.prototype.NickName = $util.newBuffer([]);

    /**
     * PokerWarRandPlayer HeaderURL.
     * @member {string} HeaderURL
     * @memberof PokerWarRandPlayer
     * @instance
     */
    PokerWarRandPlayer.prototype.HeaderURL = "";

    /**
     * PokerWarRandPlayer GoldCoin.
     * @member {string} GoldCoin
     * @memberof PokerWarRandPlayer
     * @instance
     */
    PokerWarRandPlayer.prototype.GoldCoin = "";

    /**
     * PokerWarRandPlayer Type.
     * @member {number} Type
     * @memberof PokerWarRandPlayer
     * @instance
     */
    PokerWarRandPlayer.prototype.Type = 0;

    /**
     * Creates a new PokerWarRandPlayer instance using the specified properties.
     * @function create
     * @memberof PokerWarRandPlayer
     * @static
     * @param {IPokerWarRandPlayer=} [properties] Properties to set
     * @returns {PokerWarRandPlayer} PokerWarRandPlayer instance
     */
    PokerWarRandPlayer.create = function create(properties) {
        return new PokerWarRandPlayer(properties);
    };

    /**
     * Encodes the specified PokerWarRandPlayer message. Does not implicitly {@link PokerWarRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof PokerWarRandPlayer
     * @static
     * @param {IPokerWarRandPlayer} message PokerWarRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.GoldCoin != null && Object.hasOwnProperty.call(message, "GoldCoin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GoldCoin);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified PokerWarRandPlayer message, length delimited. Does not implicitly {@link PokerWarRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PokerWarRandPlayer
     * @static
     * @param {IPokerWarRandPlayer} message PokerWarRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PokerWarRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PokerWarRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof PokerWarRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PokerWarRandPlayer} PokerWarRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PokerWarRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.GoldCoin = reader.string();
                    break;
                }
            case 5: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PokerWarRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PokerWarRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PokerWarRandPlayer} PokerWarRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PokerWarRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PokerWarRandPlayer message.
     * @function verify
     * @memberof PokerWarRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PokerWarRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            if (!$util.isString(message.GoldCoin))
                return "GoldCoin: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a PokerWarRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PokerWarRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PokerWarRandPlayer} PokerWarRandPlayer
     */
    PokerWarRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.PokerWarRandPlayer)
            return object;
        let message = new $root.PokerWarRandPlayer();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.GoldCoin != null)
            message.GoldCoin = String(object.GoldCoin);
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PokerWarRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PokerWarRandPlayer
     * @static
     * @param {PokerWarRandPlayer} message PokerWarRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PokerWarRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.GoldCoin = "";
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            object.GoldCoin = message.GoldCoin;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this PokerWarRandPlayer to JSON.
     * @function toJSON
     * @memberof PokerWarRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PokerWarRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PokerWarRandPlayer
     * @function getTypeUrl
     * @memberof PokerWarRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PokerWarRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PokerWarRandPlayer";
    };

    return PokerWarRandPlayer;
})();

export const Desk2PokerWarSrvPushRandPlayer = $root.Desk2PokerWarSrvPushRandPlayer = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushRandPlayer.
     * @exports IDesk2PokerWarSrvPushRandPlayer
     * @interface IDesk2PokerWarSrvPushRandPlayer
     * @property {Array.<IPokerWarRandPlayer>|null} [RandPlayer] Desk2PokerWarSrvPushRandPlayer RandPlayer
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushRandPlayer.
     * @exports Desk2PokerWarSrvPushRandPlayer
     * @classdesc Represents a Desk2PokerWarSrvPushRandPlayer.
     * @implements IDesk2PokerWarSrvPushRandPlayer
     * @constructor
     * @param {IDesk2PokerWarSrvPushRandPlayer=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushRandPlayer(properties) {
        this.RandPlayer = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushRandPlayer RandPlayer.
     * @member {Array.<IPokerWarRandPlayer>} RandPlayer
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @instance
     */
    Desk2PokerWarSrvPushRandPlayer.prototype.RandPlayer = $util.emptyArray;

    /**
     * Creates a new Desk2PokerWarSrvPushRandPlayer instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {IDesk2PokerWarSrvPushRandPlayer=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushRandPlayer} Desk2PokerWarSrvPushRandPlayer instance
     */
    Desk2PokerWarSrvPushRandPlayer.create = function create(properties) {
        return new Desk2PokerWarSrvPushRandPlayer(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushRandPlayer message. Does not implicitly {@link Desk2PokerWarSrvPushRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {IDesk2PokerWarSrvPushRandPlayer} message Desk2PokerWarSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RandPlayer != null && message.RandPlayer.length)
            for (let i = 0; i < message.RandPlayer.length; ++i)
                $root.PokerWarRandPlayer.encode(message.RandPlayer[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushRandPlayer message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {IDesk2PokerWarSrvPushRandPlayer} message Desk2PokerWarSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushRandPlayer} Desk2PokerWarSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.RandPlayer && message.RandPlayer.length))
                        message.RandPlayer = [];
                    message.RandPlayer.push($root.PokerWarRandPlayer.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushRandPlayer} Desk2PokerWarSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushRandPlayer message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RandPlayer != null && message.hasOwnProperty("RandPlayer")) {
            if (!Array.isArray(message.RandPlayer))
                return "RandPlayer: array expected";
            for (let i = 0; i < message.RandPlayer.length; ++i) {
                let error = $root.PokerWarRandPlayer.verify(message.RandPlayer[i]);
                if (error)
                    return "RandPlayer." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushRandPlayer} Desk2PokerWarSrvPushRandPlayer
     */
    Desk2PokerWarSrvPushRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushRandPlayer)
            return object;
        let message = new $root.Desk2PokerWarSrvPushRandPlayer();
        if (object.RandPlayer) {
            if (!Array.isArray(object.RandPlayer))
                throw TypeError(".Desk2PokerWarSrvPushRandPlayer.RandPlayer: array expected");
            message.RandPlayer = [];
            for (let i = 0; i < object.RandPlayer.length; ++i) {
                if (typeof object.RandPlayer[i] !== "object")
                    throw TypeError(".Desk2PokerWarSrvPushRandPlayer.RandPlayer: object expected");
                message.RandPlayer[i] = $root.PokerWarRandPlayer.fromObject(object.RandPlayer[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {Desk2PokerWarSrvPushRandPlayer} message Desk2PokerWarSrvPushRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RandPlayer = [];
        if (message.RandPlayer && message.RandPlayer.length) {
            object.RandPlayer = [];
            for (let j = 0; j < message.RandPlayer.length; ++j)
                object.RandPlayer[j] = $root.PokerWarRandPlayer.toObject(message.RandPlayer[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushRandPlayer to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushRandPlayer
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushRandPlayer";
    };

    return Desk2PokerWarSrvPushRandPlayer;
})();

export const Desk2PokerWarSrvPushTrend = $root.Desk2PokerWarSrvPushTrend = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushTrend.
     * @exports IDesk2PokerWarSrvPushTrend
     * @interface IDesk2PokerWarSrvPushTrend
     * @property {number|null} [UserID] Desk2PokerWarSrvPushTrend UserID
     * @property {Uint8Array|null} [Trend] Desk2PokerWarSrvPushTrend Trend
     * @property {Uint8Array|null} [Record] Desk2PokerWarSrvPushTrend Record
     * @property {Uint8Array|null} [CardTypeRecord] Desk2PokerWarSrvPushTrend CardTypeRecord
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushTrend.
     * @exports Desk2PokerWarSrvPushTrend
     * @classdesc Represents a Desk2PokerWarSrvPushTrend.
     * @implements IDesk2PokerWarSrvPushTrend
     * @constructor
     * @param {IDesk2PokerWarSrvPushTrend=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushTrend(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushTrend UserID.
     * @member {number} UserID
     * @memberof Desk2PokerWarSrvPushTrend
     * @instance
     */
    Desk2PokerWarSrvPushTrend.prototype.UserID = 0;

    /**
     * Desk2PokerWarSrvPushTrend Trend.
     * @member {Uint8Array} Trend
     * @memberof Desk2PokerWarSrvPushTrend
     * @instance
     */
    Desk2PokerWarSrvPushTrend.prototype.Trend = $util.newBuffer([]);

    /**
     * Desk2PokerWarSrvPushTrend Record.
     * @member {Uint8Array} Record
     * @memberof Desk2PokerWarSrvPushTrend
     * @instance
     */
    Desk2PokerWarSrvPushTrend.prototype.Record = $util.newBuffer([]);

    /**
     * Desk2PokerWarSrvPushTrend CardTypeRecord.
     * @member {Uint8Array} CardTypeRecord
     * @memberof Desk2PokerWarSrvPushTrend
     * @instance
     */
    Desk2PokerWarSrvPushTrend.prototype.CardTypeRecord = $util.newBuffer([]);

    /**
     * Creates a new Desk2PokerWarSrvPushTrend instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {IDesk2PokerWarSrvPushTrend=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushTrend} Desk2PokerWarSrvPushTrend instance
     */
    Desk2PokerWarSrvPushTrend.create = function create(properties) {
        return new Desk2PokerWarSrvPushTrend(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushTrend message. Does not implicitly {@link Desk2PokerWarSrvPushTrend.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {IDesk2PokerWarSrvPushTrend} message Desk2PokerWarSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushTrend.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Trend != null && Object.hasOwnProperty.call(message, "Trend"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Trend);
        if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Record);
        if (message.CardTypeRecord != null && Object.hasOwnProperty.call(message, "CardTypeRecord"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.CardTypeRecord);
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushTrend message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushTrend.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {IDesk2PokerWarSrvPushTrend} message Desk2PokerWarSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushTrend.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushTrend message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushTrend} Desk2PokerWarSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushTrend.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushTrend();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Trend = reader.bytes();
                    break;
                }
            case 3: {
                    message.Record = reader.bytes();
                    break;
                }
            case 4: {
                    message.CardTypeRecord = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushTrend message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushTrend} Desk2PokerWarSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushTrend.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushTrend message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushTrend.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            if (!(message.Trend && typeof message.Trend.length === "number" || $util.isString(message.Trend)))
                return "Trend: buffer expected";
        if (message.Record != null && message.hasOwnProperty("Record"))
            if (!(message.Record && typeof message.Record.length === "number" || $util.isString(message.Record)))
                return "Record: buffer expected";
        if (message.CardTypeRecord != null && message.hasOwnProperty("CardTypeRecord"))
            if (!(message.CardTypeRecord && typeof message.CardTypeRecord.length === "number" || $util.isString(message.CardTypeRecord)))
                return "CardTypeRecord: buffer expected";
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushTrend message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushTrend} Desk2PokerWarSrvPushTrend
     */
    Desk2PokerWarSrvPushTrend.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushTrend)
            return object;
        let message = new $root.Desk2PokerWarSrvPushTrend();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Trend != null)
            if (typeof object.Trend === "string")
                $util.base64.decode(object.Trend, message.Trend = $util.newBuffer($util.base64.length(object.Trend)), 0);
            else if (object.Trend.length >= 0)
                message.Trend = object.Trend;
        if (object.Record != null)
            if (typeof object.Record === "string")
                $util.base64.decode(object.Record, message.Record = $util.newBuffer($util.base64.length(object.Record)), 0);
            else if (object.Record.length >= 0)
                message.Record = object.Record;
        if (object.CardTypeRecord != null)
            if (typeof object.CardTypeRecord === "string")
                $util.base64.decode(object.CardTypeRecord, message.CardTypeRecord = $util.newBuffer($util.base64.length(object.CardTypeRecord)), 0);
            else if (object.CardTypeRecord.length >= 0)
                message.CardTypeRecord = object.CardTypeRecord;
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushTrend message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {Desk2PokerWarSrvPushTrend} message Desk2PokerWarSrvPushTrend
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushTrend.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Trend = "";
            else {
                object.Trend = [];
                if (options.bytes !== Array)
                    object.Trend = $util.newBuffer(object.Trend);
            }
            if (options.bytes === String)
                object.Record = "";
            else {
                object.Record = [];
                if (options.bytes !== Array)
                    object.Record = $util.newBuffer(object.Record);
            }
            if (options.bytes === String)
                object.CardTypeRecord = "";
            else {
                object.CardTypeRecord = [];
                if (options.bytes !== Array)
                    object.CardTypeRecord = $util.newBuffer(object.CardTypeRecord);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            object.Trend = options.bytes === String ? $util.base64.encode(message.Trend, 0, message.Trend.length) : options.bytes === Array ? Array.prototype.slice.call(message.Trend) : message.Trend;
        if (message.Record != null && message.hasOwnProperty("Record"))
            object.Record = options.bytes === String ? $util.base64.encode(message.Record, 0, message.Record.length) : options.bytes === Array ? Array.prototype.slice.call(message.Record) : message.Record;
        if (message.CardTypeRecord != null && message.hasOwnProperty("CardTypeRecord"))
            object.CardTypeRecord = options.bytes === String ? $util.base64.encode(message.CardTypeRecord, 0, message.CardTypeRecord.length) : options.bytes === Array ? Array.prototype.slice.call(message.CardTypeRecord) : message.CardTypeRecord;
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushTrend to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushTrend
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushTrend.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushTrend
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushTrend
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushTrend.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushTrend";
    };

    return Desk2PokerWarSrvPushTrend;
})();

export const Desk2PokerWarSrvPushLuckyStar = $root.Desk2PokerWarSrvPushLuckyStar = (() => {

    /**
     * Properties of a Desk2PokerWarSrvPushLuckyStar.
     * @exports IDesk2PokerWarSrvPushLuckyStar
     * @interface IDesk2PokerWarSrvPushLuckyStar
     * @property {number|null} [UserID] Desk2PokerWarSrvPushLuckyStar UserID
     * @property {number|null} [StarUserID] Desk2PokerWarSrvPushLuckyStar StarUserID
     * @property {Array.<number>|null} [Section] Desk2PokerWarSrvPushLuckyStar Section
     */

    /**
     * Constructs a new Desk2PokerWarSrvPushLuckyStar.
     * @exports Desk2PokerWarSrvPushLuckyStar
     * @classdesc Represents a Desk2PokerWarSrvPushLuckyStar.
     * @implements IDesk2PokerWarSrvPushLuckyStar
     * @constructor
     * @param {IDesk2PokerWarSrvPushLuckyStar=} [properties] Properties to set
     */
    function Desk2PokerWarSrvPushLuckyStar(properties) {
        this.Section = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2PokerWarSrvPushLuckyStar UserID.
     * @member {number} UserID
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @instance
     */
    Desk2PokerWarSrvPushLuckyStar.prototype.UserID = 0;

    /**
     * Desk2PokerWarSrvPushLuckyStar StarUserID.
     * @member {number} StarUserID
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @instance
     */
    Desk2PokerWarSrvPushLuckyStar.prototype.StarUserID = 0;

    /**
     * Desk2PokerWarSrvPushLuckyStar Section.
     * @member {Array.<number>} Section
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @instance
     */
    Desk2PokerWarSrvPushLuckyStar.prototype.Section = $util.emptyArray;

    /**
     * Creates a new Desk2PokerWarSrvPushLuckyStar instance using the specified properties.
     * @function create
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {IDesk2PokerWarSrvPushLuckyStar=} [properties] Properties to set
     * @returns {Desk2PokerWarSrvPushLuckyStar} Desk2PokerWarSrvPushLuckyStar instance
     */
    Desk2PokerWarSrvPushLuckyStar.create = function create(properties) {
        return new Desk2PokerWarSrvPushLuckyStar(properties);
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushLuckyStar message. Does not implicitly {@link Desk2PokerWarSrvPushLuckyStar.verify|verify} messages.
     * @function encode
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {IDesk2PokerWarSrvPushLuckyStar} message Desk2PokerWarSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushLuckyStar.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StarUserID != null && Object.hasOwnProperty.call(message, "StarUserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StarUserID);
        if (message.Section != null && message.Section.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.Section.length; ++i)
                writer.uint32(message.Section[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2PokerWarSrvPushLuckyStar message, length delimited. Does not implicitly {@link Desk2PokerWarSrvPushLuckyStar.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {IDesk2PokerWarSrvPushLuckyStar} message Desk2PokerWarSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2PokerWarSrvPushLuckyStar.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2PokerWarSrvPushLuckyStar message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2PokerWarSrvPushLuckyStar} Desk2PokerWarSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushLuckyStar.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2PokerWarSrvPushLuckyStar();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StarUserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Section && message.Section.length))
                        message.Section = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Section.push(reader.uint32());
                    } else
                        message.Section.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2PokerWarSrvPushLuckyStar message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2PokerWarSrvPushLuckyStar} Desk2PokerWarSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2PokerWarSrvPushLuckyStar.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2PokerWarSrvPushLuckyStar message.
     * @function verify
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2PokerWarSrvPushLuckyStar.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            if (!$util.isInteger(message.StarUserID))
                return "StarUserID: integer expected";
        if (message.Section != null && message.hasOwnProperty("Section")) {
            if (!Array.isArray(message.Section))
                return "Section: array expected";
            for (let i = 0; i < message.Section.length; ++i)
                if (!$util.isInteger(message.Section[i]))
                    return "Section: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2PokerWarSrvPushLuckyStar message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2PokerWarSrvPushLuckyStar} Desk2PokerWarSrvPushLuckyStar
     */
    Desk2PokerWarSrvPushLuckyStar.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2PokerWarSrvPushLuckyStar)
            return object;
        let message = new $root.Desk2PokerWarSrvPushLuckyStar();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StarUserID != null)
            message.StarUserID = object.StarUserID >>> 0;
        if (object.Section) {
            if (!Array.isArray(object.Section))
                throw TypeError(".Desk2PokerWarSrvPushLuckyStar.Section: array expected");
            message.Section = [];
            for (let i = 0; i < object.Section.length; ++i)
                message.Section[i] = object.Section[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2PokerWarSrvPushLuckyStar message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {Desk2PokerWarSrvPushLuckyStar} message Desk2PokerWarSrvPushLuckyStar
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2PokerWarSrvPushLuckyStar.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Section = [];
        if (options.defaults) {
            object.UserID = 0;
            object.StarUserID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            object.StarUserID = message.StarUserID;
        if (message.Section && message.Section.length) {
            object.Section = [];
            for (let j = 0; j < message.Section.length; ++j)
                object.Section[j] = message.Section[j];
        }
        return object;
    };

    /**
     * Converts this Desk2PokerWarSrvPushLuckyStar to JSON.
     * @function toJSON
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2PokerWarSrvPushLuckyStar.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2PokerWarSrvPushLuckyStar
     * @function getTypeUrl
     * @memberof Desk2PokerWarSrvPushLuckyStar
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2PokerWarSrvPushLuckyStar.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2PokerWarSrvPushLuckyStar";
    };

    return Desk2PokerWarSrvPushLuckyStar;
})();

export const Client2ProxyReqLogin = $root.Client2ProxyReqLogin = (() => {

    /**
     * Properties of a Client2ProxyReqLogin.
     * @exports IClient2ProxyReqLogin
     * @interface IClient2ProxyReqLogin
     * @property {number|null} [Origin] Client2ProxyReqLogin Origin
     * @property {string|null} [ClientMark] Client2ProxyReqLogin ClientMark
     * @property {string|null} [modileNum] Client2ProxyReqLogin modileNum
     * @property {number|null} [platformType] Client2ProxyReqLogin platformType
     * @property {number|null} [platform] Client2ProxyReqLogin platform
     * @property {number|null} [regChannel] Client2ProxyReqLogin regChannel
     * @property {number|null} [UserID] Client2ProxyReqLogin UserID
     * @property {string|null} [Password] Client2ProxyReqLogin Password
     * @property {string|null} [version] Client2ProxyReqLogin version
     * @property {number|null} [appVersion] Client2ProxyReqLogin appVersion
     * @property {number|null} [Type] Client2ProxyReqLogin Type
     * @property {string|null} [strAppID] Client2ProxyReqLogin strAppID
     * @property {string|null} [strSecret] Client2ProxyReqLogin strSecret
     * @property {string|null} [strToken] Client2ProxyReqLogin strToken
     * @property {string|null} [strOpenID] Client2ProxyReqLogin strOpenID
     * @property {number|null} [RecommendedUID] Client2ProxyReqLogin RecommendedUID
     * @property {number|null} [CheckVersion] Client2ProxyReqLogin CheckVersion
     * @property {string|null} [AppName] Client2ProxyReqLogin AppName
     * @property {string|null} [PackageName] Client2ProxyReqLogin PackageName
     * @property {number|null} [channel] Client2ProxyReqLogin channel
     * @property {string|null} [mobileType] Client2ProxyReqLogin mobileType
     * @property {string|null} [mobileOsVer] Client2ProxyReqLogin mobileOsVer
     * @property {string|null} [CheckLogin] Client2ProxyReqLogin CheckLogin
     */

    /**
     * Constructs a new Client2ProxyReqLogin.
     * @exports Client2ProxyReqLogin
     * @classdesc Represents a Client2ProxyReqLogin.
     * @implements IClient2ProxyReqLogin
     * @constructor
     * @param {IClient2ProxyReqLogin=} [properties] Properties to set
     */
    function Client2ProxyReqLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqLogin Origin.
     * @member {number} Origin
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.Origin = 0;

    /**
     * Client2ProxyReqLogin ClientMark.
     * @member {string} ClientMark
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.ClientMark = "";

    /**
     * Client2ProxyReqLogin modileNum.
     * @member {string} modileNum
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.modileNum = "";

    /**
     * Client2ProxyReqLogin platformType.
     * @member {number} platformType
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.platformType = 0;

    /**
     * Client2ProxyReqLogin platform.
     * @member {number} platform
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.platform = 0;

    /**
     * Client2ProxyReqLogin regChannel.
     * @member {number} regChannel
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.regChannel = 0;

    /**
     * Client2ProxyReqLogin UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.UserID = 0;

    /**
     * Client2ProxyReqLogin Password.
     * @member {string} Password
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.Password = "";

    /**
     * Client2ProxyReqLogin version.
     * @member {string} version
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.version = "";

    /**
     * Client2ProxyReqLogin appVersion.
     * @member {number} appVersion
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.appVersion = 0;

    /**
     * Client2ProxyReqLogin Type.
     * @member {number} Type
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.Type = 0;

    /**
     * Client2ProxyReqLogin strAppID.
     * @member {string} strAppID
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.strAppID = "";

    /**
     * Client2ProxyReqLogin strSecret.
     * @member {string} strSecret
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.strSecret = "";

    /**
     * Client2ProxyReqLogin strToken.
     * @member {string} strToken
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.strToken = "";

    /**
     * Client2ProxyReqLogin strOpenID.
     * @member {string} strOpenID
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.strOpenID = "";

    /**
     * Client2ProxyReqLogin RecommendedUID.
     * @member {number} RecommendedUID
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.RecommendedUID = 0;

    /**
     * Client2ProxyReqLogin CheckVersion.
     * @member {number} CheckVersion
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.CheckVersion = 0;

    /**
     * Client2ProxyReqLogin AppName.
     * @member {string} AppName
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.AppName = "";

    /**
     * Client2ProxyReqLogin PackageName.
     * @member {string} PackageName
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.PackageName = "";

    /**
     * Client2ProxyReqLogin channel.
     * @member {number} channel
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.channel = 0;

    /**
     * Client2ProxyReqLogin mobileType.
     * @member {string} mobileType
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.mobileType = "";

    /**
     * Client2ProxyReqLogin mobileOsVer.
     * @member {string} mobileOsVer
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.mobileOsVer = "";

    /**
     * Client2ProxyReqLogin CheckLogin.
     * @member {string} CheckLogin
     * @memberof Client2ProxyReqLogin
     * @instance
     */
    Client2ProxyReqLogin.prototype.CheckLogin = "";

    /**
     * Creates a new Client2ProxyReqLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {IClient2ProxyReqLogin=} [properties] Properties to set
     * @returns {Client2ProxyReqLogin} Client2ProxyReqLogin instance
     */
    Client2ProxyReqLogin.create = function create(properties) {
        return new Client2ProxyReqLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqLogin message. Does not implicitly {@link Client2ProxyReqLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {IClient2ProxyReqLogin} message Client2ProxyReqLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Origin != null && Object.hasOwnProperty.call(message, "Origin"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Origin);
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ClientMark);
        if (message.modileNum != null && Object.hasOwnProperty.call(message, "modileNum"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.modileNum);
        if (message.platformType != null && Object.hasOwnProperty.call(message, "platformType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.platformType);
        if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.platform);
        if (message.regChannel != null && Object.hasOwnProperty.call(message, "regChannel"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.regChannel);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.UserID);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.Password);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.version);
        if (message.appVersion != null && Object.hasOwnProperty.call(message, "appVersion"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.appVersion);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.Type);
        if (message.strAppID != null && Object.hasOwnProperty.call(message, "strAppID"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.strAppID);
        if (message.strSecret != null && Object.hasOwnProperty.call(message, "strSecret"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.strSecret);
        if (message.strToken != null && Object.hasOwnProperty.call(message, "strToken"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.strToken);
        if (message.strOpenID != null && Object.hasOwnProperty.call(message, "strOpenID"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.strOpenID);
        if (message.RecommendedUID != null && Object.hasOwnProperty.call(message, "RecommendedUID"))
            writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.RecommendedUID);
        if (message.CheckVersion != null && Object.hasOwnProperty.call(message, "CheckVersion"))
            writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.CheckVersion);
        if (message.AppName != null && Object.hasOwnProperty.call(message, "AppName"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.AppName);
        if (message.PackageName != null && Object.hasOwnProperty.call(message, "PackageName"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.PackageName);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.channel);
        if (message.mobileType != null && Object.hasOwnProperty.call(message, "mobileType"))
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.mobileType);
        if (message.mobileOsVer != null && Object.hasOwnProperty.call(message, "mobileOsVer"))
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.mobileOsVer);
        if (message.CheckLogin != null && Object.hasOwnProperty.call(message, "CheckLogin"))
            writer.uint32(/* id 23, wireType 2 =*/186).string(message.CheckLogin);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqLogin message, length delimited. Does not implicitly {@link Client2ProxyReqLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {IClient2ProxyReqLogin} message Client2ProxyReqLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqLogin} Client2ProxyReqLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Origin = reader.uint32();
                    break;
                }
            case 2: {
                    message.ClientMark = reader.string();
                    break;
                }
            case 3: {
                    message.modileNum = reader.string();
                    break;
                }
            case 4: {
                    message.platformType = reader.int32();
                    break;
                }
            case 5: {
                    message.platform = reader.int32();
                    break;
                }
            case 6: {
                    message.regChannel = reader.int32();
                    break;
                }
            case 7: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 8: {
                    message.Password = reader.string();
                    break;
                }
            case 9: {
                    message.version = reader.string();
                    break;
                }
            case 10: {
                    message.appVersion = reader.int32();
                    break;
                }
            case 11: {
                    message.Type = reader.int32();
                    break;
                }
            case 12: {
                    message.strAppID = reader.string();
                    break;
                }
            case 13: {
                    message.strSecret = reader.string();
                    break;
                }
            case 14: {
                    message.strToken = reader.string();
                    break;
                }
            case 15: {
                    message.strOpenID = reader.string();
                    break;
                }
            case 16: {
                    message.RecommendedUID = reader.uint32();
                    break;
                }
            case 17: {
                    message.CheckVersion = reader.uint32();
                    break;
                }
            case 18: {
                    message.AppName = reader.string();
                    break;
                }
            case 19: {
                    message.PackageName = reader.string();
                    break;
                }
            case 20: {
                    message.channel = reader.uint32();
                    break;
                }
            case 21: {
                    message.mobileType = reader.string();
                    break;
                }
            case 22: {
                    message.mobileOsVer = reader.string();
                    break;
                }
            case 23: {
                    message.CheckLogin = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqLogin} Client2ProxyReqLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqLogin message.
     * @function verify
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Origin != null && message.hasOwnProperty("Origin"))
            if (!$util.isInteger(message.Origin))
                return "Origin: integer expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            if (!$util.isString(message.modileNum))
                return "modileNum: string expected";
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            if (!$util.isInteger(message.platformType))
                return "platformType: integer expected";
        if (message.platform != null && message.hasOwnProperty("platform"))
            if (!$util.isInteger(message.platform))
                return "platform: integer expected";
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            if (!$util.isInteger(message.regChannel))
                return "regChannel: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            if (!$util.isInteger(message.appVersion))
                return "appVersion: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.strAppID != null && message.hasOwnProperty("strAppID"))
            if (!$util.isString(message.strAppID))
                return "strAppID: string expected";
        if (message.strSecret != null && message.hasOwnProperty("strSecret"))
            if (!$util.isString(message.strSecret))
                return "strSecret: string expected";
        if (message.strToken != null && message.hasOwnProperty("strToken"))
            if (!$util.isString(message.strToken))
                return "strToken: string expected";
        if (message.strOpenID != null && message.hasOwnProperty("strOpenID"))
            if (!$util.isString(message.strOpenID))
                return "strOpenID: string expected";
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            if (!$util.isInteger(message.RecommendedUID))
                return "RecommendedUID: integer expected";
        if (message.CheckVersion != null && message.hasOwnProperty("CheckVersion"))
            if (!$util.isInteger(message.CheckVersion))
                return "CheckVersion: integer expected";
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            if (!$util.isString(message.AppName))
                return "AppName: string expected";
        if (message.PackageName != null && message.hasOwnProperty("PackageName"))
            if (!$util.isString(message.PackageName))
                return "PackageName: string expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isInteger(message.channel))
                return "channel: integer expected";
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            if (!$util.isString(message.mobileType))
                return "mobileType: string expected";
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            if (!$util.isString(message.mobileOsVer))
                return "mobileOsVer: string expected";
        if (message.CheckLogin != null && message.hasOwnProperty("CheckLogin"))
            if (!$util.isString(message.CheckLogin))
                return "CheckLogin: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqLogin} Client2ProxyReqLogin
     */
    Client2ProxyReqLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqLogin)
            return object;
        let message = new $root.Client2ProxyReqLogin();
        if (object.Origin != null)
            message.Origin = object.Origin >>> 0;
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        if (object.modileNum != null)
            message.modileNum = String(object.modileNum);
        if (object.platformType != null)
            message.platformType = object.platformType | 0;
        if (object.platform != null)
            message.platform = object.platform | 0;
        if (object.regChannel != null)
            message.regChannel = object.regChannel | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Password != null)
            message.Password = String(object.Password);
        if (object.version != null)
            message.version = String(object.version);
        if (object.appVersion != null)
            message.appVersion = object.appVersion | 0;
        if (object.Type != null)
            message.Type = object.Type | 0;
        if (object.strAppID != null)
            message.strAppID = String(object.strAppID);
        if (object.strSecret != null)
            message.strSecret = String(object.strSecret);
        if (object.strToken != null)
            message.strToken = String(object.strToken);
        if (object.strOpenID != null)
            message.strOpenID = String(object.strOpenID);
        if (object.RecommendedUID != null)
            message.RecommendedUID = object.RecommendedUID >>> 0;
        if (object.CheckVersion != null)
            message.CheckVersion = object.CheckVersion >>> 0;
        if (object.AppName != null)
            message.AppName = String(object.AppName);
        if (object.PackageName != null)
            message.PackageName = String(object.PackageName);
        if (object.channel != null)
            message.channel = object.channel >>> 0;
        if (object.mobileType != null)
            message.mobileType = String(object.mobileType);
        if (object.mobileOsVer != null)
            message.mobileOsVer = String(object.mobileOsVer);
        if (object.CheckLogin != null)
            message.CheckLogin = String(object.CheckLogin);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {Client2ProxyReqLogin} message Client2ProxyReqLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Origin = 0;
            object.ClientMark = "";
            object.modileNum = "";
            object.platformType = 0;
            object.platform = 0;
            object.regChannel = 0;
            object.UserID = 0;
            object.Password = "";
            object.version = "";
            object.appVersion = 0;
            object.Type = 0;
            object.strAppID = "";
            object.strSecret = "";
            object.strToken = "";
            object.strOpenID = "";
            object.RecommendedUID = 0;
            object.CheckVersion = 0;
            object.AppName = "";
            object.PackageName = "";
            object.channel = 0;
            object.mobileType = "";
            object.mobileOsVer = "";
            object.CheckLogin = "";
        }
        if (message.Origin != null && message.hasOwnProperty("Origin"))
            object.Origin = message.Origin;
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            object.modileNum = message.modileNum;
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            object.platformType = message.platformType;
        if (message.platform != null && message.hasOwnProperty("platform"))
            object.platform = message.platform;
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            object.regChannel = message.regChannel;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            object.appVersion = message.appVersion;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.strAppID != null && message.hasOwnProperty("strAppID"))
            object.strAppID = message.strAppID;
        if (message.strSecret != null && message.hasOwnProperty("strSecret"))
            object.strSecret = message.strSecret;
        if (message.strToken != null && message.hasOwnProperty("strToken"))
            object.strToken = message.strToken;
        if (message.strOpenID != null && message.hasOwnProperty("strOpenID"))
            object.strOpenID = message.strOpenID;
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            object.RecommendedUID = message.RecommendedUID;
        if (message.CheckVersion != null && message.hasOwnProperty("CheckVersion"))
            object.CheckVersion = message.CheckVersion;
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            object.AppName = message.AppName;
        if (message.PackageName != null && message.hasOwnProperty("PackageName"))
            object.PackageName = message.PackageName;
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            object.mobileType = message.mobileType;
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            object.mobileOsVer = message.mobileOsVer;
        if (message.CheckLogin != null && message.hasOwnProperty("CheckLogin"))
            object.CheckLogin = message.CheckLogin;
        return object;
    };

    /**
     * Converts this Client2ProxyReqLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqLogin
     * @function getTypeUrl
     * @memberof Client2ProxyReqLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqLogin";
    };

    return Client2ProxyReqLogin;
})();

export const Client2ProxyAckLogin = $root.Client2ProxyAckLogin = (() => {

    /**
     * Properties of a Client2ProxyAckLogin.
     * @exports IClient2ProxyAckLogin
     * @interface IClient2ProxyAckLogin
     * @property {number|null} [Ret] Client2ProxyAckLogin Ret
     * @property {IUserInfo|null} [userInfo] Client2ProxyAckLogin userInfo
     * @property {number|null} [GameID] Client2ProxyAckLogin GameID
     * @property {boolean|null} [FirstTime] Client2ProxyAckLogin FirstTime
     * @property {boolean|null} [SendMoney] Client2ProxyAckLogin SendMoney
     */

    /**
     * Constructs a new Client2ProxyAckLogin.
     * @exports Client2ProxyAckLogin
     * @classdesc Represents a Client2ProxyAckLogin.
     * @implements IClient2ProxyAckLogin
     * @constructor
     * @param {IClient2ProxyAckLogin=} [properties] Properties to set
     */
    function Client2ProxyAckLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckLogin Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckLogin
     * @instance
     */
    Client2ProxyAckLogin.prototype.Ret = 0;

    /**
     * Client2ProxyAckLogin userInfo.
     * @member {IUserInfo|null|undefined} userInfo
     * @memberof Client2ProxyAckLogin
     * @instance
     */
    Client2ProxyAckLogin.prototype.userInfo = null;

    /**
     * Client2ProxyAckLogin GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckLogin
     * @instance
     */
    Client2ProxyAckLogin.prototype.GameID = 0;

    /**
     * Client2ProxyAckLogin FirstTime.
     * @member {boolean} FirstTime
     * @memberof Client2ProxyAckLogin
     * @instance
     */
    Client2ProxyAckLogin.prototype.FirstTime = false;

    /**
     * Client2ProxyAckLogin SendMoney.
     * @member {boolean} SendMoney
     * @memberof Client2ProxyAckLogin
     * @instance
     */
    Client2ProxyAckLogin.prototype.SendMoney = false;

    /**
     * Creates a new Client2ProxyAckLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {IClient2ProxyAckLogin=} [properties] Properties to set
     * @returns {Client2ProxyAckLogin} Client2ProxyAckLogin instance
     */
    Client2ProxyAckLogin.create = function create(properties) {
        return new Client2ProxyAckLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckLogin message. Does not implicitly {@link Client2ProxyAckLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {IClient2ProxyAckLogin} message Client2ProxyAckLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
            $root.UserInfo.encode(message.userInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.FirstTime != null && Object.hasOwnProperty.call(message, "FirstTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.FirstTime);
        if (message.SendMoney != null && Object.hasOwnProperty.call(message, "SendMoney"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.SendMoney);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckLogin message, length delimited. Does not implicitly {@link Client2ProxyAckLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {IClient2ProxyAckLogin} message Client2ProxyAckLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckLogin} Client2ProxyAckLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.userInfo = $root.UserInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.FirstTime = reader.bool();
                    break;
                }
            case 5: {
                    message.SendMoney = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckLogin} Client2ProxyAckLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckLogin message.
     * @function verify
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
            let error = $root.UserInfo.verify(message.userInfo);
            if (error)
                return "userInfo." + error;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            if (typeof message.FirstTime !== "boolean")
                return "FirstTime: boolean expected";
        if (message.SendMoney != null && message.hasOwnProperty("SendMoney"))
            if (typeof message.SendMoney !== "boolean")
                return "SendMoney: boolean expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckLogin} Client2ProxyAckLogin
     */
    Client2ProxyAckLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckLogin)
            return object;
        let message = new $root.Client2ProxyAckLogin();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.userInfo != null) {
            if (typeof object.userInfo !== "object")
                throw TypeError(".Client2ProxyAckLogin.userInfo: object expected");
            message.userInfo = $root.UserInfo.fromObject(object.userInfo);
        }
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.FirstTime != null)
            message.FirstTime = Boolean(object.FirstTime);
        if (object.SendMoney != null)
            message.SendMoney = Boolean(object.SendMoney);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {Client2ProxyAckLogin} message Client2ProxyAckLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.userInfo = null;
            object.GameID = 0;
            object.FirstTime = false;
            object.SendMoney = false;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.userInfo != null && message.hasOwnProperty("userInfo"))
            object.userInfo = $root.UserInfo.toObject(message.userInfo, options);
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            object.FirstTime = message.FirstTime;
        if (message.SendMoney != null && message.hasOwnProperty("SendMoney"))
            object.SendMoney = message.SendMoney;
        return object;
    };

    /**
     * Converts this Client2ProxyAckLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckLogin
     * @function getTypeUrl
     * @memberof Client2ProxyAckLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckLogin";
    };

    return Client2ProxyAckLogin;
})();

export const Client2ProxyReqLogout = $root.Client2ProxyReqLogout = (() => {

    /**
     * Properties of a Client2ProxyReqLogout.
     * @exports IClient2ProxyReqLogout
     * @interface IClient2ProxyReqLogout
     * @property {number|null} [UserID] Client2ProxyReqLogout UserID
     */

    /**
     * Constructs a new Client2ProxyReqLogout.
     * @exports Client2ProxyReqLogout
     * @classdesc Represents a Client2ProxyReqLogout.
     * @implements IClient2ProxyReqLogout
     * @constructor
     * @param {IClient2ProxyReqLogout=} [properties] Properties to set
     */
    function Client2ProxyReqLogout(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqLogout UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqLogout
     * @instance
     */
    Client2ProxyReqLogout.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqLogout instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {IClient2ProxyReqLogout=} [properties] Properties to set
     * @returns {Client2ProxyReqLogout} Client2ProxyReqLogout instance
     */
    Client2ProxyReqLogout.create = function create(properties) {
        return new Client2ProxyReqLogout(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqLogout message. Does not implicitly {@link Client2ProxyReqLogout.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {IClient2ProxyReqLogout} message Client2ProxyReqLogout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLogout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqLogout message, length delimited. Does not implicitly {@link Client2ProxyReqLogout.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {IClient2ProxyReqLogout} message Client2ProxyReqLogout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLogout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqLogout message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqLogout} Client2ProxyReqLogout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLogout.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqLogout();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqLogout message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqLogout} Client2ProxyReqLogout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLogout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqLogout message.
     * @function verify
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqLogout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqLogout message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqLogout} Client2ProxyReqLogout
     */
    Client2ProxyReqLogout.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqLogout)
            return object;
        let message = new $root.Client2ProxyReqLogout();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqLogout message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {Client2ProxyReqLogout} message Client2ProxyReqLogout
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqLogout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqLogout to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqLogout
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqLogout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqLogout
     * @function getTypeUrl
     * @memberof Client2ProxyReqLogout
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqLogout.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqLogout";
    };

    return Client2ProxyReqLogout;
})();

export const Client2ProxyAckLogout = $root.Client2ProxyAckLogout = (() => {

    /**
     * Properties of a Client2ProxyAckLogout.
     * @exports IClient2ProxyAckLogout
     * @interface IClient2ProxyAckLogout
     * @property {number|null} [Ret] Client2ProxyAckLogout Ret
     * @property {number|null} [UserID] Client2ProxyAckLogout UserID
     */

    /**
     * Constructs a new Client2ProxyAckLogout.
     * @exports Client2ProxyAckLogout
     * @classdesc Represents a Client2ProxyAckLogout.
     * @implements IClient2ProxyAckLogout
     * @constructor
     * @param {IClient2ProxyAckLogout=} [properties] Properties to set
     */
    function Client2ProxyAckLogout(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckLogout Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckLogout
     * @instance
     */
    Client2ProxyAckLogout.prototype.Ret = 0;

    /**
     * Client2ProxyAckLogout UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckLogout
     * @instance
     */
    Client2ProxyAckLogout.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckLogout instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {IClient2ProxyAckLogout=} [properties] Properties to set
     * @returns {Client2ProxyAckLogout} Client2ProxyAckLogout instance
     */
    Client2ProxyAckLogout.create = function create(properties) {
        return new Client2ProxyAckLogout(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckLogout message. Does not implicitly {@link Client2ProxyAckLogout.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {IClient2ProxyAckLogout} message Client2ProxyAckLogout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLogout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckLogout message, length delimited. Does not implicitly {@link Client2ProxyAckLogout.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {IClient2ProxyAckLogout} message Client2ProxyAckLogout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLogout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckLogout message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckLogout} Client2ProxyAckLogout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLogout.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckLogout();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckLogout message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckLogout} Client2ProxyAckLogout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLogout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckLogout message.
     * @function verify
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckLogout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckLogout message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckLogout} Client2ProxyAckLogout
     */
    Client2ProxyAckLogout.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckLogout)
            return object;
        let message = new $root.Client2ProxyAckLogout();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckLogout message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {Client2ProxyAckLogout} message Client2ProxyAckLogout
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckLogout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckLogout to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckLogout
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckLogout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckLogout
     * @function getTypeUrl
     * @memberof Client2ProxyAckLogout
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckLogout.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckLogout";
    };

    return Client2ProxyAckLogout;
})();

export const Client2ProxyReqPokerProduct = $root.Client2ProxyReqPokerProduct = (() => {

    /**
     * Properties of a Client2ProxyReqPokerProduct.
     * @exports IClient2ProxyReqPokerProduct
     * @interface IClient2ProxyReqPokerProduct
     * @property {number|null} [UserID] Client2ProxyReqPokerProduct UserID
     * @property {number|null} [GameID] Client2ProxyReqPokerProduct GameID
     */

    /**
     * Constructs a new Client2ProxyReqPokerProduct.
     * @exports Client2ProxyReqPokerProduct
     * @classdesc Represents a Client2ProxyReqPokerProduct.
     * @implements IClient2ProxyReqPokerProduct
     * @constructor
     * @param {IClient2ProxyReqPokerProduct=} [properties] Properties to set
     */
    function Client2ProxyReqPokerProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqPokerProduct UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqPokerProduct
     * @instance
     */
    Client2ProxyReqPokerProduct.prototype.UserID = 0;

    /**
     * Client2ProxyReqPokerProduct GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqPokerProduct
     * @instance
     */
    Client2ProxyReqPokerProduct.prototype.GameID = 0;

    /**
     * Creates a new Client2ProxyReqPokerProduct instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {IClient2ProxyReqPokerProduct=} [properties] Properties to set
     * @returns {Client2ProxyReqPokerProduct} Client2ProxyReqPokerProduct instance
     */
    Client2ProxyReqPokerProduct.create = function create(properties) {
        return new Client2ProxyReqPokerProduct(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqPokerProduct message. Does not implicitly {@link Client2ProxyReqPokerProduct.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {IClient2ProxyReqPokerProduct} message Client2ProxyReqPokerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPokerProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqPokerProduct message, length delimited. Does not implicitly {@link Client2ProxyReqPokerProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {IClient2ProxyReqPokerProduct} message Client2ProxyReqPokerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPokerProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqPokerProduct message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqPokerProduct} Client2ProxyReqPokerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPokerProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqPokerProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqPokerProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqPokerProduct} Client2ProxyReqPokerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPokerProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqPokerProduct message.
     * @function verify
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqPokerProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqPokerProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqPokerProduct} Client2ProxyReqPokerProduct
     */
    Client2ProxyReqPokerProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqPokerProduct)
            return object;
        let message = new $root.Client2ProxyReqPokerProduct();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqPokerProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {Client2ProxyReqPokerProduct} message Client2ProxyReqPokerProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqPokerProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqPokerProduct to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqPokerProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqPokerProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqPokerProduct
     * @function getTypeUrl
     * @memberof Client2ProxyReqPokerProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqPokerProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqPokerProduct";
    };

    return Client2ProxyReqPokerProduct;
})();

export const Client2ProxyAckPokerProduct = $root.Client2ProxyAckPokerProduct = (() => {

    /**
     * Properties of a Client2ProxyAckPokerProduct.
     * @exports IClient2ProxyAckPokerProduct
     * @interface IClient2ProxyAckPokerProduct
     * @property {number|null} [Ret] Client2ProxyAckPokerProduct Ret
     * @property {number|null} [UserID] Client2ProxyAckPokerProduct UserID
     * @property {number|null} [GameID] Client2ProxyAckPokerProduct GameID
     * @property {Array.<IPorkerProudct>|null} [ProductList] Client2ProxyAckPokerProduct ProductList
     */

    /**
     * Constructs a new Client2ProxyAckPokerProduct.
     * @exports Client2ProxyAckPokerProduct
     * @classdesc Represents a Client2ProxyAckPokerProduct.
     * @implements IClient2ProxyAckPokerProduct
     * @constructor
     * @param {IClient2ProxyAckPokerProduct=} [properties] Properties to set
     */
    function Client2ProxyAckPokerProduct(properties) {
        this.ProductList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPokerProduct Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckPokerProduct
     * @instance
     */
    Client2ProxyAckPokerProduct.prototype.Ret = 0;

    /**
     * Client2ProxyAckPokerProduct UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckPokerProduct
     * @instance
     */
    Client2ProxyAckPokerProduct.prototype.UserID = 0;

    /**
     * Client2ProxyAckPokerProduct GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckPokerProduct
     * @instance
     */
    Client2ProxyAckPokerProduct.prototype.GameID = 0;

    /**
     * Client2ProxyAckPokerProduct ProductList.
     * @member {Array.<IPorkerProudct>} ProductList
     * @memberof Client2ProxyAckPokerProduct
     * @instance
     */
    Client2ProxyAckPokerProduct.prototype.ProductList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckPokerProduct instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {IClient2ProxyAckPokerProduct=} [properties] Properties to set
     * @returns {Client2ProxyAckPokerProduct} Client2ProxyAckPokerProduct instance
     */
    Client2ProxyAckPokerProduct.create = function create(properties) {
        return new Client2ProxyAckPokerProduct(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPokerProduct message. Does not implicitly {@link Client2ProxyAckPokerProduct.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {IClient2ProxyAckPokerProduct} message Client2ProxyAckPokerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPokerProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductList != null && message.ProductList.length)
            for (let i = 0; i < message.ProductList.length; ++i)
                $root.PorkerProudct.encode(message.ProductList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPokerProduct message, length delimited. Does not implicitly {@link Client2ProxyAckPokerProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {IClient2ProxyAckPokerProduct} message Client2ProxyAckPokerProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPokerProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPokerProduct message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPokerProduct} Client2ProxyAckPokerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPokerProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPokerProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.ProductList && message.ProductList.length))
                        message.ProductList = [];
                    message.ProductList.push($root.PorkerProudct.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPokerProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPokerProduct} Client2ProxyAckPokerProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPokerProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPokerProduct message.
     * @function verify
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPokerProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductList != null && message.hasOwnProperty("ProductList")) {
            if (!Array.isArray(message.ProductList))
                return "ProductList: array expected";
            for (let i = 0; i < message.ProductList.length; ++i) {
                let error = $root.PorkerProudct.verify(message.ProductList[i]);
                if (error)
                    return "ProductList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckPokerProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPokerProduct} Client2ProxyAckPokerProduct
     */
    Client2ProxyAckPokerProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPokerProduct)
            return object;
        let message = new $root.Client2ProxyAckPokerProduct();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductList) {
            if (!Array.isArray(object.ProductList))
                throw TypeError(".Client2ProxyAckPokerProduct.ProductList: array expected");
            message.ProductList = [];
            for (let i = 0; i < object.ProductList.length; ++i) {
                if (typeof object.ProductList[i] !== "object")
                    throw TypeError(".Client2ProxyAckPokerProduct.ProductList: object expected");
                message.ProductList[i] = $root.PorkerProudct.fromObject(object.ProductList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPokerProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {Client2ProxyAckPokerProduct} message Client2ProxyAckPokerProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPokerProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ProductList = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductList && message.ProductList.length) {
            object.ProductList = [];
            for (let j = 0; j < message.ProductList.length; ++j)
                object.ProductList[j] = $root.PorkerProudct.toObject(message.ProductList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckPokerProduct to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPokerProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPokerProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPokerProduct
     * @function getTypeUrl
     * @memberof Client2ProxyAckPokerProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPokerProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPokerProduct";
    };

    return Client2ProxyAckPokerProduct;
})();

export const Client2ProxyReqEnterGame = $root.Client2ProxyReqEnterGame = (() => {

    /**
     * Properties of a Client2ProxyReqEnterGame.
     * @exports IClient2ProxyReqEnterGame
     * @interface IClient2ProxyReqEnterGame
     * @property {number|null} [UserID] Client2ProxyReqEnterGame UserID
     * @property {number|null} [ChannelID] Client2ProxyReqEnterGame ChannelID
     * @property {number|null} [GameID] Client2ProxyReqEnterGame GameID
     * @property {number|null} [ProdcutID] Client2ProxyReqEnterGame ProdcutID
     */

    /**
     * Constructs a new Client2ProxyReqEnterGame.
     * @exports Client2ProxyReqEnterGame
     * @classdesc Represents a Client2ProxyReqEnterGame.
     * @implements IClient2ProxyReqEnterGame
     * @constructor
     * @param {IClient2ProxyReqEnterGame=} [properties] Properties to set
     */
    function Client2ProxyReqEnterGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqEnterGame UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqEnterGame
     * @instance
     */
    Client2ProxyReqEnterGame.prototype.UserID = 0;

    /**
     * Client2ProxyReqEnterGame ChannelID.
     * @member {number} ChannelID
     * @memberof Client2ProxyReqEnterGame
     * @instance
     */
    Client2ProxyReqEnterGame.prototype.ChannelID = 0;

    /**
     * Client2ProxyReqEnterGame GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqEnterGame
     * @instance
     */
    Client2ProxyReqEnterGame.prototype.GameID = 0;

    /**
     * Client2ProxyReqEnterGame ProdcutID.
     * @member {number} ProdcutID
     * @memberof Client2ProxyReqEnterGame
     * @instance
     */
    Client2ProxyReqEnterGame.prototype.ProdcutID = 0;

    /**
     * Creates a new Client2ProxyReqEnterGame instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {IClient2ProxyReqEnterGame=} [properties] Properties to set
     * @returns {Client2ProxyReqEnterGame} Client2ProxyReqEnterGame instance
     */
    Client2ProxyReqEnterGame.create = function create(properties) {
        return new Client2ProxyReqEnterGame(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqEnterGame message. Does not implicitly {@link Client2ProxyReqEnterGame.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {IClient2ProxyReqEnterGame} message Client2ProxyReqEnterGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqEnterGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProdcutID != null && Object.hasOwnProperty.call(message, "ProdcutID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProdcutID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqEnterGame message, length delimited. Does not implicitly {@link Client2ProxyReqEnterGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {IClient2ProxyReqEnterGame} message Client2ProxyReqEnterGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqEnterGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqEnterGame message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqEnterGame} Client2ProxyReqEnterGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqEnterGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqEnterGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProdcutID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqEnterGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqEnterGame} Client2ProxyReqEnterGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqEnterGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqEnterGame message.
     * @function verify
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqEnterGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            if (!$util.isInteger(message.ProdcutID))
                return "ProdcutID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqEnterGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqEnterGame} Client2ProxyReqEnterGame
     */
    Client2ProxyReqEnterGame.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqEnterGame)
            return object;
        let message = new $root.Client2ProxyReqEnterGame();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutID != null)
            message.ProdcutID = object.ProdcutID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqEnterGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {Client2ProxyReqEnterGame} message Client2ProxyReqEnterGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqEnterGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.GameID = 0;
            object.ProdcutID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            object.ProdcutID = message.ProdcutID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqEnterGame to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqEnterGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqEnterGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqEnterGame
     * @function getTypeUrl
     * @memberof Client2ProxyReqEnterGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqEnterGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqEnterGame";
    };

    return Client2ProxyReqEnterGame;
})();

export const Client2ProxyAckEnterGame = $root.Client2ProxyAckEnterGame = (() => {

    /**
     * Properties of a Client2ProxyAckEnterGame.
     * @exports IClient2ProxyAckEnterGame
     * @interface IClient2ProxyAckEnterGame
     * @property {number|null} [Ret] Client2ProxyAckEnterGame Ret
     * @property {number|null} [UserID] Client2ProxyAckEnterGame UserID
     * @property {number|null} [ChannelID] Client2ProxyAckEnterGame ChannelID
     * @property {number|null} [GameID] Client2ProxyAckEnterGame GameID
     * @property {number|null} [ProdcutID] Client2ProxyAckEnterGame ProdcutID
     * @property {number|null} [DeskNumber] Client2ProxyAckEnterGame DeskNumber
     * @property {number|null} [SeatNo] Client2ProxyAckEnterGame SeatNo
     */

    /**
     * Constructs a new Client2ProxyAckEnterGame.
     * @exports Client2ProxyAckEnterGame
     * @classdesc Represents a Client2ProxyAckEnterGame.
     * @implements IClient2ProxyAckEnterGame
     * @constructor
     * @param {IClient2ProxyAckEnterGame=} [properties] Properties to set
     */
    function Client2ProxyAckEnterGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckEnterGame Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.Ret = 0;

    /**
     * Client2ProxyAckEnterGame UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.UserID = 0;

    /**
     * Client2ProxyAckEnterGame ChannelID.
     * @member {number} ChannelID
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.ChannelID = 0;

    /**
     * Client2ProxyAckEnterGame GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.GameID = 0;

    /**
     * Client2ProxyAckEnterGame ProdcutID.
     * @member {number} ProdcutID
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.ProdcutID = 0;

    /**
     * Client2ProxyAckEnterGame DeskNumber.
     * @member {number} DeskNumber
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.DeskNumber = 0;

    /**
     * Client2ProxyAckEnterGame SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ProxyAckEnterGame
     * @instance
     */
    Client2ProxyAckEnterGame.prototype.SeatNo = 0;

    /**
     * Creates a new Client2ProxyAckEnterGame instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {IClient2ProxyAckEnterGame=} [properties] Properties to set
     * @returns {Client2ProxyAckEnterGame} Client2ProxyAckEnterGame instance
     */
    Client2ProxyAckEnterGame.create = function create(properties) {
        return new Client2ProxyAckEnterGame(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckEnterGame message. Does not implicitly {@link Client2ProxyAckEnterGame.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {IClient2ProxyAckEnterGame} message Client2ProxyAckEnterGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckEnterGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GameID);
        if (message.ProdcutID != null && Object.hasOwnProperty.call(message, "ProdcutID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.ProdcutID);
        if (message.DeskNumber != null && Object.hasOwnProperty.call(message, "DeskNumber"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.DeskNumber);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckEnterGame message, length delimited. Does not implicitly {@link Client2ProxyAckEnterGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {IClient2ProxyAckEnterGame} message Client2ProxyAckEnterGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckEnterGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckEnterGame message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckEnterGame} Client2ProxyAckEnterGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckEnterGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckEnterGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 5: {
                    message.ProdcutID = reader.uint32();
                    break;
                }
            case 6: {
                    message.DeskNumber = reader.uint32();
                    break;
                }
            case 7: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckEnterGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckEnterGame} Client2ProxyAckEnterGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckEnterGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckEnterGame message.
     * @function verify
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckEnterGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            if (!$util.isInteger(message.ProdcutID))
                return "ProdcutID: integer expected";
        if (message.DeskNumber != null && message.hasOwnProperty("DeskNumber"))
            if (!$util.isInteger(message.DeskNumber))
                return "DeskNumber: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckEnterGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckEnterGame} Client2ProxyAckEnterGame
     */
    Client2ProxyAckEnterGame.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckEnterGame)
            return object;
        let message = new $root.Client2ProxyAckEnterGame();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutID != null)
            message.ProdcutID = object.ProdcutID >>> 0;
        if (object.DeskNumber != null)
            message.DeskNumber = object.DeskNumber >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckEnterGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {Client2ProxyAckEnterGame} message Client2ProxyAckEnterGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckEnterGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.GameID = 0;
            object.ProdcutID = 0;
            object.DeskNumber = 0;
            object.SeatNo = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            object.ProdcutID = message.ProdcutID;
        if (message.DeskNumber != null && message.hasOwnProperty("DeskNumber"))
            object.DeskNumber = message.DeskNumber;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2ProxyAckEnterGame to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckEnterGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckEnterGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckEnterGame
     * @function getTypeUrl
     * @memberof Client2ProxyAckEnterGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckEnterGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckEnterGame";
    };

    return Client2ProxyAckEnterGame;
})();

export const Client2ProxyReqMobileRegister = $root.Client2ProxyReqMobileRegister = (() => {

    /**
     * Properties of a Client2ProxyReqMobileRegister.
     * @exports IClient2ProxyReqMobileRegister
     * @interface IClient2ProxyReqMobileRegister
     * @property {string|null} [PhoneNumber] Client2ProxyReqMobileRegister PhoneNumber
     * @property {string|null} [SmsCode] Client2ProxyReqMobileRegister SmsCode
     * @property {string|null} [Password] Client2ProxyReqMobileRegister Password
     * @property {number|null} [platformType] Client2ProxyReqMobileRegister platformType
     * @property {number|null} [platform] Client2ProxyReqMobileRegister platform
     * @property {number|null} [regChannel] Client2ProxyReqMobileRegister regChannel
     * @property {string|null} [ClientMark] Client2ProxyReqMobileRegister ClientMark
     * @property {number|null} [RecommendedUID] Client2ProxyReqMobileRegister RecommendedUID
     */

    /**
     * Constructs a new Client2ProxyReqMobileRegister.
     * @exports Client2ProxyReqMobileRegister
     * @classdesc Represents a Client2ProxyReqMobileRegister.
     * @implements IClient2ProxyReqMobileRegister
     * @constructor
     * @param {IClient2ProxyReqMobileRegister=} [properties] Properties to set
     */
    function Client2ProxyReqMobileRegister(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMobileRegister PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.PhoneNumber = "";

    /**
     * Client2ProxyReqMobileRegister SmsCode.
     * @member {string} SmsCode
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.SmsCode = "";

    /**
     * Client2ProxyReqMobileRegister Password.
     * @member {string} Password
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.Password = "";

    /**
     * Client2ProxyReqMobileRegister platformType.
     * @member {number} platformType
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.platformType = 0;

    /**
     * Client2ProxyReqMobileRegister platform.
     * @member {number} platform
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.platform = 0;

    /**
     * Client2ProxyReqMobileRegister regChannel.
     * @member {number} regChannel
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.regChannel = 0;

    /**
     * Client2ProxyReqMobileRegister ClientMark.
     * @member {string} ClientMark
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.ClientMark = "";

    /**
     * Client2ProxyReqMobileRegister RecommendedUID.
     * @member {number} RecommendedUID
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     */
    Client2ProxyReqMobileRegister.prototype.RecommendedUID = 0;

    /**
     * Creates a new Client2ProxyReqMobileRegister instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {IClient2ProxyReqMobileRegister=} [properties] Properties to set
     * @returns {Client2ProxyReqMobileRegister} Client2ProxyReqMobileRegister instance
     */
    Client2ProxyReqMobileRegister.create = function create(properties) {
        return new Client2ProxyReqMobileRegister(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMobileRegister message. Does not implicitly {@link Client2ProxyReqMobileRegister.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {IClient2ProxyReqMobileRegister} message Client2ProxyReqMobileRegister message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileRegister.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.PhoneNumber);
        if (message.SmsCode != null && Object.hasOwnProperty.call(message, "SmsCode"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SmsCode);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Password);
        if (message.platformType != null && Object.hasOwnProperty.call(message, "platformType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.platformType);
        if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.platform);
        if (message.regChannel != null && Object.hasOwnProperty.call(message, "regChannel"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.regChannel);
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ClientMark);
        if (message.RecommendedUID != null && Object.hasOwnProperty.call(message, "RecommendedUID"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.RecommendedUID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMobileRegister message, length delimited. Does not implicitly {@link Client2ProxyReqMobileRegister.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {IClient2ProxyReqMobileRegister} message Client2ProxyReqMobileRegister message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileRegister.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMobileRegister message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMobileRegister} Client2ProxyReqMobileRegister
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileRegister.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMobileRegister();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 2: {
                    message.SmsCode = reader.string();
                    break;
                }
            case 3: {
                    message.Password = reader.string();
                    break;
                }
            case 4: {
                    message.platformType = reader.int32();
                    break;
                }
            case 5: {
                    message.platform = reader.int32();
                    break;
                }
            case 6: {
                    message.regChannel = reader.int32();
                    break;
                }
            case 7: {
                    message.ClientMark = reader.string();
                    break;
                }
            case 8: {
                    message.RecommendedUID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMobileRegister message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMobileRegister} Client2ProxyReqMobileRegister
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileRegister.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMobileRegister message.
     * @function verify
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMobileRegister.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            if (!$util.isString(message.SmsCode))
                return "SmsCode: string expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            if (!$util.isInteger(message.platformType))
                return "platformType: integer expected";
        if (message.platform != null && message.hasOwnProperty("platform"))
            if (!$util.isInteger(message.platform))
                return "platform: integer expected";
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            if (!$util.isInteger(message.regChannel))
                return "regChannel: integer expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            if (!$util.isInteger(message.RecommendedUID))
                return "RecommendedUID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMobileRegister message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMobileRegister} Client2ProxyReqMobileRegister
     */
    Client2ProxyReqMobileRegister.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMobileRegister)
            return object;
        let message = new $root.Client2ProxyReqMobileRegister();
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.SmsCode != null)
            message.SmsCode = String(object.SmsCode);
        if (object.Password != null)
            message.Password = String(object.Password);
        if (object.platformType != null)
            message.platformType = object.platformType | 0;
        if (object.platform != null)
            message.platform = object.platform | 0;
        if (object.regChannel != null)
            message.regChannel = object.regChannel | 0;
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        if (object.RecommendedUID != null)
            message.RecommendedUID = object.RecommendedUID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMobileRegister message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {Client2ProxyReqMobileRegister} message Client2ProxyReqMobileRegister
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMobileRegister.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PhoneNumber = "";
            object.SmsCode = "";
            object.Password = "";
            object.platformType = 0;
            object.platform = 0;
            object.regChannel = 0;
            object.ClientMark = "";
            object.RecommendedUID = 0;
        }
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            object.SmsCode = message.SmsCode;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            object.platformType = message.platformType;
        if (message.platform != null && message.hasOwnProperty("platform"))
            object.platform = message.platform;
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            object.regChannel = message.regChannel;
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            object.RecommendedUID = message.RecommendedUID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMobileRegister to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMobileRegister
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMobileRegister.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMobileRegister
     * @function getTypeUrl
     * @memberof Client2ProxyReqMobileRegister
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMobileRegister.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMobileRegister";
    };

    return Client2ProxyReqMobileRegister;
})();

export const Client2ProxyAckMobileRegister = $root.Client2ProxyAckMobileRegister = (() => {

    /**
     * Properties of a Client2ProxyAckMobileRegister.
     * @exports IClient2ProxyAckMobileRegister
     * @interface IClient2ProxyAckMobileRegister
     * @property {number|null} [Ret] Client2ProxyAckMobileRegister Ret
     * @property {string|null} [PhoneNumber] Client2ProxyAckMobileRegister PhoneNumber
     * @property {number|null} [UserID] Client2ProxyAckMobileRegister UserID
     */

    /**
     * Constructs a new Client2ProxyAckMobileRegister.
     * @exports Client2ProxyAckMobileRegister
     * @classdesc Represents a Client2ProxyAckMobileRegister.
     * @implements IClient2ProxyAckMobileRegister
     * @constructor
     * @param {IClient2ProxyAckMobileRegister=} [properties] Properties to set
     */
    function Client2ProxyAckMobileRegister(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMobileRegister Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMobileRegister
     * @instance
     */
    Client2ProxyAckMobileRegister.prototype.Ret = 0;

    /**
     * Client2ProxyAckMobileRegister PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyAckMobileRegister
     * @instance
     */
    Client2ProxyAckMobileRegister.prototype.PhoneNumber = "";

    /**
     * Client2ProxyAckMobileRegister UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckMobileRegister
     * @instance
     */
    Client2ProxyAckMobileRegister.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckMobileRegister instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {IClient2ProxyAckMobileRegister=} [properties] Properties to set
     * @returns {Client2ProxyAckMobileRegister} Client2ProxyAckMobileRegister instance
     */
    Client2ProxyAckMobileRegister.create = function create(properties) {
        return new Client2ProxyAckMobileRegister(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMobileRegister message. Does not implicitly {@link Client2ProxyAckMobileRegister.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {IClient2ProxyAckMobileRegister} message Client2ProxyAckMobileRegister message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileRegister.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PhoneNumber);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMobileRegister message, length delimited. Does not implicitly {@link Client2ProxyAckMobileRegister.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {IClient2ProxyAckMobileRegister} message Client2ProxyAckMobileRegister message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileRegister.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMobileRegister message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMobileRegister} Client2ProxyAckMobileRegister
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileRegister.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMobileRegister();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMobileRegister message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMobileRegister} Client2ProxyAckMobileRegister
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileRegister.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMobileRegister message.
     * @function verify
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMobileRegister.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMobileRegister message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMobileRegister} Client2ProxyAckMobileRegister
     */
    Client2ProxyAckMobileRegister.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMobileRegister)
            return object;
        let message = new $root.Client2ProxyAckMobileRegister();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMobileRegister message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {Client2ProxyAckMobileRegister} message Client2ProxyAckMobileRegister
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMobileRegister.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.PhoneNumber = "";
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMobileRegister to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMobileRegister
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMobileRegister.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMobileRegister
     * @function getTypeUrl
     * @memberof Client2ProxyAckMobileRegister
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMobileRegister.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMobileRegister";
    };

    return Client2ProxyAckMobileRegister;
})();

export const Client2ProxyReqMobileSmsCode = $root.Client2ProxyReqMobileSmsCode = (() => {

    /**
     * Properties of a Client2ProxyReqMobileSmsCode.
     * @exports IClient2ProxyReqMobileSmsCode
     * @interface IClient2ProxyReqMobileSmsCode
     * @property {string|null} [PhoneNumber] Client2ProxyReqMobileSmsCode PhoneNumber
     * @property {number|null} [Channel] Client2ProxyReqMobileSmsCode Channel
     */

    /**
     * Constructs a new Client2ProxyReqMobileSmsCode.
     * @exports Client2ProxyReqMobileSmsCode
     * @classdesc Represents a Client2ProxyReqMobileSmsCode.
     * @implements IClient2ProxyReqMobileSmsCode
     * @constructor
     * @param {IClient2ProxyReqMobileSmsCode=} [properties] Properties to set
     */
    function Client2ProxyReqMobileSmsCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMobileSmsCode PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyReqMobileSmsCode
     * @instance
     */
    Client2ProxyReqMobileSmsCode.prototype.PhoneNumber = "";

    /**
     * Client2ProxyReqMobileSmsCode Channel.
     * @member {number} Channel
     * @memberof Client2ProxyReqMobileSmsCode
     * @instance
     */
    Client2ProxyReqMobileSmsCode.prototype.Channel = 0;

    /**
     * Creates a new Client2ProxyReqMobileSmsCode instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {IClient2ProxyReqMobileSmsCode=} [properties] Properties to set
     * @returns {Client2ProxyReqMobileSmsCode} Client2ProxyReqMobileSmsCode instance
     */
    Client2ProxyReqMobileSmsCode.create = function create(properties) {
        return new Client2ProxyReqMobileSmsCode(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMobileSmsCode message. Does not implicitly {@link Client2ProxyReqMobileSmsCode.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {IClient2ProxyReqMobileSmsCode} message Client2ProxyReqMobileSmsCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileSmsCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.PhoneNumber);
        if (message.Channel != null && Object.hasOwnProperty.call(message, "Channel"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Channel);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMobileSmsCode message, length delimited. Does not implicitly {@link Client2ProxyReqMobileSmsCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {IClient2ProxyReqMobileSmsCode} message Client2ProxyReqMobileSmsCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileSmsCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMobileSmsCode message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMobileSmsCode} Client2ProxyReqMobileSmsCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileSmsCode.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMobileSmsCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 2: {
                    message.Channel = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMobileSmsCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMobileSmsCode} Client2ProxyReqMobileSmsCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileSmsCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMobileSmsCode message.
     * @function verify
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMobileSmsCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            if (!$util.isInteger(message.Channel))
                return "Channel: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMobileSmsCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMobileSmsCode} Client2ProxyReqMobileSmsCode
     */
    Client2ProxyReqMobileSmsCode.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMobileSmsCode)
            return object;
        let message = new $root.Client2ProxyReqMobileSmsCode();
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.Channel != null)
            message.Channel = object.Channel | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMobileSmsCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {Client2ProxyReqMobileSmsCode} message Client2ProxyReqMobileSmsCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMobileSmsCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PhoneNumber = "";
            object.Channel = 0;
        }
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            object.Channel = message.Channel;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMobileSmsCode to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMobileSmsCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMobileSmsCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMobileSmsCode
     * @function getTypeUrl
     * @memberof Client2ProxyReqMobileSmsCode
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMobileSmsCode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMobileSmsCode";
    };

    return Client2ProxyReqMobileSmsCode;
})();

export const Client2ProxyAckMobileSmsCode = $root.Client2ProxyAckMobileSmsCode = (() => {

    /**
     * Properties of a Client2ProxyAckMobileSmsCode.
     * @exports IClient2ProxyAckMobileSmsCode
     * @interface IClient2ProxyAckMobileSmsCode
     * @property {number|null} [Ret] Client2ProxyAckMobileSmsCode Ret
     * @property {string|null} [PhoneNumber] Client2ProxyAckMobileSmsCode PhoneNumber
     * @property {string|null} [MessageID] Client2ProxyAckMobileSmsCode MessageID
     */

    /**
     * Constructs a new Client2ProxyAckMobileSmsCode.
     * @exports Client2ProxyAckMobileSmsCode
     * @classdesc Represents a Client2ProxyAckMobileSmsCode.
     * @implements IClient2ProxyAckMobileSmsCode
     * @constructor
     * @param {IClient2ProxyAckMobileSmsCode=} [properties] Properties to set
     */
    function Client2ProxyAckMobileSmsCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMobileSmsCode Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMobileSmsCode
     * @instance
     */
    Client2ProxyAckMobileSmsCode.prototype.Ret = 0;

    /**
     * Client2ProxyAckMobileSmsCode PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyAckMobileSmsCode
     * @instance
     */
    Client2ProxyAckMobileSmsCode.prototype.PhoneNumber = "";

    /**
     * Client2ProxyAckMobileSmsCode MessageID.
     * @member {string} MessageID
     * @memberof Client2ProxyAckMobileSmsCode
     * @instance
     */
    Client2ProxyAckMobileSmsCode.prototype.MessageID = "";

    /**
     * Creates a new Client2ProxyAckMobileSmsCode instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {IClient2ProxyAckMobileSmsCode=} [properties] Properties to set
     * @returns {Client2ProxyAckMobileSmsCode} Client2ProxyAckMobileSmsCode instance
     */
    Client2ProxyAckMobileSmsCode.create = function create(properties) {
        return new Client2ProxyAckMobileSmsCode(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMobileSmsCode message. Does not implicitly {@link Client2ProxyAckMobileSmsCode.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {IClient2ProxyAckMobileSmsCode} message Client2ProxyAckMobileSmsCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileSmsCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PhoneNumber);
        if (message.MessageID != null && Object.hasOwnProperty.call(message, "MessageID"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.MessageID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMobileSmsCode message, length delimited. Does not implicitly {@link Client2ProxyAckMobileSmsCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {IClient2ProxyAckMobileSmsCode} message Client2ProxyAckMobileSmsCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileSmsCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMobileSmsCode message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMobileSmsCode} Client2ProxyAckMobileSmsCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileSmsCode.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMobileSmsCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 3: {
                    message.MessageID = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMobileSmsCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMobileSmsCode} Client2ProxyAckMobileSmsCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileSmsCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMobileSmsCode message.
     * @function verify
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMobileSmsCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.MessageID != null && message.hasOwnProperty("MessageID"))
            if (!$util.isString(message.MessageID))
                return "MessageID: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMobileSmsCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMobileSmsCode} Client2ProxyAckMobileSmsCode
     */
    Client2ProxyAckMobileSmsCode.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMobileSmsCode)
            return object;
        let message = new $root.Client2ProxyAckMobileSmsCode();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.MessageID != null)
            message.MessageID = String(object.MessageID);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMobileSmsCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {Client2ProxyAckMobileSmsCode} message Client2ProxyAckMobileSmsCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMobileSmsCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.PhoneNumber = "";
            object.MessageID = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.MessageID != null && message.hasOwnProperty("MessageID"))
            object.MessageID = message.MessageID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMobileSmsCode to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMobileSmsCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMobileSmsCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMobileSmsCode
     * @function getTypeUrl
     * @memberof Client2ProxyAckMobileSmsCode
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMobileSmsCode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMobileSmsCode";
    };

    return Client2ProxyAckMobileSmsCode;
})();

export const Client2ProxyReqMobileResetPwd = $root.Client2ProxyReqMobileResetPwd = (() => {

    /**
     * Properties of a Client2ProxyReqMobileResetPwd.
     * @exports IClient2ProxyReqMobileResetPwd
     * @interface IClient2ProxyReqMobileResetPwd
     * @property {string|null} [PhoneNumber] Client2ProxyReqMobileResetPwd PhoneNumber
     * @property {string|null} [SmsCode] Client2ProxyReqMobileResetPwd SmsCode
     * @property {string|null} [Password] Client2ProxyReqMobileResetPwd Password
     */

    /**
     * Constructs a new Client2ProxyReqMobileResetPwd.
     * @exports Client2ProxyReqMobileResetPwd
     * @classdesc Represents a Client2ProxyReqMobileResetPwd.
     * @implements IClient2ProxyReqMobileResetPwd
     * @constructor
     * @param {IClient2ProxyReqMobileResetPwd=} [properties] Properties to set
     */
    function Client2ProxyReqMobileResetPwd(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMobileResetPwd PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyReqMobileResetPwd
     * @instance
     */
    Client2ProxyReqMobileResetPwd.prototype.PhoneNumber = "";

    /**
     * Client2ProxyReqMobileResetPwd SmsCode.
     * @member {string} SmsCode
     * @memberof Client2ProxyReqMobileResetPwd
     * @instance
     */
    Client2ProxyReqMobileResetPwd.prototype.SmsCode = "";

    /**
     * Client2ProxyReqMobileResetPwd Password.
     * @member {string} Password
     * @memberof Client2ProxyReqMobileResetPwd
     * @instance
     */
    Client2ProxyReqMobileResetPwd.prototype.Password = "";

    /**
     * Creates a new Client2ProxyReqMobileResetPwd instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {IClient2ProxyReqMobileResetPwd=} [properties] Properties to set
     * @returns {Client2ProxyReqMobileResetPwd} Client2ProxyReqMobileResetPwd instance
     */
    Client2ProxyReqMobileResetPwd.create = function create(properties) {
        return new Client2ProxyReqMobileResetPwd(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMobileResetPwd message. Does not implicitly {@link Client2ProxyReqMobileResetPwd.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {IClient2ProxyReqMobileResetPwd} message Client2ProxyReqMobileResetPwd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileResetPwd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.PhoneNumber);
        if (message.SmsCode != null && Object.hasOwnProperty.call(message, "SmsCode"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SmsCode);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Password);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMobileResetPwd message, length delimited. Does not implicitly {@link Client2ProxyReqMobileResetPwd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {IClient2ProxyReqMobileResetPwd} message Client2ProxyReqMobileResetPwd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMobileResetPwd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMobileResetPwd message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMobileResetPwd} Client2ProxyReqMobileResetPwd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileResetPwd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMobileResetPwd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 2: {
                    message.SmsCode = reader.string();
                    break;
                }
            case 3: {
                    message.Password = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMobileResetPwd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMobileResetPwd} Client2ProxyReqMobileResetPwd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMobileResetPwd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMobileResetPwd message.
     * @function verify
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMobileResetPwd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            if (!$util.isString(message.SmsCode))
                return "SmsCode: string expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMobileResetPwd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMobileResetPwd} Client2ProxyReqMobileResetPwd
     */
    Client2ProxyReqMobileResetPwd.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMobileResetPwd)
            return object;
        let message = new $root.Client2ProxyReqMobileResetPwd();
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.SmsCode != null)
            message.SmsCode = String(object.SmsCode);
        if (object.Password != null)
            message.Password = String(object.Password);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMobileResetPwd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {Client2ProxyReqMobileResetPwd} message Client2ProxyReqMobileResetPwd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMobileResetPwd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PhoneNumber = "";
            object.SmsCode = "";
            object.Password = "";
        }
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            object.SmsCode = message.SmsCode;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMobileResetPwd to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMobileResetPwd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMobileResetPwd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMobileResetPwd
     * @function getTypeUrl
     * @memberof Client2ProxyReqMobileResetPwd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMobileResetPwd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMobileResetPwd";
    };

    return Client2ProxyReqMobileResetPwd;
})();

export const Client2ProxyAckMobileResetPwd = $root.Client2ProxyAckMobileResetPwd = (() => {

    /**
     * Properties of a Client2ProxyAckMobileResetPwd.
     * @exports IClient2ProxyAckMobileResetPwd
     * @interface IClient2ProxyAckMobileResetPwd
     * @property {number|null} [Ret] Client2ProxyAckMobileResetPwd Ret
     * @property {string|null} [PhoneNumber] Client2ProxyAckMobileResetPwd PhoneNumber
     * @property {string|null} [SmsCode] Client2ProxyAckMobileResetPwd SmsCode
     * @property {string|null} [Password] Client2ProxyAckMobileResetPwd Password
     */

    /**
     * Constructs a new Client2ProxyAckMobileResetPwd.
     * @exports Client2ProxyAckMobileResetPwd
     * @classdesc Represents a Client2ProxyAckMobileResetPwd.
     * @implements IClient2ProxyAckMobileResetPwd
     * @constructor
     * @param {IClient2ProxyAckMobileResetPwd=} [properties] Properties to set
     */
    function Client2ProxyAckMobileResetPwd(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMobileResetPwd Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMobileResetPwd
     * @instance
     */
    Client2ProxyAckMobileResetPwd.prototype.Ret = 0;

    /**
     * Client2ProxyAckMobileResetPwd PhoneNumber.
     * @member {string} PhoneNumber
     * @memberof Client2ProxyAckMobileResetPwd
     * @instance
     */
    Client2ProxyAckMobileResetPwd.prototype.PhoneNumber = "";

    /**
     * Client2ProxyAckMobileResetPwd SmsCode.
     * @member {string} SmsCode
     * @memberof Client2ProxyAckMobileResetPwd
     * @instance
     */
    Client2ProxyAckMobileResetPwd.prototype.SmsCode = "";

    /**
     * Client2ProxyAckMobileResetPwd Password.
     * @member {string} Password
     * @memberof Client2ProxyAckMobileResetPwd
     * @instance
     */
    Client2ProxyAckMobileResetPwd.prototype.Password = "";

    /**
     * Creates a new Client2ProxyAckMobileResetPwd instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {IClient2ProxyAckMobileResetPwd=} [properties] Properties to set
     * @returns {Client2ProxyAckMobileResetPwd} Client2ProxyAckMobileResetPwd instance
     */
    Client2ProxyAckMobileResetPwd.create = function create(properties) {
        return new Client2ProxyAckMobileResetPwd(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMobileResetPwd message. Does not implicitly {@link Client2ProxyAckMobileResetPwd.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {IClient2ProxyAckMobileResetPwd} message Client2ProxyAckMobileResetPwd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileResetPwd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.PhoneNumber != null && Object.hasOwnProperty.call(message, "PhoneNumber"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PhoneNumber);
        if (message.SmsCode != null && Object.hasOwnProperty.call(message, "SmsCode"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.SmsCode);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Password);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMobileResetPwd message, length delimited. Does not implicitly {@link Client2ProxyAckMobileResetPwd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {IClient2ProxyAckMobileResetPwd} message Client2ProxyAckMobileResetPwd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMobileResetPwd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMobileResetPwd message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMobileResetPwd} Client2ProxyAckMobileResetPwd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileResetPwd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMobileResetPwd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.PhoneNumber = reader.string();
                    break;
                }
            case 3: {
                    message.SmsCode = reader.string();
                    break;
                }
            case 4: {
                    message.Password = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMobileResetPwd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMobileResetPwd} Client2ProxyAckMobileResetPwd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMobileResetPwd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMobileResetPwd message.
     * @function verify
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMobileResetPwd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            if (!$util.isString(message.PhoneNumber))
                return "PhoneNumber: string expected";
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            if (!$util.isString(message.SmsCode))
                return "SmsCode: string expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMobileResetPwd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMobileResetPwd} Client2ProxyAckMobileResetPwd
     */
    Client2ProxyAckMobileResetPwd.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMobileResetPwd)
            return object;
        let message = new $root.Client2ProxyAckMobileResetPwd();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.PhoneNumber != null)
            message.PhoneNumber = String(object.PhoneNumber);
        if (object.SmsCode != null)
            message.SmsCode = String(object.SmsCode);
        if (object.Password != null)
            message.Password = String(object.Password);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMobileResetPwd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {Client2ProxyAckMobileResetPwd} message Client2ProxyAckMobileResetPwd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMobileResetPwd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.PhoneNumber = "";
            object.SmsCode = "";
            object.Password = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.PhoneNumber != null && message.hasOwnProperty("PhoneNumber"))
            object.PhoneNumber = message.PhoneNumber;
        if (message.SmsCode != null && message.hasOwnProperty("SmsCode"))
            object.SmsCode = message.SmsCode;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMobileResetPwd to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMobileResetPwd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMobileResetPwd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMobileResetPwd
     * @function getTypeUrl
     * @memberof Client2ProxyAckMobileResetPwd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMobileResetPwd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMobileResetPwd";
    };

    return Client2ProxyAckMobileResetPwd;
})();

export const Client2ProxyReqLeaveGame = $root.Client2ProxyReqLeaveGame = (() => {

    /**
     * Properties of a Client2ProxyReqLeaveGame.
     * @exports IClient2ProxyReqLeaveGame
     * @interface IClient2ProxyReqLeaveGame
     * @property {number|null} [UserID] Client2ProxyReqLeaveGame UserID
     */

    /**
     * Constructs a new Client2ProxyReqLeaveGame.
     * @exports Client2ProxyReqLeaveGame
     * @classdesc Represents a Client2ProxyReqLeaveGame.
     * @implements IClient2ProxyReqLeaveGame
     * @constructor
     * @param {IClient2ProxyReqLeaveGame=} [properties] Properties to set
     */
    function Client2ProxyReqLeaveGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqLeaveGame UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqLeaveGame
     * @instance
     */
    Client2ProxyReqLeaveGame.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqLeaveGame instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {IClient2ProxyReqLeaveGame=} [properties] Properties to set
     * @returns {Client2ProxyReqLeaveGame} Client2ProxyReqLeaveGame instance
     */
    Client2ProxyReqLeaveGame.create = function create(properties) {
        return new Client2ProxyReqLeaveGame(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqLeaveGame message. Does not implicitly {@link Client2ProxyReqLeaveGame.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {IClient2ProxyReqLeaveGame} message Client2ProxyReqLeaveGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLeaveGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqLeaveGame message, length delimited. Does not implicitly {@link Client2ProxyReqLeaveGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {IClient2ProxyReqLeaveGame} message Client2ProxyReqLeaveGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqLeaveGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqLeaveGame message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqLeaveGame} Client2ProxyReqLeaveGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLeaveGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqLeaveGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqLeaveGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqLeaveGame} Client2ProxyReqLeaveGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqLeaveGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqLeaveGame message.
     * @function verify
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqLeaveGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqLeaveGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqLeaveGame} Client2ProxyReqLeaveGame
     */
    Client2ProxyReqLeaveGame.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqLeaveGame)
            return object;
        let message = new $root.Client2ProxyReqLeaveGame();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqLeaveGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {Client2ProxyReqLeaveGame} message Client2ProxyReqLeaveGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqLeaveGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqLeaveGame to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqLeaveGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqLeaveGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqLeaveGame
     * @function getTypeUrl
     * @memberof Client2ProxyReqLeaveGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqLeaveGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqLeaveGame";
    };

    return Client2ProxyReqLeaveGame;
})();

export const Client2ProxyAckLeaveGame = $root.Client2ProxyAckLeaveGame = (() => {

    /**
     * Properties of a Client2ProxyAckLeaveGame.
     * @exports IClient2ProxyAckLeaveGame
     * @interface IClient2ProxyAckLeaveGame
     * @property {number|null} [Ret] Client2ProxyAckLeaveGame Ret
     * @property {number|null} [UserID] Client2ProxyAckLeaveGame UserID
     * @property {number|null} [Sign] Client2ProxyAckLeaveGame Sign
     */

    /**
     * Constructs a new Client2ProxyAckLeaveGame.
     * @exports Client2ProxyAckLeaveGame
     * @classdesc Represents a Client2ProxyAckLeaveGame.
     * @implements IClient2ProxyAckLeaveGame
     * @constructor
     * @param {IClient2ProxyAckLeaveGame=} [properties] Properties to set
     */
    function Client2ProxyAckLeaveGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckLeaveGame Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckLeaveGame
     * @instance
     */
    Client2ProxyAckLeaveGame.prototype.Ret = 0;

    /**
     * Client2ProxyAckLeaveGame UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckLeaveGame
     * @instance
     */
    Client2ProxyAckLeaveGame.prototype.UserID = 0;

    /**
     * Client2ProxyAckLeaveGame Sign.
     * @member {number} Sign
     * @memberof Client2ProxyAckLeaveGame
     * @instance
     */
    Client2ProxyAckLeaveGame.prototype.Sign = 0;

    /**
     * Creates a new Client2ProxyAckLeaveGame instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {IClient2ProxyAckLeaveGame=} [properties] Properties to set
     * @returns {Client2ProxyAckLeaveGame} Client2ProxyAckLeaveGame instance
     */
    Client2ProxyAckLeaveGame.create = function create(properties) {
        return new Client2ProxyAckLeaveGame(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckLeaveGame message. Does not implicitly {@link Client2ProxyAckLeaveGame.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {IClient2ProxyAckLeaveGame} message Client2ProxyAckLeaveGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLeaveGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Sign != null && Object.hasOwnProperty.call(message, "Sign"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Sign);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckLeaveGame message, length delimited. Does not implicitly {@link Client2ProxyAckLeaveGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {IClient2ProxyAckLeaveGame} message Client2ProxyAckLeaveGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckLeaveGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckLeaveGame message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckLeaveGame} Client2ProxyAckLeaveGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLeaveGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckLeaveGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Sign = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckLeaveGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckLeaveGame} Client2ProxyAckLeaveGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckLeaveGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckLeaveGame message.
     * @function verify
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckLeaveGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Sign != null && message.hasOwnProperty("Sign"))
            if (!$util.isInteger(message.Sign))
                return "Sign: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckLeaveGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckLeaveGame} Client2ProxyAckLeaveGame
     */
    Client2ProxyAckLeaveGame.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckLeaveGame)
            return object;
        let message = new $root.Client2ProxyAckLeaveGame();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Sign != null)
            message.Sign = object.Sign >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckLeaveGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {Client2ProxyAckLeaveGame} message Client2ProxyAckLeaveGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckLeaveGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Sign = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Sign != null && message.hasOwnProperty("Sign"))
            object.Sign = message.Sign;
        return object;
    };

    /**
     * Converts this Client2ProxyAckLeaveGame to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckLeaveGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckLeaveGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckLeaveGame
     * @function getTypeUrl
     * @memberof Client2ProxyAckLeaveGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckLeaveGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckLeaveGame";
    };

    return Client2ProxyAckLeaveGame;
})();

export const Client2ProxyAckPlayerArrive = $root.Client2ProxyAckPlayerArrive = (() => {

    /**
     * Properties of a Client2ProxyAckPlayerArrive.
     * @exports IClient2ProxyAckPlayerArrive
     * @interface IClient2ProxyAckPlayerArrive
     * @property {number|null} [Res] Client2ProxyAckPlayerArrive Res
     * @property {number|null} [UserID] Client2ProxyAckPlayerArrive UserID
     * @property {number|null} [NewPlayerID] Client2ProxyAckPlayerArrive NewPlayerID
     * @property {Array.<IPlayerInfo>|null} [DeskPlayer] Client2ProxyAckPlayerArrive DeskPlayer
     */

    /**
     * Constructs a new Client2ProxyAckPlayerArrive.
     * @exports Client2ProxyAckPlayerArrive
     * @classdesc Represents a Client2ProxyAckPlayerArrive.
     * @implements IClient2ProxyAckPlayerArrive
     * @constructor
     * @param {IClient2ProxyAckPlayerArrive=} [properties] Properties to set
     */
    function Client2ProxyAckPlayerArrive(properties) {
        this.DeskPlayer = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPlayerArrive Res.
     * @member {number} Res
     * @memberof Client2ProxyAckPlayerArrive
     * @instance
     */
    Client2ProxyAckPlayerArrive.prototype.Res = 0;

    /**
     * Client2ProxyAckPlayerArrive UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckPlayerArrive
     * @instance
     */
    Client2ProxyAckPlayerArrive.prototype.UserID = 0;

    /**
     * Client2ProxyAckPlayerArrive NewPlayerID.
     * @member {number} NewPlayerID
     * @memberof Client2ProxyAckPlayerArrive
     * @instance
     */
    Client2ProxyAckPlayerArrive.prototype.NewPlayerID = 0;

    /**
     * Client2ProxyAckPlayerArrive DeskPlayer.
     * @member {Array.<IPlayerInfo>} DeskPlayer
     * @memberof Client2ProxyAckPlayerArrive
     * @instance
     */
    Client2ProxyAckPlayerArrive.prototype.DeskPlayer = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckPlayerArrive instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {IClient2ProxyAckPlayerArrive=} [properties] Properties to set
     * @returns {Client2ProxyAckPlayerArrive} Client2ProxyAckPlayerArrive instance
     */
    Client2ProxyAckPlayerArrive.create = function create(properties) {
        return new Client2ProxyAckPlayerArrive(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerArrive message. Does not implicitly {@link Client2ProxyAckPlayerArrive.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {IClient2ProxyAckPlayerArrive} message Client2ProxyAckPlayerArrive message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerArrive.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NewPlayerID != null && Object.hasOwnProperty.call(message, "NewPlayerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.NewPlayerID);
        if (message.DeskPlayer != null && message.DeskPlayer.length)
            for (let i = 0; i < message.DeskPlayer.length; ++i)
                $root.PlayerInfo.encode(message.DeskPlayer[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerArrive message, length delimited. Does not implicitly {@link Client2ProxyAckPlayerArrive.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {IClient2ProxyAckPlayerArrive} message Client2ProxyAckPlayerArrive message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerArrive.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPlayerArrive message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPlayerArrive} Client2ProxyAckPlayerArrive
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerArrive.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPlayerArrive();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NewPlayerID = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.DeskPlayer && message.DeskPlayer.length))
                        message.DeskPlayer = [];
                    message.DeskPlayer.push($root.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPlayerArrive message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPlayerArrive} Client2ProxyAckPlayerArrive
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerArrive.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPlayerArrive message.
     * @function verify
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPlayerArrive.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewPlayerID != null && message.hasOwnProperty("NewPlayerID"))
            if (!$util.isInteger(message.NewPlayerID))
                return "NewPlayerID: integer expected";
        if (message.DeskPlayer != null && message.hasOwnProperty("DeskPlayer")) {
            if (!Array.isArray(message.DeskPlayer))
                return "DeskPlayer: array expected";
            for (let i = 0; i < message.DeskPlayer.length; ++i) {
                let error = $root.PlayerInfo.verify(message.DeskPlayer[i]);
                if (error)
                    return "DeskPlayer." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckPlayerArrive message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPlayerArrive} Client2ProxyAckPlayerArrive
     */
    Client2ProxyAckPlayerArrive.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPlayerArrive)
            return object;
        let message = new $root.Client2ProxyAckPlayerArrive();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewPlayerID != null)
            message.NewPlayerID = object.NewPlayerID >>> 0;
        if (object.DeskPlayer) {
            if (!Array.isArray(object.DeskPlayer))
                throw TypeError(".Client2ProxyAckPlayerArrive.DeskPlayer: array expected");
            message.DeskPlayer = [];
            for (let i = 0; i < object.DeskPlayer.length; ++i) {
                if (typeof object.DeskPlayer[i] !== "object")
                    throw TypeError(".Client2ProxyAckPlayerArrive.DeskPlayer: object expected");
                message.DeskPlayer[i] = $root.PlayerInfo.fromObject(object.DeskPlayer[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPlayerArrive message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {Client2ProxyAckPlayerArrive} message Client2ProxyAckPlayerArrive
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPlayerArrive.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.DeskPlayer = [];
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.NewPlayerID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewPlayerID != null && message.hasOwnProperty("NewPlayerID"))
            object.NewPlayerID = message.NewPlayerID;
        if (message.DeskPlayer && message.DeskPlayer.length) {
            object.DeskPlayer = [];
            for (let j = 0; j < message.DeskPlayer.length; ++j)
                object.DeskPlayer[j] = $root.PlayerInfo.toObject(message.DeskPlayer[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckPlayerArrive to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPlayerArrive
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPlayerArrive.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPlayerArrive
     * @function getTypeUrl
     * @memberof Client2ProxyAckPlayerArrive
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPlayerArrive.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPlayerArrive";
    };

    return Client2ProxyAckPlayerArrive;
})();

export const Client2ProxyReqPlayerSitDown = $root.Client2ProxyReqPlayerSitDown = (() => {

    /**
     * Properties of a Client2ProxyReqPlayerSitDown.
     * @exports IClient2ProxyReqPlayerSitDown
     * @interface IClient2ProxyReqPlayerSitDown
     * @property {number|null} [DeskNo] Client2ProxyReqPlayerSitDown DeskNo
     * @property {number|null} [UserID] Client2ProxyReqPlayerSitDown UserID
     * @property {number|null} [SeatNo] Client2ProxyReqPlayerSitDown SeatNo
     */

    /**
     * Constructs a new Client2ProxyReqPlayerSitDown.
     * @exports Client2ProxyReqPlayerSitDown
     * @classdesc Represents a Client2ProxyReqPlayerSitDown.
     * @implements IClient2ProxyReqPlayerSitDown
     * @constructor
     * @param {IClient2ProxyReqPlayerSitDown=} [properties] Properties to set
     */
    function Client2ProxyReqPlayerSitDown(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqPlayerSitDown DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyReqPlayerSitDown
     * @instance
     */
    Client2ProxyReqPlayerSitDown.prototype.DeskNo = 0;

    /**
     * Client2ProxyReqPlayerSitDown UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqPlayerSitDown
     * @instance
     */
    Client2ProxyReqPlayerSitDown.prototype.UserID = 0;

    /**
     * Client2ProxyReqPlayerSitDown SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ProxyReqPlayerSitDown
     * @instance
     */
    Client2ProxyReqPlayerSitDown.prototype.SeatNo = 0;

    /**
     * Creates a new Client2ProxyReqPlayerSitDown instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {IClient2ProxyReqPlayerSitDown=} [properties] Properties to set
     * @returns {Client2ProxyReqPlayerSitDown} Client2ProxyReqPlayerSitDown instance
     */
    Client2ProxyReqPlayerSitDown.create = function create(properties) {
        return new Client2ProxyReqPlayerSitDown(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqPlayerSitDown message. Does not implicitly {@link Client2ProxyReqPlayerSitDown.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {IClient2ProxyReqPlayerSitDown} message Client2ProxyReqPlayerSitDown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPlayerSitDown.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqPlayerSitDown message, length delimited. Does not implicitly {@link Client2ProxyReqPlayerSitDown.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {IClient2ProxyReqPlayerSitDown} message Client2ProxyReqPlayerSitDown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPlayerSitDown.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqPlayerSitDown message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqPlayerSitDown} Client2ProxyReqPlayerSitDown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPlayerSitDown.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqPlayerSitDown();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqPlayerSitDown message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqPlayerSitDown} Client2ProxyReqPlayerSitDown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPlayerSitDown.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqPlayerSitDown message.
     * @function verify
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqPlayerSitDown.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqPlayerSitDown message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqPlayerSitDown} Client2ProxyReqPlayerSitDown
     */
    Client2ProxyReqPlayerSitDown.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqPlayerSitDown)
            return object;
        let message = new $root.Client2ProxyReqPlayerSitDown();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqPlayerSitDown message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {Client2ProxyReqPlayerSitDown} message Client2ProxyReqPlayerSitDown
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqPlayerSitDown.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2ProxyReqPlayerSitDown to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqPlayerSitDown
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqPlayerSitDown.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqPlayerSitDown
     * @function getTypeUrl
     * @memberof Client2ProxyReqPlayerSitDown
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqPlayerSitDown.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqPlayerSitDown";
    };

    return Client2ProxyReqPlayerSitDown;
})();

export const Client2ProxyAckPlayerSitDown = $root.Client2ProxyAckPlayerSitDown = (() => {

    /**
     * Properties of a Client2ProxyAckPlayerSitDown.
     * @exports IClient2ProxyAckPlayerSitDown
     * @interface IClient2ProxyAckPlayerSitDown
     * @property {number|null} [Res] Client2ProxyAckPlayerSitDown Res
     * @property {number|null} [DeskNo] Client2ProxyAckPlayerSitDown DeskNo
     * @property {number|null} [UserID] Client2ProxyAckPlayerSitDown UserID
     * @property {number|null} [SeatNo] Client2ProxyAckPlayerSitDown SeatNo
     */

    /**
     * Constructs a new Client2ProxyAckPlayerSitDown.
     * @exports Client2ProxyAckPlayerSitDown
     * @classdesc Represents a Client2ProxyAckPlayerSitDown.
     * @implements IClient2ProxyAckPlayerSitDown
     * @constructor
     * @param {IClient2ProxyAckPlayerSitDown=} [properties] Properties to set
     */
    function Client2ProxyAckPlayerSitDown(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPlayerSitDown Res.
     * @member {number} Res
     * @memberof Client2ProxyAckPlayerSitDown
     * @instance
     */
    Client2ProxyAckPlayerSitDown.prototype.Res = 0;

    /**
     * Client2ProxyAckPlayerSitDown DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyAckPlayerSitDown
     * @instance
     */
    Client2ProxyAckPlayerSitDown.prototype.DeskNo = 0;

    /**
     * Client2ProxyAckPlayerSitDown UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckPlayerSitDown
     * @instance
     */
    Client2ProxyAckPlayerSitDown.prototype.UserID = 0;

    /**
     * Client2ProxyAckPlayerSitDown SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ProxyAckPlayerSitDown
     * @instance
     */
    Client2ProxyAckPlayerSitDown.prototype.SeatNo = 0;

    /**
     * Creates a new Client2ProxyAckPlayerSitDown instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {IClient2ProxyAckPlayerSitDown=} [properties] Properties to set
     * @returns {Client2ProxyAckPlayerSitDown} Client2ProxyAckPlayerSitDown instance
     */
    Client2ProxyAckPlayerSitDown.create = function create(properties) {
        return new Client2ProxyAckPlayerSitDown(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerSitDown message. Does not implicitly {@link Client2ProxyAckPlayerSitDown.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {IClient2ProxyAckPlayerSitDown} message Client2ProxyAckPlayerSitDown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerSitDown.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerSitDown message, length delimited. Does not implicitly {@link Client2ProxyAckPlayerSitDown.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {IClient2ProxyAckPlayerSitDown} message Client2ProxyAckPlayerSitDown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerSitDown.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPlayerSitDown message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPlayerSitDown} Client2ProxyAckPlayerSitDown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerSitDown.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPlayerSitDown();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPlayerSitDown message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPlayerSitDown} Client2ProxyAckPlayerSitDown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerSitDown.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPlayerSitDown message.
     * @function verify
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPlayerSitDown.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckPlayerSitDown message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPlayerSitDown} Client2ProxyAckPlayerSitDown
     */
    Client2ProxyAckPlayerSitDown.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPlayerSitDown)
            return object;
        let message = new $root.Client2ProxyAckPlayerSitDown();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPlayerSitDown message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {Client2ProxyAckPlayerSitDown} message Client2ProxyAckPlayerSitDown
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPlayerSitDown.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2ProxyAckPlayerSitDown to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPlayerSitDown
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPlayerSitDown.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPlayerSitDown
     * @function getTypeUrl
     * @memberof Client2ProxyAckPlayerSitDown
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPlayerSitDown.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPlayerSitDown";
    };

    return Client2ProxyAckPlayerSitDown;
})();

export const Client2ProxyReqPlayerStandUp = $root.Client2ProxyReqPlayerStandUp = (() => {

    /**
     * Properties of a Client2ProxyReqPlayerStandUp.
     * @exports IClient2ProxyReqPlayerStandUp
     * @interface IClient2ProxyReqPlayerStandUp
     * @property {number|null} [DeskNo] Client2ProxyReqPlayerStandUp DeskNo
     * @property {number|null} [UserID] Client2ProxyReqPlayerStandUp UserID
     * @property {number|null} [SeatNo] Client2ProxyReqPlayerStandUp SeatNo
     */

    /**
     * Constructs a new Client2ProxyReqPlayerStandUp.
     * @exports Client2ProxyReqPlayerStandUp
     * @classdesc Represents a Client2ProxyReqPlayerStandUp.
     * @implements IClient2ProxyReqPlayerStandUp
     * @constructor
     * @param {IClient2ProxyReqPlayerStandUp=} [properties] Properties to set
     */
    function Client2ProxyReqPlayerStandUp(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqPlayerStandUp DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyReqPlayerStandUp
     * @instance
     */
    Client2ProxyReqPlayerStandUp.prototype.DeskNo = 0;

    /**
     * Client2ProxyReqPlayerStandUp UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqPlayerStandUp
     * @instance
     */
    Client2ProxyReqPlayerStandUp.prototype.UserID = 0;

    /**
     * Client2ProxyReqPlayerStandUp SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ProxyReqPlayerStandUp
     * @instance
     */
    Client2ProxyReqPlayerStandUp.prototype.SeatNo = 0;

    /**
     * Creates a new Client2ProxyReqPlayerStandUp instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {IClient2ProxyReqPlayerStandUp=} [properties] Properties to set
     * @returns {Client2ProxyReqPlayerStandUp} Client2ProxyReqPlayerStandUp instance
     */
    Client2ProxyReqPlayerStandUp.create = function create(properties) {
        return new Client2ProxyReqPlayerStandUp(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqPlayerStandUp message. Does not implicitly {@link Client2ProxyReqPlayerStandUp.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {IClient2ProxyReqPlayerStandUp} message Client2ProxyReqPlayerStandUp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPlayerStandUp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqPlayerStandUp message, length delimited. Does not implicitly {@link Client2ProxyReqPlayerStandUp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {IClient2ProxyReqPlayerStandUp} message Client2ProxyReqPlayerStandUp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPlayerStandUp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqPlayerStandUp message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqPlayerStandUp} Client2ProxyReqPlayerStandUp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPlayerStandUp.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqPlayerStandUp();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqPlayerStandUp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqPlayerStandUp} Client2ProxyReqPlayerStandUp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPlayerStandUp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqPlayerStandUp message.
     * @function verify
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqPlayerStandUp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqPlayerStandUp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqPlayerStandUp} Client2ProxyReqPlayerStandUp
     */
    Client2ProxyReqPlayerStandUp.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqPlayerStandUp)
            return object;
        let message = new $root.Client2ProxyReqPlayerStandUp();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqPlayerStandUp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {Client2ProxyReqPlayerStandUp} message Client2ProxyReqPlayerStandUp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqPlayerStandUp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2ProxyReqPlayerStandUp to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqPlayerStandUp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqPlayerStandUp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqPlayerStandUp
     * @function getTypeUrl
     * @memberof Client2ProxyReqPlayerStandUp
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqPlayerStandUp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqPlayerStandUp";
    };

    return Client2ProxyReqPlayerStandUp;
})();

export const Client2ProxyAckPlayerStandUp = $root.Client2ProxyAckPlayerStandUp = (() => {

    /**
     * Properties of a Client2ProxyAckPlayerStandUp.
     * @exports IClient2ProxyAckPlayerStandUp
     * @interface IClient2ProxyAckPlayerStandUp
     * @property {number|null} [Res] Client2ProxyAckPlayerStandUp Res
     * @property {number|null} [DeskNo] Client2ProxyAckPlayerStandUp DeskNo
     * @property {number|null} [UserID] Client2ProxyAckPlayerStandUp UserID
     * @property {number|null} [SeatNo] Client2ProxyAckPlayerStandUp SeatNo
     */

    /**
     * Constructs a new Client2ProxyAckPlayerStandUp.
     * @exports Client2ProxyAckPlayerStandUp
     * @classdesc Represents a Client2ProxyAckPlayerStandUp.
     * @implements IClient2ProxyAckPlayerStandUp
     * @constructor
     * @param {IClient2ProxyAckPlayerStandUp=} [properties] Properties to set
     */
    function Client2ProxyAckPlayerStandUp(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPlayerStandUp Res.
     * @member {number} Res
     * @memberof Client2ProxyAckPlayerStandUp
     * @instance
     */
    Client2ProxyAckPlayerStandUp.prototype.Res = 0;

    /**
     * Client2ProxyAckPlayerStandUp DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyAckPlayerStandUp
     * @instance
     */
    Client2ProxyAckPlayerStandUp.prototype.DeskNo = 0;

    /**
     * Client2ProxyAckPlayerStandUp UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckPlayerStandUp
     * @instance
     */
    Client2ProxyAckPlayerStandUp.prototype.UserID = 0;

    /**
     * Client2ProxyAckPlayerStandUp SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ProxyAckPlayerStandUp
     * @instance
     */
    Client2ProxyAckPlayerStandUp.prototype.SeatNo = 0;

    /**
     * Creates a new Client2ProxyAckPlayerStandUp instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {IClient2ProxyAckPlayerStandUp=} [properties] Properties to set
     * @returns {Client2ProxyAckPlayerStandUp} Client2ProxyAckPlayerStandUp instance
     */
    Client2ProxyAckPlayerStandUp.create = function create(properties) {
        return new Client2ProxyAckPlayerStandUp(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerStandUp message. Does not implicitly {@link Client2ProxyAckPlayerStandUp.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {IClient2ProxyAckPlayerStandUp} message Client2ProxyAckPlayerStandUp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerStandUp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPlayerStandUp message, length delimited. Does not implicitly {@link Client2ProxyAckPlayerStandUp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {IClient2ProxyAckPlayerStandUp} message Client2ProxyAckPlayerStandUp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPlayerStandUp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPlayerStandUp message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPlayerStandUp} Client2ProxyAckPlayerStandUp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerStandUp.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPlayerStandUp();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPlayerStandUp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPlayerStandUp} Client2ProxyAckPlayerStandUp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPlayerStandUp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPlayerStandUp message.
     * @function verify
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPlayerStandUp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckPlayerStandUp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPlayerStandUp} Client2ProxyAckPlayerStandUp
     */
    Client2ProxyAckPlayerStandUp.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPlayerStandUp)
            return object;
        let message = new $root.Client2ProxyAckPlayerStandUp();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPlayerStandUp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {Client2ProxyAckPlayerStandUp} message Client2ProxyAckPlayerStandUp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPlayerStandUp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this Client2ProxyAckPlayerStandUp to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPlayerStandUp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPlayerStandUp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPlayerStandUp
     * @function getTypeUrl
     * @memberof Client2ProxyAckPlayerStandUp
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPlayerStandUp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPlayerStandUp";
    };

    return Client2ProxyAckPlayerStandUp;
})();

export const Client2ProxyPushGoldChange = $root.Client2ProxyPushGoldChange = (() => {

    /**
     * Properties of a Client2ProxyPushGoldChange.
     * @exports IClient2ProxyPushGoldChange
     * @interface IClient2ProxyPushGoldChange
     * @property {number|null} [UserID] Client2ProxyPushGoldChange UserID
     * @property {string|null} [NewGold] Client2ProxyPushGoldChange NewGold
     * @property {string|null} [GoldChange] Client2ProxyPushGoldChange GoldChange
     * @property {string|null} [NewDeposit] Client2ProxyPushGoldChange NewDeposit
     * @property {string|null} [NewWithdraw] Client2ProxyPushGoldChange NewWithdraw
     * @property {string|null} [NewBonus] Client2ProxyPushGoldChange NewBonus
     * @property {string|null} [NewDiamond] Client2ProxyPushGoldChange NewDiamond
     */

    /**
     * Constructs a new Client2ProxyPushGoldChange.
     * @exports Client2ProxyPushGoldChange
     * @classdesc Represents a Client2ProxyPushGoldChange.
     * @implements IClient2ProxyPushGoldChange
     * @constructor
     * @param {IClient2ProxyPushGoldChange=} [properties] Properties to set
     */
    function Client2ProxyPushGoldChange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushGoldChange UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.UserID = 0;

    /**
     * Client2ProxyPushGoldChange NewGold.
     * @member {string} NewGold
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.NewGold = "";

    /**
     * Client2ProxyPushGoldChange GoldChange.
     * @member {string} GoldChange
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.GoldChange = "";

    /**
     * Client2ProxyPushGoldChange NewDeposit.
     * @member {string} NewDeposit
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.NewDeposit = "";

    /**
     * Client2ProxyPushGoldChange NewWithdraw.
     * @member {string} NewWithdraw
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.NewWithdraw = "";

    /**
     * Client2ProxyPushGoldChange NewBonus.
     * @member {string} NewBonus
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.NewBonus = "";

    /**
     * Client2ProxyPushGoldChange NewDiamond.
     * @member {string} NewDiamond
     * @memberof Client2ProxyPushGoldChange
     * @instance
     */
    Client2ProxyPushGoldChange.prototype.NewDiamond = "";

    /**
     * Creates a new Client2ProxyPushGoldChange instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {IClient2ProxyPushGoldChange=} [properties] Properties to set
     * @returns {Client2ProxyPushGoldChange} Client2ProxyPushGoldChange instance
     */
    Client2ProxyPushGoldChange.create = function create(properties) {
        return new Client2ProxyPushGoldChange(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushGoldChange message. Does not implicitly {@link Client2ProxyPushGoldChange.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {IClient2ProxyPushGoldChange} message Client2ProxyPushGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushGoldChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NewGold != null && Object.hasOwnProperty.call(message, "NewGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.NewGold);
        if (message.GoldChange != null && Object.hasOwnProperty.call(message, "GoldChange"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.GoldChange);
        if (message.NewDeposit != null && Object.hasOwnProperty.call(message, "NewDeposit"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.NewDeposit);
        if (message.NewWithdraw != null && Object.hasOwnProperty.call(message, "NewWithdraw"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.NewWithdraw);
        if (message.NewBonus != null && Object.hasOwnProperty.call(message, "NewBonus"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.NewBonus);
        if (message.NewDiamond != null && Object.hasOwnProperty.call(message, "NewDiamond"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.NewDiamond);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushGoldChange message, length delimited. Does not implicitly {@link Client2ProxyPushGoldChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {IClient2ProxyPushGoldChange} message Client2ProxyPushGoldChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushGoldChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushGoldChange message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushGoldChange} Client2ProxyPushGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushGoldChange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushGoldChange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NewGold = reader.string();
                    break;
                }
            case 3: {
                    message.GoldChange = reader.string();
                    break;
                }
            case 4: {
                    message.NewDeposit = reader.string();
                    break;
                }
            case 5: {
                    message.NewWithdraw = reader.string();
                    break;
                }
            case 6: {
                    message.NewBonus = reader.string();
                    break;
                }
            case 7: {
                    message.NewDiamond = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushGoldChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushGoldChange} Client2ProxyPushGoldChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushGoldChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushGoldChange message.
     * @function verify
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushGoldChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewGold != null && message.hasOwnProperty("NewGold"))
            if (!$util.isString(message.NewGold))
                return "NewGold: string expected";
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            if (!$util.isString(message.GoldChange))
                return "GoldChange: string expected";
        if (message.NewDeposit != null && message.hasOwnProperty("NewDeposit"))
            if (!$util.isString(message.NewDeposit))
                return "NewDeposit: string expected";
        if (message.NewWithdraw != null && message.hasOwnProperty("NewWithdraw"))
            if (!$util.isString(message.NewWithdraw))
                return "NewWithdraw: string expected";
        if (message.NewBonus != null && message.hasOwnProperty("NewBonus"))
            if (!$util.isString(message.NewBonus))
                return "NewBonus: string expected";
        if (message.NewDiamond != null && message.hasOwnProperty("NewDiamond"))
            if (!$util.isString(message.NewDiamond))
                return "NewDiamond: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushGoldChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushGoldChange} Client2ProxyPushGoldChange
     */
    Client2ProxyPushGoldChange.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushGoldChange)
            return object;
        let message = new $root.Client2ProxyPushGoldChange();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewGold != null)
            message.NewGold = String(object.NewGold);
        if (object.GoldChange != null)
            message.GoldChange = String(object.GoldChange);
        if (object.NewDeposit != null)
            message.NewDeposit = String(object.NewDeposit);
        if (object.NewWithdraw != null)
            message.NewWithdraw = String(object.NewWithdraw);
        if (object.NewBonus != null)
            message.NewBonus = String(object.NewBonus);
        if (object.NewDiamond != null)
            message.NewDiamond = String(object.NewDiamond);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushGoldChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {Client2ProxyPushGoldChange} message Client2ProxyPushGoldChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushGoldChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.NewGold = "";
            object.GoldChange = "";
            object.NewDeposit = "";
            object.NewWithdraw = "";
            object.NewBonus = "";
            object.NewDiamond = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewGold != null && message.hasOwnProperty("NewGold"))
            object.NewGold = message.NewGold;
        if (message.GoldChange != null && message.hasOwnProperty("GoldChange"))
            object.GoldChange = message.GoldChange;
        if (message.NewDeposit != null && message.hasOwnProperty("NewDeposit"))
            object.NewDeposit = message.NewDeposit;
        if (message.NewWithdraw != null && message.hasOwnProperty("NewWithdraw"))
            object.NewWithdraw = message.NewWithdraw;
        if (message.NewBonus != null && message.hasOwnProperty("NewBonus"))
            object.NewBonus = message.NewBonus;
        if (message.NewDiamond != null && message.hasOwnProperty("NewDiamond"))
            object.NewDiamond = message.NewDiamond;
        return object;
    };

    /**
     * Converts this Client2ProxyPushGoldChange to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushGoldChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushGoldChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushGoldChange
     * @function getTypeUrl
     * @memberof Client2ProxyPushGoldChange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushGoldChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushGoldChange";
    };

    return Client2ProxyPushGoldChange;
})();

export const Client2ProxyPushLight = $root.Client2ProxyPushLight = (() => {

    /**
     * Properties of a Client2ProxyPushLight.
     * @exports IClient2ProxyPushLight
     * @interface IClient2ProxyPushLight
     * @property {Uint8Array|null} [NotifyMsg] Client2ProxyPushLight NotifyMsg
     */

    /**
     * Constructs a new Client2ProxyPushLight.
     * @exports Client2ProxyPushLight
     * @classdesc Represents a Client2ProxyPushLight.
     * @implements IClient2ProxyPushLight
     * @constructor
     * @param {IClient2ProxyPushLight=} [properties] Properties to set
     */
    function Client2ProxyPushLight(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushLight NotifyMsg.
     * @member {Uint8Array} NotifyMsg
     * @memberof Client2ProxyPushLight
     * @instance
     */
    Client2ProxyPushLight.prototype.NotifyMsg = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyPushLight instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushLight
     * @static
     * @param {IClient2ProxyPushLight=} [properties] Properties to set
     * @returns {Client2ProxyPushLight} Client2ProxyPushLight instance
     */
    Client2ProxyPushLight.create = function create(properties) {
        return new Client2ProxyPushLight(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushLight message. Does not implicitly {@link Client2ProxyPushLight.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushLight
     * @static
     * @param {IClient2ProxyPushLight} message Client2ProxyPushLight message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushLight.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.NotifyMsg != null && Object.hasOwnProperty.call(message, "NotifyMsg"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.NotifyMsg);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushLight message, length delimited. Does not implicitly {@link Client2ProxyPushLight.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushLight
     * @static
     * @param {IClient2ProxyPushLight} message Client2ProxyPushLight message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushLight.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushLight message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushLight
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushLight} Client2ProxyPushLight
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushLight.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushLight();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.NotifyMsg = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushLight message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushLight
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushLight} Client2ProxyPushLight
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushLight.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushLight message.
     * @function verify
     * @memberof Client2ProxyPushLight
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushLight.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.NotifyMsg != null && message.hasOwnProperty("NotifyMsg"))
            if (!(message.NotifyMsg && typeof message.NotifyMsg.length === "number" || $util.isString(message.NotifyMsg)))
                return "NotifyMsg: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushLight message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushLight
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushLight} Client2ProxyPushLight
     */
    Client2ProxyPushLight.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushLight)
            return object;
        let message = new $root.Client2ProxyPushLight();
        if (object.NotifyMsg != null)
            if (typeof object.NotifyMsg === "string")
                $util.base64.decode(object.NotifyMsg, message.NotifyMsg = $util.newBuffer($util.base64.length(object.NotifyMsg)), 0);
            else if (object.NotifyMsg.length >= 0)
                message.NotifyMsg = object.NotifyMsg;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushLight message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushLight
     * @static
     * @param {Client2ProxyPushLight} message Client2ProxyPushLight
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushLight.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.NotifyMsg = "";
            else {
                object.NotifyMsg = [];
                if (options.bytes !== Array)
                    object.NotifyMsg = $util.newBuffer(object.NotifyMsg);
            }
        if (message.NotifyMsg != null && message.hasOwnProperty("NotifyMsg"))
            object.NotifyMsg = options.bytes === String ? $util.base64.encode(message.NotifyMsg, 0, message.NotifyMsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.NotifyMsg) : message.NotifyMsg;
        return object;
    };

    /**
     * Converts this Client2ProxyPushLight to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushLight
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushLight.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushLight
     * @function getTypeUrl
     * @memberof Client2ProxyPushLight
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushLight.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushLight";
    };

    return Client2ProxyPushLight;
})();

export const Client2ProxyReqSwitchTable = $root.Client2ProxyReqSwitchTable = (() => {

    /**
     * Properties of a Client2ProxyReqSwitchTable.
     * @exports IClient2ProxyReqSwitchTable
     * @interface IClient2ProxyReqSwitchTable
     * @property {number|null} [UserID] Client2ProxyReqSwitchTable UserID
     * @property {number|null} [GameID] Client2ProxyReqSwitchTable GameID
     * @property {number|null} [ProductID] Client2ProxyReqSwitchTable ProductID
     * @property {number|null} [DeskNo] Client2ProxyReqSwitchTable DeskNo
     * @property {boolean|null} [FeelTable] Client2ProxyReqSwitchTable FeelTable
     */

    /**
     * Constructs a new Client2ProxyReqSwitchTable.
     * @exports Client2ProxyReqSwitchTable
     * @classdesc Represents a Client2ProxyReqSwitchTable.
     * @implements IClient2ProxyReqSwitchTable
     * @constructor
     * @param {IClient2ProxyReqSwitchTable=} [properties] Properties to set
     */
    function Client2ProxyReqSwitchTable(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqSwitchTable UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     */
    Client2ProxyReqSwitchTable.prototype.UserID = 0;

    /**
     * Client2ProxyReqSwitchTable GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     */
    Client2ProxyReqSwitchTable.prototype.GameID = 0;

    /**
     * Client2ProxyReqSwitchTable ProductID.
     * @member {number} ProductID
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     */
    Client2ProxyReqSwitchTable.prototype.ProductID = 0;

    /**
     * Client2ProxyReqSwitchTable DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     */
    Client2ProxyReqSwitchTable.prototype.DeskNo = 0;

    /**
     * Client2ProxyReqSwitchTable FeelTable.
     * @member {boolean} FeelTable
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     */
    Client2ProxyReqSwitchTable.prototype.FeelTable = false;

    /**
     * Creates a new Client2ProxyReqSwitchTable instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {IClient2ProxyReqSwitchTable=} [properties] Properties to set
     * @returns {Client2ProxyReqSwitchTable} Client2ProxyReqSwitchTable instance
     */
    Client2ProxyReqSwitchTable.create = function create(properties) {
        return new Client2ProxyReqSwitchTable(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqSwitchTable message. Does not implicitly {@link Client2ProxyReqSwitchTable.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {IClient2ProxyReqSwitchTable} message Client2ProxyReqSwitchTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqSwitchTable.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DeskNo);
        if (message.FeelTable != null && Object.hasOwnProperty.call(message, "FeelTable"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.FeelTable);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqSwitchTable message, length delimited. Does not implicitly {@link Client2ProxyReqSwitchTable.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {IClient2ProxyReqSwitchTable} message Client2ProxyReqSwitchTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqSwitchTable.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqSwitchTable message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqSwitchTable} Client2ProxyReqSwitchTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqSwitchTable.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqSwitchTable();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 4: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 5: {
                    message.FeelTable = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqSwitchTable message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqSwitchTable} Client2ProxyReqSwitchTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqSwitchTable.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqSwitchTable message.
     * @function verify
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqSwitchTable.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            if (typeof message.FeelTable !== "boolean")
                return "FeelTable: boolean expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqSwitchTable message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqSwitchTable} Client2ProxyReqSwitchTable
     */
    Client2ProxyReqSwitchTable.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqSwitchTable)
            return object;
        let message = new $root.Client2ProxyReqSwitchTable();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.FeelTable != null)
            message.FeelTable = Boolean(object.FeelTable);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqSwitchTable message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {Client2ProxyReqSwitchTable} message Client2ProxyReqSwitchTable
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqSwitchTable.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.FeelTable = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            object.FeelTable = message.FeelTable;
        return object;
    };

    /**
     * Converts this Client2ProxyReqSwitchTable to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqSwitchTable
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqSwitchTable.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqSwitchTable
     * @function getTypeUrl
     * @memberof Client2ProxyReqSwitchTable
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqSwitchTable.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqSwitchTable";
    };

    return Client2ProxyReqSwitchTable;
})();

export const Client2ProxyAckSwitchTable = $root.Client2ProxyAckSwitchTable = (() => {

    /**
     * Properties of a Client2ProxyAckSwitchTable.
     * @exports IClient2ProxyAckSwitchTable
     * @interface IClient2ProxyAckSwitchTable
     * @property {number|null} [Res] Client2ProxyAckSwitchTable Res
     * @property {number|null} [UserID] Client2ProxyAckSwitchTable UserID
     * @property {number|null} [GameID] Client2ProxyAckSwitchTable GameID
     * @property {number|null} [ProductID] Client2ProxyAckSwitchTable ProductID
     * @property {number|null} [DeskNo] Client2ProxyAckSwitchTable DeskNo
     * @property {boolean|null} [FeelTable] Client2ProxyAckSwitchTable FeelTable
     */

    /**
     * Constructs a new Client2ProxyAckSwitchTable.
     * @exports Client2ProxyAckSwitchTable
     * @classdesc Represents a Client2ProxyAckSwitchTable.
     * @implements IClient2ProxyAckSwitchTable
     * @constructor
     * @param {IClient2ProxyAckSwitchTable=} [properties] Properties to set
     */
    function Client2ProxyAckSwitchTable(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckSwitchTable Res.
     * @member {number} Res
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.Res = 0;

    /**
     * Client2ProxyAckSwitchTable UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.UserID = 0;

    /**
     * Client2ProxyAckSwitchTable GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.GameID = 0;

    /**
     * Client2ProxyAckSwitchTable ProductID.
     * @member {number} ProductID
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.ProductID = 0;

    /**
     * Client2ProxyAckSwitchTable DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.DeskNo = 0;

    /**
     * Client2ProxyAckSwitchTable FeelTable.
     * @member {boolean} FeelTable
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     */
    Client2ProxyAckSwitchTable.prototype.FeelTable = false;

    /**
     * Creates a new Client2ProxyAckSwitchTable instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {IClient2ProxyAckSwitchTable=} [properties] Properties to set
     * @returns {Client2ProxyAckSwitchTable} Client2ProxyAckSwitchTable instance
     */
    Client2ProxyAckSwitchTable.create = function create(properties) {
        return new Client2ProxyAckSwitchTable(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckSwitchTable message. Does not implicitly {@link Client2ProxyAckSwitchTable.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {IClient2ProxyAckSwitchTable} message Client2ProxyAckSwitchTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckSwitchTable.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ProductID);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.DeskNo);
        if (message.FeelTable != null && Object.hasOwnProperty.call(message, "FeelTable"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.FeelTable);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckSwitchTable message, length delimited. Does not implicitly {@link Client2ProxyAckSwitchTable.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {IClient2ProxyAckSwitchTable} message Client2ProxyAckSwitchTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckSwitchTable.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckSwitchTable message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckSwitchTable} Client2ProxyAckSwitchTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckSwitchTable.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckSwitchTable();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductID = reader.uint32();
                    break;
                }
            case 5: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 6: {
                    message.FeelTable = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckSwitchTable message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckSwitchTable} Client2ProxyAckSwitchTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckSwitchTable.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckSwitchTable message.
     * @function verify
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckSwitchTable.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            if (typeof message.FeelTable !== "boolean")
                return "FeelTable: boolean expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckSwitchTable message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckSwitchTable} Client2ProxyAckSwitchTable
     */
    Client2ProxyAckSwitchTable.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckSwitchTable)
            return object;
        let message = new $root.Client2ProxyAckSwitchTable();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.FeelTable != null)
            message.FeelTable = Boolean(object.FeelTable);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckSwitchTable message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {Client2ProxyAckSwitchTable} message Client2ProxyAckSwitchTable
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckSwitchTable.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
            object.DeskNo = 0;
            object.FeelTable = false;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.FeelTable != null && message.hasOwnProperty("FeelTable"))
            object.FeelTable = message.FeelTable;
        return object;
    };

    /**
     * Converts this Client2ProxyAckSwitchTable to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckSwitchTable
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckSwitchTable.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckSwitchTable
     * @function getTypeUrl
     * @memberof Client2ProxyAckSwitchTable
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckSwitchTable.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckSwitchTable";
    };

    return Client2ProxyAckSwitchTable;
})();

export const Client2ProxyPushPayNotiy = $root.Client2ProxyPushPayNotiy = (() => {

    /**
     * Properties of a Client2ProxyPushPayNotiy.
     * @exports IClient2ProxyPushPayNotiy
     * @interface IClient2ProxyPushPayNotiy
     * @property {number|null} [Res] Client2ProxyPushPayNotiy Res
     * @property {number|null} [UserID] Client2ProxyPushPayNotiy UserID
     * @property {string|null} [PayOrder] Client2ProxyPushPayNotiy PayOrder
     * @property {string|null} [Amount] Client2ProxyPushPayNotiy Amount
     * @property {string|null} [Gold] Client2ProxyPushPayNotiy Gold
     * @property {boolean|null} [FirstTime] Client2ProxyPushPayNotiy FirstTime
     * @property {string|null} [Deposit] Client2ProxyPushPayNotiy Deposit
     * @property {string|null} [Withdraw] Client2ProxyPushPayNotiy Withdraw
     * @property {string|null} [Bonus] Client2ProxyPushPayNotiy Bonus
     * @property {string|null} [Diamond] Client2ProxyPushPayNotiy Diamond
     */

    /**
     * Constructs a new Client2ProxyPushPayNotiy.
     * @exports Client2ProxyPushPayNotiy
     * @classdesc Represents a Client2ProxyPushPayNotiy.
     * @implements IClient2ProxyPushPayNotiy
     * @constructor
     * @param {IClient2ProxyPushPayNotiy=} [properties] Properties to set
     */
    function Client2ProxyPushPayNotiy(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushPayNotiy Res.
     * @member {number} Res
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Res = 0;

    /**
     * Client2ProxyPushPayNotiy UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.UserID = 0;

    /**
     * Client2ProxyPushPayNotiy PayOrder.
     * @member {string} PayOrder
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.PayOrder = "";

    /**
     * Client2ProxyPushPayNotiy Amount.
     * @member {string} Amount
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Amount = "";

    /**
     * Client2ProxyPushPayNotiy Gold.
     * @member {string} Gold
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Gold = "";

    /**
     * Client2ProxyPushPayNotiy FirstTime.
     * @member {boolean} FirstTime
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.FirstTime = false;

    /**
     * Client2ProxyPushPayNotiy Deposit.
     * @member {string} Deposit
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Deposit = "";

    /**
     * Client2ProxyPushPayNotiy Withdraw.
     * @member {string} Withdraw
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Withdraw = "";

    /**
     * Client2ProxyPushPayNotiy Bonus.
     * @member {string} Bonus
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Bonus = "";

    /**
     * Client2ProxyPushPayNotiy Diamond.
     * @member {string} Diamond
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     */
    Client2ProxyPushPayNotiy.prototype.Diamond = "";

    /**
     * Creates a new Client2ProxyPushPayNotiy instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {IClient2ProxyPushPayNotiy=} [properties] Properties to set
     * @returns {Client2ProxyPushPayNotiy} Client2ProxyPushPayNotiy instance
     */
    Client2ProxyPushPayNotiy.create = function create(properties) {
        return new Client2ProxyPushPayNotiy(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushPayNotiy message. Does not implicitly {@link Client2ProxyPushPayNotiy.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {IClient2ProxyPushPayNotiy} message Client2ProxyPushPayNotiy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushPayNotiy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.PayOrder != null && Object.hasOwnProperty.call(message, "PayOrder"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.PayOrder);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Amount);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Gold);
        if (message.FirstTime != null && Object.hasOwnProperty.call(message, "FirstTime"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.FirstTime);
        if (message.Deposit != null && Object.hasOwnProperty.call(message, "Deposit"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Deposit);
        if (message.Withdraw != null && Object.hasOwnProperty.call(message, "Withdraw"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.Withdraw);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Bonus);
        if (message.Diamond != null && Object.hasOwnProperty.call(message, "Diamond"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.Diamond);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushPayNotiy message, length delimited. Does not implicitly {@link Client2ProxyPushPayNotiy.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {IClient2ProxyPushPayNotiy} message Client2ProxyPushPayNotiy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushPayNotiy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushPayNotiy message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushPayNotiy} Client2ProxyPushPayNotiy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushPayNotiy.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushPayNotiy();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.PayOrder = reader.string();
                    break;
                }
            case 4: {
                    message.Amount = reader.string();
                    break;
                }
            case 5: {
                    message.Gold = reader.string();
                    break;
                }
            case 6: {
                    message.FirstTime = reader.bool();
                    break;
                }
            case 7: {
                    message.Deposit = reader.string();
                    break;
                }
            case 8: {
                    message.Withdraw = reader.string();
                    break;
                }
            case 9: {
                    message.Bonus = reader.string();
                    break;
                }
            case 10: {
                    message.Diamond = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushPayNotiy message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushPayNotiy} Client2ProxyPushPayNotiy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushPayNotiy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushPayNotiy message.
     * @function verify
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushPayNotiy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PayOrder != null && message.hasOwnProperty("PayOrder"))
            if (!$util.isString(message.PayOrder))
                return "PayOrder: string expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isString(message.Gold))
                return "Gold: string expected";
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            if (typeof message.FirstTime !== "boolean")
                return "FirstTime: boolean expected";
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            if (!$util.isString(message.Deposit))
                return "Deposit: string expected";
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            if (!$util.isString(message.Withdraw))
                return "Withdraw: string expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            if (!$util.isString(message.Diamond))
                return "Diamond: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushPayNotiy message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushPayNotiy} Client2ProxyPushPayNotiy
     */
    Client2ProxyPushPayNotiy.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushPayNotiy)
            return object;
        let message = new $root.Client2ProxyPushPayNotiy();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PayOrder != null)
            message.PayOrder = String(object.PayOrder);
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Gold != null)
            message.Gold = String(object.Gold);
        if (object.FirstTime != null)
            message.FirstTime = Boolean(object.FirstTime);
        if (object.Deposit != null)
            message.Deposit = String(object.Deposit);
        if (object.Withdraw != null)
            message.Withdraw = String(object.Withdraw);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        if (object.Diamond != null)
            message.Diamond = String(object.Diamond);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushPayNotiy message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {Client2ProxyPushPayNotiy} message Client2ProxyPushPayNotiy
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushPayNotiy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.PayOrder = "";
            object.Amount = "";
            object.Gold = "";
            object.FirstTime = false;
            object.Deposit = "";
            object.Withdraw = "";
            object.Bonus = "";
            object.Diamond = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PayOrder != null && message.hasOwnProperty("PayOrder"))
            object.PayOrder = message.PayOrder;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            object.FirstTime = message.FirstTime;
        if (message.Deposit != null && message.hasOwnProperty("Deposit"))
            object.Deposit = message.Deposit;
        if (message.Withdraw != null && message.hasOwnProperty("Withdraw"))
            object.Withdraw = message.Withdraw;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        if (message.Diamond != null && message.hasOwnProperty("Diamond"))
            object.Diamond = message.Diamond;
        return object;
    };

    /**
     * Converts this Client2ProxyPushPayNotiy to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushPayNotiy
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushPayNotiy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushPayNotiy
     * @function getTypeUrl
     * @memberof Client2ProxyPushPayNotiy
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushPayNotiy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushPayNotiy";
    };

    return Client2ProxyPushPayNotiy;
})();

export const Client2ProxyReqWithDraw = $root.Client2ProxyReqWithDraw = (() => {

    /**
     * Properties of a Client2ProxyReqWithDraw.
     * @exports IClient2ProxyReqWithDraw
     * @interface IClient2ProxyReqWithDraw
     * @property {number|null} [UserID] Client2ProxyReqWithDraw UserID
     * @property {string|null} [Mail] Client2ProxyReqWithDraw Mail
     * @property {string|null} [Amount] Client2ProxyReqWithDraw Amount
     * @property {string|null} [Biz] Client2ProxyReqWithDraw Biz
     * @property {string|null} [BankCardType] Client2ProxyReqWithDraw BankCardType
     * @property {string|null} [BankCode] Client2ProxyReqWithDraw BankCode
     * @property {string|null} [BankCardNo] Client2ProxyReqWithDraw BankCardNo
     * @property {string|null} [BankCardName] Client2ProxyReqWithDraw BankCardName
     * @property {string|null} [CertType] Client2ProxyReqWithDraw CertType
     * @property {string|null} [CertId] Client2ProxyReqWithDraw CertId
     * @property {string|null} [Mobile] Client2ProxyReqWithDraw Mobile
     * @property {string|null} [CreditValid] Client2ProxyReqWithDraw CreditValid
     * @property {string|null} [CreditCvv] Client2ProxyReqWithDraw CreditCvv
     * @property {string|null} [BankProvince] Client2ProxyReqWithDraw BankProvince
     * @property {string|null} [BankCity] Client2ProxyReqWithDraw BankCity
     * @property {string|null} [BankLineCode] Client2ProxyReqWithDraw BankLineCode
     * @property {string|null} [BankName] Client2ProxyReqWithDraw BankName
     * @property {string|null} [Remark] Client2ProxyReqWithDraw Remark
     * @property {string|null} [FirstName] Client2ProxyReqWithDraw FirstName
     * @property {string|null} [LastName] Client2ProxyReqWithDraw LastName
     * @property {string|null} [CardYear] Client2ProxyReqWithDraw CardYear
     * @property {string|null} [CardMonth] Client2ProxyReqWithDraw CardMonth
     * @property {number|null} [Type] Client2ProxyReqWithDraw Type
     * @property {string|null} [Currency] Client2ProxyReqWithDraw Currency
     * @property {string|null} [PmId] Client2ProxyReqWithDraw PmId
     * @property {number|null} [BankType] Client2ProxyReqWithDraw BankType
     * @property {string|null} [EwalletType] Client2ProxyReqWithDraw EwalletType
     * @property {number|null} [ChannelID] Client2ProxyReqWithDraw ChannelID
     * @property {string|null} [CardId] Client2ProxyReqWithDraw CardId
     * @property {string|null} [UstdAddress] Client2ProxyReqWithDraw UstdAddress
     */

    /**
     * Constructs a new Client2ProxyReqWithDraw.
     * @exports Client2ProxyReqWithDraw
     * @classdesc Represents a Client2ProxyReqWithDraw.
     * @implements IClient2ProxyReqWithDraw
     * @constructor
     * @param {IClient2ProxyReqWithDraw=} [properties] Properties to set
     */
    function Client2ProxyReqWithDraw(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqWithDraw UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.UserID = 0;

    /**
     * Client2ProxyReqWithDraw Mail.
     * @member {string} Mail
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Mail = "";

    /**
     * Client2ProxyReqWithDraw Amount.
     * @member {string} Amount
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Amount = "";

    /**
     * Client2ProxyReqWithDraw Biz.
     * @member {string} Biz
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Biz = "";

    /**
     * Client2ProxyReqWithDraw BankCardType.
     * @member {string} BankCardType
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankCardType = "";

    /**
     * Client2ProxyReqWithDraw BankCode.
     * @member {string} BankCode
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankCode = "";

    /**
     * Client2ProxyReqWithDraw BankCardNo.
     * @member {string} BankCardNo
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankCardNo = "";

    /**
     * Client2ProxyReqWithDraw BankCardName.
     * @member {string} BankCardName
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankCardName = "";

    /**
     * Client2ProxyReqWithDraw CertType.
     * @member {string} CertType
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CertType = "";

    /**
     * Client2ProxyReqWithDraw CertId.
     * @member {string} CertId
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CertId = "";

    /**
     * Client2ProxyReqWithDraw Mobile.
     * @member {string} Mobile
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Mobile = "";

    /**
     * Client2ProxyReqWithDraw CreditValid.
     * @member {string} CreditValid
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CreditValid = "";

    /**
     * Client2ProxyReqWithDraw CreditCvv.
     * @member {string} CreditCvv
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CreditCvv = "";

    /**
     * Client2ProxyReqWithDraw BankProvince.
     * @member {string} BankProvince
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankProvince = "";

    /**
     * Client2ProxyReqWithDraw BankCity.
     * @member {string} BankCity
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankCity = "";

    /**
     * Client2ProxyReqWithDraw BankLineCode.
     * @member {string} BankLineCode
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankLineCode = "";

    /**
     * Client2ProxyReqWithDraw BankName.
     * @member {string} BankName
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankName = "";

    /**
     * Client2ProxyReqWithDraw Remark.
     * @member {string} Remark
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Remark = "";

    /**
     * Client2ProxyReqWithDraw FirstName.
     * @member {string} FirstName
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.FirstName = "";

    /**
     * Client2ProxyReqWithDraw LastName.
     * @member {string} LastName
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.LastName = "";

    /**
     * Client2ProxyReqWithDraw CardYear.
     * @member {string} CardYear
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CardYear = "";

    /**
     * Client2ProxyReqWithDraw CardMonth.
     * @member {string} CardMonth
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CardMonth = "";

    /**
     * Client2ProxyReqWithDraw Type.
     * @member {number} Type
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Type = 0;

    /**
     * Client2ProxyReqWithDraw Currency.
     * @member {string} Currency
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.Currency = "";

    /**
     * Client2ProxyReqWithDraw PmId.
     * @member {string} PmId
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.PmId = "";

    /**
     * Client2ProxyReqWithDraw BankType.
     * @member {number} BankType
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.BankType = 0;

    /**
     * Client2ProxyReqWithDraw EwalletType.
     * @member {string} EwalletType
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.EwalletType = "";

    /**
     * Client2ProxyReqWithDraw ChannelID.
     * @member {number} ChannelID
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.ChannelID = 0;

    /**
     * Client2ProxyReqWithDraw CardId.
     * @member {string} CardId
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.CardId = "";

    /**
     * Client2ProxyReqWithDraw UstdAddress.
     * @member {string} UstdAddress
     * @memberof Client2ProxyReqWithDraw
     * @instance
     */
    Client2ProxyReqWithDraw.prototype.UstdAddress = "";

    /**
     * Creates a new Client2ProxyReqWithDraw instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {IClient2ProxyReqWithDraw=} [properties] Properties to set
     * @returns {Client2ProxyReqWithDraw} Client2ProxyReqWithDraw instance
     */
    Client2ProxyReqWithDraw.create = function create(properties) {
        return new Client2ProxyReqWithDraw(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqWithDraw message. Does not implicitly {@link Client2ProxyReqWithDraw.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {IClient2ProxyReqWithDraw} message Client2ProxyReqWithDraw message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqWithDraw.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Mail != null && Object.hasOwnProperty.call(message, "Mail"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Mail);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Amount);
        if (message.Biz != null && Object.hasOwnProperty.call(message, "Biz"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Biz);
        if (message.BankCardType != null && Object.hasOwnProperty.call(message, "BankCardType"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BankCardType);
        if (message.BankCode != null && Object.hasOwnProperty.call(message, "BankCode"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.BankCode);
        if (message.BankCardNo != null && Object.hasOwnProperty.call(message, "BankCardNo"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.BankCardNo);
        if (message.BankCardName != null && Object.hasOwnProperty.call(message, "BankCardName"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.BankCardName);
        if (message.CertType != null && Object.hasOwnProperty.call(message, "CertType"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.CertType);
        if (message.CertId != null && Object.hasOwnProperty.call(message, "CertId"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.CertId);
        if (message.Mobile != null && Object.hasOwnProperty.call(message, "Mobile"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.Mobile);
        if (message.CreditValid != null && Object.hasOwnProperty.call(message, "CreditValid"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.CreditValid);
        if (message.CreditCvv != null && Object.hasOwnProperty.call(message, "CreditCvv"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.CreditCvv);
        if (message.BankProvince != null && Object.hasOwnProperty.call(message, "BankProvince"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.BankProvince);
        if (message.BankCity != null && Object.hasOwnProperty.call(message, "BankCity"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.BankCity);
        if (message.BankLineCode != null && Object.hasOwnProperty.call(message, "BankLineCode"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.BankLineCode);
        if (message.BankName != null && Object.hasOwnProperty.call(message, "BankName"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.BankName);
        if (message.Remark != null && Object.hasOwnProperty.call(message, "Remark"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.Remark);
        if (message.FirstName != null && Object.hasOwnProperty.call(message, "FirstName"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.FirstName);
        if (message.LastName != null && Object.hasOwnProperty.call(message, "LastName"))
            writer.uint32(/* id 20, wireType 2 =*/162).string(message.LastName);
        if (message.CardYear != null && Object.hasOwnProperty.call(message, "CardYear"))
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.CardYear);
        if (message.CardMonth != null && Object.hasOwnProperty.call(message, "CardMonth"))
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.CardMonth);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 23, wireType 0 =*/184).uint32(message.Type);
        if (message.Currency != null && Object.hasOwnProperty.call(message, "Currency"))
            writer.uint32(/* id 24, wireType 2 =*/194).string(message.Currency);
        if (message.PmId != null && Object.hasOwnProperty.call(message, "PmId"))
            writer.uint32(/* id 25, wireType 2 =*/202).string(message.PmId);
        if (message.BankType != null && Object.hasOwnProperty.call(message, "BankType"))
            writer.uint32(/* id 26, wireType 0 =*/208).uint32(message.BankType);
        if (message.EwalletType != null && Object.hasOwnProperty.call(message, "EwalletType"))
            writer.uint32(/* id 27, wireType 2 =*/218).string(message.EwalletType);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 28, wireType 0 =*/224).uint32(message.ChannelID);
        if (message.CardId != null && Object.hasOwnProperty.call(message, "CardId"))
            writer.uint32(/* id 29, wireType 2 =*/234).string(message.CardId);
        if (message.UstdAddress != null && Object.hasOwnProperty.call(message, "UstdAddress"))
            writer.uint32(/* id 30, wireType 2 =*/242).string(message.UstdAddress);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqWithDraw message, length delimited. Does not implicitly {@link Client2ProxyReqWithDraw.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {IClient2ProxyReqWithDraw} message Client2ProxyReqWithDraw message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqWithDraw.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqWithDraw message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqWithDraw} Client2ProxyReqWithDraw
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqWithDraw.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqWithDraw();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mail = reader.string();
                    break;
                }
            case 3: {
                    message.Amount = reader.string();
                    break;
                }
            case 4: {
                    message.Biz = reader.string();
                    break;
                }
            case 5: {
                    message.BankCardType = reader.string();
                    break;
                }
            case 6: {
                    message.BankCode = reader.string();
                    break;
                }
            case 7: {
                    message.BankCardNo = reader.string();
                    break;
                }
            case 8: {
                    message.BankCardName = reader.string();
                    break;
                }
            case 9: {
                    message.CertType = reader.string();
                    break;
                }
            case 10: {
                    message.CertId = reader.string();
                    break;
                }
            case 11: {
                    message.Mobile = reader.string();
                    break;
                }
            case 12: {
                    message.CreditValid = reader.string();
                    break;
                }
            case 13: {
                    message.CreditCvv = reader.string();
                    break;
                }
            case 14: {
                    message.BankProvince = reader.string();
                    break;
                }
            case 15: {
                    message.BankCity = reader.string();
                    break;
                }
            case 16: {
                    message.BankLineCode = reader.string();
                    break;
                }
            case 17: {
                    message.BankName = reader.string();
                    break;
                }
            case 18: {
                    message.Remark = reader.string();
                    break;
                }
            case 19: {
                    message.FirstName = reader.string();
                    break;
                }
            case 20: {
                    message.LastName = reader.string();
                    break;
                }
            case 21: {
                    message.CardYear = reader.string();
                    break;
                }
            case 22: {
                    message.CardMonth = reader.string();
                    break;
                }
            case 23: {
                    message.Type = reader.uint32();
                    break;
                }
            case 24: {
                    message.Currency = reader.string();
                    break;
                }
            case 25: {
                    message.PmId = reader.string();
                    break;
                }
            case 26: {
                    message.BankType = reader.uint32();
                    break;
                }
            case 27: {
                    message.EwalletType = reader.string();
                    break;
                }
            case 28: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 29: {
                    message.CardId = reader.string();
                    break;
                }
            case 30: {
                    message.UstdAddress = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqWithDraw message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqWithDraw} Client2ProxyReqWithDraw
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqWithDraw.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqWithDraw message.
     * @function verify
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqWithDraw.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Mail != null && message.hasOwnProperty("Mail"))
            if (!$util.isString(message.Mail))
                return "Mail: string expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Biz != null && message.hasOwnProperty("Biz"))
            if (!$util.isString(message.Biz))
                return "Biz: string expected";
        if (message.BankCardType != null && message.hasOwnProperty("BankCardType"))
            if (!$util.isString(message.BankCardType))
                return "BankCardType: string expected";
        if (message.BankCode != null && message.hasOwnProperty("BankCode"))
            if (!$util.isString(message.BankCode))
                return "BankCode: string expected";
        if (message.BankCardNo != null && message.hasOwnProperty("BankCardNo"))
            if (!$util.isString(message.BankCardNo))
                return "BankCardNo: string expected";
        if (message.BankCardName != null && message.hasOwnProperty("BankCardName"))
            if (!$util.isString(message.BankCardName))
                return "BankCardName: string expected";
        if (message.CertType != null && message.hasOwnProperty("CertType"))
            if (!$util.isString(message.CertType))
                return "CertType: string expected";
        if (message.CertId != null && message.hasOwnProperty("CertId"))
            if (!$util.isString(message.CertId))
                return "CertId: string expected";
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            if (!$util.isString(message.Mobile))
                return "Mobile: string expected";
        if (message.CreditValid != null && message.hasOwnProperty("CreditValid"))
            if (!$util.isString(message.CreditValid))
                return "CreditValid: string expected";
        if (message.CreditCvv != null && message.hasOwnProperty("CreditCvv"))
            if (!$util.isString(message.CreditCvv))
                return "CreditCvv: string expected";
        if (message.BankProvince != null && message.hasOwnProperty("BankProvince"))
            if (!$util.isString(message.BankProvince))
                return "BankProvince: string expected";
        if (message.BankCity != null && message.hasOwnProperty("BankCity"))
            if (!$util.isString(message.BankCity))
                return "BankCity: string expected";
        if (message.BankLineCode != null && message.hasOwnProperty("BankLineCode"))
            if (!$util.isString(message.BankLineCode))
                return "BankLineCode: string expected";
        if (message.BankName != null && message.hasOwnProperty("BankName"))
            if (!$util.isString(message.BankName))
                return "BankName: string expected";
        if (message.Remark != null && message.hasOwnProperty("Remark"))
            if (!$util.isString(message.Remark))
                return "Remark: string expected";
        if (message.FirstName != null && message.hasOwnProperty("FirstName"))
            if (!$util.isString(message.FirstName))
                return "FirstName: string expected";
        if (message.LastName != null && message.hasOwnProperty("LastName"))
            if (!$util.isString(message.LastName))
                return "LastName: string expected";
        if (message.CardYear != null && message.hasOwnProperty("CardYear"))
            if (!$util.isString(message.CardYear))
                return "CardYear: string expected";
        if (message.CardMonth != null && message.hasOwnProperty("CardMonth"))
            if (!$util.isString(message.CardMonth))
                return "CardMonth: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            if (!$util.isString(message.Currency))
                return "Currency: string expected";
        if (message.PmId != null && message.hasOwnProperty("PmId"))
            if (!$util.isString(message.PmId))
                return "PmId: string expected";
        if (message.BankType != null && message.hasOwnProperty("BankType"))
            if (!$util.isInteger(message.BankType))
                return "BankType: integer expected";
        if (message.EwalletType != null && message.hasOwnProperty("EwalletType"))
            if (!$util.isString(message.EwalletType))
                return "EwalletType: string expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.CardId != null && message.hasOwnProperty("CardId"))
            if (!$util.isString(message.CardId))
                return "CardId: string expected";
        if (message.UstdAddress != null && message.hasOwnProperty("UstdAddress"))
            if (!$util.isString(message.UstdAddress))
                return "UstdAddress: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqWithDraw message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqWithDraw} Client2ProxyReqWithDraw
     */
    Client2ProxyReqWithDraw.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqWithDraw)
            return object;
        let message = new $root.Client2ProxyReqWithDraw();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Mail != null)
            message.Mail = String(object.Mail);
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Biz != null)
            message.Biz = String(object.Biz);
        if (object.BankCardType != null)
            message.BankCardType = String(object.BankCardType);
        if (object.BankCode != null)
            message.BankCode = String(object.BankCode);
        if (object.BankCardNo != null)
            message.BankCardNo = String(object.BankCardNo);
        if (object.BankCardName != null)
            message.BankCardName = String(object.BankCardName);
        if (object.CertType != null)
            message.CertType = String(object.CertType);
        if (object.CertId != null)
            message.CertId = String(object.CertId);
        if (object.Mobile != null)
            message.Mobile = String(object.Mobile);
        if (object.CreditValid != null)
            message.CreditValid = String(object.CreditValid);
        if (object.CreditCvv != null)
            message.CreditCvv = String(object.CreditCvv);
        if (object.BankProvince != null)
            message.BankProvince = String(object.BankProvince);
        if (object.BankCity != null)
            message.BankCity = String(object.BankCity);
        if (object.BankLineCode != null)
            message.BankLineCode = String(object.BankLineCode);
        if (object.BankName != null)
            message.BankName = String(object.BankName);
        if (object.Remark != null)
            message.Remark = String(object.Remark);
        if (object.FirstName != null)
            message.FirstName = String(object.FirstName);
        if (object.LastName != null)
            message.LastName = String(object.LastName);
        if (object.CardYear != null)
            message.CardYear = String(object.CardYear);
        if (object.CardMonth != null)
            message.CardMonth = String(object.CardMonth);
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.Currency != null)
            message.Currency = String(object.Currency);
        if (object.PmId != null)
            message.PmId = String(object.PmId);
        if (object.BankType != null)
            message.BankType = object.BankType >>> 0;
        if (object.EwalletType != null)
            message.EwalletType = String(object.EwalletType);
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.CardId != null)
            message.CardId = String(object.CardId);
        if (object.UstdAddress != null)
            message.UstdAddress = String(object.UstdAddress);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqWithDraw message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {Client2ProxyReqWithDraw} message Client2ProxyReqWithDraw
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqWithDraw.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Mail = "";
            object.Amount = "";
            object.Biz = "";
            object.BankCardType = "";
            object.BankCode = "";
            object.BankCardNo = "";
            object.BankCardName = "";
            object.CertType = "";
            object.CertId = "";
            object.Mobile = "";
            object.CreditValid = "";
            object.CreditCvv = "";
            object.BankProvince = "";
            object.BankCity = "";
            object.BankLineCode = "";
            object.BankName = "";
            object.Remark = "";
            object.FirstName = "";
            object.LastName = "";
            object.CardYear = "";
            object.CardMonth = "";
            object.Type = 0;
            object.Currency = "";
            object.PmId = "";
            object.BankType = 0;
            object.EwalletType = "";
            object.ChannelID = 0;
            object.CardId = "";
            object.UstdAddress = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Mail != null && message.hasOwnProperty("Mail"))
            object.Mail = message.Mail;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Biz != null && message.hasOwnProperty("Biz"))
            object.Biz = message.Biz;
        if (message.BankCardType != null && message.hasOwnProperty("BankCardType"))
            object.BankCardType = message.BankCardType;
        if (message.BankCode != null && message.hasOwnProperty("BankCode"))
            object.BankCode = message.BankCode;
        if (message.BankCardNo != null && message.hasOwnProperty("BankCardNo"))
            object.BankCardNo = message.BankCardNo;
        if (message.BankCardName != null && message.hasOwnProperty("BankCardName"))
            object.BankCardName = message.BankCardName;
        if (message.CertType != null && message.hasOwnProperty("CertType"))
            object.CertType = message.CertType;
        if (message.CertId != null && message.hasOwnProperty("CertId"))
            object.CertId = message.CertId;
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            object.Mobile = message.Mobile;
        if (message.CreditValid != null && message.hasOwnProperty("CreditValid"))
            object.CreditValid = message.CreditValid;
        if (message.CreditCvv != null && message.hasOwnProperty("CreditCvv"))
            object.CreditCvv = message.CreditCvv;
        if (message.BankProvince != null && message.hasOwnProperty("BankProvince"))
            object.BankProvince = message.BankProvince;
        if (message.BankCity != null && message.hasOwnProperty("BankCity"))
            object.BankCity = message.BankCity;
        if (message.BankLineCode != null && message.hasOwnProperty("BankLineCode"))
            object.BankLineCode = message.BankLineCode;
        if (message.BankName != null && message.hasOwnProperty("BankName"))
            object.BankName = message.BankName;
        if (message.Remark != null && message.hasOwnProperty("Remark"))
            object.Remark = message.Remark;
        if (message.FirstName != null && message.hasOwnProperty("FirstName"))
            object.FirstName = message.FirstName;
        if (message.LastName != null && message.hasOwnProperty("LastName"))
            object.LastName = message.LastName;
        if (message.CardYear != null && message.hasOwnProperty("CardYear"))
            object.CardYear = message.CardYear;
        if (message.CardMonth != null && message.hasOwnProperty("CardMonth"))
            object.CardMonth = message.CardMonth;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            object.Currency = message.Currency;
        if (message.PmId != null && message.hasOwnProperty("PmId"))
            object.PmId = message.PmId;
        if (message.BankType != null && message.hasOwnProperty("BankType"))
            object.BankType = message.BankType;
        if (message.EwalletType != null && message.hasOwnProperty("EwalletType"))
            object.EwalletType = message.EwalletType;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.CardId != null && message.hasOwnProperty("CardId"))
            object.CardId = message.CardId;
        if (message.UstdAddress != null && message.hasOwnProperty("UstdAddress"))
            object.UstdAddress = message.UstdAddress;
        return object;
    };

    /**
     * Converts this Client2ProxyReqWithDraw to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqWithDraw
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqWithDraw.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqWithDraw
     * @function getTypeUrl
     * @memberof Client2ProxyReqWithDraw
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqWithDraw.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqWithDraw";
    };

    return Client2ProxyReqWithDraw;
})();

export const Client2ProxyAckWithDraw = $root.Client2ProxyAckWithDraw = (() => {

    /**
     * Properties of a Client2ProxyAckWithDraw.
     * @exports IClient2ProxyAckWithDraw
     * @interface IClient2ProxyAckWithDraw
     * @property {number|null} [Res] Client2ProxyAckWithDraw Res
     * @property {number|null} [UserID] Client2ProxyAckWithDraw UserID
     * @property {string|null} [Amount] Client2ProxyAckWithDraw Amount
     * @property {string|null} [Gold] Client2ProxyAckWithDraw Gold
     * @property {string|null} [Order] Client2ProxyAckWithDraw Order
     * @property {string|null} [OrderStat] Client2ProxyAckWithDraw OrderStat
     */

    /**
     * Constructs a new Client2ProxyAckWithDraw.
     * @exports Client2ProxyAckWithDraw
     * @classdesc Represents a Client2ProxyAckWithDraw.
     * @implements IClient2ProxyAckWithDraw
     * @constructor
     * @param {IClient2ProxyAckWithDraw=} [properties] Properties to set
     */
    function Client2ProxyAckWithDraw(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckWithDraw Res.
     * @member {number} Res
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.Res = 0;

    /**
     * Client2ProxyAckWithDraw UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.UserID = 0;

    /**
     * Client2ProxyAckWithDraw Amount.
     * @member {string} Amount
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.Amount = "";

    /**
     * Client2ProxyAckWithDraw Gold.
     * @member {string} Gold
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.Gold = "";

    /**
     * Client2ProxyAckWithDraw Order.
     * @member {string} Order
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.Order = "";

    /**
     * Client2ProxyAckWithDraw OrderStat.
     * @member {string} OrderStat
     * @memberof Client2ProxyAckWithDraw
     * @instance
     */
    Client2ProxyAckWithDraw.prototype.OrderStat = "";

    /**
     * Creates a new Client2ProxyAckWithDraw instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {IClient2ProxyAckWithDraw=} [properties] Properties to set
     * @returns {Client2ProxyAckWithDraw} Client2ProxyAckWithDraw instance
     */
    Client2ProxyAckWithDraw.create = function create(properties) {
        return new Client2ProxyAckWithDraw(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckWithDraw message. Does not implicitly {@link Client2ProxyAckWithDraw.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {IClient2ProxyAckWithDraw} message Client2ProxyAckWithDraw message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckWithDraw.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Amount);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Gold);
        if (message.Order != null && Object.hasOwnProperty.call(message, "Order"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Order);
        if (message.OrderStat != null && Object.hasOwnProperty.call(message, "OrderStat"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.OrderStat);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckWithDraw message, length delimited. Does not implicitly {@link Client2ProxyAckWithDraw.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {IClient2ProxyAckWithDraw} message Client2ProxyAckWithDraw message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckWithDraw.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckWithDraw message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckWithDraw} Client2ProxyAckWithDraw
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckWithDraw.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckWithDraw();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Amount = reader.string();
                    break;
                }
            case 4: {
                    message.Gold = reader.string();
                    break;
                }
            case 5: {
                    message.Order = reader.string();
                    break;
                }
            case 6: {
                    message.OrderStat = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckWithDraw message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckWithDraw} Client2ProxyAckWithDraw
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckWithDraw.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckWithDraw message.
     * @function verify
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckWithDraw.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isString(message.Gold))
                return "Gold: string expected";
        if (message.Order != null && message.hasOwnProperty("Order"))
            if (!$util.isString(message.Order))
                return "Order: string expected";
        if (message.OrderStat != null && message.hasOwnProperty("OrderStat"))
            if (!$util.isString(message.OrderStat))
                return "OrderStat: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckWithDraw message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckWithDraw} Client2ProxyAckWithDraw
     */
    Client2ProxyAckWithDraw.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckWithDraw)
            return object;
        let message = new $root.Client2ProxyAckWithDraw();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Gold != null)
            message.Gold = String(object.Gold);
        if (object.Order != null)
            message.Order = String(object.Order);
        if (object.OrderStat != null)
            message.OrderStat = String(object.OrderStat);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckWithDraw message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {Client2ProxyAckWithDraw} message Client2ProxyAckWithDraw
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckWithDraw.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.Amount = "";
            object.Gold = "";
            object.Order = "";
            object.OrderStat = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            object.Gold = message.Gold;
        if (message.Order != null && message.hasOwnProperty("Order"))
            object.Order = message.Order;
        if (message.OrderStat != null && message.hasOwnProperty("OrderStat"))
            object.OrderStat = message.OrderStat;
        return object;
    };

    /**
     * Converts this Client2ProxyAckWithDraw to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckWithDraw
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckWithDraw.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckWithDraw
     * @function getTypeUrl
     * @memberof Client2ProxyAckWithDraw
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckWithDraw.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckWithDraw";
    };

    return Client2ProxyAckWithDraw;
})();

export const Client2ProxyReqGetToken = $root.Client2ProxyReqGetToken = (() => {

    /**
     * Properties of a Client2ProxyReqGetToken.
     * @exports IClient2ProxyReqGetToken
     * @interface IClient2ProxyReqGetToken
     * @property {number|null} [UserID] Client2ProxyReqGetToken UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetToken.
     * @exports Client2ProxyReqGetToken
     * @classdesc Represents a Client2ProxyReqGetToken.
     * @implements IClient2ProxyReqGetToken
     * @constructor
     * @param {IClient2ProxyReqGetToken=} [properties] Properties to set
     */
    function Client2ProxyReqGetToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetToken UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetToken
     * @instance
     */
    Client2ProxyReqGetToken.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetToken instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {IClient2ProxyReqGetToken=} [properties] Properties to set
     * @returns {Client2ProxyReqGetToken} Client2ProxyReqGetToken instance
     */
    Client2ProxyReqGetToken.create = function create(properties) {
        return new Client2ProxyReqGetToken(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetToken message. Does not implicitly {@link Client2ProxyReqGetToken.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {IClient2ProxyReqGetToken} message Client2ProxyReqGetToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetToken message, length delimited. Does not implicitly {@link Client2ProxyReqGetToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {IClient2ProxyReqGetToken} message Client2ProxyReqGetToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetToken message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetToken} Client2ProxyReqGetToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetToken.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetToken} Client2ProxyReqGetToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetToken message.
     * @function verify
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetToken} Client2ProxyReqGetToken
     */
    Client2ProxyReqGetToken.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetToken)
            return object;
        let message = new $root.Client2ProxyReqGetToken();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {Client2ProxyReqGetToken} message Client2ProxyReqGetToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetToken to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetToken
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetToken
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetToken";
    };

    return Client2ProxyReqGetToken;
})();

export const Client2ProxyAckGetToken = $root.Client2ProxyAckGetToken = (() => {

    /**
     * Properties of a Client2ProxyAckGetToken.
     * @exports IClient2ProxyAckGetToken
     * @interface IClient2ProxyAckGetToken
     * @property {number|null} [Res] Client2ProxyAckGetToken Res
     * @property {number|null} [UserID] Client2ProxyAckGetToken UserID
     * @property {string|null} [Token] Client2ProxyAckGetToken Token
     */

    /**
     * Constructs a new Client2ProxyAckGetToken.
     * @exports Client2ProxyAckGetToken
     * @classdesc Represents a Client2ProxyAckGetToken.
     * @implements IClient2ProxyAckGetToken
     * @constructor
     * @param {IClient2ProxyAckGetToken=} [properties] Properties to set
     */
    function Client2ProxyAckGetToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetToken Res.
     * @member {number} Res
     * @memberof Client2ProxyAckGetToken
     * @instance
     */
    Client2ProxyAckGetToken.prototype.Res = 0;

    /**
     * Client2ProxyAckGetToken UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetToken
     * @instance
     */
    Client2ProxyAckGetToken.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetToken Token.
     * @member {string} Token
     * @memberof Client2ProxyAckGetToken
     * @instance
     */
    Client2ProxyAckGetToken.prototype.Token = "";

    /**
     * Creates a new Client2ProxyAckGetToken instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {IClient2ProxyAckGetToken=} [properties] Properties to set
     * @returns {Client2ProxyAckGetToken} Client2ProxyAckGetToken instance
     */
    Client2ProxyAckGetToken.create = function create(properties) {
        return new Client2ProxyAckGetToken(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetToken message. Does not implicitly {@link Client2ProxyAckGetToken.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {IClient2ProxyAckGetToken} message Client2ProxyAckGetToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Token);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetToken message, length delimited. Does not implicitly {@link Client2ProxyAckGetToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {IClient2ProxyAckGetToken} message Client2ProxyAckGetToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetToken message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetToken} Client2ProxyAckGetToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetToken.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Token = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetToken} Client2ProxyAckGetToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetToken message.
     * @function verify
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Token != null && message.hasOwnProperty("Token"))
            if (!$util.isString(message.Token))
                return "Token: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetToken} Client2ProxyAckGetToken
     */
    Client2ProxyAckGetToken.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetToken)
            return object;
        let message = new $root.Client2ProxyAckGetToken();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Token != null)
            message.Token = String(object.Token);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {Client2ProxyAckGetToken} message Client2ProxyAckGetToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.Token = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Token != null && message.hasOwnProperty("Token"))
            object.Token = message.Token;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetToken to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetToken
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetToken
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetToken";
    };

    return Client2ProxyAckGetToken;
})();

export const Client2ProxyReqGetBalance = $root.Client2ProxyReqGetBalance = (() => {

    /**
     * Properties of a Client2ProxyReqGetBalance.
     * @exports IClient2ProxyReqGetBalance
     * @interface IClient2ProxyReqGetBalance
     * @property {number|null} [UserID] Client2ProxyReqGetBalance UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetBalance.
     * @exports Client2ProxyReqGetBalance
     * @classdesc Represents a Client2ProxyReqGetBalance.
     * @implements IClient2ProxyReqGetBalance
     * @constructor
     * @param {IClient2ProxyReqGetBalance=} [properties] Properties to set
     */
    function Client2ProxyReqGetBalance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetBalance UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetBalance
     * @instance
     */
    Client2ProxyReqGetBalance.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetBalance instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {IClient2ProxyReqGetBalance=} [properties] Properties to set
     * @returns {Client2ProxyReqGetBalance} Client2ProxyReqGetBalance instance
     */
    Client2ProxyReqGetBalance.create = function create(properties) {
        return new Client2ProxyReqGetBalance(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetBalance message. Does not implicitly {@link Client2ProxyReqGetBalance.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {IClient2ProxyReqGetBalance} message Client2ProxyReqGetBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetBalance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetBalance message, length delimited. Does not implicitly {@link Client2ProxyReqGetBalance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {IClient2ProxyReqGetBalance} message Client2ProxyReqGetBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetBalance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetBalance message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetBalance} Client2ProxyReqGetBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetBalance.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetBalance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetBalance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetBalance} Client2ProxyReqGetBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetBalance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetBalance message.
     * @function verify
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetBalance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetBalance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetBalance} Client2ProxyReqGetBalance
     */
    Client2ProxyReqGetBalance.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetBalance)
            return object;
        let message = new $root.Client2ProxyReqGetBalance();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetBalance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {Client2ProxyReqGetBalance} message Client2ProxyReqGetBalance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetBalance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetBalance to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetBalance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetBalance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetBalance
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetBalance
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetBalance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetBalance";
    };

    return Client2ProxyReqGetBalance;
})();

export const Client2ProxyAckGetBalance = $root.Client2ProxyAckGetBalance = (() => {

    /**
     * Properties of a Client2ProxyAckGetBalance.
     * @exports IClient2ProxyAckGetBalance
     * @interface IClient2ProxyAckGetBalance
     * @property {number|null} [Res] Client2ProxyAckGetBalance Res
     * @property {number|null} [UserID] Client2ProxyAckGetBalance UserID
     * @property {string|null} [DepositGold] Client2ProxyAckGetBalance DepositGold
     * @property {string|null} [CanWithDrawGold] Client2ProxyAckGetBalance CanWithDrawGold
     * @property {string|null} [ToalGold] Client2ProxyAckGetBalance ToalGold
     * @property {string|null} [BonusGold] Client2ProxyAckGetBalance BonusGold
     * @property {string|null} [DiamondGold] Client2ProxyAckGetBalance DiamondGold
     */

    /**
     * Constructs a new Client2ProxyAckGetBalance.
     * @exports Client2ProxyAckGetBalance
     * @classdesc Represents a Client2ProxyAckGetBalance.
     * @implements IClient2ProxyAckGetBalance
     * @constructor
     * @param {IClient2ProxyAckGetBalance=} [properties] Properties to set
     */
    function Client2ProxyAckGetBalance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetBalance Res.
     * @member {number} Res
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.Res = 0;

    /**
     * Client2ProxyAckGetBalance UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetBalance DepositGold.
     * @member {string} DepositGold
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.DepositGold = "";

    /**
     * Client2ProxyAckGetBalance CanWithDrawGold.
     * @member {string} CanWithDrawGold
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.CanWithDrawGold = "";

    /**
     * Client2ProxyAckGetBalance ToalGold.
     * @member {string} ToalGold
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.ToalGold = "";

    /**
     * Client2ProxyAckGetBalance BonusGold.
     * @member {string} BonusGold
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.BonusGold = "";

    /**
     * Client2ProxyAckGetBalance DiamondGold.
     * @member {string} DiamondGold
     * @memberof Client2ProxyAckGetBalance
     * @instance
     */
    Client2ProxyAckGetBalance.prototype.DiamondGold = "";

    /**
     * Creates a new Client2ProxyAckGetBalance instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {IClient2ProxyAckGetBalance=} [properties] Properties to set
     * @returns {Client2ProxyAckGetBalance} Client2ProxyAckGetBalance instance
     */
    Client2ProxyAckGetBalance.create = function create(properties) {
        return new Client2ProxyAckGetBalance(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetBalance message. Does not implicitly {@link Client2ProxyAckGetBalance.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {IClient2ProxyAckGetBalance} message Client2ProxyAckGetBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetBalance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.DepositGold != null && Object.hasOwnProperty.call(message, "DepositGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.DepositGold);
        if (message.CanWithDrawGold != null && Object.hasOwnProperty.call(message, "CanWithDrawGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.CanWithDrawGold);
        if (message.ToalGold != null && Object.hasOwnProperty.call(message, "ToalGold"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ToalGold);
        if (message.BonusGold != null && Object.hasOwnProperty.call(message, "BonusGold"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.BonusGold);
        if (message.DiamondGold != null && Object.hasOwnProperty.call(message, "DiamondGold"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.DiamondGold);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetBalance message, length delimited. Does not implicitly {@link Client2ProxyAckGetBalance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {IClient2ProxyAckGetBalance} message Client2ProxyAckGetBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetBalance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetBalance message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetBalance} Client2ProxyAckGetBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetBalance.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetBalance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DepositGold = reader.string();
                    break;
                }
            case 4: {
                    message.CanWithDrawGold = reader.string();
                    break;
                }
            case 5: {
                    message.ToalGold = reader.string();
                    break;
                }
            case 6: {
                    message.BonusGold = reader.string();
                    break;
                }
            case 7: {
                    message.DiamondGold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetBalance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetBalance} Client2ProxyAckGetBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetBalance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetBalance message.
     * @function verify
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetBalance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DepositGold != null && message.hasOwnProperty("DepositGold"))
            if (!$util.isString(message.DepositGold))
                return "DepositGold: string expected";
        if (message.CanWithDrawGold != null && message.hasOwnProperty("CanWithDrawGold"))
            if (!$util.isString(message.CanWithDrawGold))
                return "CanWithDrawGold: string expected";
        if (message.ToalGold != null && message.hasOwnProperty("ToalGold"))
            if (!$util.isString(message.ToalGold))
                return "ToalGold: string expected";
        if (message.BonusGold != null && message.hasOwnProperty("BonusGold"))
            if (!$util.isString(message.BonusGold))
                return "BonusGold: string expected";
        if (message.DiamondGold != null && message.hasOwnProperty("DiamondGold"))
            if (!$util.isString(message.DiamondGold))
                return "DiamondGold: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetBalance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetBalance} Client2ProxyAckGetBalance
     */
    Client2ProxyAckGetBalance.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetBalance)
            return object;
        let message = new $root.Client2ProxyAckGetBalance();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DepositGold != null)
            message.DepositGold = String(object.DepositGold);
        if (object.CanWithDrawGold != null)
            message.CanWithDrawGold = String(object.CanWithDrawGold);
        if (object.ToalGold != null)
            message.ToalGold = String(object.ToalGold);
        if (object.BonusGold != null)
            message.BonusGold = String(object.BonusGold);
        if (object.DiamondGold != null)
            message.DiamondGold = String(object.DiamondGold);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetBalance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {Client2ProxyAckGetBalance} message Client2ProxyAckGetBalance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetBalance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.DepositGold = "";
            object.CanWithDrawGold = "";
            object.ToalGold = "";
            object.BonusGold = "";
            object.DiamondGold = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DepositGold != null && message.hasOwnProperty("DepositGold"))
            object.DepositGold = message.DepositGold;
        if (message.CanWithDrawGold != null && message.hasOwnProperty("CanWithDrawGold"))
            object.CanWithDrawGold = message.CanWithDrawGold;
        if (message.ToalGold != null && message.hasOwnProperty("ToalGold"))
            object.ToalGold = message.ToalGold;
        if (message.BonusGold != null && message.hasOwnProperty("BonusGold"))
            object.BonusGold = message.BonusGold;
        if (message.DiamondGold != null && message.hasOwnProperty("DiamondGold"))
            object.DiamondGold = message.DiamondGold;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetBalance to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetBalance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetBalance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetBalance
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetBalance
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetBalance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetBalance";
    };

    return Client2ProxyAckGetBalance;
})();

export const Client2ProxyReqWithDrawRecord = $root.Client2ProxyReqWithDrawRecord = (() => {

    /**
     * Properties of a Client2ProxyReqWithDrawRecord.
     * @exports IClient2ProxyReqWithDrawRecord
     * @interface IClient2ProxyReqWithDrawRecord
     * @property {number|null} [UserID] Client2ProxyReqWithDrawRecord UserID
     */

    /**
     * Constructs a new Client2ProxyReqWithDrawRecord.
     * @exports Client2ProxyReqWithDrawRecord
     * @classdesc Represents a Client2ProxyReqWithDrawRecord.
     * @implements IClient2ProxyReqWithDrawRecord
     * @constructor
     * @param {IClient2ProxyReqWithDrawRecord=} [properties] Properties to set
     */
    function Client2ProxyReqWithDrawRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqWithDrawRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqWithDrawRecord
     * @instance
     */
    Client2ProxyReqWithDrawRecord.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqWithDrawRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {IClient2ProxyReqWithDrawRecord=} [properties] Properties to set
     * @returns {Client2ProxyReqWithDrawRecord} Client2ProxyReqWithDrawRecord instance
     */
    Client2ProxyReqWithDrawRecord.create = function create(properties) {
        return new Client2ProxyReqWithDrawRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqWithDrawRecord message. Does not implicitly {@link Client2ProxyReqWithDrawRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {IClient2ProxyReqWithDrawRecord} message Client2ProxyReqWithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqWithDrawRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqWithDrawRecord message, length delimited. Does not implicitly {@link Client2ProxyReqWithDrawRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {IClient2ProxyReqWithDrawRecord} message Client2ProxyReqWithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqWithDrawRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqWithDrawRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqWithDrawRecord} Client2ProxyReqWithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqWithDrawRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqWithDrawRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqWithDrawRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqWithDrawRecord} Client2ProxyReqWithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqWithDrawRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqWithDrawRecord message.
     * @function verify
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqWithDrawRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqWithDrawRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqWithDrawRecord} Client2ProxyReqWithDrawRecord
     */
    Client2ProxyReqWithDrawRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqWithDrawRecord)
            return object;
        let message = new $root.Client2ProxyReqWithDrawRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqWithDrawRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {Client2ProxyReqWithDrawRecord} message Client2ProxyReqWithDrawRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqWithDrawRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqWithDrawRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqWithDrawRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqWithDrawRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqWithDrawRecord
     * @function getTypeUrl
     * @memberof Client2ProxyReqWithDrawRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqWithDrawRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqWithDrawRecord";
    };

    return Client2ProxyReqWithDrawRecord;
})();

export const Client2ProxyAckWithDrawRecord = $root.Client2ProxyAckWithDrawRecord = (() => {

    /**
     * Properties of a Client2ProxyAckWithDrawRecord.
     * @exports IClient2ProxyAckWithDrawRecord
     * @interface IClient2ProxyAckWithDrawRecord
     * @property {number|null} [Res] Client2ProxyAckWithDrawRecord Res
     * @property {number|null} [UserID] Client2ProxyAckWithDrawRecord UserID
     * @property {Array.<IWithDrawRecord>|null} [RecordList] Client2ProxyAckWithDrawRecord RecordList
     */

    /**
     * Constructs a new Client2ProxyAckWithDrawRecord.
     * @exports Client2ProxyAckWithDrawRecord
     * @classdesc Represents a Client2ProxyAckWithDrawRecord.
     * @implements IClient2ProxyAckWithDrawRecord
     * @constructor
     * @param {IClient2ProxyAckWithDrawRecord=} [properties] Properties to set
     */
    function Client2ProxyAckWithDrawRecord(properties) {
        this.RecordList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckWithDrawRecord Res.
     * @member {number} Res
     * @memberof Client2ProxyAckWithDrawRecord
     * @instance
     */
    Client2ProxyAckWithDrawRecord.prototype.Res = 0;

    /**
     * Client2ProxyAckWithDrawRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckWithDrawRecord
     * @instance
     */
    Client2ProxyAckWithDrawRecord.prototype.UserID = 0;

    /**
     * Client2ProxyAckWithDrawRecord RecordList.
     * @member {Array.<IWithDrawRecord>} RecordList
     * @memberof Client2ProxyAckWithDrawRecord
     * @instance
     */
    Client2ProxyAckWithDrawRecord.prototype.RecordList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckWithDrawRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {IClient2ProxyAckWithDrawRecord=} [properties] Properties to set
     * @returns {Client2ProxyAckWithDrawRecord} Client2ProxyAckWithDrawRecord instance
     */
    Client2ProxyAckWithDrawRecord.create = function create(properties) {
        return new Client2ProxyAckWithDrawRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckWithDrawRecord message. Does not implicitly {@link Client2ProxyAckWithDrawRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {IClient2ProxyAckWithDrawRecord} message Client2ProxyAckWithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckWithDrawRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.RecordList != null && message.RecordList.length)
            for (let i = 0; i < message.RecordList.length; ++i)
                $root.WithDrawRecord.encode(message.RecordList[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckWithDrawRecord message, length delimited. Does not implicitly {@link Client2ProxyAckWithDrawRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {IClient2ProxyAckWithDrawRecord} message Client2ProxyAckWithDrawRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckWithDrawRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckWithDrawRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckWithDrawRecord} Client2ProxyAckWithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckWithDrawRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckWithDrawRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.RecordList && message.RecordList.length))
                        message.RecordList = [];
                    message.RecordList.push($root.WithDrawRecord.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckWithDrawRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckWithDrawRecord} Client2ProxyAckWithDrawRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckWithDrawRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckWithDrawRecord message.
     * @function verify
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckWithDrawRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RecordList != null && message.hasOwnProperty("RecordList")) {
            if (!Array.isArray(message.RecordList))
                return "RecordList: array expected";
            for (let i = 0; i < message.RecordList.length; ++i) {
                let error = $root.WithDrawRecord.verify(message.RecordList[i]);
                if (error)
                    return "RecordList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckWithDrawRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckWithDrawRecord} Client2ProxyAckWithDrawRecord
     */
    Client2ProxyAckWithDrawRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckWithDrawRecord)
            return object;
        let message = new $root.Client2ProxyAckWithDrawRecord();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RecordList) {
            if (!Array.isArray(object.RecordList))
                throw TypeError(".Client2ProxyAckWithDrawRecord.RecordList: array expected");
            message.RecordList = [];
            for (let i = 0; i < object.RecordList.length; ++i) {
                if (typeof object.RecordList[i] !== "object")
                    throw TypeError(".Client2ProxyAckWithDrawRecord.RecordList: object expected");
                message.RecordList[i] = $root.WithDrawRecord.fromObject(object.RecordList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckWithDrawRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {Client2ProxyAckWithDrawRecord} message Client2ProxyAckWithDrawRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckWithDrawRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RecordList = [];
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RecordList && message.RecordList.length) {
            object.RecordList = [];
            for (let j = 0; j < message.RecordList.length; ++j)
                object.RecordList[j] = $root.WithDrawRecord.toObject(message.RecordList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckWithDrawRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckWithDrawRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckWithDrawRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckWithDrawRecord
     * @function getTypeUrl
     * @memberof Client2ProxyAckWithDrawRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckWithDrawRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckWithDrawRecord";
    };

    return Client2ProxyAckWithDrawRecord;
})();

export const Client2ProxyKickOutUser = $root.Client2ProxyKickOutUser = (() => {

    /**
     * Properties of a Client2ProxyKickOutUser.
     * @exports IClient2ProxyKickOutUser
     * @interface IClient2ProxyKickOutUser
     * @property {number|null} [Reason] Client2ProxyKickOutUser Reason
     * @property {number|null} [UserID] Client2ProxyKickOutUser UserID
     */

    /**
     * Constructs a new Client2ProxyKickOutUser.
     * @exports Client2ProxyKickOutUser
     * @classdesc Represents a Client2ProxyKickOutUser.
     * @implements IClient2ProxyKickOutUser
     * @constructor
     * @param {IClient2ProxyKickOutUser=} [properties] Properties to set
     */
    function Client2ProxyKickOutUser(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyKickOutUser Reason.
     * @member {number} Reason
     * @memberof Client2ProxyKickOutUser
     * @instance
     */
    Client2ProxyKickOutUser.prototype.Reason = 0;

    /**
     * Client2ProxyKickOutUser UserID.
     * @member {number} UserID
     * @memberof Client2ProxyKickOutUser
     * @instance
     */
    Client2ProxyKickOutUser.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyKickOutUser instance using the specified properties.
     * @function create
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {IClient2ProxyKickOutUser=} [properties] Properties to set
     * @returns {Client2ProxyKickOutUser} Client2ProxyKickOutUser instance
     */
    Client2ProxyKickOutUser.create = function create(properties) {
        return new Client2ProxyKickOutUser(properties);
    };

    /**
     * Encodes the specified Client2ProxyKickOutUser message. Does not implicitly {@link Client2ProxyKickOutUser.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {IClient2ProxyKickOutUser} message Client2ProxyKickOutUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyKickOutUser.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyKickOutUser message, length delimited. Does not implicitly {@link Client2ProxyKickOutUser.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {IClient2ProxyKickOutUser} message Client2ProxyKickOutUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyKickOutUser.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyKickOutUser message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyKickOutUser} Client2ProxyKickOutUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyKickOutUser.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyKickOutUser();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyKickOutUser message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyKickOutUser} Client2ProxyKickOutUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyKickOutUser.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyKickOutUser message.
     * @function verify
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyKickOutUser.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyKickOutUser message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyKickOutUser} Client2ProxyKickOutUser
     */
    Client2ProxyKickOutUser.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyKickOutUser)
            return object;
        let message = new $root.Client2ProxyKickOutUser();
        if (object.Reason != null)
            message.Reason = object.Reason >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyKickOutUser message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {Client2ProxyKickOutUser} message Client2ProxyKickOutUser
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyKickOutUser.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyKickOutUser to JSON.
     * @function toJSON
     * @memberof Client2ProxyKickOutUser
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyKickOutUser.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyKickOutUser
     * @function getTypeUrl
     * @memberof Client2ProxyKickOutUser
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyKickOutUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyKickOutUser";
    };

    return Client2ProxyKickOutUser;
})();

export const Client2ProxyUserBreak = $root.Client2ProxyUserBreak = (() => {

    /**
     * Properties of a Client2ProxyUserBreak.
     * @exports IClient2ProxyUserBreak
     * @interface IClient2ProxyUserBreak
     * @property {number|null} [UserID] Client2ProxyUserBreak UserID
     */

    /**
     * Constructs a new Client2ProxyUserBreak.
     * @exports Client2ProxyUserBreak
     * @classdesc Represents a Client2ProxyUserBreak.
     * @implements IClient2ProxyUserBreak
     * @constructor
     * @param {IClient2ProxyUserBreak=} [properties] Properties to set
     */
    function Client2ProxyUserBreak(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyUserBreak UserID.
     * @member {number} UserID
     * @memberof Client2ProxyUserBreak
     * @instance
     */
    Client2ProxyUserBreak.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyUserBreak instance using the specified properties.
     * @function create
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {IClient2ProxyUserBreak=} [properties] Properties to set
     * @returns {Client2ProxyUserBreak} Client2ProxyUserBreak instance
     */
    Client2ProxyUserBreak.create = function create(properties) {
        return new Client2ProxyUserBreak(properties);
    };

    /**
     * Encodes the specified Client2ProxyUserBreak message. Does not implicitly {@link Client2ProxyUserBreak.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {IClient2ProxyUserBreak} message Client2ProxyUserBreak message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyUserBreak.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyUserBreak message, length delimited. Does not implicitly {@link Client2ProxyUserBreak.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {IClient2ProxyUserBreak} message Client2ProxyUserBreak message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyUserBreak.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyUserBreak message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyUserBreak} Client2ProxyUserBreak
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyUserBreak.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyUserBreak();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyUserBreak message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyUserBreak} Client2ProxyUserBreak
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyUserBreak.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyUserBreak message.
     * @function verify
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyUserBreak.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyUserBreak message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyUserBreak} Client2ProxyUserBreak
     */
    Client2ProxyUserBreak.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyUserBreak)
            return object;
        let message = new $root.Client2ProxyUserBreak();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyUserBreak message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {Client2ProxyUserBreak} message Client2ProxyUserBreak
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyUserBreak.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyUserBreak to JSON.
     * @function toJSON
     * @memberof Client2ProxyUserBreak
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyUserBreak.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyUserBreak
     * @function getTypeUrl
     * @memberof Client2ProxyUserBreak
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyUserBreak.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyUserBreak";
    };

    return Client2ProxyUserBreak;
})();

export const Client2ProxyUserResume = $root.Client2ProxyUserResume = (() => {

    /**
     * Properties of a Client2ProxyUserResume.
     * @exports IClient2ProxyUserResume
     * @interface IClient2ProxyUserResume
     * @property {number|null} [UserID] Client2ProxyUserResume UserID
     */

    /**
     * Constructs a new Client2ProxyUserResume.
     * @exports Client2ProxyUserResume
     * @classdesc Represents a Client2ProxyUserResume.
     * @implements IClient2ProxyUserResume
     * @constructor
     * @param {IClient2ProxyUserResume=} [properties] Properties to set
     */
    function Client2ProxyUserResume(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyUserResume UserID.
     * @member {number} UserID
     * @memberof Client2ProxyUserResume
     * @instance
     */
    Client2ProxyUserResume.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyUserResume instance using the specified properties.
     * @function create
     * @memberof Client2ProxyUserResume
     * @static
     * @param {IClient2ProxyUserResume=} [properties] Properties to set
     * @returns {Client2ProxyUserResume} Client2ProxyUserResume instance
     */
    Client2ProxyUserResume.create = function create(properties) {
        return new Client2ProxyUserResume(properties);
    };

    /**
     * Encodes the specified Client2ProxyUserResume message. Does not implicitly {@link Client2ProxyUserResume.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyUserResume
     * @static
     * @param {IClient2ProxyUserResume} message Client2ProxyUserResume message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyUserResume.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyUserResume message, length delimited. Does not implicitly {@link Client2ProxyUserResume.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyUserResume
     * @static
     * @param {IClient2ProxyUserResume} message Client2ProxyUserResume message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyUserResume.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyUserResume message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyUserResume
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyUserResume} Client2ProxyUserResume
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyUserResume.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyUserResume();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyUserResume message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyUserResume
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyUserResume} Client2ProxyUserResume
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyUserResume.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyUserResume message.
     * @function verify
     * @memberof Client2ProxyUserResume
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyUserResume.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyUserResume message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyUserResume
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyUserResume} Client2ProxyUserResume
     */
    Client2ProxyUserResume.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyUserResume)
            return object;
        let message = new $root.Client2ProxyUserResume();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyUserResume message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyUserResume
     * @static
     * @param {Client2ProxyUserResume} message Client2ProxyUserResume
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyUserResume.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyUserResume to JSON.
     * @function toJSON
     * @memberof Client2ProxyUserResume
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyUserResume.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyUserResume
     * @function getTypeUrl
     * @memberof Client2ProxyUserResume
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyUserResume.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyUserResume";
    };

    return Client2ProxyUserResume;
})();

export const Client2ProxyAckTeenPattiProduct = $root.Client2ProxyAckTeenPattiProduct = (() => {

    /**
     * Properties of a Client2ProxyAckTeenPattiProduct.
     * @exports IClient2ProxyAckTeenPattiProduct
     * @interface IClient2ProxyAckTeenPattiProduct
     * @property {number|null} [Ret] Client2ProxyAckTeenPattiProduct Ret
     * @property {number|null} [UserID] Client2ProxyAckTeenPattiProduct UserID
     * @property {number|null} [GameID] Client2ProxyAckTeenPattiProduct GameID
     * @property {Array.<ITeenPattiProudct>|null} [ProductList] Client2ProxyAckTeenPattiProduct ProductList
     */

    /**
     * Constructs a new Client2ProxyAckTeenPattiProduct.
     * @exports Client2ProxyAckTeenPattiProduct
     * @classdesc Represents a Client2ProxyAckTeenPattiProduct.
     * @implements IClient2ProxyAckTeenPattiProduct
     * @constructor
     * @param {IClient2ProxyAckTeenPattiProduct=} [properties] Properties to set
     */
    function Client2ProxyAckTeenPattiProduct(properties) {
        this.ProductList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckTeenPattiProduct Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckTeenPattiProduct
     * @instance
     */
    Client2ProxyAckTeenPattiProduct.prototype.Ret = 0;

    /**
     * Client2ProxyAckTeenPattiProduct UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckTeenPattiProduct
     * @instance
     */
    Client2ProxyAckTeenPattiProduct.prototype.UserID = 0;

    /**
     * Client2ProxyAckTeenPattiProduct GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckTeenPattiProduct
     * @instance
     */
    Client2ProxyAckTeenPattiProduct.prototype.GameID = 0;

    /**
     * Client2ProxyAckTeenPattiProduct ProductList.
     * @member {Array.<ITeenPattiProudct>} ProductList
     * @memberof Client2ProxyAckTeenPattiProduct
     * @instance
     */
    Client2ProxyAckTeenPattiProduct.prototype.ProductList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckTeenPattiProduct instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {IClient2ProxyAckTeenPattiProduct=} [properties] Properties to set
     * @returns {Client2ProxyAckTeenPattiProduct} Client2ProxyAckTeenPattiProduct instance
     */
    Client2ProxyAckTeenPattiProduct.create = function create(properties) {
        return new Client2ProxyAckTeenPattiProduct(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckTeenPattiProduct message. Does not implicitly {@link Client2ProxyAckTeenPattiProduct.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {IClient2ProxyAckTeenPattiProduct} message Client2ProxyAckTeenPattiProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTeenPattiProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductList != null && message.ProductList.length)
            for (let i = 0; i < message.ProductList.length; ++i)
                $root.TeenPattiProudct.encode(message.ProductList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckTeenPattiProduct message, length delimited. Does not implicitly {@link Client2ProxyAckTeenPattiProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {IClient2ProxyAckTeenPattiProduct} message Client2ProxyAckTeenPattiProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTeenPattiProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckTeenPattiProduct message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckTeenPattiProduct} Client2ProxyAckTeenPattiProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTeenPattiProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckTeenPattiProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.ProductList && message.ProductList.length))
                        message.ProductList = [];
                    message.ProductList.push($root.TeenPattiProudct.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckTeenPattiProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckTeenPattiProduct} Client2ProxyAckTeenPattiProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTeenPattiProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckTeenPattiProduct message.
     * @function verify
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckTeenPattiProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductList != null && message.hasOwnProperty("ProductList")) {
            if (!Array.isArray(message.ProductList))
                return "ProductList: array expected";
            for (let i = 0; i < message.ProductList.length; ++i) {
                let error = $root.TeenPattiProudct.verify(message.ProductList[i]);
                if (error)
                    return "ProductList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckTeenPattiProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckTeenPattiProduct} Client2ProxyAckTeenPattiProduct
     */
    Client2ProxyAckTeenPattiProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckTeenPattiProduct)
            return object;
        let message = new $root.Client2ProxyAckTeenPattiProduct();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductList) {
            if (!Array.isArray(object.ProductList))
                throw TypeError(".Client2ProxyAckTeenPattiProduct.ProductList: array expected");
            message.ProductList = [];
            for (let i = 0; i < object.ProductList.length; ++i) {
                if (typeof object.ProductList[i] !== "object")
                    throw TypeError(".Client2ProxyAckTeenPattiProduct.ProductList: object expected");
                message.ProductList[i] = $root.TeenPattiProudct.fromObject(object.ProductList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckTeenPattiProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {Client2ProxyAckTeenPattiProduct} message Client2ProxyAckTeenPattiProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckTeenPattiProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ProductList = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductList && message.ProductList.length) {
            object.ProductList = [];
            for (let j = 0; j < message.ProductList.length; ++j)
                object.ProductList[j] = $root.TeenPattiProudct.toObject(message.ProductList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckTeenPattiProduct to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckTeenPattiProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckTeenPattiProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckTeenPattiProduct
     * @function getTypeUrl
     * @memberof Client2ProxyAckTeenPattiProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckTeenPattiProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckTeenPattiProduct";
    };

    return Client2ProxyAckTeenPattiProduct;
})();

export const Client2ProxyPushSysMsg = $root.Client2ProxyPushSysMsg = (() => {

    /**
     * Properties of a Client2ProxyPushSysMsg.
     * @exports IClient2ProxyPushSysMsg
     * @interface IClient2ProxyPushSysMsg
     * @property {number|null} [UserID] Client2ProxyPushSysMsg UserID
     * @property {Uint8Array|null} [Msg] Client2ProxyPushSysMsg Msg
     */

    /**
     * Constructs a new Client2ProxyPushSysMsg.
     * @exports Client2ProxyPushSysMsg
     * @classdesc Represents a Client2ProxyPushSysMsg.
     * @implements IClient2ProxyPushSysMsg
     * @constructor
     * @param {IClient2ProxyPushSysMsg=} [properties] Properties to set
     */
    function Client2ProxyPushSysMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushSysMsg UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushSysMsg
     * @instance
     */
    Client2ProxyPushSysMsg.prototype.UserID = 0;

    /**
     * Client2ProxyPushSysMsg Msg.
     * @member {Uint8Array} Msg
     * @memberof Client2ProxyPushSysMsg
     * @instance
     */
    Client2ProxyPushSysMsg.prototype.Msg = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyPushSysMsg instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {IClient2ProxyPushSysMsg=} [properties] Properties to set
     * @returns {Client2ProxyPushSysMsg} Client2ProxyPushSysMsg instance
     */
    Client2ProxyPushSysMsg.create = function create(properties) {
        return new Client2ProxyPushSysMsg(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushSysMsg message. Does not implicitly {@link Client2ProxyPushSysMsg.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {IClient2ProxyPushSysMsg} message Client2ProxyPushSysMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSysMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Msg != null && Object.hasOwnProperty.call(message, "Msg"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Msg);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushSysMsg message, length delimited. Does not implicitly {@link Client2ProxyPushSysMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {IClient2ProxyPushSysMsg} message Client2ProxyPushSysMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSysMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushSysMsg message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushSysMsg} Client2ProxyPushSysMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSysMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushSysMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Msg = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushSysMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushSysMsg} Client2ProxyPushSysMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSysMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushSysMsg message.
     * @function verify
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushSysMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Msg != null && message.hasOwnProperty("Msg"))
            if (!(message.Msg && typeof message.Msg.length === "number" || $util.isString(message.Msg)))
                return "Msg: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushSysMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushSysMsg} Client2ProxyPushSysMsg
     */
    Client2ProxyPushSysMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushSysMsg)
            return object;
        let message = new $root.Client2ProxyPushSysMsg();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Msg != null)
            if (typeof object.Msg === "string")
                $util.base64.decode(object.Msg, message.Msg = $util.newBuffer($util.base64.length(object.Msg)), 0);
            else if (object.Msg.length >= 0)
                message.Msg = object.Msg;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushSysMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {Client2ProxyPushSysMsg} message Client2ProxyPushSysMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushSysMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Msg = "";
            else {
                object.Msg = [];
                if (options.bytes !== Array)
                    object.Msg = $util.newBuffer(object.Msg);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Msg != null && message.hasOwnProperty("Msg"))
            object.Msg = options.bytes === String ? $util.base64.encode(message.Msg, 0, message.Msg.length) : options.bytes === Array ? Array.prototype.slice.call(message.Msg) : message.Msg;
        return object;
    };

    /**
     * Converts this Client2ProxyPushSysMsg to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushSysMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushSysMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushSysMsg
     * @function getTypeUrl
     * @memberof Client2ProxyPushSysMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushSysMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushSysMsg";
    };

    return Client2ProxyPushSysMsg;
})();

export const Client2ProxyReqCheckMobileUsed = $root.Client2ProxyReqCheckMobileUsed = (() => {

    /**
     * Properties of a Client2ProxyReqCheckMobileUsed.
     * @exports IClient2ProxyReqCheckMobileUsed
     * @interface IClient2ProxyReqCheckMobileUsed
     * @property {string|null} [Mobile] Client2ProxyReqCheckMobileUsed Mobile
     * @property {string|null} [Password] Client2ProxyReqCheckMobileUsed Password
     */

    /**
     * Constructs a new Client2ProxyReqCheckMobileUsed.
     * @exports Client2ProxyReqCheckMobileUsed
     * @classdesc Represents a Client2ProxyReqCheckMobileUsed.
     * @implements IClient2ProxyReqCheckMobileUsed
     * @constructor
     * @param {IClient2ProxyReqCheckMobileUsed=} [properties] Properties to set
     */
    function Client2ProxyReqCheckMobileUsed(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqCheckMobileUsed Mobile.
     * @member {string} Mobile
     * @memberof Client2ProxyReqCheckMobileUsed
     * @instance
     */
    Client2ProxyReqCheckMobileUsed.prototype.Mobile = "";

    /**
     * Client2ProxyReqCheckMobileUsed Password.
     * @member {string} Password
     * @memberof Client2ProxyReqCheckMobileUsed
     * @instance
     */
    Client2ProxyReqCheckMobileUsed.prototype.Password = "";

    /**
     * Creates a new Client2ProxyReqCheckMobileUsed instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {IClient2ProxyReqCheckMobileUsed=} [properties] Properties to set
     * @returns {Client2ProxyReqCheckMobileUsed} Client2ProxyReqCheckMobileUsed instance
     */
    Client2ProxyReqCheckMobileUsed.create = function create(properties) {
        return new Client2ProxyReqCheckMobileUsed(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqCheckMobileUsed message. Does not implicitly {@link Client2ProxyReqCheckMobileUsed.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {IClient2ProxyReqCheckMobileUsed} message Client2ProxyReqCheckMobileUsed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckMobileUsed.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Mobile != null && Object.hasOwnProperty.call(message, "Mobile"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Mobile);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Password);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqCheckMobileUsed message, length delimited. Does not implicitly {@link Client2ProxyReqCheckMobileUsed.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {IClient2ProxyReqCheckMobileUsed} message Client2ProxyReqCheckMobileUsed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckMobileUsed.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqCheckMobileUsed message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqCheckMobileUsed} Client2ProxyReqCheckMobileUsed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckMobileUsed.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqCheckMobileUsed();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Mobile = reader.string();
                    break;
                }
            case 2: {
                    message.Password = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqCheckMobileUsed message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqCheckMobileUsed} Client2ProxyReqCheckMobileUsed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckMobileUsed.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqCheckMobileUsed message.
     * @function verify
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqCheckMobileUsed.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            if (!$util.isString(message.Mobile))
                return "Mobile: string expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqCheckMobileUsed message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqCheckMobileUsed} Client2ProxyReqCheckMobileUsed
     */
    Client2ProxyReqCheckMobileUsed.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqCheckMobileUsed)
            return object;
        let message = new $root.Client2ProxyReqCheckMobileUsed();
        if (object.Mobile != null)
            message.Mobile = String(object.Mobile);
        if (object.Password != null)
            message.Password = String(object.Password);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqCheckMobileUsed message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {Client2ProxyReqCheckMobileUsed} message Client2ProxyReqCheckMobileUsed
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqCheckMobileUsed.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Mobile = "";
            object.Password = "";
        }
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            object.Mobile = message.Mobile;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        return object;
    };

    /**
     * Converts this Client2ProxyReqCheckMobileUsed to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqCheckMobileUsed
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqCheckMobileUsed.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqCheckMobileUsed
     * @function getTypeUrl
     * @memberof Client2ProxyReqCheckMobileUsed
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqCheckMobileUsed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqCheckMobileUsed";
    };

    return Client2ProxyReqCheckMobileUsed;
})();

export const Client2ProxyAckCheckMobileUsed = $root.Client2ProxyAckCheckMobileUsed = (() => {

    /**
     * Properties of a Client2ProxyAckCheckMobileUsed.
     * @exports IClient2ProxyAckCheckMobileUsed
     * @interface IClient2ProxyAckCheckMobileUsed
     * @property {number|null} [Ret] Client2ProxyAckCheckMobileUsed Ret
     * @property {string|null} [Mobile] Client2ProxyAckCheckMobileUsed Mobile
     * @property {string|null} [Password] Client2ProxyAckCheckMobileUsed Password
     */

    /**
     * Constructs a new Client2ProxyAckCheckMobileUsed.
     * @exports Client2ProxyAckCheckMobileUsed
     * @classdesc Represents a Client2ProxyAckCheckMobileUsed.
     * @implements IClient2ProxyAckCheckMobileUsed
     * @constructor
     * @param {IClient2ProxyAckCheckMobileUsed=} [properties] Properties to set
     */
    function Client2ProxyAckCheckMobileUsed(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckCheckMobileUsed Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckCheckMobileUsed
     * @instance
     */
    Client2ProxyAckCheckMobileUsed.prototype.Ret = 0;

    /**
     * Client2ProxyAckCheckMobileUsed Mobile.
     * @member {string} Mobile
     * @memberof Client2ProxyAckCheckMobileUsed
     * @instance
     */
    Client2ProxyAckCheckMobileUsed.prototype.Mobile = "";

    /**
     * Client2ProxyAckCheckMobileUsed Password.
     * @member {string} Password
     * @memberof Client2ProxyAckCheckMobileUsed
     * @instance
     */
    Client2ProxyAckCheckMobileUsed.prototype.Password = "";

    /**
     * Creates a new Client2ProxyAckCheckMobileUsed instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {IClient2ProxyAckCheckMobileUsed=} [properties] Properties to set
     * @returns {Client2ProxyAckCheckMobileUsed} Client2ProxyAckCheckMobileUsed instance
     */
    Client2ProxyAckCheckMobileUsed.create = function create(properties) {
        return new Client2ProxyAckCheckMobileUsed(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckCheckMobileUsed message. Does not implicitly {@link Client2ProxyAckCheckMobileUsed.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {IClient2ProxyAckCheckMobileUsed} message Client2ProxyAckCheckMobileUsed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckMobileUsed.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.Mobile != null && Object.hasOwnProperty.call(message, "Mobile"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Mobile);
        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Password);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckCheckMobileUsed message, length delimited. Does not implicitly {@link Client2ProxyAckCheckMobileUsed.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {IClient2ProxyAckCheckMobileUsed} message Client2ProxyAckCheckMobileUsed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckMobileUsed.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckCheckMobileUsed message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckCheckMobileUsed} Client2ProxyAckCheckMobileUsed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckMobileUsed.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckCheckMobileUsed();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.Mobile = reader.string();
                    break;
                }
            case 3: {
                    message.Password = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckCheckMobileUsed message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckCheckMobileUsed} Client2ProxyAckCheckMobileUsed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckMobileUsed.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckCheckMobileUsed message.
     * @function verify
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckCheckMobileUsed.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            if (!$util.isString(message.Mobile))
                return "Mobile: string expected";
        if (message.Password != null && message.hasOwnProperty("Password"))
            if (!$util.isString(message.Password))
                return "Password: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckCheckMobileUsed message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckCheckMobileUsed} Client2ProxyAckCheckMobileUsed
     */
    Client2ProxyAckCheckMobileUsed.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckCheckMobileUsed)
            return object;
        let message = new $root.Client2ProxyAckCheckMobileUsed();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.Mobile != null)
            message.Mobile = String(object.Mobile);
        if (object.Password != null)
            message.Password = String(object.Password);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckCheckMobileUsed message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {Client2ProxyAckCheckMobileUsed} message Client2ProxyAckCheckMobileUsed
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckCheckMobileUsed.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.Mobile = "";
            object.Password = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.Mobile != null && message.hasOwnProperty("Mobile"))
            object.Mobile = message.Mobile;
        if (message.Password != null && message.hasOwnProperty("Password"))
            object.Password = message.Password;
        return object;
    };

    /**
     * Converts this Client2ProxyAckCheckMobileUsed to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckCheckMobileUsed
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckCheckMobileUsed.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckCheckMobileUsed
     * @function getTypeUrl
     * @memberof Client2ProxyAckCheckMobileUsed
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckCheckMobileUsed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckCheckMobileUsed";
    };

    return Client2ProxyAckCheckMobileUsed;
})();

export const Client2ProxyReqGetProductList = $root.Client2ProxyReqGetProductList = (() => {

    /**
     * Properties of a Client2ProxyReqGetProductList.
     * @exports IClient2ProxyReqGetProductList
     * @interface IClient2ProxyReqGetProductList
     * @property {number|null} [UserID] Client2ProxyReqGetProductList UserID
     * @property {number|null} [GameID] Client2ProxyReqGetProductList GameID
     * @property {string|null} [UserCash] Client2ProxyReqGetProductList UserCash
     */

    /**
     * Constructs a new Client2ProxyReqGetProductList.
     * @exports Client2ProxyReqGetProductList
     * @classdesc Represents a Client2ProxyReqGetProductList.
     * @implements IClient2ProxyReqGetProductList
     * @constructor
     * @param {IClient2ProxyReqGetProductList=} [properties] Properties to set
     */
    function Client2ProxyReqGetProductList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetProductList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetProductList
     * @instance
     */
    Client2ProxyReqGetProductList.prototype.UserID = 0;

    /**
     * Client2ProxyReqGetProductList GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqGetProductList
     * @instance
     */
    Client2ProxyReqGetProductList.prototype.GameID = 0;

    /**
     * Client2ProxyReqGetProductList UserCash.
     * @member {string} UserCash
     * @memberof Client2ProxyReqGetProductList
     * @instance
     */
    Client2ProxyReqGetProductList.prototype.UserCash = "";

    /**
     * Creates a new Client2ProxyReqGetProductList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {IClient2ProxyReqGetProductList=} [properties] Properties to set
     * @returns {Client2ProxyReqGetProductList} Client2ProxyReqGetProductList instance
     */
    Client2ProxyReqGetProductList.create = function create(properties) {
        return new Client2ProxyReqGetProductList(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetProductList message. Does not implicitly {@link Client2ProxyReqGetProductList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {IClient2ProxyReqGetProductList} message Client2ProxyReqGetProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetProductList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.UserCash != null && Object.hasOwnProperty.call(message, "UserCash"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.UserCash);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetProductList message, length delimited. Does not implicitly {@link Client2ProxyReqGetProductList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {IClient2ProxyReqGetProductList} message Client2ProxyReqGetProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetProductList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetProductList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetProductList} Client2ProxyReqGetProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetProductList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetProductList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserCash = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetProductList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetProductList} Client2ProxyReqGetProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetProductList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetProductList message.
     * @function verify
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetProductList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.UserCash != null && message.hasOwnProperty("UserCash"))
            if (!$util.isString(message.UserCash))
                return "UserCash: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetProductList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetProductList} Client2ProxyReqGetProductList
     */
    Client2ProxyReqGetProductList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetProductList)
            return object;
        let message = new $root.Client2ProxyReqGetProductList();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.UserCash != null)
            message.UserCash = String(object.UserCash);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetProductList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {Client2ProxyReqGetProductList} message Client2ProxyReqGetProductList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetProductList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.UserCash = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.UserCash != null && message.hasOwnProperty("UserCash"))
            object.UserCash = message.UserCash;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetProductList to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetProductList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetProductList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetProductList
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetProductList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetProductList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetProductList";
    };

    return Client2ProxyReqGetProductList;
})();

export const Client2ProxyReqAckProductList = $root.Client2ProxyReqAckProductList = (() => {

    /**
     * Properties of a Client2ProxyReqAckProductList.
     * @exports IClient2ProxyReqAckProductList
     * @interface IClient2ProxyReqAckProductList
     * @property {number|null} [Ret] Client2ProxyReqAckProductList Ret
     * @property {number|null} [UserID] Client2ProxyReqAckProductList UserID
     * @property {number|null} [GameID] Client2ProxyReqAckProductList GameID
     * @property {string|null} [ProductJson] Client2ProxyReqAckProductList ProductJson
     */

    /**
     * Constructs a new Client2ProxyReqAckProductList.
     * @exports Client2ProxyReqAckProductList
     * @classdesc Represents a Client2ProxyReqAckProductList.
     * @implements IClient2ProxyReqAckProductList
     * @constructor
     * @param {IClient2ProxyReqAckProductList=} [properties] Properties to set
     */
    function Client2ProxyReqAckProductList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAckProductList Ret.
     * @member {number} Ret
     * @memberof Client2ProxyReqAckProductList
     * @instance
     */
    Client2ProxyReqAckProductList.prototype.Ret = 0;

    /**
     * Client2ProxyReqAckProductList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqAckProductList
     * @instance
     */
    Client2ProxyReqAckProductList.prototype.UserID = 0;

    /**
     * Client2ProxyReqAckProductList GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqAckProductList
     * @instance
     */
    Client2ProxyReqAckProductList.prototype.GameID = 0;

    /**
     * Client2ProxyReqAckProductList ProductJson.
     * @member {string} ProductJson
     * @memberof Client2ProxyReqAckProductList
     * @instance
     */
    Client2ProxyReqAckProductList.prototype.ProductJson = "";

    /**
     * Creates a new Client2ProxyReqAckProductList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {IClient2ProxyReqAckProductList=} [properties] Properties to set
     * @returns {Client2ProxyReqAckProductList} Client2ProxyReqAckProductList instance
     */
    Client2ProxyReqAckProductList.create = function create(properties) {
        return new Client2ProxyReqAckProductList(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAckProductList message. Does not implicitly {@link Client2ProxyReqAckProductList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {IClient2ProxyReqAckProductList} message Client2ProxyReqAckProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAckProductList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.ProductJson != null && Object.hasOwnProperty.call(message, "ProductJson"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.ProductJson);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAckProductList message, length delimited. Does not implicitly {@link Client2ProxyReqAckProductList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {IClient2ProxyReqAckProductList} message Client2ProxyReqAckProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAckProductList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAckProductList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAckProductList} Client2ProxyReqAckProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAckProductList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAckProductList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.ProductJson = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAckProductList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAckProductList} Client2ProxyReqAckProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAckProductList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAckProductList message.
     * @function verify
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAckProductList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductJson != null && message.hasOwnProperty("ProductJson"))
            if (!$util.isString(message.ProductJson))
                return "ProductJson: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqAckProductList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAckProductList} Client2ProxyReqAckProductList
     */
    Client2ProxyReqAckProductList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAckProductList)
            return object;
        let message = new $root.Client2ProxyReqAckProductList();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductJson != null)
            message.ProductJson = String(object.ProductJson);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAckProductList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {Client2ProxyReqAckProductList} message Client2ProxyReqAckProductList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAckProductList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.GameID = 0;
            object.ProductJson = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductJson != null && message.hasOwnProperty("ProductJson"))
            object.ProductJson = message.ProductJson;
        return object;
    };

    /**
     * Converts this Client2ProxyReqAckProductList to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAckProductList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAckProductList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAckProductList
     * @function getTypeUrl
     * @memberof Client2ProxyReqAckProductList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAckProductList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAckProductList";
    };

    return Client2ProxyReqAckProductList;
})();

export const Client2ProxyReqModifyNickName = $root.Client2ProxyReqModifyNickName = (() => {

    /**
     * Properties of a Client2ProxyReqModifyNickName.
     * @exports IClient2ProxyReqModifyNickName
     * @interface IClient2ProxyReqModifyNickName
     * @property {number|null} [UserID] Client2ProxyReqModifyNickName UserID
     * @property {Uint8Array|null} [NewNickName] Client2ProxyReqModifyNickName NewNickName
     */

    /**
     * Constructs a new Client2ProxyReqModifyNickName.
     * @exports Client2ProxyReqModifyNickName
     * @classdesc Represents a Client2ProxyReqModifyNickName.
     * @implements IClient2ProxyReqModifyNickName
     * @constructor
     * @param {IClient2ProxyReqModifyNickName=} [properties] Properties to set
     */
    function Client2ProxyReqModifyNickName(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqModifyNickName UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqModifyNickName
     * @instance
     */
    Client2ProxyReqModifyNickName.prototype.UserID = 0;

    /**
     * Client2ProxyReqModifyNickName NewNickName.
     * @member {Uint8Array} NewNickName
     * @memberof Client2ProxyReqModifyNickName
     * @instance
     */
    Client2ProxyReqModifyNickName.prototype.NewNickName = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyReqModifyNickName instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {IClient2ProxyReqModifyNickName=} [properties] Properties to set
     * @returns {Client2ProxyReqModifyNickName} Client2ProxyReqModifyNickName instance
     */
    Client2ProxyReqModifyNickName.create = function create(properties) {
        return new Client2ProxyReqModifyNickName(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqModifyNickName message. Does not implicitly {@link Client2ProxyReqModifyNickName.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {IClient2ProxyReqModifyNickName} message Client2ProxyReqModifyNickName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqModifyNickName.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NewNickName != null && Object.hasOwnProperty.call(message, "NewNickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NewNickName);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqModifyNickName message, length delimited. Does not implicitly {@link Client2ProxyReqModifyNickName.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {IClient2ProxyReqModifyNickName} message Client2ProxyReqModifyNickName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqModifyNickName.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqModifyNickName message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqModifyNickName} Client2ProxyReqModifyNickName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqModifyNickName.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqModifyNickName();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NewNickName = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqModifyNickName message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqModifyNickName} Client2ProxyReqModifyNickName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqModifyNickName.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqModifyNickName message.
     * @function verify
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqModifyNickName.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewNickName != null && message.hasOwnProperty("NewNickName"))
            if (!(message.NewNickName && typeof message.NewNickName.length === "number" || $util.isString(message.NewNickName)))
                return "NewNickName: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqModifyNickName message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqModifyNickName} Client2ProxyReqModifyNickName
     */
    Client2ProxyReqModifyNickName.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqModifyNickName)
            return object;
        let message = new $root.Client2ProxyReqModifyNickName();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewNickName != null)
            if (typeof object.NewNickName === "string")
                $util.base64.decode(object.NewNickName, message.NewNickName = $util.newBuffer($util.base64.length(object.NewNickName)), 0);
            else if (object.NewNickName.length >= 0)
                message.NewNickName = object.NewNickName;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqModifyNickName message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {Client2ProxyReqModifyNickName} message Client2ProxyReqModifyNickName
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqModifyNickName.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NewNickName = "";
            else {
                object.NewNickName = [];
                if (options.bytes !== Array)
                    object.NewNickName = $util.newBuffer(object.NewNickName);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewNickName != null && message.hasOwnProperty("NewNickName"))
            object.NewNickName = options.bytes === String ? $util.base64.encode(message.NewNickName, 0, message.NewNickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NewNickName) : message.NewNickName;
        return object;
    };

    /**
     * Converts this Client2ProxyReqModifyNickName to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqModifyNickName
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqModifyNickName.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqModifyNickName
     * @function getTypeUrl
     * @memberof Client2ProxyReqModifyNickName
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqModifyNickName.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqModifyNickName";
    };

    return Client2ProxyReqModifyNickName;
})();

export const Client2ProxyAckModifyNickName = $root.Client2ProxyAckModifyNickName = (() => {

    /**
     * Properties of a Client2ProxyAckModifyNickName.
     * @exports IClient2ProxyAckModifyNickName
     * @interface IClient2ProxyAckModifyNickName
     * @property {number|null} [Ret] Client2ProxyAckModifyNickName Ret
     * @property {number|null} [UserID] Client2ProxyAckModifyNickName UserID
     * @property {Uint8Array|null} [NewNickName] Client2ProxyAckModifyNickName NewNickName
     */

    /**
     * Constructs a new Client2ProxyAckModifyNickName.
     * @exports Client2ProxyAckModifyNickName
     * @classdesc Represents a Client2ProxyAckModifyNickName.
     * @implements IClient2ProxyAckModifyNickName
     * @constructor
     * @param {IClient2ProxyAckModifyNickName=} [properties] Properties to set
     */
    function Client2ProxyAckModifyNickName(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckModifyNickName Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckModifyNickName
     * @instance
     */
    Client2ProxyAckModifyNickName.prototype.Ret = 0;

    /**
     * Client2ProxyAckModifyNickName UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckModifyNickName
     * @instance
     */
    Client2ProxyAckModifyNickName.prototype.UserID = 0;

    /**
     * Client2ProxyAckModifyNickName NewNickName.
     * @member {Uint8Array} NewNickName
     * @memberof Client2ProxyAckModifyNickName
     * @instance
     */
    Client2ProxyAckModifyNickName.prototype.NewNickName = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckModifyNickName instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {IClient2ProxyAckModifyNickName=} [properties] Properties to set
     * @returns {Client2ProxyAckModifyNickName} Client2ProxyAckModifyNickName instance
     */
    Client2ProxyAckModifyNickName.create = function create(properties) {
        return new Client2ProxyAckModifyNickName(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckModifyNickName message. Does not implicitly {@link Client2ProxyAckModifyNickName.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {IClient2ProxyAckModifyNickName} message Client2ProxyAckModifyNickName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckModifyNickName.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NewNickName != null && Object.hasOwnProperty.call(message, "NewNickName"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.NewNickName);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckModifyNickName message, length delimited. Does not implicitly {@link Client2ProxyAckModifyNickName.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {IClient2ProxyAckModifyNickName} message Client2ProxyAckModifyNickName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckModifyNickName.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckModifyNickName message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckModifyNickName} Client2ProxyAckModifyNickName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckModifyNickName.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckModifyNickName();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NewNickName = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckModifyNickName message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckModifyNickName} Client2ProxyAckModifyNickName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckModifyNickName.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckModifyNickName message.
     * @function verify
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckModifyNickName.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewNickName != null && message.hasOwnProperty("NewNickName"))
            if (!(message.NewNickName && typeof message.NewNickName.length === "number" || $util.isString(message.NewNickName)))
                return "NewNickName: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckModifyNickName message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckModifyNickName} Client2ProxyAckModifyNickName
     */
    Client2ProxyAckModifyNickName.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckModifyNickName)
            return object;
        let message = new $root.Client2ProxyAckModifyNickName();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewNickName != null)
            if (typeof object.NewNickName === "string")
                $util.base64.decode(object.NewNickName, message.NewNickName = $util.newBuffer($util.base64.length(object.NewNickName)), 0);
            else if (object.NewNickName.length >= 0)
                message.NewNickName = object.NewNickName;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckModifyNickName message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {Client2ProxyAckModifyNickName} message Client2ProxyAckModifyNickName
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckModifyNickName.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.NewNickName = "";
            else {
                object.NewNickName = [];
                if (options.bytes !== Array)
                    object.NewNickName = $util.newBuffer(object.NewNickName);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewNickName != null && message.hasOwnProperty("NewNickName"))
            object.NewNickName = options.bytes === String ? $util.base64.encode(message.NewNickName, 0, message.NewNickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NewNickName) : message.NewNickName;
        return object;
    };

    /**
     * Converts this Client2ProxyAckModifyNickName to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckModifyNickName
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckModifyNickName.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckModifyNickName
     * @function getTypeUrl
     * @memberof Client2ProxyAckModifyNickName
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckModifyNickName.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckModifyNickName";
    };

    return Client2ProxyAckModifyNickName;
})();

export const Client2ProxyReqModifyPlayHead = $root.Client2ProxyReqModifyPlayHead = (() => {

    /**
     * Properties of a Client2ProxyReqModifyPlayHead.
     * @exports IClient2ProxyReqModifyPlayHead
     * @interface IClient2ProxyReqModifyPlayHead
     * @property {number|null} [UserID] Client2ProxyReqModifyPlayHead UserID
     * @property {string|null} [PlayHead] Client2ProxyReqModifyPlayHead PlayHead
     */

    /**
     * Constructs a new Client2ProxyReqModifyPlayHead.
     * @exports Client2ProxyReqModifyPlayHead
     * @classdesc Represents a Client2ProxyReqModifyPlayHead.
     * @implements IClient2ProxyReqModifyPlayHead
     * @constructor
     * @param {IClient2ProxyReqModifyPlayHead=} [properties] Properties to set
     */
    function Client2ProxyReqModifyPlayHead(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqModifyPlayHead UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqModifyPlayHead
     * @instance
     */
    Client2ProxyReqModifyPlayHead.prototype.UserID = 0;

    /**
     * Client2ProxyReqModifyPlayHead PlayHead.
     * @member {string} PlayHead
     * @memberof Client2ProxyReqModifyPlayHead
     * @instance
     */
    Client2ProxyReqModifyPlayHead.prototype.PlayHead = "";

    /**
     * Creates a new Client2ProxyReqModifyPlayHead instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {IClient2ProxyReqModifyPlayHead=} [properties] Properties to set
     * @returns {Client2ProxyReqModifyPlayHead} Client2ProxyReqModifyPlayHead instance
     */
    Client2ProxyReqModifyPlayHead.create = function create(properties) {
        return new Client2ProxyReqModifyPlayHead(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqModifyPlayHead message. Does not implicitly {@link Client2ProxyReqModifyPlayHead.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {IClient2ProxyReqModifyPlayHead} message Client2ProxyReqModifyPlayHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqModifyPlayHead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PlayHead != null && Object.hasOwnProperty.call(message, "PlayHead"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PlayHead);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqModifyPlayHead message, length delimited. Does not implicitly {@link Client2ProxyReqModifyPlayHead.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {IClient2ProxyReqModifyPlayHead} message Client2ProxyReqModifyPlayHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqModifyPlayHead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqModifyPlayHead message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqModifyPlayHead} Client2ProxyReqModifyPlayHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqModifyPlayHead.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqModifyPlayHead();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.PlayHead = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqModifyPlayHead message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqModifyPlayHead} Client2ProxyReqModifyPlayHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqModifyPlayHead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqModifyPlayHead message.
     * @function verify
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqModifyPlayHead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PlayHead != null && message.hasOwnProperty("PlayHead"))
            if (!$util.isString(message.PlayHead))
                return "PlayHead: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqModifyPlayHead message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqModifyPlayHead} Client2ProxyReqModifyPlayHead
     */
    Client2ProxyReqModifyPlayHead.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqModifyPlayHead)
            return object;
        let message = new $root.Client2ProxyReqModifyPlayHead();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PlayHead != null)
            message.PlayHead = String(object.PlayHead);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqModifyPlayHead message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {Client2ProxyReqModifyPlayHead} message Client2ProxyReqModifyPlayHead
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqModifyPlayHead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.PlayHead = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PlayHead != null && message.hasOwnProperty("PlayHead"))
            object.PlayHead = message.PlayHead;
        return object;
    };

    /**
     * Converts this Client2ProxyReqModifyPlayHead to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqModifyPlayHead
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqModifyPlayHead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqModifyPlayHead
     * @function getTypeUrl
     * @memberof Client2ProxyReqModifyPlayHead
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqModifyPlayHead.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqModifyPlayHead";
    };

    return Client2ProxyReqModifyPlayHead;
})();

export const Client2ProxyAckModifyPlayHead = $root.Client2ProxyAckModifyPlayHead = (() => {

    /**
     * Properties of a Client2ProxyAckModifyPlayHead.
     * @exports IClient2ProxyAckModifyPlayHead
     * @interface IClient2ProxyAckModifyPlayHead
     * @property {number|null} [Ret] Client2ProxyAckModifyPlayHead Ret
     * @property {number|null} [UserID] Client2ProxyAckModifyPlayHead UserID
     * @property {string|null} [PlayHead] Client2ProxyAckModifyPlayHead PlayHead
     */

    /**
     * Constructs a new Client2ProxyAckModifyPlayHead.
     * @exports Client2ProxyAckModifyPlayHead
     * @classdesc Represents a Client2ProxyAckModifyPlayHead.
     * @implements IClient2ProxyAckModifyPlayHead
     * @constructor
     * @param {IClient2ProxyAckModifyPlayHead=} [properties] Properties to set
     */
    function Client2ProxyAckModifyPlayHead(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckModifyPlayHead Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckModifyPlayHead
     * @instance
     */
    Client2ProxyAckModifyPlayHead.prototype.Ret = 0;

    /**
     * Client2ProxyAckModifyPlayHead UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckModifyPlayHead
     * @instance
     */
    Client2ProxyAckModifyPlayHead.prototype.UserID = 0;

    /**
     * Client2ProxyAckModifyPlayHead PlayHead.
     * @member {string} PlayHead
     * @memberof Client2ProxyAckModifyPlayHead
     * @instance
     */
    Client2ProxyAckModifyPlayHead.prototype.PlayHead = "";

    /**
     * Creates a new Client2ProxyAckModifyPlayHead instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {IClient2ProxyAckModifyPlayHead=} [properties] Properties to set
     * @returns {Client2ProxyAckModifyPlayHead} Client2ProxyAckModifyPlayHead instance
     */
    Client2ProxyAckModifyPlayHead.create = function create(properties) {
        return new Client2ProxyAckModifyPlayHead(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckModifyPlayHead message. Does not implicitly {@link Client2ProxyAckModifyPlayHead.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {IClient2ProxyAckModifyPlayHead} message Client2ProxyAckModifyPlayHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckModifyPlayHead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.PlayHead != null && Object.hasOwnProperty.call(message, "PlayHead"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.PlayHead);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckModifyPlayHead message, length delimited. Does not implicitly {@link Client2ProxyAckModifyPlayHead.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {IClient2ProxyAckModifyPlayHead} message Client2ProxyAckModifyPlayHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckModifyPlayHead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckModifyPlayHead message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckModifyPlayHead} Client2ProxyAckModifyPlayHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckModifyPlayHead.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckModifyPlayHead();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.PlayHead = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckModifyPlayHead message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckModifyPlayHead} Client2ProxyAckModifyPlayHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckModifyPlayHead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckModifyPlayHead message.
     * @function verify
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckModifyPlayHead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PlayHead != null && message.hasOwnProperty("PlayHead"))
            if (!$util.isString(message.PlayHead))
                return "PlayHead: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckModifyPlayHead message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckModifyPlayHead} Client2ProxyAckModifyPlayHead
     */
    Client2ProxyAckModifyPlayHead.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckModifyPlayHead)
            return object;
        let message = new $root.Client2ProxyAckModifyPlayHead();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PlayHead != null)
            message.PlayHead = String(object.PlayHead);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckModifyPlayHead message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {Client2ProxyAckModifyPlayHead} message Client2ProxyAckModifyPlayHead
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckModifyPlayHead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.PlayHead = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PlayHead != null && message.hasOwnProperty("PlayHead"))
            object.PlayHead = message.PlayHead;
        return object;
    };

    /**
     * Converts this Client2ProxyAckModifyPlayHead to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckModifyPlayHead
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckModifyPlayHead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckModifyPlayHead
     * @function getTypeUrl
     * @memberof Client2ProxyAckModifyPlayHead
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckModifyPlayHead.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckModifyPlayHead";
    };

    return Client2ProxyAckModifyPlayHead;
})();

export const Client2ProxyPushModityHead = $root.Client2ProxyPushModityHead = (() => {

    /**
     * Properties of a Client2ProxyPushModityHead.
     * @exports IClient2ProxyPushModityHead
     * @interface IClient2ProxyPushModityHead
     * @property {number|null} [UserID] Client2ProxyPushModityHead UserID
     * @property {string|null} [NewHeadUrl] Client2ProxyPushModityHead NewHeadUrl
     */

    /**
     * Constructs a new Client2ProxyPushModityHead.
     * @exports Client2ProxyPushModityHead
     * @classdesc Represents a Client2ProxyPushModityHead.
     * @implements IClient2ProxyPushModityHead
     * @constructor
     * @param {IClient2ProxyPushModityHead=} [properties] Properties to set
     */
    function Client2ProxyPushModityHead(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushModityHead UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushModityHead
     * @instance
     */
    Client2ProxyPushModityHead.prototype.UserID = 0;

    /**
     * Client2ProxyPushModityHead NewHeadUrl.
     * @member {string} NewHeadUrl
     * @memberof Client2ProxyPushModityHead
     * @instance
     */
    Client2ProxyPushModityHead.prototype.NewHeadUrl = "";

    /**
     * Creates a new Client2ProxyPushModityHead instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {IClient2ProxyPushModityHead=} [properties] Properties to set
     * @returns {Client2ProxyPushModityHead} Client2ProxyPushModityHead instance
     */
    Client2ProxyPushModityHead.create = function create(properties) {
        return new Client2ProxyPushModityHead(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushModityHead message. Does not implicitly {@link Client2ProxyPushModityHead.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {IClient2ProxyPushModityHead} message Client2ProxyPushModityHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushModityHead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NewHeadUrl != null && Object.hasOwnProperty.call(message, "NewHeadUrl"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.NewHeadUrl);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushModityHead message, length delimited. Does not implicitly {@link Client2ProxyPushModityHead.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {IClient2ProxyPushModityHead} message Client2ProxyPushModityHead message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushModityHead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushModityHead message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushModityHead} Client2ProxyPushModityHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushModityHead.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushModityHead();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NewHeadUrl = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushModityHead message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushModityHead} Client2ProxyPushModityHead
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushModityHead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushModityHead message.
     * @function verify
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushModityHead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewHeadUrl != null && message.hasOwnProperty("NewHeadUrl"))
            if (!$util.isString(message.NewHeadUrl))
                return "NewHeadUrl: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushModityHead message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushModityHead} Client2ProxyPushModityHead
     */
    Client2ProxyPushModityHead.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushModityHead)
            return object;
        let message = new $root.Client2ProxyPushModityHead();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewHeadUrl != null)
            message.NewHeadUrl = String(object.NewHeadUrl);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushModityHead message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {Client2ProxyPushModityHead} message Client2ProxyPushModityHead
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushModityHead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.NewHeadUrl = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewHeadUrl != null && message.hasOwnProperty("NewHeadUrl"))
            object.NewHeadUrl = message.NewHeadUrl;
        return object;
    };

    /**
     * Converts this Client2ProxyPushModityHead to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushModityHead
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushModityHead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushModityHead
     * @function getTypeUrl
     * @memberof Client2ProxyPushModityHead
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushModityHead.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushModityHead";
    };

    return Client2ProxyPushModityHead;
})();

export const Client2ProxyRegisterReq = $root.Client2ProxyRegisterReq = (() => {

    /**
     * Properties of a Client2ProxyRegisterReq.
     * @exports IClient2ProxyRegisterReq
     * @interface IClient2ProxyRegisterReq
     * @property {string|null} [RegAccount] Client2ProxyRegisterReq RegAccount
     * @property {string|null} [PassWord] Client2ProxyRegisterReq PassWord
     * @property {string|null} [modileNum] Client2ProxyRegisterReq modileNum
     * @property {string|null} [clientMark] Client2ProxyRegisterReq clientMark
     * @property {number|null} [platformType] Client2ProxyRegisterReq platformType
     * @property {number|null} [platform] Client2ProxyRegisterReq platform
     * @property {number|null} [regChannel] Client2ProxyRegisterReq regChannel
     * @property {string|null} [version] Client2ProxyRegisterReq version
     * @property {number|null} [appVersion] Client2ProxyRegisterReq appVersion
     * @property {number|null} [Type] Client2ProxyRegisterReq Type
     * @property {number|null} [RecommendedUID] Client2ProxyRegisterReq RecommendedUID
     * @property {string|null} [AppName] Client2ProxyRegisterReq AppName
     * @property {number|null} [channel] Client2ProxyRegisterReq channel
     * @property {string|null} [mobileType] Client2ProxyRegisterReq mobileType
     * @property {string|null} [mobileOsVer] Client2ProxyRegisterReq mobileOsVer
     */

    /**
     * Constructs a new Client2ProxyRegisterReq.
     * @exports Client2ProxyRegisterReq
     * @classdesc Represents a Client2ProxyRegisterReq.
     * @implements IClient2ProxyRegisterReq
     * @constructor
     * @param {IClient2ProxyRegisterReq=} [properties] Properties to set
     */
    function Client2ProxyRegisterReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyRegisterReq RegAccount.
     * @member {string} RegAccount
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.RegAccount = "";

    /**
     * Client2ProxyRegisterReq PassWord.
     * @member {string} PassWord
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.PassWord = "";

    /**
     * Client2ProxyRegisterReq modileNum.
     * @member {string} modileNum
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.modileNum = "";

    /**
     * Client2ProxyRegisterReq clientMark.
     * @member {string} clientMark
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.clientMark = "";

    /**
     * Client2ProxyRegisterReq platformType.
     * @member {number} platformType
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.platformType = 0;

    /**
     * Client2ProxyRegisterReq platform.
     * @member {number} platform
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.platform = 0;

    /**
     * Client2ProxyRegisterReq regChannel.
     * @member {number} regChannel
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.regChannel = 0;

    /**
     * Client2ProxyRegisterReq version.
     * @member {string} version
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.version = "";

    /**
     * Client2ProxyRegisterReq appVersion.
     * @member {number} appVersion
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.appVersion = 0;

    /**
     * Client2ProxyRegisterReq Type.
     * @member {number} Type
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.Type = 0;

    /**
     * Client2ProxyRegisterReq RecommendedUID.
     * @member {number} RecommendedUID
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.RecommendedUID = 0;

    /**
     * Client2ProxyRegisterReq AppName.
     * @member {string} AppName
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.AppName = "";

    /**
     * Client2ProxyRegisterReq channel.
     * @member {number} channel
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.channel = 0;

    /**
     * Client2ProxyRegisterReq mobileType.
     * @member {string} mobileType
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.mobileType = "";

    /**
     * Client2ProxyRegisterReq mobileOsVer.
     * @member {string} mobileOsVer
     * @memberof Client2ProxyRegisterReq
     * @instance
     */
    Client2ProxyRegisterReq.prototype.mobileOsVer = "";

    /**
     * Creates a new Client2ProxyRegisterReq instance using the specified properties.
     * @function create
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {IClient2ProxyRegisterReq=} [properties] Properties to set
     * @returns {Client2ProxyRegisterReq} Client2ProxyRegisterReq instance
     */
    Client2ProxyRegisterReq.create = function create(properties) {
        return new Client2ProxyRegisterReq(properties);
    };

    /**
     * Encodes the specified Client2ProxyRegisterReq message. Does not implicitly {@link Client2ProxyRegisterReq.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {IClient2ProxyRegisterReq} message Client2ProxyRegisterReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyRegisterReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RegAccount != null && Object.hasOwnProperty.call(message, "RegAccount"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.RegAccount);
        if (message.PassWord != null && Object.hasOwnProperty.call(message, "PassWord"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PassWord);
        if (message.modileNum != null && Object.hasOwnProperty.call(message, "modileNum"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.modileNum);
        if (message.clientMark != null && Object.hasOwnProperty.call(message, "clientMark"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientMark);
        if (message.platformType != null && Object.hasOwnProperty.call(message, "platformType"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.platformType);
        if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.platform);
        if (message.regChannel != null && Object.hasOwnProperty.call(message, "regChannel"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.regChannel);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.version);
        if (message.appVersion != null && Object.hasOwnProperty.call(message, "appVersion"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.appVersion);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.Type);
        if (message.RecommendedUID != null && Object.hasOwnProperty.call(message, "RecommendedUID"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.RecommendedUID);
        if (message.AppName != null && Object.hasOwnProperty.call(message, "AppName"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.AppName);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.channel);
        if (message.mobileType != null && Object.hasOwnProperty.call(message, "mobileType"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.mobileType);
        if (message.mobileOsVer != null && Object.hasOwnProperty.call(message, "mobileOsVer"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.mobileOsVer);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyRegisterReq message, length delimited. Does not implicitly {@link Client2ProxyRegisterReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {IClient2ProxyRegisterReq} message Client2ProxyRegisterReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyRegisterReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyRegisterReq message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyRegisterReq} Client2ProxyRegisterReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyRegisterReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyRegisterReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RegAccount = reader.string();
                    break;
                }
            case 2: {
                    message.PassWord = reader.string();
                    break;
                }
            case 3: {
                    message.modileNum = reader.string();
                    break;
                }
            case 4: {
                    message.clientMark = reader.string();
                    break;
                }
            case 5: {
                    message.platformType = reader.int32();
                    break;
                }
            case 6: {
                    message.platform = reader.int32();
                    break;
                }
            case 7: {
                    message.regChannel = reader.int32();
                    break;
                }
            case 8: {
                    message.version = reader.string();
                    break;
                }
            case 9: {
                    message.appVersion = reader.int32();
                    break;
                }
            case 10: {
                    message.Type = reader.int32();
                    break;
                }
            case 11: {
                    message.RecommendedUID = reader.uint32();
                    break;
                }
            case 12: {
                    message.AppName = reader.string();
                    break;
                }
            case 13: {
                    message.channel = reader.uint32();
                    break;
                }
            case 14: {
                    message.mobileType = reader.string();
                    break;
                }
            case 15: {
                    message.mobileOsVer = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyRegisterReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyRegisterReq} Client2ProxyRegisterReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyRegisterReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyRegisterReq message.
     * @function verify
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyRegisterReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            if (!$util.isString(message.RegAccount))
                return "RegAccount: string expected";
        if (message.PassWord != null && message.hasOwnProperty("PassWord"))
            if (!$util.isString(message.PassWord))
                return "PassWord: string expected";
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            if (!$util.isString(message.modileNum))
                return "modileNum: string expected";
        if (message.clientMark != null && message.hasOwnProperty("clientMark"))
            if (!$util.isString(message.clientMark))
                return "clientMark: string expected";
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            if (!$util.isInteger(message.platformType))
                return "platformType: integer expected";
        if (message.platform != null && message.hasOwnProperty("platform"))
            if (!$util.isInteger(message.platform))
                return "platform: integer expected";
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            if (!$util.isInteger(message.regChannel))
                return "regChannel: integer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            if (!$util.isInteger(message.appVersion))
                return "appVersion: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            if (!$util.isInteger(message.RecommendedUID))
                return "RecommendedUID: integer expected";
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            if (!$util.isString(message.AppName))
                return "AppName: string expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isInteger(message.channel))
                return "channel: integer expected";
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            if (!$util.isString(message.mobileType))
                return "mobileType: string expected";
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            if (!$util.isString(message.mobileOsVer))
                return "mobileOsVer: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyRegisterReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyRegisterReq} Client2ProxyRegisterReq
     */
    Client2ProxyRegisterReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyRegisterReq)
            return object;
        let message = new $root.Client2ProxyRegisterReq();
        if (object.RegAccount != null)
            message.RegAccount = String(object.RegAccount);
        if (object.PassWord != null)
            message.PassWord = String(object.PassWord);
        if (object.modileNum != null)
            message.modileNum = String(object.modileNum);
        if (object.clientMark != null)
            message.clientMark = String(object.clientMark);
        if (object.platformType != null)
            message.platformType = object.platformType | 0;
        if (object.platform != null)
            message.platform = object.platform | 0;
        if (object.regChannel != null)
            message.regChannel = object.regChannel | 0;
        if (object.version != null)
            message.version = String(object.version);
        if (object.appVersion != null)
            message.appVersion = object.appVersion | 0;
        if (object.Type != null)
            message.Type = object.Type | 0;
        if (object.RecommendedUID != null)
            message.RecommendedUID = object.RecommendedUID >>> 0;
        if (object.AppName != null)
            message.AppName = String(object.AppName);
        if (object.channel != null)
            message.channel = object.channel >>> 0;
        if (object.mobileType != null)
            message.mobileType = String(object.mobileType);
        if (object.mobileOsVer != null)
            message.mobileOsVer = String(object.mobileOsVer);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyRegisterReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {Client2ProxyRegisterReq} message Client2ProxyRegisterReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyRegisterReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.RegAccount = "";
            object.PassWord = "";
            object.modileNum = "";
            object.clientMark = "";
            object.platformType = 0;
            object.platform = 0;
            object.regChannel = 0;
            object.version = "";
            object.appVersion = 0;
            object.Type = 0;
            object.RecommendedUID = 0;
            object.AppName = "";
            object.channel = 0;
            object.mobileType = "";
            object.mobileOsVer = "";
        }
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            object.RegAccount = message.RegAccount;
        if (message.PassWord != null && message.hasOwnProperty("PassWord"))
            object.PassWord = message.PassWord;
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            object.modileNum = message.modileNum;
        if (message.clientMark != null && message.hasOwnProperty("clientMark"))
            object.clientMark = message.clientMark;
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            object.platformType = message.platformType;
        if (message.platform != null && message.hasOwnProperty("platform"))
            object.platform = message.platform;
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            object.regChannel = message.regChannel;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            object.appVersion = message.appVersion;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            object.RecommendedUID = message.RecommendedUID;
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            object.AppName = message.AppName;
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            object.mobileType = message.mobileType;
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            object.mobileOsVer = message.mobileOsVer;
        return object;
    };

    /**
     * Converts this Client2ProxyRegisterReq to JSON.
     * @function toJSON
     * @memberof Client2ProxyRegisterReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyRegisterReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyRegisterReq
     * @function getTypeUrl
     * @memberof Client2ProxyRegisterReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyRegisterReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyRegisterReq";
    };

    return Client2ProxyRegisterReq;
})();

export const Client2ProxyRegisterAck = $root.Client2ProxyRegisterAck = (() => {

    /**
     * Properties of a Client2ProxyRegisterAck.
     * @exports IClient2ProxyRegisterAck
     * @interface IClient2ProxyRegisterAck
     * @property {number|null} [Ret] Client2ProxyRegisterAck Ret
     */

    /**
     * Constructs a new Client2ProxyRegisterAck.
     * @exports Client2ProxyRegisterAck
     * @classdesc Represents a Client2ProxyRegisterAck.
     * @implements IClient2ProxyRegisterAck
     * @constructor
     * @param {IClient2ProxyRegisterAck=} [properties] Properties to set
     */
    function Client2ProxyRegisterAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyRegisterAck Ret.
     * @member {number} Ret
     * @memberof Client2ProxyRegisterAck
     * @instance
     */
    Client2ProxyRegisterAck.prototype.Ret = 0;

    /**
     * Creates a new Client2ProxyRegisterAck instance using the specified properties.
     * @function create
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {IClient2ProxyRegisterAck=} [properties] Properties to set
     * @returns {Client2ProxyRegisterAck} Client2ProxyRegisterAck instance
     */
    Client2ProxyRegisterAck.create = function create(properties) {
        return new Client2ProxyRegisterAck(properties);
    };

    /**
     * Encodes the specified Client2ProxyRegisterAck message. Does not implicitly {@link Client2ProxyRegisterAck.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {IClient2ProxyRegisterAck} message Client2ProxyRegisterAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyRegisterAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyRegisterAck message, length delimited. Does not implicitly {@link Client2ProxyRegisterAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {IClient2ProxyRegisterAck} message Client2ProxyRegisterAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyRegisterAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyRegisterAck message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyRegisterAck} Client2ProxyRegisterAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyRegisterAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyRegisterAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyRegisterAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyRegisterAck} Client2ProxyRegisterAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyRegisterAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyRegisterAck message.
     * @function verify
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyRegisterAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyRegisterAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyRegisterAck} Client2ProxyRegisterAck
     */
    Client2ProxyRegisterAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyRegisterAck)
            return object;
        let message = new $root.Client2ProxyRegisterAck();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyRegisterAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {Client2ProxyRegisterAck} message Client2ProxyRegisterAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyRegisterAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.Ret = 0;
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        return object;
    };

    /**
     * Converts this Client2ProxyRegisterAck to JSON.
     * @function toJSON
     * @memberof Client2ProxyRegisterAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyRegisterAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyRegisterAck
     * @function getTypeUrl
     * @memberof Client2ProxyRegisterAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyRegisterAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyRegisterAck";
    };

    return Client2ProxyRegisterAck;
})();

export const Client2ProxyLoggingReq = $root.Client2ProxyLoggingReq = (() => {

    /**
     * Properties of a Client2ProxyLoggingReq.
     * @exports IClient2ProxyLoggingReq
     * @interface IClient2ProxyLoggingReq
     * @property {string|null} [RegAccount] Client2ProxyLoggingReq RegAccount
     * @property {string|null} [PassWord] Client2ProxyLoggingReq PassWord
     */

    /**
     * Constructs a new Client2ProxyLoggingReq.
     * @exports Client2ProxyLoggingReq
     * @classdesc Represents a Client2ProxyLoggingReq.
     * @implements IClient2ProxyLoggingReq
     * @constructor
     * @param {IClient2ProxyLoggingReq=} [properties] Properties to set
     */
    function Client2ProxyLoggingReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyLoggingReq RegAccount.
     * @member {string} RegAccount
     * @memberof Client2ProxyLoggingReq
     * @instance
     */
    Client2ProxyLoggingReq.prototype.RegAccount = "";

    /**
     * Client2ProxyLoggingReq PassWord.
     * @member {string} PassWord
     * @memberof Client2ProxyLoggingReq
     * @instance
     */
    Client2ProxyLoggingReq.prototype.PassWord = "";

    /**
     * Creates a new Client2ProxyLoggingReq instance using the specified properties.
     * @function create
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {IClient2ProxyLoggingReq=} [properties] Properties to set
     * @returns {Client2ProxyLoggingReq} Client2ProxyLoggingReq instance
     */
    Client2ProxyLoggingReq.create = function create(properties) {
        return new Client2ProxyLoggingReq(properties);
    };

    /**
     * Encodes the specified Client2ProxyLoggingReq message. Does not implicitly {@link Client2ProxyLoggingReq.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {IClient2ProxyLoggingReq} message Client2ProxyLoggingReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyLoggingReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RegAccount != null && Object.hasOwnProperty.call(message, "RegAccount"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.RegAccount);
        if (message.PassWord != null && Object.hasOwnProperty.call(message, "PassWord"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.PassWord);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyLoggingReq message, length delimited. Does not implicitly {@link Client2ProxyLoggingReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {IClient2ProxyLoggingReq} message Client2ProxyLoggingReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyLoggingReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyLoggingReq message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyLoggingReq} Client2ProxyLoggingReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyLoggingReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyLoggingReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RegAccount = reader.string();
                    break;
                }
            case 2: {
                    message.PassWord = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyLoggingReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyLoggingReq} Client2ProxyLoggingReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyLoggingReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyLoggingReq message.
     * @function verify
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyLoggingReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            if (!$util.isString(message.RegAccount))
                return "RegAccount: string expected";
        if (message.PassWord != null && message.hasOwnProperty("PassWord"))
            if (!$util.isString(message.PassWord))
                return "PassWord: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyLoggingReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyLoggingReq} Client2ProxyLoggingReq
     */
    Client2ProxyLoggingReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyLoggingReq)
            return object;
        let message = new $root.Client2ProxyLoggingReq();
        if (object.RegAccount != null)
            message.RegAccount = String(object.RegAccount);
        if (object.PassWord != null)
            message.PassWord = String(object.PassWord);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyLoggingReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {Client2ProxyLoggingReq} message Client2ProxyLoggingReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyLoggingReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.RegAccount = "";
            object.PassWord = "";
        }
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            object.RegAccount = message.RegAccount;
        if (message.PassWord != null && message.hasOwnProperty("PassWord"))
            object.PassWord = message.PassWord;
        return object;
    };

    /**
     * Converts this Client2ProxyLoggingReq to JSON.
     * @function toJSON
     * @memberof Client2ProxyLoggingReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyLoggingReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyLoggingReq
     * @function getTypeUrl
     * @memberof Client2ProxyLoggingReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyLoggingReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyLoggingReq";
    };

    return Client2ProxyLoggingReq;
})();

export const Client2ProxyLoggingAck = $root.Client2ProxyLoggingAck = (() => {

    /**
     * Properties of a Client2ProxyLoggingAck.
     * @exports IClient2ProxyLoggingAck
     * @interface IClient2ProxyLoggingAck
     * @property {number|null} [Ret] Client2ProxyLoggingAck Ret
     * @property {string|null} [Token] Client2ProxyLoggingAck Token
     */

    /**
     * Constructs a new Client2ProxyLoggingAck.
     * @exports Client2ProxyLoggingAck
     * @classdesc Represents a Client2ProxyLoggingAck.
     * @implements IClient2ProxyLoggingAck
     * @constructor
     * @param {IClient2ProxyLoggingAck=} [properties] Properties to set
     */
    function Client2ProxyLoggingAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyLoggingAck Ret.
     * @member {number} Ret
     * @memberof Client2ProxyLoggingAck
     * @instance
     */
    Client2ProxyLoggingAck.prototype.Ret = 0;

    /**
     * Client2ProxyLoggingAck Token.
     * @member {string} Token
     * @memberof Client2ProxyLoggingAck
     * @instance
     */
    Client2ProxyLoggingAck.prototype.Token = "";

    /**
     * Creates a new Client2ProxyLoggingAck instance using the specified properties.
     * @function create
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {IClient2ProxyLoggingAck=} [properties] Properties to set
     * @returns {Client2ProxyLoggingAck} Client2ProxyLoggingAck instance
     */
    Client2ProxyLoggingAck.create = function create(properties) {
        return new Client2ProxyLoggingAck(properties);
    };

    /**
     * Encodes the specified Client2ProxyLoggingAck message. Does not implicitly {@link Client2ProxyLoggingAck.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {IClient2ProxyLoggingAck} message Client2ProxyLoggingAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyLoggingAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Token);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyLoggingAck message, length delimited. Does not implicitly {@link Client2ProxyLoggingAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {IClient2ProxyLoggingAck} message Client2ProxyLoggingAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyLoggingAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyLoggingAck message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyLoggingAck} Client2ProxyLoggingAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyLoggingAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyLoggingAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.Token = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyLoggingAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyLoggingAck} Client2ProxyLoggingAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyLoggingAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyLoggingAck message.
     * @function verify
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyLoggingAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.Token != null && message.hasOwnProperty("Token"))
            if (!$util.isString(message.Token))
                return "Token: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyLoggingAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyLoggingAck} Client2ProxyLoggingAck
     */
    Client2ProxyLoggingAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyLoggingAck)
            return object;
        let message = new $root.Client2ProxyLoggingAck();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.Token != null)
            message.Token = String(object.Token);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyLoggingAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {Client2ProxyLoggingAck} message Client2ProxyLoggingAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyLoggingAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.Token = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.Token != null && message.hasOwnProperty("Token"))
            object.Token = message.Token;
        return object;
    };

    /**
     * Converts this Client2ProxyLoggingAck to JSON.
     * @function toJSON
     * @memberof Client2ProxyLoggingAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyLoggingAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyLoggingAck
     * @function getTypeUrl
     * @memberof Client2ProxyLoggingAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyLoggingAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyLoggingAck";
    };

    return Client2ProxyLoggingAck;
})();

export const Client2ProxyReqMoblieLogin = $root.Client2ProxyReqMoblieLogin = (() => {

    /**
     * Properties of a Client2ProxyReqMoblieLogin.
     * @exports IClient2ProxyReqMoblieLogin
     * @interface IClient2ProxyReqMoblieLogin
     * @property {string|null} [clientMark] Client2ProxyReqMoblieLogin clientMark
     * @property {string|null} [modileNum] Client2ProxyReqMoblieLogin modileNum
     * @property {string|null} [smsCode] Client2ProxyReqMoblieLogin smsCode
     * @property {number|null} [platformType] Client2ProxyReqMoblieLogin platformType
     * @property {number|null} [platform] Client2ProxyReqMoblieLogin platform
     * @property {number|null} [regChannel] Client2ProxyReqMoblieLogin regChannel
     * @property {string|null} [version] Client2ProxyReqMoblieLogin version
     * @property {number|null} [appVersion] Client2ProxyReqMoblieLogin appVersion
     * @property {number|null} [Type] Client2ProxyReqMoblieLogin Type
     * @property {number|null} [RecommendedUID] Client2ProxyReqMoblieLogin RecommendedUID
     * @property {string|null} [AppName] Client2ProxyReqMoblieLogin AppName
     * @property {number|null} [channel] Client2ProxyReqMoblieLogin channel
     * @property {string|null} [mobileType] Client2ProxyReqMoblieLogin mobileType
     * @property {string|null} [mobileOsVer] Client2ProxyReqMoblieLogin mobileOsVer
     * @property {string|null} [messageID] Client2ProxyReqMoblieLogin messageID
     * @property {boolean|null} [IsBing] Client2ProxyReqMoblieLogin IsBing
     */

    /**
     * Constructs a new Client2ProxyReqMoblieLogin.
     * @exports Client2ProxyReqMoblieLogin
     * @classdesc Represents a Client2ProxyReqMoblieLogin.
     * @implements IClient2ProxyReqMoblieLogin
     * @constructor
     * @param {IClient2ProxyReqMoblieLogin=} [properties] Properties to set
     */
    function Client2ProxyReqMoblieLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMoblieLogin clientMark.
     * @member {string} clientMark
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.clientMark = "";

    /**
     * Client2ProxyReqMoblieLogin modileNum.
     * @member {string} modileNum
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.modileNum = "";

    /**
     * Client2ProxyReqMoblieLogin smsCode.
     * @member {string} smsCode
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.smsCode = "";

    /**
     * Client2ProxyReqMoblieLogin platformType.
     * @member {number} platformType
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.platformType = 0;

    /**
     * Client2ProxyReqMoblieLogin platform.
     * @member {number} platform
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.platform = 0;

    /**
     * Client2ProxyReqMoblieLogin regChannel.
     * @member {number} regChannel
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.regChannel = 0;

    /**
     * Client2ProxyReqMoblieLogin version.
     * @member {string} version
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.version = "";

    /**
     * Client2ProxyReqMoblieLogin appVersion.
     * @member {number} appVersion
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.appVersion = 0;

    /**
     * Client2ProxyReqMoblieLogin Type.
     * @member {number} Type
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.Type = 0;

    /**
     * Client2ProxyReqMoblieLogin RecommendedUID.
     * @member {number} RecommendedUID
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.RecommendedUID = 0;

    /**
     * Client2ProxyReqMoblieLogin AppName.
     * @member {string} AppName
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.AppName = "";

    /**
     * Client2ProxyReqMoblieLogin channel.
     * @member {number} channel
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.channel = 0;

    /**
     * Client2ProxyReqMoblieLogin mobileType.
     * @member {string} mobileType
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.mobileType = "";

    /**
     * Client2ProxyReqMoblieLogin mobileOsVer.
     * @member {string} mobileOsVer
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.mobileOsVer = "";

    /**
     * Client2ProxyReqMoblieLogin messageID.
     * @member {string} messageID
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.messageID = "";

    /**
     * Client2ProxyReqMoblieLogin IsBing.
     * @member {boolean} IsBing
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     */
    Client2ProxyReqMoblieLogin.prototype.IsBing = false;

    /**
     * Creates a new Client2ProxyReqMoblieLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {IClient2ProxyReqMoblieLogin=} [properties] Properties to set
     * @returns {Client2ProxyReqMoblieLogin} Client2ProxyReqMoblieLogin instance
     */
    Client2ProxyReqMoblieLogin.create = function create(properties) {
        return new Client2ProxyReqMoblieLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMoblieLogin message. Does not implicitly {@link Client2ProxyReqMoblieLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {IClient2ProxyReqMoblieLogin} message Client2ProxyReqMoblieLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMoblieLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.clientMark != null && Object.hasOwnProperty.call(message, "clientMark"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientMark);
        if (message.modileNum != null && Object.hasOwnProperty.call(message, "modileNum"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.modileNum);
        if (message.smsCode != null && Object.hasOwnProperty.call(message, "smsCode"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.smsCode);
        if (message.platformType != null && Object.hasOwnProperty.call(message, "platformType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.platformType);
        if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.platform);
        if (message.regChannel != null && Object.hasOwnProperty.call(message, "regChannel"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.regChannel);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.version);
        if (message.appVersion != null && Object.hasOwnProperty.call(message, "appVersion"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.appVersion);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.Type);
        if (message.RecommendedUID != null && Object.hasOwnProperty.call(message, "RecommendedUID"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.RecommendedUID);
        if (message.AppName != null && Object.hasOwnProperty.call(message, "AppName"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.AppName);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.channel);
        if (message.mobileType != null && Object.hasOwnProperty.call(message, "mobileType"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.mobileType);
        if (message.mobileOsVer != null && Object.hasOwnProperty.call(message, "mobileOsVer"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.mobileOsVer);
        if (message.messageID != null && Object.hasOwnProperty.call(message, "messageID"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.messageID);
        if (message.IsBing != null && Object.hasOwnProperty.call(message, "IsBing"))
            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.IsBing);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMoblieLogin message, length delimited. Does not implicitly {@link Client2ProxyReqMoblieLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {IClient2ProxyReqMoblieLogin} message Client2ProxyReqMoblieLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMoblieLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMoblieLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMoblieLogin} Client2ProxyReqMoblieLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMoblieLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMoblieLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.clientMark = reader.string();
                    break;
                }
            case 2: {
                    message.modileNum = reader.string();
                    break;
                }
            case 3: {
                    message.smsCode = reader.string();
                    break;
                }
            case 4: {
                    message.platformType = reader.int32();
                    break;
                }
            case 5: {
                    message.platform = reader.int32();
                    break;
                }
            case 6: {
                    message.regChannel = reader.int32();
                    break;
                }
            case 7: {
                    message.version = reader.string();
                    break;
                }
            case 8: {
                    message.appVersion = reader.int32();
                    break;
                }
            case 9: {
                    message.Type = reader.int32();
                    break;
                }
            case 10: {
                    message.RecommendedUID = reader.uint32();
                    break;
                }
            case 11: {
                    message.AppName = reader.string();
                    break;
                }
            case 12: {
                    message.channel = reader.uint32();
                    break;
                }
            case 13: {
                    message.mobileType = reader.string();
                    break;
                }
            case 14: {
                    message.mobileOsVer = reader.string();
                    break;
                }
            case 15: {
                    message.messageID = reader.string();
                    break;
                }
            case 16: {
                    message.IsBing = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMoblieLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMoblieLogin} Client2ProxyReqMoblieLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMoblieLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMoblieLogin message.
     * @function verify
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMoblieLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.clientMark != null && message.hasOwnProperty("clientMark"))
            if (!$util.isString(message.clientMark))
                return "clientMark: string expected";
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            if (!$util.isString(message.modileNum))
                return "modileNum: string expected";
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            if (!$util.isString(message.smsCode))
                return "smsCode: string expected";
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            if (!$util.isInteger(message.platformType))
                return "platformType: integer expected";
        if (message.platform != null && message.hasOwnProperty("platform"))
            if (!$util.isInteger(message.platform))
                return "platform: integer expected";
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            if (!$util.isInteger(message.regChannel))
                return "regChannel: integer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            if (!$util.isInteger(message.appVersion))
                return "appVersion: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            if (!$util.isInteger(message.RecommendedUID))
                return "RecommendedUID: integer expected";
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            if (!$util.isString(message.AppName))
                return "AppName: string expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isInteger(message.channel))
                return "channel: integer expected";
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            if (!$util.isString(message.mobileType))
                return "mobileType: string expected";
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            if (!$util.isString(message.mobileOsVer))
                return "mobileOsVer: string expected";
        if (message.messageID != null && message.hasOwnProperty("messageID"))
            if (!$util.isString(message.messageID))
                return "messageID: string expected";
        if (message.IsBing != null && message.hasOwnProperty("IsBing"))
            if (typeof message.IsBing !== "boolean")
                return "IsBing: boolean expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMoblieLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMoblieLogin} Client2ProxyReqMoblieLogin
     */
    Client2ProxyReqMoblieLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMoblieLogin)
            return object;
        let message = new $root.Client2ProxyReqMoblieLogin();
        if (object.clientMark != null)
            message.clientMark = String(object.clientMark);
        if (object.modileNum != null)
            message.modileNum = String(object.modileNum);
        if (object.smsCode != null)
            message.smsCode = String(object.smsCode);
        if (object.platformType != null)
            message.platformType = object.platformType | 0;
        if (object.platform != null)
            message.platform = object.platform | 0;
        if (object.regChannel != null)
            message.regChannel = object.regChannel | 0;
        if (object.version != null)
            message.version = String(object.version);
        if (object.appVersion != null)
            message.appVersion = object.appVersion | 0;
        if (object.Type != null)
            message.Type = object.Type | 0;
        if (object.RecommendedUID != null)
            message.RecommendedUID = object.RecommendedUID >>> 0;
        if (object.AppName != null)
            message.AppName = String(object.AppName);
        if (object.channel != null)
            message.channel = object.channel >>> 0;
        if (object.mobileType != null)
            message.mobileType = String(object.mobileType);
        if (object.mobileOsVer != null)
            message.mobileOsVer = String(object.mobileOsVer);
        if (object.messageID != null)
            message.messageID = String(object.messageID);
        if (object.IsBing != null)
            message.IsBing = Boolean(object.IsBing);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMoblieLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {Client2ProxyReqMoblieLogin} message Client2ProxyReqMoblieLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMoblieLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.clientMark = "";
            object.modileNum = "";
            object.smsCode = "";
            object.platformType = 0;
            object.platform = 0;
            object.regChannel = 0;
            object.version = "";
            object.appVersion = 0;
            object.Type = 0;
            object.RecommendedUID = 0;
            object.AppName = "";
            object.channel = 0;
            object.mobileType = "";
            object.mobileOsVer = "";
            object.messageID = "";
            object.IsBing = false;
        }
        if (message.clientMark != null && message.hasOwnProperty("clientMark"))
            object.clientMark = message.clientMark;
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            object.modileNum = message.modileNum;
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            object.smsCode = message.smsCode;
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            object.platformType = message.platformType;
        if (message.platform != null && message.hasOwnProperty("platform"))
            object.platform = message.platform;
        if (message.regChannel != null && message.hasOwnProperty("regChannel"))
            object.regChannel = message.regChannel;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.appVersion != null && message.hasOwnProperty("appVersion"))
            object.appVersion = message.appVersion;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            object.RecommendedUID = message.RecommendedUID;
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            object.AppName = message.AppName;
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            object.mobileType = message.mobileType;
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            object.mobileOsVer = message.mobileOsVer;
        if (message.messageID != null && message.hasOwnProperty("messageID"))
            object.messageID = message.messageID;
        if (message.IsBing != null && message.hasOwnProperty("IsBing"))
            object.IsBing = message.IsBing;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMoblieLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMoblieLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMoblieLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMoblieLogin
     * @function getTypeUrl
     * @memberof Client2ProxyReqMoblieLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMoblieLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMoblieLogin";
    };

    return Client2ProxyReqMoblieLogin;
})();

export const Client2ProxyAckMoblieLogin = $root.Client2ProxyAckMoblieLogin = (() => {

    /**
     * Properties of a Client2ProxyAckMoblieLogin.
     * @exports IClient2ProxyAckMoblieLogin
     * @interface IClient2ProxyAckMoblieLogin
     * @property {number|null} [Ret] Client2ProxyAckMoblieLogin Ret
     * @property {string|null} [modileNum] Client2ProxyAckMoblieLogin modileNum
     * @property {string|null} [Token] Client2ProxyAckMoblieLogin Token
     * @property {number|null} [GameID] Client2ProxyAckMoblieLogin GameID
     * @property {boolean|null} [FirstTime] Client2ProxyAckMoblieLogin FirstTime
     * @property {boolean|null} [SendMoney] Client2ProxyAckMoblieLogin SendMoney
     */

    /**
     * Constructs a new Client2ProxyAckMoblieLogin.
     * @exports Client2ProxyAckMoblieLogin
     * @classdesc Represents a Client2ProxyAckMoblieLogin.
     * @implements IClient2ProxyAckMoblieLogin
     * @constructor
     * @param {IClient2ProxyAckMoblieLogin=} [properties] Properties to set
     */
    function Client2ProxyAckMoblieLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMoblieLogin Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.Ret = 0;

    /**
     * Client2ProxyAckMoblieLogin modileNum.
     * @member {string} modileNum
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.modileNum = "";

    /**
     * Client2ProxyAckMoblieLogin Token.
     * @member {string} Token
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.Token = "";

    /**
     * Client2ProxyAckMoblieLogin GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.GameID = 0;

    /**
     * Client2ProxyAckMoblieLogin FirstTime.
     * @member {boolean} FirstTime
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.FirstTime = false;

    /**
     * Client2ProxyAckMoblieLogin SendMoney.
     * @member {boolean} SendMoney
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     */
    Client2ProxyAckMoblieLogin.prototype.SendMoney = false;

    /**
     * Creates a new Client2ProxyAckMoblieLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {IClient2ProxyAckMoblieLogin=} [properties] Properties to set
     * @returns {Client2ProxyAckMoblieLogin} Client2ProxyAckMoblieLogin instance
     */
    Client2ProxyAckMoblieLogin.create = function create(properties) {
        return new Client2ProxyAckMoblieLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMoblieLogin message. Does not implicitly {@link Client2ProxyAckMoblieLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {IClient2ProxyAckMoblieLogin} message Client2ProxyAckMoblieLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMoblieLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.modileNum != null && Object.hasOwnProperty.call(message, "modileNum"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.modileNum);
        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Token);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.GameID);
        if (message.FirstTime != null && Object.hasOwnProperty.call(message, "FirstTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.FirstTime);
        if (message.SendMoney != null && Object.hasOwnProperty.call(message, "SendMoney"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.SendMoney);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMoblieLogin message, length delimited. Does not implicitly {@link Client2ProxyAckMoblieLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {IClient2ProxyAckMoblieLogin} message Client2ProxyAckMoblieLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMoblieLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMoblieLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMoblieLogin} Client2ProxyAckMoblieLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMoblieLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMoblieLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.modileNum = reader.string();
                    break;
                }
            case 3: {
                    message.Token = reader.string();
                    break;
                }
            case 4: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 5: {
                    message.FirstTime = reader.bool();
                    break;
                }
            case 6: {
                    message.SendMoney = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMoblieLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMoblieLogin} Client2ProxyAckMoblieLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMoblieLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMoblieLogin message.
     * @function verify
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMoblieLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            if (!$util.isString(message.modileNum))
                return "modileNum: string expected";
        if (message.Token != null && message.hasOwnProperty("Token"))
            if (!$util.isString(message.Token))
                return "Token: string expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            if (typeof message.FirstTime !== "boolean")
                return "FirstTime: boolean expected";
        if (message.SendMoney != null && message.hasOwnProperty("SendMoney"))
            if (typeof message.SendMoney !== "boolean")
                return "SendMoney: boolean expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMoblieLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMoblieLogin} Client2ProxyAckMoblieLogin
     */
    Client2ProxyAckMoblieLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMoblieLogin)
            return object;
        let message = new $root.Client2ProxyAckMoblieLogin();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.modileNum != null)
            message.modileNum = String(object.modileNum);
        if (object.Token != null)
            message.Token = String(object.Token);
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.FirstTime != null)
            message.FirstTime = Boolean(object.FirstTime);
        if (object.SendMoney != null)
            message.SendMoney = Boolean(object.SendMoney);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMoblieLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {Client2ProxyAckMoblieLogin} message Client2ProxyAckMoblieLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMoblieLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.modileNum = "";
            object.Token = "";
            object.GameID = 0;
            object.FirstTime = false;
            object.SendMoney = false;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            object.modileNum = message.modileNum;
        if (message.Token != null && message.hasOwnProperty("Token"))
            object.Token = message.Token;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            object.FirstTime = message.FirstTime;
        if (message.SendMoney != null && message.hasOwnProperty("SendMoney"))
            object.SendMoney = message.SendMoney;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMoblieLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMoblieLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMoblieLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMoblieLogin
     * @function getTypeUrl
     * @memberof Client2ProxyAckMoblieLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMoblieLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMoblieLogin";
    };

    return Client2ProxyAckMoblieLogin;
})();

export const Client2ProxyReqTokenLogin = $root.Client2ProxyReqTokenLogin = (() => {

    /**
     * Properties of a Client2ProxyReqTokenLogin.
     * @exports IClient2ProxyReqTokenLogin
     * @interface IClient2ProxyReqTokenLogin
     * @property {string|null} [Token] Client2ProxyReqTokenLogin Token
     * @property {string|null} [CheckLogin] Client2ProxyReqTokenLogin CheckLogin
     * @property {string|null} [ClientMark] Client2ProxyReqTokenLogin ClientMark
     * @property {boolean|null} [FirstTime] Client2ProxyReqTokenLogin FirstTime
     * @property {number|null} [Channel] Client2ProxyReqTokenLogin Channel
     */

    /**
     * Constructs a new Client2ProxyReqTokenLogin.
     * @exports Client2ProxyReqTokenLogin
     * @classdesc Represents a Client2ProxyReqTokenLogin.
     * @implements IClient2ProxyReqTokenLogin
     * @constructor
     * @param {IClient2ProxyReqTokenLogin=} [properties] Properties to set
     */
    function Client2ProxyReqTokenLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqTokenLogin Token.
     * @member {string} Token
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     */
    Client2ProxyReqTokenLogin.prototype.Token = "";

    /**
     * Client2ProxyReqTokenLogin CheckLogin.
     * @member {string} CheckLogin
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     */
    Client2ProxyReqTokenLogin.prototype.CheckLogin = "";

    /**
     * Client2ProxyReqTokenLogin ClientMark.
     * @member {string} ClientMark
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     */
    Client2ProxyReqTokenLogin.prototype.ClientMark = "";

    /**
     * Client2ProxyReqTokenLogin FirstTime.
     * @member {boolean} FirstTime
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     */
    Client2ProxyReqTokenLogin.prototype.FirstTime = false;

    /**
     * Client2ProxyReqTokenLogin Channel.
     * @member {number} Channel
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     */
    Client2ProxyReqTokenLogin.prototype.Channel = 0;

    /**
     * Creates a new Client2ProxyReqTokenLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {IClient2ProxyReqTokenLogin=} [properties] Properties to set
     * @returns {Client2ProxyReqTokenLogin} Client2ProxyReqTokenLogin instance
     */
    Client2ProxyReqTokenLogin.create = function create(properties) {
        return new Client2ProxyReqTokenLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqTokenLogin message. Does not implicitly {@link Client2ProxyReqTokenLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {IClient2ProxyReqTokenLogin} message Client2ProxyReqTokenLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqTokenLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Token);
        if (message.CheckLogin != null && Object.hasOwnProperty.call(message, "CheckLogin"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.CheckLogin);
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ClientMark);
        if (message.FirstTime != null && Object.hasOwnProperty.call(message, "FirstTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.FirstTime);
        if (message.Channel != null && Object.hasOwnProperty.call(message, "Channel"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Channel);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqTokenLogin message, length delimited. Does not implicitly {@link Client2ProxyReqTokenLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {IClient2ProxyReqTokenLogin} message Client2ProxyReqTokenLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqTokenLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqTokenLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqTokenLogin} Client2ProxyReqTokenLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqTokenLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqTokenLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Token = reader.string();
                    break;
                }
            case 2: {
                    message.CheckLogin = reader.string();
                    break;
                }
            case 3: {
                    message.ClientMark = reader.string();
                    break;
                }
            case 4: {
                    message.FirstTime = reader.bool();
                    break;
                }
            case 5: {
                    message.Channel = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqTokenLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqTokenLogin} Client2ProxyReqTokenLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqTokenLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqTokenLogin message.
     * @function verify
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqTokenLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Token != null && message.hasOwnProperty("Token"))
            if (!$util.isString(message.Token))
                return "Token: string expected";
        if (message.CheckLogin != null && message.hasOwnProperty("CheckLogin"))
            if (!$util.isString(message.CheckLogin))
                return "CheckLogin: string expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            if (typeof message.FirstTime !== "boolean")
                return "FirstTime: boolean expected";
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            if (!$util.isInteger(message.Channel))
                return "Channel: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqTokenLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqTokenLogin} Client2ProxyReqTokenLogin
     */
    Client2ProxyReqTokenLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqTokenLogin)
            return object;
        let message = new $root.Client2ProxyReqTokenLogin();
        if (object.Token != null)
            message.Token = String(object.Token);
        if (object.CheckLogin != null)
            message.CheckLogin = String(object.CheckLogin);
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        if (object.FirstTime != null)
            message.FirstTime = Boolean(object.FirstTime);
        if (object.Channel != null)
            message.Channel = object.Channel >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqTokenLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {Client2ProxyReqTokenLogin} message Client2ProxyReqTokenLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqTokenLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Token = "";
            object.CheckLogin = "";
            object.ClientMark = "";
            object.FirstTime = false;
            object.Channel = 0;
        }
        if (message.Token != null && message.hasOwnProperty("Token"))
            object.Token = message.Token;
        if (message.CheckLogin != null && message.hasOwnProperty("CheckLogin"))
            object.CheckLogin = message.CheckLogin;
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        if (message.FirstTime != null && message.hasOwnProperty("FirstTime"))
            object.FirstTime = message.FirstTime;
        if (message.Channel != null && message.hasOwnProperty("Channel"))
            object.Channel = message.Channel;
        return object;
    };

    /**
     * Converts this Client2ProxyReqTokenLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqTokenLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqTokenLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqTokenLogin
     * @function getTypeUrl
     * @memberof Client2ProxyReqTokenLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqTokenLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqTokenLogin";
    };

    return Client2ProxyReqTokenLogin;
})();

export const Client2ProxyAckTokenLogin = $root.Client2ProxyAckTokenLogin = (() => {

    /**
     * Properties of a Client2ProxyAckTokenLogin.
     * @exports IClient2ProxyAckTokenLogin
     * @interface IClient2ProxyAckTokenLogin
     * @property {number|null} [Ret] Client2ProxyAckTokenLogin Ret
     * @property {IUserInfo|null} [userInfo] Client2ProxyAckTokenLogin userInfo
     * @property {number|null} [GameID] Client2ProxyAckTokenLogin GameID
     * @property {string|null} [RegAccount] Client2ProxyAckTokenLogin RegAccount
     * @property {string|null} [modileNum] Client2ProxyAckTokenLogin modileNum
     */

    /**
     * Constructs a new Client2ProxyAckTokenLogin.
     * @exports Client2ProxyAckTokenLogin
     * @classdesc Represents a Client2ProxyAckTokenLogin.
     * @implements IClient2ProxyAckTokenLogin
     * @constructor
     * @param {IClient2ProxyAckTokenLogin=} [properties] Properties to set
     */
    function Client2ProxyAckTokenLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckTokenLogin Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     */
    Client2ProxyAckTokenLogin.prototype.Ret = 0;

    /**
     * Client2ProxyAckTokenLogin userInfo.
     * @member {IUserInfo|null|undefined} userInfo
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     */
    Client2ProxyAckTokenLogin.prototype.userInfo = null;

    /**
     * Client2ProxyAckTokenLogin GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     */
    Client2ProxyAckTokenLogin.prototype.GameID = 0;

    /**
     * Client2ProxyAckTokenLogin RegAccount.
     * @member {string} RegAccount
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     */
    Client2ProxyAckTokenLogin.prototype.RegAccount = "";

    /**
     * Client2ProxyAckTokenLogin modileNum.
     * @member {string} modileNum
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     */
    Client2ProxyAckTokenLogin.prototype.modileNum = "";

    /**
     * Creates a new Client2ProxyAckTokenLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {IClient2ProxyAckTokenLogin=} [properties] Properties to set
     * @returns {Client2ProxyAckTokenLogin} Client2ProxyAckTokenLogin instance
     */
    Client2ProxyAckTokenLogin.create = function create(properties) {
        return new Client2ProxyAckTokenLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckTokenLogin message. Does not implicitly {@link Client2ProxyAckTokenLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {IClient2ProxyAckTokenLogin} message Client2ProxyAckTokenLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTokenLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
            $root.UserInfo.encode(message.userInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.RegAccount != null && Object.hasOwnProperty.call(message, "RegAccount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.RegAccount);
        if (message.modileNum != null && Object.hasOwnProperty.call(message, "modileNum"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.modileNum);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckTokenLogin message, length delimited. Does not implicitly {@link Client2ProxyAckTokenLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {IClient2ProxyAckTokenLogin} message Client2ProxyAckTokenLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTokenLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckTokenLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckTokenLogin} Client2ProxyAckTokenLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTokenLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckTokenLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.userInfo = $root.UserInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.RegAccount = reader.string();
                    break;
                }
            case 5: {
                    message.modileNum = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckTokenLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckTokenLogin} Client2ProxyAckTokenLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTokenLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckTokenLogin message.
     * @function verify
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckTokenLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
            let error = $root.UserInfo.verify(message.userInfo);
            if (error)
                return "userInfo." + error;
        }
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            if (!$util.isString(message.RegAccount))
                return "RegAccount: string expected";
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            if (!$util.isString(message.modileNum))
                return "modileNum: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckTokenLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckTokenLogin} Client2ProxyAckTokenLogin
     */
    Client2ProxyAckTokenLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckTokenLogin)
            return object;
        let message = new $root.Client2ProxyAckTokenLogin();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.userInfo != null) {
            if (typeof object.userInfo !== "object")
                throw TypeError(".Client2ProxyAckTokenLogin.userInfo: object expected");
            message.userInfo = $root.UserInfo.fromObject(object.userInfo);
        }
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.RegAccount != null)
            message.RegAccount = String(object.RegAccount);
        if (object.modileNum != null)
            message.modileNum = String(object.modileNum);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckTokenLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {Client2ProxyAckTokenLogin} message Client2ProxyAckTokenLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckTokenLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.userInfo = null;
            object.GameID = 0;
            object.RegAccount = "";
            object.modileNum = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.userInfo != null && message.hasOwnProperty("userInfo"))
            object.userInfo = $root.UserInfo.toObject(message.userInfo, options);
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.RegAccount != null && message.hasOwnProperty("RegAccount"))
            object.RegAccount = message.RegAccount;
        if (message.modileNum != null && message.hasOwnProperty("modileNum"))
            object.modileNum = message.modileNum;
        return object;
    };

    /**
     * Converts this Client2ProxyAckTokenLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckTokenLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckTokenLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckTokenLogin
     * @function getTypeUrl
     * @memberof Client2ProxyAckTokenLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckTokenLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckTokenLogin";
    };

    return Client2ProxyAckTokenLogin;
})();

export const Client2ProxyPushSysMain = $root.Client2ProxyPushSysMain = (() => {

    /**
     * Properties of a Client2ProxyPushSysMain.
     * @exports IClient2ProxyPushSysMain
     * @interface IClient2ProxyPushSysMain
     * @property {number|null} [UserID] Client2ProxyPushSysMain UserID
     * @property {Uint8Array|null} [SysMainMsg] Client2ProxyPushSysMain SysMainMsg
     * @property {string|null} [MainBeginTime] Client2ProxyPushSysMain MainBeginTime
     * @property {string|null} [MainEndTime] Client2ProxyPushSysMain MainEndTime
     */

    /**
     * Constructs a new Client2ProxyPushSysMain.
     * @exports Client2ProxyPushSysMain
     * @classdesc Represents a Client2ProxyPushSysMain.
     * @implements IClient2ProxyPushSysMain
     * @constructor
     * @param {IClient2ProxyPushSysMain=} [properties] Properties to set
     */
    function Client2ProxyPushSysMain(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushSysMain UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushSysMain
     * @instance
     */
    Client2ProxyPushSysMain.prototype.UserID = 0;

    /**
     * Client2ProxyPushSysMain SysMainMsg.
     * @member {Uint8Array} SysMainMsg
     * @memberof Client2ProxyPushSysMain
     * @instance
     */
    Client2ProxyPushSysMain.prototype.SysMainMsg = $util.newBuffer([]);

    /**
     * Client2ProxyPushSysMain MainBeginTime.
     * @member {string} MainBeginTime
     * @memberof Client2ProxyPushSysMain
     * @instance
     */
    Client2ProxyPushSysMain.prototype.MainBeginTime = "";

    /**
     * Client2ProxyPushSysMain MainEndTime.
     * @member {string} MainEndTime
     * @memberof Client2ProxyPushSysMain
     * @instance
     */
    Client2ProxyPushSysMain.prototype.MainEndTime = "";

    /**
     * Creates a new Client2ProxyPushSysMain instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {IClient2ProxyPushSysMain=} [properties] Properties to set
     * @returns {Client2ProxyPushSysMain} Client2ProxyPushSysMain instance
     */
    Client2ProxyPushSysMain.create = function create(properties) {
        return new Client2ProxyPushSysMain(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushSysMain message. Does not implicitly {@link Client2ProxyPushSysMain.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {IClient2ProxyPushSysMain} message Client2ProxyPushSysMain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSysMain.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.SysMainMsg != null && Object.hasOwnProperty.call(message, "SysMainMsg"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.SysMainMsg);
        if (message.MainBeginTime != null && Object.hasOwnProperty.call(message, "MainBeginTime"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.MainBeginTime);
        if (message.MainEndTime != null && Object.hasOwnProperty.call(message, "MainEndTime"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.MainEndTime);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushSysMain message, length delimited. Does not implicitly {@link Client2ProxyPushSysMain.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {IClient2ProxyPushSysMain} message Client2ProxyPushSysMain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSysMain.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushSysMain message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushSysMain} Client2ProxyPushSysMain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSysMain.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushSysMain();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SysMainMsg = reader.bytes();
                    break;
                }
            case 3: {
                    message.MainBeginTime = reader.string();
                    break;
                }
            case 4: {
                    message.MainEndTime = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushSysMain message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushSysMain} Client2ProxyPushSysMain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSysMain.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushSysMain message.
     * @function verify
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushSysMain.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SysMainMsg != null && message.hasOwnProperty("SysMainMsg"))
            if (!(message.SysMainMsg && typeof message.SysMainMsg.length === "number" || $util.isString(message.SysMainMsg)))
                return "SysMainMsg: buffer expected";
        if (message.MainBeginTime != null && message.hasOwnProperty("MainBeginTime"))
            if (!$util.isString(message.MainBeginTime))
                return "MainBeginTime: string expected";
        if (message.MainEndTime != null && message.hasOwnProperty("MainEndTime"))
            if (!$util.isString(message.MainEndTime))
                return "MainEndTime: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushSysMain message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushSysMain} Client2ProxyPushSysMain
     */
    Client2ProxyPushSysMain.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushSysMain)
            return object;
        let message = new $root.Client2ProxyPushSysMain();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SysMainMsg != null)
            if (typeof object.SysMainMsg === "string")
                $util.base64.decode(object.SysMainMsg, message.SysMainMsg = $util.newBuffer($util.base64.length(object.SysMainMsg)), 0);
            else if (object.SysMainMsg.length >= 0)
                message.SysMainMsg = object.SysMainMsg;
        if (object.MainBeginTime != null)
            message.MainBeginTime = String(object.MainBeginTime);
        if (object.MainEndTime != null)
            message.MainEndTime = String(object.MainEndTime);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushSysMain message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {Client2ProxyPushSysMain} message Client2ProxyPushSysMain
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushSysMain.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.SysMainMsg = "";
            else {
                object.SysMainMsg = [];
                if (options.bytes !== Array)
                    object.SysMainMsg = $util.newBuffer(object.SysMainMsg);
            }
            object.MainBeginTime = "";
            object.MainEndTime = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SysMainMsg != null && message.hasOwnProperty("SysMainMsg"))
            object.SysMainMsg = options.bytes === String ? $util.base64.encode(message.SysMainMsg, 0, message.SysMainMsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.SysMainMsg) : message.SysMainMsg;
        if (message.MainBeginTime != null && message.hasOwnProperty("MainBeginTime"))
            object.MainBeginTime = message.MainBeginTime;
        if (message.MainEndTime != null && message.hasOwnProperty("MainEndTime"))
            object.MainEndTime = message.MainEndTime;
        return object;
    };

    /**
     * Converts this Client2ProxyPushSysMain to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushSysMain
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushSysMain.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushSysMain
     * @function getTypeUrl
     * @memberof Client2ProxyPushSysMain
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushSysMain.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushSysMain";
    };

    return Client2ProxyPushSysMain;
})();

export const Client2ProxyReqRebateRecord = $root.Client2ProxyReqRebateRecord = (() => {

    /**
     * Properties of a Client2ProxyReqRebateRecord.
     * @exports IClient2ProxyReqRebateRecord
     * @interface IClient2ProxyReqRebateRecord
     * @property {number|null} [AgentID] Client2ProxyReqRebateRecord AgentID
     * @property {number|null} [QueryType] Client2ProxyReqRebateRecord QueryType
     * @property {string|null} [ExtField] Client2ProxyReqRebateRecord ExtField
     */

    /**
     * Constructs a new Client2ProxyReqRebateRecord.
     * @exports Client2ProxyReqRebateRecord
     * @classdesc Represents a Client2ProxyReqRebateRecord.
     * @implements IClient2ProxyReqRebateRecord
     * @constructor
     * @param {IClient2ProxyReqRebateRecord=} [properties] Properties to set
     */
    function Client2ProxyReqRebateRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqRebateRecord AgentID.
     * @member {number} AgentID
     * @memberof Client2ProxyReqRebateRecord
     * @instance
     */
    Client2ProxyReqRebateRecord.prototype.AgentID = 0;

    /**
     * Client2ProxyReqRebateRecord QueryType.
     * @member {number} QueryType
     * @memberof Client2ProxyReqRebateRecord
     * @instance
     */
    Client2ProxyReqRebateRecord.prototype.QueryType = 0;

    /**
     * Client2ProxyReqRebateRecord ExtField.
     * @member {string} ExtField
     * @memberof Client2ProxyReqRebateRecord
     * @instance
     */
    Client2ProxyReqRebateRecord.prototype.ExtField = "";

    /**
     * Creates a new Client2ProxyReqRebateRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {IClient2ProxyReqRebateRecord=} [properties] Properties to set
     * @returns {Client2ProxyReqRebateRecord} Client2ProxyReqRebateRecord instance
     */
    Client2ProxyReqRebateRecord.create = function create(properties) {
        return new Client2ProxyReqRebateRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqRebateRecord message. Does not implicitly {@link Client2ProxyReqRebateRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {IClient2ProxyReqRebateRecord} message Client2ProxyReqRebateRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRebateRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.AgentID != null && Object.hasOwnProperty.call(message, "AgentID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.AgentID);
        if (message.QueryType != null && Object.hasOwnProperty.call(message, "QueryType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.QueryType);
        if (message.ExtField != null && Object.hasOwnProperty.call(message, "ExtField"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ExtField);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqRebateRecord message, length delimited. Does not implicitly {@link Client2ProxyReqRebateRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {IClient2ProxyReqRebateRecord} message Client2ProxyReqRebateRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRebateRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqRebateRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqRebateRecord} Client2ProxyReqRebateRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRebateRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqRebateRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.AgentID = reader.uint32();
                    break;
                }
            case 2: {
                    message.QueryType = reader.uint32();
                    break;
                }
            case 3: {
                    message.ExtField = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqRebateRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqRebateRecord} Client2ProxyReqRebateRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRebateRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqRebateRecord message.
     * @function verify
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqRebateRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            if (!$util.isInteger(message.AgentID))
                return "AgentID: integer expected";
        if (message.QueryType != null && message.hasOwnProperty("QueryType"))
            if (!$util.isInteger(message.QueryType))
                return "QueryType: integer expected";
        if (message.ExtField != null && message.hasOwnProperty("ExtField"))
            if (!$util.isString(message.ExtField))
                return "ExtField: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqRebateRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqRebateRecord} Client2ProxyReqRebateRecord
     */
    Client2ProxyReqRebateRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqRebateRecord)
            return object;
        let message = new $root.Client2ProxyReqRebateRecord();
        if (object.AgentID != null)
            message.AgentID = object.AgentID >>> 0;
        if (object.QueryType != null)
            message.QueryType = object.QueryType >>> 0;
        if (object.ExtField != null)
            message.ExtField = String(object.ExtField);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqRebateRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {Client2ProxyReqRebateRecord} message Client2ProxyReqRebateRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqRebateRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.AgentID = 0;
            object.QueryType = 0;
            object.ExtField = "";
        }
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            object.AgentID = message.AgentID;
        if (message.QueryType != null && message.hasOwnProperty("QueryType"))
            object.QueryType = message.QueryType;
        if (message.ExtField != null && message.hasOwnProperty("ExtField"))
            object.ExtField = message.ExtField;
        return object;
    };

    /**
     * Converts this Client2ProxyReqRebateRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqRebateRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqRebateRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqRebateRecord
     * @function getTypeUrl
     * @memberof Client2ProxyReqRebateRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqRebateRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqRebateRecord";
    };

    return Client2ProxyReqRebateRecord;
})();

export const Client2ProxyAckRebateRecord = $root.Client2ProxyAckRebateRecord = (() => {

    /**
     * Properties of a Client2ProxyAckRebateRecord.
     * @exports IClient2ProxyAckRebateRecord
     * @interface IClient2ProxyAckRebateRecord
     * @property {number|null} [Ret] Client2ProxyAckRebateRecord Ret
     * @property {number|null} [HasNext] Client2ProxyAckRebateRecord HasNext
     * @property {number|null} [Fragment] Client2ProxyAckRebateRecord Fragment
     * @property {number|null} [AgentID] Client2ProxyAckRebateRecord AgentID
     * @property {number|Long|null} [DayBeginTime] Client2ProxyAckRebateRecord DayBeginTime
     * @property {Array.<Uint8Array>|null} [Records] Client2ProxyAckRebateRecord Records
     * @property {number|null} [TotalInvited] Client2ProxyAckRebateRecord TotalInvited
     */

    /**
     * Constructs a new Client2ProxyAckRebateRecord.
     * @exports Client2ProxyAckRebateRecord
     * @classdesc Represents a Client2ProxyAckRebateRecord.
     * @implements IClient2ProxyAckRebateRecord
     * @constructor
     * @param {IClient2ProxyAckRebateRecord=} [properties] Properties to set
     */
    function Client2ProxyAckRebateRecord(properties) {
        this.Records = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckRebateRecord Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.Ret = 0;

    /**
     * Client2ProxyAckRebateRecord HasNext.
     * @member {number} HasNext
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.HasNext = 0;

    /**
     * Client2ProxyAckRebateRecord Fragment.
     * @member {number} Fragment
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.Fragment = 0;

    /**
     * Client2ProxyAckRebateRecord AgentID.
     * @member {number} AgentID
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.AgentID = 0;

    /**
     * Client2ProxyAckRebateRecord DayBeginTime.
     * @member {number|Long} DayBeginTime
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.DayBeginTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ProxyAckRebateRecord Records.
     * @member {Array.<Uint8Array>} Records
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.Records = $util.emptyArray;

    /**
     * Client2ProxyAckRebateRecord TotalInvited.
     * @member {number} TotalInvited
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     */
    Client2ProxyAckRebateRecord.prototype.TotalInvited = 0;

    /**
     * Creates a new Client2ProxyAckRebateRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {IClient2ProxyAckRebateRecord=} [properties] Properties to set
     * @returns {Client2ProxyAckRebateRecord} Client2ProxyAckRebateRecord instance
     */
    Client2ProxyAckRebateRecord.create = function create(properties) {
        return new Client2ProxyAckRebateRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckRebateRecord message. Does not implicitly {@link Client2ProxyAckRebateRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {IClient2ProxyAckRebateRecord} message Client2ProxyAckRebateRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRebateRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.HasNext != null && Object.hasOwnProperty.call(message, "HasNext"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.HasNext);
        if (message.Fragment != null && Object.hasOwnProperty.call(message, "Fragment"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Fragment);
        if (message.AgentID != null && Object.hasOwnProperty.call(message, "AgentID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.AgentID);
        if (message.DayBeginTime != null && Object.hasOwnProperty.call(message, "DayBeginTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.DayBeginTime);
        if (message.Records != null && message.Records.length)
            for (let i = 0; i < message.Records.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.Records[i]);
        if (message.TotalInvited != null && Object.hasOwnProperty.call(message, "TotalInvited"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.TotalInvited);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckRebateRecord message, length delimited. Does not implicitly {@link Client2ProxyAckRebateRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {IClient2ProxyAckRebateRecord} message Client2ProxyAckRebateRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRebateRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckRebateRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckRebateRecord} Client2ProxyAckRebateRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRebateRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckRebateRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.HasNext = reader.uint32();
                    break;
                }
            case 3: {
                    message.Fragment = reader.uint32();
                    break;
                }
            case 4: {
                    message.AgentID = reader.uint32();
                    break;
                }
            case 5: {
                    message.DayBeginTime = reader.uint64();
                    break;
                }
            case 6: {
                    if (!(message.Records && message.Records.length))
                        message.Records = [];
                    message.Records.push(reader.bytes());
                    break;
                }
            case 7: {
                    message.TotalInvited = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckRebateRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckRebateRecord} Client2ProxyAckRebateRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRebateRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckRebateRecord message.
     * @function verify
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckRebateRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.HasNext != null && message.hasOwnProperty("HasNext"))
            if (!$util.isInteger(message.HasNext))
                return "HasNext: integer expected";
        if (message.Fragment != null && message.hasOwnProperty("Fragment"))
            if (!$util.isInteger(message.Fragment))
                return "Fragment: integer expected";
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            if (!$util.isInteger(message.AgentID))
                return "AgentID: integer expected";
        if (message.DayBeginTime != null && message.hasOwnProperty("DayBeginTime"))
            if (!$util.isInteger(message.DayBeginTime) && !(message.DayBeginTime && $util.isInteger(message.DayBeginTime.low) && $util.isInteger(message.DayBeginTime.high)))
                return "DayBeginTime: integer|Long expected";
        if (message.Records != null && message.hasOwnProperty("Records")) {
            if (!Array.isArray(message.Records))
                return "Records: array expected";
            for (let i = 0; i < message.Records.length; ++i)
                if (!(message.Records[i] && typeof message.Records[i].length === "number" || $util.isString(message.Records[i])))
                    return "Records: buffer[] expected";
        }
        if (message.TotalInvited != null && message.hasOwnProperty("TotalInvited"))
            if (!$util.isInteger(message.TotalInvited))
                return "TotalInvited: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckRebateRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckRebateRecord} Client2ProxyAckRebateRecord
     */
    Client2ProxyAckRebateRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckRebateRecord)
            return object;
        let message = new $root.Client2ProxyAckRebateRecord();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.HasNext != null)
            message.HasNext = object.HasNext >>> 0;
        if (object.Fragment != null)
            message.Fragment = object.Fragment >>> 0;
        if (object.AgentID != null)
            message.AgentID = object.AgentID >>> 0;
        if (object.DayBeginTime != null)
            if ($util.Long)
                (message.DayBeginTime = $util.Long.fromValue(object.DayBeginTime)).unsigned = true;
            else if (typeof object.DayBeginTime === "string")
                message.DayBeginTime = parseInt(object.DayBeginTime, 10);
            else if (typeof object.DayBeginTime === "number")
                message.DayBeginTime = object.DayBeginTime;
            else if (typeof object.DayBeginTime === "object")
                message.DayBeginTime = new $util.LongBits(object.DayBeginTime.low >>> 0, object.DayBeginTime.high >>> 0).toNumber(true);
        if (object.Records) {
            if (!Array.isArray(object.Records))
                throw TypeError(".Client2ProxyAckRebateRecord.Records: array expected");
            message.Records = [];
            for (let i = 0; i < object.Records.length; ++i)
                if (typeof object.Records[i] === "string")
                    $util.base64.decode(object.Records[i], message.Records[i] = $util.newBuffer($util.base64.length(object.Records[i])), 0);
                else if (object.Records[i].length >= 0)
                    message.Records[i] = object.Records[i];
        }
        if (object.TotalInvited != null)
            message.TotalInvited = object.TotalInvited >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckRebateRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {Client2ProxyAckRebateRecord} message Client2ProxyAckRebateRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckRebateRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Records = [];
        if (options.defaults) {
            object.Ret = 0;
            object.HasNext = 0;
            object.Fragment = 0;
            object.AgentID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.DayBeginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.DayBeginTime = options.longs === String ? "0" : 0;
            object.TotalInvited = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.HasNext != null && message.hasOwnProperty("HasNext"))
            object.HasNext = message.HasNext;
        if (message.Fragment != null && message.hasOwnProperty("Fragment"))
            object.Fragment = message.Fragment;
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            object.AgentID = message.AgentID;
        if (message.DayBeginTime != null && message.hasOwnProperty("DayBeginTime"))
            if (typeof message.DayBeginTime === "number")
                object.DayBeginTime = options.longs === String ? String(message.DayBeginTime) : message.DayBeginTime;
            else
                object.DayBeginTime = options.longs === String ? $util.Long.prototype.toString.call(message.DayBeginTime) : options.longs === Number ? new $util.LongBits(message.DayBeginTime.low >>> 0, message.DayBeginTime.high >>> 0).toNumber(true) : message.DayBeginTime;
        if (message.Records && message.Records.length) {
            object.Records = [];
            for (let j = 0; j < message.Records.length; ++j)
                object.Records[j] = options.bytes === String ? $util.base64.encode(message.Records[j], 0, message.Records[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.Records[j]) : message.Records[j];
        }
        if (message.TotalInvited != null && message.hasOwnProperty("TotalInvited"))
            object.TotalInvited = message.TotalInvited;
        return object;
    };

    /**
     * Converts this Client2ProxyAckRebateRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckRebateRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckRebateRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckRebateRecord
     * @function getTypeUrl
     * @memberof Client2ProxyAckRebateRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckRebateRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckRebateRecord";
    };

    return Client2ProxyAckRebateRecord;
})();

export const Client2ProxyReqSetAgent = $root.Client2ProxyReqSetAgent = (() => {

    /**
     * Properties of a Client2ProxyReqSetAgent.
     * @exports IClient2ProxyReqSetAgent
     * @interface IClient2ProxyReqSetAgent
     * @property {number|null} [UserID] Client2ProxyReqSetAgent UserID
     * @property {number|null} [AgentID] Client2ProxyReqSetAgent AgentID
     */

    /**
     * Constructs a new Client2ProxyReqSetAgent.
     * @exports Client2ProxyReqSetAgent
     * @classdesc Represents a Client2ProxyReqSetAgent.
     * @implements IClient2ProxyReqSetAgent
     * @constructor
     * @param {IClient2ProxyReqSetAgent=} [properties] Properties to set
     */
    function Client2ProxyReqSetAgent(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqSetAgent UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqSetAgent
     * @instance
     */
    Client2ProxyReqSetAgent.prototype.UserID = 0;

    /**
     * Client2ProxyReqSetAgent AgentID.
     * @member {number} AgentID
     * @memberof Client2ProxyReqSetAgent
     * @instance
     */
    Client2ProxyReqSetAgent.prototype.AgentID = 0;

    /**
     * Creates a new Client2ProxyReqSetAgent instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {IClient2ProxyReqSetAgent=} [properties] Properties to set
     * @returns {Client2ProxyReqSetAgent} Client2ProxyReqSetAgent instance
     */
    Client2ProxyReqSetAgent.create = function create(properties) {
        return new Client2ProxyReqSetAgent(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqSetAgent message. Does not implicitly {@link Client2ProxyReqSetAgent.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {IClient2ProxyReqSetAgent} message Client2ProxyReqSetAgent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqSetAgent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.AgentID != null && Object.hasOwnProperty.call(message, "AgentID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.AgentID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqSetAgent message, length delimited. Does not implicitly {@link Client2ProxyReqSetAgent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {IClient2ProxyReqSetAgent} message Client2ProxyReqSetAgent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqSetAgent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqSetAgent message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqSetAgent} Client2ProxyReqSetAgent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqSetAgent.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqSetAgent();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.AgentID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqSetAgent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqSetAgent} Client2ProxyReqSetAgent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqSetAgent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqSetAgent message.
     * @function verify
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqSetAgent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            if (!$util.isInteger(message.AgentID))
                return "AgentID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqSetAgent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqSetAgent} Client2ProxyReqSetAgent
     */
    Client2ProxyReqSetAgent.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqSetAgent)
            return object;
        let message = new $root.Client2ProxyReqSetAgent();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.AgentID != null)
            message.AgentID = object.AgentID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqSetAgent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {Client2ProxyReqSetAgent} message Client2ProxyReqSetAgent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqSetAgent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.AgentID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            object.AgentID = message.AgentID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqSetAgent to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqSetAgent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqSetAgent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqSetAgent
     * @function getTypeUrl
     * @memberof Client2ProxyReqSetAgent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqSetAgent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqSetAgent";
    };

    return Client2ProxyReqSetAgent;
})();

export const Client2ProxyAckSetAgent = $root.Client2ProxyAckSetAgent = (() => {

    /**
     * Properties of a Client2ProxyAckSetAgent.
     * @exports IClient2ProxyAckSetAgent
     * @interface IClient2ProxyAckSetAgent
     * @property {number|null} [Ret] Client2ProxyAckSetAgent Ret
     * @property {number|null} [UserID] Client2ProxyAckSetAgent UserID
     * @property {number|null} [AgentID] Client2ProxyAckSetAgent AgentID
     */

    /**
     * Constructs a new Client2ProxyAckSetAgent.
     * @exports Client2ProxyAckSetAgent
     * @classdesc Represents a Client2ProxyAckSetAgent.
     * @implements IClient2ProxyAckSetAgent
     * @constructor
     * @param {IClient2ProxyAckSetAgent=} [properties] Properties to set
     */
    function Client2ProxyAckSetAgent(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckSetAgent Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckSetAgent
     * @instance
     */
    Client2ProxyAckSetAgent.prototype.Ret = 0;

    /**
     * Client2ProxyAckSetAgent UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckSetAgent
     * @instance
     */
    Client2ProxyAckSetAgent.prototype.UserID = 0;

    /**
     * Client2ProxyAckSetAgent AgentID.
     * @member {number} AgentID
     * @memberof Client2ProxyAckSetAgent
     * @instance
     */
    Client2ProxyAckSetAgent.prototype.AgentID = 0;

    /**
     * Creates a new Client2ProxyAckSetAgent instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {IClient2ProxyAckSetAgent=} [properties] Properties to set
     * @returns {Client2ProxyAckSetAgent} Client2ProxyAckSetAgent instance
     */
    Client2ProxyAckSetAgent.create = function create(properties) {
        return new Client2ProxyAckSetAgent(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckSetAgent message. Does not implicitly {@link Client2ProxyAckSetAgent.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {IClient2ProxyAckSetAgent} message Client2ProxyAckSetAgent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckSetAgent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.AgentID != null && Object.hasOwnProperty.call(message, "AgentID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.AgentID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckSetAgent message, length delimited. Does not implicitly {@link Client2ProxyAckSetAgent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {IClient2ProxyAckSetAgent} message Client2ProxyAckSetAgent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckSetAgent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckSetAgent message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckSetAgent} Client2ProxyAckSetAgent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckSetAgent.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckSetAgent();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.AgentID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckSetAgent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckSetAgent} Client2ProxyAckSetAgent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckSetAgent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckSetAgent message.
     * @function verify
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckSetAgent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            if (!$util.isInteger(message.AgentID))
                return "AgentID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckSetAgent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckSetAgent} Client2ProxyAckSetAgent
     */
    Client2ProxyAckSetAgent.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckSetAgent)
            return object;
        let message = new $root.Client2ProxyAckSetAgent();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.AgentID != null)
            message.AgentID = object.AgentID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckSetAgent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {Client2ProxyAckSetAgent} message Client2ProxyAckSetAgent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckSetAgent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.AgentID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            object.AgentID = message.AgentID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckSetAgent to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckSetAgent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckSetAgent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckSetAgent
     * @function getTypeUrl
     * @memberof Client2ProxyAckSetAgent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckSetAgent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckSetAgent";
    };

    return Client2ProxyAckSetAgent;
})();

export const Client2ProxyReqRebateInfo = $root.Client2ProxyReqRebateInfo = (() => {

    /**
     * Properties of a Client2ProxyReqRebateInfo.
     * @exports IClient2ProxyReqRebateInfo
     * @interface IClient2ProxyReqRebateInfo
     * @property {number|null} [UserID] Client2ProxyReqRebateInfo UserID
     */

    /**
     * Constructs a new Client2ProxyReqRebateInfo.
     * @exports Client2ProxyReqRebateInfo
     * @classdesc Represents a Client2ProxyReqRebateInfo.
     * @implements IClient2ProxyReqRebateInfo
     * @constructor
     * @param {IClient2ProxyReqRebateInfo=} [properties] Properties to set
     */
    function Client2ProxyReqRebateInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqRebateInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqRebateInfo
     * @instance
     */
    Client2ProxyReqRebateInfo.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqRebateInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {IClient2ProxyReqRebateInfo=} [properties] Properties to set
     * @returns {Client2ProxyReqRebateInfo} Client2ProxyReqRebateInfo instance
     */
    Client2ProxyReqRebateInfo.create = function create(properties) {
        return new Client2ProxyReqRebateInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqRebateInfo message. Does not implicitly {@link Client2ProxyReqRebateInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {IClient2ProxyReqRebateInfo} message Client2ProxyReqRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRebateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqRebateInfo message, length delimited. Does not implicitly {@link Client2ProxyReqRebateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {IClient2ProxyReqRebateInfo} message Client2ProxyReqRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRebateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqRebateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqRebateInfo} Client2ProxyReqRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRebateInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqRebateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqRebateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqRebateInfo} Client2ProxyReqRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRebateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqRebateInfo message.
     * @function verify
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqRebateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqRebateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqRebateInfo} Client2ProxyReqRebateInfo
     */
    Client2ProxyReqRebateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqRebateInfo)
            return object;
        let message = new $root.Client2ProxyReqRebateInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqRebateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {Client2ProxyReqRebateInfo} message Client2ProxyReqRebateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqRebateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqRebateInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqRebateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqRebateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqRebateInfo
     * @function getTypeUrl
     * @memberof Client2ProxyReqRebateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqRebateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqRebateInfo";
    };

    return Client2ProxyReqRebateInfo;
})();

export const Client2ProxyAckRebateInfo = $root.Client2ProxyAckRebateInfo = (() => {

    /**
     * Properties of a Client2ProxyAckRebateInfo.
     * @exports IClient2ProxyAckRebateInfo
     * @interface IClient2ProxyAckRebateInfo
     * @property {number|null} [Ret] Client2ProxyAckRebateInfo Ret
     * @property {number|null} [UserID] Client2ProxyAckRebateInfo UserID
     * @property {number|null} [AgentID] Client2ProxyAckRebateInfo AgentID
     * @property {string|null} [TotalRebate] Client2ProxyAckRebateInfo TotalRebate
     */

    /**
     * Constructs a new Client2ProxyAckRebateInfo.
     * @exports Client2ProxyAckRebateInfo
     * @classdesc Represents a Client2ProxyAckRebateInfo.
     * @implements IClient2ProxyAckRebateInfo
     * @constructor
     * @param {IClient2ProxyAckRebateInfo=} [properties] Properties to set
     */
    function Client2ProxyAckRebateInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckRebateInfo Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckRebateInfo
     * @instance
     */
    Client2ProxyAckRebateInfo.prototype.Ret = 0;

    /**
     * Client2ProxyAckRebateInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckRebateInfo
     * @instance
     */
    Client2ProxyAckRebateInfo.prototype.UserID = 0;

    /**
     * Client2ProxyAckRebateInfo AgentID.
     * @member {number} AgentID
     * @memberof Client2ProxyAckRebateInfo
     * @instance
     */
    Client2ProxyAckRebateInfo.prototype.AgentID = 0;

    /**
     * Client2ProxyAckRebateInfo TotalRebate.
     * @member {string} TotalRebate
     * @memberof Client2ProxyAckRebateInfo
     * @instance
     */
    Client2ProxyAckRebateInfo.prototype.TotalRebate = "";

    /**
     * Creates a new Client2ProxyAckRebateInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {IClient2ProxyAckRebateInfo=} [properties] Properties to set
     * @returns {Client2ProxyAckRebateInfo} Client2ProxyAckRebateInfo instance
     */
    Client2ProxyAckRebateInfo.create = function create(properties) {
        return new Client2ProxyAckRebateInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckRebateInfo message. Does not implicitly {@link Client2ProxyAckRebateInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {IClient2ProxyAckRebateInfo} message Client2ProxyAckRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRebateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.AgentID != null && Object.hasOwnProperty.call(message, "AgentID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.AgentID);
        if (message.TotalRebate != null && Object.hasOwnProperty.call(message, "TotalRebate"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalRebate);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckRebateInfo message, length delimited. Does not implicitly {@link Client2ProxyAckRebateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {IClient2ProxyAckRebateInfo} message Client2ProxyAckRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRebateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckRebateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckRebateInfo} Client2ProxyAckRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRebateInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckRebateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.AgentID = reader.uint32();
                    break;
                }
            case 4: {
                    message.TotalRebate = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckRebateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckRebateInfo} Client2ProxyAckRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRebateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckRebateInfo message.
     * @function verify
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckRebateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            if (!$util.isInteger(message.AgentID))
                return "AgentID: integer expected";
        if (message.TotalRebate != null && message.hasOwnProperty("TotalRebate"))
            if (!$util.isString(message.TotalRebate))
                return "TotalRebate: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckRebateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckRebateInfo} Client2ProxyAckRebateInfo
     */
    Client2ProxyAckRebateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckRebateInfo)
            return object;
        let message = new $root.Client2ProxyAckRebateInfo();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.AgentID != null)
            message.AgentID = object.AgentID >>> 0;
        if (object.TotalRebate != null)
            message.TotalRebate = String(object.TotalRebate);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckRebateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {Client2ProxyAckRebateInfo} message Client2ProxyAckRebateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckRebateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.AgentID = 0;
            object.TotalRebate = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.AgentID != null && message.hasOwnProperty("AgentID"))
            object.AgentID = message.AgentID;
        if (message.TotalRebate != null && message.hasOwnProperty("TotalRebate"))
            object.TotalRebate = message.TotalRebate;
        return object;
    };

    /**
     * Converts this Client2ProxyAckRebateInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckRebateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckRebateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckRebateInfo
     * @function getTypeUrl
     * @memberof Client2ProxyAckRebateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckRebateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckRebateInfo";
    };

    return Client2ProxyAckRebateInfo;
})();

export const Client2ProxyReqTime = $root.Client2ProxyReqTime = (() => {

    /**
     * Properties of a Client2ProxyReqTime.
     * @exports IClient2ProxyReqTime
     * @interface IClient2ProxyReqTime
     * @property {number|null} [UserID] Client2ProxyReqTime UserID
     */

    /**
     * Constructs a new Client2ProxyReqTime.
     * @exports Client2ProxyReqTime
     * @classdesc Represents a Client2ProxyReqTime.
     * @implements IClient2ProxyReqTime
     * @constructor
     * @param {IClient2ProxyReqTime=} [properties] Properties to set
     */
    function Client2ProxyReqTime(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqTime UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqTime
     * @instance
     */
    Client2ProxyReqTime.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqTime instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqTime
     * @static
     * @param {IClient2ProxyReqTime=} [properties] Properties to set
     * @returns {Client2ProxyReqTime} Client2ProxyReqTime instance
     */
    Client2ProxyReqTime.create = function create(properties) {
        return new Client2ProxyReqTime(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqTime message. Does not implicitly {@link Client2ProxyReqTime.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqTime
     * @static
     * @param {IClient2ProxyReqTime} message Client2ProxyReqTime message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqTime.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqTime message, length delimited. Does not implicitly {@link Client2ProxyReqTime.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqTime
     * @static
     * @param {IClient2ProxyReqTime} message Client2ProxyReqTime message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqTime.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqTime message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqTime
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqTime} Client2ProxyReqTime
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqTime.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqTime();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqTime message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqTime
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqTime} Client2ProxyReqTime
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqTime.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqTime message.
     * @function verify
     * @memberof Client2ProxyReqTime
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqTime.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqTime message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqTime
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqTime} Client2ProxyReqTime
     */
    Client2ProxyReqTime.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqTime)
            return object;
        let message = new $root.Client2ProxyReqTime();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqTime message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqTime
     * @static
     * @param {Client2ProxyReqTime} message Client2ProxyReqTime
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqTime.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqTime to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqTime
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqTime.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqTime
     * @function getTypeUrl
     * @memberof Client2ProxyReqTime
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqTime";
    };

    return Client2ProxyReqTime;
})();

export const Client2ProxyAckTime = $root.Client2ProxyAckTime = (() => {

    /**
     * Properties of a Client2ProxyAckTime.
     * @exports IClient2ProxyAckTime
     * @interface IClient2ProxyAckTime
     * @property {number|null} [Ret] Client2ProxyAckTime Ret
     * @property {number|null} [UserID] Client2ProxyAckTime UserID
     * @property {number|Long|null} [Timestamp] Client2ProxyAckTime Timestamp
     * @property {number|null} [TimeZone] Client2ProxyAckTime TimeZone
     */

    /**
     * Constructs a new Client2ProxyAckTime.
     * @exports Client2ProxyAckTime
     * @classdesc Represents a Client2ProxyAckTime.
     * @implements IClient2ProxyAckTime
     * @constructor
     * @param {IClient2ProxyAckTime=} [properties] Properties to set
     */
    function Client2ProxyAckTime(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckTime Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckTime
     * @instance
     */
    Client2ProxyAckTime.prototype.Ret = 0;

    /**
     * Client2ProxyAckTime UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckTime
     * @instance
     */
    Client2ProxyAckTime.prototype.UserID = 0;

    /**
     * Client2ProxyAckTime Timestamp.
     * @member {number|Long} Timestamp
     * @memberof Client2ProxyAckTime
     * @instance
     */
    Client2ProxyAckTime.prototype.Timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ProxyAckTime TimeZone.
     * @member {number} TimeZone
     * @memberof Client2ProxyAckTime
     * @instance
     */
    Client2ProxyAckTime.prototype.TimeZone = 0;

    /**
     * Creates a new Client2ProxyAckTime instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckTime
     * @static
     * @param {IClient2ProxyAckTime=} [properties] Properties to set
     * @returns {Client2ProxyAckTime} Client2ProxyAckTime instance
     */
    Client2ProxyAckTime.create = function create(properties) {
        return new Client2ProxyAckTime(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckTime message. Does not implicitly {@link Client2ProxyAckTime.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckTime
     * @static
     * @param {IClient2ProxyAckTime} message Client2ProxyAckTime message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTime.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Timestamp != null && Object.hasOwnProperty.call(message, "Timestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.Timestamp);
        if (message.TimeZone != null && Object.hasOwnProperty.call(message, "TimeZone"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.TimeZone);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckTime message, length delimited. Does not implicitly {@link Client2ProxyAckTime.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckTime
     * @static
     * @param {IClient2ProxyAckTime} message Client2ProxyAckTime message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckTime.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckTime message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckTime
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckTime} Client2ProxyAckTime
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTime.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckTime();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Timestamp = reader.uint64();
                    break;
                }
            case 4: {
                    message.TimeZone = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckTime message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckTime
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckTime} Client2ProxyAckTime
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckTime.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckTime message.
     * @function verify
     * @memberof Client2ProxyAckTime
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckTime.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (!$util.isInteger(message.Timestamp) && !(message.Timestamp && $util.isInteger(message.Timestamp.low) && $util.isInteger(message.Timestamp.high)))
                return "Timestamp: integer|Long expected";
        if (message.TimeZone != null && message.hasOwnProperty("TimeZone"))
            if (!$util.isInteger(message.TimeZone))
                return "TimeZone: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckTime message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckTime
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckTime} Client2ProxyAckTime
     */
    Client2ProxyAckTime.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckTime)
            return object;
        let message = new $root.Client2ProxyAckTime();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Timestamp != null)
            if ($util.Long)
                (message.Timestamp = $util.Long.fromValue(object.Timestamp)).unsigned = true;
            else if (typeof object.Timestamp === "string")
                message.Timestamp = parseInt(object.Timestamp, 10);
            else if (typeof object.Timestamp === "number")
                message.Timestamp = object.Timestamp;
            else if (typeof object.Timestamp === "object")
                message.Timestamp = new $util.LongBits(object.Timestamp.low >>> 0, object.Timestamp.high >>> 0).toNumber(true);
        if (object.TimeZone != null)
            message.TimeZone = object.TimeZone | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckTime message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckTime
     * @static
     * @param {Client2ProxyAckTime} message Client2ProxyAckTime
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckTime.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Timestamp = options.longs === String ? "0" : 0;
            object.TimeZone = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (typeof message.Timestamp === "number")
                object.Timestamp = options.longs === String ? String(message.Timestamp) : message.Timestamp;
            else
                object.Timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.Timestamp) : options.longs === Number ? new $util.LongBits(message.Timestamp.low >>> 0, message.Timestamp.high >>> 0).toNumber(true) : message.Timestamp;
        if (message.TimeZone != null && message.hasOwnProperty("TimeZone"))
            object.TimeZone = message.TimeZone;
        return object;
    };

    /**
     * Converts this Client2ProxyAckTime to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckTime
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckTime.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckTime
     * @function getTypeUrl
     * @memberof Client2ProxyAckTime
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckTime";
    };

    return Client2ProxyAckTime;
})();

export const Client2ProxyPushSimulator = $root.Client2ProxyPushSimulator = (() => {

    /**
     * Properties of a Client2ProxyPushSimulator.
     * @exports IClient2ProxyPushSimulator
     * @interface IClient2ProxyPushSimulator
     * @property {number|null} [UserID] Client2ProxyPushSimulator UserID
     * @property {string|null} [Simulator] Client2ProxyPushSimulator Simulator
     */

    /**
     * Constructs a new Client2ProxyPushSimulator.
     * @exports Client2ProxyPushSimulator
     * @classdesc Represents a Client2ProxyPushSimulator.
     * @implements IClient2ProxyPushSimulator
     * @constructor
     * @param {IClient2ProxyPushSimulator=} [properties] Properties to set
     */
    function Client2ProxyPushSimulator(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushSimulator UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushSimulator
     * @instance
     */
    Client2ProxyPushSimulator.prototype.UserID = 0;

    /**
     * Client2ProxyPushSimulator Simulator.
     * @member {string} Simulator
     * @memberof Client2ProxyPushSimulator
     * @instance
     */
    Client2ProxyPushSimulator.prototype.Simulator = "";

    /**
     * Creates a new Client2ProxyPushSimulator instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {IClient2ProxyPushSimulator=} [properties] Properties to set
     * @returns {Client2ProxyPushSimulator} Client2ProxyPushSimulator instance
     */
    Client2ProxyPushSimulator.create = function create(properties) {
        return new Client2ProxyPushSimulator(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushSimulator message. Does not implicitly {@link Client2ProxyPushSimulator.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {IClient2ProxyPushSimulator} message Client2ProxyPushSimulator message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSimulator.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Simulator != null && Object.hasOwnProperty.call(message, "Simulator"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Simulator);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushSimulator message, length delimited. Does not implicitly {@link Client2ProxyPushSimulator.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {IClient2ProxyPushSimulator} message Client2ProxyPushSimulator message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushSimulator.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushSimulator message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushSimulator} Client2ProxyPushSimulator
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSimulator.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushSimulator();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Simulator = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushSimulator message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushSimulator} Client2ProxyPushSimulator
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushSimulator.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushSimulator message.
     * @function verify
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushSimulator.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Simulator != null && message.hasOwnProperty("Simulator"))
            if (!$util.isString(message.Simulator))
                return "Simulator: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushSimulator message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushSimulator} Client2ProxyPushSimulator
     */
    Client2ProxyPushSimulator.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushSimulator)
            return object;
        let message = new $root.Client2ProxyPushSimulator();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Simulator != null)
            message.Simulator = String(object.Simulator);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushSimulator message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {Client2ProxyPushSimulator} message Client2ProxyPushSimulator
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushSimulator.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Simulator = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Simulator != null && message.hasOwnProperty("Simulator"))
            object.Simulator = message.Simulator;
        return object;
    };

    /**
     * Converts this Client2ProxyPushSimulator to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushSimulator
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushSimulator.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushSimulator
     * @function getTypeUrl
     * @memberof Client2ProxyPushSimulator
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushSimulator.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushSimulator";
    };

    return Client2ProxyPushSimulator;
})();

export const Client2ProxyPushInGame = $root.Client2ProxyPushInGame = (() => {

    /**
     * Properties of a Client2ProxyPushInGame.
     * @exports IClient2ProxyPushInGame
     * @interface IClient2ProxyPushInGame
     * @property {number|null} [UserID] Client2ProxyPushInGame UserID
     * @property {number|null} [GameID] Client2ProxyPushInGame GameID
     * @property {number|null} [ProductID] Client2ProxyPushInGame ProductID
     */

    /**
     * Constructs a new Client2ProxyPushInGame.
     * @exports Client2ProxyPushInGame
     * @classdesc Represents a Client2ProxyPushInGame.
     * @implements IClient2ProxyPushInGame
     * @constructor
     * @param {IClient2ProxyPushInGame=} [properties] Properties to set
     */
    function Client2ProxyPushInGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushInGame UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushInGame
     * @instance
     */
    Client2ProxyPushInGame.prototype.UserID = 0;

    /**
     * Client2ProxyPushInGame GameID.
     * @member {number} GameID
     * @memberof Client2ProxyPushInGame
     * @instance
     */
    Client2ProxyPushInGame.prototype.GameID = 0;

    /**
     * Client2ProxyPushInGame ProductID.
     * @member {number} ProductID
     * @memberof Client2ProxyPushInGame
     * @instance
     */
    Client2ProxyPushInGame.prototype.ProductID = 0;

    /**
     * Creates a new Client2ProxyPushInGame instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {IClient2ProxyPushInGame=} [properties] Properties to set
     * @returns {Client2ProxyPushInGame} Client2ProxyPushInGame instance
     */
    Client2ProxyPushInGame.create = function create(properties) {
        return new Client2ProxyPushInGame(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushInGame message. Does not implicitly {@link Client2ProxyPushInGame.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {IClient2ProxyPushInGame} message Client2ProxyPushInGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushInGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProductID != null && Object.hasOwnProperty.call(message, "ProductID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProductID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushInGame message, length delimited. Does not implicitly {@link Client2ProxyPushInGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {IClient2ProxyPushInGame} message Client2ProxyPushInGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushInGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushInGame message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushInGame} Client2ProxyPushInGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushInGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushInGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProductID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushInGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushInGame} Client2ProxyPushInGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushInGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushInGame message.
     * @function verify
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushInGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            if (!$util.isInteger(message.ProductID))
                return "ProductID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyPushInGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushInGame} Client2ProxyPushInGame
     */
    Client2ProxyPushInGame.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushInGame)
            return object;
        let message = new $root.Client2ProxyPushInGame();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProductID != null)
            message.ProductID = object.ProductID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushInGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {Client2ProxyPushInGame} message Client2ProxyPushInGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushInGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProductID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProductID != null && message.hasOwnProperty("ProductID"))
            object.ProductID = message.ProductID;
        return object;
    };

    /**
     * Converts this Client2ProxyPushInGame to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushInGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushInGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushInGame
     * @function getTypeUrl
     * @memberof Client2ProxyPushInGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushInGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushInGame";
    };

    return Client2ProxyPushInGame;
})();

export const Client2ProxyPushLBSInfo = $root.Client2ProxyPushLBSInfo = (() => {

    /**
     * Properties of a Client2ProxyPushLBSInfo.
     * @exports IClient2ProxyPushLBSInfo
     * @interface IClient2ProxyPushLBSInfo
     * @property {number|null} [UserID] Client2ProxyPushLBSInfo UserID
     * @property {IPlayerLBS|null} [LBS] Client2ProxyPushLBSInfo LBS
     */

    /**
     * Constructs a new Client2ProxyPushLBSInfo.
     * @exports Client2ProxyPushLBSInfo
     * @classdesc Represents a Client2ProxyPushLBSInfo.
     * @implements IClient2ProxyPushLBSInfo
     * @constructor
     * @param {IClient2ProxyPushLBSInfo=} [properties] Properties to set
     */
    function Client2ProxyPushLBSInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushLBSInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushLBSInfo
     * @instance
     */
    Client2ProxyPushLBSInfo.prototype.UserID = 0;

    /**
     * Client2ProxyPushLBSInfo LBS.
     * @member {IPlayerLBS|null|undefined} LBS
     * @memberof Client2ProxyPushLBSInfo
     * @instance
     */
    Client2ProxyPushLBSInfo.prototype.LBS = null;

    /**
     * Creates a new Client2ProxyPushLBSInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {IClient2ProxyPushLBSInfo=} [properties] Properties to set
     * @returns {Client2ProxyPushLBSInfo} Client2ProxyPushLBSInfo instance
     */
    Client2ProxyPushLBSInfo.create = function create(properties) {
        return new Client2ProxyPushLBSInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushLBSInfo message. Does not implicitly {@link Client2ProxyPushLBSInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {IClient2ProxyPushLBSInfo} message Client2ProxyPushLBSInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushLBSInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.LBS != null && Object.hasOwnProperty.call(message, "LBS"))
            $root.PlayerLBS.encode(message.LBS, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushLBSInfo message, length delimited. Does not implicitly {@link Client2ProxyPushLBSInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {IClient2ProxyPushLBSInfo} message Client2ProxyPushLBSInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushLBSInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushLBSInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushLBSInfo} Client2ProxyPushLBSInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushLBSInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushLBSInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.LBS = $root.PlayerLBS.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushLBSInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushLBSInfo} Client2ProxyPushLBSInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushLBSInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushLBSInfo message.
     * @function verify
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushLBSInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.LBS != null && message.hasOwnProperty("LBS")) {
            let error = $root.PlayerLBS.verify(message.LBS);
            if (error)
                return "LBS." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyPushLBSInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushLBSInfo} Client2ProxyPushLBSInfo
     */
    Client2ProxyPushLBSInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushLBSInfo)
            return object;
        let message = new $root.Client2ProxyPushLBSInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.LBS != null) {
            if (typeof object.LBS !== "object")
                throw TypeError(".Client2ProxyPushLBSInfo.LBS: object expected");
            message.LBS = $root.PlayerLBS.fromObject(object.LBS);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushLBSInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {Client2ProxyPushLBSInfo} message Client2ProxyPushLBSInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushLBSInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.LBS = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.LBS != null && message.hasOwnProperty("LBS"))
            object.LBS = $root.PlayerLBS.toObject(message.LBS, options);
        return object;
    };

    /**
     * Converts this Client2ProxyPushLBSInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushLBSInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushLBSInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushLBSInfo
     * @function getTypeUrl
     * @memberof Client2ProxyPushLBSInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushLBSInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushLBSInfo";
    };

    return Client2ProxyPushLBSInfo;
})();

export const Client2ProxyReqStatement = $root.Client2ProxyReqStatement = (() => {

    /**
     * Properties of a Client2ProxyReqStatement.
     * @exports IClient2ProxyReqStatement
     * @interface IClient2ProxyReqStatement
     * @property {number|null} [UserID] Client2ProxyReqStatement UserID
     * @property {number|null} [Index] Client2ProxyReqStatement Index
     */

    /**
     * Constructs a new Client2ProxyReqStatement.
     * @exports Client2ProxyReqStatement
     * @classdesc Represents a Client2ProxyReqStatement.
     * @implements IClient2ProxyReqStatement
     * @constructor
     * @param {IClient2ProxyReqStatement=} [properties] Properties to set
     */
    function Client2ProxyReqStatement(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqStatement UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqStatement
     * @instance
     */
    Client2ProxyReqStatement.prototype.UserID = 0;

    /**
     * Client2ProxyReqStatement Index.
     * @member {number} Index
     * @memberof Client2ProxyReqStatement
     * @instance
     */
    Client2ProxyReqStatement.prototype.Index = 0;

    /**
     * Creates a new Client2ProxyReqStatement instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {IClient2ProxyReqStatement=} [properties] Properties to set
     * @returns {Client2ProxyReqStatement} Client2ProxyReqStatement instance
     */
    Client2ProxyReqStatement.create = function create(properties) {
        return new Client2ProxyReqStatement(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqStatement message. Does not implicitly {@link Client2ProxyReqStatement.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {IClient2ProxyReqStatement} message Client2ProxyReqStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqStatement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Index != null && Object.hasOwnProperty.call(message, "Index"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Index);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqStatement message, length delimited. Does not implicitly {@link Client2ProxyReqStatement.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {IClient2ProxyReqStatement} message Client2ProxyReqStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqStatement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqStatement message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqStatement} Client2ProxyReqStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqStatement.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqStatement();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Index = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqStatement message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqStatement} Client2ProxyReqStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqStatement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqStatement message.
     * @function verify
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqStatement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Index != null && message.hasOwnProperty("Index"))
            if (!$util.isInteger(message.Index))
                return "Index: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqStatement message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqStatement} Client2ProxyReqStatement
     */
    Client2ProxyReqStatement.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqStatement)
            return object;
        let message = new $root.Client2ProxyReqStatement();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Index != null)
            message.Index = object.Index >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqStatement message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {Client2ProxyReqStatement} message Client2ProxyReqStatement
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqStatement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Index = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Index != null && message.hasOwnProperty("Index"))
            object.Index = message.Index;
        return object;
    };

    /**
     * Converts this Client2ProxyReqStatement to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqStatement
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqStatement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqStatement
     * @function getTypeUrl
     * @memberof Client2ProxyReqStatement
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqStatement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqStatement";
    };

    return Client2ProxyReqStatement;
})();

export const Client2ProxyAckStatement = $root.Client2ProxyAckStatement = (() => {

    /**
     * Properties of a Client2ProxyAckStatement.
     * @exports IClient2ProxyAckStatement
     * @interface IClient2ProxyAckStatement
     * @property {number|null} [UserID] Client2ProxyAckStatement UserID
     * @property {number|null} [CurrIndex] Client2ProxyAckStatement CurrIndex
     * @property {number|null} [TotalIndex] Client2ProxyAckStatement TotalIndex
     * @property {Array.<IUserStatement>|null} [StatementList] Client2ProxyAckStatement StatementList
     */

    /**
     * Constructs a new Client2ProxyAckStatement.
     * @exports Client2ProxyAckStatement
     * @classdesc Represents a Client2ProxyAckStatement.
     * @implements IClient2ProxyAckStatement
     * @constructor
     * @param {IClient2ProxyAckStatement=} [properties] Properties to set
     */
    function Client2ProxyAckStatement(properties) {
        this.StatementList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckStatement UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckStatement
     * @instance
     */
    Client2ProxyAckStatement.prototype.UserID = 0;

    /**
     * Client2ProxyAckStatement CurrIndex.
     * @member {number} CurrIndex
     * @memberof Client2ProxyAckStatement
     * @instance
     */
    Client2ProxyAckStatement.prototype.CurrIndex = 0;

    /**
     * Client2ProxyAckStatement TotalIndex.
     * @member {number} TotalIndex
     * @memberof Client2ProxyAckStatement
     * @instance
     */
    Client2ProxyAckStatement.prototype.TotalIndex = 0;

    /**
     * Client2ProxyAckStatement StatementList.
     * @member {Array.<IUserStatement>} StatementList
     * @memberof Client2ProxyAckStatement
     * @instance
     */
    Client2ProxyAckStatement.prototype.StatementList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckStatement instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {IClient2ProxyAckStatement=} [properties] Properties to set
     * @returns {Client2ProxyAckStatement} Client2ProxyAckStatement instance
     */
    Client2ProxyAckStatement.create = function create(properties) {
        return new Client2ProxyAckStatement(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckStatement message. Does not implicitly {@link Client2ProxyAckStatement.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {IClient2ProxyAckStatement} message Client2ProxyAckStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckStatement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CurrIndex != null && Object.hasOwnProperty.call(message, "CurrIndex"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CurrIndex);
        if (message.TotalIndex != null && Object.hasOwnProperty.call(message, "TotalIndex"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.TotalIndex);
        if (message.StatementList != null && message.StatementList.length)
            for (let i = 0; i < message.StatementList.length; ++i)
                $root.UserStatement.encode(message.StatementList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckStatement message, length delimited. Does not implicitly {@link Client2ProxyAckStatement.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {IClient2ProxyAckStatement} message Client2ProxyAckStatement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckStatement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckStatement message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckStatement} Client2ProxyAckStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckStatement.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckStatement();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CurrIndex = reader.uint32();
                    break;
                }
            case 3: {
                    message.TotalIndex = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.StatementList && message.StatementList.length))
                        message.StatementList = [];
                    message.StatementList.push($root.UserStatement.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckStatement message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckStatement} Client2ProxyAckStatement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckStatement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckStatement message.
     * @function verify
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckStatement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CurrIndex != null && message.hasOwnProperty("CurrIndex"))
            if (!$util.isInteger(message.CurrIndex))
                return "CurrIndex: integer expected";
        if (message.TotalIndex != null && message.hasOwnProperty("TotalIndex"))
            if (!$util.isInteger(message.TotalIndex))
                return "TotalIndex: integer expected";
        if (message.StatementList != null && message.hasOwnProperty("StatementList")) {
            if (!Array.isArray(message.StatementList))
                return "StatementList: array expected";
            for (let i = 0; i < message.StatementList.length; ++i) {
                let error = $root.UserStatement.verify(message.StatementList[i]);
                if (error)
                    return "StatementList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckStatement message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckStatement} Client2ProxyAckStatement
     */
    Client2ProxyAckStatement.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckStatement)
            return object;
        let message = new $root.Client2ProxyAckStatement();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CurrIndex != null)
            message.CurrIndex = object.CurrIndex >>> 0;
        if (object.TotalIndex != null)
            message.TotalIndex = object.TotalIndex >>> 0;
        if (object.StatementList) {
            if (!Array.isArray(object.StatementList))
                throw TypeError(".Client2ProxyAckStatement.StatementList: array expected");
            message.StatementList = [];
            for (let i = 0; i < object.StatementList.length; ++i) {
                if (typeof object.StatementList[i] !== "object")
                    throw TypeError(".Client2ProxyAckStatement.StatementList: object expected");
                message.StatementList[i] = $root.UserStatement.fromObject(object.StatementList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckStatement message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {Client2ProxyAckStatement} message Client2ProxyAckStatement
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckStatement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.StatementList = [];
        if (options.defaults) {
            object.UserID = 0;
            object.CurrIndex = 0;
            object.TotalIndex = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CurrIndex != null && message.hasOwnProperty("CurrIndex"))
            object.CurrIndex = message.CurrIndex;
        if (message.TotalIndex != null && message.hasOwnProperty("TotalIndex"))
            object.TotalIndex = message.TotalIndex;
        if (message.StatementList && message.StatementList.length) {
            object.StatementList = [];
            for (let j = 0; j < message.StatementList.length; ++j)
                object.StatementList[j] = $root.UserStatement.toObject(message.StatementList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckStatement to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckStatement
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckStatement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckStatement
     * @function getTypeUrl
     * @memberof Client2ProxyAckStatement
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckStatement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckStatement";
    };

    return Client2ProxyAckStatement;
})();

export const Client2ProxyReqIsPay = $root.Client2ProxyReqIsPay = (() => {

    /**
     * Properties of a Client2ProxyReqIsPay.
     * @exports IClient2ProxyReqIsPay
     * @interface IClient2ProxyReqIsPay
     * @property {number|null} [UserID] Client2ProxyReqIsPay UserID
     */

    /**
     * Constructs a new Client2ProxyReqIsPay.
     * @exports Client2ProxyReqIsPay
     * @classdesc Represents a Client2ProxyReqIsPay.
     * @implements IClient2ProxyReqIsPay
     * @constructor
     * @param {IClient2ProxyReqIsPay=} [properties] Properties to set
     */
    function Client2ProxyReqIsPay(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqIsPay UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqIsPay
     * @instance
     */
    Client2ProxyReqIsPay.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqIsPay instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {IClient2ProxyReqIsPay=} [properties] Properties to set
     * @returns {Client2ProxyReqIsPay} Client2ProxyReqIsPay instance
     */
    Client2ProxyReqIsPay.create = function create(properties) {
        return new Client2ProxyReqIsPay(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqIsPay message. Does not implicitly {@link Client2ProxyReqIsPay.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {IClient2ProxyReqIsPay} message Client2ProxyReqIsPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqIsPay.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqIsPay message, length delimited. Does not implicitly {@link Client2ProxyReqIsPay.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {IClient2ProxyReqIsPay} message Client2ProxyReqIsPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqIsPay.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqIsPay message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqIsPay} Client2ProxyReqIsPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqIsPay.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqIsPay();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqIsPay message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqIsPay} Client2ProxyReqIsPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqIsPay.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqIsPay message.
     * @function verify
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqIsPay.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqIsPay message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqIsPay} Client2ProxyReqIsPay
     */
    Client2ProxyReqIsPay.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqIsPay)
            return object;
        let message = new $root.Client2ProxyReqIsPay();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqIsPay message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {Client2ProxyReqIsPay} message Client2ProxyReqIsPay
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqIsPay.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqIsPay to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqIsPay
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqIsPay.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqIsPay
     * @function getTypeUrl
     * @memberof Client2ProxyReqIsPay
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqIsPay.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqIsPay";
    };

    return Client2ProxyReqIsPay;
})();

export const Client2ProxyAckIsPay = $root.Client2ProxyAckIsPay = (() => {

    /**
     * Properties of a Client2ProxyAckIsPay.
     * @exports IClient2ProxyAckIsPay
     * @interface IClient2ProxyAckIsPay
     * @property {number|null} [UserID] Client2ProxyAckIsPay UserID
     * @property {number|null} [IsPay] Client2ProxyAckIsPay IsPay
     */

    /**
     * Constructs a new Client2ProxyAckIsPay.
     * @exports Client2ProxyAckIsPay
     * @classdesc Represents a Client2ProxyAckIsPay.
     * @implements IClient2ProxyAckIsPay
     * @constructor
     * @param {IClient2ProxyAckIsPay=} [properties] Properties to set
     */
    function Client2ProxyAckIsPay(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckIsPay UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckIsPay
     * @instance
     */
    Client2ProxyAckIsPay.prototype.UserID = 0;

    /**
     * Client2ProxyAckIsPay IsPay.
     * @member {number} IsPay
     * @memberof Client2ProxyAckIsPay
     * @instance
     */
    Client2ProxyAckIsPay.prototype.IsPay = 0;

    /**
     * Creates a new Client2ProxyAckIsPay instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {IClient2ProxyAckIsPay=} [properties] Properties to set
     * @returns {Client2ProxyAckIsPay} Client2ProxyAckIsPay instance
     */
    Client2ProxyAckIsPay.create = function create(properties) {
        return new Client2ProxyAckIsPay(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckIsPay message. Does not implicitly {@link Client2ProxyAckIsPay.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {IClient2ProxyAckIsPay} message Client2ProxyAckIsPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckIsPay.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.IsPay != null && Object.hasOwnProperty.call(message, "IsPay"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.IsPay);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckIsPay message, length delimited. Does not implicitly {@link Client2ProxyAckIsPay.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {IClient2ProxyAckIsPay} message Client2ProxyAckIsPay message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckIsPay.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckIsPay message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckIsPay} Client2ProxyAckIsPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckIsPay.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckIsPay();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.IsPay = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckIsPay message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckIsPay} Client2ProxyAckIsPay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckIsPay.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckIsPay message.
     * @function verify
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckIsPay.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.IsPay != null && message.hasOwnProperty("IsPay"))
            if (!$util.isInteger(message.IsPay))
                return "IsPay: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckIsPay message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckIsPay} Client2ProxyAckIsPay
     */
    Client2ProxyAckIsPay.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckIsPay)
            return object;
        let message = new $root.Client2ProxyAckIsPay();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.IsPay != null)
            message.IsPay = object.IsPay | 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckIsPay message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {Client2ProxyAckIsPay} message Client2ProxyAckIsPay
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckIsPay.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.IsPay = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.IsPay != null && message.hasOwnProperty("IsPay"))
            object.IsPay = message.IsPay;
        return object;
    };

    /**
     * Converts this Client2ProxyAckIsPay to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckIsPay
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckIsPay.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckIsPay
     * @function getTypeUrl
     * @memberof Client2ProxyAckIsPay
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckIsPay.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckIsPay";
    };

    return Client2ProxyAckIsPay;
})();

export const Client2ProxyTransWebMsg = $root.Client2ProxyTransWebMsg = (() => {

    /**
     * Properties of a Client2ProxyTransWebMsg.
     * @exports IClient2ProxyTransWebMsg
     * @interface IClient2ProxyTransWebMsg
     * @property {number|null} [UserID] Client2ProxyTransWebMsg UserID
     * @property {Uint8Array|null} [Content] Client2ProxyTransWebMsg Content
     */

    /**
     * Constructs a new Client2ProxyTransWebMsg.
     * @exports Client2ProxyTransWebMsg
     * @classdesc Represents a Client2ProxyTransWebMsg.
     * @implements IClient2ProxyTransWebMsg
     * @constructor
     * @param {IClient2ProxyTransWebMsg=} [properties] Properties to set
     */
    function Client2ProxyTransWebMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyTransWebMsg UserID.
     * @member {number} UserID
     * @memberof Client2ProxyTransWebMsg
     * @instance
     */
    Client2ProxyTransWebMsg.prototype.UserID = 0;

    /**
     * Client2ProxyTransWebMsg Content.
     * @member {Uint8Array} Content
     * @memberof Client2ProxyTransWebMsg
     * @instance
     */
    Client2ProxyTransWebMsg.prototype.Content = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyTransWebMsg instance using the specified properties.
     * @function create
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {IClient2ProxyTransWebMsg=} [properties] Properties to set
     * @returns {Client2ProxyTransWebMsg} Client2ProxyTransWebMsg instance
     */
    Client2ProxyTransWebMsg.create = function create(properties) {
        return new Client2ProxyTransWebMsg(properties);
    };

    /**
     * Encodes the specified Client2ProxyTransWebMsg message. Does not implicitly {@link Client2ProxyTransWebMsg.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {IClient2ProxyTransWebMsg} message Client2ProxyTransWebMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyTransWebMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Content != null && Object.hasOwnProperty.call(message, "Content"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Content);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyTransWebMsg message, length delimited. Does not implicitly {@link Client2ProxyTransWebMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {IClient2ProxyTransWebMsg} message Client2ProxyTransWebMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyTransWebMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyTransWebMsg message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyTransWebMsg} Client2ProxyTransWebMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyTransWebMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyTransWebMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Content = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyTransWebMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyTransWebMsg} Client2ProxyTransWebMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyTransWebMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyTransWebMsg message.
     * @function verify
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyTransWebMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Content != null && message.hasOwnProperty("Content"))
            if (!(message.Content && typeof message.Content.length === "number" || $util.isString(message.Content)))
                return "Content: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyTransWebMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyTransWebMsg} Client2ProxyTransWebMsg
     */
    Client2ProxyTransWebMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyTransWebMsg)
            return object;
        let message = new $root.Client2ProxyTransWebMsg();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Content != null)
            if (typeof object.Content === "string")
                $util.base64.decode(object.Content, message.Content = $util.newBuffer($util.base64.length(object.Content)), 0);
            else if (object.Content.length >= 0)
                message.Content = object.Content;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyTransWebMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {Client2ProxyTransWebMsg} message Client2ProxyTransWebMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyTransWebMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Content = "";
            else {
                object.Content = [];
                if (options.bytes !== Array)
                    object.Content = $util.newBuffer(object.Content);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Content != null && message.hasOwnProperty("Content"))
            object.Content = options.bytes === String ? $util.base64.encode(message.Content, 0, message.Content.length) : options.bytes === Array ? Array.prototype.slice.call(message.Content) : message.Content;
        return object;
    };

    /**
     * Converts this Client2ProxyTransWebMsg to JSON.
     * @function toJSON
     * @memberof Client2ProxyTransWebMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyTransWebMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyTransWebMsg
     * @function getTypeUrl
     * @memberof Client2ProxyTransWebMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyTransWebMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyTransWebMsg";
    };

    return Client2ProxyTransWebMsg;
})();

export const Client2ProxyReqGetKyc = $root.Client2ProxyReqGetKyc = (() => {

    /**
     * Properties of a Client2ProxyReqGetKyc.
     * @exports IClient2ProxyReqGetKyc
     * @interface IClient2ProxyReqGetKyc
     * @property {number|null} [UserID] Client2ProxyReqGetKyc UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetKyc.
     * @exports Client2ProxyReqGetKyc
     * @classdesc Represents a Client2ProxyReqGetKyc.
     * @implements IClient2ProxyReqGetKyc
     * @constructor
     * @param {IClient2ProxyReqGetKyc=} [properties] Properties to set
     */
    function Client2ProxyReqGetKyc(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetKyc UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetKyc
     * @instance
     */
    Client2ProxyReqGetKyc.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetKyc instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {IClient2ProxyReqGetKyc=} [properties] Properties to set
     * @returns {Client2ProxyReqGetKyc} Client2ProxyReqGetKyc instance
     */
    Client2ProxyReqGetKyc.create = function create(properties) {
        return new Client2ProxyReqGetKyc(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetKyc message. Does not implicitly {@link Client2ProxyReqGetKyc.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {IClient2ProxyReqGetKyc} message Client2ProxyReqGetKyc message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetKyc.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetKyc message, length delimited. Does not implicitly {@link Client2ProxyReqGetKyc.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {IClient2ProxyReqGetKyc} message Client2ProxyReqGetKyc message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetKyc.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetKyc message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetKyc} Client2ProxyReqGetKyc
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetKyc.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetKyc();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetKyc message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetKyc} Client2ProxyReqGetKyc
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetKyc.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetKyc message.
     * @function verify
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetKyc.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetKyc message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetKyc} Client2ProxyReqGetKyc
     */
    Client2ProxyReqGetKyc.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetKyc)
            return object;
        let message = new $root.Client2ProxyReqGetKyc();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetKyc message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {Client2ProxyReqGetKyc} message Client2ProxyReqGetKyc
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetKyc.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetKyc to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetKyc
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetKyc.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetKyc
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetKyc
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetKyc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetKyc";
    };

    return Client2ProxyReqGetKyc;
})();

export const Client2ProxyAckGetKyc = $root.Client2ProxyAckGetKyc = (() => {

    /**
     * Properties of a Client2ProxyAckGetKyc.
     * @exports IClient2ProxyAckGetKyc
     * @interface IClient2ProxyAckGetKyc
     * @property {number|null} [Ret] Client2ProxyAckGetKyc Ret
     * @property {number|null} [UserID] Client2ProxyAckGetKyc UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyAckGetKyc Moblie
     * @property {Uint8Array|null} [mail] Client2ProxyAckGetKyc mail
     * @property {Uint8Array|null} [Front] Client2ProxyAckGetKyc Front
     * @property {Uint8Array|null} [Back] Client2ProxyAckGetKyc Back
     */

    /**
     * Constructs a new Client2ProxyAckGetKyc.
     * @exports Client2ProxyAckGetKyc
     * @classdesc Represents a Client2ProxyAckGetKyc.
     * @implements IClient2ProxyAckGetKyc
     * @constructor
     * @param {IClient2ProxyAckGetKyc=} [properties] Properties to set
     */
    function Client2ProxyAckGetKyc(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetKyc Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetKyc UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetKyc Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyAckGetKyc mail.
     * @member {Uint8Array} mail
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.mail = $util.newBuffer([]);

    /**
     * Client2ProxyAckGetKyc Front.
     * @member {Uint8Array} Front
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.Front = $util.newBuffer([]);

    /**
     * Client2ProxyAckGetKyc Back.
     * @member {Uint8Array} Back
     * @memberof Client2ProxyAckGetKyc
     * @instance
     */
    Client2ProxyAckGetKyc.prototype.Back = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckGetKyc instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {IClient2ProxyAckGetKyc=} [properties] Properties to set
     * @returns {Client2ProxyAckGetKyc} Client2ProxyAckGetKyc instance
     */
    Client2ProxyAckGetKyc.create = function create(properties) {
        return new Client2ProxyAckGetKyc(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetKyc message. Does not implicitly {@link Client2ProxyAckGetKyc.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {IClient2ProxyAckGetKyc} message Client2ProxyAckGetKyc message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetKyc.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Moblie);
        if (message.mail != null && Object.hasOwnProperty.call(message, "mail"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.mail);
        if (message.Front != null && Object.hasOwnProperty.call(message, "Front"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.Front);
        if (message.Back != null && Object.hasOwnProperty.call(message, "Back"))
            writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.Back);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetKyc message, length delimited. Does not implicitly {@link Client2ProxyAckGetKyc.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {IClient2ProxyAckGetKyc} message Client2ProxyAckGetKyc message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetKyc.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetKyc message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetKyc} Client2ProxyAckGetKyc
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetKyc.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetKyc();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 4: {
                    message.mail = reader.bytes();
                    break;
                }
            case 5: {
                    message.Front = reader.bytes();
                    break;
                }
            case 6: {
                    message.Back = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetKyc message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetKyc} Client2ProxyAckGetKyc
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetKyc.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetKyc message.
     * @function verify
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetKyc.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.mail != null && message.hasOwnProperty("mail"))
            if (!(message.mail && typeof message.mail.length === "number" || $util.isString(message.mail)))
                return "mail: buffer expected";
        if (message.Front != null && message.hasOwnProperty("Front"))
            if (!(message.Front && typeof message.Front.length === "number" || $util.isString(message.Front)))
                return "Front: buffer expected";
        if (message.Back != null && message.hasOwnProperty("Back"))
            if (!(message.Back && typeof message.Back.length === "number" || $util.isString(message.Back)))
                return "Back: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetKyc message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetKyc} Client2ProxyAckGetKyc
     */
    Client2ProxyAckGetKyc.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetKyc)
            return object;
        let message = new $root.Client2ProxyAckGetKyc();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.mail != null)
            if (typeof object.mail === "string")
                $util.base64.decode(object.mail, message.mail = $util.newBuffer($util.base64.length(object.mail)), 0);
            else if (object.mail.length >= 0)
                message.mail = object.mail;
        if (object.Front != null)
            if (typeof object.Front === "string")
                $util.base64.decode(object.Front, message.Front = $util.newBuffer($util.base64.length(object.Front)), 0);
            else if (object.Front.length >= 0)
                message.Front = object.Front;
        if (object.Back != null)
            if (typeof object.Back === "string")
                $util.base64.decode(object.Back, message.Back = $util.newBuffer($util.base64.length(object.Back)), 0);
            else if (object.Back.length >= 0)
                message.Back = object.Back;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetKyc message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {Client2ProxyAckGetKyc} message Client2ProxyAckGetKyc
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetKyc.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.mail = "";
            else {
                object.mail = [];
                if (options.bytes !== Array)
                    object.mail = $util.newBuffer(object.mail);
            }
            if (options.bytes === String)
                object.Front = "";
            else {
                object.Front = [];
                if (options.bytes !== Array)
                    object.Front = $util.newBuffer(object.Front);
            }
            if (options.bytes === String)
                object.Back = "";
            else {
                object.Back = [];
                if (options.bytes !== Array)
                    object.Back = $util.newBuffer(object.Back);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.mail != null && message.hasOwnProperty("mail"))
            object.mail = options.bytes === String ? $util.base64.encode(message.mail, 0, message.mail.length) : options.bytes === Array ? Array.prototype.slice.call(message.mail) : message.mail;
        if (message.Front != null && message.hasOwnProperty("Front"))
            object.Front = options.bytes === String ? $util.base64.encode(message.Front, 0, message.Front.length) : options.bytes === Array ? Array.prototype.slice.call(message.Front) : message.Front;
        if (message.Back != null && message.hasOwnProperty("Back"))
            object.Back = options.bytes === String ? $util.base64.encode(message.Back, 0, message.Back.length) : options.bytes === Array ? Array.prototype.slice.call(message.Back) : message.Back;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetKyc to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetKyc
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetKyc.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetKyc
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetKyc
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetKyc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetKyc";
    };

    return Client2ProxyAckGetKyc;
})();

export const Client2ProxyReqCheckKycInfo = $root.Client2ProxyReqCheckKycInfo = (() => {

    /**
     * Properties of a Client2ProxyReqCheckKycInfo.
     * @exports IClient2ProxyReqCheckKycInfo
     * @interface IClient2ProxyReqCheckKycInfo
     * @property {number|null} [UserID] Client2ProxyReqCheckKycInfo UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyReqCheckKycInfo Moblie
     * @property {Uint8Array|null} [mail] Client2ProxyReqCheckKycInfo mail
     * @property {number|null} [Type] Client2ProxyReqCheckKycInfo Type
     */

    /**
     * Constructs a new Client2ProxyReqCheckKycInfo.
     * @exports Client2ProxyReqCheckKycInfo
     * @classdesc Represents a Client2ProxyReqCheckKycInfo.
     * @implements IClient2ProxyReqCheckKycInfo
     * @constructor
     * @param {IClient2ProxyReqCheckKycInfo=} [properties] Properties to set
     */
    function Client2ProxyReqCheckKycInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqCheckKycInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqCheckKycInfo
     * @instance
     */
    Client2ProxyReqCheckKycInfo.prototype.UserID = 0;

    /**
     * Client2ProxyReqCheckKycInfo Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyReqCheckKycInfo
     * @instance
     */
    Client2ProxyReqCheckKycInfo.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyReqCheckKycInfo mail.
     * @member {Uint8Array} mail
     * @memberof Client2ProxyReqCheckKycInfo
     * @instance
     */
    Client2ProxyReqCheckKycInfo.prototype.mail = $util.newBuffer([]);

    /**
     * Client2ProxyReqCheckKycInfo Type.
     * @member {number} Type
     * @memberof Client2ProxyReqCheckKycInfo
     * @instance
     */
    Client2ProxyReqCheckKycInfo.prototype.Type = 0;

    /**
     * Creates a new Client2ProxyReqCheckKycInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {IClient2ProxyReqCheckKycInfo=} [properties] Properties to set
     * @returns {Client2ProxyReqCheckKycInfo} Client2ProxyReqCheckKycInfo instance
     */
    Client2ProxyReqCheckKycInfo.create = function create(properties) {
        return new Client2ProxyReqCheckKycInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqCheckKycInfo message. Does not implicitly {@link Client2ProxyReqCheckKycInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {IClient2ProxyReqCheckKycInfo} message Client2ProxyReqCheckKycInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckKycInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Moblie);
        if (message.mail != null && Object.hasOwnProperty.call(message, "mail"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.mail);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqCheckKycInfo message, length delimited. Does not implicitly {@link Client2ProxyReqCheckKycInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {IClient2ProxyReqCheckKycInfo} message Client2ProxyReqCheckKycInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckKycInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqCheckKycInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqCheckKycInfo} Client2ProxyReqCheckKycInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckKycInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqCheckKycInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 3: {
                    message.mail = reader.bytes();
                    break;
                }
            case 4: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqCheckKycInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqCheckKycInfo} Client2ProxyReqCheckKycInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckKycInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqCheckKycInfo message.
     * @function verify
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqCheckKycInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.mail != null && message.hasOwnProperty("mail"))
            if (!(message.mail && typeof message.mail.length === "number" || $util.isString(message.mail)))
                return "mail: buffer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqCheckKycInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqCheckKycInfo} Client2ProxyReqCheckKycInfo
     */
    Client2ProxyReqCheckKycInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqCheckKycInfo)
            return object;
        let message = new $root.Client2ProxyReqCheckKycInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.mail != null)
            if (typeof object.mail === "string")
                $util.base64.decode(object.mail, message.mail = $util.newBuffer($util.base64.length(object.mail)), 0);
            else if (object.mail.length >= 0)
                message.mail = object.mail;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqCheckKycInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {Client2ProxyReqCheckKycInfo} message Client2ProxyReqCheckKycInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqCheckKycInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.mail = "";
            else {
                object.mail = [];
                if (options.bytes !== Array)
                    object.mail = $util.newBuffer(object.mail);
            }
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.mail != null && message.hasOwnProperty("mail"))
            object.mail = options.bytes === String ? $util.base64.encode(message.mail, 0, message.mail.length) : options.bytes === Array ? Array.prototype.slice.call(message.mail) : message.mail;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this Client2ProxyReqCheckKycInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqCheckKycInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqCheckKycInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqCheckKycInfo
     * @function getTypeUrl
     * @memberof Client2ProxyReqCheckKycInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqCheckKycInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqCheckKycInfo";
    };

    return Client2ProxyReqCheckKycInfo;
})();

export const Client2ProxyAckCheckKycInfo = $root.Client2ProxyAckCheckKycInfo = (() => {

    /**
     * Properties of a Client2ProxyAckCheckKycInfo.
     * @exports IClient2ProxyAckCheckKycInfo
     * @interface IClient2ProxyAckCheckKycInfo
     * @property {number|null} [Ret] Client2ProxyAckCheckKycInfo Ret
     * @property {number|null} [UserID] Client2ProxyAckCheckKycInfo UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyAckCheckKycInfo Moblie
     * @property {Uint8Array|null} [mail] Client2ProxyAckCheckKycInfo mail
     */

    /**
     * Constructs a new Client2ProxyAckCheckKycInfo.
     * @exports Client2ProxyAckCheckKycInfo
     * @classdesc Represents a Client2ProxyAckCheckKycInfo.
     * @implements IClient2ProxyAckCheckKycInfo
     * @constructor
     * @param {IClient2ProxyAckCheckKycInfo=} [properties] Properties to set
     */
    function Client2ProxyAckCheckKycInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckCheckKycInfo Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckCheckKycInfo
     * @instance
     */
    Client2ProxyAckCheckKycInfo.prototype.Ret = 0;

    /**
     * Client2ProxyAckCheckKycInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckCheckKycInfo
     * @instance
     */
    Client2ProxyAckCheckKycInfo.prototype.UserID = 0;

    /**
     * Client2ProxyAckCheckKycInfo Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyAckCheckKycInfo
     * @instance
     */
    Client2ProxyAckCheckKycInfo.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyAckCheckKycInfo mail.
     * @member {Uint8Array} mail
     * @memberof Client2ProxyAckCheckKycInfo
     * @instance
     */
    Client2ProxyAckCheckKycInfo.prototype.mail = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckCheckKycInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {IClient2ProxyAckCheckKycInfo=} [properties] Properties to set
     * @returns {Client2ProxyAckCheckKycInfo} Client2ProxyAckCheckKycInfo instance
     */
    Client2ProxyAckCheckKycInfo.create = function create(properties) {
        return new Client2ProxyAckCheckKycInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckCheckKycInfo message. Does not implicitly {@link Client2ProxyAckCheckKycInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {IClient2ProxyAckCheckKycInfo} message Client2ProxyAckCheckKycInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckKycInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Moblie);
        if (message.mail != null && Object.hasOwnProperty.call(message, "mail"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.mail);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckCheckKycInfo message, length delimited. Does not implicitly {@link Client2ProxyAckCheckKycInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {IClient2ProxyAckCheckKycInfo} message Client2ProxyAckCheckKycInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckKycInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckCheckKycInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckCheckKycInfo} Client2ProxyAckCheckKycInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckKycInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckCheckKycInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 4: {
                    message.mail = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckCheckKycInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckCheckKycInfo} Client2ProxyAckCheckKycInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckKycInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckCheckKycInfo message.
     * @function verify
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckCheckKycInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.mail != null && message.hasOwnProperty("mail"))
            if (!(message.mail && typeof message.mail.length === "number" || $util.isString(message.mail)))
                return "mail: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckCheckKycInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckCheckKycInfo} Client2ProxyAckCheckKycInfo
     */
    Client2ProxyAckCheckKycInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckCheckKycInfo)
            return object;
        let message = new $root.Client2ProxyAckCheckKycInfo();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.mail != null)
            if (typeof object.mail === "string")
                $util.base64.decode(object.mail, message.mail = $util.newBuffer($util.base64.length(object.mail)), 0);
            else if (object.mail.length >= 0)
                message.mail = object.mail;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckCheckKycInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {Client2ProxyAckCheckKycInfo} message Client2ProxyAckCheckKycInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckCheckKycInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.mail = "";
            else {
                object.mail = [];
                if (options.bytes !== Array)
                    object.mail = $util.newBuffer(object.mail);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.mail != null && message.hasOwnProperty("mail"))
            object.mail = options.bytes === String ? $util.base64.encode(message.mail, 0, message.mail.length) : options.bytes === Array ? Array.prototype.slice.call(message.mail) : message.mail;
        return object;
    };

    /**
     * Converts this Client2ProxyAckCheckKycInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckCheckKycInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckCheckKycInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckCheckKycInfo
     * @function getTypeUrl
     * @memberof Client2ProxyAckCheckKycInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckCheckKycInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckCheckKycInfo";
    };

    return Client2ProxyAckCheckKycInfo;
})();

export const Client2ProxyReqCheckSms = $root.Client2ProxyReqCheckSms = (() => {

    /**
     * Properties of a Client2ProxyReqCheckSms.
     * @exports IClient2ProxyReqCheckSms
     * @interface IClient2ProxyReqCheckSms
     * @property {number|null} [UserID] Client2ProxyReqCheckSms UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyReqCheckSms Moblie
     * @property {Uint8Array|null} [smsCode] Client2ProxyReqCheckSms smsCode
     */

    /**
     * Constructs a new Client2ProxyReqCheckSms.
     * @exports Client2ProxyReqCheckSms
     * @classdesc Represents a Client2ProxyReqCheckSms.
     * @implements IClient2ProxyReqCheckSms
     * @constructor
     * @param {IClient2ProxyReqCheckSms=} [properties] Properties to set
     */
    function Client2ProxyReqCheckSms(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqCheckSms UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqCheckSms
     * @instance
     */
    Client2ProxyReqCheckSms.prototype.UserID = 0;

    /**
     * Client2ProxyReqCheckSms Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyReqCheckSms
     * @instance
     */
    Client2ProxyReqCheckSms.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyReqCheckSms smsCode.
     * @member {Uint8Array} smsCode
     * @memberof Client2ProxyReqCheckSms
     * @instance
     */
    Client2ProxyReqCheckSms.prototype.smsCode = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyReqCheckSms instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {IClient2ProxyReqCheckSms=} [properties] Properties to set
     * @returns {Client2ProxyReqCheckSms} Client2ProxyReqCheckSms instance
     */
    Client2ProxyReqCheckSms.create = function create(properties) {
        return new Client2ProxyReqCheckSms(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqCheckSms message. Does not implicitly {@link Client2ProxyReqCheckSms.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {IClient2ProxyReqCheckSms} message Client2ProxyReqCheckSms message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckSms.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Moblie);
        if (message.smsCode != null && Object.hasOwnProperty.call(message, "smsCode"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.smsCode);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqCheckSms message, length delimited. Does not implicitly {@link Client2ProxyReqCheckSms.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {IClient2ProxyReqCheckSms} message Client2ProxyReqCheckSms message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckSms.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqCheckSms message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqCheckSms} Client2ProxyReqCheckSms
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckSms.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqCheckSms();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 3: {
                    message.smsCode = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqCheckSms message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqCheckSms} Client2ProxyReqCheckSms
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckSms.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqCheckSms message.
     * @function verify
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqCheckSms.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            if (!(message.smsCode && typeof message.smsCode.length === "number" || $util.isString(message.smsCode)))
                return "smsCode: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqCheckSms message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqCheckSms} Client2ProxyReqCheckSms
     */
    Client2ProxyReqCheckSms.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqCheckSms)
            return object;
        let message = new $root.Client2ProxyReqCheckSms();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.smsCode != null)
            if (typeof object.smsCode === "string")
                $util.base64.decode(object.smsCode, message.smsCode = $util.newBuffer($util.base64.length(object.smsCode)), 0);
            else if (object.smsCode.length >= 0)
                message.smsCode = object.smsCode;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqCheckSms message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {Client2ProxyReqCheckSms} message Client2ProxyReqCheckSms
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqCheckSms.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.smsCode = "";
            else {
                object.smsCode = [];
                if (options.bytes !== Array)
                    object.smsCode = $util.newBuffer(object.smsCode);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            object.smsCode = options.bytes === String ? $util.base64.encode(message.smsCode, 0, message.smsCode.length) : options.bytes === Array ? Array.prototype.slice.call(message.smsCode) : message.smsCode;
        return object;
    };

    /**
     * Converts this Client2ProxyReqCheckSms to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqCheckSms
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqCheckSms.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqCheckSms
     * @function getTypeUrl
     * @memberof Client2ProxyReqCheckSms
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqCheckSms.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqCheckSms";
    };

    return Client2ProxyReqCheckSms;
})();

export const Client2ProxyAckCheckSms = $root.Client2ProxyAckCheckSms = (() => {

    /**
     * Properties of a Client2ProxyAckCheckSms.
     * @exports IClient2ProxyAckCheckSms
     * @interface IClient2ProxyAckCheckSms
     * @property {number|null} [Ret] Client2ProxyAckCheckSms Ret
     * @property {number|null} [UserID] Client2ProxyAckCheckSms UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyAckCheckSms Moblie
     * @property {Uint8Array|null} [smsCode] Client2ProxyAckCheckSms smsCode
     */

    /**
     * Constructs a new Client2ProxyAckCheckSms.
     * @exports Client2ProxyAckCheckSms
     * @classdesc Represents a Client2ProxyAckCheckSms.
     * @implements IClient2ProxyAckCheckSms
     * @constructor
     * @param {IClient2ProxyAckCheckSms=} [properties] Properties to set
     */
    function Client2ProxyAckCheckSms(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckCheckSms Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckCheckSms
     * @instance
     */
    Client2ProxyAckCheckSms.prototype.Ret = 0;

    /**
     * Client2ProxyAckCheckSms UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckCheckSms
     * @instance
     */
    Client2ProxyAckCheckSms.prototype.UserID = 0;

    /**
     * Client2ProxyAckCheckSms Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyAckCheckSms
     * @instance
     */
    Client2ProxyAckCheckSms.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyAckCheckSms smsCode.
     * @member {Uint8Array} smsCode
     * @memberof Client2ProxyAckCheckSms
     * @instance
     */
    Client2ProxyAckCheckSms.prototype.smsCode = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckCheckSms instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {IClient2ProxyAckCheckSms=} [properties] Properties to set
     * @returns {Client2ProxyAckCheckSms} Client2ProxyAckCheckSms instance
     */
    Client2ProxyAckCheckSms.create = function create(properties) {
        return new Client2ProxyAckCheckSms(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckCheckSms message. Does not implicitly {@link Client2ProxyAckCheckSms.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {IClient2ProxyAckCheckSms} message Client2ProxyAckCheckSms message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckSms.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Moblie);
        if (message.smsCode != null && Object.hasOwnProperty.call(message, "smsCode"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.smsCode);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckCheckSms message, length delimited. Does not implicitly {@link Client2ProxyAckCheckSms.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {IClient2ProxyAckCheckSms} message Client2ProxyAckCheckSms message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckSms.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckCheckSms message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckCheckSms} Client2ProxyAckCheckSms
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckSms.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckCheckSms();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 4: {
                    message.smsCode = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckCheckSms message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckCheckSms} Client2ProxyAckCheckSms
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckSms.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckCheckSms message.
     * @function verify
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckCheckSms.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            if (!(message.smsCode && typeof message.smsCode.length === "number" || $util.isString(message.smsCode)))
                return "smsCode: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckCheckSms message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckCheckSms} Client2ProxyAckCheckSms
     */
    Client2ProxyAckCheckSms.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckCheckSms)
            return object;
        let message = new $root.Client2ProxyAckCheckSms();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.smsCode != null)
            if (typeof object.smsCode === "string")
                $util.base64.decode(object.smsCode, message.smsCode = $util.newBuffer($util.base64.length(object.smsCode)), 0);
            else if (object.smsCode.length >= 0)
                message.smsCode = object.smsCode;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckCheckSms message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {Client2ProxyAckCheckSms} message Client2ProxyAckCheckSms
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckCheckSms.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.smsCode = "";
            else {
                object.smsCode = [];
                if (options.bytes !== Array)
                    object.smsCode = $util.newBuffer(object.smsCode);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.smsCode != null && message.hasOwnProperty("smsCode"))
            object.smsCode = options.bytes === String ? $util.base64.encode(message.smsCode, 0, message.smsCode.length) : options.bytes === Array ? Array.prototype.slice.call(message.smsCode) : message.smsCode;
        return object;
    };

    /**
     * Converts this Client2ProxyAckCheckSms to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckCheckSms
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckCheckSms.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckCheckSms
     * @function getTypeUrl
     * @memberof Client2ProxyAckCheckSms
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckCheckSms.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckCheckSms";
    };

    return Client2ProxyAckCheckSms;
})();

export const Client2ProxyReqGetGameCount = $root.Client2ProxyReqGetGameCount = (() => {

    /**
     * Properties of a Client2ProxyReqGetGameCount.
     * @exports IClient2ProxyReqGetGameCount
     * @interface IClient2ProxyReqGetGameCount
     * @property {number|null} [UserID] Client2ProxyReqGetGameCount UserID
     * @property {number|null} [GameID] Client2ProxyReqGetGameCount GameID
     */

    /**
     * Constructs a new Client2ProxyReqGetGameCount.
     * @exports Client2ProxyReqGetGameCount
     * @classdesc Represents a Client2ProxyReqGetGameCount.
     * @implements IClient2ProxyReqGetGameCount
     * @constructor
     * @param {IClient2ProxyReqGetGameCount=} [properties] Properties to set
     */
    function Client2ProxyReqGetGameCount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetGameCount UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetGameCount
     * @instance
     */
    Client2ProxyReqGetGameCount.prototype.UserID = 0;

    /**
     * Client2ProxyReqGetGameCount GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqGetGameCount
     * @instance
     */
    Client2ProxyReqGetGameCount.prototype.GameID = 0;

    /**
     * Creates a new Client2ProxyReqGetGameCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {IClient2ProxyReqGetGameCount=} [properties] Properties to set
     * @returns {Client2ProxyReqGetGameCount} Client2ProxyReqGetGameCount instance
     */
    Client2ProxyReqGetGameCount.create = function create(properties) {
        return new Client2ProxyReqGetGameCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetGameCount message. Does not implicitly {@link Client2ProxyReqGetGameCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {IClient2ProxyReqGetGameCount} message Client2ProxyReqGetGameCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetGameCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetGameCount message, length delimited. Does not implicitly {@link Client2ProxyReqGetGameCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {IClient2ProxyReqGetGameCount} message Client2ProxyReqGetGameCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetGameCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetGameCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetGameCount} Client2ProxyReqGetGameCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetGameCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetGameCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetGameCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetGameCount} Client2ProxyReqGetGameCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetGameCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetGameCount message.
     * @function verify
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetGameCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetGameCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetGameCount} Client2ProxyReqGetGameCount
     */
    Client2ProxyReqGetGameCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetGameCount)
            return object;
        let message = new $root.Client2ProxyReqGetGameCount();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetGameCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {Client2ProxyReqGetGameCount} message Client2ProxyReqGetGameCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetGameCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetGameCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetGameCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetGameCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetGameCount
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetGameCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetGameCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetGameCount";
    };

    return Client2ProxyReqGetGameCount;
})();

export const Client2ProxyAckGetGameCount = $root.Client2ProxyAckGetGameCount = (() => {

    /**
     * Properties of a Client2ProxyAckGetGameCount.
     * @exports IClient2ProxyAckGetGameCount
     * @interface IClient2ProxyAckGetGameCount
     * @property {number|null} [Ret] Client2ProxyAckGetGameCount Ret
     * @property {number|null} [UserID] Client2ProxyAckGetGameCount UserID
     * @property {number|null} [GameID] Client2ProxyAckGetGameCount GameID
     * @property {number|Long|null} [GameCount] Client2ProxyAckGetGameCount GameCount
     */

    /**
     * Constructs a new Client2ProxyAckGetGameCount.
     * @exports Client2ProxyAckGetGameCount
     * @classdesc Represents a Client2ProxyAckGetGameCount.
     * @implements IClient2ProxyAckGetGameCount
     * @constructor
     * @param {IClient2ProxyAckGetGameCount=} [properties] Properties to set
     */
    function Client2ProxyAckGetGameCount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetGameCount Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetGameCount
     * @instance
     */
    Client2ProxyAckGetGameCount.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetGameCount UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetGameCount
     * @instance
     */
    Client2ProxyAckGetGameCount.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetGameCount GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckGetGameCount
     * @instance
     */
    Client2ProxyAckGetGameCount.prototype.GameID = 0;

    /**
     * Client2ProxyAckGetGameCount GameCount.
     * @member {number|Long} GameCount
     * @memberof Client2ProxyAckGetGameCount
     * @instance
     */
    Client2ProxyAckGetGameCount.prototype.GameCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2ProxyAckGetGameCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {IClient2ProxyAckGetGameCount=} [properties] Properties to set
     * @returns {Client2ProxyAckGetGameCount} Client2ProxyAckGetGameCount instance
     */
    Client2ProxyAckGetGameCount.create = function create(properties) {
        return new Client2ProxyAckGetGameCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetGameCount message. Does not implicitly {@link Client2ProxyAckGetGameCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {IClient2ProxyAckGetGameCount} message Client2ProxyAckGetGameCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetGameCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GameID);
        if (message.GameCount != null && Object.hasOwnProperty.call(message, "GameCount"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.GameCount);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetGameCount message, length delimited. Does not implicitly {@link Client2ProxyAckGetGameCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {IClient2ProxyAckGetGameCount} message Client2ProxyAckGetGameCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetGameCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetGameCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetGameCount} Client2ProxyAckGetGameCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetGameCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetGameCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 4: {
                    message.GameCount = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetGameCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetGameCount} Client2ProxyAckGetGameCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetGameCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetGameCount message.
     * @function verify
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetGameCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.GameCount != null && message.hasOwnProperty("GameCount"))
            if (!$util.isInteger(message.GameCount) && !(message.GameCount && $util.isInteger(message.GameCount.low) && $util.isInteger(message.GameCount.high)))
                return "GameCount: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetGameCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetGameCount} Client2ProxyAckGetGameCount
     */
    Client2ProxyAckGetGameCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetGameCount)
            return object;
        let message = new $root.Client2ProxyAckGetGameCount();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.GameCount != null)
            if ($util.Long)
                (message.GameCount = $util.Long.fromValue(object.GameCount)).unsigned = true;
            else if (typeof object.GameCount === "string")
                message.GameCount = parseInt(object.GameCount, 10);
            else if (typeof object.GameCount === "number")
                message.GameCount = object.GameCount;
            else if (typeof object.GameCount === "object")
                message.GameCount = new $util.LongBits(object.GameCount.low >>> 0, object.GameCount.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetGameCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {Client2ProxyAckGetGameCount} message Client2ProxyAckGetGameCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetGameCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.GameID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.GameCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.GameCount = options.longs === String ? "0" : 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.GameCount != null && message.hasOwnProperty("GameCount"))
            if (typeof message.GameCount === "number")
                object.GameCount = options.longs === String ? String(message.GameCount) : message.GameCount;
            else
                object.GameCount = options.longs === String ? $util.Long.prototype.toString.call(message.GameCount) : options.longs === Number ? new $util.LongBits(message.GameCount.low >>> 0, message.GameCount.high >>> 0).toNumber(true) : message.GameCount;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetGameCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetGameCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetGameCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetGameCount
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetGameCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetGameCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetGameCount";
    };

    return Client2ProxyAckGetGameCount;
})();

export const Client2ProxyReqGetPayRecord = $root.Client2ProxyReqGetPayRecord = (() => {

    /**
     * Properties of a Client2ProxyReqGetPayRecord.
     * @exports IClient2ProxyReqGetPayRecord
     * @interface IClient2ProxyReqGetPayRecord
     * @property {number|null} [UserID] Client2ProxyReqGetPayRecord UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetPayRecord.
     * @exports Client2ProxyReqGetPayRecord
     * @classdesc Represents a Client2ProxyReqGetPayRecord.
     * @implements IClient2ProxyReqGetPayRecord
     * @constructor
     * @param {IClient2ProxyReqGetPayRecord=} [properties] Properties to set
     */
    function Client2ProxyReqGetPayRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetPayRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetPayRecord
     * @instance
     */
    Client2ProxyReqGetPayRecord.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetPayRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {IClient2ProxyReqGetPayRecord=} [properties] Properties to set
     * @returns {Client2ProxyReqGetPayRecord} Client2ProxyReqGetPayRecord instance
     */
    Client2ProxyReqGetPayRecord.create = function create(properties) {
        return new Client2ProxyReqGetPayRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetPayRecord message. Does not implicitly {@link Client2ProxyReqGetPayRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {IClient2ProxyReqGetPayRecord} message Client2ProxyReqGetPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetPayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetPayRecord message, length delimited. Does not implicitly {@link Client2ProxyReqGetPayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {IClient2ProxyReqGetPayRecord} message Client2ProxyReqGetPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetPayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetPayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetPayRecord} Client2ProxyReqGetPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetPayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetPayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetPayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetPayRecord} Client2ProxyReqGetPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetPayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetPayRecord message.
     * @function verify
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetPayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetPayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetPayRecord} Client2ProxyReqGetPayRecord
     */
    Client2ProxyReqGetPayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetPayRecord)
            return object;
        let message = new $root.Client2ProxyReqGetPayRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetPayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {Client2ProxyReqGetPayRecord} message Client2ProxyReqGetPayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetPayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetPayRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetPayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetPayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetPayRecord
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetPayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetPayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetPayRecord";
    };

    return Client2ProxyReqGetPayRecord;
})();

export const Client2ProxyAckGetPayRecord = $root.Client2ProxyAckGetPayRecord = (() => {

    /**
     * Properties of a Client2ProxyAckGetPayRecord.
     * @exports IClient2ProxyAckGetPayRecord
     * @interface IClient2ProxyAckGetPayRecord
     * @property {number|null} [UserID] Client2ProxyAckGetPayRecord UserID
     * @property {Array.<IUserPayRecord>|null} [PayRecordList] Client2ProxyAckGetPayRecord PayRecordList
     */

    /**
     * Constructs a new Client2ProxyAckGetPayRecord.
     * @exports Client2ProxyAckGetPayRecord
     * @classdesc Represents a Client2ProxyAckGetPayRecord.
     * @implements IClient2ProxyAckGetPayRecord
     * @constructor
     * @param {IClient2ProxyAckGetPayRecord=} [properties] Properties to set
     */
    function Client2ProxyAckGetPayRecord(properties) {
        this.PayRecordList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetPayRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetPayRecord
     * @instance
     */
    Client2ProxyAckGetPayRecord.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetPayRecord PayRecordList.
     * @member {Array.<IUserPayRecord>} PayRecordList
     * @memberof Client2ProxyAckGetPayRecord
     * @instance
     */
    Client2ProxyAckGetPayRecord.prototype.PayRecordList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckGetPayRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {IClient2ProxyAckGetPayRecord=} [properties] Properties to set
     * @returns {Client2ProxyAckGetPayRecord} Client2ProxyAckGetPayRecord instance
     */
    Client2ProxyAckGetPayRecord.create = function create(properties) {
        return new Client2ProxyAckGetPayRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetPayRecord message. Does not implicitly {@link Client2ProxyAckGetPayRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {IClient2ProxyAckGetPayRecord} message Client2ProxyAckGetPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetPayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PayRecordList != null && message.PayRecordList.length)
            for (let i = 0; i < message.PayRecordList.length; ++i)
                $root.UserPayRecord.encode(message.PayRecordList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetPayRecord message, length delimited. Does not implicitly {@link Client2ProxyAckGetPayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {IClient2ProxyAckGetPayRecord} message Client2ProxyAckGetPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetPayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetPayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetPayRecord} Client2ProxyAckGetPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetPayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetPayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.PayRecordList && message.PayRecordList.length))
                        message.PayRecordList = [];
                    message.PayRecordList.push($root.UserPayRecord.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetPayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetPayRecord} Client2ProxyAckGetPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetPayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetPayRecord message.
     * @function verify
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetPayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PayRecordList != null && message.hasOwnProperty("PayRecordList")) {
            if (!Array.isArray(message.PayRecordList))
                return "PayRecordList: array expected";
            for (let i = 0; i < message.PayRecordList.length; ++i) {
                let error = $root.UserPayRecord.verify(message.PayRecordList[i]);
                if (error)
                    return "PayRecordList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetPayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetPayRecord} Client2ProxyAckGetPayRecord
     */
    Client2ProxyAckGetPayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetPayRecord)
            return object;
        let message = new $root.Client2ProxyAckGetPayRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PayRecordList) {
            if (!Array.isArray(object.PayRecordList))
                throw TypeError(".Client2ProxyAckGetPayRecord.PayRecordList: array expected");
            message.PayRecordList = [];
            for (let i = 0; i < object.PayRecordList.length; ++i) {
                if (typeof object.PayRecordList[i] !== "object")
                    throw TypeError(".Client2ProxyAckGetPayRecord.PayRecordList: object expected");
                message.PayRecordList[i] = $root.UserPayRecord.fromObject(object.PayRecordList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetPayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {Client2ProxyAckGetPayRecord} message Client2ProxyAckGetPayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetPayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PayRecordList = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PayRecordList && message.PayRecordList.length) {
            object.PayRecordList = [];
            for (let j = 0; j < message.PayRecordList.length; ++j)
                object.PayRecordList[j] = $root.UserPayRecord.toObject(message.PayRecordList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetPayRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetPayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetPayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetPayRecord
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetPayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetPayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetPayRecord";
    };

    return Client2ProxyAckGetPayRecord;
})();

export const Client2ProxyReqPidPlayerCount = $root.Client2ProxyReqPidPlayerCount = (() => {

    /**
     * Properties of a Client2ProxyReqPidPlayerCount.
     * @exports IClient2ProxyReqPidPlayerCount
     * @interface IClient2ProxyReqPidPlayerCount
     * @property {number|null} [UserID] Client2ProxyReqPidPlayerCount UserID
     * @property {number|null} [GameID] Client2ProxyReqPidPlayerCount GameID
     * @property {Array.<number>|null} [ProdcutID] Client2ProxyReqPidPlayerCount ProdcutID
     */

    /**
     * Constructs a new Client2ProxyReqPidPlayerCount.
     * @exports Client2ProxyReqPidPlayerCount
     * @classdesc Represents a Client2ProxyReqPidPlayerCount.
     * @implements IClient2ProxyReqPidPlayerCount
     * @constructor
     * @param {IClient2ProxyReqPidPlayerCount=} [properties] Properties to set
     */
    function Client2ProxyReqPidPlayerCount(properties) {
        this.ProdcutID = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqPidPlayerCount UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqPidPlayerCount
     * @instance
     */
    Client2ProxyReqPidPlayerCount.prototype.UserID = 0;

    /**
     * Client2ProxyReqPidPlayerCount GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqPidPlayerCount
     * @instance
     */
    Client2ProxyReqPidPlayerCount.prototype.GameID = 0;

    /**
     * Client2ProxyReqPidPlayerCount ProdcutID.
     * @member {Array.<number>} ProdcutID
     * @memberof Client2ProxyReqPidPlayerCount
     * @instance
     */
    Client2ProxyReqPidPlayerCount.prototype.ProdcutID = $util.emptyArray;

    /**
     * Creates a new Client2ProxyReqPidPlayerCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {IClient2ProxyReqPidPlayerCount=} [properties] Properties to set
     * @returns {Client2ProxyReqPidPlayerCount} Client2ProxyReqPidPlayerCount instance
     */
    Client2ProxyReqPidPlayerCount.create = function create(properties) {
        return new Client2ProxyReqPidPlayerCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqPidPlayerCount message. Does not implicitly {@link Client2ProxyReqPidPlayerCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {IClient2ProxyReqPidPlayerCount} message Client2ProxyReqPidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPidPlayerCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProdcutID != null && message.ProdcutID.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.ProdcutID.length; ++i)
                writer.uint32(message.ProdcutID[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqPidPlayerCount message, length delimited. Does not implicitly {@link Client2ProxyReqPidPlayerCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {IClient2ProxyReqPidPlayerCount} message Client2ProxyReqPidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPidPlayerCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqPidPlayerCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqPidPlayerCount} Client2ProxyReqPidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPidPlayerCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqPidPlayerCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.ProdcutID && message.ProdcutID.length))
                        message.ProdcutID = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.ProdcutID.push(reader.uint32());
                    } else
                        message.ProdcutID.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqPidPlayerCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqPidPlayerCount} Client2ProxyReqPidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPidPlayerCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqPidPlayerCount message.
     * @function verify
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqPidPlayerCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID")) {
            if (!Array.isArray(message.ProdcutID))
                return "ProdcutID: array expected";
            for (let i = 0; i < message.ProdcutID.length; ++i)
                if (!$util.isInteger(message.ProdcutID[i]))
                    return "ProdcutID: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Client2ProxyReqPidPlayerCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqPidPlayerCount} Client2ProxyReqPidPlayerCount
     */
    Client2ProxyReqPidPlayerCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqPidPlayerCount)
            return object;
        let message = new $root.Client2ProxyReqPidPlayerCount();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutID) {
            if (!Array.isArray(object.ProdcutID))
                throw TypeError(".Client2ProxyReqPidPlayerCount.ProdcutID: array expected");
            message.ProdcutID = [];
            for (let i = 0; i < object.ProdcutID.length; ++i)
                message.ProdcutID[i] = object.ProdcutID[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqPidPlayerCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {Client2ProxyReqPidPlayerCount} message Client2ProxyReqPidPlayerCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqPidPlayerCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ProdcutID = [];
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutID && message.ProdcutID.length) {
            object.ProdcutID = [];
            for (let j = 0; j < message.ProdcutID.length; ++j)
                object.ProdcutID[j] = message.ProdcutID[j];
        }
        return object;
    };

    /**
     * Converts this Client2ProxyReqPidPlayerCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqPidPlayerCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqPidPlayerCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqPidPlayerCount
     * @function getTypeUrl
     * @memberof Client2ProxyReqPidPlayerCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqPidPlayerCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqPidPlayerCount";
    };

    return Client2ProxyReqPidPlayerCount;
})();

export const PidPlayerCount = $root.PidPlayerCount = (() => {

    /**
     * Properties of a PidPlayerCount.
     * @exports IPidPlayerCount
     * @interface IPidPlayerCount
     * @property {number|null} [ProdcutID] PidPlayerCount ProdcutID
     * @property {number|null} [PlayerCount] PidPlayerCount PlayerCount
     */

    /**
     * Constructs a new PidPlayerCount.
     * @exports PidPlayerCount
     * @classdesc Represents a PidPlayerCount.
     * @implements IPidPlayerCount
     * @constructor
     * @param {IPidPlayerCount=} [properties] Properties to set
     */
    function PidPlayerCount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PidPlayerCount ProdcutID.
     * @member {number} ProdcutID
     * @memberof PidPlayerCount
     * @instance
     */
    PidPlayerCount.prototype.ProdcutID = 0;

    /**
     * PidPlayerCount PlayerCount.
     * @member {number} PlayerCount
     * @memberof PidPlayerCount
     * @instance
     */
    PidPlayerCount.prototype.PlayerCount = 0;

    /**
     * Creates a new PidPlayerCount instance using the specified properties.
     * @function create
     * @memberof PidPlayerCount
     * @static
     * @param {IPidPlayerCount=} [properties] Properties to set
     * @returns {PidPlayerCount} PidPlayerCount instance
     */
    PidPlayerCount.create = function create(properties) {
        return new PidPlayerCount(properties);
    };

    /**
     * Encodes the specified PidPlayerCount message. Does not implicitly {@link PidPlayerCount.verify|verify} messages.
     * @function encode
     * @memberof PidPlayerCount
     * @static
     * @param {IPidPlayerCount} message PidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PidPlayerCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ProdcutID != null && Object.hasOwnProperty.call(message, "ProdcutID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ProdcutID);
        if (message.PlayerCount != null && Object.hasOwnProperty.call(message, "PlayerCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.PlayerCount);
        return writer;
    };

    /**
     * Encodes the specified PidPlayerCount message, length delimited. Does not implicitly {@link PidPlayerCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PidPlayerCount
     * @static
     * @param {IPidPlayerCount} message PidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PidPlayerCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PidPlayerCount message from the specified reader or buffer.
     * @function decode
     * @memberof PidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PidPlayerCount} PidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PidPlayerCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PidPlayerCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ProdcutID = reader.uint32();
                    break;
                }
            case 2: {
                    message.PlayerCount = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PidPlayerCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PidPlayerCount} PidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PidPlayerCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PidPlayerCount message.
     * @function verify
     * @memberof PidPlayerCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PidPlayerCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            if (!$util.isInteger(message.ProdcutID))
                return "ProdcutID: integer expected";
        if (message.PlayerCount != null && message.hasOwnProperty("PlayerCount"))
            if (!$util.isInteger(message.PlayerCount))
                return "PlayerCount: integer expected";
        return null;
    };

    /**
     * Creates a PidPlayerCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PidPlayerCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PidPlayerCount} PidPlayerCount
     */
    PidPlayerCount.fromObject = function fromObject(object) {
        if (object instanceof $root.PidPlayerCount)
            return object;
        let message = new $root.PidPlayerCount();
        if (object.ProdcutID != null)
            message.ProdcutID = object.ProdcutID >>> 0;
        if (object.PlayerCount != null)
            message.PlayerCount = object.PlayerCount >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PidPlayerCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PidPlayerCount
     * @static
     * @param {PidPlayerCount} message PidPlayerCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PidPlayerCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ProdcutID = 0;
            object.PlayerCount = 0;
        }
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            object.ProdcutID = message.ProdcutID;
        if (message.PlayerCount != null && message.hasOwnProperty("PlayerCount"))
            object.PlayerCount = message.PlayerCount;
        return object;
    };

    /**
     * Converts this PidPlayerCount to JSON.
     * @function toJSON
     * @memberof PidPlayerCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PidPlayerCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PidPlayerCount
     * @function getTypeUrl
     * @memberof PidPlayerCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PidPlayerCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PidPlayerCount";
    };

    return PidPlayerCount;
})();

export const Client2ProxyAckPidPlayerCount = $root.Client2ProxyAckPidPlayerCount = (() => {

    /**
     * Properties of a Client2ProxyAckPidPlayerCount.
     * @exports IClient2ProxyAckPidPlayerCount
     * @interface IClient2ProxyAckPidPlayerCount
     * @property {number|null} [Ret] Client2ProxyAckPidPlayerCount Ret
     * @property {number|null} [GameID] Client2ProxyAckPidPlayerCount GameID
     * @property {Array.<IPidPlayerCount>|null} [ProdcutLoad] Client2ProxyAckPidPlayerCount ProdcutLoad
     */

    /**
     * Constructs a new Client2ProxyAckPidPlayerCount.
     * @exports Client2ProxyAckPidPlayerCount
     * @classdesc Represents a Client2ProxyAckPidPlayerCount.
     * @implements IClient2ProxyAckPidPlayerCount
     * @constructor
     * @param {IClient2ProxyAckPidPlayerCount=} [properties] Properties to set
     */
    function Client2ProxyAckPidPlayerCount(properties) {
        this.ProdcutLoad = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPidPlayerCount Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckPidPlayerCount
     * @instance
     */
    Client2ProxyAckPidPlayerCount.prototype.Ret = 0;

    /**
     * Client2ProxyAckPidPlayerCount GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckPidPlayerCount
     * @instance
     */
    Client2ProxyAckPidPlayerCount.prototype.GameID = 0;

    /**
     * Client2ProxyAckPidPlayerCount ProdcutLoad.
     * @member {Array.<IPidPlayerCount>} ProdcutLoad
     * @memberof Client2ProxyAckPidPlayerCount
     * @instance
     */
    Client2ProxyAckPidPlayerCount.prototype.ProdcutLoad = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckPidPlayerCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {IClient2ProxyAckPidPlayerCount=} [properties] Properties to set
     * @returns {Client2ProxyAckPidPlayerCount} Client2ProxyAckPidPlayerCount instance
     */
    Client2ProxyAckPidPlayerCount.create = function create(properties) {
        return new Client2ProxyAckPidPlayerCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPidPlayerCount message. Does not implicitly {@link Client2ProxyAckPidPlayerCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {IClient2ProxyAckPidPlayerCount} message Client2ProxyAckPidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPidPlayerCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProdcutLoad != null && message.ProdcutLoad.length)
            for (let i = 0; i < message.ProdcutLoad.length; ++i)
                $root.PidPlayerCount.encode(message.ProdcutLoad[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPidPlayerCount message, length delimited. Does not implicitly {@link Client2ProxyAckPidPlayerCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {IClient2ProxyAckPidPlayerCount} message Client2ProxyAckPidPlayerCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPidPlayerCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPidPlayerCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPidPlayerCount} Client2ProxyAckPidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPidPlayerCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPidPlayerCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.ProdcutLoad && message.ProdcutLoad.length))
                        message.ProdcutLoad = [];
                    message.ProdcutLoad.push($root.PidPlayerCount.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPidPlayerCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPidPlayerCount} Client2ProxyAckPidPlayerCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPidPlayerCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPidPlayerCount message.
     * @function verify
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPidPlayerCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutLoad != null && message.hasOwnProperty("ProdcutLoad")) {
            if (!Array.isArray(message.ProdcutLoad))
                return "ProdcutLoad: array expected";
            for (let i = 0; i < message.ProdcutLoad.length; ++i) {
                let error = $root.PidPlayerCount.verify(message.ProdcutLoad[i]);
                if (error)
                    return "ProdcutLoad." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckPidPlayerCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPidPlayerCount} Client2ProxyAckPidPlayerCount
     */
    Client2ProxyAckPidPlayerCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPidPlayerCount)
            return object;
        let message = new $root.Client2ProxyAckPidPlayerCount();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutLoad) {
            if (!Array.isArray(object.ProdcutLoad))
                throw TypeError(".Client2ProxyAckPidPlayerCount.ProdcutLoad: array expected");
            message.ProdcutLoad = [];
            for (let i = 0; i < object.ProdcutLoad.length; ++i) {
                if (typeof object.ProdcutLoad[i] !== "object")
                    throw TypeError(".Client2ProxyAckPidPlayerCount.ProdcutLoad: object expected");
                message.ProdcutLoad[i] = $root.PidPlayerCount.fromObject(object.ProdcutLoad[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPidPlayerCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {Client2ProxyAckPidPlayerCount} message Client2ProxyAckPidPlayerCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPidPlayerCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ProdcutLoad = [];
        if (options.defaults) {
            object.Ret = 0;
            object.GameID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutLoad && message.ProdcutLoad.length) {
            object.ProdcutLoad = [];
            for (let j = 0; j < message.ProdcutLoad.length; ++j)
                object.ProdcutLoad[j] = $root.PidPlayerCount.toObject(message.ProdcutLoad[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckPidPlayerCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPidPlayerCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPidPlayerCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPidPlayerCount
     * @function getTypeUrl
     * @memberof Client2ProxyAckPidPlayerCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPidPlayerCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPidPlayerCount";
    };

    return Client2ProxyAckPidPlayerCount;
})();

export const Client2ProxyReqDaliyCheckInConfig = $root.Client2ProxyReqDaliyCheckInConfig = (() => {

    /**
     * Properties of a Client2ProxyReqDaliyCheckInConfig.
     * @exports IClient2ProxyReqDaliyCheckInConfig
     * @interface IClient2ProxyReqDaliyCheckInConfig
     * @property {number|null} [UserID] Client2ProxyReqDaliyCheckInConfig UserID
     */

    /**
     * Constructs a new Client2ProxyReqDaliyCheckInConfig.
     * @exports Client2ProxyReqDaliyCheckInConfig
     * @classdesc Represents a Client2ProxyReqDaliyCheckInConfig.
     * @implements IClient2ProxyReqDaliyCheckInConfig
     * @constructor
     * @param {IClient2ProxyReqDaliyCheckInConfig=} [properties] Properties to set
     */
    function Client2ProxyReqDaliyCheckInConfig(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqDaliyCheckInConfig UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @instance
     */
    Client2ProxyReqDaliyCheckInConfig.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqDaliyCheckInConfig instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyReqDaliyCheckInConfig=} [properties] Properties to set
     * @returns {Client2ProxyReqDaliyCheckInConfig} Client2ProxyReqDaliyCheckInConfig instance
     */
    Client2ProxyReqDaliyCheckInConfig.create = function create(properties) {
        return new Client2ProxyReqDaliyCheckInConfig(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqDaliyCheckInConfig message. Does not implicitly {@link Client2ProxyReqDaliyCheckInConfig.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyReqDaliyCheckInConfig} message Client2ProxyReqDaliyCheckInConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqDaliyCheckInConfig.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqDaliyCheckInConfig message, length delimited. Does not implicitly {@link Client2ProxyReqDaliyCheckInConfig.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyReqDaliyCheckInConfig} message Client2ProxyReqDaliyCheckInConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqDaliyCheckInConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqDaliyCheckInConfig message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqDaliyCheckInConfig} Client2ProxyReqDaliyCheckInConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqDaliyCheckInConfig.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqDaliyCheckInConfig();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqDaliyCheckInConfig message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqDaliyCheckInConfig} Client2ProxyReqDaliyCheckInConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqDaliyCheckInConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqDaliyCheckInConfig message.
     * @function verify
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqDaliyCheckInConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqDaliyCheckInConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqDaliyCheckInConfig} Client2ProxyReqDaliyCheckInConfig
     */
    Client2ProxyReqDaliyCheckInConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqDaliyCheckInConfig)
            return object;
        let message = new $root.Client2ProxyReqDaliyCheckInConfig();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqDaliyCheckInConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {Client2ProxyReqDaliyCheckInConfig} message Client2ProxyReqDaliyCheckInConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqDaliyCheckInConfig.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqDaliyCheckInConfig to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqDaliyCheckInConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqDaliyCheckInConfig
     * @function getTypeUrl
     * @memberof Client2ProxyReqDaliyCheckInConfig
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqDaliyCheckInConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqDaliyCheckInConfig";
    };

    return Client2ProxyReqDaliyCheckInConfig;
})();

export const Client2ProxyAckDaliyCheckInConfig = $root.Client2ProxyAckDaliyCheckInConfig = (() => {

    /**
     * Properties of a Client2ProxyAckDaliyCheckInConfig.
     * @exports IClient2ProxyAckDaliyCheckInConfig
     * @interface IClient2ProxyAckDaliyCheckInConfig
     * @property {number|null} [Ret] Client2ProxyAckDaliyCheckInConfig Ret
     * @property {number|null} [UserID] Client2ProxyAckDaliyCheckInConfig UserID
     * @property {Uint8Array|null} [DaliyConfig] Client2ProxyAckDaliyCheckInConfig DaliyConfig
     */

    /**
     * Constructs a new Client2ProxyAckDaliyCheckInConfig.
     * @exports Client2ProxyAckDaliyCheckInConfig
     * @classdesc Represents a Client2ProxyAckDaliyCheckInConfig.
     * @implements IClient2ProxyAckDaliyCheckInConfig
     * @constructor
     * @param {IClient2ProxyAckDaliyCheckInConfig=} [properties] Properties to set
     */
    function Client2ProxyAckDaliyCheckInConfig(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckDaliyCheckInConfig Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @instance
     */
    Client2ProxyAckDaliyCheckInConfig.prototype.Ret = 0;

    /**
     * Client2ProxyAckDaliyCheckInConfig UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @instance
     */
    Client2ProxyAckDaliyCheckInConfig.prototype.UserID = 0;

    /**
     * Client2ProxyAckDaliyCheckInConfig DaliyConfig.
     * @member {Uint8Array} DaliyConfig
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @instance
     */
    Client2ProxyAckDaliyCheckInConfig.prototype.DaliyConfig = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckDaliyCheckInConfig instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyAckDaliyCheckInConfig=} [properties] Properties to set
     * @returns {Client2ProxyAckDaliyCheckInConfig} Client2ProxyAckDaliyCheckInConfig instance
     */
    Client2ProxyAckDaliyCheckInConfig.create = function create(properties) {
        return new Client2ProxyAckDaliyCheckInConfig(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckDaliyCheckInConfig message. Does not implicitly {@link Client2ProxyAckDaliyCheckInConfig.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyAckDaliyCheckInConfig} message Client2ProxyAckDaliyCheckInConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckDaliyCheckInConfig.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.DaliyConfig != null && Object.hasOwnProperty.call(message, "DaliyConfig"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.DaliyConfig);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckDaliyCheckInConfig message, length delimited. Does not implicitly {@link Client2ProxyAckDaliyCheckInConfig.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {IClient2ProxyAckDaliyCheckInConfig} message Client2ProxyAckDaliyCheckInConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckDaliyCheckInConfig.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckDaliyCheckInConfig message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckDaliyCheckInConfig} Client2ProxyAckDaliyCheckInConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckDaliyCheckInConfig.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckDaliyCheckInConfig();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DaliyConfig = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckDaliyCheckInConfig message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckDaliyCheckInConfig} Client2ProxyAckDaliyCheckInConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckDaliyCheckInConfig.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckDaliyCheckInConfig message.
     * @function verify
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckDaliyCheckInConfig.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DaliyConfig != null && message.hasOwnProperty("DaliyConfig"))
            if (!(message.DaliyConfig && typeof message.DaliyConfig.length === "number" || $util.isString(message.DaliyConfig)))
                return "DaliyConfig: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckDaliyCheckInConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckDaliyCheckInConfig} Client2ProxyAckDaliyCheckInConfig
     */
    Client2ProxyAckDaliyCheckInConfig.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckDaliyCheckInConfig)
            return object;
        let message = new $root.Client2ProxyAckDaliyCheckInConfig();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DaliyConfig != null)
            if (typeof object.DaliyConfig === "string")
                $util.base64.decode(object.DaliyConfig, message.DaliyConfig = $util.newBuffer($util.base64.length(object.DaliyConfig)), 0);
            else if (object.DaliyConfig.length >= 0)
                message.DaliyConfig = object.DaliyConfig;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckDaliyCheckInConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {Client2ProxyAckDaliyCheckInConfig} message Client2ProxyAckDaliyCheckInConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckDaliyCheckInConfig.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.DaliyConfig = "";
            else {
                object.DaliyConfig = [];
                if (options.bytes !== Array)
                    object.DaliyConfig = $util.newBuffer(object.DaliyConfig);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DaliyConfig != null && message.hasOwnProperty("DaliyConfig"))
            object.DaliyConfig = options.bytes === String ? $util.base64.encode(message.DaliyConfig, 0, message.DaliyConfig.length) : options.bytes === Array ? Array.prototype.slice.call(message.DaliyConfig) : message.DaliyConfig;
        return object;
    };

    /**
     * Converts this Client2ProxyAckDaliyCheckInConfig to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckDaliyCheckInConfig.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckDaliyCheckInConfig
     * @function getTypeUrl
     * @memberof Client2ProxyAckDaliyCheckInConfig
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckDaliyCheckInConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckDaliyCheckInConfig";
    };

    return Client2ProxyAckDaliyCheckInConfig;
})();

export const Client2ProxyReqDaliyCheckIn = $root.Client2ProxyReqDaliyCheckIn = (() => {

    /**
     * Properties of a Client2ProxyReqDaliyCheckIn.
     * @exports IClient2ProxyReqDaliyCheckIn
     * @interface IClient2ProxyReqDaliyCheckIn
     * @property {number|null} [UserID] Client2ProxyReqDaliyCheckIn UserID
     * @property {number|null} [Daliy] Client2ProxyReqDaliyCheckIn Daliy
     */

    /**
     * Constructs a new Client2ProxyReqDaliyCheckIn.
     * @exports Client2ProxyReqDaliyCheckIn
     * @classdesc Represents a Client2ProxyReqDaliyCheckIn.
     * @implements IClient2ProxyReqDaliyCheckIn
     * @constructor
     * @param {IClient2ProxyReqDaliyCheckIn=} [properties] Properties to set
     */
    function Client2ProxyReqDaliyCheckIn(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqDaliyCheckIn UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqDaliyCheckIn
     * @instance
     */
    Client2ProxyReqDaliyCheckIn.prototype.UserID = 0;

    /**
     * Client2ProxyReqDaliyCheckIn Daliy.
     * @member {number} Daliy
     * @memberof Client2ProxyReqDaliyCheckIn
     * @instance
     */
    Client2ProxyReqDaliyCheckIn.prototype.Daliy = 0;

    /**
     * Creates a new Client2ProxyReqDaliyCheckIn instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {IClient2ProxyReqDaliyCheckIn=} [properties] Properties to set
     * @returns {Client2ProxyReqDaliyCheckIn} Client2ProxyReqDaliyCheckIn instance
     */
    Client2ProxyReqDaliyCheckIn.create = function create(properties) {
        return new Client2ProxyReqDaliyCheckIn(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqDaliyCheckIn message. Does not implicitly {@link Client2ProxyReqDaliyCheckIn.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {IClient2ProxyReqDaliyCheckIn} message Client2ProxyReqDaliyCheckIn message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqDaliyCheckIn.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Daliy != null && Object.hasOwnProperty.call(message, "Daliy"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Daliy);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqDaliyCheckIn message, length delimited. Does not implicitly {@link Client2ProxyReqDaliyCheckIn.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {IClient2ProxyReqDaliyCheckIn} message Client2ProxyReqDaliyCheckIn message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqDaliyCheckIn.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqDaliyCheckIn message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqDaliyCheckIn} Client2ProxyReqDaliyCheckIn
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqDaliyCheckIn.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqDaliyCheckIn();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Daliy = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqDaliyCheckIn message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqDaliyCheckIn} Client2ProxyReqDaliyCheckIn
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqDaliyCheckIn.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqDaliyCheckIn message.
     * @function verify
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqDaliyCheckIn.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Daliy != null && message.hasOwnProperty("Daliy"))
            if (!$util.isInteger(message.Daliy))
                return "Daliy: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqDaliyCheckIn message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqDaliyCheckIn} Client2ProxyReqDaliyCheckIn
     */
    Client2ProxyReqDaliyCheckIn.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqDaliyCheckIn)
            return object;
        let message = new $root.Client2ProxyReqDaliyCheckIn();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Daliy != null)
            message.Daliy = object.Daliy >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqDaliyCheckIn message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {Client2ProxyReqDaliyCheckIn} message Client2ProxyReqDaliyCheckIn
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqDaliyCheckIn.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Daliy = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Daliy != null && message.hasOwnProperty("Daliy"))
            object.Daliy = message.Daliy;
        return object;
    };

    /**
     * Converts this Client2ProxyReqDaliyCheckIn to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqDaliyCheckIn
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqDaliyCheckIn.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqDaliyCheckIn
     * @function getTypeUrl
     * @memberof Client2ProxyReqDaliyCheckIn
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqDaliyCheckIn.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqDaliyCheckIn";
    };

    return Client2ProxyReqDaliyCheckIn;
})();

export const Client2ProxyAckDaliyCheckIn = $root.Client2ProxyAckDaliyCheckIn = (() => {

    /**
     * Properties of a Client2ProxyAckDaliyCheckIn.
     * @exports IClient2ProxyAckDaliyCheckIn
     * @interface IClient2ProxyAckDaliyCheckIn
     * @property {number|null} [Ret] Client2ProxyAckDaliyCheckIn Ret
     * @property {number|null} [UserID] Client2ProxyAckDaliyCheckIn UserID
     * @property {number|null} [Daliy] Client2ProxyAckDaliyCheckIn Daliy
     * @property {string|null} [Bonus] Client2ProxyAckDaliyCheckIn Bonus
     */

    /**
     * Constructs a new Client2ProxyAckDaliyCheckIn.
     * @exports Client2ProxyAckDaliyCheckIn
     * @classdesc Represents a Client2ProxyAckDaliyCheckIn.
     * @implements IClient2ProxyAckDaliyCheckIn
     * @constructor
     * @param {IClient2ProxyAckDaliyCheckIn=} [properties] Properties to set
     */
    function Client2ProxyAckDaliyCheckIn(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckDaliyCheckIn Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckDaliyCheckIn
     * @instance
     */
    Client2ProxyAckDaliyCheckIn.prototype.Ret = 0;

    /**
     * Client2ProxyAckDaliyCheckIn UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckDaliyCheckIn
     * @instance
     */
    Client2ProxyAckDaliyCheckIn.prototype.UserID = 0;

    /**
     * Client2ProxyAckDaliyCheckIn Daliy.
     * @member {number} Daliy
     * @memberof Client2ProxyAckDaliyCheckIn
     * @instance
     */
    Client2ProxyAckDaliyCheckIn.prototype.Daliy = 0;

    /**
     * Client2ProxyAckDaliyCheckIn Bonus.
     * @member {string} Bonus
     * @memberof Client2ProxyAckDaliyCheckIn
     * @instance
     */
    Client2ProxyAckDaliyCheckIn.prototype.Bonus = "";

    /**
     * Creates a new Client2ProxyAckDaliyCheckIn instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {IClient2ProxyAckDaliyCheckIn=} [properties] Properties to set
     * @returns {Client2ProxyAckDaliyCheckIn} Client2ProxyAckDaliyCheckIn instance
     */
    Client2ProxyAckDaliyCheckIn.create = function create(properties) {
        return new Client2ProxyAckDaliyCheckIn(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckDaliyCheckIn message. Does not implicitly {@link Client2ProxyAckDaliyCheckIn.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {IClient2ProxyAckDaliyCheckIn} message Client2ProxyAckDaliyCheckIn message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckDaliyCheckIn.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Daliy != null && Object.hasOwnProperty.call(message, "Daliy"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Daliy);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Bonus);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckDaliyCheckIn message, length delimited. Does not implicitly {@link Client2ProxyAckDaliyCheckIn.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {IClient2ProxyAckDaliyCheckIn} message Client2ProxyAckDaliyCheckIn message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckDaliyCheckIn.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckDaliyCheckIn message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckDaliyCheckIn} Client2ProxyAckDaliyCheckIn
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckDaliyCheckIn.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckDaliyCheckIn();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Daliy = reader.uint32();
                    break;
                }
            case 4: {
                    message.Bonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckDaliyCheckIn message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckDaliyCheckIn} Client2ProxyAckDaliyCheckIn
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckDaliyCheckIn.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckDaliyCheckIn message.
     * @function verify
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckDaliyCheckIn.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Daliy != null && message.hasOwnProperty("Daliy"))
            if (!$util.isInteger(message.Daliy))
                return "Daliy: integer expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckDaliyCheckIn message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckDaliyCheckIn} Client2ProxyAckDaliyCheckIn
     */
    Client2ProxyAckDaliyCheckIn.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckDaliyCheckIn)
            return object;
        let message = new $root.Client2ProxyAckDaliyCheckIn();
        if (object.Ret != null)
            message.Ret = object.Ret | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Daliy != null)
            message.Daliy = object.Daliy >>> 0;
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckDaliyCheckIn message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {Client2ProxyAckDaliyCheckIn} message Client2ProxyAckDaliyCheckIn
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckDaliyCheckIn.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Daliy = 0;
            object.Bonus = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Daliy != null && message.hasOwnProperty("Daliy"))
            object.Daliy = message.Daliy;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        return object;
    };

    /**
     * Converts this Client2ProxyAckDaliyCheckIn to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckDaliyCheckIn
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckDaliyCheckIn.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckDaliyCheckIn
     * @function getTypeUrl
     * @memberof Client2ProxyAckDaliyCheckIn
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckDaliyCheckIn.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckDaliyCheckIn";
    };

    return Client2ProxyAckDaliyCheckIn;
})();

export const Client2ProxyReqGetCumulativeDays = $root.Client2ProxyReqGetCumulativeDays = (() => {

    /**
     * Properties of a Client2ProxyReqGetCumulativeDays.
     * @exports IClient2ProxyReqGetCumulativeDays
     * @interface IClient2ProxyReqGetCumulativeDays
     * @property {number|null} [UserID] Client2ProxyReqGetCumulativeDays UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetCumulativeDays.
     * @exports Client2ProxyReqGetCumulativeDays
     * @classdesc Represents a Client2ProxyReqGetCumulativeDays.
     * @implements IClient2ProxyReqGetCumulativeDays
     * @constructor
     * @param {IClient2ProxyReqGetCumulativeDays=} [properties] Properties to set
     */
    function Client2ProxyReqGetCumulativeDays(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetCumulativeDays UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetCumulativeDays
     * @instance
     */
    Client2ProxyReqGetCumulativeDays.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetCumulativeDays instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {IClient2ProxyReqGetCumulativeDays=} [properties] Properties to set
     * @returns {Client2ProxyReqGetCumulativeDays} Client2ProxyReqGetCumulativeDays instance
     */
    Client2ProxyReqGetCumulativeDays.create = function create(properties) {
        return new Client2ProxyReqGetCumulativeDays(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetCumulativeDays message. Does not implicitly {@link Client2ProxyReqGetCumulativeDays.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {IClient2ProxyReqGetCumulativeDays} message Client2ProxyReqGetCumulativeDays message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetCumulativeDays.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetCumulativeDays message, length delimited. Does not implicitly {@link Client2ProxyReqGetCumulativeDays.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {IClient2ProxyReqGetCumulativeDays} message Client2ProxyReqGetCumulativeDays message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetCumulativeDays.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetCumulativeDays message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetCumulativeDays} Client2ProxyReqGetCumulativeDays
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetCumulativeDays.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetCumulativeDays();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetCumulativeDays message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetCumulativeDays} Client2ProxyReqGetCumulativeDays
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetCumulativeDays.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetCumulativeDays message.
     * @function verify
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetCumulativeDays.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetCumulativeDays message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetCumulativeDays} Client2ProxyReqGetCumulativeDays
     */
    Client2ProxyReqGetCumulativeDays.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetCumulativeDays)
            return object;
        let message = new $root.Client2ProxyReqGetCumulativeDays();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetCumulativeDays message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {Client2ProxyReqGetCumulativeDays} message Client2ProxyReqGetCumulativeDays
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetCumulativeDays.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetCumulativeDays to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetCumulativeDays
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetCumulativeDays.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetCumulativeDays
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetCumulativeDays
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetCumulativeDays.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetCumulativeDays";
    };

    return Client2ProxyReqGetCumulativeDays;
})();

export const Client2ProxyAckGetCumulativeDays = $root.Client2ProxyAckGetCumulativeDays = (() => {

    /**
     * Properties of a Client2ProxyAckGetCumulativeDays.
     * @exports IClient2ProxyAckGetCumulativeDays
     * @interface IClient2ProxyAckGetCumulativeDays
     * @property {number|null} [Ret] Client2ProxyAckGetCumulativeDays Ret
     * @property {number|null} [UserID] Client2ProxyAckGetCumulativeDays UserID
     * @property {number|null} [Days] Client2ProxyAckGetCumulativeDays Days
     * @property {Uint8Array|null} [DaliyConfig] Client2ProxyAckGetCumulativeDays DaliyConfig
     * @property {number|null} [TodayCheckIn] Client2ProxyAckGetCumulativeDays TodayCheckIn
     */

    /**
     * Constructs a new Client2ProxyAckGetCumulativeDays.
     * @exports Client2ProxyAckGetCumulativeDays
     * @classdesc Represents a Client2ProxyAckGetCumulativeDays.
     * @implements IClient2ProxyAckGetCumulativeDays
     * @constructor
     * @param {IClient2ProxyAckGetCumulativeDays=} [properties] Properties to set
     */
    function Client2ProxyAckGetCumulativeDays(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetCumulativeDays Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     */
    Client2ProxyAckGetCumulativeDays.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetCumulativeDays UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     */
    Client2ProxyAckGetCumulativeDays.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetCumulativeDays Days.
     * @member {number} Days
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     */
    Client2ProxyAckGetCumulativeDays.prototype.Days = 0;

    /**
     * Client2ProxyAckGetCumulativeDays DaliyConfig.
     * @member {Uint8Array} DaliyConfig
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     */
    Client2ProxyAckGetCumulativeDays.prototype.DaliyConfig = $util.newBuffer([]);

    /**
     * Client2ProxyAckGetCumulativeDays TodayCheckIn.
     * @member {number} TodayCheckIn
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     */
    Client2ProxyAckGetCumulativeDays.prototype.TodayCheckIn = 0;

    /**
     * Creates a new Client2ProxyAckGetCumulativeDays instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {IClient2ProxyAckGetCumulativeDays=} [properties] Properties to set
     * @returns {Client2ProxyAckGetCumulativeDays} Client2ProxyAckGetCumulativeDays instance
     */
    Client2ProxyAckGetCumulativeDays.create = function create(properties) {
        return new Client2ProxyAckGetCumulativeDays(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetCumulativeDays message. Does not implicitly {@link Client2ProxyAckGetCumulativeDays.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {IClient2ProxyAckGetCumulativeDays} message Client2ProxyAckGetCumulativeDays message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetCumulativeDays.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Days != null && Object.hasOwnProperty.call(message, "Days"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Days);
        if (message.DaliyConfig != null && Object.hasOwnProperty.call(message, "DaliyConfig"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.DaliyConfig);
        if (message.TodayCheckIn != null && Object.hasOwnProperty.call(message, "TodayCheckIn"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.TodayCheckIn);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetCumulativeDays message, length delimited. Does not implicitly {@link Client2ProxyAckGetCumulativeDays.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {IClient2ProxyAckGetCumulativeDays} message Client2ProxyAckGetCumulativeDays message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetCumulativeDays.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetCumulativeDays message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetCumulativeDays} Client2ProxyAckGetCumulativeDays
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetCumulativeDays.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetCumulativeDays();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Days = reader.uint32();
                    break;
                }
            case 4: {
                    message.DaliyConfig = reader.bytes();
                    break;
                }
            case 5: {
                    message.TodayCheckIn = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetCumulativeDays message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetCumulativeDays} Client2ProxyAckGetCumulativeDays
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetCumulativeDays.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetCumulativeDays message.
     * @function verify
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetCumulativeDays.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Days != null && message.hasOwnProperty("Days"))
            if (!$util.isInteger(message.Days))
                return "Days: integer expected";
        if (message.DaliyConfig != null && message.hasOwnProperty("DaliyConfig"))
            if (!(message.DaliyConfig && typeof message.DaliyConfig.length === "number" || $util.isString(message.DaliyConfig)))
                return "DaliyConfig: buffer expected";
        if (message.TodayCheckIn != null && message.hasOwnProperty("TodayCheckIn"))
            if (!$util.isInteger(message.TodayCheckIn))
                return "TodayCheckIn: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetCumulativeDays message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetCumulativeDays} Client2ProxyAckGetCumulativeDays
     */
    Client2ProxyAckGetCumulativeDays.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetCumulativeDays)
            return object;
        let message = new $root.Client2ProxyAckGetCumulativeDays();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Days != null)
            message.Days = object.Days >>> 0;
        if (object.DaliyConfig != null)
            if (typeof object.DaliyConfig === "string")
                $util.base64.decode(object.DaliyConfig, message.DaliyConfig = $util.newBuffer($util.base64.length(object.DaliyConfig)), 0);
            else if (object.DaliyConfig.length >= 0)
                message.DaliyConfig = object.DaliyConfig;
        if (object.TodayCheckIn != null)
            message.TodayCheckIn = object.TodayCheckIn >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetCumulativeDays message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {Client2ProxyAckGetCumulativeDays} message Client2ProxyAckGetCumulativeDays
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetCumulativeDays.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Days = 0;
            if (options.bytes === String)
                object.DaliyConfig = "";
            else {
                object.DaliyConfig = [];
                if (options.bytes !== Array)
                    object.DaliyConfig = $util.newBuffer(object.DaliyConfig);
            }
            object.TodayCheckIn = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Days != null && message.hasOwnProperty("Days"))
            object.Days = message.Days;
        if (message.DaliyConfig != null && message.hasOwnProperty("DaliyConfig"))
            object.DaliyConfig = options.bytes === String ? $util.base64.encode(message.DaliyConfig, 0, message.DaliyConfig.length) : options.bytes === Array ? Array.prototype.slice.call(message.DaliyConfig) : message.DaliyConfig;
        if (message.TodayCheckIn != null && message.hasOwnProperty("TodayCheckIn"))
            object.TodayCheckIn = message.TodayCheckIn;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetCumulativeDays to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetCumulativeDays
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetCumulativeDays.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetCumulativeDays
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetCumulativeDays
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetCumulativeDays.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetCumulativeDays";
    };

    return Client2ProxyAckGetCumulativeDays;
})();

export const Client2ProxyReqPayment = $root.Client2ProxyReqPayment = (() => {

    /**
     * Properties of a Client2ProxyReqPayment.
     * @exports IClient2ProxyReqPayment
     * @interface IClient2ProxyReqPayment
     * @property {number|null} [UserID] Client2ProxyReqPayment UserID
     * @property {Uint8Array|null} [PaymentJson] Client2ProxyReqPayment PaymentJson
     */

    /**
     * Constructs a new Client2ProxyReqPayment.
     * @exports Client2ProxyReqPayment
     * @classdesc Represents a Client2ProxyReqPayment.
     * @implements IClient2ProxyReqPayment
     * @constructor
     * @param {IClient2ProxyReqPayment=} [properties] Properties to set
     */
    function Client2ProxyReqPayment(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqPayment UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqPayment
     * @instance
     */
    Client2ProxyReqPayment.prototype.UserID = 0;

    /**
     * Client2ProxyReqPayment PaymentJson.
     * @member {Uint8Array} PaymentJson
     * @memberof Client2ProxyReqPayment
     * @instance
     */
    Client2ProxyReqPayment.prototype.PaymentJson = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyReqPayment instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {IClient2ProxyReqPayment=} [properties] Properties to set
     * @returns {Client2ProxyReqPayment} Client2ProxyReqPayment instance
     */
    Client2ProxyReqPayment.create = function create(properties) {
        return new Client2ProxyReqPayment(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqPayment message. Does not implicitly {@link Client2ProxyReqPayment.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {IClient2ProxyReqPayment} message Client2ProxyReqPayment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPayment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PaymentJson != null && Object.hasOwnProperty.call(message, "PaymentJson"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.PaymentJson);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqPayment message, length delimited. Does not implicitly {@link Client2ProxyReqPayment.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {IClient2ProxyReqPayment} message Client2ProxyReqPayment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqPayment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqPayment message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqPayment} Client2ProxyReqPayment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPayment.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqPayment();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.PaymentJson = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqPayment message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqPayment} Client2ProxyReqPayment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqPayment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqPayment message.
     * @function verify
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqPayment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PaymentJson != null && message.hasOwnProperty("PaymentJson"))
            if (!(message.PaymentJson && typeof message.PaymentJson.length === "number" || $util.isString(message.PaymentJson)))
                return "PaymentJson: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqPayment message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqPayment} Client2ProxyReqPayment
     */
    Client2ProxyReqPayment.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqPayment)
            return object;
        let message = new $root.Client2ProxyReqPayment();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PaymentJson != null)
            if (typeof object.PaymentJson === "string")
                $util.base64.decode(object.PaymentJson, message.PaymentJson = $util.newBuffer($util.base64.length(object.PaymentJson)), 0);
            else if (object.PaymentJson.length >= 0)
                message.PaymentJson = object.PaymentJson;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqPayment message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {Client2ProxyReqPayment} message Client2ProxyReqPayment
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqPayment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.PaymentJson = "";
            else {
                object.PaymentJson = [];
                if (options.bytes !== Array)
                    object.PaymentJson = $util.newBuffer(object.PaymentJson);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PaymentJson != null && message.hasOwnProperty("PaymentJson"))
            object.PaymentJson = options.bytes === String ? $util.base64.encode(message.PaymentJson, 0, message.PaymentJson.length) : options.bytes === Array ? Array.prototype.slice.call(message.PaymentJson) : message.PaymentJson;
        return object;
    };

    /**
     * Converts this Client2ProxyReqPayment to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqPayment
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqPayment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqPayment
     * @function getTypeUrl
     * @memberof Client2ProxyReqPayment
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqPayment";
    };

    return Client2ProxyReqPayment;
})();

export const Client2ProxyAckPayment = $root.Client2ProxyAckPayment = (() => {

    /**
     * Properties of a Client2ProxyAckPayment.
     * @exports IClient2ProxyAckPayment
     * @interface IClient2ProxyAckPayment
     * @property {number|null} [Ret] Client2ProxyAckPayment Ret
     * @property {number|null} [UserID] Client2ProxyAckPayment UserID
     * @property {Uint8Array|null} [PaymentJson] Client2ProxyAckPayment PaymentJson
     */

    /**
     * Constructs a new Client2ProxyAckPayment.
     * @exports Client2ProxyAckPayment
     * @classdesc Represents a Client2ProxyAckPayment.
     * @implements IClient2ProxyAckPayment
     * @constructor
     * @param {IClient2ProxyAckPayment=} [properties] Properties to set
     */
    function Client2ProxyAckPayment(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckPayment Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckPayment
     * @instance
     */
    Client2ProxyAckPayment.prototype.Ret = 0;

    /**
     * Client2ProxyAckPayment UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckPayment
     * @instance
     */
    Client2ProxyAckPayment.prototype.UserID = 0;

    /**
     * Client2ProxyAckPayment PaymentJson.
     * @member {Uint8Array} PaymentJson
     * @memberof Client2ProxyAckPayment
     * @instance
     */
    Client2ProxyAckPayment.prototype.PaymentJson = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckPayment instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {IClient2ProxyAckPayment=} [properties] Properties to set
     * @returns {Client2ProxyAckPayment} Client2ProxyAckPayment instance
     */
    Client2ProxyAckPayment.create = function create(properties) {
        return new Client2ProxyAckPayment(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckPayment message. Does not implicitly {@link Client2ProxyAckPayment.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {IClient2ProxyAckPayment} message Client2ProxyAckPayment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPayment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.PaymentJson != null && Object.hasOwnProperty.call(message, "PaymentJson"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.PaymentJson);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckPayment message, length delimited. Does not implicitly {@link Client2ProxyAckPayment.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {IClient2ProxyAckPayment} message Client2ProxyAckPayment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckPayment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckPayment message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckPayment} Client2ProxyAckPayment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPayment.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckPayment();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.PaymentJson = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckPayment message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckPayment} Client2ProxyAckPayment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckPayment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckPayment message.
     * @function verify
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckPayment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PaymentJson != null && message.hasOwnProperty("PaymentJson"))
            if (!(message.PaymentJson && typeof message.PaymentJson.length === "number" || $util.isString(message.PaymentJson)))
                return "PaymentJson: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckPayment message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckPayment} Client2ProxyAckPayment
     */
    Client2ProxyAckPayment.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckPayment)
            return object;
        let message = new $root.Client2ProxyAckPayment();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PaymentJson != null)
            if (typeof object.PaymentJson === "string")
                $util.base64.decode(object.PaymentJson, message.PaymentJson = $util.newBuffer($util.base64.length(object.PaymentJson)), 0);
            else if (object.PaymentJson.length >= 0)
                message.PaymentJson = object.PaymentJson;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckPayment message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {Client2ProxyAckPayment} message Client2ProxyAckPayment
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckPayment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.PaymentJson = "";
            else {
                object.PaymentJson = [];
                if (options.bytes !== Array)
                    object.PaymentJson = $util.newBuffer(object.PaymentJson);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PaymentJson != null && message.hasOwnProperty("PaymentJson"))
            object.PaymentJson = options.bytes === String ? $util.base64.encode(message.PaymentJson, 0, message.PaymentJson.length) : options.bytes === Array ? Array.prototype.slice.call(message.PaymentJson) : message.PaymentJson;
        return object;
    };

    /**
     * Converts this Client2ProxyAckPayment to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckPayment
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckPayment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckPayment
     * @function getTypeUrl
     * @memberof Client2ProxyAckPayment
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckPayment";
    };

    return Client2ProxyAckPayment;
})();

export const Client2ProxyReqRazorPayKey = $root.Client2ProxyReqRazorPayKey = (() => {

    /**
     * Properties of a Client2ProxyReqRazorPayKey.
     * @exports IClient2ProxyReqRazorPayKey
     * @interface IClient2ProxyReqRazorPayKey
     * @property {number|null} [UserID] Client2ProxyReqRazorPayKey UserID
     */

    /**
     * Constructs a new Client2ProxyReqRazorPayKey.
     * @exports Client2ProxyReqRazorPayKey
     * @classdesc Represents a Client2ProxyReqRazorPayKey.
     * @implements IClient2ProxyReqRazorPayKey
     * @constructor
     * @param {IClient2ProxyReqRazorPayKey=} [properties] Properties to set
     */
    function Client2ProxyReqRazorPayKey(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqRazorPayKey UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqRazorPayKey
     * @instance
     */
    Client2ProxyReqRazorPayKey.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqRazorPayKey instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {IClient2ProxyReqRazorPayKey=} [properties] Properties to set
     * @returns {Client2ProxyReqRazorPayKey} Client2ProxyReqRazorPayKey instance
     */
    Client2ProxyReqRazorPayKey.create = function create(properties) {
        return new Client2ProxyReqRazorPayKey(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqRazorPayKey message. Does not implicitly {@link Client2ProxyReqRazorPayKey.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {IClient2ProxyReqRazorPayKey} message Client2ProxyReqRazorPayKey message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRazorPayKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqRazorPayKey message, length delimited. Does not implicitly {@link Client2ProxyReqRazorPayKey.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {IClient2ProxyReqRazorPayKey} message Client2ProxyReqRazorPayKey message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRazorPayKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqRazorPayKey message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqRazorPayKey} Client2ProxyReqRazorPayKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRazorPayKey.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqRazorPayKey();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqRazorPayKey message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqRazorPayKey} Client2ProxyReqRazorPayKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRazorPayKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqRazorPayKey message.
     * @function verify
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqRazorPayKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqRazorPayKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqRazorPayKey} Client2ProxyReqRazorPayKey
     */
    Client2ProxyReqRazorPayKey.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqRazorPayKey)
            return object;
        let message = new $root.Client2ProxyReqRazorPayKey();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqRazorPayKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {Client2ProxyReqRazorPayKey} message Client2ProxyReqRazorPayKey
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqRazorPayKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqRazorPayKey to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqRazorPayKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqRazorPayKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqRazorPayKey
     * @function getTypeUrl
     * @memberof Client2ProxyReqRazorPayKey
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqRazorPayKey.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqRazorPayKey";
    };

    return Client2ProxyReqRazorPayKey;
})();

export const Client2ProxyAckRazorPayKey = $root.Client2ProxyAckRazorPayKey = (() => {

    /**
     * Properties of a Client2ProxyAckRazorPayKey.
     * @exports IClient2ProxyAckRazorPayKey
     * @interface IClient2ProxyAckRazorPayKey
     * @property {number|null} [Ret] Client2ProxyAckRazorPayKey Ret
     * @property {number|null} [UserID] Client2ProxyAckRazorPayKey UserID
     * @property {Uint8Array|null} [AppKeyID] Client2ProxyAckRazorPayKey AppKeyID
     * @property {Uint8Array|null} [AppKeySecret] Client2ProxyAckRazorPayKey AppKeySecret
     */

    /**
     * Constructs a new Client2ProxyAckRazorPayKey.
     * @exports Client2ProxyAckRazorPayKey
     * @classdesc Represents a Client2ProxyAckRazorPayKey.
     * @implements IClient2ProxyAckRazorPayKey
     * @constructor
     * @param {IClient2ProxyAckRazorPayKey=} [properties] Properties to set
     */
    function Client2ProxyAckRazorPayKey(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckRazorPayKey Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckRazorPayKey
     * @instance
     */
    Client2ProxyAckRazorPayKey.prototype.Ret = 0;

    /**
     * Client2ProxyAckRazorPayKey UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckRazorPayKey
     * @instance
     */
    Client2ProxyAckRazorPayKey.prototype.UserID = 0;

    /**
     * Client2ProxyAckRazorPayKey AppKeyID.
     * @member {Uint8Array} AppKeyID
     * @memberof Client2ProxyAckRazorPayKey
     * @instance
     */
    Client2ProxyAckRazorPayKey.prototype.AppKeyID = $util.newBuffer([]);

    /**
     * Client2ProxyAckRazorPayKey AppKeySecret.
     * @member {Uint8Array} AppKeySecret
     * @memberof Client2ProxyAckRazorPayKey
     * @instance
     */
    Client2ProxyAckRazorPayKey.prototype.AppKeySecret = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckRazorPayKey instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {IClient2ProxyAckRazorPayKey=} [properties] Properties to set
     * @returns {Client2ProxyAckRazorPayKey} Client2ProxyAckRazorPayKey instance
     */
    Client2ProxyAckRazorPayKey.create = function create(properties) {
        return new Client2ProxyAckRazorPayKey(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckRazorPayKey message. Does not implicitly {@link Client2ProxyAckRazorPayKey.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {IClient2ProxyAckRazorPayKey} message Client2ProxyAckRazorPayKey message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRazorPayKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.AppKeyID != null && Object.hasOwnProperty.call(message, "AppKeyID"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.AppKeyID);
        if (message.AppKeySecret != null && Object.hasOwnProperty.call(message, "AppKeySecret"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.AppKeySecret);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckRazorPayKey message, length delimited. Does not implicitly {@link Client2ProxyAckRazorPayKey.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {IClient2ProxyAckRazorPayKey} message Client2ProxyAckRazorPayKey message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRazorPayKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckRazorPayKey message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckRazorPayKey} Client2ProxyAckRazorPayKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRazorPayKey.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckRazorPayKey();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.AppKeyID = reader.bytes();
                    break;
                }
            case 4: {
                    message.AppKeySecret = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckRazorPayKey message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckRazorPayKey} Client2ProxyAckRazorPayKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRazorPayKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckRazorPayKey message.
     * @function verify
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckRazorPayKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.AppKeyID != null && message.hasOwnProperty("AppKeyID"))
            if (!(message.AppKeyID && typeof message.AppKeyID.length === "number" || $util.isString(message.AppKeyID)))
                return "AppKeyID: buffer expected";
        if (message.AppKeySecret != null && message.hasOwnProperty("AppKeySecret"))
            if (!(message.AppKeySecret && typeof message.AppKeySecret.length === "number" || $util.isString(message.AppKeySecret)))
                return "AppKeySecret: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckRazorPayKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckRazorPayKey} Client2ProxyAckRazorPayKey
     */
    Client2ProxyAckRazorPayKey.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckRazorPayKey)
            return object;
        let message = new $root.Client2ProxyAckRazorPayKey();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.AppKeyID != null)
            if (typeof object.AppKeyID === "string")
                $util.base64.decode(object.AppKeyID, message.AppKeyID = $util.newBuffer($util.base64.length(object.AppKeyID)), 0);
            else if (object.AppKeyID.length >= 0)
                message.AppKeyID = object.AppKeyID;
        if (object.AppKeySecret != null)
            if (typeof object.AppKeySecret === "string")
                $util.base64.decode(object.AppKeySecret, message.AppKeySecret = $util.newBuffer($util.base64.length(object.AppKeySecret)), 0);
            else if (object.AppKeySecret.length >= 0)
                message.AppKeySecret = object.AppKeySecret;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckRazorPayKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {Client2ProxyAckRazorPayKey} message Client2ProxyAckRazorPayKey
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckRazorPayKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.AppKeyID = "";
            else {
                object.AppKeyID = [];
                if (options.bytes !== Array)
                    object.AppKeyID = $util.newBuffer(object.AppKeyID);
            }
            if (options.bytes === String)
                object.AppKeySecret = "";
            else {
                object.AppKeySecret = [];
                if (options.bytes !== Array)
                    object.AppKeySecret = $util.newBuffer(object.AppKeySecret);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.AppKeyID != null && message.hasOwnProperty("AppKeyID"))
            object.AppKeyID = options.bytes === String ? $util.base64.encode(message.AppKeyID, 0, message.AppKeyID.length) : options.bytes === Array ? Array.prototype.slice.call(message.AppKeyID) : message.AppKeyID;
        if (message.AppKeySecret != null && message.hasOwnProperty("AppKeySecret"))
            object.AppKeySecret = options.bytes === String ? $util.base64.encode(message.AppKeySecret, 0, message.AppKeySecret.length) : options.bytes === Array ? Array.prototype.slice.call(message.AppKeySecret) : message.AppKeySecret;
        return object;
    };

    /**
     * Converts this Client2ProxyAckRazorPayKey to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckRazorPayKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckRazorPayKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckRazorPayKey
     * @function getTypeUrl
     * @memberof Client2ProxyAckRazorPayKey
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckRazorPayKey.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckRazorPayKey";
    };

    return Client2ProxyAckRazorPayKey;
})();

export const Client2ProxyReqRazorPayOrderID = $root.Client2ProxyReqRazorPayOrderID = (() => {

    /**
     * Properties of a Client2ProxyReqRazorPayOrderID.
     * @exports IClient2ProxyReqRazorPayOrderID
     * @interface IClient2ProxyReqRazorPayOrderID
     * @property {number|null} [UserID] Client2ProxyReqRazorPayOrderID UserID
     * @property {string|null} [Amount] Client2ProxyReqRazorPayOrderID Amount
     * @property {string|null} [Currency] Client2ProxyReqRazorPayOrderID Currency
     */

    /**
     * Constructs a new Client2ProxyReqRazorPayOrderID.
     * @exports Client2ProxyReqRazorPayOrderID
     * @classdesc Represents a Client2ProxyReqRazorPayOrderID.
     * @implements IClient2ProxyReqRazorPayOrderID
     * @constructor
     * @param {IClient2ProxyReqRazorPayOrderID=} [properties] Properties to set
     */
    function Client2ProxyReqRazorPayOrderID(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqRazorPayOrderID UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqRazorPayOrderID
     * @instance
     */
    Client2ProxyReqRazorPayOrderID.prototype.UserID = 0;

    /**
     * Client2ProxyReqRazorPayOrderID Amount.
     * @member {string} Amount
     * @memberof Client2ProxyReqRazorPayOrderID
     * @instance
     */
    Client2ProxyReqRazorPayOrderID.prototype.Amount = "";

    /**
     * Client2ProxyReqRazorPayOrderID Currency.
     * @member {string} Currency
     * @memberof Client2ProxyReqRazorPayOrderID
     * @instance
     */
    Client2ProxyReqRazorPayOrderID.prototype.Currency = "";

    /**
     * Creates a new Client2ProxyReqRazorPayOrderID instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {IClient2ProxyReqRazorPayOrderID=} [properties] Properties to set
     * @returns {Client2ProxyReqRazorPayOrderID} Client2ProxyReqRazorPayOrderID instance
     */
    Client2ProxyReqRazorPayOrderID.create = function create(properties) {
        return new Client2ProxyReqRazorPayOrderID(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqRazorPayOrderID message. Does not implicitly {@link Client2ProxyReqRazorPayOrderID.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {IClient2ProxyReqRazorPayOrderID} message Client2ProxyReqRazorPayOrderID message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRazorPayOrderID.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Amount);
        if (message.Currency != null && Object.hasOwnProperty.call(message, "Currency"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Currency);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqRazorPayOrderID message, length delimited. Does not implicitly {@link Client2ProxyReqRazorPayOrderID.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {IClient2ProxyReqRazorPayOrderID} message Client2ProxyReqRazorPayOrderID message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRazorPayOrderID.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqRazorPayOrderID message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqRazorPayOrderID} Client2ProxyReqRazorPayOrderID
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRazorPayOrderID.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqRazorPayOrderID();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Amount = reader.string();
                    break;
                }
            case 3: {
                    message.Currency = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqRazorPayOrderID message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqRazorPayOrderID} Client2ProxyReqRazorPayOrderID
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRazorPayOrderID.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqRazorPayOrderID message.
     * @function verify
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqRazorPayOrderID.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            if (!$util.isString(message.Currency))
                return "Currency: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqRazorPayOrderID message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqRazorPayOrderID} Client2ProxyReqRazorPayOrderID
     */
    Client2ProxyReqRazorPayOrderID.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqRazorPayOrderID)
            return object;
        let message = new $root.Client2ProxyReqRazorPayOrderID();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Currency != null)
            message.Currency = String(object.Currency);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqRazorPayOrderID message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {Client2ProxyReqRazorPayOrderID} message Client2ProxyReqRazorPayOrderID
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqRazorPayOrderID.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Amount = "";
            object.Currency = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            object.Currency = message.Currency;
        return object;
    };

    /**
     * Converts this Client2ProxyReqRazorPayOrderID to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqRazorPayOrderID
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqRazorPayOrderID.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqRazorPayOrderID
     * @function getTypeUrl
     * @memberof Client2ProxyReqRazorPayOrderID
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqRazorPayOrderID.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqRazorPayOrderID";
    };

    return Client2ProxyReqRazorPayOrderID;
})();

export const Client2ProxyAckRazorPayOrderID = $root.Client2ProxyAckRazorPayOrderID = (() => {

    /**
     * Properties of a Client2ProxyAckRazorPayOrderID.
     * @exports IClient2ProxyAckRazorPayOrderID
     * @interface IClient2ProxyAckRazorPayOrderID
     * @property {number|null} [Ret] Client2ProxyAckRazorPayOrderID Ret
     * @property {number|null} [UserID] Client2ProxyAckRazorPayOrderID UserID
     * @property {string|null} [Amount] Client2ProxyAckRazorPayOrderID Amount
     * @property {string|null} [Currency] Client2ProxyAckRazorPayOrderID Currency
     * @property {string|null} [Receipt] Client2ProxyAckRazorPayOrderID Receipt
     * @property {string|null} [OrderID] Client2ProxyAckRazorPayOrderID OrderID
     */

    /**
     * Constructs a new Client2ProxyAckRazorPayOrderID.
     * @exports Client2ProxyAckRazorPayOrderID
     * @classdesc Represents a Client2ProxyAckRazorPayOrderID.
     * @implements IClient2ProxyAckRazorPayOrderID
     * @constructor
     * @param {IClient2ProxyAckRazorPayOrderID=} [properties] Properties to set
     */
    function Client2ProxyAckRazorPayOrderID(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckRazorPayOrderID Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.Ret = 0;

    /**
     * Client2ProxyAckRazorPayOrderID UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.UserID = 0;

    /**
     * Client2ProxyAckRazorPayOrderID Amount.
     * @member {string} Amount
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.Amount = "";

    /**
     * Client2ProxyAckRazorPayOrderID Currency.
     * @member {string} Currency
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.Currency = "";

    /**
     * Client2ProxyAckRazorPayOrderID Receipt.
     * @member {string} Receipt
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.Receipt = "";

    /**
     * Client2ProxyAckRazorPayOrderID OrderID.
     * @member {string} OrderID
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     */
    Client2ProxyAckRazorPayOrderID.prototype.OrderID = "";

    /**
     * Creates a new Client2ProxyAckRazorPayOrderID instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {IClient2ProxyAckRazorPayOrderID=} [properties] Properties to set
     * @returns {Client2ProxyAckRazorPayOrderID} Client2ProxyAckRazorPayOrderID instance
     */
    Client2ProxyAckRazorPayOrderID.create = function create(properties) {
        return new Client2ProxyAckRazorPayOrderID(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckRazorPayOrderID message. Does not implicitly {@link Client2ProxyAckRazorPayOrderID.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {IClient2ProxyAckRazorPayOrderID} message Client2ProxyAckRazorPayOrderID message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRazorPayOrderID.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Amount != null && Object.hasOwnProperty.call(message, "Amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Amount);
        if (message.Currency != null && Object.hasOwnProperty.call(message, "Currency"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Currency);
        if (message.Receipt != null && Object.hasOwnProperty.call(message, "Receipt"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Receipt);
        if (message.OrderID != null && Object.hasOwnProperty.call(message, "OrderID"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.OrderID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckRazorPayOrderID message, length delimited. Does not implicitly {@link Client2ProxyAckRazorPayOrderID.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {IClient2ProxyAckRazorPayOrderID} message Client2ProxyAckRazorPayOrderID message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRazorPayOrderID.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckRazorPayOrderID message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckRazorPayOrderID} Client2ProxyAckRazorPayOrderID
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRazorPayOrderID.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckRazorPayOrderID();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Amount = reader.string();
                    break;
                }
            case 4: {
                    message.Currency = reader.string();
                    break;
                }
            case 5: {
                    message.Receipt = reader.string();
                    break;
                }
            case 6: {
                    message.OrderID = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckRazorPayOrderID message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckRazorPayOrderID} Client2ProxyAckRazorPayOrderID
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRazorPayOrderID.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckRazorPayOrderID message.
     * @function verify
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckRazorPayOrderID.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (!$util.isString(message.Amount))
                return "Amount: string expected";
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            if (!$util.isString(message.Currency))
                return "Currency: string expected";
        if (message.Receipt != null && message.hasOwnProperty("Receipt"))
            if (!$util.isString(message.Receipt))
                return "Receipt: string expected";
        if (message.OrderID != null && message.hasOwnProperty("OrderID"))
            if (!$util.isString(message.OrderID))
                return "OrderID: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckRazorPayOrderID message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckRazorPayOrderID} Client2ProxyAckRazorPayOrderID
     */
    Client2ProxyAckRazorPayOrderID.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckRazorPayOrderID)
            return object;
        let message = new $root.Client2ProxyAckRazorPayOrderID();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Amount != null)
            message.Amount = String(object.Amount);
        if (object.Currency != null)
            message.Currency = String(object.Currency);
        if (object.Receipt != null)
            message.Receipt = String(object.Receipt);
        if (object.OrderID != null)
            message.OrderID = String(object.OrderID);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckRazorPayOrderID message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {Client2ProxyAckRazorPayOrderID} message Client2ProxyAckRazorPayOrderID
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckRazorPayOrderID.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Amount = "";
            object.Currency = "";
            object.Receipt = "";
            object.OrderID = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = message.Amount;
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            object.Currency = message.Currency;
        if (message.Receipt != null && message.hasOwnProperty("Receipt"))
            object.Receipt = message.Receipt;
        if (message.OrderID != null && message.hasOwnProperty("OrderID"))
            object.OrderID = message.OrderID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckRazorPayOrderID to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckRazorPayOrderID
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckRazorPayOrderID.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckRazorPayOrderID
     * @function getTypeUrl
     * @memberof Client2ProxyAckRazorPayOrderID
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckRazorPayOrderID.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckRazorPayOrderID";
    };

    return Client2ProxyAckRazorPayOrderID;
})();

export const Client2ProxyReqGetMailCount = $root.Client2ProxyReqGetMailCount = (() => {

    /**
     * Properties of a Client2ProxyReqGetMailCount.
     * @exports IClient2ProxyReqGetMailCount
     * @interface IClient2ProxyReqGetMailCount
     * @property {number|null} [UserID] Client2ProxyReqGetMailCount UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetMailCount.
     * @exports Client2ProxyReqGetMailCount
     * @classdesc Represents a Client2ProxyReqGetMailCount.
     * @implements IClient2ProxyReqGetMailCount
     * @constructor
     * @param {IClient2ProxyReqGetMailCount=} [properties] Properties to set
     */
    function Client2ProxyReqGetMailCount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetMailCount UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetMailCount
     * @instance
     */
    Client2ProxyReqGetMailCount.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetMailCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {IClient2ProxyReqGetMailCount=} [properties] Properties to set
     * @returns {Client2ProxyReqGetMailCount} Client2ProxyReqGetMailCount instance
     */
    Client2ProxyReqGetMailCount.create = function create(properties) {
        return new Client2ProxyReqGetMailCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailCount message. Does not implicitly {@link Client2ProxyReqGetMailCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {IClient2ProxyReqGetMailCount} message Client2ProxyReqGetMailCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailCount message, length delimited. Does not implicitly {@link Client2ProxyReqGetMailCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {IClient2ProxyReqGetMailCount} message Client2ProxyReqGetMailCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetMailCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetMailCount} Client2ProxyReqGetMailCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetMailCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetMailCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetMailCount} Client2ProxyReqGetMailCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetMailCount message.
     * @function verify
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetMailCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetMailCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetMailCount} Client2ProxyReqGetMailCount
     */
    Client2ProxyReqGetMailCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetMailCount)
            return object;
        let message = new $root.Client2ProxyReqGetMailCount();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetMailCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {Client2ProxyReqGetMailCount} message Client2ProxyReqGetMailCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetMailCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetMailCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetMailCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetMailCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetMailCount
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetMailCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetMailCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetMailCount";
    };

    return Client2ProxyReqGetMailCount;
})();

export const Client2ProxyAckGetMailCount = $root.Client2ProxyAckGetMailCount = (() => {

    /**
     * Properties of a Client2ProxyAckGetMailCount.
     * @exports IClient2ProxyAckGetMailCount
     * @interface IClient2ProxyAckGetMailCount
     * @property {number|null} [Ret] Client2ProxyAckGetMailCount Ret
     * @property {number|null} [MailCount] Client2ProxyAckGetMailCount MailCount
     * @property {number|null} [UserID] Client2ProxyAckGetMailCount UserID
     */

    /**
     * Constructs a new Client2ProxyAckGetMailCount.
     * @exports Client2ProxyAckGetMailCount
     * @classdesc Represents a Client2ProxyAckGetMailCount.
     * @implements IClient2ProxyAckGetMailCount
     * @constructor
     * @param {IClient2ProxyAckGetMailCount=} [properties] Properties to set
     */
    function Client2ProxyAckGetMailCount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetMailCount Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetMailCount
     * @instance
     */
    Client2ProxyAckGetMailCount.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetMailCount MailCount.
     * @member {number} MailCount
     * @memberof Client2ProxyAckGetMailCount
     * @instance
     */
    Client2ProxyAckGetMailCount.prototype.MailCount = 0;

    /**
     * Client2ProxyAckGetMailCount UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetMailCount
     * @instance
     */
    Client2ProxyAckGetMailCount.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckGetMailCount instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {IClient2ProxyAckGetMailCount=} [properties] Properties to set
     * @returns {Client2ProxyAckGetMailCount} Client2ProxyAckGetMailCount instance
     */
    Client2ProxyAckGetMailCount.create = function create(properties) {
        return new Client2ProxyAckGetMailCount(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailCount message. Does not implicitly {@link Client2ProxyAckGetMailCount.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {IClient2ProxyAckGetMailCount} message Client2ProxyAckGetMailCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailCount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.MailCount != null && Object.hasOwnProperty.call(message, "MailCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MailCount);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailCount message, length delimited. Does not implicitly {@link Client2ProxyAckGetMailCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {IClient2ProxyAckGetMailCount} message Client2ProxyAckGetMailCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetMailCount message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetMailCount} Client2ProxyAckGetMailCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailCount.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetMailCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.MailCount = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetMailCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetMailCount} Client2ProxyAckGetMailCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetMailCount message.
     * @function verify
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetMailCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.MailCount != null && message.hasOwnProperty("MailCount"))
            if (!$util.isInteger(message.MailCount))
                return "MailCount: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetMailCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetMailCount} Client2ProxyAckGetMailCount
     */
    Client2ProxyAckGetMailCount.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetMailCount)
            return object;
        let message = new $root.Client2ProxyAckGetMailCount();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.MailCount != null)
            message.MailCount = object.MailCount >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetMailCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {Client2ProxyAckGetMailCount} message Client2ProxyAckGetMailCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetMailCount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.MailCount = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.MailCount != null && message.hasOwnProperty("MailCount"))
            object.MailCount = message.MailCount;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetMailCount to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetMailCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetMailCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetMailCount
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetMailCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetMailCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetMailCount";
    };

    return Client2ProxyAckGetMailCount;
})();

export const Client2ProxyReqGetMailList = $root.Client2ProxyReqGetMailList = (() => {

    /**
     * Properties of a Client2ProxyReqGetMailList.
     * @exports IClient2ProxyReqGetMailList
     * @interface IClient2ProxyReqGetMailList
     * @property {number|null} [UserID] Client2ProxyReqGetMailList UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetMailList.
     * @exports Client2ProxyReqGetMailList
     * @classdesc Represents a Client2ProxyReqGetMailList.
     * @implements IClient2ProxyReqGetMailList
     * @constructor
     * @param {IClient2ProxyReqGetMailList=} [properties] Properties to set
     */
    function Client2ProxyReqGetMailList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetMailList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetMailList
     * @instance
     */
    Client2ProxyReqGetMailList.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetMailList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {IClient2ProxyReqGetMailList=} [properties] Properties to set
     * @returns {Client2ProxyReqGetMailList} Client2ProxyReqGetMailList instance
     */
    Client2ProxyReqGetMailList.create = function create(properties) {
        return new Client2ProxyReqGetMailList(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailList message. Does not implicitly {@link Client2ProxyReqGetMailList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {IClient2ProxyReqGetMailList} message Client2ProxyReqGetMailList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailList message, length delimited. Does not implicitly {@link Client2ProxyReqGetMailList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {IClient2ProxyReqGetMailList} message Client2ProxyReqGetMailList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetMailList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetMailList} Client2ProxyReqGetMailList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetMailList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetMailList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetMailList} Client2ProxyReqGetMailList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetMailList message.
     * @function verify
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetMailList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetMailList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetMailList} Client2ProxyReqGetMailList
     */
    Client2ProxyReqGetMailList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetMailList)
            return object;
        let message = new $root.Client2ProxyReqGetMailList();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetMailList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {Client2ProxyReqGetMailList} message Client2ProxyReqGetMailList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetMailList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetMailList to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetMailList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetMailList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetMailList
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetMailList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetMailList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetMailList";
    };

    return Client2ProxyReqGetMailList;
})();

export const MailBriefInfo = $root.MailBriefInfo = (() => {

    /**
     * Properties of a MailBriefInfo.
     * @exports IMailBriefInfo
     * @interface IMailBriefInfo
     * @property {number|null} [MailId] MailBriefInfo MailId
     * @property {number|null} [MailStatus] MailBriefInfo MailStatus
     * @property {Uint8Array|null} [MailTitle] MailBriefInfo MailTitle
     * @property {Uint8Array|null} [MailSubTitle] MailBriefInfo MailSubTitle
     * @property {Uint8Array|null} [JsonParameter] MailBriefInfo JsonParameter
     */

    /**
     * Constructs a new MailBriefInfo.
     * @exports MailBriefInfo
     * @classdesc Represents a MailBriefInfo.
     * @implements IMailBriefInfo
     * @constructor
     * @param {IMailBriefInfo=} [properties] Properties to set
     */
    function MailBriefInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MailBriefInfo MailId.
     * @member {number} MailId
     * @memberof MailBriefInfo
     * @instance
     */
    MailBriefInfo.prototype.MailId = 0;

    /**
     * MailBriefInfo MailStatus.
     * @member {number} MailStatus
     * @memberof MailBriefInfo
     * @instance
     */
    MailBriefInfo.prototype.MailStatus = 0;

    /**
     * MailBriefInfo MailTitle.
     * @member {Uint8Array} MailTitle
     * @memberof MailBriefInfo
     * @instance
     */
    MailBriefInfo.prototype.MailTitle = $util.newBuffer([]);

    /**
     * MailBriefInfo MailSubTitle.
     * @member {Uint8Array} MailSubTitle
     * @memberof MailBriefInfo
     * @instance
     */
    MailBriefInfo.prototype.MailSubTitle = $util.newBuffer([]);

    /**
     * MailBriefInfo JsonParameter.
     * @member {Uint8Array} JsonParameter
     * @memberof MailBriefInfo
     * @instance
     */
    MailBriefInfo.prototype.JsonParameter = $util.newBuffer([]);

    /**
     * Creates a new MailBriefInfo instance using the specified properties.
     * @function create
     * @memberof MailBriefInfo
     * @static
     * @param {IMailBriefInfo=} [properties] Properties to set
     * @returns {MailBriefInfo} MailBriefInfo instance
     */
    MailBriefInfo.create = function create(properties) {
        return new MailBriefInfo(properties);
    };

    /**
     * Encodes the specified MailBriefInfo message. Does not implicitly {@link MailBriefInfo.verify|verify} messages.
     * @function encode
     * @memberof MailBriefInfo
     * @static
     * @param {IMailBriefInfo} message MailBriefInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MailBriefInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.MailId != null && Object.hasOwnProperty.call(message, "MailId"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MailId);
        if (message.MailStatus != null && Object.hasOwnProperty.call(message, "MailStatus"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MailStatus);
        if (message.MailTitle != null && Object.hasOwnProperty.call(message, "MailTitle"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.MailTitle);
        if (message.MailSubTitle != null && Object.hasOwnProperty.call(message, "MailSubTitle"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.MailSubTitle);
        if (message.JsonParameter != null && Object.hasOwnProperty.call(message, "JsonParameter"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.JsonParameter);
        return writer;
    };

    /**
     * Encodes the specified MailBriefInfo message, length delimited. Does not implicitly {@link MailBriefInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MailBriefInfo
     * @static
     * @param {IMailBriefInfo} message MailBriefInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MailBriefInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MailBriefInfo message from the specified reader or buffer.
     * @function decode
     * @memberof MailBriefInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MailBriefInfo} MailBriefInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MailBriefInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MailBriefInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.MailId = reader.uint32();
                    break;
                }
            case 2: {
                    message.MailStatus = reader.uint32();
                    break;
                }
            case 3: {
                    message.MailTitle = reader.bytes();
                    break;
                }
            case 4: {
                    message.MailSubTitle = reader.bytes();
                    break;
                }
            case 5: {
                    message.JsonParameter = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MailBriefInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MailBriefInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MailBriefInfo} MailBriefInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MailBriefInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MailBriefInfo message.
     * @function verify
     * @memberof MailBriefInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MailBriefInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.MailId != null && message.hasOwnProperty("MailId"))
            if (!$util.isInteger(message.MailId))
                return "MailId: integer expected";
        if (message.MailStatus != null && message.hasOwnProperty("MailStatus"))
            if (!$util.isInteger(message.MailStatus))
                return "MailStatus: integer expected";
        if (message.MailTitle != null && message.hasOwnProperty("MailTitle"))
            if (!(message.MailTitle && typeof message.MailTitle.length === "number" || $util.isString(message.MailTitle)))
                return "MailTitle: buffer expected";
        if (message.MailSubTitle != null && message.hasOwnProperty("MailSubTitle"))
            if (!(message.MailSubTitle && typeof message.MailSubTitle.length === "number" || $util.isString(message.MailSubTitle)))
                return "MailSubTitle: buffer expected";
        if (message.JsonParameter != null && message.hasOwnProperty("JsonParameter"))
            if (!(message.JsonParameter && typeof message.JsonParameter.length === "number" || $util.isString(message.JsonParameter)))
                return "JsonParameter: buffer expected";
        return null;
    };

    /**
     * Creates a MailBriefInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MailBriefInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MailBriefInfo} MailBriefInfo
     */
    MailBriefInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.MailBriefInfo)
            return object;
        let message = new $root.MailBriefInfo();
        if (object.MailId != null)
            message.MailId = object.MailId >>> 0;
        if (object.MailStatus != null)
            message.MailStatus = object.MailStatus >>> 0;
        if (object.MailTitle != null)
            if (typeof object.MailTitle === "string")
                $util.base64.decode(object.MailTitle, message.MailTitle = $util.newBuffer($util.base64.length(object.MailTitle)), 0);
            else if (object.MailTitle.length >= 0)
                message.MailTitle = object.MailTitle;
        if (object.MailSubTitle != null)
            if (typeof object.MailSubTitle === "string")
                $util.base64.decode(object.MailSubTitle, message.MailSubTitle = $util.newBuffer($util.base64.length(object.MailSubTitle)), 0);
            else if (object.MailSubTitle.length >= 0)
                message.MailSubTitle = object.MailSubTitle;
        if (object.JsonParameter != null)
            if (typeof object.JsonParameter === "string")
                $util.base64.decode(object.JsonParameter, message.JsonParameter = $util.newBuffer($util.base64.length(object.JsonParameter)), 0);
            else if (object.JsonParameter.length >= 0)
                message.JsonParameter = object.JsonParameter;
        return message;
    };

    /**
     * Creates a plain object from a MailBriefInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MailBriefInfo
     * @static
     * @param {MailBriefInfo} message MailBriefInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MailBriefInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.MailId = 0;
            object.MailStatus = 0;
            if (options.bytes === String)
                object.MailTitle = "";
            else {
                object.MailTitle = [];
                if (options.bytes !== Array)
                    object.MailTitle = $util.newBuffer(object.MailTitle);
            }
            if (options.bytes === String)
                object.MailSubTitle = "";
            else {
                object.MailSubTitle = [];
                if (options.bytes !== Array)
                    object.MailSubTitle = $util.newBuffer(object.MailSubTitle);
            }
            if (options.bytes === String)
                object.JsonParameter = "";
            else {
                object.JsonParameter = [];
                if (options.bytes !== Array)
                    object.JsonParameter = $util.newBuffer(object.JsonParameter);
            }
        }
        if (message.MailId != null && message.hasOwnProperty("MailId"))
            object.MailId = message.MailId;
        if (message.MailStatus != null && message.hasOwnProperty("MailStatus"))
            object.MailStatus = message.MailStatus;
        if (message.MailTitle != null && message.hasOwnProperty("MailTitle"))
            object.MailTitle = options.bytes === String ? $util.base64.encode(message.MailTitle, 0, message.MailTitle.length) : options.bytes === Array ? Array.prototype.slice.call(message.MailTitle) : message.MailTitle;
        if (message.MailSubTitle != null && message.hasOwnProperty("MailSubTitle"))
            object.MailSubTitle = options.bytes === String ? $util.base64.encode(message.MailSubTitle, 0, message.MailSubTitle.length) : options.bytes === Array ? Array.prototype.slice.call(message.MailSubTitle) : message.MailSubTitle;
        if (message.JsonParameter != null && message.hasOwnProperty("JsonParameter"))
            object.JsonParameter = options.bytes === String ? $util.base64.encode(message.JsonParameter, 0, message.JsonParameter.length) : options.bytes === Array ? Array.prototype.slice.call(message.JsonParameter) : message.JsonParameter;
        return object;
    };

    /**
     * Converts this MailBriefInfo to JSON.
     * @function toJSON
     * @memberof MailBriefInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MailBriefInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MailBriefInfo
     * @function getTypeUrl
     * @memberof MailBriefInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MailBriefInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MailBriefInfo";
    };

    return MailBriefInfo;
})();

export const Client2ProxyAckGetMailList = $root.Client2ProxyAckGetMailList = (() => {

    /**
     * Properties of a Client2ProxyAckGetMailList.
     * @exports IClient2ProxyAckGetMailList
     * @interface IClient2ProxyAckGetMailList
     * @property {number|null} [Ret] Client2ProxyAckGetMailList Ret
     * @property {Array.<IMailBriefInfo>|null} [MailListInfo] Client2ProxyAckGetMailList MailListInfo
     * @property {number|null} [UserID] Client2ProxyAckGetMailList UserID
     * @property {number|null} [FirstMailType] Client2ProxyAckGetMailList FirstMailType
     * @property {Uint8Array|null} [SendTime] Client2ProxyAckGetMailList SendTime
     */

    /**
     * Constructs a new Client2ProxyAckGetMailList.
     * @exports Client2ProxyAckGetMailList
     * @classdesc Represents a Client2ProxyAckGetMailList.
     * @implements IClient2ProxyAckGetMailList
     * @constructor
     * @param {IClient2ProxyAckGetMailList=} [properties] Properties to set
     */
    function Client2ProxyAckGetMailList(properties) {
        this.MailListInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetMailList Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetMailList
     * @instance
     */
    Client2ProxyAckGetMailList.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetMailList MailListInfo.
     * @member {Array.<IMailBriefInfo>} MailListInfo
     * @memberof Client2ProxyAckGetMailList
     * @instance
     */
    Client2ProxyAckGetMailList.prototype.MailListInfo = $util.emptyArray;

    /**
     * Client2ProxyAckGetMailList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetMailList
     * @instance
     */
    Client2ProxyAckGetMailList.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetMailList FirstMailType.
     * @member {number} FirstMailType
     * @memberof Client2ProxyAckGetMailList
     * @instance
     */
    Client2ProxyAckGetMailList.prototype.FirstMailType = 0;

    /**
     * Client2ProxyAckGetMailList SendTime.
     * @member {Uint8Array} SendTime
     * @memberof Client2ProxyAckGetMailList
     * @instance
     */
    Client2ProxyAckGetMailList.prototype.SendTime = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckGetMailList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {IClient2ProxyAckGetMailList=} [properties] Properties to set
     * @returns {Client2ProxyAckGetMailList} Client2ProxyAckGetMailList instance
     */
    Client2ProxyAckGetMailList.create = function create(properties) {
        return new Client2ProxyAckGetMailList(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailList message. Does not implicitly {@link Client2ProxyAckGetMailList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {IClient2ProxyAckGetMailList} message Client2ProxyAckGetMailList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.MailListInfo != null && message.MailListInfo.length)
            for (let i = 0; i < message.MailListInfo.length; ++i)
                $root.MailBriefInfo.encode(message.MailListInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.FirstMailType != null && Object.hasOwnProperty.call(message, "FirstMailType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.FirstMailType);
        if (message.SendTime != null && Object.hasOwnProperty.call(message, "SendTime"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.SendTime);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailList message, length delimited. Does not implicitly {@link Client2ProxyAckGetMailList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {IClient2ProxyAckGetMailList} message Client2ProxyAckGetMailList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetMailList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetMailList} Client2ProxyAckGetMailList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetMailList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.MailListInfo && message.MailListInfo.length))
                        message.MailListInfo = [];
                    message.MailListInfo.push($root.MailBriefInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.FirstMailType = reader.uint32();
                    break;
                }
            case 5: {
                    message.SendTime = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetMailList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetMailList} Client2ProxyAckGetMailList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetMailList message.
     * @function verify
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetMailList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.MailListInfo != null && message.hasOwnProperty("MailListInfo")) {
            if (!Array.isArray(message.MailListInfo))
                return "MailListInfo: array expected";
            for (let i = 0; i < message.MailListInfo.length; ++i) {
                let error = $root.MailBriefInfo.verify(message.MailListInfo[i]);
                if (error)
                    return "MailListInfo." + error;
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.FirstMailType != null && message.hasOwnProperty("FirstMailType"))
            if (!$util.isInteger(message.FirstMailType))
                return "FirstMailType: integer expected";
        if (message.SendTime != null && message.hasOwnProperty("SendTime"))
            if (!(message.SendTime && typeof message.SendTime.length === "number" || $util.isString(message.SendTime)))
                return "SendTime: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetMailList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetMailList} Client2ProxyAckGetMailList
     */
    Client2ProxyAckGetMailList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetMailList)
            return object;
        let message = new $root.Client2ProxyAckGetMailList();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.MailListInfo) {
            if (!Array.isArray(object.MailListInfo))
                throw TypeError(".Client2ProxyAckGetMailList.MailListInfo: array expected");
            message.MailListInfo = [];
            for (let i = 0; i < object.MailListInfo.length; ++i) {
                if (typeof object.MailListInfo[i] !== "object")
                    throw TypeError(".Client2ProxyAckGetMailList.MailListInfo: object expected");
                message.MailListInfo[i] = $root.MailBriefInfo.fromObject(object.MailListInfo[i]);
            }
        }
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.FirstMailType != null)
            message.FirstMailType = object.FirstMailType >>> 0;
        if (object.SendTime != null)
            if (typeof object.SendTime === "string")
                $util.base64.decode(object.SendTime, message.SendTime = $util.newBuffer($util.base64.length(object.SendTime)), 0);
            else if (object.SendTime.length >= 0)
                message.SendTime = object.SendTime;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetMailList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {Client2ProxyAckGetMailList} message Client2ProxyAckGetMailList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetMailList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.MailListInfo = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.FirstMailType = 0;
            if (options.bytes === String)
                object.SendTime = "";
            else {
                object.SendTime = [];
                if (options.bytes !== Array)
                    object.SendTime = $util.newBuffer(object.SendTime);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.MailListInfo && message.MailListInfo.length) {
            object.MailListInfo = [];
            for (let j = 0; j < message.MailListInfo.length; ++j)
                object.MailListInfo[j] = $root.MailBriefInfo.toObject(message.MailListInfo[j], options);
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.FirstMailType != null && message.hasOwnProperty("FirstMailType"))
            object.FirstMailType = message.FirstMailType;
        if (message.SendTime != null && message.hasOwnProperty("SendTime"))
            object.SendTime = options.bytes === String ? $util.base64.encode(message.SendTime, 0, message.SendTime.length) : options.bytes === Array ? Array.prototype.slice.call(message.SendTime) : message.SendTime;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetMailList to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetMailList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetMailList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetMailList
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetMailList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetMailList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetMailList";
    };

    return Client2ProxyAckGetMailList;
})();

export const Client2ProxyReqGetMailContent = $root.Client2ProxyReqGetMailContent = (() => {

    /**
     * Properties of a Client2ProxyReqGetMailContent.
     * @exports IClient2ProxyReqGetMailContent
     * @interface IClient2ProxyReqGetMailContent
     * @property {number|null} [UserID] Client2ProxyReqGetMailContent UserID
     * @property {number|null} [MailId] Client2ProxyReqGetMailContent MailId
     */

    /**
     * Constructs a new Client2ProxyReqGetMailContent.
     * @exports Client2ProxyReqGetMailContent
     * @classdesc Represents a Client2ProxyReqGetMailContent.
     * @implements IClient2ProxyReqGetMailContent
     * @constructor
     * @param {IClient2ProxyReqGetMailContent=} [properties] Properties to set
     */
    function Client2ProxyReqGetMailContent(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetMailContent UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetMailContent
     * @instance
     */
    Client2ProxyReqGetMailContent.prototype.UserID = 0;

    /**
     * Client2ProxyReqGetMailContent MailId.
     * @member {number} MailId
     * @memberof Client2ProxyReqGetMailContent
     * @instance
     */
    Client2ProxyReqGetMailContent.prototype.MailId = 0;

    /**
     * Creates a new Client2ProxyReqGetMailContent instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {IClient2ProxyReqGetMailContent=} [properties] Properties to set
     * @returns {Client2ProxyReqGetMailContent} Client2ProxyReqGetMailContent instance
     */
    Client2ProxyReqGetMailContent.create = function create(properties) {
        return new Client2ProxyReqGetMailContent(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailContent message. Does not implicitly {@link Client2ProxyReqGetMailContent.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {IClient2ProxyReqGetMailContent} message Client2ProxyReqGetMailContent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailContent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.MailId != null && Object.hasOwnProperty.call(message, "MailId"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MailId);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetMailContent message, length delimited. Does not implicitly {@link Client2ProxyReqGetMailContent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {IClient2ProxyReqGetMailContent} message Client2ProxyReqGetMailContent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetMailContent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetMailContent message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetMailContent} Client2ProxyReqGetMailContent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailContent.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetMailContent();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.MailId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetMailContent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetMailContent} Client2ProxyReqGetMailContent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetMailContent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetMailContent message.
     * @function verify
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetMailContent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MailId != null && message.hasOwnProperty("MailId"))
            if (!$util.isInteger(message.MailId))
                return "MailId: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetMailContent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetMailContent} Client2ProxyReqGetMailContent
     */
    Client2ProxyReqGetMailContent.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetMailContent)
            return object;
        let message = new $root.Client2ProxyReqGetMailContent();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MailId != null)
            message.MailId = object.MailId >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetMailContent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {Client2ProxyReqGetMailContent} message Client2ProxyReqGetMailContent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetMailContent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.MailId = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MailId != null && message.hasOwnProperty("MailId"))
            object.MailId = message.MailId;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetMailContent to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetMailContent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetMailContent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetMailContent
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetMailContent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetMailContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetMailContent";
    };

    return Client2ProxyReqGetMailContent;
})();

export const Client2ProxyAckGetMailContent = $root.Client2ProxyAckGetMailContent = (() => {

    /**
     * Properties of a Client2ProxyAckGetMailContent.
     * @exports IClient2ProxyAckGetMailContent
     * @interface IClient2ProxyAckGetMailContent
     * @property {number|null} [Ret] Client2ProxyAckGetMailContent Ret
     * @property {IMailBriefInfo|null} [MailInfoContent] Client2ProxyAckGetMailContent MailInfoContent
     * @property {number|null} [UserID] Client2ProxyAckGetMailContent UserID
     * @property {number|null} [UnReadMailCount] Client2ProxyAckGetMailContent UnReadMailCount
     * @property {Uint8Array|null} [SendTime] Client2ProxyAckGetMailContent SendTime
     * @property {number|null} [MailType] Client2ProxyAckGetMailContent MailType
     */

    /**
     * Constructs a new Client2ProxyAckGetMailContent.
     * @exports Client2ProxyAckGetMailContent
     * @classdesc Represents a Client2ProxyAckGetMailContent.
     * @implements IClient2ProxyAckGetMailContent
     * @constructor
     * @param {IClient2ProxyAckGetMailContent=} [properties] Properties to set
     */
    function Client2ProxyAckGetMailContent(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetMailContent Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetMailContent MailInfoContent.
     * @member {IMailBriefInfo|null|undefined} MailInfoContent
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.MailInfoContent = null;

    /**
     * Client2ProxyAckGetMailContent UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetMailContent UnReadMailCount.
     * @member {number} UnReadMailCount
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.UnReadMailCount = 0;

    /**
     * Client2ProxyAckGetMailContent SendTime.
     * @member {Uint8Array} SendTime
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.SendTime = $util.newBuffer([]);

    /**
     * Client2ProxyAckGetMailContent MailType.
     * @member {number} MailType
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     */
    Client2ProxyAckGetMailContent.prototype.MailType = 0;

    /**
     * Creates a new Client2ProxyAckGetMailContent instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {IClient2ProxyAckGetMailContent=} [properties] Properties to set
     * @returns {Client2ProxyAckGetMailContent} Client2ProxyAckGetMailContent instance
     */
    Client2ProxyAckGetMailContent.create = function create(properties) {
        return new Client2ProxyAckGetMailContent(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailContent message. Does not implicitly {@link Client2ProxyAckGetMailContent.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {IClient2ProxyAckGetMailContent} message Client2ProxyAckGetMailContent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailContent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.MailInfoContent != null && Object.hasOwnProperty.call(message, "MailInfoContent"))
            $root.MailBriefInfo.encode(message.MailInfoContent, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.UnReadMailCount != null && Object.hasOwnProperty.call(message, "UnReadMailCount"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.UnReadMailCount);
        if (message.SendTime != null && Object.hasOwnProperty.call(message, "SendTime"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.SendTime);
        if (message.MailType != null && Object.hasOwnProperty.call(message, "MailType"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.MailType);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailContent message, length delimited. Does not implicitly {@link Client2ProxyAckGetMailContent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {IClient2ProxyAckGetMailContent} message Client2ProxyAckGetMailContent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailContent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetMailContent message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetMailContent} Client2ProxyAckGetMailContent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailContent.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetMailContent();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.MailInfoContent = $root.MailBriefInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.UnReadMailCount = reader.uint32();
                    break;
                }
            case 5: {
                    message.SendTime = reader.bytes();
                    break;
                }
            case 6: {
                    message.MailType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetMailContent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetMailContent} Client2ProxyAckGetMailContent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailContent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetMailContent message.
     * @function verify
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetMailContent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.MailInfoContent != null && message.hasOwnProperty("MailInfoContent")) {
            let error = $root.MailBriefInfo.verify(message.MailInfoContent);
            if (error)
                return "MailInfoContent." + error;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.UnReadMailCount != null && message.hasOwnProperty("UnReadMailCount"))
            if (!$util.isInteger(message.UnReadMailCount))
                return "UnReadMailCount: integer expected";
        if (message.SendTime != null && message.hasOwnProperty("SendTime"))
            if (!(message.SendTime && typeof message.SendTime.length === "number" || $util.isString(message.SendTime)))
                return "SendTime: buffer expected";
        if (message.MailType != null && message.hasOwnProperty("MailType"))
            if (!$util.isInteger(message.MailType))
                return "MailType: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetMailContent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetMailContent} Client2ProxyAckGetMailContent
     */
    Client2ProxyAckGetMailContent.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetMailContent)
            return object;
        let message = new $root.Client2ProxyAckGetMailContent();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.MailInfoContent != null) {
            if (typeof object.MailInfoContent !== "object")
                throw TypeError(".Client2ProxyAckGetMailContent.MailInfoContent: object expected");
            message.MailInfoContent = $root.MailBriefInfo.fromObject(object.MailInfoContent);
        }
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.UnReadMailCount != null)
            message.UnReadMailCount = object.UnReadMailCount >>> 0;
        if (object.SendTime != null)
            if (typeof object.SendTime === "string")
                $util.base64.decode(object.SendTime, message.SendTime = $util.newBuffer($util.base64.length(object.SendTime)), 0);
            else if (object.SendTime.length >= 0)
                message.SendTime = object.SendTime;
        if (object.MailType != null)
            message.MailType = object.MailType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetMailContent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {Client2ProxyAckGetMailContent} message Client2ProxyAckGetMailContent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetMailContent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.MailInfoContent = null;
            object.UserID = 0;
            object.UnReadMailCount = 0;
            if (options.bytes === String)
                object.SendTime = "";
            else {
                object.SendTime = [];
                if (options.bytes !== Array)
                    object.SendTime = $util.newBuffer(object.SendTime);
            }
            object.MailType = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.MailInfoContent != null && message.hasOwnProperty("MailInfoContent"))
            object.MailInfoContent = $root.MailBriefInfo.toObject(message.MailInfoContent, options);
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.UnReadMailCount != null && message.hasOwnProperty("UnReadMailCount"))
            object.UnReadMailCount = message.UnReadMailCount;
        if (message.SendTime != null && message.hasOwnProperty("SendTime"))
            object.SendTime = options.bytes === String ? $util.base64.encode(message.SendTime, 0, message.SendTime.length) : options.bytes === Array ? Array.prototype.slice.call(message.SendTime) : message.SendTime;
        if (message.MailType != null && message.hasOwnProperty("MailType"))
            object.MailType = message.MailType;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetMailContent to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetMailContent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetMailContent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetMailContent
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetMailContent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetMailContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetMailContent";
    };

    return Client2ProxyAckGetMailContent;
})();

export const Client2ProxyAckGetMailNeedUpdate = $root.Client2ProxyAckGetMailNeedUpdate = (() => {

    /**
     * Properties of a Client2ProxyAckGetMailNeedUpdate.
     * @exports IClient2ProxyAckGetMailNeedUpdate
     * @interface IClient2ProxyAckGetMailNeedUpdate
     * @property {number|null} [Ret] Client2ProxyAckGetMailNeedUpdate Ret
     * @property {number|null} [UserID] Client2ProxyAckGetMailNeedUpdate UserID
     */

    /**
     * Constructs a new Client2ProxyAckGetMailNeedUpdate.
     * @exports Client2ProxyAckGetMailNeedUpdate
     * @classdesc Represents a Client2ProxyAckGetMailNeedUpdate.
     * @implements IClient2ProxyAckGetMailNeedUpdate
     * @constructor
     * @param {IClient2ProxyAckGetMailNeedUpdate=} [properties] Properties to set
     */
    function Client2ProxyAckGetMailNeedUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetMailNeedUpdate Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @instance
     */
    Client2ProxyAckGetMailNeedUpdate.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetMailNeedUpdate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @instance
     */
    Client2ProxyAckGetMailNeedUpdate.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckGetMailNeedUpdate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {IClient2ProxyAckGetMailNeedUpdate=} [properties] Properties to set
     * @returns {Client2ProxyAckGetMailNeedUpdate} Client2ProxyAckGetMailNeedUpdate instance
     */
    Client2ProxyAckGetMailNeedUpdate.create = function create(properties) {
        return new Client2ProxyAckGetMailNeedUpdate(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailNeedUpdate message. Does not implicitly {@link Client2ProxyAckGetMailNeedUpdate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {IClient2ProxyAckGetMailNeedUpdate} message Client2ProxyAckGetMailNeedUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailNeedUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetMailNeedUpdate message, length delimited. Does not implicitly {@link Client2ProxyAckGetMailNeedUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {IClient2ProxyAckGetMailNeedUpdate} message Client2ProxyAckGetMailNeedUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetMailNeedUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetMailNeedUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetMailNeedUpdate} Client2ProxyAckGetMailNeedUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailNeedUpdate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetMailNeedUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetMailNeedUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetMailNeedUpdate} Client2ProxyAckGetMailNeedUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetMailNeedUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetMailNeedUpdate message.
     * @function verify
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetMailNeedUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetMailNeedUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetMailNeedUpdate} Client2ProxyAckGetMailNeedUpdate
     */
    Client2ProxyAckGetMailNeedUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetMailNeedUpdate)
            return object;
        let message = new $root.Client2ProxyAckGetMailNeedUpdate();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetMailNeedUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {Client2ProxyAckGetMailNeedUpdate} message Client2ProxyAckGetMailNeedUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetMailNeedUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetMailNeedUpdate to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetMailNeedUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetMailNeedUpdate
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetMailNeedUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetMailNeedUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetMailNeedUpdate";
    };

    return Client2ProxyAckGetMailNeedUpdate;
})();

export const Client2ProxyReqCheckCashInfo = $root.Client2ProxyReqCheckCashInfo = (() => {

    /**
     * Properties of a Client2ProxyReqCheckCashInfo.
     * @exports IClient2ProxyReqCheckCashInfo
     * @interface IClient2ProxyReqCheckCashInfo
     * @property {number|null} [UserID] Client2ProxyReqCheckCashInfo UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyReqCheckCashInfo Moblie
     * @property {Uint8Array|null} [mail] Client2ProxyReqCheckCashInfo mail
     * @property {Uint8Array|null} [Name] Client2ProxyReqCheckCashInfo Name
     */

    /**
     * Constructs a new Client2ProxyReqCheckCashInfo.
     * @exports Client2ProxyReqCheckCashInfo
     * @classdesc Represents a Client2ProxyReqCheckCashInfo.
     * @implements IClient2ProxyReqCheckCashInfo
     * @constructor
     * @param {IClient2ProxyReqCheckCashInfo=} [properties] Properties to set
     */
    function Client2ProxyReqCheckCashInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqCheckCashInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqCheckCashInfo
     * @instance
     */
    Client2ProxyReqCheckCashInfo.prototype.UserID = 0;

    /**
     * Client2ProxyReqCheckCashInfo Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyReqCheckCashInfo
     * @instance
     */
    Client2ProxyReqCheckCashInfo.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyReqCheckCashInfo mail.
     * @member {Uint8Array} mail
     * @memberof Client2ProxyReqCheckCashInfo
     * @instance
     */
    Client2ProxyReqCheckCashInfo.prototype.mail = $util.newBuffer([]);

    /**
     * Client2ProxyReqCheckCashInfo Name.
     * @member {Uint8Array} Name
     * @memberof Client2ProxyReqCheckCashInfo
     * @instance
     */
    Client2ProxyReqCheckCashInfo.prototype.Name = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyReqCheckCashInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {IClient2ProxyReqCheckCashInfo=} [properties] Properties to set
     * @returns {Client2ProxyReqCheckCashInfo} Client2ProxyReqCheckCashInfo instance
     */
    Client2ProxyReqCheckCashInfo.create = function create(properties) {
        return new Client2ProxyReqCheckCashInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqCheckCashInfo message. Does not implicitly {@link Client2ProxyReqCheckCashInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {IClient2ProxyReqCheckCashInfo} message Client2ProxyReqCheckCashInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckCashInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Moblie);
        if (message.mail != null && Object.hasOwnProperty.call(message, "mail"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.mail);
        if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.Name);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqCheckCashInfo message, length delimited. Does not implicitly {@link Client2ProxyReqCheckCashInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {IClient2ProxyReqCheckCashInfo} message Client2ProxyReqCheckCashInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCheckCashInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqCheckCashInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqCheckCashInfo} Client2ProxyReqCheckCashInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckCashInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqCheckCashInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 3: {
                    message.mail = reader.bytes();
                    break;
                }
            case 4: {
                    message.Name = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqCheckCashInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqCheckCashInfo} Client2ProxyReqCheckCashInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCheckCashInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqCheckCashInfo message.
     * @function verify
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqCheckCashInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.mail != null && message.hasOwnProperty("mail"))
            if (!(message.mail && typeof message.mail.length === "number" || $util.isString(message.mail)))
                return "mail: buffer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!(message.Name && typeof message.Name.length === "number" || $util.isString(message.Name)))
                return "Name: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqCheckCashInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqCheckCashInfo} Client2ProxyReqCheckCashInfo
     */
    Client2ProxyReqCheckCashInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqCheckCashInfo)
            return object;
        let message = new $root.Client2ProxyReqCheckCashInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.mail != null)
            if (typeof object.mail === "string")
                $util.base64.decode(object.mail, message.mail = $util.newBuffer($util.base64.length(object.mail)), 0);
            else if (object.mail.length >= 0)
                message.mail = object.mail;
        if (object.Name != null)
            if (typeof object.Name === "string")
                $util.base64.decode(object.Name, message.Name = $util.newBuffer($util.base64.length(object.Name)), 0);
            else if (object.Name.length >= 0)
                message.Name = object.Name;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqCheckCashInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {Client2ProxyReqCheckCashInfo} message Client2ProxyReqCheckCashInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqCheckCashInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.mail = "";
            else {
                object.mail = [];
                if (options.bytes !== Array)
                    object.mail = $util.newBuffer(object.mail);
            }
            if (options.bytes === String)
                object.Name = "";
            else {
                object.Name = [];
                if (options.bytes !== Array)
                    object.Name = $util.newBuffer(object.Name);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.mail != null && message.hasOwnProperty("mail"))
            object.mail = options.bytes === String ? $util.base64.encode(message.mail, 0, message.mail.length) : options.bytes === Array ? Array.prototype.slice.call(message.mail) : message.mail;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = options.bytes === String ? $util.base64.encode(message.Name, 0, message.Name.length) : options.bytes === Array ? Array.prototype.slice.call(message.Name) : message.Name;
        return object;
    };

    /**
     * Converts this Client2ProxyReqCheckCashInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqCheckCashInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqCheckCashInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqCheckCashInfo
     * @function getTypeUrl
     * @memberof Client2ProxyReqCheckCashInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqCheckCashInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqCheckCashInfo";
    };

    return Client2ProxyReqCheckCashInfo;
})();

export const Client2ProxyAckCheckCashInfo = $root.Client2ProxyAckCheckCashInfo = (() => {

    /**
     * Properties of a Client2ProxyAckCheckCashInfo.
     * @exports IClient2ProxyAckCheckCashInfo
     * @interface IClient2ProxyAckCheckCashInfo
     * @property {number|null} [Ret] Client2ProxyAckCheckCashInfo Ret
     * @property {number|null} [UserID] Client2ProxyAckCheckCashInfo UserID
     * @property {Uint8Array|null} [Moblie] Client2ProxyAckCheckCashInfo Moblie
     * @property {Uint8Array|null} [mail] Client2ProxyAckCheckCashInfo mail
     * @property {Uint8Array|null} [Name] Client2ProxyAckCheckCashInfo Name
     */

    /**
     * Constructs a new Client2ProxyAckCheckCashInfo.
     * @exports Client2ProxyAckCheckCashInfo
     * @classdesc Represents a Client2ProxyAckCheckCashInfo.
     * @implements IClient2ProxyAckCheckCashInfo
     * @constructor
     * @param {IClient2ProxyAckCheckCashInfo=} [properties] Properties to set
     */
    function Client2ProxyAckCheckCashInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckCheckCashInfo Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     */
    Client2ProxyAckCheckCashInfo.prototype.Ret = 0;

    /**
     * Client2ProxyAckCheckCashInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     */
    Client2ProxyAckCheckCashInfo.prototype.UserID = 0;

    /**
     * Client2ProxyAckCheckCashInfo Moblie.
     * @member {Uint8Array} Moblie
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     */
    Client2ProxyAckCheckCashInfo.prototype.Moblie = $util.newBuffer([]);

    /**
     * Client2ProxyAckCheckCashInfo mail.
     * @member {Uint8Array} mail
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     */
    Client2ProxyAckCheckCashInfo.prototype.mail = $util.newBuffer([]);

    /**
     * Client2ProxyAckCheckCashInfo Name.
     * @member {Uint8Array} Name
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     */
    Client2ProxyAckCheckCashInfo.prototype.Name = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckCheckCashInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {IClient2ProxyAckCheckCashInfo=} [properties] Properties to set
     * @returns {Client2ProxyAckCheckCashInfo} Client2ProxyAckCheckCashInfo instance
     */
    Client2ProxyAckCheckCashInfo.create = function create(properties) {
        return new Client2ProxyAckCheckCashInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckCheckCashInfo message. Does not implicitly {@link Client2ProxyAckCheckCashInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {IClient2ProxyAckCheckCashInfo} message Client2ProxyAckCheckCashInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckCashInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Moblie != null && Object.hasOwnProperty.call(message, "Moblie"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Moblie);
        if (message.mail != null && Object.hasOwnProperty.call(message, "mail"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.mail);
        if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.Name);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckCheckCashInfo message, length delimited. Does not implicitly {@link Client2ProxyAckCheckCashInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {IClient2ProxyAckCheckCashInfo} message Client2ProxyAckCheckCashInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCheckCashInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckCheckCashInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckCheckCashInfo} Client2ProxyAckCheckCashInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckCashInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckCheckCashInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Moblie = reader.bytes();
                    break;
                }
            case 4: {
                    message.mail = reader.bytes();
                    break;
                }
            case 5: {
                    message.Name = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckCheckCashInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckCheckCashInfo} Client2ProxyAckCheckCashInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCheckCashInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckCheckCashInfo message.
     * @function verify
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckCheckCashInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            if (!(message.Moblie && typeof message.Moblie.length === "number" || $util.isString(message.Moblie)))
                return "Moblie: buffer expected";
        if (message.mail != null && message.hasOwnProperty("mail"))
            if (!(message.mail && typeof message.mail.length === "number" || $util.isString(message.mail)))
                return "mail: buffer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!(message.Name && typeof message.Name.length === "number" || $util.isString(message.Name)))
                return "Name: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckCheckCashInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckCheckCashInfo} Client2ProxyAckCheckCashInfo
     */
    Client2ProxyAckCheckCashInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckCheckCashInfo)
            return object;
        let message = new $root.Client2ProxyAckCheckCashInfo();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Moblie != null)
            if (typeof object.Moblie === "string")
                $util.base64.decode(object.Moblie, message.Moblie = $util.newBuffer($util.base64.length(object.Moblie)), 0);
            else if (object.Moblie.length >= 0)
                message.Moblie = object.Moblie;
        if (object.mail != null)
            if (typeof object.mail === "string")
                $util.base64.decode(object.mail, message.mail = $util.newBuffer($util.base64.length(object.mail)), 0);
            else if (object.mail.length >= 0)
                message.mail = object.mail;
        if (object.Name != null)
            if (typeof object.Name === "string")
                $util.base64.decode(object.Name, message.Name = $util.newBuffer($util.base64.length(object.Name)), 0);
            else if (object.Name.length >= 0)
                message.Name = object.Name;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckCheckCashInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {Client2ProxyAckCheckCashInfo} message Client2ProxyAckCheckCashInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckCheckCashInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            if (options.bytes === String)
                object.Moblie = "";
            else {
                object.Moblie = [];
                if (options.bytes !== Array)
                    object.Moblie = $util.newBuffer(object.Moblie);
            }
            if (options.bytes === String)
                object.mail = "";
            else {
                object.mail = [];
                if (options.bytes !== Array)
                    object.mail = $util.newBuffer(object.mail);
            }
            if (options.bytes === String)
                object.Name = "";
            else {
                object.Name = [];
                if (options.bytes !== Array)
                    object.Name = $util.newBuffer(object.Name);
            }
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Moblie != null && message.hasOwnProperty("Moblie"))
            object.Moblie = options.bytes === String ? $util.base64.encode(message.Moblie, 0, message.Moblie.length) : options.bytes === Array ? Array.prototype.slice.call(message.Moblie) : message.Moblie;
        if (message.mail != null && message.hasOwnProperty("mail"))
            object.mail = options.bytes === String ? $util.base64.encode(message.mail, 0, message.mail.length) : options.bytes === Array ? Array.prototype.slice.call(message.mail) : message.mail;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = options.bytes === String ? $util.base64.encode(message.Name, 0, message.Name.length) : options.bytes === Array ? Array.prototype.slice.call(message.Name) : message.Name;
        return object;
    };

    /**
     * Converts this Client2ProxyAckCheckCashInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckCheckCashInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckCheckCashInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckCheckCashInfo
     * @function getTypeUrl
     * @memberof Client2ProxyAckCheckCashInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckCheckCashInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckCheckCashInfo";
    };

    return Client2ProxyAckCheckCashInfo;
})();

export const Client2ProxyReqGetTourney = $root.Client2ProxyReqGetTourney = (() => {

    /**
     * Properties of a Client2ProxyReqGetTourney.
     * @exports IClient2ProxyReqGetTourney
     * @interface IClient2ProxyReqGetTourney
     * @property {number|null} [UserID] Client2ProxyReqGetTourney UserID
     * @property {number|null} [GameID] Client2ProxyReqGetTourney GameID
     */

    /**
     * Constructs a new Client2ProxyReqGetTourney.
     * @exports Client2ProxyReqGetTourney
     * @classdesc Represents a Client2ProxyReqGetTourney.
     * @implements IClient2ProxyReqGetTourney
     * @constructor
     * @param {IClient2ProxyReqGetTourney=} [properties] Properties to set
     */
    function Client2ProxyReqGetTourney(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetTourney UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetTourney
     * @instance
     */
    Client2ProxyReqGetTourney.prototype.UserID = 0;

    /**
     * Client2ProxyReqGetTourney GameID.
     * @member {number} GameID
     * @memberof Client2ProxyReqGetTourney
     * @instance
     */
    Client2ProxyReqGetTourney.prototype.GameID = 0;

    /**
     * Creates a new Client2ProxyReqGetTourney instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {IClient2ProxyReqGetTourney=} [properties] Properties to set
     * @returns {Client2ProxyReqGetTourney} Client2ProxyReqGetTourney instance
     */
    Client2ProxyReqGetTourney.create = function create(properties) {
        return new Client2ProxyReqGetTourney(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetTourney message. Does not implicitly {@link Client2ProxyReqGetTourney.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {IClient2ProxyReqGetTourney} message Client2ProxyReqGetTourney message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetTourney.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetTourney message, length delimited. Does not implicitly {@link Client2ProxyReqGetTourney.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {IClient2ProxyReqGetTourney} message Client2ProxyReqGetTourney message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetTourney.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetTourney message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetTourney} Client2ProxyReqGetTourney
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetTourney.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetTourney();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetTourney message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetTourney} Client2ProxyReqGetTourney
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetTourney.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetTourney message.
     * @function verify
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetTourney.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetTourney message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetTourney} Client2ProxyReqGetTourney
     */
    Client2ProxyReqGetTourney.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetTourney)
            return object;
        let message = new $root.Client2ProxyReqGetTourney();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetTourney message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {Client2ProxyReqGetTourney} message Client2ProxyReqGetTourney
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetTourney.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetTourney to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetTourney
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetTourney.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetTourney
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetTourney
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetTourney.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetTourney";
    };

    return Client2ProxyReqGetTourney;
})();

export const Client2ProxyAckGetTourney = $root.Client2ProxyAckGetTourney = (() => {

    /**
     * Properties of a Client2ProxyAckGetTourney.
     * @exports IClient2ProxyAckGetTourney
     * @interface IClient2ProxyAckGetTourney
     * @property {number|null} [UserID] Client2ProxyAckGetTourney UserID
     * @property {number|null} [GameID] Client2ProxyAckGetTourney GameID
     * @property {Uint8Array|null} [TourneyList] Client2ProxyAckGetTourney TourneyList
     */

    /**
     * Constructs a new Client2ProxyAckGetTourney.
     * @exports Client2ProxyAckGetTourney
     * @classdesc Represents a Client2ProxyAckGetTourney.
     * @implements IClient2ProxyAckGetTourney
     * @constructor
     * @param {IClient2ProxyAckGetTourney=} [properties] Properties to set
     */
    function Client2ProxyAckGetTourney(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetTourney UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetTourney
     * @instance
     */
    Client2ProxyAckGetTourney.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetTourney GameID.
     * @member {number} GameID
     * @memberof Client2ProxyAckGetTourney
     * @instance
     */
    Client2ProxyAckGetTourney.prototype.GameID = 0;

    /**
     * Client2ProxyAckGetTourney TourneyList.
     * @member {Uint8Array} TourneyList
     * @memberof Client2ProxyAckGetTourney
     * @instance
     */
    Client2ProxyAckGetTourney.prototype.TourneyList = $util.newBuffer([]);

    /**
     * Creates a new Client2ProxyAckGetTourney instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {IClient2ProxyAckGetTourney=} [properties] Properties to set
     * @returns {Client2ProxyAckGetTourney} Client2ProxyAckGetTourney instance
     */
    Client2ProxyAckGetTourney.create = function create(properties) {
        return new Client2ProxyAckGetTourney(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetTourney message. Does not implicitly {@link Client2ProxyAckGetTourney.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {IClient2ProxyAckGetTourney} message Client2ProxyAckGetTourney message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetTourney.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.TourneyList != null && Object.hasOwnProperty.call(message, "TourneyList"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.TourneyList);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetTourney message, length delimited. Does not implicitly {@link Client2ProxyAckGetTourney.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {IClient2ProxyAckGetTourney} message Client2ProxyAckGetTourney message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetTourney.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetTourney message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetTourney} Client2ProxyAckGetTourney
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetTourney.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetTourney();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.TourneyList = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetTourney message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetTourney} Client2ProxyAckGetTourney
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetTourney.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetTourney message.
     * @function verify
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetTourney.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.TourneyList != null && message.hasOwnProperty("TourneyList"))
            if (!(message.TourneyList && typeof message.TourneyList.length === "number" || $util.isString(message.TourneyList)))
                return "TourneyList: buffer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetTourney message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetTourney} Client2ProxyAckGetTourney
     */
    Client2ProxyAckGetTourney.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetTourney)
            return object;
        let message = new $root.Client2ProxyAckGetTourney();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.TourneyList != null)
            if (typeof object.TourneyList === "string")
                $util.base64.decode(object.TourneyList, message.TourneyList = $util.newBuffer($util.base64.length(object.TourneyList)), 0);
            else if (object.TourneyList.length >= 0)
                message.TourneyList = object.TourneyList;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetTourney message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {Client2ProxyAckGetTourney} message Client2ProxyAckGetTourney
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetTourney.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            if (options.bytes === String)
                object.TourneyList = "";
            else {
                object.TourneyList = [];
                if (options.bytes !== Array)
                    object.TourneyList = $util.newBuffer(object.TourneyList);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.TourneyList != null && message.hasOwnProperty("TourneyList"))
            object.TourneyList = options.bytes === String ? $util.base64.encode(message.TourneyList, 0, message.TourneyList.length) : options.bytes === Array ? Array.prototype.slice.call(message.TourneyList) : message.TourneyList;
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetTourney to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetTourney
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetTourney.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetTourney
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetTourney
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetTourney.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetTourney";
    };

    return Client2ProxyAckGetTourney;
})();

export const Client2ProxyReqGetGameList = $root.Client2ProxyReqGetGameList = (() => {

    /**
     * Properties of a Client2ProxyReqGetGameList.
     * @exports IClient2ProxyReqGetGameList
     * @interface IClient2ProxyReqGetGameList
     * @property {number|null} [UserID] Client2ProxyReqGetGameList UserID
     */

    /**
     * Constructs a new Client2ProxyReqGetGameList.
     * @exports Client2ProxyReqGetGameList
     * @classdesc Represents a Client2ProxyReqGetGameList.
     * @implements IClient2ProxyReqGetGameList
     * @constructor
     * @param {IClient2ProxyReqGetGameList=} [properties] Properties to set
     */
    function Client2ProxyReqGetGameList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqGetGameList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqGetGameList
     * @instance
     */
    Client2ProxyReqGetGameList.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqGetGameList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {IClient2ProxyReqGetGameList=} [properties] Properties to set
     * @returns {Client2ProxyReqGetGameList} Client2ProxyReqGetGameList instance
     */
    Client2ProxyReqGetGameList.create = function create(properties) {
        return new Client2ProxyReqGetGameList(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqGetGameList message. Does not implicitly {@link Client2ProxyReqGetGameList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {IClient2ProxyReqGetGameList} message Client2ProxyReqGetGameList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetGameList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqGetGameList message, length delimited. Does not implicitly {@link Client2ProxyReqGetGameList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {IClient2ProxyReqGetGameList} message Client2ProxyReqGetGameList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqGetGameList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqGetGameList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqGetGameList} Client2ProxyReqGetGameList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetGameList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqGetGameList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqGetGameList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqGetGameList} Client2ProxyReqGetGameList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqGetGameList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqGetGameList message.
     * @function verify
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqGetGameList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqGetGameList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqGetGameList} Client2ProxyReqGetGameList
     */
    Client2ProxyReqGetGameList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqGetGameList)
            return object;
        let message = new $root.Client2ProxyReqGetGameList();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqGetGameList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {Client2ProxyReqGetGameList} message Client2ProxyReqGetGameList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqGetGameList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqGetGameList to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqGetGameList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqGetGameList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqGetGameList
     * @function getTypeUrl
     * @memberof Client2ProxyReqGetGameList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqGetGameList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqGetGameList";
    };

    return Client2ProxyReqGetGameList;
})();

export const Client2ProxyAckGetGameList = $root.Client2ProxyAckGetGameList = (() => {

    /**
     * Properties of a Client2ProxyAckGetGameList.
     * @exports IClient2ProxyAckGetGameList
     * @interface IClient2ProxyAckGetGameList
     * @property {number|null} [Ret] Client2ProxyAckGetGameList Ret
     * @property {number|null} [UserID] Client2ProxyAckGetGameList UserID
     * @property {Array.<number>|null} [GameID] Client2ProxyAckGetGameList GameID
     */

    /**
     * Constructs a new Client2ProxyAckGetGameList.
     * @exports Client2ProxyAckGetGameList
     * @classdesc Represents a Client2ProxyAckGetGameList.
     * @implements IClient2ProxyAckGetGameList
     * @constructor
     * @param {IClient2ProxyAckGetGameList=} [properties] Properties to set
     */
    function Client2ProxyAckGetGameList(properties) {
        this.GameID = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckGetGameList Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckGetGameList
     * @instance
     */
    Client2ProxyAckGetGameList.prototype.Ret = 0;

    /**
     * Client2ProxyAckGetGameList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckGetGameList
     * @instance
     */
    Client2ProxyAckGetGameList.prototype.UserID = 0;

    /**
     * Client2ProxyAckGetGameList GameID.
     * @member {Array.<number>} GameID
     * @memberof Client2ProxyAckGetGameList
     * @instance
     */
    Client2ProxyAckGetGameList.prototype.GameID = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckGetGameList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {IClient2ProxyAckGetGameList=} [properties] Properties to set
     * @returns {Client2ProxyAckGetGameList} Client2ProxyAckGetGameList instance
     */
    Client2ProxyAckGetGameList.create = function create(properties) {
        return new Client2ProxyAckGetGameList(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckGetGameList message. Does not implicitly {@link Client2ProxyAckGetGameList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {IClient2ProxyAckGetGameList} message Client2ProxyAckGetGameList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetGameList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameID != null && message.GameID.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.GameID.length; ++i)
                writer.uint32(message.GameID[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckGetGameList message, length delimited. Does not implicitly {@link Client2ProxyAckGetGameList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {IClient2ProxyAckGetGameList} message Client2ProxyAckGetGameList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckGetGameList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckGetGameList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckGetGameList} Client2ProxyAckGetGameList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetGameList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckGetGameList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GameID && message.GameID.length))
                        message.GameID = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GameID.push(reader.uint32());
                    } else
                        message.GameID.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckGetGameList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckGetGameList} Client2ProxyAckGetGameList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckGetGameList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckGetGameList message.
     * @function verify
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckGetGameList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID")) {
            if (!Array.isArray(message.GameID))
                return "GameID: array expected";
            for (let i = 0; i < message.GameID.length; ++i)
                if (!$util.isInteger(message.GameID[i]))
                    return "GameID: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckGetGameList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckGetGameList} Client2ProxyAckGetGameList
     */
    Client2ProxyAckGetGameList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckGetGameList)
            return object;
        let message = new $root.Client2ProxyAckGetGameList();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID) {
            if (!Array.isArray(object.GameID))
                throw TypeError(".Client2ProxyAckGetGameList.GameID: array expected");
            message.GameID = [];
            for (let i = 0; i < object.GameID.length; ++i)
                message.GameID[i] = object.GameID[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckGetGameList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {Client2ProxyAckGetGameList} message Client2ProxyAckGetGameList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckGetGameList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GameID = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID && message.GameID.length) {
            object.GameID = [];
            for (let j = 0; j < message.GameID.length; ++j)
                object.GameID[j] = message.GameID[j];
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckGetGameList to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckGetGameList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckGetGameList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckGetGameList
     * @function getTypeUrl
     * @memberof Client2ProxyAckGetGameList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckGetGameList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckGetGameList";
    };

    return Client2ProxyAckGetGameList;
})();

export const Client2ProxyReqCashMark = $root.Client2ProxyReqCashMark = (() => {

    /**
     * Properties of a Client2ProxyReqCashMark.
     * @exports IClient2ProxyReqCashMark
     * @interface IClient2ProxyReqCashMark
     * @property {number|null} [platformType] Client2ProxyReqCashMark platformType
     * @property {number|null} [channel] Client2ProxyReqCashMark channel
     * @property {string|null} [version] Client2ProxyReqCashMark version
     */

    /**
     * Constructs a new Client2ProxyReqCashMark.
     * @exports Client2ProxyReqCashMark
     * @classdesc Represents a Client2ProxyReqCashMark.
     * @implements IClient2ProxyReqCashMark
     * @constructor
     * @param {IClient2ProxyReqCashMark=} [properties] Properties to set
     */
    function Client2ProxyReqCashMark(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqCashMark platformType.
     * @member {number} platformType
     * @memberof Client2ProxyReqCashMark
     * @instance
     */
    Client2ProxyReqCashMark.prototype.platformType = 0;

    /**
     * Client2ProxyReqCashMark channel.
     * @member {number} channel
     * @memberof Client2ProxyReqCashMark
     * @instance
     */
    Client2ProxyReqCashMark.prototype.channel = 0;

    /**
     * Client2ProxyReqCashMark version.
     * @member {string} version
     * @memberof Client2ProxyReqCashMark
     * @instance
     */
    Client2ProxyReqCashMark.prototype.version = "";

    /**
     * Creates a new Client2ProxyReqCashMark instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {IClient2ProxyReqCashMark=} [properties] Properties to set
     * @returns {Client2ProxyReqCashMark} Client2ProxyReqCashMark instance
     */
    Client2ProxyReqCashMark.create = function create(properties) {
        return new Client2ProxyReqCashMark(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqCashMark message. Does not implicitly {@link Client2ProxyReqCashMark.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {IClient2ProxyReqCashMark} message Client2ProxyReqCashMark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCashMark.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.platformType != null && Object.hasOwnProperty.call(message, "platformType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.platformType);
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.channel);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.version);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqCashMark message, length delimited. Does not implicitly {@link Client2ProxyReqCashMark.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {IClient2ProxyReqCashMark} message Client2ProxyReqCashMark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqCashMark.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqCashMark message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqCashMark} Client2ProxyReqCashMark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCashMark.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqCashMark();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.platformType = reader.uint32();
                    break;
                }
            case 2: {
                    message.channel = reader.uint32();
                    break;
                }
            case 3: {
                    message.version = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqCashMark message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqCashMark} Client2ProxyReqCashMark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqCashMark.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqCashMark message.
     * @function verify
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqCashMark.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            if (!$util.isInteger(message.platformType))
                return "platformType: integer expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isInteger(message.channel))
                return "channel: integer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqCashMark message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqCashMark} Client2ProxyReqCashMark
     */
    Client2ProxyReqCashMark.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqCashMark)
            return object;
        let message = new $root.Client2ProxyReqCashMark();
        if (object.platformType != null)
            message.platformType = object.platformType >>> 0;
        if (object.channel != null)
            message.channel = object.channel >>> 0;
        if (object.version != null)
            message.version = String(object.version);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqCashMark message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {Client2ProxyReqCashMark} message Client2ProxyReqCashMark
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqCashMark.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.platformType = 0;
            object.channel = 0;
            object.version = "";
        }
        if (message.platformType != null && message.hasOwnProperty("platformType"))
            object.platformType = message.platformType;
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        return object;
    };

    /**
     * Converts this Client2ProxyReqCashMark to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqCashMark
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqCashMark.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqCashMark
     * @function getTypeUrl
     * @memberof Client2ProxyReqCashMark
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqCashMark.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqCashMark";
    };

    return Client2ProxyReqCashMark;
})();

export const Client2ProxyAckCashMark = $root.Client2ProxyAckCashMark = (() => {

    /**
     * Properties of a Client2ProxyAckCashMark.
     * @exports IClient2ProxyAckCashMark
     * @interface IClient2ProxyAckCashMark
     * @property {number|null} [Ret] Client2ProxyAckCashMark Ret
     * @property {number|null} [markType] Client2ProxyAckCashMark markType
     */

    /**
     * Constructs a new Client2ProxyAckCashMark.
     * @exports Client2ProxyAckCashMark
     * @classdesc Represents a Client2ProxyAckCashMark.
     * @implements IClient2ProxyAckCashMark
     * @constructor
     * @param {IClient2ProxyAckCashMark=} [properties] Properties to set
     */
    function Client2ProxyAckCashMark(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckCashMark Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckCashMark
     * @instance
     */
    Client2ProxyAckCashMark.prototype.Ret = 0;

    /**
     * Client2ProxyAckCashMark markType.
     * @member {number} markType
     * @memberof Client2ProxyAckCashMark
     * @instance
     */
    Client2ProxyAckCashMark.prototype.markType = 0;

    /**
     * Creates a new Client2ProxyAckCashMark instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {IClient2ProxyAckCashMark=} [properties] Properties to set
     * @returns {Client2ProxyAckCashMark} Client2ProxyAckCashMark instance
     */
    Client2ProxyAckCashMark.create = function create(properties) {
        return new Client2ProxyAckCashMark(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckCashMark message. Does not implicitly {@link Client2ProxyAckCashMark.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {IClient2ProxyAckCashMark} message Client2ProxyAckCashMark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCashMark.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.markType != null && Object.hasOwnProperty.call(message, "markType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.markType);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckCashMark message, length delimited. Does not implicitly {@link Client2ProxyAckCashMark.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {IClient2ProxyAckCashMark} message Client2ProxyAckCashMark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckCashMark.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckCashMark message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckCashMark} Client2ProxyAckCashMark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCashMark.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckCashMark();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.markType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckCashMark message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckCashMark} Client2ProxyAckCashMark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckCashMark.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckCashMark message.
     * @function verify
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckCashMark.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.markType != null && message.hasOwnProperty("markType"))
            if (!$util.isInteger(message.markType))
                return "markType: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckCashMark message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckCashMark} Client2ProxyAckCashMark
     */
    Client2ProxyAckCashMark.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckCashMark)
            return object;
        let message = new $root.Client2ProxyAckCashMark();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.markType != null)
            message.markType = object.markType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckCashMark message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {Client2ProxyAckCashMark} message Client2ProxyAckCashMark
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckCashMark.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.markType = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.markType != null && message.hasOwnProperty("markType"))
            object.markType = message.markType;
        return object;
    };

    /**
     * Converts this Client2ProxyAckCashMark to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckCashMark
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckCashMark.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckCashMark
     * @function getTypeUrl
     * @memberof Client2ProxyAckCashMark
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckCashMark.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckCashMark";
    };

    return Client2ProxyAckCashMark;
})();

export const Client2ProxyReqAppleLogin = $root.Client2ProxyReqAppleLogin = (() => {

    /**
     * Properties of a Client2ProxyReqAppleLogin.
     * @exports IClient2ProxyReqAppleLogin
     * @interface IClient2ProxyReqAppleLogin
     * @property {string|null} [ClientMark] Client2ProxyReqAppleLogin ClientMark
     * @property {string|null} [appleUid] Client2ProxyReqAppleLogin appleUid
     * @property {string|null} [appleToken] Client2ProxyReqAppleLogin appleToken
     * @property {string|null} [appleAuth] Client2ProxyReqAppleLogin appleAuth
     * @property {number|null} [RecommendedUID] Client2ProxyReqAppleLogin RecommendedUID
     * @property {string|null} [AppName] Client2ProxyReqAppleLogin AppName
     * @property {string|null} [mobileType] Client2ProxyReqAppleLogin mobileType
     * @property {string|null} [mobileOsVer] Client2ProxyReqAppleLogin mobileOsVer
     * @property {string|null} [version] Client2ProxyReqAppleLogin version
     * @property {number|null} [channelid] Client2ProxyReqAppleLogin channelid
     */

    /**
     * Constructs a new Client2ProxyReqAppleLogin.
     * @exports Client2ProxyReqAppleLogin
     * @classdesc Represents a Client2ProxyReqAppleLogin.
     * @implements IClient2ProxyReqAppleLogin
     * @constructor
     * @param {IClient2ProxyReqAppleLogin=} [properties] Properties to set
     */
    function Client2ProxyReqAppleLogin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAppleLogin ClientMark.
     * @member {string} ClientMark
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.ClientMark = "";

    /**
     * Client2ProxyReqAppleLogin appleUid.
     * @member {string} appleUid
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.appleUid = "";

    /**
     * Client2ProxyReqAppleLogin appleToken.
     * @member {string} appleToken
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.appleToken = "";

    /**
     * Client2ProxyReqAppleLogin appleAuth.
     * @member {string} appleAuth
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.appleAuth = "";

    /**
     * Client2ProxyReqAppleLogin RecommendedUID.
     * @member {number} RecommendedUID
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.RecommendedUID = 0;

    /**
     * Client2ProxyReqAppleLogin AppName.
     * @member {string} AppName
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.AppName = "";

    /**
     * Client2ProxyReqAppleLogin mobileType.
     * @member {string} mobileType
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.mobileType = "";

    /**
     * Client2ProxyReqAppleLogin mobileOsVer.
     * @member {string} mobileOsVer
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.mobileOsVer = "";

    /**
     * Client2ProxyReqAppleLogin version.
     * @member {string} version
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.version = "";

    /**
     * Client2ProxyReqAppleLogin channelid.
     * @member {number} channelid
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     */
    Client2ProxyReqAppleLogin.prototype.channelid = 0;

    /**
     * Creates a new Client2ProxyReqAppleLogin instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {IClient2ProxyReqAppleLogin=} [properties] Properties to set
     * @returns {Client2ProxyReqAppleLogin} Client2ProxyReqAppleLogin instance
     */
    Client2ProxyReqAppleLogin.create = function create(properties) {
        return new Client2ProxyReqAppleLogin(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAppleLogin message. Does not implicitly {@link Client2ProxyReqAppleLogin.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {IClient2ProxyReqAppleLogin} message Client2ProxyReqAppleLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAppleLogin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientMark != null && Object.hasOwnProperty.call(message, "ClientMark"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ClientMark);
        if (message.appleUid != null && Object.hasOwnProperty.call(message, "appleUid"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.appleUid);
        if (message.appleToken != null && Object.hasOwnProperty.call(message, "appleToken"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.appleToken);
        if (message.appleAuth != null && Object.hasOwnProperty.call(message, "appleAuth"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.appleAuth);
        if (message.RecommendedUID != null && Object.hasOwnProperty.call(message, "RecommendedUID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.RecommendedUID);
        if (message.AppName != null && Object.hasOwnProperty.call(message, "AppName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.AppName);
        if (message.mobileType != null && Object.hasOwnProperty.call(message, "mobileType"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.mobileType);
        if (message.mobileOsVer != null && Object.hasOwnProperty.call(message, "mobileOsVer"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.mobileOsVer);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.version);
        if (message.channelid != null && Object.hasOwnProperty.call(message, "channelid"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.channelid);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAppleLogin message, length delimited. Does not implicitly {@link Client2ProxyReqAppleLogin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {IClient2ProxyReqAppleLogin} message Client2ProxyReqAppleLogin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAppleLogin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAppleLogin message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAppleLogin} Client2ProxyReqAppleLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAppleLogin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAppleLogin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ClientMark = reader.string();
                    break;
                }
            case 2: {
                    message.appleUid = reader.string();
                    break;
                }
            case 3: {
                    message.appleToken = reader.string();
                    break;
                }
            case 4: {
                    message.appleAuth = reader.string();
                    break;
                }
            case 5: {
                    message.RecommendedUID = reader.uint32();
                    break;
                }
            case 6: {
                    message.AppName = reader.string();
                    break;
                }
            case 7: {
                    message.mobileType = reader.string();
                    break;
                }
            case 8: {
                    message.mobileOsVer = reader.string();
                    break;
                }
            case 9: {
                    message.version = reader.string();
                    break;
                }
            case 10: {
                    message.channelid = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAppleLogin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAppleLogin} Client2ProxyReqAppleLogin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAppleLogin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAppleLogin message.
     * @function verify
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAppleLogin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            if (!$util.isString(message.ClientMark))
                return "ClientMark: string expected";
        if (message.appleUid != null && message.hasOwnProperty("appleUid"))
            if (!$util.isString(message.appleUid))
                return "appleUid: string expected";
        if (message.appleToken != null && message.hasOwnProperty("appleToken"))
            if (!$util.isString(message.appleToken))
                return "appleToken: string expected";
        if (message.appleAuth != null && message.hasOwnProperty("appleAuth"))
            if (!$util.isString(message.appleAuth))
                return "appleAuth: string expected";
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            if (!$util.isInteger(message.RecommendedUID))
                return "RecommendedUID: integer expected";
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            if (!$util.isString(message.AppName))
                return "AppName: string expected";
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            if (!$util.isString(message.mobileType))
                return "mobileType: string expected";
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            if (!$util.isString(message.mobileOsVer))
                return "mobileOsVer: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        if (message.channelid != null && message.hasOwnProperty("channelid"))
            if (!$util.isInteger(message.channelid))
                return "channelid: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqAppleLogin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAppleLogin} Client2ProxyReqAppleLogin
     */
    Client2ProxyReqAppleLogin.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAppleLogin)
            return object;
        let message = new $root.Client2ProxyReqAppleLogin();
        if (object.ClientMark != null)
            message.ClientMark = String(object.ClientMark);
        if (object.appleUid != null)
            message.appleUid = String(object.appleUid);
        if (object.appleToken != null)
            message.appleToken = String(object.appleToken);
        if (object.appleAuth != null)
            message.appleAuth = String(object.appleAuth);
        if (object.RecommendedUID != null)
            message.RecommendedUID = object.RecommendedUID >>> 0;
        if (object.AppName != null)
            message.AppName = String(object.AppName);
        if (object.mobileType != null)
            message.mobileType = String(object.mobileType);
        if (object.mobileOsVer != null)
            message.mobileOsVer = String(object.mobileOsVer);
        if (object.version != null)
            message.version = String(object.version);
        if (object.channelid != null)
            message.channelid = object.channelid >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAppleLogin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {Client2ProxyReqAppleLogin} message Client2ProxyReqAppleLogin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAppleLogin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ClientMark = "";
            object.appleUid = "";
            object.appleToken = "";
            object.appleAuth = "";
            object.RecommendedUID = 0;
            object.AppName = "";
            object.mobileType = "";
            object.mobileOsVer = "";
            object.version = "";
            object.channelid = 0;
        }
        if (message.ClientMark != null && message.hasOwnProperty("ClientMark"))
            object.ClientMark = message.ClientMark;
        if (message.appleUid != null && message.hasOwnProperty("appleUid"))
            object.appleUid = message.appleUid;
        if (message.appleToken != null && message.hasOwnProperty("appleToken"))
            object.appleToken = message.appleToken;
        if (message.appleAuth != null && message.hasOwnProperty("appleAuth"))
            object.appleAuth = message.appleAuth;
        if (message.RecommendedUID != null && message.hasOwnProperty("RecommendedUID"))
            object.RecommendedUID = message.RecommendedUID;
        if (message.AppName != null && message.hasOwnProperty("AppName"))
            object.AppName = message.AppName;
        if (message.mobileType != null && message.hasOwnProperty("mobileType"))
            object.mobileType = message.mobileType;
        if (message.mobileOsVer != null && message.hasOwnProperty("mobileOsVer"))
            object.mobileOsVer = message.mobileOsVer;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.channelid != null && message.hasOwnProperty("channelid"))
            object.channelid = message.channelid;
        return object;
    };

    /**
     * Converts this Client2ProxyReqAppleLogin to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAppleLogin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAppleLogin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAppleLogin
     * @function getTypeUrl
     * @memberof Client2ProxyReqAppleLogin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAppleLogin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAppleLogin";
    };

    return Client2ProxyReqAppleLogin;
})();

export const Client2ProxyReqNewPayRecord = $root.Client2ProxyReqNewPayRecord = (() => {

    /**
     * Properties of a Client2ProxyReqNewPayRecord.
     * @exports IClient2ProxyReqNewPayRecord
     * @interface IClient2ProxyReqNewPayRecord
     * @property {number|null} [UserID] Client2ProxyReqNewPayRecord UserID
     */

    /**
     * Constructs a new Client2ProxyReqNewPayRecord.
     * @exports Client2ProxyReqNewPayRecord
     * @classdesc Represents a Client2ProxyReqNewPayRecord.
     * @implements IClient2ProxyReqNewPayRecord
     * @constructor
     * @param {IClient2ProxyReqNewPayRecord=} [properties] Properties to set
     */
    function Client2ProxyReqNewPayRecord(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqNewPayRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqNewPayRecord
     * @instance
     */
    Client2ProxyReqNewPayRecord.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqNewPayRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {IClient2ProxyReqNewPayRecord=} [properties] Properties to set
     * @returns {Client2ProxyReqNewPayRecord} Client2ProxyReqNewPayRecord instance
     */
    Client2ProxyReqNewPayRecord.create = function create(properties) {
        return new Client2ProxyReqNewPayRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqNewPayRecord message. Does not implicitly {@link Client2ProxyReqNewPayRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {IClient2ProxyReqNewPayRecord} message Client2ProxyReqNewPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqNewPayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqNewPayRecord message, length delimited. Does not implicitly {@link Client2ProxyReqNewPayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {IClient2ProxyReqNewPayRecord} message Client2ProxyReqNewPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqNewPayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqNewPayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqNewPayRecord} Client2ProxyReqNewPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqNewPayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqNewPayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqNewPayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqNewPayRecord} Client2ProxyReqNewPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqNewPayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqNewPayRecord message.
     * @function verify
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqNewPayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqNewPayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqNewPayRecord} Client2ProxyReqNewPayRecord
     */
    Client2ProxyReqNewPayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqNewPayRecord)
            return object;
        let message = new $root.Client2ProxyReqNewPayRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqNewPayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {Client2ProxyReqNewPayRecord} message Client2ProxyReqNewPayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqNewPayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqNewPayRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqNewPayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqNewPayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqNewPayRecord
     * @function getTypeUrl
     * @memberof Client2ProxyReqNewPayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqNewPayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqNewPayRecord";
    };

    return Client2ProxyReqNewPayRecord;
})();

export const Client2ProxyAckNewPayRecord = $root.Client2ProxyAckNewPayRecord = (() => {

    /**
     * Properties of a Client2ProxyAckNewPayRecord.
     * @exports IClient2ProxyAckNewPayRecord
     * @interface IClient2ProxyAckNewPayRecord
     * @property {number|null} [UserID] Client2ProxyAckNewPayRecord UserID
     * @property {Array.<IUserPayRecord>|null} [PayRecordList] Client2ProxyAckNewPayRecord PayRecordList
     */

    /**
     * Constructs a new Client2ProxyAckNewPayRecord.
     * @exports Client2ProxyAckNewPayRecord
     * @classdesc Represents a Client2ProxyAckNewPayRecord.
     * @implements IClient2ProxyAckNewPayRecord
     * @constructor
     * @param {IClient2ProxyAckNewPayRecord=} [properties] Properties to set
     */
    function Client2ProxyAckNewPayRecord(properties) {
        this.PayRecordList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckNewPayRecord UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckNewPayRecord
     * @instance
     */
    Client2ProxyAckNewPayRecord.prototype.UserID = 0;

    /**
     * Client2ProxyAckNewPayRecord PayRecordList.
     * @member {Array.<IUserPayRecord>} PayRecordList
     * @memberof Client2ProxyAckNewPayRecord
     * @instance
     */
    Client2ProxyAckNewPayRecord.prototype.PayRecordList = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckNewPayRecord instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {IClient2ProxyAckNewPayRecord=} [properties] Properties to set
     * @returns {Client2ProxyAckNewPayRecord} Client2ProxyAckNewPayRecord instance
     */
    Client2ProxyAckNewPayRecord.create = function create(properties) {
        return new Client2ProxyAckNewPayRecord(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckNewPayRecord message. Does not implicitly {@link Client2ProxyAckNewPayRecord.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {IClient2ProxyAckNewPayRecord} message Client2ProxyAckNewPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckNewPayRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PayRecordList != null && message.PayRecordList.length)
            for (let i = 0; i < message.PayRecordList.length; ++i)
                $root.UserPayRecord.encode(message.PayRecordList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckNewPayRecord message, length delimited. Does not implicitly {@link Client2ProxyAckNewPayRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {IClient2ProxyAckNewPayRecord} message Client2ProxyAckNewPayRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckNewPayRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckNewPayRecord message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckNewPayRecord} Client2ProxyAckNewPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckNewPayRecord.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckNewPayRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.PayRecordList && message.PayRecordList.length))
                        message.PayRecordList = [];
                    message.PayRecordList.push($root.UserPayRecord.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckNewPayRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckNewPayRecord} Client2ProxyAckNewPayRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckNewPayRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckNewPayRecord message.
     * @function verify
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckNewPayRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PayRecordList != null && message.hasOwnProperty("PayRecordList")) {
            if (!Array.isArray(message.PayRecordList))
                return "PayRecordList: array expected";
            for (let i = 0; i < message.PayRecordList.length; ++i) {
                let error = $root.UserPayRecord.verify(message.PayRecordList[i]);
                if (error)
                    return "PayRecordList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckNewPayRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckNewPayRecord} Client2ProxyAckNewPayRecord
     */
    Client2ProxyAckNewPayRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckNewPayRecord)
            return object;
        let message = new $root.Client2ProxyAckNewPayRecord();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PayRecordList) {
            if (!Array.isArray(object.PayRecordList))
                throw TypeError(".Client2ProxyAckNewPayRecord.PayRecordList: array expected");
            message.PayRecordList = [];
            for (let i = 0; i < object.PayRecordList.length; ++i) {
                if (typeof object.PayRecordList[i] !== "object")
                    throw TypeError(".Client2ProxyAckNewPayRecord.PayRecordList: object expected");
                message.PayRecordList[i] = $root.UserPayRecord.fromObject(object.PayRecordList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckNewPayRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {Client2ProxyAckNewPayRecord} message Client2ProxyAckNewPayRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckNewPayRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PayRecordList = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PayRecordList && message.PayRecordList.length) {
            object.PayRecordList = [];
            for (let j = 0; j < message.PayRecordList.length; ++j)
                object.PayRecordList[j] = $root.UserPayRecord.toObject(message.PayRecordList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckNewPayRecord to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckNewPayRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckNewPayRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckNewPayRecord
     * @function getTypeUrl
     * @memberof Client2ProxyAckNewPayRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckNewPayRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckNewPayRecord";
    };

    return Client2ProxyAckNewPayRecord;
})();

export const Client2ProxyReqNewPayUpdate = $root.Client2ProxyReqNewPayUpdate = (() => {

    /**
     * Properties of a Client2ProxyReqNewPayUpdate.
     * @exports IClient2ProxyReqNewPayUpdate
     * @interface IClient2ProxyReqNewPayUpdate
     * @property {number|null} [UserID] Client2ProxyReqNewPayUpdate UserID
     * @property {Array.<string>|null} [Order] Client2ProxyReqNewPayUpdate Order
     */

    /**
     * Constructs a new Client2ProxyReqNewPayUpdate.
     * @exports Client2ProxyReqNewPayUpdate
     * @classdesc Represents a Client2ProxyReqNewPayUpdate.
     * @implements IClient2ProxyReqNewPayUpdate
     * @constructor
     * @param {IClient2ProxyReqNewPayUpdate=} [properties] Properties to set
     */
    function Client2ProxyReqNewPayUpdate(properties) {
        this.Order = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqNewPayUpdate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqNewPayUpdate
     * @instance
     */
    Client2ProxyReqNewPayUpdate.prototype.UserID = 0;

    /**
     * Client2ProxyReqNewPayUpdate Order.
     * @member {Array.<string>} Order
     * @memberof Client2ProxyReqNewPayUpdate
     * @instance
     */
    Client2ProxyReqNewPayUpdate.prototype.Order = $util.emptyArray;

    /**
     * Creates a new Client2ProxyReqNewPayUpdate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {IClient2ProxyReqNewPayUpdate=} [properties] Properties to set
     * @returns {Client2ProxyReqNewPayUpdate} Client2ProxyReqNewPayUpdate instance
     */
    Client2ProxyReqNewPayUpdate.create = function create(properties) {
        return new Client2ProxyReqNewPayUpdate(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqNewPayUpdate message. Does not implicitly {@link Client2ProxyReqNewPayUpdate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {IClient2ProxyReqNewPayUpdate} message Client2ProxyReqNewPayUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqNewPayUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Order != null && message.Order.length)
            for (let i = 0; i < message.Order.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Order[i]);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqNewPayUpdate message, length delimited. Does not implicitly {@link Client2ProxyReqNewPayUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {IClient2ProxyReqNewPayUpdate} message Client2ProxyReqNewPayUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqNewPayUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqNewPayUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqNewPayUpdate} Client2ProxyReqNewPayUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqNewPayUpdate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqNewPayUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.Order && message.Order.length))
                        message.Order = [];
                    message.Order.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqNewPayUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqNewPayUpdate} Client2ProxyReqNewPayUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqNewPayUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqNewPayUpdate message.
     * @function verify
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqNewPayUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Order != null && message.hasOwnProperty("Order")) {
            if (!Array.isArray(message.Order))
                return "Order: array expected";
            for (let i = 0; i < message.Order.length; ++i)
                if (!$util.isString(message.Order[i]))
                    return "Order: string[] expected";
        }
        return null;
    };

    /**
     * Creates a Client2ProxyReqNewPayUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqNewPayUpdate} Client2ProxyReqNewPayUpdate
     */
    Client2ProxyReqNewPayUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqNewPayUpdate)
            return object;
        let message = new $root.Client2ProxyReqNewPayUpdate();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Order) {
            if (!Array.isArray(object.Order))
                throw TypeError(".Client2ProxyReqNewPayUpdate.Order: array expected");
            message.Order = [];
            for (let i = 0; i < object.Order.length; ++i)
                message.Order[i] = String(object.Order[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqNewPayUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {Client2ProxyReqNewPayUpdate} message Client2ProxyReqNewPayUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqNewPayUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Order = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Order && message.Order.length) {
            object.Order = [];
            for (let j = 0; j < message.Order.length; ++j)
                object.Order[j] = message.Order[j];
        }
        return object;
    };

    /**
     * Converts this Client2ProxyReqNewPayUpdate to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqNewPayUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqNewPayUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqNewPayUpdate
     * @function getTypeUrl
     * @memberof Client2ProxyReqNewPayUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqNewPayUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqNewPayUpdate";
    };

    return Client2ProxyReqNewPayUpdate;
})();

export const Client2ProxyAckNewPayUpdate = $root.Client2ProxyAckNewPayUpdate = (() => {

    /**
     * Properties of a Client2ProxyAckNewPayUpdate.
     * @exports IClient2ProxyAckNewPayUpdate
     * @interface IClient2ProxyAckNewPayUpdate
     * @property {number|null} [Ret] Client2ProxyAckNewPayUpdate Ret
     * @property {number|null} [UserID] Client2ProxyAckNewPayUpdate UserID
     */

    /**
     * Constructs a new Client2ProxyAckNewPayUpdate.
     * @exports Client2ProxyAckNewPayUpdate
     * @classdesc Represents a Client2ProxyAckNewPayUpdate.
     * @implements IClient2ProxyAckNewPayUpdate
     * @constructor
     * @param {IClient2ProxyAckNewPayUpdate=} [properties] Properties to set
     */
    function Client2ProxyAckNewPayUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckNewPayUpdate Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckNewPayUpdate
     * @instance
     */
    Client2ProxyAckNewPayUpdate.prototype.Ret = 0;

    /**
     * Client2ProxyAckNewPayUpdate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckNewPayUpdate
     * @instance
     */
    Client2ProxyAckNewPayUpdate.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckNewPayUpdate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {IClient2ProxyAckNewPayUpdate=} [properties] Properties to set
     * @returns {Client2ProxyAckNewPayUpdate} Client2ProxyAckNewPayUpdate instance
     */
    Client2ProxyAckNewPayUpdate.create = function create(properties) {
        return new Client2ProxyAckNewPayUpdate(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckNewPayUpdate message. Does not implicitly {@link Client2ProxyAckNewPayUpdate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {IClient2ProxyAckNewPayUpdate} message Client2ProxyAckNewPayUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckNewPayUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckNewPayUpdate message, length delimited. Does not implicitly {@link Client2ProxyAckNewPayUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {IClient2ProxyAckNewPayUpdate} message Client2ProxyAckNewPayUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckNewPayUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckNewPayUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckNewPayUpdate} Client2ProxyAckNewPayUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckNewPayUpdate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckNewPayUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckNewPayUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckNewPayUpdate} Client2ProxyAckNewPayUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckNewPayUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckNewPayUpdate message.
     * @function verify
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckNewPayUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckNewPayUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckNewPayUpdate} Client2ProxyAckNewPayUpdate
     */
    Client2ProxyAckNewPayUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckNewPayUpdate)
            return object;
        let message = new $root.Client2ProxyAckNewPayUpdate();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckNewPayUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {Client2ProxyAckNewPayUpdate} message Client2ProxyAckNewPayUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckNewPayUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckNewPayUpdate to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckNewPayUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckNewPayUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckNewPayUpdate
     * @function getTypeUrl
     * @memberof Client2ProxyAckNewPayUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckNewPayUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckNewPayUpdate";
    };

    return Client2ProxyAckNewPayUpdate;
})();

export const ClientPageInfo = $root.ClientPageInfo = (() => {

    /**
     * Properties of a ClientPageInfo.
     * @exports IClientPageInfo
     * @interface IClientPageInfo
     * @property {number|null} [Page] ClientPageInfo Page
     * @property {number|null} [PageSize] ClientPageInfo PageSize
     */

    /**
     * Constructs a new ClientPageInfo.
     * @exports ClientPageInfo
     * @classdesc Represents a ClientPageInfo.
     * @implements IClientPageInfo
     * @constructor
     * @param {IClientPageInfo=} [properties] Properties to set
     */
    function ClientPageInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientPageInfo Page.
     * @member {number} Page
     * @memberof ClientPageInfo
     * @instance
     */
    ClientPageInfo.prototype.Page = 0;

    /**
     * ClientPageInfo PageSize.
     * @member {number} PageSize
     * @memberof ClientPageInfo
     * @instance
     */
    ClientPageInfo.prototype.PageSize = 0;

    /**
     * Creates a new ClientPageInfo instance using the specified properties.
     * @function create
     * @memberof ClientPageInfo
     * @static
     * @param {IClientPageInfo=} [properties] Properties to set
     * @returns {ClientPageInfo} ClientPageInfo instance
     */
    ClientPageInfo.create = function create(properties) {
        return new ClientPageInfo(properties);
    };

    /**
     * Encodes the specified ClientPageInfo message. Does not implicitly {@link ClientPageInfo.verify|verify} messages.
     * @function encode
     * @memberof ClientPageInfo
     * @static
     * @param {IClientPageInfo} message ClientPageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientPageInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Page);
        if (message.PageSize != null && Object.hasOwnProperty.call(message, "PageSize"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.PageSize);
        return writer;
    };

    /**
     * Encodes the specified ClientPageInfo message, length delimited. Does not implicitly {@link ClientPageInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientPageInfo
     * @static
     * @param {IClientPageInfo} message ClientPageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientPageInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientPageInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ClientPageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientPageInfo} ClientPageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientPageInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientPageInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Page = reader.uint32();
                    break;
                }
            case 2: {
                    message.PageSize = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientPageInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientPageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientPageInfo} ClientPageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientPageInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientPageInfo message.
     * @function verify
     * @memberof ClientPageInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientPageInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Page != null && message.hasOwnProperty("Page"))
            if (!$util.isInteger(message.Page))
                return "Page: integer expected";
        if (message.PageSize != null && message.hasOwnProperty("PageSize"))
            if (!$util.isInteger(message.PageSize))
                return "PageSize: integer expected";
        return null;
    };

    /**
     * Creates a ClientPageInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientPageInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientPageInfo} ClientPageInfo
     */
    ClientPageInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientPageInfo)
            return object;
        let message = new $root.ClientPageInfo();
        if (object.Page != null)
            message.Page = object.Page >>> 0;
        if (object.PageSize != null)
            message.PageSize = object.PageSize >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientPageInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientPageInfo
     * @static
     * @param {ClientPageInfo} message ClientPageInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientPageInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Page = 0;
            object.PageSize = 0;
        }
        if (message.Page != null && message.hasOwnProperty("Page"))
            object.Page = message.Page;
        if (message.PageSize != null && message.hasOwnProperty("PageSize"))
            object.PageSize = message.PageSize;
        return object;
    };

    /**
     * Converts this ClientPageInfo to JSON.
     * @function toJSON
     * @memberof ClientPageInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientPageInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientPageInfo
     * @function getTypeUrl
     * @memberof ClientPageInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientPageInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientPageInfo";
    };

    return ClientPageInfo;
})();

export const Client2ProxyReqBalanceDetail = $root.Client2ProxyReqBalanceDetail = (() => {

    /**
     * Properties of a Client2ProxyReqBalanceDetail.
     * @exports IClient2ProxyReqBalanceDetail
     * @interface IClient2ProxyReqBalanceDetail
     * @property {number|null} [UserID] Client2ProxyReqBalanceDetail UserID
     * @property {number|null} [QueryType] Client2ProxyReqBalanceDetail QueryType
     * @property {number|Long|null} [StartTimestamp] Client2ProxyReqBalanceDetail StartTimestamp
     * @property {number|Long|null} [EndTimestamp] Client2ProxyReqBalanceDetail EndTimestamp
     * @property {IClientPageInfo|null} [PageInfo] Client2ProxyReqBalanceDetail PageInfo
     */

    /**
     * Constructs a new Client2ProxyReqBalanceDetail.
     * @exports Client2ProxyReqBalanceDetail
     * @classdesc Represents a Client2ProxyReqBalanceDetail.
     * @implements IClient2ProxyReqBalanceDetail
     * @constructor
     * @param {IClient2ProxyReqBalanceDetail=} [properties] Properties to set
     */
    function Client2ProxyReqBalanceDetail(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqBalanceDetail UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     */
    Client2ProxyReqBalanceDetail.prototype.UserID = 0;

    /**
     * Client2ProxyReqBalanceDetail QueryType.
     * @member {number} QueryType
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     */
    Client2ProxyReqBalanceDetail.prototype.QueryType = 0;

    /**
     * Client2ProxyReqBalanceDetail StartTimestamp.
     * @member {number|Long} StartTimestamp
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     */
    Client2ProxyReqBalanceDetail.prototype.StartTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ProxyReqBalanceDetail EndTimestamp.
     * @member {number|Long} EndTimestamp
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     */
    Client2ProxyReqBalanceDetail.prototype.EndTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ProxyReqBalanceDetail PageInfo.
     * @member {IClientPageInfo|null|undefined} PageInfo
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     */
    Client2ProxyReqBalanceDetail.prototype.PageInfo = null;

    /**
     * Creates a new Client2ProxyReqBalanceDetail instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {IClient2ProxyReqBalanceDetail=} [properties] Properties to set
     * @returns {Client2ProxyReqBalanceDetail} Client2ProxyReqBalanceDetail instance
     */
    Client2ProxyReqBalanceDetail.create = function create(properties) {
        return new Client2ProxyReqBalanceDetail(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqBalanceDetail message. Does not implicitly {@link Client2ProxyReqBalanceDetail.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {IClient2ProxyReqBalanceDetail} message Client2ProxyReqBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqBalanceDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.QueryType != null && Object.hasOwnProperty.call(message, "QueryType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.QueryType);
        if (message.StartTimestamp != null && Object.hasOwnProperty.call(message, "StartTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.StartTimestamp);
        if (message.EndTimestamp != null && Object.hasOwnProperty.call(message, "EndTimestamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.EndTimestamp);
        if (message.PageInfo != null && Object.hasOwnProperty.call(message, "PageInfo"))
            $root.ClientPageInfo.encode(message.PageInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqBalanceDetail message, length delimited. Does not implicitly {@link Client2ProxyReqBalanceDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {IClient2ProxyReqBalanceDetail} message Client2ProxyReqBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqBalanceDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqBalanceDetail message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqBalanceDetail} Client2ProxyReqBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqBalanceDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqBalanceDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.QueryType = reader.uint32();
                    break;
                }
            case 3: {
                    message.StartTimestamp = reader.uint64();
                    break;
                }
            case 4: {
                    message.EndTimestamp = reader.uint64();
                    break;
                }
            case 5: {
                    message.PageInfo = $root.ClientPageInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqBalanceDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqBalanceDetail} Client2ProxyReqBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqBalanceDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqBalanceDetail message.
     * @function verify
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqBalanceDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.QueryType != null && message.hasOwnProperty("QueryType"))
            if (!$util.isInteger(message.QueryType))
                return "QueryType: integer expected";
        if (message.StartTimestamp != null && message.hasOwnProperty("StartTimestamp"))
            if (!$util.isInteger(message.StartTimestamp) && !(message.StartTimestamp && $util.isInteger(message.StartTimestamp.low) && $util.isInteger(message.StartTimestamp.high)))
                return "StartTimestamp: integer|Long expected";
        if (message.EndTimestamp != null && message.hasOwnProperty("EndTimestamp"))
            if (!$util.isInteger(message.EndTimestamp) && !(message.EndTimestamp && $util.isInteger(message.EndTimestamp.low) && $util.isInteger(message.EndTimestamp.high)))
                return "EndTimestamp: integer|Long expected";
        if (message.PageInfo != null && message.hasOwnProperty("PageInfo")) {
            let error = $root.ClientPageInfo.verify(message.PageInfo);
            if (error)
                return "PageInfo." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyReqBalanceDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqBalanceDetail} Client2ProxyReqBalanceDetail
     */
    Client2ProxyReqBalanceDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqBalanceDetail)
            return object;
        let message = new $root.Client2ProxyReqBalanceDetail();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.QueryType != null)
            message.QueryType = object.QueryType >>> 0;
        if (object.StartTimestamp != null)
            if ($util.Long)
                (message.StartTimestamp = $util.Long.fromValue(object.StartTimestamp)).unsigned = true;
            else if (typeof object.StartTimestamp === "string")
                message.StartTimestamp = parseInt(object.StartTimestamp, 10);
            else if (typeof object.StartTimestamp === "number")
                message.StartTimestamp = object.StartTimestamp;
            else if (typeof object.StartTimestamp === "object")
                message.StartTimestamp = new $util.LongBits(object.StartTimestamp.low >>> 0, object.StartTimestamp.high >>> 0).toNumber(true);
        if (object.EndTimestamp != null)
            if ($util.Long)
                (message.EndTimestamp = $util.Long.fromValue(object.EndTimestamp)).unsigned = true;
            else if (typeof object.EndTimestamp === "string")
                message.EndTimestamp = parseInt(object.EndTimestamp, 10);
            else if (typeof object.EndTimestamp === "number")
                message.EndTimestamp = object.EndTimestamp;
            else if (typeof object.EndTimestamp === "object")
                message.EndTimestamp = new $util.LongBits(object.EndTimestamp.low >>> 0, object.EndTimestamp.high >>> 0).toNumber(true);
        if (object.PageInfo != null) {
            if (typeof object.PageInfo !== "object")
                throw TypeError(".Client2ProxyReqBalanceDetail.PageInfo: object expected");
            message.PageInfo = $root.ClientPageInfo.fromObject(object.PageInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqBalanceDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {Client2ProxyReqBalanceDetail} message Client2ProxyReqBalanceDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqBalanceDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.QueryType = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTimestamp = options.longs === String ? "0" : 0;
            object.PageInfo = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.QueryType != null && message.hasOwnProperty("QueryType"))
            object.QueryType = message.QueryType;
        if (message.StartTimestamp != null && message.hasOwnProperty("StartTimestamp"))
            if (typeof message.StartTimestamp === "number")
                object.StartTimestamp = options.longs === String ? String(message.StartTimestamp) : message.StartTimestamp;
            else
                object.StartTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.StartTimestamp) : options.longs === Number ? new $util.LongBits(message.StartTimestamp.low >>> 0, message.StartTimestamp.high >>> 0).toNumber(true) : message.StartTimestamp;
        if (message.EndTimestamp != null && message.hasOwnProperty("EndTimestamp"))
            if (typeof message.EndTimestamp === "number")
                object.EndTimestamp = options.longs === String ? String(message.EndTimestamp) : message.EndTimestamp;
            else
                object.EndTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.EndTimestamp) : options.longs === Number ? new $util.LongBits(message.EndTimestamp.low >>> 0, message.EndTimestamp.high >>> 0).toNumber(true) : message.EndTimestamp;
        if (message.PageInfo != null && message.hasOwnProperty("PageInfo"))
            object.PageInfo = $root.ClientPageInfo.toObject(message.PageInfo, options);
        return object;
    };

    /**
     * Converts this Client2ProxyReqBalanceDetail to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqBalanceDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqBalanceDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqBalanceDetail
     * @function getTypeUrl
     * @memberof Client2ProxyReqBalanceDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqBalanceDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqBalanceDetail";
    };

    return Client2ProxyReqBalanceDetail;
})();

export const Client2ProxyAckBalanceDetail = $root.Client2ProxyAckBalanceDetail = (() => {

    /**
     * Properties of a Client2ProxyAckBalanceDetail.
     * @exports IClient2ProxyAckBalanceDetail
     * @interface IClient2ProxyAckBalanceDetail
     * @property {number|null} [Ret] Client2ProxyAckBalanceDetail Ret
     * @property {number|null} [UserID] Client2ProxyAckBalanceDetail UserID
     * @property {Array.<IAccountBalanceDetail>|null} [BalanceDetail] Client2ProxyAckBalanceDetail BalanceDetail
     * @property {IClientPageInfo|null} [PageInfo] Client2ProxyAckBalanceDetail PageInfo
     */

    /**
     * Constructs a new Client2ProxyAckBalanceDetail.
     * @exports Client2ProxyAckBalanceDetail
     * @classdesc Represents a Client2ProxyAckBalanceDetail.
     * @implements IClient2ProxyAckBalanceDetail
     * @constructor
     * @param {IClient2ProxyAckBalanceDetail=} [properties] Properties to set
     */
    function Client2ProxyAckBalanceDetail(properties) {
        this.BalanceDetail = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckBalanceDetail Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckBalanceDetail
     * @instance
     */
    Client2ProxyAckBalanceDetail.prototype.Ret = 0;

    /**
     * Client2ProxyAckBalanceDetail UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckBalanceDetail
     * @instance
     */
    Client2ProxyAckBalanceDetail.prototype.UserID = 0;

    /**
     * Client2ProxyAckBalanceDetail BalanceDetail.
     * @member {Array.<IAccountBalanceDetail>} BalanceDetail
     * @memberof Client2ProxyAckBalanceDetail
     * @instance
     */
    Client2ProxyAckBalanceDetail.prototype.BalanceDetail = $util.emptyArray;

    /**
     * Client2ProxyAckBalanceDetail PageInfo.
     * @member {IClientPageInfo|null|undefined} PageInfo
     * @memberof Client2ProxyAckBalanceDetail
     * @instance
     */
    Client2ProxyAckBalanceDetail.prototype.PageInfo = null;

    /**
     * Creates a new Client2ProxyAckBalanceDetail instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {IClient2ProxyAckBalanceDetail=} [properties] Properties to set
     * @returns {Client2ProxyAckBalanceDetail} Client2ProxyAckBalanceDetail instance
     */
    Client2ProxyAckBalanceDetail.create = function create(properties) {
        return new Client2ProxyAckBalanceDetail(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckBalanceDetail message. Does not implicitly {@link Client2ProxyAckBalanceDetail.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {IClient2ProxyAckBalanceDetail} message Client2ProxyAckBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckBalanceDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.BalanceDetail != null && message.BalanceDetail.length)
            for (let i = 0; i < message.BalanceDetail.length; ++i)
                $root.AccountBalanceDetail.encode(message.BalanceDetail[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.PageInfo != null && Object.hasOwnProperty.call(message, "PageInfo"))
            $root.ClientPageInfo.encode(message.PageInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckBalanceDetail message, length delimited. Does not implicitly {@link Client2ProxyAckBalanceDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {IClient2ProxyAckBalanceDetail} message Client2ProxyAckBalanceDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckBalanceDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckBalanceDetail message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckBalanceDetail} Client2ProxyAckBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckBalanceDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckBalanceDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.BalanceDetail && message.BalanceDetail.length))
                        message.BalanceDetail = [];
                    message.BalanceDetail.push($root.AccountBalanceDetail.decode(reader, reader.uint32()));
                    break;
                }
            case 4: {
                    message.PageInfo = $root.ClientPageInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckBalanceDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckBalanceDetail} Client2ProxyAckBalanceDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckBalanceDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckBalanceDetail message.
     * @function verify
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckBalanceDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BalanceDetail != null && message.hasOwnProperty("BalanceDetail")) {
            if (!Array.isArray(message.BalanceDetail))
                return "BalanceDetail: array expected";
            for (let i = 0; i < message.BalanceDetail.length; ++i) {
                let error = $root.AccountBalanceDetail.verify(message.BalanceDetail[i]);
                if (error)
                    return "BalanceDetail." + error;
            }
        }
        if (message.PageInfo != null && message.hasOwnProperty("PageInfo")) {
            let error = $root.ClientPageInfo.verify(message.PageInfo);
            if (error)
                return "PageInfo." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckBalanceDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckBalanceDetail} Client2ProxyAckBalanceDetail
     */
    Client2ProxyAckBalanceDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckBalanceDetail)
            return object;
        let message = new $root.Client2ProxyAckBalanceDetail();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BalanceDetail) {
            if (!Array.isArray(object.BalanceDetail))
                throw TypeError(".Client2ProxyAckBalanceDetail.BalanceDetail: array expected");
            message.BalanceDetail = [];
            for (let i = 0; i < object.BalanceDetail.length; ++i) {
                if (typeof object.BalanceDetail[i] !== "object")
                    throw TypeError(".Client2ProxyAckBalanceDetail.BalanceDetail: object expected");
                message.BalanceDetail[i] = $root.AccountBalanceDetail.fromObject(object.BalanceDetail[i]);
            }
        }
        if (object.PageInfo != null) {
            if (typeof object.PageInfo !== "object")
                throw TypeError(".Client2ProxyAckBalanceDetail.PageInfo: object expected");
            message.PageInfo = $root.ClientPageInfo.fromObject(object.PageInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckBalanceDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {Client2ProxyAckBalanceDetail} message Client2ProxyAckBalanceDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckBalanceDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BalanceDetail = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.PageInfo = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BalanceDetail && message.BalanceDetail.length) {
            object.BalanceDetail = [];
            for (let j = 0; j < message.BalanceDetail.length; ++j)
                object.BalanceDetail[j] = $root.AccountBalanceDetail.toObject(message.BalanceDetail[j], options);
        }
        if (message.PageInfo != null && message.hasOwnProperty("PageInfo"))
            object.PageInfo = $root.ClientPageInfo.toObject(message.PageInfo, options);
        return object;
    };

    /**
     * Converts this Client2ProxyAckBalanceDetail to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckBalanceDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckBalanceDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckBalanceDetail
     * @function getTypeUrl
     * @memberof Client2ProxyAckBalanceDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckBalanceDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckBalanceDetail";
    };

    return Client2ProxyAckBalanceDetail;
})();

export const Client2ProxyReqActivityDetail = $root.Client2ProxyReqActivityDetail = (() => {

    /**
     * Properties of a Client2ProxyReqActivityDetail.
     * @exports IClient2ProxyReqActivityDetail
     * @interface IClient2ProxyReqActivityDetail
     * @property {number|null} [UserID] Client2ProxyReqActivityDetail UserID
     */

    /**
     * Constructs a new Client2ProxyReqActivityDetail.
     * @exports Client2ProxyReqActivityDetail
     * @classdesc Represents a Client2ProxyReqActivityDetail.
     * @implements IClient2ProxyReqActivityDetail
     * @constructor
     * @param {IClient2ProxyReqActivityDetail=} [properties] Properties to set
     */
    function Client2ProxyReqActivityDetail(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqActivityDetail UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqActivityDetail
     * @instance
     */
    Client2ProxyReqActivityDetail.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqActivityDetail instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {IClient2ProxyReqActivityDetail=} [properties] Properties to set
     * @returns {Client2ProxyReqActivityDetail} Client2ProxyReqActivityDetail instance
     */
    Client2ProxyReqActivityDetail.create = function create(properties) {
        return new Client2ProxyReqActivityDetail(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqActivityDetail message. Does not implicitly {@link Client2ProxyReqActivityDetail.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {IClient2ProxyReqActivityDetail} message Client2ProxyReqActivityDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqActivityDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqActivityDetail message, length delimited. Does not implicitly {@link Client2ProxyReqActivityDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {IClient2ProxyReqActivityDetail} message Client2ProxyReqActivityDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqActivityDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqActivityDetail message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqActivityDetail} Client2ProxyReqActivityDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqActivityDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqActivityDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqActivityDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqActivityDetail} Client2ProxyReqActivityDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqActivityDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqActivityDetail message.
     * @function verify
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqActivityDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqActivityDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqActivityDetail} Client2ProxyReqActivityDetail
     */
    Client2ProxyReqActivityDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqActivityDetail)
            return object;
        let message = new $root.Client2ProxyReqActivityDetail();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqActivityDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {Client2ProxyReqActivityDetail} message Client2ProxyReqActivityDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqActivityDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqActivityDetail to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqActivityDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqActivityDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqActivityDetail
     * @function getTypeUrl
     * @memberof Client2ProxyReqActivityDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqActivityDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqActivityDetail";
    };

    return Client2ProxyReqActivityDetail;
})();

export const Client2ProxyAckActivityDetail = $root.Client2ProxyAckActivityDetail = (() => {

    /**
     * Properties of a Client2ProxyAckActivityDetail.
     * @exports IClient2ProxyAckActivityDetail
     * @interface IClient2ProxyAckActivityDetail
     * @property {number|null} [UserID] Client2ProxyAckActivityDetail UserID
     * @property {Array.<IClientActivity>|null} [Activitys] Client2ProxyAckActivityDetail Activitys
     */

    /**
     * Constructs a new Client2ProxyAckActivityDetail.
     * @exports Client2ProxyAckActivityDetail
     * @classdesc Represents a Client2ProxyAckActivityDetail.
     * @implements IClient2ProxyAckActivityDetail
     * @constructor
     * @param {IClient2ProxyAckActivityDetail=} [properties] Properties to set
     */
    function Client2ProxyAckActivityDetail(properties) {
        this.Activitys = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckActivityDetail UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckActivityDetail
     * @instance
     */
    Client2ProxyAckActivityDetail.prototype.UserID = 0;

    /**
     * Client2ProxyAckActivityDetail Activitys.
     * @member {Array.<IClientActivity>} Activitys
     * @memberof Client2ProxyAckActivityDetail
     * @instance
     */
    Client2ProxyAckActivityDetail.prototype.Activitys = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckActivityDetail instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {IClient2ProxyAckActivityDetail=} [properties] Properties to set
     * @returns {Client2ProxyAckActivityDetail} Client2ProxyAckActivityDetail instance
     */
    Client2ProxyAckActivityDetail.create = function create(properties) {
        return new Client2ProxyAckActivityDetail(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckActivityDetail message. Does not implicitly {@link Client2ProxyAckActivityDetail.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {IClient2ProxyAckActivityDetail} message Client2ProxyAckActivityDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckActivityDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Activitys != null && message.Activitys.length)
            for (let i = 0; i < message.Activitys.length; ++i)
                $root.ClientActivity.encode(message.Activitys[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckActivityDetail message, length delimited. Does not implicitly {@link Client2ProxyAckActivityDetail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {IClient2ProxyAckActivityDetail} message Client2ProxyAckActivityDetail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckActivityDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckActivityDetail message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckActivityDetail} Client2ProxyAckActivityDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckActivityDetail.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckActivityDetail();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.Activitys && message.Activitys.length))
                        message.Activitys = [];
                    message.Activitys.push($root.ClientActivity.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckActivityDetail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckActivityDetail} Client2ProxyAckActivityDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckActivityDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckActivityDetail message.
     * @function verify
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckActivityDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Activitys != null && message.hasOwnProperty("Activitys")) {
            if (!Array.isArray(message.Activitys))
                return "Activitys: array expected";
            for (let i = 0; i < message.Activitys.length; ++i) {
                let error = $root.ClientActivity.verify(message.Activitys[i]);
                if (error)
                    return "Activitys." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckActivityDetail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckActivityDetail} Client2ProxyAckActivityDetail
     */
    Client2ProxyAckActivityDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckActivityDetail)
            return object;
        let message = new $root.Client2ProxyAckActivityDetail();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Activitys) {
            if (!Array.isArray(object.Activitys))
                throw TypeError(".Client2ProxyAckActivityDetail.Activitys: array expected");
            message.Activitys = [];
            for (let i = 0; i < object.Activitys.length; ++i) {
                if (typeof object.Activitys[i] !== "object")
                    throw TypeError(".Client2ProxyAckActivityDetail.Activitys: object expected");
                message.Activitys[i] = $root.ClientActivity.fromObject(object.Activitys[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckActivityDetail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {Client2ProxyAckActivityDetail} message Client2ProxyAckActivityDetail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckActivityDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Activitys = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Activitys && message.Activitys.length) {
            object.Activitys = [];
            for (let j = 0; j < message.Activitys.length; ++j)
                object.Activitys[j] = $root.ClientActivity.toObject(message.Activitys[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckActivityDetail to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckActivityDetail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckActivityDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckActivityDetail
     * @function getTypeUrl
     * @memberof Client2ProxyAckActivityDetail
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckActivityDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckActivityDetail";
    };

    return Client2ProxyAckActivityDetail;
})();

export const Client2ProxyReqAppleCancel = $root.Client2ProxyReqAppleCancel = (() => {

    /**
     * Properties of a Client2ProxyReqAppleCancel.
     * @exports IClient2ProxyReqAppleCancel
     * @interface IClient2ProxyReqAppleCancel
     * @property {number|null} [UserID] Client2ProxyReqAppleCancel UserID
     */

    /**
     * Constructs a new Client2ProxyReqAppleCancel.
     * @exports Client2ProxyReqAppleCancel
     * @classdesc Represents a Client2ProxyReqAppleCancel.
     * @implements IClient2ProxyReqAppleCancel
     * @constructor
     * @param {IClient2ProxyReqAppleCancel=} [properties] Properties to set
     */
    function Client2ProxyReqAppleCancel(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAppleCancel UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqAppleCancel
     * @instance
     */
    Client2ProxyReqAppleCancel.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqAppleCancel instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {IClient2ProxyReqAppleCancel=} [properties] Properties to set
     * @returns {Client2ProxyReqAppleCancel} Client2ProxyReqAppleCancel instance
     */
    Client2ProxyReqAppleCancel.create = function create(properties) {
        return new Client2ProxyReqAppleCancel(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAppleCancel message. Does not implicitly {@link Client2ProxyReqAppleCancel.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {IClient2ProxyReqAppleCancel} message Client2ProxyReqAppleCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAppleCancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAppleCancel message, length delimited. Does not implicitly {@link Client2ProxyReqAppleCancel.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {IClient2ProxyReqAppleCancel} message Client2ProxyReqAppleCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAppleCancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAppleCancel message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAppleCancel} Client2ProxyReqAppleCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAppleCancel.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAppleCancel();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAppleCancel message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAppleCancel} Client2ProxyReqAppleCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAppleCancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAppleCancel message.
     * @function verify
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAppleCancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqAppleCancel message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAppleCancel} Client2ProxyReqAppleCancel
     */
    Client2ProxyReqAppleCancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAppleCancel)
            return object;
        let message = new $root.Client2ProxyReqAppleCancel();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAppleCancel message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {Client2ProxyReqAppleCancel} message Client2ProxyReqAppleCancel
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAppleCancel.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqAppleCancel to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAppleCancel
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAppleCancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAppleCancel
     * @function getTypeUrl
     * @memberof Client2ProxyReqAppleCancel
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAppleCancel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAppleCancel";
    };

    return Client2ProxyReqAppleCancel;
})();

export const Client2ProxyAckAppleCancel = $root.Client2ProxyAckAppleCancel = (() => {

    /**
     * Properties of a Client2ProxyAckAppleCancel.
     * @exports IClient2ProxyAckAppleCancel
     * @interface IClient2ProxyAckAppleCancel
     * @property {number|null} [Res] Client2ProxyAckAppleCancel Res
     */

    /**
     * Constructs a new Client2ProxyAckAppleCancel.
     * @exports Client2ProxyAckAppleCancel
     * @classdesc Represents a Client2ProxyAckAppleCancel.
     * @implements IClient2ProxyAckAppleCancel
     * @constructor
     * @param {IClient2ProxyAckAppleCancel=} [properties] Properties to set
     */
    function Client2ProxyAckAppleCancel(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckAppleCancel Res.
     * @member {number} Res
     * @memberof Client2ProxyAckAppleCancel
     * @instance
     */
    Client2ProxyAckAppleCancel.prototype.Res = 0;

    /**
     * Creates a new Client2ProxyAckAppleCancel instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {IClient2ProxyAckAppleCancel=} [properties] Properties to set
     * @returns {Client2ProxyAckAppleCancel} Client2ProxyAckAppleCancel instance
     */
    Client2ProxyAckAppleCancel.create = function create(properties) {
        return new Client2ProxyAckAppleCancel(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckAppleCancel message. Does not implicitly {@link Client2ProxyAckAppleCancel.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {IClient2ProxyAckAppleCancel} message Client2ProxyAckAppleCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAppleCancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckAppleCancel message, length delimited. Does not implicitly {@link Client2ProxyAckAppleCancel.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {IClient2ProxyAckAppleCancel} message Client2ProxyAckAppleCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAppleCancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckAppleCancel message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckAppleCancel} Client2ProxyAckAppleCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAppleCancel.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckAppleCancel();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckAppleCancel message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckAppleCancel} Client2ProxyAckAppleCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAppleCancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckAppleCancel message.
     * @function verify
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckAppleCancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckAppleCancel message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckAppleCancel} Client2ProxyAckAppleCancel
     */
    Client2ProxyAckAppleCancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckAppleCancel)
            return object;
        let message = new $root.Client2ProxyAckAppleCancel();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckAppleCancel message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {Client2ProxyAckAppleCancel} message Client2ProxyAckAppleCancel
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckAppleCancel.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.Res = 0;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        return object;
    };

    /**
     * Converts this Client2ProxyAckAppleCancel to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckAppleCancel
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckAppleCancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckAppleCancel
     * @function getTypeUrl
     * @memberof Client2ProxyAckAppleCancel
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckAppleCancel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckAppleCancel";
    };

    return Client2ProxyAckAppleCancel;
})();

export const Client2ProxyReqAgentRebate = $root.Client2ProxyReqAgentRebate = (() => {

    /**
     * Properties of a Client2ProxyReqAgentRebate.
     * @exports IClient2ProxyReqAgentRebate
     * @interface IClient2ProxyReqAgentRebate
     * @property {number|null} [UserID] Client2ProxyReqAgentRebate UserID
     * @property {number|Long|null} [StartTimestamp] Client2ProxyReqAgentRebate StartTimestamp
     */

    /**
     * Constructs a new Client2ProxyReqAgentRebate.
     * @exports Client2ProxyReqAgentRebate
     * @classdesc Represents a Client2ProxyReqAgentRebate.
     * @implements IClient2ProxyReqAgentRebate
     * @constructor
     * @param {IClient2ProxyReqAgentRebate=} [properties] Properties to set
     */
    function Client2ProxyReqAgentRebate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAgentRebate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqAgentRebate
     * @instance
     */
    Client2ProxyReqAgentRebate.prototype.UserID = 0;

    /**
     * Client2ProxyReqAgentRebate StartTimestamp.
     * @member {number|Long} StartTimestamp
     * @memberof Client2ProxyReqAgentRebate
     * @instance
     */
    Client2ProxyReqAgentRebate.prototype.StartTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2ProxyReqAgentRebate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {IClient2ProxyReqAgentRebate=} [properties] Properties to set
     * @returns {Client2ProxyReqAgentRebate} Client2ProxyReqAgentRebate instance
     */
    Client2ProxyReqAgentRebate.create = function create(properties) {
        return new Client2ProxyReqAgentRebate(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAgentRebate message. Does not implicitly {@link Client2ProxyReqAgentRebate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {IClient2ProxyReqAgentRebate} message Client2ProxyReqAgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentRebate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StartTimestamp != null && Object.hasOwnProperty.call(message, "StartTimestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StartTimestamp);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAgentRebate message, length delimited. Does not implicitly {@link Client2ProxyReqAgentRebate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {IClient2ProxyReqAgentRebate} message Client2ProxyReqAgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentRebate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAgentRebate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAgentRebate} Client2ProxyReqAgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentRebate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAgentRebate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StartTimestamp = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAgentRebate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAgentRebate} Client2ProxyReqAgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentRebate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAgentRebate message.
     * @function verify
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAgentRebate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StartTimestamp != null && message.hasOwnProperty("StartTimestamp"))
            if (!$util.isInteger(message.StartTimestamp) && !(message.StartTimestamp && $util.isInteger(message.StartTimestamp.low) && $util.isInteger(message.StartTimestamp.high)))
                return "StartTimestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqAgentRebate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAgentRebate} Client2ProxyReqAgentRebate
     */
    Client2ProxyReqAgentRebate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAgentRebate)
            return object;
        let message = new $root.Client2ProxyReqAgentRebate();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StartTimestamp != null)
            if ($util.Long)
                (message.StartTimestamp = $util.Long.fromValue(object.StartTimestamp)).unsigned = true;
            else if (typeof object.StartTimestamp === "string")
                message.StartTimestamp = parseInt(object.StartTimestamp, 10);
            else if (typeof object.StartTimestamp === "number")
                message.StartTimestamp = object.StartTimestamp;
            else if (typeof object.StartTimestamp === "object")
                message.StartTimestamp = new $util.LongBits(object.StartTimestamp.low >>> 0, object.StartTimestamp.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAgentRebate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {Client2ProxyReqAgentRebate} message Client2ProxyReqAgentRebate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAgentRebate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTimestamp = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StartTimestamp != null && message.hasOwnProperty("StartTimestamp"))
            if (typeof message.StartTimestamp === "number")
                object.StartTimestamp = options.longs === String ? String(message.StartTimestamp) : message.StartTimestamp;
            else
                object.StartTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.StartTimestamp) : options.longs === Number ? new $util.LongBits(message.StartTimestamp.low >>> 0, message.StartTimestamp.high >>> 0).toNumber(true) : message.StartTimestamp;
        return object;
    };

    /**
     * Converts this Client2ProxyReqAgentRebate to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAgentRebate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAgentRebate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAgentRebate
     * @function getTypeUrl
     * @memberof Client2ProxyReqAgentRebate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAgentRebate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAgentRebate";
    };

    return Client2ProxyReqAgentRebate;
})();

export const Client2ProxyAckAgentRebate = $root.Client2ProxyAckAgentRebate = (() => {

    /**
     * Properties of a Client2ProxyAckAgentRebate.
     * @exports IClient2ProxyAckAgentRebate
     * @interface IClient2ProxyAckAgentRebate
     * @property {number|null} [Res] Client2ProxyAckAgentRebate Res
     * @property {number|null} [UserID] Client2ProxyAckAgentRebate UserID
     * @property {number|null} [NewSub] Client2ProxyAckAgentRebate NewSub
     * @property {number|null} [RebateSub] Client2ProxyAckAgentRebate RebateSub
     * @property {string|null} [Total] Client2ProxyAckAgentRebate Total
     * @property {string|null} [CanGet] Client2ProxyAckAgentRebate CanGet
     */

    /**
     * Constructs a new Client2ProxyAckAgentRebate.
     * @exports Client2ProxyAckAgentRebate
     * @classdesc Represents a Client2ProxyAckAgentRebate.
     * @implements IClient2ProxyAckAgentRebate
     * @constructor
     * @param {IClient2ProxyAckAgentRebate=} [properties] Properties to set
     */
    function Client2ProxyAckAgentRebate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckAgentRebate Res.
     * @member {number} Res
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.Res = 0;

    /**
     * Client2ProxyAckAgentRebate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.UserID = 0;

    /**
     * Client2ProxyAckAgentRebate NewSub.
     * @member {number} NewSub
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.NewSub = 0;

    /**
     * Client2ProxyAckAgentRebate RebateSub.
     * @member {number} RebateSub
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.RebateSub = 0;

    /**
     * Client2ProxyAckAgentRebate Total.
     * @member {string} Total
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.Total = "";

    /**
     * Client2ProxyAckAgentRebate CanGet.
     * @member {string} CanGet
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     */
    Client2ProxyAckAgentRebate.prototype.CanGet = "";

    /**
     * Creates a new Client2ProxyAckAgentRebate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {IClient2ProxyAckAgentRebate=} [properties] Properties to set
     * @returns {Client2ProxyAckAgentRebate} Client2ProxyAckAgentRebate instance
     */
    Client2ProxyAckAgentRebate.create = function create(properties) {
        return new Client2ProxyAckAgentRebate(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckAgentRebate message. Does not implicitly {@link Client2ProxyAckAgentRebate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {IClient2ProxyAckAgentRebate} message Client2ProxyAckAgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentRebate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NewSub != null && Object.hasOwnProperty.call(message, "NewSub"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.NewSub);
        if (message.RebateSub != null && Object.hasOwnProperty.call(message, "RebateSub"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.RebateSub);
        if (message.Total != null && Object.hasOwnProperty.call(message, "Total"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Total);
        if (message.CanGet != null && Object.hasOwnProperty.call(message, "CanGet"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.CanGet);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckAgentRebate message, length delimited. Does not implicitly {@link Client2ProxyAckAgentRebate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {IClient2ProxyAckAgentRebate} message Client2ProxyAckAgentRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentRebate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckAgentRebate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckAgentRebate} Client2ProxyAckAgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentRebate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckAgentRebate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NewSub = reader.uint32();
                    break;
                }
            case 4: {
                    message.RebateSub = reader.uint32();
                    break;
                }
            case 5: {
                    message.Total = reader.string();
                    break;
                }
            case 6: {
                    message.CanGet = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckAgentRebate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckAgentRebate} Client2ProxyAckAgentRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentRebate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckAgentRebate message.
     * @function verify
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckAgentRebate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewSub != null && message.hasOwnProperty("NewSub"))
            if (!$util.isInteger(message.NewSub))
                return "NewSub: integer expected";
        if (message.RebateSub != null && message.hasOwnProperty("RebateSub"))
            if (!$util.isInteger(message.RebateSub))
                return "RebateSub: integer expected";
        if (message.Total != null && message.hasOwnProperty("Total"))
            if (!$util.isString(message.Total))
                return "Total: string expected";
        if (message.CanGet != null && message.hasOwnProperty("CanGet"))
            if (!$util.isString(message.CanGet))
                return "CanGet: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckAgentRebate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckAgentRebate} Client2ProxyAckAgentRebate
     */
    Client2ProxyAckAgentRebate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckAgentRebate)
            return object;
        let message = new $root.Client2ProxyAckAgentRebate();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewSub != null)
            message.NewSub = object.NewSub >>> 0;
        if (object.RebateSub != null)
            message.RebateSub = object.RebateSub >>> 0;
        if (object.Total != null)
            message.Total = String(object.Total);
        if (object.CanGet != null)
            message.CanGet = String(object.CanGet);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckAgentRebate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {Client2ProxyAckAgentRebate} message Client2ProxyAckAgentRebate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckAgentRebate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.NewSub = 0;
            object.RebateSub = 0;
            object.Total = "";
            object.CanGet = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewSub != null && message.hasOwnProperty("NewSub"))
            object.NewSub = message.NewSub;
        if (message.RebateSub != null && message.hasOwnProperty("RebateSub"))
            object.RebateSub = message.RebateSub;
        if (message.Total != null && message.hasOwnProperty("Total"))
            object.Total = message.Total;
        if (message.CanGet != null && message.hasOwnProperty("CanGet"))
            object.CanGet = message.CanGet;
        return object;
    };

    /**
     * Converts this Client2ProxyAckAgentRebate to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckAgentRebate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckAgentRebate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckAgentRebate
     * @function getTypeUrl
     * @memberof Client2ProxyAckAgentRebate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckAgentRebate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckAgentRebate";
    };

    return Client2ProxyAckAgentRebate;
})();

export const Client2ProxyReqAgentRebateInfo = $root.Client2ProxyReqAgentRebateInfo = (() => {

    /**
     * Properties of a Client2ProxyReqAgentRebateInfo.
     * @exports IClient2ProxyReqAgentRebateInfo
     * @interface IClient2ProxyReqAgentRebateInfo
     * @property {number|null} [UserID] Client2ProxyReqAgentRebateInfo UserID
     * @property {number|Long|null} [StartTime] Client2ProxyReqAgentRebateInfo StartTime
     * @property {IPageInfo|null} [Pages] Client2ProxyReqAgentRebateInfo Pages
     */

    /**
     * Constructs a new Client2ProxyReqAgentRebateInfo.
     * @exports Client2ProxyReqAgentRebateInfo
     * @classdesc Represents a Client2ProxyReqAgentRebateInfo.
     * @implements IClient2ProxyReqAgentRebateInfo
     * @constructor
     * @param {IClient2ProxyReqAgentRebateInfo=} [properties] Properties to set
     */
    function Client2ProxyReqAgentRebateInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAgentRebateInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqAgentRebateInfo
     * @instance
     */
    Client2ProxyReqAgentRebateInfo.prototype.UserID = 0;

    /**
     * Client2ProxyReqAgentRebateInfo StartTime.
     * @member {number|Long} StartTime
     * @memberof Client2ProxyReqAgentRebateInfo
     * @instance
     */
    Client2ProxyReqAgentRebateInfo.prototype.StartTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ProxyReqAgentRebateInfo Pages.
     * @member {IPageInfo|null|undefined} Pages
     * @memberof Client2ProxyReqAgentRebateInfo
     * @instance
     */
    Client2ProxyReqAgentRebateInfo.prototype.Pages = null;

    /**
     * Creates a new Client2ProxyReqAgentRebateInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {IClient2ProxyReqAgentRebateInfo=} [properties] Properties to set
     * @returns {Client2ProxyReqAgentRebateInfo} Client2ProxyReqAgentRebateInfo instance
     */
    Client2ProxyReqAgentRebateInfo.create = function create(properties) {
        return new Client2ProxyReqAgentRebateInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAgentRebateInfo message. Does not implicitly {@link Client2ProxyReqAgentRebateInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {IClient2ProxyReqAgentRebateInfo} message Client2ProxyReqAgentRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentRebateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StartTime != null && Object.hasOwnProperty.call(message, "StartTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StartTime);
        if (message.Pages != null && Object.hasOwnProperty.call(message, "Pages"))
            $root.PageInfo.encode(message.Pages, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAgentRebateInfo message, length delimited. Does not implicitly {@link Client2ProxyReqAgentRebateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {IClient2ProxyReqAgentRebateInfo} message Client2ProxyReqAgentRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentRebateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAgentRebateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAgentRebateInfo} Client2ProxyReqAgentRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentRebateInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAgentRebateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StartTime = reader.uint64();
                    break;
                }
            case 3: {
                    message.Pages = $root.PageInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAgentRebateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAgentRebateInfo} Client2ProxyReqAgentRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentRebateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAgentRebateInfo message.
     * @function verify
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAgentRebateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (!$util.isInteger(message.StartTime) && !(message.StartTime && $util.isInteger(message.StartTime.low) && $util.isInteger(message.StartTime.high)))
                return "StartTime: integer|Long expected";
        if (message.Pages != null && message.hasOwnProperty("Pages")) {
            let error = $root.PageInfo.verify(message.Pages);
            if (error)
                return "Pages." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyReqAgentRebateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAgentRebateInfo} Client2ProxyReqAgentRebateInfo
     */
    Client2ProxyReqAgentRebateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAgentRebateInfo)
            return object;
        let message = new $root.Client2ProxyReqAgentRebateInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StartTime != null)
            if ($util.Long)
                (message.StartTime = $util.Long.fromValue(object.StartTime)).unsigned = true;
            else if (typeof object.StartTime === "string")
                message.StartTime = parseInt(object.StartTime, 10);
            else if (typeof object.StartTime === "number")
                message.StartTime = object.StartTime;
            else if (typeof object.StartTime === "object")
                message.StartTime = new $util.LongBits(object.StartTime.low >>> 0, object.StartTime.high >>> 0).toNumber(true);
        if (object.Pages != null) {
            if (typeof object.Pages !== "object")
                throw TypeError(".Client2ProxyReqAgentRebateInfo.Pages: object expected");
            message.Pages = $root.PageInfo.fromObject(object.Pages);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAgentRebateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {Client2ProxyReqAgentRebateInfo} message Client2ProxyReqAgentRebateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAgentRebateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.StartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.StartTime = options.longs === String ? "0" : 0;
            object.Pages = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StartTime != null && message.hasOwnProperty("StartTime"))
            if (typeof message.StartTime === "number")
                object.StartTime = options.longs === String ? String(message.StartTime) : message.StartTime;
            else
                object.StartTime = options.longs === String ? $util.Long.prototype.toString.call(message.StartTime) : options.longs === Number ? new $util.LongBits(message.StartTime.low >>> 0, message.StartTime.high >>> 0).toNumber(true) : message.StartTime;
        if (message.Pages != null && message.hasOwnProperty("Pages"))
            object.Pages = $root.PageInfo.toObject(message.Pages, options);
        return object;
    };

    /**
     * Converts this Client2ProxyReqAgentRebateInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAgentRebateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAgentRebateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAgentRebateInfo
     * @function getTypeUrl
     * @memberof Client2ProxyReqAgentRebateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAgentRebateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAgentRebateInfo";
    };

    return Client2ProxyReqAgentRebateInfo;
})();

export const Client2ProxyAckAgentRebateInfo = $root.Client2ProxyAckAgentRebateInfo = (() => {

    /**
     * Properties of a Client2ProxyAckAgentRebateInfo.
     * @exports IClient2ProxyAckAgentRebateInfo
     * @interface IClient2ProxyAckAgentRebateInfo
     * @property {number|null} [Ret] Client2ProxyAckAgentRebateInfo Ret
     * @property {number|null} [UserID] Client2ProxyAckAgentRebateInfo UserID
     * @property {Array.<IRebateInfo>|null} [RebInfo] Client2ProxyAckAgentRebateInfo RebInfo
     * @property {IPageInfo|null} [Pages] Client2ProxyAckAgentRebateInfo Pages
     */

    /**
     * Constructs a new Client2ProxyAckAgentRebateInfo.
     * @exports Client2ProxyAckAgentRebateInfo
     * @classdesc Represents a Client2ProxyAckAgentRebateInfo.
     * @implements IClient2ProxyAckAgentRebateInfo
     * @constructor
     * @param {IClient2ProxyAckAgentRebateInfo=} [properties] Properties to set
     */
    function Client2ProxyAckAgentRebateInfo(properties) {
        this.RebInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckAgentRebateInfo Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckAgentRebateInfo
     * @instance
     */
    Client2ProxyAckAgentRebateInfo.prototype.Ret = 0;

    /**
     * Client2ProxyAckAgentRebateInfo UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckAgentRebateInfo
     * @instance
     */
    Client2ProxyAckAgentRebateInfo.prototype.UserID = 0;

    /**
     * Client2ProxyAckAgentRebateInfo RebInfo.
     * @member {Array.<IRebateInfo>} RebInfo
     * @memberof Client2ProxyAckAgentRebateInfo
     * @instance
     */
    Client2ProxyAckAgentRebateInfo.prototype.RebInfo = $util.emptyArray;

    /**
     * Client2ProxyAckAgentRebateInfo Pages.
     * @member {IPageInfo|null|undefined} Pages
     * @memberof Client2ProxyAckAgentRebateInfo
     * @instance
     */
    Client2ProxyAckAgentRebateInfo.prototype.Pages = null;

    /**
     * Creates a new Client2ProxyAckAgentRebateInfo instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {IClient2ProxyAckAgentRebateInfo=} [properties] Properties to set
     * @returns {Client2ProxyAckAgentRebateInfo} Client2ProxyAckAgentRebateInfo instance
     */
    Client2ProxyAckAgentRebateInfo.create = function create(properties) {
        return new Client2ProxyAckAgentRebateInfo(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckAgentRebateInfo message. Does not implicitly {@link Client2ProxyAckAgentRebateInfo.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {IClient2ProxyAckAgentRebateInfo} message Client2ProxyAckAgentRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentRebateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.RebInfo != null && message.RebInfo.length)
            for (let i = 0; i < message.RebInfo.length; ++i)
                $root.RebateInfo.encode(message.RebInfo[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Pages != null && Object.hasOwnProperty.call(message, "Pages"))
            $root.PageInfo.encode(message.Pages, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckAgentRebateInfo message, length delimited. Does not implicitly {@link Client2ProxyAckAgentRebateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {IClient2ProxyAckAgentRebateInfo} message Client2ProxyAckAgentRebateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentRebateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckAgentRebateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckAgentRebateInfo} Client2ProxyAckAgentRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentRebateInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckAgentRebateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.RebInfo && message.RebInfo.length))
                        message.RebInfo = [];
                    message.RebInfo.push($root.RebateInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 4: {
                    message.Pages = $root.PageInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckAgentRebateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckAgentRebateInfo} Client2ProxyAckAgentRebateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentRebateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckAgentRebateInfo message.
     * @function verify
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckAgentRebateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RebInfo != null && message.hasOwnProperty("RebInfo")) {
            if (!Array.isArray(message.RebInfo))
                return "RebInfo: array expected";
            for (let i = 0; i < message.RebInfo.length; ++i) {
                let error = $root.RebateInfo.verify(message.RebInfo[i]);
                if (error)
                    return "RebInfo." + error;
            }
        }
        if (message.Pages != null && message.hasOwnProperty("Pages")) {
            let error = $root.PageInfo.verify(message.Pages);
            if (error)
                return "Pages." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckAgentRebateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckAgentRebateInfo} Client2ProxyAckAgentRebateInfo
     */
    Client2ProxyAckAgentRebateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckAgentRebateInfo)
            return object;
        let message = new $root.Client2ProxyAckAgentRebateInfo();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RebInfo) {
            if (!Array.isArray(object.RebInfo))
                throw TypeError(".Client2ProxyAckAgentRebateInfo.RebInfo: array expected");
            message.RebInfo = [];
            for (let i = 0; i < object.RebInfo.length; ++i) {
                if (typeof object.RebInfo[i] !== "object")
                    throw TypeError(".Client2ProxyAckAgentRebateInfo.RebInfo: object expected");
                message.RebInfo[i] = $root.RebateInfo.fromObject(object.RebInfo[i]);
            }
        }
        if (object.Pages != null) {
            if (typeof object.Pages !== "object")
                throw TypeError(".Client2ProxyAckAgentRebateInfo.Pages: object expected");
            message.Pages = $root.PageInfo.fromObject(object.Pages);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckAgentRebateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {Client2ProxyAckAgentRebateInfo} message Client2ProxyAckAgentRebateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckAgentRebateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RebInfo = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Pages = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RebInfo && message.RebInfo.length) {
            object.RebInfo = [];
            for (let j = 0; j < message.RebInfo.length; ++j)
                object.RebInfo[j] = $root.RebateInfo.toObject(message.RebInfo[j], options);
        }
        if (message.Pages != null && message.hasOwnProperty("Pages"))
            object.Pages = $root.PageInfo.toObject(message.Pages, options);
        return object;
    };

    /**
     * Converts this Client2ProxyAckAgentRebateInfo to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckAgentRebateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckAgentRebateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckAgentRebateInfo
     * @function getTypeUrl
     * @memberof Client2ProxyAckAgentRebateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckAgentRebateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckAgentRebateInfo";
    };

    return Client2ProxyAckAgentRebateInfo;
})();

export const Client2ProxyReqAgentGetRebate = $root.Client2ProxyReqAgentGetRebate = (() => {

    /**
     * Properties of a Client2ProxyReqAgentGetRebate.
     * @exports IClient2ProxyReqAgentGetRebate
     * @interface IClient2ProxyReqAgentGetRebate
     * @property {number|null} [UserID] Client2ProxyReqAgentGetRebate UserID
     */

    /**
     * Constructs a new Client2ProxyReqAgentGetRebate.
     * @exports Client2ProxyReqAgentGetRebate
     * @classdesc Represents a Client2ProxyReqAgentGetRebate.
     * @implements IClient2ProxyReqAgentGetRebate
     * @constructor
     * @param {IClient2ProxyReqAgentGetRebate=} [properties] Properties to set
     */
    function Client2ProxyReqAgentGetRebate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqAgentGetRebate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqAgentGetRebate
     * @instance
     */
    Client2ProxyReqAgentGetRebate.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqAgentGetRebate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {IClient2ProxyReqAgentGetRebate=} [properties] Properties to set
     * @returns {Client2ProxyReqAgentGetRebate} Client2ProxyReqAgentGetRebate instance
     */
    Client2ProxyReqAgentGetRebate.create = function create(properties) {
        return new Client2ProxyReqAgentGetRebate(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqAgentGetRebate message. Does not implicitly {@link Client2ProxyReqAgentGetRebate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {IClient2ProxyReqAgentGetRebate} message Client2ProxyReqAgentGetRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentGetRebate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqAgentGetRebate message, length delimited. Does not implicitly {@link Client2ProxyReqAgentGetRebate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {IClient2ProxyReqAgentGetRebate} message Client2ProxyReqAgentGetRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqAgentGetRebate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqAgentGetRebate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqAgentGetRebate} Client2ProxyReqAgentGetRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentGetRebate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqAgentGetRebate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqAgentGetRebate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqAgentGetRebate} Client2ProxyReqAgentGetRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqAgentGetRebate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqAgentGetRebate message.
     * @function verify
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqAgentGetRebate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqAgentGetRebate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqAgentGetRebate} Client2ProxyReqAgentGetRebate
     */
    Client2ProxyReqAgentGetRebate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqAgentGetRebate)
            return object;
        let message = new $root.Client2ProxyReqAgentGetRebate();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqAgentGetRebate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {Client2ProxyReqAgentGetRebate} message Client2ProxyReqAgentGetRebate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqAgentGetRebate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqAgentGetRebate to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqAgentGetRebate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqAgentGetRebate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqAgentGetRebate
     * @function getTypeUrl
     * @memberof Client2ProxyReqAgentGetRebate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqAgentGetRebate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqAgentGetRebate";
    };

    return Client2ProxyReqAgentGetRebate;
})();

export const Client2ProxyAckAgentGetRebate = $root.Client2ProxyAckAgentGetRebate = (() => {

    /**
     * Properties of a Client2ProxyAckAgentGetRebate.
     * @exports IClient2ProxyAckAgentGetRebate
     * @interface IClient2ProxyAckAgentGetRebate
     * @property {number|null} [Res] Client2ProxyAckAgentGetRebate Res
     * @property {number|null} [UserID] Client2ProxyAckAgentGetRebate UserID
     * @property {string|null} [GetRebate] Client2ProxyAckAgentGetRebate GetRebate
     */

    /**
     * Constructs a new Client2ProxyAckAgentGetRebate.
     * @exports Client2ProxyAckAgentGetRebate
     * @classdesc Represents a Client2ProxyAckAgentGetRebate.
     * @implements IClient2ProxyAckAgentGetRebate
     * @constructor
     * @param {IClient2ProxyAckAgentGetRebate=} [properties] Properties to set
     */
    function Client2ProxyAckAgentGetRebate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckAgentGetRebate Res.
     * @member {number} Res
     * @memberof Client2ProxyAckAgentGetRebate
     * @instance
     */
    Client2ProxyAckAgentGetRebate.prototype.Res = 0;

    /**
     * Client2ProxyAckAgentGetRebate UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckAgentGetRebate
     * @instance
     */
    Client2ProxyAckAgentGetRebate.prototype.UserID = 0;

    /**
     * Client2ProxyAckAgentGetRebate GetRebate.
     * @member {string} GetRebate
     * @memberof Client2ProxyAckAgentGetRebate
     * @instance
     */
    Client2ProxyAckAgentGetRebate.prototype.GetRebate = "";

    /**
     * Creates a new Client2ProxyAckAgentGetRebate instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {IClient2ProxyAckAgentGetRebate=} [properties] Properties to set
     * @returns {Client2ProxyAckAgentGetRebate} Client2ProxyAckAgentGetRebate instance
     */
    Client2ProxyAckAgentGetRebate.create = function create(properties) {
        return new Client2ProxyAckAgentGetRebate(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckAgentGetRebate message. Does not implicitly {@link Client2ProxyAckAgentGetRebate.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {IClient2ProxyAckAgentGetRebate} message Client2ProxyAckAgentGetRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentGetRebate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GetRebate != null && Object.hasOwnProperty.call(message, "GetRebate"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.GetRebate);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckAgentGetRebate message, length delimited. Does not implicitly {@link Client2ProxyAckAgentGetRebate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {IClient2ProxyAckAgentGetRebate} message Client2ProxyAckAgentGetRebate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckAgentGetRebate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckAgentGetRebate message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckAgentGetRebate} Client2ProxyAckAgentGetRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentGetRebate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckAgentGetRebate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GetRebate = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckAgentGetRebate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckAgentGetRebate} Client2ProxyAckAgentGetRebate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckAgentGetRebate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckAgentGetRebate message.
     * @function verify
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckAgentGetRebate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GetRebate != null && message.hasOwnProperty("GetRebate"))
            if (!$util.isString(message.GetRebate))
                return "GetRebate: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckAgentGetRebate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckAgentGetRebate} Client2ProxyAckAgentGetRebate
     */
    Client2ProxyAckAgentGetRebate.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckAgentGetRebate)
            return object;
        let message = new $root.Client2ProxyAckAgentGetRebate();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GetRebate != null)
            message.GetRebate = String(object.GetRebate);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckAgentGetRebate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {Client2ProxyAckAgentGetRebate} message Client2ProxyAckAgentGetRebate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckAgentGetRebate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.GetRebate = "";
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GetRebate != null && message.hasOwnProperty("GetRebate"))
            object.GetRebate = message.GetRebate;
        return object;
    };

    /**
     * Converts this Client2ProxyAckAgentGetRebate to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckAgentGetRebate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckAgentGetRebate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckAgentGetRebate
     * @function getTypeUrl
     * @memberof Client2ProxyAckAgentGetRebate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckAgentGetRebate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckAgentGetRebate";
    };

    return Client2ProxyAckAgentGetRebate;
})();

export const Client2ProxyTraSealUser = $root.Client2ProxyTraSealUser = (() => {

    /**
     * Properties of a Client2ProxyTraSealUser.
     * @exports IClient2ProxyTraSealUser
     * @interface IClient2ProxyTraSealUser
     * @property {number|null} [UserID] Client2ProxyTraSealUser UserID
     */

    /**
     * Constructs a new Client2ProxyTraSealUser.
     * @exports Client2ProxyTraSealUser
     * @classdesc Represents a Client2ProxyTraSealUser.
     * @implements IClient2ProxyTraSealUser
     * @constructor
     * @param {IClient2ProxyTraSealUser=} [properties] Properties to set
     */
    function Client2ProxyTraSealUser(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyTraSealUser UserID.
     * @member {number} UserID
     * @memberof Client2ProxyTraSealUser
     * @instance
     */
    Client2ProxyTraSealUser.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyTraSealUser instance using the specified properties.
     * @function create
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {IClient2ProxyTraSealUser=} [properties] Properties to set
     * @returns {Client2ProxyTraSealUser} Client2ProxyTraSealUser instance
     */
    Client2ProxyTraSealUser.create = function create(properties) {
        return new Client2ProxyTraSealUser(properties);
    };

    /**
     * Encodes the specified Client2ProxyTraSealUser message. Does not implicitly {@link Client2ProxyTraSealUser.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {IClient2ProxyTraSealUser} message Client2ProxyTraSealUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyTraSealUser.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyTraSealUser message, length delimited. Does not implicitly {@link Client2ProxyTraSealUser.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {IClient2ProxyTraSealUser} message Client2ProxyTraSealUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyTraSealUser.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyTraSealUser message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyTraSealUser} Client2ProxyTraSealUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyTraSealUser.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyTraSealUser();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyTraSealUser message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyTraSealUser} Client2ProxyTraSealUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyTraSealUser.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyTraSealUser message.
     * @function verify
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyTraSealUser.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyTraSealUser message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyTraSealUser} Client2ProxyTraSealUser
     */
    Client2ProxyTraSealUser.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyTraSealUser)
            return object;
        let message = new $root.Client2ProxyTraSealUser();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyTraSealUser message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {Client2ProxyTraSealUser} message Client2ProxyTraSealUser
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyTraSealUser.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyTraSealUser to JSON.
     * @function toJSON
     * @memberof Client2ProxyTraSealUser
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyTraSealUser.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyTraSealUser
     * @function getTypeUrl
     * @memberof Client2ProxyTraSealUser
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyTraSealUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyTraSealUser";
    };

    return Client2ProxyTraSealUser;
})();

export const Client2ProxyReqRecordAF = $root.Client2ProxyReqRecordAF = (() => {

    /**
     * Properties of a Client2ProxyReqRecordAF.
     * @exports IClient2ProxyReqRecordAF
     * @interface IClient2ProxyReqRecordAF
     * @property {number|null} [UserID] Client2ProxyReqRecordAF UserID
     * @property {number|null} [Platform] Client2ProxyReqRecordAF Platform
     * @property {number|null} [Channelid] Client2ProxyReqRecordAF Channelid
     * @property {string|null} [Idfa] Client2ProxyReqRecordAF Idfa
     * @property {string|null} [Idfv] Client2ProxyReqRecordAF Idfv
     * @property {string|null} [AdvertisingId] Client2ProxyReqRecordAF AdvertisingId
     * @property {string|null} [Oaid] Client2ProxyReqRecordAF Oaid
     * @property {string|null} [AmazonAid] Client2ProxyReqRecordAF AmazonAid
     * @property {string|null} [Imei] Client2ProxyReqRecordAF Imei
     * @property {string|null} [AppsflyerId] Client2ProxyReqRecordAF AppsflyerId
     * @property {string|null} [InstallSource] Client2ProxyReqRecordAF InstallSource
     * @property {string|null} [InstallCampaign] Client2ProxyReqRecordAF InstallCampaign
     */

    /**
     * Constructs a new Client2ProxyReqRecordAF.
     * @exports Client2ProxyReqRecordAF
     * @classdesc Represents a Client2ProxyReqRecordAF.
     * @implements IClient2ProxyReqRecordAF
     * @constructor
     * @param {IClient2ProxyReqRecordAF=} [properties] Properties to set
     */
    function Client2ProxyReqRecordAF(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqRecordAF UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.UserID = 0;

    /**
     * Client2ProxyReqRecordAF Platform.
     * @member {number} Platform
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Platform = 0;

    /**
     * Client2ProxyReqRecordAF Channelid.
     * @member {number} Channelid
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Channelid = 0;

    /**
     * Client2ProxyReqRecordAF Idfa.
     * @member {string} Idfa
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Idfa = "";

    /**
     * Client2ProxyReqRecordAF Idfv.
     * @member {string} Idfv
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Idfv = "";

    /**
     * Client2ProxyReqRecordAF AdvertisingId.
     * @member {string} AdvertisingId
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.AdvertisingId = "";

    /**
     * Client2ProxyReqRecordAF Oaid.
     * @member {string} Oaid
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Oaid = "";

    /**
     * Client2ProxyReqRecordAF AmazonAid.
     * @member {string} AmazonAid
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.AmazonAid = "";

    /**
     * Client2ProxyReqRecordAF Imei.
     * @member {string} Imei
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.Imei = "";

    /**
     * Client2ProxyReqRecordAF AppsflyerId.
     * @member {string} AppsflyerId
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.AppsflyerId = "";

    /**
     * Client2ProxyReqRecordAF InstallSource.
     * @member {string} InstallSource
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.InstallSource = "";

    /**
     * Client2ProxyReqRecordAF InstallCampaign.
     * @member {string} InstallCampaign
     * @memberof Client2ProxyReqRecordAF
     * @instance
     */
    Client2ProxyReqRecordAF.prototype.InstallCampaign = "";

    /**
     * Creates a new Client2ProxyReqRecordAF instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {IClient2ProxyReqRecordAF=} [properties] Properties to set
     * @returns {Client2ProxyReqRecordAF} Client2ProxyReqRecordAF instance
     */
    Client2ProxyReqRecordAF.create = function create(properties) {
        return new Client2ProxyReqRecordAF(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqRecordAF message. Does not implicitly {@link Client2ProxyReqRecordAF.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {IClient2ProxyReqRecordAF} message Client2ProxyReqRecordAF message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRecordAF.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Platform != null && Object.hasOwnProperty.call(message, "Platform"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Platform);
        if (message.Channelid != null && Object.hasOwnProperty.call(message, "Channelid"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Channelid);
        if (message.Idfa != null && Object.hasOwnProperty.call(message, "Idfa"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Idfa);
        if (message.Idfv != null && Object.hasOwnProperty.call(message, "Idfv"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Idfv);
        if (message.AdvertisingId != null && Object.hasOwnProperty.call(message, "AdvertisingId"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.AdvertisingId);
        if (message.Oaid != null && Object.hasOwnProperty.call(message, "Oaid"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Oaid);
        if (message.AmazonAid != null && Object.hasOwnProperty.call(message, "AmazonAid"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.AmazonAid);
        if (message.Imei != null && Object.hasOwnProperty.call(message, "Imei"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Imei);
        if (message.AppsflyerId != null && Object.hasOwnProperty.call(message, "AppsflyerId"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.AppsflyerId);
        if (message.InstallSource != null && Object.hasOwnProperty.call(message, "InstallSource"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.InstallSource);
        if (message.InstallCampaign != null && Object.hasOwnProperty.call(message, "InstallCampaign"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.InstallCampaign);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqRecordAF message, length delimited. Does not implicitly {@link Client2ProxyReqRecordAF.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {IClient2ProxyReqRecordAF} message Client2ProxyReqRecordAF message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqRecordAF.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqRecordAF message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqRecordAF} Client2ProxyReqRecordAF
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRecordAF.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqRecordAF();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Platform = reader.uint32();
                    break;
                }
            case 3: {
                    message.Channelid = reader.uint32();
                    break;
                }
            case 4: {
                    message.Idfa = reader.string();
                    break;
                }
            case 5: {
                    message.Idfv = reader.string();
                    break;
                }
            case 6: {
                    message.AdvertisingId = reader.string();
                    break;
                }
            case 7: {
                    message.Oaid = reader.string();
                    break;
                }
            case 8: {
                    message.AmazonAid = reader.string();
                    break;
                }
            case 9: {
                    message.Imei = reader.string();
                    break;
                }
            case 10: {
                    message.AppsflyerId = reader.string();
                    break;
                }
            case 11: {
                    message.InstallSource = reader.string();
                    break;
                }
            case 12: {
                    message.InstallCampaign = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqRecordAF message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqRecordAF} Client2ProxyReqRecordAF
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqRecordAF.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqRecordAF message.
     * @function verify
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqRecordAF.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Platform != null && message.hasOwnProperty("Platform"))
            if (!$util.isInteger(message.Platform))
                return "Platform: integer expected";
        if (message.Channelid != null && message.hasOwnProperty("Channelid"))
            if (!$util.isInteger(message.Channelid))
                return "Channelid: integer expected";
        if (message.Idfa != null && message.hasOwnProperty("Idfa"))
            if (!$util.isString(message.Idfa))
                return "Idfa: string expected";
        if (message.Idfv != null && message.hasOwnProperty("Idfv"))
            if (!$util.isString(message.Idfv))
                return "Idfv: string expected";
        if (message.AdvertisingId != null && message.hasOwnProperty("AdvertisingId"))
            if (!$util.isString(message.AdvertisingId))
                return "AdvertisingId: string expected";
        if (message.Oaid != null && message.hasOwnProperty("Oaid"))
            if (!$util.isString(message.Oaid))
                return "Oaid: string expected";
        if (message.AmazonAid != null && message.hasOwnProperty("AmazonAid"))
            if (!$util.isString(message.AmazonAid))
                return "AmazonAid: string expected";
        if (message.Imei != null && message.hasOwnProperty("Imei"))
            if (!$util.isString(message.Imei))
                return "Imei: string expected";
        if (message.AppsflyerId != null && message.hasOwnProperty("AppsflyerId"))
            if (!$util.isString(message.AppsflyerId))
                return "AppsflyerId: string expected";
        if (message.InstallSource != null && message.hasOwnProperty("InstallSource"))
            if (!$util.isString(message.InstallSource))
                return "InstallSource: string expected";
        if (message.InstallCampaign != null && message.hasOwnProperty("InstallCampaign"))
            if (!$util.isString(message.InstallCampaign))
                return "InstallCampaign: string expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqRecordAF message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqRecordAF} Client2ProxyReqRecordAF
     */
    Client2ProxyReqRecordAF.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqRecordAF)
            return object;
        let message = new $root.Client2ProxyReqRecordAF();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Platform != null)
            message.Platform = object.Platform >>> 0;
        if (object.Channelid != null)
            message.Channelid = object.Channelid >>> 0;
        if (object.Idfa != null)
            message.Idfa = String(object.Idfa);
        if (object.Idfv != null)
            message.Idfv = String(object.Idfv);
        if (object.AdvertisingId != null)
            message.AdvertisingId = String(object.AdvertisingId);
        if (object.Oaid != null)
            message.Oaid = String(object.Oaid);
        if (object.AmazonAid != null)
            message.AmazonAid = String(object.AmazonAid);
        if (object.Imei != null)
            message.Imei = String(object.Imei);
        if (object.AppsflyerId != null)
            message.AppsflyerId = String(object.AppsflyerId);
        if (object.InstallSource != null)
            message.InstallSource = String(object.InstallSource);
        if (object.InstallCampaign != null)
            message.InstallCampaign = String(object.InstallCampaign);
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqRecordAF message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {Client2ProxyReqRecordAF} message Client2ProxyReqRecordAF
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqRecordAF.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Platform = 0;
            object.Channelid = 0;
            object.Idfa = "";
            object.Idfv = "";
            object.AdvertisingId = "";
            object.Oaid = "";
            object.AmazonAid = "";
            object.Imei = "";
            object.AppsflyerId = "";
            object.InstallSource = "";
            object.InstallCampaign = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Platform != null && message.hasOwnProperty("Platform"))
            object.Platform = message.Platform;
        if (message.Channelid != null && message.hasOwnProperty("Channelid"))
            object.Channelid = message.Channelid;
        if (message.Idfa != null && message.hasOwnProperty("Idfa"))
            object.Idfa = message.Idfa;
        if (message.Idfv != null && message.hasOwnProperty("Idfv"))
            object.Idfv = message.Idfv;
        if (message.AdvertisingId != null && message.hasOwnProperty("AdvertisingId"))
            object.AdvertisingId = message.AdvertisingId;
        if (message.Oaid != null && message.hasOwnProperty("Oaid"))
            object.Oaid = message.Oaid;
        if (message.AmazonAid != null && message.hasOwnProperty("AmazonAid"))
            object.AmazonAid = message.AmazonAid;
        if (message.Imei != null && message.hasOwnProperty("Imei"))
            object.Imei = message.Imei;
        if (message.AppsflyerId != null && message.hasOwnProperty("AppsflyerId"))
            object.AppsflyerId = message.AppsflyerId;
        if (message.InstallSource != null && message.hasOwnProperty("InstallSource"))
            object.InstallSource = message.InstallSource;
        if (message.InstallCampaign != null && message.hasOwnProperty("InstallCampaign"))
            object.InstallCampaign = message.InstallCampaign;
        return object;
    };

    /**
     * Converts this Client2ProxyReqRecordAF to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqRecordAF
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqRecordAF.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqRecordAF
     * @function getTypeUrl
     * @memberof Client2ProxyReqRecordAF
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqRecordAF.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqRecordAF";
    };

    return Client2ProxyReqRecordAF;
})();

export const Client2ProxyAckRecordAF = $root.Client2ProxyAckRecordAF = (() => {

    /**
     * Properties of a Client2ProxyAckRecordAF.
     * @exports IClient2ProxyAckRecordAF
     * @interface IClient2ProxyAckRecordAF
     * @property {number|null} [Ret] Client2ProxyAckRecordAF Ret
     * @property {number|null} [UserID] Client2ProxyAckRecordAF UserID
     */

    /**
     * Constructs a new Client2ProxyAckRecordAF.
     * @exports Client2ProxyAckRecordAF
     * @classdesc Represents a Client2ProxyAckRecordAF.
     * @implements IClient2ProxyAckRecordAF
     * @constructor
     * @param {IClient2ProxyAckRecordAF=} [properties] Properties to set
     */
    function Client2ProxyAckRecordAF(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckRecordAF Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckRecordAF
     * @instance
     */
    Client2ProxyAckRecordAF.prototype.Ret = 0;

    /**
     * Client2ProxyAckRecordAF UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckRecordAF
     * @instance
     */
    Client2ProxyAckRecordAF.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyAckRecordAF instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {IClient2ProxyAckRecordAF=} [properties] Properties to set
     * @returns {Client2ProxyAckRecordAF} Client2ProxyAckRecordAF instance
     */
    Client2ProxyAckRecordAF.create = function create(properties) {
        return new Client2ProxyAckRecordAF(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckRecordAF message. Does not implicitly {@link Client2ProxyAckRecordAF.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {IClient2ProxyAckRecordAF} message Client2ProxyAckRecordAF message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRecordAF.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckRecordAF message, length delimited. Does not implicitly {@link Client2ProxyAckRecordAF.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {IClient2ProxyAckRecordAF} message Client2ProxyAckRecordAF message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckRecordAF.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckRecordAF message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckRecordAF} Client2ProxyAckRecordAF
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRecordAF.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckRecordAF();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckRecordAF message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckRecordAF} Client2ProxyAckRecordAF
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckRecordAF.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckRecordAF message.
     * @function verify
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckRecordAF.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckRecordAF message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckRecordAF} Client2ProxyAckRecordAF
     */
    Client2ProxyAckRecordAF.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckRecordAF)
            return object;
        let message = new $root.Client2ProxyAckRecordAF();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckRecordAF message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {Client2ProxyAckRecordAF} message Client2ProxyAckRecordAF
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckRecordAF.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckRecordAF to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckRecordAF
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckRecordAF.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckRecordAF
     * @function getTypeUrl
     * @memberof Client2ProxyAckRecordAF
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckRecordAF.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckRecordAF";
    };

    return Client2ProxyAckRecordAF;
})();

export const Client2ProxyReqMatchList = $root.Client2ProxyReqMatchList = (() => {

    /**
     * Properties of a Client2ProxyReqMatchList.
     * @exports IClient2ProxyReqMatchList
     * @interface IClient2ProxyReqMatchList
     * @property {number|null} [UserID] Client2ProxyReqMatchList UserID
     */

    /**
     * Constructs a new Client2ProxyReqMatchList.
     * @exports Client2ProxyReqMatchList
     * @classdesc Represents a Client2ProxyReqMatchList.
     * @implements IClient2ProxyReqMatchList
     * @constructor
     * @param {IClient2ProxyReqMatchList=} [properties] Properties to set
     */
    function Client2ProxyReqMatchList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMatchList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqMatchList
     * @instance
     */
    Client2ProxyReqMatchList.prototype.UserID = 0;

    /**
     * Creates a new Client2ProxyReqMatchList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {IClient2ProxyReqMatchList=} [properties] Properties to set
     * @returns {Client2ProxyReqMatchList} Client2ProxyReqMatchList instance
     */
    Client2ProxyReqMatchList.create = function create(properties) {
        return new Client2ProxyReqMatchList(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMatchList message. Does not implicitly {@link Client2ProxyReqMatchList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {IClient2ProxyReqMatchList} message Client2ProxyReqMatchList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMatchList message, length delimited. Does not implicitly {@link Client2ProxyReqMatchList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {IClient2ProxyReqMatchList} message Client2ProxyReqMatchList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMatchList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMatchList} Client2ProxyReqMatchList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMatchList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMatchList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMatchList} Client2ProxyReqMatchList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMatchList message.
     * @function verify
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMatchList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMatchList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMatchList} Client2ProxyReqMatchList
     */
    Client2ProxyReqMatchList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMatchList)
            return object;
        let message = new $root.Client2ProxyReqMatchList();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMatchList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {Client2ProxyReqMatchList} message Client2ProxyReqMatchList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMatchList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMatchList to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMatchList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMatchList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMatchList
     * @function getTypeUrl
     * @memberof Client2ProxyReqMatchList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMatchList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMatchList";
    };

    return Client2ProxyReqMatchList;
})();

export const Client2ProxyAckMatchList = $root.Client2ProxyAckMatchList = (() => {

    /**
     * Properties of a Client2ProxyAckMatchList.
     * @exports IClient2ProxyAckMatchList
     * @interface IClient2ProxyAckMatchList
     * @property {number|null} [Ret] Client2ProxyAckMatchList Ret
     * @property {number|null} [UserID] Client2ProxyAckMatchList UserID
     * @property {Array.<IGameMatchInfo>|null} [GameMatch] Client2ProxyAckMatchList GameMatch
     */

    /**
     * Constructs a new Client2ProxyAckMatchList.
     * @exports Client2ProxyAckMatchList
     * @classdesc Represents a Client2ProxyAckMatchList.
     * @implements IClient2ProxyAckMatchList
     * @constructor
     * @param {IClient2ProxyAckMatchList=} [properties] Properties to set
     */
    function Client2ProxyAckMatchList(properties) {
        this.GameMatch = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMatchList Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMatchList
     * @instance
     */
    Client2ProxyAckMatchList.prototype.Ret = 0;

    /**
     * Client2ProxyAckMatchList UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckMatchList
     * @instance
     */
    Client2ProxyAckMatchList.prototype.UserID = 0;

    /**
     * Client2ProxyAckMatchList GameMatch.
     * @member {Array.<IGameMatchInfo>} GameMatch
     * @memberof Client2ProxyAckMatchList
     * @instance
     */
    Client2ProxyAckMatchList.prototype.GameMatch = $util.emptyArray;

    /**
     * Creates a new Client2ProxyAckMatchList instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {IClient2ProxyAckMatchList=} [properties] Properties to set
     * @returns {Client2ProxyAckMatchList} Client2ProxyAckMatchList instance
     */
    Client2ProxyAckMatchList.create = function create(properties) {
        return new Client2ProxyAckMatchList(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMatchList message. Does not implicitly {@link Client2ProxyAckMatchList.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {IClient2ProxyAckMatchList} message Client2ProxyAckMatchList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GameMatch != null && message.GameMatch.length)
            for (let i = 0; i < message.GameMatch.length; ++i)
                $root.GameMatchInfo.encode(message.GameMatch[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMatchList message, length delimited. Does not implicitly {@link Client2ProxyAckMatchList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {IClient2ProxyAckMatchList} message Client2ProxyAckMatchList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMatchList message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMatchList} Client2ProxyAckMatchList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMatchList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GameMatch && message.GameMatch.length))
                        message.GameMatch = [];
                    message.GameMatch.push($root.GameMatchInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMatchList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMatchList} Client2ProxyAckMatchList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMatchList message.
     * @function verify
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMatchList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameMatch != null && message.hasOwnProperty("GameMatch")) {
            if (!Array.isArray(message.GameMatch))
                return "GameMatch: array expected";
            for (let i = 0; i < message.GameMatch.length; ++i) {
                let error = $root.GameMatchInfo.verify(message.GameMatch[i]);
                if (error)
                    return "GameMatch." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckMatchList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMatchList} Client2ProxyAckMatchList
     */
    Client2ProxyAckMatchList.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMatchList)
            return object;
        let message = new $root.Client2ProxyAckMatchList();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameMatch) {
            if (!Array.isArray(object.GameMatch))
                throw TypeError(".Client2ProxyAckMatchList.GameMatch: array expected");
            message.GameMatch = [];
            for (let i = 0; i < object.GameMatch.length; ++i) {
                if (typeof object.GameMatch[i] !== "object")
                    throw TypeError(".Client2ProxyAckMatchList.GameMatch: object expected");
                message.GameMatch[i] = $root.GameMatchInfo.fromObject(object.GameMatch[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMatchList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {Client2ProxyAckMatchList} message Client2ProxyAckMatchList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMatchList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GameMatch = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameMatch && message.GameMatch.length) {
            object.GameMatch = [];
            for (let j = 0; j < message.GameMatch.length; ++j)
                object.GameMatch[j] = $root.GameMatchInfo.toObject(message.GameMatch[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2ProxyAckMatchList to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMatchList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMatchList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMatchList
     * @function getTypeUrl
     * @memberof Client2ProxyAckMatchList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMatchList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMatchList";
    };

    return Client2ProxyAckMatchList;
})();

export const Client2ProxyReqMatchSign = $root.Client2ProxyReqMatchSign = (() => {

    /**
     * Properties of a Client2ProxyReqMatchSign.
     * @exports IClient2ProxyReqMatchSign
     * @interface IClient2ProxyReqMatchSign
     * @property {number|null} [UserID] Client2ProxyReqMatchSign UserID
     * @property {number|null} [MatchID] Client2ProxyReqMatchSign MatchID
     */

    /**
     * Constructs a new Client2ProxyReqMatchSign.
     * @exports Client2ProxyReqMatchSign
     * @classdesc Represents a Client2ProxyReqMatchSign.
     * @implements IClient2ProxyReqMatchSign
     * @constructor
     * @param {IClient2ProxyReqMatchSign=} [properties] Properties to set
     */
    function Client2ProxyReqMatchSign(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMatchSign UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqMatchSign
     * @instance
     */
    Client2ProxyReqMatchSign.prototype.UserID = 0;

    /**
     * Client2ProxyReqMatchSign MatchID.
     * @member {number} MatchID
     * @memberof Client2ProxyReqMatchSign
     * @instance
     */
    Client2ProxyReqMatchSign.prototype.MatchID = 0;

    /**
     * Creates a new Client2ProxyReqMatchSign instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {IClient2ProxyReqMatchSign=} [properties] Properties to set
     * @returns {Client2ProxyReqMatchSign} Client2ProxyReqMatchSign instance
     */
    Client2ProxyReqMatchSign.create = function create(properties) {
        return new Client2ProxyReqMatchSign(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSign message. Does not implicitly {@link Client2ProxyReqMatchSign.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {IClient2ProxyReqMatchSign} message Client2ProxyReqMatchSign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MatchID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSign message, length delimited. Does not implicitly {@link Client2ProxyReqMatchSign.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {IClient2ProxyReqMatchSign} message Client2ProxyReqMatchSign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMatchSign message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMatchSign} Client2ProxyReqMatchSign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSign.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMatchSign();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.MatchID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMatchSign message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMatchSign} Client2ProxyReqMatchSign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMatchSign message.
     * @function verify
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMatchSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMatchSign message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMatchSign} Client2ProxyReqMatchSign
     */
    Client2ProxyReqMatchSign.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMatchSign)
            return object;
        let message = new $root.Client2ProxyReqMatchSign();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMatchSign message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {Client2ProxyReqMatchSign} message Client2ProxyReqMatchSign
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMatchSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.MatchID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMatchSign to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMatchSign
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMatchSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMatchSign
     * @function getTypeUrl
     * @memberof Client2ProxyReqMatchSign
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMatchSign.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMatchSign";
    };

    return Client2ProxyReqMatchSign;
})();

export const Client2ProxyAckMatchSign = $root.Client2ProxyAckMatchSign = (() => {

    /**
     * Properties of a Client2ProxyAckMatchSign.
     * @exports IClient2ProxyAckMatchSign
     * @interface IClient2ProxyAckMatchSign
     * @property {number|null} [Ret] Client2ProxyAckMatchSign Ret
     * @property {number|null} [UserID] Client2ProxyAckMatchSign UserID
     * @property {number|null} [MatchID] Client2ProxyAckMatchSign MatchID
     */

    /**
     * Constructs a new Client2ProxyAckMatchSign.
     * @exports Client2ProxyAckMatchSign
     * @classdesc Represents a Client2ProxyAckMatchSign.
     * @implements IClient2ProxyAckMatchSign
     * @constructor
     * @param {IClient2ProxyAckMatchSign=} [properties] Properties to set
     */
    function Client2ProxyAckMatchSign(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMatchSign Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMatchSign
     * @instance
     */
    Client2ProxyAckMatchSign.prototype.Ret = 0;

    /**
     * Client2ProxyAckMatchSign UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckMatchSign
     * @instance
     */
    Client2ProxyAckMatchSign.prototype.UserID = 0;

    /**
     * Client2ProxyAckMatchSign MatchID.
     * @member {number} MatchID
     * @memberof Client2ProxyAckMatchSign
     * @instance
     */
    Client2ProxyAckMatchSign.prototype.MatchID = 0;

    /**
     * Creates a new Client2ProxyAckMatchSign instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {IClient2ProxyAckMatchSign=} [properties] Properties to set
     * @returns {Client2ProxyAckMatchSign} Client2ProxyAckMatchSign instance
     */
    Client2ProxyAckMatchSign.create = function create(properties) {
        return new Client2ProxyAckMatchSign(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSign message. Does not implicitly {@link Client2ProxyAckMatchSign.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {IClient2ProxyAckMatchSign} message Client2ProxyAckMatchSign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MatchID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSign message, length delimited. Does not implicitly {@link Client2ProxyAckMatchSign.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {IClient2ProxyAckMatchSign} message Client2ProxyAckMatchSign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMatchSign message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMatchSign} Client2ProxyAckMatchSign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSign.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMatchSign();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.MatchID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMatchSign message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMatchSign} Client2ProxyAckMatchSign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMatchSign message.
     * @function verify
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMatchSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMatchSign message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMatchSign} Client2ProxyAckMatchSign
     */
    Client2ProxyAckMatchSign.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMatchSign)
            return object;
        let message = new $root.Client2ProxyAckMatchSign();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMatchSign message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {Client2ProxyAckMatchSign} message Client2ProxyAckMatchSign
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMatchSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.MatchID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMatchSign to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMatchSign
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMatchSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMatchSign
     * @function getTypeUrl
     * @memberof Client2ProxyAckMatchSign
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMatchSign.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMatchSign";
    };

    return Client2ProxyAckMatchSign;
})();

export const Client2ProxyReqMatchSignCancel = $root.Client2ProxyReqMatchSignCancel = (() => {

    /**
     * Properties of a Client2ProxyReqMatchSignCancel.
     * @exports IClient2ProxyReqMatchSignCancel
     * @interface IClient2ProxyReqMatchSignCancel
     * @property {number|null} [UserID] Client2ProxyReqMatchSignCancel UserID
     * @property {number|null} [MatchID] Client2ProxyReqMatchSignCancel MatchID
     */

    /**
     * Constructs a new Client2ProxyReqMatchSignCancel.
     * @exports Client2ProxyReqMatchSignCancel
     * @classdesc Represents a Client2ProxyReqMatchSignCancel.
     * @implements IClient2ProxyReqMatchSignCancel
     * @constructor
     * @param {IClient2ProxyReqMatchSignCancel=} [properties] Properties to set
     */
    function Client2ProxyReqMatchSignCancel(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMatchSignCancel UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqMatchSignCancel
     * @instance
     */
    Client2ProxyReqMatchSignCancel.prototype.UserID = 0;

    /**
     * Client2ProxyReqMatchSignCancel MatchID.
     * @member {number} MatchID
     * @memberof Client2ProxyReqMatchSignCancel
     * @instance
     */
    Client2ProxyReqMatchSignCancel.prototype.MatchID = 0;

    /**
     * Creates a new Client2ProxyReqMatchSignCancel instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {IClient2ProxyReqMatchSignCancel=} [properties] Properties to set
     * @returns {Client2ProxyReqMatchSignCancel} Client2ProxyReqMatchSignCancel instance
     */
    Client2ProxyReqMatchSignCancel.create = function create(properties) {
        return new Client2ProxyReqMatchSignCancel(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSignCancel message. Does not implicitly {@link Client2ProxyReqMatchSignCancel.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {IClient2ProxyReqMatchSignCancel} message Client2ProxyReqMatchSignCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSignCancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MatchID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSignCancel message, length delimited. Does not implicitly {@link Client2ProxyReqMatchSignCancel.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {IClient2ProxyReqMatchSignCancel} message Client2ProxyReqMatchSignCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSignCancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMatchSignCancel message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMatchSignCancel} Client2ProxyReqMatchSignCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSignCancel.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMatchSignCancel();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.MatchID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMatchSignCancel message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMatchSignCancel} Client2ProxyReqMatchSignCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSignCancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMatchSignCancel message.
     * @function verify
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMatchSignCancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMatchSignCancel message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMatchSignCancel} Client2ProxyReqMatchSignCancel
     */
    Client2ProxyReqMatchSignCancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMatchSignCancel)
            return object;
        let message = new $root.Client2ProxyReqMatchSignCancel();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMatchSignCancel message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {Client2ProxyReqMatchSignCancel} message Client2ProxyReqMatchSignCancel
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMatchSignCancel.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.MatchID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMatchSignCancel to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMatchSignCancel
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMatchSignCancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMatchSignCancel
     * @function getTypeUrl
     * @memberof Client2ProxyReqMatchSignCancel
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMatchSignCancel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMatchSignCancel";
    };

    return Client2ProxyReqMatchSignCancel;
})();

export const Client2ProxyAckMatchSignCancel = $root.Client2ProxyAckMatchSignCancel = (() => {

    /**
     * Properties of a Client2ProxyAckMatchSignCancel.
     * @exports IClient2ProxyAckMatchSignCancel
     * @interface IClient2ProxyAckMatchSignCancel
     * @property {number|null} [Ret] Client2ProxyAckMatchSignCancel Ret
     * @property {number|null} [UserID] Client2ProxyAckMatchSignCancel UserID
     * @property {number|null} [MatchID] Client2ProxyAckMatchSignCancel MatchID
     */

    /**
     * Constructs a new Client2ProxyAckMatchSignCancel.
     * @exports Client2ProxyAckMatchSignCancel
     * @classdesc Represents a Client2ProxyAckMatchSignCancel.
     * @implements IClient2ProxyAckMatchSignCancel
     * @constructor
     * @param {IClient2ProxyAckMatchSignCancel=} [properties] Properties to set
     */
    function Client2ProxyAckMatchSignCancel(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMatchSignCancel Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMatchSignCancel
     * @instance
     */
    Client2ProxyAckMatchSignCancel.prototype.Ret = 0;

    /**
     * Client2ProxyAckMatchSignCancel UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckMatchSignCancel
     * @instance
     */
    Client2ProxyAckMatchSignCancel.prototype.UserID = 0;

    /**
     * Client2ProxyAckMatchSignCancel MatchID.
     * @member {number} MatchID
     * @memberof Client2ProxyAckMatchSignCancel
     * @instance
     */
    Client2ProxyAckMatchSignCancel.prototype.MatchID = 0;

    /**
     * Creates a new Client2ProxyAckMatchSignCancel instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {IClient2ProxyAckMatchSignCancel=} [properties] Properties to set
     * @returns {Client2ProxyAckMatchSignCancel} Client2ProxyAckMatchSignCancel instance
     */
    Client2ProxyAckMatchSignCancel.create = function create(properties) {
        return new Client2ProxyAckMatchSignCancel(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSignCancel message. Does not implicitly {@link Client2ProxyAckMatchSignCancel.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {IClient2ProxyAckMatchSignCancel} message Client2ProxyAckMatchSignCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSignCancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MatchID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSignCancel message, length delimited. Does not implicitly {@link Client2ProxyAckMatchSignCancel.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {IClient2ProxyAckMatchSignCancel} message Client2ProxyAckMatchSignCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSignCancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMatchSignCancel message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMatchSignCancel} Client2ProxyAckMatchSignCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSignCancel.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMatchSignCancel();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.MatchID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMatchSignCancel message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMatchSignCancel} Client2ProxyAckMatchSignCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSignCancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMatchSignCancel message.
     * @function verify
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMatchSignCancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyAckMatchSignCancel message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMatchSignCancel} Client2ProxyAckMatchSignCancel
     */
    Client2ProxyAckMatchSignCancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMatchSignCancel)
            return object;
        let message = new $root.Client2ProxyAckMatchSignCancel();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMatchSignCancel message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {Client2ProxyAckMatchSignCancel} message Client2ProxyAckMatchSignCancel
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMatchSignCancel.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.MatchID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        return object;
    };

    /**
     * Converts this Client2ProxyAckMatchSignCancel to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMatchSignCancel
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMatchSignCancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMatchSignCancel
     * @function getTypeUrl
     * @memberof Client2ProxyAckMatchSignCancel
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMatchSignCancel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMatchSignCancel";
    };

    return Client2ProxyAckMatchSignCancel;
})();

export const Client2ProxyReqMatchSchedule = $root.Client2ProxyReqMatchSchedule = (() => {

    /**
     * Properties of a Client2ProxyReqMatchSchedule.
     * @exports IClient2ProxyReqMatchSchedule
     * @interface IClient2ProxyReqMatchSchedule
     * @property {number|null} [UserID] Client2ProxyReqMatchSchedule UserID
     * @property {number|null} [MatchID] Client2ProxyReqMatchSchedule MatchID
     */

    /**
     * Constructs a new Client2ProxyReqMatchSchedule.
     * @exports Client2ProxyReqMatchSchedule
     * @classdesc Represents a Client2ProxyReqMatchSchedule.
     * @implements IClient2ProxyReqMatchSchedule
     * @constructor
     * @param {IClient2ProxyReqMatchSchedule=} [properties] Properties to set
     */
    function Client2ProxyReqMatchSchedule(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyReqMatchSchedule UserID.
     * @member {number} UserID
     * @memberof Client2ProxyReqMatchSchedule
     * @instance
     */
    Client2ProxyReqMatchSchedule.prototype.UserID = 0;

    /**
     * Client2ProxyReqMatchSchedule MatchID.
     * @member {number} MatchID
     * @memberof Client2ProxyReqMatchSchedule
     * @instance
     */
    Client2ProxyReqMatchSchedule.prototype.MatchID = 0;

    /**
     * Creates a new Client2ProxyReqMatchSchedule instance using the specified properties.
     * @function create
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {IClient2ProxyReqMatchSchedule=} [properties] Properties to set
     * @returns {Client2ProxyReqMatchSchedule} Client2ProxyReqMatchSchedule instance
     */
    Client2ProxyReqMatchSchedule.create = function create(properties) {
        return new Client2ProxyReqMatchSchedule(properties);
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSchedule message. Does not implicitly {@link Client2ProxyReqMatchSchedule.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {IClient2ProxyReqMatchSchedule} message Client2ProxyReqMatchSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSchedule.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.MatchID != null && Object.hasOwnProperty.call(message, "MatchID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MatchID);
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyReqMatchSchedule message, length delimited. Does not implicitly {@link Client2ProxyReqMatchSchedule.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {IClient2ProxyReqMatchSchedule} message Client2ProxyReqMatchSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyReqMatchSchedule.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyReqMatchSchedule message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyReqMatchSchedule} Client2ProxyReqMatchSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSchedule.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyReqMatchSchedule();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.MatchID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyReqMatchSchedule message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyReqMatchSchedule} Client2ProxyReqMatchSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyReqMatchSchedule.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyReqMatchSchedule message.
     * @function verify
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyReqMatchSchedule.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            if (!$util.isInteger(message.MatchID))
                return "MatchID: integer expected";
        return null;
    };

    /**
     * Creates a Client2ProxyReqMatchSchedule message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyReqMatchSchedule} Client2ProxyReqMatchSchedule
     */
    Client2ProxyReqMatchSchedule.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyReqMatchSchedule)
            return object;
        let message = new $root.Client2ProxyReqMatchSchedule();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchID != null)
            message.MatchID = object.MatchID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyReqMatchSchedule message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {Client2ProxyReqMatchSchedule} message Client2ProxyReqMatchSchedule
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyReqMatchSchedule.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.MatchID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchID != null && message.hasOwnProperty("MatchID"))
            object.MatchID = message.MatchID;
        return object;
    };

    /**
     * Converts this Client2ProxyReqMatchSchedule to JSON.
     * @function toJSON
     * @memberof Client2ProxyReqMatchSchedule
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyReqMatchSchedule.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyReqMatchSchedule
     * @function getTypeUrl
     * @memberof Client2ProxyReqMatchSchedule
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyReqMatchSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyReqMatchSchedule";
    };

    return Client2ProxyReqMatchSchedule;
})();

export const Client2ProxyAckMatchSchedule = $root.Client2ProxyAckMatchSchedule = (() => {

    /**
     * Properties of a Client2ProxyAckMatchSchedule.
     * @exports IClient2ProxyAckMatchSchedule
     * @interface IClient2ProxyAckMatchSchedule
     * @property {number|null} [Ret] Client2ProxyAckMatchSchedule Ret
     * @property {number|null} [UserID] Client2ProxyAckMatchSchedule UserID
     * @property {IMatchScheduleInfo|null} [MatchSchedule] Client2ProxyAckMatchSchedule MatchSchedule
     */

    /**
     * Constructs a new Client2ProxyAckMatchSchedule.
     * @exports Client2ProxyAckMatchSchedule
     * @classdesc Represents a Client2ProxyAckMatchSchedule.
     * @implements IClient2ProxyAckMatchSchedule
     * @constructor
     * @param {IClient2ProxyAckMatchSchedule=} [properties] Properties to set
     */
    function Client2ProxyAckMatchSchedule(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyAckMatchSchedule Ret.
     * @member {number} Ret
     * @memberof Client2ProxyAckMatchSchedule
     * @instance
     */
    Client2ProxyAckMatchSchedule.prototype.Ret = 0;

    /**
     * Client2ProxyAckMatchSchedule UserID.
     * @member {number} UserID
     * @memberof Client2ProxyAckMatchSchedule
     * @instance
     */
    Client2ProxyAckMatchSchedule.prototype.UserID = 0;

    /**
     * Client2ProxyAckMatchSchedule MatchSchedule.
     * @member {IMatchScheduleInfo|null|undefined} MatchSchedule
     * @memberof Client2ProxyAckMatchSchedule
     * @instance
     */
    Client2ProxyAckMatchSchedule.prototype.MatchSchedule = null;

    /**
     * Creates a new Client2ProxyAckMatchSchedule instance using the specified properties.
     * @function create
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {IClient2ProxyAckMatchSchedule=} [properties] Properties to set
     * @returns {Client2ProxyAckMatchSchedule} Client2ProxyAckMatchSchedule instance
     */
    Client2ProxyAckMatchSchedule.create = function create(properties) {
        return new Client2ProxyAckMatchSchedule(properties);
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSchedule message. Does not implicitly {@link Client2ProxyAckMatchSchedule.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {IClient2ProxyAckMatchSchedule} message Client2ProxyAckMatchSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSchedule.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.MatchSchedule != null && Object.hasOwnProperty.call(message, "MatchSchedule"))
            $root.MatchScheduleInfo.encode(message.MatchSchedule, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyAckMatchSchedule message, length delimited. Does not implicitly {@link Client2ProxyAckMatchSchedule.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {IClient2ProxyAckMatchSchedule} message Client2ProxyAckMatchSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyAckMatchSchedule.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyAckMatchSchedule message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyAckMatchSchedule} Client2ProxyAckMatchSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSchedule.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyAckMatchSchedule();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.MatchSchedule = $root.MatchScheduleInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyAckMatchSchedule message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyAckMatchSchedule} Client2ProxyAckMatchSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyAckMatchSchedule.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyAckMatchSchedule message.
     * @function verify
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyAckMatchSchedule.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.MatchSchedule != null && message.hasOwnProperty("MatchSchedule")) {
            let error = $root.MatchScheduleInfo.verify(message.MatchSchedule);
            if (error)
                return "MatchSchedule." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyAckMatchSchedule message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyAckMatchSchedule} Client2ProxyAckMatchSchedule
     */
    Client2ProxyAckMatchSchedule.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyAckMatchSchedule)
            return object;
        let message = new $root.Client2ProxyAckMatchSchedule();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.MatchSchedule != null) {
            if (typeof object.MatchSchedule !== "object")
                throw TypeError(".Client2ProxyAckMatchSchedule.MatchSchedule: object expected");
            message.MatchSchedule = $root.MatchScheduleInfo.fromObject(object.MatchSchedule);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyAckMatchSchedule message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {Client2ProxyAckMatchSchedule} message Client2ProxyAckMatchSchedule
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyAckMatchSchedule.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.MatchSchedule = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.MatchSchedule != null && message.hasOwnProperty("MatchSchedule"))
            object.MatchSchedule = $root.MatchScheduleInfo.toObject(message.MatchSchedule, options);
        return object;
    };

    /**
     * Converts this Client2ProxyAckMatchSchedule to JSON.
     * @function toJSON
     * @memberof Client2ProxyAckMatchSchedule
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyAckMatchSchedule.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyAckMatchSchedule
     * @function getTypeUrl
     * @memberof Client2ProxyAckMatchSchedule
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyAckMatchSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyAckMatchSchedule";
    };

    return Client2ProxyAckMatchSchedule;
})();

export const Client2ProxyPushMatchResult = $root.Client2ProxyPushMatchResult = (() => {

    /**
     * Properties of a Client2ProxyPushMatchResult.
     * @exports IClient2ProxyPushMatchResult
     * @interface IClient2ProxyPushMatchResult
     * @property {number|null} [UserID] Client2ProxyPushMatchResult UserID
     * @property {IUserMatchInfo|null} [UserMatch] Client2ProxyPushMatchResult UserMatch
     */

    /**
     * Constructs a new Client2ProxyPushMatchResult.
     * @exports Client2ProxyPushMatchResult
     * @classdesc Represents a Client2ProxyPushMatchResult.
     * @implements IClient2ProxyPushMatchResult
     * @constructor
     * @param {IClient2ProxyPushMatchResult=} [properties] Properties to set
     */
    function Client2ProxyPushMatchResult(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ProxyPushMatchResult UserID.
     * @member {number} UserID
     * @memberof Client2ProxyPushMatchResult
     * @instance
     */
    Client2ProxyPushMatchResult.prototype.UserID = 0;

    /**
     * Client2ProxyPushMatchResult UserMatch.
     * @member {IUserMatchInfo|null|undefined} UserMatch
     * @memberof Client2ProxyPushMatchResult
     * @instance
     */
    Client2ProxyPushMatchResult.prototype.UserMatch = null;

    /**
     * Creates a new Client2ProxyPushMatchResult instance using the specified properties.
     * @function create
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {IClient2ProxyPushMatchResult=} [properties] Properties to set
     * @returns {Client2ProxyPushMatchResult} Client2ProxyPushMatchResult instance
     */
    Client2ProxyPushMatchResult.create = function create(properties) {
        return new Client2ProxyPushMatchResult(properties);
    };

    /**
     * Encodes the specified Client2ProxyPushMatchResult message. Does not implicitly {@link Client2ProxyPushMatchResult.verify|verify} messages.
     * @function encode
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {IClient2ProxyPushMatchResult} message Client2ProxyPushMatchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushMatchResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.UserMatch != null && Object.hasOwnProperty.call(message, "UserMatch"))
            $root.UserMatchInfo.encode(message.UserMatch, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2ProxyPushMatchResult message, length delimited. Does not implicitly {@link Client2ProxyPushMatchResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {IClient2ProxyPushMatchResult} message Client2ProxyPushMatchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ProxyPushMatchResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ProxyPushMatchResult message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ProxyPushMatchResult} Client2ProxyPushMatchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushMatchResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ProxyPushMatchResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserMatch = $root.UserMatchInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ProxyPushMatchResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ProxyPushMatchResult} Client2ProxyPushMatchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ProxyPushMatchResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ProxyPushMatchResult message.
     * @function verify
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ProxyPushMatchResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.UserMatch != null && message.hasOwnProperty("UserMatch")) {
            let error = $root.UserMatchInfo.verify(message.UserMatch);
            if (error)
                return "UserMatch." + error;
        }
        return null;
    };

    /**
     * Creates a Client2ProxyPushMatchResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ProxyPushMatchResult} Client2ProxyPushMatchResult
     */
    Client2ProxyPushMatchResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ProxyPushMatchResult)
            return object;
        let message = new $root.Client2ProxyPushMatchResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.UserMatch != null) {
            if (typeof object.UserMatch !== "object")
                throw TypeError(".Client2ProxyPushMatchResult.UserMatch: object expected");
            message.UserMatch = $root.UserMatchInfo.fromObject(object.UserMatch);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2ProxyPushMatchResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {Client2ProxyPushMatchResult} message Client2ProxyPushMatchResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ProxyPushMatchResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.UserMatch = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.UserMatch != null && message.hasOwnProperty("UserMatch"))
            object.UserMatch = $root.UserMatchInfo.toObject(message.UserMatch, options);
        return object;
    };

    /**
     * Converts this Client2ProxyPushMatchResult to JSON.
     * @function toJSON
     * @memberof Client2ProxyPushMatchResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ProxyPushMatchResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ProxyPushMatchResult
     * @function getTypeUrl
     * @memberof Client2ProxyPushMatchResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ProxyPushMatchResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ProxyPushMatchResult";
    };

    return Client2ProxyPushMatchResult;
})();

export const Client2PokerTestReq = $root.Client2PokerTestReq = (() => {

    /**
     * Properties of a Client2PokerTestReq.
     * @exports IClient2PokerTestReq
     * @interface IClient2PokerTestReq
     * @property {number|null} [UserID] Client2PokerTestReq UserID
     * @property {number|null} [GameID] Client2PokerTestReq GameID
     * @property {number|null} [ProdcutID] Client2PokerTestReq ProdcutID
     */

    /**
     * Constructs a new Client2PokerTestReq.
     * @exports Client2PokerTestReq
     * @classdesc Represents a Client2PokerTestReq.
     * @implements IClient2PokerTestReq
     * @constructor
     * @param {IClient2PokerTestReq=} [properties] Properties to set
     */
    function Client2PokerTestReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2PokerTestReq UserID.
     * @member {number} UserID
     * @memberof Client2PokerTestReq
     * @instance
     */
    Client2PokerTestReq.prototype.UserID = 0;

    /**
     * Client2PokerTestReq GameID.
     * @member {number} GameID
     * @memberof Client2PokerTestReq
     * @instance
     */
    Client2PokerTestReq.prototype.GameID = 0;

    /**
     * Client2PokerTestReq ProdcutID.
     * @member {number} ProdcutID
     * @memberof Client2PokerTestReq
     * @instance
     */
    Client2PokerTestReq.prototype.ProdcutID = 0;

    /**
     * Creates a new Client2PokerTestReq instance using the specified properties.
     * @function create
     * @memberof Client2PokerTestReq
     * @static
     * @param {IClient2PokerTestReq=} [properties] Properties to set
     * @returns {Client2PokerTestReq} Client2PokerTestReq instance
     */
    Client2PokerTestReq.create = function create(properties) {
        return new Client2PokerTestReq(properties);
    };

    /**
     * Encodes the specified Client2PokerTestReq message. Does not implicitly {@link Client2PokerTestReq.verify|verify} messages.
     * @function encode
     * @memberof Client2PokerTestReq
     * @static
     * @param {IClient2PokerTestReq} message Client2PokerTestReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerTestReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProdcutID != null && Object.hasOwnProperty.call(message, "ProdcutID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProdcutID);
        return writer;
    };

    /**
     * Encodes the specified Client2PokerTestReq message, length delimited. Does not implicitly {@link Client2PokerTestReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2PokerTestReq
     * @static
     * @param {IClient2PokerTestReq} message Client2PokerTestReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerTestReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2PokerTestReq message from the specified reader or buffer.
     * @function decode
     * @memberof Client2PokerTestReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2PokerTestReq} Client2PokerTestReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerTestReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2PokerTestReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProdcutID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2PokerTestReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2PokerTestReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2PokerTestReq} Client2PokerTestReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerTestReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2PokerTestReq message.
     * @function verify
     * @memberof Client2PokerTestReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2PokerTestReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            if (!$util.isInteger(message.ProdcutID))
                return "ProdcutID: integer expected";
        return null;
    };

    /**
     * Creates a Client2PokerTestReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2PokerTestReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2PokerTestReq} Client2PokerTestReq
     */
    Client2PokerTestReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2PokerTestReq)
            return object;
        let message = new $root.Client2PokerTestReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutID != null)
            message.ProdcutID = object.ProdcutID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2PokerTestReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2PokerTestReq
     * @static
     * @param {Client2PokerTestReq} message Client2PokerTestReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2PokerTestReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProdcutID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            object.ProdcutID = message.ProdcutID;
        return object;
    };

    /**
     * Converts this Client2PokerTestReq to JSON.
     * @function toJSON
     * @memberof Client2PokerTestReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2PokerTestReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2PokerTestReq
     * @function getTypeUrl
     * @memberof Client2PokerTestReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2PokerTestReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2PokerTestReq";
    };

    return Client2PokerTestReq;
})();

export const Client2PokerTestAck = $root.Client2PokerTestAck = (() => {

    /**
     * Properties of a Client2PokerTestAck.
     * @exports IClient2PokerTestAck
     * @interface IClient2PokerTestAck
     * @property {number|null} [UserID] Client2PokerTestAck UserID
     * @property {number|null} [GameID] Client2PokerTestAck GameID
     * @property {number|null} [ProdcutID] Client2PokerTestAck ProdcutID
     */

    /**
     * Constructs a new Client2PokerTestAck.
     * @exports Client2PokerTestAck
     * @classdesc Represents a Client2PokerTestAck.
     * @implements IClient2PokerTestAck
     * @constructor
     * @param {IClient2PokerTestAck=} [properties] Properties to set
     */
    function Client2PokerTestAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2PokerTestAck UserID.
     * @member {number} UserID
     * @memberof Client2PokerTestAck
     * @instance
     */
    Client2PokerTestAck.prototype.UserID = 0;

    /**
     * Client2PokerTestAck GameID.
     * @member {number} GameID
     * @memberof Client2PokerTestAck
     * @instance
     */
    Client2PokerTestAck.prototype.GameID = 0;

    /**
     * Client2PokerTestAck ProdcutID.
     * @member {number} ProdcutID
     * @memberof Client2PokerTestAck
     * @instance
     */
    Client2PokerTestAck.prototype.ProdcutID = 0;

    /**
     * Creates a new Client2PokerTestAck instance using the specified properties.
     * @function create
     * @memberof Client2PokerTestAck
     * @static
     * @param {IClient2PokerTestAck=} [properties] Properties to set
     * @returns {Client2PokerTestAck} Client2PokerTestAck instance
     */
    Client2PokerTestAck.create = function create(properties) {
        return new Client2PokerTestAck(properties);
    };

    /**
     * Encodes the specified Client2PokerTestAck message. Does not implicitly {@link Client2PokerTestAck.verify|verify} messages.
     * @function encode
     * @memberof Client2PokerTestAck
     * @static
     * @param {IClient2PokerTestAck} message Client2PokerTestAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerTestAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.ProdcutID != null && Object.hasOwnProperty.call(message, "ProdcutID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ProdcutID);
        return writer;
    };

    /**
     * Encodes the specified Client2PokerTestAck message, length delimited. Does not implicitly {@link Client2PokerTestAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2PokerTestAck
     * @static
     * @param {IClient2PokerTestAck} message Client2PokerTestAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2PokerTestAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2PokerTestAck message from the specified reader or buffer.
     * @function decode
     * @memberof Client2PokerTestAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2PokerTestAck} Client2PokerTestAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerTestAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2PokerTestAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ProdcutID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2PokerTestAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2PokerTestAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2PokerTestAck} Client2PokerTestAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2PokerTestAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2PokerTestAck message.
     * @function verify
     * @memberof Client2PokerTestAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2PokerTestAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            if (!$util.isInteger(message.ProdcutID))
                return "ProdcutID: integer expected";
        return null;
    };

    /**
     * Creates a Client2PokerTestAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2PokerTestAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2PokerTestAck} Client2PokerTestAck
     */
    Client2PokerTestAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2PokerTestAck)
            return object;
        let message = new $root.Client2PokerTestAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.ProdcutID != null)
            message.ProdcutID = object.ProdcutID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Client2PokerTestAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2PokerTestAck
     * @static
     * @param {Client2PokerTestAck} message Client2PokerTestAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2PokerTestAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.ProdcutID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.ProdcutID != null && message.hasOwnProperty("ProdcutID"))
            object.ProdcutID = message.ProdcutID;
        return object;
    };

    /**
     * Converts this Client2PokerTestAck to JSON.
     * @function toJSON
     * @memberof Client2PokerTestAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2PokerTestAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2PokerTestAck
     * @function getTypeUrl
     * @memberof Client2PokerTestAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2PokerTestAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2PokerTestAck";
    };

    return Client2PokerTestAck;
})();

export const ClientActivityDataPush = $root.ClientActivityDataPush = (() => {

    /**
     * Properties of a ClientActivityDataPush.
     * @exports IClientActivityDataPush
     * @interface IClientActivityDataPush
     * @property {number|null} [UserID] ClientActivityDataPush UserID
     * @property {number|null} [DataType] ClientActivityDataPush DataType
     * @property {string|null} [ActyData] ClientActivityDataPush ActyData
     */

    /**
     * Constructs a new ClientActivityDataPush.
     * @exports ClientActivityDataPush
     * @classdesc Represents a ClientActivityDataPush.
     * @implements IClientActivityDataPush
     * @constructor
     * @param {IClientActivityDataPush=} [properties] Properties to set
     */
    function ClientActivityDataPush(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientActivityDataPush UserID.
     * @member {number} UserID
     * @memberof ClientActivityDataPush
     * @instance
     */
    ClientActivityDataPush.prototype.UserID = 0;

    /**
     * ClientActivityDataPush DataType.
     * @member {number} DataType
     * @memberof ClientActivityDataPush
     * @instance
     */
    ClientActivityDataPush.prototype.DataType = 0;

    /**
     * ClientActivityDataPush ActyData.
     * @member {string} ActyData
     * @memberof ClientActivityDataPush
     * @instance
     */
    ClientActivityDataPush.prototype.ActyData = "";

    /**
     * Creates a new ClientActivityDataPush instance using the specified properties.
     * @function create
     * @memberof ClientActivityDataPush
     * @static
     * @param {IClientActivityDataPush=} [properties] Properties to set
     * @returns {ClientActivityDataPush} ClientActivityDataPush instance
     */
    ClientActivityDataPush.create = function create(properties) {
        return new ClientActivityDataPush(properties);
    };

    /**
     * Encodes the specified ClientActivityDataPush message. Does not implicitly {@link ClientActivityDataPush.verify|verify} messages.
     * @function encode
     * @memberof ClientActivityDataPush
     * @static
     * @param {IClientActivityDataPush} message ClientActivityDataPush message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientActivityDataPush.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.DataType != null && Object.hasOwnProperty.call(message, "DataType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DataType);
        if (message.ActyData != null && Object.hasOwnProperty.call(message, "ActyData"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ActyData);
        return writer;
    };

    /**
     * Encodes the specified ClientActivityDataPush message, length delimited. Does not implicitly {@link ClientActivityDataPush.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientActivityDataPush
     * @static
     * @param {IClientActivityDataPush} message ClientActivityDataPush message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientActivityDataPush.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientActivityDataPush message from the specified reader or buffer.
     * @function decode
     * @memberof ClientActivityDataPush
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientActivityDataPush} ClientActivityDataPush
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientActivityDataPush.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientActivityDataPush();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.DataType = reader.uint32();
                    break;
                }
            case 3: {
                    message.ActyData = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientActivityDataPush message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientActivityDataPush
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientActivityDataPush} ClientActivityDataPush
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientActivityDataPush.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientActivityDataPush message.
     * @function verify
     * @memberof ClientActivityDataPush
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientActivityDataPush.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.DataType != null && message.hasOwnProperty("DataType"))
            if (!$util.isInteger(message.DataType))
                return "DataType: integer expected";
        if (message.ActyData != null && message.hasOwnProperty("ActyData"))
            if (!$util.isString(message.ActyData))
                return "ActyData: string expected";
        return null;
    };

    /**
     * Creates a ClientActivityDataPush message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientActivityDataPush
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientActivityDataPush} ClientActivityDataPush
     */
    ClientActivityDataPush.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientActivityDataPush)
            return object;
        let message = new $root.ClientActivityDataPush();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.DataType != null)
            message.DataType = object.DataType >>> 0;
        if (object.ActyData != null)
            message.ActyData = String(object.ActyData);
        return message;
    };

    /**
     * Creates a plain object from a ClientActivityDataPush message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientActivityDataPush
     * @static
     * @param {ClientActivityDataPush} message ClientActivityDataPush
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientActivityDataPush.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.DataType = 0;
            object.ActyData = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.DataType != null && message.hasOwnProperty("DataType"))
            object.DataType = message.DataType;
        if (message.ActyData != null && message.hasOwnProperty("ActyData"))
            object.ActyData = message.ActyData;
        return object;
    };

    /**
     * Converts this ClientActivityDataPush to JSON.
     * @function toJSON
     * @memberof ClientActivityDataPush
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientActivityDataPush.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientActivityDataPush
     * @function getTypeUrl
     * @memberof ClientActivityDataPush
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientActivityDataPush.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientActivityDataPush";
    };

    return ClientActivityDataPush;
})();

export const ClientBrokeDataInf = $root.ClientBrokeDataInf = (() => {

    /**
     * Properties of a ClientBrokeDataInf.
     * @exports IClientBrokeDataInf
     * @interface IClientBrokeDataInf
     * @property {number|null} [UserID] ClientBrokeDataInf UserID
     * @property {number|null} [GameID] ClientBrokeDataInf GameID
     * @property {number|null} [GoodsID] ClientBrokeDataInf GoodsID
     */

    /**
     * Constructs a new ClientBrokeDataInf.
     * @exports ClientBrokeDataInf
     * @classdesc Represents a ClientBrokeDataInf.
     * @implements IClientBrokeDataInf
     * @constructor
     * @param {IClientBrokeDataInf=} [properties] Properties to set
     */
    function ClientBrokeDataInf(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBrokeDataInf UserID.
     * @member {number} UserID
     * @memberof ClientBrokeDataInf
     * @instance
     */
    ClientBrokeDataInf.prototype.UserID = 0;

    /**
     * ClientBrokeDataInf GameID.
     * @member {number} GameID
     * @memberof ClientBrokeDataInf
     * @instance
     */
    ClientBrokeDataInf.prototype.GameID = 0;

    /**
     * ClientBrokeDataInf GoodsID.
     * @member {number} GoodsID
     * @memberof ClientBrokeDataInf
     * @instance
     */
    ClientBrokeDataInf.prototype.GoodsID = 0;

    /**
     * Creates a new ClientBrokeDataInf instance using the specified properties.
     * @function create
     * @memberof ClientBrokeDataInf
     * @static
     * @param {IClientBrokeDataInf=} [properties] Properties to set
     * @returns {ClientBrokeDataInf} ClientBrokeDataInf instance
     */
    ClientBrokeDataInf.create = function create(properties) {
        return new ClientBrokeDataInf(properties);
    };

    /**
     * Encodes the specified ClientBrokeDataInf message. Does not implicitly {@link ClientBrokeDataInf.verify|verify} messages.
     * @function encode
     * @memberof ClientBrokeDataInf
     * @static
     * @param {IClientBrokeDataInf} message ClientBrokeDataInf message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBrokeDataInf.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.GoodsID != null && Object.hasOwnProperty.call(message, "GoodsID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GoodsID);
        return writer;
    };

    /**
     * Encodes the specified ClientBrokeDataInf message, length delimited. Does not implicitly {@link ClientBrokeDataInf.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBrokeDataInf
     * @static
     * @param {IClientBrokeDataInf} message ClientBrokeDataInf message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBrokeDataInf.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBrokeDataInf message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBrokeDataInf
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBrokeDataInf} ClientBrokeDataInf
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBrokeDataInf.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBrokeDataInf();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GoodsID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBrokeDataInf message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBrokeDataInf
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBrokeDataInf} ClientBrokeDataInf
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBrokeDataInf.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBrokeDataInf message.
     * @function verify
     * @memberof ClientBrokeDataInf
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBrokeDataInf.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.GoodsID != null && message.hasOwnProperty("GoodsID"))
            if (!$util.isInteger(message.GoodsID))
                return "GoodsID: integer expected";
        return null;
    };

    /**
     * Creates a ClientBrokeDataInf message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBrokeDataInf
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBrokeDataInf} ClientBrokeDataInf
     */
    ClientBrokeDataInf.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBrokeDataInf)
            return object;
        let message = new $root.ClientBrokeDataInf();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.GoodsID != null)
            message.GoodsID = object.GoodsID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBrokeDataInf message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBrokeDataInf
     * @static
     * @param {ClientBrokeDataInf} message ClientBrokeDataInf
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBrokeDataInf.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
            object.GoodsID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.GoodsID != null && message.hasOwnProperty("GoodsID"))
            object.GoodsID = message.GoodsID;
        return object;
    };

    /**
     * Converts this ClientBrokeDataInf to JSON.
     * @function toJSON
     * @memberof ClientBrokeDataInf
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBrokeDataInf.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBrokeDataInf
     * @function getTypeUrl
     * @memberof ClientBrokeDataInf
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBrokeDataInf.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBrokeDataInf";
    };

    return ClientBrokeDataInf;
})();

export const ClientJackPotDataReq = $root.ClientJackPotDataReq = (() => {

    /**
     * Properties of a ClientJackPotDataReq.
     * @exports IClientJackPotDataReq
     * @interface IClientJackPotDataReq
     * @property {number|null} [UserID] ClientJackPotDataReq UserID
     * @property {number|null} [GameID] ClientJackPotDataReq GameID
     */

    /**
     * Constructs a new ClientJackPotDataReq.
     * @exports ClientJackPotDataReq
     * @classdesc Represents a ClientJackPotDataReq.
     * @implements IClientJackPotDataReq
     * @constructor
     * @param {IClientJackPotDataReq=} [properties] Properties to set
     */
    function ClientJackPotDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientJackPotDataReq UserID.
     * @member {number} UserID
     * @memberof ClientJackPotDataReq
     * @instance
     */
    ClientJackPotDataReq.prototype.UserID = 0;

    /**
     * ClientJackPotDataReq GameID.
     * @member {number} GameID
     * @memberof ClientJackPotDataReq
     * @instance
     */
    ClientJackPotDataReq.prototype.GameID = 0;

    /**
     * Creates a new ClientJackPotDataReq instance using the specified properties.
     * @function create
     * @memberof ClientJackPotDataReq
     * @static
     * @param {IClientJackPotDataReq=} [properties] Properties to set
     * @returns {ClientJackPotDataReq} ClientJackPotDataReq instance
     */
    ClientJackPotDataReq.create = function create(properties) {
        return new ClientJackPotDataReq(properties);
    };

    /**
     * Encodes the specified ClientJackPotDataReq message. Does not implicitly {@link ClientJackPotDataReq.verify|verify} messages.
     * @function encode
     * @memberof ClientJackPotDataReq
     * @static
     * @param {IClientJackPotDataReq} message ClientJackPotDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientJackPotDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        return writer;
    };

    /**
     * Encodes the specified ClientJackPotDataReq message, length delimited. Does not implicitly {@link ClientJackPotDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientJackPotDataReq
     * @static
     * @param {IClientJackPotDataReq} message ClientJackPotDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientJackPotDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientJackPotDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientJackPotDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientJackPotDataReq} ClientJackPotDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientJackPotDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientJackPotDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientJackPotDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientJackPotDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientJackPotDataReq} ClientJackPotDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientJackPotDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientJackPotDataReq message.
     * @function verify
     * @memberof ClientJackPotDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientJackPotDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        return null;
    };

    /**
     * Creates a ClientJackPotDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientJackPotDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientJackPotDataReq} ClientJackPotDataReq
     */
    ClientJackPotDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientJackPotDataReq)
            return object;
        let message = new $root.ClientJackPotDataReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientJackPotDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientJackPotDataReq
     * @static
     * @param {ClientJackPotDataReq} message ClientJackPotDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientJackPotDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        return object;
    };

    /**
     * Converts this ClientJackPotDataReq to JSON.
     * @function toJSON
     * @memberof ClientJackPotDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientJackPotDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientJackPotDataReq
     * @function getTypeUrl
     * @memberof ClientJackPotDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientJackPotDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientJackPotDataReq";
    };

    return ClientJackPotDataReq;
})();

export const ClientJackPotDataAck = $root.ClientJackPotDataAck = (() => {

    /**
     * Properties of a ClientJackPotDataAck.
     * @exports IClientJackPotDataAck
     * @interface IClientJackPotDataAck
     * @property {number|null} [UserID] ClientJackPotDataAck UserID
     * @property {number|null} [GameID] ClientJackPotDataAck GameID
     * @property {Array.<IJackPotData>|null} [JackPot] ClientJackPotDataAck JackPot
     */

    /**
     * Constructs a new ClientJackPotDataAck.
     * @exports ClientJackPotDataAck
     * @classdesc Represents a ClientJackPotDataAck.
     * @implements IClientJackPotDataAck
     * @constructor
     * @param {IClientJackPotDataAck=} [properties] Properties to set
     */
    function ClientJackPotDataAck(properties) {
        this.JackPot = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientJackPotDataAck UserID.
     * @member {number} UserID
     * @memberof ClientJackPotDataAck
     * @instance
     */
    ClientJackPotDataAck.prototype.UserID = 0;

    /**
     * ClientJackPotDataAck GameID.
     * @member {number} GameID
     * @memberof ClientJackPotDataAck
     * @instance
     */
    ClientJackPotDataAck.prototype.GameID = 0;

    /**
     * ClientJackPotDataAck JackPot.
     * @member {Array.<IJackPotData>} JackPot
     * @memberof ClientJackPotDataAck
     * @instance
     */
    ClientJackPotDataAck.prototype.JackPot = $util.emptyArray;

    /**
     * Creates a new ClientJackPotDataAck instance using the specified properties.
     * @function create
     * @memberof ClientJackPotDataAck
     * @static
     * @param {IClientJackPotDataAck=} [properties] Properties to set
     * @returns {ClientJackPotDataAck} ClientJackPotDataAck instance
     */
    ClientJackPotDataAck.create = function create(properties) {
        return new ClientJackPotDataAck(properties);
    };

    /**
     * Encodes the specified ClientJackPotDataAck message. Does not implicitly {@link ClientJackPotDataAck.verify|verify} messages.
     * @function encode
     * @memberof ClientJackPotDataAck
     * @static
     * @param {IClientJackPotDataAck} message ClientJackPotDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientJackPotDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GameID != null && Object.hasOwnProperty.call(message, "GameID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GameID);
        if (message.JackPot != null && message.JackPot.length)
            for (let i = 0; i < message.JackPot.length; ++i)
                $root.JackPotData.encode(message.JackPot[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientJackPotDataAck message, length delimited. Does not implicitly {@link ClientJackPotDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientJackPotDataAck
     * @static
     * @param {IClientJackPotDataAck} message ClientJackPotDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientJackPotDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientJackPotDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientJackPotDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientJackPotDataAck} ClientJackPotDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientJackPotDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientJackPotDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GameID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.JackPot && message.JackPot.length))
                        message.JackPot = [];
                    message.JackPot.push($root.JackPotData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientJackPotDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientJackPotDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientJackPotDataAck} ClientJackPotDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientJackPotDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientJackPotDataAck message.
     * @function verify
     * @memberof ClientJackPotDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientJackPotDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            if (!$util.isInteger(message.GameID))
                return "GameID: integer expected";
        if (message.JackPot != null && message.hasOwnProperty("JackPot")) {
            if (!Array.isArray(message.JackPot))
                return "JackPot: array expected";
            for (let i = 0; i < message.JackPot.length; ++i) {
                let error = $root.JackPotData.verify(message.JackPot[i]);
                if (error)
                    return "JackPot." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientJackPotDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientJackPotDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientJackPotDataAck} ClientJackPotDataAck
     */
    ClientJackPotDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientJackPotDataAck)
            return object;
        let message = new $root.ClientJackPotDataAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GameID != null)
            message.GameID = object.GameID >>> 0;
        if (object.JackPot) {
            if (!Array.isArray(object.JackPot))
                throw TypeError(".ClientJackPotDataAck.JackPot: array expected");
            message.JackPot = [];
            for (let i = 0; i < object.JackPot.length; ++i) {
                if (typeof object.JackPot[i] !== "object")
                    throw TypeError(".ClientJackPotDataAck.JackPot: object expected");
                message.JackPot[i] = $root.JackPotData.fromObject(object.JackPot[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientJackPotDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientJackPotDataAck
     * @static
     * @param {ClientJackPotDataAck} message ClientJackPotDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientJackPotDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.JackPot = [];
        if (options.defaults) {
            object.UserID = 0;
            object.GameID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GameID != null && message.hasOwnProperty("GameID"))
            object.GameID = message.GameID;
        if (message.JackPot && message.JackPot.length) {
            object.JackPot = [];
            for (let j = 0; j < message.JackPot.length; ++j)
                object.JackPot[j] = $root.JackPotData.toObject(message.JackPot[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientJackPotDataAck to JSON.
     * @function toJSON
     * @memberof ClientJackPotDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientJackPotDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientJackPotDataAck
     * @function getTypeUrl
     * @memberof ClientJackPotDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientJackPotDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientJackPotDataAck";
    };

    return ClientJackPotDataAck;
})();

export const ClientInviteDataReq = $root.ClientInviteDataReq = (() => {

    /**
     * Properties of a ClientInviteDataReq.
     * @exports IClientInviteDataReq
     * @interface IClientInviteDataReq
     * @property {number|null} [UserID] ClientInviteDataReq UserID
     * @property {number|null} [CID] ClientInviteDataReq CID
     */

    /**
     * Constructs a new ClientInviteDataReq.
     * @exports ClientInviteDataReq
     * @classdesc Represents a ClientInviteDataReq.
     * @implements IClientInviteDataReq
     * @constructor
     * @param {IClientInviteDataReq=} [properties] Properties to set
     */
    function ClientInviteDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteDataReq UserID.
     * @member {number} UserID
     * @memberof ClientInviteDataReq
     * @instance
     */
    ClientInviteDataReq.prototype.UserID = 0;

    /**
     * ClientInviteDataReq CID.
     * @member {number} CID
     * @memberof ClientInviteDataReq
     * @instance
     */
    ClientInviteDataReq.prototype.CID = 0;

    /**
     * Creates a new ClientInviteDataReq instance using the specified properties.
     * @function create
     * @memberof ClientInviteDataReq
     * @static
     * @param {IClientInviteDataReq=} [properties] Properties to set
     * @returns {ClientInviteDataReq} ClientInviteDataReq instance
     */
    ClientInviteDataReq.create = function create(properties) {
        return new ClientInviteDataReq(properties);
    };

    /**
     * Encodes the specified ClientInviteDataReq message. Does not implicitly {@link ClientInviteDataReq.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteDataReq
     * @static
     * @param {IClientInviteDataReq} message ClientInviteDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteDataReq message, length delimited. Does not implicitly {@link ClientInviteDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteDataReq
     * @static
     * @param {IClientInviteDataReq} message ClientInviteDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteDataReq} ClientInviteDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteDataReq} ClientInviteDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteDataReq message.
     * @function verify
     * @memberof ClientInviteDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteDataReq} ClientInviteDataReq
     */
    ClientInviteDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteDataReq)
            return object;
        let message = new $root.ClientInviteDataReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteDataReq
     * @static
     * @param {ClientInviteDataReq} message ClientInviteDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        return object;
    };

    /**
     * Converts this ClientInviteDataReq to JSON.
     * @function toJSON
     * @memberof ClientInviteDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteDataReq
     * @function getTypeUrl
     * @memberof ClientInviteDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteDataReq";
    };

    return ClientInviteDataReq;
})();

export const ClientInviteDataAck = $root.ClientInviteDataAck = (() => {

    /**
     * Properties of a ClientInviteDataAck.
     * @exports IClientInviteDataAck
     * @interface IClientInviteDataAck
     * @property {number|null} [ret] ClientInviteDataAck ret
     * @property {number|null} [UserID] ClientInviteDataAck UserID
     * @property {number|null} [CID] ClientInviteDataAck CID
     * @property {number|null} [Taskstatus] ClientInviteDataAck Taskstatus
     * @property {number|null} [Begintime] ClientInviteDataAck Begintime
     * @property {number|null} [Endtime] ClientInviteDataAck Endtime
     * @property {number|null} [Activitytime] ClientInviteDataAck Activitytime
     * @property {number|null} [Awardgold] ClientInviteDataAck Awardgold
     */

    /**
     * Constructs a new ClientInviteDataAck.
     * @exports ClientInviteDataAck
     * @classdesc Represents a ClientInviteDataAck.
     * @implements IClientInviteDataAck
     * @constructor
     * @param {IClientInviteDataAck=} [properties] Properties to set
     */
    function ClientInviteDataAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteDataAck ret.
     * @member {number} ret
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.ret = 0;

    /**
     * ClientInviteDataAck UserID.
     * @member {number} UserID
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.UserID = 0;

    /**
     * ClientInviteDataAck CID.
     * @member {number} CID
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.CID = 0;

    /**
     * ClientInviteDataAck Taskstatus.
     * @member {number} Taskstatus
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.Taskstatus = 0;

    /**
     * ClientInviteDataAck Begintime.
     * @member {number} Begintime
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.Begintime = 0;

    /**
     * ClientInviteDataAck Endtime.
     * @member {number} Endtime
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.Endtime = 0;

    /**
     * ClientInviteDataAck Activitytime.
     * @member {number} Activitytime
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.Activitytime = 0;

    /**
     * ClientInviteDataAck Awardgold.
     * @member {number} Awardgold
     * @memberof ClientInviteDataAck
     * @instance
     */
    ClientInviteDataAck.prototype.Awardgold = 0;

    /**
     * Creates a new ClientInviteDataAck instance using the specified properties.
     * @function create
     * @memberof ClientInviteDataAck
     * @static
     * @param {IClientInviteDataAck=} [properties] Properties to set
     * @returns {ClientInviteDataAck} ClientInviteDataAck instance
     */
    ClientInviteDataAck.create = function create(properties) {
        return new ClientInviteDataAck(properties);
    };

    /**
     * Encodes the specified ClientInviteDataAck message. Does not implicitly {@link ClientInviteDataAck.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteDataAck
     * @static
     * @param {IClientInviteDataAck} message ClientInviteDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CID);
        if (message.Taskstatus != null && Object.hasOwnProperty.call(message, "Taskstatus"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Taskstatus);
        if (message.Begintime != null && Object.hasOwnProperty.call(message, "Begintime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Begintime);
        if (message.Endtime != null && Object.hasOwnProperty.call(message, "Endtime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Endtime);
        if (message.Activitytime != null && Object.hasOwnProperty.call(message, "Activitytime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Activitytime);
        if (message.Awardgold != null && Object.hasOwnProperty.call(message, "Awardgold"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Awardgold);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteDataAck message, length delimited. Does not implicitly {@link ClientInviteDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteDataAck
     * @static
     * @param {IClientInviteDataAck} message ClientInviteDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteDataAck} ClientInviteDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Taskstatus = reader.uint32();
                    break;
                }
            case 5: {
                    message.Begintime = reader.uint32();
                    break;
                }
            case 6: {
                    message.Endtime = reader.uint32();
                    break;
                }
            case 7: {
                    message.Activitytime = reader.uint32();
                    break;
                }
            case 8: {
                    message.Awardgold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteDataAck} ClientInviteDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteDataAck message.
     * @function verify
     * @memberof ClientInviteDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.Taskstatus != null && message.hasOwnProperty("Taskstatus"))
            if (!$util.isInteger(message.Taskstatus))
                return "Taskstatus: integer expected";
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (!$util.isInteger(message.Begintime))
                return "Begintime: integer expected";
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (!$util.isInteger(message.Endtime))
                return "Endtime: integer expected";
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            if (!$util.isInteger(message.Activitytime))
                return "Activitytime: integer expected";
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            if (!$util.isInteger(message.Awardgold))
                return "Awardgold: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteDataAck} ClientInviteDataAck
     */
    ClientInviteDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteDataAck)
            return object;
        let message = new $root.ClientInviteDataAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.Taskstatus != null)
            message.Taskstatus = object.Taskstatus >>> 0;
        if (object.Begintime != null)
            message.Begintime = object.Begintime >>> 0;
        if (object.Endtime != null)
            message.Endtime = object.Endtime >>> 0;
        if (object.Activitytime != null)
            message.Activitytime = object.Activitytime >>> 0;
        if (object.Awardgold != null)
            message.Awardgold = object.Awardgold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteDataAck
     * @static
     * @param {ClientInviteDataAck} message ClientInviteDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.CID = 0;
            object.Taskstatus = 0;
            object.Begintime = 0;
            object.Endtime = 0;
            object.Activitytime = 0;
            object.Awardgold = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.Taskstatus != null && message.hasOwnProperty("Taskstatus"))
            object.Taskstatus = message.Taskstatus;
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            object.Begintime = message.Begintime;
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            object.Endtime = message.Endtime;
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            object.Activitytime = message.Activitytime;
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            object.Awardgold = message.Awardgold;
        return object;
    };

    /**
     * Converts this ClientInviteDataAck to JSON.
     * @function toJSON
     * @memberof ClientInviteDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteDataAck
     * @function getTypeUrl
     * @memberof ClientInviteDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteDataAck";
    };

    return ClientInviteDataAck;
})();

export const ClientInviteGoldReq = $root.ClientInviteGoldReq = (() => {

    /**
     * Properties of a ClientInviteGoldReq.
     * @exports IClientInviteGoldReq
     * @interface IClientInviteGoldReq
     * @property {number|null} [UserID] ClientInviteGoldReq UserID
     * @property {number|null} [CID] ClientInviteGoldReq CID
     * @property {number|null} [Begintime] ClientInviteGoldReq Begintime
     * @property {number|null} [Activitytime] ClientInviteGoldReq Activitytime
     * @property {number|null} [Awardgold] ClientInviteGoldReq Awardgold
     */

    /**
     * Constructs a new ClientInviteGoldReq.
     * @exports ClientInviteGoldReq
     * @classdesc Represents a ClientInviteGoldReq.
     * @implements IClientInviteGoldReq
     * @constructor
     * @param {IClientInviteGoldReq=} [properties] Properties to set
     */
    function ClientInviteGoldReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteGoldReq UserID.
     * @member {number} UserID
     * @memberof ClientInviteGoldReq
     * @instance
     */
    ClientInviteGoldReq.prototype.UserID = 0;

    /**
     * ClientInviteGoldReq CID.
     * @member {number} CID
     * @memberof ClientInviteGoldReq
     * @instance
     */
    ClientInviteGoldReq.prototype.CID = 0;

    /**
     * ClientInviteGoldReq Begintime.
     * @member {number} Begintime
     * @memberof ClientInviteGoldReq
     * @instance
     */
    ClientInviteGoldReq.prototype.Begintime = 0;

    /**
     * ClientInviteGoldReq Activitytime.
     * @member {number} Activitytime
     * @memberof ClientInviteGoldReq
     * @instance
     */
    ClientInviteGoldReq.prototype.Activitytime = 0;

    /**
     * ClientInviteGoldReq Awardgold.
     * @member {number} Awardgold
     * @memberof ClientInviteGoldReq
     * @instance
     */
    ClientInviteGoldReq.prototype.Awardgold = 0;

    /**
     * Creates a new ClientInviteGoldReq instance using the specified properties.
     * @function create
     * @memberof ClientInviteGoldReq
     * @static
     * @param {IClientInviteGoldReq=} [properties] Properties to set
     * @returns {ClientInviteGoldReq} ClientInviteGoldReq instance
     */
    ClientInviteGoldReq.create = function create(properties) {
        return new ClientInviteGoldReq(properties);
    };

    /**
     * Encodes the specified ClientInviteGoldReq message. Does not implicitly {@link ClientInviteGoldReq.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteGoldReq
     * @static
     * @param {IClientInviteGoldReq} message ClientInviteGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteGoldReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        if (message.Begintime != null && Object.hasOwnProperty.call(message, "Begintime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Begintime);
        if (message.Activitytime != null && Object.hasOwnProperty.call(message, "Activitytime"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Activitytime);
        if (message.Awardgold != null && Object.hasOwnProperty.call(message, "Awardgold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Awardgold);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteGoldReq message, length delimited. Does not implicitly {@link ClientInviteGoldReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteGoldReq
     * @static
     * @param {IClientInviteGoldReq} message ClientInviteGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteGoldReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteGoldReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteGoldReq} ClientInviteGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteGoldReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteGoldReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Begintime = reader.uint32();
                    break;
                }
            case 4: {
                    message.Activitytime = reader.uint32();
                    break;
                }
            case 5: {
                    message.Awardgold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteGoldReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteGoldReq} ClientInviteGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteGoldReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteGoldReq message.
     * @function verify
     * @memberof ClientInviteGoldReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteGoldReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (!$util.isInteger(message.Begintime))
                return "Begintime: integer expected";
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            if (!$util.isInteger(message.Activitytime))
                return "Activitytime: integer expected";
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            if (!$util.isInteger(message.Awardgold))
                return "Awardgold: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteGoldReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteGoldReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteGoldReq} ClientInviteGoldReq
     */
    ClientInviteGoldReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteGoldReq)
            return object;
        let message = new $root.ClientInviteGoldReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.Begintime != null)
            message.Begintime = object.Begintime >>> 0;
        if (object.Activitytime != null)
            message.Activitytime = object.Activitytime >>> 0;
        if (object.Awardgold != null)
            message.Awardgold = object.Awardgold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteGoldReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteGoldReq
     * @static
     * @param {ClientInviteGoldReq} message ClientInviteGoldReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteGoldReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
            object.Begintime = 0;
            object.Activitytime = 0;
            object.Awardgold = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            object.Begintime = message.Begintime;
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            object.Activitytime = message.Activitytime;
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            object.Awardgold = message.Awardgold;
        return object;
    };

    /**
     * Converts this ClientInviteGoldReq to JSON.
     * @function toJSON
     * @memberof ClientInviteGoldReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteGoldReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteGoldReq
     * @function getTypeUrl
     * @memberof ClientInviteGoldReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteGoldReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteGoldReq";
    };

    return ClientInviteGoldReq;
})();

export const ClientInviteGoldAck = $root.ClientInviteGoldAck = (() => {

    /**
     * Properties of a ClientInviteGoldAck.
     * @exports IClientInviteGoldAck
     * @interface IClientInviteGoldAck
     * @property {number|null} [ret] ClientInviteGoldAck ret
     * @property {number|null} [UserID] ClientInviteGoldAck UserID
     * @property {number|null} [CID] ClientInviteGoldAck CID
     * @property {boolean|null} [BGold] ClientInviteGoldAck BGold
     * @property {number|null} [Awardgold] ClientInviteGoldAck Awardgold
     * @property {number|null} [Begintime] ClientInviteGoldAck Begintime
     * @property {number|null} [Endtime] ClientInviteGoldAck Endtime
     * @property {number|null} [Nowtime] ClientInviteGoldAck Nowtime
     * @property {number|null} [Activitytime] ClientInviteGoldAck Activitytime
     * @property {Array.<IInviteUserAvatar>|null} [uar] ClientInviteGoldAck uar
     */

    /**
     * Constructs a new ClientInviteGoldAck.
     * @exports ClientInviteGoldAck
     * @classdesc Represents a ClientInviteGoldAck.
     * @implements IClientInviteGoldAck
     * @constructor
     * @param {IClientInviteGoldAck=} [properties] Properties to set
     */
    function ClientInviteGoldAck(properties) {
        this.uar = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteGoldAck ret.
     * @member {number} ret
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.ret = 0;

    /**
     * ClientInviteGoldAck UserID.
     * @member {number} UserID
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.UserID = 0;

    /**
     * ClientInviteGoldAck CID.
     * @member {number} CID
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.CID = 0;

    /**
     * ClientInviteGoldAck BGold.
     * @member {boolean} BGold
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.BGold = false;

    /**
     * ClientInviteGoldAck Awardgold.
     * @member {number} Awardgold
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.Awardgold = 0;

    /**
     * ClientInviteGoldAck Begintime.
     * @member {number} Begintime
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.Begintime = 0;

    /**
     * ClientInviteGoldAck Endtime.
     * @member {number} Endtime
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.Endtime = 0;

    /**
     * ClientInviteGoldAck Nowtime.
     * @member {number} Nowtime
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.Nowtime = 0;

    /**
     * ClientInviteGoldAck Activitytime.
     * @member {number} Activitytime
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.Activitytime = 0;

    /**
     * ClientInviteGoldAck uar.
     * @member {Array.<IInviteUserAvatar>} uar
     * @memberof ClientInviteGoldAck
     * @instance
     */
    ClientInviteGoldAck.prototype.uar = $util.emptyArray;

    /**
     * Creates a new ClientInviteGoldAck instance using the specified properties.
     * @function create
     * @memberof ClientInviteGoldAck
     * @static
     * @param {IClientInviteGoldAck=} [properties] Properties to set
     * @returns {ClientInviteGoldAck} ClientInviteGoldAck instance
     */
    ClientInviteGoldAck.create = function create(properties) {
        return new ClientInviteGoldAck(properties);
    };

    /**
     * Encodes the specified ClientInviteGoldAck message. Does not implicitly {@link ClientInviteGoldAck.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteGoldAck
     * @static
     * @param {IClientInviteGoldAck} message ClientInviteGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteGoldAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CID);
        if (message.BGold != null && Object.hasOwnProperty.call(message, "BGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.BGold);
        if (message.Awardgold != null && Object.hasOwnProperty.call(message, "Awardgold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Awardgold);
        if (message.Begintime != null && Object.hasOwnProperty.call(message, "Begintime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Begintime);
        if (message.Endtime != null && Object.hasOwnProperty.call(message, "Endtime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Endtime);
        if (message.Nowtime != null && Object.hasOwnProperty.call(message, "Nowtime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Nowtime);
        if (message.Activitytime != null && Object.hasOwnProperty.call(message, "Activitytime"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.Activitytime);
        if (message.uar != null && message.uar.length)
            for (let i = 0; i < message.uar.length; ++i)
                $root.InviteUserAvatar.encode(message.uar[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientInviteGoldAck message, length delimited. Does not implicitly {@link ClientInviteGoldAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteGoldAck
     * @static
     * @param {IClientInviteGoldAck} message ClientInviteGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteGoldAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteGoldAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteGoldAck} ClientInviteGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteGoldAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteGoldAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CID = reader.uint32();
                    break;
                }
            case 4: {
                    message.BGold = reader.bool();
                    break;
                }
            case 5: {
                    message.Awardgold = reader.uint32();
                    break;
                }
            case 6: {
                    message.Begintime = reader.uint32();
                    break;
                }
            case 7: {
                    message.Endtime = reader.uint32();
                    break;
                }
            case 8: {
                    message.Nowtime = reader.uint32();
                    break;
                }
            case 9: {
                    message.Activitytime = reader.uint32();
                    break;
                }
            case 10: {
                    if (!(message.uar && message.uar.length))
                        message.uar = [];
                    message.uar.push($root.InviteUserAvatar.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteGoldAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteGoldAck} ClientInviteGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteGoldAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteGoldAck message.
     * @function verify
     * @memberof ClientInviteGoldAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteGoldAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.BGold != null && message.hasOwnProperty("BGold"))
            if (typeof message.BGold !== "boolean")
                return "BGold: boolean expected";
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            if (!$util.isInteger(message.Awardgold))
                return "Awardgold: integer expected";
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (!$util.isInteger(message.Begintime))
                return "Begintime: integer expected";
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (!$util.isInteger(message.Endtime))
                return "Endtime: integer expected";
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            if (!$util.isInteger(message.Nowtime))
                return "Nowtime: integer expected";
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            if (!$util.isInteger(message.Activitytime))
                return "Activitytime: integer expected";
        if (message.uar != null && message.hasOwnProperty("uar")) {
            if (!Array.isArray(message.uar))
                return "uar: array expected";
            for (let i = 0; i < message.uar.length; ++i) {
                let error = $root.InviteUserAvatar.verify(message.uar[i]);
                if (error)
                    return "uar." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientInviteGoldAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteGoldAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteGoldAck} ClientInviteGoldAck
     */
    ClientInviteGoldAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteGoldAck)
            return object;
        let message = new $root.ClientInviteGoldAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.BGold != null)
            message.BGold = Boolean(object.BGold);
        if (object.Awardgold != null)
            message.Awardgold = object.Awardgold >>> 0;
        if (object.Begintime != null)
            message.Begintime = object.Begintime >>> 0;
        if (object.Endtime != null)
            message.Endtime = object.Endtime >>> 0;
        if (object.Nowtime != null)
            message.Nowtime = object.Nowtime >>> 0;
        if (object.Activitytime != null)
            message.Activitytime = object.Activitytime >>> 0;
        if (object.uar) {
            if (!Array.isArray(object.uar))
                throw TypeError(".ClientInviteGoldAck.uar: array expected");
            message.uar = [];
            for (let i = 0; i < object.uar.length; ++i) {
                if (typeof object.uar[i] !== "object")
                    throw TypeError(".ClientInviteGoldAck.uar: object expected");
                message.uar[i] = $root.InviteUserAvatar.fromObject(object.uar[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteGoldAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteGoldAck
     * @static
     * @param {ClientInviteGoldAck} message ClientInviteGoldAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteGoldAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.uar = [];
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.CID = 0;
            object.BGold = false;
            object.Awardgold = 0;
            object.Begintime = 0;
            object.Endtime = 0;
            object.Nowtime = 0;
            object.Activitytime = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.BGold != null && message.hasOwnProperty("BGold"))
            object.BGold = message.BGold;
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            object.Awardgold = message.Awardgold;
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            object.Begintime = message.Begintime;
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            object.Endtime = message.Endtime;
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            object.Nowtime = message.Nowtime;
        if (message.Activitytime != null && message.hasOwnProperty("Activitytime"))
            object.Activitytime = message.Activitytime;
        if (message.uar && message.uar.length) {
            object.uar = [];
            for (let j = 0; j < message.uar.length; ++j)
                object.uar[j] = $root.InviteUserAvatar.toObject(message.uar[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientInviteGoldAck to JSON.
     * @function toJSON
     * @memberof ClientInviteGoldAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteGoldAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteGoldAck
     * @function getTypeUrl
     * @memberof ClientInviteGoldAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteGoldAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteGoldAck";
    };

    return ClientInviteGoldAck;
})();

export const ClientInviteTasktStatusReq = $root.ClientInviteTasktStatusReq = (() => {

    /**
     * Properties of a ClientInviteTasktStatusReq.
     * @exports IClientInviteTasktStatusReq
     * @interface IClientInviteTasktStatusReq
     * @property {number|null} [UserID] ClientInviteTasktStatusReq UserID
     * @property {number|null} [CID] ClientInviteTasktStatusReq CID
     */

    /**
     * Constructs a new ClientInviteTasktStatusReq.
     * @exports ClientInviteTasktStatusReq
     * @classdesc Represents a ClientInviteTasktStatusReq.
     * @implements IClientInviteTasktStatusReq
     * @constructor
     * @param {IClientInviteTasktStatusReq=} [properties] Properties to set
     */
    function ClientInviteTasktStatusReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteTasktStatusReq UserID.
     * @member {number} UserID
     * @memberof ClientInviteTasktStatusReq
     * @instance
     */
    ClientInviteTasktStatusReq.prototype.UserID = 0;

    /**
     * ClientInviteTasktStatusReq CID.
     * @member {number} CID
     * @memberof ClientInviteTasktStatusReq
     * @instance
     */
    ClientInviteTasktStatusReq.prototype.CID = 0;

    /**
     * Creates a new ClientInviteTasktStatusReq instance using the specified properties.
     * @function create
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {IClientInviteTasktStatusReq=} [properties] Properties to set
     * @returns {ClientInviteTasktStatusReq} ClientInviteTasktStatusReq instance
     */
    ClientInviteTasktStatusReq.create = function create(properties) {
        return new ClientInviteTasktStatusReq(properties);
    };

    /**
     * Encodes the specified ClientInviteTasktStatusReq message. Does not implicitly {@link ClientInviteTasktStatusReq.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {IClientInviteTasktStatusReq} message ClientInviteTasktStatusReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteTasktStatusReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteTasktStatusReq message, length delimited. Does not implicitly {@link ClientInviteTasktStatusReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {IClientInviteTasktStatusReq} message ClientInviteTasktStatusReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteTasktStatusReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteTasktStatusReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteTasktStatusReq} ClientInviteTasktStatusReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteTasktStatusReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteTasktStatusReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteTasktStatusReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteTasktStatusReq} ClientInviteTasktStatusReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteTasktStatusReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteTasktStatusReq message.
     * @function verify
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteTasktStatusReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteTasktStatusReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteTasktStatusReq} ClientInviteTasktStatusReq
     */
    ClientInviteTasktStatusReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteTasktStatusReq)
            return object;
        let message = new $root.ClientInviteTasktStatusReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteTasktStatusReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {ClientInviteTasktStatusReq} message ClientInviteTasktStatusReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteTasktStatusReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        return object;
    };

    /**
     * Converts this ClientInviteTasktStatusReq to JSON.
     * @function toJSON
     * @memberof ClientInviteTasktStatusReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteTasktStatusReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteTasktStatusReq
     * @function getTypeUrl
     * @memberof ClientInviteTasktStatusReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteTasktStatusReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteTasktStatusReq";
    };

    return ClientInviteTasktStatusReq;
})();

export const ClientInviteTasktStatusAck = $root.ClientInviteTasktStatusAck = (() => {

    /**
     * Properties of a ClientInviteTasktStatusAck.
     * @exports IClientInviteTasktStatusAck
     * @interface IClientInviteTasktStatusAck
     * @property {number|null} [ret] ClientInviteTasktStatusAck ret
     * @property {number|null} [UserID] ClientInviteTasktStatusAck UserID
     * @property {number|null} [CID] ClientInviteTasktStatusAck CID
     * @property {number|null} [Taskstatus] ClientInviteTasktStatusAck Taskstatus
     */

    /**
     * Constructs a new ClientInviteTasktStatusAck.
     * @exports ClientInviteTasktStatusAck
     * @classdesc Represents a ClientInviteTasktStatusAck.
     * @implements IClientInviteTasktStatusAck
     * @constructor
     * @param {IClientInviteTasktStatusAck=} [properties] Properties to set
     */
    function ClientInviteTasktStatusAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteTasktStatusAck ret.
     * @member {number} ret
     * @memberof ClientInviteTasktStatusAck
     * @instance
     */
    ClientInviteTasktStatusAck.prototype.ret = 0;

    /**
     * ClientInviteTasktStatusAck UserID.
     * @member {number} UserID
     * @memberof ClientInviteTasktStatusAck
     * @instance
     */
    ClientInviteTasktStatusAck.prototype.UserID = 0;

    /**
     * ClientInviteTasktStatusAck CID.
     * @member {number} CID
     * @memberof ClientInviteTasktStatusAck
     * @instance
     */
    ClientInviteTasktStatusAck.prototype.CID = 0;

    /**
     * ClientInviteTasktStatusAck Taskstatus.
     * @member {number} Taskstatus
     * @memberof ClientInviteTasktStatusAck
     * @instance
     */
    ClientInviteTasktStatusAck.prototype.Taskstatus = 0;

    /**
     * Creates a new ClientInviteTasktStatusAck instance using the specified properties.
     * @function create
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {IClientInviteTasktStatusAck=} [properties] Properties to set
     * @returns {ClientInviteTasktStatusAck} ClientInviteTasktStatusAck instance
     */
    ClientInviteTasktStatusAck.create = function create(properties) {
        return new ClientInviteTasktStatusAck(properties);
    };

    /**
     * Encodes the specified ClientInviteTasktStatusAck message. Does not implicitly {@link ClientInviteTasktStatusAck.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {IClientInviteTasktStatusAck} message ClientInviteTasktStatusAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteTasktStatusAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CID);
        if (message.Taskstatus != null && Object.hasOwnProperty.call(message, "Taskstatus"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Taskstatus);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteTasktStatusAck message, length delimited. Does not implicitly {@link ClientInviteTasktStatusAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {IClientInviteTasktStatusAck} message ClientInviteTasktStatusAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteTasktStatusAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteTasktStatusAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteTasktStatusAck} ClientInviteTasktStatusAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteTasktStatusAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteTasktStatusAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Taskstatus = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteTasktStatusAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteTasktStatusAck} ClientInviteTasktStatusAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteTasktStatusAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteTasktStatusAck message.
     * @function verify
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteTasktStatusAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.Taskstatus != null && message.hasOwnProperty("Taskstatus"))
            if (!$util.isInteger(message.Taskstatus))
                return "Taskstatus: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteTasktStatusAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteTasktStatusAck} ClientInviteTasktStatusAck
     */
    ClientInviteTasktStatusAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteTasktStatusAck)
            return object;
        let message = new $root.ClientInviteTasktStatusAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.Taskstatus != null)
            message.Taskstatus = object.Taskstatus >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteTasktStatusAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {ClientInviteTasktStatusAck} message ClientInviteTasktStatusAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteTasktStatusAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.CID = 0;
            object.Taskstatus = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.Taskstatus != null && message.hasOwnProperty("Taskstatus"))
            object.Taskstatus = message.Taskstatus;
        return object;
    };

    /**
     * Converts this ClientInviteTasktStatusAck to JSON.
     * @function toJSON
     * @memberof ClientInviteTasktStatusAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteTasktStatusAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteTasktStatusAck
     * @function getTypeUrl
     * @memberof ClientInviteTasktStatusAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteTasktStatusAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteTasktStatusAck";
    };

    return ClientInviteTasktStatusAck;
})();

export const ClientInviteAddGoldReq = $root.ClientInviteAddGoldReq = (() => {

    /**
     * Properties of a ClientInviteAddGoldReq.
     * @exports IClientInviteAddGoldReq
     * @interface IClientInviteAddGoldReq
     * @property {number|null} [UserID] ClientInviteAddGoldReq UserID
     * @property {number|null} [CID] ClientInviteAddGoldReq CID
     * @property {number|null} [Awardgold] ClientInviteAddGoldReq Awardgold
     */

    /**
     * Constructs a new ClientInviteAddGoldReq.
     * @exports ClientInviteAddGoldReq
     * @classdesc Represents a ClientInviteAddGoldReq.
     * @implements IClientInviteAddGoldReq
     * @constructor
     * @param {IClientInviteAddGoldReq=} [properties] Properties to set
     */
    function ClientInviteAddGoldReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteAddGoldReq UserID.
     * @member {number} UserID
     * @memberof ClientInviteAddGoldReq
     * @instance
     */
    ClientInviteAddGoldReq.prototype.UserID = 0;

    /**
     * ClientInviteAddGoldReq CID.
     * @member {number} CID
     * @memberof ClientInviteAddGoldReq
     * @instance
     */
    ClientInviteAddGoldReq.prototype.CID = 0;

    /**
     * ClientInviteAddGoldReq Awardgold.
     * @member {number} Awardgold
     * @memberof ClientInviteAddGoldReq
     * @instance
     */
    ClientInviteAddGoldReq.prototype.Awardgold = 0;

    /**
     * Creates a new ClientInviteAddGoldReq instance using the specified properties.
     * @function create
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {IClientInviteAddGoldReq=} [properties] Properties to set
     * @returns {ClientInviteAddGoldReq} ClientInviteAddGoldReq instance
     */
    ClientInviteAddGoldReq.create = function create(properties) {
        return new ClientInviteAddGoldReq(properties);
    };

    /**
     * Encodes the specified ClientInviteAddGoldReq message. Does not implicitly {@link ClientInviteAddGoldReq.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {IClientInviteAddGoldReq} message ClientInviteAddGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteAddGoldReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CID);
        if (message.Awardgold != null && Object.hasOwnProperty.call(message, "Awardgold"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Awardgold);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteAddGoldReq message, length delimited. Does not implicitly {@link ClientInviteAddGoldReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {IClientInviteAddGoldReq} message ClientInviteAddGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteAddGoldReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteAddGoldReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteAddGoldReq} ClientInviteAddGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteAddGoldReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteAddGoldReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Awardgold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteAddGoldReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteAddGoldReq} ClientInviteAddGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteAddGoldReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteAddGoldReq message.
     * @function verify
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteAddGoldReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            if (!$util.isInteger(message.Awardgold))
                return "Awardgold: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteAddGoldReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteAddGoldReq} ClientInviteAddGoldReq
     */
    ClientInviteAddGoldReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteAddGoldReq)
            return object;
        let message = new $root.ClientInviteAddGoldReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        if (object.Awardgold != null)
            message.Awardgold = object.Awardgold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteAddGoldReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {ClientInviteAddGoldReq} message ClientInviteAddGoldReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteAddGoldReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CID = 0;
            object.Awardgold = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        if (message.Awardgold != null && message.hasOwnProperty("Awardgold"))
            object.Awardgold = message.Awardgold;
        return object;
    };

    /**
     * Converts this ClientInviteAddGoldReq to JSON.
     * @function toJSON
     * @memberof ClientInviteAddGoldReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteAddGoldReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteAddGoldReq
     * @function getTypeUrl
     * @memberof ClientInviteAddGoldReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteAddGoldReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteAddGoldReq";
    };

    return ClientInviteAddGoldReq;
})();

export const ClientInviteAddGoldAck = $root.ClientInviteAddGoldAck = (() => {

    /**
     * Properties of a ClientInviteAddGoldAck.
     * @exports IClientInviteAddGoldAck
     * @interface IClientInviteAddGoldAck
     * @property {number|null} [ret] ClientInviteAddGoldAck ret
     * @property {number|null} [UserID] ClientInviteAddGoldAck UserID
     * @property {number|null} [CID] ClientInviteAddGoldAck CID
     */

    /**
     * Constructs a new ClientInviteAddGoldAck.
     * @exports ClientInviteAddGoldAck
     * @classdesc Represents a ClientInviteAddGoldAck.
     * @implements IClientInviteAddGoldAck
     * @constructor
     * @param {IClientInviteAddGoldAck=} [properties] Properties to set
     */
    function ClientInviteAddGoldAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInviteAddGoldAck ret.
     * @member {number} ret
     * @memberof ClientInviteAddGoldAck
     * @instance
     */
    ClientInviteAddGoldAck.prototype.ret = 0;

    /**
     * ClientInviteAddGoldAck UserID.
     * @member {number} UserID
     * @memberof ClientInviteAddGoldAck
     * @instance
     */
    ClientInviteAddGoldAck.prototype.UserID = 0;

    /**
     * ClientInviteAddGoldAck CID.
     * @member {number} CID
     * @memberof ClientInviteAddGoldAck
     * @instance
     */
    ClientInviteAddGoldAck.prototype.CID = 0;

    /**
     * Creates a new ClientInviteAddGoldAck instance using the specified properties.
     * @function create
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {IClientInviteAddGoldAck=} [properties] Properties to set
     * @returns {ClientInviteAddGoldAck} ClientInviteAddGoldAck instance
     */
    ClientInviteAddGoldAck.create = function create(properties) {
        return new ClientInviteAddGoldAck(properties);
    };

    /**
     * Encodes the specified ClientInviteAddGoldAck message. Does not implicitly {@link ClientInviteAddGoldAck.verify|verify} messages.
     * @function encode
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {IClientInviteAddGoldAck} message ClientInviteAddGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteAddGoldAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CID != null && Object.hasOwnProperty.call(message, "CID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CID);
        return writer;
    };

    /**
     * Encodes the specified ClientInviteAddGoldAck message, length delimited. Does not implicitly {@link ClientInviteAddGoldAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {IClientInviteAddGoldAck} message ClientInviteAddGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInviteAddGoldAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInviteAddGoldAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInviteAddGoldAck} ClientInviteAddGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteAddGoldAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInviteAddGoldAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInviteAddGoldAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInviteAddGoldAck} ClientInviteAddGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInviteAddGoldAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInviteAddGoldAck message.
     * @function verify
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInviteAddGoldAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CID != null && message.hasOwnProperty("CID"))
            if (!$util.isInteger(message.CID))
                return "CID: integer expected";
        return null;
    };

    /**
     * Creates a ClientInviteAddGoldAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInviteAddGoldAck} ClientInviteAddGoldAck
     */
    ClientInviteAddGoldAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInviteAddGoldAck)
            return object;
        let message = new $root.ClientInviteAddGoldAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CID != null)
            message.CID = object.CID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientInviteAddGoldAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {ClientInviteAddGoldAck} message ClientInviteAddGoldAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInviteAddGoldAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.CID = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CID != null && message.hasOwnProperty("CID"))
            object.CID = message.CID;
        return object;
    };

    /**
     * Converts this ClientInviteAddGoldAck to JSON.
     * @function toJSON
     * @memberof ClientInviteAddGoldAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInviteAddGoldAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInviteAddGoldAck
     * @function getTypeUrl
     * @memberof ClientInviteAddGoldAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInviteAddGoldAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInviteAddGoldAck";
    };

    return ClientInviteAddGoldAck;
})();

export const ClientDrawNumReq = $root.ClientDrawNumReq = (() => {

    /**
     * Properties of a ClientDrawNumReq.
     * @exports IClientDrawNumReq
     * @interface IClientDrawNumReq
     * @property {number|null} [UserID] ClientDrawNumReq UserID
     */

    /**
     * Constructs a new ClientDrawNumReq.
     * @exports ClientDrawNumReq
     * @classdesc Represents a ClientDrawNumReq.
     * @implements IClientDrawNumReq
     * @constructor
     * @param {IClientDrawNumReq=} [properties] Properties to set
     */
    function ClientDrawNumReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientDrawNumReq UserID.
     * @member {number} UserID
     * @memberof ClientDrawNumReq
     * @instance
     */
    ClientDrawNumReq.prototype.UserID = 0;

    /**
     * Creates a new ClientDrawNumReq instance using the specified properties.
     * @function create
     * @memberof ClientDrawNumReq
     * @static
     * @param {IClientDrawNumReq=} [properties] Properties to set
     * @returns {ClientDrawNumReq} ClientDrawNumReq instance
     */
    ClientDrawNumReq.create = function create(properties) {
        return new ClientDrawNumReq(properties);
    };

    /**
     * Encodes the specified ClientDrawNumReq message. Does not implicitly {@link ClientDrawNumReq.verify|verify} messages.
     * @function encode
     * @memberof ClientDrawNumReq
     * @static
     * @param {IClientDrawNumReq} message ClientDrawNumReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientDrawNumReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientDrawNumReq message, length delimited. Does not implicitly {@link ClientDrawNumReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientDrawNumReq
     * @static
     * @param {IClientDrawNumReq} message ClientDrawNumReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientDrawNumReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientDrawNumReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientDrawNumReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientDrawNumReq} ClientDrawNumReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientDrawNumReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientDrawNumReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientDrawNumReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientDrawNumReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientDrawNumReq} ClientDrawNumReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientDrawNumReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientDrawNumReq message.
     * @function verify
     * @memberof ClientDrawNumReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientDrawNumReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientDrawNumReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientDrawNumReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientDrawNumReq} ClientDrawNumReq
     */
    ClientDrawNumReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientDrawNumReq)
            return object;
        let message = new $root.ClientDrawNumReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientDrawNumReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientDrawNumReq
     * @static
     * @param {ClientDrawNumReq} message ClientDrawNumReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientDrawNumReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientDrawNumReq to JSON.
     * @function toJSON
     * @memberof ClientDrawNumReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientDrawNumReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientDrawNumReq
     * @function getTypeUrl
     * @memberof ClientDrawNumReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientDrawNumReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientDrawNumReq";
    };

    return ClientDrawNumReq;
})();

export const ClientDrawNumAck = $root.ClientDrawNumAck = (() => {

    /**
     * Properties of a ClientDrawNumAck.
     * @exports IClientDrawNumAck
     * @interface IClientDrawNumAck
     * @property {number|null} [UserID] ClientDrawNumAck UserID
     * @property {number|null} [Dnum] ClientDrawNumAck Dnum
     */

    /**
     * Constructs a new ClientDrawNumAck.
     * @exports ClientDrawNumAck
     * @classdesc Represents a ClientDrawNumAck.
     * @implements IClientDrawNumAck
     * @constructor
     * @param {IClientDrawNumAck=} [properties] Properties to set
     */
    function ClientDrawNumAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientDrawNumAck UserID.
     * @member {number} UserID
     * @memberof ClientDrawNumAck
     * @instance
     */
    ClientDrawNumAck.prototype.UserID = 0;

    /**
     * ClientDrawNumAck Dnum.
     * @member {number} Dnum
     * @memberof ClientDrawNumAck
     * @instance
     */
    ClientDrawNumAck.prototype.Dnum = 0;

    /**
     * Creates a new ClientDrawNumAck instance using the specified properties.
     * @function create
     * @memberof ClientDrawNumAck
     * @static
     * @param {IClientDrawNumAck=} [properties] Properties to set
     * @returns {ClientDrawNumAck} ClientDrawNumAck instance
     */
    ClientDrawNumAck.create = function create(properties) {
        return new ClientDrawNumAck(properties);
    };

    /**
     * Encodes the specified ClientDrawNumAck message. Does not implicitly {@link ClientDrawNumAck.verify|verify} messages.
     * @function encode
     * @memberof ClientDrawNumAck
     * @static
     * @param {IClientDrawNumAck} message ClientDrawNumAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientDrawNumAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Dnum != null && Object.hasOwnProperty.call(message, "Dnum"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Dnum);
        return writer;
    };

    /**
     * Encodes the specified ClientDrawNumAck message, length delimited. Does not implicitly {@link ClientDrawNumAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientDrawNumAck
     * @static
     * @param {IClientDrawNumAck} message ClientDrawNumAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientDrawNumAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientDrawNumAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientDrawNumAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientDrawNumAck} ClientDrawNumAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientDrawNumAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientDrawNumAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Dnum = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientDrawNumAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientDrawNumAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientDrawNumAck} ClientDrawNumAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientDrawNumAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientDrawNumAck message.
     * @function verify
     * @memberof ClientDrawNumAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientDrawNumAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Dnum != null && message.hasOwnProperty("Dnum"))
            if (!$util.isInteger(message.Dnum))
                return "Dnum: integer expected";
        return null;
    };

    /**
     * Creates a ClientDrawNumAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientDrawNumAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientDrawNumAck} ClientDrawNumAck
     */
    ClientDrawNumAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientDrawNumAck)
            return object;
        let message = new $root.ClientDrawNumAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Dnum != null)
            message.Dnum = object.Dnum >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientDrawNumAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientDrawNumAck
     * @static
     * @param {ClientDrawNumAck} message ClientDrawNumAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientDrawNumAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Dnum = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Dnum != null && message.hasOwnProperty("Dnum"))
            object.Dnum = message.Dnum;
        return object;
    };

    /**
     * Converts this ClientDrawNumAck to JSON.
     * @function toJSON
     * @memberof ClientDrawNumAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientDrawNumAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientDrawNumAck
     * @function getTypeUrl
     * @memberof ClientDrawNumAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientDrawNumAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientDrawNumAck";
    };

    return ClientDrawNumAck;
})();

export const ClientTurntableReq = $root.ClientTurntableReq = (() => {

    /**
     * Properties of a ClientTurntableReq.
     * @exports IClientTurntableReq
     * @interface IClientTurntableReq
     * @property {number|null} [UserID] ClientTurntableReq UserID
     * @property {number|null} [ChannelID] ClientTurntableReq ChannelID
     */

    /**
     * Constructs a new ClientTurntableReq.
     * @exports ClientTurntableReq
     * @classdesc Represents a ClientTurntableReq.
     * @implements IClientTurntableReq
     * @constructor
     * @param {IClientTurntableReq=} [properties] Properties to set
     */
    function ClientTurntableReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurntableReq UserID.
     * @member {number} UserID
     * @memberof ClientTurntableReq
     * @instance
     */
    ClientTurntableReq.prototype.UserID = 0;

    /**
     * ClientTurntableReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientTurntableReq
     * @instance
     */
    ClientTurntableReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientTurntableReq instance using the specified properties.
     * @function create
     * @memberof ClientTurntableReq
     * @static
     * @param {IClientTurntableReq=} [properties] Properties to set
     * @returns {ClientTurntableReq} ClientTurntableReq instance
     */
    ClientTurntableReq.create = function create(properties) {
        return new ClientTurntableReq(properties);
    };

    /**
     * Encodes the specified ClientTurntableReq message. Does not implicitly {@link ClientTurntableReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurntableReq
     * @static
     * @param {IClientTurntableReq} message ClientTurntableReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurntableReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurntableReq message, length delimited. Does not implicitly {@link ClientTurntableReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurntableReq
     * @static
     * @param {IClientTurntableReq} message ClientTurntableReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurntableReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurntableReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurntableReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurntableReq} ClientTurntableReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurntableReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurntableReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurntableReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurntableReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurntableReq} ClientTurntableReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurntableReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurntableReq message.
     * @function verify
     * @memberof ClientTurntableReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurntableReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurntableReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurntableReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurntableReq} ClientTurntableReq
     */
    ClientTurntableReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurntableReq)
            return object;
        let message = new $root.ClientTurntableReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurntableReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurntableReq
     * @static
     * @param {ClientTurntableReq} message ClientTurntableReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurntableReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientTurntableReq to JSON.
     * @function toJSON
     * @memberof ClientTurntableReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurntableReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurntableReq
     * @function getTypeUrl
     * @memberof ClientTurntableReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurntableReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurntableReq";
    };

    return ClientTurntableReq;
})();

export const ClientTurntableAck = $root.ClientTurntableAck = (() => {

    /**
     * Properties of a ClientTurntableAck.
     * @exports IClientTurntableAck
     * @interface IClientTurntableAck
     * @property {number|null} [ret] ClientTurntableAck ret
     * @property {number|null} [UserID] ClientTurntableAck UserID
     * @property {number|null} [TurnID] ClientTurntableAck TurnID
     * @property {string|null} [strGold] ClientTurntableAck strGold
     * @property {string|null} [strBonus] ClientTurntableAck strBonus
     */

    /**
     * Constructs a new ClientTurntableAck.
     * @exports ClientTurntableAck
     * @classdesc Represents a ClientTurntableAck.
     * @implements IClientTurntableAck
     * @constructor
     * @param {IClientTurntableAck=} [properties] Properties to set
     */
    function ClientTurntableAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurntableAck ret.
     * @member {number} ret
     * @memberof ClientTurntableAck
     * @instance
     */
    ClientTurntableAck.prototype.ret = 0;

    /**
     * ClientTurntableAck UserID.
     * @member {number} UserID
     * @memberof ClientTurntableAck
     * @instance
     */
    ClientTurntableAck.prototype.UserID = 0;

    /**
     * ClientTurntableAck TurnID.
     * @member {number} TurnID
     * @memberof ClientTurntableAck
     * @instance
     */
    ClientTurntableAck.prototype.TurnID = 0;

    /**
     * ClientTurntableAck strGold.
     * @member {string} strGold
     * @memberof ClientTurntableAck
     * @instance
     */
    ClientTurntableAck.prototype.strGold = "";

    /**
     * ClientTurntableAck strBonus.
     * @member {string} strBonus
     * @memberof ClientTurntableAck
     * @instance
     */
    ClientTurntableAck.prototype.strBonus = "";

    /**
     * Creates a new ClientTurntableAck instance using the specified properties.
     * @function create
     * @memberof ClientTurntableAck
     * @static
     * @param {IClientTurntableAck=} [properties] Properties to set
     * @returns {ClientTurntableAck} ClientTurntableAck instance
     */
    ClientTurntableAck.create = function create(properties) {
        return new ClientTurntableAck(properties);
    };

    /**
     * Encodes the specified ClientTurntableAck message. Does not implicitly {@link ClientTurntableAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurntableAck
     * @static
     * @param {IClientTurntableAck} message ClientTurntableAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurntableAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.TurnID != null && Object.hasOwnProperty.call(message, "TurnID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.TurnID);
        if (message.strGold != null && Object.hasOwnProperty.call(message, "strGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.strGold);
        if (message.strBonus != null && Object.hasOwnProperty.call(message, "strBonus"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.strBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientTurntableAck message, length delimited. Does not implicitly {@link ClientTurntableAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurntableAck
     * @static
     * @param {IClientTurntableAck} message ClientTurntableAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurntableAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurntableAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurntableAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurntableAck} ClientTurntableAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurntableAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurntableAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.TurnID = reader.uint32();
                    break;
                }
            case 4: {
                    message.strGold = reader.string();
                    break;
                }
            case 5: {
                    message.strBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurntableAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurntableAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurntableAck} ClientTurntableAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurntableAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurntableAck message.
     * @function verify
     * @memberof ClientTurntableAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurntableAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TurnID != null && message.hasOwnProperty("TurnID"))
            if (!$util.isInteger(message.TurnID))
                return "TurnID: integer expected";
        if (message.strGold != null && message.hasOwnProperty("strGold"))
            if (!$util.isString(message.strGold))
                return "strGold: string expected";
        if (message.strBonus != null && message.hasOwnProperty("strBonus"))
            if (!$util.isString(message.strBonus))
                return "strBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientTurntableAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurntableAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurntableAck} ClientTurntableAck
     */
    ClientTurntableAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurntableAck)
            return object;
        let message = new $root.ClientTurntableAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TurnID != null)
            message.TurnID = object.TurnID >>> 0;
        if (object.strGold != null)
            message.strGold = String(object.strGold);
        if (object.strBonus != null)
            message.strBonus = String(object.strBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientTurntableAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurntableAck
     * @static
     * @param {ClientTurntableAck} message ClientTurntableAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurntableAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.TurnID = 0;
            object.strGold = "";
            object.strBonus = "";
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TurnID != null && message.hasOwnProperty("TurnID"))
            object.TurnID = message.TurnID;
        if (message.strGold != null && message.hasOwnProperty("strGold"))
            object.strGold = message.strGold;
        if (message.strBonus != null && message.hasOwnProperty("strBonus"))
            object.strBonus = message.strBonus;
        return object;
    };

    /**
     * Converts this ClientTurntableAck to JSON.
     * @function toJSON
     * @memberof ClientTurntableAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurntableAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurntableAck
     * @function getTypeUrl
     * @memberof ClientTurntableAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurntableAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurntableAck";
    };

    return ClientTurntableAck;
})();

export const ClientRankingDataReq = $root.ClientRankingDataReq = (() => {

    /**
     * Properties of a ClientRankingDataReq.
     * @exports IClientRankingDataReq
     * @interface IClientRankingDataReq
     * @property {number|null} [UserID] ClientRankingDataReq UserID
     * @property {number|null} [RankType] ClientRankingDataReq RankType
     */

    /**
     * Constructs a new ClientRankingDataReq.
     * @exports ClientRankingDataReq
     * @classdesc Represents a ClientRankingDataReq.
     * @implements IClientRankingDataReq
     * @constructor
     * @param {IClientRankingDataReq=} [properties] Properties to set
     */
    function ClientRankingDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingDataReq UserID.
     * @member {number} UserID
     * @memberof ClientRankingDataReq
     * @instance
     */
    ClientRankingDataReq.prototype.UserID = 0;

    /**
     * ClientRankingDataReq RankType.
     * @member {number} RankType
     * @memberof ClientRankingDataReq
     * @instance
     */
    ClientRankingDataReq.prototype.RankType = 0;

    /**
     * Creates a new ClientRankingDataReq instance using the specified properties.
     * @function create
     * @memberof ClientRankingDataReq
     * @static
     * @param {IClientRankingDataReq=} [properties] Properties to set
     * @returns {ClientRankingDataReq} ClientRankingDataReq instance
     */
    ClientRankingDataReq.create = function create(properties) {
        return new ClientRankingDataReq(properties);
    };

    /**
     * Encodes the specified ClientRankingDataReq message. Does not implicitly {@link ClientRankingDataReq.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingDataReq
     * @static
     * @param {IClientRankingDataReq} message ClientRankingDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.RankType != null && Object.hasOwnProperty.call(message, "RankType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.RankType);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingDataReq message, length delimited. Does not implicitly {@link ClientRankingDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingDataReq
     * @static
     * @param {IClientRankingDataReq} message ClientRankingDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingDataReq} ClientRankingDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.RankType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingDataReq} ClientRankingDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingDataReq message.
     * @function verify
     * @memberof ClientRankingDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            if (!$util.isInteger(message.RankType))
                return "RankType: integer expected";
        return null;
    };

    /**
     * Creates a ClientRankingDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingDataReq} ClientRankingDataReq
     */
    ClientRankingDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingDataReq)
            return object;
        let message = new $root.ClientRankingDataReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RankType != null)
            message.RankType = object.RankType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingDataReq
     * @static
     * @param {ClientRankingDataReq} message ClientRankingDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.RankType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            object.RankType = message.RankType;
        return object;
    };

    /**
     * Converts this ClientRankingDataReq to JSON.
     * @function toJSON
     * @memberof ClientRankingDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingDataReq
     * @function getTypeUrl
     * @memberof ClientRankingDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingDataReq";
    };

    return ClientRankingDataReq;
})();

export const ClientRankingDataAck = $root.ClientRankingDataAck = (() => {

    /**
     * Properties of a ClientRankingDataAck.
     * @exports IClientRankingDataAck
     * @interface IClientRankingDataAck
     * @property {number|null} [ret] ClientRankingDataAck ret
     * @property {number|null} [RankType] ClientRankingDataAck RankType
     * @property {number|null} [reqUser] ClientRankingDataAck reqUser
     * @property {Array.<IRankingStu>|null} [RankData] ClientRankingDataAck RankData
     * @property {number|Long|null} [Jackpot] ClientRankingDataAck Jackpot
     * @property {number|Long|null} [Begintime] ClientRankingDataAck Begintime
     * @property {number|Long|null} [Endtime] ClientRankingDataAck Endtime
     * @property {number|Long|null} [Nowtime] ClientRankingDataAck Nowtime
     */

    /**
     * Constructs a new ClientRankingDataAck.
     * @exports ClientRankingDataAck
     * @classdesc Represents a ClientRankingDataAck.
     * @implements IClientRankingDataAck
     * @constructor
     * @param {IClientRankingDataAck=} [properties] Properties to set
     */
    function ClientRankingDataAck(properties) {
        this.RankData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingDataAck ret.
     * @member {number} ret
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.ret = 0;

    /**
     * ClientRankingDataAck RankType.
     * @member {number} RankType
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.RankType = 0;

    /**
     * ClientRankingDataAck reqUser.
     * @member {number} reqUser
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.reqUser = 0;

    /**
     * ClientRankingDataAck RankData.
     * @member {Array.<IRankingStu>} RankData
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.RankData = $util.emptyArray;

    /**
     * ClientRankingDataAck Jackpot.
     * @member {number|Long} Jackpot
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.Jackpot = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingDataAck Begintime.
     * @member {number|Long} Begintime
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.Begintime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingDataAck Endtime.
     * @member {number|Long} Endtime
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.Endtime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingDataAck Nowtime.
     * @member {number|Long} Nowtime
     * @memberof ClientRankingDataAck
     * @instance
     */
    ClientRankingDataAck.prototype.Nowtime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientRankingDataAck instance using the specified properties.
     * @function create
     * @memberof ClientRankingDataAck
     * @static
     * @param {IClientRankingDataAck=} [properties] Properties to set
     * @returns {ClientRankingDataAck} ClientRankingDataAck instance
     */
    ClientRankingDataAck.create = function create(properties) {
        return new ClientRankingDataAck(properties);
    };

    /**
     * Encodes the specified ClientRankingDataAck message. Does not implicitly {@link ClientRankingDataAck.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingDataAck
     * @static
     * @param {IClientRankingDataAck} message ClientRankingDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.RankType != null && Object.hasOwnProperty.call(message, "RankType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.RankType);
        if (message.reqUser != null && Object.hasOwnProperty.call(message, "reqUser"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.reqUser);
        if (message.RankData != null && message.RankData.length)
            for (let i = 0; i < message.RankData.length; ++i)
                $root.RankingStu.encode(message.RankData[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.Jackpot != null && Object.hasOwnProperty.call(message, "Jackpot"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Jackpot);
        if (message.Begintime != null && Object.hasOwnProperty.call(message, "Begintime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.Begintime);
        if (message.Endtime != null && Object.hasOwnProperty.call(message, "Endtime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.Endtime);
        if (message.Nowtime != null && Object.hasOwnProperty.call(message, "Nowtime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.Nowtime);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingDataAck message, length delimited. Does not implicitly {@link ClientRankingDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingDataAck
     * @static
     * @param {IClientRankingDataAck} message ClientRankingDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingDataAck} ClientRankingDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.RankType = reader.uint32();
                    break;
                }
            case 3: {
                    message.reqUser = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.RankData && message.RankData.length))
                        message.RankData = [];
                    message.RankData.push($root.RankingStu.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.Jackpot = reader.uint64();
                    break;
                }
            case 6: {
                    message.Begintime = reader.uint64();
                    break;
                }
            case 7: {
                    message.Endtime = reader.uint64();
                    break;
                }
            case 8: {
                    message.Nowtime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingDataAck} ClientRankingDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingDataAck message.
     * @function verify
     * @memberof ClientRankingDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            if (!$util.isInteger(message.RankType))
                return "RankType: integer expected";
        if (message.reqUser != null && message.hasOwnProperty("reqUser"))
            if (!$util.isInteger(message.reqUser))
                return "reqUser: integer expected";
        if (message.RankData != null && message.hasOwnProperty("RankData")) {
            if (!Array.isArray(message.RankData))
                return "RankData: array expected";
            for (let i = 0; i < message.RankData.length; ++i) {
                let error = $root.RankingStu.verify(message.RankData[i]);
                if (error)
                    return "RankData." + error;
            }
        }
        if (message.Jackpot != null && message.hasOwnProperty("Jackpot"))
            if (!$util.isInteger(message.Jackpot) && !(message.Jackpot && $util.isInteger(message.Jackpot.low) && $util.isInteger(message.Jackpot.high)))
                return "Jackpot: integer|Long expected";
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (!$util.isInteger(message.Begintime) && !(message.Begintime && $util.isInteger(message.Begintime.low) && $util.isInteger(message.Begintime.high)))
                return "Begintime: integer|Long expected";
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (!$util.isInteger(message.Endtime) && !(message.Endtime && $util.isInteger(message.Endtime.low) && $util.isInteger(message.Endtime.high)))
                return "Endtime: integer|Long expected";
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            if (!$util.isInteger(message.Nowtime) && !(message.Nowtime && $util.isInteger(message.Nowtime.low) && $util.isInteger(message.Nowtime.high)))
                return "Nowtime: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientRankingDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingDataAck} ClientRankingDataAck
     */
    ClientRankingDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingDataAck)
            return object;
        let message = new $root.ClientRankingDataAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.RankType != null)
            message.RankType = object.RankType >>> 0;
        if (object.reqUser != null)
            message.reqUser = object.reqUser >>> 0;
        if (object.RankData) {
            if (!Array.isArray(object.RankData))
                throw TypeError(".ClientRankingDataAck.RankData: array expected");
            message.RankData = [];
            for (let i = 0; i < object.RankData.length; ++i) {
                if (typeof object.RankData[i] !== "object")
                    throw TypeError(".ClientRankingDataAck.RankData: object expected");
                message.RankData[i] = $root.RankingStu.fromObject(object.RankData[i]);
            }
        }
        if (object.Jackpot != null)
            if ($util.Long)
                (message.Jackpot = $util.Long.fromValue(object.Jackpot)).unsigned = true;
            else if (typeof object.Jackpot === "string")
                message.Jackpot = parseInt(object.Jackpot, 10);
            else if (typeof object.Jackpot === "number")
                message.Jackpot = object.Jackpot;
            else if (typeof object.Jackpot === "object")
                message.Jackpot = new $util.LongBits(object.Jackpot.low >>> 0, object.Jackpot.high >>> 0).toNumber(true);
        if (object.Begintime != null)
            if ($util.Long)
                (message.Begintime = $util.Long.fromValue(object.Begintime)).unsigned = true;
            else if (typeof object.Begintime === "string")
                message.Begintime = parseInt(object.Begintime, 10);
            else if (typeof object.Begintime === "number")
                message.Begintime = object.Begintime;
            else if (typeof object.Begintime === "object")
                message.Begintime = new $util.LongBits(object.Begintime.low >>> 0, object.Begintime.high >>> 0).toNumber(true);
        if (object.Endtime != null)
            if ($util.Long)
                (message.Endtime = $util.Long.fromValue(object.Endtime)).unsigned = true;
            else if (typeof object.Endtime === "string")
                message.Endtime = parseInt(object.Endtime, 10);
            else if (typeof object.Endtime === "number")
                message.Endtime = object.Endtime;
            else if (typeof object.Endtime === "object")
                message.Endtime = new $util.LongBits(object.Endtime.low >>> 0, object.Endtime.high >>> 0).toNumber(true);
        if (object.Nowtime != null)
            if ($util.Long)
                (message.Nowtime = $util.Long.fromValue(object.Nowtime)).unsigned = true;
            else if (typeof object.Nowtime === "string")
                message.Nowtime = parseInt(object.Nowtime, 10);
            else if (typeof object.Nowtime === "number")
                message.Nowtime = object.Nowtime;
            else if (typeof object.Nowtime === "object")
                message.Nowtime = new $util.LongBits(object.Nowtime.low >>> 0, object.Nowtime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingDataAck
     * @static
     * @param {ClientRankingDataAck} message ClientRankingDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RankData = [];
        if (options.defaults) {
            object.ret = 0;
            object.RankType = 0;
            object.reqUser = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Jackpot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Jackpot = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Begintime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Begintime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Endtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Endtime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Nowtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Nowtime = options.longs === String ? "0" : 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            object.RankType = message.RankType;
        if (message.reqUser != null && message.hasOwnProperty("reqUser"))
            object.reqUser = message.reqUser;
        if (message.RankData && message.RankData.length) {
            object.RankData = [];
            for (let j = 0; j < message.RankData.length; ++j)
                object.RankData[j] = $root.RankingStu.toObject(message.RankData[j], options);
        }
        if (message.Jackpot != null && message.hasOwnProperty("Jackpot"))
            if (typeof message.Jackpot === "number")
                object.Jackpot = options.longs === String ? String(message.Jackpot) : message.Jackpot;
            else
                object.Jackpot = options.longs === String ? $util.Long.prototype.toString.call(message.Jackpot) : options.longs === Number ? new $util.LongBits(message.Jackpot.low >>> 0, message.Jackpot.high >>> 0).toNumber(true) : message.Jackpot;
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (typeof message.Begintime === "number")
                object.Begintime = options.longs === String ? String(message.Begintime) : message.Begintime;
            else
                object.Begintime = options.longs === String ? $util.Long.prototype.toString.call(message.Begintime) : options.longs === Number ? new $util.LongBits(message.Begintime.low >>> 0, message.Begintime.high >>> 0).toNumber(true) : message.Begintime;
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (typeof message.Endtime === "number")
                object.Endtime = options.longs === String ? String(message.Endtime) : message.Endtime;
            else
                object.Endtime = options.longs === String ? $util.Long.prototype.toString.call(message.Endtime) : options.longs === Number ? new $util.LongBits(message.Endtime.low >>> 0, message.Endtime.high >>> 0).toNumber(true) : message.Endtime;
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            if (typeof message.Nowtime === "number")
                object.Nowtime = options.longs === String ? String(message.Nowtime) : message.Nowtime;
            else
                object.Nowtime = options.longs === String ? $util.Long.prototype.toString.call(message.Nowtime) : options.longs === Number ? new $util.LongBits(message.Nowtime.low >>> 0, message.Nowtime.high >>> 0).toNumber(true) : message.Nowtime;
        return object;
    };

    /**
     * Converts this ClientRankingDataAck to JSON.
     * @function toJSON
     * @memberof ClientRankingDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingDataAck
     * @function getTypeUrl
     * @memberof ClientRankingDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingDataAck";
    };

    return ClientRankingDataAck;
})();

export const ClientRankingJackPotReq = $root.ClientRankingJackPotReq = (() => {

    /**
     * Properties of a ClientRankingJackPotReq.
     * @exports IClientRankingJackPotReq
     * @interface IClientRankingJackPotReq
     * @property {number|null} [UserID] ClientRankingJackPotReq UserID
     * @property {number|null} [RankType] ClientRankingJackPotReq RankType
     */

    /**
     * Constructs a new ClientRankingJackPotReq.
     * @exports ClientRankingJackPotReq
     * @classdesc Represents a ClientRankingJackPotReq.
     * @implements IClientRankingJackPotReq
     * @constructor
     * @param {IClientRankingJackPotReq=} [properties] Properties to set
     */
    function ClientRankingJackPotReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingJackPotReq UserID.
     * @member {number} UserID
     * @memberof ClientRankingJackPotReq
     * @instance
     */
    ClientRankingJackPotReq.prototype.UserID = 0;

    /**
     * ClientRankingJackPotReq RankType.
     * @member {number} RankType
     * @memberof ClientRankingJackPotReq
     * @instance
     */
    ClientRankingJackPotReq.prototype.RankType = 0;

    /**
     * Creates a new ClientRankingJackPotReq instance using the specified properties.
     * @function create
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {IClientRankingJackPotReq=} [properties] Properties to set
     * @returns {ClientRankingJackPotReq} ClientRankingJackPotReq instance
     */
    ClientRankingJackPotReq.create = function create(properties) {
        return new ClientRankingJackPotReq(properties);
    };

    /**
     * Encodes the specified ClientRankingJackPotReq message. Does not implicitly {@link ClientRankingJackPotReq.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {IClientRankingJackPotReq} message ClientRankingJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingJackPotReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.RankType != null && Object.hasOwnProperty.call(message, "RankType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.RankType);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingJackPotReq message, length delimited. Does not implicitly {@link ClientRankingJackPotReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {IClientRankingJackPotReq} message ClientRankingJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingJackPotReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingJackPotReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingJackPotReq} ClientRankingJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingJackPotReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingJackPotReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.RankType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingJackPotReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingJackPotReq} ClientRankingJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingJackPotReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingJackPotReq message.
     * @function verify
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingJackPotReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            if (!$util.isInteger(message.RankType))
                return "RankType: integer expected";
        return null;
    };

    /**
     * Creates a ClientRankingJackPotReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingJackPotReq} ClientRankingJackPotReq
     */
    ClientRankingJackPotReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingJackPotReq)
            return object;
        let message = new $root.ClientRankingJackPotReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RankType != null)
            message.RankType = object.RankType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingJackPotReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {ClientRankingJackPotReq} message ClientRankingJackPotReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingJackPotReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.RankType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            object.RankType = message.RankType;
        return object;
    };

    /**
     * Converts this ClientRankingJackPotReq to JSON.
     * @function toJSON
     * @memberof ClientRankingJackPotReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingJackPotReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingJackPotReq
     * @function getTypeUrl
     * @memberof ClientRankingJackPotReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingJackPotReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingJackPotReq";
    };

    return ClientRankingJackPotReq;
})();

export const ClientRankingJackPotAck = $root.ClientRankingJackPotAck = (() => {

    /**
     * Properties of a ClientRankingJackPotAck.
     * @exports IClientRankingJackPotAck
     * @interface IClientRankingJackPotAck
     * @property {number|null} [ret] ClientRankingJackPotAck ret
     * @property {number|null} [UserID] ClientRankingJackPotAck UserID
     * @property {number|null} [RankType] ClientRankingJackPotAck RankType
     * @property {number|Long|null} [Jackpot] ClientRankingJackPotAck Jackpot
     * @property {number|Long|null} [Begintime] ClientRankingJackPotAck Begintime
     * @property {number|Long|null} [Endtime] ClientRankingJackPotAck Endtime
     * @property {number|Long|null} [Nowtime] ClientRankingJackPotAck Nowtime
     */

    /**
     * Constructs a new ClientRankingJackPotAck.
     * @exports ClientRankingJackPotAck
     * @classdesc Represents a ClientRankingJackPotAck.
     * @implements IClientRankingJackPotAck
     * @constructor
     * @param {IClientRankingJackPotAck=} [properties] Properties to set
     */
    function ClientRankingJackPotAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingJackPotAck ret.
     * @member {number} ret
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.ret = 0;

    /**
     * ClientRankingJackPotAck UserID.
     * @member {number} UserID
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.UserID = 0;

    /**
     * ClientRankingJackPotAck RankType.
     * @member {number} RankType
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.RankType = 0;

    /**
     * ClientRankingJackPotAck Jackpot.
     * @member {number|Long} Jackpot
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.Jackpot = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingJackPotAck Begintime.
     * @member {number|Long} Begintime
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.Begintime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingJackPotAck Endtime.
     * @member {number|Long} Endtime
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.Endtime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingJackPotAck Nowtime.
     * @member {number|Long} Nowtime
     * @memberof ClientRankingJackPotAck
     * @instance
     */
    ClientRankingJackPotAck.prototype.Nowtime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientRankingJackPotAck instance using the specified properties.
     * @function create
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {IClientRankingJackPotAck=} [properties] Properties to set
     * @returns {ClientRankingJackPotAck} ClientRankingJackPotAck instance
     */
    ClientRankingJackPotAck.create = function create(properties) {
        return new ClientRankingJackPotAck(properties);
    };

    /**
     * Encodes the specified ClientRankingJackPotAck message. Does not implicitly {@link ClientRankingJackPotAck.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {IClientRankingJackPotAck} message ClientRankingJackPotAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingJackPotAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.RankType != null && Object.hasOwnProperty.call(message, "RankType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.RankType);
        if (message.Jackpot != null && Object.hasOwnProperty.call(message, "Jackpot"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Jackpot);
        if (message.Begintime != null && Object.hasOwnProperty.call(message, "Begintime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Begintime);
        if (message.Endtime != null && Object.hasOwnProperty.call(message, "Endtime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.Endtime);
        if (message.Nowtime != null && Object.hasOwnProperty.call(message, "Nowtime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.Nowtime);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingJackPotAck message, length delimited. Does not implicitly {@link ClientRankingJackPotAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {IClientRankingJackPotAck} message ClientRankingJackPotAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingJackPotAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingJackPotAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingJackPotAck} ClientRankingJackPotAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingJackPotAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingJackPotAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.RankType = reader.uint32();
                    break;
                }
            case 4: {
                    message.Jackpot = reader.uint64();
                    break;
                }
            case 5: {
                    message.Begintime = reader.uint64();
                    break;
                }
            case 6: {
                    message.Endtime = reader.uint64();
                    break;
                }
            case 7: {
                    message.Nowtime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingJackPotAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingJackPotAck} ClientRankingJackPotAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingJackPotAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingJackPotAck message.
     * @function verify
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingJackPotAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            if (!$util.isInteger(message.RankType))
                return "RankType: integer expected";
        if (message.Jackpot != null && message.hasOwnProperty("Jackpot"))
            if (!$util.isInteger(message.Jackpot) && !(message.Jackpot && $util.isInteger(message.Jackpot.low) && $util.isInteger(message.Jackpot.high)))
                return "Jackpot: integer|Long expected";
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (!$util.isInteger(message.Begintime) && !(message.Begintime && $util.isInteger(message.Begintime.low) && $util.isInteger(message.Begintime.high)))
                return "Begintime: integer|Long expected";
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (!$util.isInteger(message.Endtime) && !(message.Endtime && $util.isInteger(message.Endtime.low) && $util.isInteger(message.Endtime.high)))
                return "Endtime: integer|Long expected";
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            if (!$util.isInteger(message.Nowtime) && !(message.Nowtime && $util.isInteger(message.Nowtime.low) && $util.isInteger(message.Nowtime.high)))
                return "Nowtime: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientRankingJackPotAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingJackPotAck} ClientRankingJackPotAck
     */
    ClientRankingJackPotAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingJackPotAck)
            return object;
        let message = new $root.ClientRankingJackPotAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RankType != null)
            message.RankType = object.RankType >>> 0;
        if (object.Jackpot != null)
            if ($util.Long)
                (message.Jackpot = $util.Long.fromValue(object.Jackpot)).unsigned = true;
            else if (typeof object.Jackpot === "string")
                message.Jackpot = parseInt(object.Jackpot, 10);
            else if (typeof object.Jackpot === "number")
                message.Jackpot = object.Jackpot;
            else if (typeof object.Jackpot === "object")
                message.Jackpot = new $util.LongBits(object.Jackpot.low >>> 0, object.Jackpot.high >>> 0).toNumber(true);
        if (object.Begintime != null)
            if ($util.Long)
                (message.Begintime = $util.Long.fromValue(object.Begintime)).unsigned = true;
            else if (typeof object.Begintime === "string")
                message.Begintime = parseInt(object.Begintime, 10);
            else if (typeof object.Begintime === "number")
                message.Begintime = object.Begintime;
            else if (typeof object.Begintime === "object")
                message.Begintime = new $util.LongBits(object.Begintime.low >>> 0, object.Begintime.high >>> 0).toNumber(true);
        if (object.Endtime != null)
            if ($util.Long)
                (message.Endtime = $util.Long.fromValue(object.Endtime)).unsigned = true;
            else if (typeof object.Endtime === "string")
                message.Endtime = parseInt(object.Endtime, 10);
            else if (typeof object.Endtime === "number")
                message.Endtime = object.Endtime;
            else if (typeof object.Endtime === "object")
                message.Endtime = new $util.LongBits(object.Endtime.low >>> 0, object.Endtime.high >>> 0).toNumber(true);
        if (object.Nowtime != null)
            if ($util.Long)
                (message.Nowtime = $util.Long.fromValue(object.Nowtime)).unsigned = true;
            else if (typeof object.Nowtime === "string")
                message.Nowtime = parseInt(object.Nowtime, 10);
            else if (typeof object.Nowtime === "number")
                message.Nowtime = object.Nowtime;
            else if (typeof object.Nowtime === "object")
                message.Nowtime = new $util.LongBits(object.Nowtime.low >>> 0, object.Nowtime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingJackPotAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {ClientRankingJackPotAck} message ClientRankingJackPotAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingJackPotAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.RankType = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Jackpot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Jackpot = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Begintime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Begintime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Endtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Endtime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Nowtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Nowtime = options.longs === String ? "0" : 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RankType != null && message.hasOwnProperty("RankType"))
            object.RankType = message.RankType;
        if (message.Jackpot != null && message.hasOwnProperty("Jackpot"))
            if (typeof message.Jackpot === "number")
                object.Jackpot = options.longs === String ? String(message.Jackpot) : message.Jackpot;
            else
                object.Jackpot = options.longs === String ? $util.Long.prototype.toString.call(message.Jackpot) : options.longs === Number ? new $util.LongBits(message.Jackpot.low >>> 0, message.Jackpot.high >>> 0).toNumber(true) : message.Jackpot;
        if (message.Begintime != null && message.hasOwnProperty("Begintime"))
            if (typeof message.Begintime === "number")
                object.Begintime = options.longs === String ? String(message.Begintime) : message.Begintime;
            else
                object.Begintime = options.longs === String ? $util.Long.prototype.toString.call(message.Begintime) : options.longs === Number ? new $util.LongBits(message.Begintime.low >>> 0, message.Begintime.high >>> 0).toNumber(true) : message.Begintime;
        if (message.Endtime != null && message.hasOwnProperty("Endtime"))
            if (typeof message.Endtime === "number")
                object.Endtime = options.longs === String ? String(message.Endtime) : message.Endtime;
            else
                object.Endtime = options.longs === String ? $util.Long.prototype.toString.call(message.Endtime) : options.longs === Number ? new $util.LongBits(message.Endtime.low >>> 0, message.Endtime.high >>> 0).toNumber(true) : message.Endtime;
        if (message.Nowtime != null && message.hasOwnProperty("Nowtime"))
            if (typeof message.Nowtime === "number")
                object.Nowtime = options.longs === String ? String(message.Nowtime) : message.Nowtime;
            else
                object.Nowtime = options.longs === String ? $util.Long.prototype.toString.call(message.Nowtime) : options.longs === Number ? new $util.LongBits(message.Nowtime.low >>> 0, message.Nowtime.high >>> 0).toNumber(true) : message.Nowtime;
        return object;
    };

    /**
     * Converts this ClientRankingJackPotAck to JSON.
     * @function toJSON
     * @memberof ClientRankingJackPotAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingJackPotAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingJackPotAck
     * @function getTypeUrl
     * @memberof ClientRankingJackPotAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingJackPotAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingJackPotAck";
    };

    return ClientRankingJackPotAck;
})();

export const ClientRankingPrizeGoldReq = $root.ClientRankingPrizeGoldReq = (() => {

    /**
     * Properties of a ClientRankingPrizeGoldReq.
     * @exports IClientRankingPrizeGoldReq
     * @interface IClientRankingPrizeGoldReq
     * @property {number|null} [UserID] ClientRankingPrizeGoldReq UserID
     */

    /**
     * Constructs a new ClientRankingPrizeGoldReq.
     * @exports ClientRankingPrizeGoldReq
     * @classdesc Represents a ClientRankingPrizeGoldReq.
     * @implements IClientRankingPrizeGoldReq
     * @constructor
     * @param {IClientRankingPrizeGoldReq=} [properties] Properties to set
     */
    function ClientRankingPrizeGoldReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingPrizeGoldReq UserID.
     * @member {number} UserID
     * @memberof ClientRankingPrizeGoldReq
     * @instance
     */
    ClientRankingPrizeGoldReq.prototype.UserID = 0;

    /**
     * Creates a new ClientRankingPrizeGoldReq instance using the specified properties.
     * @function create
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {IClientRankingPrizeGoldReq=} [properties] Properties to set
     * @returns {ClientRankingPrizeGoldReq} ClientRankingPrizeGoldReq instance
     */
    ClientRankingPrizeGoldReq.create = function create(properties) {
        return new ClientRankingPrizeGoldReq(properties);
    };

    /**
     * Encodes the specified ClientRankingPrizeGoldReq message. Does not implicitly {@link ClientRankingPrizeGoldReq.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {IClientRankingPrizeGoldReq} message ClientRankingPrizeGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingPrizeGoldReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingPrizeGoldReq message, length delimited. Does not implicitly {@link ClientRankingPrizeGoldReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {IClientRankingPrizeGoldReq} message ClientRankingPrizeGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingPrizeGoldReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingPrizeGoldReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingPrizeGoldReq} ClientRankingPrizeGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingPrizeGoldReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingPrizeGoldReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingPrizeGoldReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingPrizeGoldReq} ClientRankingPrizeGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingPrizeGoldReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingPrizeGoldReq message.
     * @function verify
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingPrizeGoldReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientRankingPrizeGoldReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingPrizeGoldReq} ClientRankingPrizeGoldReq
     */
    ClientRankingPrizeGoldReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingPrizeGoldReq)
            return object;
        let message = new $root.ClientRankingPrizeGoldReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingPrizeGoldReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {ClientRankingPrizeGoldReq} message ClientRankingPrizeGoldReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingPrizeGoldReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientRankingPrizeGoldReq to JSON.
     * @function toJSON
     * @memberof ClientRankingPrizeGoldReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingPrizeGoldReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingPrizeGoldReq
     * @function getTypeUrl
     * @memberof ClientRankingPrizeGoldReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingPrizeGoldReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingPrizeGoldReq";
    };

    return ClientRankingPrizeGoldReq;
})();

export const ClientRankingPrizeGoldAck = $root.ClientRankingPrizeGoldAck = (() => {

    /**
     * Properties of a ClientRankingPrizeGoldAck.
     * @exports IClientRankingPrizeGoldAck
     * @interface IClientRankingPrizeGoldAck
     * @property {number|null} [UserID] ClientRankingPrizeGoldAck UserID
     * @property {number|Long|null} [PrizeDate] ClientRankingPrizeGoldAck PrizeDate
     * @property {number|null} [RankidDate] ClientRankingPrizeGoldAck RankidDate
     * @property {number|Long|null} [TbeginDate] ClientRankingPrizeGoldAck TbeginDate
     * @property {number|Long|null} [TendDate] ClientRankingPrizeGoldAck TendDate
     * @property {number|Long|null} [PrizeSunday] ClientRankingPrizeGoldAck PrizeSunday
     * @property {number|null} [RankidSunday] ClientRankingPrizeGoldAck RankidSunday
     * @property {number|Long|null} [TbeginSunday] ClientRankingPrizeGoldAck TbeginSunday
     * @property {number|Long|null} [TendSunday] ClientRankingPrizeGoldAck TendSunday
     */

    /**
     * Constructs a new ClientRankingPrizeGoldAck.
     * @exports ClientRankingPrizeGoldAck
     * @classdesc Represents a ClientRankingPrizeGoldAck.
     * @implements IClientRankingPrizeGoldAck
     * @constructor
     * @param {IClientRankingPrizeGoldAck=} [properties] Properties to set
     */
    function ClientRankingPrizeGoldAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingPrizeGoldAck UserID.
     * @member {number} UserID
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.UserID = 0;

    /**
     * ClientRankingPrizeGoldAck PrizeDate.
     * @member {number|Long} PrizeDate
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.PrizeDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingPrizeGoldAck RankidDate.
     * @member {number} RankidDate
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.RankidDate = 0;

    /**
     * ClientRankingPrizeGoldAck TbeginDate.
     * @member {number|Long} TbeginDate
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.TbeginDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingPrizeGoldAck TendDate.
     * @member {number|Long} TendDate
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.TendDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingPrizeGoldAck PrizeSunday.
     * @member {number|Long} PrizeSunday
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.PrizeSunday = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingPrizeGoldAck RankidSunday.
     * @member {number} RankidSunday
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.RankidSunday = 0;

    /**
     * ClientRankingPrizeGoldAck TbeginSunday.
     * @member {number|Long} TbeginSunday
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.TbeginSunday = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingPrizeGoldAck TendSunday.
     * @member {number|Long} TendSunday
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     */
    ClientRankingPrizeGoldAck.prototype.TendSunday = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientRankingPrizeGoldAck instance using the specified properties.
     * @function create
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {IClientRankingPrizeGoldAck=} [properties] Properties to set
     * @returns {ClientRankingPrizeGoldAck} ClientRankingPrizeGoldAck instance
     */
    ClientRankingPrizeGoldAck.create = function create(properties) {
        return new ClientRankingPrizeGoldAck(properties);
    };

    /**
     * Encodes the specified ClientRankingPrizeGoldAck message. Does not implicitly {@link ClientRankingPrizeGoldAck.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {IClientRankingPrizeGoldAck} message ClientRankingPrizeGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingPrizeGoldAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PrizeDate != null && Object.hasOwnProperty.call(message, "PrizeDate"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.PrizeDate);
        if (message.RankidDate != null && Object.hasOwnProperty.call(message, "RankidDate"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.RankidDate);
        if (message.TbeginDate != null && Object.hasOwnProperty.call(message, "TbeginDate"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.TbeginDate);
        if (message.TendDate != null && Object.hasOwnProperty.call(message, "TendDate"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.TendDate);
        if (message.PrizeSunday != null && Object.hasOwnProperty.call(message, "PrizeSunday"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.PrizeSunday);
        if (message.RankidSunday != null && Object.hasOwnProperty.call(message, "RankidSunday"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.RankidSunday);
        if (message.TbeginSunday != null && Object.hasOwnProperty.call(message, "TbeginSunday"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.TbeginSunday);
        if (message.TendSunday != null && Object.hasOwnProperty.call(message, "TendSunday"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.TendSunday);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingPrizeGoldAck message, length delimited. Does not implicitly {@link ClientRankingPrizeGoldAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {IClientRankingPrizeGoldAck} message ClientRankingPrizeGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingPrizeGoldAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingPrizeGoldAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingPrizeGoldAck} ClientRankingPrizeGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingPrizeGoldAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingPrizeGoldAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.PrizeDate = reader.uint64();
                    break;
                }
            case 3: {
                    message.RankidDate = reader.uint32();
                    break;
                }
            case 4: {
                    message.TbeginDate = reader.uint64();
                    break;
                }
            case 5: {
                    message.TendDate = reader.uint64();
                    break;
                }
            case 6: {
                    message.PrizeSunday = reader.uint64();
                    break;
                }
            case 7: {
                    message.RankidSunday = reader.uint32();
                    break;
                }
            case 8: {
                    message.TbeginSunday = reader.uint64();
                    break;
                }
            case 9: {
                    message.TendSunday = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingPrizeGoldAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingPrizeGoldAck} ClientRankingPrizeGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingPrizeGoldAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingPrizeGoldAck message.
     * @function verify
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingPrizeGoldAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PrizeDate != null && message.hasOwnProperty("PrizeDate"))
            if (!$util.isInteger(message.PrizeDate) && !(message.PrizeDate && $util.isInteger(message.PrizeDate.low) && $util.isInteger(message.PrizeDate.high)))
                return "PrizeDate: integer|Long expected";
        if (message.RankidDate != null && message.hasOwnProperty("RankidDate"))
            if (!$util.isInteger(message.RankidDate))
                return "RankidDate: integer expected";
        if (message.TbeginDate != null && message.hasOwnProperty("TbeginDate"))
            if (!$util.isInteger(message.TbeginDate) && !(message.TbeginDate && $util.isInteger(message.TbeginDate.low) && $util.isInteger(message.TbeginDate.high)))
                return "TbeginDate: integer|Long expected";
        if (message.TendDate != null && message.hasOwnProperty("TendDate"))
            if (!$util.isInteger(message.TendDate) && !(message.TendDate && $util.isInteger(message.TendDate.low) && $util.isInteger(message.TendDate.high)))
                return "TendDate: integer|Long expected";
        if (message.PrizeSunday != null && message.hasOwnProperty("PrizeSunday"))
            if (!$util.isInteger(message.PrizeSunday) && !(message.PrizeSunday && $util.isInteger(message.PrizeSunday.low) && $util.isInteger(message.PrizeSunday.high)))
                return "PrizeSunday: integer|Long expected";
        if (message.RankidSunday != null && message.hasOwnProperty("RankidSunday"))
            if (!$util.isInteger(message.RankidSunday))
                return "RankidSunday: integer expected";
        if (message.TbeginSunday != null && message.hasOwnProperty("TbeginSunday"))
            if (!$util.isInteger(message.TbeginSunday) && !(message.TbeginSunday && $util.isInteger(message.TbeginSunday.low) && $util.isInteger(message.TbeginSunday.high)))
                return "TbeginSunday: integer|Long expected";
        if (message.TendSunday != null && message.hasOwnProperty("TendSunday"))
            if (!$util.isInteger(message.TendSunday) && !(message.TendSunday && $util.isInteger(message.TendSunday.low) && $util.isInteger(message.TendSunday.high)))
                return "TendSunday: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientRankingPrizeGoldAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingPrizeGoldAck} ClientRankingPrizeGoldAck
     */
    ClientRankingPrizeGoldAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingPrizeGoldAck)
            return object;
        let message = new $root.ClientRankingPrizeGoldAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PrizeDate != null)
            if ($util.Long)
                (message.PrizeDate = $util.Long.fromValue(object.PrizeDate)).unsigned = true;
            else if (typeof object.PrizeDate === "string")
                message.PrizeDate = parseInt(object.PrizeDate, 10);
            else if (typeof object.PrizeDate === "number")
                message.PrizeDate = object.PrizeDate;
            else if (typeof object.PrizeDate === "object")
                message.PrizeDate = new $util.LongBits(object.PrizeDate.low >>> 0, object.PrizeDate.high >>> 0).toNumber(true);
        if (object.RankidDate != null)
            message.RankidDate = object.RankidDate >>> 0;
        if (object.TbeginDate != null)
            if ($util.Long)
                (message.TbeginDate = $util.Long.fromValue(object.TbeginDate)).unsigned = true;
            else if (typeof object.TbeginDate === "string")
                message.TbeginDate = parseInt(object.TbeginDate, 10);
            else if (typeof object.TbeginDate === "number")
                message.TbeginDate = object.TbeginDate;
            else if (typeof object.TbeginDate === "object")
                message.TbeginDate = new $util.LongBits(object.TbeginDate.low >>> 0, object.TbeginDate.high >>> 0).toNumber(true);
        if (object.TendDate != null)
            if ($util.Long)
                (message.TendDate = $util.Long.fromValue(object.TendDate)).unsigned = true;
            else if (typeof object.TendDate === "string")
                message.TendDate = parseInt(object.TendDate, 10);
            else if (typeof object.TendDate === "number")
                message.TendDate = object.TendDate;
            else if (typeof object.TendDate === "object")
                message.TendDate = new $util.LongBits(object.TendDate.low >>> 0, object.TendDate.high >>> 0).toNumber(true);
        if (object.PrizeSunday != null)
            if ($util.Long)
                (message.PrizeSunday = $util.Long.fromValue(object.PrizeSunday)).unsigned = true;
            else if (typeof object.PrizeSunday === "string")
                message.PrizeSunday = parseInt(object.PrizeSunday, 10);
            else if (typeof object.PrizeSunday === "number")
                message.PrizeSunday = object.PrizeSunday;
            else if (typeof object.PrizeSunday === "object")
                message.PrizeSunday = new $util.LongBits(object.PrizeSunday.low >>> 0, object.PrizeSunday.high >>> 0).toNumber(true);
        if (object.RankidSunday != null)
            message.RankidSunday = object.RankidSunday >>> 0;
        if (object.TbeginSunday != null)
            if ($util.Long)
                (message.TbeginSunday = $util.Long.fromValue(object.TbeginSunday)).unsigned = true;
            else if (typeof object.TbeginSunday === "string")
                message.TbeginSunday = parseInt(object.TbeginSunday, 10);
            else if (typeof object.TbeginSunday === "number")
                message.TbeginSunday = object.TbeginSunday;
            else if (typeof object.TbeginSunday === "object")
                message.TbeginSunday = new $util.LongBits(object.TbeginSunday.low >>> 0, object.TbeginSunday.high >>> 0).toNumber(true);
        if (object.TendSunday != null)
            if ($util.Long)
                (message.TendSunday = $util.Long.fromValue(object.TendSunday)).unsigned = true;
            else if (typeof object.TendSunday === "string")
                message.TendSunday = parseInt(object.TendSunday, 10);
            else if (typeof object.TendSunday === "number")
                message.TendSunday = object.TendSunday;
            else if (typeof object.TendSunday === "object")
                message.TendSunday = new $util.LongBits(object.TendSunday.low >>> 0, object.TendSunday.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingPrizeGoldAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {ClientRankingPrizeGoldAck} message ClientRankingPrizeGoldAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingPrizeGoldAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeDate = options.longs === String ? "0" : 0;
            object.RankidDate = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TbeginDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TbeginDate = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TendDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TendDate = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeSunday = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeSunday = options.longs === String ? "0" : 0;
            object.RankidSunday = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TbeginSunday = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TbeginSunday = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.TendSunday = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TendSunday = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PrizeDate != null && message.hasOwnProperty("PrizeDate"))
            if (typeof message.PrizeDate === "number")
                object.PrizeDate = options.longs === String ? String(message.PrizeDate) : message.PrizeDate;
            else
                object.PrizeDate = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeDate) : options.longs === Number ? new $util.LongBits(message.PrizeDate.low >>> 0, message.PrizeDate.high >>> 0).toNumber(true) : message.PrizeDate;
        if (message.RankidDate != null && message.hasOwnProperty("RankidDate"))
            object.RankidDate = message.RankidDate;
        if (message.TbeginDate != null && message.hasOwnProperty("TbeginDate"))
            if (typeof message.TbeginDate === "number")
                object.TbeginDate = options.longs === String ? String(message.TbeginDate) : message.TbeginDate;
            else
                object.TbeginDate = options.longs === String ? $util.Long.prototype.toString.call(message.TbeginDate) : options.longs === Number ? new $util.LongBits(message.TbeginDate.low >>> 0, message.TbeginDate.high >>> 0).toNumber(true) : message.TbeginDate;
        if (message.TendDate != null && message.hasOwnProperty("TendDate"))
            if (typeof message.TendDate === "number")
                object.TendDate = options.longs === String ? String(message.TendDate) : message.TendDate;
            else
                object.TendDate = options.longs === String ? $util.Long.prototype.toString.call(message.TendDate) : options.longs === Number ? new $util.LongBits(message.TendDate.low >>> 0, message.TendDate.high >>> 0).toNumber(true) : message.TendDate;
        if (message.PrizeSunday != null && message.hasOwnProperty("PrizeSunday"))
            if (typeof message.PrizeSunday === "number")
                object.PrizeSunday = options.longs === String ? String(message.PrizeSunday) : message.PrizeSunday;
            else
                object.PrizeSunday = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeSunday) : options.longs === Number ? new $util.LongBits(message.PrizeSunday.low >>> 0, message.PrizeSunday.high >>> 0).toNumber(true) : message.PrizeSunday;
        if (message.RankidSunday != null && message.hasOwnProperty("RankidSunday"))
            object.RankidSunday = message.RankidSunday;
        if (message.TbeginSunday != null && message.hasOwnProperty("TbeginSunday"))
            if (typeof message.TbeginSunday === "number")
                object.TbeginSunday = options.longs === String ? String(message.TbeginSunday) : message.TbeginSunday;
            else
                object.TbeginSunday = options.longs === String ? $util.Long.prototype.toString.call(message.TbeginSunday) : options.longs === Number ? new $util.LongBits(message.TbeginSunday.low >>> 0, message.TbeginSunday.high >>> 0).toNumber(true) : message.TbeginSunday;
        if (message.TendSunday != null && message.hasOwnProperty("TendSunday"))
            if (typeof message.TendSunday === "number")
                object.TendSunday = options.longs === String ? String(message.TendSunday) : message.TendSunday;
            else
                object.TendSunday = options.longs === String ? $util.Long.prototype.toString.call(message.TendSunday) : options.longs === Number ? new $util.LongBits(message.TendSunday.low >>> 0, message.TendSunday.high >>> 0).toNumber(true) : message.TendSunday;
        return object;
    };

    /**
     * Converts this ClientRankingPrizeGoldAck to JSON.
     * @function toJSON
     * @memberof ClientRankingPrizeGoldAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingPrizeGoldAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingPrizeGoldAck
     * @function getTypeUrl
     * @memberof ClientRankingPrizeGoldAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingPrizeGoldAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingPrizeGoldAck";
    };

    return ClientRankingPrizeGoldAck;
})();

export const ClientRankingGetPrizeReq = $root.ClientRankingGetPrizeReq = (() => {

    /**
     * Properties of a ClientRankingGetPrizeReq.
     * @exports IClientRankingGetPrizeReq
     * @interface IClientRankingGetPrizeReq
     * @property {number|null} [UserID] ClientRankingGetPrizeReq UserID
     * @property {number|null} [ChannelID] ClientRankingGetPrizeReq ChannelID
     * @property {number|Long|null} [PrizeGold] ClientRankingGetPrizeReq PrizeGold
     * @property {number|Long|null} [Tbegin] ClientRankingGetPrizeReq Tbegin
     * @property {number|Long|null} [Tend] ClientRankingGetPrizeReq Tend
     */

    /**
     * Constructs a new ClientRankingGetPrizeReq.
     * @exports ClientRankingGetPrizeReq
     * @classdesc Represents a ClientRankingGetPrizeReq.
     * @implements IClientRankingGetPrizeReq
     * @constructor
     * @param {IClientRankingGetPrizeReq=} [properties] Properties to set
     */
    function ClientRankingGetPrizeReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingGetPrizeReq UserID.
     * @member {number} UserID
     * @memberof ClientRankingGetPrizeReq
     * @instance
     */
    ClientRankingGetPrizeReq.prototype.UserID = 0;

    /**
     * ClientRankingGetPrizeReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientRankingGetPrizeReq
     * @instance
     */
    ClientRankingGetPrizeReq.prototype.ChannelID = 0;

    /**
     * ClientRankingGetPrizeReq PrizeGold.
     * @member {number|Long} PrizeGold
     * @memberof ClientRankingGetPrizeReq
     * @instance
     */
    ClientRankingGetPrizeReq.prototype.PrizeGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingGetPrizeReq Tbegin.
     * @member {number|Long} Tbegin
     * @memberof ClientRankingGetPrizeReq
     * @instance
     */
    ClientRankingGetPrizeReq.prototype.Tbegin = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientRankingGetPrizeReq Tend.
     * @member {number|Long} Tend
     * @memberof ClientRankingGetPrizeReq
     * @instance
     */
    ClientRankingGetPrizeReq.prototype.Tend = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientRankingGetPrizeReq instance using the specified properties.
     * @function create
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {IClientRankingGetPrizeReq=} [properties] Properties to set
     * @returns {ClientRankingGetPrizeReq} ClientRankingGetPrizeReq instance
     */
    ClientRankingGetPrizeReq.create = function create(properties) {
        return new ClientRankingGetPrizeReq(properties);
    };

    /**
     * Encodes the specified ClientRankingGetPrizeReq message. Does not implicitly {@link ClientRankingGetPrizeReq.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {IClientRankingGetPrizeReq} message ClientRankingGetPrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingGetPrizeReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.PrizeGold != null && Object.hasOwnProperty.call(message, "PrizeGold"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.PrizeGold);
        if (message.Tbegin != null && Object.hasOwnProperty.call(message, "Tbegin"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Tbegin);
        if (message.Tend != null && Object.hasOwnProperty.call(message, "Tend"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Tend);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingGetPrizeReq message, length delimited. Does not implicitly {@link ClientRankingGetPrizeReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {IClientRankingGetPrizeReq} message ClientRankingGetPrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingGetPrizeReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingGetPrizeReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingGetPrizeReq} ClientRankingGetPrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingGetPrizeReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingGetPrizeReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.PrizeGold = reader.uint64();
                    break;
                }
            case 4: {
                    message.Tbegin = reader.uint64();
                    break;
                }
            case 5: {
                    message.Tend = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingGetPrizeReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingGetPrizeReq} ClientRankingGetPrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingGetPrizeReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingGetPrizeReq message.
     * @function verify
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingGetPrizeReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (!$util.isInteger(message.PrizeGold) && !(message.PrizeGold && $util.isInteger(message.PrizeGold.low) && $util.isInteger(message.PrizeGold.high)))
                return "PrizeGold: integer|Long expected";
        if (message.Tbegin != null && message.hasOwnProperty("Tbegin"))
            if (!$util.isInteger(message.Tbegin) && !(message.Tbegin && $util.isInteger(message.Tbegin.low) && $util.isInteger(message.Tbegin.high)))
                return "Tbegin: integer|Long expected";
        if (message.Tend != null && message.hasOwnProperty("Tend"))
            if (!$util.isInteger(message.Tend) && !(message.Tend && $util.isInteger(message.Tend.low) && $util.isInteger(message.Tend.high)))
                return "Tend: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientRankingGetPrizeReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingGetPrizeReq} ClientRankingGetPrizeReq
     */
    ClientRankingGetPrizeReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingGetPrizeReq)
            return object;
        let message = new $root.ClientRankingGetPrizeReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.PrizeGold != null)
            if ($util.Long)
                (message.PrizeGold = $util.Long.fromValue(object.PrizeGold)).unsigned = true;
            else if (typeof object.PrizeGold === "string")
                message.PrizeGold = parseInt(object.PrizeGold, 10);
            else if (typeof object.PrizeGold === "number")
                message.PrizeGold = object.PrizeGold;
            else if (typeof object.PrizeGold === "object")
                message.PrizeGold = new $util.LongBits(object.PrizeGold.low >>> 0, object.PrizeGold.high >>> 0).toNumber(true);
        if (object.Tbegin != null)
            if ($util.Long)
                (message.Tbegin = $util.Long.fromValue(object.Tbegin)).unsigned = true;
            else if (typeof object.Tbegin === "string")
                message.Tbegin = parseInt(object.Tbegin, 10);
            else if (typeof object.Tbegin === "number")
                message.Tbegin = object.Tbegin;
            else if (typeof object.Tbegin === "object")
                message.Tbegin = new $util.LongBits(object.Tbegin.low >>> 0, object.Tbegin.high >>> 0).toNumber(true);
        if (object.Tend != null)
            if ($util.Long)
                (message.Tend = $util.Long.fromValue(object.Tend)).unsigned = true;
            else if (typeof object.Tend === "string")
                message.Tend = parseInt(object.Tend, 10);
            else if (typeof object.Tend === "number")
                message.Tend = object.Tend;
            else if (typeof object.Tend === "object")
                message.Tend = new $util.LongBits(object.Tend.low >>> 0, object.Tend.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingGetPrizeReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {ClientRankingGetPrizeReq} message ClientRankingGetPrizeReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingGetPrizeReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Tbegin = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Tbegin = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Tend = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Tend = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (typeof message.PrizeGold === "number")
                object.PrizeGold = options.longs === String ? String(message.PrizeGold) : message.PrizeGold;
            else
                object.PrizeGold = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeGold) : options.longs === Number ? new $util.LongBits(message.PrizeGold.low >>> 0, message.PrizeGold.high >>> 0).toNumber(true) : message.PrizeGold;
        if (message.Tbegin != null && message.hasOwnProperty("Tbegin"))
            if (typeof message.Tbegin === "number")
                object.Tbegin = options.longs === String ? String(message.Tbegin) : message.Tbegin;
            else
                object.Tbegin = options.longs === String ? $util.Long.prototype.toString.call(message.Tbegin) : options.longs === Number ? new $util.LongBits(message.Tbegin.low >>> 0, message.Tbegin.high >>> 0).toNumber(true) : message.Tbegin;
        if (message.Tend != null && message.hasOwnProperty("Tend"))
            if (typeof message.Tend === "number")
                object.Tend = options.longs === String ? String(message.Tend) : message.Tend;
            else
                object.Tend = options.longs === String ? $util.Long.prototype.toString.call(message.Tend) : options.longs === Number ? new $util.LongBits(message.Tend.low >>> 0, message.Tend.high >>> 0).toNumber(true) : message.Tend;
        return object;
    };

    /**
     * Converts this ClientRankingGetPrizeReq to JSON.
     * @function toJSON
     * @memberof ClientRankingGetPrizeReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingGetPrizeReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingGetPrizeReq
     * @function getTypeUrl
     * @memberof ClientRankingGetPrizeReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingGetPrizeReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingGetPrizeReq";
    };

    return ClientRankingGetPrizeReq;
})();

export const ClientRankingGetPrizeAck = $root.ClientRankingGetPrizeAck = (() => {

    /**
     * Properties of a ClientRankingGetPrizeAck.
     * @exports IClientRankingGetPrizeAck
     * @interface IClientRankingGetPrizeAck
     * @property {number|null} [Ret] ClientRankingGetPrizeAck Ret
     * @property {number|null} [UserID] ClientRankingGetPrizeAck UserID
     */

    /**
     * Constructs a new ClientRankingGetPrizeAck.
     * @exports ClientRankingGetPrizeAck
     * @classdesc Represents a ClientRankingGetPrizeAck.
     * @implements IClientRankingGetPrizeAck
     * @constructor
     * @param {IClientRankingGetPrizeAck=} [properties] Properties to set
     */
    function ClientRankingGetPrizeAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRankingGetPrizeAck Ret.
     * @member {number} Ret
     * @memberof ClientRankingGetPrizeAck
     * @instance
     */
    ClientRankingGetPrizeAck.prototype.Ret = 0;

    /**
     * ClientRankingGetPrizeAck UserID.
     * @member {number} UserID
     * @memberof ClientRankingGetPrizeAck
     * @instance
     */
    ClientRankingGetPrizeAck.prototype.UserID = 0;

    /**
     * Creates a new ClientRankingGetPrizeAck instance using the specified properties.
     * @function create
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {IClientRankingGetPrizeAck=} [properties] Properties to set
     * @returns {ClientRankingGetPrizeAck} ClientRankingGetPrizeAck instance
     */
    ClientRankingGetPrizeAck.create = function create(properties) {
        return new ClientRankingGetPrizeAck(properties);
    };

    /**
     * Encodes the specified ClientRankingGetPrizeAck message. Does not implicitly {@link ClientRankingGetPrizeAck.verify|verify} messages.
     * @function encode
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {IClientRankingGetPrizeAck} message ClientRankingGetPrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingGetPrizeAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientRankingGetPrizeAck message, length delimited. Does not implicitly {@link ClientRankingGetPrizeAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {IClientRankingGetPrizeAck} message ClientRankingGetPrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRankingGetPrizeAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRankingGetPrizeAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRankingGetPrizeAck} ClientRankingGetPrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingGetPrizeAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRankingGetPrizeAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRankingGetPrizeAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRankingGetPrizeAck} ClientRankingGetPrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRankingGetPrizeAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRankingGetPrizeAck message.
     * @function verify
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRankingGetPrizeAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientRankingGetPrizeAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRankingGetPrizeAck} ClientRankingGetPrizeAck
     */
    ClientRankingGetPrizeAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRankingGetPrizeAck)
            return object;
        let message = new $root.ClientRankingGetPrizeAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientRankingGetPrizeAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {ClientRankingGetPrizeAck} message ClientRankingGetPrizeAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRankingGetPrizeAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientRankingGetPrizeAck to JSON.
     * @function toJSON
     * @memberof ClientRankingGetPrizeAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRankingGetPrizeAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRankingGetPrizeAck
     * @function getTypeUrl
     * @memberof ClientRankingGetPrizeAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRankingGetPrizeAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRankingGetPrizeAck";
    };

    return ClientRankingGetPrizeAck;
})();

export const ClientCP2dBetReq = $root.ClientCP2dBetReq = (() => {

    /**
     * Properties of a ClientCP2dBetReq.
     * @exports IClientCP2dBetReq
     * @interface IClientCP2dBetReq
     * @property {number|null} [UserID] ClientCP2dBetReq UserID
     * @property {number|null} [ChannelID] ClientCP2dBetReq ChannelID
     * @property {string|null} [strName] ClientCP2dBetReq strName
     * @property {string|null} [strAvatar] ClientCP2dBetReq strAvatar
     * @property {number|null} [BetDate] ClientCP2dBetReq BetDate
     * @property {number|null} [TimeID] ClientCP2dBetReq TimeID
     * @property {string|null} [HistoryId] ClientCP2dBetReq HistoryId
     * @property {string|null} [StockDate] ClientCP2dBetReq StockDate
     * @property {string|null} [StockDatetime] ClientCP2dBetReq StockDatetime
     * @property {Array.<ICP2dBetData>|null} [CP2d] ClientCP2dBetReq CP2d
     * @property {number|Long|null} [UserAllBetGold] ClientCP2dBetReq UserAllBetGold
     */

    /**
     * Constructs a new ClientCP2dBetReq.
     * @exports ClientCP2dBetReq
     * @classdesc Represents a ClientCP2dBetReq.
     * @implements IClientCP2dBetReq
     * @constructor
     * @param {IClientCP2dBetReq=} [properties] Properties to set
     */
    function ClientCP2dBetReq(properties) {
        this.CP2d = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP2dBetReq UserID.
     * @member {number} UserID
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.UserID = 0;

    /**
     * ClientCP2dBetReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.ChannelID = 0;

    /**
     * ClientCP2dBetReq strName.
     * @member {string} strName
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.strName = "";

    /**
     * ClientCP2dBetReq strAvatar.
     * @member {string} strAvatar
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.strAvatar = "";

    /**
     * ClientCP2dBetReq BetDate.
     * @member {number} BetDate
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.BetDate = 0;

    /**
     * ClientCP2dBetReq TimeID.
     * @member {number} TimeID
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.TimeID = 0;

    /**
     * ClientCP2dBetReq HistoryId.
     * @member {string} HistoryId
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.HistoryId = "";

    /**
     * ClientCP2dBetReq StockDate.
     * @member {string} StockDate
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.StockDate = "";

    /**
     * ClientCP2dBetReq StockDatetime.
     * @member {string} StockDatetime
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.StockDatetime = "";

    /**
     * ClientCP2dBetReq CP2d.
     * @member {Array.<ICP2dBetData>} CP2d
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.CP2d = $util.emptyArray;

    /**
     * ClientCP2dBetReq UserAllBetGold.
     * @member {number|Long} UserAllBetGold
     * @memberof ClientCP2dBetReq
     * @instance
     */
    ClientCP2dBetReq.prototype.UserAllBetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientCP2dBetReq instance using the specified properties.
     * @function create
     * @memberof ClientCP2dBetReq
     * @static
     * @param {IClientCP2dBetReq=} [properties] Properties to set
     * @returns {ClientCP2dBetReq} ClientCP2dBetReq instance
     */
    ClientCP2dBetReq.create = function create(properties) {
        return new ClientCP2dBetReq(properties);
    };

    /**
     * Encodes the specified ClientCP2dBetReq message. Does not implicitly {@link ClientCP2dBetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientCP2dBetReq
     * @static
     * @param {IClientCP2dBetReq} message ClientCP2dBetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dBetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.strName != null && Object.hasOwnProperty.call(message, "strName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strName);
        if (message.strAvatar != null && Object.hasOwnProperty.call(message, "strAvatar"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.strAvatar);
        if (message.BetDate != null && Object.hasOwnProperty.call(message, "BetDate"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BetDate);
        if (message.TimeID != null && Object.hasOwnProperty.call(message, "TimeID"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.TimeID);
        if (message.HistoryId != null && Object.hasOwnProperty.call(message, "HistoryId"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.HistoryId);
        if (message.StockDate != null && Object.hasOwnProperty.call(message, "StockDate"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.StockDate);
        if (message.StockDatetime != null && Object.hasOwnProperty.call(message, "StockDatetime"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.StockDatetime);
        if (message.CP2d != null && message.CP2d.length)
            for (let i = 0; i < message.CP2d.length; ++i)
                $root.CP2dBetData.encode(message.CP2d[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.UserAllBetGold != null && Object.hasOwnProperty.call(message, "UserAllBetGold"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.UserAllBetGold);
        return writer;
    };

    /**
     * Encodes the specified ClientCP2dBetReq message, length delimited. Does not implicitly {@link ClientCP2dBetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP2dBetReq
     * @static
     * @param {IClientCP2dBetReq} message ClientCP2dBetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dBetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP2dBetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP2dBetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP2dBetReq} ClientCP2dBetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dBetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP2dBetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.strName = reader.string();
                    break;
                }
            case 4: {
                    message.strAvatar = reader.string();
                    break;
                }
            case 5: {
                    message.BetDate = reader.uint32();
                    break;
                }
            case 6: {
                    message.TimeID = reader.uint32();
                    break;
                }
            case 7: {
                    message.HistoryId = reader.string();
                    break;
                }
            case 8: {
                    message.StockDate = reader.string();
                    break;
                }
            case 9: {
                    message.StockDatetime = reader.string();
                    break;
                }
            case 10: {
                    if (!(message.CP2d && message.CP2d.length))
                        message.CP2d = [];
                    message.CP2d.push($root.CP2dBetData.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    message.UserAllBetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP2dBetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP2dBetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP2dBetReq} ClientCP2dBetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dBetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP2dBetReq message.
     * @function verify
     * @memberof ClientCP2dBetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP2dBetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.strName != null && message.hasOwnProperty("strName"))
            if (!$util.isString(message.strName))
                return "strName: string expected";
        if (message.strAvatar != null && message.hasOwnProperty("strAvatar"))
            if (!$util.isString(message.strAvatar))
                return "strAvatar: string expected";
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            if (!$util.isInteger(message.BetDate))
                return "BetDate: integer expected";
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            if (!$util.isInteger(message.TimeID))
                return "TimeID: integer expected";
        if (message.HistoryId != null && message.hasOwnProperty("HistoryId"))
            if (!$util.isString(message.HistoryId))
                return "HistoryId: string expected";
        if (message.StockDate != null && message.hasOwnProperty("StockDate"))
            if (!$util.isString(message.StockDate))
                return "StockDate: string expected";
        if (message.StockDatetime != null && message.hasOwnProperty("StockDatetime"))
            if (!$util.isString(message.StockDatetime))
                return "StockDatetime: string expected";
        if (message.CP2d != null && message.hasOwnProperty("CP2d")) {
            if (!Array.isArray(message.CP2d))
                return "CP2d: array expected";
            for (let i = 0; i < message.CP2d.length; ++i) {
                let error = $root.CP2dBetData.verify(message.CP2d[i]);
                if (error)
                    return "CP2d." + error;
            }
        }
        if (message.UserAllBetGold != null && message.hasOwnProperty("UserAllBetGold"))
            if (!$util.isInteger(message.UserAllBetGold) && !(message.UserAllBetGold && $util.isInteger(message.UserAllBetGold.low) && $util.isInteger(message.UserAllBetGold.high)))
                return "UserAllBetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientCP2dBetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP2dBetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP2dBetReq} ClientCP2dBetReq
     */
    ClientCP2dBetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP2dBetReq)
            return object;
        let message = new $root.ClientCP2dBetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.strName != null)
            message.strName = String(object.strName);
        if (object.strAvatar != null)
            message.strAvatar = String(object.strAvatar);
        if (object.BetDate != null)
            message.BetDate = object.BetDate >>> 0;
        if (object.TimeID != null)
            message.TimeID = object.TimeID >>> 0;
        if (object.HistoryId != null)
            message.HistoryId = String(object.HistoryId);
        if (object.StockDate != null)
            message.StockDate = String(object.StockDate);
        if (object.StockDatetime != null)
            message.StockDatetime = String(object.StockDatetime);
        if (object.CP2d) {
            if (!Array.isArray(object.CP2d))
                throw TypeError(".ClientCP2dBetReq.CP2d: array expected");
            message.CP2d = [];
            for (let i = 0; i < object.CP2d.length; ++i) {
                if (typeof object.CP2d[i] !== "object")
                    throw TypeError(".ClientCP2dBetReq.CP2d: object expected");
                message.CP2d[i] = $root.CP2dBetData.fromObject(object.CP2d[i]);
            }
        }
        if (object.UserAllBetGold != null)
            if ($util.Long)
                (message.UserAllBetGold = $util.Long.fromValue(object.UserAllBetGold)).unsigned = true;
            else if (typeof object.UserAllBetGold === "string")
                message.UserAllBetGold = parseInt(object.UserAllBetGold, 10);
            else if (typeof object.UserAllBetGold === "number")
                message.UserAllBetGold = object.UserAllBetGold;
            else if (typeof object.UserAllBetGold === "object")
                message.UserAllBetGold = new $util.LongBits(object.UserAllBetGold.low >>> 0, object.UserAllBetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientCP2dBetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP2dBetReq
     * @static
     * @param {ClientCP2dBetReq} message ClientCP2dBetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP2dBetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.CP2d = [];
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.strName = "";
            object.strAvatar = "";
            object.BetDate = 0;
            object.TimeID = 0;
            object.HistoryId = "";
            object.StockDate = "";
            object.StockDatetime = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.UserAllBetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.UserAllBetGold = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.strName != null && message.hasOwnProperty("strName"))
            object.strName = message.strName;
        if (message.strAvatar != null && message.hasOwnProperty("strAvatar"))
            object.strAvatar = message.strAvatar;
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            object.BetDate = message.BetDate;
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            object.TimeID = message.TimeID;
        if (message.HistoryId != null && message.hasOwnProperty("HistoryId"))
            object.HistoryId = message.HistoryId;
        if (message.StockDate != null && message.hasOwnProperty("StockDate"))
            object.StockDate = message.StockDate;
        if (message.StockDatetime != null && message.hasOwnProperty("StockDatetime"))
            object.StockDatetime = message.StockDatetime;
        if (message.CP2d && message.CP2d.length) {
            object.CP2d = [];
            for (let j = 0; j < message.CP2d.length; ++j)
                object.CP2d[j] = $root.CP2dBetData.toObject(message.CP2d[j], options);
        }
        if (message.UserAllBetGold != null && message.hasOwnProperty("UserAllBetGold"))
            if (typeof message.UserAllBetGold === "number")
                object.UserAllBetGold = options.longs === String ? String(message.UserAllBetGold) : message.UserAllBetGold;
            else
                object.UserAllBetGold = options.longs === String ? $util.Long.prototype.toString.call(message.UserAllBetGold) : options.longs === Number ? new $util.LongBits(message.UserAllBetGold.low >>> 0, message.UserAllBetGold.high >>> 0).toNumber(true) : message.UserAllBetGold;
        return object;
    };

    /**
     * Converts this ClientCP2dBetReq to JSON.
     * @function toJSON
     * @memberof ClientCP2dBetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP2dBetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP2dBetReq
     * @function getTypeUrl
     * @memberof ClientCP2dBetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP2dBetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP2dBetReq";
    };

    return ClientCP2dBetReq;
})();

export const ClientCP2dBetAck = $root.ClientCP2dBetAck = (() => {

    /**
     * Properties of a ClientCP2dBetAck.
     * @exports IClientCP2dBetAck
     * @interface IClientCP2dBetAck
     * @property {number|null} [Ret] ClientCP2dBetAck Ret
     * @property {number|null} [UserID] ClientCP2dBetAck UserID
     * @property {Array.<number>|null} [BetNum] ClientCP2dBetAck BetNum
     * @property {string|null} [UserGold] ClientCP2dBetAck UserGold
     * @property {string|null} [UserDeposit] ClientCP2dBetAck UserDeposit
     * @property {string|null} [UserWithdraw] ClientCP2dBetAck UserWithdraw
     * @property {string|null} [UserBonus] ClientCP2dBetAck UserBonus
     */

    /**
     * Constructs a new ClientCP2dBetAck.
     * @exports ClientCP2dBetAck
     * @classdesc Represents a ClientCP2dBetAck.
     * @implements IClientCP2dBetAck
     * @constructor
     * @param {IClientCP2dBetAck=} [properties] Properties to set
     */
    function ClientCP2dBetAck(properties) {
        this.BetNum = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP2dBetAck Ret.
     * @member {number} Ret
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.Ret = 0;

    /**
     * ClientCP2dBetAck UserID.
     * @member {number} UserID
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.UserID = 0;

    /**
     * ClientCP2dBetAck BetNum.
     * @member {Array.<number>} BetNum
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.BetNum = $util.emptyArray;

    /**
     * ClientCP2dBetAck UserGold.
     * @member {string} UserGold
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.UserGold = "";

    /**
     * ClientCP2dBetAck UserDeposit.
     * @member {string} UserDeposit
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.UserDeposit = "";

    /**
     * ClientCP2dBetAck UserWithdraw.
     * @member {string} UserWithdraw
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.UserWithdraw = "";

    /**
     * ClientCP2dBetAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientCP2dBetAck
     * @instance
     */
    ClientCP2dBetAck.prototype.UserBonus = "";

    /**
     * Creates a new ClientCP2dBetAck instance using the specified properties.
     * @function create
     * @memberof ClientCP2dBetAck
     * @static
     * @param {IClientCP2dBetAck=} [properties] Properties to set
     * @returns {ClientCP2dBetAck} ClientCP2dBetAck instance
     */
    ClientCP2dBetAck.create = function create(properties) {
        return new ClientCP2dBetAck(properties);
    };

    /**
     * Encodes the specified ClientCP2dBetAck message. Does not implicitly {@link ClientCP2dBetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientCP2dBetAck
     * @static
     * @param {IClientCP2dBetAck} message ClientCP2dBetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dBetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.BetNum != null && message.BetNum.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.BetNum.length; ++i)
                writer.uint32(message.BetNum[i]);
            writer.ldelim();
        }
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.UserGold);
        if (message.UserDeposit != null && Object.hasOwnProperty.call(message, "UserDeposit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.UserDeposit);
        if (message.UserWithdraw != null && Object.hasOwnProperty.call(message, "UserWithdraw"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.UserWithdraw);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.UserBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientCP2dBetAck message, length delimited. Does not implicitly {@link ClientCP2dBetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP2dBetAck
     * @static
     * @param {IClientCP2dBetAck} message ClientCP2dBetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dBetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP2dBetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP2dBetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP2dBetAck} ClientCP2dBetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dBetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP2dBetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.BetNum && message.BetNum.length))
                        message.BetNum = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.BetNum.push(reader.uint32());
                    } else
                        message.BetNum.push(reader.uint32());
                    break;
                }
            case 4: {
                    message.UserGold = reader.string();
                    break;
                }
            case 5: {
                    message.UserDeposit = reader.string();
                    break;
                }
            case 6: {
                    message.UserWithdraw = reader.string();
                    break;
                }
            case 7: {
                    message.UserBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP2dBetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP2dBetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP2dBetAck} ClientCP2dBetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dBetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP2dBetAck message.
     * @function verify
     * @memberof ClientCP2dBetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP2dBetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum")) {
            if (!Array.isArray(message.BetNum))
                return "BetNum: array expected";
            for (let i = 0; i < message.BetNum.length; ++i)
                if (!$util.isInteger(message.BetNum[i]))
                    return "BetNum: integer[] expected";
        }
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            if (!$util.isString(message.UserDeposit))
                return "UserDeposit: string expected";
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            if (!$util.isString(message.UserWithdraw))
                return "UserWithdraw: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientCP2dBetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP2dBetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP2dBetAck} ClientCP2dBetAck
     */
    ClientCP2dBetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP2dBetAck)
            return object;
        let message = new $root.ClientCP2dBetAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BetNum) {
            if (!Array.isArray(object.BetNum))
                throw TypeError(".ClientCP2dBetAck.BetNum: array expected");
            message.BetNum = [];
            for (let i = 0; i < object.BetNum.length; ++i)
                message.BetNum[i] = object.BetNum[i] >>> 0;
        }
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserDeposit != null)
            message.UserDeposit = String(object.UserDeposit);
        if (object.UserWithdraw != null)
            message.UserWithdraw = String(object.UserWithdraw);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientCP2dBetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP2dBetAck
     * @static
     * @param {ClientCP2dBetAck} message ClientCP2dBetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP2dBetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetNum = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.UserGold = "";
            object.UserDeposit = "";
            object.UserWithdraw = "";
            object.UserBonus = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BetNum && message.BetNum.length) {
            object.BetNum = [];
            for (let j = 0; j < message.BetNum.length; ++j)
                object.BetNum[j] = message.BetNum[j];
        }
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            object.UserDeposit = message.UserDeposit;
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            object.UserWithdraw = message.UserWithdraw;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        return object;
    };

    /**
     * Converts this ClientCP2dBetAck to JSON.
     * @function toJSON
     * @memberof ClientCP2dBetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP2dBetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP2dBetAck
     * @function getTypeUrl
     * @memberof ClientCP2dBetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP2dBetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP2dBetAck";
    };

    return ClientCP2dBetAck;
})();

export const ClientCP2dNumRecordReq = $root.ClientCP2dNumRecordReq = (() => {

    /**
     * Properties of a ClientCP2dNumRecordReq.
     * @exports IClientCP2dNumRecordReq
     * @interface IClientCP2dNumRecordReq
     * @property {number|null} [UserID] ClientCP2dNumRecordReq UserID
     * @property {number|null} [BetDate] ClientCP2dNumRecordReq BetDate
     * @property {number|null} [TimeID] ClientCP2dNumRecordReq TimeID
     */

    /**
     * Constructs a new ClientCP2dNumRecordReq.
     * @exports ClientCP2dNumRecordReq
     * @classdesc Represents a ClientCP2dNumRecordReq.
     * @implements IClientCP2dNumRecordReq
     * @constructor
     * @param {IClientCP2dNumRecordReq=} [properties] Properties to set
     */
    function ClientCP2dNumRecordReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP2dNumRecordReq UserID.
     * @member {number} UserID
     * @memberof ClientCP2dNumRecordReq
     * @instance
     */
    ClientCP2dNumRecordReq.prototype.UserID = 0;

    /**
     * ClientCP2dNumRecordReq BetDate.
     * @member {number} BetDate
     * @memberof ClientCP2dNumRecordReq
     * @instance
     */
    ClientCP2dNumRecordReq.prototype.BetDate = 0;

    /**
     * ClientCP2dNumRecordReq TimeID.
     * @member {number} TimeID
     * @memberof ClientCP2dNumRecordReq
     * @instance
     */
    ClientCP2dNumRecordReq.prototype.TimeID = 0;

    /**
     * Creates a new ClientCP2dNumRecordReq instance using the specified properties.
     * @function create
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {IClientCP2dNumRecordReq=} [properties] Properties to set
     * @returns {ClientCP2dNumRecordReq} ClientCP2dNumRecordReq instance
     */
    ClientCP2dNumRecordReq.create = function create(properties) {
        return new ClientCP2dNumRecordReq(properties);
    };

    /**
     * Encodes the specified ClientCP2dNumRecordReq message. Does not implicitly {@link ClientCP2dNumRecordReq.verify|verify} messages.
     * @function encode
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {IClientCP2dNumRecordReq} message ClientCP2dNumRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dNumRecordReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.BetDate != null && Object.hasOwnProperty.call(message, "BetDate"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.BetDate);
        if (message.TimeID != null && Object.hasOwnProperty.call(message, "TimeID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.TimeID);
        return writer;
    };

    /**
     * Encodes the specified ClientCP2dNumRecordReq message, length delimited. Does not implicitly {@link ClientCP2dNumRecordReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {IClientCP2dNumRecordReq} message ClientCP2dNumRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dNumRecordReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP2dNumRecordReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP2dNumRecordReq} ClientCP2dNumRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dNumRecordReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP2dNumRecordReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.BetDate = reader.uint32();
                    break;
                }
            case 3: {
                    message.TimeID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP2dNumRecordReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP2dNumRecordReq} ClientCP2dNumRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dNumRecordReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP2dNumRecordReq message.
     * @function verify
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP2dNumRecordReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            if (!$util.isInteger(message.BetDate))
                return "BetDate: integer expected";
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            if (!$util.isInteger(message.TimeID))
                return "TimeID: integer expected";
        return null;
    };

    /**
     * Creates a ClientCP2dNumRecordReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP2dNumRecordReq} ClientCP2dNumRecordReq
     */
    ClientCP2dNumRecordReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP2dNumRecordReq)
            return object;
        let message = new $root.ClientCP2dNumRecordReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BetDate != null)
            message.BetDate = object.BetDate >>> 0;
        if (object.TimeID != null)
            message.TimeID = object.TimeID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientCP2dNumRecordReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {ClientCP2dNumRecordReq} message ClientCP2dNumRecordReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP2dNumRecordReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.BetDate = 0;
            object.TimeID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            object.BetDate = message.BetDate;
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            object.TimeID = message.TimeID;
        return object;
    };

    /**
     * Converts this ClientCP2dNumRecordReq to JSON.
     * @function toJSON
     * @memberof ClientCP2dNumRecordReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP2dNumRecordReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP2dNumRecordReq
     * @function getTypeUrl
     * @memberof ClientCP2dNumRecordReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP2dNumRecordReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP2dNumRecordReq";
    };

    return ClientCP2dNumRecordReq;
})();

export const ClientCP2dNumRecordAck = $root.ClientCP2dNumRecordAck = (() => {

    /**
     * Properties of a ClientCP2dNumRecordAck.
     * @exports IClientCP2dNumRecordAck
     * @interface IClientCP2dNumRecordAck
     * @property {number|null} [Ret] ClientCP2dNumRecordAck Ret
     * @property {number|null} [UserID] ClientCP2dNumRecordAck UserID
     * @property {number|null} [BetDate] ClientCP2dNumRecordAck BetDate
     * @property {number|null} [TimeID] ClientCP2dNumRecordAck TimeID
     * @property {Array.<ICP2dNumRecordData>|null} [RecordData] ClientCP2dNumRecordAck RecordData
     */

    /**
     * Constructs a new ClientCP2dNumRecordAck.
     * @exports ClientCP2dNumRecordAck
     * @classdesc Represents a ClientCP2dNumRecordAck.
     * @implements IClientCP2dNumRecordAck
     * @constructor
     * @param {IClientCP2dNumRecordAck=} [properties] Properties to set
     */
    function ClientCP2dNumRecordAck(properties) {
        this.RecordData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP2dNumRecordAck Ret.
     * @member {number} Ret
     * @memberof ClientCP2dNumRecordAck
     * @instance
     */
    ClientCP2dNumRecordAck.prototype.Ret = 0;

    /**
     * ClientCP2dNumRecordAck UserID.
     * @member {number} UserID
     * @memberof ClientCP2dNumRecordAck
     * @instance
     */
    ClientCP2dNumRecordAck.prototype.UserID = 0;

    /**
     * ClientCP2dNumRecordAck BetDate.
     * @member {number} BetDate
     * @memberof ClientCP2dNumRecordAck
     * @instance
     */
    ClientCP2dNumRecordAck.prototype.BetDate = 0;

    /**
     * ClientCP2dNumRecordAck TimeID.
     * @member {number} TimeID
     * @memberof ClientCP2dNumRecordAck
     * @instance
     */
    ClientCP2dNumRecordAck.prototype.TimeID = 0;

    /**
     * ClientCP2dNumRecordAck RecordData.
     * @member {Array.<ICP2dNumRecordData>} RecordData
     * @memberof ClientCP2dNumRecordAck
     * @instance
     */
    ClientCP2dNumRecordAck.prototype.RecordData = $util.emptyArray;

    /**
     * Creates a new ClientCP2dNumRecordAck instance using the specified properties.
     * @function create
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {IClientCP2dNumRecordAck=} [properties] Properties to set
     * @returns {ClientCP2dNumRecordAck} ClientCP2dNumRecordAck instance
     */
    ClientCP2dNumRecordAck.create = function create(properties) {
        return new ClientCP2dNumRecordAck(properties);
    };

    /**
     * Encodes the specified ClientCP2dNumRecordAck message. Does not implicitly {@link ClientCP2dNumRecordAck.verify|verify} messages.
     * @function encode
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {IClientCP2dNumRecordAck} message ClientCP2dNumRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dNumRecordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.BetDate != null && Object.hasOwnProperty.call(message, "BetDate"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetDate);
        if (message.TimeID != null && Object.hasOwnProperty.call(message, "TimeID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.TimeID);
        if (message.RecordData != null && message.RecordData.length)
            for (let i = 0; i < message.RecordData.length; ++i)
                $root.CP2dNumRecordData.encode(message.RecordData[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientCP2dNumRecordAck message, length delimited. Does not implicitly {@link ClientCP2dNumRecordAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {IClientCP2dNumRecordAck} message ClientCP2dNumRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP2dNumRecordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP2dNumRecordAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP2dNumRecordAck} ClientCP2dNumRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dNumRecordAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP2dNumRecordAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetDate = reader.uint32();
                    break;
                }
            case 4: {
                    message.TimeID = reader.uint32();
                    break;
                }
            case 5: {
                    if (!(message.RecordData && message.RecordData.length))
                        message.RecordData = [];
                    message.RecordData.push($root.CP2dNumRecordData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP2dNumRecordAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP2dNumRecordAck} ClientCP2dNumRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP2dNumRecordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP2dNumRecordAck message.
     * @function verify
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP2dNumRecordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            if (!$util.isInteger(message.BetDate))
                return "BetDate: integer expected";
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            if (!$util.isInteger(message.TimeID))
                return "TimeID: integer expected";
        if (message.RecordData != null && message.hasOwnProperty("RecordData")) {
            if (!Array.isArray(message.RecordData))
                return "RecordData: array expected";
            for (let i = 0; i < message.RecordData.length; ++i) {
                let error = $root.CP2dNumRecordData.verify(message.RecordData[i]);
                if (error)
                    return "RecordData." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientCP2dNumRecordAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP2dNumRecordAck} ClientCP2dNumRecordAck
     */
    ClientCP2dNumRecordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP2dNumRecordAck)
            return object;
        let message = new $root.ClientCP2dNumRecordAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BetDate != null)
            message.BetDate = object.BetDate >>> 0;
        if (object.TimeID != null)
            message.TimeID = object.TimeID >>> 0;
        if (object.RecordData) {
            if (!Array.isArray(object.RecordData))
                throw TypeError(".ClientCP2dNumRecordAck.RecordData: array expected");
            message.RecordData = [];
            for (let i = 0; i < object.RecordData.length; ++i) {
                if (typeof object.RecordData[i] !== "object")
                    throw TypeError(".ClientCP2dNumRecordAck.RecordData: object expected");
                message.RecordData[i] = $root.CP2dNumRecordData.fromObject(object.RecordData[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientCP2dNumRecordAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {ClientCP2dNumRecordAck} message ClientCP2dNumRecordAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP2dNumRecordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RecordData = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.BetDate = 0;
            object.TimeID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BetDate != null && message.hasOwnProperty("BetDate"))
            object.BetDate = message.BetDate;
        if (message.TimeID != null && message.hasOwnProperty("TimeID"))
            object.TimeID = message.TimeID;
        if (message.RecordData && message.RecordData.length) {
            object.RecordData = [];
            for (let j = 0; j < message.RecordData.length; ++j)
                object.RecordData[j] = $root.CP2dNumRecordData.toObject(message.RecordData[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientCP2dNumRecordAck to JSON.
     * @function toJSON
     * @memberof ClientCP2dNumRecordAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP2dNumRecordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP2dNumRecordAck
     * @function getTypeUrl
     * @memberof ClientCP2dNumRecordAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP2dNumRecordAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP2dNumRecordAck";
    };

    return ClientCP2dNumRecordAck;
})();

export const ClientTurn2Req = $root.ClientTurn2Req = (() => {

    /**
     * Properties of a ClientTurn2Req.
     * @exports IClientTurn2Req
     * @interface IClientTurn2Req
     * @property {number|null} [UserID] ClientTurn2Req UserID
     */

    /**
     * Constructs a new ClientTurn2Req.
     * @exports ClientTurn2Req
     * @classdesc Represents a ClientTurn2Req.
     * @implements IClientTurn2Req
     * @constructor
     * @param {IClientTurn2Req=} [properties] Properties to set
     */
    function ClientTurn2Req(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn2Req UserID.
     * @member {number} UserID
     * @memberof ClientTurn2Req
     * @instance
     */
    ClientTurn2Req.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn2Req instance using the specified properties.
     * @function create
     * @memberof ClientTurn2Req
     * @static
     * @param {IClientTurn2Req=} [properties] Properties to set
     * @returns {ClientTurn2Req} ClientTurn2Req instance
     */
    ClientTurn2Req.create = function create(properties) {
        return new ClientTurn2Req(properties);
    };

    /**
     * Encodes the specified ClientTurn2Req message. Does not implicitly {@link ClientTurn2Req.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn2Req
     * @static
     * @param {IClientTurn2Req} message ClientTurn2Req message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2Req.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn2Req message, length delimited. Does not implicitly {@link ClientTurn2Req.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn2Req
     * @static
     * @param {IClientTurn2Req} message ClientTurn2Req message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2Req.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn2Req message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn2Req
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn2Req} ClientTurn2Req
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2Req.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn2Req();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn2Req message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn2Req
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn2Req} ClientTurn2Req
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2Req.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn2Req message.
     * @function verify
     * @memberof ClientTurn2Req
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn2Req.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn2Req message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn2Req
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn2Req} ClientTurn2Req
     */
    ClientTurn2Req.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn2Req)
            return object;
        let message = new $root.ClientTurn2Req();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn2Req message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn2Req
     * @static
     * @param {ClientTurn2Req} message ClientTurn2Req
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn2Req.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn2Req to JSON.
     * @function toJSON
     * @memberof ClientTurn2Req
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn2Req.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn2Req
     * @function getTypeUrl
     * @memberof ClientTurn2Req
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn2Req.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn2Req";
    };

    return ClientTurn2Req;
})();

export const ClientTurn2Ack = $root.ClientTurn2Ack = (() => {

    /**
     * Properties of a ClientTurn2Ack.
     * @exports IClientTurn2Ack
     * @interface IClientTurn2Ack
     * @property {number|null} [UserID] ClientTurn2Ack UserID
     * @property {boolean|null} [Level_1] ClientTurn2Ack Level_1
     * @property {boolean|null} [Level_2] ClientTurn2Ack Level_2
     * @property {boolean|null} [Level_3] ClientTurn2Ack Level_3
     * @property {boolean|null} [Level_4] ClientTurn2Ack Level_4
     * @property {boolean|null} [Level_5] ClientTurn2Ack Level_5
     */

    /**
     * Constructs a new ClientTurn2Ack.
     * @exports ClientTurn2Ack
     * @classdesc Represents a ClientTurn2Ack.
     * @implements IClientTurn2Ack
     * @constructor
     * @param {IClientTurn2Ack=} [properties] Properties to set
     */
    function ClientTurn2Ack(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn2Ack UserID.
     * @member {number} UserID
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.UserID = 0;

    /**
     * ClientTurn2Ack Level_1.
     * @member {boolean} Level_1
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.Level_1 = false;

    /**
     * ClientTurn2Ack Level_2.
     * @member {boolean} Level_2
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.Level_2 = false;

    /**
     * ClientTurn2Ack Level_3.
     * @member {boolean} Level_3
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.Level_3 = false;

    /**
     * ClientTurn2Ack Level_4.
     * @member {boolean} Level_4
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.Level_4 = false;

    /**
     * ClientTurn2Ack Level_5.
     * @member {boolean} Level_5
     * @memberof ClientTurn2Ack
     * @instance
     */
    ClientTurn2Ack.prototype.Level_5 = false;

    /**
     * Creates a new ClientTurn2Ack instance using the specified properties.
     * @function create
     * @memberof ClientTurn2Ack
     * @static
     * @param {IClientTurn2Ack=} [properties] Properties to set
     * @returns {ClientTurn2Ack} ClientTurn2Ack instance
     */
    ClientTurn2Ack.create = function create(properties) {
        return new ClientTurn2Ack(properties);
    };

    /**
     * Encodes the specified ClientTurn2Ack message. Does not implicitly {@link ClientTurn2Ack.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn2Ack
     * @static
     * @param {IClientTurn2Ack} message ClientTurn2Ack message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2Ack.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Level_1 != null && Object.hasOwnProperty.call(message, "Level_1"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Level_1);
        if (message.Level_2 != null && Object.hasOwnProperty.call(message, "Level_2"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Level_2);
        if (message.Level_3 != null && Object.hasOwnProperty.call(message, "Level_3"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Level_3);
        if (message.Level_4 != null && Object.hasOwnProperty.call(message, "Level_4"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Level_4);
        if (message.Level_5 != null && Object.hasOwnProperty.call(message, "Level_5"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Level_5);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn2Ack message, length delimited. Does not implicitly {@link ClientTurn2Ack.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn2Ack
     * @static
     * @param {IClientTurn2Ack} message ClientTurn2Ack message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2Ack.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn2Ack message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn2Ack
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn2Ack} ClientTurn2Ack
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2Ack.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn2Ack();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Level_1 = reader.bool();
                    break;
                }
            case 3: {
                    message.Level_2 = reader.bool();
                    break;
                }
            case 4: {
                    message.Level_3 = reader.bool();
                    break;
                }
            case 5: {
                    message.Level_4 = reader.bool();
                    break;
                }
            case 6: {
                    message.Level_5 = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn2Ack message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn2Ack
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn2Ack} ClientTurn2Ack
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2Ack.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn2Ack message.
     * @function verify
     * @memberof ClientTurn2Ack
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn2Ack.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Level_1 != null && message.hasOwnProperty("Level_1"))
            if (typeof message.Level_1 !== "boolean")
                return "Level_1: boolean expected";
        if (message.Level_2 != null && message.hasOwnProperty("Level_2"))
            if (typeof message.Level_2 !== "boolean")
                return "Level_2: boolean expected";
        if (message.Level_3 != null && message.hasOwnProperty("Level_3"))
            if (typeof message.Level_3 !== "boolean")
                return "Level_3: boolean expected";
        if (message.Level_4 != null && message.hasOwnProperty("Level_4"))
            if (typeof message.Level_4 !== "boolean")
                return "Level_4: boolean expected";
        if (message.Level_5 != null && message.hasOwnProperty("Level_5"))
            if (typeof message.Level_5 !== "boolean")
                return "Level_5: boolean expected";
        return null;
    };

    /**
     * Creates a ClientTurn2Ack message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn2Ack
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn2Ack} ClientTurn2Ack
     */
    ClientTurn2Ack.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn2Ack)
            return object;
        let message = new $root.ClientTurn2Ack();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Level_1 != null)
            message.Level_1 = Boolean(object.Level_1);
        if (object.Level_2 != null)
            message.Level_2 = Boolean(object.Level_2);
        if (object.Level_3 != null)
            message.Level_3 = Boolean(object.Level_3);
        if (object.Level_4 != null)
            message.Level_4 = Boolean(object.Level_4);
        if (object.Level_5 != null)
            message.Level_5 = Boolean(object.Level_5);
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn2Ack message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn2Ack
     * @static
     * @param {ClientTurn2Ack} message ClientTurn2Ack
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn2Ack.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Level_1 = false;
            object.Level_2 = false;
            object.Level_3 = false;
            object.Level_4 = false;
            object.Level_5 = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Level_1 != null && message.hasOwnProperty("Level_1"))
            object.Level_1 = message.Level_1;
        if (message.Level_2 != null && message.hasOwnProperty("Level_2"))
            object.Level_2 = message.Level_2;
        if (message.Level_3 != null && message.hasOwnProperty("Level_3"))
            object.Level_3 = message.Level_3;
        if (message.Level_4 != null && message.hasOwnProperty("Level_4"))
            object.Level_4 = message.Level_4;
        if (message.Level_5 != null && message.hasOwnProperty("Level_5"))
            object.Level_5 = message.Level_5;
        return object;
    };

    /**
     * Converts this ClientTurn2Ack to JSON.
     * @function toJSON
     * @memberof ClientTurn2Ack
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn2Ack.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn2Ack
     * @function getTypeUrl
     * @memberof ClientTurn2Ack
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn2Ack.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn2Ack";
    };

    return ClientTurn2Ack;
})();

export const ClientTurn2GoldReq = $root.ClientTurn2GoldReq = (() => {

    /**
     * Properties of a ClientTurn2GoldReq.
     * @exports IClientTurn2GoldReq
     * @interface IClientTurn2GoldReq
     * @property {number|null} [UserID] ClientTurn2GoldReq UserID
     * @property {number|null} [ChannelID] ClientTurn2GoldReq ChannelID
     * @property {number|null} [TurnLevel] ClientTurn2GoldReq TurnLevel
     */

    /**
     * Constructs a new ClientTurn2GoldReq.
     * @exports ClientTurn2GoldReq
     * @classdesc Represents a ClientTurn2GoldReq.
     * @implements IClientTurn2GoldReq
     * @constructor
     * @param {IClientTurn2GoldReq=} [properties] Properties to set
     */
    function ClientTurn2GoldReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn2GoldReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn2GoldReq
     * @instance
     */
    ClientTurn2GoldReq.prototype.UserID = 0;

    /**
     * ClientTurn2GoldReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientTurn2GoldReq
     * @instance
     */
    ClientTurn2GoldReq.prototype.ChannelID = 0;

    /**
     * ClientTurn2GoldReq TurnLevel.
     * @member {number} TurnLevel
     * @memberof ClientTurn2GoldReq
     * @instance
     */
    ClientTurn2GoldReq.prototype.TurnLevel = 0;

    /**
     * Creates a new ClientTurn2GoldReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {IClientTurn2GoldReq=} [properties] Properties to set
     * @returns {ClientTurn2GoldReq} ClientTurn2GoldReq instance
     */
    ClientTurn2GoldReq.create = function create(properties) {
        return new ClientTurn2GoldReq(properties);
    };

    /**
     * Encodes the specified ClientTurn2GoldReq message. Does not implicitly {@link ClientTurn2GoldReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {IClientTurn2GoldReq} message ClientTurn2GoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2GoldReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.TurnLevel != null && Object.hasOwnProperty.call(message, "TurnLevel"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.TurnLevel);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn2GoldReq message, length delimited. Does not implicitly {@link ClientTurn2GoldReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {IClientTurn2GoldReq} message ClientTurn2GoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2GoldReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn2GoldReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn2GoldReq} ClientTurn2GoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2GoldReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn2GoldReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.TurnLevel = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn2GoldReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn2GoldReq} ClientTurn2GoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2GoldReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn2GoldReq message.
     * @function verify
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn2GoldReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.TurnLevel != null && message.hasOwnProperty("TurnLevel"))
            if (!$util.isInteger(message.TurnLevel))
                return "TurnLevel: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn2GoldReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn2GoldReq} ClientTurn2GoldReq
     */
    ClientTurn2GoldReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn2GoldReq)
            return object;
        let message = new $root.ClientTurn2GoldReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.TurnLevel != null)
            message.TurnLevel = object.TurnLevel >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn2GoldReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {ClientTurn2GoldReq} message ClientTurn2GoldReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn2GoldReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.TurnLevel = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.TurnLevel != null && message.hasOwnProperty("TurnLevel"))
            object.TurnLevel = message.TurnLevel;
        return object;
    };

    /**
     * Converts this ClientTurn2GoldReq to JSON.
     * @function toJSON
     * @memberof ClientTurn2GoldReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn2GoldReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn2GoldReq
     * @function getTypeUrl
     * @memberof ClientTurn2GoldReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn2GoldReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn2GoldReq";
    };

    return ClientTurn2GoldReq;
})();

export const ClientTurn2GoldAck = $root.ClientTurn2GoldAck = (() => {

    /**
     * Properties of a ClientTurn2GoldAck.
     * @exports IClientTurn2GoldAck
     * @interface IClientTurn2GoldAck
     * @property {number|null} [UserID] ClientTurn2GoldAck UserID
     * @property {number|null} [TurnID] ClientTurn2GoldAck TurnID
     */

    /**
     * Constructs a new ClientTurn2GoldAck.
     * @exports ClientTurn2GoldAck
     * @classdesc Represents a ClientTurn2GoldAck.
     * @implements IClientTurn2GoldAck
     * @constructor
     * @param {IClientTurn2GoldAck=} [properties] Properties to set
     */
    function ClientTurn2GoldAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn2GoldAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn2GoldAck
     * @instance
     */
    ClientTurn2GoldAck.prototype.UserID = 0;

    /**
     * ClientTurn2GoldAck TurnID.
     * @member {number} TurnID
     * @memberof ClientTurn2GoldAck
     * @instance
     */
    ClientTurn2GoldAck.prototype.TurnID = 0;

    /**
     * Creates a new ClientTurn2GoldAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {IClientTurn2GoldAck=} [properties] Properties to set
     * @returns {ClientTurn2GoldAck} ClientTurn2GoldAck instance
     */
    ClientTurn2GoldAck.create = function create(properties) {
        return new ClientTurn2GoldAck(properties);
    };

    /**
     * Encodes the specified ClientTurn2GoldAck message. Does not implicitly {@link ClientTurn2GoldAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {IClientTurn2GoldAck} message ClientTurn2GoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2GoldAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TurnID != null && Object.hasOwnProperty.call(message, "TurnID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.TurnID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn2GoldAck message, length delimited. Does not implicitly {@link ClientTurn2GoldAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {IClientTurn2GoldAck} message ClientTurn2GoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn2GoldAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn2GoldAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn2GoldAck} ClientTurn2GoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2GoldAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn2GoldAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TurnID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn2GoldAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn2GoldAck} ClientTurn2GoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn2GoldAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn2GoldAck message.
     * @function verify
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn2GoldAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TurnID != null && message.hasOwnProperty("TurnID"))
            if (!$util.isInteger(message.TurnID))
                return "TurnID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn2GoldAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn2GoldAck} ClientTurn2GoldAck
     */
    ClientTurn2GoldAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn2GoldAck)
            return object;
        let message = new $root.ClientTurn2GoldAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TurnID != null)
            message.TurnID = object.TurnID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn2GoldAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {ClientTurn2GoldAck} message ClientTurn2GoldAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn2GoldAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.TurnID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TurnID != null && message.hasOwnProperty("TurnID"))
            object.TurnID = message.TurnID;
        return object;
    };

    /**
     * Converts this ClientTurn2GoldAck to JSON.
     * @function toJSON
     * @memberof ClientTurn2GoldAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn2GoldAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn2GoldAck
     * @function getTypeUrl
     * @memberof ClientTurn2GoldAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn2GoldAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn2GoldAck";
    };

    return ClientTurn2GoldAck;
})();

export const ClientCP3dBetReq = $root.ClientCP3dBetReq = (() => {

    /**
     * Properties of a ClientCP3dBetReq.
     * @exports IClientCP3dBetReq
     * @interface IClientCP3dBetReq
     * @property {number|null} [UserID] ClientCP3dBetReq UserID
     * @property {number|null} [ChannelID] ClientCP3dBetReq ChannelID
     * @property {string|null} [strName] ClientCP3dBetReq strName
     * @property {string|null} [strAvatar] ClientCP3dBetReq strAvatar
     * @property {string|null} [strDateTime] ClientCP3dBetReq strDateTime
     * @property {Array.<ICP3dBetData>|null} [CP3d] ClientCP3dBetReq CP3d
     * @property {number|Long|null} [UserAllBetGold] ClientCP3dBetReq UserAllBetGold
     */

    /**
     * Constructs a new ClientCP3dBetReq.
     * @exports ClientCP3dBetReq
     * @classdesc Represents a ClientCP3dBetReq.
     * @implements IClientCP3dBetReq
     * @constructor
     * @param {IClientCP3dBetReq=} [properties] Properties to set
     */
    function ClientCP3dBetReq(properties) {
        this.CP3d = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP3dBetReq UserID.
     * @member {number} UserID
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.UserID = 0;

    /**
     * ClientCP3dBetReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.ChannelID = 0;

    /**
     * ClientCP3dBetReq strName.
     * @member {string} strName
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.strName = "";

    /**
     * ClientCP3dBetReq strAvatar.
     * @member {string} strAvatar
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.strAvatar = "";

    /**
     * ClientCP3dBetReq strDateTime.
     * @member {string} strDateTime
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.strDateTime = "";

    /**
     * ClientCP3dBetReq CP3d.
     * @member {Array.<ICP3dBetData>} CP3d
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.CP3d = $util.emptyArray;

    /**
     * ClientCP3dBetReq UserAllBetGold.
     * @member {number|Long} UserAllBetGold
     * @memberof ClientCP3dBetReq
     * @instance
     */
    ClientCP3dBetReq.prototype.UserAllBetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientCP3dBetReq instance using the specified properties.
     * @function create
     * @memberof ClientCP3dBetReq
     * @static
     * @param {IClientCP3dBetReq=} [properties] Properties to set
     * @returns {ClientCP3dBetReq} ClientCP3dBetReq instance
     */
    ClientCP3dBetReq.create = function create(properties) {
        return new ClientCP3dBetReq(properties);
    };

    /**
     * Encodes the specified ClientCP3dBetReq message. Does not implicitly {@link ClientCP3dBetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientCP3dBetReq
     * @static
     * @param {IClientCP3dBetReq} message ClientCP3dBetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dBetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.strName != null && Object.hasOwnProperty.call(message, "strName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strName);
        if (message.strAvatar != null && Object.hasOwnProperty.call(message, "strAvatar"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.strAvatar);
        if (message.strDateTime != null && Object.hasOwnProperty.call(message, "strDateTime"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.strDateTime);
        if (message.CP3d != null && message.CP3d.length)
            for (let i = 0; i < message.CP3d.length; ++i)
                $root.CP3dBetData.encode(message.CP3d[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.UserAllBetGold != null && Object.hasOwnProperty.call(message, "UserAllBetGold"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.UserAllBetGold);
        return writer;
    };

    /**
     * Encodes the specified ClientCP3dBetReq message, length delimited. Does not implicitly {@link ClientCP3dBetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP3dBetReq
     * @static
     * @param {IClientCP3dBetReq} message ClientCP3dBetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dBetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP3dBetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP3dBetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP3dBetReq} ClientCP3dBetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dBetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP3dBetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.strName = reader.string();
                    break;
                }
            case 4: {
                    message.strAvatar = reader.string();
                    break;
                }
            case 5: {
                    message.strDateTime = reader.string();
                    break;
                }
            case 6: {
                    if (!(message.CP3d && message.CP3d.length))
                        message.CP3d = [];
                    message.CP3d.push($root.CP3dBetData.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.UserAllBetGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP3dBetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP3dBetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP3dBetReq} ClientCP3dBetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dBetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP3dBetReq message.
     * @function verify
     * @memberof ClientCP3dBetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP3dBetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.strName != null && message.hasOwnProperty("strName"))
            if (!$util.isString(message.strName))
                return "strName: string expected";
        if (message.strAvatar != null && message.hasOwnProperty("strAvatar"))
            if (!$util.isString(message.strAvatar))
                return "strAvatar: string expected";
        if (message.strDateTime != null && message.hasOwnProperty("strDateTime"))
            if (!$util.isString(message.strDateTime))
                return "strDateTime: string expected";
        if (message.CP3d != null && message.hasOwnProperty("CP3d")) {
            if (!Array.isArray(message.CP3d))
                return "CP3d: array expected";
            for (let i = 0; i < message.CP3d.length; ++i) {
                let error = $root.CP3dBetData.verify(message.CP3d[i]);
                if (error)
                    return "CP3d." + error;
            }
        }
        if (message.UserAllBetGold != null && message.hasOwnProperty("UserAllBetGold"))
            if (!$util.isInteger(message.UserAllBetGold) && !(message.UserAllBetGold && $util.isInteger(message.UserAllBetGold.low) && $util.isInteger(message.UserAllBetGold.high)))
                return "UserAllBetGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientCP3dBetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP3dBetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP3dBetReq} ClientCP3dBetReq
     */
    ClientCP3dBetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP3dBetReq)
            return object;
        let message = new $root.ClientCP3dBetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.strName != null)
            message.strName = String(object.strName);
        if (object.strAvatar != null)
            message.strAvatar = String(object.strAvatar);
        if (object.strDateTime != null)
            message.strDateTime = String(object.strDateTime);
        if (object.CP3d) {
            if (!Array.isArray(object.CP3d))
                throw TypeError(".ClientCP3dBetReq.CP3d: array expected");
            message.CP3d = [];
            for (let i = 0; i < object.CP3d.length; ++i) {
                if (typeof object.CP3d[i] !== "object")
                    throw TypeError(".ClientCP3dBetReq.CP3d: object expected");
                message.CP3d[i] = $root.CP3dBetData.fromObject(object.CP3d[i]);
            }
        }
        if (object.UserAllBetGold != null)
            if ($util.Long)
                (message.UserAllBetGold = $util.Long.fromValue(object.UserAllBetGold)).unsigned = true;
            else if (typeof object.UserAllBetGold === "string")
                message.UserAllBetGold = parseInt(object.UserAllBetGold, 10);
            else if (typeof object.UserAllBetGold === "number")
                message.UserAllBetGold = object.UserAllBetGold;
            else if (typeof object.UserAllBetGold === "object")
                message.UserAllBetGold = new $util.LongBits(object.UserAllBetGold.low >>> 0, object.UserAllBetGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientCP3dBetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP3dBetReq
     * @static
     * @param {ClientCP3dBetReq} message ClientCP3dBetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP3dBetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.CP3d = [];
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.strName = "";
            object.strAvatar = "";
            object.strDateTime = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.UserAllBetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.UserAllBetGold = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.strName != null && message.hasOwnProperty("strName"))
            object.strName = message.strName;
        if (message.strAvatar != null && message.hasOwnProperty("strAvatar"))
            object.strAvatar = message.strAvatar;
        if (message.strDateTime != null && message.hasOwnProperty("strDateTime"))
            object.strDateTime = message.strDateTime;
        if (message.CP3d && message.CP3d.length) {
            object.CP3d = [];
            for (let j = 0; j < message.CP3d.length; ++j)
                object.CP3d[j] = $root.CP3dBetData.toObject(message.CP3d[j], options);
        }
        if (message.UserAllBetGold != null && message.hasOwnProperty("UserAllBetGold"))
            if (typeof message.UserAllBetGold === "number")
                object.UserAllBetGold = options.longs === String ? String(message.UserAllBetGold) : message.UserAllBetGold;
            else
                object.UserAllBetGold = options.longs === String ? $util.Long.prototype.toString.call(message.UserAllBetGold) : options.longs === Number ? new $util.LongBits(message.UserAllBetGold.low >>> 0, message.UserAllBetGold.high >>> 0).toNumber(true) : message.UserAllBetGold;
        return object;
    };

    /**
     * Converts this ClientCP3dBetReq to JSON.
     * @function toJSON
     * @memberof ClientCP3dBetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP3dBetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP3dBetReq
     * @function getTypeUrl
     * @memberof ClientCP3dBetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP3dBetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP3dBetReq";
    };

    return ClientCP3dBetReq;
})();

export const ClientCP3dBetAck = $root.ClientCP3dBetAck = (() => {

    /**
     * Properties of a ClientCP3dBetAck.
     * @exports IClientCP3dBetAck
     * @interface IClientCP3dBetAck
     * @property {number|null} [Ret] ClientCP3dBetAck Ret
     * @property {number|null} [UserID] ClientCP3dBetAck UserID
     * @property {Array.<number>|null} [BetNum] ClientCP3dBetAck BetNum
     * @property {string|null} [UserGold] ClientCP3dBetAck UserGold
     * @property {string|null} [UserDeposit] ClientCP3dBetAck UserDeposit
     * @property {string|null} [UserWithdraw] ClientCP3dBetAck UserWithdraw
     * @property {string|null} [UserBonus] ClientCP3dBetAck UserBonus
     */

    /**
     * Constructs a new ClientCP3dBetAck.
     * @exports ClientCP3dBetAck
     * @classdesc Represents a ClientCP3dBetAck.
     * @implements IClientCP3dBetAck
     * @constructor
     * @param {IClientCP3dBetAck=} [properties] Properties to set
     */
    function ClientCP3dBetAck(properties) {
        this.BetNum = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP3dBetAck Ret.
     * @member {number} Ret
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.Ret = 0;

    /**
     * ClientCP3dBetAck UserID.
     * @member {number} UserID
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.UserID = 0;

    /**
     * ClientCP3dBetAck BetNum.
     * @member {Array.<number>} BetNum
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.BetNum = $util.emptyArray;

    /**
     * ClientCP3dBetAck UserGold.
     * @member {string} UserGold
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.UserGold = "";

    /**
     * ClientCP3dBetAck UserDeposit.
     * @member {string} UserDeposit
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.UserDeposit = "";

    /**
     * ClientCP3dBetAck UserWithdraw.
     * @member {string} UserWithdraw
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.UserWithdraw = "";

    /**
     * ClientCP3dBetAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientCP3dBetAck
     * @instance
     */
    ClientCP3dBetAck.prototype.UserBonus = "";

    /**
     * Creates a new ClientCP3dBetAck instance using the specified properties.
     * @function create
     * @memberof ClientCP3dBetAck
     * @static
     * @param {IClientCP3dBetAck=} [properties] Properties to set
     * @returns {ClientCP3dBetAck} ClientCP3dBetAck instance
     */
    ClientCP3dBetAck.create = function create(properties) {
        return new ClientCP3dBetAck(properties);
    };

    /**
     * Encodes the specified ClientCP3dBetAck message. Does not implicitly {@link ClientCP3dBetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientCP3dBetAck
     * @static
     * @param {IClientCP3dBetAck} message ClientCP3dBetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dBetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.BetNum != null && message.BetNum.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.BetNum.length; ++i)
                writer.uint32(message.BetNum[i]);
            writer.ldelim();
        }
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.UserGold);
        if (message.UserDeposit != null && Object.hasOwnProperty.call(message, "UserDeposit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.UserDeposit);
        if (message.UserWithdraw != null && Object.hasOwnProperty.call(message, "UserWithdraw"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.UserWithdraw);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.UserBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientCP3dBetAck message, length delimited. Does not implicitly {@link ClientCP3dBetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP3dBetAck
     * @static
     * @param {IClientCP3dBetAck} message ClientCP3dBetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dBetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP3dBetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP3dBetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP3dBetAck} ClientCP3dBetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dBetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP3dBetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.BetNum && message.BetNum.length))
                        message.BetNum = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.BetNum.push(reader.uint32());
                    } else
                        message.BetNum.push(reader.uint32());
                    break;
                }
            case 4: {
                    message.UserGold = reader.string();
                    break;
                }
            case 5: {
                    message.UserDeposit = reader.string();
                    break;
                }
            case 6: {
                    message.UserWithdraw = reader.string();
                    break;
                }
            case 7: {
                    message.UserBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP3dBetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP3dBetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP3dBetAck} ClientCP3dBetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dBetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP3dBetAck message.
     * @function verify
     * @memberof ClientCP3dBetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP3dBetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BetNum != null && message.hasOwnProperty("BetNum")) {
            if (!Array.isArray(message.BetNum))
                return "BetNum: array expected";
            for (let i = 0; i < message.BetNum.length; ++i)
                if (!$util.isInteger(message.BetNum[i]))
                    return "BetNum: integer[] expected";
        }
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            if (!$util.isString(message.UserDeposit))
                return "UserDeposit: string expected";
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            if (!$util.isString(message.UserWithdraw))
                return "UserWithdraw: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientCP3dBetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP3dBetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP3dBetAck} ClientCP3dBetAck
     */
    ClientCP3dBetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP3dBetAck)
            return object;
        let message = new $root.ClientCP3dBetAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BetNum) {
            if (!Array.isArray(object.BetNum))
                throw TypeError(".ClientCP3dBetAck.BetNum: array expected");
            message.BetNum = [];
            for (let i = 0; i < object.BetNum.length; ++i)
                message.BetNum[i] = object.BetNum[i] >>> 0;
        }
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserDeposit != null)
            message.UserDeposit = String(object.UserDeposit);
        if (object.UserWithdraw != null)
            message.UserWithdraw = String(object.UserWithdraw);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientCP3dBetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP3dBetAck
     * @static
     * @param {ClientCP3dBetAck} message ClientCP3dBetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP3dBetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetNum = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.UserGold = "";
            object.UserDeposit = "";
            object.UserWithdraw = "";
            object.UserBonus = "";
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BetNum && message.BetNum.length) {
            object.BetNum = [];
            for (let j = 0; j < message.BetNum.length; ++j)
                object.BetNum[j] = message.BetNum[j];
        }
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            object.UserDeposit = message.UserDeposit;
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            object.UserWithdraw = message.UserWithdraw;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        return object;
    };

    /**
     * Converts this ClientCP3dBetAck to JSON.
     * @function toJSON
     * @memberof ClientCP3dBetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP3dBetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP3dBetAck
     * @function getTypeUrl
     * @memberof ClientCP3dBetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP3dBetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP3dBetAck";
    };

    return ClientCP3dBetAck;
})();

export const ClientCP3dNumRecordReq = $root.ClientCP3dNumRecordReq = (() => {

    /**
     * Properties of a ClientCP3dNumRecordReq.
     * @exports IClientCP3dNumRecordReq
     * @interface IClientCP3dNumRecordReq
     * @property {number|null} [UserID] ClientCP3dNumRecordReq UserID
     */

    /**
     * Constructs a new ClientCP3dNumRecordReq.
     * @exports ClientCP3dNumRecordReq
     * @classdesc Represents a ClientCP3dNumRecordReq.
     * @implements IClientCP3dNumRecordReq
     * @constructor
     * @param {IClientCP3dNumRecordReq=} [properties] Properties to set
     */
    function ClientCP3dNumRecordReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP3dNumRecordReq UserID.
     * @member {number} UserID
     * @memberof ClientCP3dNumRecordReq
     * @instance
     */
    ClientCP3dNumRecordReq.prototype.UserID = 0;

    /**
     * Creates a new ClientCP3dNumRecordReq instance using the specified properties.
     * @function create
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {IClientCP3dNumRecordReq=} [properties] Properties to set
     * @returns {ClientCP3dNumRecordReq} ClientCP3dNumRecordReq instance
     */
    ClientCP3dNumRecordReq.create = function create(properties) {
        return new ClientCP3dNumRecordReq(properties);
    };

    /**
     * Encodes the specified ClientCP3dNumRecordReq message. Does not implicitly {@link ClientCP3dNumRecordReq.verify|verify} messages.
     * @function encode
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {IClientCP3dNumRecordReq} message ClientCP3dNumRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dNumRecordReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientCP3dNumRecordReq message, length delimited. Does not implicitly {@link ClientCP3dNumRecordReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {IClientCP3dNumRecordReq} message ClientCP3dNumRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dNumRecordReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP3dNumRecordReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP3dNumRecordReq} ClientCP3dNumRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dNumRecordReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP3dNumRecordReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP3dNumRecordReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP3dNumRecordReq} ClientCP3dNumRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dNumRecordReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP3dNumRecordReq message.
     * @function verify
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP3dNumRecordReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientCP3dNumRecordReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP3dNumRecordReq} ClientCP3dNumRecordReq
     */
    ClientCP3dNumRecordReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP3dNumRecordReq)
            return object;
        let message = new $root.ClientCP3dNumRecordReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientCP3dNumRecordReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {ClientCP3dNumRecordReq} message ClientCP3dNumRecordReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP3dNumRecordReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientCP3dNumRecordReq to JSON.
     * @function toJSON
     * @memberof ClientCP3dNumRecordReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP3dNumRecordReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP3dNumRecordReq
     * @function getTypeUrl
     * @memberof ClientCP3dNumRecordReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP3dNumRecordReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP3dNumRecordReq";
    };

    return ClientCP3dNumRecordReq;
})();

export const ClientCP3dNumRecordAck = $root.ClientCP3dNumRecordAck = (() => {

    /**
     * Properties of a ClientCP3dNumRecordAck.
     * @exports IClientCP3dNumRecordAck
     * @interface IClientCP3dNumRecordAck
     * @property {number|null} [Ret] ClientCP3dNumRecordAck Ret
     * @property {number|null} [UserID] ClientCP3dNumRecordAck UserID
     * @property {Array.<ICP3dNumRecordData>|null} [RecordData] ClientCP3dNumRecordAck RecordData
     */

    /**
     * Constructs a new ClientCP3dNumRecordAck.
     * @exports ClientCP3dNumRecordAck
     * @classdesc Represents a ClientCP3dNumRecordAck.
     * @implements IClientCP3dNumRecordAck
     * @constructor
     * @param {IClientCP3dNumRecordAck=} [properties] Properties to set
     */
    function ClientCP3dNumRecordAck(properties) {
        this.RecordData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientCP3dNumRecordAck Ret.
     * @member {number} Ret
     * @memberof ClientCP3dNumRecordAck
     * @instance
     */
    ClientCP3dNumRecordAck.prototype.Ret = 0;

    /**
     * ClientCP3dNumRecordAck UserID.
     * @member {number} UserID
     * @memberof ClientCP3dNumRecordAck
     * @instance
     */
    ClientCP3dNumRecordAck.prototype.UserID = 0;

    /**
     * ClientCP3dNumRecordAck RecordData.
     * @member {Array.<ICP3dNumRecordData>} RecordData
     * @memberof ClientCP3dNumRecordAck
     * @instance
     */
    ClientCP3dNumRecordAck.prototype.RecordData = $util.emptyArray;

    /**
     * Creates a new ClientCP3dNumRecordAck instance using the specified properties.
     * @function create
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {IClientCP3dNumRecordAck=} [properties] Properties to set
     * @returns {ClientCP3dNumRecordAck} ClientCP3dNumRecordAck instance
     */
    ClientCP3dNumRecordAck.create = function create(properties) {
        return new ClientCP3dNumRecordAck(properties);
    };

    /**
     * Encodes the specified ClientCP3dNumRecordAck message. Does not implicitly {@link ClientCP3dNumRecordAck.verify|verify} messages.
     * @function encode
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {IClientCP3dNumRecordAck} message ClientCP3dNumRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dNumRecordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.RecordData != null && message.RecordData.length)
            for (let i = 0; i < message.RecordData.length; ++i)
                $root.CP3dNumRecordData.encode(message.RecordData[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientCP3dNumRecordAck message, length delimited. Does not implicitly {@link ClientCP3dNumRecordAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {IClientCP3dNumRecordAck} message ClientCP3dNumRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientCP3dNumRecordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientCP3dNumRecordAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientCP3dNumRecordAck} ClientCP3dNumRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dNumRecordAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientCP3dNumRecordAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.RecordData && message.RecordData.length))
                        message.RecordData = [];
                    message.RecordData.push($root.CP3dNumRecordData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientCP3dNumRecordAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientCP3dNumRecordAck} ClientCP3dNumRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientCP3dNumRecordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientCP3dNumRecordAck message.
     * @function verify
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientCP3dNumRecordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.RecordData != null && message.hasOwnProperty("RecordData")) {
            if (!Array.isArray(message.RecordData))
                return "RecordData: array expected";
            for (let i = 0; i < message.RecordData.length; ++i) {
                let error = $root.CP3dNumRecordData.verify(message.RecordData[i]);
                if (error)
                    return "RecordData." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientCP3dNumRecordAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientCP3dNumRecordAck} ClientCP3dNumRecordAck
     */
    ClientCP3dNumRecordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientCP3dNumRecordAck)
            return object;
        let message = new $root.ClientCP3dNumRecordAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.RecordData) {
            if (!Array.isArray(object.RecordData))
                throw TypeError(".ClientCP3dNumRecordAck.RecordData: array expected");
            message.RecordData = [];
            for (let i = 0; i < object.RecordData.length; ++i) {
                if (typeof object.RecordData[i] !== "object")
                    throw TypeError(".ClientCP3dNumRecordAck.RecordData: object expected");
                message.RecordData[i] = $root.CP3dNumRecordData.fromObject(object.RecordData[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientCP3dNumRecordAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {ClientCP3dNumRecordAck} message ClientCP3dNumRecordAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientCP3dNumRecordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RecordData = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.RecordData && message.RecordData.length) {
            object.RecordData = [];
            for (let j = 0; j < message.RecordData.length; ++j)
                object.RecordData[j] = $root.CP3dNumRecordData.toObject(message.RecordData[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientCP3dNumRecordAck to JSON.
     * @function toJSON
     * @memberof ClientCP3dNumRecordAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientCP3dNumRecordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientCP3dNumRecordAck
     * @function getTypeUrl
     * @memberof ClientCP3dNumRecordAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientCP3dNumRecordAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientCP3dNumRecordAck";
    };

    return ClientCP3dNumRecordAck;
})();

export const ClientTurn3GiftReq = $root.ClientTurn3GiftReq = (() => {

    /**
     * Properties of a ClientTurn3GiftReq.
     * @exports IClientTurn3GiftReq
     * @interface IClientTurn3GiftReq
     * @property {number|null} [UserID] ClientTurn3GiftReq UserID
     */

    /**
     * Constructs a new ClientTurn3GiftReq.
     * @exports ClientTurn3GiftReq
     * @classdesc Represents a ClientTurn3GiftReq.
     * @implements IClientTurn3GiftReq
     * @constructor
     * @param {IClientTurn3GiftReq=} [properties] Properties to set
     */
    function ClientTurn3GiftReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3GiftReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3GiftReq
     * @instance
     */
    ClientTurn3GiftReq.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn3GiftReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {IClientTurn3GiftReq=} [properties] Properties to set
     * @returns {ClientTurn3GiftReq} ClientTurn3GiftReq instance
     */
    ClientTurn3GiftReq.create = function create(properties) {
        return new ClientTurn3GiftReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3GiftReq message. Does not implicitly {@link ClientTurn3GiftReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {IClientTurn3GiftReq} message ClientTurn3GiftReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3GiftReq message, length delimited. Does not implicitly {@link ClientTurn3GiftReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {IClientTurn3GiftReq} message ClientTurn3GiftReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3GiftReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3GiftReq} ClientTurn3GiftReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3GiftReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3GiftReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3GiftReq} ClientTurn3GiftReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3GiftReq message.
     * @function verify
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3GiftReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3GiftReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3GiftReq} ClientTurn3GiftReq
     */
    ClientTurn3GiftReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3GiftReq)
            return object;
        let message = new $root.ClientTurn3GiftReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3GiftReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {ClientTurn3GiftReq} message ClientTurn3GiftReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3GiftReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn3GiftReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3GiftReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3GiftReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3GiftReq
     * @function getTypeUrl
     * @memberof ClientTurn3GiftReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3GiftReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3GiftReq";
    };

    return ClientTurn3GiftReq;
})();

export const ClientTurn3GiftAck = $root.ClientTurn3GiftAck = (() => {

    /**
     * Properties of a ClientTurn3GiftAck.
     * @exports IClientTurn3GiftAck
     * @interface IClientTurn3GiftAck
     * @property {number|null} [UserID] ClientTurn3GiftAck UserID
     * @property {number|null} [GiftType] ClientTurn3GiftAck GiftType
     * @property {Array.<string>|null} [GiftGold] ClientTurn3GiftAck GiftGold
     * @property {string|null} [GiftGold_Pot] ClientTurn3GiftAck GiftGold_Pot
     * @property {number|null} [Turn3playid] ClientTurn3GiftAck Turn3playid
     */

    /**
     * Constructs a new ClientTurn3GiftAck.
     * @exports ClientTurn3GiftAck
     * @classdesc Represents a ClientTurn3GiftAck.
     * @implements IClientTurn3GiftAck
     * @constructor
     * @param {IClientTurn3GiftAck=} [properties] Properties to set
     */
    function ClientTurn3GiftAck(properties) {
        this.GiftGold = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3GiftAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3GiftAck
     * @instance
     */
    ClientTurn3GiftAck.prototype.UserID = 0;

    /**
     * ClientTurn3GiftAck GiftType.
     * @member {number} GiftType
     * @memberof ClientTurn3GiftAck
     * @instance
     */
    ClientTurn3GiftAck.prototype.GiftType = 0;

    /**
     * ClientTurn3GiftAck GiftGold.
     * @member {Array.<string>} GiftGold
     * @memberof ClientTurn3GiftAck
     * @instance
     */
    ClientTurn3GiftAck.prototype.GiftGold = $util.emptyArray;

    /**
     * ClientTurn3GiftAck GiftGold_Pot.
     * @member {string} GiftGold_Pot
     * @memberof ClientTurn3GiftAck
     * @instance
     */
    ClientTurn3GiftAck.prototype.GiftGold_Pot = "";

    /**
     * ClientTurn3GiftAck Turn3playid.
     * @member {number} Turn3playid
     * @memberof ClientTurn3GiftAck
     * @instance
     */
    ClientTurn3GiftAck.prototype.Turn3playid = 0;

    /**
     * Creates a new ClientTurn3GiftAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {IClientTurn3GiftAck=} [properties] Properties to set
     * @returns {ClientTurn3GiftAck} ClientTurn3GiftAck instance
     */
    ClientTurn3GiftAck.create = function create(properties) {
        return new ClientTurn3GiftAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3GiftAck message. Does not implicitly {@link ClientTurn3GiftAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {IClientTurn3GiftAck} message ClientTurn3GiftAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GiftType != null && Object.hasOwnProperty.call(message, "GiftType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GiftType);
        if (message.GiftGold != null && message.GiftGold.length)
            for (let i = 0; i < message.GiftGold.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.GiftGold[i]);
        if (message.GiftGold_Pot != null && Object.hasOwnProperty.call(message, "GiftGold_Pot"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GiftGold_Pot);
        if (message.Turn3playid != null && Object.hasOwnProperty.call(message, "Turn3playid"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Turn3playid);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3GiftAck message, length delimited. Does not implicitly {@link ClientTurn3GiftAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {IClientTurn3GiftAck} message ClientTurn3GiftAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3GiftAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3GiftAck} ClientTurn3GiftAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3GiftAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GiftType = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GiftGold && message.GiftGold.length))
                        message.GiftGold = [];
                    message.GiftGold.push(reader.string());
                    break;
                }
            case 4: {
                    message.GiftGold_Pot = reader.string();
                    break;
                }
            case 5: {
                    message.Turn3playid = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3GiftAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3GiftAck} ClientTurn3GiftAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3GiftAck message.
     * @function verify
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3GiftAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GiftType != null && message.hasOwnProperty("GiftType"))
            if (!$util.isInteger(message.GiftType))
                return "GiftType: integer expected";
        if (message.GiftGold != null && message.hasOwnProperty("GiftGold")) {
            if (!Array.isArray(message.GiftGold))
                return "GiftGold: array expected";
            for (let i = 0; i < message.GiftGold.length; ++i)
                if (!$util.isString(message.GiftGold[i]))
                    return "GiftGold: string[] expected";
        }
        if (message.GiftGold_Pot != null && message.hasOwnProperty("GiftGold_Pot"))
            if (!$util.isString(message.GiftGold_Pot))
                return "GiftGold_Pot: string expected";
        if (message.Turn3playid != null && message.hasOwnProperty("Turn3playid"))
            if (!$util.isInteger(message.Turn3playid))
                return "Turn3playid: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3GiftAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3GiftAck} ClientTurn3GiftAck
     */
    ClientTurn3GiftAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3GiftAck)
            return object;
        let message = new $root.ClientTurn3GiftAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GiftType != null)
            message.GiftType = object.GiftType >>> 0;
        if (object.GiftGold) {
            if (!Array.isArray(object.GiftGold))
                throw TypeError(".ClientTurn3GiftAck.GiftGold: array expected");
            message.GiftGold = [];
            for (let i = 0; i < object.GiftGold.length; ++i)
                message.GiftGold[i] = String(object.GiftGold[i]);
        }
        if (object.GiftGold_Pot != null)
            message.GiftGold_Pot = String(object.GiftGold_Pot);
        if (object.Turn3playid != null)
            message.Turn3playid = object.Turn3playid >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3GiftAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {ClientTurn3GiftAck} message ClientTurn3GiftAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3GiftAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GiftGold = [];
        if (options.defaults) {
            object.UserID = 0;
            object.GiftType = 0;
            object.GiftGold_Pot = "";
            object.Turn3playid = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GiftType != null && message.hasOwnProperty("GiftType"))
            object.GiftType = message.GiftType;
        if (message.GiftGold && message.GiftGold.length) {
            object.GiftGold = [];
            for (let j = 0; j < message.GiftGold.length; ++j)
                object.GiftGold[j] = message.GiftGold[j];
        }
        if (message.GiftGold_Pot != null && message.hasOwnProperty("GiftGold_Pot"))
            object.GiftGold_Pot = message.GiftGold_Pot;
        if (message.Turn3playid != null && message.hasOwnProperty("Turn3playid"))
            object.Turn3playid = message.Turn3playid;
        return object;
    };

    /**
     * Converts this ClientTurn3GiftAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3GiftAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3GiftAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3GiftAck
     * @function getTypeUrl
     * @memberof ClientTurn3GiftAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3GiftAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3GiftAck";
    };

    return ClientTurn3GiftAck;
})();

export const ClientTurn3GiftGetReq = $root.ClientTurn3GiftGetReq = (() => {

    /**
     * Properties of a ClientTurn3GiftGetReq.
     * @exports IClientTurn3GiftGetReq
     * @interface IClientTurn3GiftGetReq
     * @property {number|null} [UserID] ClientTurn3GiftGetReq UserID
     * @property {string|null} [GiftGold] ClientTurn3GiftGetReq GiftGold
     * @property {number|null} [Turn3playid] ClientTurn3GiftGetReq Turn3playid
     */

    /**
     * Constructs a new ClientTurn3GiftGetReq.
     * @exports ClientTurn3GiftGetReq
     * @classdesc Represents a ClientTurn3GiftGetReq.
     * @implements IClientTurn3GiftGetReq
     * @constructor
     * @param {IClientTurn3GiftGetReq=} [properties] Properties to set
     */
    function ClientTurn3GiftGetReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3GiftGetReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3GiftGetReq
     * @instance
     */
    ClientTurn3GiftGetReq.prototype.UserID = 0;

    /**
     * ClientTurn3GiftGetReq GiftGold.
     * @member {string} GiftGold
     * @memberof ClientTurn3GiftGetReq
     * @instance
     */
    ClientTurn3GiftGetReq.prototype.GiftGold = "";

    /**
     * ClientTurn3GiftGetReq Turn3playid.
     * @member {number} Turn3playid
     * @memberof ClientTurn3GiftGetReq
     * @instance
     */
    ClientTurn3GiftGetReq.prototype.Turn3playid = 0;

    /**
     * Creates a new ClientTurn3GiftGetReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {IClientTurn3GiftGetReq=} [properties] Properties to set
     * @returns {ClientTurn3GiftGetReq} ClientTurn3GiftGetReq instance
     */
    ClientTurn3GiftGetReq.create = function create(properties) {
        return new ClientTurn3GiftGetReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3GiftGetReq message. Does not implicitly {@link ClientTurn3GiftGetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {IClientTurn3GiftGetReq} message ClientTurn3GiftGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftGetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GiftGold != null && Object.hasOwnProperty.call(message, "GiftGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.GiftGold);
        if (message.Turn3playid != null && Object.hasOwnProperty.call(message, "Turn3playid"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Turn3playid);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3GiftGetReq message, length delimited. Does not implicitly {@link ClientTurn3GiftGetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {IClientTurn3GiftGetReq} message ClientTurn3GiftGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftGetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3GiftGetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3GiftGetReq} ClientTurn3GiftGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftGetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3GiftGetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GiftGold = reader.string();
                    break;
                }
            case 3: {
                    message.Turn3playid = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3GiftGetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3GiftGetReq} ClientTurn3GiftGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftGetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3GiftGetReq message.
     * @function verify
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3GiftGetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GiftGold != null && message.hasOwnProperty("GiftGold"))
            if (!$util.isString(message.GiftGold))
                return "GiftGold: string expected";
        if (message.Turn3playid != null && message.hasOwnProperty("Turn3playid"))
            if (!$util.isInteger(message.Turn3playid))
                return "Turn3playid: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3GiftGetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3GiftGetReq} ClientTurn3GiftGetReq
     */
    ClientTurn3GiftGetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3GiftGetReq)
            return object;
        let message = new $root.ClientTurn3GiftGetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GiftGold != null)
            message.GiftGold = String(object.GiftGold);
        if (object.Turn3playid != null)
            message.Turn3playid = object.Turn3playid >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3GiftGetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {ClientTurn3GiftGetReq} message ClientTurn3GiftGetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3GiftGetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GiftGold = "";
            object.Turn3playid = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GiftGold != null && message.hasOwnProperty("GiftGold"))
            object.GiftGold = message.GiftGold;
        if (message.Turn3playid != null && message.hasOwnProperty("Turn3playid"))
            object.Turn3playid = message.Turn3playid;
        return object;
    };

    /**
     * Converts this ClientTurn3GiftGetReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3GiftGetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3GiftGetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3GiftGetReq
     * @function getTypeUrl
     * @memberof ClientTurn3GiftGetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3GiftGetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3GiftGetReq";
    };

    return ClientTurn3GiftGetReq;
})();

export const ClientTurn3GiftGetAck = $root.ClientTurn3GiftGetAck = (() => {

    /**
     * Properties of a ClientTurn3GiftGetAck.
     * @exports IClientTurn3GiftGetAck
     * @interface IClientTurn3GiftGetAck
     * @property {number|null} [UserID] ClientTurn3GiftGetAck UserID
     */

    /**
     * Constructs a new ClientTurn3GiftGetAck.
     * @exports ClientTurn3GiftGetAck
     * @classdesc Represents a ClientTurn3GiftGetAck.
     * @implements IClientTurn3GiftGetAck
     * @constructor
     * @param {IClientTurn3GiftGetAck=} [properties] Properties to set
     */
    function ClientTurn3GiftGetAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3GiftGetAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3GiftGetAck
     * @instance
     */
    ClientTurn3GiftGetAck.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn3GiftGetAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {IClientTurn3GiftGetAck=} [properties] Properties to set
     * @returns {ClientTurn3GiftGetAck} ClientTurn3GiftGetAck instance
     */
    ClientTurn3GiftGetAck.create = function create(properties) {
        return new ClientTurn3GiftGetAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3GiftGetAck message. Does not implicitly {@link ClientTurn3GiftGetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {IClientTurn3GiftGetAck} message ClientTurn3GiftGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftGetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3GiftGetAck message, length delimited. Does not implicitly {@link ClientTurn3GiftGetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {IClientTurn3GiftGetAck} message ClientTurn3GiftGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3GiftGetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3GiftGetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3GiftGetAck} ClientTurn3GiftGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftGetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3GiftGetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3GiftGetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3GiftGetAck} ClientTurn3GiftGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3GiftGetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3GiftGetAck message.
     * @function verify
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3GiftGetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3GiftGetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3GiftGetAck} ClientTurn3GiftGetAck
     */
    ClientTurn3GiftGetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3GiftGetAck)
            return object;
        let message = new $root.ClientTurn3GiftGetAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3GiftGetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {ClientTurn3GiftGetAck} message ClientTurn3GiftGetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3GiftGetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn3GiftGetAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3GiftGetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3GiftGetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3GiftGetAck
     * @function getTypeUrl
     * @memberof ClientTurn3GiftGetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3GiftGetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3GiftGetAck";
    };

    return ClientTurn3GiftGetAck;
})();

export const ClientTurn3PlayDataReq = $root.ClientTurn3PlayDataReq = (() => {

    /**
     * Properties of a ClientTurn3PlayDataReq.
     * @exports IClientTurn3PlayDataReq
     * @interface IClientTurn3PlayDataReq
     * @property {number|null} [UserID] ClientTurn3PlayDataReq UserID
     */

    /**
     * Constructs a new ClientTurn3PlayDataReq.
     * @exports ClientTurn3PlayDataReq
     * @classdesc Represents a ClientTurn3PlayDataReq.
     * @implements IClientTurn3PlayDataReq
     * @constructor
     * @param {IClientTurn3PlayDataReq=} [properties] Properties to set
     */
    function ClientTurn3PlayDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3PlayDataReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3PlayDataReq
     * @instance
     */
    ClientTurn3PlayDataReq.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn3PlayDataReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {IClientTurn3PlayDataReq=} [properties] Properties to set
     * @returns {ClientTurn3PlayDataReq} ClientTurn3PlayDataReq instance
     */
    ClientTurn3PlayDataReq.create = function create(properties) {
        return new ClientTurn3PlayDataReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3PlayDataReq message. Does not implicitly {@link ClientTurn3PlayDataReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {IClientTurn3PlayDataReq} message ClientTurn3PlayDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PlayDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3PlayDataReq message, length delimited. Does not implicitly {@link ClientTurn3PlayDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {IClientTurn3PlayDataReq} message ClientTurn3PlayDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PlayDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3PlayDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3PlayDataReq} ClientTurn3PlayDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PlayDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3PlayDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3PlayDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3PlayDataReq} ClientTurn3PlayDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PlayDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3PlayDataReq message.
     * @function verify
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3PlayDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3PlayDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3PlayDataReq} ClientTurn3PlayDataReq
     */
    ClientTurn3PlayDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3PlayDataReq)
            return object;
        let message = new $root.ClientTurn3PlayDataReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3PlayDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {ClientTurn3PlayDataReq} message ClientTurn3PlayDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3PlayDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn3PlayDataReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3PlayDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3PlayDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3PlayDataReq
     * @function getTypeUrl
     * @memberof ClientTurn3PlayDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3PlayDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3PlayDataReq";
    };

    return ClientTurn3PlayDataReq;
})();

export const ClientTurn3PlayDataAck = $root.ClientTurn3PlayDataAck = (() => {

    /**
     * Properties of a ClientTurn3PlayDataAck.
     * @exports IClientTurn3PlayDataAck
     * @interface IClientTurn3PlayDataAck
     * @property {number|null} [UserID] ClientTurn3PlayDataAck UserID
     * @property {string|null} [strGiftGold] ClientTurn3PlayDataAck strGiftGold
     * @property {string|null} [strGiftLimit] ClientTurn3PlayDataAck strGiftLimit
     * @property {number|null} [TurnNum] ClientTurn3PlayDataAck TurnNum
     * @property {boolean|null} [BGet] ClientTurn3PlayDataAck BGet
     * @property {number|Long|null} [NowTime] ClientTurn3PlayDataAck NowTime
     * @property {number|Long|null} [EndTime] ClientTurn3PlayDataAck EndTime
     * @property {Array.<ITurn3CellGold>|null} [Turn3Cell] ClientTurn3PlayDataAck Turn3Cell
     * @property {Array.<ITurn3GetGoldData>|null} [Turn3Data] ClientTurn3PlayDataAck Turn3Data
     */

    /**
     * Constructs a new ClientTurn3PlayDataAck.
     * @exports ClientTurn3PlayDataAck
     * @classdesc Represents a ClientTurn3PlayDataAck.
     * @implements IClientTurn3PlayDataAck
     * @constructor
     * @param {IClientTurn3PlayDataAck=} [properties] Properties to set
     */
    function ClientTurn3PlayDataAck(properties) {
        this.Turn3Cell = [];
        this.Turn3Data = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3PlayDataAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.UserID = 0;

    /**
     * ClientTurn3PlayDataAck strGiftGold.
     * @member {string} strGiftGold
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.strGiftGold = "";

    /**
     * ClientTurn3PlayDataAck strGiftLimit.
     * @member {string} strGiftLimit
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.strGiftLimit = "";

    /**
     * ClientTurn3PlayDataAck TurnNum.
     * @member {number} TurnNum
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.TurnNum = 0;

    /**
     * ClientTurn3PlayDataAck BGet.
     * @member {boolean} BGet
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.BGet = false;

    /**
     * ClientTurn3PlayDataAck NowTime.
     * @member {number|Long} NowTime
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.NowTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientTurn3PlayDataAck EndTime.
     * @member {number|Long} EndTime
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientTurn3PlayDataAck Turn3Cell.
     * @member {Array.<ITurn3CellGold>} Turn3Cell
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.Turn3Cell = $util.emptyArray;

    /**
     * ClientTurn3PlayDataAck Turn3Data.
     * @member {Array.<ITurn3GetGoldData>} Turn3Data
     * @memberof ClientTurn3PlayDataAck
     * @instance
     */
    ClientTurn3PlayDataAck.prototype.Turn3Data = $util.emptyArray;

    /**
     * Creates a new ClientTurn3PlayDataAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {IClientTurn3PlayDataAck=} [properties] Properties to set
     * @returns {ClientTurn3PlayDataAck} ClientTurn3PlayDataAck instance
     */
    ClientTurn3PlayDataAck.create = function create(properties) {
        return new ClientTurn3PlayDataAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3PlayDataAck message. Does not implicitly {@link ClientTurn3PlayDataAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {IClientTurn3PlayDataAck} message ClientTurn3PlayDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PlayDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.strGiftGold != null && Object.hasOwnProperty.call(message, "strGiftGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.strGiftGold);
        if (message.strGiftLimit != null && Object.hasOwnProperty.call(message, "strGiftLimit"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strGiftLimit);
        if (message.TurnNum != null && Object.hasOwnProperty.call(message, "TurnNum"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.TurnNum);
        if (message.BGet != null && Object.hasOwnProperty.call(message, "BGet"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.BGet);
        if (message.NowTime != null && Object.hasOwnProperty.call(message, "NowTime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.NowTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.EndTime);
        if (message.Turn3Cell != null && message.Turn3Cell.length)
            for (let i = 0; i < message.Turn3Cell.length; ++i)
                $root.Turn3CellGold.encode(message.Turn3Cell[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.Turn3Data != null && message.Turn3Data.length)
            for (let i = 0; i < message.Turn3Data.length; ++i)
                $root.Turn3GetGoldData.encode(message.Turn3Data[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3PlayDataAck message, length delimited. Does not implicitly {@link ClientTurn3PlayDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {IClientTurn3PlayDataAck} message ClientTurn3PlayDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PlayDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3PlayDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3PlayDataAck} ClientTurn3PlayDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PlayDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3PlayDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.strGiftGold = reader.string();
                    break;
                }
            case 3: {
                    message.strGiftLimit = reader.string();
                    break;
                }
            case 4: {
                    message.TurnNum = reader.uint32();
                    break;
                }
            case 5: {
                    message.BGet = reader.bool();
                    break;
                }
            case 6: {
                    message.NowTime = reader.uint64();
                    break;
                }
            case 7: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 8: {
                    if (!(message.Turn3Cell && message.Turn3Cell.length))
                        message.Turn3Cell = [];
                    message.Turn3Cell.push($root.Turn3CellGold.decode(reader, reader.uint32()));
                    break;
                }
            case 9: {
                    if (!(message.Turn3Data && message.Turn3Data.length))
                        message.Turn3Data = [];
                    message.Turn3Data.push($root.Turn3GetGoldData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3PlayDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3PlayDataAck} ClientTurn3PlayDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PlayDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3PlayDataAck message.
     * @function verify
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3PlayDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.strGiftGold != null && message.hasOwnProperty("strGiftGold"))
            if (!$util.isString(message.strGiftGold))
                return "strGiftGold: string expected";
        if (message.strGiftLimit != null && message.hasOwnProperty("strGiftLimit"))
            if (!$util.isString(message.strGiftLimit))
                return "strGiftLimit: string expected";
        if (message.TurnNum != null && message.hasOwnProperty("TurnNum"))
            if (!$util.isInteger(message.TurnNum))
                return "TurnNum: integer expected";
        if (message.BGet != null && message.hasOwnProperty("BGet"))
            if (typeof message.BGet !== "boolean")
                return "BGet: boolean expected";
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (!$util.isInteger(message.NowTime) && !(message.NowTime && $util.isInteger(message.NowTime.low) && $util.isInteger(message.NowTime.high)))
                return "NowTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.Turn3Cell != null && message.hasOwnProperty("Turn3Cell")) {
            if (!Array.isArray(message.Turn3Cell))
                return "Turn3Cell: array expected";
            for (let i = 0; i < message.Turn3Cell.length; ++i) {
                let error = $root.Turn3CellGold.verify(message.Turn3Cell[i]);
                if (error)
                    return "Turn3Cell." + error;
            }
        }
        if (message.Turn3Data != null && message.hasOwnProperty("Turn3Data")) {
            if (!Array.isArray(message.Turn3Data))
                return "Turn3Data: array expected";
            for (let i = 0; i < message.Turn3Data.length; ++i) {
                let error = $root.Turn3GetGoldData.verify(message.Turn3Data[i]);
                if (error)
                    return "Turn3Data." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientTurn3PlayDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3PlayDataAck} ClientTurn3PlayDataAck
     */
    ClientTurn3PlayDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3PlayDataAck)
            return object;
        let message = new $root.ClientTurn3PlayDataAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.strGiftGold != null)
            message.strGiftGold = String(object.strGiftGold);
        if (object.strGiftLimit != null)
            message.strGiftLimit = String(object.strGiftLimit);
        if (object.TurnNum != null)
            message.TurnNum = object.TurnNum >>> 0;
        if (object.BGet != null)
            message.BGet = Boolean(object.BGet);
        if (object.NowTime != null)
            if ($util.Long)
                (message.NowTime = $util.Long.fromValue(object.NowTime)).unsigned = true;
            else if (typeof object.NowTime === "string")
                message.NowTime = parseInt(object.NowTime, 10);
            else if (typeof object.NowTime === "number")
                message.NowTime = object.NowTime;
            else if (typeof object.NowTime === "object")
                message.NowTime = new $util.LongBits(object.NowTime.low >>> 0, object.NowTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.Turn3Cell) {
            if (!Array.isArray(object.Turn3Cell))
                throw TypeError(".ClientTurn3PlayDataAck.Turn3Cell: array expected");
            message.Turn3Cell = [];
            for (let i = 0; i < object.Turn3Cell.length; ++i) {
                if (typeof object.Turn3Cell[i] !== "object")
                    throw TypeError(".ClientTurn3PlayDataAck.Turn3Cell: object expected");
                message.Turn3Cell[i] = $root.Turn3CellGold.fromObject(object.Turn3Cell[i]);
            }
        }
        if (object.Turn3Data) {
            if (!Array.isArray(object.Turn3Data))
                throw TypeError(".ClientTurn3PlayDataAck.Turn3Data: array expected");
            message.Turn3Data = [];
            for (let i = 0; i < object.Turn3Data.length; ++i) {
                if (typeof object.Turn3Data[i] !== "object")
                    throw TypeError(".ClientTurn3PlayDataAck.Turn3Data: object expected");
                message.Turn3Data[i] = $root.Turn3GetGoldData.fromObject(object.Turn3Data[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3PlayDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {ClientTurn3PlayDataAck} message ClientTurn3PlayDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3PlayDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.Turn3Cell = [];
            object.Turn3Data = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.strGiftGold = "";
            object.strGiftLimit = "";
            object.TurnNum = 0;
            object.BGet = false;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NowTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NowTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.strGiftGold != null && message.hasOwnProperty("strGiftGold"))
            object.strGiftGold = message.strGiftGold;
        if (message.strGiftLimit != null && message.hasOwnProperty("strGiftLimit"))
            object.strGiftLimit = message.strGiftLimit;
        if (message.TurnNum != null && message.hasOwnProperty("TurnNum"))
            object.TurnNum = message.TurnNum;
        if (message.BGet != null && message.hasOwnProperty("BGet"))
            object.BGet = message.BGet;
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (typeof message.NowTime === "number")
                object.NowTime = options.longs === String ? String(message.NowTime) : message.NowTime;
            else
                object.NowTime = options.longs === String ? $util.Long.prototype.toString.call(message.NowTime) : options.longs === Number ? new $util.LongBits(message.NowTime.low >>> 0, message.NowTime.high >>> 0).toNumber(true) : message.NowTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.Turn3Cell && message.Turn3Cell.length) {
            object.Turn3Cell = [];
            for (let j = 0; j < message.Turn3Cell.length; ++j)
                object.Turn3Cell[j] = $root.Turn3CellGold.toObject(message.Turn3Cell[j], options);
        }
        if (message.Turn3Data && message.Turn3Data.length) {
            object.Turn3Data = [];
            for (let j = 0; j < message.Turn3Data.length; ++j)
                object.Turn3Data[j] = $root.Turn3GetGoldData.toObject(message.Turn3Data[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientTurn3PlayDataAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3PlayDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3PlayDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3PlayDataAck
     * @function getTypeUrl
     * @memberof ClientTurn3PlayDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3PlayDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3PlayDataAck";
    };

    return ClientTurn3PlayDataAck;
})();

export const ClientTurn3SpinReq = $root.ClientTurn3SpinReq = (() => {

    /**
     * Properties of a ClientTurn3SpinReq.
     * @exports IClientTurn3SpinReq
     * @interface IClientTurn3SpinReq
     * @property {number|null} [UserID] ClientTurn3SpinReq UserID
     */

    /**
     * Constructs a new ClientTurn3SpinReq.
     * @exports ClientTurn3SpinReq
     * @classdesc Represents a ClientTurn3SpinReq.
     * @implements IClientTurn3SpinReq
     * @constructor
     * @param {IClientTurn3SpinReq=} [properties] Properties to set
     */
    function ClientTurn3SpinReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3SpinReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3SpinReq
     * @instance
     */
    ClientTurn3SpinReq.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn3SpinReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {IClientTurn3SpinReq=} [properties] Properties to set
     * @returns {ClientTurn3SpinReq} ClientTurn3SpinReq instance
     */
    ClientTurn3SpinReq.create = function create(properties) {
        return new ClientTurn3SpinReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3SpinReq message. Does not implicitly {@link ClientTurn3SpinReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {IClientTurn3SpinReq} message ClientTurn3SpinReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3SpinReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3SpinReq message, length delimited. Does not implicitly {@link ClientTurn3SpinReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {IClientTurn3SpinReq} message ClientTurn3SpinReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3SpinReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3SpinReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3SpinReq} ClientTurn3SpinReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3SpinReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3SpinReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3SpinReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3SpinReq} ClientTurn3SpinReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3SpinReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3SpinReq message.
     * @function verify
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3SpinReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3SpinReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3SpinReq} ClientTurn3SpinReq
     */
    ClientTurn3SpinReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3SpinReq)
            return object;
        let message = new $root.ClientTurn3SpinReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3SpinReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {ClientTurn3SpinReq} message ClientTurn3SpinReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3SpinReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn3SpinReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3SpinReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3SpinReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3SpinReq
     * @function getTypeUrl
     * @memberof ClientTurn3SpinReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3SpinReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3SpinReq";
    };

    return ClientTurn3SpinReq;
})();

export const ClientTurn3SpinAck = $root.ClientTurn3SpinAck = (() => {

    /**
     * Properties of a ClientTurn3SpinAck.
     * @exports IClientTurn3SpinAck
     * @interface IClientTurn3SpinAck
     * @property {number|null} [UserID] ClientTurn3SpinAck UserID
     * @property {string|null} [strGiftLimit] ClientTurn3SpinAck strGiftLimit
     * @property {string|null} [strNowGiftGold] ClientTurn3SpinAck strNowGiftGold
     * @property {string|null} [strPlayGiftGold] ClientTurn3SpinAck strPlayGiftGold
     */

    /**
     * Constructs a new ClientTurn3SpinAck.
     * @exports ClientTurn3SpinAck
     * @classdesc Represents a ClientTurn3SpinAck.
     * @implements IClientTurn3SpinAck
     * @constructor
     * @param {IClientTurn3SpinAck=} [properties] Properties to set
     */
    function ClientTurn3SpinAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3SpinAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3SpinAck
     * @instance
     */
    ClientTurn3SpinAck.prototype.UserID = 0;

    /**
     * ClientTurn3SpinAck strGiftLimit.
     * @member {string} strGiftLimit
     * @memberof ClientTurn3SpinAck
     * @instance
     */
    ClientTurn3SpinAck.prototype.strGiftLimit = "";

    /**
     * ClientTurn3SpinAck strNowGiftGold.
     * @member {string} strNowGiftGold
     * @memberof ClientTurn3SpinAck
     * @instance
     */
    ClientTurn3SpinAck.prototype.strNowGiftGold = "";

    /**
     * ClientTurn3SpinAck strPlayGiftGold.
     * @member {string} strPlayGiftGold
     * @memberof ClientTurn3SpinAck
     * @instance
     */
    ClientTurn3SpinAck.prototype.strPlayGiftGold = "";

    /**
     * Creates a new ClientTurn3SpinAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {IClientTurn3SpinAck=} [properties] Properties to set
     * @returns {ClientTurn3SpinAck} ClientTurn3SpinAck instance
     */
    ClientTurn3SpinAck.create = function create(properties) {
        return new ClientTurn3SpinAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3SpinAck message. Does not implicitly {@link ClientTurn3SpinAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {IClientTurn3SpinAck} message ClientTurn3SpinAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3SpinAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.strGiftLimit != null && Object.hasOwnProperty.call(message, "strGiftLimit"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.strGiftLimit);
        if (message.strNowGiftGold != null && Object.hasOwnProperty.call(message, "strNowGiftGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.strNowGiftGold);
        if (message.strPlayGiftGold != null && Object.hasOwnProperty.call(message, "strPlayGiftGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.strPlayGiftGold);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3SpinAck message, length delimited. Does not implicitly {@link ClientTurn3SpinAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {IClientTurn3SpinAck} message ClientTurn3SpinAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3SpinAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3SpinAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3SpinAck} ClientTurn3SpinAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3SpinAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3SpinAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.strGiftLimit = reader.string();
                    break;
                }
            case 3: {
                    message.strNowGiftGold = reader.string();
                    break;
                }
            case 4: {
                    message.strPlayGiftGold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3SpinAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3SpinAck} ClientTurn3SpinAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3SpinAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3SpinAck message.
     * @function verify
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3SpinAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.strGiftLimit != null && message.hasOwnProperty("strGiftLimit"))
            if (!$util.isString(message.strGiftLimit))
                return "strGiftLimit: string expected";
        if (message.strNowGiftGold != null && message.hasOwnProperty("strNowGiftGold"))
            if (!$util.isString(message.strNowGiftGold))
                return "strNowGiftGold: string expected";
        if (message.strPlayGiftGold != null && message.hasOwnProperty("strPlayGiftGold"))
            if (!$util.isString(message.strPlayGiftGold))
                return "strPlayGiftGold: string expected";
        return null;
    };

    /**
     * Creates a ClientTurn3SpinAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3SpinAck} ClientTurn3SpinAck
     */
    ClientTurn3SpinAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3SpinAck)
            return object;
        let message = new $root.ClientTurn3SpinAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.strGiftLimit != null)
            message.strGiftLimit = String(object.strGiftLimit);
        if (object.strNowGiftGold != null)
            message.strNowGiftGold = String(object.strNowGiftGold);
        if (object.strPlayGiftGold != null)
            message.strPlayGiftGold = String(object.strPlayGiftGold);
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3SpinAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {ClientTurn3SpinAck} message ClientTurn3SpinAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3SpinAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.strGiftLimit = "";
            object.strNowGiftGold = "";
            object.strPlayGiftGold = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.strGiftLimit != null && message.hasOwnProperty("strGiftLimit"))
            object.strGiftLimit = message.strGiftLimit;
        if (message.strNowGiftGold != null && message.hasOwnProperty("strNowGiftGold"))
            object.strNowGiftGold = message.strNowGiftGold;
        if (message.strPlayGiftGold != null && message.hasOwnProperty("strPlayGiftGold"))
            object.strPlayGiftGold = message.strPlayGiftGold;
        return object;
    };

    /**
     * Converts this ClientTurn3SpinAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3SpinAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3SpinAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3SpinAck
     * @function getTypeUrl
     * @memberof ClientTurn3SpinAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3SpinAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3SpinAck";
    };

    return ClientTurn3SpinAck;
})();

export const ClientTurn3PrizeReq = $root.ClientTurn3PrizeReq = (() => {

    /**
     * Properties of a ClientTurn3PrizeReq.
     * @exports IClientTurn3PrizeReq
     * @interface IClientTurn3PrizeReq
     * @property {number|null} [UserID] ClientTurn3PrizeReq UserID
     * @property {number|null} [ChannelID] ClientTurn3PrizeReq ChannelID
     */

    /**
     * Constructs a new ClientTurn3PrizeReq.
     * @exports ClientTurn3PrizeReq
     * @classdesc Represents a ClientTurn3PrizeReq.
     * @implements IClientTurn3PrizeReq
     * @constructor
     * @param {IClientTurn3PrizeReq=} [properties] Properties to set
     */
    function ClientTurn3PrizeReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3PrizeReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3PrizeReq
     * @instance
     */
    ClientTurn3PrizeReq.prototype.UserID = 0;

    /**
     * ClientTurn3PrizeReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientTurn3PrizeReq
     * @instance
     */
    ClientTurn3PrizeReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientTurn3PrizeReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {IClientTurn3PrizeReq=} [properties] Properties to set
     * @returns {ClientTurn3PrizeReq} ClientTurn3PrizeReq instance
     */
    ClientTurn3PrizeReq.create = function create(properties) {
        return new ClientTurn3PrizeReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3PrizeReq message. Does not implicitly {@link ClientTurn3PrizeReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {IClientTurn3PrizeReq} message ClientTurn3PrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PrizeReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3PrizeReq message, length delimited. Does not implicitly {@link ClientTurn3PrizeReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {IClientTurn3PrizeReq} message ClientTurn3PrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PrizeReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3PrizeReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3PrizeReq} ClientTurn3PrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PrizeReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3PrizeReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3PrizeReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3PrizeReq} ClientTurn3PrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PrizeReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3PrizeReq message.
     * @function verify
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3PrizeReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3PrizeReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3PrizeReq} ClientTurn3PrizeReq
     */
    ClientTurn3PrizeReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3PrizeReq)
            return object;
        let message = new $root.ClientTurn3PrizeReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3PrizeReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {ClientTurn3PrizeReq} message ClientTurn3PrizeReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3PrizeReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientTurn3PrizeReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3PrizeReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3PrizeReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3PrizeReq
     * @function getTypeUrl
     * @memberof ClientTurn3PrizeReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3PrizeReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3PrizeReq";
    };

    return ClientTurn3PrizeReq;
})();

export const ClientTurn3PrizeAck = $root.ClientTurn3PrizeAck = (() => {

    /**
     * Properties of a ClientTurn3PrizeAck.
     * @exports IClientTurn3PrizeAck
     * @interface IClientTurn3PrizeAck
     * @property {number|null} [UserID] ClientTurn3PrizeAck UserID
     * @property {string|null} [UserGold] ClientTurn3PrizeAck UserGold
     * @property {string|null} [UserDeposit] ClientTurn3PrizeAck UserDeposit
     * @property {string|null} [UserWithdraw] ClientTurn3PrizeAck UserWithdraw
     * @property {string|null} [UserBonus] ClientTurn3PrizeAck UserBonus
     */

    /**
     * Constructs a new ClientTurn3PrizeAck.
     * @exports ClientTurn3PrizeAck
     * @classdesc Represents a ClientTurn3PrizeAck.
     * @implements IClientTurn3PrizeAck
     * @constructor
     * @param {IClientTurn3PrizeAck=} [properties] Properties to set
     */
    function ClientTurn3PrizeAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3PrizeAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3PrizeAck
     * @instance
     */
    ClientTurn3PrizeAck.prototype.UserID = 0;

    /**
     * ClientTurn3PrizeAck UserGold.
     * @member {string} UserGold
     * @memberof ClientTurn3PrizeAck
     * @instance
     */
    ClientTurn3PrizeAck.prototype.UserGold = "";

    /**
     * ClientTurn3PrizeAck UserDeposit.
     * @member {string} UserDeposit
     * @memberof ClientTurn3PrizeAck
     * @instance
     */
    ClientTurn3PrizeAck.prototype.UserDeposit = "";

    /**
     * ClientTurn3PrizeAck UserWithdraw.
     * @member {string} UserWithdraw
     * @memberof ClientTurn3PrizeAck
     * @instance
     */
    ClientTurn3PrizeAck.prototype.UserWithdraw = "";

    /**
     * ClientTurn3PrizeAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientTurn3PrizeAck
     * @instance
     */
    ClientTurn3PrizeAck.prototype.UserBonus = "";

    /**
     * Creates a new ClientTurn3PrizeAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {IClientTurn3PrizeAck=} [properties] Properties to set
     * @returns {ClientTurn3PrizeAck} ClientTurn3PrizeAck instance
     */
    ClientTurn3PrizeAck.create = function create(properties) {
        return new ClientTurn3PrizeAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3PrizeAck message. Does not implicitly {@link ClientTurn3PrizeAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {IClientTurn3PrizeAck} message ClientTurn3PrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PrizeAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.UserGold);
        if (message.UserDeposit != null && Object.hasOwnProperty.call(message, "UserDeposit"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.UserDeposit);
        if (message.UserWithdraw != null && Object.hasOwnProperty.call(message, "UserWithdraw"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.UserWithdraw);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.UserBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3PrizeAck message, length delimited. Does not implicitly {@link ClientTurn3PrizeAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {IClientTurn3PrizeAck} message ClientTurn3PrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3PrizeAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3PrizeAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3PrizeAck} ClientTurn3PrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PrizeAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3PrizeAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserGold = reader.string();
                    break;
                }
            case 3: {
                    message.UserDeposit = reader.string();
                    break;
                }
            case 4: {
                    message.UserWithdraw = reader.string();
                    break;
                }
            case 5: {
                    message.UserBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3PrizeAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3PrizeAck} ClientTurn3PrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3PrizeAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3PrizeAck message.
     * @function verify
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3PrizeAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            if (!$util.isString(message.UserDeposit))
                return "UserDeposit: string expected";
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            if (!$util.isString(message.UserWithdraw))
                return "UserWithdraw: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientTurn3PrizeAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3PrizeAck} ClientTurn3PrizeAck
     */
    ClientTurn3PrizeAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3PrizeAck)
            return object;
        let message = new $root.ClientTurn3PrizeAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserDeposit != null)
            message.UserDeposit = String(object.UserDeposit);
        if (object.UserWithdraw != null)
            message.UserWithdraw = String(object.UserWithdraw);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3PrizeAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {ClientTurn3PrizeAck} message ClientTurn3PrizeAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3PrizeAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.UserGold = "";
            object.UserDeposit = "";
            object.UserWithdraw = "";
            object.UserBonus = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            object.UserDeposit = message.UserDeposit;
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            object.UserWithdraw = message.UserWithdraw;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        return object;
    };

    /**
     * Converts this ClientTurn3PrizeAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3PrizeAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3PrizeAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3PrizeAck
     * @function getTypeUrl
     * @memberof ClientTurn3PrizeAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3PrizeAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3PrizeAck";
    };

    return ClientTurn3PrizeAck;
})();

export const ClientTurn3WinRecordReq = $root.ClientTurn3WinRecordReq = (() => {

    /**
     * Properties of a ClientTurn3WinRecordReq.
     * @exports IClientTurn3WinRecordReq
     * @interface IClientTurn3WinRecordReq
     * @property {number|null} [UserID] ClientTurn3WinRecordReq UserID
     */

    /**
     * Constructs a new ClientTurn3WinRecordReq.
     * @exports ClientTurn3WinRecordReq
     * @classdesc Represents a ClientTurn3WinRecordReq.
     * @implements IClientTurn3WinRecordReq
     * @constructor
     * @param {IClientTurn3WinRecordReq=} [properties] Properties to set
     */
    function ClientTurn3WinRecordReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3WinRecordReq UserID.
     * @member {number} UserID
     * @memberof ClientTurn3WinRecordReq
     * @instance
     */
    ClientTurn3WinRecordReq.prototype.UserID = 0;

    /**
     * Creates a new ClientTurn3WinRecordReq instance using the specified properties.
     * @function create
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {IClientTurn3WinRecordReq=} [properties] Properties to set
     * @returns {ClientTurn3WinRecordReq} ClientTurn3WinRecordReq instance
     */
    ClientTurn3WinRecordReq.create = function create(properties) {
        return new ClientTurn3WinRecordReq(properties);
    };

    /**
     * Encodes the specified ClientTurn3WinRecordReq message. Does not implicitly {@link ClientTurn3WinRecordReq.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {IClientTurn3WinRecordReq} message ClientTurn3WinRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3WinRecordReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3WinRecordReq message, length delimited. Does not implicitly {@link ClientTurn3WinRecordReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {IClientTurn3WinRecordReq} message ClientTurn3WinRecordReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3WinRecordReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3WinRecordReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3WinRecordReq} ClientTurn3WinRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3WinRecordReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3WinRecordReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3WinRecordReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3WinRecordReq} ClientTurn3WinRecordReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3WinRecordReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3WinRecordReq message.
     * @function verify
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3WinRecordReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientTurn3WinRecordReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3WinRecordReq} ClientTurn3WinRecordReq
     */
    ClientTurn3WinRecordReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3WinRecordReq)
            return object;
        let message = new $root.ClientTurn3WinRecordReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3WinRecordReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {ClientTurn3WinRecordReq} message ClientTurn3WinRecordReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3WinRecordReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientTurn3WinRecordReq to JSON.
     * @function toJSON
     * @memberof ClientTurn3WinRecordReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3WinRecordReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3WinRecordReq
     * @function getTypeUrl
     * @memberof ClientTurn3WinRecordReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3WinRecordReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3WinRecordReq";
    };

    return ClientTurn3WinRecordReq;
})();

export const ClientTurn3WinRecordAck = $root.ClientTurn3WinRecordAck = (() => {

    /**
     * Properties of a ClientTurn3WinRecordAck.
     * @exports IClientTurn3WinRecordAck
     * @interface IClientTurn3WinRecordAck
     * @property {number|null} [UserID] ClientTurn3WinRecordAck UserID
     * @property {Array.<ITurn3GetWinRecordData>|null} [Turn3WinRecordData] ClientTurn3WinRecordAck Turn3WinRecordData
     */

    /**
     * Constructs a new ClientTurn3WinRecordAck.
     * @exports ClientTurn3WinRecordAck
     * @classdesc Represents a ClientTurn3WinRecordAck.
     * @implements IClientTurn3WinRecordAck
     * @constructor
     * @param {IClientTurn3WinRecordAck=} [properties] Properties to set
     */
    function ClientTurn3WinRecordAck(properties) {
        this.Turn3WinRecordData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientTurn3WinRecordAck UserID.
     * @member {number} UserID
     * @memberof ClientTurn3WinRecordAck
     * @instance
     */
    ClientTurn3WinRecordAck.prototype.UserID = 0;

    /**
     * ClientTurn3WinRecordAck Turn3WinRecordData.
     * @member {Array.<ITurn3GetWinRecordData>} Turn3WinRecordData
     * @memberof ClientTurn3WinRecordAck
     * @instance
     */
    ClientTurn3WinRecordAck.prototype.Turn3WinRecordData = $util.emptyArray;

    /**
     * Creates a new ClientTurn3WinRecordAck instance using the specified properties.
     * @function create
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {IClientTurn3WinRecordAck=} [properties] Properties to set
     * @returns {ClientTurn3WinRecordAck} ClientTurn3WinRecordAck instance
     */
    ClientTurn3WinRecordAck.create = function create(properties) {
        return new ClientTurn3WinRecordAck(properties);
    };

    /**
     * Encodes the specified ClientTurn3WinRecordAck message. Does not implicitly {@link ClientTurn3WinRecordAck.verify|verify} messages.
     * @function encode
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {IClientTurn3WinRecordAck} message ClientTurn3WinRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3WinRecordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Turn3WinRecordData != null && message.Turn3WinRecordData.length)
            for (let i = 0; i < message.Turn3WinRecordData.length; ++i)
                $root.Turn3GetWinRecordData.encode(message.Turn3WinRecordData[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientTurn3WinRecordAck message, length delimited. Does not implicitly {@link ClientTurn3WinRecordAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {IClientTurn3WinRecordAck} message ClientTurn3WinRecordAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientTurn3WinRecordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientTurn3WinRecordAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientTurn3WinRecordAck} ClientTurn3WinRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3WinRecordAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientTurn3WinRecordAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.Turn3WinRecordData && message.Turn3WinRecordData.length))
                        message.Turn3WinRecordData = [];
                    message.Turn3WinRecordData.push($root.Turn3GetWinRecordData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientTurn3WinRecordAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientTurn3WinRecordAck} ClientTurn3WinRecordAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientTurn3WinRecordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientTurn3WinRecordAck message.
     * @function verify
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientTurn3WinRecordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Turn3WinRecordData != null && message.hasOwnProperty("Turn3WinRecordData")) {
            if (!Array.isArray(message.Turn3WinRecordData))
                return "Turn3WinRecordData: array expected";
            for (let i = 0; i < message.Turn3WinRecordData.length; ++i) {
                let error = $root.Turn3GetWinRecordData.verify(message.Turn3WinRecordData[i]);
                if (error)
                    return "Turn3WinRecordData." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientTurn3WinRecordAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientTurn3WinRecordAck} ClientTurn3WinRecordAck
     */
    ClientTurn3WinRecordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientTurn3WinRecordAck)
            return object;
        let message = new $root.ClientTurn3WinRecordAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Turn3WinRecordData) {
            if (!Array.isArray(object.Turn3WinRecordData))
                throw TypeError(".ClientTurn3WinRecordAck.Turn3WinRecordData: array expected");
            message.Turn3WinRecordData = [];
            for (let i = 0; i < object.Turn3WinRecordData.length; ++i) {
                if (typeof object.Turn3WinRecordData[i] !== "object")
                    throw TypeError(".ClientTurn3WinRecordAck.Turn3WinRecordData: object expected");
                message.Turn3WinRecordData[i] = $root.Turn3GetWinRecordData.fromObject(object.Turn3WinRecordData[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientTurn3WinRecordAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {ClientTurn3WinRecordAck} message ClientTurn3WinRecordAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientTurn3WinRecordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Turn3WinRecordData = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Turn3WinRecordData && message.Turn3WinRecordData.length) {
            object.Turn3WinRecordData = [];
            for (let j = 0; j < message.Turn3WinRecordData.length; ++j)
                object.Turn3WinRecordData[j] = $root.Turn3GetWinRecordData.toObject(message.Turn3WinRecordData[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientTurn3WinRecordAck to JSON.
     * @function toJSON
     * @memberof ClientTurn3WinRecordAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientTurn3WinRecordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientTurn3WinRecordAck
     * @function getTypeUrl
     * @memberof ClientTurn3WinRecordAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientTurn3WinRecordAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientTurn3WinRecordAck";
    };

    return ClientTurn3WinRecordAck;
})();

export const ClientSignActivityReq = $root.ClientSignActivityReq = (() => {

    /**
     * Properties of a ClientSignActivityReq.
     * @exports IClientSignActivityReq
     * @interface IClientSignActivityReq
     * @property {number|null} [UserID] ClientSignActivityReq UserID
     * @property {number|null} [ChannelID] ClientSignActivityReq ChannelID
     */

    /**
     * Constructs a new ClientSignActivityReq.
     * @exports ClientSignActivityReq
     * @classdesc Represents a ClientSignActivityReq.
     * @implements IClientSignActivityReq
     * @constructor
     * @param {IClientSignActivityReq=} [properties] Properties to set
     */
    function ClientSignActivityReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityReq UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityReq
     * @instance
     */
    ClientSignActivityReq.prototype.UserID = 0;

    /**
     * ClientSignActivityReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityReq
     * @instance
     */
    ClientSignActivityReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientSignActivityReq instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityReq
     * @static
     * @param {IClientSignActivityReq=} [properties] Properties to set
     * @returns {ClientSignActivityReq} ClientSignActivityReq instance
     */
    ClientSignActivityReq.create = function create(properties) {
        return new ClientSignActivityReq(properties);
    };

    /**
     * Encodes the specified ClientSignActivityReq message. Does not implicitly {@link ClientSignActivityReq.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityReq
     * @static
     * @param {IClientSignActivityReq} message ClientSignActivityReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityReq message, length delimited. Does not implicitly {@link ClientSignActivityReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityReq
     * @static
     * @param {IClientSignActivityReq} message ClientSignActivityReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityReq} ClientSignActivityReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityReq} ClientSignActivityReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityReq message.
     * @function verify
     * @memberof ClientSignActivityReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityReq} ClientSignActivityReq
     */
    ClientSignActivityReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityReq)
            return object;
        let message = new $root.ClientSignActivityReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityReq
     * @static
     * @param {ClientSignActivityReq} message ClientSignActivityReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientSignActivityReq to JSON.
     * @function toJSON
     * @memberof ClientSignActivityReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityReq
     * @function getTypeUrl
     * @memberof ClientSignActivityReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityReq";
    };

    return ClientSignActivityReq;
})();

export const ClientSignActivityAck = $root.ClientSignActivityAck = (() => {

    /**
     * Properties of a ClientSignActivityAck.
     * @exports IClientSignActivityAck
     * @interface IClientSignActivityAck
     * @property {number|null} [ret] ClientSignActivityAck ret
     * @property {number|null} [UserID] ClientSignActivityAck UserID
     * @property {number|null} [ChannelID] ClientSignActivityAck ChannelID
     * @property {string|null} [Sign7Cof] ClientSignActivityAck Sign7Cof
     * @property {number|null} [Sign7Date] ClientSignActivityAck Sign7Date
     * @property {number|null} [Sign7Status] ClientSignActivityAck Sign7Status
     * @property {string|null} [Sign30Cof] ClientSignActivityAck Sign30Cof
     * @property {number|null} [Sign30Date] ClientSignActivityAck Sign30Date
     * @property {string|null} [Sign30Status] ClientSignActivityAck Sign30Status
     * @property {number|null} [DateTop] ClientSignActivityAck DateTop
     * @property {number|null} [ProgUpg] ClientSignActivityAck ProgUpg
     */

    /**
     * Constructs a new ClientSignActivityAck.
     * @exports ClientSignActivityAck
     * @classdesc Represents a ClientSignActivityAck.
     * @implements IClientSignActivityAck
     * @constructor
     * @param {IClientSignActivityAck=} [properties] Properties to set
     */
    function ClientSignActivityAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityAck ret.
     * @member {number} ret
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.ret = 0;

    /**
     * ClientSignActivityAck UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.UserID = 0;

    /**
     * ClientSignActivityAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.ChannelID = 0;

    /**
     * ClientSignActivityAck Sign7Cof.
     * @member {string} Sign7Cof
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign7Cof = "";

    /**
     * ClientSignActivityAck Sign7Date.
     * @member {number} Sign7Date
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign7Date = 0;

    /**
     * ClientSignActivityAck Sign7Status.
     * @member {number} Sign7Status
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign7Status = 0;

    /**
     * ClientSignActivityAck Sign30Cof.
     * @member {string} Sign30Cof
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign30Cof = "";

    /**
     * ClientSignActivityAck Sign30Date.
     * @member {number} Sign30Date
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign30Date = 0;

    /**
     * ClientSignActivityAck Sign30Status.
     * @member {string} Sign30Status
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.Sign30Status = "";

    /**
     * ClientSignActivityAck DateTop.
     * @member {number} DateTop
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.DateTop = 0;

    /**
     * ClientSignActivityAck ProgUpg.
     * @member {number} ProgUpg
     * @memberof ClientSignActivityAck
     * @instance
     */
    ClientSignActivityAck.prototype.ProgUpg = 0;

    /**
     * Creates a new ClientSignActivityAck instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityAck
     * @static
     * @param {IClientSignActivityAck=} [properties] Properties to set
     * @returns {ClientSignActivityAck} ClientSignActivityAck instance
     */
    ClientSignActivityAck.create = function create(properties) {
        return new ClientSignActivityAck(properties);
    };

    /**
     * Encodes the specified ClientSignActivityAck message. Does not implicitly {@link ClientSignActivityAck.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityAck
     * @static
     * @param {IClientSignActivityAck} message ClientSignActivityAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.Sign7Cof != null && Object.hasOwnProperty.call(message, "Sign7Cof"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Sign7Cof);
        if (message.Sign7Date != null && Object.hasOwnProperty.call(message, "Sign7Date"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Sign7Date);
        if (message.Sign7Status != null && Object.hasOwnProperty.call(message, "Sign7Status"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Sign7Status);
        if (message.Sign30Cof != null && Object.hasOwnProperty.call(message, "Sign30Cof"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.Sign30Cof);
        if (message.Sign30Date != null && Object.hasOwnProperty.call(message, "Sign30Date"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Sign30Date);
        if (message.Sign30Status != null && Object.hasOwnProperty.call(message, "Sign30Status"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Sign30Status);
        if (message.DateTop != null && Object.hasOwnProperty.call(message, "DateTop"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.DateTop);
        if (message.ProgUpg != null && Object.hasOwnProperty.call(message, "ProgUpg"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.ProgUpg);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityAck message, length delimited. Does not implicitly {@link ClientSignActivityAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityAck
     * @static
     * @param {IClientSignActivityAck} message ClientSignActivityAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityAck} ClientSignActivityAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Sign7Cof = reader.string();
                    break;
                }
            case 5: {
                    message.Sign7Date = reader.uint32();
                    break;
                }
            case 6: {
                    message.Sign7Status = reader.uint32();
                    break;
                }
            case 7: {
                    message.Sign30Cof = reader.string();
                    break;
                }
            case 8: {
                    message.Sign30Date = reader.uint32();
                    break;
                }
            case 9: {
                    message.Sign30Status = reader.string();
                    break;
                }
            case 10: {
                    message.DateTop = reader.uint32();
                    break;
                }
            case 11: {
                    message.ProgUpg = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityAck} ClientSignActivityAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityAck message.
     * @function verify
     * @memberof ClientSignActivityAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.Sign7Cof != null && message.hasOwnProperty("Sign7Cof"))
            if (!$util.isString(message.Sign7Cof))
                return "Sign7Cof: string expected";
        if (message.Sign7Date != null && message.hasOwnProperty("Sign7Date"))
            if (!$util.isInteger(message.Sign7Date))
                return "Sign7Date: integer expected";
        if (message.Sign7Status != null && message.hasOwnProperty("Sign7Status"))
            if (!$util.isInteger(message.Sign7Status))
                return "Sign7Status: integer expected";
        if (message.Sign30Cof != null && message.hasOwnProperty("Sign30Cof"))
            if (!$util.isString(message.Sign30Cof))
                return "Sign30Cof: string expected";
        if (message.Sign30Date != null && message.hasOwnProperty("Sign30Date"))
            if (!$util.isInteger(message.Sign30Date))
                return "Sign30Date: integer expected";
        if (message.Sign30Status != null && message.hasOwnProperty("Sign30Status"))
            if (!$util.isString(message.Sign30Status))
                return "Sign30Status: string expected";
        if (message.DateTop != null && message.hasOwnProperty("DateTop"))
            if (!$util.isInteger(message.DateTop))
                return "DateTop: integer expected";
        if (message.ProgUpg != null && message.hasOwnProperty("ProgUpg"))
            if (!$util.isInteger(message.ProgUpg))
                return "ProgUpg: integer expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityAck} ClientSignActivityAck
     */
    ClientSignActivityAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityAck)
            return object;
        let message = new $root.ClientSignActivityAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.Sign7Cof != null)
            message.Sign7Cof = String(object.Sign7Cof);
        if (object.Sign7Date != null)
            message.Sign7Date = object.Sign7Date >>> 0;
        if (object.Sign7Status != null)
            message.Sign7Status = object.Sign7Status >>> 0;
        if (object.Sign30Cof != null)
            message.Sign30Cof = String(object.Sign30Cof);
        if (object.Sign30Date != null)
            message.Sign30Date = object.Sign30Date >>> 0;
        if (object.Sign30Status != null)
            message.Sign30Status = String(object.Sign30Status);
        if (object.DateTop != null)
            message.DateTop = object.DateTop >>> 0;
        if (object.ProgUpg != null)
            message.ProgUpg = object.ProgUpg >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityAck
     * @static
     * @param {ClientSignActivityAck} message ClientSignActivityAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.Sign7Cof = "";
            object.Sign7Date = 0;
            object.Sign7Status = 0;
            object.Sign30Cof = "";
            object.Sign30Date = 0;
            object.Sign30Status = "";
            object.DateTop = 0;
            object.ProgUpg = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.Sign7Cof != null && message.hasOwnProperty("Sign7Cof"))
            object.Sign7Cof = message.Sign7Cof;
        if (message.Sign7Date != null && message.hasOwnProperty("Sign7Date"))
            object.Sign7Date = message.Sign7Date;
        if (message.Sign7Status != null && message.hasOwnProperty("Sign7Status"))
            object.Sign7Status = message.Sign7Status;
        if (message.Sign30Cof != null && message.hasOwnProperty("Sign30Cof"))
            object.Sign30Cof = message.Sign30Cof;
        if (message.Sign30Date != null && message.hasOwnProperty("Sign30Date"))
            object.Sign30Date = message.Sign30Date;
        if (message.Sign30Status != null && message.hasOwnProperty("Sign30Status"))
            object.Sign30Status = message.Sign30Status;
        if (message.DateTop != null && message.hasOwnProperty("DateTop"))
            object.DateTop = message.DateTop;
        if (message.ProgUpg != null && message.hasOwnProperty("ProgUpg"))
            object.ProgUpg = message.ProgUpg;
        return object;
    };

    /**
     * Converts this ClientSignActivityAck to JSON.
     * @function toJSON
     * @memberof ClientSignActivityAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityAck
     * @function getTypeUrl
     * @memberof ClientSignActivityAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityAck";
    };

    return ClientSignActivityAck;
})();

export const ClientSignActivityAggReq = $root.ClientSignActivityAggReq = (() => {

    /**
     * Properties of a ClientSignActivityAggReq.
     * @exports IClientSignActivityAggReq
     * @interface IClientSignActivityAggReq
     * @property {number|null} [UserID] ClientSignActivityAggReq UserID
     * @property {number|null} [ChannelID] ClientSignActivityAggReq ChannelID
     * @property {number|null} [Propward] ClientSignActivityAggReq Propward
     */

    /**
     * Constructs a new ClientSignActivityAggReq.
     * @exports ClientSignActivityAggReq
     * @classdesc Represents a ClientSignActivityAggReq.
     * @implements IClientSignActivityAggReq
     * @constructor
     * @param {IClientSignActivityAggReq=} [properties] Properties to set
     */
    function ClientSignActivityAggReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityAggReq UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityAggReq
     * @instance
     */
    ClientSignActivityAggReq.prototype.UserID = 0;

    /**
     * ClientSignActivityAggReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityAggReq
     * @instance
     */
    ClientSignActivityAggReq.prototype.ChannelID = 0;

    /**
     * ClientSignActivityAggReq Propward.
     * @member {number} Propward
     * @memberof ClientSignActivityAggReq
     * @instance
     */
    ClientSignActivityAggReq.prototype.Propward = 0;

    /**
     * Creates a new ClientSignActivityAggReq instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {IClientSignActivityAggReq=} [properties] Properties to set
     * @returns {ClientSignActivityAggReq} ClientSignActivityAggReq instance
     */
    ClientSignActivityAggReq.create = function create(properties) {
        return new ClientSignActivityAggReq(properties);
    };

    /**
     * Encodes the specified ClientSignActivityAggReq message. Does not implicitly {@link ClientSignActivityAggReq.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {IClientSignActivityAggReq} message ClientSignActivityAggReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAggReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.Propward != null && Object.hasOwnProperty.call(message, "Propward"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Propward);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityAggReq message, length delimited. Does not implicitly {@link ClientSignActivityAggReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {IClientSignActivityAggReq} message ClientSignActivityAggReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAggReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityAggReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityAggReq} ClientSignActivityAggReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAggReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityAggReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Propward = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityAggReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityAggReq} ClientSignActivityAggReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAggReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityAggReq message.
     * @function verify
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityAggReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.Propward != null && message.hasOwnProperty("Propward"))
            if (!$util.isInteger(message.Propward))
                return "Propward: integer expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityAggReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityAggReq} ClientSignActivityAggReq
     */
    ClientSignActivityAggReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityAggReq)
            return object;
        let message = new $root.ClientSignActivityAggReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.Propward != null)
            message.Propward = object.Propward >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityAggReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {ClientSignActivityAggReq} message ClientSignActivityAggReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityAggReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.Propward = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.Propward != null && message.hasOwnProperty("Propward"))
            object.Propward = message.Propward;
        return object;
    };

    /**
     * Converts this ClientSignActivityAggReq to JSON.
     * @function toJSON
     * @memberof ClientSignActivityAggReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityAggReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityAggReq
     * @function getTypeUrl
     * @memberof ClientSignActivityAggReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityAggReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityAggReq";
    };

    return ClientSignActivityAggReq;
})();

export const ClientSignActivityAggAck = $root.ClientSignActivityAggAck = (() => {

    /**
     * Properties of a ClientSignActivityAggAck.
     * @exports IClientSignActivityAggAck
     * @interface IClientSignActivityAggAck
     * @property {number|null} [ret] ClientSignActivityAggAck ret
     * @property {number|null} [UserID] ClientSignActivityAggAck UserID
     * @property {number|null} [ChannelID] ClientSignActivityAggAck ChannelID
     * @property {string|null} [UserGold] ClientSignActivityAggAck UserGold
     * @property {string|null} [UserDeposit] ClientSignActivityAggAck UserDeposit
     * @property {string|null} [UserWithdraw] ClientSignActivityAggAck UserWithdraw
     * @property {string|null} [UserBonus] ClientSignActivityAggAck UserBonus
     */

    /**
     * Constructs a new ClientSignActivityAggAck.
     * @exports ClientSignActivityAggAck
     * @classdesc Represents a ClientSignActivityAggAck.
     * @implements IClientSignActivityAggAck
     * @constructor
     * @param {IClientSignActivityAggAck=} [properties] Properties to set
     */
    function ClientSignActivityAggAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityAggAck ret.
     * @member {number} ret
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.ret = 0;

    /**
     * ClientSignActivityAggAck UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.UserID = 0;

    /**
     * ClientSignActivityAggAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.ChannelID = 0;

    /**
     * ClientSignActivityAggAck UserGold.
     * @member {string} UserGold
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.UserGold = "";

    /**
     * ClientSignActivityAggAck UserDeposit.
     * @member {string} UserDeposit
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.UserDeposit = "";

    /**
     * ClientSignActivityAggAck UserWithdraw.
     * @member {string} UserWithdraw
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.UserWithdraw = "";

    /**
     * ClientSignActivityAggAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientSignActivityAggAck
     * @instance
     */
    ClientSignActivityAggAck.prototype.UserBonus = "";

    /**
     * Creates a new ClientSignActivityAggAck instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {IClientSignActivityAggAck=} [properties] Properties to set
     * @returns {ClientSignActivityAggAck} ClientSignActivityAggAck instance
     */
    ClientSignActivityAggAck.create = function create(properties) {
        return new ClientSignActivityAggAck(properties);
    };

    /**
     * Encodes the specified ClientSignActivityAggAck message. Does not implicitly {@link ClientSignActivityAggAck.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {IClientSignActivityAggAck} message ClientSignActivityAggAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAggAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.UserGold);
        if (message.UserDeposit != null && Object.hasOwnProperty.call(message, "UserDeposit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.UserDeposit);
        if (message.UserWithdraw != null && Object.hasOwnProperty.call(message, "UserWithdraw"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.UserWithdraw);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.UserBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityAggAck message, length delimited. Does not implicitly {@link ClientSignActivityAggAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {IClientSignActivityAggAck} message ClientSignActivityAggAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityAggAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityAggAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityAggAck} ClientSignActivityAggAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAggAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityAggAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.UserGold = reader.string();
                    break;
                }
            case 5: {
                    message.UserDeposit = reader.string();
                    break;
                }
            case 6: {
                    message.UserWithdraw = reader.string();
                    break;
                }
            case 7: {
                    message.UserBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityAggAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityAggAck} ClientSignActivityAggAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityAggAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityAggAck message.
     * @function verify
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityAggAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            if (!$util.isString(message.UserDeposit))
                return "UserDeposit: string expected";
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            if (!$util.isString(message.UserWithdraw))
                return "UserWithdraw: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityAggAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityAggAck} ClientSignActivityAggAck
     */
    ClientSignActivityAggAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityAggAck)
            return object;
        let message = new $root.ClientSignActivityAggAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserDeposit != null)
            message.UserDeposit = String(object.UserDeposit);
        if (object.UserWithdraw != null)
            message.UserWithdraw = String(object.UserWithdraw);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityAggAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {ClientSignActivityAggAck} message ClientSignActivityAggAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityAggAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.UserGold = "";
            object.UserDeposit = "";
            object.UserWithdraw = "";
            object.UserBonus = "";
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            object.UserDeposit = message.UserDeposit;
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            object.UserWithdraw = message.UserWithdraw;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        return object;
    };

    /**
     * Converts this ClientSignActivityAggAck to JSON.
     * @function toJSON
     * @memberof ClientSignActivityAggAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityAggAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityAggAck
     * @function getTypeUrl
     * @memberof ClientSignActivityAggAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityAggAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityAggAck";
    };

    return ClientSignActivityAggAck;
})();

export const ClientSignActivityInReq = $root.ClientSignActivityInReq = (() => {

    /**
     * Properties of a ClientSignActivityInReq.
     * @exports IClientSignActivityInReq
     * @interface IClientSignActivityInReq
     * @property {number|null} [UserID] ClientSignActivityInReq UserID
     * @property {number|null} [ChannelID] ClientSignActivityInReq ChannelID
     * @property {number|null} [SignType] ClientSignActivityInReq SignType
     */

    /**
     * Constructs a new ClientSignActivityInReq.
     * @exports ClientSignActivityInReq
     * @classdesc Represents a ClientSignActivityInReq.
     * @implements IClientSignActivityInReq
     * @constructor
     * @param {IClientSignActivityInReq=} [properties] Properties to set
     */
    function ClientSignActivityInReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityInReq UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityInReq
     * @instance
     */
    ClientSignActivityInReq.prototype.UserID = 0;

    /**
     * ClientSignActivityInReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityInReq
     * @instance
     */
    ClientSignActivityInReq.prototype.ChannelID = 0;

    /**
     * ClientSignActivityInReq SignType.
     * @member {number} SignType
     * @memberof ClientSignActivityInReq
     * @instance
     */
    ClientSignActivityInReq.prototype.SignType = 0;

    /**
     * Creates a new ClientSignActivityInReq instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityInReq
     * @static
     * @param {IClientSignActivityInReq=} [properties] Properties to set
     * @returns {ClientSignActivityInReq} ClientSignActivityInReq instance
     */
    ClientSignActivityInReq.create = function create(properties) {
        return new ClientSignActivityInReq(properties);
    };

    /**
     * Encodes the specified ClientSignActivityInReq message. Does not implicitly {@link ClientSignActivityInReq.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityInReq
     * @static
     * @param {IClientSignActivityInReq} message ClientSignActivityInReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityInReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.SignType != null && Object.hasOwnProperty.call(message, "SignType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.SignType);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityInReq message, length delimited. Does not implicitly {@link ClientSignActivityInReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityInReq
     * @static
     * @param {IClientSignActivityInReq} message ClientSignActivityInReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityInReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityInReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityInReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityInReq} ClientSignActivityInReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityInReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityInReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SignType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityInReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityInReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityInReq} ClientSignActivityInReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityInReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityInReq message.
     * @function verify
     * @memberof ClientSignActivityInReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityInReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.SignType != null && message.hasOwnProperty("SignType"))
            if (!$util.isInteger(message.SignType))
                return "SignType: integer expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityInReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityInReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityInReq} ClientSignActivityInReq
     */
    ClientSignActivityInReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityInReq)
            return object;
        let message = new $root.ClientSignActivityInReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.SignType != null)
            message.SignType = object.SignType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityInReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityInReq
     * @static
     * @param {ClientSignActivityInReq} message ClientSignActivityInReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityInReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.SignType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.SignType != null && message.hasOwnProperty("SignType"))
            object.SignType = message.SignType;
        return object;
    };

    /**
     * Converts this ClientSignActivityInReq to JSON.
     * @function toJSON
     * @memberof ClientSignActivityInReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityInReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityInReq
     * @function getTypeUrl
     * @memberof ClientSignActivityInReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityInReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityInReq";
    };

    return ClientSignActivityInReq;
})();

export const ClientSignActivityInAck = $root.ClientSignActivityInAck = (() => {

    /**
     * Properties of a ClientSignActivityInAck.
     * @exports IClientSignActivityInAck
     * @interface IClientSignActivityInAck
     * @property {number|null} [ret] ClientSignActivityInAck ret
     * @property {number|null} [UserID] ClientSignActivityInAck UserID
     * @property {number|null} [ChannelID] ClientSignActivityInAck ChannelID
     * @property {number|null} [SignType] ClientSignActivityInAck SignType
     * @property {number|null} [MultNum] ClientSignActivityInAck MultNum
     * @property {string|null} [UserGold] ClientSignActivityInAck UserGold
     * @property {string|null} [UserDeposit] ClientSignActivityInAck UserDeposit
     * @property {string|null} [UserWithdraw] ClientSignActivityInAck UserWithdraw
     * @property {string|null} [UserBonus] ClientSignActivityInAck UserBonus
     */

    /**
     * Constructs a new ClientSignActivityInAck.
     * @exports ClientSignActivityInAck
     * @classdesc Represents a ClientSignActivityInAck.
     * @implements IClientSignActivityInAck
     * @constructor
     * @param {IClientSignActivityInAck=} [properties] Properties to set
     */
    function ClientSignActivityInAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSignActivityInAck ret.
     * @member {number} ret
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.ret = 0;

    /**
     * ClientSignActivityInAck UserID.
     * @member {number} UserID
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.UserID = 0;

    /**
     * ClientSignActivityInAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.ChannelID = 0;

    /**
     * ClientSignActivityInAck SignType.
     * @member {number} SignType
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.SignType = 0;

    /**
     * ClientSignActivityInAck MultNum.
     * @member {number} MultNum
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.MultNum = 0;

    /**
     * ClientSignActivityInAck UserGold.
     * @member {string} UserGold
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.UserGold = "";

    /**
     * ClientSignActivityInAck UserDeposit.
     * @member {string} UserDeposit
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.UserDeposit = "";

    /**
     * ClientSignActivityInAck UserWithdraw.
     * @member {string} UserWithdraw
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.UserWithdraw = "";

    /**
     * ClientSignActivityInAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientSignActivityInAck
     * @instance
     */
    ClientSignActivityInAck.prototype.UserBonus = "";

    /**
     * Creates a new ClientSignActivityInAck instance using the specified properties.
     * @function create
     * @memberof ClientSignActivityInAck
     * @static
     * @param {IClientSignActivityInAck=} [properties] Properties to set
     * @returns {ClientSignActivityInAck} ClientSignActivityInAck instance
     */
    ClientSignActivityInAck.create = function create(properties) {
        return new ClientSignActivityInAck(properties);
    };

    /**
     * Encodes the specified ClientSignActivityInAck message. Does not implicitly {@link ClientSignActivityInAck.verify|verify} messages.
     * @function encode
     * @memberof ClientSignActivityInAck
     * @static
     * @param {IClientSignActivityInAck} message ClientSignActivityInAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityInAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.SignType != null && Object.hasOwnProperty.call(message, "SignType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SignType);
        if (message.MultNum != null && Object.hasOwnProperty.call(message, "MultNum"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.MultNum);
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.UserGold);
        if (message.UserDeposit != null && Object.hasOwnProperty.call(message, "UserDeposit"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.UserDeposit);
        if (message.UserWithdraw != null && Object.hasOwnProperty.call(message, "UserWithdraw"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.UserWithdraw);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.UserBonus);
        return writer;
    };

    /**
     * Encodes the specified ClientSignActivityInAck message, length delimited. Does not implicitly {@link ClientSignActivityInAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSignActivityInAck
     * @static
     * @param {IClientSignActivityInAck} message ClientSignActivityInAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSignActivityInAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSignActivityInAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSignActivityInAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSignActivityInAck} ClientSignActivityInAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityInAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSignActivityInAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SignType = reader.uint32();
                    break;
                }
            case 5: {
                    message.MultNum = reader.uint32();
                    break;
                }
            case 6: {
                    message.UserGold = reader.string();
                    break;
                }
            case 7: {
                    message.UserDeposit = reader.string();
                    break;
                }
            case 8: {
                    message.UserWithdraw = reader.string();
                    break;
                }
            case 9: {
                    message.UserBonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSignActivityInAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSignActivityInAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSignActivityInAck} ClientSignActivityInAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSignActivityInAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSignActivityInAck message.
     * @function verify
     * @memberof ClientSignActivityInAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSignActivityInAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.SignType != null && message.hasOwnProperty("SignType"))
            if (!$util.isInteger(message.SignType))
                return "SignType: integer expected";
        if (message.MultNum != null && message.hasOwnProperty("MultNum"))
            if (!$util.isInteger(message.MultNum))
                return "MultNum: integer expected";
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            if (!$util.isString(message.UserDeposit))
                return "UserDeposit: string expected";
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            if (!$util.isString(message.UserWithdraw))
                return "UserWithdraw: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        return null;
    };

    /**
     * Creates a ClientSignActivityInAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSignActivityInAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSignActivityInAck} ClientSignActivityInAck
     */
    ClientSignActivityInAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSignActivityInAck)
            return object;
        let message = new $root.ClientSignActivityInAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.SignType != null)
            message.SignType = object.SignType >>> 0;
        if (object.MultNum != null)
            message.MultNum = object.MultNum >>> 0;
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserDeposit != null)
            message.UserDeposit = String(object.UserDeposit);
        if (object.UserWithdraw != null)
            message.UserWithdraw = String(object.UserWithdraw);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        return message;
    };

    /**
     * Creates a plain object from a ClientSignActivityInAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSignActivityInAck
     * @static
     * @param {ClientSignActivityInAck} message ClientSignActivityInAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSignActivityInAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.SignType = 0;
            object.MultNum = 0;
            object.UserGold = "";
            object.UserDeposit = "";
            object.UserWithdraw = "";
            object.UserBonus = "";
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.SignType != null && message.hasOwnProperty("SignType"))
            object.SignType = message.SignType;
        if (message.MultNum != null && message.hasOwnProperty("MultNum"))
            object.MultNum = message.MultNum;
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserDeposit != null && message.hasOwnProperty("UserDeposit"))
            object.UserDeposit = message.UserDeposit;
        if (message.UserWithdraw != null && message.hasOwnProperty("UserWithdraw"))
            object.UserWithdraw = message.UserWithdraw;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        return object;
    };

    /**
     * Converts this ClientSignActivityInAck to JSON.
     * @function toJSON
     * @memberof ClientSignActivityInAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSignActivityInAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSignActivityInAck
     * @function getTypeUrl
     * @memberof ClientSignActivityInAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSignActivityInAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSignActivityInAck";
    };

    return ClientSignActivityInAck;
})();

export const ClientLuckySpinGetReq = $root.ClientLuckySpinGetReq = (() => {

    /**
     * Properties of a ClientLuckySpinGetReq.
     * @exports IClientLuckySpinGetReq
     * @interface IClientLuckySpinGetReq
     * @property {number|null} [UserID] ClientLuckySpinGetReq UserID
     */

    /**
     * Constructs a new ClientLuckySpinGetReq.
     * @exports ClientLuckySpinGetReq
     * @classdesc Represents a ClientLuckySpinGetReq.
     * @implements IClientLuckySpinGetReq
     * @constructor
     * @param {IClientLuckySpinGetReq=} [properties] Properties to set
     */
    function ClientLuckySpinGetReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientLuckySpinGetReq UserID.
     * @member {number} UserID
     * @memberof ClientLuckySpinGetReq
     * @instance
     */
    ClientLuckySpinGetReq.prototype.UserID = 0;

    /**
     * Creates a new ClientLuckySpinGetReq instance using the specified properties.
     * @function create
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {IClientLuckySpinGetReq=} [properties] Properties to set
     * @returns {ClientLuckySpinGetReq} ClientLuckySpinGetReq instance
     */
    ClientLuckySpinGetReq.create = function create(properties) {
        return new ClientLuckySpinGetReq(properties);
    };

    /**
     * Encodes the specified ClientLuckySpinGetReq message. Does not implicitly {@link ClientLuckySpinGetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {IClientLuckySpinGetReq} message ClientLuckySpinGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinGetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientLuckySpinGetReq message, length delimited. Does not implicitly {@link ClientLuckySpinGetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {IClientLuckySpinGetReq} message ClientLuckySpinGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinGetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientLuckySpinGetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientLuckySpinGetReq} ClientLuckySpinGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinGetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientLuckySpinGetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientLuckySpinGetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientLuckySpinGetReq} ClientLuckySpinGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinGetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientLuckySpinGetReq message.
     * @function verify
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientLuckySpinGetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientLuckySpinGetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientLuckySpinGetReq} ClientLuckySpinGetReq
     */
    ClientLuckySpinGetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientLuckySpinGetReq)
            return object;
        let message = new $root.ClientLuckySpinGetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientLuckySpinGetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {ClientLuckySpinGetReq} message ClientLuckySpinGetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientLuckySpinGetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientLuckySpinGetReq to JSON.
     * @function toJSON
     * @memberof ClientLuckySpinGetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientLuckySpinGetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientLuckySpinGetReq
     * @function getTypeUrl
     * @memberof ClientLuckySpinGetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientLuckySpinGetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientLuckySpinGetReq";
    };

    return ClientLuckySpinGetReq;
})();

export const ClientLuckySpinGetAck = $root.ClientLuckySpinGetAck = (() => {

    /**
     * Properties of a ClientLuckySpinGetAck.
     * @exports IClientLuckySpinGetAck
     * @interface IClientLuckySpinGetAck
     * @property {number|null} [UserID] ClientLuckySpinGetAck UserID
     * @property {string|null} [TotalBets] ClientLuckySpinGetAck TotalBets
     * @property {number|Long|null} [NowTime] ClientLuckySpinGetAck NowTime
     * @property {number|Long|null} [ResetTime] ClientLuckySpinGetAck ResetTime
     * @property {number|null} [LeftSpinTimes] ClientLuckySpinGetAck LeftSpinTimes
     * @property {Array.<ILuckySpinLevelInfo>|null} [LuckySpinLevelInfos] ClientLuckySpinGetAck LuckySpinLevelInfos
     */

    /**
     * Constructs a new ClientLuckySpinGetAck.
     * @exports ClientLuckySpinGetAck
     * @classdesc Represents a ClientLuckySpinGetAck.
     * @implements IClientLuckySpinGetAck
     * @constructor
     * @param {IClientLuckySpinGetAck=} [properties] Properties to set
     */
    function ClientLuckySpinGetAck(properties) {
        this.LuckySpinLevelInfos = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientLuckySpinGetAck UserID.
     * @member {number} UserID
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.UserID = 0;

    /**
     * ClientLuckySpinGetAck TotalBets.
     * @member {string} TotalBets
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.TotalBets = "";

    /**
     * ClientLuckySpinGetAck NowTime.
     * @member {number|Long} NowTime
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.NowTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientLuckySpinGetAck ResetTime.
     * @member {number|Long} ResetTime
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.ResetTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientLuckySpinGetAck LeftSpinTimes.
     * @member {number} LeftSpinTimes
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.LeftSpinTimes = 0;

    /**
     * ClientLuckySpinGetAck LuckySpinLevelInfos.
     * @member {Array.<ILuckySpinLevelInfo>} LuckySpinLevelInfos
     * @memberof ClientLuckySpinGetAck
     * @instance
     */
    ClientLuckySpinGetAck.prototype.LuckySpinLevelInfos = $util.emptyArray;

    /**
     * Creates a new ClientLuckySpinGetAck instance using the specified properties.
     * @function create
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {IClientLuckySpinGetAck=} [properties] Properties to set
     * @returns {ClientLuckySpinGetAck} ClientLuckySpinGetAck instance
     */
    ClientLuckySpinGetAck.create = function create(properties) {
        return new ClientLuckySpinGetAck(properties);
    };

    /**
     * Encodes the specified ClientLuckySpinGetAck message. Does not implicitly {@link ClientLuckySpinGetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {IClientLuckySpinGetAck} message ClientLuckySpinGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinGetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TotalBets != null && Object.hasOwnProperty.call(message, "TotalBets"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.TotalBets);
        if (message.NowTime != null && Object.hasOwnProperty.call(message, "NowTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.NowTime);
        if (message.ResetTime != null && Object.hasOwnProperty.call(message, "ResetTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.ResetTime);
        if (message.LeftSpinTimes != null && Object.hasOwnProperty.call(message, "LeftSpinTimes"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.LeftSpinTimes);
        if (message.LuckySpinLevelInfos != null && message.LuckySpinLevelInfos.length)
            for (let i = 0; i < message.LuckySpinLevelInfos.length; ++i)
                $root.LuckySpinLevelInfo.encode(message.LuckySpinLevelInfos[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientLuckySpinGetAck message, length delimited. Does not implicitly {@link ClientLuckySpinGetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {IClientLuckySpinGetAck} message ClientLuckySpinGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinGetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientLuckySpinGetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientLuckySpinGetAck} ClientLuckySpinGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinGetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientLuckySpinGetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TotalBets = reader.string();
                    break;
                }
            case 3: {
                    message.NowTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.ResetTime = reader.uint64();
                    break;
                }
            case 5: {
                    message.LeftSpinTimes = reader.uint32();
                    break;
                }
            case 6: {
                    if (!(message.LuckySpinLevelInfos && message.LuckySpinLevelInfos.length))
                        message.LuckySpinLevelInfos = [];
                    message.LuckySpinLevelInfos.push($root.LuckySpinLevelInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientLuckySpinGetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientLuckySpinGetAck} ClientLuckySpinGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinGetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientLuckySpinGetAck message.
     * @function verify
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientLuckySpinGetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TotalBets != null && message.hasOwnProperty("TotalBets"))
            if (!$util.isString(message.TotalBets))
                return "TotalBets: string expected";
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (!$util.isInteger(message.NowTime) && !(message.NowTime && $util.isInteger(message.NowTime.low) && $util.isInteger(message.NowTime.high)))
                return "NowTime: integer|Long expected";
        if (message.ResetTime != null && message.hasOwnProperty("ResetTime"))
            if (!$util.isInteger(message.ResetTime) && !(message.ResetTime && $util.isInteger(message.ResetTime.low) && $util.isInteger(message.ResetTime.high)))
                return "ResetTime: integer|Long expected";
        if (message.LeftSpinTimes != null && message.hasOwnProperty("LeftSpinTimes"))
            if (!$util.isInteger(message.LeftSpinTimes))
                return "LeftSpinTimes: integer expected";
        if (message.LuckySpinLevelInfos != null && message.hasOwnProperty("LuckySpinLevelInfos")) {
            if (!Array.isArray(message.LuckySpinLevelInfos))
                return "LuckySpinLevelInfos: array expected";
            for (let i = 0; i < message.LuckySpinLevelInfos.length; ++i) {
                let error = $root.LuckySpinLevelInfo.verify(message.LuckySpinLevelInfos[i]);
                if (error)
                    return "LuckySpinLevelInfos." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientLuckySpinGetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientLuckySpinGetAck} ClientLuckySpinGetAck
     */
    ClientLuckySpinGetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientLuckySpinGetAck)
            return object;
        let message = new $root.ClientLuckySpinGetAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TotalBets != null)
            message.TotalBets = String(object.TotalBets);
        if (object.NowTime != null)
            if ($util.Long)
                (message.NowTime = $util.Long.fromValue(object.NowTime)).unsigned = true;
            else if (typeof object.NowTime === "string")
                message.NowTime = parseInt(object.NowTime, 10);
            else if (typeof object.NowTime === "number")
                message.NowTime = object.NowTime;
            else if (typeof object.NowTime === "object")
                message.NowTime = new $util.LongBits(object.NowTime.low >>> 0, object.NowTime.high >>> 0).toNumber(true);
        if (object.ResetTime != null)
            if ($util.Long)
                (message.ResetTime = $util.Long.fromValue(object.ResetTime)).unsigned = true;
            else if (typeof object.ResetTime === "string")
                message.ResetTime = parseInt(object.ResetTime, 10);
            else if (typeof object.ResetTime === "number")
                message.ResetTime = object.ResetTime;
            else if (typeof object.ResetTime === "object")
                message.ResetTime = new $util.LongBits(object.ResetTime.low >>> 0, object.ResetTime.high >>> 0).toNumber(true);
        if (object.LeftSpinTimes != null)
            message.LeftSpinTimes = object.LeftSpinTimes >>> 0;
        if (object.LuckySpinLevelInfos) {
            if (!Array.isArray(object.LuckySpinLevelInfos))
                throw TypeError(".ClientLuckySpinGetAck.LuckySpinLevelInfos: array expected");
            message.LuckySpinLevelInfos = [];
            for (let i = 0; i < object.LuckySpinLevelInfos.length; ++i) {
                if (typeof object.LuckySpinLevelInfos[i] !== "object")
                    throw TypeError(".ClientLuckySpinGetAck.LuckySpinLevelInfos: object expected");
                message.LuckySpinLevelInfos[i] = $root.LuckySpinLevelInfo.fromObject(object.LuckySpinLevelInfos[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientLuckySpinGetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {ClientLuckySpinGetAck} message ClientLuckySpinGetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientLuckySpinGetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.LuckySpinLevelInfos = [];
        if (options.defaults) {
            object.UserID = 0;
            object.TotalBets = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NowTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NowTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ResetTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ResetTime = options.longs === String ? "0" : 0;
            object.LeftSpinTimes = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TotalBets != null && message.hasOwnProperty("TotalBets"))
            object.TotalBets = message.TotalBets;
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (typeof message.NowTime === "number")
                object.NowTime = options.longs === String ? String(message.NowTime) : message.NowTime;
            else
                object.NowTime = options.longs === String ? $util.Long.prototype.toString.call(message.NowTime) : options.longs === Number ? new $util.LongBits(message.NowTime.low >>> 0, message.NowTime.high >>> 0).toNumber(true) : message.NowTime;
        if (message.ResetTime != null && message.hasOwnProperty("ResetTime"))
            if (typeof message.ResetTime === "number")
                object.ResetTime = options.longs === String ? String(message.ResetTime) : message.ResetTime;
            else
                object.ResetTime = options.longs === String ? $util.Long.prototype.toString.call(message.ResetTime) : options.longs === Number ? new $util.LongBits(message.ResetTime.low >>> 0, message.ResetTime.high >>> 0).toNumber(true) : message.ResetTime;
        if (message.LeftSpinTimes != null && message.hasOwnProperty("LeftSpinTimes"))
            object.LeftSpinTimes = message.LeftSpinTimes;
        if (message.LuckySpinLevelInfos && message.LuckySpinLevelInfos.length) {
            object.LuckySpinLevelInfos = [];
            for (let j = 0; j < message.LuckySpinLevelInfos.length; ++j)
                object.LuckySpinLevelInfos[j] = $root.LuckySpinLevelInfo.toObject(message.LuckySpinLevelInfos[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientLuckySpinGetAck to JSON.
     * @function toJSON
     * @memberof ClientLuckySpinGetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientLuckySpinGetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientLuckySpinGetAck
     * @function getTypeUrl
     * @memberof ClientLuckySpinGetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientLuckySpinGetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientLuckySpinGetAck";
    };

    return ClientLuckySpinGetAck;
})();

export const ClientLuckySpinPlayReq = $root.ClientLuckySpinPlayReq = (() => {

    /**
     * Properties of a ClientLuckySpinPlayReq.
     * @exports IClientLuckySpinPlayReq
     * @interface IClientLuckySpinPlayReq
     * @property {number|null} [UserID] ClientLuckySpinPlayReq UserID
     * @property {number|null} [SpinLevel] ClientLuckySpinPlayReq SpinLevel
     * @property {number|null} [ChannelID] ClientLuckySpinPlayReq ChannelID
     */

    /**
     * Constructs a new ClientLuckySpinPlayReq.
     * @exports ClientLuckySpinPlayReq
     * @classdesc Represents a ClientLuckySpinPlayReq.
     * @implements IClientLuckySpinPlayReq
     * @constructor
     * @param {IClientLuckySpinPlayReq=} [properties] Properties to set
     */
    function ClientLuckySpinPlayReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientLuckySpinPlayReq UserID.
     * @member {number} UserID
     * @memberof ClientLuckySpinPlayReq
     * @instance
     */
    ClientLuckySpinPlayReq.prototype.UserID = 0;

    /**
     * ClientLuckySpinPlayReq SpinLevel.
     * @member {number} SpinLevel
     * @memberof ClientLuckySpinPlayReq
     * @instance
     */
    ClientLuckySpinPlayReq.prototype.SpinLevel = 0;

    /**
     * ClientLuckySpinPlayReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientLuckySpinPlayReq
     * @instance
     */
    ClientLuckySpinPlayReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientLuckySpinPlayReq instance using the specified properties.
     * @function create
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {IClientLuckySpinPlayReq=} [properties] Properties to set
     * @returns {ClientLuckySpinPlayReq} ClientLuckySpinPlayReq instance
     */
    ClientLuckySpinPlayReq.create = function create(properties) {
        return new ClientLuckySpinPlayReq(properties);
    };

    /**
     * Encodes the specified ClientLuckySpinPlayReq message. Does not implicitly {@link ClientLuckySpinPlayReq.verify|verify} messages.
     * @function encode
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {IClientLuckySpinPlayReq} message ClientLuckySpinPlayReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinPlayReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.SpinLevel != null && Object.hasOwnProperty.call(message, "SpinLevel"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SpinLevel);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientLuckySpinPlayReq message, length delimited. Does not implicitly {@link ClientLuckySpinPlayReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {IClientLuckySpinPlayReq} message ClientLuckySpinPlayReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinPlayReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientLuckySpinPlayReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientLuckySpinPlayReq} ClientLuckySpinPlayReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinPlayReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientLuckySpinPlayReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SpinLevel = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientLuckySpinPlayReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientLuckySpinPlayReq} ClientLuckySpinPlayReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinPlayReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientLuckySpinPlayReq message.
     * @function verify
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientLuckySpinPlayReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            if (!$util.isInteger(message.SpinLevel))
                return "SpinLevel: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientLuckySpinPlayReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientLuckySpinPlayReq} ClientLuckySpinPlayReq
     */
    ClientLuckySpinPlayReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientLuckySpinPlayReq)
            return object;
        let message = new $root.ClientLuckySpinPlayReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SpinLevel != null)
            message.SpinLevel = object.SpinLevel >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientLuckySpinPlayReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {ClientLuckySpinPlayReq} message ClientLuckySpinPlayReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientLuckySpinPlayReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.SpinLevel = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            object.SpinLevel = message.SpinLevel;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientLuckySpinPlayReq to JSON.
     * @function toJSON
     * @memberof ClientLuckySpinPlayReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientLuckySpinPlayReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientLuckySpinPlayReq
     * @function getTypeUrl
     * @memberof ClientLuckySpinPlayReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientLuckySpinPlayReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientLuckySpinPlayReq";
    };

    return ClientLuckySpinPlayReq;
})();

export const ClientLuckySpinPlayAck = $root.ClientLuckySpinPlayAck = (() => {

    /**
     * Properties of a ClientLuckySpinPlayAck.
     * @exports IClientLuckySpinPlayAck
     * @interface IClientLuckySpinPlayAck
     * @property {number|null} [Ret] ClientLuckySpinPlayAck Ret
     * @property {number|null} [UserID] ClientLuckySpinPlayAck UserID
     * @property {number|null} [SpinLevel] ClientLuckySpinPlayAck SpinLevel
     * @property {string|null} [SpinPrize] ClientLuckySpinPlayAck SpinPrize
     * @property {string|null} [UserGold] ClientLuckySpinPlayAck UserGold
     * @property {string|null} [UserBonus] ClientLuckySpinPlayAck UserBonus
     * @property {string|null} [TotalBets] ClientLuckySpinPlayAck TotalBets
     * @property {number|Long|null} [NowTime] ClientLuckySpinPlayAck NowTime
     * @property {number|Long|null} [ResetTime] ClientLuckySpinPlayAck ResetTime
     * @property {number|null} [LeftSpinTimes] ClientLuckySpinPlayAck LeftSpinTimes
     * @property {Array.<ILuckySpinLevelInfo>|null} [LuckySpinLevelInfos] ClientLuckySpinPlayAck LuckySpinLevelInfos
     */

    /**
     * Constructs a new ClientLuckySpinPlayAck.
     * @exports ClientLuckySpinPlayAck
     * @classdesc Represents a ClientLuckySpinPlayAck.
     * @implements IClientLuckySpinPlayAck
     * @constructor
     * @param {IClientLuckySpinPlayAck=} [properties] Properties to set
     */
    function ClientLuckySpinPlayAck(properties) {
        this.LuckySpinLevelInfos = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientLuckySpinPlayAck Ret.
     * @member {number} Ret
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.Ret = 0;

    /**
     * ClientLuckySpinPlayAck UserID.
     * @member {number} UserID
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.UserID = 0;

    /**
     * ClientLuckySpinPlayAck SpinLevel.
     * @member {number} SpinLevel
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.SpinLevel = 0;

    /**
     * ClientLuckySpinPlayAck SpinPrize.
     * @member {string} SpinPrize
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.SpinPrize = "";

    /**
     * ClientLuckySpinPlayAck UserGold.
     * @member {string} UserGold
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.UserGold = "";

    /**
     * ClientLuckySpinPlayAck UserBonus.
     * @member {string} UserBonus
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.UserBonus = "";

    /**
     * ClientLuckySpinPlayAck TotalBets.
     * @member {string} TotalBets
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.TotalBets = "";

    /**
     * ClientLuckySpinPlayAck NowTime.
     * @member {number|Long} NowTime
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.NowTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientLuckySpinPlayAck ResetTime.
     * @member {number|Long} ResetTime
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.ResetTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientLuckySpinPlayAck LeftSpinTimes.
     * @member {number} LeftSpinTimes
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.LeftSpinTimes = 0;

    /**
     * ClientLuckySpinPlayAck LuckySpinLevelInfos.
     * @member {Array.<ILuckySpinLevelInfo>} LuckySpinLevelInfos
     * @memberof ClientLuckySpinPlayAck
     * @instance
     */
    ClientLuckySpinPlayAck.prototype.LuckySpinLevelInfos = $util.emptyArray;

    /**
     * Creates a new ClientLuckySpinPlayAck instance using the specified properties.
     * @function create
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {IClientLuckySpinPlayAck=} [properties] Properties to set
     * @returns {ClientLuckySpinPlayAck} ClientLuckySpinPlayAck instance
     */
    ClientLuckySpinPlayAck.create = function create(properties) {
        return new ClientLuckySpinPlayAck(properties);
    };

    /**
     * Encodes the specified ClientLuckySpinPlayAck message. Does not implicitly {@link ClientLuckySpinPlayAck.verify|verify} messages.
     * @function encode
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {IClientLuckySpinPlayAck} message ClientLuckySpinPlayAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinPlayAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SpinLevel != null && Object.hasOwnProperty.call(message, "SpinLevel"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.SpinLevel);
        if (message.SpinPrize != null && Object.hasOwnProperty.call(message, "SpinPrize"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.SpinPrize);
        if (message.UserGold != null && Object.hasOwnProperty.call(message, "UserGold"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.UserGold);
        if (message.UserBonus != null && Object.hasOwnProperty.call(message, "UserBonus"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.UserBonus);
        if (message.TotalBets != null && Object.hasOwnProperty.call(message, "TotalBets"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.TotalBets);
        if (message.NowTime != null && Object.hasOwnProperty.call(message, "NowTime"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.NowTime);
        if (message.ResetTime != null && Object.hasOwnProperty.call(message, "ResetTime"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.ResetTime);
        if (message.LeftSpinTimes != null && Object.hasOwnProperty.call(message, "LeftSpinTimes"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.LeftSpinTimes);
        if (message.LuckySpinLevelInfos != null && message.LuckySpinLevelInfos.length)
            for (let i = 0; i < message.LuckySpinLevelInfos.length; ++i)
                $root.LuckySpinLevelInfo.encode(message.LuckySpinLevelInfos[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientLuckySpinPlayAck message, length delimited. Does not implicitly {@link ClientLuckySpinPlayAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {IClientLuckySpinPlayAck} message ClientLuckySpinPlayAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientLuckySpinPlayAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientLuckySpinPlayAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientLuckySpinPlayAck} ClientLuckySpinPlayAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinPlayAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientLuckySpinPlayAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SpinLevel = reader.uint32();
                    break;
                }
            case 4: {
                    message.SpinPrize = reader.string();
                    break;
                }
            case 5: {
                    message.UserGold = reader.string();
                    break;
                }
            case 6: {
                    message.UserBonus = reader.string();
                    break;
                }
            case 7: {
                    message.TotalBets = reader.string();
                    break;
                }
            case 8: {
                    message.NowTime = reader.uint64();
                    break;
                }
            case 9: {
                    message.ResetTime = reader.uint64();
                    break;
                }
            case 10: {
                    message.LeftSpinTimes = reader.uint32();
                    break;
                }
            case 11: {
                    if (!(message.LuckySpinLevelInfos && message.LuckySpinLevelInfos.length))
                        message.LuckySpinLevelInfos = [];
                    message.LuckySpinLevelInfos.push($root.LuckySpinLevelInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientLuckySpinPlayAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientLuckySpinPlayAck} ClientLuckySpinPlayAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientLuckySpinPlayAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientLuckySpinPlayAck message.
     * @function verify
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientLuckySpinPlayAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            if (!$util.isInteger(message.SpinLevel))
                return "SpinLevel: integer expected";
        if (message.SpinPrize != null && message.hasOwnProperty("SpinPrize"))
            if (!$util.isString(message.SpinPrize))
                return "SpinPrize: string expected";
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            if (!$util.isString(message.UserGold))
                return "UserGold: string expected";
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            if (!$util.isString(message.UserBonus))
                return "UserBonus: string expected";
        if (message.TotalBets != null && message.hasOwnProperty("TotalBets"))
            if (!$util.isString(message.TotalBets))
                return "TotalBets: string expected";
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (!$util.isInteger(message.NowTime) && !(message.NowTime && $util.isInteger(message.NowTime.low) && $util.isInteger(message.NowTime.high)))
                return "NowTime: integer|Long expected";
        if (message.ResetTime != null && message.hasOwnProperty("ResetTime"))
            if (!$util.isInteger(message.ResetTime) && !(message.ResetTime && $util.isInteger(message.ResetTime.low) && $util.isInteger(message.ResetTime.high)))
                return "ResetTime: integer|Long expected";
        if (message.LeftSpinTimes != null && message.hasOwnProperty("LeftSpinTimes"))
            if (!$util.isInteger(message.LeftSpinTimes))
                return "LeftSpinTimes: integer expected";
        if (message.LuckySpinLevelInfos != null && message.hasOwnProperty("LuckySpinLevelInfos")) {
            if (!Array.isArray(message.LuckySpinLevelInfos))
                return "LuckySpinLevelInfos: array expected";
            for (let i = 0; i < message.LuckySpinLevelInfos.length; ++i) {
                let error = $root.LuckySpinLevelInfo.verify(message.LuckySpinLevelInfos[i]);
                if (error)
                    return "LuckySpinLevelInfos." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientLuckySpinPlayAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientLuckySpinPlayAck} ClientLuckySpinPlayAck
     */
    ClientLuckySpinPlayAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientLuckySpinPlayAck)
            return object;
        let message = new $root.ClientLuckySpinPlayAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SpinLevel != null)
            message.SpinLevel = object.SpinLevel >>> 0;
        if (object.SpinPrize != null)
            message.SpinPrize = String(object.SpinPrize);
        if (object.UserGold != null)
            message.UserGold = String(object.UserGold);
        if (object.UserBonus != null)
            message.UserBonus = String(object.UserBonus);
        if (object.TotalBets != null)
            message.TotalBets = String(object.TotalBets);
        if (object.NowTime != null)
            if ($util.Long)
                (message.NowTime = $util.Long.fromValue(object.NowTime)).unsigned = true;
            else if (typeof object.NowTime === "string")
                message.NowTime = parseInt(object.NowTime, 10);
            else if (typeof object.NowTime === "number")
                message.NowTime = object.NowTime;
            else if (typeof object.NowTime === "object")
                message.NowTime = new $util.LongBits(object.NowTime.low >>> 0, object.NowTime.high >>> 0).toNumber(true);
        if (object.ResetTime != null)
            if ($util.Long)
                (message.ResetTime = $util.Long.fromValue(object.ResetTime)).unsigned = true;
            else if (typeof object.ResetTime === "string")
                message.ResetTime = parseInt(object.ResetTime, 10);
            else if (typeof object.ResetTime === "number")
                message.ResetTime = object.ResetTime;
            else if (typeof object.ResetTime === "object")
                message.ResetTime = new $util.LongBits(object.ResetTime.low >>> 0, object.ResetTime.high >>> 0).toNumber(true);
        if (object.LeftSpinTimes != null)
            message.LeftSpinTimes = object.LeftSpinTimes >>> 0;
        if (object.LuckySpinLevelInfos) {
            if (!Array.isArray(object.LuckySpinLevelInfos))
                throw TypeError(".ClientLuckySpinPlayAck.LuckySpinLevelInfos: array expected");
            message.LuckySpinLevelInfos = [];
            for (let i = 0; i < object.LuckySpinLevelInfos.length; ++i) {
                if (typeof object.LuckySpinLevelInfos[i] !== "object")
                    throw TypeError(".ClientLuckySpinPlayAck.LuckySpinLevelInfos: object expected");
                message.LuckySpinLevelInfos[i] = $root.LuckySpinLevelInfo.fromObject(object.LuckySpinLevelInfos[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientLuckySpinPlayAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {ClientLuckySpinPlayAck} message ClientLuckySpinPlayAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientLuckySpinPlayAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.LuckySpinLevelInfos = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.SpinLevel = 0;
            object.SpinPrize = "";
            object.UserGold = "";
            object.UserBonus = "";
            object.TotalBets = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NowTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NowTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.ResetTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ResetTime = options.longs === String ? "0" : 0;
            object.LeftSpinTimes = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SpinLevel != null && message.hasOwnProperty("SpinLevel"))
            object.SpinLevel = message.SpinLevel;
        if (message.SpinPrize != null && message.hasOwnProperty("SpinPrize"))
            object.SpinPrize = message.SpinPrize;
        if (message.UserGold != null && message.hasOwnProperty("UserGold"))
            object.UserGold = message.UserGold;
        if (message.UserBonus != null && message.hasOwnProperty("UserBonus"))
            object.UserBonus = message.UserBonus;
        if (message.TotalBets != null && message.hasOwnProperty("TotalBets"))
            object.TotalBets = message.TotalBets;
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (typeof message.NowTime === "number")
                object.NowTime = options.longs === String ? String(message.NowTime) : message.NowTime;
            else
                object.NowTime = options.longs === String ? $util.Long.prototype.toString.call(message.NowTime) : options.longs === Number ? new $util.LongBits(message.NowTime.low >>> 0, message.NowTime.high >>> 0).toNumber(true) : message.NowTime;
        if (message.ResetTime != null && message.hasOwnProperty("ResetTime"))
            if (typeof message.ResetTime === "number")
                object.ResetTime = options.longs === String ? String(message.ResetTime) : message.ResetTime;
            else
                object.ResetTime = options.longs === String ? $util.Long.prototype.toString.call(message.ResetTime) : options.longs === Number ? new $util.LongBits(message.ResetTime.low >>> 0, message.ResetTime.high >>> 0).toNumber(true) : message.ResetTime;
        if (message.LeftSpinTimes != null && message.hasOwnProperty("LeftSpinTimes"))
            object.LeftSpinTimes = message.LeftSpinTimes;
        if (message.LuckySpinLevelInfos && message.LuckySpinLevelInfos.length) {
            object.LuckySpinLevelInfos = [];
            for (let j = 0; j < message.LuckySpinLevelInfos.length; ++j)
                object.LuckySpinLevelInfos[j] = $root.LuckySpinLevelInfo.toObject(message.LuckySpinLevelInfos[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientLuckySpinPlayAck to JSON.
     * @function toJSON
     * @memberof ClientLuckySpinPlayAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientLuckySpinPlayAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientLuckySpinPlayAck
     * @function getTypeUrl
     * @memberof ClientLuckySpinPlayAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientLuckySpinPlayAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientLuckySpinPlayAck";
    };

    return ClientLuckySpinPlayAck;
})();

export const ClientFreeSpinReq = $root.ClientFreeSpinReq = (() => {

    /**
     * Properties of a ClientFreeSpinReq.
     * @exports IClientFreeSpinReq
     * @interface IClientFreeSpinReq
     * @property {number|null} [UserID] ClientFreeSpinReq UserID
     * @property {number|null} [ChannelID] ClientFreeSpinReq ChannelID
     */

    /**
     * Constructs a new ClientFreeSpinReq.
     * @exports ClientFreeSpinReq
     * @classdesc Represents a ClientFreeSpinReq.
     * @implements IClientFreeSpinReq
     * @constructor
     * @param {IClientFreeSpinReq=} [properties] Properties to set
     */
    function ClientFreeSpinReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFreeSpinReq UserID.
     * @member {number} UserID
     * @memberof ClientFreeSpinReq
     * @instance
     */
    ClientFreeSpinReq.prototype.UserID = 0;

    /**
     * ClientFreeSpinReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientFreeSpinReq
     * @instance
     */
    ClientFreeSpinReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientFreeSpinReq instance using the specified properties.
     * @function create
     * @memberof ClientFreeSpinReq
     * @static
     * @param {IClientFreeSpinReq=} [properties] Properties to set
     * @returns {ClientFreeSpinReq} ClientFreeSpinReq instance
     */
    ClientFreeSpinReq.create = function create(properties) {
        return new ClientFreeSpinReq(properties);
    };

    /**
     * Encodes the specified ClientFreeSpinReq message. Does not implicitly {@link ClientFreeSpinReq.verify|verify} messages.
     * @function encode
     * @memberof ClientFreeSpinReq
     * @static
     * @param {IClientFreeSpinReq} message ClientFreeSpinReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFreeSpinReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientFreeSpinReq message, length delimited. Does not implicitly {@link ClientFreeSpinReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFreeSpinReq
     * @static
     * @param {IClientFreeSpinReq} message ClientFreeSpinReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFreeSpinReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFreeSpinReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFreeSpinReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFreeSpinReq} ClientFreeSpinReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFreeSpinReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFreeSpinReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFreeSpinReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFreeSpinReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFreeSpinReq} ClientFreeSpinReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFreeSpinReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFreeSpinReq message.
     * @function verify
     * @memberof ClientFreeSpinReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFreeSpinReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientFreeSpinReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFreeSpinReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFreeSpinReq} ClientFreeSpinReq
     */
    ClientFreeSpinReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFreeSpinReq)
            return object;
        let message = new $root.ClientFreeSpinReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientFreeSpinReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFreeSpinReq
     * @static
     * @param {ClientFreeSpinReq} message ClientFreeSpinReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFreeSpinReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientFreeSpinReq to JSON.
     * @function toJSON
     * @memberof ClientFreeSpinReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFreeSpinReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFreeSpinReq
     * @function getTypeUrl
     * @memberof ClientFreeSpinReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFreeSpinReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFreeSpinReq";
    };

    return ClientFreeSpinReq;
})();

export const ClientFreeSpinAck = $root.ClientFreeSpinAck = (() => {

    /**
     * Properties of a ClientFreeSpinAck.
     * @exports IClientFreeSpinAck
     * @interface IClientFreeSpinAck
     * @property {number|null} [ret] ClientFreeSpinAck ret
     * @property {number|null} [UserID] ClientFreeSpinAck UserID
     * @property {number|null} [ChannelID] ClientFreeSpinAck ChannelID
     * @property {number|null} [FreeSpinCount] ClientFreeSpinAck FreeSpinCount
     * @property {Array.<number>|null} [GameID] ClientFreeSpinAck GameID
     */

    /**
     * Constructs a new ClientFreeSpinAck.
     * @exports ClientFreeSpinAck
     * @classdesc Represents a ClientFreeSpinAck.
     * @implements IClientFreeSpinAck
     * @constructor
     * @param {IClientFreeSpinAck=} [properties] Properties to set
     */
    function ClientFreeSpinAck(properties) {
        this.GameID = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientFreeSpinAck ret.
     * @member {number} ret
     * @memberof ClientFreeSpinAck
     * @instance
     */
    ClientFreeSpinAck.prototype.ret = 0;

    /**
     * ClientFreeSpinAck UserID.
     * @member {number} UserID
     * @memberof ClientFreeSpinAck
     * @instance
     */
    ClientFreeSpinAck.prototype.UserID = 0;

    /**
     * ClientFreeSpinAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientFreeSpinAck
     * @instance
     */
    ClientFreeSpinAck.prototype.ChannelID = 0;

    /**
     * ClientFreeSpinAck FreeSpinCount.
     * @member {number} FreeSpinCount
     * @memberof ClientFreeSpinAck
     * @instance
     */
    ClientFreeSpinAck.prototype.FreeSpinCount = 0;

    /**
     * ClientFreeSpinAck GameID.
     * @member {Array.<number>} GameID
     * @memberof ClientFreeSpinAck
     * @instance
     */
    ClientFreeSpinAck.prototype.GameID = $util.emptyArray;

    /**
     * Creates a new ClientFreeSpinAck instance using the specified properties.
     * @function create
     * @memberof ClientFreeSpinAck
     * @static
     * @param {IClientFreeSpinAck=} [properties] Properties to set
     * @returns {ClientFreeSpinAck} ClientFreeSpinAck instance
     */
    ClientFreeSpinAck.create = function create(properties) {
        return new ClientFreeSpinAck(properties);
    };

    /**
     * Encodes the specified ClientFreeSpinAck message. Does not implicitly {@link ClientFreeSpinAck.verify|verify} messages.
     * @function encode
     * @memberof ClientFreeSpinAck
     * @static
     * @param {IClientFreeSpinAck} message ClientFreeSpinAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFreeSpinAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.FreeSpinCount != null && Object.hasOwnProperty.call(message, "FreeSpinCount"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.FreeSpinCount);
        if (message.GameID != null && message.GameID.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.GameID.length; ++i)
                writer.uint32(message.GameID[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified ClientFreeSpinAck message, length delimited. Does not implicitly {@link ClientFreeSpinAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientFreeSpinAck
     * @static
     * @param {IClientFreeSpinAck} message ClientFreeSpinAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientFreeSpinAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientFreeSpinAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientFreeSpinAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientFreeSpinAck} ClientFreeSpinAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFreeSpinAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientFreeSpinAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.FreeSpinCount = reader.uint32();
                    break;
                }
            case 5: {
                    if (!(message.GameID && message.GameID.length))
                        message.GameID = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GameID.push(reader.uint32());
                    } else
                        message.GameID.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientFreeSpinAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientFreeSpinAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientFreeSpinAck} ClientFreeSpinAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientFreeSpinAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientFreeSpinAck message.
     * @function verify
     * @memberof ClientFreeSpinAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientFreeSpinAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.FreeSpinCount != null && message.hasOwnProperty("FreeSpinCount"))
            if (!$util.isInteger(message.FreeSpinCount))
                return "FreeSpinCount: integer expected";
        if (message.GameID != null && message.hasOwnProperty("GameID")) {
            if (!Array.isArray(message.GameID))
                return "GameID: array expected";
            for (let i = 0; i < message.GameID.length; ++i)
                if (!$util.isInteger(message.GameID[i]))
                    return "GameID: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a ClientFreeSpinAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientFreeSpinAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientFreeSpinAck} ClientFreeSpinAck
     */
    ClientFreeSpinAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientFreeSpinAck)
            return object;
        let message = new $root.ClientFreeSpinAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.FreeSpinCount != null)
            message.FreeSpinCount = object.FreeSpinCount >>> 0;
        if (object.GameID) {
            if (!Array.isArray(object.GameID))
                throw TypeError(".ClientFreeSpinAck.GameID: array expected");
            message.GameID = [];
            for (let i = 0; i < object.GameID.length; ++i)
                message.GameID[i] = object.GameID[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientFreeSpinAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientFreeSpinAck
     * @static
     * @param {ClientFreeSpinAck} message ClientFreeSpinAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientFreeSpinAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GameID = [];
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.FreeSpinCount = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.FreeSpinCount != null && message.hasOwnProperty("FreeSpinCount"))
            object.FreeSpinCount = message.FreeSpinCount;
        if (message.GameID && message.GameID.length) {
            object.GameID = [];
            for (let j = 0; j < message.GameID.length; ++j)
                object.GameID[j] = message.GameID[j];
        }
        return object;
    };

    /**
     * Converts this ClientFreeSpinAck to JSON.
     * @function toJSON
     * @memberof ClientFreeSpinAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientFreeSpinAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientFreeSpinAck
     * @function getTypeUrl
     * @memberof ClientFreeSpinAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientFreeSpinAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientFreeSpinAck";
    };

    return ClientFreeSpinAck;
})();

export const ClientEveryDayReq = $root.ClientEveryDayReq = (() => {

    /**
     * Properties of a ClientEveryDayReq.
     * @exports IClientEveryDayReq
     * @interface IClientEveryDayReq
     * @property {number|null} [UserID] ClientEveryDayReq UserID
     * @property {number|null} [ChannelID] ClientEveryDayReq ChannelID
     */

    /**
     * Constructs a new ClientEveryDayReq.
     * @exports ClientEveryDayReq
     * @classdesc Represents a ClientEveryDayReq.
     * @implements IClientEveryDayReq
     * @constructor
     * @param {IClientEveryDayReq=} [properties] Properties to set
     */
    function ClientEveryDayReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientEveryDayReq UserID.
     * @member {number} UserID
     * @memberof ClientEveryDayReq
     * @instance
     */
    ClientEveryDayReq.prototype.UserID = 0;

    /**
     * ClientEveryDayReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientEveryDayReq
     * @instance
     */
    ClientEveryDayReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientEveryDayReq instance using the specified properties.
     * @function create
     * @memberof ClientEveryDayReq
     * @static
     * @param {IClientEveryDayReq=} [properties] Properties to set
     * @returns {ClientEveryDayReq} ClientEveryDayReq instance
     */
    ClientEveryDayReq.create = function create(properties) {
        return new ClientEveryDayReq(properties);
    };

    /**
     * Encodes the specified ClientEveryDayReq message. Does not implicitly {@link ClientEveryDayReq.verify|verify} messages.
     * @function encode
     * @memberof ClientEveryDayReq
     * @static
     * @param {IClientEveryDayReq} message ClientEveryDayReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientEveryDayReq message, length delimited. Does not implicitly {@link ClientEveryDayReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientEveryDayReq
     * @static
     * @param {IClientEveryDayReq} message ClientEveryDayReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientEveryDayReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientEveryDayReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientEveryDayReq} ClientEveryDayReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientEveryDayReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientEveryDayReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientEveryDayReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientEveryDayReq} ClientEveryDayReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientEveryDayReq message.
     * @function verify
     * @memberof ClientEveryDayReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientEveryDayReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientEveryDayReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientEveryDayReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientEveryDayReq} ClientEveryDayReq
     */
    ClientEveryDayReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientEveryDayReq)
            return object;
        let message = new $root.ClientEveryDayReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientEveryDayReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientEveryDayReq
     * @static
     * @param {ClientEveryDayReq} message ClientEveryDayReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientEveryDayReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientEveryDayReq to JSON.
     * @function toJSON
     * @memberof ClientEveryDayReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientEveryDayReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientEveryDayReq
     * @function getTypeUrl
     * @memberof ClientEveryDayReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientEveryDayReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientEveryDayReq";
    };

    return ClientEveryDayReq;
})();

export const ClientEveryDayAck = $root.ClientEveryDayAck = (() => {

    /**
     * Properties of a ClientEveryDayAck.
     * @exports IClientEveryDayAck
     * @interface IClientEveryDayAck
     * @property {number|null} [ret] ClientEveryDayAck ret
     * @property {number|null} [UserID] ClientEveryDayAck UserID
     * @property {number|null} [ChannelID] ClientEveryDayAck ChannelID
     * @property {string|null} [BetCof] ClientEveryDayAck BetCof
     * @property {string|null} [BetStatus] ClientEveryDayAck BetStatus
     * @property {string|null} [BetGold] ClientEveryDayAck BetGold
     * @property {string|null} [DepCof] ClientEveryDayAck DepCof
     * @property {string|null} [DepStatus] ClientEveryDayAck DepStatus
     * @property {string|null} [DepGold] ClientEveryDayAck DepGold
     */

    /**
     * Constructs a new ClientEveryDayAck.
     * @exports ClientEveryDayAck
     * @classdesc Represents a ClientEveryDayAck.
     * @implements IClientEveryDayAck
     * @constructor
     * @param {IClientEveryDayAck=} [properties] Properties to set
     */
    function ClientEveryDayAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientEveryDayAck ret.
     * @member {number} ret
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.ret = 0;

    /**
     * ClientEveryDayAck UserID.
     * @member {number} UserID
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.UserID = 0;

    /**
     * ClientEveryDayAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.ChannelID = 0;

    /**
     * ClientEveryDayAck BetCof.
     * @member {string} BetCof
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.BetCof = "";

    /**
     * ClientEveryDayAck BetStatus.
     * @member {string} BetStatus
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.BetStatus = "";

    /**
     * ClientEveryDayAck BetGold.
     * @member {string} BetGold
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.BetGold = "";

    /**
     * ClientEveryDayAck DepCof.
     * @member {string} DepCof
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.DepCof = "";

    /**
     * ClientEveryDayAck DepStatus.
     * @member {string} DepStatus
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.DepStatus = "";

    /**
     * ClientEveryDayAck DepGold.
     * @member {string} DepGold
     * @memberof ClientEveryDayAck
     * @instance
     */
    ClientEveryDayAck.prototype.DepGold = "";

    /**
     * Creates a new ClientEveryDayAck instance using the specified properties.
     * @function create
     * @memberof ClientEveryDayAck
     * @static
     * @param {IClientEveryDayAck=} [properties] Properties to set
     * @returns {ClientEveryDayAck} ClientEveryDayAck instance
     */
    ClientEveryDayAck.create = function create(properties) {
        return new ClientEveryDayAck(properties);
    };

    /**
     * Encodes the specified ClientEveryDayAck message. Does not implicitly {@link ClientEveryDayAck.verify|verify} messages.
     * @function encode
     * @memberof ClientEveryDayAck
     * @static
     * @param {IClientEveryDayAck} message ClientEveryDayAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.BetCof != null && Object.hasOwnProperty.call(message, "BetCof"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BetCof);
        if (message.BetStatus != null && Object.hasOwnProperty.call(message, "BetStatus"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BetStatus);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.BetGold);
        if (message.DepCof != null && Object.hasOwnProperty.call(message, "DepCof"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.DepCof);
        if (message.DepStatus != null && Object.hasOwnProperty.call(message, "DepStatus"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.DepStatus);
        if (message.DepGold != null && Object.hasOwnProperty.call(message, "DepGold"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.DepGold);
        return writer;
    };

    /**
     * Encodes the specified ClientEveryDayAck message, length delimited. Does not implicitly {@link ClientEveryDayAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientEveryDayAck
     * @static
     * @param {IClientEveryDayAck} message ClientEveryDayAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientEveryDayAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientEveryDayAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientEveryDayAck} ClientEveryDayAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientEveryDayAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetCof = reader.string();
                    break;
                }
            case 5: {
                    message.BetStatus = reader.string();
                    break;
                }
            case 6: {
                    message.BetGold = reader.string();
                    break;
                }
            case 7: {
                    message.DepCof = reader.string();
                    break;
                }
            case 8: {
                    message.DepStatus = reader.string();
                    break;
                }
            case 9: {
                    message.DepGold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientEveryDayAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientEveryDayAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientEveryDayAck} ClientEveryDayAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientEveryDayAck message.
     * @function verify
     * @memberof ClientEveryDayAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientEveryDayAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.BetCof != null && message.hasOwnProperty("BetCof"))
            if (!$util.isString(message.BetCof))
                return "BetCof: string expected";
        if (message.BetStatus != null && message.hasOwnProperty("BetStatus"))
            if (!$util.isString(message.BetStatus))
                return "BetStatus: string expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isString(message.BetGold))
                return "BetGold: string expected";
        if (message.DepCof != null && message.hasOwnProperty("DepCof"))
            if (!$util.isString(message.DepCof))
                return "DepCof: string expected";
        if (message.DepStatus != null && message.hasOwnProperty("DepStatus"))
            if (!$util.isString(message.DepStatus))
                return "DepStatus: string expected";
        if (message.DepGold != null && message.hasOwnProperty("DepGold"))
            if (!$util.isString(message.DepGold))
                return "DepGold: string expected";
        return null;
    };

    /**
     * Creates a ClientEveryDayAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientEveryDayAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientEveryDayAck} ClientEveryDayAck
     */
    ClientEveryDayAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientEveryDayAck)
            return object;
        let message = new $root.ClientEveryDayAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.BetCof != null)
            message.BetCof = String(object.BetCof);
        if (object.BetStatus != null)
            message.BetStatus = String(object.BetStatus);
        if (object.BetGold != null)
            message.BetGold = String(object.BetGold);
        if (object.DepCof != null)
            message.DepCof = String(object.DepCof);
        if (object.DepStatus != null)
            message.DepStatus = String(object.DepStatus);
        if (object.DepGold != null)
            message.DepGold = String(object.DepGold);
        return message;
    };

    /**
     * Creates a plain object from a ClientEveryDayAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientEveryDayAck
     * @static
     * @param {ClientEveryDayAck} message ClientEveryDayAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientEveryDayAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.BetCof = "";
            object.BetStatus = "";
            object.BetGold = "";
            object.DepCof = "";
            object.DepStatus = "";
            object.DepGold = "";
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.BetCof != null && message.hasOwnProperty("BetCof"))
            object.BetCof = message.BetCof;
        if (message.BetStatus != null && message.hasOwnProperty("BetStatus"))
            object.BetStatus = message.BetStatus;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            object.BetGold = message.BetGold;
        if (message.DepCof != null && message.hasOwnProperty("DepCof"))
            object.DepCof = message.DepCof;
        if (message.DepStatus != null && message.hasOwnProperty("DepStatus"))
            object.DepStatus = message.DepStatus;
        if (message.DepGold != null && message.hasOwnProperty("DepGold"))
            object.DepGold = message.DepGold;
        return object;
    };

    /**
     * Converts this ClientEveryDayAck to JSON.
     * @function toJSON
     * @memberof ClientEveryDayAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientEveryDayAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientEveryDayAck
     * @function getTypeUrl
     * @memberof ClientEveryDayAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientEveryDayAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientEveryDayAck";
    };

    return ClientEveryDayAck;
})();

export const ClientEveryDayGoldReq = $root.ClientEveryDayGoldReq = (() => {

    /**
     * Properties of a ClientEveryDayGoldReq.
     * @exports IClientEveryDayGoldReq
     * @interface IClientEveryDayGoldReq
     * @property {number|null} [UserID] ClientEveryDayGoldReq UserID
     * @property {number|null} [ChannelID] ClientEveryDayGoldReq ChannelID
     * @property {number|null} [IdType] ClientEveryDayGoldReq IdType
     * @property {Array.<string>|null} [AllID] ClientEveryDayGoldReq AllID
     */

    /**
     * Constructs a new ClientEveryDayGoldReq.
     * @exports ClientEveryDayGoldReq
     * @classdesc Represents a ClientEveryDayGoldReq.
     * @implements IClientEveryDayGoldReq
     * @constructor
     * @param {IClientEveryDayGoldReq=} [properties] Properties to set
     */
    function ClientEveryDayGoldReq(properties) {
        this.AllID = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientEveryDayGoldReq UserID.
     * @member {number} UserID
     * @memberof ClientEveryDayGoldReq
     * @instance
     */
    ClientEveryDayGoldReq.prototype.UserID = 0;

    /**
     * ClientEveryDayGoldReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientEveryDayGoldReq
     * @instance
     */
    ClientEveryDayGoldReq.prototype.ChannelID = 0;

    /**
     * ClientEveryDayGoldReq IdType.
     * @member {number} IdType
     * @memberof ClientEveryDayGoldReq
     * @instance
     */
    ClientEveryDayGoldReq.prototype.IdType = 0;

    /**
     * ClientEveryDayGoldReq AllID.
     * @member {Array.<string>} AllID
     * @memberof ClientEveryDayGoldReq
     * @instance
     */
    ClientEveryDayGoldReq.prototype.AllID = $util.emptyArray;

    /**
     * Creates a new ClientEveryDayGoldReq instance using the specified properties.
     * @function create
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {IClientEveryDayGoldReq=} [properties] Properties to set
     * @returns {ClientEveryDayGoldReq} ClientEveryDayGoldReq instance
     */
    ClientEveryDayGoldReq.create = function create(properties) {
        return new ClientEveryDayGoldReq(properties);
    };

    /**
     * Encodes the specified ClientEveryDayGoldReq message. Does not implicitly {@link ClientEveryDayGoldReq.verify|verify} messages.
     * @function encode
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {IClientEveryDayGoldReq} message ClientEveryDayGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayGoldReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.IdType != null && Object.hasOwnProperty.call(message, "IdType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.IdType);
        if (message.AllID != null && message.AllID.length)
            for (let i = 0; i < message.AllID.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.AllID[i]);
        return writer;
    };

    /**
     * Encodes the specified ClientEveryDayGoldReq message, length delimited. Does not implicitly {@link ClientEveryDayGoldReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {IClientEveryDayGoldReq} message ClientEveryDayGoldReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayGoldReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientEveryDayGoldReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientEveryDayGoldReq} ClientEveryDayGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayGoldReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientEveryDayGoldReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.IdType = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.AllID && message.AllID.length))
                        message.AllID = [];
                    message.AllID.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientEveryDayGoldReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientEveryDayGoldReq} ClientEveryDayGoldReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayGoldReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientEveryDayGoldReq message.
     * @function verify
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientEveryDayGoldReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.IdType != null && message.hasOwnProperty("IdType"))
            if (!$util.isInteger(message.IdType))
                return "IdType: integer expected";
        if (message.AllID != null && message.hasOwnProperty("AllID")) {
            if (!Array.isArray(message.AllID))
                return "AllID: array expected";
            for (let i = 0; i < message.AllID.length; ++i)
                if (!$util.isString(message.AllID[i]))
                    return "AllID: string[] expected";
        }
        return null;
    };

    /**
     * Creates a ClientEveryDayGoldReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientEveryDayGoldReq} ClientEveryDayGoldReq
     */
    ClientEveryDayGoldReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientEveryDayGoldReq)
            return object;
        let message = new $root.ClientEveryDayGoldReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.IdType != null)
            message.IdType = object.IdType >>> 0;
        if (object.AllID) {
            if (!Array.isArray(object.AllID))
                throw TypeError(".ClientEveryDayGoldReq.AllID: array expected");
            message.AllID = [];
            for (let i = 0; i < object.AllID.length; ++i)
                message.AllID[i] = String(object.AllID[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientEveryDayGoldReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {ClientEveryDayGoldReq} message ClientEveryDayGoldReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientEveryDayGoldReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.AllID = [];
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.IdType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.IdType != null && message.hasOwnProperty("IdType"))
            object.IdType = message.IdType;
        if (message.AllID && message.AllID.length) {
            object.AllID = [];
            for (let j = 0; j < message.AllID.length; ++j)
                object.AllID[j] = message.AllID[j];
        }
        return object;
    };

    /**
     * Converts this ClientEveryDayGoldReq to JSON.
     * @function toJSON
     * @memberof ClientEveryDayGoldReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientEveryDayGoldReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientEveryDayGoldReq
     * @function getTypeUrl
     * @memberof ClientEveryDayGoldReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientEveryDayGoldReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientEveryDayGoldReq";
    };

    return ClientEveryDayGoldReq;
})();

export const ClientEveryDayGoldAck = $root.ClientEveryDayGoldAck = (() => {

    /**
     * Properties of a ClientEveryDayGoldAck.
     * @exports IClientEveryDayGoldAck
     * @interface IClientEveryDayGoldAck
     * @property {number|null} [ret] ClientEveryDayGoldAck ret
     * @property {number|null} [UserID] ClientEveryDayGoldAck UserID
     * @property {number|null} [ChannelID] ClientEveryDayGoldAck ChannelID
     * @property {string|null} [EDatGold] ClientEveryDayGoldAck EDatGold
     */

    /**
     * Constructs a new ClientEveryDayGoldAck.
     * @exports ClientEveryDayGoldAck
     * @classdesc Represents a ClientEveryDayGoldAck.
     * @implements IClientEveryDayGoldAck
     * @constructor
     * @param {IClientEveryDayGoldAck=} [properties] Properties to set
     */
    function ClientEveryDayGoldAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientEveryDayGoldAck ret.
     * @member {number} ret
     * @memberof ClientEveryDayGoldAck
     * @instance
     */
    ClientEveryDayGoldAck.prototype.ret = 0;

    /**
     * ClientEveryDayGoldAck UserID.
     * @member {number} UserID
     * @memberof ClientEveryDayGoldAck
     * @instance
     */
    ClientEveryDayGoldAck.prototype.UserID = 0;

    /**
     * ClientEveryDayGoldAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientEveryDayGoldAck
     * @instance
     */
    ClientEveryDayGoldAck.prototype.ChannelID = 0;

    /**
     * ClientEveryDayGoldAck EDatGold.
     * @member {string} EDatGold
     * @memberof ClientEveryDayGoldAck
     * @instance
     */
    ClientEveryDayGoldAck.prototype.EDatGold = "";

    /**
     * Creates a new ClientEveryDayGoldAck instance using the specified properties.
     * @function create
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {IClientEveryDayGoldAck=} [properties] Properties to set
     * @returns {ClientEveryDayGoldAck} ClientEveryDayGoldAck instance
     */
    ClientEveryDayGoldAck.create = function create(properties) {
        return new ClientEveryDayGoldAck(properties);
    };

    /**
     * Encodes the specified ClientEveryDayGoldAck message. Does not implicitly {@link ClientEveryDayGoldAck.verify|verify} messages.
     * @function encode
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {IClientEveryDayGoldAck} message ClientEveryDayGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayGoldAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.EDatGold != null && Object.hasOwnProperty.call(message, "EDatGold"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.EDatGold);
        return writer;
    };

    /**
     * Encodes the specified ClientEveryDayGoldAck message, length delimited. Does not implicitly {@link ClientEveryDayGoldAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {IClientEveryDayGoldAck} message ClientEveryDayGoldAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientEveryDayGoldAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientEveryDayGoldAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientEveryDayGoldAck} ClientEveryDayGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayGoldAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientEveryDayGoldAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.EDatGold = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientEveryDayGoldAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientEveryDayGoldAck} ClientEveryDayGoldAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientEveryDayGoldAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientEveryDayGoldAck message.
     * @function verify
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientEveryDayGoldAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.EDatGold != null && message.hasOwnProperty("EDatGold"))
            if (!$util.isString(message.EDatGold))
                return "EDatGold: string expected";
        return null;
    };

    /**
     * Creates a ClientEveryDayGoldAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientEveryDayGoldAck} ClientEveryDayGoldAck
     */
    ClientEveryDayGoldAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientEveryDayGoldAck)
            return object;
        let message = new $root.ClientEveryDayGoldAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.EDatGold != null)
            message.EDatGold = String(object.EDatGold);
        return message;
    };

    /**
     * Creates a plain object from a ClientEveryDayGoldAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {ClientEveryDayGoldAck} message ClientEveryDayGoldAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientEveryDayGoldAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.EDatGold = "";
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.EDatGold != null && message.hasOwnProperty("EDatGold"))
            object.EDatGold = message.EDatGold;
        return object;
    };

    /**
     * Converts this ClientEveryDayGoldAck to JSON.
     * @function toJSON
     * @memberof ClientEveryDayGoldAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientEveryDayGoldAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientEveryDayGoldAck
     * @function getTypeUrl
     * @memberof ClientEveryDayGoldAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientEveryDayGoldAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientEveryDayGoldAck";
    };

    return ClientEveryDayGoldAck;
})();

export const ClientBoxActReq = $root.ClientBoxActReq = (() => {

    /**
     * Properties of a ClientBoxActReq.
     * @exports IClientBoxActReq
     * @interface IClientBoxActReq
     * @property {number|null} [UserID] ClientBoxActReq UserID
     * @property {number|null} [ChannelID] ClientBoxActReq ChannelID
     */

    /**
     * Constructs a new ClientBoxActReq.
     * @exports ClientBoxActReq
     * @classdesc Represents a ClientBoxActReq.
     * @implements IClientBoxActReq
     * @constructor
     * @param {IClientBoxActReq=} [properties] Properties to set
     */
    function ClientBoxActReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBoxActReq UserID.
     * @member {number} UserID
     * @memberof ClientBoxActReq
     * @instance
     */
    ClientBoxActReq.prototype.UserID = 0;

    /**
     * ClientBoxActReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientBoxActReq
     * @instance
     */
    ClientBoxActReq.prototype.ChannelID = 0;

    /**
     * Creates a new ClientBoxActReq instance using the specified properties.
     * @function create
     * @memberof ClientBoxActReq
     * @static
     * @param {IClientBoxActReq=} [properties] Properties to set
     * @returns {ClientBoxActReq} ClientBoxActReq instance
     */
    ClientBoxActReq.create = function create(properties) {
        return new ClientBoxActReq(properties);
    };

    /**
     * Encodes the specified ClientBoxActReq message. Does not implicitly {@link ClientBoxActReq.verify|verify} messages.
     * @function encode
     * @memberof ClientBoxActReq
     * @static
     * @param {IClientBoxActReq} message ClientBoxActReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        return writer;
    };

    /**
     * Encodes the specified ClientBoxActReq message, length delimited. Does not implicitly {@link ClientBoxActReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBoxActReq
     * @static
     * @param {IClientBoxActReq} message ClientBoxActReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBoxActReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBoxActReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBoxActReq} ClientBoxActReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBoxActReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBoxActReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBoxActReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBoxActReq} ClientBoxActReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBoxActReq message.
     * @function verify
     * @memberof ClientBoxActReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBoxActReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        return null;
    };

    /**
     * Creates a ClientBoxActReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBoxActReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBoxActReq} ClientBoxActReq
     */
    ClientBoxActReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBoxActReq)
            return object;
        let message = new $root.ClientBoxActReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBoxActReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBoxActReq
     * @static
     * @param {ClientBoxActReq} message ClientBoxActReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBoxActReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        return object;
    };

    /**
     * Converts this ClientBoxActReq to JSON.
     * @function toJSON
     * @memberof ClientBoxActReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBoxActReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBoxActReq
     * @function getTypeUrl
     * @memberof ClientBoxActReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBoxActReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBoxActReq";
    };

    return ClientBoxActReq;
})();

export const ClientBoxActAck = $root.ClientBoxActAck = (() => {

    /**
     * Properties of a ClientBoxActAck.
     * @exports IClientBoxActAck
     * @interface IClientBoxActAck
     * @property {number|null} [ret] ClientBoxActAck ret
     * @property {number|null} [UserID] ClientBoxActAck UserID
     * @property {number|null} [ChannelID] ClientBoxActAck ChannelID
     * @property {boolean|null} [BcanBox] ClientBoxActAck BcanBox
     * @property {number|Long|null} [WeeTime] ClientBoxActAck WeeTime
     * @property {number|Long|null} [NowTime] ClientBoxActAck NowTime
     * @property {number|null} [BoxNum] ClientBoxActAck BoxNum
     * @property {number|null} [BoxTop] ClientBoxActAck BoxTop
     * @property {number|null} [GetBox] ClientBoxActAck GetBox
     * @property {Array.<IBoxInfo>|null} [BoxCell] ClientBoxActAck BoxCell
     */

    /**
     * Constructs a new ClientBoxActAck.
     * @exports ClientBoxActAck
     * @classdesc Represents a ClientBoxActAck.
     * @implements IClientBoxActAck
     * @constructor
     * @param {IClientBoxActAck=} [properties] Properties to set
     */
    function ClientBoxActAck(properties) {
        this.BoxCell = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBoxActAck ret.
     * @member {number} ret
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.ret = 0;

    /**
     * ClientBoxActAck UserID.
     * @member {number} UserID
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.UserID = 0;

    /**
     * ClientBoxActAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.ChannelID = 0;

    /**
     * ClientBoxActAck BcanBox.
     * @member {boolean} BcanBox
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.BcanBox = false;

    /**
     * ClientBoxActAck WeeTime.
     * @member {number|Long} WeeTime
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.WeeTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientBoxActAck NowTime.
     * @member {number|Long} NowTime
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.NowTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientBoxActAck BoxNum.
     * @member {number} BoxNum
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.BoxNum = 0;

    /**
     * ClientBoxActAck BoxTop.
     * @member {number} BoxTop
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.BoxTop = 0;

    /**
     * ClientBoxActAck GetBox.
     * @member {number} GetBox
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.GetBox = 0;

    /**
     * ClientBoxActAck BoxCell.
     * @member {Array.<IBoxInfo>} BoxCell
     * @memberof ClientBoxActAck
     * @instance
     */
    ClientBoxActAck.prototype.BoxCell = $util.emptyArray;

    /**
     * Creates a new ClientBoxActAck instance using the specified properties.
     * @function create
     * @memberof ClientBoxActAck
     * @static
     * @param {IClientBoxActAck=} [properties] Properties to set
     * @returns {ClientBoxActAck} ClientBoxActAck instance
     */
    ClientBoxActAck.create = function create(properties) {
        return new ClientBoxActAck(properties);
    };

    /**
     * Encodes the specified ClientBoxActAck message. Does not implicitly {@link ClientBoxActAck.verify|verify} messages.
     * @function encode
     * @memberof ClientBoxActAck
     * @static
     * @param {IClientBoxActAck} message ClientBoxActAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.BcanBox != null && Object.hasOwnProperty.call(message, "BcanBox"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.BcanBox);
        if (message.WeeTime != null && Object.hasOwnProperty.call(message, "WeeTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.WeeTime);
        if (message.NowTime != null && Object.hasOwnProperty.call(message, "NowTime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.NowTime);
        if (message.BoxNum != null && Object.hasOwnProperty.call(message, "BoxNum"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.BoxNum);
        if (message.BoxTop != null && Object.hasOwnProperty.call(message, "BoxTop"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.BoxTop);
        if (message.GetBox != null && Object.hasOwnProperty.call(message, "GetBox"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.GetBox);
        if (message.BoxCell != null && message.BoxCell.length)
            for (let i = 0; i < message.BoxCell.length; ++i)
                $root.BoxInfo.encode(message.BoxCell[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientBoxActAck message, length delimited. Does not implicitly {@link ClientBoxActAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBoxActAck
     * @static
     * @param {IClientBoxActAck} message ClientBoxActAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBoxActAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBoxActAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBoxActAck} ClientBoxActAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBoxActAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.BcanBox = reader.bool();
                    break;
                }
            case 5: {
                    message.WeeTime = reader.uint64();
                    break;
                }
            case 6: {
                    message.NowTime = reader.uint64();
                    break;
                }
            case 7: {
                    message.BoxNum = reader.uint32();
                    break;
                }
            case 8: {
                    message.BoxTop = reader.uint32();
                    break;
                }
            case 9: {
                    message.GetBox = reader.uint32();
                    break;
                }
            case 10: {
                    if (!(message.BoxCell && message.BoxCell.length))
                        message.BoxCell = [];
                    message.BoxCell.push($root.BoxInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBoxActAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBoxActAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBoxActAck} ClientBoxActAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBoxActAck message.
     * @function verify
     * @memberof ClientBoxActAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBoxActAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.BcanBox != null && message.hasOwnProperty("BcanBox"))
            if (typeof message.BcanBox !== "boolean")
                return "BcanBox: boolean expected";
        if (message.WeeTime != null && message.hasOwnProperty("WeeTime"))
            if (!$util.isInteger(message.WeeTime) && !(message.WeeTime && $util.isInteger(message.WeeTime.low) && $util.isInteger(message.WeeTime.high)))
                return "WeeTime: integer|Long expected";
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (!$util.isInteger(message.NowTime) && !(message.NowTime && $util.isInteger(message.NowTime.low) && $util.isInteger(message.NowTime.high)))
                return "NowTime: integer|Long expected";
        if (message.BoxNum != null && message.hasOwnProperty("BoxNum"))
            if (!$util.isInteger(message.BoxNum))
                return "BoxNum: integer expected";
        if (message.BoxTop != null && message.hasOwnProperty("BoxTop"))
            if (!$util.isInteger(message.BoxTop))
                return "BoxTop: integer expected";
        if (message.GetBox != null && message.hasOwnProperty("GetBox"))
            if (!$util.isInteger(message.GetBox))
                return "GetBox: integer expected";
        if (message.BoxCell != null && message.hasOwnProperty("BoxCell")) {
            if (!Array.isArray(message.BoxCell))
                return "BoxCell: array expected";
            for (let i = 0; i < message.BoxCell.length; ++i) {
                let error = $root.BoxInfo.verify(message.BoxCell[i]);
                if (error)
                    return "BoxCell." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientBoxActAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBoxActAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBoxActAck} ClientBoxActAck
     */
    ClientBoxActAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBoxActAck)
            return object;
        let message = new $root.ClientBoxActAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.BcanBox != null)
            message.BcanBox = Boolean(object.BcanBox);
        if (object.WeeTime != null)
            if ($util.Long)
                (message.WeeTime = $util.Long.fromValue(object.WeeTime)).unsigned = true;
            else if (typeof object.WeeTime === "string")
                message.WeeTime = parseInt(object.WeeTime, 10);
            else if (typeof object.WeeTime === "number")
                message.WeeTime = object.WeeTime;
            else if (typeof object.WeeTime === "object")
                message.WeeTime = new $util.LongBits(object.WeeTime.low >>> 0, object.WeeTime.high >>> 0).toNumber(true);
        if (object.NowTime != null)
            if ($util.Long)
                (message.NowTime = $util.Long.fromValue(object.NowTime)).unsigned = true;
            else if (typeof object.NowTime === "string")
                message.NowTime = parseInt(object.NowTime, 10);
            else if (typeof object.NowTime === "number")
                message.NowTime = object.NowTime;
            else if (typeof object.NowTime === "object")
                message.NowTime = new $util.LongBits(object.NowTime.low >>> 0, object.NowTime.high >>> 0).toNumber(true);
        if (object.BoxNum != null)
            message.BoxNum = object.BoxNum >>> 0;
        if (object.BoxTop != null)
            message.BoxTop = object.BoxTop >>> 0;
        if (object.GetBox != null)
            message.GetBox = object.GetBox >>> 0;
        if (object.BoxCell) {
            if (!Array.isArray(object.BoxCell))
                throw TypeError(".ClientBoxActAck.BoxCell: array expected");
            message.BoxCell = [];
            for (let i = 0; i < object.BoxCell.length; ++i) {
                if (typeof object.BoxCell[i] !== "object")
                    throw TypeError(".ClientBoxActAck.BoxCell: object expected");
                message.BoxCell[i] = $root.BoxInfo.fromObject(object.BoxCell[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientBoxActAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBoxActAck
     * @static
     * @param {ClientBoxActAck} message ClientBoxActAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBoxActAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BoxCell = [];
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.BcanBox = false;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.WeeTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.WeeTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NowTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NowTime = options.longs === String ? "0" : 0;
            object.BoxNum = 0;
            object.BoxTop = 0;
            object.GetBox = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.BcanBox != null && message.hasOwnProperty("BcanBox"))
            object.BcanBox = message.BcanBox;
        if (message.WeeTime != null && message.hasOwnProperty("WeeTime"))
            if (typeof message.WeeTime === "number")
                object.WeeTime = options.longs === String ? String(message.WeeTime) : message.WeeTime;
            else
                object.WeeTime = options.longs === String ? $util.Long.prototype.toString.call(message.WeeTime) : options.longs === Number ? new $util.LongBits(message.WeeTime.low >>> 0, message.WeeTime.high >>> 0).toNumber(true) : message.WeeTime;
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (typeof message.NowTime === "number")
                object.NowTime = options.longs === String ? String(message.NowTime) : message.NowTime;
            else
                object.NowTime = options.longs === String ? $util.Long.prototype.toString.call(message.NowTime) : options.longs === Number ? new $util.LongBits(message.NowTime.low >>> 0, message.NowTime.high >>> 0).toNumber(true) : message.NowTime;
        if (message.BoxNum != null && message.hasOwnProperty("BoxNum"))
            object.BoxNum = message.BoxNum;
        if (message.BoxTop != null && message.hasOwnProperty("BoxTop"))
            object.BoxTop = message.BoxTop;
        if (message.GetBox != null && message.hasOwnProperty("GetBox"))
            object.GetBox = message.GetBox;
        if (message.BoxCell && message.BoxCell.length) {
            object.BoxCell = [];
            for (let j = 0; j < message.BoxCell.length; ++j)
                object.BoxCell[j] = $root.BoxInfo.toObject(message.BoxCell[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientBoxActAck to JSON.
     * @function toJSON
     * @memberof ClientBoxActAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBoxActAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBoxActAck
     * @function getTypeUrl
     * @memberof ClientBoxActAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBoxActAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBoxActAck";
    };

    return ClientBoxActAck;
})();

export const ClientBoxActGetReq = $root.ClientBoxActGetReq = (() => {

    /**
     * Properties of a ClientBoxActGetReq.
     * @exports IClientBoxActGetReq
     * @interface IClientBoxActGetReq
     * @property {number|null} [UserID] ClientBoxActGetReq UserID
     * @property {number|null} [ChannelID] ClientBoxActGetReq ChannelID
     * @property {number|null} [BoxCell] ClientBoxActGetReq BoxCell
     */

    /**
     * Constructs a new ClientBoxActGetReq.
     * @exports ClientBoxActGetReq
     * @classdesc Represents a ClientBoxActGetReq.
     * @implements IClientBoxActGetReq
     * @constructor
     * @param {IClientBoxActGetReq=} [properties] Properties to set
     */
    function ClientBoxActGetReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBoxActGetReq UserID.
     * @member {number} UserID
     * @memberof ClientBoxActGetReq
     * @instance
     */
    ClientBoxActGetReq.prototype.UserID = 0;

    /**
     * ClientBoxActGetReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientBoxActGetReq
     * @instance
     */
    ClientBoxActGetReq.prototype.ChannelID = 0;

    /**
     * ClientBoxActGetReq BoxCell.
     * @member {number} BoxCell
     * @memberof ClientBoxActGetReq
     * @instance
     */
    ClientBoxActGetReq.prototype.BoxCell = 0;

    /**
     * Creates a new ClientBoxActGetReq instance using the specified properties.
     * @function create
     * @memberof ClientBoxActGetReq
     * @static
     * @param {IClientBoxActGetReq=} [properties] Properties to set
     * @returns {ClientBoxActGetReq} ClientBoxActGetReq instance
     */
    ClientBoxActGetReq.create = function create(properties) {
        return new ClientBoxActGetReq(properties);
    };

    /**
     * Encodes the specified ClientBoxActGetReq message. Does not implicitly {@link ClientBoxActGetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientBoxActGetReq
     * @static
     * @param {IClientBoxActGetReq} message ClientBoxActGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActGetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.BoxCell != null && Object.hasOwnProperty.call(message, "BoxCell"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BoxCell);
        return writer;
    };

    /**
     * Encodes the specified ClientBoxActGetReq message, length delimited. Does not implicitly {@link ClientBoxActGetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBoxActGetReq
     * @static
     * @param {IClientBoxActGetReq} message ClientBoxActGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActGetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBoxActGetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBoxActGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBoxActGetReq} ClientBoxActGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActGetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBoxActGetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.BoxCell = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBoxActGetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBoxActGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBoxActGetReq} ClientBoxActGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActGetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBoxActGetReq message.
     * @function verify
     * @memberof ClientBoxActGetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBoxActGetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.BoxCell != null && message.hasOwnProperty("BoxCell"))
            if (!$util.isInteger(message.BoxCell))
                return "BoxCell: integer expected";
        return null;
    };

    /**
     * Creates a ClientBoxActGetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBoxActGetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBoxActGetReq} ClientBoxActGetReq
     */
    ClientBoxActGetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBoxActGetReq)
            return object;
        let message = new $root.ClientBoxActGetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.BoxCell != null)
            message.BoxCell = object.BoxCell >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBoxActGetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBoxActGetReq
     * @static
     * @param {ClientBoxActGetReq} message ClientBoxActGetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBoxActGetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.BoxCell = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.BoxCell != null && message.hasOwnProperty("BoxCell"))
            object.BoxCell = message.BoxCell;
        return object;
    };

    /**
     * Converts this ClientBoxActGetReq to JSON.
     * @function toJSON
     * @memberof ClientBoxActGetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBoxActGetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBoxActGetReq
     * @function getTypeUrl
     * @memberof ClientBoxActGetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBoxActGetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBoxActGetReq";
    };

    return ClientBoxActGetReq;
})();

export const ClientBoxActGetAck = $root.ClientBoxActGetAck = (() => {

    /**
     * Properties of a ClientBoxActGetAck.
     * @exports IClientBoxActGetAck
     * @interface IClientBoxActGetAck
     * @property {number|null} [ret] ClientBoxActGetAck ret
     * @property {number|null} [UserID] ClientBoxActGetAck UserID
     * @property {number|null} [ChannelID] ClientBoxActGetAck ChannelID
     * @property {number|null} [BoxType] ClientBoxActGetAck BoxType
     * @property {number|null} [BoxProp] ClientBoxActGetAck BoxProp
     */

    /**
     * Constructs a new ClientBoxActGetAck.
     * @exports ClientBoxActGetAck
     * @classdesc Represents a ClientBoxActGetAck.
     * @implements IClientBoxActGetAck
     * @constructor
     * @param {IClientBoxActGetAck=} [properties] Properties to set
     */
    function ClientBoxActGetAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientBoxActGetAck ret.
     * @member {number} ret
     * @memberof ClientBoxActGetAck
     * @instance
     */
    ClientBoxActGetAck.prototype.ret = 0;

    /**
     * ClientBoxActGetAck UserID.
     * @member {number} UserID
     * @memberof ClientBoxActGetAck
     * @instance
     */
    ClientBoxActGetAck.prototype.UserID = 0;

    /**
     * ClientBoxActGetAck ChannelID.
     * @member {number} ChannelID
     * @memberof ClientBoxActGetAck
     * @instance
     */
    ClientBoxActGetAck.prototype.ChannelID = 0;

    /**
     * ClientBoxActGetAck BoxType.
     * @member {number} BoxType
     * @memberof ClientBoxActGetAck
     * @instance
     */
    ClientBoxActGetAck.prototype.BoxType = 0;

    /**
     * ClientBoxActGetAck BoxProp.
     * @member {number} BoxProp
     * @memberof ClientBoxActGetAck
     * @instance
     */
    ClientBoxActGetAck.prototype.BoxProp = 0;

    /**
     * Creates a new ClientBoxActGetAck instance using the specified properties.
     * @function create
     * @memberof ClientBoxActGetAck
     * @static
     * @param {IClientBoxActGetAck=} [properties] Properties to set
     * @returns {ClientBoxActGetAck} ClientBoxActGetAck instance
     */
    ClientBoxActGetAck.create = function create(properties) {
        return new ClientBoxActGetAck(properties);
    };

    /**
     * Encodes the specified ClientBoxActGetAck message. Does not implicitly {@link ClientBoxActGetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientBoxActGetAck
     * @static
     * @param {IClientBoxActGetAck} message ClientBoxActGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActGetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ChannelID);
        if (message.BoxType != null && Object.hasOwnProperty.call(message, "BoxType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.BoxType);
        if (message.BoxProp != null && Object.hasOwnProperty.call(message, "BoxProp"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BoxProp);
        return writer;
    };

    /**
     * Encodes the specified ClientBoxActGetAck message, length delimited. Does not implicitly {@link ClientBoxActGetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientBoxActGetAck
     * @static
     * @param {IClientBoxActGetAck} message ClientBoxActGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientBoxActGetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientBoxActGetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientBoxActGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientBoxActGetAck} ClientBoxActGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActGetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientBoxActGetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 4: {
                    message.BoxType = reader.uint32();
                    break;
                }
            case 5: {
                    message.BoxProp = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientBoxActGetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientBoxActGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientBoxActGetAck} ClientBoxActGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientBoxActGetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientBoxActGetAck message.
     * @function verify
     * @memberof ClientBoxActGetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientBoxActGetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.BoxType != null && message.hasOwnProperty("BoxType"))
            if (!$util.isInteger(message.BoxType))
                return "BoxType: integer expected";
        if (message.BoxProp != null && message.hasOwnProperty("BoxProp"))
            if (!$util.isInteger(message.BoxProp))
                return "BoxProp: integer expected";
        return null;
    };

    /**
     * Creates a ClientBoxActGetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientBoxActGetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientBoxActGetAck} ClientBoxActGetAck
     */
    ClientBoxActGetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientBoxActGetAck)
            return object;
        let message = new $root.ClientBoxActGetAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.BoxType != null)
            message.BoxType = object.BoxType >>> 0;
        if (object.BoxProp != null)
            message.BoxProp = object.BoxProp >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientBoxActGetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientBoxActGetAck
     * @static
     * @param {ClientBoxActGetAck} message ClientBoxActGetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientBoxActGetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.ChannelID = 0;
            object.BoxType = 0;
            object.BoxProp = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.BoxType != null && message.hasOwnProperty("BoxType"))
            object.BoxType = message.BoxType;
        if (message.BoxProp != null && message.hasOwnProperty("BoxProp"))
            object.BoxProp = message.BoxProp;
        return object;
    };

    /**
     * Converts this ClientBoxActGetAck to JSON.
     * @function toJSON
     * @memberof ClientBoxActGetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientBoxActGetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientBoxActGetAck
     * @function getTypeUrl
     * @memberof ClientBoxActGetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientBoxActGetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientBoxActGetAck";
    };

    return ClientBoxActGetAck;
})();

export const ClientGemActReq = $root.ClientGemActReq = (() => {

    /**
     * Properties of a ClientGemActReq.
     * @exports IClientGemActReq
     * @interface IClientGemActReq
     * @property {number|null} [UserID] ClientGemActReq UserID
     */

    /**
     * Constructs a new ClientGemActReq.
     * @exports ClientGemActReq
     * @classdesc Represents a ClientGemActReq.
     * @implements IClientGemActReq
     * @constructor
     * @param {IClientGemActReq=} [properties] Properties to set
     */
    function ClientGemActReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemActReq UserID.
     * @member {number} UserID
     * @memberof ClientGemActReq
     * @instance
     */
    ClientGemActReq.prototype.UserID = 0;

    /**
     * Creates a new ClientGemActReq instance using the specified properties.
     * @function create
     * @memberof ClientGemActReq
     * @static
     * @param {IClientGemActReq=} [properties] Properties to set
     * @returns {ClientGemActReq} ClientGemActReq instance
     */
    ClientGemActReq.create = function create(properties) {
        return new ClientGemActReq(properties);
    };

    /**
     * Encodes the specified ClientGemActReq message. Does not implicitly {@link ClientGemActReq.verify|verify} messages.
     * @function encode
     * @memberof ClientGemActReq
     * @static
     * @param {IClientGemActReq} message ClientGemActReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemActReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientGemActReq message, length delimited. Does not implicitly {@link ClientGemActReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemActReq
     * @static
     * @param {IClientGemActReq} message ClientGemActReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemActReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemActReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemActReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemActReq} ClientGemActReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemActReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemActReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemActReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemActReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemActReq} ClientGemActReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemActReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemActReq message.
     * @function verify
     * @memberof ClientGemActReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemActReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemActReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemActReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemActReq} ClientGemActReq
     */
    ClientGemActReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemActReq)
            return object;
        let message = new $root.ClientGemActReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemActReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemActReq
     * @static
     * @param {ClientGemActReq} message ClientGemActReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemActReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientGemActReq to JSON.
     * @function toJSON
     * @memberof ClientGemActReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemActReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemActReq
     * @function getTypeUrl
     * @memberof ClientGemActReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemActReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemActReq";
    };

    return ClientGemActReq;
})();

export const ClientGemActAck = $root.ClientGemActAck = (() => {

    /**
     * Properties of a ClientGemActAck.
     * @exports IClientGemActAck
     * @interface IClientGemActAck
     * @property {number|null} [UserID] ClientGemActAck UserID
     * @property {number|null} [IGem] ClientGemActAck IGem
     */

    /**
     * Constructs a new ClientGemActAck.
     * @exports ClientGemActAck
     * @classdesc Represents a ClientGemActAck.
     * @implements IClientGemActAck
     * @constructor
     * @param {IClientGemActAck=} [properties] Properties to set
     */
    function ClientGemActAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemActAck UserID.
     * @member {number} UserID
     * @memberof ClientGemActAck
     * @instance
     */
    ClientGemActAck.prototype.UserID = 0;

    /**
     * ClientGemActAck IGem.
     * @member {number} IGem
     * @memberof ClientGemActAck
     * @instance
     */
    ClientGemActAck.prototype.IGem = 0;

    /**
     * Creates a new ClientGemActAck instance using the specified properties.
     * @function create
     * @memberof ClientGemActAck
     * @static
     * @param {IClientGemActAck=} [properties] Properties to set
     * @returns {ClientGemActAck} ClientGemActAck instance
     */
    ClientGemActAck.create = function create(properties) {
        return new ClientGemActAck(properties);
    };

    /**
     * Encodes the specified ClientGemActAck message. Does not implicitly {@link ClientGemActAck.verify|verify} messages.
     * @function encode
     * @memberof ClientGemActAck
     * @static
     * @param {IClientGemActAck} message ClientGemActAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemActAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.IGem != null && Object.hasOwnProperty.call(message, "IGem"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.IGem);
        return writer;
    };

    /**
     * Encodes the specified ClientGemActAck message, length delimited. Does not implicitly {@link ClientGemActAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemActAck
     * @static
     * @param {IClientGemActAck} message ClientGemActAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemActAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemActAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemActAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemActAck} ClientGemActAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemActAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemActAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.IGem = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemActAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemActAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemActAck} ClientGemActAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemActAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemActAck message.
     * @function verify
     * @memberof ClientGemActAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemActAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.IGem != null && message.hasOwnProperty("IGem"))
            if (!$util.isInteger(message.IGem))
                return "IGem: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemActAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemActAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemActAck} ClientGemActAck
     */
    ClientGemActAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemActAck)
            return object;
        let message = new $root.ClientGemActAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.IGem != null)
            message.IGem = object.IGem >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemActAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemActAck
     * @static
     * @param {ClientGemActAck} message ClientGemActAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemActAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.IGem = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.IGem != null && message.hasOwnProperty("IGem"))
            object.IGem = message.IGem;
        return object;
    };

    /**
     * Converts this ClientGemActAck to JSON.
     * @function toJSON
     * @memberof ClientGemActAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemActAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemActAck
     * @function getTypeUrl
     * @memberof ClientGemActAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemActAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemActAck";
    };

    return ClientGemActAck;
})();

export const ClientGemDataReq = $root.ClientGemDataReq = (() => {

    /**
     * Properties of a ClientGemDataReq.
     * @exports IClientGemDataReq
     * @interface IClientGemDataReq
     * @property {number|null} [UserID] ClientGemDataReq UserID
     */

    /**
     * Constructs a new ClientGemDataReq.
     * @exports ClientGemDataReq
     * @classdesc Represents a ClientGemDataReq.
     * @implements IClientGemDataReq
     * @constructor
     * @param {IClientGemDataReq=} [properties] Properties to set
     */
    function ClientGemDataReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemDataReq UserID.
     * @member {number} UserID
     * @memberof ClientGemDataReq
     * @instance
     */
    ClientGemDataReq.prototype.UserID = 0;

    /**
     * Creates a new ClientGemDataReq instance using the specified properties.
     * @function create
     * @memberof ClientGemDataReq
     * @static
     * @param {IClientGemDataReq=} [properties] Properties to set
     * @returns {ClientGemDataReq} ClientGemDataReq instance
     */
    ClientGemDataReq.create = function create(properties) {
        return new ClientGemDataReq(properties);
    };

    /**
     * Encodes the specified ClientGemDataReq message. Does not implicitly {@link ClientGemDataReq.verify|verify} messages.
     * @function encode
     * @memberof ClientGemDataReq
     * @static
     * @param {IClientGemDataReq} message ClientGemDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemDataReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientGemDataReq message, length delimited. Does not implicitly {@link ClientGemDataReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemDataReq
     * @static
     * @param {IClientGemDataReq} message ClientGemDataReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemDataReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemDataReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemDataReq} ClientGemDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemDataReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemDataReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemDataReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemDataReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemDataReq} ClientGemDataReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemDataReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemDataReq message.
     * @function verify
     * @memberof ClientGemDataReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemDataReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemDataReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemDataReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemDataReq} ClientGemDataReq
     */
    ClientGemDataReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemDataReq)
            return object;
        let message = new $root.ClientGemDataReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemDataReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemDataReq
     * @static
     * @param {ClientGemDataReq} message ClientGemDataReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemDataReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientGemDataReq to JSON.
     * @function toJSON
     * @memberof ClientGemDataReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemDataReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemDataReq
     * @function getTypeUrl
     * @memberof ClientGemDataReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemDataReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemDataReq";
    };

    return ClientGemDataReq;
})();

export const ClientGemDataAck = $root.ClientGemDataAck = (() => {

    /**
     * Properties of a ClientGemDataAck.
     * @exports IClientGemDataAck
     * @interface IClientGemDataAck
     * @property {number|null} [ret] ClientGemDataAck ret
     * @property {number|null} [UserID] ClientGemDataAck UserID
     * @property {number|Long|null} [NowTime] ClientGemDataAck NowTime
     * @property {number|Long|null} [BegTime] ClientGemDataAck BegTime
     * @property {number|Long|null} [EndTime] ClientGemDataAck EndTime
     * @property {number|null} [GemNum1] ClientGemDataAck GemNum1
     * @property {number|null} [GemGold1] ClientGemDataAck GemGold1
     * @property {number|null} [GemNum2] ClientGemDataAck GemNum2
     * @property {number|null} [GemGold2] ClientGemDataAck GemGold2
     * @property {number|null} [GemNum3] ClientGemDataAck GemNum3
     * @property {number|null} [GemGold3] ClientGemDataAck GemGold3
     * @property {string|null} [GemTake] ClientGemDataAck GemTake
     * @property {number|null} [SpinsLeft] ClientGemDataAck SpinsLeft
     */

    /**
     * Constructs a new ClientGemDataAck.
     * @exports ClientGemDataAck
     * @classdesc Represents a ClientGemDataAck.
     * @implements IClientGemDataAck
     * @constructor
     * @param {IClientGemDataAck=} [properties] Properties to set
     */
    function ClientGemDataAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemDataAck ret.
     * @member {number} ret
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.ret = 0;

    /**
     * ClientGemDataAck UserID.
     * @member {number} UserID
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.UserID = 0;

    /**
     * ClientGemDataAck NowTime.
     * @member {number|Long} NowTime
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.NowTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientGemDataAck BegTime.
     * @member {number|Long} BegTime
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.BegTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientGemDataAck EndTime.
     * @member {number|Long} EndTime
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.EndTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ClientGemDataAck GemNum1.
     * @member {number} GemNum1
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemNum1 = 0;

    /**
     * ClientGemDataAck GemGold1.
     * @member {number} GemGold1
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemGold1 = 0;

    /**
     * ClientGemDataAck GemNum2.
     * @member {number} GemNum2
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemNum2 = 0;

    /**
     * ClientGemDataAck GemGold2.
     * @member {number} GemGold2
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemGold2 = 0;

    /**
     * ClientGemDataAck GemNum3.
     * @member {number} GemNum3
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemNum3 = 0;

    /**
     * ClientGemDataAck GemGold3.
     * @member {number} GemGold3
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemGold3 = 0;

    /**
     * ClientGemDataAck GemTake.
     * @member {string} GemTake
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.GemTake = "";

    /**
     * ClientGemDataAck SpinsLeft.
     * @member {number} SpinsLeft
     * @memberof ClientGemDataAck
     * @instance
     */
    ClientGemDataAck.prototype.SpinsLeft = 0;

    /**
     * Creates a new ClientGemDataAck instance using the specified properties.
     * @function create
     * @memberof ClientGemDataAck
     * @static
     * @param {IClientGemDataAck=} [properties] Properties to set
     * @returns {ClientGemDataAck} ClientGemDataAck instance
     */
    ClientGemDataAck.create = function create(properties) {
        return new ClientGemDataAck(properties);
    };

    /**
     * Encodes the specified ClientGemDataAck message. Does not implicitly {@link ClientGemDataAck.verify|verify} messages.
     * @function encode
     * @memberof ClientGemDataAck
     * @static
     * @param {IClientGemDataAck} message ClientGemDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.NowTime != null && Object.hasOwnProperty.call(message, "NowTime"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.NowTime);
        if (message.BegTime != null && Object.hasOwnProperty.call(message, "BegTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BegTime);
        if (message.EndTime != null && Object.hasOwnProperty.call(message, "EndTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.EndTime);
        if (message.GemNum1 != null && Object.hasOwnProperty.call(message, "GemNum1"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.GemNum1);
        if (message.GemGold1 != null && Object.hasOwnProperty.call(message, "GemGold1"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.GemGold1);
        if (message.GemNum2 != null && Object.hasOwnProperty.call(message, "GemNum2"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.GemNum2);
        if (message.GemGold2 != null && Object.hasOwnProperty.call(message, "GemGold2"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.GemGold2);
        if (message.GemNum3 != null && Object.hasOwnProperty.call(message, "GemNum3"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.GemNum3);
        if (message.GemGold3 != null && Object.hasOwnProperty.call(message, "GemGold3"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.GemGold3);
        if (message.GemTake != null && Object.hasOwnProperty.call(message, "GemTake"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.GemTake);
        if (message.SpinsLeft != null && Object.hasOwnProperty.call(message, "SpinsLeft"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.SpinsLeft);
        return writer;
    };

    /**
     * Encodes the specified ClientGemDataAck message, length delimited. Does not implicitly {@link ClientGemDataAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemDataAck
     * @static
     * @param {IClientGemDataAck} message ClientGemDataAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemDataAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemDataAck} ClientGemDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemDataAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemDataAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.NowTime = reader.uint64();
                    break;
                }
            case 4: {
                    message.BegTime = reader.uint64();
                    break;
                }
            case 5: {
                    message.EndTime = reader.uint64();
                    break;
                }
            case 6: {
                    message.GemNum1 = reader.uint32();
                    break;
                }
            case 7: {
                    message.GemGold1 = reader.uint32();
                    break;
                }
            case 8: {
                    message.GemNum2 = reader.uint32();
                    break;
                }
            case 9: {
                    message.GemGold2 = reader.uint32();
                    break;
                }
            case 10: {
                    message.GemNum3 = reader.uint32();
                    break;
                }
            case 11: {
                    message.GemGold3 = reader.uint32();
                    break;
                }
            case 12: {
                    message.GemTake = reader.string();
                    break;
                }
            case 13: {
                    message.SpinsLeft = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemDataAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemDataAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemDataAck} ClientGemDataAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemDataAck message.
     * @function verify
     * @memberof ClientGemDataAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (!$util.isInteger(message.NowTime) && !(message.NowTime && $util.isInteger(message.NowTime.low) && $util.isInteger(message.NowTime.high)))
                return "NowTime: integer|Long expected";
        if (message.BegTime != null && message.hasOwnProperty("BegTime"))
            if (!$util.isInteger(message.BegTime) && !(message.BegTime && $util.isInteger(message.BegTime.low) && $util.isInteger(message.BegTime.high)))
                return "BegTime: integer|Long expected";
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (!$util.isInteger(message.EndTime) && !(message.EndTime && $util.isInteger(message.EndTime.low) && $util.isInteger(message.EndTime.high)))
                return "EndTime: integer|Long expected";
        if (message.GemNum1 != null && message.hasOwnProperty("GemNum1"))
            if (!$util.isInteger(message.GemNum1))
                return "GemNum1: integer expected";
        if (message.GemGold1 != null && message.hasOwnProperty("GemGold1"))
            if (!$util.isInteger(message.GemGold1))
                return "GemGold1: integer expected";
        if (message.GemNum2 != null && message.hasOwnProperty("GemNum2"))
            if (!$util.isInteger(message.GemNum2))
                return "GemNum2: integer expected";
        if (message.GemGold2 != null && message.hasOwnProperty("GemGold2"))
            if (!$util.isInteger(message.GemGold2))
                return "GemGold2: integer expected";
        if (message.GemNum3 != null && message.hasOwnProperty("GemNum3"))
            if (!$util.isInteger(message.GemNum3))
                return "GemNum3: integer expected";
        if (message.GemGold3 != null && message.hasOwnProperty("GemGold3"))
            if (!$util.isInteger(message.GemGold3))
                return "GemGold3: integer expected";
        if (message.GemTake != null && message.hasOwnProperty("GemTake"))
            if (!$util.isString(message.GemTake))
                return "GemTake: string expected";
        if (message.SpinsLeft != null && message.hasOwnProperty("SpinsLeft"))
            if (!$util.isInteger(message.SpinsLeft))
                return "SpinsLeft: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemDataAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemDataAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemDataAck} ClientGemDataAck
     */
    ClientGemDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemDataAck)
            return object;
        let message = new $root.ClientGemDataAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NowTime != null)
            if ($util.Long)
                (message.NowTime = $util.Long.fromValue(object.NowTime)).unsigned = true;
            else if (typeof object.NowTime === "string")
                message.NowTime = parseInt(object.NowTime, 10);
            else if (typeof object.NowTime === "number")
                message.NowTime = object.NowTime;
            else if (typeof object.NowTime === "object")
                message.NowTime = new $util.LongBits(object.NowTime.low >>> 0, object.NowTime.high >>> 0).toNumber(true);
        if (object.BegTime != null)
            if ($util.Long)
                (message.BegTime = $util.Long.fromValue(object.BegTime)).unsigned = true;
            else if (typeof object.BegTime === "string")
                message.BegTime = parseInt(object.BegTime, 10);
            else if (typeof object.BegTime === "number")
                message.BegTime = object.BegTime;
            else if (typeof object.BegTime === "object")
                message.BegTime = new $util.LongBits(object.BegTime.low >>> 0, object.BegTime.high >>> 0).toNumber(true);
        if (object.EndTime != null)
            if ($util.Long)
                (message.EndTime = $util.Long.fromValue(object.EndTime)).unsigned = true;
            else if (typeof object.EndTime === "string")
                message.EndTime = parseInt(object.EndTime, 10);
            else if (typeof object.EndTime === "number")
                message.EndTime = object.EndTime;
            else if (typeof object.EndTime === "object")
                message.EndTime = new $util.LongBits(object.EndTime.low >>> 0, object.EndTime.high >>> 0).toNumber(true);
        if (object.GemNum1 != null)
            message.GemNum1 = object.GemNum1 >>> 0;
        if (object.GemGold1 != null)
            message.GemGold1 = object.GemGold1 >>> 0;
        if (object.GemNum2 != null)
            message.GemNum2 = object.GemNum2 >>> 0;
        if (object.GemGold2 != null)
            message.GemGold2 = object.GemGold2 >>> 0;
        if (object.GemNum3 != null)
            message.GemNum3 = object.GemNum3 >>> 0;
        if (object.GemGold3 != null)
            message.GemGold3 = object.GemGold3 >>> 0;
        if (object.GemTake != null)
            message.GemTake = String(object.GemTake);
        if (object.SpinsLeft != null)
            message.SpinsLeft = object.SpinsLeft >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemDataAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemDataAck
     * @static
     * @param {ClientGemDataAck} message ClientGemDataAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.NowTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.NowTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BegTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BegTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.EndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EndTime = options.longs === String ? "0" : 0;
            object.GemNum1 = 0;
            object.GemGold1 = 0;
            object.GemNum2 = 0;
            object.GemGold2 = 0;
            object.GemNum3 = 0;
            object.GemGold3 = 0;
            object.GemTake = "";
            object.SpinsLeft = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NowTime != null && message.hasOwnProperty("NowTime"))
            if (typeof message.NowTime === "number")
                object.NowTime = options.longs === String ? String(message.NowTime) : message.NowTime;
            else
                object.NowTime = options.longs === String ? $util.Long.prototype.toString.call(message.NowTime) : options.longs === Number ? new $util.LongBits(message.NowTime.low >>> 0, message.NowTime.high >>> 0).toNumber(true) : message.NowTime;
        if (message.BegTime != null && message.hasOwnProperty("BegTime"))
            if (typeof message.BegTime === "number")
                object.BegTime = options.longs === String ? String(message.BegTime) : message.BegTime;
            else
                object.BegTime = options.longs === String ? $util.Long.prototype.toString.call(message.BegTime) : options.longs === Number ? new $util.LongBits(message.BegTime.low >>> 0, message.BegTime.high >>> 0).toNumber(true) : message.BegTime;
        if (message.EndTime != null && message.hasOwnProperty("EndTime"))
            if (typeof message.EndTime === "number")
                object.EndTime = options.longs === String ? String(message.EndTime) : message.EndTime;
            else
                object.EndTime = options.longs === String ? $util.Long.prototype.toString.call(message.EndTime) : options.longs === Number ? new $util.LongBits(message.EndTime.low >>> 0, message.EndTime.high >>> 0).toNumber(true) : message.EndTime;
        if (message.GemNum1 != null && message.hasOwnProperty("GemNum1"))
            object.GemNum1 = message.GemNum1;
        if (message.GemGold1 != null && message.hasOwnProperty("GemGold1"))
            object.GemGold1 = message.GemGold1;
        if (message.GemNum2 != null && message.hasOwnProperty("GemNum2"))
            object.GemNum2 = message.GemNum2;
        if (message.GemGold2 != null && message.hasOwnProperty("GemGold2"))
            object.GemGold2 = message.GemGold2;
        if (message.GemNum3 != null && message.hasOwnProperty("GemNum3"))
            object.GemNum3 = message.GemNum3;
        if (message.GemGold3 != null && message.hasOwnProperty("GemGold3"))
            object.GemGold3 = message.GemGold3;
        if (message.GemTake != null && message.hasOwnProperty("GemTake"))
            object.GemTake = message.GemTake;
        if (message.SpinsLeft != null && message.hasOwnProperty("SpinsLeft"))
            object.SpinsLeft = message.SpinsLeft;
        return object;
    };

    /**
     * Converts this ClientGemDataAck to JSON.
     * @function toJSON
     * @memberof ClientGemDataAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemDataAck
     * @function getTypeUrl
     * @memberof ClientGemDataAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemDataAck";
    };

    return ClientGemDataAck;
})();

export const ClientGemGetReq = $root.ClientGemGetReq = (() => {

    /**
     * Properties of a ClientGemGetReq.
     * @exports IClientGemGetReq
     * @interface IClientGemGetReq
     * @property {number|null} [UserID] ClientGemGetReq UserID
     * @property {number|null} [GemIndx] ClientGemGetReq GemIndx
     */

    /**
     * Constructs a new ClientGemGetReq.
     * @exports ClientGemGetReq
     * @classdesc Represents a ClientGemGetReq.
     * @implements IClientGemGetReq
     * @constructor
     * @param {IClientGemGetReq=} [properties] Properties to set
     */
    function ClientGemGetReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemGetReq UserID.
     * @member {number} UserID
     * @memberof ClientGemGetReq
     * @instance
     */
    ClientGemGetReq.prototype.UserID = 0;

    /**
     * ClientGemGetReq GemIndx.
     * @member {number} GemIndx
     * @memberof ClientGemGetReq
     * @instance
     */
    ClientGemGetReq.prototype.GemIndx = 0;

    /**
     * Creates a new ClientGemGetReq instance using the specified properties.
     * @function create
     * @memberof ClientGemGetReq
     * @static
     * @param {IClientGemGetReq=} [properties] Properties to set
     * @returns {ClientGemGetReq} ClientGemGetReq instance
     */
    ClientGemGetReq.create = function create(properties) {
        return new ClientGemGetReq(properties);
    };

    /**
     * Encodes the specified ClientGemGetReq message. Does not implicitly {@link ClientGemGetReq.verify|verify} messages.
     * @function encode
     * @memberof ClientGemGetReq
     * @static
     * @param {IClientGemGetReq} message ClientGemGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemGetReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GemIndx != null && Object.hasOwnProperty.call(message, "GemIndx"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.GemIndx);
        return writer;
    };

    /**
     * Encodes the specified ClientGemGetReq message, length delimited. Does not implicitly {@link ClientGemGetReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemGetReq
     * @static
     * @param {IClientGemGetReq} message ClientGemGetReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemGetReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemGetReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemGetReq} ClientGemGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemGetReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemGetReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.GemIndx = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemGetReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemGetReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemGetReq} ClientGemGetReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemGetReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemGetReq message.
     * @function verify
     * @memberof ClientGemGetReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemGetReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GemIndx != null && message.hasOwnProperty("GemIndx"))
            if (!$util.isInteger(message.GemIndx))
                return "GemIndx: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemGetReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemGetReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemGetReq} ClientGemGetReq
     */
    ClientGemGetReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemGetReq)
            return object;
        let message = new $root.ClientGemGetReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GemIndx != null)
            message.GemIndx = object.GemIndx >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemGetReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemGetReq
     * @static
     * @param {ClientGemGetReq} message ClientGemGetReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemGetReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.GemIndx = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GemIndx != null && message.hasOwnProperty("GemIndx"))
            object.GemIndx = message.GemIndx;
        return object;
    };

    /**
     * Converts this ClientGemGetReq to JSON.
     * @function toJSON
     * @memberof ClientGemGetReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemGetReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemGetReq
     * @function getTypeUrl
     * @memberof ClientGemGetReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemGetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemGetReq";
    };

    return ClientGemGetReq;
})();

export const ClientGemGetAck = $root.ClientGemGetAck = (() => {

    /**
     * Properties of a ClientGemGetAck.
     * @exports IClientGemGetAck
     * @interface IClientGemGetAck
     * @property {number|null} [ret] ClientGemGetAck ret
     * @property {number|null} [UserID] ClientGemGetAck UserID
     * @property {number|null} [GemSign] ClientGemGetAck GemSign
     */

    /**
     * Constructs a new ClientGemGetAck.
     * @exports ClientGemGetAck
     * @classdesc Represents a ClientGemGetAck.
     * @implements IClientGemGetAck
     * @constructor
     * @param {IClientGemGetAck=} [properties] Properties to set
     */
    function ClientGemGetAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemGetAck ret.
     * @member {number} ret
     * @memberof ClientGemGetAck
     * @instance
     */
    ClientGemGetAck.prototype.ret = 0;

    /**
     * ClientGemGetAck UserID.
     * @member {number} UserID
     * @memberof ClientGemGetAck
     * @instance
     */
    ClientGemGetAck.prototype.UserID = 0;

    /**
     * ClientGemGetAck GemSign.
     * @member {number} GemSign
     * @memberof ClientGemGetAck
     * @instance
     */
    ClientGemGetAck.prototype.GemSign = 0;

    /**
     * Creates a new ClientGemGetAck instance using the specified properties.
     * @function create
     * @memberof ClientGemGetAck
     * @static
     * @param {IClientGemGetAck=} [properties] Properties to set
     * @returns {ClientGemGetAck} ClientGemGetAck instance
     */
    ClientGemGetAck.create = function create(properties) {
        return new ClientGemGetAck(properties);
    };

    /**
     * Encodes the specified ClientGemGetAck message. Does not implicitly {@link ClientGemGetAck.verify|verify} messages.
     * @function encode
     * @memberof ClientGemGetAck
     * @static
     * @param {IClientGemGetAck} message ClientGemGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemGetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GemSign != null && Object.hasOwnProperty.call(message, "GemSign"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GemSign);
        return writer;
    };

    /**
     * Encodes the specified ClientGemGetAck message, length delimited. Does not implicitly {@link ClientGemGetAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemGetAck
     * @static
     * @param {IClientGemGetAck} message ClientGemGetAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemGetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemGetAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemGetAck} ClientGemGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemGetAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemGetAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GemSign = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemGetAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemGetAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemGetAck} ClientGemGetAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemGetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemGetAck message.
     * @function verify
     * @memberof ClientGemGetAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemGetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GemSign != null && message.hasOwnProperty("GemSign"))
            if (!$util.isInteger(message.GemSign))
                return "GemSign: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemGetAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemGetAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemGetAck} ClientGemGetAck
     */
    ClientGemGetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemGetAck)
            return object;
        let message = new $root.ClientGemGetAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GemSign != null)
            message.GemSign = object.GemSign >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemGetAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemGetAck
     * @static
     * @param {ClientGemGetAck} message ClientGemGetAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemGetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.GemSign = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GemSign != null && message.hasOwnProperty("GemSign"))
            object.GemSign = message.GemSign;
        return object;
    };

    /**
     * Converts this ClientGemGetAck to JSON.
     * @function toJSON
     * @memberof ClientGemGetAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemGetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemGetAck
     * @function getTypeUrl
     * @memberof ClientGemGetAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemGetAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemGetAck";
    };

    return ClientGemGetAck;
})();

export const ClientGemPrizeReq = $root.ClientGemPrizeReq = (() => {

    /**
     * Properties of a ClientGemPrizeReq.
     * @exports IClientGemPrizeReq
     * @interface IClientGemPrizeReq
     * @property {number|null} [UserID] ClientGemPrizeReq UserID
     * @property {number|null} [ChannelID] ClientGemPrizeReq ChannelID
     * @property {number|null} [GemSign] ClientGemPrizeReq GemSign
     */

    /**
     * Constructs a new ClientGemPrizeReq.
     * @exports ClientGemPrizeReq
     * @classdesc Represents a ClientGemPrizeReq.
     * @implements IClientGemPrizeReq
     * @constructor
     * @param {IClientGemPrizeReq=} [properties] Properties to set
     */
    function ClientGemPrizeReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemPrizeReq UserID.
     * @member {number} UserID
     * @memberof ClientGemPrizeReq
     * @instance
     */
    ClientGemPrizeReq.prototype.UserID = 0;

    /**
     * ClientGemPrizeReq ChannelID.
     * @member {number} ChannelID
     * @memberof ClientGemPrizeReq
     * @instance
     */
    ClientGemPrizeReq.prototype.ChannelID = 0;

    /**
     * ClientGemPrizeReq GemSign.
     * @member {number} GemSign
     * @memberof ClientGemPrizeReq
     * @instance
     */
    ClientGemPrizeReq.prototype.GemSign = 0;

    /**
     * Creates a new ClientGemPrizeReq instance using the specified properties.
     * @function create
     * @memberof ClientGemPrizeReq
     * @static
     * @param {IClientGemPrizeReq=} [properties] Properties to set
     * @returns {ClientGemPrizeReq} ClientGemPrizeReq instance
     */
    ClientGemPrizeReq.create = function create(properties) {
        return new ClientGemPrizeReq(properties);
    };

    /**
     * Encodes the specified ClientGemPrizeReq message. Does not implicitly {@link ClientGemPrizeReq.verify|verify} messages.
     * @function encode
     * @memberof ClientGemPrizeReq
     * @static
     * @param {IClientGemPrizeReq} message ClientGemPrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemPrizeReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ChannelID != null && Object.hasOwnProperty.call(message, "ChannelID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChannelID);
        if (message.GemSign != null && Object.hasOwnProperty.call(message, "GemSign"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GemSign);
        return writer;
    };

    /**
     * Encodes the specified ClientGemPrizeReq message, length delimited. Does not implicitly {@link ClientGemPrizeReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemPrizeReq
     * @static
     * @param {IClientGemPrizeReq} message ClientGemPrizeReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemPrizeReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemPrizeReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemPrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemPrizeReq} ClientGemPrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemPrizeReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemPrizeReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ChannelID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GemSign = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemPrizeReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemPrizeReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemPrizeReq} ClientGemPrizeReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemPrizeReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemPrizeReq message.
     * @function verify
     * @memberof ClientGemPrizeReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemPrizeReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            if (!$util.isInteger(message.ChannelID))
                return "ChannelID: integer expected";
        if (message.GemSign != null && message.hasOwnProperty("GemSign"))
            if (!$util.isInteger(message.GemSign))
                return "GemSign: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemPrizeReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemPrizeReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemPrizeReq} ClientGemPrizeReq
     */
    ClientGemPrizeReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemPrizeReq)
            return object;
        let message = new $root.ClientGemPrizeReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ChannelID != null)
            message.ChannelID = object.ChannelID >>> 0;
        if (object.GemSign != null)
            message.GemSign = object.GemSign >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemPrizeReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemPrizeReq
     * @static
     * @param {ClientGemPrizeReq} message ClientGemPrizeReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemPrizeReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ChannelID = 0;
            object.GemSign = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
            object.ChannelID = message.ChannelID;
        if (message.GemSign != null && message.hasOwnProperty("GemSign"))
            object.GemSign = message.GemSign;
        return object;
    };

    /**
     * Converts this ClientGemPrizeReq to JSON.
     * @function toJSON
     * @memberof ClientGemPrizeReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemPrizeReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemPrizeReq
     * @function getTypeUrl
     * @memberof ClientGemPrizeReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemPrizeReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemPrizeReq";
    };

    return ClientGemPrizeReq;
})();

export const ClientGemPrizeAck = $root.ClientGemPrizeAck = (() => {

    /**
     * Properties of a ClientGemPrizeAck.
     * @exports IClientGemPrizeAck
     * @interface IClientGemPrizeAck
     * @property {number|null} [ret] ClientGemPrizeAck ret
     * @property {number|null} [UserID] ClientGemPrizeAck UserID
     * @property {number|null} [GemGold] ClientGemPrizeAck GemGold
     */

    /**
     * Constructs a new ClientGemPrizeAck.
     * @exports ClientGemPrizeAck
     * @classdesc Represents a ClientGemPrizeAck.
     * @implements IClientGemPrizeAck
     * @constructor
     * @param {IClientGemPrizeAck=} [properties] Properties to set
     */
    function ClientGemPrizeAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientGemPrizeAck ret.
     * @member {number} ret
     * @memberof ClientGemPrizeAck
     * @instance
     */
    ClientGemPrizeAck.prototype.ret = 0;

    /**
     * ClientGemPrizeAck UserID.
     * @member {number} UserID
     * @memberof ClientGemPrizeAck
     * @instance
     */
    ClientGemPrizeAck.prototype.UserID = 0;

    /**
     * ClientGemPrizeAck GemGold.
     * @member {number} GemGold
     * @memberof ClientGemPrizeAck
     * @instance
     */
    ClientGemPrizeAck.prototype.GemGold = 0;

    /**
     * Creates a new ClientGemPrizeAck instance using the specified properties.
     * @function create
     * @memberof ClientGemPrizeAck
     * @static
     * @param {IClientGemPrizeAck=} [properties] Properties to set
     * @returns {ClientGemPrizeAck} ClientGemPrizeAck instance
     */
    ClientGemPrizeAck.create = function create(properties) {
        return new ClientGemPrizeAck(properties);
    };

    /**
     * Encodes the specified ClientGemPrizeAck message. Does not implicitly {@link ClientGemPrizeAck.verify|verify} messages.
     * @function encode
     * @memberof ClientGemPrizeAck
     * @static
     * @param {IClientGemPrizeAck} message ClientGemPrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemPrizeAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ret != null && Object.hasOwnProperty.call(message, "ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.GemGold != null && Object.hasOwnProperty.call(message, "GemGold"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GemGold);
        return writer;
    };

    /**
     * Encodes the specified ClientGemPrizeAck message, length delimited. Does not implicitly {@link ClientGemPrizeAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientGemPrizeAck
     * @static
     * @param {IClientGemPrizeAck} message ClientGemPrizeAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientGemPrizeAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientGemPrizeAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientGemPrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientGemPrizeAck} ClientGemPrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemPrizeAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientGemPrizeAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.GemGold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientGemPrizeAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientGemPrizeAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientGemPrizeAck} ClientGemPrizeAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientGemPrizeAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientGemPrizeAck message.
     * @function verify
     * @memberof ClientGemPrizeAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientGemPrizeAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ret != null && message.hasOwnProperty("ret"))
            if (!$util.isInteger(message.ret))
                return "ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GemGold != null && message.hasOwnProperty("GemGold"))
            if (!$util.isInteger(message.GemGold))
                return "GemGold: integer expected";
        return null;
    };

    /**
     * Creates a ClientGemPrizeAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientGemPrizeAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientGemPrizeAck} ClientGemPrizeAck
     */
    ClientGemPrizeAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientGemPrizeAck)
            return object;
        let message = new $root.ClientGemPrizeAck();
        if (object.ret != null)
            message.ret = object.ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GemGold != null)
            message.GemGold = object.GemGold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientGemPrizeAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientGemPrizeAck
     * @static
     * @param {ClientGemPrizeAck} message ClientGemPrizeAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientGemPrizeAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ret = 0;
            object.UserID = 0;
            object.GemGold = 0;
        }
        if (message.ret != null && message.hasOwnProperty("ret"))
            object.ret = message.ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GemGold != null && message.hasOwnProperty("GemGold"))
            object.GemGold = message.GemGold;
        return object;
    };

    /**
     * Converts this ClientGemPrizeAck to JSON.
     * @function toJSON
     * @memberof ClientGemPrizeAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientGemPrizeAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientGemPrizeAck
     * @function getTypeUrl
     * @memberof ClientGemPrizeAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientGemPrizeAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientGemPrizeAck";
    };

    return ClientGemPrizeAck;
})();

export const RummySrvToDeskPushStartGame = $root.RummySrvToDeskPushStartGame = (() => {

    /**
     * Properties of a RummySrvToDeskPushStartGame.
     * @exports IRummySrvToDeskPushStartGame
     * @interface IRummySrvToDeskPushStartGame
     * @property {number|null} [DealerID] RummySrvToDeskPushStartGame DealerID
     * @property {number|null} [CurSeatNo] RummySrvToDeskPushStartGame CurSeatNo
     * @property {Array.<number>|null} [GamingIDs] RummySrvToDeskPushStartGame GamingIDs
     * @property {Array.<number>|null} [WatchingIDs] RummySrvToDeskPushStartGame WatchingIDs
     */

    /**
     * Constructs a new RummySrvToDeskPushStartGame.
     * @exports RummySrvToDeskPushStartGame
     * @classdesc Represents a RummySrvToDeskPushStartGame.
     * @implements IRummySrvToDeskPushStartGame
     * @constructor
     * @param {IRummySrvToDeskPushStartGame=} [properties] Properties to set
     */
    function RummySrvToDeskPushStartGame(properties) {
        this.GamingIDs = [];
        this.WatchingIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushStartGame DealerID.
     * @member {number} DealerID
     * @memberof RummySrvToDeskPushStartGame
     * @instance
     */
    RummySrvToDeskPushStartGame.prototype.DealerID = 0;

    /**
     * RummySrvToDeskPushStartGame CurSeatNo.
     * @member {number} CurSeatNo
     * @memberof RummySrvToDeskPushStartGame
     * @instance
     */
    RummySrvToDeskPushStartGame.prototype.CurSeatNo = 0;

    /**
     * RummySrvToDeskPushStartGame GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof RummySrvToDeskPushStartGame
     * @instance
     */
    RummySrvToDeskPushStartGame.prototype.GamingIDs = $util.emptyArray;

    /**
     * RummySrvToDeskPushStartGame WatchingIDs.
     * @member {Array.<number>} WatchingIDs
     * @memberof RummySrvToDeskPushStartGame
     * @instance
     */
    RummySrvToDeskPushStartGame.prototype.WatchingIDs = $util.emptyArray;

    /**
     * Creates a new RummySrvToDeskPushStartGame instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {IRummySrvToDeskPushStartGame=} [properties] Properties to set
     * @returns {RummySrvToDeskPushStartGame} RummySrvToDeskPushStartGame instance
     */
    RummySrvToDeskPushStartGame.create = function create(properties) {
        return new RummySrvToDeskPushStartGame(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushStartGame message. Does not implicitly {@link RummySrvToDeskPushStartGame.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {IRummySrvToDeskPushStartGame} message RummySrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushStartGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DealerID);
        if (message.CurSeatNo != null && Object.hasOwnProperty.call(message, "CurSeatNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CurSeatNo);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.WatchingIDs != null && message.WatchingIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                writer.uint32(message.WatchingIDs[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushStartGame message, length delimited. Does not implicitly {@link RummySrvToDeskPushStartGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {IRummySrvToDeskPushStartGame} message RummySrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushStartGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushStartGame message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushStartGame} RummySrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushStartGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushStartGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CurSeatNo = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.WatchingIDs && message.WatchingIDs.length))
                        message.WatchingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.WatchingIDs.push(reader.uint32());
                    } else
                        message.WatchingIDs.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushStartGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushStartGame} RummySrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushStartGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushStartGame message.
     * @function verify
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushStartGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.CurSeatNo != null && message.hasOwnProperty("CurSeatNo"))
            if (!$util.isInteger(message.CurSeatNo))
                return "CurSeatNo: integer expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.WatchingIDs != null && message.hasOwnProperty("WatchingIDs")) {
            if (!Array.isArray(message.WatchingIDs))
                return "WatchingIDs: array expected";
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                if (!$util.isInteger(message.WatchingIDs[i]))
                    return "WatchingIDs: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushStartGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushStartGame} RummySrvToDeskPushStartGame
     */
    RummySrvToDeskPushStartGame.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushStartGame)
            return object;
        let message = new $root.RummySrvToDeskPushStartGame();
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.CurSeatNo != null)
            message.CurSeatNo = object.CurSeatNo >>> 0;
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".RummySrvToDeskPushStartGame.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.WatchingIDs) {
            if (!Array.isArray(object.WatchingIDs))
                throw TypeError(".RummySrvToDeskPushStartGame.WatchingIDs: array expected");
            message.WatchingIDs = [];
            for (let i = 0; i < object.WatchingIDs.length; ++i)
                message.WatchingIDs[i] = object.WatchingIDs[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushStartGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {RummySrvToDeskPushStartGame} message RummySrvToDeskPushStartGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushStartGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.WatchingIDs = [];
        }
        if (options.defaults) {
            object.DealerID = 0;
            object.CurSeatNo = 0;
        }
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.CurSeatNo != null && message.hasOwnProperty("CurSeatNo"))
            object.CurSeatNo = message.CurSeatNo;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.WatchingIDs && message.WatchingIDs.length) {
            object.WatchingIDs = [];
            for (let j = 0; j < message.WatchingIDs.length; ++j)
                object.WatchingIDs[j] = message.WatchingIDs[j];
        }
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushStartGame to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushStartGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushStartGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushStartGame
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushStartGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushStartGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushStartGame";
    };

    return RummySrvToDeskPushStartGame;
})();

export const RummySrvToDeskPushPublicCard = $root.RummySrvToDeskPushPublicCard = (() => {

    /**
     * Properties of a RummySrvToDeskPushPublicCard.
     * @exports IRummySrvToDeskPushPublicCard
     * @interface IRummySrvToDeskPushPublicCard
     * @property {number|null} [PublicCard] RummySrvToDeskPushPublicCard PublicCard
     * @property {number|null} [UserID] RummySrvToDeskPushPublicCard UserID
     */

    /**
     * Constructs a new RummySrvToDeskPushPublicCard.
     * @exports RummySrvToDeskPushPublicCard
     * @classdesc Represents a RummySrvToDeskPushPublicCard.
     * @implements IRummySrvToDeskPushPublicCard
     * @constructor
     * @param {IRummySrvToDeskPushPublicCard=} [properties] Properties to set
     */
    function RummySrvToDeskPushPublicCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushPublicCard PublicCard.
     * @member {number} PublicCard
     * @memberof RummySrvToDeskPushPublicCard
     * @instance
     */
    RummySrvToDeskPushPublicCard.prototype.PublicCard = 0;

    /**
     * RummySrvToDeskPushPublicCard UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushPublicCard
     * @instance
     */
    RummySrvToDeskPushPublicCard.prototype.UserID = 0;

    /**
     * Creates a new RummySrvToDeskPushPublicCard instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {IRummySrvToDeskPushPublicCard=} [properties] Properties to set
     * @returns {RummySrvToDeskPushPublicCard} RummySrvToDeskPushPublicCard instance
     */
    RummySrvToDeskPushPublicCard.create = function create(properties) {
        return new RummySrvToDeskPushPublicCard(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushPublicCard message. Does not implicitly {@link RummySrvToDeskPushPublicCard.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {IRummySrvToDeskPushPublicCard} message RummySrvToDeskPushPublicCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushPublicCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PublicCard != null && Object.hasOwnProperty.call(message, "PublicCard"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PublicCard);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushPublicCard message, length delimited. Does not implicitly {@link RummySrvToDeskPushPublicCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {IRummySrvToDeskPushPublicCard} message RummySrvToDeskPushPublicCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushPublicCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushPublicCard message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushPublicCard} RummySrvToDeskPushPublicCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushPublicCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushPublicCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PublicCard = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushPublicCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushPublicCard} RummySrvToDeskPushPublicCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushPublicCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushPublicCard message.
     * @function verify
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushPublicCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PublicCard != null && message.hasOwnProperty("PublicCard"))
            if (!$util.isInteger(message.PublicCard))
                return "PublicCard: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushPublicCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushPublicCard} RummySrvToDeskPushPublicCard
     */
    RummySrvToDeskPushPublicCard.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushPublicCard)
            return object;
        let message = new $root.RummySrvToDeskPushPublicCard();
        if (object.PublicCard != null)
            message.PublicCard = object.PublicCard >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushPublicCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {RummySrvToDeskPushPublicCard} message RummySrvToDeskPushPublicCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushPublicCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PublicCard = 0;
            object.UserID = 0;
        }
        if (message.PublicCard != null && message.hasOwnProperty("PublicCard"))
            object.PublicCard = message.PublicCard;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushPublicCard to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushPublicCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushPublicCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushPublicCard
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushPublicCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushPublicCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushPublicCard";
    };

    return RummySrvToDeskPushPublicCard;
})();

export const RummySrvToDeskPushMagicCard = $root.RummySrvToDeskPushMagicCard = (() => {

    /**
     * Properties of a RummySrvToDeskPushMagicCard.
     * @exports IRummySrvToDeskPushMagicCard
     * @interface IRummySrvToDeskPushMagicCard
     * @property {number|null} [MagicCard] RummySrvToDeskPushMagicCard MagicCard
     * @property {number|null} [LeftCardCnt] RummySrvToDeskPushMagicCard LeftCardCnt
     */

    /**
     * Constructs a new RummySrvToDeskPushMagicCard.
     * @exports RummySrvToDeskPushMagicCard
     * @classdesc Represents a RummySrvToDeskPushMagicCard.
     * @implements IRummySrvToDeskPushMagicCard
     * @constructor
     * @param {IRummySrvToDeskPushMagicCard=} [properties] Properties to set
     */
    function RummySrvToDeskPushMagicCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushMagicCard MagicCard.
     * @member {number} MagicCard
     * @memberof RummySrvToDeskPushMagicCard
     * @instance
     */
    RummySrvToDeskPushMagicCard.prototype.MagicCard = 0;

    /**
     * RummySrvToDeskPushMagicCard LeftCardCnt.
     * @member {number} LeftCardCnt
     * @memberof RummySrvToDeskPushMagicCard
     * @instance
     */
    RummySrvToDeskPushMagicCard.prototype.LeftCardCnt = 0;

    /**
     * Creates a new RummySrvToDeskPushMagicCard instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {IRummySrvToDeskPushMagicCard=} [properties] Properties to set
     * @returns {RummySrvToDeskPushMagicCard} RummySrvToDeskPushMagicCard instance
     */
    RummySrvToDeskPushMagicCard.create = function create(properties) {
        return new RummySrvToDeskPushMagicCard(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushMagicCard message. Does not implicitly {@link RummySrvToDeskPushMagicCard.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {IRummySrvToDeskPushMagicCard} message RummySrvToDeskPushMagicCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushMagicCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.MagicCard != null && Object.hasOwnProperty.call(message, "MagicCard"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MagicCard);
        if (message.LeftCardCnt != null && Object.hasOwnProperty.call(message, "LeftCardCnt"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.LeftCardCnt);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushMagicCard message, length delimited. Does not implicitly {@link RummySrvToDeskPushMagicCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {IRummySrvToDeskPushMagicCard} message RummySrvToDeskPushMagicCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushMagicCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushMagicCard message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushMagicCard} RummySrvToDeskPushMagicCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushMagicCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushMagicCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.MagicCard = reader.uint32();
                    break;
                }
            case 2: {
                    message.LeftCardCnt = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushMagicCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushMagicCard} RummySrvToDeskPushMagicCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushMagicCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushMagicCard message.
     * @function verify
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushMagicCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.MagicCard != null && message.hasOwnProperty("MagicCard"))
            if (!$util.isInteger(message.MagicCard))
                return "MagicCard: integer expected";
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            if (!$util.isInteger(message.LeftCardCnt))
                return "LeftCardCnt: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushMagicCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushMagicCard} RummySrvToDeskPushMagicCard
     */
    RummySrvToDeskPushMagicCard.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushMagicCard)
            return object;
        let message = new $root.RummySrvToDeskPushMagicCard();
        if (object.MagicCard != null)
            message.MagicCard = object.MagicCard >>> 0;
        if (object.LeftCardCnt != null)
            message.LeftCardCnt = object.LeftCardCnt >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushMagicCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {RummySrvToDeskPushMagicCard} message RummySrvToDeskPushMagicCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushMagicCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.MagicCard = 0;
            object.LeftCardCnt = 0;
        }
        if (message.MagicCard != null && message.hasOwnProperty("MagicCard"))
            object.MagicCard = message.MagicCard;
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            object.LeftCardCnt = message.LeftCardCnt;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushMagicCard to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushMagicCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushMagicCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushMagicCard
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushMagicCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushMagicCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushMagicCard";
    };

    return RummySrvToDeskPushMagicCard;
})();

export const RummySrvToDeskPushCommand = $root.RummySrvToDeskPushCommand = (() => {

    /**
     * Properties of a RummySrvToDeskPushCommand.
     * @exports IRummySrvToDeskPushCommand
     * @interface IRummySrvToDeskPushCommand
     * @property {number|null} [UserID] RummySrvToDeskPushCommand UserID
     * @property {number|null} [Practitioner] RummySrvToDeskPushCommand Practitioner
     */

    /**
     * Constructs a new RummySrvToDeskPushCommand.
     * @exports RummySrvToDeskPushCommand
     * @classdesc Represents a RummySrvToDeskPushCommand.
     * @implements IRummySrvToDeskPushCommand
     * @constructor
     * @param {IRummySrvToDeskPushCommand=} [properties] Properties to set
     */
    function RummySrvToDeskPushCommand(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushCommand UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushCommand
     * @instance
     */
    RummySrvToDeskPushCommand.prototype.UserID = 0;

    /**
     * RummySrvToDeskPushCommand Practitioner.
     * @member {number} Practitioner
     * @memberof RummySrvToDeskPushCommand
     * @instance
     */
    RummySrvToDeskPushCommand.prototype.Practitioner = 0;

    /**
     * Creates a new RummySrvToDeskPushCommand instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {IRummySrvToDeskPushCommand=} [properties] Properties to set
     * @returns {RummySrvToDeskPushCommand} RummySrvToDeskPushCommand instance
     */
    RummySrvToDeskPushCommand.create = function create(properties) {
        return new RummySrvToDeskPushCommand(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushCommand message. Does not implicitly {@link RummySrvToDeskPushCommand.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {IRummySrvToDeskPushCommand} message RummySrvToDeskPushCommand message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushCommand.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Practitioner);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushCommand message, length delimited. Does not implicitly {@link RummySrvToDeskPushCommand.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {IRummySrvToDeskPushCommand} message RummySrvToDeskPushCommand message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushCommand.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushCommand message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushCommand} RummySrvToDeskPushCommand
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushCommand.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushCommand();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushCommand message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushCommand} RummySrvToDeskPushCommand
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushCommand.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushCommand message.
     * @function verify
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushCommand.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushCommand message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushCommand} RummySrvToDeskPushCommand
     */
    RummySrvToDeskPushCommand.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushCommand)
            return object;
        let message = new $root.RummySrvToDeskPushCommand();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushCommand message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {RummySrvToDeskPushCommand} message RummySrvToDeskPushCommand
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushCommand.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Practitioner = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushCommand to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushCommand
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushCommand.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushCommand
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushCommand
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushCommand.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushCommand";
    };

    return RummySrvToDeskPushCommand;
})();

export const RummySrvToDeskPushCurUser = $root.RummySrvToDeskPushCurUser = (() => {

    /**
     * Properties of a RummySrvToDeskPushCurUser.
     * @exports IRummySrvToDeskPushCurUser
     * @interface IRummySrvToDeskPushCurUser
     * @property {number|null} [CurOperaUser] RummySrvToDeskPushCurUser CurOperaUser
     */

    /**
     * Constructs a new RummySrvToDeskPushCurUser.
     * @exports RummySrvToDeskPushCurUser
     * @classdesc Represents a RummySrvToDeskPushCurUser.
     * @implements IRummySrvToDeskPushCurUser
     * @constructor
     * @param {IRummySrvToDeskPushCurUser=} [properties] Properties to set
     */
    function RummySrvToDeskPushCurUser(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushCurUser CurOperaUser.
     * @member {number} CurOperaUser
     * @memberof RummySrvToDeskPushCurUser
     * @instance
     */
    RummySrvToDeskPushCurUser.prototype.CurOperaUser = 0;

    /**
     * Creates a new RummySrvToDeskPushCurUser instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {IRummySrvToDeskPushCurUser=} [properties] Properties to set
     * @returns {RummySrvToDeskPushCurUser} RummySrvToDeskPushCurUser instance
     */
    RummySrvToDeskPushCurUser.create = function create(properties) {
        return new RummySrvToDeskPushCurUser(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushCurUser message. Does not implicitly {@link RummySrvToDeskPushCurUser.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {IRummySrvToDeskPushCurUser} message RummySrvToDeskPushCurUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushCurUser.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CurOperaUser != null && Object.hasOwnProperty.call(message, "CurOperaUser"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CurOperaUser);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushCurUser message, length delimited. Does not implicitly {@link RummySrvToDeskPushCurUser.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {IRummySrvToDeskPushCurUser} message RummySrvToDeskPushCurUser message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushCurUser.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushCurUser message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushCurUser} RummySrvToDeskPushCurUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushCurUser.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushCurUser();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CurOperaUser = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushCurUser message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushCurUser} RummySrvToDeskPushCurUser
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushCurUser.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushCurUser message.
     * @function verify
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushCurUser.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CurOperaUser != null && message.hasOwnProperty("CurOperaUser"))
            if (!$util.isInteger(message.CurOperaUser))
                return "CurOperaUser: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushCurUser message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushCurUser} RummySrvToDeskPushCurUser
     */
    RummySrvToDeskPushCurUser.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushCurUser)
            return object;
        let message = new $root.RummySrvToDeskPushCurUser();
        if (object.CurOperaUser != null)
            message.CurOperaUser = object.CurOperaUser >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushCurUser message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {RummySrvToDeskPushCurUser} message RummySrvToDeskPushCurUser
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushCurUser.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.CurOperaUser = 0;
        if (message.CurOperaUser != null && message.hasOwnProperty("CurOperaUser"))
            object.CurOperaUser = message.CurOperaUser;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushCurUser to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushCurUser
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushCurUser.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushCurUser
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushCurUser
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushCurUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushCurUser";
    };

    return RummySrvToDeskPushCurUser;
})();

export const ShowCardRummy = $root.ShowCardRummy = (() => {

    /**
     * Properties of a ShowCardRummy.
     * @exports IShowCardRummy
     * @interface IShowCardRummy
     * @property {number|null} [UserID] ShowCardRummy UserID
     * @property {Array.<number>|null} [ShowCard] ShowCardRummy ShowCard
     * @property {boolean|null} [playwin] ShowCardRummy playwin
     * @property {number|null} [winaiID] ShowCardRummy winaiID
     * @property {number|null} [irs] ShowCardRummy irs
     */

    /**
     * Constructs a new ShowCardRummy.
     * @exports ShowCardRummy
     * @classdesc Represents a ShowCardRummy.
     * @implements IShowCardRummy
     * @constructor
     * @param {IShowCardRummy=} [properties] Properties to set
     */
    function ShowCardRummy(properties) {
        this.ShowCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ShowCardRummy UserID.
     * @member {number} UserID
     * @memberof ShowCardRummy
     * @instance
     */
    ShowCardRummy.prototype.UserID = 0;

    /**
     * ShowCardRummy ShowCard.
     * @member {Array.<number>} ShowCard
     * @memberof ShowCardRummy
     * @instance
     */
    ShowCardRummy.prototype.ShowCard = $util.emptyArray;

    /**
     * ShowCardRummy playwin.
     * @member {boolean} playwin
     * @memberof ShowCardRummy
     * @instance
     */
    ShowCardRummy.prototype.playwin = false;

    /**
     * ShowCardRummy winaiID.
     * @member {number} winaiID
     * @memberof ShowCardRummy
     * @instance
     */
    ShowCardRummy.prototype.winaiID = 0;

    /**
     * ShowCardRummy irs.
     * @member {number} irs
     * @memberof ShowCardRummy
     * @instance
     */
    ShowCardRummy.prototype.irs = 0;

    /**
     * Creates a new ShowCardRummy instance using the specified properties.
     * @function create
     * @memberof ShowCardRummy
     * @static
     * @param {IShowCardRummy=} [properties] Properties to set
     * @returns {ShowCardRummy} ShowCardRummy instance
     */
    ShowCardRummy.create = function create(properties) {
        return new ShowCardRummy(properties);
    };

    /**
     * Encodes the specified ShowCardRummy message. Does not implicitly {@link ShowCardRummy.verify|verify} messages.
     * @function encode
     * @memberof ShowCardRummy
     * @static
     * @param {IShowCardRummy} message ShowCardRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowCardRummy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ShowCard != null && message.ShowCard.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.ShowCard.length; ++i)
                writer.uint32(message.ShowCard[i]);
            writer.ldelim();
        }
        if (message.playwin != null && Object.hasOwnProperty.call(message, "playwin"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.playwin);
        if (message.winaiID != null && Object.hasOwnProperty.call(message, "winaiID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.winaiID);
        if (message.irs != null && Object.hasOwnProperty.call(message, "irs"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.irs);
        return writer;
    };

    /**
     * Encodes the specified ShowCardRummy message, length delimited. Does not implicitly {@link ShowCardRummy.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ShowCardRummy
     * @static
     * @param {IShowCardRummy} message ShowCardRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowCardRummy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ShowCardRummy message from the specified reader or buffer.
     * @function decode
     * @memberof ShowCardRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ShowCardRummy} ShowCardRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowCardRummy.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ShowCardRummy();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.ShowCard && message.ShowCard.length))
                        message.ShowCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.ShowCard.push(reader.uint32());
                    } else
                        message.ShowCard.push(reader.uint32());
                    break;
                }
            case 3: {
                    message.playwin = reader.bool();
                    break;
                }
            case 4: {
                    message.winaiID = reader.uint32();
                    break;
                }
            case 5: {
                    message.irs = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ShowCardRummy message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ShowCardRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ShowCardRummy} ShowCardRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowCardRummy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ShowCardRummy message.
     * @function verify
     * @memberof ShowCardRummy
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ShowCardRummy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ShowCard != null && message.hasOwnProperty("ShowCard")) {
            if (!Array.isArray(message.ShowCard))
                return "ShowCard: array expected";
            for (let i = 0; i < message.ShowCard.length; ++i)
                if (!$util.isInteger(message.ShowCard[i]))
                    return "ShowCard: integer[] expected";
        }
        if (message.playwin != null && message.hasOwnProperty("playwin"))
            if (typeof message.playwin !== "boolean")
                return "playwin: boolean expected";
        if (message.winaiID != null && message.hasOwnProperty("winaiID"))
            if (!$util.isInteger(message.winaiID))
                return "winaiID: integer expected";
        if (message.irs != null && message.hasOwnProperty("irs"))
            if (!$util.isInteger(message.irs))
                return "irs: integer expected";
        return null;
    };

    /**
     * Creates a ShowCardRummy message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ShowCardRummy
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ShowCardRummy} ShowCardRummy
     */
    ShowCardRummy.fromObject = function fromObject(object) {
        if (object instanceof $root.ShowCardRummy)
            return object;
        let message = new $root.ShowCardRummy();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ShowCard) {
            if (!Array.isArray(object.ShowCard))
                throw TypeError(".ShowCardRummy.ShowCard: array expected");
            message.ShowCard = [];
            for (let i = 0; i < object.ShowCard.length; ++i)
                message.ShowCard[i] = object.ShowCard[i] >>> 0;
        }
        if (object.playwin != null)
            message.playwin = Boolean(object.playwin);
        if (object.winaiID != null)
            message.winaiID = object.winaiID >>> 0;
        if (object.irs != null)
            message.irs = object.irs | 0;
        return message;
    };

    /**
     * Creates a plain object from a ShowCardRummy message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ShowCardRummy
     * @static
     * @param {ShowCardRummy} message ShowCardRummy
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ShowCardRummy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ShowCard = [];
        if (options.defaults) {
            object.UserID = 0;
            object.playwin = false;
            object.winaiID = 0;
            object.irs = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ShowCard && message.ShowCard.length) {
            object.ShowCard = [];
            for (let j = 0; j < message.ShowCard.length; ++j)
                object.ShowCard[j] = message.ShowCard[j];
        }
        if (message.playwin != null && message.hasOwnProperty("playwin"))
            object.playwin = message.playwin;
        if (message.winaiID != null && message.hasOwnProperty("winaiID"))
            object.winaiID = message.winaiID;
        if (message.irs != null && message.hasOwnProperty("irs"))
            object.irs = message.irs;
        return object;
    };

    /**
     * Converts this ShowCardRummy to JSON.
     * @function toJSON
     * @memberof ShowCardRummy
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ShowCardRummy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ShowCardRummy
     * @function getTypeUrl
     * @memberof ShowCardRummy
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ShowCardRummy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ShowCardRummy";
    };

    return ShowCardRummy;
})();

export const OperCmdForRummy = $root.OperCmdForRummy = (() => {

    /**
     * Properties of an OperCmdForRummy.
     * @exports IOperCmdForRummy
     * @interface IOperCmdForRummy
     * @property {number|null} [Practitioner] OperCmdForRummy Practitioner
     * @property {number|null} [Operation] OperCmdForRummy Operation
     * @property {number|null} [OperateCardType] OperCmdForRummy OperateCardType
     * @property {Array.<number>|null} [CardList1] OperCmdForRummy CardList1
     * @property {Array.<number>|null} [CardList2] OperCmdForRummy CardList2
     * @property {Array.<number>|null} [CardList3] OperCmdForRummy CardList3
     * @property {Array.<number>|null} [CardList4] OperCmdForRummy CardList4
     * @property {Array.<number>|null} [CardList5] OperCmdForRummy CardList5
     */

    /**
     * Constructs a new OperCmdForRummy.
     * @exports OperCmdForRummy
     * @classdesc Represents an OperCmdForRummy.
     * @implements IOperCmdForRummy
     * @constructor
     * @param {IOperCmdForRummy=} [properties] Properties to set
     */
    function OperCmdForRummy(properties) {
        this.CardList1 = [];
        this.CardList2 = [];
        this.CardList3 = [];
        this.CardList4 = [];
        this.CardList5 = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OperCmdForRummy Practitioner.
     * @member {number} Practitioner
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.Practitioner = 0;

    /**
     * OperCmdForRummy Operation.
     * @member {number} Operation
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.Operation = 0;

    /**
     * OperCmdForRummy OperateCardType.
     * @member {number} OperateCardType
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.OperateCardType = 0;

    /**
     * OperCmdForRummy CardList1.
     * @member {Array.<number>} CardList1
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.CardList1 = $util.emptyArray;

    /**
     * OperCmdForRummy CardList2.
     * @member {Array.<number>} CardList2
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.CardList2 = $util.emptyArray;

    /**
     * OperCmdForRummy CardList3.
     * @member {Array.<number>} CardList3
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.CardList3 = $util.emptyArray;

    /**
     * OperCmdForRummy CardList4.
     * @member {Array.<number>} CardList4
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.CardList4 = $util.emptyArray;

    /**
     * OperCmdForRummy CardList5.
     * @member {Array.<number>} CardList5
     * @memberof OperCmdForRummy
     * @instance
     */
    OperCmdForRummy.prototype.CardList5 = $util.emptyArray;

    /**
     * Creates a new OperCmdForRummy instance using the specified properties.
     * @function create
     * @memberof OperCmdForRummy
     * @static
     * @param {IOperCmdForRummy=} [properties] Properties to set
     * @returns {OperCmdForRummy} OperCmdForRummy instance
     */
    OperCmdForRummy.create = function create(properties) {
        return new OperCmdForRummy(properties);
    };

    /**
     * Encodes the specified OperCmdForRummy message. Does not implicitly {@link OperCmdForRummy.verify|verify} messages.
     * @function encode
     * @memberof OperCmdForRummy
     * @static
     * @param {IOperCmdForRummy} message OperCmdForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmdForRummy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Practitioner);
        if (message.Operation != null && Object.hasOwnProperty.call(message, "Operation"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Operation);
        if (message.OperateCardType != null && Object.hasOwnProperty.call(message, "OperateCardType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OperateCardType);
        if (message.CardList1 != null && message.CardList1.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.CardList1.length; ++i)
                writer.uint32(message.CardList1[i]);
            writer.ldelim();
        }
        if (message.CardList2 != null && message.CardList2.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.CardList2.length; ++i)
                writer.uint32(message.CardList2[i]);
            writer.ldelim();
        }
        if (message.CardList3 != null && message.CardList3.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.CardList3.length; ++i)
                writer.uint32(message.CardList3[i]);
            writer.ldelim();
        }
        if (message.CardList4 != null && message.CardList4.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.CardList4.length; ++i)
                writer.uint32(message.CardList4[i]);
            writer.ldelim();
        }
        if (message.CardList5 != null && message.CardList5.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.CardList5.length; ++i)
                writer.uint32(message.CardList5[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified OperCmdForRummy message, length delimited. Does not implicitly {@link OperCmdForRummy.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OperCmdForRummy
     * @static
     * @param {IOperCmdForRummy} message OperCmdForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OperCmdForRummy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OperCmdForRummy message from the specified reader or buffer.
     * @function decode
     * @memberof OperCmdForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OperCmdForRummy} OperCmdForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmdForRummy.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OperCmdForRummy();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 2: {
                    message.Operation = reader.uint32();
                    break;
                }
            case 3: {
                    message.OperateCardType = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.CardList1 && message.CardList1.length))
                        message.CardList1 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList1.push(reader.uint32());
                    } else
                        message.CardList1.push(reader.uint32());
                    break;
                }
            case 5: {
                    if (!(message.CardList2 && message.CardList2.length))
                        message.CardList2 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList2.push(reader.uint32());
                    } else
                        message.CardList2.push(reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.CardList3 && message.CardList3.length))
                        message.CardList3 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList3.push(reader.uint32());
                    } else
                        message.CardList3.push(reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.CardList4 && message.CardList4.length))
                        message.CardList4 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList4.push(reader.uint32());
                    } else
                        message.CardList4.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.CardList5 && message.CardList5.length))
                        message.CardList5 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList5.push(reader.uint32());
                    } else
                        message.CardList5.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OperCmdForRummy message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OperCmdForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OperCmdForRummy} OperCmdForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OperCmdForRummy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OperCmdForRummy message.
     * @function verify
     * @memberof OperCmdForRummy
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OperCmdForRummy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            if (!$util.isInteger(message.Operation))
                return "Operation: integer expected";
        if (message.OperateCardType != null && message.hasOwnProperty("OperateCardType"))
            if (!$util.isInteger(message.OperateCardType))
                return "OperateCardType: integer expected";
        if (message.CardList1 != null && message.hasOwnProperty("CardList1")) {
            if (!Array.isArray(message.CardList1))
                return "CardList1: array expected";
            for (let i = 0; i < message.CardList1.length; ++i)
                if (!$util.isInteger(message.CardList1[i]))
                    return "CardList1: integer[] expected";
        }
        if (message.CardList2 != null && message.hasOwnProperty("CardList2")) {
            if (!Array.isArray(message.CardList2))
                return "CardList2: array expected";
            for (let i = 0; i < message.CardList2.length; ++i)
                if (!$util.isInteger(message.CardList2[i]))
                    return "CardList2: integer[] expected";
        }
        if (message.CardList3 != null && message.hasOwnProperty("CardList3")) {
            if (!Array.isArray(message.CardList3))
                return "CardList3: array expected";
            for (let i = 0; i < message.CardList3.length; ++i)
                if (!$util.isInteger(message.CardList3[i]))
                    return "CardList3: integer[] expected";
        }
        if (message.CardList4 != null && message.hasOwnProperty("CardList4")) {
            if (!Array.isArray(message.CardList4))
                return "CardList4: array expected";
            for (let i = 0; i < message.CardList4.length; ++i)
                if (!$util.isInteger(message.CardList4[i]))
                    return "CardList4: integer[] expected";
        }
        if (message.CardList5 != null && message.hasOwnProperty("CardList5")) {
            if (!Array.isArray(message.CardList5))
                return "CardList5: array expected";
            for (let i = 0; i < message.CardList5.length; ++i)
                if (!$util.isInteger(message.CardList5[i]))
                    return "CardList5: integer[] expected";
        }
        return null;
    };

    /**
     * Creates an OperCmdForRummy message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OperCmdForRummy
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OperCmdForRummy} OperCmdForRummy
     */
    OperCmdForRummy.fromObject = function fromObject(object) {
        if (object instanceof $root.OperCmdForRummy)
            return object;
        let message = new $root.OperCmdForRummy();
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.Operation != null)
            message.Operation = object.Operation >>> 0;
        if (object.OperateCardType != null)
            message.OperateCardType = object.OperateCardType >>> 0;
        if (object.CardList1) {
            if (!Array.isArray(object.CardList1))
                throw TypeError(".OperCmdForRummy.CardList1: array expected");
            message.CardList1 = [];
            for (let i = 0; i < object.CardList1.length; ++i)
                message.CardList1[i] = object.CardList1[i] >>> 0;
        }
        if (object.CardList2) {
            if (!Array.isArray(object.CardList2))
                throw TypeError(".OperCmdForRummy.CardList2: array expected");
            message.CardList2 = [];
            for (let i = 0; i < object.CardList2.length; ++i)
                message.CardList2[i] = object.CardList2[i] >>> 0;
        }
        if (object.CardList3) {
            if (!Array.isArray(object.CardList3))
                throw TypeError(".OperCmdForRummy.CardList3: array expected");
            message.CardList3 = [];
            for (let i = 0; i < object.CardList3.length; ++i)
                message.CardList3[i] = object.CardList3[i] >>> 0;
        }
        if (object.CardList4) {
            if (!Array.isArray(object.CardList4))
                throw TypeError(".OperCmdForRummy.CardList4: array expected");
            message.CardList4 = [];
            for (let i = 0; i < object.CardList4.length; ++i)
                message.CardList4[i] = object.CardList4[i] >>> 0;
        }
        if (object.CardList5) {
            if (!Array.isArray(object.CardList5))
                throw TypeError(".OperCmdForRummy.CardList5: array expected");
            message.CardList5 = [];
            for (let i = 0; i < object.CardList5.length; ++i)
                message.CardList5[i] = object.CardList5[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from an OperCmdForRummy message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OperCmdForRummy
     * @static
     * @param {OperCmdForRummy} message OperCmdForRummy
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OperCmdForRummy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.CardList1 = [];
            object.CardList2 = [];
            object.CardList3 = [];
            object.CardList4 = [];
            object.CardList5 = [];
        }
        if (options.defaults) {
            object.Practitioner = 0;
            object.Operation = 0;
            object.OperateCardType = 0;
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            object.Operation = message.Operation;
        if (message.OperateCardType != null && message.hasOwnProperty("OperateCardType"))
            object.OperateCardType = message.OperateCardType;
        if (message.CardList1 && message.CardList1.length) {
            object.CardList1 = [];
            for (let j = 0; j < message.CardList1.length; ++j)
                object.CardList1[j] = message.CardList1[j];
        }
        if (message.CardList2 && message.CardList2.length) {
            object.CardList2 = [];
            for (let j = 0; j < message.CardList2.length; ++j)
                object.CardList2[j] = message.CardList2[j];
        }
        if (message.CardList3 && message.CardList3.length) {
            object.CardList3 = [];
            for (let j = 0; j < message.CardList3.length; ++j)
                object.CardList3[j] = message.CardList3[j];
        }
        if (message.CardList4 && message.CardList4.length) {
            object.CardList4 = [];
            for (let j = 0; j < message.CardList4.length; ++j)
                object.CardList4[j] = message.CardList4[j];
        }
        if (message.CardList5 && message.CardList5.length) {
            object.CardList5 = [];
            for (let j = 0; j < message.CardList5.length; ++j)
                object.CardList5[j] = message.CardList5[j];
        }
        return object;
    };

    /**
     * Converts this OperCmdForRummy to JSON.
     * @function toJSON
     * @memberof OperCmdForRummy
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OperCmdForRummy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OperCmdForRummy
     * @function getTypeUrl
     * @memberof OperCmdForRummy
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OperCmdForRummy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OperCmdForRummy";
    };

    return OperCmdForRummy;
})();

export const DeskToRummySrvPlayerCommandReq = $root.DeskToRummySrvPlayerCommandReq = (() => {

    /**
     * Properties of a DeskToRummySrvPlayerCommandReq.
     * @exports IDeskToRummySrvPlayerCommandReq
     * @interface IDeskToRummySrvPlayerCommandReq
     * @property {number|null} [DeskNo] DeskToRummySrvPlayerCommandReq DeskNo
     * @property {number|null} [UserID] DeskToRummySrvPlayerCommandReq UserID
     * @property {number|null} [SeatNo] DeskToRummySrvPlayerCommandReq SeatNo
     * @property {IOperCmdForRummy|null} [Command] DeskToRummySrvPlayerCommandReq Command
     */

    /**
     * Constructs a new DeskToRummySrvPlayerCommandReq.
     * @exports DeskToRummySrvPlayerCommandReq
     * @classdesc Represents a DeskToRummySrvPlayerCommandReq.
     * @implements IDeskToRummySrvPlayerCommandReq
     * @constructor
     * @param {IDeskToRummySrvPlayerCommandReq=} [properties] Properties to set
     */
    function DeskToRummySrvPlayerCommandReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToRummySrvPlayerCommandReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToRummySrvPlayerCommandReq
     * @instance
     */
    DeskToRummySrvPlayerCommandReq.prototype.DeskNo = 0;

    /**
     * DeskToRummySrvPlayerCommandReq UserID.
     * @member {number} UserID
     * @memberof DeskToRummySrvPlayerCommandReq
     * @instance
     */
    DeskToRummySrvPlayerCommandReq.prototype.UserID = 0;

    /**
     * DeskToRummySrvPlayerCommandReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToRummySrvPlayerCommandReq
     * @instance
     */
    DeskToRummySrvPlayerCommandReq.prototype.SeatNo = 0;

    /**
     * DeskToRummySrvPlayerCommandReq Command.
     * @member {IOperCmdForRummy|null|undefined} Command
     * @memberof DeskToRummySrvPlayerCommandReq
     * @instance
     */
    DeskToRummySrvPlayerCommandReq.prototype.Command = null;

    /**
     * Creates a new DeskToRummySrvPlayerCommandReq instance using the specified properties.
     * @function create
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {IDeskToRummySrvPlayerCommandReq=} [properties] Properties to set
     * @returns {DeskToRummySrvPlayerCommandReq} DeskToRummySrvPlayerCommandReq instance
     */
    DeskToRummySrvPlayerCommandReq.create = function create(properties) {
        return new DeskToRummySrvPlayerCommandReq(properties);
    };

    /**
     * Encodes the specified DeskToRummySrvPlayerCommandReq message. Does not implicitly {@link DeskToRummySrvPlayerCommandReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {IDeskToRummySrvPlayerCommandReq} message DeskToRummySrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummySrvPlayerCommandReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Command != null && Object.hasOwnProperty.call(message, "Command"))
            $root.OperCmdForRummy.encode(message.Command, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToRummySrvPlayerCommandReq message, length delimited. Does not implicitly {@link DeskToRummySrvPlayerCommandReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {IDeskToRummySrvPlayerCommandReq} message DeskToRummySrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummySrvPlayerCommandReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToRummySrvPlayerCommandReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToRummySrvPlayerCommandReq} DeskToRummySrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummySrvPlayerCommandReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToRummySrvPlayerCommandReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Command = $root.OperCmdForRummy.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToRummySrvPlayerCommandReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToRummySrvPlayerCommandReq} DeskToRummySrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummySrvPlayerCommandReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToRummySrvPlayerCommandReq message.
     * @function verify
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToRummySrvPlayerCommandReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Command != null && message.hasOwnProperty("Command")) {
            let error = $root.OperCmdForRummy.verify(message.Command);
            if (error)
                return "Command." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToRummySrvPlayerCommandReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToRummySrvPlayerCommandReq} DeskToRummySrvPlayerCommandReq
     */
    DeskToRummySrvPlayerCommandReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToRummySrvPlayerCommandReq)
            return object;
        let message = new $root.DeskToRummySrvPlayerCommandReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Command != null) {
            if (typeof object.Command !== "object")
                throw TypeError(".DeskToRummySrvPlayerCommandReq.Command: object expected");
            message.Command = $root.OperCmdForRummy.fromObject(object.Command);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToRummySrvPlayerCommandReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {DeskToRummySrvPlayerCommandReq} message DeskToRummySrvPlayerCommandReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToRummySrvPlayerCommandReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Command = null;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Command != null && message.hasOwnProperty("Command"))
            object.Command = $root.OperCmdForRummy.toObject(message.Command, options);
        return object;
    };

    /**
     * Converts this DeskToRummySrvPlayerCommandReq to JSON.
     * @function toJSON
     * @memberof DeskToRummySrvPlayerCommandReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToRummySrvPlayerCommandReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToRummySrvPlayerCommandReq
     * @function getTypeUrl
     * @memberof DeskToRummySrvPlayerCommandReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToRummySrvPlayerCommandReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToRummySrvPlayerCommandReq";
    };

    return DeskToRummySrvPlayerCommandReq;
})();

export const DeskToRummySrvPlayerCommandAck = $root.DeskToRummySrvPlayerCommandAck = (() => {

    /**
     * Properties of a DeskToRummySrvPlayerCommandAck.
     * @exports IDeskToRummySrvPlayerCommandAck
     * @interface IDeskToRummySrvPlayerCommandAck
     * @property {number|null} [Res] DeskToRummySrvPlayerCommandAck Res
     * @property {number|null} [UserID] DeskToRummySrvPlayerCommandAck UserID
     * @property {number|null} [Operation] DeskToRummySrvPlayerCommandAck Operation
     * @property {number|null} [OperateCardType] DeskToRummySrvPlayerCommandAck OperateCardType
     * @property {number|null} [LeftCardCnt] DeskToRummySrvPlayerCommandAck LeftCardCnt
     * @property {number|null} [DropCheatScore] DeskToRummySrvPlayerCommandAck DropCheatScore
     * @property {Array.<number>|null} [AiCard] DeskToRummySrvPlayerCommandAck AiCard
     * @property {Array.<number>|null} [AiCardList1] DeskToRummySrvPlayerCommandAck AiCardList1
     * @property {Array.<number>|null} [AiCardList2] DeskToRummySrvPlayerCommandAck AiCardList2
     * @property {Array.<number>|null} [AiCardList3] DeskToRummySrvPlayerCommandAck AiCardList3
     * @property {Array.<number>|null} [AiCardList4] DeskToRummySrvPlayerCommandAck AiCardList4
     * @property {Array.<number>|null} [AiCardList5] DeskToRummySrvPlayerCommandAck AiCardList5
     */

    /**
     * Constructs a new DeskToRummySrvPlayerCommandAck.
     * @exports DeskToRummySrvPlayerCommandAck
     * @classdesc Represents a DeskToRummySrvPlayerCommandAck.
     * @implements IDeskToRummySrvPlayerCommandAck
     * @constructor
     * @param {IDeskToRummySrvPlayerCommandAck=} [properties] Properties to set
     */
    function DeskToRummySrvPlayerCommandAck(properties) {
        this.AiCard = [];
        this.AiCardList1 = [];
        this.AiCardList2 = [];
        this.AiCardList3 = [];
        this.AiCardList4 = [];
        this.AiCardList5 = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToRummySrvPlayerCommandAck Res.
     * @member {number} Res
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.Res = 0;

    /**
     * DeskToRummySrvPlayerCommandAck UserID.
     * @member {number} UserID
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.UserID = 0;

    /**
     * DeskToRummySrvPlayerCommandAck Operation.
     * @member {number} Operation
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.Operation = 0;

    /**
     * DeskToRummySrvPlayerCommandAck OperateCardType.
     * @member {number} OperateCardType
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.OperateCardType = 0;

    /**
     * DeskToRummySrvPlayerCommandAck LeftCardCnt.
     * @member {number} LeftCardCnt
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.LeftCardCnt = 0;

    /**
     * DeskToRummySrvPlayerCommandAck DropCheatScore.
     * @member {number} DropCheatScore
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.DropCheatScore = 0;

    /**
     * DeskToRummySrvPlayerCommandAck AiCard.
     * @member {Array.<number>} AiCard
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCard = $util.emptyArray;

    /**
     * DeskToRummySrvPlayerCommandAck AiCardList1.
     * @member {Array.<number>} AiCardList1
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCardList1 = $util.emptyArray;

    /**
     * DeskToRummySrvPlayerCommandAck AiCardList2.
     * @member {Array.<number>} AiCardList2
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCardList2 = $util.emptyArray;

    /**
     * DeskToRummySrvPlayerCommandAck AiCardList3.
     * @member {Array.<number>} AiCardList3
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCardList3 = $util.emptyArray;

    /**
     * DeskToRummySrvPlayerCommandAck AiCardList4.
     * @member {Array.<number>} AiCardList4
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCardList4 = $util.emptyArray;

    /**
     * DeskToRummySrvPlayerCommandAck AiCardList5.
     * @member {Array.<number>} AiCardList5
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     */
    DeskToRummySrvPlayerCommandAck.prototype.AiCardList5 = $util.emptyArray;

    /**
     * Creates a new DeskToRummySrvPlayerCommandAck instance using the specified properties.
     * @function create
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {IDeskToRummySrvPlayerCommandAck=} [properties] Properties to set
     * @returns {DeskToRummySrvPlayerCommandAck} DeskToRummySrvPlayerCommandAck instance
     */
    DeskToRummySrvPlayerCommandAck.create = function create(properties) {
        return new DeskToRummySrvPlayerCommandAck(properties);
    };

    /**
     * Encodes the specified DeskToRummySrvPlayerCommandAck message. Does not implicitly {@link DeskToRummySrvPlayerCommandAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {IDeskToRummySrvPlayerCommandAck} message DeskToRummySrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummySrvPlayerCommandAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Operation != null && Object.hasOwnProperty.call(message, "Operation"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Operation);
        if (message.OperateCardType != null && Object.hasOwnProperty.call(message, "OperateCardType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.OperateCardType);
        if (message.LeftCardCnt != null && Object.hasOwnProperty.call(message, "LeftCardCnt"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.LeftCardCnt);
        if (message.DropCheatScore != null && Object.hasOwnProperty.call(message, "DropCheatScore"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.DropCheatScore);
        if (message.AiCard != null && message.AiCard.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.AiCard.length; ++i)
                writer.uint32(message.AiCard[i]);
            writer.ldelim();
        }
        if (message.AiCardList1 != null && message.AiCardList1.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.AiCardList1.length; ++i)
                writer.uint32(message.AiCardList1[i]);
            writer.ldelim();
        }
        if (message.AiCardList2 != null && message.AiCardList2.length) {
            writer.uint32(/* id 9, wireType 2 =*/74).fork();
            for (let i = 0; i < message.AiCardList2.length; ++i)
                writer.uint32(message.AiCardList2[i]);
            writer.ldelim();
        }
        if (message.AiCardList3 != null && message.AiCardList3.length) {
            writer.uint32(/* id 10, wireType 2 =*/82).fork();
            for (let i = 0; i < message.AiCardList3.length; ++i)
                writer.uint32(message.AiCardList3[i]);
            writer.ldelim();
        }
        if (message.AiCardList4 != null && message.AiCardList4.length) {
            writer.uint32(/* id 11, wireType 2 =*/90).fork();
            for (let i = 0; i < message.AiCardList4.length; ++i)
                writer.uint32(message.AiCardList4[i]);
            writer.ldelim();
        }
        if (message.AiCardList5 != null && message.AiCardList5.length) {
            writer.uint32(/* id 12, wireType 2 =*/98).fork();
            for (let i = 0; i < message.AiCardList5.length; ++i)
                writer.uint32(message.AiCardList5[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified DeskToRummySrvPlayerCommandAck message, length delimited. Does not implicitly {@link DeskToRummySrvPlayerCommandAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {IDeskToRummySrvPlayerCommandAck} message DeskToRummySrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummySrvPlayerCommandAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToRummySrvPlayerCommandAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToRummySrvPlayerCommandAck} DeskToRummySrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummySrvPlayerCommandAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToRummySrvPlayerCommandAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Operation = reader.uint32();
                    break;
                }
            case 4: {
                    message.OperateCardType = reader.uint32();
                    break;
                }
            case 5: {
                    message.LeftCardCnt = reader.uint32();
                    break;
                }
            case 6: {
                    message.DropCheatScore = reader.uint32();
                    break;
                }
            case 7: {
                    if (!(message.AiCard && message.AiCard.length))
                        message.AiCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCard.push(reader.uint32());
                    } else
                        message.AiCard.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.AiCardList1 && message.AiCardList1.length))
                        message.AiCardList1 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCardList1.push(reader.uint32());
                    } else
                        message.AiCardList1.push(reader.uint32());
                    break;
                }
            case 9: {
                    if (!(message.AiCardList2 && message.AiCardList2.length))
                        message.AiCardList2 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCardList2.push(reader.uint32());
                    } else
                        message.AiCardList2.push(reader.uint32());
                    break;
                }
            case 10: {
                    if (!(message.AiCardList3 && message.AiCardList3.length))
                        message.AiCardList3 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCardList3.push(reader.uint32());
                    } else
                        message.AiCardList3.push(reader.uint32());
                    break;
                }
            case 11: {
                    if (!(message.AiCardList4 && message.AiCardList4.length))
                        message.AiCardList4 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCardList4.push(reader.uint32());
                    } else
                        message.AiCardList4.push(reader.uint32());
                    break;
                }
            case 12: {
                    if (!(message.AiCardList5 && message.AiCardList5.length))
                        message.AiCardList5 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AiCardList5.push(reader.uint32());
                    } else
                        message.AiCardList5.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToRummySrvPlayerCommandAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToRummySrvPlayerCommandAck} DeskToRummySrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummySrvPlayerCommandAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToRummySrvPlayerCommandAck message.
     * @function verify
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToRummySrvPlayerCommandAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            if (!$util.isInteger(message.Operation))
                return "Operation: integer expected";
        if (message.OperateCardType != null && message.hasOwnProperty("OperateCardType"))
            if (!$util.isInteger(message.OperateCardType))
                return "OperateCardType: integer expected";
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            if (!$util.isInteger(message.LeftCardCnt))
                return "LeftCardCnt: integer expected";
        if (message.DropCheatScore != null && message.hasOwnProperty("DropCheatScore"))
            if (!$util.isInteger(message.DropCheatScore))
                return "DropCheatScore: integer expected";
        if (message.AiCard != null && message.hasOwnProperty("AiCard")) {
            if (!Array.isArray(message.AiCard))
                return "AiCard: array expected";
            for (let i = 0; i < message.AiCard.length; ++i)
                if (!$util.isInteger(message.AiCard[i]))
                    return "AiCard: integer[] expected";
        }
        if (message.AiCardList1 != null && message.hasOwnProperty("AiCardList1")) {
            if (!Array.isArray(message.AiCardList1))
                return "AiCardList1: array expected";
            for (let i = 0; i < message.AiCardList1.length; ++i)
                if (!$util.isInteger(message.AiCardList1[i]))
                    return "AiCardList1: integer[] expected";
        }
        if (message.AiCardList2 != null && message.hasOwnProperty("AiCardList2")) {
            if (!Array.isArray(message.AiCardList2))
                return "AiCardList2: array expected";
            for (let i = 0; i < message.AiCardList2.length; ++i)
                if (!$util.isInteger(message.AiCardList2[i]))
                    return "AiCardList2: integer[] expected";
        }
        if (message.AiCardList3 != null && message.hasOwnProperty("AiCardList3")) {
            if (!Array.isArray(message.AiCardList3))
                return "AiCardList3: array expected";
            for (let i = 0; i < message.AiCardList3.length; ++i)
                if (!$util.isInteger(message.AiCardList3[i]))
                    return "AiCardList3: integer[] expected";
        }
        if (message.AiCardList4 != null && message.hasOwnProperty("AiCardList4")) {
            if (!Array.isArray(message.AiCardList4))
                return "AiCardList4: array expected";
            for (let i = 0; i < message.AiCardList4.length; ++i)
                if (!$util.isInteger(message.AiCardList4[i]))
                    return "AiCardList4: integer[] expected";
        }
        if (message.AiCardList5 != null && message.hasOwnProperty("AiCardList5")) {
            if (!Array.isArray(message.AiCardList5))
                return "AiCardList5: array expected";
            for (let i = 0; i < message.AiCardList5.length; ++i)
                if (!$util.isInteger(message.AiCardList5[i]))
                    return "AiCardList5: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a DeskToRummySrvPlayerCommandAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToRummySrvPlayerCommandAck} DeskToRummySrvPlayerCommandAck
     */
    DeskToRummySrvPlayerCommandAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToRummySrvPlayerCommandAck)
            return object;
        let message = new $root.DeskToRummySrvPlayerCommandAck();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Operation != null)
            message.Operation = object.Operation >>> 0;
        if (object.OperateCardType != null)
            message.OperateCardType = object.OperateCardType >>> 0;
        if (object.LeftCardCnt != null)
            message.LeftCardCnt = object.LeftCardCnt >>> 0;
        if (object.DropCheatScore != null)
            message.DropCheatScore = object.DropCheatScore >>> 0;
        if (object.AiCard) {
            if (!Array.isArray(object.AiCard))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCard: array expected");
            message.AiCard = [];
            for (let i = 0; i < object.AiCard.length; ++i)
                message.AiCard[i] = object.AiCard[i] >>> 0;
        }
        if (object.AiCardList1) {
            if (!Array.isArray(object.AiCardList1))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCardList1: array expected");
            message.AiCardList1 = [];
            for (let i = 0; i < object.AiCardList1.length; ++i)
                message.AiCardList1[i] = object.AiCardList1[i] >>> 0;
        }
        if (object.AiCardList2) {
            if (!Array.isArray(object.AiCardList2))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCardList2: array expected");
            message.AiCardList2 = [];
            for (let i = 0; i < object.AiCardList2.length; ++i)
                message.AiCardList2[i] = object.AiCardList2[i] >>> 0;
        }
        if (object.AiCardList3) {
            if (!Array.isArray(object.AiCardList3))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCardList3: array expected");
            message.AiCardList3 = [];
            for (let i = 0; i < object.AiCardList3.length; ++i)
                message.AiCardList3[i] = object.AiCardList3[i] >>> 0;
        }
        if (object.AiCardList4) {
            if (!Array.isArray(object.AiCardList4))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCardList4: array expected");
            message.AiCardList4 = [];
            for (let i = 0; i < object.AiCardList4.length; ++i)
                message.AiCardList4[i] = object.AiCardList4[i] >>> 0;
        }
        if (object.AiCardList5) {
            if (!Array.isArray(object.AiCardList5))
                throw TypeError(".DeskToRummySrvPlayerCommandAck.AiCardList5: array expected");
            message.AiCardList5 = [];
            for (let i = 0; i < object.AiCardList5.length; ++i)
                message.AiCardList5[i] = object.AiCardList5[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToRummySrvPlayerCommandAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {DeskToRummySrvPlayerCommandAck} message DeskToRummySrvPlayerCommandAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToRummySrvPlayerCommandAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.AiCard = [];
            object.AiCardList1 = [];
            object.AiCardList2 = [];
            object.AiCardList3 = [];
            object.AiCardList4 = [];
            object.AiCardList5 = [];
        }
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.Operation = 0;
            object.OperateCardType = 0;
            object.LeftCardCnt = 0;
            object.DropCheatScore = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            object.Operation = message.Operation;
        if (message.OperateCardType != null && message.hasOwnProperty("OperateCardType"))
            object.OperateCardType = message.OperateCardType;
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            object.LeftCardCnt = message.LeftCardCnt;
        if (message.DropCheatScore != null && message.hasOwnProperty("DropCheatScore"))
            object.DropCheatScore = message.DropCheatScore;
        if (message.AiCard && message.AiCard.length) {
            object.AiCard = [];
            for (let j = 0; j < message.AiCard.length; ++j)
                object.AiCard[j] = message.AiCard[j];
        }
        if (message.AiCardList1 && message.AiCardList1.length) {
            object.AiCardList1 = [];
            for (let j = 0; j < message.AiCardList1.length; ++j)
                object.AiCardList1[j] = message.AiCardList1[j];
        }
        if (message.AiCardList2 && message.AiCardList2.length) {
            object.AiCardList2 = [];
            for (let j = 0; j < message.AiCardList2.length; ++j)
                object.AiCardList2[j] = message.AiCardList2[j];
        }
        if (message.AiCardList3 && message.AiCardList3.length) {
            object.AiCardList3 = [];
            for (let j = 0; j < message.AiCardList3.length; ++j)
                object.AiCardList3[j] = message.AiCardList3[j];
        }
        if (message.AiCardList4 && message.AiCardList4.length) {
            object.AiCardList4 = [];
            for (let j = 0; j < message.AiCardList4.length; ++j)
                object.AiCardList4[j] = message.AiCardList4[j];
        }
        if (message.AiCardList5 && message.AiCardList5.length) {
            object.AiCardList5 = [];
            for (let j = 0; j < message.AiCardList5.length; ++j)
                object.AiCardList5[j] = message.AiCardList5[j];
        }
        return object;
    };

    /**
     * Converts this DeskToRummySrvPlayerCommandAck to JSON.
     * @function toJSON
     * @memberof DeskToRummySrvPlayerCommandAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToRummySrvPlayerCommandAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToRummySrvPlayerCommandAck
     * @function getTypeUrl
     * @memberof DeskToRummySrvPlayerCommandAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToRummySrvPlayerCommandAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToRummySrvPlayerCommandAck";
    };

    return DeskToRummySrvPlayerCommandAck;
})();

export const RummySrvToDeskPushDealCard = $root.RummySrvToDeskPushDealCard = (() => {

    /**
     * Properties of a RummySrvToDeskPushDealCard.
     * @exports IRummySrvToDeskPushDealCard
     * @interface IRummySrvToDeskPushDealCard
     * @property {number|null} [UserID] RummySrvToDeskPushDealCard UserID
     * @property {Array.<number>|null} [NewCard] RummySrvToDeskPushDealCard NewCard
     * @property {boolean|null} [IsChange] RummySrvToDeskPushDealCard IsChange
     */

    /**
     * Constructs a new RummySrvToDeskPushDealCard.
     * @exports RummySrvToDeskPushDealCard
     * @classdesc Represents a RummySrvToDeskPushDealCard.
     * @implements IRummySrvToDeskPushDealCard
     * @constructor
     * @param {IRummySrvToDeskPushDealCard=} [properties] Properties to set
     */
    function RummySrvToDeskPushDealCard(properties) {
        this.NewCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushDealCard UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushDealCard
     * @instance
     */
    RummySrvToDeskPushDealCard.prototype.UserID = 0;

    /**
     * RummySrvToDeskPushDealCard NewCard.
     * @member {Array.<number>} NewCard
     * @memberof RummySrvToDeskPushDealCard
     * @instance
     */
    RummySrvToDeskPushDealCard.prototype.NewCard = $util.emptyArray;

    /**
     * RummySrvToDeskPushDealCard IsChange.
     * @member {boolean} IsChange
     * @memberof RummySrvToDeskPushDealCard
     * @instance
     */
    RummySrvToDeskPushDealCard.prototype.IsChange = false;

    /**
     * Creates a new RummySrvToDeskPushDealCard instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {IRummySrvToDeskPushDealCard=} [properties] Properties to set
     * @returns {RummySrvToDeskPushDealCard} RummySrvToDeskPushDealCard instance
     */
    RummySrvToDeskPushDealCard.create = function create(properties) {
        return new RummySrvToDeskPushDealCard(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushDealCard message. Does not implicitly {@link RummySrvToDeskPushDealCard.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {IRummySrvToDeskPushDealCard} message RummySrvToDeskPushDealCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushDealCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NewCard != null && message.NewCard.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.NewCard.length; ++i)
                writer.uint32(message.NewCard[i]);
            writer.ldelim();
        }
        if (message.IsChange != null && Object.hasOwnProperty.call(message, "IsChange"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsChange);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushDealCard message, length delimited. Does not implicitly {@link RummySrvToDeskPushDealCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {IRummySrvToDeskPushDealCard} message RummySrvToDeskPushDealCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushDealCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushDealCard message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushDealCard} RummySrvToDeskPushDealCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushDealCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushDealCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.NewCard && message.NewCard.length))
                        message.NewCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.NewCard.push(reader.uint32());
                    } else
                        message.NewCard.push(reader.uint32());
                    break;
                }
            case 3: {
                    message.IsChange = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushDealCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushDealCard} RummySrvToDeskPushDealCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushDealCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushDealCard message.
     * @function verify
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushDealCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NewCard != null && message.hasOwnProperty("NewCard")) {
            if (!Array.isArray(message.NewCard))
                return "NewCard: array expected";
            for (let i = 0; i < message.NewCard.length; ++i)
                if (!$util.isInteger(message.NewCard[i]))
                    return "NewCard: integer[] expected";
        }
        if (message.IsChange != null && message.hasOwnProperty("IsChange"))
            if (typeof message.IsChange !== "boolean")
                return "IsChange: boolean expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushDealCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushDealCard} RummySrvToDeskPushDealCard
     */
    RummySrvToDeskPushDealCard.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushDealCard)
            return object;
        let message = new $root.RummySrvToDeskPushDealCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NewCard) {
            if (!Array.isArray(object.NewCard))
                throw TypeError(".RummySrvToDeskPushDealCard.NewCard: array expected");
            message.NewCard = [];
            for (let i = 0; i < object.NewCard.length; ++i)
                message.NewCard[i] = object.NewCard[i] >>> 0;
        }
        if (object.IsChange != null)
            message.IsChange = Boolean(object.IsChange);
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushDealCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {RummySrvToDeskPushDealCard} message RummySrvToDeskPushDealCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushDealCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.NewCard = [];
        if (options.defaults) {
            object.UserID = 0;
            object.IsChange = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NewCard && message.NewCard.length) {
            object.NewCard = [];
            for (let j = 0; j < message.NewCard.length; ++j)
                object.NewCard[j] = message.NewCard[j];
        }
        if (message.IsChange != null && message.hasOwnProperty("IsChange"))
            object.IsChange = message.IsChange;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushDealCard to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushDealCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushDealCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushDealCard
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushDealCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushDealCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushDealCard";
    };

    return RummySrvToDeskPushDealCard;
})();

export const PlayerTotalBetForRummy = $root.PlayerTotalBetForRummy = (() => {

    /**
     * Properties of a PlayerTotalBetForRummy.
     * @exports IPlayerTotalBetForRummy
     * @interface IPlayerTotalBetForRummy
     * @property {number|null} [UserID] PlayerTotalBetForRummy UserID
     * @property {string|null} [CurBetChip] PlayerTotalBetForRummy CurBetChip
     * @property {string|null} [CurEnterChip] PlayerTotalBetForRummy CurEnterChip
     * @property {number|null} [DropScore] PlayerTotalBetForRummy DropScore
     */

    /**
     * Constructs a new PlayerTotalBetForRummy.
     * @exports PlayerTotalBetForRummy
     * @classdesc Represents a PlayerTotalBetForRummy.
     * @implements IPlayerTotalBetForRummy
     * @constructor
     * @param {IPlayerTotalBetForRummy=} [properties] Properties to set
     */
    function PlayerTotalBetForRummy(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerTotalBetForRummy UserID.
     * @member {number} UserID
     * @memberof PlayerTotalBetForRummy
     * @instance
     */
    PlayerTotalBetForRummy.prototype.UserID = 0;

    /**
     * PlayerTotalBetForRummy CurBetChip.
     * @member {string} CurBetChip
     * @memberof PlayerTotalBetForRummy
     * @instance
     */
    PlayerTotalBetForRummy.prototype.CurBetChip = "";

    /**
     * PlayerTotalBetForRummy CurEnterChip.
     * @member {string} CurEnterChip
     * @memberof PlayerTotalBetForRummy
     * @instance
     */
    PlayerTotalBetForRummy.prototype.CurEnterChip = "";

    /**
     * PlayerTotalBetForRummy DropScore.
     * @member {number} DropScore
     * @memberof PlayerTotalBetForRummy
     * @instance
     */
    PlayerTotalBetForRummy.prototype.DropScore = 0;

    /**
     * Creates a new PlayerTotalBetForRummy instance using the specified properties.
     * @function create
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {IPlayerTotalBetForRummy=} [properties] Properties to set
     * @returns {PlayerTotalBetForRummy} PlayerTotalBetForRummy instance
     */
    PlayerTotalBetForRummy.create = function create(properties) {
        return new PlayerTotalBetForRummy(properties);
    };

    /**
     * Encodes the specified PlayerTotalBetForRummy message. Does not implicitly {@link PlayerTotalBetForRummy.verify|verify} messages.
     * @function encode
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {IPlayerTotalBetForRummy} message PlayerTotalBetForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerTotalBetForRummy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CurBetChip != null && Object.hasOwnProperty.call(message, "CurBetChip"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.CurBetChip);
        if (message.CurEnterChip != null && Object.hasOwnProperty.call(message, "CurEnterChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.CurEnterChip);
        if (message.DropScore != null && Object.hasOwnProperty.call(message, "DropScore"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.DropScore);
        return writer;
    };

    /**
     * Encodes the specified PlayerTotalBetForRummy message, length delimited. Does not implicitly {@link PlayerTotalBetForRummy.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {IPlayerTotalBetForRummy} message PlayerTotalBetForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerTotalBetForRummy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerTotalBetForRummy message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerTotalBetForRummy} PlayerTotalBetForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerTotalBetForRummy.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerTotalBetForRummy();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CurBetChip = reader.string();
                    break;
                }
            case 3: {
                    message.CurEnterChip = reader.string();
                    break;
                }
            case 4: {
                    message.DropScore = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerTotalBetForRummy message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerTotalBetForRummy} PlayerTotalBetForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerTotalBetForRummy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerTotalBetForRummy message.
     * @function verify
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerTotalBetForRummy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CurBetChip != null && message.hasOwnProperty("CurBetChip"))
            if (!$util.isString(message.CurBetChip))
                return "CurBetChip: string expected";
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            if (!$util.isString(message.CurEnterChip))
                return "CurEnterChip: string expected";
        if (message.DropScore != null && message.hasOwnProperty("DropScore"))
            if (!$util.isInteger(message.DropScore))
                return "DropScore: integer expected";
        return null;
    };

    /**
     * Creates a PlayerTotalBetForRummy message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerTotalBetForRummy} PlayerTotalBetForRummy
     */
    PlayerTotalBetForRummy.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerTotalBetForRummy)
            return object;
        let message = new $root.PlayerTotalBetForRummy();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CurBetChip != null)
            message.CurBetChip = String(object.CurBetChip);
        if (object.CurEnterChip != null)
            message.CurEnterChip = String(object.CurEnterChip);
        if (object.DropScore != null)
            message.DropScore = object.DropScore >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PlayerTotalBetForRummy message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {PlayerTotalBetForRummy} message PlayerTotalBetForRummy
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerTotalBetForRummy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CurBetChip = "";
            object.CurEnterChip = "";
            object.DropScore = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CurBetChip != null && message.hasOwnProperty("CurBetChip"))
            object.CurBetChip = message.CurBetChip;
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            object.CurEnterChip = message.CurEnterChip;
        if (message.DropScore != null && message.hasOwnProperty("DropScore"))
            object.DropScore = message.DropScore;
        return object;
    };

    /**
     * Converts this PlayerTotalBetForRummy to JSON.
     * @function toJSON
     * @memberof PlayerTotalBetForRummy
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerTotalBetForRummy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerTotalBetForRummy
     * @function getTypeUrl
     * @memberof PlayerTotalBetForRummy
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerTotalBetForRummy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerTotalBetForRummy";
    };

    return PlayerTotalBetForRummy;
})();

export const RummySrvToDeskPushPlayingInfo = $root.RummySrvToDeskPushPlayingInfo = (() => {

    /**
     * Properties of a RummySrvToDeskPushPlayingInfo.
     * @exports IRummySrvToDeskPushPlayingInfo
     * @interface IRummySrvToDeskPushPlayingInfo
     * @property {number|null} [UserID] RummySrvToDeskPushPlayingInfo UserID
     * @property {number|null} [StateID] RummySrvToDeskPushPlayingInfo StateID
     * @property {number|null} [DealerID] RummySrvToDeskPushPlayingInfo DealerID
     * @property {number|null} [Practitioner] RummySrvToDeskPushPlayingInfo Practitioner
     * @property {Array.<IPlayerTotalBetForRummy>|null} [PlayerBet] RummySrvToDeskPushPlayingInfo PlayerBet
     * @property {Array.<number>|null} [PublicCard] RummySrvToDeskPushPlayingInfo PublicCard
     * @property {Array.<number>|null} [HandCard] RummySrvToDeskPushPlayingInfo HandCard
     * @property {Array.<number>|null} [FoldPlayerIDs] RummySrvToDeskPushPlayingInfo FoldPlayerIDs
     * @property {Array.<number>|null} [GamingIDs] RummySrvToDeskPushPlayingInfo GamingIDs
     * @property {number|null} [MagicCard] RummySrvToDeskPushPlayingInfo MagicCard
     * @property {number|null} [CardLeftCnt] RummySrvToDeskPushPlayingInfo CardLeftCnt
     * @property {string|null} [BootInfo] RummySrvToDeskPushPlayingInfo BootInfo
     * @property {number|null} [CurSeatNo] RummySrvToDeskPushPlayingInfo CurSeatNo
     * @property {boolean|null} [IsDeclared] RummySrvToDeskPushPlayingInfo IsDeclared
     * @property {Array.<number>|null} [CardList1] RummySrvToDeskPushPlayingInfo CardList1
     * @property {Array.<number>|null} [CardList2] RummySrvToDeskPushPlayingInfo CardList2
     * @property {Array.<number>|null} [CardList3] RummySrvToDeskPushPlayingInfo CardList3
     * @property {Array.<number>|null} [CardList4] RummySrvToDeskPushPlayingInfo CardList4
     * @property {Array.<number>|null} [CardList5] RummySrvToDeskPushPlayingInfo CardList5
     * @property {Array.<IPlayerResultForRummy>|null} [PlayerResult] RummySrvToDeskPushPlayingInfo PlayerResult
     * @property {number|null} [ShowCard] RummySrvToDeskPushPlayingInfo ShowCard
     * @property {number|null} [WinnerId] RummySrvToDeskPushPlayingInfo WinnerId
     * @property {Array.<number>|null} [FireHu] RummySrvToDeskPushPlayingInfo FireHu
     */

    /**
     * Constructs a new RummySrvToDeskPushPlayingInfo.
     * @exports RummySrvToDeskPushPlayingInfo
     * @classdesc Represents a RummySrvToDeskPushPlayingInfo.
     * @implements IRummySrvToDeskPushPlayingInfo
     * @constructor
     * @param {IRummySrvToDeskPushPlayingInfo=} [properties] Properties to set
     */
    function RummySrvToDeskPushPlayingInfo(properties) {
        this.PlayerBet = [];
        this.PublicCard = [];
        this.HandCard = [];
        this.FoldPlayerIDs = [];
        this.GamingIDs = [];
        this.CardList1 = [];
        this.CardList2 = [];
        this.CardList3 = [];
        this.CardList4 = [];
        this.CardList5 = [];
        this.PlayerResult = [];
        this.FireHu = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.UserID = 0;

    /**
     * RummySrvToDeskPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.StateID = 0;

    /**
     * RummySrvToDeskPushPlayingInfo DealerID.
     * @member {number} DealerID
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.DealerID = 0;

    /**
     * RummySrvToDeskPushPlayingInfo Practitioner.
     * @member {number} Practitioner
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.Practitioner = 0;

    /**
     * RummySrvToDeskPushPlayingInfo PlayerBet.
     * @member {Array.<IPlayerTotalBetForRummy>} PlayerBet
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.PlayerBet = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo PublicCard.
     * @member {Array.<number>} PublicCard
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.PublicCard = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo HandCard.
     * @member {Array.<number>} HandCard
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.HandCard = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo FoldPlayerIDs.
     * @member {Array.<number>} FoldPlayerIDs
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.FoldPlayerIDs = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo MagicCard.
     * @member {number} MagicCard
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.MagicCard = 0;

    /**
     * RummySrvToDeskPushPlayingInfo CardLeftCnt.
     * @member {number} CardLeftCnt
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardLeftCnt = 0;

    /**
     * RummySrvToDeskPushPlayingInfo BootInfo.
     * @member {string} BootInfo
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.BootInfo = "";

    /**
     * RummySrvToDeskPushPlayingInfo CurSeatNo.
     * @member {number} CurSeatNo
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CurSeatNo = 0;

    /**
     * RummySrvToDeskPushPlayingInfo IsDeclared.
     * @member {boolean} IsDeclared
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.IsDeclared = false;

    /**
     * RummySrvToDeskPushPlayingInfo CardList1.
     * @member {Array.<number>} CardList1
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardList1 = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo CardList2.
     * @member {Array.<number>} CardList2
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardList2 = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo CardList3.
     * @member {Array.<number>} CardList3
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardList3 = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo CardList4.
     * @member {Array.<number>} CardList4
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardList4 = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo CardList5.
     * @member {Array.<number>} CardList5
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.CardList5 = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo PlayerResult.
     * @member {Array.<IPlayerResultForRummy>} PlayerResult
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.PlayerResult = $util.emptyArray;

    /**
     * RummySrvToDeskPushPlayingInfo ShowCard.
     * @member {number} ShowCard
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.ShowCard = 0;

    /**
     * RummySrvToDeskPushPlayingInfo WinnerId.
     * @member {number} WinnerId
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.WinnerId = 0;

    /**
     * RummySrvToDeskPushPlayingInfo FireHu.
     * @member {Array.<number>} FireHu
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     */
    RummySrvToDeskPushPlayingInfo.prototype.FireHu = $util.emptyArray;

    /**
     * Creates a new RummySrvToDeskPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {IRummySrvToDeskPushPlayingInfo=} [properties] Properties to set
     * @returns {RummySrvToDeskPushPlayingInfo} RummySrvToDeskPushPlayingInfo instance
     */
    RummySrvToDeskPushPlayingInfo.create = function create(properties) {
        return new RummySrvToDeskPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushPlayingInfo message. Does not implicitly {@link RummySrvToDeskPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {IRummySrvToDeskPushPlayingInfo} message RummySrvToDeskPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DealerID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Practitioner);
        if (message.PlayerBet != null && message.PlayerBet.length)
            for (let i = 0; i < message.PlayerBet.length; ++i)
                $root.PlayerTotalBetForRummy.encode(message.PlayerBet[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.PublicCard != null && message.PublicCard.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.PublicCard.length; ++i)
                writer.uint32(message.PublicCard[i]);
            writer.ldelim();
        }
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        if (message.FoldPlayerIDs != null && message.FoldPlayerIDs.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.FoldPlayerIDs.length; ++i)
                writer.uint32(message.FoldPlayerIDs[i]);
            writer.ldelim();
        }
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 9, wireType 2 =*/74).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.MagicCard != null && Object.hasOwnProperty.call(message, "MagicCard"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.MagicCard);
        if (message.CardLeftCnt != null && Object.hasOwnProperty.call(message, "CardLeftCnt"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.CardLeftCnt);
        if (message.BootInfo != null && Object.hasOwnProperty.call(message, "BootInfo"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.BootInfo);
        if (message.CurSeatNo != null && Object.hasOwnProperty.call(message, "CurSeatNo"))
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.CurSeatNo);
        if (message.IsDeclared != null && Object.hasOwnProperty.call(message, "IsDeclared"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.IsDeclared);
        if (message.CardList1 != null && message.CardList1.length) {
            writer.uint32(/* id 15, wireType 2 =*/122).fork();
            for (let i = 0; i < message.CardList1.length; ++i)
                writer.uint32(message.CardList1[i]);
            writer.ldelim();
        }
        if (message.CardList2 != null && message.CardList2.length) {
            writer.uint32(/* id 16, wireType 2 =*/130).fork();
            for (let i = 0; i < message.CardList2.length; ++i)
                writer.uint32(message.CardList2[i]);
            writer.ldelim();
        }
        if (message.CardList3 != null && message.CardList3.length) {
            writer.uint32(/* id 17, wireType 2 =*/138).fork();
            for (let i = 0; i < message.CardList3.length; ++i)
                writer.uint32(message.CardList3[i]);
            writer.ldelim();
        }
        if (message.CardList4 != null && message.CardList4.length) {
            writer.uint32(/* id 18, wireType 2 =*/146).fork();
            for (let i = 0; i < message.CardList4.length; ++i)
                writer.uint32(message.CardList4[i]);
            writer.ldelim();
        }
        if (message.CardList5 != null && message.CardList5.length) {
            writer.uint32(/* id 19, wireType 2 =*/154).fork();
            for (let i = 0; i < message.CardList5.length; ++i)
                writer.uint32(message.CardList5[i]);
            writer.ldelim();
        }
        if (message.PlayerResult != null && message.PlayerResult.length)
            for (let i = 0; i < message.PlayerResult.length; ++i)
                $root.PlayerResultForRummy.encode(message.PlayerResult[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
        if (message.ShowCard != null && Object.hasOwnProperty.call(message, "ShowCard"))
            writer.uint32(/* id 21, wireType 0 =*/168).uint32(message.ShowCard);
        if (message.WinnerId != null && Object.hasOwnProperty.call(message, "WinnerId"))
            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.WinnerId);
        if (message.FireHu != null && message.FireHu.length) {
            writer.uint32(/* id 23, wireType 2 =*/186).fork();
            for (let i = 0; i < message.FireHu.length; ++i)
                writer.uint32(message.FireHu[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushPlayingInfo message, length delimited. Does not implicitly {@link RummySrvToDeskPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {IRummySrvToDeskPushPlayingInfo} message RummySrvToDeskPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushPlayingInfo} RummySrvToDeskPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Practitioner = reader.int32();
                    break;
                }
            case 5: {
                    if (!(message.PlayerBet && message.PlayerBet.length))
                        message.PlayerBet = [];
                    message.PlayerBet.push($root.PlayerTotalBetForRummy.decode(reader, reader.uint32()));
                    break;
                }
            case 6: {
                    if (!(message.PublicCard && message.PublicCard.length))
                        message.PublicCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PublicCard.push(reader.uint32());
                    } else
                        message.PublicCard.push(reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.FoldPlayerIDs && message.FoldPlayerIDs.length))
                        message.FoldPlayerIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.FoldPlayerIDs.push(reader.uint32());
                    } else
                        message.FoldPlayerIDs.push(reader.uint32());
                    break;
                }
            case 9: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 10: {
                    message.MagicCard = reader.uint32();
                    break;
                }
            case 11: {
                    message.CardLeftCnt = reader.uint32();
                    break;
                }
            case 12: {
                    message.BootInfo = reader.string();
                    break;
                }
            case 13: {
                    message.CurSeatNo = reader.int32();
                    break;
                }
            case 14: {
                    message.IsDeclared = reader.bool();
                    break;
                }
            case 15: {
                    if (!(message.CardList1 && message.CardList1.length))
                        message.CardList1 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList1.push(reader.uint32());
                    } else
                        message.CardList1.push(reader.uint32());
                    break;
                }
            case 16: {
                    if (!(message.CardList2 && message.CardList2.length))
                        message.CardList2 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList2.push(reader.uint32());
                    } else
                        message.CardList2.push(reader.uint32());
                    break;
                }
            case 17: {
                    if (!(message.CardList3 && message.CardList3.length))
                        message.CardList3 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList3.push(reader.uint32());
                    } else
                        message.CardList3.push(reader.uint32());
                    break;
                }
            case 18: {
                    if (!(message.CardList4 && message.CardList4.length))
                        message.CardList4 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList4.push(reader.uint32());
                    } else
                        message.CardList4.push(reader.uint32());
                    break;
                }
            case 19: {
                    if (!(message.CardList5 && message.CardList5.length))
                        message.CardList5 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList5.push(reader.uint32());
                    } else
                        message.CardList5.push(reader.uint32());
                    break;
                }
            case 20: {
                    if (!(message.PlayerResult && message.PlayerResult.length))
                        message.PlayerResult = [];
                    message.PlayerResult.push($root.PlayerResultForRummy.decode(reader, reader.uint32()));
                    break;
                }
            case 21: {
                    message.ShowCard = reader.uint32();
                    break;
                }
            case 22: {
                    message.WinnerId = reader.int32();
                    break;
                }
            case 23: {
                    if (!(message.FireHu && message.FireHu.length))
                        message.FireHu = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.FireHu.push(reader.uint32());
                    } else
                        message.FireHu.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushPlayingInfo} RummySrvToDeskPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushPlayingInfo message.
     * @function verify
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.PlayerBet != null && message.hasOwnProperty("PlayerBet")) {
            if (!Array.isArray(message.PlayerBet))
                return "PlayerBet: array expected";
            for (let i = 0; i < message.PlayerBet.length; ++i) {
                let error = $root.PlayerTotalBetForRummy.verify(message.PlayerBet[i]);
                if (error)
                    return "PlayerBet." + error;
            }
        }
        if (message.PublicCard != null && message.hasOwnProperty("PublicCard")) {
            if (!Array.isArray(message.PublicCard))
                return "PublicCard: array expected";
            for (let i = 0; i < message.PublicCard.length; ++i)
                if (!$util.isInteger(message.PublicCard[i]))
                    return "PublicCard: integer[] expected";
        }
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        if (message.FoldPlayerIDs != null && message.hasOwnProperty("FoldPlayerIDs")) {
            if (!Array.isArray(message.FoldPlayerIDs))
                return "FoldPlayerIDs: array expected";
            for (let i = 0; i < message.FoldPlayerIDs.length; ++i)
                if (!$util.isInteger(message.FoldPlayerIDs[i]))
                    return "FoldPlayerIDs: integer[] expected";
        }
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.MagicCard != null && message.hasOwnProperty("MagicCard"))
            if (!$util.isInteger(message.MagicCard))
                return "MagicCard: integer expected";
        if (message.CardLeftCnt != null && message.hasOwnProperty("CardLeftCnt"))
            if (!$util.isInteger(message.CardLeftCnt))
                return "CardLeftCnt: integer expected";
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            if (!$util.isString(message.BootInfo))
                return "BootInfo: string expected";
        if (message.CurSeatNo != null && message.hasOwnProperty("CurSeatNo"))
            if (!$util.isInteger(message.CurSeatNo))
                return "CurSeatNo: integer expected";
        if (message.IsDeclared != null && message.hasOwnProperty("IsDeclared"))
            if (typeof message.IsDeclared !== "boolean")
                return "IsDeclared: boolean expected";
        if (message.CardList1 != null && message.hasOwnProperty("CardList1")) {
            if (!Array.isArray(message.CardList1))
                return "CardList1: array expected";
            for (let i = 0; i < message.CardList1.length; ++i)
                if (!$util.isInteger(message.CardList1[i]))
                    return "CardList1: integer[] expected";
        }
        if (message.CardList2 != null && message.hasOwnProperty("CardList2")) {
            if (!Array.isArray(message.CardList2))
                return "CardList2: array expected";
            for (let i = 0; i < message.CardList2.length; ++i)
                if (!$util.isInteger(message.CardList2[i]))
                    return "CardList2: integer[] expected";
        }
        if (message.CardList3 != null && message.hasOwnProperty("CardList3")) {
            if (!Array.isArray(message.CardList3))
                return "CardList3: array expected";
            for (let i = 0; i < message.CardList3.length; ++i)
                if (!$util.isInteger(message.CardList3[i]))
                    return "CardList3: integer[] expected";
        }
        if (message.CardList4 != null && message.hasOwnProperty("CardList4")) {
            if (!Array.isArray(message.CardList4))
                return "CardList4: array expected";
            for (let i = 0; i < message.CardList4.length; ++i)
                if (!$util.isInteger(message.CardList4[i]))
                    return "CardList4: integer[] expected";
        }
        if (message.CardList5 != null && message.hasOwnProperty("CardList5")) {
            if (!Array.isArray(message.CardList5))
                return "CardList5: array expected";
            for (let i = 0; i < message.CardList5.length; ++i)
                if (!$util.isInteger(message.CardList5[i]))
                    return "CardList5: integer[] expected";
        }
        if (message.PlayerResult != null && message.hasOwnProperty("PlayerResult")) {
            if (!Array.isArray(message.PlayerResult))
                return "PlayerResult: array expected";
            for (let i = 0; i < message.PlayerResult.length; ++i) {
                let error = $root.PlayerResultForRummy.verify(message.PlayerResult[i]);
                if (error)
                    return "PlayerResult." + error;
            }
        }
        if (message.ShowCard != null && message.hasOwnProperty("ShowCard"))
            if (!$util.isInteger(message.ShowCard))
                return "ShowCard: integer expected";
        if (message.WinnerId != null && message.hasOwnProperty("WinnerId"))
            if (!$util.isInteger(message.WinnerId))
                return "WinnerId: integer expected";
        if (message.FireHu != null && message.hasOwnProperty("FireHu")) {
            if (!Array.isArray(message.FireHu))
                return "FireHu: array expected";
            for (let i = 0; i < message.FireHu.length; ++i)
                if (!$util.isInteger(message.FireHu[i]))
                    return "FireHu: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushPlayingInfo} RummySrvToDeskPushPlayingInfo
     */
    RummySrvToDeskPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushPlayingInfo)
            return object;
        let message = new $root.RummySrvToDeskPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner | 0;
        if (object.PlayerBet) {
            if (!Array.isArray(object.PlayerBet))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.PlayerBet: array expected");
            message.PlayerBet = [];
            for (let i = 0; i < object.PlayerBet.length; ++i) {
                if (typeof object.PlayerBet[i] !== "object")
                    throw TypeError(".RummySrvToDeskPushPlayingInfo.PlayerBet: object expected");
                message.PlayerBet[i] = $root.PlayerTotalBetForRummy.fromObject(object.PlayerBet[i]);
            }
        }
        if (object.PublicCard) {
            if (!Array.isArray(object.PublicCard))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.PublicCard: array expected");
            message.PublicCard = [];
            for (let i = 0; i < object.PublicCard.length; ++i)
                message.PublicCard[i] = object.PublicCard[i] >>> 0;
        }
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        if (object.FoldPlayerIDs) {
            if (!Array.isArray(object.FoldPlayerIDs))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.FoldPlayerIDs: array expected");
            message.FoldPlayerIDs = [];
            for (let i = 0; i < object.FoldPlayerIDs.length; ++i)
                message.FoldPlayerIDs[i] = object.FoldPlayerIDs[i] >>> 0;
        }
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.MagicCard != null)
            message.MagicCard = object.MagicCard >>> 0;
        if (object.CardLeftCnt != null)
            message.CardLeftCnt = object.CardLeftCnt >>> 0;
        if (object.BootInfo != null)
            message.BootInfo = String(object.BootInfo);
        if (object.CurSeatNo != null)
            message.CurSeatNo = object.CurSeatNo | 0;
        if (object.IsDeclared != null)
            message.IsDeclared = Boolean(object.IsDeclared);
        if (object.CardList1) {
            if (!Array.isArray(object.CardList1))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.CardList1: array expected");
            message.CardList1 = [];
            for (let i = 0; i < object.CardList1.length; ++i)
                message.CardList1[i] = object.CardList1[i] >>> 0;
        }
        if (object.CardList2) {
            if (!Array.isArray(object.CardList2))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.CardList2: array expected");
            message.CardList2 = [];
            for (let i = 0; i < object.CardList2.length; ++i)
                message.CardList2[i] = object.CardList2[i] >>> 0;
        }
        if (object.CardList3) {
            if (!Array.isArray(object.CardList3))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.CardList3: array expected");
            message.CardList3 = [];
            for (let i = 0; i < object.CardList3.length; ++i)
                message.CardList3[i] = object.CardList3[i] >>> 0;
        }
        if (object.CardList4) {
            if (!Array.isArray(object.CardList4))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.CardList4: array expected");
            message.CardList4 = [];
            for (let i = 0; i < object.CardList4.length; ++i)
                message.CardList4[i] = object.CardList4[i] >>> 0;
        }
        if (object.CardList5) {
            if (!Array.isArray(object.CardList5))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.CardList5: array expected");
            message.CardList5 = [];
            for (let i = 0; i < object.CardList5.length; ++i)
                message.CardList5[i] = object.CardList5[i] >>> 0;
        }
        if (object.PlayerResult) {
            if (!Array.isArray(object.PlayerResult))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.PlayerResult: array expected");
            message.PlayerResult = [];
            for (let i = 0; i < object.PlayerResult.length; ++i) {
                if (typeof object.PlayerResult[i] !== "object")
                    throw TypeError(".RummySrvToDeskPushPlayingInfo.PlayerResult: object expected");
                message.PlayerResult[i] = $root.PlayerResultForRummy.fromObject(object.PlayerResult[i]);
            }
        }
        if (object.ShowCard != null)
            message.ShowCard = object.ShowCard >>> 0;
        if (object.WinnerId != null)
            message.WinnerId = object.WinnerId | 0;
        if (object.FireHu) {
            if (!Array.isArray(object.FireHu))
                throw TypeError(".RummySrvToDeskPushPlayingInfo.FireHu: array expected");
            message.FireHu = [];
            for (let i = 0; i < object.FireHu.length; ++i)
                message.FireHu[i] = object.FireHu[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {RummySrvToDeskPushPlayingInfo} message RummySrvToDeskPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.PlayerBet = [];
            object.PublicCard = [];
            object.HandCard = [];
            object.FoldPlayerIDs = [];
            object.GamingIDs = [];
            object.CardList1 = [];
            object.CardList2 = [];
            object.CardList3 = [];
            object.CardList4 = [];
            object.CardList5 = [];
            object.PlayerResult = [];
            object.FireHu = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.DealerID = 0;
            object.Practitioner = 0;
            object.MagicCard = 0;
            object.CardLeftCnt = 0;
            object.BootInfo = "";
            object.CurSeatNo = 0;
            object.IsDeclared = false;
            object.ShowCard = 0;
            object.WinnerId = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.PlayerBet && message.PlayerBet.length) {
            object.PlayerBet = [];
            for (let j = 0; j < message.PlayerBet.length; ++j)
                object.PlayerBet[j] = $root.PlayerTotalBetForRummy.toObject(message.PlayerBet[j], options);
        }
        if (message.PublicCard && message.PublicCard.length) {
            object.PublicCard = [];
            for (let j = 0; j < message.PublicCard.length; ++j)
                object.PublicCard[j] = message.PublicCard[j];
        }
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        if (message.FoldPlayerIDs && message.FoldPlayerIDs.length) {
            object.FoldPlayerIDs = [];
            for (let j = 0; j < message.FoldPlayerIDs.length; ++j)
                object.FoldPlayerIDs[j] = message.FoldPlayerIDs[j];
        }
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.MagicCard != null && message.hasOwnProperty("MagicCard"))
            object.MagicCard = message.MagicCard;
        if (message.CardLeftCnt != null && message.hasOwnProperty("CardLeftCnt"))
            object.CardLeftCnt = message.CardLeftCnt;
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            object.BootInfo = message.BootInfo;
        if (message.CurSeatNo != null && message.hasOwnProperty("CurSeatNo"))
            object.CurSeatNo = message.CurSeatNo;
        if (message.IsDeclared != null && message.hasOwnProperty("IsDeclared"))
            object.IsDeclared = message.IsDeclared;
        if (message.CardList1 && message.CardList1.length) {
            object.CardList1 = [];
            for (let j = 0; j < message.CardList1.length; ++j)
                object.CardList1[j] = message.CardList1[j];
        }
        if (message.CardList2 && message.CardList2.length) {
            object.CardList2 = [];
            for (let j = 0; j < message.CardList2.length; ++j)
                object.CardList2[j] = message.CardList2[j];
        }
        if (message.CardList3 && message.CardList3.length) {
            object.CardList3 = [];
            for (let j = 0; j < message.CardList3.length; ++j)
                object.CardList3[j] = message.CardList3[j];
        }
        if (message.CardList4 && message.CardList4.length) {
            object.CardList4 = [];
            for (let j = 0; j < message.CardList4.length; ++j)
                object.CardList4[j] = message.CardList4[j];
        }
        if (message.CardList5 && message.CardList5.length) {
            object.CardList5 = [];
            for (let j = 0; j < message.CardList5.length; ++j)
                object.CardList5[j] = message.CardList5[j];
        }
        if (message.PlayerResult && message.PlayerResult.length) {
            object.PlayerResult = [];
            for (let j = 0; j < message.PlayerResult.length; ++j)
                object.PlayerResult[j] = $root.PlayerResultForRummy.toObject(message.PlayerResult[j], options);
        }
        if (message.ShowCard != null && message.hasOwnProperty("ShowCard"))
            object.ShowCard = message.ShowCard;
        if (message.WinnerId != null && message.hasOwnProperty("WinnerId"))
            object.WinnerId = message.WinnerId;
        if (message.FireHu && message.FireHu.length) {
            object.FireHu = [];
            for (let j = 0; j < message.FireHu.length; ++j)
                object.FireHu[j] = message.FireHu[j];
        }
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushPlayingInfo
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushPlayingInfo";
    };

    return RummySrvToDeskPushPlayingInfo;
})();

export const PlayerResultForRummy = $root.PlayerResultForRummy = (() => {

    /**
     * Properties of a PlayerResultForRummy.
     * @exports IPlayerResultForRummy
     * @interface IPlayerResultForRummy
     * @property {number|null} [UserID] PlayerResultForRummy UserID
     * @property {number|null} [CardsScore] PlayerResultForRummy CardsScore
     * @property {string|null} [ChangeGold] PlayerResultForRummy ChangeGold
     * @property {string|null} [TotalEnterChip] PlayerResultForRummy TotalEnterChip
     * @property {Array.<number>|null} [CardList1] PlayerResultForRummy CardList1
     * @property {Array.<number>|null} [CardList2] PlayerResultForRummy CardList2
     * @property {Array.<number>|null} [CardList3] PlayerResultForRummy CardList3
     * @property {Array.<number>|null} [CardList4] PlayerResultForRummy CardList4
     * @property {Array.<number>|null} [CardList5] PlayerResultForRummy CardList5
     * @property {Uint8Array|null} [NickName] PlayerResultForRummy NickName
     * @property {boolean|null} [BFoldUser] PlayerResultForRummy BFoldUser
     * @property {boolean|null} [WaittingUser] PlayerResultForRummy WaittingUser
     * @property {boolean|null} [IsWinner] PlayerResultForRummy IsWinner
     */

    /**
     * Constructs a new PlayerResultForRummy.
     * @exports PlayerResultForRummy
     * @classdesc Represents a PlayerResultForRummy.
     * @implements IPlayerResultForRummy
     * @constructor
     * @param {IPlayerResultForRummy=} [properties] Properties to set
     */
    function PlayerResultForRummy(properties) {
        this.CardList1 = [];
        this.CardList2 = [];
        this.CardList3 = [];
        this.CardList4 = [];
        this.CardList5 = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerResultForRummy UserID.
     * @member {number} UserID
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.UserID = 0;

    /**
     * PlayerResultForRummy CardsScore.
     * @member {number} CardsScore
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardsScore = 0;

    /**
     * PlayerResultForRummy ChangeGold.
     * @member {string} ChangeGold
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.ChangeGold = "";

    /**
     * PlayerResultForRummy TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.TotalEnterChip = "";

    /**
     * PlayerResultForRummy CardList1.
     * @member {Array.<number>} CardList1
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardList1 = $util.emptyArray;

    /**
     * PlayerResultForRummy CardList2.
     * @member {Array.<number>} CardList2
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardList2 = $util.emptyArray;

    /**
     * PlayerResultForRummy CardList3.
     * @member {Array.<number>} CardList3
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardList3 = $util.emptyArray;

    /**
     * PlayerResultForRummy CardList4.
     * @member {Array.<number>} CardList4
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardList4 = $util.emptyArray;

    /**
     * PlayerResultForRummy CardList5.
     * @member {Array.<number>} CardList5
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.CardList5 = $util.emptyArray;

    /**
     * PlayerResultForRummy NickName.
     * @member {Uint8Array} NickName
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.NickName = $util.newBuffer([]);

    /**
     * PlayerResultForRummy BFoldUser.
     * @member {boolean} BFoldUser
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.BFoldUser = false;

    /**
     * PlayerResultForRummy WaittingUser.
     * @member {boolean} WaittingUser
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.WaittingUser = false;

    /**
     * PlayerResultForRummy IsWinner.
     * @member {boolean} IsWinner
     * @memberof PlayerResultForRummy
     * @instance
     */
    PlayerResultForRummy.prototype.IsWinner = false;

    /**
     * Creates a new PlayerResultForRummy instance using the specified properties.
     * @function create
     * @memberof PlayerResultForRummy
     * @static
     * @param {IPlayerResultForRummy=} [properties] Properties to set
     * @returns {PlayerResultForRummy} PlayerResultForRummy instance
     */
    PlayerResultForRummy.create = function create(properties) {
        return new PlayerResultForRummy(properties);
    };

    /**
     * Encodes the specified PlayerResultForRummy message. Does not implicitly {@link PlayerResultForRummy.verify|verify} messages.
     * @function encode
     * @memberof PlayerResultForRummy
     * @static
     * @param {IPlayerResultForRummy} message PlayerResultForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerResultForRummy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CardsScore != null && Object.hasOwnProperty.call(message, "CardsScore"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CardsScore);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        if (message.CardList1 != null && message.CardList1.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.CardList1.length; ++i)
                writer.uint32(message.CardList1[i]);
            writer.ldelim();
        }
        if (message.CardList2 != null && message.CardList2.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.CardList2.length; ++i)
                writer.uint32(message.CardList2[i]);
            writer.ldelim();
        }
        if (message.CardList3 != null && message.CardList3.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.CardList3.length; ++i)
                writer.uint32(message.CardList3[i]);
            writer.ldelim();
        }
        if (message.CardList4 != null && message.CardList4.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.CardList4.length; ++i)
                writer.uint32(message.CardList4[i]);
            writer.ldelim();
        }
        if (message.CardList5 != null && message.CardList5.length) {
            writer.uint32(/* id 9, wireType 2 =*/74).fork();
            for (let i = 0; i < message.CardList5.length; ++i)
                writer.uint32(message.CardList5[i]);
            writer.ldelim();
        }
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.NickName);
        if (message.BFoldUser != null && Object.hasOwnProperty.call(message, "BFoldUser"))
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.BFoldUser);
        if (message.WaittingUser != null && Object.hasOwnProperty.call(message, "WaittingUser"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.WaittingUser);
        if (message.IsWinner != null && Object.hasOwnProperty.call(message, "IsWinner"))
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.IsWinner);
        return writer;
    };

    /**
     * Encodes the specified PlayerResultForRummy message, length delimited. Does not implicitly {@link PlayerResultForRummy.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerResultForRummy
     * @static
     * @param {IPlayerResultForRummy} message PlayerResultForRummy message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerResultForRummy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerResultForRummy message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerResultForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerResultForRummy} PlayerResultForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerResultForRummy.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerResultForRummy();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CardsScore = reader.uint32();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.CardList1 && message.CardList1.length))
                        message.CardList1 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList1.push(reader.uint32());
                    } else
                        message.CardList1.push(reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.CardList2 && message.CardList2.length))
                        message.CardList2 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList2.push(reader.uint32());
                    } else
                        message.CardList2.push(reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.CardList3 && message.CardList3.length))
                        message.CardList3 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList3.push(reader.uint32());
                    } else
                        message.CardList3.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.CardList4 && message.CardList4.length))
                        message.CardList4 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList4.push(reader.uint32());
                    } else
                        message.CardList4.push(reader.uint32());
                    break;
                }
            case 9: {
                    if (!(message.CardList5 && message.CardList5.length))
                        message.CardList5 = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.CardList5.push(reader.uint32());
                    } else
                        message.CardList5.push(reader.uint32());
                    break;
                }
            case 10: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 11: {
                    message.BFoldUser = reader.bool();
                    break;
                }
            case 12: {
                    message.WaittingUser = reader.bool();
                    break;
                }
            case 13: {
                    message.IsWinner = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerResultForRummy message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerResultForRummy
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerResultForRummy} PlayerResultForRummy
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerResultForRummy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerResultForRummy message.
     * @function verify
     * @memberof PlayerResultForRummy
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerResultForRummy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CardsScore != null && message.hasOwnProperty("CardsScore"))
            if (!$util.isInteger(message.CardsScore))
                return "CardsScore: integer expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        if (message.CardList1 != null && message.hasOwnProperty("CardList1")) {
            if (!Array.isArray(message.CardList1))
                return "CardList1: array expected";
            for (let i = 0; i < message.CardList1.length; ++i)
                if (!$util.isInteger(message.CardList1[i]))
                    return "CardList1: integer[] expected";
        }
        if (message.CardList2 != null && message.hasOwnProperty("CardList2")) {
            if (!Array.isArray(message.CardList2))
                return "CardList2: array expected";
            for (let i = 0; i < message.CardList2.length; ++i)
                if (!$util.isInteger(message.CardList2[i]))
                    return "CardList2: integer[] expected";
        }
        if (message.CardList3 != null && message.hasOwnProperty("CardList3")) {
            if (!Array.isArray(message.CardList3))
                return "CardList3: array expected";
            for (let i = 0; i < message.CardList3.length; ++i)
                if (!$util.isInteger(message.CardList3[i]))
                    return "CardList3: integer[] expected";
        }
        if (message.CardList4 != null && message.hasOwnProperty("CardList4")) {
            if (!Array.isArray(message.CardList4))
                return "CardList4: array expected";
            for (let i = 0; i < message.CardList4.length; ++i)
                if (!$util.isInteger(message.CardList4[i]))
                    return "CardList4: integer[] expected";
        }
        if (message.CardList5 != null && message.hasOwnProperty("CardList5")) {
            if (!Array.isArray(message.CardList5))
                return "CardList5: array expected";
            for (let i = 0; i < message.CardList5.length; ++i)
                if (!$util.isInteger(message.CardList5[i]))
                    return "CardList5: integer[] expected";
        }
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.BFoldUser != null && message.hasOwnProperty("BFoldUser"))
            if (typeof message.BFoldUser !== "boolean")
                return "BFoldUser: boolean expected";
        if (message.WaittingUser != null && message.hasOwnProperty("WaittingUser"))
            if (typeof message.WaittingUser !== "boolean")
                return "WaittingUser: boolean expected";
        if (message.IsWinner != null && message.hasOwnProperty("IsWinner"))
            if (typeof message.IsWinner !== "boolean")
                return "IsWinner: boolean expected";
        return null;
    };

    /**
     * Creates a PlayerResultForRummy message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerResultForRummy
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerResultForRummy} PlayerResultForRummy
     */
    PlayerResultForRummy.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerResultForRummy)
            return object;
        let message = new $root.PlayerResultForRummy();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CardsScore != null)
            message.CardsScore = object.CardsScore >>> 0;
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        if (object.CardList1) {
            if (!Array.isArray(object.CardList1))
                throw TypeError(".PlayerResultForRummy.CardList1: array expected");
            message.CardList1 = [];
            for (let i = 0; i < object.CardList1.length; ++i)
                message.CardList1[i] = object.CardList1[i] >>> 0;
        }
        if (object.CardList2) {
            if (!Array.isArray(object.CardList2))
                throw TypeError(".PlayerResultForRummy.CardList2: array expected");
            message.CardList2 = [];
            for (let i = 0; i < object.CardList2.length; ++i)
                message.CardList2[i] = object.CardList2[i] >>> 0;
        }
        if (object.CardList3) {
            if (!Array.isArray(object.CardList3))
                throw TypeError(".PlayerResultForRummy.CardList3: array expected");
            message.CardList3 = [];
            for (let i = 0; i < object.CardList3.length; ++i)
                message.CardList3[i] = object.CardList3[i] >>> 0;
        }
        if (object.CardList4) {
            if (!Array.isArray(object.CardList4))
                throw TypeError(".PlayerResultForRummy.CardList4: array expected");
            message.CardList4 = [];
            for (let i = 0; i < object.CardList4.length; ++i)
                message.CardList4[i] = object.CardList4[i] >>> 0;
        }
        if (object.CardList5) {
            if (!Array.isArray(object.CardList5))
                throw TypeError(".PlayerResultForRummy.CardList5: array expected");
            message.CardList5 = [];
            for (let i = 0; i < object.CardList5.length; ++i)
                message.CardList5[i] = object.CardList5[i] >>> 0;
        }
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.BFoldUser != null)
            message.BFoldUser = Boolean(object.BFoldUser);
        if (object.WaittingUser != null)
            message.WaittingUser = Boolean(object.WaittingUser);
        if (object.IsWinner != null)
            message.IsWinner = Boolean(object.IsWinner);
        return message;
    };

    /**
     * Creates a plain object from a PlayerResultForRummy message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerResultForRummy
     * @static
     * @param {PlayerResultForRummy} message PlayerResultForRummy
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerResultForRummy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.CardList1 = [];
            object.CardList2 = [];
            object.CardList3 = [];
            object.CardList4 = [];
            object.CardList5 = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.CardsScore = 0;
            object.ChangeGold = "";
            object.TotalEnterChip = "";
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.BFoldUser = false;
            object.WaittingUser = false;
            object.IsWinner = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CardsScore != null && message.hasOwnProperty("CardsScore"))
            object.CardsScore = message.CardsScore;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        if (message.CardList1 && message.CardList1.length) {
            object.CardList1 = [];
            for (let j = 0; j < message.CardList1.length; ++j)
                object.CardList1[j] = message.CardList1[j];
        }
        if (message.CardList2 && message.CardList2.length) {
            object.CardList2 = [];
            for (let j = 0; j < message.CardList2.length; ++j)
                object.CardList2[j] = message.CardList2[j];
        }
        if (message.CardList3 && message.CardList3.length) {
            object.CardList3 = [];
            for (let j = 0; j < message.CardList3.length; ++j)
                object.CardList3[j] = message.CardList3[j];
        }
        if (message.CardList4 && message.CardList4.length) {
            object.CardList4 = [];
            for (let j = 0; j < message.CardList4.length; ++j)
                object.CardList4[j] = message.CardList4[j];
        }
        if (message.CardList5 && message.CardList5.length) {
            object.CardList5 = [];
            for (let j = 0; j < message.CardList5.length; ++j)
                object.CardList5[j] = message.CardList5[j];
        }
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.BFoldUser != null && message.hasOwnProperty("BFoldUser"))
            object.BFoldUser = message.BFoldUser;
        if (message.WaittingUser != null && message.hasOwnProperty("WaittingUser"))
            object.WaittingUser = message.WaittingUser;
        if (message.IsWinner != null && message.hasOwnProperty("IsWinner"))
            object.IsWinner = message.IsWinner;
        return object;
    };

    /**
     * Converts this PlayerResultForRummy to JSON.
     * @function toJSON
     * @memberof PlayerResultForRummy
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerResultForRummy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerResultForRummy
     * @function getTypeUrl
     * @memberof PlayerResultForRummy
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerResultForRummy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerResultForRummy";
    };

    return PlayerResultForRummy;
})();

export const RummySrvToDeskPushGameResult = $root.RummySrvToDeskPushGameResult = (() => {

    /**
     * Properties of a RummySrvToDeskPushGameResult.
     * @exports IRummySrvToDeskPushGameResult
     * @interface IRummySrvToDeskPushGameResult
     * @property {number|null} [UserID] RummySrvToDeskPushGameResult UserID
     * @property {Array.<IPlayerResultForRummy>|null} [GoldResult] RummySrvToDeskPushGameResult GoldResult
     */

    /**
     * Constructs a new RummySrvToDeskPushGameResult.
     * @exports RummySrvToDeskPushGameResult
     * @classdesc Represents a RummySrvToDeskPushGameResult.
     * @implements IRummySrvToDeskPushGameResult
     * @constructor
     * @param {IRummySrvToDeskPushGameResult=} [properties] Properties to set
     */
    function RummySrvToDeskPushGameResult(properties) {
        this.GoldResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushGameResult UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushGameResult
     * @instance
     */
    RummySrvToDeskPushGameResult.prototype.UserID = 0;

    /**
     * RummySrvToDeskPushGameResult GoldResult.
     * @member {Array.<IPlayerResultForRummy>} GoldResult
     * @memberof RummySrvToDeskPushGameResult
     * @instance
     */
    RummySrvToDeskPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Creates a new RummySrvToDeskPushGameResult instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {IRummySrvToDeskPushGameResult=} [properties] Properties to set
     * @returns {RummySrvToDeskPushGameResult} RummySrvToDeskPushGameResult instance
     */
    RummySrvToDeskPushGameResult.create = function create(properties) {
        return new RummySrvToDeskPushGameResult(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushGameResult message. Does not implicitly {@link RummySrvToDeskPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {IRummySrvToDeskPushGameResult} message RummySrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.PlayerResultForRummy.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushGameResult message, length delimited. Does not implicitly {@link RummySrvToDeskPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {IRummySrvToDeskPushGameResult} message RummySrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushGameResult} RummySrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.PlayerResultForRummy.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushGameResult} RummySrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushGameResult message.
     * @function verify
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.PlayerResultForRummy.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushGameResult} RummySrvToDeskPushGameResult
     */
    RummySrvToDeskPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushGameResult)
            return object;
        let message = new $root.RummySrvToDeskPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".RummySrvToDeskPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".RummySrvToDeskPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.PlayerResultForRummy.fromObject(object.GoldResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {RummySrvToDeskPushGameResult} message RummySrvToDeskPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GoldResult = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.PlayerResultForRummy.toObject(message.GoldResult[j], options);
        }
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushGameResult to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushGameResult
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushGameResult";
    };

    return RummySrvToDeskPushGameResult;
})();

export const RummySrvToDeskPushAssetInfo = $root.RummySrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a RummySrvToDeskPushAssetInfo.
     * @exports IRummySrvToDeskPushAssetInfo
     * @interface IRummySrvToDeskPushAssetInfo
     * @property {number|null} [Reason] RummySrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] RummySrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] RummySrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] RummySrvToDeskPushAssetInfo Chip
     * @property {string|null} [EnterChip] RummySrvToDeskPushAssetInfo EnterChip
     * @property {string|null} [BootInfo] RummySrvToDeskPushAssetInfo BootInfo
     */

    /**
     * Constructs a new RummySrvToDeskPushAssetInfo.
     * @exports RummySrvToDeskPushAssetInfo
     * @classdesc Represents a RummySrvToDeskPushAssetInfo.
     * @implements IRummySrvToDeskPushAssetInfo
     * @constructor
     * @param {IRummySrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function RummySrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * RummySrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * RummySrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * RummySrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * RummySrvToDeskPushAssetInfo EnterChip.
     * @member {string} EnterChip
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.EnterChip = "";

    /**
     * RummySrvToDeskPushAssetInfo BootInfo.
     * @member {string} BootInfo
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     */
    RummySrvToDeskPushAssetInfo.prototype.BootInfo = "";

    /**
     * Creates a new RummySrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {IRummySrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {RummySrvToDeskPushAssetInfo} RummySrvToDeskPushAssetInfo instance
     */
    RummySrvToDeskPushAssetInfo.create = function create(properties) {
        return new RummySrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushAssetInfo message. Does not implicitly {@link RummySrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {IRummySrvToDeskPushAssetInfo} message RummySrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.EnterChip != null && Object.hasOwnProperty.call(message, "EnterChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.EnterChip);
        if (message.BootInfo != null && Object.hasOwnProperty.call(message, "BootInfo"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.BootInfo);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link RummySrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {IRummySrvToDeskPushAssetInfo} message RummySrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushAssetInfo} RummySrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.EnterChip = reader.string();
                    break;
                }
            case 6: {
                    message.BootInfo = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushAssetInfo} RummySrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            if (!$util.isString(message.EnterChip))
                return "EnterChip: string expected";
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            if (!$util.isString(message.BootInfo))
                return "BootInfo: string expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushAssetInfo} RummySrvToDeskPushAssetInfo
     */
    RummySrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushAssetInfo)
            return object;
        let message = new $root.RummySrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.EnterChip != null)
            message.EnterChip = String(object.EnterChip);
        if (object.BootInfo != null)
            message.BootInfo = String(object.BootInfo);
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {RummySrvToDeskPushAssetInfo} message RummySrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
            object.EnterChip = "";
            object.BootInfo = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            object.EnterChip = message.EnterChip;
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            object.BootInfo = message.BootInfo;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushAssetInfo";
    };

    return RummySrvToDeskPushAssetInfo;
})();

export const RummyPoolSrvToDeskPushAssetInfo = $root.RummyPoolSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a RummyPoolSrvToDeskPushAssetInfo.
     * @exports IRummyPoolSrvToDeskPushAssetInfo
     * @interface IRummyPoolSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] RummyPoolSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] RummyPoolSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] RummyPoolSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] RummyPoolSrvToDeskPushAssetInfo Chip
     * @property {string|null} [EnterChip] RummyPoolSrvToDeskPushAssetInfo EnterChip
     * @property {string|null} [BootInfo] RummyPoolSrvToDeskPushAssetInfo BootInfo
     * @property {number|null} [UserScore] RummyPoolSrvToDeskPushAssetInfo UserScore
     */

    /**
     * Constructs a new RummyPoolSrvToDeskPushAssetInfo.
     * @exports RummyPoolSrvToDeskPushAssetInfo
     * @classdesc Represents a RummyPoolSrvToDeskPushAssetInfo.
     * @implements IRummyPoolSrvToDeskPushAssetInfo
     * @constructor
     * @param {IRummyPoolSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function RummyPoolSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * RummyPoolSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * RummyPoolSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * RummyPoolSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * RummyPoolSrvToDeskPushAssetInfo EnterChip.
     * @member {string} EnterChip
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.EnterChip = "";

    /**
     * RummyPoolSrvToDeskPushAssetInfo BootInfo.
     * @member {string} BootInfo
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.BootInfo = "";

    /**
     * RummyPoolSrvToDeskPushAssetInfo UserScore.
     * @member {number} UserScore
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.UserScore = 0;

    /**
     * Creates a new RummyPoolSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {RummyPoolSrvToDeskPushAssetInfo} RummyPoolSrvToDeskPushAssetInfo instance
     */
    RummyPoolSrvToDeskPushAssetInfo.create = function create(properties) {
        return new RummyPoolSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushAssetInfo message. Does not implicitly {@link RummyPoolSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushAssetInfo} message RummyPoolSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.EnterChip != null && Object.hasOwnProperty.call(message, "EnterChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.EnterChip);
        if (message.BootInfo != null && Object.hasOwnProperty.call(message, "BootInfo"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.BootInfo);
        if (message.UserScore != null && Object.hasOwnProperty.call(message, "UserScore"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.UserScore);
        return writer;
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link RummyPoolSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushAssetInfo} message RummyPoolSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolSrvToDeskPushAssetInfo} RummyPoolSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.EnterChip = reader.string();
                    break;
                }
            case 6: {
                    message.BootInfo = reader.string();
                    break;
                }
            case 7: {
                    message.UserScore = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolSrvToDeskPushAssetInfo} RummyPoolSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            if (!$util.isString(message.EnterChip))
                return "EnterChip: string expected";
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            if (!$util.isString(message.BootInfo))
                return "BootInfo: string expected";
        if (message.UserScore != null && message.hasOwnProperty("UserScore"))
            if (!$util.isInteger(message.UserScore))
                return "UserScore: integer expected";
        return null;
    };

    /**
     * Creates a RummyPoolSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolSrvToDeskPushAssetInfo} RummyPoolSrvToDeskPushAssetInfo
     */
    RummyPoolSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.RummyPoolSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.EnterChip != null)
            message.EnterChip = String(object.EnterChip);
        if (object.BootInfo != null)
            message.BootInfo = String(object.BootInfo);
        if (object.UserScore != null)
            message.UserScore = object.UserScore | 0;
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {RummyPoolSrvToDeskPushAssetInfo} message RummyPoolSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
            object.EnterChip = "";
            object.BootInfo = "";
            object.UserScore = 0;
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            object.EnterChip = message.EnterChip;
        if (message.BootInfo != null && message.hasOwnProperty("BootInfo"))
            object.BootInfo = message.BootInfo;
        if (message.UserScore != null && message.hasOwnProperty("UserScore"))
            object.UserScore = message.UserScore;
        return object;
    };

    /**
     * Converts this RummyPoolSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof RummyPoolSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolSrvToDeskPushAssetInfo";
    };

    return RummyPoolSrvToDeskPushAssetInfo;
})();

export const RummyPoolSrvToDeskPushRuleInfo = $root.RummyPoolSrvToDeskPushRuleInfo = (() => {

    /**
     * Properties of a RummyPoolSrvToDeskPushRuleInfo.
     * @exports IRummyPoolSrvToDeskPushRuleInfo
     * @interface IRummyPoolSrvToDeskPushRuleInfo
     * @property {number|null} [PoolType] RummyPoolSrvToDeskPushRuleInfo PoolType
     * @property {number|null} [UserID] RummyPoolSrvToDeskPushRuleInfo UserID
     * @property {number|null} [CurRound] RummyPoolSrvToDeskPushRuleInfo CurRound
     * @property {string|null} [EnterChip] RummyPoolSrvToDeskPushRuleInfo EnterChip
     * @property {string|null} [Bonus] RummyPoolSrvToDeskPushRuleInfo Bonus
     */

    /**
     * Constructs a new RummyPoolSrvToDeskPushRuleInfo.
     * @exports RummyPoolSrvToDeskPushRuleInfo
     * @classdesc Represents a RummyPoolSrvToDeskPushRuleInfo.
     * @implements IRummyPoolSrvToDeskPushRuleInfo
     * @constructor
     * @param {IRummyPoolSrvToDeskPushRuleInfo=} [properties] Properties to set
     */
    function RummyPoolSrvToDeskPushRuleInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolSrvToDeskPushRuleInfo PoolType.
     * @member {number} PoolType
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.PoolType = 0;

    /**
     * RummyPoolSrvToDeskPushRuleInfo UserID.
     * @member {number} UserID
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.UserID = 0;

    /**
     * RummyPoolSrvToDeskPushRuleInfo CurRound.
     * @member {number} CurRound
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.CurRound = 0;

    /**
     * RummyPoolSrvToDeskPushRuleInfo EnterChip.
     * @member {string} EnterChip
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.EnterChip = "";

    /**
     * RummyPoolSrvToDeskPushRuleInfo Bonus.
     * @member {string} Bonus
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.Bonus = "";

    /**
     * Creates a new RummyPoolSrvToDeskPushRuleInfo instance using the specified properties.
     * @function create
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRuleInfo=} [properties] Properties to set
     * @returns {RummyPoolSrvToDeskPushRuleInfo} RummyPoolSrvToDeskPushRuleInfo instance
     */
    RummyPoolSrvToDeskPushRuleInfo.create = function create(properties) {
        return new RummyPoolSrvToDeskPushRuleInfo(properties);
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushRuleInfo message. Does not implicitly {@link RummyPoolSrvToDeskPushRuleInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRuleInfo} message RummyPoolSrvToDeskPushRuleInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushRuleInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PoolType != null && Object.hasOwnProperty.call(message, "PoolType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.PoolType);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.CurRound != null && Object.hasOwnProperty.call(message, "CurRound"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.CurRound);
        if (message.EnterChip != null && Object.hasOwnProperty.call(message, "EnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.EnterChip);
        if (message.Bonus != null && Object.hasOwnProperty.call(message, "Bonus"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Bonus);
        return writer;
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushRuleInfo message, length delimited. Does not implicitly {@link RummyPoolSrvToDeskPushRuleInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRuleInfo} message RummyPoolSrvToDeskPushRuleInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushRuleInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushRuleInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolSrvToDeskPushRuleInfo} RummyPoolSrvToDeskPushRuleInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushRuleInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolSrvToDeskPushRuleInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PoolType = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.CurRound = reader.int32();
                    break;
                }
            case 4: {
                    message.EnterChip = reader.string();
                    break;
                }
            case 5: {
                    message.Bonus = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushRuleInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolSrvToDeskPushRuleInfo} RummyPoolSrvToDeskPushRuleInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushRuleInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolSrvToDeskPushRuleInfo message.
     * @function verify
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolSrvToDeskPushRuleInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PoolType != null && message.hasOwnProperty("PoolType"))
            if (!$util.isInteger(message.PoolType))
                return "PoolType: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CurRound != null && message.hasOwnProperty("CurRound"))
            if (!$util.isInteger(message.CurRound))
                return "CurRound: integer expected";
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            if (!$util.isString(message.EnterChip))
                return "EnterChip: string expected";
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            if (!$util.isString(message.Bonus))
                return "Bonus: string expected";
        return null;
    };

    /**
     * Creates a RummyPoolSrvToDeskPushRuleInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolSrvToDeskPushRuleInfo} RummyPoolSrvToDeskPushRuleInfo
     */
    RummyPoolSrvToDeskPushRuleInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolSrvToDeskPushRuleInfo)
            return object;
        let message = new $root.RummyPoolSrvToDeskPushRuleInfo();
        if (object.PoolType != null)
            message.PoolType = object.PoolType | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CurRound != null)
            message.CurRound = object.CurRound | 0;
        if (object.EnterChip != null)
            message.EnterChip = String(object.EnterChip);
        if (object.Bonus != null)
            message.Bonus = String(object.Bonus);
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolSrvToDeskPushRuleInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {RummyPoolSrvToDeskPushRuleInfo} message RummyPoolSrvToDeskPushRuleInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolSrvToDeskPushRuleInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PoolType = 0;
            object.UserID = 0;
            object.CurRound = 0;
            object.EnterChip = "";
            object.Bonus = "";
        }
        if (message.PoolType != null && message.hasOwnProperty("PoolType"))
            object.PoolType = message.PoolType;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CurRound != null && message.hasOwnProperty("CurRound"))
            object.CurRound = message.CurRound;
        if (message.EnterChip != null && message.hasOwnProperty("EnterChip"))
            object.EnterChip = message.EnterChip;
        if (message.Bonus != null && message.hasOwnProperty("Bonus"))
            object.Bonus = message.Bonus;
        return object;
    };

    /**
     * Converts this RummyPoolSrvToDeskPushRuleInfo to JSON.
     * @function toJSON
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolSrvToDeskPushRuleInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolSrvToDeskPushRuleInfo
     * @function getTypeUrl
     * @memberof RummyPoolSrvToDeskPushRuleInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolSrvToDeskPushRuleInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolSrvToDeskPushRuleInfo";
    };

    return RummyPoolSrvToDeskPushRuleInfo;
})();

export const RummyPoolShowRoundScore = $root.RummyPoolShowRoundScore = (() => {

    /**
     * Properties of a RummyPoolShowRoundScore.
     * @exports IRummyPoolShowRoundScore
     * @interface IRummyPoolShowRoundScore
     * @property {number|null} [UserID] RummyPoolShowRoundScore UserID
     * @property {number|null} [WinScore] RummyPoolShowRoundScore WinScore
     * @property {boolean|null} [IsOut] RummyPoolShowRoundScore IsOut
     * @property {boolean|null} [IsShow] RummyPoolShowRoundScore IsShow
     */

    /**
     * Constructs a new RummyPoolShowRoundScore.
     * @exports RummyPoolShowRoundScore
     * @classdesc Represents a RummyPoolShowRoundScore.
     * @implements IRummyPoolShowRoundScore
     * @constructor
     * @param {IRummyPoolShowRoundScore=} [properties] Properties to set
     */
    function RummyPoolShowRoundScore(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolShowRoundScore UserID.
     * @member {number} UserID
     * @memberof RummyPoolShowRoundScore
     * @instance
     */
    RummyPoolShowRoundScore.prototype.UserID = 0;

    /**
     * RummyPoolShowRoundScore WinScore.
     * @member {number} WinScore
     * @memberof RummyPoolShowRoundScore
     * @instance
     */
    RummyPoolShowRoundScore.prototype.WinScore = 0;

    /**
     * RummyPoolShowRoundScore IsOut.
     * @member {boolean} IsOut
     * @memberof RummyPoolShowRoundScore
     * @instance
     */
    RummyPoolShowRoundScore.prototype.IsOut = false;

    /**
     * RummyPoolShowRoundScore IsShow.
     * @member {boolean} IsShow
     * @memberof RummyPoolShowRoundScore
     * @instance
     */
    RummyPoolShowRoundScore.prototype.IsShow = false;

    /**
     * Creates a new RummyPoolShowRoundScore instance using the specified properties.
     * @function create
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {IRummyPoolShowRoundScore=} [properties] Properties to set
     * @returns {RummyPoolShowRoundScore} RummyPoolShowRoundScore instance
     */
    RummyPoolShowRoundScore.create = function create(properties) {
        return new RummyPoolShowRoundScore(properties);
    };

    /**
     * Encodes the specified RummyPoolShowRoundScore message. Does not implicitly {@link RummyPoolShowRoundScore.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {IRummyPoolShowRoundScore} message RummyPoolShowRoundScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolShowRoundScore.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinScore != null && Object.hasOwnProperty.call(message, "WinScore"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.WinScore);
        if (message.IsOut != null && Object.hasOwnProperty.call(message, "IsOut"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsOut);
        if (message.IsShow != null && Object.hasOwnProperty.call(message, "IsShow"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.IsShow);
        return writer;
    };

    /**
     * Encodes the specified RummyPoolShowRoundScore message, length delimited. Does not implicitly {@link RummyPoolShowRoundScore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {IRummyPoolShowRoundScore} message RummyPoolShowRoundScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolShowRoundScore.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolShowRoundScore message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolShowRoundScore} RummyPoolShowRoundScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolShowRoundScore.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolShowRoundScore();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinScore = reader.int32();
                    break;
                }
            case 3: {
                    message.IsOut = reader.bool();
                    break;
                }
            case 4: {
                    message.IsShow = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolShowRoundScore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolShowRoundScore} RummyPoolShowRoundScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolShowRoundScore.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolShowRoundScore message.
     * @function verify
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolShowRoundScore.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinScore != null && message.hasOwnProperty("WinScore"))
            if (!$util.isInteger(message.WinScore))
                return "WinScore: integer expected";
        if (message.IsOut != null && message.hasOwnProperty("IsOut"))
            if (typeof message.IsOut !== "boolean")
                return "IsOut: boolean expected";
        if (message.IsShow != null && message.hasOwnProperty("IsShow"))
            if (typeof message.IsShow !== "boolean")
                return "IsShow: boolean expected";
        return null;
    };

    /**
     * Creates a RummyPoolShowRoundScore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolShowRoundScore} RummyPoolShowRoundScore
     */
    RummyPoolShowRoundScore.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolShowRoundScore)
            return object;
        let message = new $root.RummyPoolShowRoundScore();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinScore != null)
            message.WinScore = object.WinScore | 0;
        if (object.IsOut != null)
            message.IsOut = Boolean(object.IsOut);
        if (object.IsShow != null)
            message.IsShow = Boolean(object.IsShow);
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolShowRoundScore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {RummyPoolShowRoundScore} message RummyPoolShowRoundScore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolShowRoundScore.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.WinScore = 0;
            object.IsOut = false;
            object.IsShow = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinScore != null && message.hasOwnProperty("WinScore"))
            object.WinScore = message.WinScore;
        if (message.IsOut != null && message.hasOwnProperty("IsOut"))
            object.IsOut = message.IsOut;
        if (message.IsShow != null && message.hasOwnProperty("IsShow"))
            object.IsShow = message.IsShow;
        return object;
    };

    /**
     * Converts this RummyPoolShowRoundScore to JSON.
     * @function toJSON
     * @memberof RummyPoolShowRoundScore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolShowRoundScore.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolShowRoundScore
     * @function getTypeUrl
     * @memberof RummyPoolShowRoundScore
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolShowRoundScore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolShowRoundScore";
    };

    return RummyPoolShowRoundScore;
})();

export const RummyPoolPlayerRoundInfo = $root.RummyPoolPlayerRoundInfo = (() => {

    /**
     * Properties of a RummyPoolPlayerRoundInfo.
     * @exports IRummyPoolPlayerRoundInfo
     * @interface IRummyPoolPlayerRoundInfo
     * @property {number|null} [RoundIndex] RummyPoolPlayerRoundInfo RoundIndex
     * @property {Array.<IRummyPoolShowRoundScore>|null} [ShowInfo] RummyPoolPlayerRoundInfo ShowInfo
     */

    /**
     * Constructs a new RummyPoolPlayerRoundInfo.
     * @exports RummyPoolPlayerRoundInfo
     * @classdesc Represents a RummyPoolPlayerRoundInfo.
     * @implements IRummyPoolPlayerRoundInfo
     * @constructor
     * @param {IRummyPoolPlayerRoundInfo=} [properties] Properties to set
     */
    function RummyPoolPlayerRoundInfo(properties) {
        this.ShowInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolPlayerRoundInfo RoundIndex.
     * @member {number} RoundIndex
     * @memberof RummyPoolPlayerRoundInfo
     * @instance
     */
    RummyPoolPlayerRoundInfo.prototype.RoundIndex = 0;

    /**
     * RummyPoolPlayerRoundInfo ShowInfo.
     * @member {Array.<IRummyPoolShowRoundScore>} ShowInfo
     * @memberof RummyPoolPlayerRoundInfo
     * @instance
     */
    RummyPoolPlayerRoundInfo.prototype.ShowInfo = $util.emptyArray;

    /**
     * Creates a new RummyPoolPlayerRoundInfo instance using the specified properties.
     * @function create
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {IRummyPoolPlayerRoundInfo=} [properties] Properties to set
     * @returns {RummyPoolPlayerRoundInfo} RummyPoolPlayerRoundInfo instance
     */
    RummyPoolPlayerRoundInfo.create = function create(properties) {
        return new RummyPoolPlayerRoundInfo(properties);
    };

    /**
     * Encodes the specified RummyPoolPlayerRoundInfo message. Does not implicitly {@link RummyPoolPlayerRoundInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {IRummyPoolPlayerRoundInfo} message RummyPoolPlayerRoundInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolPlayerRoundInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RoundIndex != null && Object.hasOwnProperty.call(message, "RoundIndex"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.RoundIndex);
        if (message.ShowInfo != null && message.ShowInfo.length)
            for (let i = 0; i < message.ShowInfo.length; ++i)
                $root.RummyPoolShowRoundScore.encode(message.ShowInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyPoolPlayerRoundInfo message, length delimited. Does not implicitly {@link RummyPoolPlayerRoundInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {IRummyPoolPlayerRoundInfo} message RummyPoolPlayerRoundInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolPlayerRoundInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolPlayerRoundInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolPlayerRoundInfo} RummyPoolPlayerRoundInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolPlayerRoundInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolPlayerRoundInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.RoundIndex = reader.int32();
                    break;
                }
            case 2: {
                    if (!(message.ShowInfo && message.ShowInfo.length))
                        message.ShowInfo = [];
                    message.ShowInfo.push($root.RummyPoolShowRoundScore.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolPlayerRoundInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolPlayerRoundInfo} RummyPoolPlayerRoundInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolPlayerRoundInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolPlayerRoundInfo message.
     * @function verify
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolPlayerRoundInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RoundIndex != null && message.hasOwnProperty("RoundIndex"))
            if (!$util.isInteger(message.RoundIndex))
                return "RoundIndex: integer expected";
        if (message.ShowInfo != null && message.hasOwnProperty("ShowInfo")) {
            if (!Array.isArray(message.ShowInfo))
                return "ShowInfo: array expected";
            for (let i = 0; i < message.ShowInfo.length; ++i) {
                let error = $root.RummyPoolShowRoundScore.verify(message.ShowInfo[i]);
                if (error)
                    return "ShowInfo." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyPoolPlayerRoundInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolPlayerRoundInfo} RummyPoolPlayerRoundInfo
     */
    RummyPoolPlayerRoundInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolPlayerRoundInfo)
            return object;
        let message = new $root.RummyPoolPlayerRoundInfo();
        if (object.RoundIndex != null)
            message.RoundIndex = object.RoundIndex | 0;
        if (object.ShowInfo) {
            if (!Array.isArray(object.ShowInfo))
                throw TypeError(".RummyPoolPlayerRoundInfo.ShowInfo: array expected");
            message.ShowInfo = [];
            for (let i = 0; i < object.ShowInfo.length; ++i) {
                if (typeof object.ShowInfo[i] !== "object")
                    throw TypeError(".RummyPoolPlayerRoundInfo.ShowInfo: object expected");
                message.ShowInfo[i] = $root.RummyPoolShowRoundScore.fromObject(object.ShowInfo[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolPlayerRoundInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {RummyPoolPlayerRoundInfo} message RummyPoolPlayerRoundInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolPlayerRoundInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ShowInfo = [];
        if (options.defaults)
            object.RoundIndex = 0;
        if (message.RoundIndex != null && message.hasOwnProperty("RoundIndex"))
            object.RoundIndex = message.RoundIndex;
        if (message.ShowInfo && message.ShowInfo.length) {
            object.ShowInfo = [];
            for (let j = 0; j < message.ShowInfo.length; ++j)
                object.ShowInfo[j] = $root.RummyPoolShowRoundScore.toObject(message.ShowInfo[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyPoolPlayerRoundInfo to JSON.
     * @function toJSON
     * @memberof RummyPoolPlayerRoundInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolPlayerRoundInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolPlayerRoundInfo
     * @function getTypeUrl
     * @memberof RummyPoolPlayerRoundInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolPlayerRoundInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolPlayerRoundInfo";
    };

    return RummyPoolPlayerRoundInfo;
})();

export const RummyPoolPlayerTotalWin = $root.RummyPoolPlayerTotalWin = (() => {

    /**
     * Properties of a RummyPoolPlayerTotalWin.
     * @exports IRummyPoolPlayerTotalWin
     * @interface IRummyPoolPlayerTotalWin
     * @property {number|null} [UserID] RummyPoolPlayerTotalWin UserID
     * @property {number|null} [UserSeatNo] RummyPoolPlayerTotalWin UserSeatNo
     * @property {number|null} [TotalWin] RummyPoolPlayerTotalWin TotalWin
     * @property {Uint8Array|null} [NickName] RummyPoolPlayerTotalWin NickName
     */

    /**
     * Constructs a new RummyPoolPlayerTotalWin.
     * @exports RummyPoolPlayerTotalWin
     * @classdesc Represents a RummyPoolPlayerTotalWin.
     * @implements IRummyPoolPlayerTotalWin
     * @constructor
     * @param {IRummyPoolPlayerTotalWin=} [properties] Properties to set
     */
    function RummyPoolPlayerTotalWin(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolPlayerTotalWin UserID.
     * @member {number} UserID
     * @memberof RummyPoolPlayerTotalWin
     * @instance
     */
    RummyPoolPlayerTotalWin.prototype.UserID = 0;

    /**
     * RummyPoolPlayerTotalWin UserSeatNo.
     * @member {number} UserSeatNo
     * @memberof RummyPoolPlayerTotalWin
     * @instance
     */
    RummyPoolPlayerTotalWin.prototype.UserSeatNo = 0;

    /**
     * RummyPoolPlayerTotalWin TotalWin.
     * @member {number} TotalWin
     * @memberof RummyPoolPlayerTotalWin
     * @instance
     */
    RummyPoolPlayerTotalWin.prototype.TotalWin = 0;

    /**
     * RummyPoolPlayerTotalWin NickName.
     * @member {Uint8Array} NickName
     * @memberof RummyPoolPlayerTotalWin
     * @instance
     */
    RummyPoolPlayerTotalWin.prototype.NickName = $util.newBuffer([]);

    /**
     * Creates a new RummyPoolPlayerTotalWin instance using the specified properties.
     * @function create
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {IRummyPoolPlayerTotalWin=} [properties] Properties to set
     * @returns {RummyPoolPlayerTotalWin} RummyPoolPlayerTotalWin instance
     */
    RummyPoolPlayerTotalWin.create = function create(properties) {
        return new RummyPoolPlayerTotalWin(properties);
    };

    /**
     * Encodes the specified RummyPoolPlayerTotalWin message. Does not implicitly {@link RummyPoolPlayerTotalWin.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {IRummyPoolPlayerTotalWin} message RummyPoolPlayerTotalWin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolPlayerTotalWin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.UserSeatNo != null && Object.hasOwnProperty.call(message, "UserSeatNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.UserSeatNo);
        if (message.TotalWin != null && Object.hasOwnProperty.call(message, "TotalWin"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.TotalWin);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.NickName);
        return writer;
    };

    /**
     * Encodes the specified RummyPoolPlayerTotalWin message, length delimited. Does not implicitly {@link RummyPoolPlayerTotalWin.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {IRummyPoolPlayerTotalWin} message RummyPoolPlayerTotalWin message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolPlayerTotalWin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolPlayerTotalWin message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolPlayerTotalWin} RummyPoolPlayerTotalWin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolPlayerTotalWin.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolPlayerTotalWin();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserSeatNo = reader.int32();
                    break;
                }
            case 3: {
                    message.TotalWin = reader.int32();
                    break;
                }
            case 4: {
                    message.NickName = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolPlayerTotalWin message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolPlayerTotalWin} RummyPoolPlayerTotalWin
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolPlayerTotalWin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolPlayerTotalWin message.
     * @function verify
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolPlayerTotalWin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.UserSeatNo != null && message.hasOwnProperty("UserSeatNo"))
            if (!$util.isInteger(message.UserSeatNo))
                return "UserSeatNo: integer expected";
        if (message.TotalWin != null && message.hasOwnProperty("TotalWin"))
            if (!$util.isInteger(message.TotalWin))
                return "TotalWin: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        return null;
    };

    /**
     * Creates a RummyPoolPlayerTotalWin message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolPlayerTotalWin} RummyPoolPlayerTotalWin
     */
    RummyPoolPlayerTotalWin.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolPlayerTotalWin)
            return object;
        let message = new $root.RummyPoolPlayerTotalWin();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.UserSeatNo != null)
            message.UserSeatNo = object.UserSeatNo | 0;
        if (object.TotalWin != null)
            message.TotalWin = object.TotalWin | 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolPlayerTotalWin message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {RummyPoolPlayerTotalWin} message RummyPoolPlayerTotalWin
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolPlayerTotalWin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.UserSeatNo = 0;
            object.TotalWin = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.UserSeatNo != null && message.hasOwnProperty("UserSeatNo"))
            object.UserSeatNo = message.UserSeatNo;
        if (message.TotalWin != null && message.hasOwnProperty("TotalWin"))
            object.TotalWin = message.TotalWin;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        return object;
    };

    /**
     * Converts this RummyPoolPlayerTotalWin to JSON.
     * @function toJSON
     * @memberof RummyPoolPlayerTotalWin
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolPlayerTotalWin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolPlayerTotalWin
     * @function getTypeUrl
     * @memberof RummyPoolPlayerTotalWin
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolPlayerTotalWin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolPlayerTotalWin";
    };

    return RummyPoolPlayerTotalWin;
})();

export const RummyPoolSrvToDeskPushRoundInfo = $root.RummyPoolSrvToDeskPushRoundInfo = (() => {

    /**
     * Properties of a RummyPoolSrvToDeskPushRoundInfo.
     * @exports IRummyPoolSrvToDeskPushRoundInfo
     * @interface IRummyPoolSrvToDeskPushRoundInfo
     * @property {number|null} [UserID] RummyPoolSrvToDeskPushRoundInfo UserID
     * @property {Array.<IRummyPoolPlayerRoundInfo>|null} [PlayerRoundInfo] RummyPoolSrvToDeskPushRoundInfo PlayerRoundInfo
     * @property {Array.<IRummyPoolPlayerTotalWin>|null} [PlayerTotalWin] RummyPoolSrvToDeskPushRoundInfo PlayerTotalWin
     */

    /**
     * Constructs a new RummyPoolSrvToDeskPushRoundInfo.
     * @exports RummyPoolSrvToDeskPushRoundInfo
     * @classdesc Represents a RummyPoolSrvToDeskPushRoundInfo.
     * @implements IRummyPoolSrvToDeskPushRoundInfo
     * @constructor
     * @param {IRummyPoolSrvToDeskPushRoundInfo=} [properties] Properties to set
     */
    function RummyPoolSrvToDeskPushRoundInfo(properties) {
        this.PlayerRoundInfo = [];
        this.PlayerTotalWin = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolSrvToDeskPushRoundInfo UserID.
     * @member {number} UserID
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRoundInfo.prototype.UserID = 0;

    /**
     * RummyPoolSrvToDeskPushRoundInfo PlayerRoundInfo.
     * @member {Array.<IRummyPoolPlayerRoundInfo>} PlayerRoundInfo
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRoundInfo.prototype.PlayerRoundInfo = $util.emptyArray;

    /**
     * RummyPoolSrvToDeskPushRoundInfo PlayerTotalWin.
     * @member {Array.<IRummyPoolPlayerTotalWin>} PlayerTotalWin
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @instance
     */
    RummyPoolSrvToDeskPushRoundInfo.prototype.PlayerTotalWin = $util.emptyArray;

    /**
     * Creates a new RummyPoolSrvToDeskPushRoundInfo instance using the specified properties.
     * @function create
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRoundInfo=} [properties] Properties to set
     * @returns {RummyPoolSrvToDeskPushRoundInfo} RummyPoolSrvToDeskPushRoundInfo instance
     */
    RummyPoolSrvToDeskPushRoundInfo.create = function create(properties) {
        return new RummyPoolSrvToDeskPushRoundInfo(properties);
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushRoundInfo message. Does not implicitly {@link RummyPoolSrvToDeskPushRoundInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRoundInfo} message RummyPoolSrvToDeskPushRoundInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushRoundInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.PlayerRoundInfo != null && message.PlayerRoundInfo.length)
            for (let i = 0; i < message.PlayerRoundInfo.length; ++i)
                $root.RummyPoolPlayerRoundInfo.encode(message.PlayerRoundInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.PlayerTotalWin != null && message.PlayerTotalWin.length)
            for (let i = 0; i < message.PlayerTotalWin.length; ++i)
                $root.RummyPoolPlayerTotalWin.encode(message.PlayerTotalWin[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushRoundInfo message, length delimited. Does not implicitly {@link RummyPoolSrvToDeskPushRoundInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {IRummyPoolSrvToDeskPushRoundInfo} message RummyPoolSrvToDeskPushRoundInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushRoundInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushRoundInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolSrvToDeskPushRoundInfo} RummyPoolSrvToDeskPushRoundInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushRoundInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolSrvToDeskPushRoundInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.PlayerRoundInfo && message.PlayerRoundInfo.length))
                        message.PlayerRoundInfo = [];
                    message.PlayerRoundInfo.push($root.RummyPoolPlayerRoundInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    if (!(message.PlayerTotalWin && message.PlayerTotalWin.length))
                        message.PlayerTotalWin = [];
                    message.PlayerTotalWin.push($root.RummyPoolPlayerTotalWin.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushRoundInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolSrvToDeskPushRoundInfo} RummyPoolSrvToDeskPushRoundInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushRoundInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolSrvToDeskPushRoundInfo message.
     * @function verify
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolSrvToDeskPushRoundInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.PlayerRoundInfo != null && message.hasOwnProperty("PlayerRoundInfo")) {
            if (!Array.isArray(message.PlayerRoundInfo))
                return "PlayerRoundInfo: array expected";
            for (let i = 0; i < message.PlayerRoundInfo.length; ++i) {
                let error = $root.RummyPoolPlayerRoundInfo.verify(message.PlayerRoundInfo[i]);
                if (error)
                    return "PlayerRoundInfo." + error;
            }
        }
        if (message.PlayerTotalWin != null && message.hasOwnProperty("PlayerTotalWin")) {
            if (!Array.isArray(message.PlayerTotalWin))
                return "PlayerTotalWin: array expected";
            for (let i = 0; i < message.PlayerTotalWin.length; ++i) {
                let error = $root.RummyPoolPlayerTotalWin.verify(message.PlayerTotalWin[i]);
                if (error)
                    return "PlayerTotalWin." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyPoolSrvToDeskPushRoundInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolSrvToDeskPushRoundInfo} RummyPoolSrvToDeskPushRoundInfo
     */
    RummyPoolSrvToDeskPushRoundInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolSrvToDeskPushRoundInfo)
            return object;
        let message = new $root.RummyPoolSrvToDeskPushRoundInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.PlayerRoundInfo) {
            if (!Array.isArray(object.PlayerRoundInfo))
                throw TypeError(".RummyPoolSrvToDeskPushRoundInfo.PlayerRoundInfo: array expected");
            message.PlayerRoundInfo = [];
            for (let i = 0; i < object.PlayerRoundInfo.length; ++i) {
                if (typeof object.PlayerRoundInfo[i] !== "object")
                    throw TypeError(".RummyPoolSrvToDeskPushRoundInfo.PlayerRoundInfo: object expected");
                message.PlayerRoundInfo[i] = $root.RummyPoolPlayerRoundInfo.fromObject(object.PlayerRoundInfo[i]);
            }
        }
        if (object.PlayerTotalWin) {
            if (!Array.isArray(object.PlayerTotalWin))
                throw TypeError(".RummyPoolSrvToDeskPushRoundInfo.PlayerTotalWin: array expected");
            message.PlayerTotalWin = [];
            for (let i = 0; i < object.PlayerTotalWin.length; ++i) {
                if (typeof object.PlayerTotalWin[i] !== "object")
                    throw TypeError(".RummyPoolSrvToDeskPushRoundInfo.PlayerTotalWin: object expected");
                message.PlayerTotalWin[i] = $root.RummyPoolPlayerTotalWin.fromObject(object.PlayerTotalWin[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolSrvToDeskPushRoundInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {RummyPoolSrvToDeskPushRoundInfo} message RummyPoolSrvToDeskPushRoundInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolSrvToDeskPushRoundInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.PlayerRoundInfo = [];
            object.PlayerTotalWin = [];
        }
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.PlayerRoundInfo && message.PlayerRoundInfo.length) {
            object.PlayerRoundInfo = [];
            for (let j = 0; j < message.PlayerRoundInfo.length; ++j)
                object.PlayerRoundInfo[j] = $root.RummyPoolPlayerRoundInfo.toObject(message.PlayerRoundInfo[j], options);
        }
        if (message.PlayerTotalWin && message.PlayerTotalWin.length) {
            object.PlayerTotalWin = [];
            for (let j = 0; j < message.PlayerTotalWin.length; ++j)
                object.PlayerTotalWin[j] = $root.RummyPoolPlayerTotalWin.toObject(message.PlayerTotalWin[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyPoolSrvToDeskPushRoundInfo to JSON.
     * @function toJSON
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolSrvToDeskPushRoundInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolSrvToDeskPushRoundInfo
     * @function getTypeUrl
     * @memberof RummyPoolSrvToDeskPushRoundInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolSrvToDeskPushRoundInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolSrvToDeskPushRoundInfo";
    };

    return RummyPoolSrvToDeskPushRoundInfo;
})();

export const DeskToRummyPoolSrvRoundInfoReq = $root.DeskToRummyPoolSrvRoundInfoReq = (() => {

    /**
     * Properties of a DeskToRummyPoolSrvRoundInfoReq.
     * @exports IDeskToRummyPoolSrvRoundInfoReq
     * @interface IDeskToRummyPoolSrvRoundInfoReq
     * @property {number|null} [DeskNo] DeskToRummyPoolSrvRoundInfoReq DeskNo
     * @property {number|null} [UserID] DeskToRummyPoolSrvRoundInfoReq UserID
     * @property {number|null} [SeatNo] DeskToRummyPoolSrvRoundInfoReq SeatNo
     */

    /**
     * Constructs a new DeskToRummyPoolSrvRoundInfoReq.
     * @exports DeskToRummyPoolSrvRoundInfoReq
     * @classdesc Represents a DeskToRummyPoolSrvRoundInfoReq.
     * @implements IDeskToRummyPoolSrvRoundInfoReq
     * @constructor
     * @param {IDeskToRummyPoolSrvRoundInfoReq=} [properties] Properties to set
     */
    function DeskToRummyPoolSrvRoundInfoReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToRummyPoolSrvRoundInfoReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @instance
     */
    DeskToRummyPoolSrvRoundInfoReq.prototype.DeskNo = 0;

    /**
     * DeskToRummyPoolSrvRoundInfoReq UserID.
     * @member {number} UserID
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @instance
     */
    DeskToRummyPoolSrvRoundInfoReq.prototype.UserID = 0;

    /**
     * DeskToRummyPoolSrvRoundInfoReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @instance
     */
    DeskToRummyPoolSrvRoundInfoReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToRummyPoolSrvRoundInfoReq instance using the specified properties.
     * @function create
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {IDeskToRummyPoolSrvRoundInfoReq=} [properties] Properties to set
     * @returns {DeskToRummyPoolSrvRoundInfoReq} DeskToRummyPoolSrvRoundInfoReq instance
     */
    DeskToRummyPoolSrvRoundInfoReq.create = function create(properties) {
        return new DeskToRummyPoolSrvRoundInfoReq(properties);
    };

    /**
     * Encodes the specified DeskToRummyPoolSrvRoundInfoReq message. Does not implicitly {@link DeskToRummyPoolSrvRoundInfoReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {IDeskToRummyPoolSrvRoundInfoReq} message DeskToRummyPoolSrvRoundInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummyPoolSrvRoundInfoReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToRummyPoolSrvRoundInfoReq message, length delimited. Does not implicitly {@link DeskToRummyPoolSrvRoundInfoReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {IDeskToRummyPoolSrvRoundInfoReq} message DeskToRummyPoolSrvRoundInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummyPoolSrvRoundInfoReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToRummyPoolSrvRoundInfoReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToRummyPoolSrvRoundInfoReq} DeskToRummyPoolSrvRoundInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummyPoolSrvRoundInfoReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToRummyPoolSrvRoundInfoReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToRummyPoolSrvRoundInfoReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToRummyPoolSrvRoundInfoReq} DeskToRummyPoolSrvRoundInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummyPoolSrvRoundInfoReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToRummyPoolSrvRoundInfoReq message.
     * @function verify
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToRummyPoolSrvRoundInfoReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToRummyPoolSrvRoundInfoReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToRummyPoolSrvRoundInfoReq} DeskToRummyPoolSrvRoundInfoReq
     */
    DeskToRummyPoolSrvRoundInfoReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToRummyPoolSrvRoundInfoReq)
            return object;
        let message = new $root.DeskToRummyPoolSrvRoundInfoReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToRummyPoolSrvRoundInfoReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {DeskToRummyPoolSrvRoundInfoReq} message DeskToRummyPoolSrvRoundInfoReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToRummyPoolSrvRoundInfoReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToRummyPoolSrvRoundInfoReq to JSON.
     * @function toJSON
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToRummyPoolSrvRoundInfoReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToRummyPoolSrvRoundInfoReq
     * @function getTypeUrl
     * @memberof DeskToRummyPoolSrvRoundInfoReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToRummyPoolSrvRoundInfoReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToRummyPoolSrvRoundInfoReq";
    };

    return DeskToRummyPoolSrvRoundInfoReq;
})();

export const RummyPoolSrvToDeskPushPlayerGameEnd = $root.RummyPoolSrvToDeskPushPlayerGameEnd = (() => {

    /**
     * Properties of a RummyPoolSrvToDeskPushPlayerGameEnd.
     * @exports IRummyPoolSrvToDeskPushPlayerGameEnd
     * @interface IRummyPoolSrvToDeskPushPlayerGameEnd
     * @property {number|null} [UserID] RummyPoolSrvToDeskPushPlayerGameEnd UserID
     * @property {number|null} [Practitioner] RummyPoolSrvToDeskPushPlayerGameEnd Practitioner
     * @property {number|null} [EndType] RummyPoolSrvToDeskPushPlayerGameEnd EndType
     * @property {Array.<IRummyPoolPlayerRoundInfo>|null} [PlayerRoundInfo] RummyPoolSrvToDeskPushPlayerGameEnd PlayerRoundInfo
     * @property {Array.<IRummyPoolPlayerTotalWin>|null} [PlayerTotalWin] RummyPoolSrvToDeskPushPlayerGameEnd PlayerTotalWin
     */

    /**
     * Constructs a new RummyPoolSrvToDeskPushPlayerGameEnd.
     * @exports RummyPoolSrvToDeskPushPlayerGameEnd
     * @classdesc Represents a RummyPoolSrvToDeskPushPlayerGameEnd.
     * @implements IRummyPoolSrvToDeskPushPlayerGameEnd
     * @constructor
     * @param {IRummyPoolSrvToDeskPushPlayerGameEnd=} [properties] Properties to set
     */
    function RummyPoolSrvToDeskPushPlayerGameEnd(properties) {
        this.PlayerRoundInfo = [];
        this.PlayerTotalWin = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyPoolSrvToDeskPushPlayerGameEnd UserID.
     * @member {number} UserID
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.UserID = 0;

    /**
     * RummyPoolSrvToDeskPushPlayerGameEnd Practitioner.
     * @member {number} Practitioner
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.Practitioner = 0;

    /**
     * RummyPoolSrvToDeskPushPlayerGameEnd EndType.
     * @member {number} EndType
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.EndType = 0;

    /**
     * RummyPoolSrvToDeskPushPlayerGameEnd PlayerRoundInfo.
     * @member {Array.<IRummyPoolPlayerRoundInfo>} PlayerRoundInfo
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.PlayerRoundInfo = $util.emptyArray;

    /**
     * RummyPoolSrvToDeskPushPlayerGameEnd PlayerTotalWin.
     * @member {Array.<IRummyPoolPlayerTotalWin>} PlayerTotalWin
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.PlayerTotalWin = $util.emptyArray;

    /**
     * Creates a new RummyPoolSrvToDeskPushPlayerGameEnd instance using the specified properties.
     * @function create
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {IRummyPoolSrvToDeskPushPlayerGameEnd=} [properties] Properties to set
     * @returns {RummyPoolSrvToDeskPushPlayerGameEnd} RummyPoolSrvToDeskPushPlayerGameEnd instance
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.create = function create(properties) {
        return new RummyPoolSrvToDeskPushPlayerGameEnd(properties);
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushPlayerGameEnd message. Does not implicitly {@link RummyPoolSrvToDeskPushPlayerGameEnd.verify|verify} messages.
     * @function encode
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {IRummyPoolSrvToDeskPushPlayerGameEnd} message RummyPoolSrvToDeskPushPlayerGameEnd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Practitioner);
        if (message.EndType != null && Object.hasOwnProperty.call(message, "EndType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.EndType);
        if (message.PlayerRoundInfo != null && message.PlayerRoundInfo.length)
            for (let i = 0; i < message.PlayerRoundInfo.length; ++i)
                $root.RummyPoolPlayerRoundInfo.encode(message.PlayerRoundInfo[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.PlayerTotalWin != null && message.PlayerTotalWin.length)
            for (let i = 0; i < message.PlayerTotalWin.length; ++i)
                $root.RummyPoolPlayerTotalWin.encode(message.PlayerTotalWin[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyPoolSrvToDeskPushPlayerGameEnd message, length delimited. Does not implicitly {@link RummyPoolSrvToDeskPushPlayerGameEnd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {IRummyPoolSrvToDeskPushPlayerGameEnd} message RummyPoolSrvToDeskPushPlayerGameEnd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushPlayerGameEnd message from the specified reader or buffer.
     * @function decode
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyPoolSrvToDeskPushPlayerGameEnd} RummyPoolSrvToDeskPushPlayerGameEnd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyPoolSrvToDeskPushPlayerGameEnd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 3: {
                    message.EndType = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.PlayerRoundInfo && message.PlayerRoundInfo.length))
                        message.PlayerRoundInfo = [];
                    message.PlayerRoundInfo.push($root.RummyPoolPlayerRoundInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    if (!(message.PlayerTotalWin && message.PlayerTotalWin.length))
                        message.PlayerTotalWin = [];
                    message.PlayerTotalWin.push($root.RummyPoolPlayerTotalWin.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyPoolSrvToDeskPushPlayerGameEnd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyPoolSrvToDeskPushPlayerGameEnd} RummyPoolSrvToDeskPushPlayerGameEnd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyPoolSrvToDeskPushPlayerGameEnd message.
     * @function verify
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.EndType != null && message.hasOwnProperty("EndType"))
            if (!$util.isInteger(message.EndType))
                return "EndType: integer expected";
        if (message.PlayerRoundInfo != null && message.hasOwnProperty("PlayerRoundInfo")) {
            if (!Array.isArray(message.PlayerRoundInfo))
                return "PlayerRoundInfo: array expected";
            for (let i = 0; i < message.PlayerRoundInfo.length; ++i) {
                let error = $root.RummyPoolPlayerRoundInfo.verify(message.PlayerRoundInfo[i]);
                if (error)
                    return "PlayerRoundInfo." + error;
            }
        }
        if (message.PlayerTotalWin != null && message.hasOwnProperty("PlayerTotalWin")) {
            if (!Array.isArray(message.PlayerTotalWin))
                return "PlayerTotalWin: array expected";
            for (let i = 0; i < message.PlayerTotalWin.length; ++i) {
                let error = $root.RummyPoolPlayerTotalWin.verify(message.PlayerTotalWin[i]);
                if (error)
                    return "PlayerTotalWin." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyPoolSrvToDeskPushPlayerGameEnd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyPoolSrvToDeskPushPlayerGameEnd} RummyPoolSrvToDeskPushPlayerGameEnd
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyPoolSrvToDeskPushPlayerGameEnd)
            return object;
        let message = new $root.RummyPoolSrvToDeskPushPlayerGameEnd();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.EndType != null)
            message.EndType = object.EndType >>> 0;
        if (object.PlayerRoundInfo) {
            if (!Array.isArray(object.PlayerRoundInfo))
                throw TypeError(".RummyPoolSrvToDeskPushPlayerGameEnd.PlayerRoundInfo: array expected");
            message.PlayerRoundInfo = [];
            for (let i = 0; i < object.PlayerRoundInfo.length; ++i) {
                if (typeof object.PlayerRoundInfo[i] !== "object")
                    throw TypeError(".RummyPoolSrvToDeskPushPlayerGameEnd.PlayerRoundInfo: object expected");
                message.PlayerRoundInfo[i] = $root.RummyPoolPlayerRoundInfo.fromObject(object.PlayerRoundInfo[i]);
            }
        }
        if (object.PlayerTotalWin) {
            if (!Array.isArray(object.PlayerTotalWin))
                throw TypeError(".RummyPoolSrvToDeskPushPlayerGameEnd.PlayerTotalWin: array expected");
            message.PlayerTotalWin = [];
            for (let i = 0; i < object.PlayerTotalWin.length; ++i) {
                if (typeof object.PlayerTotalWin[i] !== "object")
                    throw TypeError(".RummyPoolSrvToDeskPushPlayerGameEnd.PlayerTotalWin: object expected");
                message.PlayerTotalWin[i] = $root.RummyPoolPlayerTotalWin.fromObject(object.PlayerTotalWin[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyPoolSrvToDeskPushPlayerGameEnd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {RummyPoolSrvToDeskPushPlayerGameEnd} message RummyPoolSrvToDeskPushPlayerGameEnd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.PlayerRoundInfo = [];
            object.PlayerTotalWin = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.Practitioner = 0;
            object.EndType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.EndType != null && message.hasOwnProperty("EndType"))
            object.EndType = message.EndType;
        if (message.PlayerRoundInfo && message.PlayerRoundInfo.length) {
            object.PlayerRoundInfo = [];
            for (let j = 0; j < message.PlayerRoundInfo.length; ++j)
                object.PlayerRoundInfo[j] = $root.RummyPoolPlayerRoundInfo.toObject(message.PlayerRoundInfo[j], options);
        }
        if (message.PlayerTotalWin && message.PlayerTotalWin.length) {
            object.PlayerTotalWin = [];
            for (let j = 0; j < message.PlayerTotalWin.length; ++j)
                object.PlayerTotalWin[j] = $root.RummyPoolPlayerTotalWin.toObject(message.PlayerTotalWin[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyPoolSrvToDeskPushPlayerGameEnd to JSON.
     * @function toJSON
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyPoolSrvToDeskPushPlayerGameEnd
     * @function getTypeUrl
     * @memberof RummyPoolSrvToDeskPushPlayerGameEnd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyPoolSrvToDeskPushPlayerGameEnd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyPoolSrvToDeskPushPlayerGameEnd";
    };

    return RummyPoolSrvToDeskPushPlayerGameEnd;
})();

export const RummyDealesDealerCardInfo = $root.RummyDealesDealerCardInfo = (() => {

    /**
     * Properties of a RummyDealesDealerCardInfo.
     * @exports IRummyDealesDealerCardInfo
     * @interface IRummyDealesDealerCardInfo
     * @property {number|null} [Practitioner] RummyDealesDealerCardInfo Practitioner
     * @property {number|null} [ShowCard] RummyDealesDealerCardInfo ShowCard
     * @property {boolean|null} [MaxValue] RummyDealesDealerCardInfo MaxValue
     * @property {number|null} [SeatNo] RummyDealesDealerCardInfo SeatNo
     */

    /**
     * Constructs a new RummyDealesDealerCardInfo.
     * @exports RummyDealesDealerCardInfo
     * @classdesc Represents a RummyDealesDealerCardInfo.
     * @implements IRummyDealesDealerCardInfo
     * @constructor
     * @param {IRummyDealesDealerCardInfo=} [properties] Properties to set
     */
    function RummyDealesDealerCardInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesDealerCardInfo Practitioner.
     * @member {number} Practitioner
     * @memberof RummyDealesDealerCardInfo
     * @instance
     */
    RummyDealesDealerCardInfo.prototype.Practitioner = 0;

    /**
     * RummyDealesDealerCardInfo ShowCard.
     * @member {number} ShowCard
     * @memberof RummyDealesDealerCardInfo
     * @instance
     */
    RummyDealesDealerCardInfo.prototype.ShowCard = 0;

    /**
     * RummyDealesDealerCardInfo MaxValue.
     * @member {boolean} MaxValue
     * @memberof RummyDealesDealerCardInfo
     * @instance
     */
    RummyDealesDealerCardInfo.prototype.MaxValue = false;

    /**
     * RummyDealesDealerCardInfo SeatNo.
     * @member {number} SeatNo
     * @memberof RummyDealesDealerCardInfo
     * @instance
     */
    RummyDealesDealerCardInfo.prototype.SeatNo = 0;

    /**
     * Creates a new RummyDealesDealerCardInfo instance using the specified properties.
     * @function create
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {IRummyDealesDealerCardInfo=} [properties] Properties to set
     * @returns {RummyDealesDealerCardInfo} RummyDealesDealerCardInfo instance
     */
    RummyDealesDealerCardInfo.create = function create(properties) {
        return new RummyDealesDealerCardInfo(properties);
    };

    /**
     * Encodes the specified RummyDealesDealerCardInfo message. Does not implicitly {@link RummyDealesDealerCardInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {IRummyDealesDealerCardInfo} message RummyDealesDealerCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesDealerCardInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Practitioner);
        if (message.ShowCard != null && Object.hasOwnProperty.call(message, "ShowCard"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ShowCard);
        if (message.MaxValue != null && Object.hasOwnProperty.call(message, "MaxValue"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.MaxValue);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified RummyDealesDealerCardInfo message, length delimited. Does not implicitly {@link RummyDealesDealerCardInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {IRummyDealesDealerCardInfo} message RummyDealesDealerCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesDealerCardInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesDealerCardInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesDealerCardInfo} RummyDealesDealerCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesDealerCardInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesDealerCardInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 2: {
                    message.ShowCard = reader.uint32();
                    break;
                }
            case 3: {
                    message.MaxValue = reader.bool();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesDealerCardInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesDealerCardInfo} RummyDealesDealerCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesDealerCardInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesDealerCardInfo message.
     * @function verify
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesDealerCardInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.ShowCard != null && message.hasOwnProperty("ShowCard"))
            if (!$util.isInteger(message.ShowCard))
                return "ShowCard: integer expected";
        if (message.MaxValue != null && message.hasOwnProperty("MaxValue"))
            if (typeof message.MaxValue !== "boolean")
                return "MaxValue: boolean expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a RummyDealesDealerCardInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesDealerCardInfo} RummyDealesDealerCardInfo
     */
    RummyDealesDealerCardInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesDealerCardInfo)
            return object;
        let message = new $root.RummyDealesDealerCardInfo();
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.ShowCard != null)
            message.ShowCard = object.ShowCard >>> 0;
        if (object.MaxValue != null)
            message.MaxValue = Boolean(object.MaxValue);
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesDealerCardInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {RummyDealesDealerCardInfo} message RummyDealesDealerCardInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesDealerCardInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Practitioner = 0;
            object.ShowCard = 0;
            object.MaxValue = false;
            object.SeatNo = 0;
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.ShowCard != null && message.hasOwnProperty("ShowCard"))
            object.ShowCard = message.ShowCard;
        if (message.MaxValue != null && message.hasOwnProperty("MaxValue"))
            object.MaxValue = message.MaxValue;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this RummyDealesDealerCardInfo to JSON.
     * @function toJSON
     * @memberof RummyDealesDealerCardInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesDealerCardInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesDealerCardInfo
     * @function getTypeUrl
     * @memberof RummyDealesDealerCardInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesDealerCardInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesDealerCardInfo";
    };

    return RummyDealesDealerCardInfo;
})();

export const RummyDealesSrvToDeskPushDealerCard = $root.RummyDealesSrvToDeskPushDealerCard = (() => {

    /**
     * Properties of a RummyDealesSrvToDeskPushDealerCard.
     * @exports IRummyDealesSrvToDeskPushDealerCard
     * @interface IRummyDealesSrvToDeskPushDealerCard
     * @property {number|null} [UserID] RummyDealesSrvToDeskPushDealerCard UserID
     * @property {Array.<IRummyDealesDealerCardInfo>|null} [CardSInfo] RummyDealesSrvToDeskPushDealerCard CardSInfo
     */

    /**
     * Constructs a new RummyDealesSrvToDeskPushDealerCard.
     * @exports RummyDealesSrvToDeskPushDealerCard
     * @classdesc Represents a RummyDealesSrvToDeskPushDealerCard.
     * @implements IRummyDealesSrvToDeskPushDealerCard
     * @constructor
     * @param {IRummyDealesSrvToDeskPushDealerCard=} [properties] Properties to set
     */
    function RummyDealesSrvToDeskPushDealerCard(properties) {
        this.CardSInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesSrvToDeskPushDealerCard UserID.
     * @member {number} UserID
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @instance
     */
    RummyDealesSrvToDeskPushDealerCard.prototype.UserID = 0;

    /**
     * RummyDealesSrvToDeskPushDealerCard CardSInfo.
     * @member {Array.<IRummyDealesDealerCardInfo>} CardSInfo
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @instance
     */
    RummyDealesSrvToDeskPushDealerCard.prototype.CardSInfo = $util.emptyArray;

    /**
     * Creates a new RummyDealesSrvToDeskPushDealerCard instance using the specified properties.
     * @function create
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {IRummyDealesSrvToDeskPushDealerCard=} [properties] Properties to set
     * @returns {RummyDealesSrvToDeskPushDealerCard} RummyDealesSrvToDeskPushDealerCard instance
     */
    RummyDealesSrvToDeskPushDealerCard.create = function create(properties) {
        return new RummyDealesSrvToDeskPushDealerCard(properties);
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushDealerCard message. Does not implicitly {@link RummyDealesSrvToDeskPushDealerCard.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {IRummyDealesSrvToDeskPushDealerCard} message RummyDealesSrvToDeskPushDealerCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushDealerCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CardSInfo != null && message.CardSInfo.length)
            for (let i = 0; i < message.CardSInfo.length; ++i)
                $root.RummyDealesDealerCardInfo.encode(message.CardSInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushDealerCard message, length delimited. Does not implicitly {@link RummyDealesSrvToDeskPushDealerCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {IRummyDealesSrvToDeskPushDealerCard} message RummyDealesSrvToDeskPushDealerCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushDealerCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushDealerCard message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesSrvToDeskPushDealerCard} RummyDealesSrvToDeskPushDealerCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushDealerCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesSrvToDeskPushDealerCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.CardSInfo && message.CardSInfo.length))
                        message.CardSInfo = [];
                    message.CardSInfo.push($root.RummyDealesDealerCardInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushDealerCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesSrvToDeskPushDealerCard} RummyDealesSrvToDeskPushDealerCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushDealerCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesSrvToDeskPushDealerCard message.
     * @function verify
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesSrvToDeskPushDealerCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CardSInfo != null && message.hasOwnProperty("CardSInfo")) {
            if (!Array.isArray(message.CardSInfo))
                return "CardSInfo: array expected";
            for (let i = 0; i < message.CardSInfo.length; ++i) {
                let error = $root.RummyDealesDealerCardInfo.verify(message.CardSInfo[i]);
                if (error)
                    return "CardSInfo." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyDealesSrvToDeskPushDealerCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesSrvToDeskPushDealerCard} RummyDealesSrvToDeskPushDealerCard
     */
    RummyDealesSrvToDeskPushDealerCard.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesSrvToDeskPushDealerCard)
            return object;
        let message = new $root.RummyDealesSrvToDeskPushDealerCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CardSInfo) {
            if (!Array.isArray(object.CardSInfo))
                throw TypeError(".RummyDealesSrvToDeskPushDealerCard.CardSInfo: array expected");
            message.CardSInfo = [];
            for (let i = 0; i < object.CardSInfo.length; ++i) {
                if (typeof object.CardSInfo[i] !== "object")
                    throw TypeError(".RummyDealesSrvToDeskPushDealerCard.CardSInfo: object expected");
                message.CardSInfo[i] = $root.RummyDealesDealerCardInfo.fromObject(object.CardSInfo[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesSrvToDeskPushDealerCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {RummyDealesSrvToDeskPushDealerCard} message RummyDealesSrvToDeskPushDealerCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesSrvToDeskPushDealerCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.CardSInfo = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CardSInfo && message.CardSInfo.length) {
            object.CardSInfo = [];
            for (let j = 0; j < message.CardSInfo.length; ++j)
                object.CardSInfo[j] = $root.RummyDealesDealerCardInfo.toObject(message.CardSInfo[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyDealesSrvToDeskPushDealerCard to JSON.
     * @function toJSON
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesSrvToDeskPushDealerCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesSrvToDeskPushDealerCard
     * @function getTypeUrl
     * @memberof RummyDealesSrvToDeskPushDealerCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesSrvToDeskPushDealerCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesSrvToDeskPushDealerCard";
    };

    return RummyDealesSrvToDeskPushDealerCard;
})();

export const DeskToRummyDealesSrvResultReq = $root.DeskToRummyDealesSrvResultReq = (() => {

    /**
     * Properties of a DeskToRummyDealesSrvResultReq.
     * @exports IDeskToRummyDealesSrvResultReq
     * @interface IDeskToRummyDealesSrvResultReq
     * @property {number|null} [DeskNo] DeskToRummyDealesSrvResultReq DeskNo
     * @property {number|null} [UserID] DeskToRummyDealesSrvResultReq UserID
     * @property {number|null} [SeatNo] DeskToRummyDealesSrvResultReq SeatNo
     */

    /**
     * Constructs a new DeskToRummyDealesSrvResultReq.
     * @exports DeskToRummyDealesSrvResultReq
     * @classdesc Represents a DeskToRummyDealesSrvResultReq.
     * @implements IDeskToRummyDealesSrvResultReq
     * @constructor
     * @param {IDeskToRummyDealesSrvResultReq=} [properties] Properties to set
     */
    function DeskToRummyDealesSrvResultReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToRummyDealesSrvResultReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToRummyDealesSrvResultReq
     * @instance
     */
    DeskToRummyDealesSrvResultReq.prototype.DeskNo = 0;

    /**
     * DeskToRummyDealesSrvResultReq UserID.
     * @member {number} UserID
     * @memberof DeskToRummyDealesSrvResultReq
     * @instance
     */
    DeskToRummyDealesSrvResultReq.prototype.UserID = 0;

    /**
     * DeskToRummyDealesSrvResultReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToRummyDealesSrvResultReq
     * @instance
     */
    DeskToRummyDealesSrvResultReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToRummyDealesSrvResultReq instance using the specified properties.
     * @function create
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {IDeskToRummyDealesSrvResultReq=} [properties] Properties to set
     * @returns {DeskToRummyDealesSrvResultReq} DeskToRummyDealesSrvResultReq instance
     */
    DeskToRummyDealesSrvResultReq.create = function create(properties) {
        return new DeskToRummyDealesSrvResultReq(properties);
    };

    /**
     * Encodes the specified DeskToRummyDealesSrvResultReq message. Does not implicitly {@link DeskToRummyDealesSrvResultReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {IDeskToRummyDealesSrvResultReq} message DeskToRummyDealesSrvResultReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummyDealesSrvResultReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToRummyDealesSrvResultReq message, length delimited. Does not implicitly {@link DeskToRummyDealesSrvResultReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {IDeskToRummyDealesSrvResultReq} message DeskToRummyDealesSrvResultReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToRummyDealesSrvResultReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToRummyDealesSrvResultReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToRummyDealesSrvResultReq} DeskToRummyDealesSrvResultReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummyDealesSrvResultReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToRummyDealesSrvResultReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToRummyDealesSrvResultReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToRummyDealesSrvResultReq} DeskToRummyDealesSrvResultReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToRummyDealesSrvResultReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToRummyDealesSrvResultReq message.
     * @function verify
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToRummyDealesSrvResultReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToRummyDealesSrvResultReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToRummyDealesSrvResultReq} DeskToRummyDealesSrvResultReq
     */
    DeskToRummyDealesSrvResultReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToRummyDealesSrvResultReq)
            return object;
        let message = new $root.DeskToRummyDealesSrvResultReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToRummyDealesSrvResultReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {DeskToRummyDealesSrvResultReq} message DeskToRummyDealesSrvResultReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToRummyDealesSrvResultReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToRummyDealesSrvResultReq to JSON.
     * @function toJSON
     * @memberof DeskToRummyDealesSrvResultReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToRummyDealesSrvResultReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToRummyDealesSrvResultReq
     * @function getTypeUrl
     * @memberof DeskToRummyDealesSrvResultReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToRummyDealesSrvResultReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToRummyDealesSrvResultReq";
    };

    return DeskToRummyDealesSrvResultReq;
})();

export const RummyDealesSrvToDeskPushGameResult = $root.RummyDealesSrvToDeskPushGameResult = (() => {

    /**
     * Properties of a RummyDealesSrvToDeskPushGameResult.
     * @exports IRummyDealesSrvToDeskPushGameResult
     * @interface IRummyDealesSrvToDeskPushGameResult
     * @property {number|null} [UserID] RummyDealesSrvToDeskPushGameResult UserID
     * @property {Array.<IPlayerResultForRummy>|null} [GoldResult] RummyDealesSrvToDeskPushGameResult GoldResult
     */

    /**
     * Constructs a new RummyDealesSrvToDeskPushGameResult.
     * @exports RummyDealesSrvToDeskPushGameResult
     * @classdesc Represents a RummyDealesSrvToDeskPushGameResult.
     * @implements IRummyDealesSrvToDeskPushGameResult
     * @constructor
     * @param {IRummyDealesSrvToDeskPushGameResult=} [properties] Properties to set
     */
    function RummyDealesSrvToDeskPushGameResult(properties) {
        this.GoldResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesSrvToDeskPushGameResult UserID.
     * @member {number} UserID
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @instance
     */
    RummyDealesSrvToDeskPushGameResult.prototype.UserID = 0;

    /**
     * RummyDealesSrvToDeskPushGameResult GoldResult.
     * @member {Array.<IPlayerResultForRummy>} GoldResult
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @instance
     */
    RummyDealesSrvToDeskPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Creates a new RummyDealesSrvToDeskPushGameResult instance using the specified properties.
     * @function create
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {IRummyDealesSrvToDeskPushGameResult=} [properties] Properties to set
     * @returns {RummyDealesSrvToDeskPushGameResult} RummyDealesSrvToDeskPushGameResult instance
     */
    RummyDealesSrvToDeskPushGameResult.create = function create(properties) {
        return new RummyDealesSrvToDeskPushGameResult(properties);
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushGameResult message. Does not implicitly {@link RummyDealesSrvToDeskPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {IRummyDealesSrvToDeskPushGameResult} message RummyDealesSrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.PlayerResultForRummy.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushGameResult message, length delimited. Does not implicitly {@link RummyDealesSrvToDeskPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {IRummyDealesSrvToDeskPushGameResult} message RummyDealesSrvToDeskPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesSrvToDeskPushGameResult} RummyDealesSrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesSrvToDeskPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.PlayerResultForRummy.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesSrvToDeskPushGameResult} RummyDealesSrvToDeskPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesSrvToDeskPushGameResult message.
     * @function verify
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesSrvToDeskPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.PlayerResultForRummy.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyDealesSrvToDeskPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesSrvToDeskPushGameResult} RummyDealesSrvToDeskPushGameResult
     */
    RummyDealesSrvToDeskPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesSrvToDeskPushGameResult)
            return object;
        let message = new $root.RummyDealesSrvToDeskPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".RummyDealesSrvToDeskPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".RummyDealesSrvToDeskPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.PlayerResultForRummy.fromObject(object.GoldResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesSrvToDeskPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {RummyDealesSrvToDeskPushGameResult} message RummyDealesSrvToDeskPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesSrvToDeskPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GoldResult = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.PlayerResultForRummy.toObject(message.GoldResult[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyDealesSrvToDeskPushGameResult to JSON.
     * @function toJSON
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesSrvToDeskPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesSrvToDeskPushGameResult
     * @function getTypeUrl
     * @memberof RummyDealesSrvToDeskPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesSrvToDeskPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesSrvToDeskPushGameResult";
    };

    return RummyDealesSrvToDeskPushGameResult;
})();

export const RummyDealesSrvToDeskPushMaxPlayerCnt = $root.RummyDealesSrvToDeskPushMaxPlayerCnt = (() => {

    /**
     * Properties of a RummyDealesSrvToDeskPushMaxPlayerCnt.
     * @exports IRummyDealesSrvToDeskPushMaxPlayerCnt
     * @interface IRummyDealesSrvToDeskPushMaxPlayerCnt
     * @property {number|null} [MaxPlayerCnt] RummyDealesSrvToDeskPushMaxPlayerCnt MaxPlayerCnt
     */

    /**
     * Constructs a new RummyDealesSrvToDeskPushMaxPlayerCnt.
     * @exports RummyDealesSrvToDeskPushMaxPlayerCnt
     * @classdesc Represents a RummyDealesSrvToDeskPushMaxPlayerCnt.
     * @implements IRummyDealesSrvToDeskPushMaxPlayerCnt
     * @constructor
     * @param {IRummyDealesSrvToDeskPushMaxPlayerCnt=} [properties] Properties to set
     */
    function RummyDealesSrvToDeskPushMaxPlayerCnt(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesSrvToDeskPushMaxPlayerCnt MaxPlayerCnt.
     * @member {number} MaxPlayerCnt
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @instance
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.prototype.MaxPlayerCnt = 0;

    /**
     * Creates a new RummyDealesSrvToDeskPushMaxPlayerCnt instance using the specified properties.
     * @function create
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {IRummyDealesSrvToDeskPushMaxPlayerCnt=} [properties] Properties to set
     * @returns {RummyDealesSrvToDeskPushMaxPlayerCnt} RummyDealesSrvToDeskPushMaxPlayerCnt instance
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.create = function create(properties) {
        return new RummyDealesSrvToDeskPushMaxPlayerCnt(properties);
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushMaxPlayerCnt message. Does not implicitly {@link RummyDealesSrvToDeskPushMaxPlayerCnt.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {IRummyDealesSrvToDeskPushMaxPlayerCnt} message RummyDealesSrvToDeskPushMaxPlayerCnt message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.MaxPlayerCnt != null && Object.hasOwnProperty.call(message, "MaxPlayerCnt"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MaxPlayerCnt);
        return writer;
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushMaxPlayerCnt message, length delimited. Does not implicitly {@link RummyDealesSrvToDeskPushMaxPlayerCnt.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {IRummyDealesSrvToDeskPushMaxPlayerCnt} message RummyDealesSrvToDeskPushMaxPlayerCnt message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushMaxPlayerCnt message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesSrvToDeskPushMaxPlayerCnt} RummyDealesSrvToDeskPushMaxPlayerCnt
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesSrvToDeskPushMaxPlayerCnt();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.MaxPlayerCnt = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushMaxPlayerCnt message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesSrvToDeskPushMaxPlayerCnt} RummyDealesSrvToDeskPushMaxPlayerCnt
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesSrvToDeskPushMaxPlayerCnt message.
     * @function verify
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.MaxPlayerCnt != null && message.hasOwnProperty("MaxPlayerCnt"))
            if (!$util.isInteger(message.MaxPlayerCnt))
                return "MaxPlayerCnt: integer expected";
        return null;
    };

    /**
     * Creates a RummyDealesSrvToDeskPushMaxPlayerCnt message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesSrvToDeskPushMaxPlayerCnt} RummyDealesSrvToDeskPushMaxPlayerCnt
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesSrvToDeskPushMaxPlayerCnt)
            return object;
        let message = new $root.RummyDealesSrvToDeskPushMaxPlayerCnt();
        if (object.MaxPlayerCnt != null)
            message.MaxPlayerCnt = object.MaxPlayerCnt >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesSrvToDeskPushMaxPlayerCnt message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {RummyDealesSrvToDeskPushMaxPlayerCnt} message RummyDealesSrvToDeskPushMaxPlayerCnt
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.MaxPlayerCnt = 0;
        if (message.MaxPlayerCnt != null && message.hasOwnProperty("MaxPlayerCnt"))
            object.MaxPlayerCnt = message.MaxPlayerCnt;
        return object;
    };

    /**
     * Converts this RummyDealesSrvToDeskPushMaxPlayerCnt to JSON.
     * @function toJSON
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesSrvToDeskPushMaxPlayerCnt
     * @function getTypeUrl
     * @memberof RummyDealesSrvToDeskPushMaxPlayerCnt
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesSrvToDeskPushMaxPlayerCnt.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesSrvToDeskPushMaxPlayerCnt";
    };

    return RummyDealesSrvToDeskPushMaxPlayerCnt;
})();

export const RummyDealesGameEndPlayerInfo = $root.RummyDealesGameEndPlayerInfo = (() => {

    /**
     * Properties of a RummyDealesGameEndPlayerInfo.
     * @exports IRummyDealesGameEndPlayerInfo
     * @interface IRummyDealesGameEndPlayerInfo
     * @property {number|null} [UserID] RummyDealesGameEndPlayerInfo UserID
     * @property {number|null} [TotalScore] RummyDealesGameEndPlayerInfo TotalScore
     * @property {boolean|null} [IsWinner] RummyDealesGameEndPlayerInfo IsWinner
     * @property {Uint8Array|null} [NickName] RummyDealesGameEndPlayerInfo NickName
     * @property {string|null} [HeaderURL] RummyDealesGameEndPlayerInfo HeaderURL
     */

    /**
     * Constructs a new RummyDealesGameEndPlayerInfo.
     * @exports RummyDealesGameEndPlayerInfo
     * @classdesc Represents a RummyDealesGameEndPlayerInfo.
     * @implements IRummyDealesGameEndPlayerInfo
     * @constructor
     * @param {IRummyDealesGameEndPlayerInfo=} [properties] Properties to set
     */
    function RummyDealesGameEndPlayerInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesGameEndPlayerInfo UserID.
     * @member {number} UserID
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     */
    RummyDealesGameEndPlayerInfo.prototype.UserID = 0;

    /**
     * RummyDealesGameEndPlayerInfo TotalScore.
     * @member {number} TotalScore
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     */
    RummyDealesGameEndPlayerInfo.prototype.TotalScore = 0;

    /**
     * RummyDealesGameEndPlayerInfo IsWinner.
     * @member {boolean} IsWinner
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     */
    RummyDealesGameEndPlayerInfo.prototype.IsWinner = false;

    /**
     * RummyDealesGameEndPlayerInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     */
    RummyDealesGameEndPlayerInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * RummyDealesGameEndPlayerInfo HeaderURL.
     * @member {string} HeaderURL
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     */
    RummyDealesGameEndPlayerInfo.prototype.HeaderURL = "";

    /**
     * Creates a new RummyDealesGameEndPlayerInfo instance using the specified properties.
     * @function create
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {IRummyDealesGameEndPlayerInfo=} [properties] Properties to set
     * @returns {RummyDealesGameEndPlayerInfo} RummyDealesGameEndPlayerInfo instance
     */
    RummyDealesGameEndPlayerInfo.create = function create(properties) {
        return new RummyDealesGameEndPlayerInfo(properties);
    };

    /**
     * Encodes the specified RummyDealesGameEndPlayerInfo message. Does not implicitly {@link RummyDealesGameEndPlayerInfo.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {IRummyDealesGameEndPlayerInfo} message RummyDealesGameEndPlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesGameEndPlayerInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TotalScore != null && Object.hasOwnProperty.call(message, "TotalScore"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TotalScore);
        if (message.IsWinner != null && Object.hasOwnProperty.call(message, "IsWinner"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsWinner);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.HeaderURL);
        return writer;
    };

    /**
     * Encodes the specified RummyDealesGameEndPlayerInfo message, length delimited. Does not implicitly {@link RummyDealesGameEndPlayerInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {IRummyDealesGameEndPlayerInfo} message RummyDealesGameEndPlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesGameEndPlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesGameEndPlayerInfo message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesGameEndPlayerInfo} RummyDealesGameEndPlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesGameEndPlayerInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesGameEndPlayerInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TotalScore = reader.int32();
                    break;
                }
            case 3: {
                    message.IsWinner = reader.bool();
                    break;
                }
            case 4: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 5: {
                    message.HeaderURL = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesGameEndPlayerInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesGameEndPlayerInfo} RummyDealesGameEndPlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesGameEndPlayerInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesGameEndPlayerInfo message.
     * @function verify
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesGameEndPlayerInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TotalScore != null && message.hasOwnProperty("TotalScore"))
            if (!$util.isInteger(message.TotalScore))
                return "TotalScore: integer expected";
        if (message.IsWinner != null && message.hasOwnProperty("IsWinner"))
            if (typeof message.IsWinner !== "boolean")
                return "IsWinner: boolean expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        return null;
    };

    /**
     * Creates a RummyDealesGameEndPlayerInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesGameEndPlayerInfo} RummyDealesGameEndPlayerInfo
     */
    RummyDealesGameEndPlayerInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesGameEndPlayerInfo)
            return object;
        let message = new $root.RummyDealesGameEndPlayerInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TotalScore != null)
            message.TotalScore = object.TotalScore | 0;
        if (object.IsWinner != null)
            message.IsWinner = Boolean(object.IsWinner);
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesGameEndPlayerInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {RummyDealesGameEndPlayerInfo} message RummyDealesGameEndPlayerInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesGameEndPlayerInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.TotalScore = 0;
            object.IsWinner = false;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TotalScore != null && message.hasOwnProperty("TotalScore"))
            object.TotalScore = message.TotalScore;
        if (message.IsWinner != null && message.hasOwnProperty("IsWinner"))
            object.IsWinner = message.IsWinner;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        return object;
    };

    /**
     * Converts this RummyDealesGameEndPlayerInfo to JSON.
     * @function toJSON
     * @memberof RummyDealesGameEndPlayerInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesGameEndPlayerInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesGameEndPlayerInfo
     * @function getTypeUrl
     * @memberof RummyDealesGameEndPlayerInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesGameEndPlayerInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesGameEndPlayerInfo";
    };

    return RummyDealesGameEndPlayerInfo;
})();

export const RummyDealesSrvToDeskPushGameEnd = $root.RummyDealesSrvToDeskPushGameEnd = (() => {

    /**
     * Properties of a RummyDealesSrvToDeskPushGameEnd.
     * @exports IRummyDealesSrvToDeskPushGameEnd
     * @interface IRummyDealesSrvToDeskPushGameEnd
     * @property {number|null} [UserID] RummyDealesSrvToDeskPushGameEnd UserID
     * @property {string|null} [Price] RummyDealesSrvToDeskPushGameEnd Price
     * @property {Array.<IRummyDealesGameEndPlayerInfo>|null} [PlayerInfo] RummyDealesSrvToDeskPushGameEnd PlayerInfo
     */

    /**
     * Constructs a new RummyDealesSrvToDeskPushGameEnd.
     * @exports RummyDealesSrvToDeskPushGameEnd
     * @classdesc Represents a RummyDealesSrvToDeskPushGameEnd.
     * @implements IRummyDealesSrvToDeskPushGameEnd
     * @constructor
     * @param {IRummyDealesSrvToDeskPushGameEnd=} [properties] Properties to set
     */
    function RummyDealesSrvToDeskPushGameEnd(properties) {
        this.PlayerInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesSrvToDeskPushGameEnd UserID.
     * @member {number} UserID
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @instance
     */
    RummyDealesSrvToDeskPushGameEnd.prototype.UserID = 0;

    /**
     * RummyDealesSrvToDeskPushGameEnd Price.
     * @member {string} Price
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @instance
     */
    RummyDealesSrvToDeskPushGameEnd.prototype.Price = "";

    /**
     * RummyDealesSrvToDeskPushGameEnd PlayerInfo.
     * @member {Array.<IRummyDealesGameEndPlayerInfo>} PlayerInfo
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @instance
     */
    RummyDealesSrvToDeskPushGameEnd.prototype.PlayerInfo = $util.emptyArray;

    /**
     * Creates a new RummyDealesSrvToDeskPushGameEnd instance using the specified properties.
     * @function create
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {IRummyDealesSrvToDeskPushGameEnd=} [properties] Properties to set
     * @returns {RummyDealesSrvToDeskPushGameEnd} RummyDealesSrvToDeskPushGameEnd instance
     */
    RummyDealesSrvToDeskPushGameEnd.create = function create(properties) {
        return new RummyDealesSrvToDeskPushGameEnd(properties);
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushGameEnd message. Does not implicitly {@link RummyDealesSrvToDeskPushGameEnd.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {IRummyDealesSrvToDeskPushGameEnd} message RummyDealesSrvToDeskPushGameEnd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushGameEnd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Price);
        if (message.PlayerInfo != null && message.PlayerInfo.length)
            for (let i = 0; i < message.PlayerInfo.length; ++i)
                $root.RummyDealesGameEndPlayerInfo.encode(message.PlayerInfo[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskPushGameEnd message, length delimited. Does not implicitly {@link RummyDealesSrvToDeskPushGameEnd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {IRummyDealesSrvToDeskPushGameEnd} message RummyDealesSrvToDeskPushGameEnd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskPushGameEnd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushGameEnd message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesSrvToDeskPushGameEnd} RummyDealesSrvToDeskPushGameEnd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushGameEnd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesSrvToDeskPushGameEnd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Price = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.PlayerInfo && message.PlayerInfo.length))
                        message.PlayerInfo = [];
                    message.PlayerInfo.push($root.RummyDealesGameEndPlayerInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesSrvToDeskPushGameEnd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesSrvToDeskPushGameEnd} RummyDealesSrvToDeskPushGameEnd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskPushGameEnd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesSrvToDeskPushGameEnd message.
     * @function verify
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesSrvToDeskPushGameEnd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Price != null && message.hasOwnProperty("Price"))
            if (!$util.isString(message.Price))
                return "Price: string expected";
        if (message.PlayerInfo != null && message.hasOwnProperty("PlayerInfo")) {
            if (!Array.isArray(message.PlayerInfo))
                return "PlayerInfo: array expected";
            for (let i = 0; i < message.PlayerInfo.length; ++i) {
                let error = $root.RummyDealesGameEndPlayerInfo.verify(message.PlayerInfo[i]);
                if (error)
                    return "PlayerInfo." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RummyDealesSrvToDeskPushGameEnd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesSrvToDeskPushGameEnd} RummyDealesSrvToDeskPushGameEnd
     */
    RummyDealesSrvToDeskPushGameEnd.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesSrvToDeskPushGameEnd)
            return object;
        let message = new $root.RummyDealesSrvToDeskPushGameEnd();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Price != null)
            message.Price = String(object.Price);
        if (object.PlayerInfo) {
            if (!Array.isArray(object.PlayerInfo))
                throw TypeError(".RummyDealesSrvToDeskPushGameEnd.PlayerInfo: array expected");
            message.PlayerInfo = [];
            for (let i = 0; i < object.PlayerInfo.length; ++i) {
                if (typeof object.PlayerInfo[i] !== "object")
                    throw TypeError(".RummyDealesSrvToDeskPushGameEnd.PlayerInfo: object expected");
                message.PlayerInfo[i] = $root.RummyDealesGameEndPlayerInfo.fromObject(object.PlayerInfo[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesSrvToDeskPushGameEnd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {RummyDealesSrvToDeskPushGameEnd} message RummyDealesSrvToDeskPushGameEnd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesSrvToDeskPushGameEnd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PlayerInfo = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Price = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = message.Price;
        if (message.PlayerInfo && message.PlayerInfo.length) {
            object.PlayerInfo = [];
            for (let j = 0; j < message.PlayerInfo.length; ++j)
                object.PlayerInfo[j] = $root.RummyDealesGameEndPlayerInfo.toObject(message.PlayerInfo[j], options);
        }
        return object;
    };

    /**
     * Converts this RummyDealesSrvToDeskPushGameEnd to JSON.
     * @function toJSON
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesSrvToDeskPushGameEnd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesSrvToDeskPushGameEnd
     * @function getTypeUrl
     * @memberof RummyDealesSrvToDeskPushGameEnd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesSrvToDeskPushGameEnd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesSrvToDeskPushGameEnd";
    };

    return RummyDealesSrvToDeskPushGameEnd;
})();

export const RummyDealesSrvToDeskGameEndReq = $root.RummyDealesSrvToDeskGameEndReq = (() => {

    /**
     * Properties of a RummyDealesSrvToDeskGameEndReq.
     * @exports IRummyDealesSrvToDeskGameEndReq
     * @interface IRummyDealesSrvToDeskGameEndReq
     * @property {number|null} [DeskNo] RummyDealesSrvToDeskGameEndReq DeskNo
     * @property {number|null} [UserID] RummyDealesSrvToDeskGameEndReq UserID
     * @property {number|null} [SeatNo] RummyDealesSrvToDeskGameEndReq SeatNo
     */

    /**
     * Constructs a new RummyDealesSrvToDeskGameEndReq.
     * @exports RummyDealesSrvToDeskGameEndReq
     * @classdesc Represents a RummyDealesSrvToDeskGameEndReq.
     * @implements IRummyDealesSrvToDeskGameEndReq
     * @constructor
     * @param {IRummyDealesSrvToDeskGameEndReq=} [properties] Properties to set
     */
    function RummyDealesSrvToDeskGameEndReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummyDealesSrvToDeskGameEndReq DeskNo.
     * @member {number} DeskNo
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @instance
     */
    RummyDealesSrvToDeskGameEndReq.prototype.DeskNo = 0;

    /**
     * RummyDealesSrvToDeskGameEndReq UserID.
     * @member {number} UserID
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @instance
     */
    RummyDealesSrvToDeskGameEndReq.prototype.UserID = 0;

    /**
     * RummyDealesSrvToDeskGameEndReq SeatNo.
     * @member {number} SeatNo
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @instance
     */
    RummyDealesSrvToDeskGameEndReq.prototype.SeatNo = 0;

    /**
     * Creates a new RummyDealesSrvToDeskGameEndReq instance using the specified properties.
     * @function create
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {IRummyDealesSrvToDeskGameEndReq=} [properties] Properties to set
     * @returns {RummyDealesSrvToDeskGameEndReq} RummyDealesSrvToDeskGameEndReq instance
     */
    RummyDealesSrvToDeskGameEndReq.create = function create(properties) {
        return new RummyDealesSrvToDeskGameEndReq(properties);
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskGameEndReq message. Does not implicitly {@link RummyDealesSrvToDeskGameEndReq.verify|verify} messages.
     * @function encode
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {IRummyDealesSrvToDeskGameEndReq} message RummyDealesSrvToDeskGameEndReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskGameEndReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified RummyDealesSrvToDeskGameEndReq message, length delimited. Does not implicitly {@link RummyDealesSrvToDeskGameEndReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {IRummyDealesSrvToDeskGameEndReq} message RummyDealesSrvToDeskGameEndReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummyDealesSrvToDeskGameEndReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummyDealesSrvToDeskGameEndReq message from the specified reader or buffer.
     * @function decode
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummyDealesSrvToDeskGameEndReq} RummyDealesSrvToDeskGameEndReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskGameEndReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummyDealesSrvToDeskGameEndReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummyDealesSrvToDeskGameEndReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummyDealesSrvToDeskGameEndReq} RummyDealesSrvToDeskGameEndReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummyDealesSrvToDeskGameEndReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummyDealesSrvToDeskGameEndReq message.
     * @function verify
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummyDealesSrvToDeskGameEndReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a RummyDealesSrvToDeskGameEndReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummyDealesSrvToDeskGameEndReq} RummyDealesSrvToDeskGameEndReq
     */
    RummyDealesSrvToDeskGameEndReq.fromObject = function fromObject(object) {
        if (object instanceof $root.RummyDealesSrvToDeskGameEndReq)
            return object;
        let message = new $root.RummyDealesSrvToDeskGameEndReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a RummyDealesSrvToDeskGameEndReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {RummyDealesSrvToDeskGameEndReq} message RummyDealesSrvToDeskGameEndReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummyDealesSrvToDeskGameEndReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this RummyDealesSrvToDeskGameEndReq to JSON.
     * @function toJSON
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummyDealesSrvToDeskGameEndReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummyDealesSrvToDeskGameEndReq
     * @function getTypeUrl
     * @memberof RummyDealesSrvToDeskGameEndReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummyDealesSrvToDeskGameEndReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummyDealesSrvToDeskGameEndReq";
    };

    return RummyDealesSrvToDeskGameEndReq;
})();

export const RummySrvToDeskPushShuffleCards = $root.RummySrvToDeskPushShuffleCards = (() => {

    /**
     * Properties of a RummySrvToDeskPushShuffleCards.
     * @exports IRummySrvToDeskPushShuffleCards
     * @interface IRummySrvToDeskPushShuffleCards
     * @property {number|null} [LeftCardCnt] RummySrvToDeskPushShuffleCards LeftCardCnt
     * @property {Array.<number>|null} [PublicCardList] RummySrvToDeskPushShuffleCards PublicCardList
     */

    /**
     * Constructs a new RummySrvToDeskPushShuffleCards.
     * @exports RummySrvToDeskPushShuffleCards
     * @classdesc Represents a RummySrvToDeskPushShuffleCards.
     * @implements IRummySrvToDeskPushShuffleCards
     * @constructor
     * @param {IRummySrvToDeskPushShuffleCards=} [properties] Properties to set
     */
    function RummySrvToDeskPushShuffleCards(properties) {
        this.PublicCardList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushShuffleCards LeftCardCnt.
     * @member {number} LeftCardCnt
     * @memberof RummySrvToDeskPushShuffleCards
     * @instance
     */
    RummySrvToDeskPushShuffleCards.prototype.LeftCardCnt = 0;

    /**
     * RummySrvToDeskPushShuffleCards PublicCardList.
     * @member {Array.<number>} PublicCardList
     * @memberof RummySrvToDeskPushShuffleCards
     * @instance
     */
    RummySrvToDeskPushShuffleCards.prototype.PublicCardList = $util.emptyArray;

    /**
     * Creates a new RummySrvToDeskPushShuffleCards instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {IRummySrvToDeskPushShuffleCards=} [properties] Properties to set
     * @returns {RummySrvToDeskPushShuffleCards} RummySrvToDeskPushShuffleCards instance
     */
    RummySrvToDeskPushShuffleCards.create = function create(properties) {
        return new RummySrvToDeskPushShuffleCards(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushShuffleCards message. Does not implicitly {@link RummySrvToDeskPushShuffleCards.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {IRummySrvToDeskPushShuffleCards} message RummySrvToDeskPushShuffleCards message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushShuffleCards.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.LeftCardCnt != null && Object.hasOwnProperty.call(message, "LeftCardCnt"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.LeftCardCnt);
        if (message.PublicCardList != null && message.PublicCardList.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.PublicCardList.length; ++i)
                writer.uint32(message.PublicCardList[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushShuffleCards message, length delimited. Does not implicitly {@link RummySrvToDeskPushShuffleCards.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {IRummySrvToDeskPushShuffleCards} message RummySrvToDeskPushShuffleCards message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushShuffleCards.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushShuffleCards message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushShuffleCards} RummySrvToDeskPushShuffleCards
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushShuffleCards.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushShuffleCards();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.LeftCardCnt = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.PublicCardList && message.PublicCardList.length))
                        message.PublicCardList = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PublicCardList.push(reader.uint32());
                    } else
                        message.PublicCardList.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushShuffleCards message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushShuffleCards} RummySrvToDeskPushShuffleCards
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushShuffleCards.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushShuffleCards message.
     * @function verify
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushShuffleCards.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            if (!$util.isInteger(message.LeftCardCnt))
                return "LeftCardCnt: integer expected";
        if (message.PublicCardList != null && message.hasOwnProperty("PublicCardList")) {
            if (!Array.isArray(message.PublicCardList))
                return "PublicCardList: array expected";
            for (let i = 0; i < message.PublicCardList.length; ++i)
                if (!$util.isInteger(message.PublicCardList[i]))
                    return "PublicCardList: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushShuffleCards message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushShuffleCards} RummySrvToDeskPushShuffleCards
     */
    RummySrvToDeskPushShuffleCards.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushShuffleCards)
            return object;
        let message = new $root.RummySrvToDeskPushShuffleCards();
        if (object.LeftCardCnt != null)
            message.LeftCardCnt = object.LeftCardCnt >>> 0;
        if (object.PublicCardList) {
            if (!Array.isArray(object.PublicCardList))
                throw TypeError(".RummySrvToDeskPushShuffleCards.PublicCardList: array expected");
            message.PublicCardList = [];
            for (let i = 0; i < object.PublicCardList.length; ++i)
                message.PublicCardList[i] = object.PublicCardList[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushShuffleCards message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {RummySrvToDeskPushShuffleCards} message RummySrvToDeskPushShuffleCards
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushShuffleCards.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PublicCardList = [];
        if (options.defaults)
            object.LeftCardCnt = 0;
        if (message.LeftCardCnt != null && message.hasOwnProperty("LeftCardCnt"))
            object.LeftCardCnt = message.LeftCardCnt;
        if (message.PublicCardList && message.PublicCardList.length) {
            object.PublicCardList = [];
            for (let j = 0; j < message.PublicCardList.length; ++j)
                object.PublicCardList[j] = message.PublicCardList[j];
        }
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushShuffleCards to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushShuffleCards
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushShuffleCards.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushShuffleCards
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushShuffleCards
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushShuffleCards.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushShuffleCards";
    };

    return RummySrvToDeskPushShuffleCards;
})();

export const RummySrvToDeskPushNewSeat = $root.RummySrvToDeskPushNewSeat = (() => {

    /**
     * Properties of a RummySrvToDeskPushNewSeat.
     * @exports IRummySrvToDeskPushNewSeat
     * @interface IRummySrvToDeskPushNewSeat
     * @property {number|null} [SeatNo] RummySrvToDeskPushNewSeat SeatNo
     * @property {number|null} [UserID] RummySrvToDeskPushNewSeat UserID
     */

    /**
     * Constructs a new RummySrvToDeskPushNewSeat.
     * @exports RummySrvToDeskPushNewSeat
     * @classdesc Represents a RummySrvToDeskPushNewSeat.
     * @implements IRummySrvToDeskPushNewSeat
     * @constructor
     * @param {IRummySrvToDeskPushNewSeat=} [properties] Properties to set
     */
    function RummySrvToDeskPushNewSeat(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RummySrvToDeskPushNewSeat SeatNo.
     * @member {number} SeatNo
     * @memberof RummySrvToDeskPushNewSeat
     * @instance
     */
    RummySrvToDeskPushNewSeat.prototype.SeatNo = 0;

    /**
     * RummySrvToDeskPushNewSeat UserID.
     * @member {number} UserID
     * @memberof RummySrvToDeskPushNewSeat
     * @instance
     */
    RummySrvToDeskPushNewSeat.prototype.UserID = 0;

    /**
     * Creates a new RummySrvToDeskPushNewSeat instance using the specified properties.
     * @function create
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {IRummySrvToDeskPushNewSeat=} [properties] Properties to set
     * @returns {RummySrvToDeskPushNewSeat} RummySrvToDeskPushNewSeat instance
     */
    RummySrvToDeskPushNewSeat.create = function create(properties) {
        return new RummySrvToDeskPushNewSeat(properties);
    };

    /**
     * Encodes the specified RummySrvToDeskPushNewSeat message. Does not implicitly {@link RummySrvToDeskPushNewSeat.verify|verify} messages.
     * @function encode
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {IRummySrvToDeskPushNewSeat} message RummySrvToDeskPushNewSeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushNewSeat.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.SeatNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified RummySrvToDeskPushNewSeat message, length delimited. Does not implicitly {@link RummySrvToDeskPushNewSeat.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {IRummySrvToDeskPushNewSeat} message RummySrvToDeskPushNewSeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RummySrvToDeskPushNewSeat.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RummySrvToDeskPushNewSeat message from the specified reader or buffer.
     * @function decode
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RummySrvToDeskPushNewSeat} RummySrvToDeskPushNewSeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushNewSeat.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RummySrvToDeskPushNewSeat();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RummySrvToDeskPushNewSeat message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RummySrvToDeskPushNewSeat} RummySrvToDeskPushNewSeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RummySrvToDeskPushNewSeat.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RummySrvToDeskPushNewSeat message.
     * @function verify
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RummySrvToDeskPushNewSeat.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a RummySrvToDeskPushNewSeat message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RummySrvToDeskPushNewSeat} RummySrvToDeskPushNewSeat
     */
    RummySrvToDeskPushNewSeat.fromObject = function fromObject(object) {
        if (object instanceof $root.RummySrvToDeskPushNewSeat)
            return object;
        let message = new $root.RummySrvToDeskPushNewSeat();
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RummySrvToDeskPushNewSeat message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {RummySrvToDeskPushNewSeat} message RummySrvToDeskPushNewSeat
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RummySrvToDeskPushNewSeat.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.SeatNo = 0;
            object.UserID = 0;
        }
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this RummySrvToDeskPushNewSeat to JSON.
     * @function toJSON
     * @memberof RummySrvToDeskPushNewSeat
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RummySrvToDeskPushNewSeat.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RummySrvToDeskPushNewSeat
     * @function getTypeUrl
     * @memberof RummySrvToDeskPushNewSeat
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RummySrvToDeskPushNewSeat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RummySrvToDeskPushNewSeat";
    };

    return RummySrvToDeskPushNewSeat;
})();

export const TeenPattiSrvToDeskPushAssetInfo = $root.TeenPattiSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a TeenPattiSrvToDeskPushAssetInfo.
     * @exports ITeenPattiSrvToDeskPushAssetInfo
     * @interface ITeenPattiSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] TeenPattiSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] TeenPattiSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] TeenPattiSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] TeenPattiSrvToDeskPushAssetInfo Chip
     */

    /**
     * Constructs a new TeenPattiSrvToDeskPushAssetInfo.
     * @exports TeenPattiSrvToDeskPushAssetInfo
     * @classdesc Represents a TeenPattiSrvToDeskPushAssetInfo.
     * @implements ITeenPattiSrvToDeskPushAssetInfo
     * @constructor
     * @param {ITeenPattiSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function TeenPattiSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @instance
     */
    TeenPattiSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * TeenPattiSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @instance
     */
    TeenPattiSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * TeenPattiSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @instance
     */
    TeenPattiSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * TeenPattiSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @instance
     */
    TeenPattiSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * Creates a new TeenPattiSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {TeenPattiSrvToDeskPushAssetInfo} TeenPattiSrvToDeskPushAssetInfo instance
     */
    TeenPattiSrvToDeskPushAssetInfo.create = function create(properties) {
        return new TeenPattiSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushAssetInfo message. Does not implicitly {@link TeenPattiSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushAssetInfo} message TeenPattiSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link TeenPattiSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushAssetInfo} message TeenPattiSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiSrvToDeskPushAssetInfo} TeenPattiSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiSrvToDeskPushAssetInfo} TeenPattiSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a TeenPattiSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiSrvToDeskPushAssetInfo} TeenPattiSrvToDeskPushAssetInfo
     */
    TeenPattiSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.TeenPattiSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {TeenPattiSrvToDeskPushAssetInfo} message TeenPattiSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this TeenPattiSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof TeenPattiSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiSrvToDeskPushAssetInfo";
    };

    return TeenPattiSrvToDeskPushAssetInfo;
})();

export const Desk2TeenPattiSrvWaitForCharge = $root.Desk2TeenPattiSrvWaitForCharge = (() => {

    /**
     * Properties of a Desk2TeenPattiSrvWaitForCharge.
     * @exports IDesk2TeenPattiSrvWaitForCharge
     * @interface IDesk2TeenPattiSrvWaitForCharge
     * @property {number|null} [DeskNo] Desk2TeenPattiSrvWaitForCharge DeskNo
     * @property {number|null} [UserID] Desk2TeenPattiSrvWaitForCharge UserID
     * @property {number|null} [SeatNo] Desk2TeenPattiSrvWaitForCharge SeatNo
     * @property {boolean|null} [WatiOrder] Desk2TeenPattiSrvWaitForCharge WatiOrder
     */

    /**
     * Constructs a new Desk2TeenPattiSrvWaitForCharge.
     * @exports Desk2TeenPattiSrvWaitForCharge
     * @classdesc Represents a Desk2TeenPattiSrvWaitForCharge.
     * @implements IDesk2TeenPattiSrvWaitForCharge
     * @constructor
     * @param {IDesk2TeenPattiSrvWaitForCharge=} [properties] Properties to set
     */
    function Desk2TeenPattiSrvWaitForCharge(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TeenPattiSrvWaitForCharge DeskNo.
     * @member {number} DeskNo
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @instance
     */
    Desk2TeenPattiSrvWaitForCharge.prototype.DeskNo = 0;

    /**
     * Desk2TeenPattiSrvWaitForCharge UserID.
     * @member {number} UserID
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @instance
     */
    Desk2TeenPattiSrvWaitForCharge.prototype.UserID = 0;

    /**
     * Desk2TeenPattiSrvWaitForCharge SeatNo.
     * @member {number} SeatNo
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @instance
     */
    Desk2TeenPattiSrvWaitForCharge.prototype.SeatNo = 0;

    /**
     * Desk2TeenPattiSrvWaitForCharge WatiOrder.
     * @member {boolean} WatiOrder
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @instance
     */
    Desk2TeenPattiSrvWaitForCharge.prototype.WatiOrder = false;

    /**
     * Creates a new Desk2TeenPattiSrvWaitForCharge instance using the specified properties.
     * @function create
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {IDesk2TeenPattiSrvWaitForCharge=} [properties] Properties to set
     * @returns {Desk2TeenPattiSrvWaitForCharge} Desk2TeenPattiSrvWaitForCharge instance
     */
    Desk2TeenPattiSrvWaitForCharge.create = function create(properties) {
        return new Desk2TeenPattiSrvWaitForCharge(properties);
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvWaitForCharge message. Does not implicitly {@link Desk2TeenPattiSrvWaitForCharge.verify|verify} messages.
     * @function encode
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {IDesk2TeenPattiSrvWaitForCharge} message Desk2TeenPattiSrvWaitForCharge message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvWaitForCharge.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.WatiOrder != null && Object.hasOwnProperty.call(message, "WatiOrder"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.WatiOrder);
        return writer;
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvWaitForCharge message, length delimited. Does not implicitly {@link Desk2TeenPattiSrvWaitForCharge.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {IDesk2TeenPattiSrvWaitForCharge} message Desk2TeenPattiSrvWaitForCharge message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvWaitForCharge.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TeenPattiSrvWaitForCharge message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TeenPattiSrvWaitForCharge} Desk2TeenPattiSrvWaitForCharge
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvWaitForCharge.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TeenPattiSrvWaitForCharge();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.WatiOrder = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TeenPattiSrvWaitForCharge message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TeenPattiSrvWaitForCharge} Desk2TeenPattiSrvWaitForCharge
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvWaitForCharge.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TeenPattiSrvWaitForCharge message.
     * @function verify
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TeenPattiSrvWaitForCharge.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.WatiOrder != null && message.hasOwnProperty("WatiOrder"))
            if (typeof message.WatiOrder !== "boolean")
                return "WatiOrder: boolean expected";
        return null;
    };

    /**
     * Creates a Desk2TeenPattiSrvWaitForCharge message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TeenPattiSrvWaitForCharge} Desk2TeenPattiSrvWaitForCharge
     */
    Desk2TeenPattiSrvWaitForCharge.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TeenPattiSrvWaitForCharge)
            return object;
        let message = new $root.Desk2TeenPattiSrvWaitForCharge();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.WatiOrder != null)
            message.WatiOrder = Boolean(object.WatiOrder);
        return message;
    };

    /**
     * Creates a plain object from a Desk2TeenPattiSrvWaitForCharge message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {Desk2TeenPattiSrvWaitForCharge} message Desk2TeenPattiSrvWaitForCharge
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TeenPattiSrvWaitForCharge.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.WatiOrder = false;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.WatiOrder != null && message.hasOwnProperty("WatiOrder"))
            object.WatiOrder = message.WatiOrder;
        return object;
    };

    /**
     * Converts this Desk2TeenPattiSrvWaitForCharge to JSON.
     * @function toJSON
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TeenPattiSrvWaitForCharge.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TeenPattiSrvWaitForCharge
     * @function getTypeUrl
     * @memberof Desk2TeenPattiSrvWaitForCharge
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TeenPattiSrvWaitForCharge.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TeenPattiSrvWaitForCharge";
    };

    return Desk2TeenPattiSrvWaitForCharge;
})();

export const TeenPattiSrvToDeskPushStartGame = $root.TeenPattiSrvToDeskPushStartGame = (() => {

    /**
     * Properties of a TeenPattiSrvToDeskPushStartGame.
     * @exports ITeenPattiSrvToDeskPushStartGame
     * @interface ITeenPattiSrvToDeskPushStartGame
     * @property {number|null} [DealerID] TeenPattiSrvToDeskPushStartGame DealerID
     * @property {string|null} [Boot] TeenPattiSrvToDeskPushStartGame Boot
     * @property {string|null} [TotalPot] TeenPattiSrvToDeskPushStartGame TotalPot
     * @property {Array.<number>|null} [GamingIDs] TeenPattiSrvToDeskPushStartGame GamingIDs
     * @property {Array.<number>|null} [WatchingIDs] TeenPattiSrvToDeskPushStartGame WatchingIDs
     */

    /**
     * Constructs a new TeenPattiSrvToDeskPushStartGame.
     * @exports TeenPattiSrvToDeskPushStartGame
     * @classdesc Represents a TeenPattiSrvToDeskPushStartGame.
     * @implements ITeenPattiSrvToDeskPushStartGame
     * @constructor
     * @param {ITeenPattiSrvToDeskPushStartGame=} [properties] Properties to set
     */
    function TeenPattiSrvToDeskPushStartGame(properties) {
        this.GamingIDs = [];
        this.WatchingIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiSrvToDeskPushStartGame DealerID.
     * @member {number} DealerID
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     */
    TeenPattiSrvToDeskPushStartGame.prototype.DealerID = 0;

    /**
     * TeenPattiSrvToDeskPushStartGame Boot.
     * @member {string} Boot
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     */
    TeenPattiSrvToDeskPushStartGame.prototype.Boot = "";

    /**
     * TeenPattiSrvToDeskPushStartGame TotalPot.
     * @member {string} TotalPot
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     */
    TeenPattiSrvToDeskPushStartGame.prototype.TotalPot = "";

    /**
     * TeenPattiSrvToDeskPushStartGame GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     */
    TeenPattiSrvToDeskPushStartGame.prototype.GamingIDs = $util.emptyArray;

    /**
     * TeenPattiSrvToDeskPushStartGame WatchingIDs.
     * @member {Array.<number>} WatchingIDs
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     */
    TeenPattiSrvToDeskPushStartGame.prototype.WatchingIDs = $util.emptyArray;

    /**
     * Creates a new TeenPattiSrvToDeskPushStartGame instance using the specified properties.
     * @function create
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {ITeenPattiSrvToDeskPushStartGame=} [properties] Properties to set
     * @returns {TeenPattiSrvToDeskPushStartGame} TeenPattiSrvToDeskPushStartGame instance
     */
    TeenPattiSrvToDeskPushStartGame.create = function create(properties) {
        return new TeenPattiSrvToDeskPushStartGame(properties);
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushStartGame message. Does not implicitly {@link TeenPattiSrvToDeskPushStartGame.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {ITeenPattiSrvToDeskPushStartGame} message TeenPattiSrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushStartGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DealerID);
        if (message.Boot != null && Object.hasOwnProperty.call(message, "Boot"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Boot);
        if (message.TotalPot != null && Object.hasOwnProperty.call(message, "TotalPot"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.TotalPot);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.WatchingIDs != null && message.WatchingIDs.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                writer.uint32(message.WatchingIDs[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushStartGame message, length delimited. Does not implicitly {@link TeenPattiSrvToDeskPushStartGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {ITeenPattiSrvToDeskPushStartGame} message TeenPattiSrvToDeskPushStartGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushStartGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushStartGame message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiSrvToDeskPushStartGame} TeenPattiSrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushStartGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiSrvToDeskPushStartGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Boot = reader.string();
                    break;
                }
            case 3: {
                    message.TotalPot = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 5: {
                    if (!(message.WatchingIDs && message.WatchingIDs.length))
                        message.WatchingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.WatchingIDs.push(reader.uint32());
                    } else
                        message.WatchingIDs.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushStartGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiSrvToDeskPushStartGame} TeenPattiSrvToDeskPushStartGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushStartGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiSrvToDeskPushStartGame message.
     * @function verify
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiSrvToDeskPushStartGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            if (!$util.isString(message.Boot))
                return "Boot: string expected";
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            if (!$util.isString(message.TotalPot))
                return "TotalPot: string expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.WatchingIDs != null && message.hasOwnProperty("WatchingIDs")) {
            if (!Array.isArray(message.WatchingIDs))
                return "WatchingIDs: array expected";
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                if (!$util.isInteger(message.WatchingIDs[i]))
                    return "WatchingIDs: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a TeenPattiSrvToDeskPushStartGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiSrvToDeskPushStartGame} TeenPattiSrvToDeskPushStartGame
     */
    TeenPattiSrvToDeskPushStartGame.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiSrvToDeskPushStartGame)
            return object;
        let message = new $root.TeenPattiSrvToDeskPushStartGame();
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.Boot != null)
            message.Boot = String(object.Boot);
        if (object.TotalPot != null)
            message.TotalPot = String(object.TotalPot);
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".TeenPattiSrvToDeskPushStartGame.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.WatchingIDs) {
            if (!Array.isArray(object.WatchingIDs))
                throw TypeError(".TeenPattiSrvToDeskPushStartGame.WatchingIDs: array expected");
            message.WatchingIDs = [];
            for (let i = 0; i < object.WatchingIDs.length; ++i)
                message.WatchingIDs[i] = object.WatchingIDs[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiSrvToDeskPushStartGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {TeenPattiSrvToDeskPushStartGame} message TeenPattiSrvToDeskPushStartGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiSrvToDeskPushStartGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.WatchingIDs = [];
        }
        if (options.defaults) {
            object.DealerID = 0;
            object.Boot = "";
            object.TotalPot = "";
        }
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            object.Boot = message.Boot;
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            object.TotalPot = message.TotalPot;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.WatchingIDs && message.WatchingIDs.length) {
            object.WatchingIDs = [];
            for (let j = 0; j < message.WatchingIDs.length; ++j)
                object.WatchingIDs[j] = message.WatchingIDs[j];
        }
        return object;
    };

    /**
     * Converts this TeenPattiSrvToDeskPushStartGame to JSON.
     * @function toJSON
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiSrvToDeskPushStartGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiSrvToDeskPushStartGame
     * @function getTypeUrl
     * @memberof TeenPattiSrvToDeskPushStartGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiSrvToDeskPushStartGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiSrvToDeskPushStartGame";
    };

    return TeenPattiSrvToDeskPushStartGame;
})();

export const TeenPattiOperCmdTip = $root.TeenPattiOperCmdTip = (() => {

    /**
     * Properties of a TeenPattiOperCmdTip.
     * @exports ITeenPattiOperCmdTip
     * @interface ITeenPattiOperCmdTip
     * @property {number|null} [OperType] TeenPattiOperCmdTip OperType
     * @property {string|null} [MinBet] TeenPattiOperCmdTip MinBet
     * @property {string|null} [MaxBet] TeenPattiOperCmdTip MaxBet
     * @property {number|null} [ChallengedID] TeenPattiOperCmdTip ChallengedID
     */

    /**
     * Constructs a new TeenPattiOperCmdTip.
     * @exports TeenPattiOperCmdTip
     * @classdesc Represents a TeenPattiOperCmdTip.
     * @implements ITeenPattiOperCmdTip
     * @constructor
     * @param {ITeenPattiOperCmdTip=} [properties] Properties to set
     */
    function TeenPattiOperCmdTip(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiOperCmdTip OperType.
     * @member {number} OperType
     * @memberof TeenPattiOperCmdTip
     * @instance
     */
    TeenPattiOperCmdTip.prototype.OperType = 0;

    /**
     * TeenPattiOperCmdTip MinBet.
     * @member {string} MinBet
     * @memberof TeenPattiOperCmdTip
     * @instance
     */
    TeenPattiOperCmdTip.prototype.MinBet = "";

    /**
     * TeenPattiOperCmdTip MaxBet.
     * @member {string} MaxBet
     * @memberof TeenPattiOperCmdTip
     * @instance
     */
    TeenPattiOperCmdTip.prototype.MaxBet = "";

    /**
     * TeenPattiOperCmdTip ChallengedID.
     * @member {number} ChallengedID
     * @memberof TeenPattiOperCmdTip
     * @instance
     */
    TeenPattiOperCmdTip.prototype.ChallengedID = 0;

    /**
     * Creates a new TeenPattiOperCmdTip instance using the specified properties.
     * @function create
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {ITeenPattiOperCmdTip=} [properties] Properties to set
     * @returns {TeenPattiOperCmdTip} TeenPattiOperCmdTip instance
     */
    TeenPattiOperCmdTip.create = function create(properties) {
        return new TeenPattiOperCmdTip(properties);
    };

    /**
     * Encodes the specified TeenPattiOperCmdTip message. Does not implicitly {@link TeenPattiOperCmdTip.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {ITeenPattiOperCmdTip} message TeenPattiOperCmdTip message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiOperCmdTip.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OperType != null && Object.hasOwnProperty.call(message, "OperType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.OperType);
        if (message.MinBet != null && Object.hasOwnProperty.call(message, "MinBet"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.MinBet);
        if (message.MaxBet != null && Object.hasOwnProperty.call(message, "MaxBet"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.MaxBet);
        if (message.ChallengedID != null && Object.hasOwnProperty.call(message, "ChallengedID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ChallengedID);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiOperCmdTip message, length delimited. Does not implicitly {@link TeenPattiOperCmdTip.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {ITeenPattiOperCmdTip} message TeenPattiOperCmdTip message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiOperCmdTip.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiOperCmdTip message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiOperCmdTip} TeenPattiOperCmdTip
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiOperCmdTip.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiOperCmdTip();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.OperType = reader.uint32();
                    break;
                }
            case 2: {
                    message.MinBet = reader.string();
                    break;
                }
            case 3: {
                    message.MaxBet = reader.string();
                    break;
                }
            case 4: {
                    message.ChallengedID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiOperCmdTip message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiOperCmdTip} TeenPattiOperCmdTip
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiOperCmdTip.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiOperCmdTip message.
     * @function verify
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiOperCmdTip.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OperType != null && message.hasOwnProperty("OperType"))
            if (!$util.isInteger(message.OperType))
                return "OperType: integer expected";
        if (message.MinBet != null && message.hasOwnProperty("MinBet"))
            if (!$util.isString(message.MinBet))
                return "MinBet: string expected";
        if (message.MaxBet != null && message.hasOwnProperty("MaxBet"))
            if (!$util.isString(message.MaxBet))
                return "MaxBet: string expected";
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            if (!$util.isInteger(message.ChallengedID))
                return "ChallengedID: integer expected";
        return null;
    };

    /**
     * Creates a TeenPattiOperCmdTip message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiOperCmdTip} TeenPattiOperCmdTip
     */
    TeenPattiOperCmdTip.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiOperCmdTip)
            return object;
        let message = new $root.TeenPattiOperCmdTip();
        if (object.OperType != null)
            message.OperType = object.OperType >>> 0;
        if (object.MinBet != null)
            message.MinBet = String(object.MinBet);
        if (object.MaxBet != null)
            message.MaxBet = String(object.MaxBet);
        if (object.ChallengedID != null)
            message.ChallengedID = object.ChallengedID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiOperCmdTip message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {TeenPattiOperCmdTip} message TeenPattiOperCmdTip
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiOperCmdTip.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.OperType = 0;
            object.MinBet = "";
            object.MaxBet = "";
            object.ChallengedID = 0;
        }
        if (message.OperType != null && message.hasOwnProperty("OperType"))
            object.OperType = message.OperType;
        if (message.MinBet != null && message.hasOwnProperty("MinBet"))
            object.MinBet = message.MinBet;
        if (message.MaxBet != null && message.hasOwnProperty("MaxBet"))
            object.MaxBet = message.MaxBet;
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            object.ChallengedID = message.ChallengedID;
        return object;
    };

    /**
     * Converts this TeenPattiOperCmdTip to JSON.
     * @function toJSON
     * @memberof TeenPattiOperCmdTip
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiOperCmdTip.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiOperCmdTip
     * @function getTypeUrl
     * @memberof TeenPattiOperCmdTip
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiOperCmdTip.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiOperCmdTip";
    };

    return TeenPattiOperCmdTip;
})();

export const TeenPattiSrvToDeskPushCommandTips = $root.TeenPattiSrvToDeskPushCommandTips = (() => {

    /**
     * Properties of a TeenPattiSrvToDeskPushCommandTips.
     * @exports ITeenPattiSrvToDeskPushCommandTips
     * @interface ITeenPattiSrvToDeskPushCommandTips
     * @property {number|null} [UserID] TeenPattiSrvToDeskPushCommandTips UserID
     * @property {number|null} [Practitioner] TeenPattiSrvToDeskPushCommandTips Practitioner
     * @property {number|null} [PrevPractitioner] TeenPattiSrvToDeskPushCommandTips PrevPractitioner
     * @property {Array.<ITeenPattiOperCmdTip>|null} [Operation] TeenPattiSrvToDeskPushCommandTips Operation
     * @property {string|null} [BlindChip] TeenPattiSrvToDeskPushCommandTips BlindChip
     * @property {boolean|null} [IsPrevSeenCard] TeenPattiSrvToDeskPushCommandTips IsPrevSeenCard
     */

    /**
     * Constructs a new TeenPattiSrvToDeskPushCommandTips.
     * @exports TeenPattiSrvToDeskPushCommandTips
     * @classdesc Represents a TeenPattiSrvToDeskPushCommandTips.
     * @implements ITeenPattiSrvToDeskPushCommandTips
     * @constructor
     * @param {ITeenPattiSrvToDeskPushCommandTips=} [properties] Properties to set
     */
    function TeenPattiSrvToDeskPushCommandTips(properties) {
        this.Operation = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiSrvToDeskPushCommandTips UserID.
     * @member {number} UserID
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.UserID = 0;

    /**
     * TeenPattiSrvToDeskPushCommandTips Practitioner.
     * @member {number} Practitioner
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.Practitioner = 0;

    /**
     * TeenPattiSrvToDeskPushCommandTips PrevPractitioner.
     * @member {number} PrevPractitioner
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.PrevPractitioner = 0;

    /**
     * TeenPattiSrvToDeskPushCommandTips Operation.
     * @member {Array.<ITeenPattiOperCmdTip>} Operation
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.Operation = $util.emptyArray;

    /**
     * TeenPattiSrvToDeskPushCommandTips BlindChip.
     * @member {string} BlindChip
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.BlindChip = "";

    /**
     * TeenPattiSrvToDeskPushCommandTips IsPrevSeenCard.
     * @member {boolean} IsPrevSeenCard
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.IsPrevSeenCard = false;

    /**
     * Creates a new TeenPattiSrvToDeskPushCommandTips instance using the specified properties.
     * @function create
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {ITeenPattiSrvToDeskPushCommandTips=} [properties] Properties to set
     * @returns {TeenPattiSrvToDeskPushCommandTips} TeenPattiSrvToDeskPushCommandTips instance
     */
    TeenPattiSrvToDeskPushCommandTips.create = function create(properties) {
        return new TeenPattiSrvToDeskPushCommandTips(properties);
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushCommandTips message. Does not implicitly {@link TeenPattiSrvToDeskPushCommandTips.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {ITeenPattiSrvToDeskPushCommandTips} message TeenPattiSrvToDeskPushCommandTips message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushCommandTips.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Practitioner);
        if (message.PrevPractitioner != null && Object.hasOwnProperty.call(message, "PrevPractitioner"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.PrevPractitioner);
        if (message.Operation != null && message.Operation.length)
            for (let i = 0; i < message.Operation.length; ++i)
                $root.TeenPattiOperCmdTip.encode(message.Operation[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.BlindChip != null && Object.hasOwnProperty.call(message, "BlindChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BlindChip);
        if (message.IsPrevSeenCard != null && Object.hasOwnProperty.call(message, "IsPrevSeenCard"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.IsPrevSeenCard);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushCommandTips message, length delimited. Does not implicitly {@link TeenPattiSrvToDeskPushCommandTips.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {ITeenPattiSrvToDeskPushCommandTips} message TeenPattiSrvToDeskPushCommandTips message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushCommandTips.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushCommandTips message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiSrvToDeskPushCommandTips} TeenPattiSrvToDeskPushCommandTips
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushCommandTips.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiSrvToDeskPushCommandTips();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 3: {
                    message.PrevPractitioner = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.Operation && message.Operation.length))
                        message.Operation = [];
                    message.Operation.push($root.TeenPattiOperCmdTip.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.BlindChip = reader.string();
                    break;
                }
            case 6: {
                    message.IsPrevSeenCard = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushCommandTips message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiSrvToDeskPushCommandTips} TeenPattiSrvToDeskPushCommandTips
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushCommandTips.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiSrvToDeskPushCommandTips message.
     * @function verify
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiSrvToDeskPushCommandTips.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.PrevPractitioner != null && message.hasOwnProperty("PrevPractitioner"))
            if (!$util.isInteger(message.PrevPractitioner))
                return "PrevPractitioner: integer expected";
        if (message.Operation != null && message.hasOwnProperty("Operation")) {
            if (!Array.isArray(message.Operation))
                return "Operation: array expected";
            for (let i = 0; i < message.Operation.length; ++i) {
                let error = $root.TeenPattiOperCmdTip.verify(message.Operation[i]);
                if (error)
                    return "Operation." + error;
            }
        }
        if (message.BlindChip != null && message.hasOwnProperty("BlindChip"))
            if (!$util.isString(message.BlindChip))
                return "BlindChip: string expected";
        if (message.IsPrevSeenCard != null && message.hasOwnProperty("IsPrevSeenCard"))
            if (typeof message.IsPrevSeenCard !== "boolean")
                return "IsPrevSeenCard: boolean expected";
        return null;
    };

    /**
     * Creates a TeenPattiSrvToDeskPushCommandTips message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiSrvToDeskPushCommandTips} TeenPattiSrvToDeskPushCommandTips
     */
    TeenPattiSrvToDeskPushCommandTips.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiSrvToDeskPushCommandTips)
            return object;
        let message = new $root.TeenPattiSrvToDeskPushCommandTips();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.PrevPractitioner != null)
            message.PrevPractitioner = object.PrevPractitioner >>> 0;
        if (object.Operation) {
            if (!Array.isArray(object.Operation))
                throw TypeError(".TeenPattiSrvToDeskPushCommandTips.Operation: array expected");
            message.Operation = [];
            for (let i = 0; i < object.Operation.length; ++i) {
                if (typeof object.Operation[i] !== "object")
                    throw TypeError(".TeenPattiSrvToDeskPushCommandTips.Operation: object expected");
                message.Operation[i] = $root.TeenPattiOperCmdTip.fromObject(object.Operation[i]);
            }
        }
        if (object.BlindChip != null)
            message.BlindChip = String(object.BlindChip);
        if (object.IsPrevSeenCard != null)
            message.IsPrevSeenCard = Boolean(object.IsPrevSeenCard);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiSrvToDeskPushCommandTips message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {TeenPattiSrvToDeskPushCommandTips} message TeenPattiSrvToDeskPushCommandTips
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiSrvToDeskPushCommandTips.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Operation = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Practitioner = 0;
            object.PrevPractitioner = 0;
            object.BlindChip = "";
            object.IsPrevSeenCard = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.PrevPractitioner != null && message.hasOwnProperty("PrevPractitioner"))
            object.PrevPractitioner = message.PrevPractitioner;
        if (message.Operation && message.Operation.length) {
            object.Operation = [];
            for (let j = 0; j < message.Operation.length; ++j)
                object.Operation[j] = $root.TeenPattiOperCmdTip.toObject(message.Operation[j], options);
        }
        if (message.BlindChip != null && message.hasOwnProperty("BlindChip"))
            object.BlindChip = message.BlindChip;
        if (message.IsPrevSeenCard != null && message.hasOwnProperty("IsPrevSeenCard"))
            object.IsPrevSeenCard = message.IsPrevSeenCard;
        return object;
    };

    /**
     * Converts this TeenPattiSrvToDeskPushCommandTips to JSON.
     * @function toJSON
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiSrvToDeskPushCommandTips.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiSrvToDeskPushCommandTips
     * @function getTypeUrl
     * @memberof TeenPattiSrvToDeskPushCommandTips
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiSrvToDeskPushCommandTips.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiSrvToDeskPushCommandTips";
    };

    return TeenPattiSrvToDeskPushCommandTips;
})();

export const TeenPattiOperCmd = $root.TeenPattiOperCmd = (() => {

    /**
     * Properties of a TeenPattiOperCmd.
     * @exports ITeenPattiOperCmd
     * @interface ITeenPattiOperCmd
     * @property {number|null} [Practitioner] TeenPattiOperCmd Practitioner
     * @property {number|null} [Operation] TeenPattiOperCmd Operation
     * @property {string|null} [BetChip] TeenPattiOperCmd BetChip
     * @property {number|null} [ChallengedID] TeenPattiOperCmd ChallengedID
     */

    /**
     * Constructs a new TeenPattiOperCmd.
     * @exports TeenPattiOperCmd
     * @classdesc Represents a TeenPattiOperCmd.
     * @implements ITeenPattiOperCmd
     * @constructor
     * @param {ITeenPattiOperCmd=} [properties] Properties to set
     */
    function TeenPattiOperCmd(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiOperCmd Practitioner.
     * @member {number} Practitioner
     * @memberof TeenPattiOperCmd
     * @instance
     */
    TeenPattiOperCmd.prototype.Practitioner = 0;

    /**
     * TeenPattiOperCmd Operation.
     * @member {number} Operation
     * @memberof TeenPattiOperCmd
     * @instance
     */
    TeenPattiOperCmd.prototype.Operation = 0;

    /**
     * TeenPattiOperCmd BetChip.
     * @member {string} BetChip
     * @memberof TeenPattiOperCmd
     * @instance
     */
    TeenPattiOperCmd.prototype.BetChip = "";

    /**
     * TeenPattiOperCmd ChallengedID.
     * @member {number} ChallengedID
     * @memberof TeenPattiOperCmd
     * @instance
     */
    TeenPattiOperCmd.prototype.ChallengedID = 0;

    /**
     * Creates a new TeenPattiOperCmd instance using the specified properties.
     * @function create
     * @memberof TeenPattiOperCmd
     * @static
     * @param {ITeenPattiOperCmd=} [properties] Properties to set
     * @returns {TeenPattiOperCmd} TeenPattiOperCmd instance
     */
    TeenPattiOperCmd.create = function create(properties) {
        return new TeenPattiOperCmd(properties);
    };

    /**
     * Encodes the specified TeenPattiOperCmd message. Does not implicitly {@link TeenPattiOperCmd.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiOperCmd
     * @static
     * @param {ITeenPattiOperCmd} message TeenPattiOperCmd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiOperCmd.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Practitioner);
        if (message.Operation != null && Object.hasOwnProperty.call(message, "Operation"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Operation);
        if (message.BetChip != null && Object.hasOwnProperty.call(message, "BetChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetChip);
        if (message.ChallengedID != null && Object.hasOwnProperty.call(message, "ChallengedID"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ChallengedID);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiOperCmd message, length delimited. Does not implicitly {@link TeenPattiOperCmd.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiOperCmd
     * @static
     * @param {ITeenPattiOperCmd} message TeenPattiOperCmd message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiOperCmd.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiOperCmd message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiOperCmd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiOperCmd} TeenPattiOperCmd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiOperCmd.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiOperCmd();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 2: {
                    message.Operation = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetChip = reader.string();
                    break;
                }
            case 4: {
                    message.ChallengedID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiOperCmd message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiOperCmd
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiOperCmd} TeenPattiOperCmd
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiOperCmd.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiOperCmd message.
     * @function verify
     * @memberof TeenPattiOperCmd
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiOperCmd.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            if (!$util.isInteger(message.Operation))
                return "Operation: integer expected";
        if (message.BetChip != null && message.hasOwnProperty("BetChip"))
            if (!$util.isString(message.BetChip))
                return "BetChip: string expected";
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            if (!$util.isInteger(message.ChallengedID))
                return "ChallengedID: integer expected";
        return null;
    };

    /**
     * Creates a TeenPattiOperCmd message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiOperCmd
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiOperCmd} TeenPattiOperCmd
     */
    TeenPattiOperCmd.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiOperCmd)
            return object;
        let message = new $root.TeenPattiOperCmd();
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.Operation != null)
            message.Operation = object.Operation >>> 0;
        if (object.BetChip != null)
            message.BetChip = String(object.BetChip);
        if (object.ChallengedID != null)
            message.ChallengedID = object.ChallengedID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiOperCmd message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiOperCmd
     * @static
     * @param {TeenPattiOperCmd} message TeenPattiOperCmd
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiOperCmd.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Practitioner = 0;
            object.Operation = 0;
            object.BetChip = "";
            object.ChallengedID = 0;
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.Operation != null && message.hasOwnProperty("Operation"))
            object.Operation = message.Operation;
        if (message.BetChip != null && message.hasOwnProperty("BetChip"))
            object.BetChip = message.BetChip;
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            object.ChallengedID = message.ChallengedID;
        return object;
    };

    /**
     * Converts this TeenPattiOperCmd to JSON.
     * @function toJSON
     * @memberof TeenPattiOperCmd
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiOperCmd.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiOperCmd
     * @function getTypeUrl
     * @memberof TeenPattiOperCmd
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiOperCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiOperCmd";
    };

    return TeenPattiOperCmd;
})();

export const DeskToTeenPattiSrvPlayerCommandReq = $root.DeskToTeenPattiSrvPlayerCommandReq = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvPlayerCommandReq.
     * @exports IDeskToTeenPattiSrvPlayerCommandReq
     * @interface IDeskToTeenPattiSrvPlayerCommandReq
     * @property {number|null} [DeskNo] DeskToTeenPattiSrvPlayerCommandReq DeskNo
     * @property {number|null} [UserID] DeskToTeenPattiSrvPlayerCommandReq UserID
     * @property {number|null} [SeatNo] DeskToTeenPattiSrvPlayerCommandReq SeatNo
     * @property {ITeenPattiOperCmd|null} [Command] DeskToTeenPattiSrvPlayerCommandReq Command
     */

    /**
     * Constructs a new DeskToTeenPattiSrvPlayerCommandReq.
     * @exports DeskToTeenPattiSrvPlayerCommandReq
     * @classdesc Represents a DeskToTeenPattiSrvPlayerCommandReq.
     * @implements IDeskToTeenPattiSrvPlayerCommandReq
     * @constructor
     * @param {IDeskToTeenPattiSrvPlayerCommandReq=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvPlayerCommandReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvPlayerCommandReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandReq.prototype.DeskNo = 0;

    /**
     * DeskToTeenPattiSrvPlayerCommandReq UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandReq.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvPlayerCommandReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandReq.prototype.SeatNo = 0;

    /**
     * DeskToTeenPattiSrvPlayerCommandReq Command.
     * @member {ITeenPattiOperCmd|null|undefined} Command
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandReq.prototype.Command = null;

    /**
     * Creates a new DeskToTeenPattiSrvPlayerCommandReq instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandReq=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvPlayerCommandReq} DeskToTeenPattiSrvPlayerCommandReq instance
     */
    DeskToTeenPattiSrvPlayerCommandReq.create = function create(properties) {
        return new DeskToTeenPattiSrvPlayerCommandReq(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCommandReq message. Does not implicitly {@link DeskToTeenPattiSrvPlayerCommandReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandReq} message DeskToTeenPattiSrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCommandReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Command != null && Object.hasOwnProperty.call(message, "Command"))
            $root.TeenPattiOperCmd.encode(message.Command, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCommandReq message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvPlayerCommandReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandReq} message DeskToTeenPattiSrvPlayerCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCommandReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCommandReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvPlayerCommandReq} DeskToTeenPattiSrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCommandReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvPlayerCommandReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Command = $root.TeenPattiOperCmd.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCommandReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvPlayerCommandReq} DeskToTeenPattiSrvPlayerCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCommandReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvPlayerCommandReq message.
     * @function verify
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvPlayerCommandReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Command != null && message.hasOwnProperty("Command")) {
            let error = $root.TeenPattiOperCmd.verify(message.Command);
            if (error)
                return "Command." + error;
        }
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvPlayerCommandReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvPlayerCommandReq} DeskToTeenPattiSrvPlayerCommandReq
     */
    DeskToTeenPattiSrvPlayerCommandReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvPlayerCommandReq)
            return object;
        let message = new $root.DeskToTeenPattiSrvPlayerCommandReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Command != null) {
            if (typeof object.Command !== "object")
                throw TypeError(".DeskToTeenPattiSrvPlayerCommandReq.Command: object expected");
            message.Command = $root.TeenPattiOperCmd.fromObject(object.Command);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvPlayerCommandReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {DeskToTeenPattiSrvPlayerCommandReq} message DeskToTeenPattiSrvPlayerCommandReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvPlayerCommandReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Command = null;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Command != null && message.hasOwnProperty("Command"))
            object.Command = $root.TeenPattiOperCmd.toObject(message.Command, options);
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvPlayerCommandReq to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvPlayerCommandReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvPlayerCommandReq
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvPlayerCommandReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvPlayerCommandReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvPlayerCommandReq";
    };

    return DeskToTeenPattiSrvPlayerCommandReq;
})();

export const DeskToTeenPattiSrvPlayerCommandAck = $root.DeskToTeenPattiSrvPlayerCommandAck = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvPlayerCommandAck.
     * @exports IDeskToTeenPattiSrvPlayerCommandAck
     * @interface IDeskToTeenPattiSrvPlayerCommandAck
     * @property {number|null} [Ret] DeskToTeenPattiSrvPlayerCommandAck Ret
     * @property {number|null} [UserID] DeskToTeenPattiSrvPlayerCommandAck UserID
     * @property {ITeenPattiOperCmd|null} [Command] DeskToTeenPattiSrvPlayerCommandAck Command
     * @property {string|null} [TotalPot] DeskToTeenPattiSrvPlayerCommandAck TotalPot
     * @property {string|null} [CurEnterChip] DeskToTeenPattiSrvPlayerCommandAck CurEnterChip
     * @property {number|null} [CurBlind] DeskToTeenPattiSrvPlayerCommandAck CurBlind
     */

    /**
     * Constructs a new DeskToTeenPattiSrvPlayerCommandAck.
     * @exports DeskToTeenPattiSrvPlayerCommandAck
     * @classdesc Represents a DeskToTeenPattiSrvPlayerCommandAck.
     * @implements IDeskToTeenPattiSrvPlayerCommandAck
     * @constructor
     * @param {IDeskToTeenPattiSrvPlayerCommandAck=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvPlayerCommandAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvPlayerCommandAck Ret.
     * @member {number} Ret
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.Ret = 0;

    /**
     * DeskToTeenPattiSrvPlayerCommandAck UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvPlayerCommandAck Command.
     * @member {ITeenPattiOperCmd|null|undefined} Command
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.Command = null;

    /**
     * DeskToTeenPattiSrvPlayerCommandAck TotalPot.
     * @member {string} TotalPot
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.TotalPot = "";

    /**
     * DeskToTeenPattiSrvPlayerCommandAck CurEnterChip.
     * @member {string} CurEnterChip
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.CurEnterChip = "";

    /**
     * DeskToTeenPattiSrvPlayerCommandAck CurBlind.
     * @member {number} CurBlind
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.CurBlind = 0;

    /**
     * Creates a new DeskToTeenPattiSrvPlayerCommandAck instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandAck=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvPlayerCommandAck} DeskToTeenPattiSrvPlayerCommandAck instance
     */
    DeskToTeenPattiSrvPlayerCommandAck.create = function create(properties) {
        return new DeskToTeenPattiSrvPlayerCommandAck(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCommandAck message. Does not implicitly {@link DeskToTeenPattiSrvPlayerCommandAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandAck} message DeskToTeenPattiSrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCommandAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Command != null && Object.hasOwnProperty.call(message, "Command"))
            $root.TeenPattiOperCmd.encode(message.Command, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.TotalPot != null && Object.hasOwnProperty.call(message, "TotalPot"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalPot);
        if (message.CurEnterChip != null && Object.hasOwnProperty.call(message, "CurEnterChip"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.CurEnterChip);
        if (message.CurBlind != null && Object.hasOwnProperty.call(message, "CurBlind"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.CurBlind);
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCommandAck message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvPlayerCommandAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCommandAck} message DeskToTeenPattiSrvPlayerCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCommandAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCommandAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvPlayerCommandAck} DeskToTeenPattiSrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCommandAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvPlayerCommandAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Command = $root.TeenPattiOperCmd.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.TotalPot = reader.string();
                    break;
                }
            case 5: {
                    message.CurEnterChip = reader.string();
                    break;
                }
            case 6: {
                    message.CurBlind = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCommandAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvPlayerCommandAck} DeskToTeenPattiSrvPlayerCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCommandAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvPlayerCommandAck message.
     * @function verify
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvPlayerCommandAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Command != null && message.hasOwnProperty("Command")) {
            let error = $root.TeenPattiOperCmd.verify(message.Command);
            if (error)
                return "Command." + error;
        }
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            if (!$util.isString(message.TotalPot))
                return "TotalPot: string expected";
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            if (!$util.isString(message.CurEnterChip))
                return "CurEnterChip: string expected";
        if (message.CurBlind != null && message.hasOwnProperty("CurBlind"))
            if (!$util.isInteger(message.CurBlind))
                return "CurBlind: integer expected";
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvPlayerCommandAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvPlayerCommandAck} DeskToTeenPattiSrvPlayerCommandAck
     */
    DeskToTeenPattiSrvPlayerCommandAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvPlayerCommandAck)
            return object;
        let message = new $root.DeskToTeenPattiSrvPlayerCommandAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Command != null) {
            if (typeof object.Command !== "object")
                throw TypeError(".DeskToTeenPattiSrvPlayerCommandAck.Command: object expected");
            message.Command = $root.TeenPattiOperCmd.fromObject(object.Command);
        }
        if (object.TotalPot != null)
            message.TotalPot = String(object.TotalPot);
        if (object.CurEnterChip != null)
            message.CurEnterChip = String(object.CurEnterChip);
        if (object.CurBlind != null)
            message.CurBlind = object.CurBlind >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvPlayerCommandAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {DeskToTeenPattiSrvPlayerCommandAck} message DeskToTeenPattiSrvPlayerCommandAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvPlayerCommandAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
            object.Command = null;
            object.TotalPot = "";
            object.CurEnterChip = "";
            object.CurBlind = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Command != null && message.hasOwnProperty("Command"))
            object.Command = $root.TeenPattiOperCmd.toObject(message.Command, options);
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            object.TotalPot = message.TotalPot;
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            object.CurEnterChip = message.CurEnterChip;
        if (message.CurBlind != null && message.hasOwnProperty("CurBlind"))
            object.CurBlind = message.CurBlind;
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvPlayerCommandAck to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvPlayerCommandAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvPlayerCommandAck
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvPlayerCommandAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvPlayerCommandAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvPlayerCommandAck";
    };

    return DeskToTeenPattiSrvPlayerCommandAck;
})();

export const DeskToTeenPattiSrvRecordCommandReq = $root.DeskToTeenPattiSrvRecordCommandReq = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvRecordCommandReq.
     * @exports IDeskToTeenPattiSrvRecordCommandReq
     * @interface IDeskToTeenPattiSrvRecordCommandReq
     * @property {number|null} [DeskNo] DeskToTeenPattiSrvRecordCommandReq DeskNo
     * @property {number|null} [UserID] DeskToTeenPattiSrvRecordCommandReq UserID
     * @property {number|null} [SeatNo] DeskToTeenPattiSrvRecordCommandReq SeatNo
     */

    /**
     * Constructs a new DeskToTeenPattiSrvRecordCommandReq.
     * @exports DeskToTeenPattiSrvRecordCommandReq
     * @classdesc Represents a DeskToTeenPattiSrvRecordCommandReq.
     * @implements IDeskToTeenPattiSrvRecordCommandReq
     * @constructor
     * @param {IDeskToTeenPattiSrvRecordCommandReq=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvRecordCommandReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvRecordCommandReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandReq.prototype.DeskNo = 0;

    /**
     * DeskToTeenPattiSrvRecordCommandReq UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandReq.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvRecordCommandReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandReq.prototype.SeatNo = 0;

    /**
     * Creates a new DeskToTeenPattiSrvRecordCommandReq instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandReq=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvRecordCommandReq} DeskToTeenPattiSrvRecordCommandReq instance
     */
    DeskToTeenPattiSrvRecordCommandReq.create = function create(properties) {
        return new DeskToTeenPattiSrvRecordCommandReq(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvRecordCommandReq message. Does not implicitly {@link DeskToTeenPattiSrvRecordCommandReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandReq} message DeskToTeenPattiSrvRecordCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvRecordCommandReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvRecordCommandReq message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvRecordCommandReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandReq} message DeskToTeenPattiSrvRecordCommandReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvRecordCommandReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvRecordCommandReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvRecordCommandReq} DeskToTeenPattiSrvRecordCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvRecordCommandReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvRecordCommandReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvRecordCommandReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvRecordCommandReq} DeskToTeenPattiSrvRecordCommandReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvRecordCommandReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvRecordCommandReq message.
     * @function verify
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvRecordCommandReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvRecordCommandReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvRecordCommandReq} DeskToTeenPattiSrvRecordCommandReq
     */
    DeskToTeenPattiSrvRecordCommandReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvRecordCommandReq)
            return object;
        let message = new $root.DeskToTeenPattiSrvRecordCommandReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvRecordCommandReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {DeskToTeenPattiSrvRecordCommandReq} message DeskToTeenPattiSrvRecordCommandReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvRecordCommandReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvRecordCommandReq to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvRecordCommandReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvRecordCommandReq
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvRecordCommandReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvRecordCommandReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvRecordCommandReq";
    };

    return DeskToTeenPattiSrvRecordCommandReq;
})();

export const Details = $root.Details = (() => {

    /**
     * Properties of a Details.
     * @exports IDetails
     * @interface IDetails
     * @property {number|null} [UserID] Details UserID
     * @property {number|null} [SeatNo] Details SeatNo
     * @property {string|null} [NickName] Details NickName
     * @property {number|null} [Score] Details Score
     * @property {Array.<number>|null} [Card] Details Card
     * @property {boolean|null} [Laycard] Details Laycard
     */

    /**
     * Constructs a new Details.
     * @exports Details
     * @classdesc Represents a Details.
     * @implements IDetails
     * @constructor
     * @param {IDetails=} [properties] Properties to set
     */
    function Details(properties) {
        this.Card = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Details UserID.
     * @member {number} UserID
     * @memberof Details
     * @instance
     */
    Details.prototype.UserID = 0;

    /**
     * Details SeatNo.
     * @member {number} SeatNo
     * @memberof Details
     * @instance
     */
    Details.prototype.SeatNo = 0;

    /**
     * Details NickName.
     * @member {string} NickName
     * @memberof Details
     * @instance
     */
    Details.prototype.NickName = "";

    /**
     * Details Score.
     * @member {number} Score
     * @memberof Details
     * @instance
     */
    Details.prototype.Score = 0;

    /**
     * Details Card.
     * @member {Array.<number>} Card
     * @memberof Details
     * @instance
     */
    Details.prototype.Card = $util.emptyArray;

    /**
     * Details Laycard.
     * @member {boolean} Laycard
     * @memberof Details
     * @instance
     */
    Details.prototype.Laycard = false;

    /**
     * Creates a new Details instance using the specified properties.
     * @function create
     * @memberof Details
     * @static
     * @param {IDetails=} [properties] Properties to set
     * @returns {Details} Details instance
     */
    Details.create = function create(properties) {
        return new Details(properties);
    };

    /**
     * Encodes the specified Details message. Does not implicitly {@link Details.verify|verify} messages.
     * @function encode
     * @memberof Details
     * @static
     * @param {IDetails} message Details message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Details.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.SeatNo);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.NickName);
        if (message.Score != null && Object.hasOwnProperty.call(message, "Score"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Score);
        if (message.Card != null && message.Card.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.Card.length; ++i)
                writer.int32(message.Card[i]);
            writer.ldelim();
        }
        if (message.Laycard != null && Object.hasOwnProperty.call(message, "Laycard"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Laycard);
        return writer;
    };

    /**
     * Encodes the specified Details message, length delimited. Does not implicitly {@link Details.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Details
     * @static
     * @param {IDetails} message Details message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Details.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Details message from the specified reader or buffer.
     * @function decode
     * @memberof Details
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Details} Details
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Details.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Details();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.int32();
                    break;
                }
            case 2: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 3: {
                    message.NickName = reader.string();
                    break;
                }
            case 4: {
                    message.Score = reader.int32();
                    break;
                }
            case 5: {
                    if (!(message.Card && message.Card.length))
                        message.Card = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Card.push(reader.int32());
                    } else
                        message.Card.push(reader.int32());
                    break;
                }
            case 6: {
                    message.Laycard = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Details message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Details
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Details} Details
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Details.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Details message.
     * @function verify
     * @memberof Details
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Details.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!$util.isString(message.NickName))
                return "NickName: string expected";
        if (message.Score != null && message.hasOwnProperty("Score"))
            if (!$util.isInteger(message.Score))
                return "Score: integer expected";
        if (message.Card != null && message.hasOwnProperty("Card")) {
            if (!Array.isArray(message.Card))
                return "Card: array expected";
            for (let i = 0; i < message.Card.length; ++i)
                if (!$util.isInteger(message.Card[i]))
                    return "Card: integer[] expected";
        }
        if (message.Laycard != null && message.hasOwnProperty("Laycard"))
            if (typeof message.Laycard !== "boolean")
                return "Laycard: boolean expected";
        return null;
    };

    /**
     * Creates a Details message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Details
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Details} Details
     */
    Details.fromObject = function fromObject(object) {
        if (object instanceof $root.Details)
            return object;
        let message = new $root.Details();
        if (object.UserID != null)
            message.UserID = object.UserID | 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.NickName != null)
            message.NickName = String(object.NickName);
        if (object.Score != null)
            message.Score = object.Score | 0;
        if (object.Card) {
            if (!Array.isArray(object.Card))
                throw TypeError(".Details.Card: array expected");
            message.Card = [];
            for (let i = 0; i < object.Card.length; ++i)
                message.Card[i] = object.Card[i] | 0;
        }
        if (object.Laycard != null)
            message.Laycard = Boolean(object.Laycard);
        return message;
    };

    /**
     * Creates a plain object from a Details message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Details
     * @static
     * @param {Details} message Details
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Details.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Card = [];
        if (options.defaults) {
            object.UserID = 0;
            object.SeatNo = 0;
            object.NickName = "";
            object.Score = 0;
            object.Laycard = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = message.NickName;
        if (message.Score != null && message.hasOwnProperty("Score"))
            object.Score = message.Score;
        if (message.Card && message.Card.length) {
            object.Card = [];
            for (let j = 0; j < message.Card.length; ++j)
                object.Card[j] = message.Card[j];
        }
        if (message.Laycard != null && message.hasOwnProperty("Laycard"))
            object.Laycard = message.Laycard;
        return object;
    };

    /**
     * Converts this Details to JSON.
     * @function toJSON
     * @memberof Details
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Details.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Details
     * @function getTypeUrl
     * @memberof Details
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Details.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Details";
    };

    return Details;
})();

export const RecordS = $root.RecordS = (() => {

    /**
     * Properties of a RecordS.
     * @exports IRecordS
     * @interface IRecordS
     * @property {Array.<IDetails>|null} [Detail] RecordS Detail
     */

    /**
     * Constructs a new RecordS.
     * @exports RecordS
     * @classdesc Represents a RecordS.
     * @implements IRecordS
     * @constructor
     * @param {IRecordS=} [properties] Properties to set
     */
    function RecordS(properties) {
        this.Detail = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RecordS Detail.
     * @member {Array.<IDetails>} Detail
     * @memberof RecordS
     * @instance
     */
    RecordS.prototype.Detail = $util.emptyArray;

    /**
     * Creates a new RecordS instance using the specified properties.
     * @function create
     * @memberof RecordS
     * @static
     * @param {IRecordS=} [properties] Properties to set
     * @returns {RecordS} RecordS instance
     */
    RecordS.create = function create(properties) {
        return new RecordS(properties);
    };

    /**
     * Encodes the specified RecordS message. Does not implicitly {@link RecordS.verify|verify} messages.
     * @function encode
     * @memberof RecordS
     * @static
     * @param {IRecordS} message RecordS message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RecordS.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Detail != null && message.Detail.length)
            for (let i = 0; i < message.Detail.length; ++i)
                $root.Details.encode(message.Detail[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RecordS message, length delimited. Does not implicitly {@link RecordS.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RecordS
     * @static
     * @param {IRecordS} message RecordS message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RecordS.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RecordS message from the specified reader or buffer.
     * @function decode
     * @memberof RecordS
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RecordS} RecordS
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RecordS.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RecordS();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.Detail && message.Detail.length))
                        message.Detail = [];
                    message.Detail.push($root.Details.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RecordS message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RecordS
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RecordS} RecordS
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RecordS.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RecordS message.
     * @function verify
     * @memberof RecordS
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RecordS.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Detail != null && message.hasOwnProperty("Detail")) {
            if (!Array.isArray(message.Detail))
                return "Detail: array expected";
            for (let i = 0; i < message.Detail.length; ++i) {
                let error = $root.Details.verify(message.Detail[i]);
                if (error)
                    return "Detail." + error;
            }
        }
        return null;
    };

    /**
     * Creates a RecordS message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RecordS
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RecordS} RecordS
     */
    RecordS.fromObject = function fromObject(object) {
        if (object instanceof $root.RecordS)
            return object;
        let message = new $root.RecordS();
        if (object.Detail) {
            if (!Array.isArray(object.Detail))
                throw TypeError(".RecordS.Detail: array expected");
            message.Detail = [];
            for (let i = 0; i < object.Detail.length; ++i) {
                if (typeof object.Detail[i] !== "object")
                    throw TypeError(".RecordS.Detail: object expected");
                message.Detail[i] = $root.Details.fromObject(object.Detail[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a RecordS message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RecordS
     * @static
     * @param {RecordS} message RecordS
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RecordS.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Detail = [];
        if (message.Detail && message.Detail.length) {
            object.Detail = [];
            for (let j = 0; j < message.Detail.length; ++j)
                object.Detail[j] = $root.Details.toObject(message.Detail[j], options);
        }
        return object;
    };

    /**
     * Converts this RecordS to JSON.
     * @function toJSON
     * @memberof RecordS
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RecordS.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RecordS
     * @function getTypeUrl
     * @memberof RecordS
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RecordS.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RecordS";
    };

    return RecordS;
})();

export const DeskToTeenPattiSrvRecordCommandAck = $root.DeskToTeenPattiSrvRecordCommandAck = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvRecordCommandAck.
     * @exports IDeskToTeenPattiSrvRecordCommandAck
     * @interface IDeskToTeenPattiSrvRecordCommandAck
     * @property {number|null} [Ret] DeskToTeenPattiSrvRecordCommandAck Ret
     * @property {number|null} [UserID] DeskToTeenPattiSrvRecordCommandAck UserID
     * @property {Array.<IRecordS>|null} [Record] DeskToTeenPattiSrvRecordCommandAck Record
     */

    /**
     * Constructs a new DeskToTeenPattiSrvRecordCommandAck.
     * @exports DeskToTeenPattiSrvRecordCommandAck
     * @classdesc Represents a DeskToTeenPattiSrvRecordCommandAck.
     * @implements IDeskToTeenPattiSrvRecordCommandAck
     * @constructor
     * @param {IDeskToTeenPattiSrvRecordCommandAck=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvRecordCommandAck(properties) {
        this.Record = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvRecordCommandAck Ret.
     * @member {number} Ret
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandAck.prototype.Ret = 0;

    /**
     * DeskToTeenPattiSrvRecordCommandAck UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandAck.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvRecordCommandAck Record.
     * @member {Array.<IRecordS>} Record
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @instance
     */
    DeskToTeenPattiSrvRecordCommandAck.prototype.Record = $util.emptyArray;

    /**
     * Creates a new DeskToTeenPattiSrvRecordCommandAck instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandAck=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvRecordCommandAck} DeskToTeenPattiSrvRecordCommandAck instance
     */
    DeskToTeenPattiSrvRecordCommandAck.create = function create(properties) {
        return new DeskToTeenPattiSrvRecordCommandAck(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvRecordCommandAck message. Does not implicitly {@link DeskToTeenPattiSrvRecordCommandAck.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandAck} message DeskToTeenPattiSrvRecordCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvRecordCommandAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.Record != null && message.Record.length)
            for (let i = 0; i < message.Record.length; ++i)
                $root.RecordS.encode(message.Record[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvRecordCommandAck message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvRecordCommandAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {IDeskToTeenPattiSrvRecordCommandAck} message DeskToTeenPattiSrvRecordCommandAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvRecordCommandAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvRecordCommandAck message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvRecordCommandAck} DeskToTeenPattiSrvRecordCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvRecordCommandAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvRecordCommandAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Record && message.Record.length))
                        message.Record = [];
                    message.Record.push($root.RecordS.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvRecordCommandAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvRecordCommandAck} DeskToTeenPattiSrvRecordCommandAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvRecordCommandAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvRecordCommandAck message.
     * @function verify
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvRecordCommandAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Record != null && message.hasOwnProperty("Record")) {
            if (!Array.isArray(message.Record))
                return "Record: array expected";
            for (let i = 0; i < message.Record.length; ++i) {
                let error = $root.RecordS.verify(message.Record[i]);
                if (error)
                    return "Record." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvRecordCommandAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvRecordCommandAck} DeskToTeenPattiSrvRecordCommandAck
     */
    DeskToTeenPattiSrvRecordCommandAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvRecordCommandAck)
            return object;
        let message = new $root.DeskToTeenPattiSrvRecordCommandAck();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Record) {
            if (!Array.isArray(object.Record))
                throw TypeError(".DeskToTeenPattiSrvRecordCommandAck.Record: array expected");
            message.Record = [];
            for (let i = 0; i < object.Record.length; ++i) {
                if (typeof object.Record[i] !== "object")
                    throw TypeError(".DeskToTeenPattiSrvRecordCommandAck.Record: object expected");
                message.Record[i] = $root.RecordS.fromObject(object.Record[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvRecordCommandAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {DeskToTeenPattiSrvRecordCommandAck} message DeskToTeenPattiSrvRecordCommandAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvRecordCommandAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Record = [];
        if (options.defaults) {
            object.Ret = 0;
            object.UserID = 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Record && message.Record.length) {
            object.Record = [];
            for (let j = 0; j < message.Record.length; ++j)
                object.Record[j] = $root.RecordS.toObject(message.Record[j], options);
        }
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvRecordCommandAck to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvRecordCommandAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvRecordCommandAck
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvRecordCommandAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvRecordCommandAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvRecordCommandAck";
    };

    return DeskToTeenPattiSrvRecordCommandAck;
})();

export const DeskToTeenPattiSrvPushCompareResult = $root.DeskToTeenPattiSrvPushCompareResult = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvPushCompareResult.
     * @exports IDeskToTeenPattiSrvPushCompareResult
     * @interface IDeskToTeenPattiSrvPushCompareResult
     * @property {number|null} [UserID] DeskToTeenPattiSrvPushCompareResult UserID
     * @property {number|null} [CompareType] DeskToTeenPattiSrvPushCompareResult CompareType
     * @property {number|null} [Ret] DeskToTeenPattiSrvPushCompareResult Ret
     * @property {ITeenPattiCardRes|null} [Challenger] DeskToTeenPattiSrvPushCompareResult Challenger
     * @property {ITeenPattiCardRes|null} [Challenged] DeskToTeenPattiSrvPushCompareResult Challenged
     * @property {number|null} [IsWin] DeskToTeenPattiSrvPushCompareResult IsWin
     */

    /**
     * Constructs a new DeskToTeenPattiSrvPushCompareResult.
     * @exports DeskToTeenPattiSrvPushCompareResult
     * @classdesc Represents a DeskToTeenPattiSrvPushCompareResult.
     * @implements IDeskToTeenPattiSrvPushCompareResult
     * @constructor
     * @param {IDeskToTeenPattiSrvPushCompareResult=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvPushCompareResult(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvPushCompareResult UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvPushCompareResult CompareType.
     * @member {number} CompareType
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.CompareType = 0;

    /**
     * DeskToTeenPattiSrvPushCompareResult Ret.
     * @member {number} Ret
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.Ret = 0;

    /**
     * DeskToTeenPattiSrvPushCompareResult Challenger.
     * @member {ITeenPattiCardRes|null|undefined} Challenger
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.Challenger = null;

    /**
     * DeskToTeenPattiSrvPushCompareResult Challenged.
     * @member {ITeenPattiCardRes|null|undefined} Challenged
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.Challenged = null;

    /**
     * DeskToTeenPattiSrvPushCompareResult IsWin.
     * @member {number} IsWin
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.IsWin = 0;

    /**
     * Creates a new DeskToTeenPattiSrvPushCompareResult instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {IDeskToTeenPattiSrvPushCompareResult=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvPushCompareResult} DeskToTeenPattiSrvPushCompareResult instance
     */
    DeskToTeenPattiSrvPushCompareResult.create = function create(properties) {
        return new DeskToTeenPattiSrvPushCompareResult(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPushCompareResult message. Does not implicitly {@link DeskToTeenPattiSrvPushCompareResult.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {IDeskToTeenPattiSrvPushCompareResult} message DeskToTeenPattiSrvPushCompareResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPushCompareResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CompareType != null && Object.hasOwnProperty.call(message, "CompareType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CompareType);
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Ret);
        if (message.Challenger != null && Object.hasOwnProperty.call(message, "Challenger"))
            $root.TeenPattiCardRes.encode(message.Challenger, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.Challenged != null && Object.hasOwnProperty.call(message, "Challenged"))
            $root.TeenPattiCardRes.encode(message.Challenged, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.IsWin != null && Object.hasOwnProperty.call(message, "IsWin"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.IsWin);
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPushCompareResult message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvPushCompareResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {IDeskToTeenPattiSrvPushCompareResult} message DeskToTeenPattiSrvPushCompareResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPushCompareResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvPushCompareResult message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvPushCompareResult} DeskToTeenPattiSrvPushCompareResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPushCompareResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvPushCompareResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CompareType = reader.uint32();
                    break;
                }
            case 3: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 4: {
                    message.Challenger = $root.TeenPattiCardRes.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.Challenged = $root.TeenPattiCardRes.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.IsWin = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvPushCompareResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvPushCompareResult} DeskToTeenPattiSrvPushCompareResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPushCompareResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvPushCompareResult message.
     * @function verify
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvPushCompareResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            if (!$util.isInteger(message.CompareType))
                return "CompareType: integer expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.Challenger != null && message.hasOwnProperty("Challenger")) {
            let error = $root.TeenPattiCardRes.verify(message.Challenger);
            if (error)
                return "Challenger." + error;
        }
        if (message.Challenged != null && message.hasOwnProperty("Challenged")) {
            let error = $root.TeenPattiCardRes.verify(message.Challenged);
            if (error)
                return "Challenged." + error;
        }
        if (message.IsWin != null && message.hasOwnProperty("IsWin"))
            if (!$util.isInteger(message.IsWin))
                return "IsWin: integer expected";
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvPushCompareResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvPushCompareResult} DeskToTeenPattiSrvPushCompareResult
     */
    DeskToTeenPattiSrvPushCompareResult.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvPushCompareResult)
            return object;
        let message = new $root.DeskToTeenPattiSrvPushCompareResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CompareType != null)
            message.CompareType = object.CompareType >>> 0;
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.Challenger != null) {
            if (typeof object.Challenger !== "object")
                throw TypeError(".DeskToTeenPattiSrvPushCompareResult.Challenger: object expected");
            message.Challenger = $root.TeenPattiCardRes.fromObject(object.Challenger);
        }
        if (object.Challenged != null) {
            if (typeof object.Challenged !== "object")
                throw TypeError(".DeskToTeenPattiSrvPushCompareResult.Challenged: object expected");
            message.Challenged = $root.TeenPattiCardRes.fromObject(object.Challenged);
        }
        if (object.IsWin != null)
            message.IsWin = object.IsWin >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvPushCompareResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {DeskToTeenPattiSrvPushCompareResult} message DeskToTeenPattiSrvPushCompareResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvPushCompareResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.CompareType = 0;
            object.Ret = 0;
            object.Challenger = null;
            object.Challenged = null;
            object.IsWin = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            object.CompareType = message.CompareType;
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.Challenger != null && message.hasOwnProperty("Challenger"))
            object.Challenger = $root.TeenPattiCardRes.toObject(message.Challenger, options);
        if (message.Challenged != null && message.hasOwnProperty("Challenged"))
            object.Challenged = $root.TeenPattiCardRes.toObject(message.Challenged, options);
        if (message.IsWin != null && message.hasOwnProperty("IsWin"))
            object.IsWin = message.IsWin;
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvPushCompareResult to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvPushCompareResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvPushCompareResult
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvPushCompareResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvPushCompareResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvPushCompareResult";
    };

    return DeskToTeenPattiSrvPushCompareResult;
})();

export const TeenPattiGoldRes = $root.TeenPattiGoldRes = (() => {

    /**
     * Properties of a TeenPattiGoldRes.
     * @exports ITeenPattiGoldRes
     * @interface ITeenPattiGoldRes
     * @property {number|null} [UserID] TeenPattiGoldRes UserID
     * @property {string|null} [WinGold] TeenPattiGoldRes WinGold
     * @property {string|null} [ChangeGold] TeenPattiGoldRes ChangeGold
     * @property {string|null} [TotalEnterChip] TeenPattiGoldRes TotalEnterChip
     */

    /**
     * Constructs a new TeenPattiGoldRes.
     * @exports TeenPattiGoldRes
     * @classdesc Represents a TeenPattiGoldRes.
     * @implements ITeenPattiGoldRes
     * @constructor
     * @param {ITeenPattiGoldRes=} [properties] Properties to set
     */
    function TeenPattiGoldRes(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiGoldRes UserID.
     * @member {number} UserID
     * @memberof TeenPattiGoldRes
     * @instance
     */
    TeenPattiGoldRes.prototype.UserID = 0;

    /**
     * TeenPattiGoldRes WinGold.
     * @member {string} WinGold
     * @memberof TeenPattiGoldRes
     * @instance
     */
    TeenPattiGoldRes.prototype.WinGold = "";

    /**
     * TeenPattiGoldRes ChangeGold.
     * @member {string} ChangeGold
     * @memberof TeenPattiGoldRes
     * @instance
     */
    TeenPattiGoldRes.prototype.ChangeGold = "";

    /**
     * TeenPattiGoldRes TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof TeenPattiGoldRes
     * @instance
     */
    TeenPattiGoldRes.prototype.TotalEnterChip = "";

    /**
     * Creates a new TeenPattiGoldRes instance using the specified properties.
     * @function create
     * @memberof TeenPattiGoldRes
     * @static
     * @param {ITeenPattiGoldRes=} [properties] Properties to set
     * @returns {TeenPattiGoldRes} TeenPattiGoldRes instance
     */
    TeenPattiGoldRes.create = function create(properties) {
        return new TeenPattiGoldRes(properties);
    };

    /**
     * Encodes the specified TeenPattiGoldRes message. Does not implicitly {@link TeenPattiGoldRes.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiGoldRes
     * @static
     * @param {ITeenPattiGoldRes} message TeenPattiGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiGoldRes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.WinGold);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiGoldRes message, length delimited. Does not implicitly {@link TeenPattiGoldRes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiGoldRes
     * @static
     * @param {ITeenPattiGoldRes} message TeenPattiGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiGoldRes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiGoldRes message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiGoldRes} TeenPattiGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiGoldRes.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiGoldRes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinGold = reader.string();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiGoldRes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiGoldRes} TeenPattiGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiGoldRes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiGoldRes message.
     * @function verify
     * @memberof TeenPattiGoldRes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiGoldRes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isString(message.WinGold))
                return "WinGold: string expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        return null;
    };

    /**
     * Creates a TeenPattiGoldRes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiGoldRes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiGoldRes} TeenPattiGoldRes
     */
    TeenPattiGoldRes.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiGoldRes)
            return object;
        let message = new $root.TeenPattiGoldRes();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinGold != null)
            message.WinGold = String(object.WinGold);
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiGoldRes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiGoldRes
     * @static
     * @param {TeenPattiGoldRes} message TeenPattiGoldRes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiGoldRes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.WinGold = "";
            object.ChangeGold = "";
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        return object;
    };

    /**
     * Converts this TeenPattiGoldRes to JSON.
     * @function toJSON
     * @memberof TeenPattiGoldRes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiGoldRes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiGoldRes
     * @function getTypeUrl
     * @memberof TeenPattiGoldRes
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiGoldRes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiGoldRes";
    };

    return TeenPattiGoldRes;
})();

export const TeenPattiCardRes = $root.TeenPattiCardRes = (() => {

    /**
     * Properties of a TeenPattiCardRes.
     * @exports ITeenPattiCardRes
     * @interface ITeenPattiCardRes
     * @property {number|null} [UserID] TeenPattiCardRes UserID
     * @property {number|null} [CardType] TeenPattiCardRes CardType
     * @property {Array.<number>|null} [HandCard] TeenPattiCardRes HandCard
     */

    /**
     * Constructs a new TeenPattiCardRes.
     * @exports TeenPattiCardRes
     * @classdesc Represents a TeenPattiCardRes.
     * @implements ITeenPattiCardRes
     * @constructor
     * @param {ITeenPattiCardRes=} [properties] Properties to set
     */
    function TeenPattiCardRes(properties) {
        this.HandCard = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiCardRes UserID.
     * @member {number} UserID
     * @memberof TeenPattiCardRes
     * @instance
     */
    TeenPattiCardRes.prototype.UserID = 0;

    /**
     * TeenPattiCardRes CardType.
     * @member {number} CardType
     * @memberof TeenPattiCardRes
     * @instance
     */
    TeenPattiCardRes.prototype.CardType = 0;

    /**
     * TeenPattiCardRes HandCard.
     * @member {Array.<number>} HandCard
     * @memberof TeenPattiCardRes
     * @instance
     */
    TeenPattiCardRes.prototype.HandCard = $util.emptyArray;

    /**
     * Creates a new TeenPattiCardRes instance using the specified properties.
     * @function create
     * @memberof TeenPattiCardRes
     * @static
     * @param {ITeenPattiCardRes=} [properties] Properties to set
     * @returns {TeenPattiCardRes} TeenPattiCardRes instance
     */
    TeenPattiCardRes.create = function create(properties) {
        return new TeenPattiCardRes(properties);
    };

    /**
     * Encodes the specified TeenPattiCardRes message. Does not implicitly {@link TeenPattiCardRes.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiCardRes
     * @static
     * @param {ITeenPattiCardRes} message TeenPattiCardRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiCardRes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.CardType);
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified TeenPattiCardRes message, length delimited. Does not implicitly {@link TeenPattiCardRes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiCardRes
     * @static
     * @param {ITeenPattiCardRes} message TeenPattiCardRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiCardRes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiCardRes message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiCardRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiCardRes} TeenPattiCardRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiCardRes.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiCardRes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.CardType = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiCardRes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiCardRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiCardRes} TeenPattiCardRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiCardRes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiCardRes message.
     * @function verify
     * @memberof TeenPattiCardRes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiCardRes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a TeenPattiCardRes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiCardRes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiCardRes} TeenPattiCardRes
     */
    TeenPattiCardRes.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiCardRes)
            return object;
        let message = new $root.TeenPattiCardRes();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.CardType != null)
            message.CardType = object.CardType >>> 0;
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".TeenPattiCardRes.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiCardRes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiCardRes
     * @static
     * @param {TeenPattiCardRes} message TeenPattiCardRes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiCardRes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.HandCard = [];
        if (options.defaults) {
            object.UserID = 0;
            object.CardType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        return object;
    };

    /**
     * Converts this TeenPattiCardRes to JSON.
     * @function toJSON
     * @memberof TeenPattiCardRes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiCardRes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiCardRes
     * @function getTypeUrl
     * @memberof TeenPattiCardRes
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiCardRes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiCardRes";
    };

    return TeenPattiCardRes;
})();

export const Desk2TeenPattiSrvPushGameResult = $root.Desk2TeenPattiSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2TeenPattiSrvPushGameResult.
     * @exports IDesk2TeenPattiSrvPushGameResult
     * @interface IDesk2TeenPattiSrvPushGameResult
     * @property {number|null} [UserID] Desk2TeenPattiSrvPushGameResult UserID
     * @property {Array.<ITeenPattiGoldRes>|null} [GoldResult] Desk2TeenPattiSrvPushGameResult GoldResult
     * @property {Array.<ITeenPattiCardRes>|null} [CardResult] Desk2TeenPattiSrvPushGameResult CardResult
     */

    /**
     * Constructs a new Desk2TeenPattiSrvPushGameResult.
     * @exports Desk2TeenPattiSrvPushGameResult
     * @classdesc Represents a Desk2TeenPattiSrvPushGameResult.
     * @implements IDesk2TeenPattiSrvPushGameResult
     * @constructor
     * @param {IDesk2TeenPattiSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2TeenPattiSrvPushGameResult(properties) {
        this.GoldResult = [];
        this.CardResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TeenPattiSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @instance
     */
    Desk2TeenPattiSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2TeenPattiSrvPushGameResult GoldResult.
     * @member {Array.<ITeenPattiGoldRes>} GoldResult
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @instance
     */
    Desk2TeenPattiSrvPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushGameResult CardResult.
     * @member {Array.<ITeenPattiCardRes>} CardResult
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @instance
     */
    Desk2TeenPattiSrvPushGameResult.prototype.CardResult = $util.emptyArray;

    /**
     * Creates a new Desk2TeenPattiSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {IDesk2TeenPattiSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2TeenPattiSrvPushGameResult} Desk2TeenPattiSrvPushGameResult instance
     */
    Desk2TeenPattiSrvPushGameResult.create = function create(properties) {
        return new Desk2TeenPattiSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvPushGameResult message. Does not implicitly {@link Desk2TeenPattiSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {IDesk2TeenPattiSrvPushGameResult} message Desk2TeenPattiSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.TeenPattiGoldRes.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.CardResult != null && message.CardResult.length)
            for (let i = 0; i < message.CardResult.length; ++i)
                $root.TeenPattiCardRes.encode(message.CardResult[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2TeenPattiSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {IDesk2TeenPattiSrvPushGameResult} message Desk2TeenPattiSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TeenPattiSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TeenPattiSrvPushGameResult} Desk2TeenPattiSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TeenPattiSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.TeenPattiGoldRes.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    if (!(message.CardResult && message.CardResult.length))
                        message.CardResult = [];
                    message.CardResult.push($root.TeenPattiCardRes.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TeenPattiSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TeenPattiSrvPushGameResult} Desk2TeenPattiSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TeenPattiSrvPushGameResult message.
     * @function verify
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TeenPattiSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.TeenPattiGoldRes.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        if (message.CardResult != null && message.hasOwnProperty("CardResult")) {
            if (!Array.isArray(message.CardResult))
                return "CardResult: array expected";
            for (let i = 0; i < message.CardResult.length; ++i) {
                let error = $root.TeenPattiCardRes.verify(message.CardResult[i]);
                if (error)
                    return "CardResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2TeenPattiSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TeenPattiSrvPushGameResult} Desk2TeenPattiSrvPushGameResult
     */
    Desk2TeenPattiSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TeenPattiSrvPushGameResult)
            return object;
        let message = new $root.Desk2TeenPattiSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".Desk2TeenPattiSrvPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".Desk2TeenPattiSrvPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.TeenPattiGoldRes.fromObject(object.GoldResult[i]);
            }
        }
        if (object.CardResult) {
            if (!Array.isArray(object.CardResult))
                throw TypeError(".Desk2TeenPattiSrvPushGameResult.CardResult: array expected");
            message.CardResult = [];
            for (let i = 0; i < object.CardResult.length; ++i) {
                if (typeof object.CardResult[i] !== "object")
                    throw TypeError(".Desk2TeenPattiSrvPushGameResult.CardResult: object expected");
                message.CardResult[i] = $root.TeenPattiCardRes.fromObject(object.CardResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TeenPattiSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {Desk2TeenPattiSrvPushGameResult} message Desk2TeenPattiSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TeenPattiSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GoldResult = [];
            object.CardResult = [];
        }
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.TeenPattiGoldRes.toObject(message.GoldResult[j], options);
        }
        if (message.CardResult && message.CardResult.length) {
            object.CardResult = [];
            for (let j = 0; j < message.CardResult.length; ++j)
                object.CardResult[j] = $root.TeenPattiCardRes.toObject(message.CardResult[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2TeenPattiSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TeenPattiSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TeenPattiSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2TeenPattiSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TeenPattiSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TeenPattiSrvPushGameResult";
    };

    return Desk2TeenPattiSrvPushGameResult;
})();

export const TeenPattiPlayerTotalBet = $root.TeenPattiPlayerTotalBet = (() => {

    /**
     * Properties of a TeenPattiPlayerTotalBet.
     * @exports ITeenPattiPlayerTotalBet
     * @interface ITeenPattiPlayerTotalBet
     * @property {number|null} [UserID] TeenPattiPlayerTotalBet UserID
     * @property {string|null} [TotalBetChip] TeenPattiPlayerTotalBet TotalBetChip
     * @property {string|null} [CurEnterChip] TeenPattiPlayerTotalBet CurEnterChip
     */

    /**
     * Constructs a new TeenPattiPlayerTotalBet.
     * @exports TeenPattiPlayerTotalBet
     * @classdesc Represents a TeenPattiPlayerTotalBet.
     * @implements ITeenPattiPlayerTotalBet
     * @constructor
     * @param {ITeenPattiPlayerTotalBet=} [properties] Properties to set
     */
    function TeenPattiPlayerTotalBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiPlayerTotalBet UserID.
     * @member {number} UserID
     * @memberof TeenPattiPlayerTotalBet
     * @instance
     */
    TeenPattiPlayerTotalBet.prototype.UserID = 0;

    /**
     * TeenPattiPlayerTotalBet TotalBetChip.
     * @member {string} TotalBetChip
     * @memberof TeenPattiPlayerTotalBet
     * @instance
     */
    TeenPattiPlayerTotalBet.prototype.TotalBetChip = "";

    /**
     * TeenPattiPlayerTotalBet CurEnterChip.
     * @member {string} CurEnterChip
     * @memberof TeenPattiPlayerTotalBet
     * @instance
     */
    TeenPattiPlayerTotalBet.prototype.CurEnterChip = "";

    /**
     * Creates a new TeenPattiPlayerTotalBet instance using the specified properties.
     * @function create
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {ITeenPattiPlayerTotalBet=} [properties] Properties to set
     * @returns {TeenPattiPlayerTotalBet} TeenPattiPlayerTotalBet instance
     */
    TeenPattiPlayerTotalBet.create = function create(properties) {
        return new TeenPattiPlayerTotalBet(properties);
    };

    /**
     * Encodes the specified TeenPattiPlayerTotalBet message. Does not implicitly {@link TeenPattiPlayerTotalBet.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {ITeenPattiPlayerTotalBet} message TeenPattiPlayerTotalBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiPlayerTotalBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TotalBetChip != null && Object.hasOwnProperty.call(message, "TotalBetChip"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.TotalBetChip);
        if (message.CurEnterChip != null && Object.hasOwnProperty.call(message, "CurEnterChip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.CurEnterChip);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiPlayerTotalBet message, length delimited. Does not implicitly {@link TeenPattiPlayerTotalBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {ITeenPattiPlayerTotalBet} message TeenPattiPlayerTotalBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiPlayerTotalBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiPlayerTotalBet message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiPlayerTotalBet} TeenPattiPlayerTotalBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiPlayerTotalBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiPlayerTotalBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TotalBetChip = reader.string();
                    break;
                }
            case 3: {
                    message.CurEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiPlayerTotalBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiPlayerTotalBet} TeenPattiPlayerTotalBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiPlayerTotalBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiPlayerTotalBet message.
     * @function verify
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiPlayerTotalBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TotalBetChip != null && message.hasOwnProperty("TotalBetChip"))
            if (!$util.isString(message.TotalBetChip))
                return "TotalBetChip: string expected";
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            if (!$util.isString(message.CurEnterChip))
                return "CurEnterChip: string expected";
        return null;
    };

    /**
     * Creates a TeenPattiPlayerTotalBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiPlayerTotalBet} TeenPattiPlayerTotalBet
     */
    TeenPattiPlayerTotalBet.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiPlayerTotalBet)
            return object;
        let message = new $root.TeenPattiPlayerTotalBet();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TotalBetChip != null)
            message.TotalBetChip = String(object.TotalBetChip);
        if (object.CurEnterChip != null)
            message.CurEnterChip = String(object.CurEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiPlayerTotalBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {TeenPattiPlayerTotalBet} message TeenPattiPlayerTotalBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiPlayerTotalBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.TotalBetChip = "";
            object.CurEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TotalBetChip != null && message.hasOwnProperty("TotalBetChip"))
            object.TotalBetChip = message.TotalBetChip;
        if (message.CurEnterChip != null && message.hasOwnProperty("CurEnterChip"))
            object.CurEnterChip = message.CurEnterChip;
        return object;
    };

    /**
     * Converts this TeenPattiPlayerTotalBet to JSON.
     * @function toJSON
     * @memberof TeenPattiPlayerTotalBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiPlayerTotalBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiPlayerTotalBet
     * @function getTypeUrl
     * @memberof TeenPattiPlayerTotalBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiPlayerTotalBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiPlayerTotalBet";
    };

    return TeenPattiPlayerTotalBet;
})();

export const Desk2TeenPattiSrvPushPlayingInfo = $root.Desk2TeenPattiSrvPushPlayingInfo = (() => {

    /**
     * Properties of a Desk2TeenPattiSrvPushPlayingInfo.
     * @exports IDesk2TeenPattiSrvPushPlayingInfo
     * @interface IDesk2TeenPattiSrvPushPlayingInfo
     * @property {number|null} [UserID] Desk2TeenPattiSrvPushPlayingInfo UserID
     * @property {number|null} [StateID] Desk2TeenPattiSrvPushPlayingInfo StateID
     * @property {number|null} [DealerID] Desk2TeenPattiSrvPushPlayingInfo DealerID
     * @property {string|null} [Boot] Desk2TeenPattiSrvPushPlayingInfo Boot
     * @property {Array.<number>|null} [GamingIDs] Desk2TeenPattiSrvPushPlayingInfo GamingIDs
     * @property {Array.<number>|null} [WatchingIDs] Desk2TeenPattiSrvPushPlayingInfo WatchingIDs
     * @property {Array.<number>|null} [BreakIDs] Desk2TeenPattiSrvPushPlayingInfo BreakIDs
     * @property {Array.<number>|null} [SeenIDs] Desk2TeenPattiSrvPushPlayingInfo SeenIDs
     * @property {Array.<ITeenPattiPlayerTotalBet>|null} [PlayerBet] Desk2TeenPattiSrvPushPlayingInfo PlayerBet
     * @property {Array.<ITeenPattiOperCmdTip>|null} [Operation] Desk2TeenPattiSrvPushPlayingInfo Operation
     * @property {number|null} [Challenger] Desk2TeenPattiSrvPushPlayingInfo Challenger
     * @property {number|null} [ChallengedID] Desk2TeenPattiSrvPushPlayingInfo ChallengedID
     * @property {number|null} [CompareType] Desk2TeenPattiSrvPushPlayingInfo CompareType
     * @property {Array.<number>|null} [HandCard] Desk2TeenPattiSrvPushPlayingInfo HandCard
     * @property {number|null} [Practitioner] Desk2TeenPattiSrvPushPlayingInfo Practitioner
     * @property {Array.<number>|null} [Packed] Desk2TeenPattiSrvPushPlayingInfo Packed
     * @property {string|null} [TotalPot] Desk2TeenPattiSrvPushPlayingInfo TotalPot
     * @property {string|null} [BlindChip] Desk2TeenPattiSrvPushPlayingInfo BlindChip
     */

    /**
     * Constructs a new Desk2TeenPattiSrvPushPlayingInfo.
     * @exports Desk2TeenPattiSrvPushPlayingInfo
     * @classdesc Represents a Desk2TeenPattiSrvPushPlayingInfo.
     * @implements IDesk2TeenPattiSrvPushPlayingInfo
     * @constructor
     * @param {IDesk2TeenPattiSrvPushPlayingInfo=} [properties] Properties to set
     */
    function Desk2TeenPattiSrvPushPlayingInfo(properties) {
        this.GamingIDs = [];
        this.WatchingIDs = [];
        this.BreakIDs = [];
        this.SeenIDs = [];
        this.PlayerBet = [];
        this.Operation = [];
        this.HandCard = [];
        this.Packed = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TeenPattiSrvPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.UserID = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.StateID = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo DealerID.
     * @member {number} DealerID
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.DealerID = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo Boot.
     * @member {string} Boot
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.Boot = "";

    /**
     * Desk2TeenPattiSrvPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo WatchingIDs.
     * @member {Array.<number>} WatchingIDs
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.WatchingIDs = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo BreakIDs.
     * @member {Array.<number>} BreakIDs
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.BreakIDs = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo SeenIDs.
     * @member {Array.<number>} SeenIDs
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.SeenIDs = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo PlayerBet.
     * @member {Array.<ITeenPattiPlayerTotalBet>} PlayerBet
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.PlayerBet = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo Operation.
     * @member {Array.<ITeenPattiOperCmdTip>} Operation
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.Operation = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo Challenger.
     * @member {number} Challenger
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.Challenger = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo ChallengedID.
     * @member {number} ChallengedID
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.ChallengedID = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo CompareType.
     * @member {number} CompareType
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.CompareType = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo HandCard.
     * @member {Array.<number>} HandCard
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.HandCard = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo Practitioner.
     * @member {number} Practitioner
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.Practitioner = 0;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo Packed.
     * @member {Array.<number>} Packed
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.Packed = $util.emptyArray;

    /**
     * Desk2TeenPattiSrvPushPlayingInfo TotalPot.
     * @member {string} TotalPot
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.TotalPot = "";

    /**
     * Desk2TeenPattiSrvPushPlayingInfo BlindChip.
     * @member {string} BlindChip
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.BlindChip = "";

    /**
     * Creates a new Desk2TeenPattiSrvPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {IDesk2TeenPattiSrvPushPlayingInfo=} [properties] Properties to set
     * @returns {Desk2TeenPattiSrvPushPlayingInfo} Desk2TeenPattiSrvPushPlayingInfo instance
     */
    Desk2TeenPattiSrvPushPlayingInfo.create = function create(properties) {
        return new Desk2TeenPattiSrvPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvPushPlayingInfo message. Does not implicitly {@link Desk2TeenPattiSrvPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {IDesk2TeenPattiSrvPushPlayingInfo} message Desk2TeenPattiSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.DealerID != null && Object.hasOwnProperty.call(message, "DealerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DealerID);
        if (message.Boot != null && Object.hasOwnProperty.call(message, "Boot"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Boot);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.WatchingIDs != null && message.WatchingIDs.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                writer.uint32(message.WatchingIDs[i]);
            writer.ldelim();
        }
        if (message.BreakIDs != null && message.BreakIDs.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.BreakIDs.length; ++i)
                writer.uint32(message.BreakIDs[i]);
            writer.ldelim();
        }
        if (message.SeenIDs != null && message.SeenIDs.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.SeenIDs.length; ++i)
                writer.uint32(message.SeenIDs[i]);
            writer.ldelim();
        }
        if (message.PlayerBet != null && message.PlayerBet.length)
            for (let i = 0; i < message.PlayerBet.length; ++i)
                $root.TeenPattiPlayerTotalBet.encode(message.PlayerBet[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.Operation != null && message.Operation.length)
            for (let i = 0; i < message.Operation.length; ++i)
                $root.TeenPattiOperCmdTip.encode(message.Operation[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.Challenger != null && Object.hasOwnProperty.call(message, "Challenger"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Challenger);
        if (message.ChallengedID != null && Object.hasOwnProperty.call(message, "ChallengedID"))
            writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.ChallengedID);
        if (message.CompareType != null && Object.hasOwnProperty.call(message, "CompareType"))
            writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.CompareType);
        if (message.HandCard != null && message.HandCard.length) {
            writer.uint32(/* id 14, wireType 2 =*/114).fork();
            for (let i = 0; i < message.HandCard.length; ++i)
                writer.uint32(message.HandCard[i]);
            writer.ldelim();
        }
        if (message.Practitioner != null && Object.hasOwnProperty.call(message, "Practitioner"))
            writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.Practitioner);
        if (message.Packed != null && message.Packed.length) {
            writer.uint32(/* id 16, wireType 2 =*/130).fork();
            for (let i = 0; i < message.Packed.length; ++i)
                writer.uint32(message.Packed[i]);
            writer.ldelim();
        }
        if (message.TotalPot != null && Object.hasOwnProperty.call(message, "TotalPot"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.TotalPot);
        if (message.BlindChip != null && Object.hasOwnProperty.call(message, "BlindChip"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.BlindChip);
        return writer;
    };

    /**
     * Encodes the specified Desk2TeenPattiSrvPushPlayingInfo message, length delimited. Does not implicitly {@link Desk2TeenPattiSrvPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {IDesk2TeenPattiSrvPushPlayingInfo} message Desk2TeenPattiSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TeenPattiSrvPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TeenPattiSrvPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TeenPattiSrvPushPlayingInfo} Desk2TeenPattiSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TeenPattiSrvPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    message.DealerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Boot = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.WatchingIDs && message.WatchingIDs.length))
                        message.WatchingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.WatchingIDs.push(reader.uint32());
                    } else
                        message.WatchingIDs.push(reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.BreakIDs && message.BreakIDs.length))
                        message.BreakIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.BreakIDs.push(reader.uint32());
                    } else
                        message.BreakIDs.push(reader.uint32());
                    break;
                }
            case 8: {
                    if (!(message.SeenIDs && message.SeenIDs.length))
                        message.SeenIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.SeenIDs.push(reader.uint32());
                    } else
                        message.SeenIDs.push(reader.uint32());
                    break;
                }
            case 9: {
                    if (!(message.PlayerBet && message.PlayerBet.length))
                        message.PlayerBet = [];
                    message.PlayerBet.push($root.TeenPattiPlayerTotalBet.decode(reader, reader.uint32()));
                    break;
                }
            case 10: {
                    if (!(message.Operation && message.Operation.length))
                        message.Operation = [];
                    message.Operation.push($root.TeenPattiOperCmdTip.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    message.Challenger = reader.uint32();
                    break;
                }
            case 12: {
                    message.ChallengedID = reader.uint32();
                    break;
                }
            case 13: {
                    message.CompareType = reader.uint32();
                    break;
                }
            case 14: {
                    if (!(message.HandCard && message.HandCard.length))
                        message.HandCard = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.HandCard.push(reader.uint32());
                    } else
                        message.HandCard.push(reader.uint32());
                    break;
                }
            case 15: {
                    message.Practitioner = reader.uint32();
                    break;
                }
            case 16: {
                    if (!(message.Packed && message.Packed.length))
                        message.Packed = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Packed.push(reader.uint32());
                    } else
                        message.Packed.push(reader.uint32());
                    break;
                }
            case 17: {
                    message.TotalPot = reader.string();
                    break;
                }
            case 18: {
                    message.BlindChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TeenPattiSrvPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TeenPattiSrvPushPlayingInfo} Desk2TeenPattiSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TeenPattiSrvPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TeenPattiSrvPushPlayingInfo message.
     * @function verify
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TeenPattiSrvPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            if (!$util.isInteger(message.DealerID))
                return "DealerID: integer expected";
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            if (!$util.isString(message.Boot))
                return "Boot: string expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.WatchingIDs != null && message.hasOwnProperty("WatchingIDs")) {
            if (!Array.isArray(message.WatchingIDs))
                return "WatchingIDs: array expected";
            for (let i = 0; i < message.WatchingIDs.length; ++i)
                if (!$util.isInteger(message.WatchingIDs[i]))
                    return "WatchingIDs: integer[] expected";
        }
        if (message.BreakIDs != null && message.hasOwnProperty("BreakIDs")) {
            if (!Array.isArray(message.BreakIDs))
                return "BreakIDs: array expected";
            for (let i = 0; i < message.BreakIDs.length; ++i)
                if (!$util.isInteger(message.BreakIDs[i]))
                    return "BreakIDs: integer[] expected";
        }
        if (message.SeenIDs != null && message.hasOwnProperty("SeenIDs")) {
            if (!Array.isArray(message.SeenIDs))
                return "SeenIDs: array expected";
            for (let i = 0; i < message.SeenIDs.length; ++i)
                if (!$util.isInteger(message.SeenIDs[i]))
                    return "SeenIDs: integer[] expected";
        }
        if (message.PlayerBet != null && message.hasOwnProperty("PlayerBet")) {
            if (!Array.isArray(message.PlayerBet))
                return "PlayerBet: array expected";
            for (let i = 0; i < message.PlayerBet.length; ++i) {
                let error = $root.TeenPattiPlayerTotalBet.verify(message.PlayerBet[i]);
                if (error)
                    return "PlayerBet." + error;
            }
        }
        if (message.Operation != null && message.hasOwnProperty("Operation")) {
            if (!Array.isArray(message.Operation))
                return "Operation: array expected";
            for (let i = 0; i < message.Operation.length; ++i) {
                let error = $root.TeenPattiOperCmdTip.verify(message.Operation[i]);
                if (error)
                    return "Operation." + error;
            }
        }
        if (message.Challenger != null && message.hasOwnProperty("Challenger"))
            if (!$util.isInteger(message.Challenger))
                return "Challenger: integer expected";
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            if (!$util.isInteger(message.ChallengedID))
                return "ChallengedID: integer expected";
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            if (!$util.isInteger(message.CompareType))
                return "CompareType: integer expected";
        if (message.HandCard != null && message.hasOwnProperty("HandCard")) {
            if (!Array.isArray(message.HandCard))
                return "HandCard: array expected";
            for (let i = 0; i < message.HandCard.length; ++i)
                if (!$util.isInteger(message.HandCard[i]))
                    return "HandCard: integer[] expected";
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            if (!$util.isInteger(message.Practitioner))
                return "Practitioner: integer expected";
        if (message.Packed != null && message.hasOwnProperty("Packed")) {
            if (!Array.isArray(message.Packed))
                return "Packed: array expected";
            for (let i = 0; i < message.Packed.length; ++i)
                if (!$util.isInteger(message.Packed[i]))
                    return "Packed: integer[] expected";
        }
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            if (!$util.isString(message.TotalPot))
                return "TotalPot: string expected";
        if (message.BlindChip != null && message.hasOwnProperty("BlindChip"))
            if (!$util.isString(message.BlindChip))
                return "BlindChip: string expected";
        return null;
    };

    /**
     * Creates a Desk2TeenPattiSrvPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TeenPattiSrvPushPlayingInfo} Desk2TeenPattiSrvPushPlayingInfo
     */
    Desk2TeenPattiSrvPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TeenPattiSrvPushPlayingInfo)
            return object;
        let message = new $root.Desk2TeenPattiSrvPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.DealerID != null)
            message.DealerID = object.DealerID >>> 0;
        if (object.Boot != null)
            message.Boot = String(object.Boot);
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.WatchingIDs) {
            if (!Array.isArray(object.WatchingIDs))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.WatchingIDs: array expected");
            message.WatchingIDs = [];
            for (let i = 0; i < object.WatchingIDs.length; ++i)
                message.WatchingIDs[i] = object.WatchingIDs[i] >>> 0;
        }
        if (object.BreakIDs) {
            if (!Array.isArray(object.BreakIDs))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.BreakIDs: array expected");
            message.BreakIDs = [];
            for (let i = 0; i < object.BreakIDs.length; ++i)
                message.BreakIDs[i] = object.BreakIDs[i] >>> 0;
        }
        if (object.SeenIDs) {
            if (!Array.isArray(object.SeenIDs))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.SeenIDs: array expected");
            message.SeenIDs = [];
            for (let i = 0; i < object.SeenIDs.length; ++i)
                message.SeenIDs[i] = object.SeenIDs[i] >>> 0;
        }
        if (object.PlayerBet) {
            if (!Array.isArray(object.PlayerBet))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.PlayerBet: array expected");
            message.PlayerBet = [];
            for (let i = 0; i < object.PlayerBet.length; ++i) {
                if (typeof object.PlayerBet[i] !== "object")
                    throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.PlayerBet: object expected");
                message.PlayerBet[i] = $root.TeenPattiPlayerTotalBet.fromObject(object.PlayerBet[i]);
            }
        }
        if (object.Operation) {
            if (!Array.isArray(object.Operation))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.Operation: array expected");
            message.Operation = [];
            for (let i = 0; i < object.Operation.length; ++i) {
                if (typeof object.Operation[i] !== "object")
                    throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.Operation: object expected");
                message.Operation[i] = $root.TeenPattiOperCmdTip.fromObject(object.Operation[i]);
            }
        }
        if (object.Challenger != null)
            message.Challenger = object.Challenger >>> 0;
        if (object.ChallengedID != null)
            message.ChallengedID = object.ChallengedID >>> 0;
        if (object.CompareType != null)
            message.CompareType = object.CompareType >>> 0;
        if (object.HandCard) {
            if (!Array.isArray(object.HandCard))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.HandCard: array expected");
            message.HandCard = [];
            for (let i = 0; i < object.HandCard.length; ++i)
                message.HandCard[i] = object.HandCard[i] >>> 0;
        }
        if (object.Practitioner != null)
            message.Practitioner = object.Practitioner >>> 0;
        if (object.Packed) {
            if (!Array.isArray(object.Packed))
                throw TypeError(".Desk2TeenPattiSrvPushPlayingInfo.Packed: array expected");
            message.Packed = [];
            for (let i = 0; i < object.Packed.length; ++i)
                message.Packed[i] = object.Packed[i] >>> 0;
        }
        if (object.TotalPot != null)
            message.TotalPot = String(object.TotalPot);
        if (object.BlindChip != null)
            message.BlindChip = String(object.BlindChip);
        return message;
    };

    /**
     * Creates a plain object from a Desk2TeenPattiSrvPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {Desk2TeenPattiSrvPushPlayingInfo} message Desk2TeenPattiSrvPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TeenPattiSrvPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.WatchingIDs = [];
            object.BreakIDs = [];
            object.SeenIDs = [];
            object.PlayerBet = [];
            object.Operation = [];
            object.HandCard = [];
            object.Packed = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.DealerID = 0;
            object.Boot = "";
            object.Challenger = 0;
            object.ChallengedID = 0;
            object.CompareType = 0;
            object.Practitioner = 0;
            object.TotalPot = "";
            object.BlindChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.DealerID != null && message.hasOwnProperty("DealerID"))
            object.DealerID = message.DealerID;
        if (message.Boot != null && message.hasOwnProperty("Boot"))
            object.Boot = message.Boot;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.WatchingIDs && message.WatchingIDs.length) {
            object.WatchingIDs = [];
            for (let j = 0; j < message.WatchingIDs.length; ++j)
                object.WatchingIDs[j] = message.WatchingIDs[j];
        }
        if (message.BreakIDs && message.BreakIDs.length) {
            object.BreakIDs = [];
            for (let j = 0; j < message.BreakIDs.length; ++j)
                object.BreakIDs[j] = message.BreakIDs[j];
        }
        if (message.SeenIDs && message.SeenIDs.length) {
            object.SeenIDs = [];
            for (let j = 0; j < message.SeenIDs.length; ++j)
                object.SeenIDs[j] = message.SeenIDs[j];
        }
        if (message.PlayerBet && message.PlayerBet.length) {
            object.PlayerBet = [];
            for (let j = 0; j < message.PlayerBet.length; ++j)
                object.PlayerBet[j] = $root.TeenPattiPlayerTotalBet.toObject(message.PlayerBet[j], options);
        }
        if (message.Operation && message.Operation.length) {
            object.Operation = [];
            for (let j = 0; j < message.Operation.length; ++j)
                object.Operation[j] = $root.TeenPattiOperCmdTip.toObject(message.Operation[j], options);
        }
        if (message.Challenger != null && message.hasOwnProperty("Challenger"))
            object.Challenger = message.Challenger;
        if (message.ChallengedID != null && message.hasOwnProperty("ChallengedID"))
            object.ChallengedID = message.ChallengedID;
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            object.CompareType = message.CompareType;
        if (message.HandCard && message.HandCard.length) {
            object.HandCard = [];
            for (let j = 0; j < message.HandCard.length; ++j)
                object.HandCard[j] = message.HandCard[j];
        }
        if (message.Practitioner != null && message.hasOwnProperty("Practitioner"))
            object.Practitioner = message.Practitioner;
        if (message.Packed && message.Packed.length) {
            object.Packed = [];
            for (let j = 0; j < message.Packed.length; ++j)
                object.Packed[j] = message.Packed[j];
        }
        if (message.TotalPot != null && message.hasOwnProperty("TotalPot"))
            object.TotalPot = message.TotalPot;
        if (message.BlindChip != null && message.hasOwnProperty("BlindChip"))
            object.BlindChip = message.BlindChip;
        return object;
    };

    /**
     * Converts this Desk2TeenPattiSrvPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TeenPattiSrvPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TeenPattiSrvPushPlayingInfo
     * @function getTypeUrl
     * @memberof Desk2TeenPattiSrvPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TeenPattiSrvPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TeenPattiSrvPushPlayingInfo";
    };

    return Desk2TeenPattiSrvPushPlayingInfo;
})();

export const DeskToTeenPattiSrvPlayerCompareReq = $root.DeskToTeenPattiSrvPlayerCompareReq = (() => {

    /**
     * Properties of a DeskToTeenPattiSrvPlayerCompareReq.
     * @exports IDeskToTeenPattiSrvPlayerCompareReq
     * @interface IDeskToTeenPattiSrvPlayerCompareReq
     * @property {number|null} [DeskNo] DeskToTeenPattiSrvPlayerCompareReq DeskNo
     * @property {number|null} [UserID] DeskToTeenPattiSrvPlayerCompareReq UserID
     * @property {number|null} [SeatNo] DeskToTeenPattiSrvPlayerCompareReq SeatNo
     * @property {number|null} [Accept] DeskToTeenPattiSrvPlayerCompareReq Accept
     * @property {number|null} [ChallengerID] DeskToTeenPattiSrvPlayerCompareReq ChallengerID
     * @property {number|null} [CompareType] DeskToTeenPattiSrvPlayerCompareReq CompareType
     */

    /**
     * Constructs a new DeskToTeenPattiSrvPlayerCompareReq.
     * @exports DeskToTeenPattiSrvPlayerCompareReq
     * @classdesc Represents a DeskToTeenPattiSrvPlayerCompareReq.
     * @implements IDeskToTeenPattiSrvPlayerCompareReq
     * @constructor
     * @param {IDeskToTeenPattiSrvPlayerCompareReq=} [properties] Properties to set
     */
    function DeskToTeenPattiSrvPlayerCompareReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeskToTeenPattiSrvPlayerCompareReq DeskNo.
     * @member {number} DeskNo
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.DeskNo = 0;

    /**
     * DeskToTeenPattiSrvPlayerCompareReq UserID.
     * @member {number} UserID
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.UserID = 0;

    /**
     * DeskToTeenPattiSrvPlayerCompareReq SeatNo.
     * @member {number} SeatNo
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.SeatNo = 0;

    /**
     * DeskToTeenPattiSrvPlayerCompareReq Accept.
     * @member {number} Accept
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.Accept = 0;

    /**
     * DeskToTeenPattiSrvPlayerCompareReq ChallengerID.
     * @member {number} ChallengerID
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.ChallengerID = 0;

    /**
     * DeskToTeenPattiSrvPlayerCompareReq CompareType.
     * @member {number} CompareType
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.CompareType = 0;

    /**
     * Creates a new DeskToTeenPattiSrvPlayerCompareReq instance using the specified properties.
     * @function create
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCompareReq=} [properties] Properties to set
     * @returns {DeskToTeenPattiSrvPlayerCompareReq} DeskToTeenPattiSrvPlayerCompareReq instance
     */
    DeskToTeenPattiSrvPlayerCompareReq.create = function create(properties) {
        return new DeskToTeenPattiSrvPlayerCompareReq(properties);
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCompareReq message. Does not implicitly {@link DeskToTeenPattiSrvPlayerCompareReq.verify|verify} messages.
     * @function encode
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCompareReq} message DeskToTeenPattiSrvPlayerCompareReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCompareReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.Accept != null && Object.hasOwnProperty.call(message, "Accept"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Accept);
        if (message.ChallengerID != null && Object.hasOwnProperty.call(message, "ChallengerID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.ChallengerID);
        if (message.CompareType != null && Object.hasOwnProperty.call(message, "CompareType"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.CompareType);
        return writer;
    };

    /**
     * Encodes the specified DeskToTeenPattiSrvPlayerCompareReq message, length delimited. Does not implicitly {@link DeskToTeenPattiSrvPlayerCompareReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {IDeskToTeenPattiSrvPlayerCompareReq} message DeskToTeenPattiSrvPlayerCompareReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeskToTeenPattiSrvPlayerCompareReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCompareReq message from the specified reader or buffer.
     * @function decode
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeskToTeenPattiSrvPlayerCompareReq} DeskToTeenPattiSrvPlayerCompareReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCompareReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeskToTeenPattiSrvPlayerCompareReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.Accept = reader.int32();
                    break;
                }
            case 5: {
                    message.ChallengerID = reader.uint32();
                    break;
                }
            case 6: {
                    message.CompareType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeskToTeenPattiSrvPlayerCompareReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeskToTeenPattiSrvPlayerCompareReq} DeskToTeenPattiSrvPlayerCompareReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeskToTeenPattiSrvPlayerCompareReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeskToTeenPattiSrvPlayerCompareReq message.
     * @function verify
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeskToTeenPattiSrvPlayerCompareReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Accept != null && message.hasOwnProperty("Accept"))
            if (!$util.isInteger(message.Accept))
                return "Accept: integer expected";
        if (message.ChallengerID != null && message.hasOwnProperty("ChallengerID"))
            if (!$util.isInteger(message.ChallengerID))
                return "ChallengerID: integer expected";
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            if (!$util.isInteger(message.CompareType))
                return "CompareType: integer expected";
        return null;
    };

    /**
     * Creates a DeskToTeenPattiSrvPlayerCompareReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeskToTeenPattiSrvPlayerCompareReq} DeskToTeenPattiSrvPlayerCompareReq
     */
    DeskToTeenPattiSrvPlayerCompareReq.fromObject = function fromObject(object) {
        if (object instanceof $root.DeskToTeenPattiSrvPlayerCompareReq)
            return object;
        let message = new $root.DeskToTeenPattiSrvPlayerCompareReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Accept != null)
            message.Accept = object.Accept | 0;
        if (object.ChallengerID != null)
            message.ChallengerID = object.ChallengerID >>> 0;
        if (object.CompareType != null)
            message.CompareType = object.CompareType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a DeskToTeenPattiSrvPlayerCompareReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {DeskToTeenPattiSrvPlayerCompareReq} message DeskToTeenPattiSrvPlayerCompareReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeskToTeenPattiSrvPlayerCompareReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.Accept = 0;
            object.ChallengerID = 0;
            object.CompareType = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Accept != null && message.hasOwnProperty("Accept"))
            object.Accept = message.Accept;
        if (message.ChallengerID != null && message.hasOwnProperty("ChallengerID"))
            object.ChallengerID = message.ChallengerID;
        if (message.CompareType != null && message.hasOwnProperty("CompareType"))
            object.CompareType = message.CompareType;
        return object;
    };

    /**
     * Converts this DeskToTeenPattiSrvPlayerCompareReq to JSON.
     * @function toJSON
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeskToTeenPattiSrvPlayerCompareReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeskToTeenPattiSrvPlayerCompareReq
     * @function getTypeUrl
     * @memberof DeskToTeenPattiSrvPlayerCompareReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeskToTeenPattiSrvPlayerCompareReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeskToTeenPattiSrvPlayerCompareReq";
    };

    return DeskToTeenPattiSrvPlayerCompareReq;
})();

export const TeenPattiSrvToDeskPushLackAsset = $root.TeenPattiSrvToDeskPushLackAsset = (() => {

    /**
     * Properties of a TeenPattiSrvToDeskPushLackAsset.
     * @exports ITeenPattiSrvToDeskPushLackAsset
     * @interface ITeenPattiSrvToDeskPushLackAsset
     * @property {number|null} [UserID] TeenPattiSrvToDeskPushLackAsset UserID
     * @property {number|null} [OwnerID] TeenPattiSrvToDeskPushLackAsset OwnerID
     * @property {string|null} [Chip] TeenPattiSrvToDeskPushLackAsset Chip
     */

    /**
     * Constructs a new TeenPattiSrvToDeskPushLackAsset.
     * @exports TeenPattiSrvToDeskPushLackAsset
     * @classdesc Represents a TeenPattiSrvToDeskPushLackAsset.
     * @implements ITeenPattiSrvToDeskPushLackAsset
     * @constructor
     * @param {ITeenPattiSrvToDeskPushLackAsset=} [properties] Properties to set
     */
    function TeenPattiSrvToDeskPushLackAsset(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiSrvToDeskPushLackAsset UserID.
     * @member {number} UserID
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @instance
     */
    TeenPattiSrvToDeskPushLackAsset.prototype.UserID = 0;

    /**
     * TeenPattiSrvToDeskPushLackAsset OwnerID.
     * @member {number} OwnerID
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @instance
     */
    TeenPattiSrvToDeskPushLackAsset.prototype.OwnerID = 0;

    /**
     * TeenPattiSrvToDeskPushLackAsset Chip.
     * @member {string} Chip
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @instance
     */
    TeenPattiSrvToDeskPushLackAsset.prototype.Chip = "";

    /**
     * Creates a new TeenPattiSrvToDeskPushLackAsset instance using the specified properties.
     * @function create
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {ITeenPattiSrvToDeskPushLackAsset=} [properties] Properties to set
     * @returns {TeenPattiSrvToDeskPushLackAsset} TeenPattiSrvToDeskPushLackAsset instance
     */
    TeenPattiSrvToDeskPushLackAsset.create = function create(properties) {
        return new TeenPattiSrvToDeskPushLackAsset(properties);
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushLackAsset message. Does not implicitly {@link TeenPattiSrvToDeskPushLackAsset.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {ITeenPattiSrvToDeskPushLackAsset} message TeenPattiSrvToDeskPushLackAsset message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushLackAsset.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushLackAsset message, length delimited. Does not implicitly {@link TeenPattiSrvToDeskPushLackAsset.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {ITeenPattiSrvToDeskPushLackAsset} message TeenPattiSrvToDeskPushLackAsset message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushLackAsset.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushLackAsset message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiSrvToDeskPushLackAsset} TeenPattiSrvToDeskPushLackAsset
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushLackAsset.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiSrvToDeskPushLackAsset();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 3: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushLackAsset message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiSrvToDeskPushLackAsset} TeenPattiSrvToDeskPushLackAsset
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushLackAsset.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiSrvToDeskPushLackAsset message.
     * @function verify
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiSrvToDeskPushLackAsset.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a TeenPattiSrvToDeskPushLackAsset message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiSrvToDeskPushLackAsset} TeenPattiSrvToDeskPushLackAsset
     */
    TeenPattiSrvToDeskPushLackAsset.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiSrvToDeskPushLackAsset)
            return object;
        let message = new $root.TeenPattiSrvToDeskPushLackAsset();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiSrvToDeskPushLackAsset message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {TeenPattiSrvToDeskPushLackAsset} message TeenPattiSrvToDeskPushLackAsset
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiSrvToDeskPushLackAsset.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this TeenPattiSrvToDeskPushLackAsset to JSON.
     * @function toJSON
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiSrvToDeskPushLackAsset.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiSrvToDeskPushLackAsset
     * @function getTypeUrl
     * @memberof TeenPattiSrvToDeskPushLackAsset
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiSrvToDeskPushLackAsset.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiSrvToDeskPushLackAsset";
    };

    return TeenPattiSrvToDeskPushLackAsset;
})();

export const TeenPattiSrvToDeskPushDeskInfo = $root.TeenPattiSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a TeenPattiSrvToDeskPushDeskInfo.
     * @exports ITeenPattiSrvToDeskPushDeskInfo
     * @interface ITeenPattiSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] TeenPattiSrvToDeskPushDeskInfo UserID
     * @property {ITeenPattiProudct|null} [Product] TeenPattiSrvToDeskPushDeskInfo Product
     * @property {string|null} [Tax] TeenPattiSrvToDeskPushDeskInfo Tax
     */

    /**
     * Constructs a new TeenPattiSrvToDeskPushDeskInfo.
     * @exports TeenPattiSrvToDeskPushDeskInfo
     * @classdesc Represents a TeenPattiSrvToDeskPushDeskInfo.
     * @implements ITeenPattiSrvToDeskPushDeskInfo
     * @constructor
     * @param {ITeenPattiSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function TeenPattiSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @instance
     */
    TeenPattiSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * TeenPattiSrvToDeskPushDeskInfo Product.
     * @member {ITeenPattiProudct|null|undefined} Product
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @instance
     */
    TeenPattiSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * TeenPattiSrvToDeskPushDeskInfo Tax.
     * @member {string} Tax
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @instance
     */
    TeenPattiSrvToDeskPushDeskInfo.prototype.Tax = "";

    /**
     * Creates a new TeenPattiSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {TeenPattiSrvToDeskPushDeskInfo} TeenPattiSrvToDeskPushDeskInfo instance
     */
    TeenPattiSrvToDeskPushDeskInfo.create = function create(properties) {
        return new TeenPattiSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushDeskInfo message. Does not implicitly {@link TeenPattiSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushDeskInfo} message TeenPattiSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.TeenPattiProudct.encode(message.Product, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Tax);
        return writer;
    };

    /**
     * Encodes the specified TeenPattiSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link TeenPattiSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {ITeenPattiSrvToDeskPushDeskInfo} message TeenPattiSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiSrvToDeskPushDeskInfo} TeenPattiSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Product = $root.TeenPattiProudct.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.Tax = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiSrvToDeskPushDeskInfo} TeenPattiSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.TeenPattiProudct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        return null;
    };

    /**
     * Creates a TeenPattiSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiSrvToDeskPushDeskInfo} TeenPattiSrvToDeskPushDeskInfo
     */
    TeenPattiSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.TeenPattiSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".TeenPattiSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.TeenPattiProudct.fromObject(object.Product);
        }
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {TeenPattiSrvToDeskPushDeskInfo} message TeenPattiSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Product = null;
            object.Tax = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.TeenPattiProudct.toObject(message.Product, options);
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        return object;
    };

    /**
     * Converts this TeenPattiSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof TeenPattiSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiSrvToDeskPushDeskInfo";
    };

    return TeenPattiSrvToDeskPushDeskInfo;
})();

export const TeenPattiHandCardInfo = $root.TeenPattiHandCardInfo = (() => {

    /**
     * Properties of a TeenPattiHandCardInfo.
     * @exports ITeenPattiHandCardInfo
     * @interface ITeenPattiHandCardInfo
     * @property {number|null} [UserID] TeenPattiHandCardInfo UserID
     * @property {number|null} [SeatNo] TeenPattiHandCardInfo SeatNo
     * @property {number|null} [Rank] TeenPattiHandCardInfo Rank
     * @property {number|null} [CardType] TeenPattiHandCardInfo CardType
     * @property {Array.<number>|null} [Card] TeenPattiHandCardInfo Card
     */

    /**
     * Constructs a new TeenPattiHandCardInfo.
     * @exports TeenPattiHandCardInfo
     * @classdesc Represents a TeenPattiHandCardInfo.
     * @implements ITeenPattiHandCardInfo
     * @constructor
     * @param {ITeenPattiHandCardInfo=} [properties] Properties to set
     */
    function TeenPattiHandCardInfo(properties) {
        this.Card = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiHandCardInfo UserID.
     * @member {number} UserID
     * @memberof TeenPattiHandCardInfo
     * @instance
     */
    TeenPattiHandCardInfo.prototype.UserID = 0;

    /**
     * TeenPattiHandCardInfo SeatNo.
     * @member {number} SeatNo
     * @memberof TeenPattiHandCardInfo
     * @instance
     */
    TeenPattiHandCardInfo.prototype.SeatNo = 0;

    /**
     * TeenPattiHandCardInfo Rank.
     * @member {number} Rank
     * @memberof TeenPattiHandCardInfo
     * @instance
     */
    TeenPattiHandCardInfo.prototype.Rank = 0;

    /**
     * TeenPattiHandCardInfo CardType.
     * @member {number} CardType
     * @memberof TeenPattiHandCardInfo
     * @instance
     */
    TeenPattiHandCardInfo.prototype.CardType = 0;

    /**
     * TeenPattiHandCardInfo Card.
     * @member {Array.<number>} Card
     * @memberof TeenPattiHandCardInfo
     * @instance
     */
    TeenPattiHandCardInfo.prototype.Card = $util.emptyArray;

    /**
     * Creates a new TeenPattiHandCardInfo instance using the specified properties.
     * @function create
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {ITeenPattiHandCardInfo=} [properties] Properties to set
     * @returns {TeenPattiHandCardInfo} TeenPattiHandCardInfo instance
     */
    TeenPattiHandCardInfo.create = function create(properties) {
        return new TeenPattiHandCardInfo(properties);
    };

    /**
     * Encodes the specified TeenPattiHandCardInfo message. Does not implicitly {@link TeenPattiHandCardInfo.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {ITeenPattiHandCardInfo} message TeenPattiHandCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiHandCardInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.SeatNo);
        if (message.Rank != null && Object.hasOwnProperty.call(message, "Rank"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Rank);
        if (message.CardType != null && Object.hasOwnProperty.call(message, "CardType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.CardType);
        if (message.Card != null && message.Card.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.Card.length; ++i)
                writer.uint32(message.Card[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified TeenPattiHandCardInfo message, length delimited. Does not implicitly {@link TeenPattiHandCardInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {ITeenPattiHandCardInfo} message TeenPattiHandCardInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiHandCardInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiHandCardInfo message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiHandCardInfo} TeenPattiHandCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiHandCardInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiHandCardInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 3: {
                    message.Rank = reader.int32();
                    break;
                }
            case 4: {
                    message.CardType = reader.int32();
                    break;
                }
            case 5: {
                    if (!(message.Card && message.Card.length))
                        message.Card = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Card.push(reader.uint32());
                    } else
                        message.Card.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiHandCardInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiHandCardInfo} TeenPattiHandCardInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiHandCardInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiHandCardInfo message.
     * @function verify
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiHandCardInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Rank != null && message.hasOwnProperty("Rank"))
            if (!$util.isInteger(message.Rank))
                return "Rank: integer expected";
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            if (!$util.isInteger(message.CardType))
                return "CardType: integer expected";
        if (message.Card != null && message.hasOwnProperty("Card")) {
            if (!Array.isArray(message.Card))
                return "Card: array expected";
            for (let i = 0; i < message.Card.length; ++i)
                if (!$util.isInteger(message.Card[i]))
                    return "Card: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a TeenPattiHandCardInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiHandCardInfo} TeenPattiHandCardInfo
     */
    TeenPattiHandCardInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiHandCardInfo)
            return object;
        let message = new $root.TeenPattiHandCardInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Rank != null)
            message.Rank = object.Rank | 0;
        if (object.CardType != null)
            message.CardType = object.CardType | 0;
        if (object.Card) {
            if (!Array.isArray(object.Card))
                throw TypeError(".TeenPattiHandCardInfo.Card: array expected");
            message.Card = [];
            for (let i = 0; i < object.Card.length; ++i)
                message.Card[i] = object.Card[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiHandCardInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {TeenPattiHandCardInfo} message TeenPattiHandCardInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiHandCardInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Card = [];
        if (options.defaults) {
            object.UserID = 0;
            object.SeatNo = 0;
            object.Rank = 0;
            object.CardType = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Rank != null && message.hasOwnProperty("Rank"))
            object.Rank = message.Rank;
        if (message.CardType != null && message.hasOwnProperty("CardType"))
            object.CardType = message.CardType;
        if (message.Card && message.Card.length) {
            object.Card = [];
            for (let j = 0; j < message.Card.length; ++j)
                object.Card[j] = message.Card[j];
        }
        return object;
    };

    /**
     * Converts this TeenPattiHandCardInfo to JSON.
     * @function toJSON
     * @memberof TeenPattiHandCardInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiHandCardInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiHandCardInfo
     * @function getTypeUrl
     * @memberof TeenPattiHandCardInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiHandCardInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiHandCardInfo";
    };

    return TeenPattiHandCardInfo;
})();

export const TeenPattiDeskPlayerInfo = $root.TeenPattiDeskPlayerInfo = (() => {

    /**
     * Properties of a TeenPattiDeskPlayerInfo.
     * @exports ITeenPattiDeskPlayerInfo
     * @interface ITeenPattiDeskPlayerInfo
     * @property {number|null} [DeskNo] TeenPattiDeskPlayerInfo DeskNo
     * @property {ITeenPattiHandCardInfo|null} [PlayerCardInfo] TeenPattiDeskPlayerInfo PlayerCardInfo
     * @property {Array.<ITeenPattiHandCardInfo>|null} [OtherCardInfo] TeenPattiDeskPlayerInfo OtherCardInfo
     */

    /**
     * Constructs a new TeenPattiDeskPlayerInfo.
     * @exports TeenPattiDeskPlayerInfo
     * @classdesc Represents a TeenPattiDeskPlayerInfo.
     * @implements ITeenPattiDeskPlayerInfo
     * @constructor
     * @param {ITeenPattiDeskPlayerInfo=} [properties] Properties to set
     */
    function TeenPattiDeskPlayerInfo(properties) {
        this.OtherCardInfo = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeenPattiDeskPlayerInfo DeskNo.
     * @member {number} DeskNo
     * @memberof TeenPattiDeskPlayerInfo
     * @instance
     */
    TeenPattiDeskPlayerInfo.prototype.DeskNo = 0;

    /**
     * TeenPattiDeskPlayerInfo PlayerCardInfo.
     * @member {ITeenPattiHandCardInfo|null|undefined} PlayerCardInfo
     * @memberof TeenPattiDeskPlayerInfo
     * @instance
     */
    TeenPattiDeskPlayerInfo.prototype.PlayerCardInfo = null;

    /**
     * TeenPattiDeskPlayerInfo OtherCardInfo.
     * @member {Array.<ITeenPattiHandCardInfo>} OtherCardInfo
     * @memberof TeenPattiDeskPlayerInfo
     * @instance
     */
    TeenPattiDeskPlayerInfo.prototype.OtherCardInfo = $util.emptyArray;

    /**
     * Creates a new TeenPattiDeskPlayerInfo instance using the specified properties.
     * @function create
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {ITeenPattiDeskPlayerInfo=} [properties] Properties to set
     * @returns {TeenPattiDeskPlayerInfo} TeenPattiDeskPlayerInfo instance
     */
    TeenPattiDeskPlayerInfo.create = function create(properties) {
        return new TeenPattiDeskPlayerInfo(properties);
    };

    /**
     * Encodes the specified TeenPattiDeskPlayerInfo message. Does not implicitly {@link TeenPattiDeskPlayerInfo.verify|verify} messages.
     * @function encode
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {ITeenPattiDeskPlayerInfo} message TeenPattiDeskPlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiDeskPlayerInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.PlayerCardInfo != null && Object.hasOwnProperty.call(message, "PlayerCardInfo"))
            $root.TeenPattiHandCardInfo.encode(message.PlayerCardInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.OtherCardInfo != null && message.OtherCardInfo.length)
            for (let i = 0; i < message.OtherCardInfo.length; ++i)
                $root.TeenPattiHandCardInfo.encode(message.OtherCardInfo[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TeenPattiDeskPlayerInfo message, length delimited. Does not implicitly {@link TeenPattiDeskPlayerInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {ITeenPattiDeskPlayerInfo} message TeenPattiDeskPlayerInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeenPattiDeskPlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeenPattiDeskPlayerInfo message from the specified reader or buffer.
     * @function decode
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeenPattiDeskPlayerInfo} TeenPattiDeskPlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiDeskPlayerInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeenPattiDeskPlayerInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.PlayerCardInfo = $root.TeenPattiHandCardInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.OtherCardInfo && message.OtherCardInfo.length))
                        message.OtherCardInfo = [];
                    message.OtherCardInfo.push($root.TeenPattiHandCardInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeenPattiDeskPlayerInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeenPattiDeskPlayerInfo} TeenPattiDeskPlayerInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeenPattiDeskPlayerInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeenPattiDeskPlayerInfo message.
     * @function verify
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeenPattiDeskPlayerInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.PlayerCardInfo != null && message.hasOwnProperty("PlayerCardInfo")) {
            let error = $root.TeenPattiHandCardInfo.verify(message.PlayerCardInfo);
            if (error)
                return "PlayerCardInfo." + error;
        }
        if (message.OtherCardInfo != null && message.hasOwnProperty("OtherCardInfo")) {
            if (!Array.isArray(message.OtherCardInfo))
                return "OtherCardInfo: array expected";
            for (let i = 0; i < message.OtherCardInfo.length; ++i) {
                let error = $root.TeenPattiHandCardInfo.verify(message.OtherCardInfo[i]);
                if (error)
                    return "OtherCardInfo." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TeenPattiDeskPlayerInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeenPattiDeskPlayerInfo} TeenPattiDeskPlayerInfo
     */
    TeenPattiDeskPlayerInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.TeenPattiDeskPlayerInfo)
            return object;
        let message = new $root.TeenPattiDeskPlayerInfo();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.PlayerCardInfo != null) {
            if (typeof object.PlayerCardInfo !== "object")
                throw TypeError(".TeenPattiDeskPlayerInfo.PlayerCardInfo: object expected");
            message.PlayerCardInfo = $root.TeenPattiHandCardInfo.fromObject(object.PlayerCardInfo);
        }
        if (object.OtherCardInfo) {
            if (!Array.isArray(object.OtherCardInfo))
                throw TypeError(".TeenPattiDeskPlayerInfo.OtherCardInfo: array expected");
            message.OtherCardInfo = [];
            for (let i = 0; i < object.OtherCardInfo.length; ++i) {
                if (typeof object.OtherCardInfo[i] !== "object")
                    throw TypeError(".TeenPattiDeskPlayerInfo.OtherCardInfo: object expected");
                message.OtherCardInfo[i] = $root.TeenPattiHandCardInfo.fromObject(object.OtherCardInfo[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TeenPattiDeskPlayerInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {TeenPattiDeskPlayerInfo} message TeenPattiDeskPlayerInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeenPattiDeskPlayerInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.OtherCardInfo = [];
        if (options.defaults) {
            object.DeskNo = 0;
            object.PlayerCardInfo = null;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.PlayerCardInfo != null && message.hasOwnProperty("PlayerCardInfo"))
            object.PlayerCardInfo = $root.TeenPattiHandCardInfo.toObject(message.PlayerCardInfo, options);
        if (message.OtherCardInfo && message.OtherCardInfo.length) {
            object.OtherCardInfo = [];
            for (let j = 0; j < message.OtherCardInfo.length; ++j)
                object.OtherCardInfo[j] = $root.TeenPattiHandCardInfo.toObject(message.OtherCardInfo[j], options);
        }
        return object;
    };

    /**
     * Converts this TeenPattiDeskPlayerInfo to JSON.
     * @function toJSON
     * @memberof TeenPattiDeskPlayerInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeenPattiDeskPlayerInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeenPattiDeskPlayerInfo
     * @function getTypeUrl
     * @memberof TeenPattiDeskPlayerInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeenPattiDeskPlayerInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeenPattiDeskPlayerInfo";
    };

    return TeenPattiDeskPlayerInfo;
})();

export const ShowAiMessage = $root.ShowAiMessage = (() => {

    /**
     * Properties of a ShowAiMessage.
     * @exports IShowAiMessage
     * @interface IShowAiMessage
     * @property {number|null} [UserID] ShowAiMessage UserID
     * @property {boolean|null} [bPlayWin] ShowAiMessage bPlayWin
     */

    /**
     * Constructs a new ShowAiMessage.
     * @exports ShowAiMessage
     * @classdesc Represents a ShowAiMessage.
     * @implements IShowAiMessage
     * @constructor
     * @param {IShowAiMessage=} [properties] Properties to set
     */
    function ShowAiMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ShowAiMessage UserID.
     * @member {number} UserID
     * @memberof ShowAiMessage
     * @instance
     */
    ShowAiMessage.prototype.UserID = 0;

    /**
     * ShowAiMessage bPlayWin.
     * @member {boolean} bPlayWin
     * @memberof ShowAiMessage
     * @instance
     */
    ShowAiMessage.prototype.bPlayWin = false;

    /**
     * Creates a new ShowAiMessage instance using the specified properties.
     * @function create
     * @memberof ShowAiMessage
     * @static
     * @param {IShowAiMessage=} [properties] Properties to set
     * @returns {ShowAiMessage} ShowAiMessage instance
     */
    ShowAiMessage.create = function create(properties) {
        return new ShowAiMessage(properties);
    };

    /**
     * Encodes the specified ShowAiMessage message. Does not implicitly {@link ShowAiMessage.verify|verify} messages.
     * @function encode
     * @memberof ShowAiMessage
     * @static
     * @param {IShowAiMessage} message ShowAiMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowAiMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.bPlayWin != null && Object.hasOwnProperty.call(message, "bPlayWin"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.bPlayWin);
        return writer;
    };

    /**
     * Encodes the specified ShowAiMessage message, length delimited. Does not implicitly {@link ShowAiMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ShowAiMessage
     * @static
     * @param {IShowAiMessage} message ShowAiMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowAiMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ShowAiMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ShowAiMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ShowAiMessage} ShowAiMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowAiMessage.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ShowAiMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.bPlayWin = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ShowAiMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ShowAiMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ShowAiMessage} ShowAiMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowAiMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ShowAiMessage message.
     * @function verify
     * @memberof ShowAiMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ShowAiMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.bPlayWin != null && message.hasOwnProperty("bPlayWin"))
            if (typeof message.bPlayWin !== "boolean")
                return "bPlayWin: boolean expected";
        return null;
    };

    /**
     * Creates a ShowAiMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ShowAiMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ShowAiMessage} ShowAiMessage
     */
    ShowAiMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ShowAiMessage)
            return object;
        let message = new $root.ShowAiMessage();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.bPlayWin != null)
            message.bPlayWin = Boolean(object.bPlayWin);
        return message;
    };

    /**
     * Creates a plain object from a ShowAiMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ShowAiMessage
     * @static
     * @param {ShowAiMessage} message ShowAiMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ShowAiMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.bPlayWin = false;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.bPlayWin != null && message.hasOwnProperty("bPlayWin"))
            object.bPlayWin = message.bPlayWin;
        return object;
    };

    /**
     * Converts this ShowAiMessage to JSON.
     * @function toJSON
     * @memberof ShowAiMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ShowAiMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ShowAiMessage
     * @function getTypeUrl
     * @memberof ShowAiMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ShowAiMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ShowAiMessage";
    };

    return ShowAiMessage;
})();

export const PushTeenPattinChargeGold = $root.PushTeenPattinChargeGold = (() => {

    /**
     * Properties of a PushTeenPattinChargeGold.
     * @exports IPushTeenPattinChargeGold
     * @interface IPushTeenPattinChargeGold
     * @property {number|null} [ChargeGold] PushTeenPattinChargeGold ChargeGold
     */

    /**
     * Constructs a new PushTeenPattinChargeGold.
     * @exports PushTeenPattinChargeGold
     * @classdesc Represents a PushTeenPattinChargeGold.
     * @implements IPushTeenPattinChargeGold
     * @constructor
     * @param {IPushTeenPattinChargeGold=} [properties] Properties to set
     */
    function PushTeenPattinChargeGold(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PushTeenPattinChargeGold ChargeGold.
     * @member {number} ChargeGold
     * @memberof PushTeenPattinChargeGold
     * @instance
     */
    PushTeenPattinChargeGold.prototype.ChargeGold = 0;

    /**
     * Creates a new PushTeenPattinChargeGold instance using the specified properties.
     * @function create
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {IPushTeenPattinChargeGold=} [properties] Properties to set
     * @returns {PushTeenPattinChargeGold} PushTeenPattinChargeGold instance
     */
    PushTeenPattinChargeGold.create = function create(properties) {
        return new PushTeenPattinChargeGold(properties);
    };

    /**
     * Encodes the specified PushTeenPattinChargeGold message. Does not implicitly {@link PushTeenPattinChargeGold.verify|verify} messages.
     * @function encode
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {IPushTeenPattinChargeGold} message PushTeenPattinChargeGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushTeenPattinChargeGold.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ChargeGold != null && Object.hasOwnProperty.call(message, "ChargeGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ChargeGold);
        return writer;
    };

    /**
     * Encodes the specified PushTeenPattinChargeGold message, length delimited. Does not implicitly {@link PushTeenPattinChargeGold.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {IPushTeenPattinChargeGold} message PushTeenPattinChargeGold message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushTeenPattinChargeGold.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PushTeenPattinChargeGold message from the specified reader or buffer.
     * @function decode
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PushTeenPattinChargeGold} PushTeenPattinChargeGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushTeenPattinChargeGold.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PushTeenPattinChargeGold();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ChargeGold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PushTeenPattinChargeGold message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PushTeenPattinChargeGold} PushTeenPattinChargeGold
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushTeenPattinChargeGold.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PushTeenPattinChargeGold message.
     * @function verify
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PushTeenPattinChargeGold.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ChargeGold != null && message.hasOwnProperty("ChargeGold"))
            if (!$util.isInteger(message.ChargeGold))
                return "ChargeGold: integer expected";
        return null;
    };

    /**
     * Creates a PushTeenPattinChargeGold message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PushTeenPattinChargeGold} PushTeenPattinChargeGold
     */
    PushTeenPattinChargeGold.fromObject = function fromObject(object) {
        if (object instanceof $root.PushTeenPattinChargeGold)
            return object;
        let message = new $root.PushTeenPattinChargeGold();
        if (object.ChargeGold != null)
            message.ChargeGold = object.ChargeGold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PushTeenPattinChargeGold message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {PushTeenPattinChargeGold} message PushTeenPattinChargeGold
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PushTeenPattinChargeGold.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.ChargeGold = 0;
        if (message.ChargeGold != null && message.hasOwnProperty("ChargeGold"))
            object.ChargeGold = message.ChargeGold;
        return object;
    };

    /**
     * Converts this PushTeenPattinChargeGold to JSON.
     * @function toJSON
     * @memberof PushTeenPattinChargeGold
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PushTeenPattinChargeGold.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PushTeenPattinChargeGold
     * @function getTypeUrl
     * @memberof PushTeenPattinChargeGold
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PushTeenPattinChargeGold.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PushTeenPattinChargeGold";
    };

    return PushTeenPattinChargeGold;
})();

export const ThunderProduct = $root.ThunderProduct = (() => {

    /**
     * Properties of a ThunderProduct.
     * @exports IThunderProduct
     * @interface IThunderProduct
     * @property {number|null} [PID] ThunderProduct PID
     * @property {number|null} [Mode] ThunderProduct Mode
     * @property {string|null} [AutoBet] ThunderProduct AutoBet
     */

    /**
     * Constructs a new ThunderProduct.
     * @exports ThunderProduct
     * @classdesc Represents a ThunderProduct.
     * @implements IThunderProduct
     * @constructor
     * @param {IThunderProduct=} [properties] Properties to set
     */
    function ThunderProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThunderProduct PID.
     * @member {number} PID
     * @memberof ThunderProduct
     * @instance
     */
    ThunderProduct.prototype.PID = 0;

    /**
     * ThunderProduct Mode.
     * @member {number} Mode
     * @memberof ThunderProduct
     * @instance
     */
    ThunderProduct.prototype.Mode = 0;

    /**
     * ThunderProduct AutoBet.
     * @member {string} AutoBet
     * @memberof ThunderProduct
     * @instance
     */
    ThunderProduct.prototype.AutoBet = "";

    /**
     * Creates a new ThunderProduct instance using the specified properties.
     * @function create
     * @memberof ThunderProduct
     * @static
     * @param {IThunderProduct=} [properties] Properties to set
     * @returns {ThunderProduct} ThunderProduct instance
     */
    ThunderProduct.create = function create(properties) {
        return new ThunderProduct(properties);
    };

    /**
     * Encodes the specified ThunderProduct message. Does not implicitly {@link ThunderProduct.verify|verify} messages.
     * @function encode
     * @memberof ThunderProduct
     * @static
     * @param {IThunderProduct} message ThunderProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.AutoBet != null && Object.hasOwnProperty.call(message, "AutoBet"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.AutoBet);
        return writer;
    };

    /**
     * Encodes the specified ThunderProduct message, length delimited. Does not implicitly {@link ThunderProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThunderProduct
     * @static
     * @param {IThunderProduct} message ThunderProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThunderProduct message from the specified reader or buffer.
     * @function decode
     * @memberof ThunderProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThunderProduct} ThunderProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThunderProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.AutoBet = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThunderProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThunderProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThunderProduct} ThunderProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThunderProduct message.
     * @function verify
     * @memberof ThunderProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThunderProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            if (!$util.isString(message.AutoBet))
                return "AutoBet: string expected";
        return null;
    };

    /**
     * Creates a ThunderProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThunderProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThunderProduct} ThunderProduct
     */
    ThunderProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.ThunderProduct)
            return object;
        let message = new $root.ThunderProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.AutoBet != null)
            message.AutoBet = String(object.AutoBet);
        return message;
    };

    /**
     * Creates a plain object from a ThunderProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThunderProduct
     * @static
     * @param {ThunderProduct} message ThunderProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThunderProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.AutoBet = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            object.AutoBet = message.AutoBet;
        return object;
    };

    /**
     * Converts this ThunderProduct to JSON.
     * @function toJSON
     * @memberof ThunderProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThunderProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ThunderProduct
     * @function getTypeUrl
     * @memberof ThunderProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ThunderProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ThunderProduct";
    };

    return ThunderProduct;
})();

export const ThunderGame = $root.ThunderGame = (() => {

    /**
     * Properties of a ThunderGame.
     * @exports IThunderGame
     * @interface IThunderGame
     * @property {number|Long|null} [BetGold] ThunderGame BetGold
     * @property {number|Long|null} [LeiHuo5] ThunderGame LeiHuo5
     * @property {number|Long|null} [LeiHuo6] ThunderGame LeiHuo6
     * @property {number|Long|null} [LeiHuo7] ThunderGame LeiHuo7
     * @property {number|Long|null} [LeiHuo8] ThunderGame LeiHuo8
     * @property {number|Long|null} [LeiHuo9] ThunderGame LeiHuo9
     */

    /**
     * Constructs a new ThunderGame.
     * @exports ThunderGame
     * @classdesc Represents a ThunderGame.
     * @implements IThunderGame
     * @constructor
     * @param {IThunderGame=} [properties] Properties to set
     */
    function ThunderGame(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThunderGame BetGold.
     * @member {number|Long} BetGold
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderGame LeiHuo5.
     * @member {number|Long} LeiHuo5
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.LeiHuo5 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderGame LeiHuo6.
     * @member {number|Long} LeiHuo6
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.LeiHuo6 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderGame LeiHuo7.
     * @member {number|Long} LeiHuo7
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.LeiHuo7 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderGame LeiHuo8.
     * @member {number|Long} LeiHuo8
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.LeiHuo8 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderGame LeiHuo9.
     * @member {number|Long} LeiHuo9
     * @memberof ThunderGame
     * @instance
     */
    ThunderGame.prototype.LeiHuo9 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ThunderGame instance using the specified properties.
     * @function create
     * @memberof ThunderGame
     * @static
     * @param {IThunderGame=} [properties] Properties to set
     * @returns {ThunderGame} ThunderGame instance
     */
    ThunderGame.create = function create(properties) {
        return new ThunderGame(properties);
    };

    /**
     * Encodes the specified ThunderGame message. Does not implicitly {@link ThunderGame.verify|verify} messages.
     * @function encode
     * @memberof ThunderGame
     * @static
     * @param {IThunderGame} message ThunderGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderGame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.BetGold);
        if (message.LeiHuo5 != null && Object.hasOwnProperty.call(message, "LeiHuo5"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.LeiHuo5);
        if (message.LeiHuo6 != null && Object.hasOwnProperty.call(message, "LeiHuo6"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.LeiHuo6);
        if (message.LeiHuo7 != null && Object.hasOwnProperty.call(message, "LeiHuo7"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.LeiHuo7);
        if (message.LeiHuo8 != null && Object.hasOwnProperty.call(message, "LeiHuo8"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.LeiHuo8);
        if (message.LeiHuo9 != null && Object.hasOwnProperty.call(message, "LeiHuo9"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.LeiHuo9);
        return writer;
    };

    /**
     * Encodes the specified ThunderGame message, length delimited. Does not implicitly {@link ThunderGame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThunderGame
     * @static
     * @param {IThunderGame} message ThunderGame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderGame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThunderGame message from the specified reader or buffer.
     * @function decode
     * @memberof ThunderGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThunderGame} ThunderGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderGame.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThunderGame();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetGold = reader.uint64();
                    break;
                }
            case 2: {
                    message.LeiHuo5 = reader.uint64();
                    break;
                }
            case 3: {
                    message.LeiHuo6 = reader.uint64();
                    break;
                }
            case 4: {
                    message.LeiHuo7 = reader.uint64();
                    break;
                }
            case 5: {
                    message.LeiHuo8 = reader.uint64();
                    break;
                }
            case 6: {
                    message.LeiHuo9 = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThunderGame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThunderGame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThunderGame} ThunderGame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderGame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThunderGame message.
     * @function verify
     * @memberof ThunderGame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThunderGame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        if (message.LeiHuo5 != null && message.hasOwnProperty("LeiHuo5"))
            if (!$util.isInteger(message.LeiHuo5) && !(message.LeiHuo5 && $util.isInteger(message.LeiHuo5.low) && $util.isInteger(message.LeiHuo5.high)))
                return "LeiHuo5: integer|Long expected";
        if (message.LeiHuo6 != null && message.hasOwnProperty("LeiHuo6"))
            if (!$util.isInteger(message.LeiHuo6) && !(message.LeiHuo6 && $util.isInteger(message.LeiHuo6.low) && $util.isInteger(message.LeiHuo6.high)))
                return "LeiHuo6: integer|Long expected";
        if (message.LeiHuo7 != null && message.hasOwnProperty("LeiHuo7"))
            if (!$util.isInteger(message.LeiHuo7) && !(message.LeiHuo7 && $util.isInteger(message.LeiHuo7.low) && $util.isInteger(message.LeiHuo7.high)))
                return "LeiHuo7: integer|Long expected";
        if (message.LeiHuo8 != null && message.hasOwnProperty("LeiHuo8"))
            if (!$util.isInteger(message.LeiHuo8) && !(message.LeiHuo8 && $util.isInteger(message.LeiHuo8.low) && $util.isInteger(message.LeiHuo8.high)))
                return "LeiHuo8: integer|Long expected";
        if (message.LeiHuo9 != null && message.hasOwnProperty("LeiHuo9"))
            if (!$util.isInteger(message.LeiHuo9) && !(message.LeiHuo9 && $util.isInteger(message.LeiHuo9.low) && $util.isInteger(message.LeiHuo9.high)))
                return "LeiHuo9: integer|Long expected";
        return null;
    };

    /**
     * Creates a ThunderGame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThunderGame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThunderGame} ThunderGame
     */
    ThunderGame.fromObject = function fromObject(object) {
        if (object instanceof $root.ThunderGame)
            return object;
        let message = new $root.ThunderGame();
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        if (object.LeiHuo5 != null)
            if ($util.Long)
                (message.LeiHuo5 = $util.Long.fromValue(object.LeiHuo5)).unsigned = true;
            else if (typeof object.LeiHuo5 === "string")
                message.LeiHuo5 = parseInt(object.LeiHuo5, 10);
            else if (typeof object.LeiHuo5 === "number")
                message.LeiHuo5 = object.LeiHuo5;
            else if (typeof object.LeiHuo5 === "object")
                message.LeiHuo5 = new $util.LongBits(object.LeiHuo5.low >>> 0, object.LeiHuo5.high >>> 0).toNumber(true);
        if (object.LeiHuo6 != null)
            if ($util.Long)
                (message.LeiHuo6 = $util.Long.fromValue(object.LeiHuo6)).unsigned = true;
            else if (typeof object.LeiHuo6 === "string")
                message.LeiHuo6 = parseInt(object.LeiHuo6, 10);
            else if (typeof object.LeiHuo6 === "number")
                message.LeiHuo6 = object.LeiHuo6;
            else if (typeof object.LeiHuo6 === "object")
                message.LeiHuo6 = new $util.LongBits(object.LeiHuo6.low >>> 0, object.LeiHuo6.high >>> 0).toNumber(true);
        if (object.LeiHuo7 != null)
            if ($util.Long)
                (message.LeiHuo7 = $util.Long.fromValue(object.LeiHuo7)).unsigned = true;
            else if (typeof object.LeiHuo7 === "string")
                message.LeiHuo7 = parseInt(object.LeiHuo7, 10);
            else if (typeof object.LeiHuo7 === "number")
                message.LeiHuo7 = object.LeiHuo7;
            else if (typeof object.LeiHuo7 === "object")
                message.LeiHuo7 = new $util.LongBits(object.LeiHuo7.low >>> 0, object.LeiHuo7.high >>> 0).toNumber(true);
        if (object.LeiHuo8 != null)
            if ($util.Long)
                (message.LeiHuo8 = $util.Long.fromValue(object.LeiHuo8)).unsigned = true;
            else if (typeof object.LeiHuo8 === "string")
                message.LeiHuo8 = parseInt(object.LeiHuo8, 10);
            else if (typeof object.LeiHuo8 === "number")
                message.LeiHuo8 = object.LeiHuo8;
            else if (typeof object.LeiHuo8 === "object")
                message.LeiHuo8 = new $util.LongBits(object.LeiHuo8.low >>> 0, object.LeiHuo8.high >>> 0).toNumber(true);
        if (object.LeiHuo9 != null)
            if ($util.Long)
                (message.LeiHuo9 = $util.Long.fromValue(object.LeiHuo9)).unsigned = true;
            else if (typeof object.LeiHuo9 === "string")
                message.LeiHuo9 = parseInt(object.LeiHuo9, 10);
            else if (typeof object.LeiHuo9 === "number")
                message.LeiHuo9 = object.LeiHuo9;
            else if (typeof object.LeiHuo9 === "object")
                message.LeiHuo9 = new $util.LongBits(object.LeiHuo9.low >>> 0, object.LeiHuo9.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ThunderGame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThunderGame
     * @static
     * @param {ThunderGame} message ThunderGame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThunderGame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeiHuo5 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeiHuo5 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeiHuo6 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeiHuo6 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeiHuo7 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeiHuo7 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeiHuo8 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeiHuo8 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LeiHuo9 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LeiHuo9 = options.longs === String ? "0" : 0;
        }
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        if (message.LeiHuo5 != null && message.hasOwnProperty("LeiHuo5"))
            if (typeof message.LeiHuo5 === "number")
                object.LeiHuo5 = options.longs === String ? String(message.LeiHuo5) : message.LeiHuo5;
            else
                object.LeiHuo5 = options.longs === String ? $util.Long.prototype.toString.call(message.LeiHuo5) : options.longs === Number ? new $util.LongBits(message.LeiHuo5.low >>> 0, message.LeiHuo5.high >>> 0).toNumber(true) : message.LeiHuo5;
        if (message.LeiHuo6 != null && message.hasOwnProperty("LeiHuo6"))
            if (typeof message.LeiHuo6 === "number")
                object.LeiHuo6 = options.longs === String ? String(message.LeiHuo6) : message.LeiHuo6;
            else
                object.LeiHuo6 = options.longs === String ? $util.Long.prototype.toString.call(message.LeiHuo6) : options.longs === Number ? new $util.LongBits(message.LeiHuo6.low >>> 0, message.LeiHuo6.high >>> 0).toNumber(true) : message.LeiHuo6;
        if (message.LeiHuo7 != null && message.hasOwnProperty("LeiHuo7"))
            if (typeof message.LeiHuo7 === "number")
                object.LeiHuo7 = options.longs === String ? String(message.LeiHuo7) : message.LeiHuo7;
            else
                object.LeiHuo7 = options.longs === String ? $util.Long.prototype.toString.call(message.LeiHuo7) : options.longs === Number ? new $util.LongBits(message.LeiHuo7.low >>> 0, message.LeiHuo7.high >>> 0).toNumber(true) : message.LeiHuo7;
        if (message.LeiHuo8 != null && message.hasOwnProperty("LeiHuo8"))
            if (typeof message.LeiHuo8 === "number")
                object.LeiHuo8 = options.longs === String ? String(message.LeiHuo8) : message.LeiHuo8;
            else
                object.LeiHuo8 = options.longs === String ? $util.Long.prototype.toString.call(message.LeiHuo8) : options.longs === Number ? new $util.LongBits(message.LeiHuo8.low >>> 0, message.LeiHuo8.high >>> 0).toNumber(true) : message.LeiHuo8;
        if (message.LeiHuo9 != null && message.hasOwnProperty("LeiHuo9"))
            if (typeof message.LeiHuo9 === "number")
                object.LeiHuo9 = options.longs === String ? String(message.LeiHuo9) : message.LeiHuo9;
            else
                object.LeiHuo9 = options.longs === String ? $util.Long.prototype.toString.call(message.LeiHuo9) : options.longs === Number ? new $util.LongBits(message.LeiHuo9.low >>> 0, message.LeiHuo9.high >>> 0).toNumber(true) : message.LeiHuo9;
        return object;
    };

    /**
     * Converts this ThunderGame to JSON.
     * @function toJSON
     * @memberof ThunderGame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThunderGame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ThunderGame
     * @function getTypeUrl
     * @memberof ThunderGame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ThunderGame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ThunderGame";
    };

    return ThunderGame;
})();

export const ThunderOdds = $root.ThunderOdds = (() => {

    /**
     * Properties of a ThunderOdds.
     * @exports IThunderOdds
     * @interface IThunderOdds
     * @property {number|null} [PrizeType] ThunderOdds PrizeType
     * @property {Array.<number>|null} [Odds] ThunderOdds Odds
     */

    /**
     * Constructs a new ThunderOdds.
     * @exports ThunderOdds
     * @classdesc Represents a ThunderOdds.
     * @implements IThunderOdds
     * @constructor
     * @param {IThunderOdds=} [properties] Properties to set
     */
    function ThunderOdds(properties) {
        this.Odds = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThunderOdds PrizeType.
     * @member {number} PrizeType
     * @memberof ThunderOdds
     * @instance
     */
    ThunderOdds.prototype.PrizeType = 0;

    /**
     * ThunderOdds Odds.
     * @member {Array.<number>} Odds
     * @memberof ThunderOdds
     * @instance
     */
    ThunderOdds.prototype.Odds = $util.emptyArray;

    /**
     * Creates a new ThunderOdds instance using the specified properties.
     * @function create
     * @memberof ThunderOdds
     * @static
     * @param {IThunderOdds=} [properties] Properties to set
     * @returns {ThunderOdds} ThunderOdds instance
     */
    ThunderOdds.create = function create(properties) {
        return new ThunderOdds(properties);
    };

    /**
     * Encodes the specified ThunderOdds message. Does not implicitly {@link ThunderOdds.verify|verify} messages.
     * @function encode
     * @memberof ThunderOdds
     * @static
     * @param {IThunderOdds} message ThunderOdds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderOdds.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PrizeType != null && Object.hasOwnProperty.call(message, "PrizeType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PrizeType);
        if (message.Odds != null && message.Odds.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.Odds.length; ++i)
                writer.uint32(message.Odds[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified ThunderOdds message, length delimited. Does not implicitly {@link ThunderOdds.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThunderOdds
     * @static
     * @param {IThunderOdds} message ThunderOdds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderOdds.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThunderOdds message from the specified reader or buffer.
     * @function decode
     * @memberof ThunderOdds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThunderOdds} ThunderOdds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderOdds.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThunderOdds();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PrizeType = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.Odds && message.Odds.length))
                        message.Odds = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Odds.push(reader.uint32());
                    } else
                        message.Odds.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThunderOdds message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThunderOdds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThunderOdds} ThunderOdds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderOdds.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThunderOdds message.
     * @function verify
     * @memberof ThunderOdds
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThunderOdds.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PrizeType != null && message.hasOwnProperty("PrizeType"))
            if (!$util.isInteger(message.PrizeType))
                return "PrizeType: integer expected";
        if (message.Odds != null && message.hasOwnProperty("Odds")) {
            if (!Array.isArray(message.Odds))
                return "Odds: array expected";
            for (let i = 0; i < message.Odds.length; ++i)
                if (!$util.isInteger(message.Odds[i]))
                    return "Odds: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a ThunderOdds message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThunderOdds
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThunderOdds} ThunderOdds
     */
    ThunderOdds.fromObject = function fromObject(object) {
        if (object instanceof $root.ThunderOdds)
            return object;
        let message = new $root.ThunderOdds();
        if (object.PrizeType != null)
            message.PrizeType = object.PrizeType >>> 0;
        if (object.Odds) {
            if (!Array.isArray(object.Odds))
                throw TypeError(".ThunderOdds.Odds: array expected");
            message.Odds = [];
            for (let i = 0; i < object.Odds.length; ++i)
                message.Odds[i] = object.Odds[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a ThunderOdds message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThunderOdds
     * @static
     * @param {ThunderOdds} message ThunderOdds
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThunderOdds.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Odds = [];
        if (options.defaults)
            object.PrizeType = 0;
        if (message.PrizeType != null && message.hasOwnProperty("PrizeType"))
            object.PrizeType = message.PrizeType;
        if (message.Odds && message.Odds.length) {
            object.Odds = [];
            for (let j = 0; j < message.Odds.length; ++j)
                object.Odds[j] = message.Odds[j];
        }
        return object;
    };

    /**
     * Converts this ThunderOdds to JSON.
     * @function toJSON
     * @memberof ThunderOdds
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThunderOdds.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ThunderOdds
     * @function getTypeUrl
     * @memberof ThunderOdds
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ThunderOdds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ThunderOdds";
    };

    return ThunderOdds;
})();

export const ThunderSrvToDeskPushDeskInfo = $root.ThunderSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a ThunderSrvToDeskPushDeskInfo.
     * @exports IThunderSrvToDeskPushDeskInfo
     * @interface IThunderSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] ThunderSrvToDeskPushDeskInfo UserID
     * @property {number|Long|null} [Gold] ThunderSrvToDeskPushDeskInfo Gold
     * @property {IThunderProduct|null} [Product] ThunderSrvToDeskPushDeskInfo Product
     * @property {Array.<IThunderGame>|null} [GameCfg] ThunderSrvToDeskPushDeskInfo GameCfg
     * @property {Array.<IThunderOdds>|null} [PrizeOdds] ThunderSrvToDeskPushDeskInfo PrizeOdds
     */

    /**
     * Constructs a new ThunderSrvToDeskPushDeskInfo.
     * @exports ThunderSrvToDeskPushDeskInfo
     * @classdesc Represents a ThunderSrvToDeskPushDeskInfo.
     * @implements IThunderSrvToDeskPushDeskInfo
     * @constructor
     * @param {IThunderSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function ThunderSrvToDeskPushDeskInfo(properties) {
        this.GameCfg = [];
        this.PrizeOdds = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThunderSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     */
    ThunderSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * ThunderSrvToDeskPushDeskInfo Gold.
     * @member {number|Long} Gold
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     */
    ThunderSrvToDeskPushDeskInfo.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderSrvToDeskPushDeskInfo Product.
     * @member {IThunderProduct|null|undefined} Product
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     */
    ThunderSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * ThunderSrvToDeskPushDeskInfo GameCfg.
     * @member {Array.<IThunderGame>} GameCfg
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     */
    ThunderSrvToDeskPushDeskInfo.prototype.GameCfg = $util.emptyArray;

    /**
     * ThunderSrvToDeskPushDeskInfo PrizeOdds.
     * @member {Array.<IThunderOdds>} PrizeOdds
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     */
    ThunderSrvToDeskPushDeskInfo.prototype.PrizeOdds = $util.emptyArray;

    /**
     * Creates a new ThunderSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {IThunderSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {ThunderSrvToDeskPushDeskInfo} ThunderSrvToDeskPushDeskInfo instance
     */
    ThunderSrvToDeskPushDeskInfo.create = function create(properties) {
        return new ThunderSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified ThunderSrvToDeskPushDeskInfo message. Does not implicitly {@link ThunderSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {IThunderSrvToDeskPushDeskInfo} message ThunderSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.Gold);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.ThunderProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.GameCfg != null && message.GameCfg.length)
            for (let i = 0; i < message.GameCfg.length; ++i)
                $root.ThunderGame.encode(message.GameCfg[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.PrizeOdds != null && message.PrizeOdds.length)
            for (let i = 0; i < message.PrizeOdds.length; ++i)
                $root.ThunderOdds.encode(message.PrizeOdds[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ThunderSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link ThunderSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {IThunderSrvToDeskPushDeskInfo} message ThunderSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThunderSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThunderSrvToDeskPushDeskInfo} ThunderSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThunderSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Gold = reader.uint64();
                    break;
                }
            case 3: {
                    message.Product = $root.ThunderProduct.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.GameCfg && message.GameCfg.length))
                        message.GameCfg = [];
                    message.GameCfg.push($root.ThunderGame.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    if (!(message.PrizeOdds && message.PrizeOdds.length))
                        message.PrizeOdds = [];
                    message.PrizeOdds.push($root.ThunderOdds.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThunderSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThunderSrvToDeskPushDeskInfo} ThunderSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThunderSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThunderSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.ThunderProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.GameCfg != null && message.hasOwnProperty("GameCfg")) {
            if (!Array.isArray(message.GameCfg))
                return "GameCfg: array expected";
            for (let i = 0; i < message.GameCfg.length; ++i) {
                let error = $root.ThunderGame.verify(message.GameCfg[i]);
                if (error)
                    return "GameCfg." + error;
            }
        }
        if (message.PrizeOdds != null && message.hasOwnProperty("PrizeOdds")) {
            if (!Array.isArray(message.PrizeOdds))
                return "PrizeOdds: array expected";
            for (let i = 0; i < message.PrizeOdds.length; ++i) {
                let error = $root.ThunderOdds.verify(message.PrizeOdds[i]);
                if (error)
                    return "PrizeOdds." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ThunderSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThunderSrvToDeskPushDeskInfo} ThunderSrvToDeskPushDeskInfo
     */
    ThunderSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ThunderSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.ThunderSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".ThunderSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.ThunderProduct.fromObject(object.Product);
        }
        if (object.GameCfg) {
            if (!Array.isArray(object.GameCfg))
                throw TypeError(".ThunderSrvToDeskPushDeskInfo.GameCfg: array expected");
            message.GameCfg = [];
            for (let i = 0; i < object.GameCfg.length; ++i) {
                if (typeof object.GameCfg[i] !== "object")
                    throw TypeError(".ThunderSrvToDeskPushDeskInfo.GameCfg: object expected");
                message.GameCfg[i] = $root.ThunderGame.fromObject(object.GameCfg[i]);
            }
        }
        if (object.PrizeOdds) {
            if (!Array.isArray(object.PrizeOdds))
                throw TypeError(".ThunderSrvToDeskPushDeskInfo.PrizeOdds: array expected");
            message.PrizeOdds = [];
            for (let i = 0; i < object.PrizeOdds.length; ++i) {
                if (typeof object.PrizeOdds[i] !== "object")
                    throw TypeError(".ThunderSrvToDeskPushDeskInfo.PrizeOdds: object expected");
                message.PrizeOdds[i] = $root.ThunderOdds.fromObject(object.PrizeOdds[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ThunderSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {ThunderSrvToDeskPushDeskInfo} message ThunderSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThunderSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GameCfg = [];
            object.PrizeOdds = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.ThunderProduct.toObject(message.Product, options);
        if (message.GameCfg && message.GameCfg.length) {
            object.GameCfg = [];
            for (let j = 0; j < message.GameCfg.length; ++j)
                object.GameCfg[j] = $root.ThunderGame.toObject(message.GameCfg[j], options);
        }
        if (message.PrizeOdds && message.PrizeOdds.length) {
            object.PrizeOdds = [];
            for (let j = 0; j < message.PrizeOdds.length; ++j)
                object.PrizeOdds[j] = $root.ThunderOdds.toObject(message.PrizeOdds[j], options);
        }
        return object;
    };

    /**
     * Converts this ThunderSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThunderSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ThunderSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof ThunderSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ThunderSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ThunderSrvToDeskPushDeskInfo";
    };

    return ThunderSrvToDeskPushDeskInfo;
})();

export const Client2ThunderSrvReqBet = $root.Client2ThunderSrvReqBet = (() => {

    /**
     * Properties of a Client2ThunderSrvReqBet.
     * @exports IClient2ThunderSrvReqBet
     * @interface IClient2ThunderSrvReqBet
     * @property {number|null} [DeskNo] Client2ThunderSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2ThunderSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2ThunderSrvReqBet SeatNo
     * @property {number|Long|null} [BetGold] Client2ThunderSrvReqBet BetGold
     * @property {number|Long|null} [LineBet] Client2ThunderSrvReqBet LineBet
     */

    /**
     * Constructs a new Client2ThunderSrvReqBet.
     * @exports Client2ThunderSrvReqBet
     * @classdesc Represents a Client2ThunderSrvReqBet.
     * @implements IClient2ThunderSrvReqBet
     * @constructor
     * @param {IClient2ThunderSrvReqBet=} [properties] Properties to set
     */
    function Client2ThunderSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ThunderSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ThunderSrvReqBet
     * @instance
     */
    Client2ThunderSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2ThunderSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2ThunderSrvReqBet
     * @instance
     */
    Client2ThunderSrvReqBet.prototype.UserID = 0;

    /**
     * Client2ThunderSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ThunderSrvReqBet
     * @instance
     */
    Client2ThunderSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2ThunderSrvReqBet BetGold.
     * @member {number|Long} BetGold
     * @memberof Client2ThunderSrvReqBet
     * @instance
     */
    Client2ThunderSrvReqBet.prototype.BetGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Client2ThunderSrvReqBet LineBet.
     * @member {number|Long} LineBet
     * @memberof Client2ThunderSrvReqBet
     * @instance
     */
    Client2ThunderSrvReqBet.prototype.LineBet = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2ThunderSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {IClient2ThunderSrvReqBet=} [properties] Properties to set
     * @returns {Client2ThunderSrvReqBet} Client2ThunderSrvReqBet instance
     */
    Client2ThunderSrvReqBet.create = function create(properties) {
        return new Client2ThunderSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2ThunderSrvReqBet message. Does not implicitly {@link Client2ThunderSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {IClient2ThunderSrvReqBet} message Client2ThunderSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ThunderSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.BetGold);
        if (message.LineBet != null && Object.hasOwnProperty.call(message, "LineBet"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.LineBet);
        return writer;
    };

    /**
     * Encodes the specified Client2ThunderSrvReqBet message, length delimited. Does not implicitly {@link Client2ThunderSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {IClient2ThunderSrvReqBet} message Client2ThunderSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ThunderSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ThunderSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ThunderSrvReqBet} Client2ThunderSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ThunderSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ThunderSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetGold = reader.uint64();
                    break;
                }
            case 5: {
                    message.LineBet = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ThunderSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ThunderSrvReqBet} Client2ThunderSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ThunderSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ThunderSrvReqBet message.
     * @function verify
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ThunderSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold) && !(message.BetGold && $util.isInteger(message.BetGold.low) && $util.isInteger(message.BetGold.high)))
                return "BetGold: integer|Long expected";
        if (message.LineBet != null && message.hasOwnProperty("LineBet"))
            if (!$util.isInteger(message.LineBet) && !(message.LineBet && $util.isInteger(message.LineBet.low) && $util.isInteger(message.LineBet.high)))
                return "LineBet: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2ThunderSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ThunderSrvReqBet} Client2ThunderSrvReqBet
     */
    Client2ThunderSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ThunderSrvReqBet)
            return object;
        let message = new $root.Client2ThunderSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetGold != null)
            if ($util.Long)
                (message.BetGold = $util.Long.fromValue(object.BetGold)).unsigned = true;
            else if (typeof object.BetGold === "string")
                message.BetGold = parseInt(object.BetGold, 10);
            else if (typeof object.BetGold === "number")
                message.BetGold = object.BetGold;
            else if (typeof object.BetGold === "object")
                message.BetGold = new $util.LongBits(object.BetGold.low >>> 0, object.BetGold.high >>> 0).toNumber(true);
        if (object.LineBet != null)
            if ($util.Long)
                (message.LineBet = $util.Long.fromValue(object.LineBet)).unsigned = true;
            else if (typeof object.LineBet === "string")
                message.LineBet = parseInt(object.LineBet, 10);
            else if (typeof object.LineBet === "number")
                message.LineBet = object.LineBet;
            else if (typeof object.LineBet === "object")
                message.LineBet = new $util.LongBits(object.LineBet.low >>> 0, object.LineBet.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2ThunderSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {Client2ThunderSrvReqBet} message Client2ThunderSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ThunderSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BetGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BetGold = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.LineBet = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.LineBet = options.longs === String ? "0" : 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (typeof message.BetGold === "number")
                object.BetGold = options.longs === String ? String(message.BetGold) : message.BetGold;
            else
                object.BetGold = options.longs === String ? $util.Long.prototype.toString.call(message.BetGold) : options.longs === Number ? new $util.LongBits(message.BetGold.low >>> 0, message.BetGold.high >>> 0).toNumber(true) : message.BetGold;
        if (message.LineBet != null && message.hasOwnProperty("LineBet"))
            if (typeof message.LineBet === "number")
                object.LineBet = options.longs === String ? String(message.LineBet) : message.LineBet;
            else
                object.LineBet = options.longs === String ? $util.Long.prototype.toString.call(message.LineBet) : options.longs === Number ? new $util.LongBits(message.LineBet.low >>> 0, message.LineBet.high >>> 0).toNumber(true) : message.LineBet;
        return object;
    };

    /**
     * Converts this Client2ThunderSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2ThunderSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ThunderSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ThunderSrvReqBet
     * @function getTypeUrl
     * @memberof Client2ThunderSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ThunderSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ThunderSrvReqBet";
    };

    return Client2ThunderSrvReqBet;
})();

export const Client2ThunderSrvAckBet = $root.Client2ThunderSrvAckBet = (() => {

    /**
     * Properties of a Client2ThunderSrvAckBet.
     * @exports IClient2ThunderSrvAckBet
     * @interface IClient2ThunderSrvAckBet
     * @property {number|null} [Ret] Client2ThunderSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2ThunderSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2ThunderSrvAckBet UserID
     * @property {number|null} [SeatNo] Client2ThunderSrvAckBet SeatNo
     * @property {number|Long|null} [Gold] Client2ThunderSrvAckBet Gold
     */

    /**
     * Constructs a new Client2ThunderSrvAckBet.
     * @exports Client2ThunderSrvAckBet
     * @classdesc Represents a Client2ThunderSrvAckBet.
     * @implements IClient2ThunderSrvAckBet
     * @constructor
     * @param {IClient2ThunderSrvAckBet=} [properties] Properties to set
     */
    function Client2ThunderSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2ThunderSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2ThunderSrvAckBet
     * @instance
     */
    Client2ThunderSrvAckBet.prototype.Ret = 0;

    /**
     * Client2ThunderSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2ThunderSrvAckBet
     * @instance
     */
    Client2ThunderSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2ThunderSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2ThunderSrvAckBet
     * @instance
     */
    Client2ThunderSrvAckBet.prototype.UserID = 0;

    /**
     * Client2ThunderSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2ThunderSrvAckBet
     * @instance
     */
    Client2ThunderSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2ThunderSrvAckBet Gold.
     * @member {number|Long} Gold
     * @memberof Client2ThunderSrvAckBet
     * @instance
     */
    Client2ThunderSrvAckBet.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new Client2ThunderSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {IClient2ThunderSrvAckBet=} [properties] Properties to set
     * @returns {Client2ThunderSrvAckBet} Client2ThunderSrvAckBet instance
     */
    Client2ThunderSrvAckBet.create = function create(properties) {
        return new Client2ThunderSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2ThunderSrvAckBet message. Does not implicitly {@link Client2ThunderSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {IClient2ThunderSrvAckBet} message Client2ThunderSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ThunderSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SeatNo);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.Gold);
        return writer;
    };

    /**
     * Encodes the specified Client2ThunderSrvAckBet message, length delimited. Does not implicitly {@link Client2ThunderSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {IClient2ThunderSrvAckBet} message Client2ThunderSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2ThunderSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2ThunderSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2ThunderSrvAckBet} Client2ThunderSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ThunderSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2ThunderSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 5: {
                    message.Gold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2ThunderSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2ThunderSrvAckBet} Client2ThunderSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2ThunderSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2ThunderSrvAckBet message.
     * @function verify
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2ThunderSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        return null;
    };

    /**
     * Creates a Client2ThunderSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2ThunderSrvAckBet} Client2ThunderSrvAckBet
     */
    Client2ThunderSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2ThunderSrvAckBet)
            return object;
        let message = new $root.Client2ThunderSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a Client2ThunderSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {Client2ThunderSrvAckBet} message Client2ThunderSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2ThunderSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        return object;
    };

    /**
     * Converts this Client2ThunderSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2ThunderSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2ThunderSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2ThunderSrvAckBet
     * @function getTypeUrl
     * @memberof Client2ThunderSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2ThunderSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2ThunderSrvAckBet";
    };

    return Client2ThunderSrvAckBet;
})();

export const ThunderBetData = $root.ThunderBetData = (() => {

    /**
     * Properties of a ThunderBetData.
     * @exports IThunderBetData
     * @interface IThunderBetData
     * @property {number|null} [playing] ThunderBetData playing
     * @property {number|Long|null} [prizegold] ThunderBetData prizegold
     * @property {Array.<number>|null} [card] ThunderBetData card
     * @property {Array.<number>|null} [prizeline] ThunderBetData prizeline
     * @property {Array.<number>|null} [prizemult] ThunderBetData prizemult
     * @property {number|null} [freegamenum] ThunderBetData freegamenum
     */

    /**
     * Constructs a new ThunderBetData.
     * @exports ThunderBetData
     * @classdesc Represents a ThunderBetData.
     * @implements IThunderBetData
     * @constructor
     * @param {IThunderBetData=} [properties] Properties to set
     */
    function ThunderBetData(properties) {
        this.card = [];
        this.prizeline = [];
        this.prizemult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThunderBetData playing.
     * @member {number} playing
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.playing = 0;

    /**
     * ThunderBetData prizegold.
     * @member {number|Long} prizegold
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.prizegold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ThunderBetData card.
     * @member {Array.<number>} card
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.card = $util.emptyArray;

    /**
     * ThunderBetData prizeline.
     * @member {Array.<number>} prizeline
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.prizeline = $util.emptyArray;

    /**
     * ThunderBetData prizemult.
     * @member {Array.<number>} prizemult
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.prizemult = $util.emptyArray;

    /**
     * ThunderBetData freegamenum.
     * @member {number} freegamenum
     * @memberof ThunderBetData
     * @instance
     */
    ThunderBetData.prototype.freegamenum = 0;

    /**
     * Creates a new ThunderBetData instance using the specified properties.
     * @function create
     * @memberof ThunderBetData
     * @static
     * @param {IThunderBetData=} [properties] Properties to set
     * @returns {ThunderBetData} ThunderBetData instance
     */
    ThunderBetData.create = function create(properties) {
        return new ThunderBetData(properties);
    };

    /**
     * Encodes the specified ThunderBetData message. Does not implicitly {@link ThunderBetData.verify|verify} messages.
     * @function encode
     * @memberof ThunderBetData
     * @static
     * @param {IThunderBetData} message ThunderBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderBetData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.playing != null && Object.hasOwnProperty.call(message, "playing"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.playing);
        if (message.prizegold != null && Object.hasOwnProperty.call(message, "prizegold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.prizegold);
        if (message.card != null && message.card.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.card.length; ++i)
                writer.uint32(message.card[i]);
            writer.ldelim();
        }
        if (message.prizeline != null && message.prizeline.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.prizeline.length; ++i)
                writer.uint32(message.prizeline[i]);
            writer.ldelim();
        }
        if (message.prizemult != null && message.prizemult.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.prizemult.length; ++i)
                writer.uint32(message.prizemult[i]);
            writer.ldelim();
        }
        if (message.freegamenum != null && Object.hasOwnProperty.call(message, "freegamenum"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.freegamenum);
        return writer;
    };

    /**
     * Encodes the specified ThunderBetData message, length delimited. Does not implicitly {@link ThunderBetData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThunderBetData
     * @static
     * @param {IThunderBetData} message ThunderBetData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThunderBetData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThunderBetData message from the specified reader or buffer.
     * @function decode
     * @memberof ThunderBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThunderBetData} ThunderBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderBetData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThunderBetData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.playing = reader.uint32();
                    break;
                }
            case 2: {
                    message.prizegold = reader.uint64();
                    break;
                }
            case 3: {
                    if (!(message.card && message.card.length))
                        message.card = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.card.push(reader.uint32());
                    } else
                        message.card.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.prizeline && message.prizeline.length))
                        message.prizeline = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.prizeline.push(reader.uint32());
                    } else
                        message.prizeline.push(reader.uint32());
                    break;
                }
            case 5: {
                    if (!(message.prizemult && message.prizemult.length))
                        message.prizemult = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.prizemult.push(reader.uint32());
                    } else
                        message.prizemult.push(reader.uint32());
                    break;
                }
            case 6: {
                    message.freegamenum = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThunderBetData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThunderBetData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThunderBetData} ThunderBetData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThunderBetData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThunderBetData message.
     * @function verify
     * @memberof ThunderBetData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThunderBetData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.playing != null && message.hasOwnProperty("playing"))
            if (!$util.isInteger(message.playing))
                return "playing: integer expected";
        if (message.prizegold != null && message.hasOwnProperty("prizegold"))
            if (!$util.isInteger(message.prizegold) && !(message.prizegold && $util.isInteger(message.prizegold.low) && $util.isInteger(message.prizegold.high)))
                return "prizegold: integer|Long expected";
        if (message.card != null && message.hasOwnProperty("card")) {
            if (!Array.isArray(message.card))
                return "card: array expected";
            for (let i = 0; i < message.card.length; ++i)
                if (!$util.isInteger(message.card[i]))
                    return "card: integer[] expected";
        }
        if (message.prizeline != null && message.hasOwnProperty("prizeline")) {
            if (!Array.isArray(message.prizeline))
                return "prizeline: array expected";
            for (let i = 0; i < message.prizeline.length; ++i)
                if (!$util.isInteger(message.prizeline[i]))
                    return "prizeline: integer[] expected";
        }
        if (message.prizemult != null && message.hasOwnProperty("prizemult")) {
            if (!Array.isArray(message.prizemult))
                return "prizemult: array expected";
            for (let i = 0; i < message.prizemult.length; ++i)
                if (!$util.isInteger(message.prizemult[i]))
                    return "prizemult: integer[] expected";
        }
        if (message.freegamenum != null && message.hasOwnProperty("freegamenum"))
            if (!$util.isInteger(message.freegamenum))
                return "freegamenum: integer expected";
        return null;
    };

    /**
     * Creates a ThunderBetData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThunderBetData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThunderBetData} ThunderBetData
     */
    ThunderBetData.fromObject = function fromObject(object) {
        if (object instanceof $root.ThunderBetData)
            return object;
        let message = new $root.ThunderBetData();
        if (object.playing != null)
            message.playing = object.playing >>> 0;
        if (object.prizegold != null)
            if ($util.Long)
                (message.prizegold = $util.Long.fromValue(object.prizegold)).unsigned = true;
            else if (typeof object.prizegold === "string")
                message.prizegold = parseInt(object.prizegold, 10);
            else if (typeof object.prizegold === "number")
                message.prizegold = object.prizegold;
            else if (typeof object.prizegold === "object")
                message.prizegold = new $util.LongBits(object.prizegold.low >>> 0, object.prizegold.high >>> 0).toNumber(true);
        if (object.card) {
            if (!Array.isArray(object.card))
                throw TypeError(".ThunderBetData.card: array expected");
            message.card = [];
            for (let i = 0; i < object.card.length; ++i)
                message.card[i] = object.card[i] >>> 0;
        }
        if (object.prizeline) {
            if (!Array.isArray(object.prizeline))
                throw TypeError(".ThunderBetData.prizeline: array expected");
            message.prizeline = [];
            for (let i = 0; i < object.prizeline.length; ++i)
                message.prizeline[i] = object.prizeline[i] >>> 0;
        }
        if (object.prizemult) {
            if (!Array.isArray(object.prizemult))
                throw TypeError(".ThunderBetData.prizemult: array expected");
            message.prizemult = [];
            for (let i = 0; i < object.prizemult.length; ++i)
                message.prizemult[i] = object.prizemult[i] >>> 0;
        }
        if (object.freegamenum != null)
            message.freegamenum = object.freegamenum >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ThunderBetData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThunderBetData
     * @static
     * @param {ThunderBetData} message ThunderBetData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThunderBetData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.card = [];
            object.prizeline = [];
            object.prizemult = [];
        }
        if (options.defaults) {
            object.playing = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.prizegold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.prizegold = options.longs === String ? "0" : 0;
            object.freegamenum = 0;
        }
        if (message.playing != null && message.hasOwnProperty("playing"))
            object.playing = message.playing;
        if (message.prizegold != null && message.hasOwnProperty("prizegold"))
            if (typeof message.prizegold === "number")
                object.prizegold = options.longs === String ? String(message.prizegold) : message.prizegold;
            else
                object.prizegold = options.longs === String ? $util.Long.prototype.toString.call(message.prizegold) : options.longs === Number ? new $util.LongBits(message.prizegold.low >>> 0, message.prizegold.high >>> 0).toNumber(true) : message.prizegold;
        if (message.card && message.card.length) {
            object.card = [];
            for (let j = 0; j < message.card.length; ++j)
                object.card[j] = message.card[j];
        }
        if (message.prizeline && message.prizeline.length) {
            object.prizeline = [];
            for (let j = 0; j < message.prizeline.length; ++j)
                object.prizeline[j] = message.prizeline[j];
        }
        if (message.prizemult && message.prizemult.length) {
            object.prizemult = [];
            for (let j = 0; j < message.prizemult.length; ++j)
                object.prizemult[j] = message.prizemult[j];
        }
        if (message.freegamenum != null && message.hasOwnProperty("freegamenum"))
            object.freegamenum = message.freegamenum;
        return object;
    };

    /**
     * Converts this ThunderBetData to JSON.
     * @function toJSON
     * @memberof ThunderBetData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThunderBetData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ThunderBetData
     * @function getTypeUrl
     * @memberof ThunderBetData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ThunderBetData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ThunderBetData";
    };

    return ThunderBetData;
})();

export const ClientThunderPushBetDate = $root.ClientThunderPushBetDate = (() => {

    /**
     * Properties of a ClientThunderPushBetDate.
     * @exports IClientThunderPushBetDate
     * @interface IClientThunderPushBetDate
     * @property {Array.<IThunderBetData>|null} [ThunderData] ClientThunderPushBetDate ThunderData
     */

    /**
     * Constructs a new ClientThunderPushBetDate.
     * @exports ClientThunderPushBetDate
     * @classdesc Represents a ClientThunderPushBetDate.
     * @implements IClientThunderPushBetDate
     * @constructor
     * @param {IClientThunderPushBetDate=} [properties] Properties to set
     */
    function ClientThunderPushBetDate(properties) {
        this.ThunderData = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientThunderPushBetDate ThunderData.
     * @member {Array.<IThunderBetData>} ThunderData
     * @memberof ClientThunderPushBetDate
     * @instance
     */
    ClientThunderPushBetDate.prototype.ThunderData = $util.emptyArray;

    /**
     * Creates a new ClientThunderPushBetDate instance using the specified properties.
     * @function create
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {IClientThunderPushBetDate=} [properties] Properties to set
     * @returns {ClientThunderPushBetDate} ClientThunderPushBetDate instance
     */
    ClientThunderPushBetDate.create = function create(properties) {
        return new ClientThunderPushBetDate(properties);
    };

    /**
     * Encodes the specified ClientThunderPushBetDate message. Does not implicitly {@link ClientThunderPushBetDate.verify|verify} messages.
     * @function encode
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {IClientThunderPushBetDate} message ClientThunderPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderPushBetDate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ThunderData != null && message.ThunderData.length)
            for (let i = 0; i < message.ThunderData.length; ++i)
                $root.ThunderBetData.encode(message.ThunderData[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientThunderPushBetDate message, length delimited. Does not implicitly {@link ClientThunderPushBetDate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {IClientThunderPushBetDate} message ClientThunderPushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderPushBetDate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientThunderPushBetDate message from the specified reader or buffer.
     * @function decode
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientThunderPushBetDate} ClientThunderPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderPushBetDate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientThunderPushBetDate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.ThunderData && message.ThunderData.length))
                        message.ThunderData = [];
                    message.ThunderData.push($root.ThunderBetData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientThunderPushBetDate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientThunderPushBetDate} ClientThunderPushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderPushBetDate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientThunderPushBetDate message.
     * @function verify
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientThunderPushBetDate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ThunderData != null && message.hasOwnProperty("ThunderData")) {
            if (!Array.isArray(message.ThunderData))
                return "ThunderData: array expected";
            for (let i = 0; i < message.ThunderData.length; ++i) {
                let error = $root.ThunderBetData.verify(message.ThunderData[i]);
                if (error)
                    return "ThunderData." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientThunderPushBetDate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientThunderPushBetDate} ClientThunderPushBetDate
     */
    ClientThunderPushBetDate.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientThunderPushBetDate)
            return object;
        let message = new $root.ClientThunderPushBetDate();
        if (object.ThunderData) {
            if (!Array.isArray(object.ThunderData))
                throw TypeError(".ClientThunderPushBetDate.ThunderData: array expected");
            message.ThunderData = [];
            for (let i = 0; i < object.ThunderData.length; ++i) {
                if (typeof object.ThunderData[i] !== "object")
                    throw TypeError(".ClientThunderPushBetDate.ThunderData: object expected");
                message.ThunderData[i] = $root.ThunderBetData.fromObject(object.ThunderData[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientThunderPushBetDate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {ClientThunderPushBetDate} message ClientThunderPushBetDate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientThunderPushBetDate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ThunderData = [];
        if (message.ThunderData && message.ThunderData.length) {
            object.ThunderData = [];
            for (let j = 0; j < message.ThunderData.length; ++j)
                object.ThunderData[j] = $root.ThunderBetData.toObject(message.ThunderData[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientThunderPushBetDate to JSON.
     * @function toJSON
     * @memberof ClientThunderPushBetDate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientThunderPushBetDate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientThunderPushBetDate
     * @function getTypeUrl
     * @memberof ClientThunderPushBetDate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientThunderPushBetDate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientThunderPushBetDate";
    };

    return ClientThunderPushBetDate;
})();

export const ClientThunderCartoonReq = $root.ClientThunderCartoonReq = (() => {

    /**
     * Properties of a ClientThunderCartoonReq.
     * @exports IClientThunderCartoonReq
     * @interface IClientThunderCartoonReq
     * @property {number|null} [DeskNo] ClientThunderCartoonReq DeskNo
     * @property {number|null} [UserID] ClientThunderCartoonReq UserID
     */

    /**
     * Constructs a new ClientThunderCartoonReq.
     * @exports ClientThunderCartoonReq
     * @classdesc Represents a ClientThunderCartoonReq.
     * @implements IClientThunderCartoonReq
     * @constructor
     * @param {IClientThunderCartoonReq=} [properties] Properties to set
     */
    function ClientThunderCartoonReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientThunderCartoonReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientThunderCartoonReq
     * @instance
     */
    ClientThunderCartoonReq.prototype.DeskNo = 0;

    /**
     * ClientThunderCartoonReq UserID.
     * @member {number} UserID
     * @memberof ClientThunderCartoonReq
     * @instance
     */
    ClientThunderCartoonReq.prototype.UserID = 0;

    /**
     * Creates a new ClientThunderCartoonReq instance using the specified properties.
     * @function create
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {IClientThunderCartoonReq=} [properties] Properties to set
     * @returns {ClientThunderCartoonReq} ClientThunderCartoonReq instance
     */
    ClientThunderCartoonReq.create = function create(properties) {
        return new ClientThunderCartoonReq(properties);
    };

    /**
     * Encodes the specified ClientThunderCartoonReq message. Does not implicitly {@link ClientThunderCartoonReq.verify|verify} messages.
     * @function encode
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {IClientThunderCartoonReq} message ClientThunderCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderCartoonReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientThunderCartoonReq message, length delimited. Does not implicitly {@link ClientThunderCartoonReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {IClientThunderCartoonReq} message ClientThunderCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderCartoonReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientThunderCartoonReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientThunderCartoonReq} ClientThunderCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderCartoonReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientThunderCartoonReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientThunderCartoonReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientThunderCartoonReq} ClientThunderCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderCartoonReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientThunderCartoonReq message.
     * @function verify
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientThunderCartoonReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientThunderCartoonReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientThunderCartoonReq} ClientThunderCartoonReq
     */
    ClientThunderCartoonReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientThunderCartoonReq)
            return object;
        let message = new $root.ClientThunderCartoonReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientThunderCartoonReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {ClientThunderCartoonReq} message ClientThunderCartoonReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientThunderCartoonReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientThunderCartoonReq to JSON.
     * @function toJSON
     * @memberof ClientThunderCartoonReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientThunderCartoonReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientThunderCartoonReq
     * @function getTypeUrl
     * @memberof ClientThunderCartoonReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientThunderCartoonReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientThunderCartoonReq";
    };

    return ClientThunderCartoonReq;
})();

export const ClientThunderPushGameEndData = $root.ClientThunderPushGameEndData = (() => {

    /**
     * Properties of a ClientThunderPushGameEndData.
     * @exports IClientThunderPushGameEndData
     * @interface IClientThunderPushGameEndData
     * @property {number|Long|null} [PlayerGold] ClientThunderPushGameEndData PlayerGold
     */

    /**
     * Constructs a new ClientThunderPushGameEndData.
     * @exports ClientThunderPushGameEndData
     * @classdesc Represents a ClientThunderPushGameEndData.
     * @implements IClientThunderPushGameEndData
     * @constructor
     * @param {IClientThunderPushGameEndData=} [properties] Properties to set
     */
    function ClientThunderPushGameEndData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientThunderPushGameEndData PlayerGold.
     * @member {number|Long} PlayerGold
     * @memberof ClientThunderPushGameEndData
     * @instance
     */
    ClientThunderPushGameEndData.prototype.PlayerGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientThunderPushGameEndData instance using the specified properties.
     * @function create
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {IClientThunderPushGameEndData=} [properties] Properties to set
     * @returns {ClientThunderPushGameEndData} ClientThunderPushGameEndData instance
     */
    ClientThunderPushGameEndData.create = function create(properties) {
        return new ClientThunderPushGameEndData(properties);
    };

    /**
     * Encodes the specified ClientThunderPushGameEndData message. Does not implicitly {@link ClientThunderPushGameEndData.verify|verify} messages.
     * @function encode
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {IClientThunderPushGameEndData} message ClientThunderPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderPushGameEndData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PlayerGold != null && Object.hasOwnProperty.call(message, "PlayerGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PlayerGold);
        return writer;
    };

    /**
     * Encodes the specified ClientThunderPushGameEndData message, length delimited. Does not implicitly {@link ClientThunderPushGameEndData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {IClientThunderPushGameEndData} message ClientThunderPushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderPushGameEndData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientThunderPushGameEndData message from the specified reader or buffer.
     * @function decode
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientThunderPushGameEndData} ClientThunderPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderPushGameEndData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientThunderPushGameEndData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PlayerGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientThunderPushGameEndData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientThunderPushGameEndData} ClientThunderPushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderPushGameEndData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientThunderPushGameEndData message.
     * @function verify
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientThunderPushGameEndData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (!$util.isInteger(message.PlayerGold) && !(message.PlayerGold && $util.isInteger(message.PlayerGold.low) && $util.isInteger(message.PlayerGold.high)))
                return "PlayerGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientThunderPushGameEndData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientThunderPushGameEndData} ClientThunderPushGameEndData
     */
    ClientThunderPushGameEndData.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientThunderPushGameEndData)
            return object;
        let message = new $root.ClientThunderPushGameEndData();
        if (object.PlayerGold != null)
            if ($util.Long)
                (message.PlayerGold = $util.Long.fromValue(object.PlayerGold)).unsigned = true;
            else if (typeof object.PlayerGold === "string")
                message.PlayerGold = parseInt(object.PlayerGold, 10);
            else if (typeof object.PlayerGold === "number")
                message.PlayerGold = object.PlayerGold;
            else if (typeof object.PlayerGold === "object")
                message.PlayerGold = new $util.LongBits(object.PlayerGold.low >>> 0, object.PlayerGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientThunderPushGameEndData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {ClientThunderPushGameEndData} message ClientThunderPushGameEndData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientThunderPushGameEndData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerGold = options.longs === String ? "0" : 0;
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (typeof message.PlayerGold === "number")
                object.PlayerGold = options.longs === String ? String(message.PlayerGold) : message.PlayerGold;
            else
                object.PlayerGold = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerGold) : options.longs === Number ? new $util.LongBits(message.PlayerGold.low >>> 0, message.PlayerGold.high >>> 0).toNumber(true) : message.PlayerGold;
        return object;
    };

    /**
     * Converts this ClientThunderPushGameEndData to JSON.
     * @function toJSON
     * @memberof ClientThunderPushGameEndData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientThunderPushGameEndData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientThunderPushGameEndData
     * @function getTypeUrl
     * @memberof ClientThunderPushGameEndData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientThunderPushGameEndData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientThunderPushGameEndData";
    };

    return ClientThunderPushGameEndData;
})();

export const ClientThunderJackPotReq = $root.ClientThunderJackPotReq = (() => {

    /**
     * Properties of a ClientThunderJackPotReq.
     * @exports IClientThunderJackPotReq
     * @interface IClientThunderJackPotReq
     * @property {number|null} [DeskNo] ClientThunderJackPotReq DeskNo
     * @property {number|null} [UserID] ClientThunderJackPotReq UserID
     */

    /**
     * Constructs a new ClientThunderJackPotReq.
     * @exports ClientThunderJackPotReq
     * @classdesc Represents a ClientThunderJackPotReq.
     * @implements IClientThunderJackPotReq
     * @constructor
     * @param {IClientThunderJackPotReq=} [properties] Properties to set
     */
    function ClientThunderJackPotReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientThunderJackPotReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientThunderJackPotReq
     * @instance
     */
    ClientThunderJackPotReq.prototype.DeskNo = 0;

    /**
     * ClientThunderJackPotReq UserID.
     * @member {number} UserID
     * @memberof ClientThunderJackPotReq
     * @instance
     */
    ClientThunderJackPotReq.prototype.UserID = 0;

    /**
     * Creates a new ClientThunderJackPotReq instance using the specified properties.
     * @function create
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {IClientThunderJackPotReq=} [properties] Properties to set
     * @returns {ClientThunderJackPotReq} ClientThunderJackPotReq instance
     */
    ClientThunderJackPotReq.create = function create(properties) {
        return new ClientThunderJackPotReq(properties);
    };

    /**
     * Encodes the specified ClientThunderJackPotReq message. Does not implicitly {@link ClientThunderJackPotReq.verify|verify} messages.
     * @function encode
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {IClientThunderJackPotReq} message ClientThunderJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderJackPotReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientThunderJackPotReq message, length delimited. Does not implicitly {@link ClientThunderJackPotReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {IClientThunderJackPotReq} message ClientThunderJackPotReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderJackPotReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientThunderJackPotReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientThunderJackPotReq} ClientThunderJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderJackPotReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientThunderJackPotReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientThunderJackPotReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientThunderJackPotReq} ClientThunderJackPotReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderJackPotReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientThunderJackPotReq message.
     * @function verify
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientThunderJackPotReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientThunderJackPotReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientThunderJackPotReq} ClientThunderJackPotReq
     */
    ClientThunderJackPotReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientThunderJackPotReq)
            return object;
        let message = new $root.ClientThunderJackPotReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientThunderJackPotReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {ClientThunderJackPotReq} message ClientThunderJackPotReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientThunderJackPotReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientThunderJackPotReq to JSON.
     * @function toJSON
     * @memberof ClientThunderJackPotReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientThunderJackPotReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientThunderJackPotReq
     * @function getTypeUrl
     * @memberof ClientThunderJackPotReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientThunderJackPotReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientThunderJackPotReq";
    };

    return ClientThunderJackPotReq;
})();

export const ClientThunderJackPotAck = $root.ClientThunderJackPotAck = (() => {

    /**
     * Properties of a ClientThunderJackPotAck.
     * @exports IClientThunderJackPotAck
     * @interface IClientThunderJackPotAck
     * @property {number|null} [UserID] ClientThunderJackPotAck UserID
     * @property {Array.<number|Long>|null} [JackPotGold] ClientThunderJackPotAck JackPotGold
     */

    /**
     * Constructs a new ClientThunderJackPotAck.
     * @exports ClientThunderJackPotAck
     * @classdesc Represents a ClientThunderJackPotAck.
     * @implements IClientThunderJackPotAck
     * @constructor
     * @param {IClientThunderJackPotAck=} [properties] Properties to set
     */
    function ClientThunderJackPotAck(properties) {
        this.JackPotGold = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientThunderJackPotAck UserID.
     * @member {number} UserID
     * @memberof ClientThunderJackPotAck
     * @instance
     */
    ClientThunderJackPotAck.prototype.UserID = 0;

    /**
     * ClientThunderJackPotAck JackPotGold.
     * @member {Array.<number|Long>} JackPotGold
     * @memberof ClientThunderJackPotAck
     * @instance
     */
    ClientThunderJackPotAck.prototype.JackPotGold = $util.emptyArray;

    /**
     * Creates a new ClientThunderJackPotAck instance using the specified properties.
     * @function create
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {IClientThunderJackPotAck=} [properties] Properties to set
     * @returns {ClientThunderJackPotAck} ClientThunderJackPotAck instance
     */
    ClientThunderJackPotAck.create = function create(properties) {
        return new ClientThunderJackPotAck(properties);
    };

    /**
     * Encodes the specified ClientThunderJackPotAck message. Does not implicitly {@link ClientThunderJackPotAck.verify|verify} messages.
     * @function encode
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {IClientThunderJackPotAck} message ClientThunderJackPotAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderJackPotAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.JackPotGold != null && message.JackPotGold.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.JackPotGold.length; ++i)
                writer.int64(message.JackPotGold[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified ClientThunderJackPotAck message, length delimited. Does not implicitly {@link ClientThunderJackPotAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {IClientThunderJackPotAck} message ClientThunderJackPotAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientThunderJackPotAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientThunderJackPotAck message from the specified reader or buffer.
     * @function decode
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientThunderJackPotAck} ClientThunderJackPotAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderJackPotAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientThunderJackPotAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.JackPotGold && message.JackPotGold.length))
                        message.JackPotGold = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.JackPotGold.push(reader.int64());
                    } else
                        message.JackPotGold.push(reader.int64());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientThunderJackPotAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientThunderJackPotAck} ClientThunderJackPotAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientThunderJackPotAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientThunderJackPotAck message.
     * @function verify
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientThunderJackPotAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.JackPotGold != null && message.hasOwnProperty("JackPotGold")) {
            if (!Array.isArray(message.JackPotGold))
                return "JackPotGold: array expected";
            for (let i = 0; i < message.JackPotGold.length; ++i)
                if (!$util.isInteger(message.JackPotGold[i]) && !(message.JackPotGold[i] && $util.isInteger(message.JackPotGold[i].low) && $util.isInteger(message.JackPotGold[i].high)))
                    return "JackPotGold: integer|Long[] expected";
        }
        return null;
    };

    /**
     * Creates a ClientThunderJackPotAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientThunderJackPotAck} ClientThunderJackPotAck
     */
    ClientThunderJackPotAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientThunderJackPotAck)
            return object;
        let message = new $root.ClientThunderJackPotAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.JackPotGold) {
            if (!Array.isArray(object.JackPotGold))
                throw TypeError(".ClientThunderJackPotAck.JackPotGold: array expected");
            message.JackPotGold = [];
            for (let i = 0; i < object.JackPotGold.length; ++i)
                if ($util.Long)
                    (message.JackPotGold[i] = $util.Long.fromValue(object.JackPotGold[i])).unsigned = false;
                else if (typeof object.JackPotGold[i] === "string")
                    message.JackPotGold[i] = parseInt(object.JackPotGold[i], 10);
                else if (typeof object.JackPotGold[i] === "number")
                    message.JackPotGold[i] = object.JackPotGold[i];
                else if (typeof object.JackPotGold[i] === "object")
                    message.JackPotGold[i] = new $util.LongBits(object.JackPotGold[i].low >>> 0, object.JackPotGold[i].high >>> 0).toNumber();
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientThunderJackPotAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {ClientThunderJackPotAck} message ClientThunderJackPotAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientThunderJackPotAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.JackPotGold = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.JackPotGold && message.JackPotGold.length) {
            object.JackPotGold = [];
            for (let j = 0; j < message.JackPotGold.length; ++j)
                if (typeof message.JackPotGold[j] === "number")
                    object.JackPotGold[j] = options.longs === String ? String(message.JackPotGold[j]) : message.JackPotGold[j];
                else
                    object.JackPotGold[j] = options.longs === String ? $util.Long.prototype.toString.call(message.JackPotGold[j]) : options.longs === Number ? new $util.LongBits(message.JackPotGold[j].low >>> 0, message.JackPotGold[j].high >>> 0).toNumber() : message.JackPotGold[j];
        }
        return object;
    };

    /**
     * Converts this ClientThunderJackPotAck to JSON.
     * @function toJSON
     * @memberof ClientThunderJackPotAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientThunderJackPotAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientThunderJackPotAck
     * @function getTypeUrl
     * @memberof ClientThunderJackPotAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientThunderJackPotAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientThunderJackPotAck";
    };

    return ClientThunderJackPotAck;
})();

export const OrderInfo = $root.OrderInfo = (() => {

    /**
     * Properties of an OrderInfo.
     * @exports IOrderInfo
     * @interface IOrderInfo
     * @property {number|Long|null} [CreateAt] OrderInfo CreateAt
     * @property {number|null} [Number] OrderInfo Number
     */

    /**
     * Constructs a new OrderInfo.
     * @exports OrderInfo
     * @classdesc Represents an OrderInfo.
     * @implements IOrderInfo
     * @constructor
     * @param {IOrderInfo=} [properties] Properties to set
     */
    function OrderInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderInfo CreateAt.
     * @member {number|Long} CreateAt
     * @memberof OrderInfo
     * @instance
     */
    OrderInfo.prototype.CreateAt = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * OrderInfo Number.
     * @member {number} Number
     * @memberof OrderInfo
     * @instance
     */
    OrderInfo.prototype.Number = 0;

    /**
     * Creates a new OrderInfo instance using the specified properties.
     * @function create
     * @memberof OrderInfo
     * @static
     * @param {IOrderInfo=} [properties] Properties to set
     * @returns {OrderInfo} OrderInfo instance
     */
    OrderInfo.create = function create(properties) {
        return new OrderInfo(properties);
    };

    /**
     * Encodes the specified OrderInfo message. Does not implicitly {@link OrderInfo.verify|verify} messages.
     * @function encode
     * @memberof OrderInfo
     * @static
     * @param {IOrderInfo} message OrderInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CreateAt != null && Object.hasOwnProperty.call(message, "CreateAt"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.CreateAt);
        if (message.Number != null && Object.hasOwnProperty.call(message, "Number"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Number);
        return writer;
    };

    /**
     * Encodes the specified OrderInfo message, length delimited. Does not implicitly {@link OrderInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderInfo
     * @static
     * @param {IOrderInfo} message OrderInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderInfo message from the specified reader or buffer.
     * @function decode
     * @memberof OrderInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderInfo} OrderInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CreateAt = reader.uint64();
                    break;
                }
            case 2: {
                    message.Number = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderInfo} OrderInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderInfo message.
     * @function verify
     * @memberof OrderInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CreateAt != null && message.hasOwnProperty("CreateAt"))
            if (!$util.isInteger(message.CreateAt) && !(message.CreateAt && $util.isInteger(message.CreateAt.low) && $util.isInteger(message.CreateAt.high)))
                return "CreateAt: integer|Long expected";
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isInteger(message.Number))
                return "Number: integer expected";
        return null;
    };

    /**
     * Creates an OrderInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderInfo} OrderInfo
     */
    OrderInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderInfo)
            return object;
        let message = new $root.OrderInfo();
        if (object.CreateAt != null)
            if ($util.Long)
                (message.CreateAt = $util.Long.fromValue(object.CreateAt)).unsigned = true;
            else if (typeof object.CreateAt === "string")
                message.CreateAt = parseInt(object.CreateAt, 10);
            else if (typeof object.CreateAt === "number")
                message.CreateAt = object.CreateAt;
            else if (typeof object.CreateAt === "object")
                message.CreateAt = new $util.LongBits(object.CreateAt.low >>> 0, object.CreateAt.high >>> 0).toNumber(true);
        if (object.Number != null)
            message.Number = object.Number >>> 0;
        return message;
    };

    /**
     * Creates a plain object from an OrderInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderInfo
     * @static
     * @param {OrderInfo} message OrderInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.CreateAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.CreateAt = options.longs === String ? "0" : 0;
            object.Number = 0;
        }
        if (message.CreateAt != null && message.hasOwnProperty("CreateAt"))
            if (typeof message.CreateAt === "number")
                object.CreateAt = options.longs === String ? String(message.CreateAt) : message.CreateAt;
            else
                object.CreateAt = options.longs === String ? $util.Long.prototype.toString.call(message.CreateAt) : options.longs === Number ? new $util.LongBits(message.CreateAt.low >>> 0, message.CreateAt.high >>> 0).toNumber(true) : message.CreateAt;
        if (message.Number != null && message.hasOwnProperty("Number"))
            object.Number = message.Number;
        return object;
    };

    /**
     * Converts this OrderInfo to JSON.
     * @function toJSON
     * @memberof OrderInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderInfo
     * @function getTypeUrl
     * @memberof OrderInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderInfo";
    };

    return OrderInfo;
})();

export const PlayerOrderInfo = $root.PlayerOrderInfo = (() => {

    /**
     * Properties of a PlayerOrderInfo.
     * @exports IPlayerOrderInfo
     * @interface IPlayerOrderInfo
     * @property {number|null} [UserID] PlayerOrderInfo UserID
     * @property {Uint8Array|null} [NickName] PlayerOrderInfo NickName
     * @property {Uint8Array|null} [HeadUrl] PlayerOrderInfo HeadUrl
     * @property {Array.<IOrderInfo>|null} [Order] PlayerOrderInfo Order
     */

    /**
     * Constructs a new PlayerOrderInfo.
     * @exports PlayerOrderInfo
     * @classdesc Represents a PlayerOrderInfo.
     * @implements IPlayerOrderInfo
     * @constructor
     * @param {IPlayerOrderInfo=} [properties] Properties to set
     */
    function PlayerOrderInfo(properties) {
        this.Order = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerOrderInfo UserID.
     * @member {number} UserID
     * @memberof PlayerOrderInfo
     * @instance
     */
    PlayerOrderInfo.prototype.UserID = 0;

    /**
     * PlayerOrderInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof PlayerOrderInfo
     * @instance
     */
    PlayerOrderInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * PlayerOrderInfo HeadUrl.
     * @member {Uint8Array} HeadUrl
     * @memberof PlayerOrderInfo
     * @instance
     */
    PlayerOrderInfo.prototype.HeadUrl = $util.newBuffer([]);

    /**
     * PlayerOrderInfo Order.
     * @member {Array.<IOrderInfo>} Order
     * @memberof PlayerOrderInfo
     * @instance
     */
    PlayerOrderInfo.prototype.Order = $util.emptyArray;

    /**
     * Creates a new PlayerOrderInfo instance using the specified properties.
     * @function create
     * @memberof PlayerOrderInfo
     * @static
     * @param {IPlayerOrderInfo=} [properties] Properties to set
     * @returns {PlayerOrderInfo} PlayerOrderInfo instance
     */
    PlayerOrderInfo.create = function create(properties) {
        return new PlayerOrderInfo(properties);
    };

    /**
     * Encodes the specified PlayerOrderInfo message. Does not implicitly {@link PlayerOrderInfo.verify|verify} messages.
     * @function encode
     * @memberof PlayerOrderInfo
     * @static
     * @param {IPlayerOrderInfo} message PlayerOrderInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerOrderInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeadUrl != null && Object.hasOwnProperty.call(message, "HeadUrl"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.HeadUrl);
        if (message.Order != null && message.Order.length)
            for (let i = 0; i < message.Order.length; ++i)
                $root.OrderInfo.encode(message.Order[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PlayerOrderInfo message, length delimited. Does not implicitly {@link PlayerOrderInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerOrderInfo
     * @static
     * @param {IPlayerOrderInfo} message PlayerOrderInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerOrderInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerOrderInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerOrderInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerOrderInfo} PlayerOrderInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerOrderInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerOrderInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeadUrl = reader.bytes();
                    break;
                }
            case 4: {
                    if (!(message.Order && message.Order.length))
                        message.Order = [];
                    message.Order.push($root.OrderInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerOrderInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerOrderInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerOrderInfo} PlayerOrderInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerOrderInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerOrderInfo message.
     * @function verify
     * @memberof PlayerOrderInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerOrderInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            if (!(message.HeadUrl && typeof message.HeadUrl.length === "number" || $util.isString(message.HeadUrl)))
                return "HeadUrl: buffer expected";
        if (message.Order != null && message.hasOwnProperty("Order")) {
            if (!Array.isArray(message.Order))
                return "Order: array expected";
            for (let i = 0; i < message.Order.length; ++i) {
                let error = $root.OrderInfo.verify(message.Order[i]);
                if (error)
                    return "Order." + error;
            }
        }
        return null;
    };

    /**
     * Creates a PlayerOrderInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerOrderInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerOrderInfo} PlayerOrderInfo
     */
    PlayerOrderInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerOrderInfo)
            return object;
        let message = new $root.PlayerOrderInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeadUrl != null)
            if (typeof object.HeadUrl === "string")
                $util.base64.decode(object.HeadUrl, message.HeadUrl = $util.newBuffer($util.base64.length(object.HeadUrl)), 0);
            else if (object.HeadUrl.length >= 0)
                message.HeadUrl = object.HeadUrl;
        if (object.Order) {
            if (!Array.isArray(object.Order))
                throw TypeError(".PlayerOrderInfo.Order: array expected");
            message.Order = [];
            for (let i = 0; i < object.Order.length; ++i) {
                if (typeof object.Order[i] !== "object")
                    throw TypeError(".PlayerOrderInfo.Order: object expected");
                message.Order[i] = $root.OrderInfo.fromObject(object.Order[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a PlayerOrderInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerOrderInfo
     * @static
     * @param {PlayerOrderInfo} message PlayerOrderInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerOrderInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Order = [];
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            if (options.bytes === String)
                object.HeadUrl = "";
            else {
                object.HeadUrl = [];
                if (options.bytes !== Array)
                    object.HeadUrl = $util.newBuffer(object.HeadUrl);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            object.HeadUrl = options.bytes === String ? $util.base64.encode(message.HeadUrl, 0, message.HeadUrl.length) : options.bytes === Array ? Array.prototype.slice.call(message.HeadUrl) : message.HeadUrl;
        if (message.Order && message.Order.length) {
            object.Order = [];
            for (let j = 0; j < message.Order.length; ++j)
                object.Order[j] = $root.OrderInfo.toObject(message.Order[j], options);
        }
        return object;
    };

    /**
     * Converts this PlayerOrderInfo to JSON.
     * @function toJSON
     * @memberof PlayerOrderInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerOrderInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerOrderInfo
     * @function getTypeUrl
     * @memberof PlayerOrderInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerOrderInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerOrderInfo";
    };

    return PlayerOrderInfo;
})();

export const ParticipationInfo = $root.ParticipationInfo = (() => {

    /**
     * Properties of a ParticipationInfo.
     * @exports IParticipationInfo
     * @interface IParticipationInfo
     * @property {number|null} [ParticipationID] ParticipationInfo ParticipationID
     * @property {number|null} [Type] ParticipationInfo Type
     * @property {string|null} [BonusValue] ParticipationInfo BonusValue
     * @property {number|null} [TotalTickets] ParticipationInfo TotalTickets
     * @property {number|null} [AvailableTickets] ParticipationInfo AvailableTickets
     * @property {number|null} [WinningNumber] ParticipationInfo WinningNumber
     * @property {number|Long|null} [AnnouncementTime] ParticipationInfo AnnouncementTime
     * @property {number|null} [WinnerID] ParticipationInfo WinnerID
     * @property {Uint8Array|null} [NickName] ParticipationInfo NickName
     * @property {Uint8Array|null} [HeadUrl] ParticipationInfo HeadUrl
     */

    /**
     * Constructs a new ParticipationInfo.
     * @exports ParticipationInfo
     * @classdesc Represents a ParticipationInfo.
     * @implements IParticipationInfo
     * @constructor
     * @param {IParticipationInfo=} [properties] Properties to set
     */
    function ParticipationInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ParticipationInfo ParticipationID.
     * @member {number} ParticipationID
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.ParticipationID = 0;

    /**
     * ParticipationInfo Type.
     * @member {number} Type
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.Type = 0;

    /**
     * ParticipationInfo BonusValue.
     * @member {string} BonusValue
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.BonusValue = "";

    /**
     * ParticipationInfo TotalTickets.
     * @member {number} TotalTickets
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.TotalTickets = 0;

    /**
     * ParticipationInfo AvailableTickets.
     * @member {number} AvailableTickets
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.AvailableTickets = 0;

    /**
     * ParticipationInfo WinningNumber.
     * @member {number} WinningNumber
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.WinningNumber = 0;

    /**
     * ParticipationInfo AnnouncementTime.
     * @member {number|Long} AnnouncementTime
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.AnnouncementTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ParticipationInfo WinnerID.
     * @member {number} WinnerID
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.WinnerID = 0;

    /**
     * ParticipationInfo NickName.
     * @member {Uint8Array} NickName
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.NickName = $util.newBuffer([]);

    /**
     * ParticipationInfo HeadUrl.
     * @member {Uint8Array} HeadUrl
     * @memberof ParticipationInfo
     * @instance
     */
    ParticipationInfo.prototype.HeadUrl = $util.newBuffer([]);

    /**
     * Creates a new ParticipationInfo instance using the specified properties.
     * @function create
     * @memberof ParticipationInfo
     * @static
     * @param {IParticipationInfo=} [properties] Properties to set
     * @returns {ParticipationInfo} ParticipationInfo instance
     */
    ParticipationInfo.create = function create(properties) {
        return new ParticipationInfo(properties);
    };

    /**
     * Encodes the specified ParticipationInfo message. Does not implicitly {@link ParticipationInfo.verify|verify} messages.
     * @function encode
     * @memberof ParticipationInfo
     * @static
     * @param {IParticipationInfo} message ParticipationInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ParticipationInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ParticipationID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        if (message.BonusValue != null && Object.hasOwnProperty.call(message, "BonusValue"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BonusValue);
        if (message.TotalTickets != null && Object.hasOwnProperty.call(message, "TotalTickets"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.TotalTickets);
        if (message.AvailableTickets != null && Object.hasOwnProperty.call(message, "AvailableTickets"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.AvailableTickets);
        if (message.WinningNumber != null && Object.hasOwnProperty.call(message, "WinningNumber"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.WinningNumber);
        if (message.AnnouncementTime != null && Object.hasOwnProperty.call(message, "AnnouncementTime"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.AnnouncementTime);
        if (message.WinnerID != null && Object.hasOwnProperty.call(message, "WinnerID"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.WinnerID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.NickName);
        if (message.HeadUrl != null && Object.hasOwnProperty.call(message, "HeadUrl"))
            writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.HeadUrl);
        return writer;
    };

    /**
     * Encodes the specified ParticipationInfo message, length delimited. Does not implicitly {@link ParticipationInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ParticipationInfo
     * @static
     * @param {IParticipationInfo} message ParticipationInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ParticipationInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ParticipationInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ParticipationInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ParticipationInfo} ParticipationInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ParticipationInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ParticipationInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            case 3: {
                    message.BonusValue = reader.string();
                    break;
                }
            case 4: {
                    message.TotalTickets = reader.uint32();
                    break;
                }
            case 5: {
                    message.AvailableTickets = reader.uint32();
                    break;
                }
            case 6: {
                    message.WinningNumber = reader.uint32();
                    break;
                }
            case 7: {
                    message.AnnouncementTime = reader.uint64();
                    break;
                }
            case 8: {
                    message.WinnerID = reader.uint32();
                    break;
                }
            case 9: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 10: {
                    message.HeadUrl = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ParticipationInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ParticipationInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ParticipationInfo} ParticipationInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ParticipationInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ParticipationInfo message.
     * @function verify
     * @memberof ParticipationInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ParticipationInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            if (!$util.isString(message.BonusValue))
                return "BonusValue: string expected";
        if (message.TotalTickets != null && message.hasOwnProperty("TotalTickets"))
            if (!$util.isInteger(message.TotalTickets))
                return "TotalTickets: integer expected";
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            if (!$util.isInteger(message.AvailableTickets))
                return "AvailableTickets: integer expected";
        if (message.WinningNumber != null && message.hasOwnProperty("WinningNumber"))
            if (!$util.isInteger(message.WinningNumber))
                return "WinningNumber: integer expected";
        if (message.AnnouncementTime != null && message.hasOwnProperty("AnnouncementTime"))
            if (!$util.isInteger(message.AnnouncementTime) && !(message.AnnouncementTime && $util.isInteger(message.AnnouncementTime.low) && $util.isInteger(message.AnnouncementTime.high)))
                return "AnnouncementTime: integer|Long expected";
        if (message.WinnerID != null && message.hasOwnProperty("WinnerID"))
            if (!$util.isInteger(message.WinnerID))
                return "WinnerID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            if (!(message.HeadUrl && typeof message.HeadUrl.length === "number" || $util.isString(message.HeadUrl)))
                return "HeadUrl: buffer expected";
        return null;
    };

    /**
     * Creates a ParticipationInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ParticipationInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ParticipationInfo} ParticipationInfo
     */
    ParticipationInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ParticipationInfo)
            return object;
        let message = new $root.ParticipationInfo();
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.BonusValue != null)
            message.BonusValue = String(object.BonusValue);
        if (object.TotalTickets != null)
            message.TotalTickets = object.TotalTickets >>> 0;
        if (object.AvailableTickets != null)
            message.AvailableTickets = object.AvailableTickets >>> 0;
        if (object.WinningNumber != null)
            message.WinningNumber = object.WinningNumber >>> 0;
        if (object.AnnouncementTime != null)
            if ($util.Long)
                (message.AnnouncementTime = $util.Long.fromValue(object.AnnouncementTime)).unsigned = true;
            else if (typeof object.AnnouncementTime === "string")
                message.AnnouncementTime = parseInt(object.AnnouncementTime, 10);
            else if (typeof object.AnnouncementTime === "number")
                message.AnnouncementTime = object.AnnouncementTime;
            else if (typeof object.AnnouncementTime === "object")
                message.AnnouncementTime = new $util.LongBits(object.AnnouncementTime.low >>> 0, object.AnnouncementTime.high >>> 0).toNumber(true);
        if (object.WinnerID != null)
            message.WinnerID = object.WinnerID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeadUrl != null)
            if (typeof object.HeadUrl === "string")
                $util.base64.decode(object.HeadUrl, message.HeadUrl = $util.newBuffer($util.base64.length(object.HeadUrl)), 0);
            else if (object.HeadUrl.length >= 0)
                message.HeadUrl = object.HeadUrl;
        return message;
    };

    /**
     * Creates a plain object from a ParticipationInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ParticipationInfo
     * @static
     * @param {ParticipationInfo} message ParticipationInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ParticipationInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ParticipationID = 0;
            object.Type = 0;
            object.BonusValue = "";
            object.TotalTickets = 0;
            object.AvailableTickets = 0;
            object.WinningNumber = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.AnnouncementTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.AnnouncementTime = options.longs === String ? "0" : 0;
            object.WinnerID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            if (options.bytes === String)
                object.HeadUrl = "";
            else {
                object.HeadUrl = [];
                if (options.bytes !== Array)
                    object.HeadUrl = $util.newBuffer(object.HeadUrl);
            }
        }
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            object.BonusValue = message.BonusValue;
        if (message.TotalTickets != null && message.hasOwnProperty("TotalTickets"))
            object.TotalTickets = message.TotalTickets;
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            object.AvailableTickets = message.AvailableTickets;
        if (message.WinningNumber != null && message.hasOwnProperty("WinningNumber"))
            object.WinningNumber = message.WinningNumber;
        if (message.AnnouncementTime != null && message.hasOwnProperty("AnnouncementTime"))
            if (typeof message.AnnouncementTime === "number")
                object.AnnouncementTime = options.longs === String ? String(message.AnnouncementTime) : message.AnnouncementTime;
            else
                object.AnnouncementTime = options.longs === String ? $util.Long.prototype.toString.call(message.AnnouncementTime) : options.longs === Number ? new $util.LongBits(message.AnnouncementTime.low >>> 0, message.AnnouncementTime.high >>> 0).toNumber(true) : message.AnnouncementTime;
        if (message.WinnerID != null && message.hasOwnProperty("WinnerID"))
            object.WinnerID = message.WinnerID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            object.HeadUrl = options.bytes === String ? $util.base64.encode(message.HeadUrl, 0, message.HeadUrl.length) : options.bytes === Array ? Array.prototype.slice.call(message.HeadUrl) : message.HeadUrl;
        return object;
    };

    /**
     * Converts this ParticipationInfo to JSON.
     * @function toJSON
     * @memberof ParticipationInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ParticipationInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ParticipationInfo
     * @function getTypeUrl
     * @memberof ParticipationInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ParticipationInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ParticipationInfo";
    };

    return ParticipationInfo;
})();

export const Desk2TreasureSrvCurrentParticipationReq = $root.Desk2TreasureSrvCurrentParticipationReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvCurrentParticipationReq.
     * @exports IDesk2TreasureSrvCurrentParticipationReq
     * @interface IDesk2TreasureSrvCurrentParticipationReq
     * @property {number|null} [UserID] Desk2TreasureSrvCurrentParticipationReq UserID
     * @property {number|null} [Type] Desk2TreasureSrvCurrentParticipationReq Type
     */

    /**
     * Constructs a new Desk2TreasureSrvCurrentParticipationReq.
     * @exports Desk2TreasureSrvCurrentParticipationReq
     * @classdesc Represents a Desk2TreasureSrvCurrentParticipationReq.
     * @implements IDesk2TreasureSrvCurrentParticipationReq
     * @constructor
     * @param {IDesk2TreasureSrvCurrentParticipationReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvCurrentParticipationReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvCurrentParticipationReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @instance
     */
    Desk2TreasureSrvCurrentParticipationReq.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvCurrentParticipationReq Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @instance
     */
    Desk2TreasureSrvCurrentParticipationReq.prototype.Type = 0;

    /**
     * Creates a new Desk2TreasureSrvCurrentParticipationReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvCurrentParticipationReq} Desk2TreasureSrvCurrentParticipationReq instance
     */
    Desk2TreasureSrvCurrentParticipationReq.create = function create(properties) {
        return new Desk2TreasureSrvCurrentParticipationReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvCurrentParticipationReq message. Does not implicitly {@link Desk2TreasureSrvCurrentParticipationReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationReq} message Desk2TreasureSrvCurrentParticipationReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvCurrentParticipationReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvCurrentParticipationReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvCurrentParticipationReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationReq} message Desk2TreasureSrvCurrentParticipationReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvCurrentParticipationReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvCurrentParticipationReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvCurrentParticipationReq} Desk2TreasureSrvCurrentParticipationReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvCurrentParticipationReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvCurrentParticipationReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvCurrentParticipationReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvCurrentParticipationReq} Desk2TreasureSrvCurrentParticipationReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvCurrentParticipationReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvCurrentParticipationReq message.
     * @function verify
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvCurrentParticipationReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvCurrentParticipationReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvCurrentParticipationReq} Desk2TreasureSrvCurrentParticipationReq
     */
    Desk2TreasureSrvCurrentParticipationReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvCurrentParticipationReq)
            return object;
        let message = new $root.Desk2TreasureSrvCurrentParticipationReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvCurrentParticipationReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {Desk2TreasureSrvCurrentParticipationReq} message Desk2TreasureSrvCurrentParticipationReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvCurrentParticipationReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvCurrentParticipationReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvCurrentParticipationReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvCurrentParticipationReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvCurrentParticipationReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvCurrentParticipationReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvCurrentParticipationReq";
    };

    return Desk2TreasureSrvCurrentParticipationReq;
})();

export const Desk2TreasureSrvCurrentParticipationAck = $root.Desk2TreasureSrvCurrentParticipationAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvCurrentParticipationAck.
     * @exports IDesk2TreasureSrvCurrentParticipationAck
     * @interface IDesk2TreasureSrvCurrentParticipationAck
     * @property {number|null} [UserID] Desk2TreasureSrvCurrentParticipationAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvCurrentParticipationAck Res
     * @property {Array.<IPlayerOrderInfo>|null} [PlayerOrder] Desk2TreasureSrvCurrentParticipationAck PlayerOrder
     */

    /**
     * Constructs a new Desk2TreasureSrvCurrentParticipationAck.
     * @exports Desk2TreasureSrvCurrentParticipationAck
     * @classdesc Represents a Desk2TreasureSrvCurrentParticipationAck.
     * @implements IDesk2TreasureSrvCurrentParticipationAck
     * @constructor
     * @param {IDesk2TreasureSrvCurrentParticipationAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvCurrentParticipationAck(properties) {
        this.PlayerOrder = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvCurrentParticipationAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @instance
     */
    Desk2TreasureSrvCurrentParticipationAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvCurrentParticipationAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @instance
     */
    Desk2TreasureSrvCurrentParticipationAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvCurrentParticipationAck PlayerOrder.
     * @member {Array.<IPlayerOrderInfo>} PlayerOrder
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @instance
     */
    Desk2TreasureSrvCurrentParticipationAck.prototype.PlayerOrder = $util.emptyArray;

    /**
     * Creates a new Desk2TreasureSrvCurrentParticipationAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvCurrentParticipationAck} Desk2TreasureSrvCurrentParticipationAck instance
     */
    Desk2TreasureSrvCurrentParticipationAck.create = function create(properties) {
        return new Desk2TreasureSrvCurrentParticipationAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvCurrentParticipationAck message. Does not implicitly {@link Desk2TreasureSrvCurrentParticipationAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationAck} message Desk2TreasureSrvCurrentParticipationAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvCurrentParticipationAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.PlayerOrder != null && message.PlayerOrder.length)
            for (let i = 0; i < message.PlayerOrder.length; ++i)
                $root.PlayerOrderInfo.encode(message.PlayerOrder[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvCurrentParticipationAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvCurrentParticipationAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {IDesk2TreasureSrvCurrentParticipationAck} message Desk2TreasureSrvCurrentParticipationAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvCurrentParticipationAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvCurrentParticipationAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvCurrentParticipationAck} Desk2TreasureSrvCurrentParticipationAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvCurrentParticipationAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvCurrentParticipationAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.PlayerOrder && message.PlayerOrder.length))
                        message.PlayerOrder = [];
                    message.PlayerOrder.push($root.PlayerOrderInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvCurrentParticipationAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvCurrentParticipationAck} Desk2TreasureSrvCurrentParticipationAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvCurrentParticipationAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvCurrentParticipationAck message.
     * @function verify
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvCurrentParticipationAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.PlayerOrder != null && message.hasOwnProperty("PlayerOrder")) {
            if (!Array.isArray(message.PlayerOrder))
                return "PlayerOrder: array expected";
            for (let i = 0; i < message.PlayerOrder.length; ++i) {
                let error = $root.PlayerOrderInfo.verify(message.PlayerOrder[i]);
                if (error)
                    return "PlayerOrder." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvCurrentParticipationAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvCurrentParticipationAck} Desk2TreasureSrvCurrentParticipationAck
     */
    Desk2TreasureSrvCurrentParticipationAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvCurrentParticipationAck)
            return object;
        let message = new $root.Desk2TreasureSrvCurrentParticipationAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.PlayerOrder) {
            if (!Array.isArray(object.PlayerOrder))
                throw TypeError(".Desk2TreasureSrvCurrentParticipationAck.PlayerOrder: array expected");
            message.PlayerOrder = [];
            for (let i = 0; i < object.PlayerOrder.length; ++i) {
                if (typeof object.PlayerOrder[i] !== "object")
                    throw TypeError(".Desk2TreasureSrvCurrentParticipationAck.PlayerOrder: object expected");
                message.PlayerOrder[i] = $root.PlayerOrderInfo.fromObject(object.PlayerOrder[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvCurrentParticipationAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {Desk2TreasureSrvCurrentParticipationAck} message Desk2TreasureSrvCurrentParticipationAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvCurrentParticipationAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.PlayerOrder = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.PlayerOrder && message.PlayerOrder.length) {
            object.PlayerOrder = [];
            for (let j = 0; j < message.PlayerOrder.length; ++j)
                object.PlayerOrder[j] = $root.PlayerOrderInfo.toObject(message.PlayerOrder[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvCurrentParticipationAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvCurrentParticipationAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvCurrentParticipationAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvCurrentParticipationAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvCurrentParticipationAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvCurrentParticipationAck";
    };

    return Desk2TreasureSrvCurrentParticipationAck;
})();

export const Desk2TreasureSrvPlayerParticipationReq = $root.Desk2TreasureSrvPlayerParticipationReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvPlayerParticipationReq.
     * @exports IDesk2TreasureSrvPlayerParticipationReq
     * @interface IDesk2TreasureSrvPlayerParticipationReq
     * @property {number|null} [UserID] Desk2TreasureSrvPlayerParticipationReq UserID
     */

    /**
     * Constructs a new Desk2TreasureSrvPlayerParticipationReq.
     * @exports Desk2TreasureSrvPlayerParticipationReq
     * @classdesc Represents a Desk2TreasureSrvPlayerParticipationReq.
     * @implements IDesk2TreasureSrvPlayerParticipationReq
     * @constructor
     * @param {IDesk2TreasureSrvPlayerParticipationReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvPlayerParticipationReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPlayerParticipationReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @instance
     */
    Desk2TreasureSrvPlayerParticipationReq.prototype.UserID = 0;

    /**
     * Creates a new Desk2TreasureSrvPlayerParticipationReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPlayerParticipationReq} Desk2TreasureSrvPlayerParticipationReq instance
     */
    Desk2TreasureSrvPlayerParticipationReq.create = function create(properties) {
        return new Desk2TreasureSrvPlayerParticipationReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPlayerParticipationReq message. Does not implicitly {@link Desk2TreasureSrvPlayerParticipationReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationReq} message Desk2TreasureSrvPlayerParticipationReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPlayerParticipationReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPlayerParticipationReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvPlayerParticipationReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationReq} message Desk2TreasureSrvPlayerParticipationReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPlayerParticipationReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPlayerParticipationReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPlayerParticipationReq} Desk2TreasureSrvPlayerParticipationReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPlayerParticipationReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPlayerParticipationReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPlayerParticipationReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPlayerParticipationReq} Desk2TreasureSrvPlayerParticipationReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPlayerParticipationReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPlayerParticipationReq message.
     * @function verify
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPlayerParticipationReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPlayerParticipationReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPlayerParticipationReq} Desk2TreasureSrvPlayerParticipationReq
     */
    Desk2TreasureSrvPlayerParticipationReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPlayerParticipationReq)
            return object;
        let message = new $root.Desk2TreasureSrvPlayerParticipationReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPlayerParticipationReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {Desk2TreasureSrvPlayerParticipationReq} message Desk2TreasureSrvPlayerParticipationReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPlayerParticipationReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPlayerParticipationReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPlayerParticipationReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPlayerParticipationReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPlayerParticipationReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPlayerParticipationReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPlayerParticipationReq";
    };

    return Desk2TreasureSrvPlayerParticipationReq;
})();

export const Desk2TreasureSrvPlayerParticipationAck = $root.Desk2TreasureSrvPlayerParticipationAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvPlayerParticipationAck.
     * @exports IDesk2TreasureSrvPlayerParticipationAck
     * @interface IDesk2TreasureSrvPlayerParticipationAck
     * @property {number|null} [UserID] Desk2TreasureSrvPlayerParticipationAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvPlayerParticipationAck Res
     * @property {Array.<IParticipationInfo>|null} [Record] Desk2TreasureSrvPlayerParticipationAck Record
     */

    /**
     * Constructs a new Desk2TreasureSrvPlayerParticipationAck.
     * @exports Desk2TreasureSrvPlayerParticipationAck
     * @classdesc Represents a Desk2TreasureSrvPlayerParticipationAck.
     * @implements IDesk2TreasureSrvPlayerParticipationAck
     * @constructor
     * @param {IDesk2TreasureSrvPlayerParticipationAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvPlayerParticipationAck(properties) {
        this.Record = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPlayerParticipationAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @instance
     */
    Desk2TreasureSrvPlayerParticipationAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPlayerParticipationAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @instance
     */
    Desk2TreasureSrvPlayerParticipationAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvPlayerParticipationAck Record.
     * @member {Array.<IParticipationInfo>} Record
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @instance
     */
    Desk2TreasureSrvPlayerParticipationAck.prototype.Record = $util.emptyArray;

    /**
     * Creates a new Desk2TreasureSrvPlayerParticipationAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPlayerParticipationAck} Desk2TreasureSrvPlayerParticipationAck instance
     */
    Desk2TreasureSrvPlayerParticipationAck.create = function create(properties) {
        return new Desk2TreasureSrvPlayerParticipationAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPlayerParticipationAck message. Does not implicitly {@link Desk2TreasureSrvPlayerParticipationAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationAck} message Desk2TreasureSrvPlayerParticipationAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPlayerParticipationAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.Record != null && message.Record.length)
            for (let i = 0; i < message.Record.length; ++i)
                $root.ParticipationInfo.encode(message.Record[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPlayerParticipationAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvPlayerParticipationAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {IDesk2TreasureSrvPlayerParticipationAck} message Desk2TreasureSrvPlayerParticipationAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPlayerParticipationAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPlayerParticipationAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPlayerParticipationAck} Desk2TreasureSrvPlayerParticipationAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPlayerParticipationAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPlayerParticipationAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Record && message.Record.length))
                        message.Record = [];
                    message.Record.push($root.ParticipationInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPlayerParticipationAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPlayerParticipationAck} Desk2TreasureSrvPlayerParticipationAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPlayerParticipationAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPlayerParticipationAck message.
     * @function verify
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPlayerParticipationAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.Record != null && message.hasOwnProperty("Record")) {
            if (!Array.isArray(message.Record))
                return "Record: array expected";
            for (let i = 0; i < message.Record.length; ++i) {
                let error = $root.ParticipationInfo.verify(message.Record[i]);
                if (error)
                    return "Record." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPlayerParticipationAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPlayerParticipationAck} Desk2TreasureSrvPlayerParticipationAck
     */
    Desk2TreasureSrvPlayerParticipationAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPlayerParticipationAck)
            return object;
        let message = new $root.Desk2TreasureSrvPlayerParticipationAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.Record) {
            if (!Array.isArray(object.Record))
                throw TypeError(".Desk2TreasureSrvPlayerParticipationAck.Record: array expected");
            message.Record = [];
            for (let i = 0; i < object.Record.length; ++i) {
                if (typeof object.Record[i] !== "object")
                    throw TypeError(".Desk2TreasureSrvPlayerParticipationAck.Record: object expected");
                message.Record[i] = $root.ParticipationInfo.fromObject(object.Record[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPlayerParticipationAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {Desk2TreasureSrvPlayerParticipationAck} message Desk2TreasureSrvPlayerParticipationAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPlayerParticipationAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Record = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.Record && message.Record.length) {
            object.Record = [];
            for (let j = 0; j < message.Record.length; ++j)
                object.Record[j] = $root.ParticipationInfo.toObject(message.Record[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPlayerParticipationAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPlayerParticipationAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPlayerParticipationAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPlayerParticipationAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPlayerParticipationAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPlayerParticipationAck";
    };

    return Desk2TreasureSrvPlayerParticipationAck;
})();

export const Desk2TreasureSrvPastRecordsReq = $root.Desk2TreasureSrvPastRecordsReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvPastRecordsReq.
     * @exports IDesk2TreasureSrvPastRecordsReq
     * @interface IDesk2TreasureSrvPastRecordsReq
     * @property {number|null} [UserID] Desk2TreasureSrvPastRecordsReq UserID
     * @property {number|null} [Type] Desk2TreasureSrvPastRecordsReq Type
     */

    /**
     * Constructs a new Desk2TreasureSrvPastRecordsReq.
     * @exports Desk2TreasureSrvPastRecordsReq
     * @classdesc Represents a Desk2TreasureSrvPastRecordsReq.
     * @implements IDesk2TreasureSrvPastRecordsReq
     * @constructor
     * @param {IDesk2TreasureSrvPastRecordsReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvPastRecordsReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPastRecordsReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @instance
     */
    Desk2TreasureSrvPastRecordsReq.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPastRecordsReq Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @instance
     */
    Desk2TreasureSrvPastRecordsReq.prototype.Type = 0;

    /**
     * Creates a new Desk2TreasureSrvPastRecordsReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {IDesk2TreasureSrvPastRecordsReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPastRecordsReq} Desk2TreasureSrvPastRecordsReq instance
     */
    Desk2TreasureSrvPastRecordsReq.create = function create(properties) {
        return new Desk2TreasureSrvPastRecordsReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPastRecordsReq message. Does not implicitly {@link Desk2TreasureSrvPastRecordsReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {IDesk2TreasureSrvPastRecordsReq} message Desk2TreasureSrvPastRecordsReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPastRecordsReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPastRecordsReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvPastRecordsReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {IDesk2TreasureSrvPastRecordsReq} message Desk2TreasureSrvPastRecordsReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPastRecordsReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPastRecordsReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPastRecordsReq} Desk2TreasureSrvPastRecordsReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPastRecordsReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPastRecordsReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPastRecordsReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPastRecordsReq} Desk2TreasureSrvPastRecordsReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPastRecordsReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPastRecordsReq message.
     * @function verify
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPastRecordsReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPastRecordsReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPastRecordsReq} Desk2TreasureSrvPastRecordsReq
     */
    Desk2TreasureSrvPastRecordsReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPastRecordsReq)
            return object;
        let message = new $root.Desk2TreasureSrvPastRecordsReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPastRecordsReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {Desk2TreasureSrvPastRecordsReq} message Desk2TreasureSrvPastRecordsReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPastRecordsReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPastRecordsReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPastRecordsReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPastRecordsReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPastRecordsReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPastRecordsReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPastRecordsReq";
    };

    return Desk2TreasureSrvPastRecordsReq;
})();

export const Desk2TreasureSrvPastRecordsAck = $root.Desk2TreasureSrvPastRecordsAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvPastRecordsAck.
     * @exports IDesk2TreasureSrvPastRecordsAck
     * @interface IDesk2TreasureSrvPastRecordsAck
     * @property {number|null} [UserID] Desk2TreasureSrvPastRecordsAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvPastRecordsAck Res
     * @property {Array.<IParticipationInfo>|null} [Record] Desk2TreasureSrvPastRecordsAck Record
     */

    /**
     * Constructs a new Desk2TreasureSrvPastRecordsAck.
     * @exports Desk2TreasureSrvPastRecordsAck
     * @classdesc Represents a Desk2TreasureSrvPastRecordsAck.
     * @implements IDesk2TreasureSrvPastRecordsAck
     * @constructor
     * @param {IDesk2TreasureSrvPastRecordsAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvPastRecordsAck(properties) {
        this.Record = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPastRecordsAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @instance
     */
    Desk2TreasureSrvPastRecordsAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPastRecordsAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @instance
     */
    Desk2TreasureSrvPastRecordsAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvPastRecordsAck Record.
     * @member {Array.<IParticipationInfo>} Record
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @instance
     */
    Desk2TreasureSrvPastRecordsAck.prototype.Record = $util.emptyArray;

    /**
     * Creates a new Desk2TreasureSrvPastRecordsAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {IDesk2TreasureSrvPastRecordsAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPastRecordsAck} Desk2TreasureSrvPastRecordsAck instance
     */
    Desk2TreasureSrvPastRecordsAck.create = function create(properties) {
        return new Desk2TreasureSrvPastRecordsAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPastRecordsAck message. Does not implicitly {@link Desk2TreasureSrvPastRecordsAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {IDesk2TreasureSrvPastRecordsAck} message Desk2TreasureSrvPastRecordsAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPastRecordsAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.Record != null && message.Record.length)
            for (let i = 0; i < message.Record.length; ++i)
                $root.ParticipationInfo.encode(message.Record[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPastRecordsAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvPastRecordsAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {IDesk2TreasureSrvPastRecordsAck} message Desk2TreasureSrvPastRecordsAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPastRecordsAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPastRecordsAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPastRecordsAck} Desk2TreasureSrvPastRecordsAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPastRecordsAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPastRecordsAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Record && message.Record.length))
                        message.Record = [];
                    message.Record.push($root.ParticipationInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPastRecordsAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPastRecordsAck} Desk2TreasureSrvPastRecordsAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPastRecordsAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPastRecordsAck message.
     * @function verify
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPastRecordsAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.Record != null && message.hasOwnProperty("Record")) {
            if (!Array.isArray(message.Record))
                return "Record: array expected";
            for (let i = 0; i < message.Record.length; ++i) {
                let error = $root.ParticipationInfo.verify(message.Record[i]);
                if (error)
                    return "Record." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPastRecordsAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPastRecordsAck} Desk2TreasureSrvPastRecordsAck
     */
    Desk2TreasureSrvPastRecordsAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPastRecordsAck)
            return object;
        let message = new $root.Desk2TreasureSrvPastRecordsAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.Record) {
            if (!Array.isArray(object.Record))
                throw TypeError(".Desk2TreasureSrvPastRecordsAck.Record: array expected");
            message.Record = [];
            for (let i = 0; i < object.Record.length; ++i) {
                if (typeof object.Record[i] !== "object")
                    throw TypeError(".Desk2TreasureSrvPastRecordsAck.Record: object expected");
                message.Record[i] = $root.ParticipationInfo.fromObject(object.Record[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPastRecordsAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {Desk2TreasureSrvPastRecordsAck} message Desk2TreasureSrvPastRecordsAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPastRecordsAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Record = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.Record && message.Record.length) {
            object.Record = [];
            for (let j = 0; j < message.Record.length; ++j)
                object.Record[j] = $root.ParticipationInfo.toObject(message.Record[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPastRecordsAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPastRecordsAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPastRecordsAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPastRecordsAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPastRecordsAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPastRecordsAck";
    };

    return Desk2TreasureSrvPastRecordsAck;
})();

export const Desk2TreasureSrvTickNumberReq = $root.Desk2TreasureSrvTickNumberReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvTickNumberReq.
     * @exports IDesk2TreasureSrvTickNumberReq
     * @interface IDesk2TreasureSrvTickNumberReq
     * @property {number|null} [UserID] Desk2TreasureSrvTickNumberReq UserID
     * @property {number|null} [ParticipationID] Desk2TreasureSrvTickNumberReq ParticipationID
     * @property {number|null} [TicketOwnerID] Desk2TreasureSrvTickNumberReq TicketOwnerID
     */

    /**
     * Constructs a new Desk2TreasureSrvTickNumberReq.
     * @exports Desk2TreasureSrvTickNumberReq
     * @classdesc Represents a Desk2TreasureSrvTickNumberReq.
     * @implements IDesk2TreasureSrvTickNumberReq
     * @constructor
     * @param {IDesk2TreasureSrvTickNumberReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvTickNumberReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvTickNumberReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvTickNumberReq
     * @instance
     */
    Desk2TreasureSrvTickNumberReq.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvTickNumberReq ParticipationID.
     * @member {number} ParticipationID
     * @memberof Desk2TreasureSrvTickNumberReq
     * @instance
     */
    Desk2TreasureSrvTickNumberReq.prototype.ParticipationID = 0;

    /**
     * Desk2TreasureSrvTickNumberReq TicketOwnerID.
     * @member {number} TicketOwnerID
     * @memberof Desk2TreasureSrvTickNumberReq
     * @instance
     */
    Desk2TreasureSrvTickNumberReq.prototype.TicketOwnerID = 0;

    /**
     * Creates a new Desk2TreasureSrvTickNumberReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {IDesk2TreasureSrvTickNumberReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvTickNumberReq} Desk2TreasureSrvTickNumberReq instance
     */
    Desk2TreasureSrvTickNumberReq.create = function create(properties) {
        return new Desk2TreasureSrvTickNumberReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvTickNumberReq message. Does not implicitly {@link Desk2TreasureSrvTickNumberReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {IDesk2TreasureSrvTickNumberReq} message Desk2TreasureSrvTickNumberReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvTickNumberReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ParticipationID);
        if (message.TicketOwnerID != null && Object.hasOwnProperty.call(message, "TicketOwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.TicketOwnerID);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvTickNumberReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvTickNumberReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {IDesk2TreasureSrvTickNumberReq} message Desk2TreasureSrvTickNumberReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvTickNumberReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvTickNumberReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvTickNumberReq} Desk2TreasureSrvTickNumberReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvTickNumberReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvTickNumberReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 3: {
                    message.TicketOwnerID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvTickNumberReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvTickNumberReq} Desk2TreasureSrvTickNumberReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvTickNumberReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvTickNumberReq message.
     * @function verify
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvTickNumberReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.TicketOwnerID != null && message.hasOwnProperty("TicketOwnerID"))
            if (!$util.isInteger(message.TicketOwnerID))
                return "TicketOwnerID: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvTickNumberReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvTickNumberReq} Desk2TreasureSrvTickNumberReq
     */
    Desk2TreasureSrvTickNumberReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvTickNumberReq)
            return object;
        let message = new $root.Desk2TreasureSrvTickNumberReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.TicketOwnerID != null)
            message.TicketOwnerID = object.TicketOwnerID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvTickNumberReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {Desk2TreasureSrvTickNumberReq} message Desk2TreasureSrvTickNumberReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvTickNumberReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ParticipationID = 0;
            object.TicketOwnerID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.TicketOwnerID != null && message.hasOwnProperty("TicketOwnerID"))
            object.TicketOwnerID = message.TicketOwnerID;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvTickNumberReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvTickNumberReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvTickNumberReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvTickNumberReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvTickNumberReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvTickNumberReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvTickNumberReq";
    };

    return Desk2TreasureSrvTickNumberReq;
})();

export const Desk2TreasureSrvTickNumberAck = $root.Desk2TreasureSrvTickNumberAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvTickNumberAck.
     * @exports IDesk2TreasureSrvTickNumberAck
     * @interface IDesk2TreasureSrvTickNumberAck
     * @property {number|null} [UserID] Desk2TreasureSrvTickNumberAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvTickNumberAck Res
     * @property {number|null} [ParticipationID] Desk2TreasureSrvTickNumberAck ParticipationID
     * @property {IPlayerOrderInfo|null} [PlayerOrder] Desk2TreasureSrvTickNumberAck PlayerOrder
     */

    /**
     * Constructs a new Desk2TreasureSrvTickNumberAck.
     * @exports Desk2TreasureSrvTickNumberAck
     * @classdesc Represents a Desk2TreasureSrvTickNumberAck.
     * @implements IDesk2TreasureSrvTickNumberAck
     * @constructor
     * @param {IDesk2TreasureSrvTickNumberAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvTickNumberAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvTickNumberAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvTickNumberAck
     * @instance
     */
    Desk2TreasureSrvTickNumberAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvTickNumberAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvTickNumberAck
     * @instance
     */
    Desk2TreasureSrvTickNumberAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvTickNumberAck ParticipationID.
     * @member {number} ParticipationID
     * @memberof Desk2TreasureSrvTickNumberAck
     * @instance
     */
    Desk2TreasureSrvTickNumberAck.prototype.ParticipationID = 0;

    /**
     * Desk2TreasureSrvTickNumberAck PlayerOrder.
     * @member {IPlayerOrderInfo|null|undefined} PlayerOrder
     * @memberof Desk2TreasureSrvTickNumberAck
     * @instance
     */
    Desk2TreasureSrvTickNumberAck.prototype.PlayerOrder = null;

    /**
     * Creates a new Desk2TreasureSrvTickNumberAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {IDesk2TreasureSrvTickNumberAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvTickNumberAck} Desk2TreasureSrvTickNumberAck instance
     */
    Desk2TreasureSrvTickNumberAck.create = function create(properties) {
        return new Desk2TreasureSrvTickNumberAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvTickNumberAck message. Does not implicitly {@link Desk2TreasureSrvTickNumberAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {IDesk2TreasureSrvTickNumberAck} message Desk2TreasureSrvTickNumberAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvTickNumberAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ParticipationID);
        if (message.PlayerOrder != null && Object.hasOwnProperty.call(message, "PlayerOrder"))
            $root.PlayerOrderInfo.encode(message.PlayerOrder, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvTickNumberAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvTickNumberAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {IDesk2TreasureSrvTickNumberAck} message Desk2TreasureSrvTickNumberAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvTickNumberAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvTickNumberAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvTickNumberAck} Desk2TreasureSrvTickNumberAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvTickNumberAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvTickNumberAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 4: {
                    message.PlayerOrder = $root.PlayerOrderInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvTickNumberAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvTickNumberAck} Desk2TreasureSrvTickNumberAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvTickNumberAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvTickNumberAck message.
     * @function verify
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvTickNumberAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.PlayerOrder != null && message.hasOwnProperty("PlayerOrder")) {
            let error = $root.PlayerOrderInfo.verify(message.PlayerOrder);
            if (error)
                return "PlayerOrder." + error;
        }
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvTickNumberAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvTickNumberAck} Desk2TreasureSrvTickNumberAck
     */
    Desk2TreasureSrvTickNumberAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvTickNumberAck)
            return object;
        let message = new $root.Desk2TreasureSrvTickNumberAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.PlayerOrder != null) {
            if (typeof object.PlayerOrder !== "object")
                throw TypeError(".Desk2TreasureSrvTickNumberAck.PlayerOrder: object expected");
            message.PlayerOrder = $root.PlayerOrderInfo.fromObject(object.PlayerOrder);
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvTickNumberAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {Desk2TreasureSrvTickNumberAck} message Desk2TreasureSrvTickNumberAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvTickNumberAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
            object.ParticipationID = 0;
            object.PlayerOrder = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.PlayerOrder != null && message.hasOwnProperty("PlayerOrder"))
            object.PlayerOrder = $root.PlayerOrderInfo.toObject(message.PlayerOrder, options);
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvTickNumberAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvTickNumberAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvTickNumberAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvTickNumberAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvTickNumberAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvTickNumberAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvTickNumberAck";
    };

    return Desk2TreasureSrvTickNumberAck;
})();

export const Desk2TreasureSrvQueryLotteryReq = $root.Desk2TreasureSrvQueryLotteryReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvQueryLotteryReq.
     * @exports IDesk2TreasureSrvQueryLotteryReq
     * @interface IDesk2TreasureSrvQueryLotteryReq
     * @property {number|null} [UserID] Desk2TreasureSrvQueryLotteryReq UserID
     * @property {number|null} [Type] Desk2TreasureSrvQueryLotteryReq Type
     */

    /**
     * Constructs a new Desk2TreasureSrvQueryLotteryReq.
     * @exports Desk2TreasureSrvQueryLotteryReq
     * @classdesc Represents a Desk2TreasureSrvQueryLotteryReq.
     * @implements IDesk2TreasureSrvQueryLotteryReq
     * @constructor
     * @param {IDesk2TreasureSrvQueryLotteryReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvQueryLotteryReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvQueryLotteryReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @instance
     */
    Desk2TreasureSrvQueryLotteryReq.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvQueryLotteryReq Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @instance
     */
    Desk2TreasureSrvQueryLotteryReq.prototype.Type = 0;

    /**
     * Creates a new Desk2TreasureSrvQueryLotteryReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvQueryLotteryReq} Desk2TreasureSrvQueryLotteryReq instance
     */
    Desk2TreasureSrvQueryLotteryReq.create = function create(properties) {
        return new Desk2TreasureSrvQueryLotteryReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvQueryLotteryReq message. Does not implicitly {@link Desk2TreasureSrvQueryLotteryReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryReq} message Desk2TreasureSrvQueryLotteryReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvQueryLotteryReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvQueryLotteryReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvQueryLotteryReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryReq} message Desk2TreasureSrvQueryLotteryReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvQueryLotteryReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvQueryLotteryReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvQueryLotteryReq} Desk2TreasureSrvQueryLotteryReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvQueryLotteryReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvQueryLotteryReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvQueryLotteryReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvQueryLotteryReq} Desk2TreasureSrvQueryLotteryReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvQueryLotteryReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvQueryLotteryReq message.
     * @function verify
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvQueryLotteryReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvQueryLotteryReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvQueryLotteryReq} Desk2TreasureSrvQueryLotteryReq
     */
    Desk2TreasureSrvQueryLotteryReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvQueryLotteryReq)
            return object;
        let message = new $root.Desk2TreasureSrvQueryLotteryReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvQueryLotteryReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {Desk2TreasureSrvQueryLotteryReq} message Desk2TreasureSrvQueryLotteryReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvQueryLotteryReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvQueryLotteryReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvQueryLotteryReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvQueryLotteryReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvQueryLotteryReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvQueryLotteryReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvQueryLotteryReq";
    };

    return Desk2TreasureSrvQueryLotteryReq;
})();

export const Desk2TreasureSrvQueryLotteryAck = $root.Desk2TreasureSrvQueryLotteryAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvQueryLotteryAck.
     * @exports IDesk2TreasureSrvQueryLotteryAck
     * @interface IDesk2TreasureSrvQueryLotteryAck
     * @property {number|null} [UserID] Desk2TreasureSrvQueryLotteryAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvQueryLotteryAck Res
     * @property {number|null} [ParticipationID] Desk2TreasureSrvQueryLotteryAck ParticipationID
     * @property {number|null} [Type] Desk2TreasureSrvQueryLotteryAck Type
     * @property {string|null} [BonusValue] Desk2TreasureSrvQueryLotteryAck BonusValue
     * @property {number|null} [TotalTickets] Desk2TreasureSrvQueryLotteryAck TotalTickets
     * @property {number|null} [AvailableTickets] Desk2TreasureSrvQueryLotteryAck AvailableTickets
     * @property {number|null} [RestTicketCount] Desk2TreasureSrvQueryLotteryAck RestTicketCount
     * @property {string|null} [Price] Desk2TreasureSrvQueryLotteryAck Price
     * @property {string|null} [EnterCarry] Desk2TreasureSrvQueryLotteryAck EnterCarry
     * @property {number|null} [CurState] Desk2TreasureSrvQueryLotteryAck CurState
     * @property {Array.<number>|null} [QuickBuyNumber] Desk2TreasureSrvQueryLotteryAck QuickBuyNumber
     */

    /**
     * Constructs a new Desk2TreasureSrvQueryLotteryAck.
     * @exports Desk2TreasureSrvQueryLotteryAck
     * @classdesc Represents a Desk2TreasureSrvQueryLotteryAck.
     * @implements IDesk2TreasureSrvQueryLotteryAck
     * @constructor
     * @param {IDesk2TreasureSrvQueryLotteryAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvQueryLotteryAck(properties) {
        this.QuickBuyNumber = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvQueryLotteryAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck ParticipationID.
     * @member {number} ParticipationID
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.ParticipationID = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.Type = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck BonusValue.
     * @member {string} BonusValue
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.BonusValue = "";

    /**
     * Desk2TreasureSrvQueryLotteryAck TotalTickets.
     * @member {number} TotalTickets
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.TotalTickets = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck AvailableTickets.
     * @member {number} AvailableTickets
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.AvailableTickets = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck RestTicketCount.
     * @member {number} RestTicketCount
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.RestTicketCount = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck Price.
     * @member {string} Price
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.Price = "";

    /**
     * Desk2TreasureSrvQueryLotteryAck EnterCarry.
     * @member {string} EnterCarry
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.EnterCarry = "";

    /**
     * Desk2TreasureSrvQueryLotteryAck CurState.
     * @member {number} CurState
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.CurState = 0;

    /**
     * Desk2TreasureSrvQueryLotteryAck QuickBuyNumber.
     * @member {Array.<number>} QuickBuyNumber
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.QuickBuyNumber = $util.emptyArray;

    /**
     * Creates a new Desk2TreasureSrvQueryLotteryAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvQueryLotteryAck} Desk2TreasureSrvQueryLotteryAck instance
     */
    Desk2TreasureSrvQueryLotteryAck.create = function create(properties) {
        return new Desk2TreasureSrvQueryLotteryAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvQueryLotteryAck message. Does not implicitly {@link Desk2TreasureSrvQueryLotteryAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryAck} message Desk2TreasureSrvQueryLotteryAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvQueryLotteryAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ParticipationID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Type);
        if (message.BonusValue != null && Object.hasOwnProperty.call(message, "BonusValue"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BonusValue);
        if (message.TotalTickets != null && Object.hasOwnProperty.call(message, "TotalTickets"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.TotalTickets);
        if (message.AvailableTickets != null && Object.hasOwnProperty.call(message, "AvailableTickets"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.AvailableTickets);
        if (message.RestTicketCount != null && Object.hasOwnProperty.call(message, "RestTicketCount"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.RestTicketCount);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Price);
        if (message.EnterCarry != null && Object.hasOwnProperty.call(message, "EnterCarry"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.EnterCarry);
        if (message.CurState != null && Object.hasOwnProperty.call(message, "CurState"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.CurState);
        if (message.QuickBuyNumber != null && message.QuickBuyNumber.length) {
            writer.uint32(/* id 12, wireType 2 =*/98).fork();
            for (let i = 0; i < message.QuickBuyNumber.length; ++i)
                writer.uint32(message.QuickBuyNumber[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvQueryLotteryAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvQueryLotteryAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {IDesk2TreasureSrvQueryLotteryAck} message Desk2TreasureSrvQueryLotteryAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvQueryLotteryAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvQueryLotteryAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvQueryLotteryAck} Desk2TreasureSrvQueryLotteryAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvQueryLotteryAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvQueryLotteryAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Type = reader.uint32();
                    break;
                }
            case 5: {
                    message.BonusValue = reader.string();
                    break;
                }
            case 6: {
                    message.TotalTickets = reader.uint32();
                    break;
                }
            case 7: {
                    message.AvailableTickets = reader.uint32();
                    break;
                }
            case 8: {
                    message.RestTicketCount = reader.uint32();
                    break;
                }
            case 9: {
                    message.Price = reader.string();
                    break;
                }
            case 10: {
                    message.EnterCarry = reader.string();
                    break;
                }
            case 11: {
                    message.CurState = reader.uint32();
                    break;
                }
            case 12: {
                    if (!(message.QuickBuyNumber && message.QuickBuyNumber.length))
                        message.QuickBuyNumber = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.QuickBuyNumber.push(reader.uint32());
                    } else
                        message.QuickBuyNumber.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvQueryLotteryAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvQueryLotteryAck} Desk2TreasureSrvQueryLotteryAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvQueryLotteryAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvQueryLotteryAck message.
     * @function verify
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvQueryLotteryAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            if (!$util.isString(message.BonusValue))
                return "BonusValue: string expected";
        if (message.TotalTickets != null && message.hasOwnProperty("TotalTickets"))
            if (!$util.isInteger(message.TotalTickets))
                return "TotalTickets: integer expected";
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            if (!$util.isInteger(message.AvailableTickets))
                return "AvailableTickets: integer expected";
        if (message.RestTicketCount != null && message.hasOwnProperty("RestTicketCount"))
            if (!$util.isInteger(message.RestTicketCount))
                return "RestTicketCount: integer expected";
        if (message.Price != null && message.hasOwnProperty("Price"))
            if (!$util.isString(message.Price))
                return "Price: string expected";
        if (message.EnterCarry != null && message.hasOwnProperty("EnterCarry"))
            if (!$util.isString(message.EnterCarry))
                return "EnterCarry: string expected";
        if (message.CurState != null && message.hasOwnProperty("CurState"))
            if (!$util.isInteger(message.CurState))
                return "CurState: integer expected";
        if (message.QuickBuyNumber != null && message.hasOwnProperty("QuickBuyNumber")) {
            if (!Array.isArray(message.QuickBuyNumber))
                return "QuickBuyNumber: array expected";
            for (let i = 0; i < message.QuickBuyNumber.length; ++i)
                if (!$util.isInteger(message.QuickBuyNumber[i]))
                    return "QuickBuyNumber: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvQueryLotteryAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvQueryLotteryAck} Desk2TreasureSrvQueryLotteryAck
     */
    Desk2TreasureSrvQueryLotteryAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvQueryLotteryAck)
            return object;
        let message = new $root.Desk2TreasureSrvQueryLotteryAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.BonusValue != null)
            message.BonusValue = String(object.BonusValue);
        if (object.TotalTickets != null)
            message.TotalTickets = object.TotalTickets >>> 0;
        if (object.AvailableTickets != null)
            message.AvailableTickets = object.AvailableTickets >>> 0;
        if (object.RestTicketCount != null)
            message.RestTicketCount = object.RestTicketCount >>> 0;
        if (object.Price != null)
            message.Price = String(object.Price);
        if (object.EnterCarry != null)
            message.EnterCarry = String(object.EnterCarry);
        if (object.CurState != null)
            message.CurState = object.CurState >>> 0;
        if (object.QuickBuyNumber) {
            if (!Array.isArray(object.QuickBuyNumber))
                throw TypeError(".Desk2TreasureSrvQueryLotteryAck.QuickBuyNumber: array expected");
            message.QuickBuyNumber = [];
            for (let i = 0; i < object.QuickBuyNumber.length; ++i)
                message.QuickBuyNumber[i] = object.QuickBuyNumber[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvQueryLotteryAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {Desk2TreasureSrvQueryLotteryAck} message Desk2TreasureSrvQueryLotteryAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvQueryLotteryAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.QuickBuyNumber = [];
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
            object.ParticipationID = 0;
            object.Type = 0;
            object.BonusValue = "";
            object.TotalTickets = 0;
            object.AvailableTickets = 0;
            object.RestTicketCount = 0;
            object.Price = "";
            object.EnterCarry = "";
            object.CurState = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            object.BonusValue = message.BonusValue;
        if (message.TotalTickets != null && message.hasOwnProperty("TotalTickets"))
            object.TotalTickets = message.TotalTickets;
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            object.AvailableTickets = message.AvailableTickets;
        if (message.RestTicketCount != null && message.hasOwnProperty("RestTicketCount"))
            object.RestTicketCount = message.RestTicketCount;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = message.Price;
        if (message.EnterCarry != null && message.hasOwnProperty("EnterCarry"))
            object.EnterCarry = message.EnterCarry;
        if (message.CurState != null && message.hasOwnProperty("CurState"))
            object.CurState = message.CurState;
        if (message.QuickBuyNumber && message.QuickBuyNumber.length) {
            object.QuickBuyNumber = [];
            for (let j = 0; j < message.QuickBuyNumber.length; ++j)
                object.QuickBuyNumber[j] = message.QuickBuyNumber[j];
        }
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvQueryLotteryAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvQueryLotteryAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvQueryLotteryAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvQueryLotteryAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvQueryLotteryAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvQueryLotteryAck";
    };

    return Desk2TreasureSrvQueryLotteryAck;
})();

export const Desk2TreasureSrvByTicketReq = $root.Desk2TreasureSrvByTicketReq = (() => {

    /**
     * Properties of a Desk2TreasureSrvByTicketReq.
     * @exports IDesk2TreasureSrvByTicketReq
     * @interface IDesk2TreasureSrvByTicketReq
     * @property {number|null} [UserID] Desk2TreasureSrvByTicketReq UserID
     * @property {number|null} [Type] Desk2TreasureSrvByTicketReq Type
     * @property {number|null} [Count] Desk2TreasureSrvByTicketReq Count
     */

    /**
     * Constructs a new Desk2TreasureSrvByTicketReq.
     * @exports Desk2TreasureSrvByTicketReq
     * @classdesc Represents a Desk2TreasureSrvByTicketReq.
     * @implements IDesk2TreasureSrvByTicketReq
     * @constructor
     * @param {IDesk2TreasureSrvByTicketReq=} [properties] Properties to set
     */
    function Desk2TreasureSrvByTicketReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvByTicketReq UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvByTicketReq
     * @instance
     */
    Desk2TreasureSrvByTicketReq.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvByTicketReq Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvByTicketReq
     * @instance
     */
    Desk2TreasureSrvByTicketReq.prototype.Type = 0;

    /**
     * Desk2TreasureSrvByTicketReq Count.
     * @member {number} Count
     * @memberof Desk2TreasureSrvByTicketReq
     * @instance
     */
    Desk2TreasureSrvByTicketReq.prototype.Count = 0;

    /**
     * Creates a new Desk2TreasureSrvByTicketReq instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {IDesk2TreasureSrvByTicketReq=} [properties] Properties to set
     * @returns {Desk2TreasureSrvByTicketReq} Desk2TreasureSrvByTicketReq instance
     */
    Desk2TreasureSrvByTicketReq.create = function create(properties) {
        return new Desk2TreasureSrvByTicketReq(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvByTicketReq message. Does not implicitly {@link Desk2TreasureSrvByTicketReq.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {IDesk2TreasureSrvByTicketReq} message Desk2TreasureSrvByTicketReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvByTicketReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Count);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvByTicketReq message, length delimited. Does not implicitly {@link Desk2TreasureSrvByTicketReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {IDesk2TreasureSrvByTicketReq} message Desk2TreasureSrvByTicketReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvByTicketReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvByTicketReq message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvByTicketReq} Desk2TreasureSrvByTicketReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvByTicketReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvByTicketReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            case 3: {
                    message.Count = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvByTicketReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvByTicketReq} Desk2TreasureSrvByTicketReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvByTicketReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvByTicketReq message.
     * @function verify
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvByTicketReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.Count != null && message.hasOwnProperty("Count"))
            if (!$util.isInteger(message.Count))
                return "Count: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvByTicketReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvByTicketReq} Desk2TreasureSrvByTicketReq
     */
    Desk2TreasureSrvByTicketReq.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvByTicketReq)
            return object;
        let message = new $root.Desk2TreasureSrvByTicketReq();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.Count != null)
            message.Count = object.Count | 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvByTicketReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {Desk2TreasureSrvByTicketReq} message Desk2TreasureSrvByTicketReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvByTicketReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Type = 0;
            object.Count = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.Count != null && message.hasOwnProperty("Count"))
            object.Count = message.Count;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvByTicketReq to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvByTicketReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvByTicketReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvByTicketReq
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvByTicketReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvByTicketReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvByTicketReq";
    };

    return Desk2TreasureSrvByTicketReq;
})();

export const Desk2TreasureSrvByTicketAck = $root.Desk2TreasureSrvByTicketAck = (() => {

    /**
     * Properties of a Desk2TreasureSrvByTicketAck.
     * @exports IDesk2TreasureSrvByTicketAck
     * @interface IDesk2TreasureSrvByTicketAck
     * @property {number|null} [UserID] Desk2TreasureSrvByTicketAck UserID
     * @property {number|null} [Res] Desk2TreasureSrvByTicketAck Res
     * @property {number|null} [Count] Desk2TreasureSrvByTicketAck Count
     * @property {string|null} [Cost] Desk2TreasureSrvByTicketAck Cost
     * @property {number|null} [RestCount] Desk2TreasureSrvByTicketAck RestCount
     * @property {number|null} [PlayerTotalCount] Desk2TreasureSrvByTicketAck PlayerTotalCount
     * @property {number|null} [Type] Desk2TreasureSrvByTicketAck Type
     * @property {number|null} [TotalCount] Desk2TreasureSrvByTicketAck TotalCount
     */

    /**
     * Constructs a new Desk2TreasureSrvByTicketAck.
     * @exports Desk2TreasureSrvByTicketAck
     * @classdesc Represents a Desk2TreasureSrvByTicketAck.
     * @implements IDesk2TreasureSrvByTicketAck
     * @constructor
     * @param {IDesk2TreasureSrvByTicketAck=} [properties] Properties to set
     */
    function Desk2TreasureSrvByTicketAck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvByTicketAck UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvByTicketAck Res.
     * @member {number} Res
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.Res = 0;

    /**
     * Desk2TreasureSrvByTicketAck Count.
     * @member {number} Count
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.Count = 0;

    /**
     * Desk2TreasureSrvByTicketAck Cost.
     * @member {string} Cost
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.Cost = "";

    /**
     * Desk2TreasureSrvByTicketAck RestCount.
     * @member {number} RestCount
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.RestCount = 0;

    /**
     * Desk2TreasureSrvByTicketAck PlayerTotalCount.
     * @member {number} PlayerTotalCount
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.PlayerTotalCount = 0;

    /**
     * Desk2TreasureSrvByTicketAck Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.Type = 0;

    /**
     * Desk2TreasureSrvByTicketAck TotalCount.
     * @member {number} TotalCount
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     */
    Desk2TreasureSrvByTicketAck.prototype.TotalCount = 0;

    /**
     * Creates a new Desk2TreasureSrvByTicketAck instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {IDesk2TreasureSrvByTicketAck=} [properties] Properties to set
     * @returns {Desk2TreasureSrvByTicketAck} Desk2TreasureSrvByTicketAck instance
     */
    Desk2TreasureSrvByTicketAck.create = function create(properties) {
        return new Desk2TreasureSrvByTicketAck(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvByTicketAck message. Does not implicitly {@link Desk2TreasureSrvByTicketAck.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {IDesk2TreasureSrvByTicketAck} message Desk2TreasureSrvByTicketAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvByTicketAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Res);
        if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Count);
        if (message.Cost != null && Object.hasOwnProperty.call(message, "Cost"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Cost);
        if (message.RestCount != null && Object.hasOwnProperty.call(message, "RestCount"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.RestCount);
        if (message.PlayerTotalCount != null && Object.hasOwnProperty.call(message, "PlayerTotalCount"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.PlayerTotalCount);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Type);
        if (message.TotalCount != null && Object.hasOwnProperty.call(message, "TotalCount"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.TotalCount);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvByTicketAck message, length delimited. Does not implicitly {@link Desk2TreasureSrvByTicketAck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {IDesk2TreasureSrvByTicketAck} message Desk2TreasureSrvByTicketAck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvByTicketAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvByTicketAck message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvByTicketAck} Desk2TreasureSrvByTicketAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvByTicketAck.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvByTicketAck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Res = reader.uint32();
                    break;
                }
            case 3: {
                    message.Count = reader.int32();
                    break;
                }
            case 4: {
                    message.Cost = reader.string();
                    break;
                }
            case 5: {
                    message.RestCount = reader.uint32();
                    break;
                }
            case 6: {
                    message.PlayerTotalCount = reader.uint32();
                    break;
                }
            case 7: {
                    message.Type = reader.uint32();
                    break;
                }
            case 8: {
                    message.TotalCount = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvByTicketAck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvByTicketAck} Desk2TreasureSrvByTicketAck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvByTicketAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvByTicketAck message.
     * @function verify
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvByTicketAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.Count != null && message.hasOwnProperty("Count"))
            if (!$util.isInteger(message.Count))
                return "Count: integer expected";
        if (message.Cost != null && message.hasOwnProperty("Cost"))
            if (!$util.isString(message.Cost))
                return "Cost: string expected";
        if (message.RestCount != null && message.hasOwnProperty("RestCount"))
            if (!$util.isInteger(message.RestCount))
                return "RestCount: integer expected";
        if (message.PlayerTotalCount != null && message.hasOwnProperty("PlayerTotalCount"))
            if (!$util.isInteger(message.PlayerTotalCount))
                return "PlayerTotalCount: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            if (!$util.isInteger(message.TotalCount))
                return "TotalCount: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvByTicketAck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvByTicketAck} Desk2TreasureSrvByTicketAck
     */
    Desk2TreasureSrvByTicketAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvByTicketAck)
            return object;
        let message = new $root.Desk2TreasureSrvByTicketAck();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.Count != null)
            message.Count = object.Count | 0;
        if (object.Cost != null)
            message.Cost = String(object.Cost);
        if (object.RestCount != null)
            message.RestCount = object.RestCount >>> 0;
        if (object.PlayerTotalCount != null)
            message.PlayerTotalCount = object.PlayerTotalCount >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.TotalCount != null)
            message.TotalCount = object.TotalCount >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvByTicketAck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {Desk2TreasureSrvByTicketAck} message Desk2TreasureSrvByTicketAck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvByTicketAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Res = 0;
            object.Count = 0;
            object.Cost = "";
            object.RestCount = 0;
            object.PlayerTotalCount = 0;
            object.Type = 0;
            object.TotalCount = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.Count != null && message.hasOwnProperty("Count"))
            object.Count = message.Count;
        if (message.Cost != null && message.hasOwnProperty("Cost"))
            object.Cost = message.Cost;
        if (message.RestCount != null && message.hasOwnProperty("RestCount"))
            object.RestCount = message.RestCount;
        if (message.PlayerTotalCount != null && message.hasOwnProperty("PlayerTotalCount"))
            object.PlayerTotalCount = message.PlayerTotalCount;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            object.TotalCount = message.TotalCount;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvByTicketAck to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvByTicketAck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvByTicketAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvByTicketAck
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvByTicketAck
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvByTicketAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvByTicketAck";
    };

    return Desk2TreasureSrvByTicketAck;
})();

export const Desk2TreasureSrvPushResultTimeout = $root.Desk2TreasureSrvPushResultTimeout = (() => {

    /**
     * Properties of a Desk2TreasureSrvPushResultTimeout.
     * @exports IDesk2TreasureSrvPushResultTimeout
     * @interface IDesk2TreasureSrvPushResultTimeout
     * @property {number|null} [ParticipationID] Desk2TreasureSrvPushResultTimeout ParticipationID
     * @property {number|null} [Type] Desk2TreasureSrvPushResultTimeout Type
     * @property {string|null} [BonusValue] Desk2TreasureSrvPushResultTimeout BonusValue
     * @property {number|Long|null} [Timeout] Desk2TreasureSrvPushResultTimeout Timeout
     * @property {number|null} [UserID] Desk2TreasureSrvPushResultTimeout UserID
     * @property {number|null} [AvailableTickets] Desk2TreasureSrvPushResultTimeout AvailableTickets
     */

    /**
     * Constructs a new Desk2TreasureSrvPushResultTimeout.
     * @exports Desk2TreasureSrvPushResultTimeout
     * @classdesc Represents a Desk2TreasureSrvPushResultTimeout.
     * @implements IDesk2TreasureSrvPushResultTimeout
     * @constructor
     * @param {IDesk2TreasureSrvPushResultTimeout=} [properties] Properties to set
     */
    function Desk2TreasureSrvPushResultTimeout(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPushResultTimeout ParticipationID.
     * @member {number} ParticipationID
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.ParticipationID = 0;

    /**
     * Desk2TreasureSrvPushResultTimeout Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.Type = 0;

    /**
     * Desk2TreasureSrvPushResultTimeout BonusValue.
     * @member {string} BonusValue
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.BonusValue = "";

    /**
     * Desk2TreasureSrvPushResultTimeout Timeout.
     * @member {number|Long} Timeout
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.Timeout = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Desk2TreasureSrvPushResultTimeout UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPushResultTimeout AvailableTickets.
     * @member {number} AvailableTickets
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     */
    Desk2TreasureSrvPushResultTimeout.prototype.AvailableTickets = 0;

    /**
     * Creates a new Desk2TreasureSrvPushResultTimeout instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {IDesk2TreasureSrvPushResultTimeout=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPushResultTimeout} Desk2TreasureSrvPushResultTimeout instance
     */
    Desk2TreasureSrvPushResultTimeout.create = function create(properties) {
        return new Desk2TreasureSrvPushResultTimeout(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushResultTimeout message. Does not implicitly {@link Desk2TreasureSrvPushResultTimeout.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {IDesk2TreasureSrvPushResultTimeout} message Desk2TreasureSrvPushResultTimeout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushResultTimeout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ParticipationID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Type);
        if (message.BonusValue != null && Object.hasOwnProperty.call(message, "BonusValue"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BonusValue);
        if (message.Timeout != null && Object.hasOwnProperty.call(message, "Timeout"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Timeout);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.UserID);
        if (message.AvailableTickets != null && Object.hasOwnProperty.call(message, "AvailableTickets"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.AvailableTickets);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushResultTimeout message, length delimited. Does not implicitly {@link Desk2TreasureSrvPushResultTimeout.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {IDesk2TreasureSrvPushResultTimeout} message Desk2TreasureSrvPushResultTimeout message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushResultTimeout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPushResultTimeout message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPushResultTimeout} Desk2TreasureSrvPushResultTimeout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushResultTimeout.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPushResultTimeout();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Type = reader.uint32();
                    break;
                }
            case 3: {
                    message.BonusValue = reader.string();
                    break;
                }
            case 4: {
                    message.Timeout = reader.uint64();
                    break;
                }
            case 5: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 6: {
                    message.AvailableTickets = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPushResultTimeout message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPushResultTimeout} Desk2TreasureSrvPushResultTimeout
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushResultTimeout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPushResultTimeout message.
     * @function verify
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPushResultTimeout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            if (!$util.isString(message.BonusValue))
                return "BonusValue: string expected";
        if (message.Timeout != null && message.hasOwnProperty("Timeout"))
            if (!$util.isInteger(message.Timeout) && !(message.Timeout && $util.isInteger(message.Timeout.low) && $util.isInteger(message.Timeout.high)))
                return "Timeout: integer|Long expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            if (!$util.isInteger(message.AvailableTickets))
                return "AvailableTickets: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPushResultTimeout message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPushResultTimeout} Desk2TreasureSrvPushResultTimeout
     */
    Desk2TreasureSrvPushResultTimeout.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPushResultTimeout)
            return object;
        let message = new $root.Desk2TreasureSrvPushResultTimeout();
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.BonusValue != null)
            message.BonusValue = String(object.BonusValue);
        if (object.Timeout != null)
            if ($util.Long)
                (message.Timeout = $util.Long.fromValue(object.Timeout)).unsigned = true;
            else if (typeof object.Timeout === "string")
                message.Timeout = parseInt(object.Timeout, 10);
            else if (typeof object.Timeout === "number")
                message.Timeout = object.Timeout;
            else if (typeof object.Timeout === "object")
                message.Timeout = new $util.LongBits(object.Timeout.low >>> 0, object.Timeout.high >>> 0).toNumber(true);
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.AvailableTickets != null)
            message.AvailableTickets = object.AvailableTickets >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPushResultTimeout message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {Desk2TreasureSrvPushResultTimeout} message Desk2TreasureSrvPushResultTimeout
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPushResultTimeout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ParticipationID = 0;
            object.Type = 0;
            object.BonusValue = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Timeout = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Timeout = options.longs === String ? "0" : 0;
            object.UserID = 0;
            object.AvailableTickets = 0;
        }
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            object.BonusValue = message.BonusValue;
        if (message.Timeout != null && message.hasOwnProperty("Timeout"))
            if (typeof message.Timeout === "number")
                object.Timeout = options.longs === String ? String(message.Timeout) : message.Timeout;
            else
                object.Timeout = options.longs === String ? $util.Long.prototype.toString.call(message.Timeout) : options.longs === Number ? new $util.LongBits(message.Timeout.low >>> 0, message.Timeout.high >>> 0).toNumber(true) : message.Timeout;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.AvailableTickets != null && message.hasOwnProperty("AvailableTickets"))
            object.AvailableTickets = message.AvailableTickets;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPushResultTimeout to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPushResultTimeout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPushResultTimeout
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPushResultTimeout
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPushResultTimeout.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPushResultTimeout";
    };

    return Desk2TreasureSrvPushResultTimeout;
})();

export const Desk2TreasureSrvPushResult = $root.Desk2TreasureSrvPushResult = (() => {

    /**
     * Properties of a Desk2TreasureSrvPushResult.
     * @exports IDesk2TreasureSrvPushResult
     * @interface IDesk2TreasureSrvPushResult
     * @property {number|null} [UserID] Desk2TreasureSrvPushResult UserID
     * @property {number|null} [TicketCount] Desk2TreasureSrvPushResult TicketCount
     * @property {number|null} [ParticipationID] Desk2TreasureSrvPushResult ParticipationID
     * @property {number|null} [Type] Desk2TreasureSrvPushResult Type
     * @property {string|null} [BonusValue] Desk2TreasureSrvPushResult BonusValue
     * @property {number|null} [WinnerID] Desk2TreasureSrvPushResult WinnerID
     * @property {Uint8Array|null} [NickName] Desk2TreasureSrvPushResult NickName
     * @property {Uint8Array|null} [HeadUrl] Desk2TreasureSrvPushResult HeadUrl
     * @property {number|null} [WinningTicketCount] Desk2TreasureSrvPushResult WinningTicketCount
     * @property {number|Long|null} [AnnouncementTime] Desk2TreasureSrvPushResult AnnouncementTime
     * @property {number|null} [Number] Desk2TreasureSrvPushResult Number
     */

    /**
     * Constructs a new Desk2TreasureSrvPushResult.
     * @exports Desk2TreasureSrvPushResult
     * @classdesc Represents a Desk2TreasureSrvPushResult.
     * @implements IDesk2TreasureSrvPushResult
     * @constructor
     * @param {IDesk2TreasureSrvPushResult=} [properties] Properties to set
     */
    function Desk2TreasureSrvPushResult(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPushResult UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPushResult TicketCount.
     * @member {number} TicketCount
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.TicketCount = 0;

    /**
     * Desk2TreasureSrvPushResult ParticipationID.
     * @member {number} ParticipationID
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.ParticipationID = 0;

    /**
     * Desk2TreasureSrvPushResult Type.
     * @member {number} Type
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.Type = 0;

    /**
     * Desk2TreasureSrvPushResult BonusValue.
     * @member {string} BonusValue
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.BonusValue = "";

    /**
     * Desk2TreasureSrvPushResult WinnerID.
     * @member {number} WinnerID
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.WinnerID = 0;

    /**
     * Desk2TreasureSrvPushResult NickName.
     * @member {Uint8Array} NickName
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.NickName = $util.newBuffer([]);

    /**
     * Desk2TreasureSrvPushResult HeadUrl.
     * @member {Uint8Array} HeadUrl
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.HeadUrl = $util.newBuffer([]);

    /**
     * Desk2TreasureSrvPushResult WinningTicketCount.
     * @member {number} WinningTicketCount
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.WinningTicketCount = 0;

    /**
     * Desk2TreasureSrvPushResult AnnouncementTime.
     * @member {number|Long} AnnouncementTime
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.AnnouncementTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Desk2TreasureSrvPushResult Number.
     * @member {number} Number
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     */
    Desk2TreasureSrvPushResult.prototype.Number = 0;

    /**
     * Creates a new Desk2TreasureSrvPushResult instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {IDesk2TreasureSrvPushResult=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPushResult} Desk2TreasureSrvPushResult instance
     */
    Desk2TreasureSrvPushResult.create = function create(properties) {
        return new Desk2TreasureSrvPushResult(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushResult message. Does not implicitly {@link Desk2TreasureSrvPushResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {IDesk2TreasureSrvPushResult} message Desk2TreasureSrvPushResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.TicketCount != null && Object.hasOwnProperty.call(message, "TicketCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.TicketCount);
        if (message.ParticipationID != null && Object.hasOwnProperty.call(message, "ParticipationID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ParticipationID);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Type);
        if (message.BonusValue != null && Object.hasOwnProperty.call(message, "BonusValue"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BonusValue);
        if (message.WinnerID != null && Object.hasOwnProperty.call(message, "WinnerID"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.WinnerID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.NickName);
        if (message.HeadUrl != null && Object.hasOwnProperty.call(message, "HeadUrl"))
            writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.HeadUrl);
        if (message.WinningTicketCount != null && Object.hasOwnProperty.call(message, "WinningTicketCount"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.WinningTicketCount);
        if (message.AnnouncementTime != null && Object.hasOwnProperty.call(message, "AnnouncementTime"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.AnnouncementTime);
        if (message.Number != null && Object.hasOwnProperty.call(message, "Number"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Number);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushResult message, length delimited. Does not implicitly {@link Desk2TreasureSrvPushResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {IDesk2TreasureSrvPushResult} message Desk2TreasureSrvPushResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPushResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPushResult} Desk2TreasureSrvPushResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPushResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.TicketCount = reader.uint32();
                    break;
                }
            case 3: {
                    message.ParticipationID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Type = reader.uint32();
                    break;
                }
            case 5: {
                    message.BonusValue = reader.string();
                    break;
                }
            case 6: {
                    message.WinnerID = reader.uint32();
                    break;
                }
            case 7: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 8: {
                    message.HeadUrl = reader.bytes();
                    break;
                }
            case 9: {
                    message.WinningTicketCount = reader.uint32();
                    break;
                }
            case 10: {
                    message.AnnouncementTime = reader.uint64();
                    break;
                }
            case 11: {
                    message.Number = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPushResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPushResult} Desk2TreasureSrvPushResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPushResult message.
     * @function verify
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPushResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.TicketCount != null && message.hasOwnProperty("TicketCount"))
            if (!$util.isInteger(message.TicketCount))
                return "TicketCount: integer expected";
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            if (!$util.isInteger(message.ParticipationID))
                return "ParticipationID: integer expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            if (!$util.isString(message.BonusValue))
                return "BonusValue: string expected";
        if (message.WinnerID != null && message.hasOwnProperty("WinnerID"))
            if (!$util.isInteger(message.WinnerID))
                return "WinnerID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            if (!(message.HeadUrl && typeof message.HeadUrl.length === "number" || $util.isString(message.HeadUrl)))
                return "HeadUrl: buffer expected";
        if (message.WinningTicketCount != null && message.hasOwnProperty("WinningTicketCount"))
            if (!$util.isInteger(message.WinningTicketCount))
                return "WinningTicketCount: integer expected";
        if (message.AnnouncementTime != null && message.hasOwnProperty("AnnouncementTime"))
            if (!$util.isInteger(message.AnnouncementTime) && !(message.AnnouncementTime && $util.isInteger(message.AnnouncementTime.low) && $util.isInteger(message.AnnouncementTime.high)))
                return "AnnouncementTime: integer|Long expected";
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isInteger(message.Number))
                return "Number: integer expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPushResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPushResult} Desk2TreasureSrvPushResult
     */
    Desk2TreasureSrvPushResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPushResult)
            return object;
        let message = new $root.Desk2TreasureSrvPushResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.TicketCount != null)
            message.TicketCount = object.TicketCount >>> 0;
        if (object.ParticipationID != null)
            message.ParticipationID = object.ParticipationID >>> 0;
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        if (object.BonusValue != null)
            message.BonusValue = String(object.BonusValue);
        if (object.WinnerID != null)
            message.WinnerID = object.WinnerID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeadUrl != null)
            if (typeof object.HeadUrl === "string")
                $util.base64.decode(object.HeadUrl, message.HeadUrl = $util.newBuffer($util.base64.length(object.HeadUrl)), 0);
            else if (object.HeadUrl.length >= 0)
                message.HeadUrl = object.HeadUrl;
        if (object.WinningTicketCount != null)
            message.WinningTicketCount = object.WinningTicketCount >>> 0;
        if (object.AnnouncementTime != null)
            if ($util.Long)
                (message.AnnouncementTime = $util.Long.fromValue(object.AnnouncementTime)).unsigned = true;
            else if (typeof object.AnnouncementTime === "string")
                message.AnnouncementTime = parseInt(object.AnnouncementTime, 10);
            else if (typeof object.AnnouncementTime === "number")
                message.AnnouncementTime = object.AnnouncementTime;
            else if (typeof object.AnnouncementTime === "object")
                message.AnnouncementTime = new $util.LongBits(object.AnnouncementTime.low >>> 0, object.AnnouncementTime.high >>> 0).toNumber(true);
        if (object.Number != null)
            message.Number = object.Number >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPushResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {Desk2TreasureSrvPushResult} message Desk2TreasureSrvPushResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPushResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.TicketCount = 0;
            object.ParticipationID = 0;
            object.Type = 0;
            object.BonusValue = "";
            object.WinnerID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            if (options.bytes === String)
                object.HeadUrl = "";
            else {
                object.HeadUrl = [];
                if (options.bytes !== Array)
                    object.HeadUrl = $util.newBuffer(object.HeadUrl);
            }
            object.WinningTicketCount = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.AnnouncementTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.AnnouncementTime = options.longs === String ? "0" : 0;
            object.Number = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.TicketCount != null && message.hasOwnProperty("TicketCount"))
            object.TicketCount = message.TicketCount;
        if (message.ParticipationID != null && message.hasOwnProperty("ParticipationID"))
            object.ParticipationID = message.ParticipationID;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        if (message.BonusValue != null && message.hasOwnProperty("BonusValue"))
            object.BonusValue = message.BonusValue;
        if (message.WinnerID != null && message.hasOwnProperty("WinnerID"))
            object.WinnerID = message.WinnerID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeadUrl != null && message.hasOwnProperty("HeadUrl"))
            object.HeadUrl = options.bytes === String ? $util.base64.encode(message.HeadUrl, 0, message.HeadUrl.length) : options.bytes === Array ? Array.prototype.slice.call(message.HeadUrl) : message.HeadUrl;
        if (message.WinningTicketCount != null && message.hasOwnProperty("WinningTicketCount"))
            object.WinningTicketCount = message.WinningTicketCount;
        if (message.AnnouncementTime != null && message.hasOwnProperty("AnnouncementTime"))
            if (typeof message.AnnouncementTime === "number")
                object.AnnouncementTime = options.longs === String ? String(message.AnnouncementTime) : message.AnnouncementTime;
            else
                object.AnnouncementTime = options.longs === String ? $util.Long.prototype.toString.call(message.AnnouncementTime) : options.longs === Number ? new $util.LongBits(message.AnnouncementTime.low >>> 0, message.AnnouncementTime.high >>> 0).toNumber(true) : message.AnnouncementTime;
        if (message.Number != null && message.hasOwnProperty("Number"))
            object.Number = message.Number;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPushResult to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPushResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPushResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPushResult
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPushResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPushResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPushResult";
    };

    return Desk2TreasureSrvPushResult;
})();

export const Desk2TreasureSrvPushProductList = $root.Desk2TreasureSrvPushProductList = (() => {

    /**
     * Properties of a Desk2TreasureSrvPushProductList.
     * @exports IDesk2TreasureSrvPushProductList
     * @interface IDesk2TreasureSrvPushProductList
     * @property {number|null} [UserID] Desk2TreasureSrvPushProductList UserID
     * @property {string|null} [ProductList] Desk2TreasureSrvPushProductList ProductList
     */

    /**
     * Constructs a new Desk2TreasureSrvPushProductList.
     * @exports Desk2TreasureSrvPushProductList
     * @classdesc Represents a Desk2TreasureSrvPushProductList.
     * @implements IDesk2TreasureSrvPushProductList
     * @constructor
     * @param {IDesk2TreasureSrvPushProductList=} [properties] Properties to set
     */
    function Desk2TreasureSrvPushProductList(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2TreasureSrvPushProductList UserID.
     * @member {number} UserID
     * @memberof Desk2TreasureSrvPushProductList
     * @instance
     */
    Desk2TreasureSrvPushProductList.prototype.UserID = 0;

    /**
     * Desk2TreasureSrvPushProductList ProductList.
     * @member {string} ProductList
     * @memberof Desk2TreasureSrvPushProductList
     * @instance
     */
    Desk2TreasureSrvPushProductList.prototype.ProductList = "";

    /**
     * Creates a new Desk2TreasureSrvPushProductList instance using the specified properties.
     * @function create
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {IDesk2TreasureSrvPushProductList=} [properties] Properties to set
     * @returns {Desk2TreasureSrvPushProductList} Desk2TreasureSrvPushProductList instance
     */
    Desk2TreasureSrvPushProductList.create = function create(properties) {
        return new Desk2TreasureSrvPushProductList(properties);
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushProductList message. Does not implicitly {@link Desk2TreasureSrvPushProductList.verify|verify} messages.
     * @function encode
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {IDesk2TreasureSrvPushProductList} message Desk2TreasureSrvPushProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushProductList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.ProductList != null && Object.hasOwnProperty.call(message, "ProductList"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ProductList);
        return writer;
    };

    /**
     * Encodes the specified Desk2TreasureSrvPushProductList message, length delimited. Does not implicitly {@link Desk2TreasureSrvPushProductList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {IDesk2TreasureSrvPushProductList} message Desk2TreasureSrvPushProductList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2TreasureSrvPushProductList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2TreasureSrvPushProductList message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2TreasureSrvPushProductList} Desk2TreasureSrvPushProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushProductList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2TreasureSrvPushProductList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.ProductList = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2TreasureSrvPushProductList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2TreasureSrvPushProductList} Desk2TreasureSrvPushProductList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2TreasureSrvPushProductList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2TreasureSrvPushProductList message.
     * @function verify
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2TreasureSrvPushProductList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.ProductList != null && message.hasOwnProperty("ProductList"))
            if (!$util.isString(message.ProductList))
                return "ProductList: string expected";
        return null;
    };

    /**
     * Creates a Desk2TreasureSrvPushProductList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2TreasureSrvPushProductList} Desk2TreasureSrvPushProductList
     */
    Desk2TreasureSrvPushProductList.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2TreasureSrvPushProductList)
            return object;
        let message = new $root.Desk2TreasureSrvPushProductList();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.ProductList != null)
            message.ProductList = String(object.ProductList);
        return message;
    };

    /**
     * Creates a plain object from a Desk2TreasureSrvPushProductList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {Desk2TreasureSrvPushProductList} message Desk2TreasureSrvPushProductList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2TreasureSrvPushProductList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.ProductList = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.ProductList != null && message.hasOwnProperty("ProductList"))
            object.ProductList = message.ProductList;
        return object;
    };

    /**
     * Converts this Desk2TreasureSrvPushProductList to JSON.
     * @function toJSON
     * @memberof Desk2TreasureSrvPushProductList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2TreasureSrvPushProductList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2TreasureSrvPushProductList
     * @function getTypeUrl
     * @memberof Desk2TreasureSrvPushProductList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2TreasureSrvPushProductList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2TreasureSrvPushProductList";
    };

    return Desk2TreasureSrvPushProductList;
})();

export const WheelOfFortureProduct = $root.WheelOfFortureProduct = (() => {

    /**
     * Properties of a WheelOfFortureProduct.
     * @exports IWheelOfFortureProduct
     * @interface IWheelOfFortureProduct
     * @property {number|null} [PID] WheelOfFortureProduct PID
     * @property {number|null} [Mode] WheelOfFortureProduct Mode
     * @property {number|null} [BetSecond] WheelOfFortureProduct BetSecond
     * @property {string|null} [BetList] WheelOfFortureProduct BetList
     * @property {string|null} [ChaalLimit] WheelOfFortureProduct ChaalLimit
     */

    /**
     * Constructs a new WheelOfFortureProduct.
     * @exports WheelOfFortureProduct
     * @classdesc Represents a WheelOfFortureProduct.
     * @implements IWheelOfFortureProduct
     * @constructor
     * @param {IWheelOfFortureProduct=} [properties] Properties to set
     */
    function WheelOfFortureProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureProduct PID.
     * @member {number} PID
     * @memberof WheelOfFortureProduct
     * @instance
     */
    WheelOfFortureProduct.prototype.PID = 0;

    /**
     * WheelOfFortureProduct Mode.
     * @member {number} Mode
     * @memberof WheelOfFortureProduct
     * @instance
     */
    WheelOfFortureProduct.prototype.Mode = 0;

    /**
     * WheelOfFortureProduct BetSecond.
     * @member {number} BetSecond
     * @memberof WheelOfFortureProduct
     * @instance
     */
    WheelOfFortureProduct.prototype.BetSecond = 0;

    /**
     * WheelOfFortureProduct BetList.
     * @member {string} BetList
     * @memberof WheelOfFortureProduct
     * @instance
     */
    WheelOfFortureProduct.prototype.BetList = "";

    /**
     * WheelOfFortureProduct ChaalLimit.
     * @member {string} ChaalLimit
     * @memberof WheelOfFortureProduct
     * @instance
     */
    WheelOfFortureProduct.prototype.ChaalLimit = "";

    /**
     * Creates a new WheelOfFortureProduct instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureProduct
     * @static
     * @param {IWheelOfFortureProduct=} [properties] Properties to set
     * @returns {WheelOfFortureProduct} WheelOfFortureProduct instance
     */
    WheelOfFortureProduct.create = function create(properties) {
        return new WheelOfFortureProduct(properties);
    };

    /**
     * Encodes the specified WheelOfFortureProduct message. Does not implicitly {@link WheelOfFortureProduct.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureProduct
     * @static
     * @param {IWheelOfFortureProduct} message WheelOfFortureProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetSecond != null && Object.hasOwnProperty.call(message, "BetSecond"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetSecond);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BetList);
        if (message.ChaalLimit != null && Object.hasOwnProperty.call(message, "ChaalLimit"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ChaalLimit);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureProduct message, length delimited. Does not implicitly {@link WheelOfFortureProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureProduct
     * @static
     * @param {IWheelOfFortureProduct} message WheelOfFortureProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureProduct message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureProduct} WheelOfFortureProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetSecond = reader.uint32();
                    break;
                }
            case 4: {
                    message.BetList = reader.string();
                    break;
                }
            case 5: {
                    message.ChaalLimit = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureProduct} WheelOfFortureProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureProduct message.
     * @function verify
     * @memberof WheelOfFortureProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetSecond != null && message.hasOwnProperty("BetSecond"))
            if (!$util.isInteger(message.BetSecond))
                return "BetSecond: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            if (!$util.isString(message.ChaalLimit))
                return "ChaalLimit: string expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureProduct} WheelOfFortureProduct
     */
    WheelOfFortureProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureProduct)
            return object;
        let message = new $root.WheelOfFortureProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetSecond != null)
            message.BetSecond = object.BetSecond >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.ChaalLimit != null)
            message.ChaalLimit = String(object.ChaalLimit);
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureProduct
     * @static
     * @param {WheelOfFortureProduct} message WheelOfFortureProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetSecond = 0;
            object.BetList = "";
            object.ChaalLimit = "";
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetSecond != null && message.hasOwnProperty("BetSecond"))
            object.BetSecond = message.BetSecond;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.ChaalLimit != null && message.hasOwnProperty("ChaalLimit"))
            object.ChaalLimit = message.ChaalLimit;
        return object;
    };

    /**
     * Converts this WheelOfFortureProduct to JSON.
     * @function toJSON
     * @memberof WheelOfFortureProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureProduct
     * @function getTypeUrl
     * @memberof WheelOfFortureProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureProduct";
    };

    return WheelOfFortureProduct;
})();

export const WheelOfFortureSrvToDeskPushAssetInfo = $root.WheelOfFortureSrvToDeskPushAssetInfo = (() => {

    /**
     * Properties of a WheelOfFortureSrvToDeskPushAssetInfo.
     * @exports IWheelOfFortureSrvToDeskPushAssetInfo
     * @interface IWheelOfFortureSrvToDeskPushAssetInfo
     * @property {number|null} [Reason] WheelOfFortureSrvToDeskPushAssetInfo Reason
     * @property {number|null} [UserID] WheelOfFortureSrvToDeskPushAssetInfo UserID
     * @property {number|null} [OwnerID] WheelOfFortureSrvToDeskPushAssetInfo OwnerID
     * @property {string|null} [Chip] WheelOfFortureSrvToDeskPushAssetInfo Chip
     */

    /**
     * Constructs a new WheelOfFortureSrvToDeskPushAssetInfo.
     * @exports WheelOfFortureSrvToDeskPushAssetInfo
     * @classdesc Represents a WheelOfFortureSrvToDeskPushAssetInfo.
     * @implements IWheelOfFortureSrvToDeskPushAssetInfo
     * @constructor
     * @param {IWheelOfFortureSrvToDeskPushAssetInfo=} [properties] Properties to set
     */
    function WheelOfFortureSrvToDeskPushAssetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureSrvToDeskPushAssetInfo Reason.
     * @member {number} Reason
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushAssetInfo.prototype.Reason = 0;

    /**
     * WheelOfFortureSrvToDeskPushAssetInfo UserID.
     * @member {number} UserID
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushAssetInfo.prototype.UserID = 0;

    /**
     * WheelOfFortureSrvToDeskPushAssetInfo OwnerID.
     * @member {number} OwnerID
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushAssetInfo.prototype.OwnerID = 0;

    /**
     * WheelOfFortureSrvToDeskPushAssetInfo Chip.
     * @member {string} Chip
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushAssetInfo.prototype.Chip = "";

    /**
     * Creates a new WheelOfFortureSrvToDeskPushAssetInfo instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushAssetInfo=} [properties] Properties to set
     * @returns {WheelOfFortureSrvToDeskPushAssetInfo} WheelOfFortureSrvToDeskPushAssetInfo instance
     */
    WheelOfFortureSrvToDeskPushAssetInfo.create = function create(properties) {
        return new WheelOfFortureSrvToDeskPushAssetInfo(properties);
    };

    /**
     * Encodes the specified WheelOfFortureSrvToDeskPushAssetInfo message. Does not implicitly {@link WheelOfFortureSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushAssetInfo} message WheelOfFortureSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureSrvToDeskPushAssetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.OwnerID != null && Object.hasOwnProperty.call(message, "OwnerID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.OwnerID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureSrvToDeskPushAssetInfo message, length delimited. Does not implicitly {@link WheelOfFortureSrvToDeskPushAssetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushAssetInfo} message WheelOfFortureSrvToDeskPushAssetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureSrvToDeskPushAssetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureSrvToDeskPushAssetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureSrvToDeskPushAssetInfo} WheelOfFortureSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureSrvToDeskPushAssetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureSrvToDeskPushAssetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Reason = reader.int32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.OwnerID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureSrvToDeskPushAssetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureSrvToDeskPushAssetInfo} WheelOfFortureSrvToDeskPushAssetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureSrvToDeskPushAssetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureSrvToDeskPushAssetInfo message.
     * @function verify
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureSrvToDeskPushAssetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isInteger(message.Reason))
                return "Reason: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            if (!$util.isInteger(message.OwnerID))
                return "OwnerID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureSrvToDeskPushAssetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureSrvToDeskPushAssetInfo} WheelOfFortureSrvToDeskPushAssetInfo
     */
    WheelOfFortureSrvToDeskPushAssetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureSrvToDeskPushAssetInfo)
            return object;
        let message = new $root.WheelOfFortureSrvToDeskPushAssetInfo();
        if (object.Reason != null)
            message.Reason = object.Reason | 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.OwnerID != null)
            message.OwnerID = object.OwnerID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureSrvToDeskPushAssetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {WheelOfFortureSrvToDeskPushAssetInfo} message WheelOfFortureSrvToDeskPushAssetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureSrvToDeskPushAssetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Reason = 0;
            object.UserID = 0;
            object.OwnerID = 0;
            object.Chip = "";
        }
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.OwnerID != null && message.hasOwnProperty("OwnerID"))
            object.OwnerID = message.OwnerID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this WheelOfFortureSrvToDeskPushAssetInfo to JSON.
     * @function toJSON
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureSrvToDeskPushAssetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureSrvToDeskPushAssetInfo
     * @function getTypeUrl
     * @memberof WheelOfFortureSrvToDeskPushAssetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureSrvToDeskPushAssetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureSrvToDeskPushAssetInfo";
    };

    return WheelOfFortureSrvToDeskPushAssetInfo;
})();

export const WheelOfFortureSrvToDeskPushDeskInfo = $root.WheelOfFortureSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a WheelOfFortureSrvToDeskPushDeskInfo.
     * @exports IWheelOfFortureSrvToDeskPushDeskInfo
     * @interface IWheelOfFortureSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] WheelOfFortureSrvToDeskPushDeskInfo UserID
     * @property {IWheelOfFortureProduct|null} [Product] WheelOfFortureSrvToDeskPushDeskInfo Product
     * @property {string|null} [Tax] WheelOfFortureSrvToDeskPushDeskInfo Tax
     */

    /**
     * Constructs a new WheelOfFortureSrvToDeskPushDeskInfo.
     * @exports WheelOfFortureSrvToDeskPushDeskInfo
     * @classdesc Represents a WheelOfFortureSrvToDeskPushDeskInfo.
     * @implements IWheelOfFortureSrvToDeskPushDeskInfo
     * @constructor
     * @param {IWheelOfFortureSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function WheelOfFortureSrvToDeskPushDeskInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * WheelOfFortureSrvToDeskPushDeskInfo Product.
     * @member {IWheelOfFortureProduct|null|undefined} Product
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * WheelOfFortureSrvToDeskPushDeskInfo Tax.
     * @member {string} Tax
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @instance
     */
    WheelOfFortureSrvToDeskPushDeskInfo.prototype.Tax = "";

    /**
     * Creates a new WheelOfFortureSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {WheelOfFortureSrvToDeskPushDeskInfo} WheelOfFortureSrvToDeskPushDeskInfo instance
     */
    WheelOfFortureSrvToDeskPushDeskInfo.create = function create(properties) {
        return new WheelOfFortureSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified WheelOfFortureSrvToDeskPushDeskInfo message. Does not implicitly {@link WheelOfFortureSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushDeskInfo} message WheelOfFortureSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.WheelOfFortureProduct.encode(message.Product, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Tax != null && Object.hasOwnProperty.call(message, "Tax"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Tax);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link WheelOfFortureSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {IWheelOfFortureSrvToDeskPushDeskInfo} message WheelOfFortureSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureSrvToDeskPushDeskInfo} WheelOfFortureSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Product = $root.WheelOfFortureProduct.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.Tax = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureSrvToDeskPushDeskInfo} WheelOfFortureSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.WheelOfFortureProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            if (!$util.isString(message.Tax))
                return "Tax: string expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureSrvToDeskPushDeskInfo} WheelOfFortureSrvToDeskPushDeskInfo
     */
    WheelOfFortureSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.WheelOfFortureSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".WheelOfFortureSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.WheelOfFortureProduct.fromObject(object.Product);
        }
        if (object.Tax != null)
            message.Tax = String(object.Tax);
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {WheelOfFortureSrvToDeskPushDeskInfo} message WheelOfFortureSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Product = null;
            object.Tax = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.WheelOfFortureProduct.toObject(message.Product, options);
        if (message.Tax != null && message.hasOwnProperty("Tax"))
            object.Tax = message.Tax;
        return object;
    };

    /**
     * Converts this WheelOfFortureSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof WheelOfFortureSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureSrvToDeskPushDeskInfo";
    };

    return WheelOfFortureSrvToDeskPushDeskInfo;
})();

export const WheelOfFortureBetInfo = $root.WheelOfFortureBetInfo = (() => {

    /**
     * Properties of a WheelOfFortureBetInfo.
     * @exports IWheelOfFortureBetInfo
     * @interface IWheelOfFortureBetInfo
     * @property {number|Long|null} [BlueTotalBetChip] WheelOfFortureBetInfo BlueTotalBetChip
     * @property {number|Long|null} [YellowTotalBetChip] WheelOfFortureBetInfo YellowTotalBetChip
     * @property {number|Long|null} [RedTotalBetChip] WheelOfFortureBetInfo RedTotalBetChip
     * @property {number|Long|null} [PlayerBlueTotalChip] WheelOfFortureBetInfo PlayerBlueTotalChip
     * @property {number|Long|null} [PlayerYellowTotalChip] WheelOfFortureBetInfo PlayerYellowTotalChip
     * @property {number|Long|null} [PlayerRedTotalChip] WheelOfFortureBetInfo PlayerRedTotalChip
     */

    /**
     * Constructs a new WheelOfFortureBetInfo.
     * @exports WheelOfFortureBetInfo
     * @classdesc Represents a WheelOfFortureBetInfo.
     * @implements IWheelOfFortureBetInfo
     * @constructor
     * @param {IWheelOfFortureBetInfo=} [properties] Properties to set
     */
    function WheelOfFortureBetInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureBetInfo BlueTotalBetChip.
     * @member {number|Long} BlueTotalBetChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.BlueTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * WheelOfFortureBetInfo YellowTotalBetChip.
     * @member {number|Long} YellowTotalBetChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.YellowTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * WheelOfFortureBetInfo RedTotalBetChip.
     * @member {number|Long} RedTotalBetChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.RedTotalBetChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * WheelOfFortureBetInfo PlayerBlueTotalChip.
     * @member {number|Long} PlayerBlueTotalChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.PlayerBlueTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * WheelOfFortureBetInfo PlayerYellowTotalChip.
     * @member {number|Long} PlayerYellowTotalChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.PlayerYellowTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * WheelOfFortureBetInfo PlayerRedTotalChip.
     * @member {number|Long} PlayerRedTotalChip
     * @memberof WheelOfFortureBetInfo
     * @instance
     */
    WheelOfFortureBetInfo.prototype.PlayerRedTotalChip = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new WheelOfFortureBetInfo instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {IWheelOfFortureBetInfo=} [properties] Properties to set
     * @returns {WheelOfFortureBetInfo} WheelOfFortureBetInfo instance
     */
    WheelOfFortureBetInfo.create = function create(properties) {
        return new WheelOfFortureBetInfo(properties);
    };

    /**
     * Encodes the specified WheelOfFortureBetInfo message. Does not implicitly {@link WheelOfFortureBetInfo.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {IWheelOfFortureBetInfo} message WheelOfFortureBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureBetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BlueTotalBetChip != null && Object.hasOwnProperty.call(message, "BlueTotalBetChip"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.BlueTotalBetChip);
        if (message.YellowTotalBetChip != null && Object.hasOwnProperty.call(message, "YellowTotalBetChip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.YellowTotalBetChip);
        if (message.RedTotalBetChip != null && Object.hasOwnProperty.call(message, "RedTotalBetChip"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.RedTotalBetChip);
        if (message.PlayerBlueTotalChip != null && Object.hasOwnProperty.call(message, "PlayerBlueTotalChip"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.PlayerBlueTotalChip);
        if (message.PlayerYellowTotalChip != null && Object.hasOwnProperty.call(message, "PlayerYellowTotalChip"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.PlayerYellowTotalChip);
        if (message.PlayerRedTotalChip != null && Object.hasOwnProperty.call(message, "PlayerRedTotalChip"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.PlayerRedTotalChip);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureBetInfo message, length delimited. Does not implicitly {@link WheelOfFortureBetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {IWheelOfFortureBetInfo} message WheelOfFortureBetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureBetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureBetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureBetInfo} WheelOfFortureBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureBetInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureBetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BlueTotalBetChip = reader.uint64();
                    break;
                }
            case 2: {
                    message.YellowTotalBetChip = reader.uint64();
                    break;
                }
            case 3: {
                    message.RedTotalBetChip = reader.uint64();
                    break;
                }
            case 4: {
                    message.PlayerBlueTotalChip = reader.uint64();
                    break;
                }
            case 5: {
                    message.PlayerYellowTotalChip = reader.uint64();
                    break;
                }
            case 6: {
                    message.PlayerRedTotalChip = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureBetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureBetInfo} WheelOfFortureBetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureBetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureBetInfo message.
     * @function verify
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureBetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BlueTotalBetChip != null && message.hasOwnProperty("BlueTotalBetChip"))
            if (!$util.isInteger(message.BlueTotalBetChip) && !(message.BlueTotalBetChip && $util.isInteger(message.BlueTotalBetChip.low) && $util.isInteger(message.BlueTotalBetChip.high)))
                return "BlueTotalBetChip: integer|Long expected";
        if (message.YellowTotalBetChip != null && message.hasOwnProperty("YellowTotalBetChip"))
            if (!$util.isInteger(message.YellowTotalBetChip) && !(message.YellowTotalBetChip && $util.isInteger(message.YellowTotalBetChip.low) && $util.isInteger(message.YellowTotalBetChip.high)))
                return "YellowTotalBetChip: integer|Long expected";
        if (message.RedTotalBetChip != null && message.hasOwnProperty("RedTotalBetChip"))
            if (!$util.isInteger(message.RedTotalBetChip) && !(message.RedTotalBetChip && $util.isInteger(message.RedTotalBetChip.low) && $util.isInteger(message.RedTotalBetChip.high)))
                return "RedTotalBetChip: integer|Long expected";
        if (message.PlayerBlueTotalChip != null && message.hasOwnProperty("PlayerBlueTotalChip"))
            if (!$util.isInteger(message.PlayerBlueTotalChip) && !(message.PlayerBlueTotalChip && $util.isInteger(message.PlayerBlueTotalChip.low) && $util.isInteger(message.PlayerBlueTotalChip.high)))
                return "PlayerBlueTotalChip: integer|Long expected";
        if (message.PlayerYellowTotalChip != null && message.hasOwnProperty("PlayerYellowTotalChip"))
            if (!$util.isInteger(message.PlayerYellowTotalChip) && !(message.PlayerYellowTotalChip && $util.isInteger(message.PlayerYellowTotalChip.low) && $util.isInteger(message.PlayerYellowTotalChip.high)))
                return "PlayerYellowTotalChip: integer|Long expected";
        if (message.PlayerRedTotalChip != null && message.hasOwnProperty("PlayerRedTotalChip"))
            if (!$util.isInteger(message.PlayerRedTotalChip) && !(message.PlayerRedTotalChip && $util.isInteger(message.PlayerRedTotalChip.low) && $util.isInteger(message.PlayerRedTotalChip.high)))
                return "PlayerRedTotalChip: integer|Long expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureBetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureBetInfo} WheelOfFortureBetInfo
     */
    WheelOfFortureBetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureBetInfo)
            return object;
        let message = new $root.WheelOfFortureBetInfo();
        if (object.BlueTotalBetChip != null)
            if ($util.Long)
                (message.BlueTotalBetChip = $util.Long.fromValue(object.BlueTotalBetChip)).unsigned = true;
            else if (typeof object.BlueTotalBetChip === "string")
                message.BlueTotalBetChip = parseInt(object.BlueTotalBetChip, 10);
            else if (typeof object.BlueTotalBetChip === "number")
                message.BlueTotalBetChip = object.BlueTotalBetChip;
            else if (typeof object.BlueTotalBetChip === "object")
                message.BlueTotalBetChip = new $util.LongBits(object.BlueTotalBetChip.low >>> 0, object.BlueTotalBetChip.high >>> 0).toNumber(true);
        if (object.YellowTotalBetChip != null)
            if ($util.Long)
                (message.YellowTotalBetChip = $util.Long.fromValue(object.YellowTotalBetChip)).unsigned = true;
            else if (typeof object.YellowTotalBetChip === "string")
                message.YellowTotalBetChip = parseInt(object.YellowTotalBetChip, 10);
            else if (typeof object.YellowTotalBetChip === "number")
                message.YellowTotalBetChip = object.YellowTotalBetChip;
            else if (typeof object.YellowTotalBetChip === "object")
                message.YellowTotalBetChip = new $util.LongBits(object.YellowTotalBetChip.low >>> 0, object.YellowTotalBetChip.high >>> 0).toNumber(true);
        if (object.RedTotalBetChip != null)
            if ($util.Long)
                (message.RedTotalBetChip = $util.Long.fromValue(object.RedTotalBetChip)).unsigned = true;
            else if (typeof object.RedTotalBetChip === "string")
                message.RedTotalBetChip = parseInt(object.RedTotalBetChip, 10);
            else if (typeof object.RedTotalBetChip === "number")
                message.RedTotalBetChip = object.RedTotalBetChip;
            else if (typeof object.RedTotalBetChip === "object")
                message.RedTotalBetChip = new $util.LongBits(object.RedTotalBetChip.low >>> 0, object.RedTotalBetChip.high >>> 0).toNumber(true);
        if (object.PlayerBlueTotalChip != null)
            if ($util.Long)
                (message.PlayerBlueTotalChip = $util.Long.fromValue(object.PlayerBlueTotalChip)).unsigned = true;
            else if (typeof object.PlayerBlueTotalChip === "string")
                message.PlayerBlueTotalChip = parseInt(object.PlayerBlueTotalChip, 10);
            else if (typeof object.PlayerBlueTotalChip === "number")
                message.PlayerBlueTotalChip = object.PlayerBlueTotalChip;
            else if (typeof object.PlayerBlueTotalChip === "object")
                message.PlayerBlueTotalChip = new $util.LongBits(object.PlayerBlueTotalChip.low >>> 0, object.PlayerBlueTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerYellowTotalChip != null)
            if ($util.Long)
                (message.PlayerYellowTotalChip = $util.Long.fromValue(object.PlayerYellowTotalChip)).unsigned = true;
            else if (typeof object.PlayerYellowTotalChip === "string")
                message.PlayerYellowTotalChip = parseInt(object.PlayerYellowTotalChip, 10);
            else if (typeof object.PlayerYellowTotalChip === "number")
                message.PlayerYellowTotalChip = object.PlayerYellowTotalChip;
            else if (typeof object.PlayerYellowTotalChip === "object")
                message.PlayerYellowTotalChip = new $util.LongBits(object.PlayerYellowTotalChip.low >>> 0, object.PlayerYellowTotalChip.high >>> 0).toNumber(true);
        if (object.PlayerRedTotalChip != null)
            if ($util.Long)
                (message.PlayerRedTotalChip = $util.Long.fromValue(object.PlayerRedTotalChip)).unsigned = true;
            else if (typeof object.PlayerRedTotalChip === "string")
                message.PlayerRedTotalChip = parseInt(object.PlayerRedTotalChip, 10);
            else if (typeof object.PlayerRedTotalChip === "number")
                message.PlayerRedTotalChip = object.PlayerRedTotalChip;
            else if (typeof object.PlayerRedTotalChip === "object")
                message.PlayerRedTotalChip = new $util.LongBits(object.PlayerRedTotalChip.low >>> 0, object.PlayerRedTotalChip.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureBetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {WheelOfFortureBetInfo} message WheelOfFortureBetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureBetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.BlueTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BlueTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.YellowTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.YellowTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.RedTotalBetChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.RedTotalBetChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerBlueTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerBlueTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerYellowTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerYellowTotalChip = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerRedTotalChip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerRedTotalChip = options.longs === String ? "0" : 0;
        }
        if (message.BlueTotalBetChip != null && message.hasOwnProperty("BlueTotalBetChip"))
            if (typeof message.BlueTotalBetChip === "number")
                object.BlueTotalBetChip = options.longs === String ? String(message.BlueTotalBetChip) : message.BlueTotalBetChip;
            else
                object.BlueTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.BlueTotalBetChip) : options.longs === Number ? new $util.LongBits(message.BlueTotalBetChip.low >>> 0, message.BlueTotalBetChip.high >>> 0).toNumber(true) : message.BlueTotalBetChip;
        if (message.YellowTotalBetChip != null && message.hasOwnProperty("YellowTotalBetChip"))
            if (typeof message.YellowTotalBetChip === "number")
                object.YellowTotalBetChip = options.longs === String ? String(message.YellowTotalBetChip) : message.YellowTotalBetChip;
            else
                object.YellowTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.YellowTotalBetChip) : options.longs === Number ? new $util.LongBits(message.YellowTotalBetChip.low >>> 0, message.YellowTotalBetChip.high >>> 0).toNumber(true) : message.YellowTotalBetChip;
        if (message.RedTotalBetChip != null && message.hasOwnProperty("RedTotalBetChip"))
            if (typeof message.RedTotalBetChip === "number")
                object.RedTotalBetChip = options.longs === String ? String(message.RedTotalBetChip) : message.RedTotalBetChip;
            else
                object.RedTotalBetChip = options.longs === String ? $util.Long.prototype.toString.call(message.RedTotalBetChip) : options.longs === Number ? new $util.LongBits(message.RedTotalBetChip.low >>> 0, message.RedTotalBetChip.high >>> 0).toNumber(true) : message.RedTotalBetChip;
        if (message.PlayerBlueTotalChip != null && message.hasOwnProperty("PlayerBlueTotalChip"))
            if (typeof message.PlayerBlueTotalChip === "number")
                object.PlayerBlueTotalChip = options.longs === String ? String(message.PlayerBlueTotalChip) : message.PlayerBlueTotalChip;
            else
                object.PlayerBlueTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerBlueTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerBlueTotalChip.low >>> 0, message.PlayerBlueTotalChip.high >>> 0).toNumber(true) : message.PlayerBlueTotalChip;
        if (message.PlayerYellowTotalChip != null && message.hasOwnProperty("PlayerYellowTotalChip"))
            if (typeof message.PlayerYellowTotalChip === "number")
                object.PlayerYellowTotalChip = options.longs === String ? String(message.PlayerYellowTotalChip) : message.PlayerYellowTotalChip;
            else
                object.PlayerYellowTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerYellowTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerYellowTotalChip.low >>> 0, message.PlayerYellowTotalChip.high >>> 0).toNumber(true) : message.PlayerYellowTotalChip;
        if (message.PlayerRedTotalChip != null && message.hasOwnProperty("PlayerRedTotalChip"))
            if (typeof message.PlayerRedTotalChip === "number")
                object.PlayerRedTotalChip = options.longs === String ? String(message.PlayerRedTotalChip) : message.PlayerRedTotalChip;
            else
                object.PlayerRedTotalChip = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerRedTotalChip) : options.longs === Number ? new $util.LongBits(message.PlayerRedTotalChip.low >>> 0, message.PlayerRedTotalChip.high >>> 0).toNumber(true) : message.PlayerRedTotalChip;
        return object;
    };

    /**
     * Converts this WheelOfFortureBetInfo to JSON.
     * @function toJSON
     * @memberof WheelOfFortureBetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureBetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureBetInfo
     * @function getTypeUrl
     * @memberof WheelOfFortureBetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureBetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureBetInfo";
    };

    return WheelOfFortureBetInfo;
})();

export const Desk2WheelOfFortureSrvPushPlayingInfo = $root.Desk2WheelOfFortureSrvPushPlayingInfo = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushPlayingInfo.
     * @exports IDesk2WheelOfFortureSrvPushPlayingInfo
     * @interface IDesk2WheelOfFortureSrvPushPlayingInfo
     * @property {number|null} [UserID] Desk2WheelOfFortureSrvPushPlayingInfo UserID
     * @property {number|null} [StateID] Desk2WheelOfFortureSrvPushPlayingInfo StateID
     * @property {Array.<number>|null} [GamingIDs] Desk2WheelOfFortureSrvPushPlayingInfo GamingIDs
     * @property {Array.<number>|null} [PlayerBetIDs] Desk2WheelOfFortureSrvPushPlayingInfo PlayerBetIDs
     * @property {IWheelOfFortureBetInfo|null} [RoundBetInfo] Desk2WheelOfFortureSrvPushPlayingInfo RoundBetInfo
     * @property {number|null} [PointResult] Desk2WheelOfFortureSrvPushPlayingInfo PointResult
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushPlayingInfo.
     * @exports Desk2WheelOfFortureSrvPushPlayingInfo
     * @classdesc Represents a Desk2WheelOfFortureSrvPushPlayingInfo.
     * @implements IDesk2WheelOfFortureSrvPushPlayingInfo
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushPlayingInfo=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushPlayingInfo(properties) {
        this.GamingIDs = [];
        this.PlayerBetIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo UserID.
     * @member {number} UserID
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.UserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo StateID.
     * @member {number} StateID
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.StateID = 0;

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo GamingIDs.
     * @member {Array.<number>} GamingIDs
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.GamingIDs = $util.emptyArray;

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo PlayerBetIDs.
     * @member {Array.<number>} PlayerBetIDs
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.PlayerBetIDs = $util.emptyArray;

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo RoundBetInfo.
     * @member {IWheelOfFortureBetInfo|null|undefined} RoundBetInfo
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.RoundBetInfo = null;

    /**
     * Desk2WheelOfFortureSrvPushPlayingInfo PointResult.
     * @member {number} PointResult
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.PointResult = 0;

    /**
     * Creates a new Desk2WheelOfFortureSrvPushPlayingInfo instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {IDesk2WheelOfFortureSrvPushPlayingInfo=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushPlayingInfo} Desk2WheelOfFortureSrvPushPlayingInfo instance
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushPlayingInfo(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushPlayingInfo message. Does not implicitly {@link Desk2WheelOfFortureSrvPushPlayingInfo.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {IDesk2WheelOfFortureSrvPushPlayingInfo} message Desk2WheelOfFortureSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StateID != null && Object.hasOwnProperty.call(message, "StateID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StateID);
        if (message.GamingIDs != null && message.GamingIDs.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.GamingIDs.length; ++i)
                writer.uint32(message.GamingIDs[i]);
            writer.ldelim();
        }
        if (message.PlayerBetIDs != null && message.PlayerBetIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                writer.uint32(message.PlayerBetIDs[i]);
            writer.ldelim();
        }
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.WheelOfFortureBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.PointResult != null && Object.hasOwnProperty.call(message, "PointResult"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.PointResult);
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushPlayingInfo message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushPlayingInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {IDesk2WheelOfFortureSrvPushPlayingInfo} message Desk2WheelOfFortureSrvPushPlayingInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushPlayingInfo message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushPlayingInfo} Desk2WheelOfFortureSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushPlayingInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StateID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.GamingIDs && message.GamingIDs.length))
                        message.GamingIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GamingIDs.push(reader.uint32());
                    } else
                        message.GamingIDs.push(reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.PlayerBetIDs && message.PlayerBetIDs.length))
                        message.PlayerBetIDs = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.PlayerBetIDs.push(reader.uint32());
                    } else
                        message.PlayerBetIDs.push(reader.uint32());
                    break;
                }
            case 5: {
                    message.RoundBetInfo = $root.WheelOfFortureBetInfo.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.PointResult = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushPlayingInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushPlayingInfo} Desk2WheelOfFortureSrvPushPlayingInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushPlayingInfo message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            if (!$util.isInteger(message.StateID))
                return "StateID: integer expected";
        if (message.GamingIDs != null && message.hasOwnProperty("GamingIDs")) {
            if (!Array.isArray(message.GamingIDs))
                return "GamingIDs: array expected";
            for (let i = 0; i < message.GamingIDs.length; ++i)
                if (!$util.isInteger(message.GamingIDs[i]))
                    return "GamingIDs: integer[] expected";
        }
        if (message.PlayerBetIDs != null && message.hasOwnProperty("PlayerBetIDs")) {
            if (!Array.isArray(message.PlayerBetIDs))
                return "PlayerBetIDs: array expected";
            for (let i = 0; i < message.PlayerBetIDs.length; ++i)
                if (!$util.isInteger(message.PlayerBetIDs[i]))
                    return "PlayerBetIDs: integer[] expected";
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.WheelOfFortureBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        if (message.PointResult != null && message.hasOwnProperty("PointResult"))
            if (!$util.isInteger(message.PointResult))
                return "PointResult: integer expected";
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushPlayingInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushPlayingInfo} Desk2WheelOfFortureSrvPushPlayingInfo
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushPlayingInfo)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushPlayingInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StateID != null)
            message.StateID = object.StateID >>> 0;
        if (object.GamingIDs) {
            if (!Array.isArray(object.GamingIDs))
                throw TypeError(".Desk2WheelOfFortureSrvPushPlayingInfo.GamingIDs: array expected");
            message.GamingIDs = [];
            for (let i = 0; i < object.GamingIDs.length; ++i)
                message.GamingIDs[i] = object.GamingIDs[i] >>> 0;
        }
        if (object.PlayerBetIDs) {
            if (!Array.isArray(object.PlayerBetIDs))
                throw TypeError(".Desk2WheelOfFortureSrvPushPlayingInfo.PlayerBetIDs: array expected");
            message.PlayerBetIDs = [];
            for (let i = 0; i < object.PlayerBetIDs.length; ++i)
                message.PlayerBetIDs[i] = object.PlayerBetIDs[i] >>> 0;
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Desk2WheelOfFortureSrvPushPlayingInfo.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.WheelOfFortureBetInfo.fromObject(object.RoundBetInfo);
        }
        if (object.PointResult != null)
            message.PointResult = object.PointResult >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushPlayingInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {Desk2WheelOfFortureSrvPushPlayingInfo} message Desk2WheelOfFortureSrvPushPlayingInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.GamingIDs = [];
            object.PlayerBetIDs = [];
        }
        if (options.defaults) {
            object.UserID = 0;
            object.StateID = 0;
            object.RoundBetInfo = null;
            object.PointResult = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StateID != null && message.hasOwnProperty("StateID"))
            object.StateID = message.StateID;
        if (message.GamingIDs && message.GamingIDs.length) {
            object.GamingIDs = [];
            for (let j = 0; j < message.GamingIDs.length; ++j)
                object.GamingIDs[j] = message.GamingIDs[j];
        }
        if (message.PlayerBetIDs && message.PlayerBetIDs.length) {
            object.PlayerBetIDs = [];
            for (let j = 0; j < message.PlayerBetIDs.length; ++j)
                object.PlayerBetIDs[j] = message.PlayerBetIDs[j];
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.WheelOfFortureBetInfo.toObject(message.RoundBetInfo, options);
        if (message.PointResult != null && message.hasOwnProperty("PointResult"))
            object.PointResult = message.PointResult;
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushPlayingInfo to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushPlayingInfo
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushPlayingInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushPlayingInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushPlayingInfo";
    };

    return Desk2WheelOfFortureSrvPushPlayingInfo;
})();

/**
 * WheelOfFortureBetType enum.
 * @exports WheelOfFortureBetType
 * @enum {number}
 * @property {number} Bet_Type_NULL=0 Bet_Type_NULL value
 * @property {number} Bet_Type_Blue=1 Bet_Type_Blue value
 * @property {number} Bet_Type_Yellow=2 Bet_Type_Yellow value
 * @property {number} Bet_Type_Red=3 Bet_Type_Red value
 */
export const WheelOfFortureBetType = $root.WheelOfFortureBetType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bet_Type_NULL"] = 0;
    values[valuesById[1] = "Bet_Type_Blue"] = 1;
    values[valuesById[2] = "Bet_Type_Yellow"] = 2;
    values[valuesById[3] = "Bet_Type_Red"] = 3;
    return values;
})();

export const PlayerWheelOfFortureBet = $root.PlayerWheelOfFortureBet = (() => {

    /**
     * Properties of a PlayerWheelOfFortureBet.
     * @exports IPlayerWheelOfFortureBet
     * @interface IPlayerWheelOfFortureBet
     * @property {number|null} [BetType] PlayerWheelOfFortureBet BetType
     * @property {number|null} [Chip] PlayerWheelOfFortureBet Chip
     */

    /**
     * Constructs a new PlayerWheelOfFortureBet.
     * @exports PlayerWheelOfFortureBet
     * @classdesc Represents a PlayerWheelOfFortureBet.
     * @implements IPlayerWheelOfFortureBet
     * @constructor
     * @param {IPlayerWheelOfFortureBet=} [properties] Properties to set
     */
    function PlayerWheelOfFortureBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlayerWheelOfFortureBet BetType.
     * @member {number} BetType
     * @memberof PlayerWheelOfFortureBet
     * @instance
     */
    PlayerWheelOfFortureBet.prototype.BetType = 0;

    /**
     * PlayerWheelOfFortureBet Chip.
     * @member {number} Chip
     * @memberof PlayerWheelOfFortureBet
     * @instance
     */
    PlayerWheelOfFortureBet.prototype.Chip = 0;

    /**
     * Creates a new PlayerWheelOfFortureBet instance using the specified properties.
     * @function create
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {IPlayerWheelOfFortureBet=} [properties] Properties to set
     * @returns {PlayerWheelOfFortureBet} PlayerWheelOfFortureBet instance
     */
    PlayerWheelOfFortureBet.create = function create(properties) {
        return new PlayerWheelOfFortureBet(properties);
    };

    /**
     * Encodes the specified PlayerWheelOfFortureBet message. Does not implicitly {@link PlayerWheelOfFortureBet.verify|verify} messages.
     * @function encode
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {IPlayerWheelOfFortureBet} message PlayerWheelOfFortureBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerWheelOfFortureBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.BetType);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Chip);
        return writer;
    };

    /**
     * Encodes the specified PlayerWheelOfFortureBet message, length delimited. Does not implicitly {@link PlayerWheelOfFortureBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {IPlayerWheelOfFortureBet} message PlayerWheelOfFortureBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlayerWheelOfFortureBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlayerWheelOfFortureBet message from the specified reader or buffer.
     * @function decode
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlayerWheelOfFortureBet} PlayerWheelOfFortureBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerWheelOfFortureBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlayerWheelOfFortureBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.BetType = reader.uint32();
                    break;
                }
            case 2: {
                    message.Chip = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlayerWheelOfFortureBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlayerWheelOfFortureBet} PlayerWheelOfFortureBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlayerWheelOfFortureBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlayerWheelOfFortureBet message.
     * @function verify
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlayerWheelOfFortureBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isInteger(message.Chip))
                return "Chip: integer expected";
        return null;
    };

    /**
     * Creates a PlayerWheelOfFortureBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlayerWheelOfFortureBet} PlayerWheelOfFortureBet
     */
    PlayerWheelOfFortureBet.fromObject = function fromObject(object) {
        if (object instanceof $root.PlayerWheelOfFortureBet)
            return object;
        let message = new $root.PlayerWheelOfFortureBet();
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        if (object.Chip != null)
            message.Chip = object.Chip >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a PlayerWheelOfFortureBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {PlayerWheelOfFortureBet} message PlayerWheelOfFortureBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlayerWheelOfFortureBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.BetType = 0;
            object.Chip = 0;
        }
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        return object;
    };

    /**
     * Converts this PlayerWheelOfFortureBet to JSON.
     * @function toJSON
     * @memberof PlayerWheelOfFortureBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlayerWheelOfFortureBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PlayerWheelOfFortureBet
     * @function getTypeUrl
     * @memberof PlayerWheelOfFortureBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PlayerWheelOfFortureBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PlayerWheelOfFortureBet";
    };

    return PlayerWheelOfFortureBet;
})();

export const Client2WheelOfFortureSrvReqBet = $root.Client2WheelOfFortureSrvReqBet = (() => {

    /**
     * Properties of a Client2WheelOfFortureSrvReqBet.
     * @exports IClient2WheelOfFortureSrvReqBet
     * @interface IClient2WheelOfFortureSrvReqBet
     * @property {number|null} [DeskNo] Client2WheelOfFortureSrvReqBet DeskNo
     * @property {number|null} [UserID] Client2WheelOfFortureSrvReqBet UserID
     * @property {number|null} [SeatNo] Client2WheelOfFortureSrvReqBet SeatNo
     * @property {Array.<IPlayerWheelOfFortureBet>|null} [BetList] Client2WheelOfFortureSrvReqBet BetList
     */

    /**
     * Constructs a new Client2WheelOfFortureSrvReqBet.
     * @exports Client2WheelOfFortureSrvReqBet
     * @classdesc Represents a Client2WheelOfFortureSrvReqBet.
     * @implements IClient2WheelOfFortureSrvReqBet
     * @constructor
     * @param {IClient2WheelOfFortureSrvReqBet=} [properties] Properties to set
     */
    function Client2WheelOfFortureSrvReqBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2WheelOfFortureSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2WheelOfFortureSrvReqBet
     * @instance
     */
    Client2WheelOfFortureSrvReqBet.prototype.DeskNo = 0;

    /**
     * Client2WheelOfFortureSrvReqBet UserID.
     * @member {number} UserID
     * @memberof Client2WheelOfFortureSrvReqBet
     * @instance
     */
    Client2WheelOfFortureSrvReqBet.prototype.UserID = 0;

    /**
     * Client2WheelOfFortureSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2WheelOfFortureSrvReqBet
     * @instance
     */
    Client2WheelOfFortureSrvReqBet.prototype.SeatNo = 0;

    /**
     * Client2WheelOfFortureSrvReqBet BetList.
     * @member {Array.<IPlayerWheelOfFortureBet>} BetList
     * @memberof Client2WheelOfFortureSrvReqBet
     * @instance
     */
    Client2WheelOfFortureSrvReqBet.prototype.BetList = $util.emptyArray;

    /**
     * Creates a new Client2WheelOfFortureSrvReqBet instance using the specified properties.
     * @function create
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {IClient2WheelOfFortureSrvReqBet=} [properties] Properties to set
     * @returns {Client2WheelOfFortureSrvReqBet} Client2WheelOfFortureSrvReqBet instance
     */
    Client2WheelOfFortureSrvReqBet.create = function create(properties) {
        return new Client2WheelOfFortureSrvReqBet(properties);
    };

    /**
     * Encodes the specified Client2WheelOfFortureSrvReqBet message. Does not implicitly {@link Client2WheelOfFortureSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {IClient2WheelOfFortureSrvReqBet} message Client2WheelOfFortureSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2WheelOfFortureSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerWheelOfFortureBet.encode(message.BetList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2WheelOfFortureSrvReqBet message, length delimited. Does not implicitly {@link Client2WheelOfFortureSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {IClient2WheelOfFortureSrvReqBet} message Client2WheelOfFortureSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2WheelOfFortureSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2WheelOfFortureSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2WheelOfFortureSrvReqBet} Client2WheelOfFortureSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2WheelOfFortureSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2WheelOfFortureSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerWheelOfFortureBet.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2WheelOfFortureSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2WheelOfFortureSrvReqBet} Client2WheelOfFortureSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2WheelOfFortureSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2WheelOfFortureSrvReqBet message.
     * @function verify
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2WheelOfFortureSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerWheelOfFortureBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Client2WheelOfFortureSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2WheelOfFortureSrvReqBet} Client2WheelOfFortureSrvReqBet
     */
    Client2WheelOfFortureSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2WheelOfFortureSrvReqBet)
            return object;
        let message = new $root.Client2WheelOfFortureSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2WheelOfFortureSrvReqBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2WheelOfFortureSrvReqBet.BetList: object expected");
                message.BetList[i] = $root.PlayerWheelOfFortureBet.fromObject(object.BetList[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2WheelOfFortureSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {Client2WheelOfFortureSrvReqBet} message Client2WheelOfFortureSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2WheelOfFortureSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerWheelOfFortureBet.toObject(message.BetList[j], options);
        }
        return object;
    };

    /**
     * Converts this Client2WheelOfFortureSrvReqBet to JSON.
     * @function toJSON
     * @memberof Client2WheelOfFortureSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2WheelOfFortureSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2WheelOfFortureSrvReqBet
     * @function getTypeUrl
     * @memberof Client2WheelOfFortureSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2WheelOfFortureSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2WheelOfFortureSrvReqBet";
    };

    return Client2WheelOfFortureSrvReqBet;
})();

export const Client2WheelOfFortureSrvAckBet = $root.Client2WheelOfFortureSrvAckBet = (() => {

    /**
     * Properties of a Client2WheelOfFortureSrvAckBet.
     * @exports IClient2WheelOfFortureSrvAckBet
     * @interface IClient2WheelOfFortureSrvAckBet
     * @property {number|null} [Ret] Client2WheelOfFortureSrvAckBet Ret
     * @property {number|null} [DeskNo] Client2WheelOfFortureSrvAckBet DeskNo
     * @property {number|null} [UserID] Client2WheelOfFortureSrvAckBet UserID
     * @property {string|null} [Chip] Client2WheelOfFortureSrvAckBet Chip
     * @property {number|null} [SeatNo] Client2WheelOfFortureSrvAckBet SeatNo
     * @property {Array.<IPlayerWheelOfFortureBet>|null} [BetList] Client2WheelOfFortureSrvAckBet BetList
     * @property {IWheelOfFortureBetInfo|null} [RoundBetInfo] Client2WheelOfFortureSrvAckBet RoundBetInfo
     */

    /**
     * Constructs a new Client2WheelOfFortureSrvAckBet.
     * @exports Client2WheelOfFortureSrvAckBet
     * @classdesc Represents a Client2WheelOfFortureSrvAckBet.
     * @implements IClient2WheelOfFortureSrvAckBet
     * @constructor
     * @param {IClient2WheelOfFortureSrvAckBet=} [properties] Properties to set
     */
    function Client2WheelOfFortureSrvAckBet(properties) {
        this.BetList = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Client2WheelOfFortureSrvAckBet Ret.
     * @member {number} Ret
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.Ret = 0;

    /**
     * Client2WheelOfFortureSrvAckBet DeskNo.
     * @member {number} DeskNo
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.DeskNo = 0;

    /**
     * Client2WheelOfFortureSrvAckBet UserID.
     * @member {number} UserID
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.UserID = 0;

    /**
     * Client2WheelOfFortureSrvAckBet Chip.
     * @member {string} Chip
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.Chip = "";

    /**
     * Client2WheelOfFortureSrvAckBet SeatNo.
     * @member {number} SeatNo
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.SeatNo = 0;

    /**
     * Client2WheelOfFortureSrvAckBet BetList.
     * @member {Array.<IPlayerWheelOfFortureBet>} BetList
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.BetList = $util.emptyArray;

    /**
     * Client2WheelOfFortureSrvAckBet RoundBetInfo.
     * @member {IWheelOfFortureBetInfo|null|undefined} RoundBetInfo
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     */
    Client2WheelOfFortureSrvAckBet.prototype.RoundBetInfo = null;

    /**
     * Creates a new Client2WheelOfFortureSrvAckBet instance using the specified properties.
     * @function create
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {IClient2WheelOfFortureSrvAckBet=} [properties] Properties to set
     * @returns {Client2WheelOfFortureSrvAckBet} Client2WheelOfFortureSrvAckBet instance
     */
    Client2WheelOfFortureSrvAckBet.create = function create(properties) {
        return new Client2WheelOfFortureSrvAckBet(properties);
    };

    /**
     * Encodes the specified Client2WheelOfFortureSrvAckBet message. Does not implicitly {@link Client2WheelOfFortureSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {IClient2WheelOfFortureSrvAckBet} message Client2WheelOfFortureSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2WheelOfFortureSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Ret != null && Object.hasOwnProperty.call(message, "Ret"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Ret);
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
        if (message.Chip != null && Object.hasOwnProperty.call(message, "Chip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Chip);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.SeatNo);
        if (message.BetList != null && message.BetList.length)
            for (let i = 0; i < message.BetList.length; ++i)
                $root.PlayerWheelOfFortureBet.encode(message.BetList[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.RoundBetInfo != null && Object.hasOwnProperty.call(message, "RoundBetInfo"))
            $root.WheelOfFortureBetInfo.encode(message.RoundBetInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Client2WheelOfFortureSrvAckBet message, length delimited. Does not implicitly {@link Client2WheelOfFortureSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {IClient2WheelOfFortureSrvAckBet} message Client2WheelOfFortureSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Client2WheelOfFortureSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Client2WheelOfFortureSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Client2WheelOfFortureSrvAckBet} Client2WheelOfFortureSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2WheelOfFortureSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Client2WheelOfFortureSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Ret = reader.uint32();
                    break;
                }
            case 2: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 3: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 4: {
                    message.Chip = reader.string();
                    break;
                }
            case 5: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 6: {
                    if (!(message.BetList && message.BetList.length))
                        message.BetList = [];
                    message.BetList.push($root.PlayerWheelOfFortureBet.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.RoundBetInfo = $root.WheelOfFortureBetInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Client2WheelOfFortureSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Client2WheelOfFortureSrvAckBet} Client2WheelOfFortureSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Client2WheelOfFortureSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Client2WheelOfFortureSrvAckBet message.
     * @function verify
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Client2WheelOfFortureSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            if (!$util.isInteger(message.Ret))
                return "Ret: integer expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            if (!$util.isString(message.Chip))
                return "Chip: string expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList")) {
            if (!Array.isArray(message.BetList))
                return "BetList: array expected";
            for (let i = 0; i < message.BetList.length; ++i) {
                let error = $root.PlayerWheelOfFortureBet.verify(message.BetList[i]);
                if (error)
                    return "BetList." + error;
            }
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo")) {
            let error = $root.WheelOfFortureBetInfo.verify(message.RoundBetInfo);
            if (error)
                return "RoundBetInfo." + error;
        }
        return null;
    };

    /**
     * Creates a Client2WheelOfFortureSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Client2WheelOfFortureSrvAckBet} Client2WheelOfFortureSrvAckBet
     */
    Client2WheelOfFortureSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.Client2WheelOfFortureSrvAckBet)
            return object;
        let message = new $root.Client2WheelOfFortureSrvAckBet();
        if (object.Ret != null)
            message.Ret = object.Ret >>> 0;
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Chip != null)
            message.Chip = String(object.Chip);
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetList) {
            if (!Array.isArray(object.BetList))
                throw TypeError(".Client2WheelOfFortureSrvAckBet.BetList: array expected");
            message.BetList = [];
            for (let i = 0; i < object.BetList.length; ++i) {
                if (typeof object.BetList[i] !== "object")
                    throw TypeError(".Client2WheelOfFortureSrvAckBet.BetList: object expected");
                message.BetList[i] = $root.PlayerWheelOfFortureBet.fromObject(object.BetList[i]);
            }
        }
        if (object.RoundBetInfo != null) {
            if (typeof object.RoundBetInfo !== "object")
                throw TypeError(".Client2WheelOfFortureSrvAckBet.RoundBetInfo: object expected");
            message.RoundBetInfo = $root.WheelOfFortureBetInfo.fromObject(object.RoundBetInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Client2WheelOfFortureSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {Client2WheelOfFortureSrvAckBet} message Client2WheelOfFortureSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Client2WheelOfFortureSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.BetList = [];
        if (options.defaults) {
            object.Ret = 0;
            object.DeskNo = 0;
            object.UserID = 0;
            object.Chip = "";
            object.SeatNo = 0;
            object.RoundBetInfo = null;
        }
        if (message.Ret != null && message.hasOwnProperty("Ret"))
            object.Ret = message.Ret;
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Chip != null && message.hasOwnProperty("Chip"))
            object.Chip = message.Chip;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetList && message.BetList.length) {
            object.BetList = [];
            for (let j = 0; j < message.BetList.length; ++j)
                object.BetList[j] = $root.PlayerWheelOfFortureBet.toObject(message.BetList[j], options);
        }
        if (message.RoundBetInfo != null && message.hasOwnProperty("RoundBetInfo"))
            object.RoundBetInfo = $root.WheelOfFortureBetInfo.toObject(message.RoundBetInfo, options);
        return object;
    };

    /**
     * Converts this Client2WheelOfFortureSrvAckBet to JSON.
     * @function toJSON
     * @memberof Client2WheelOfFortureSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Client2WheelOfFortureSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Client2WheelOfFortureSrvAckBet
     * @function getTypeUrl
     * @memberof Client2WheelOfFortureSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Client2WheelOfFortureSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Client2WheelOfFortureSrvAckBet";
    };

    return Client2WheelOfFortureSrvAckBet;
})();

export const Desk2WheelOfFortureSrvPushGameCard = $root.Desk2WheelOfFortureSrvPushGameCard = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushGameCard.
     * @exports IDesk2WheelOfFortureSrvPushGameCard
     * @interface IDesk2WheelOfFortureSrvPushGameCard
     * @property {number|null} [UserID] Desk2WheelOfFortureSrvPushGameCard UserID
     * @property {number|null} [Result] Desk2WheelOfFortureSrvPushGameCard Result
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushGameCard.
     * @exports Desk2WheelOfFortureSrvPushGameCard
     * @classdesc Represents a Desk2WheelOfFortureSrvPushGameCard.
     * @implements IDesk2WheelOfFortureSrvPushGameCard
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushGameCard=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushGameCard(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushGameCard UserID.
     * @member {number} UserID
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @instance
     */
    Desk2WheelOfFortureSrvPushGameCard.prototype.UserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushGameCard Result.
     * @member {number} Result
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @instance
     */
    Desk2WheelOfFortureSrvPushGameCard.prototype.Result = 0;

    /**
     * Creates a new Desk2WheelOfFortureSrvPushGameCard instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameCard=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushGameCard} Desk2WheelOfFortureSrvPushGameCard instance
     */
    Desk2WheelOfFortureSrvPushGameCard.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushGameCard(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushGameCard message. Does not implicitly {@link Desk2WheelOfFortureSrvPushGameCard.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameCard} message Desk2WheelOfFortureSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushGameCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Result != null && Object.hasOwnProperty.call(message, "Result"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Result);
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushGameCard message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushGameCard.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameCard} message Desk2WheelOfFortureSrvPushGameCard message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushGameCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushGameCard message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushGameCard} Desk2WheelOfFortureSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushGameCard.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushGameCard();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Result = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushGameCard message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushGameCard} Desk2WheelOfFortureSrvPushGameCard
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushGameCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushGameCard message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushGameCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Result != null && message.hasOwnProperty("Result"))
            if (!$util.isInteger(message.Result))
                return "Result: integer expected";
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushGameCard message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushGameCard} Desk2WheelOfFortureSrvPushGameCard
     */
    Desk2WheelOfFortureSrvPushGameCard.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushGameCard)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushGameCard();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Result != null)
            message.Result = object.Result >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushGameCard message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {Desk2WheelOfFortureSrvPushGameCard} message Desk2WheelOfFortureSrvPushGameCard
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushGameCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.Result = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Result != null && message.hasOwnProperty("Result"))
            object.Result = message.Result;
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushGameCard to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushGameCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushGameCard
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushGameCard
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushGameCard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushGameCard";
    };

    return Desk2WheelOfFortureSrvPushGameCard;
})();

export const WheelOfFortureGoldRes = $root.WheelOfFortureGoldRes = (() => {

    /**
     * Properties of a WheelOfFortureGoldRes.
     * @exports IWheelOfFortureGoldRes
     * @interface IWheelOfFortureGoldRes
     * @property {number|null} [UserID] WheelOfFortureGoldRes UserID
     * @property {string|null} [WinGold] WheelOfFortureGoldRes WinGold
     * @property {string|null} [ChangeGold] WheelOfFortureGoldRes ChangeGold
     * @property {string|null} [TotalEnterChip] WheelOfFortureGoldRes TotalEnterChip
     */

    /**
     * Constructs a new WheelOfFortureGoldRes.
     * @exports WheelOfFortureGoldRes
     * @classdesc Represents a WheelOfFortureGoldRes.
     * @implements IWheelOfFortureGoldRes
     * @constructor
     * @param {IWheelOfFortureGoldRes=} [properties] Properties to set
     */
    function WheelOfFortureGoldRes(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureGoldRes UserID.
     * @member {number} UserID
     * @memberof WheelOfFortureGoldRes
     * @instance
     */
    WheelOfFortureGoldRes.prototype.UserID = 0;

    /**
     * WheelOfFortureGoldRes WinGold.
     * @member {string} WinGold
     * @memberof WheelOfFortureGoldRes
     * @instance
     */
    WheelOfFortureGoldRes.prototype.WinGold = "";

    /**
     * WheelOfFortureGoldRes ChangeGold.
     * @member {string} ChangeGold
     * @memberof WheelOfFortureGoldRes
     * @instance
     */
    WheelOfFortureGoldRes.prototype.ChangeGold = "";

    /**
     * WheelOfFortureGoldRes TotalEnterChip.
     * @member {string} TotalEnterChip
     * @memberof WheelOfFortureGoldRes
     * @instance
     */
    WheelOfFortureGoldRes.prototype.TotalEnterChip = "";

    /**
     * Creates a new WheelOfFortureGoldRes instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {IWheelOfFortureGoldRes=} [properties] Properties to set
     * @returns {WheelOfFortureGoldRes} WheelOfFortureGoldRes instance
     */
    WheelOfFortureGoldRes.create = function create(properties) {
        return new WheelOfFortureGoldRes(properties);
    };

    /**
     * Encodes the specified WheelOfFortureGoldRes message. Does not implicitly {@link WheelOfFortureGoldRes.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {IWheelOfFortureGoldRes} message WheelOfFortureGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureGoldRes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.WinGold != null && Object.hasOwnProperty.call(message, "WinGold"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.WinGold);
        if (message.ChangeGold != null && Object.hasOwnProperty.call(message, "ChangeGold"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChangeGold);
        if (message.TotalEnterChip != null && Object.hasOwnProperty.call(message, "TotalEnterChip"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TotalEnterChip);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureGoldRes message, length delimited. Does not implicitly {@link WheelOfFortureGoldRes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {IWheelOfFortureGoldRes} message WheelOfFortureGoldRes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureGoldRes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureGoldRes message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureGoldRes} WheelOfFortureGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureGoldRes.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureGoldRes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.WinGold = reader.string();
                    break;
                }
            case 3: {
                    message.ChangeGold = reader.string();
                    break;
                }
            case 4: {
                    message.TotalEnterChip = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureGoldRes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureGoldRes} WheelOfFortureGoldRes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureGoldRes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureGoldRes message.
     * @function verify
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureGoldRes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            if (!$util.isString(message.WinGold))
                return "WinGold: string expected";
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            if (!$util.isString(message.ChangeGold))
                return "ChangeGold: string expected";
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            if (!$util.isString(message.TotalEnterChip))
                return "TotalEnterChip: string expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureGoldRes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureGoldRes} WheelOfFortureGoldRes
     */
    WheelOfFortureGoldRes.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureGoldRes)
            return object;
        let message = new $root.WheelOfFortureGoldRes();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.WinGold != null)
            message.WinGold = String(object.WinGold);
        if (object.ChangeGold != null)
            message.ChangeGold = String(object.ChangeGold);
        if (object.TotalEnterChip != null)
            message.TotalEnterChip = String(object.TotalEnterChip);
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureGoldRes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {WheelOfFortureGoldRes} message WheelOfFortureGoldRes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureGoldRes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            object.WinGold = "";
            object.ChangeGold = "";
            object.TotalEnterChip = "";
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.WinGold != null && message.hasOwnProperty("WinGold"))
            object.WinGold = message.WinGold;
        if (message.ChangeGold != null && message.hasOwnProperty("ChangeGold"))
            object.ChangeGold = message.ChangeGold;
        if (message.TotalEnterChip != null && message.hasOwnProperty("TotalEnterChip"))
            object.TotalEnterChip = message.TotalEnterChip;
        return object;
    };

    /**
     * Converts this WheelOfFortureGoldRes to JSON.
     * @function toJSON
     * @memberof WheelOfFortureGoldRes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureGoldRes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureGoldRes
     * @function getTypeUrl
     * @memberof WheelOfFortureGoldRes
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureGoldRes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureGoldRes";
    };

    return WheelOfFortureGoldRes;
})();

export const Desk2WheelOfFortureSrvPushGameResult = $root.Desk2WheelOfFortureSrvPushGameResult = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushGameResult.
     * @exports IDesk2WheelOfFortureSrvPushGameResult
     * @interface IDesk2WheelOfFortureSrvPushGameResult
     * @property {number|null} [UserID] Desk2WheelOfFortureSrvPushGameResult UserID
     * @property {Array.<IWheelOfFortureGoldRes>|null} [GoldResult] Desk2WheelOfFortureSrvPushGameResult GoldResult
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushGameResult.
     * @exports Desk2WheelOfFortureSrvPushGameResult
     * @classdesc Represents a Desk2WheelOfFortureSrvPushGameResult.
     * @implements IDesk2WheelOfFortureSrvPushGameResult
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushGameResult=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushGameResult(properties) {
        this.GoldResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushGameResult UserID.
     * @member {number} UserID
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @instance
     */
    Desk2WheelOfFortureSrvPushGameResult.prototype.UserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushGameResult GoldResult.
     * @member {Array.<IWheelOfFortureGoldRes>} GoldResult
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @instance
     */
    Desk2WheelOfFortureSrvPushGameResult.prototype.GoldResult = $util.emptyArray;

    /**
     * Creates a new Desk2WheelOfFortureSrvPushGameResult instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameResult=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushGameResult} Desk2WheelOfFortureSrvPushGameResult instance
     */
    Desk2WheelOfFortureSrvPushGameResult.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushGameResult(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushGameResult message. Does not implicitly {@link Desk2WheelOfFortureSrvPushGameResult.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameResult} message Desk2WheelOfFortureSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushGameResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.GoldResult != null && message.GoldResult.length)
            for (let i = 0; i < message.GoldResult.length; ++i)
                $root.WheelOfFortureGoldRes.encode(message.GoldResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushGameResult message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushGameResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {IDesk2WheelOfFortureSrvPushGameResult} message Desk2WheelOfFortureSrvPushGameResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushGameResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushGameResult message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushGameResult} Desk2WheelOfFortureSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushGameResult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushGameResult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.GoldResult && message.GoldResult.length))
                        message.GoldResult = [];
                    message.GoldResult.push($root.WheelOfFortureGoldRes.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushGameResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushGameResult} Desk2WheelOfFortureSrvPushGameResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushGameResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushGameResult message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushGameResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.GoldResult != null && message.hasOwnProperty("GoldResult")) {
            if (!Array.isArray(message.GoldResult))
                return "GoldResult: array expected";
            for (let i = 0; i < message.GoldResult.length; ++i) {
                let error = $root.WheelOfFortureGoldRes.verify(message.GoldResult[i]);
                if (error)
                    return "GoldResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushGameResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushGameResult} Desk2WheelOfFortureSrvPushGameResult
     */
    Desk2WheelOfFortureSrvPushGameResult.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushGameResult)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushGameResult();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.GoldResult) {
            if (!Array.isArray(object.GoldResult))
                throw TypeError(".Desk2WheelOfFortureSrvPushGameResult.GoldResult: array expected");
            message.GoldResult = [];
            for (let i = 0; i < object.GoldResult.length; ++i) {
                if (typeof object.GoldResult[i] !== "object")
                    throw TypeError(".Desk2WheelOfFortureSrvPushGameResult.GoldResult: object expected");
                message.GoldResult[i] = $root.WheelOfFortureGoldRes.fromObject(object.GoldResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushGameResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {Desk2WheelOfFortureSrvPushGameResult} message Desk2WheelOfFortureSrvPushGameResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushGameResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.GoldResult = [];
        if (options.defaults)
            object.UserID = 0;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.GoldResult && message.GoldResult.length) {
            object.GoldResult = [];
            for (let j = 0; j < message.GoldResult.length; ++j)
                object.GoldResult[j] = $root.WheelOfFortureGoldRes.toObject(message.GoldResult[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushGameResult to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushGameResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushGameResult
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushGameResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushGameResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushGameResult";
    };

    return Desk2WheelOfFortureSrvPushGameResult;
})();

/**
 * WheelOfFortureRandPlayerType enum.
 * @exports WheelOfFortureRandPlayerType
 * @enum {number}
 * @property {number} WheelOfFortureRandPlayerType_NULL=0 WheelOfFortureRandPlayerType_NULL value
 * @property {number} WheelOfFortureRandPlayerType_RICH=1 WheelOfFortureRandPlayerType_RICH value
 * @property {number} WheelOfFortureRandPlayerType_LUCK=2 WheelOfFortureRandPlayerType_LUCK value
 * @property {number} WheelOfFortureRandPlayerType_NORMAL=3 WheelOfFortureRandPlayerType_NORMAL value
 */
export const WheelOfFortureRandPlayerType = $root.WheelOfFortureRandPlayerType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "WheelOfFortureRandPlayerType_NULL"] = 0;
    values[valuesById[1] = "WheelOfFortureRandPlayerType_RICH"] = 1;
    values[valuesById[2] = "WheelOfFortureRandPlayerType_LUCK"] = 2;
    values[valuesById[3] = "WheelOfFortureRandPlayerType_NORMAL"] = 3;
    return values;
})();

export const WheelOfFortureRandPlayer = $root.WheelOfFortureRandPlayer = (() => {

    /**
     * Properties of a WheelOfFortureRandPlayer.
     * @exports IWheelOfFortureRandPlayer
     * @interface IWheelOfFortureRandPlayer
     * @property {number|null} [UserID] WheelOfFortureRandPlayer UserID
     * @property {Uint8Array|null} [NickName] WheelOfFortureRandPlayer NickName
     * @property {string|null} [HeaderURL] WheelOfFortureRandPlayer HeaderURL
     * @property {string|null} [GoldCoin] WheelOfFortureRandPlayer GoldCoin
     * @property {number|null} [Type] WheelOfFortureRandPlayer Type
     */

    /**
     * Constructs a new WheelOfFortureRandPlayer.
     * @exports WheelOfFortureRandPlayer
     * @classdesc Represents a WheelOfFortureRandPlayer.
     * @implements IWheelOfFortureRandPlayer
     * @constructor
     * @param {IWheelOfFortureRandPlayer=} [properties] Properties to set
     */
    function WheelOfFortureRandPlayer(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WheelOfFortureRandPlayer UserID.
     * @member {number} UserID
     * @memberof WheelOfFortureRandPlayer
     * @instance
     */
    WheelOfFortureRandPlayer.prototype.UserID = 0;

    /**
     * WheelOfFortureRandPlayer NickName.
     * @member {Uint8Array} NickName
     * @memberof WheelOfFortureRandPlayer
     * @instance
     */
    WheelOfFortureRandPlayer.prototype.NickName = $util.newBuffer([]);

    /**
     * WheelOfFortureRandPlayer HeaderURL.
     * @member {string} HeaderURL
     * @memberof WheelOfFortureRandPlayer
     * @instance
     */
    WheelOfFortureRandPlayer.prototype.HeaderURL = "";

    /**
     * WheelOfFortureRandPlayer GoldCoin.
     * @member {string} GoldCoin
     * @memberof WheelOfFortureRandPlayer
     * @instance
     */
    WheelOfFortureRandPlayer.prototype.GoldCoin = "";

    /**
     * WheelOfFortureRandPlayer Type.
     * @member {number} Type
     * @memberof WheelOfFortureRandPlayer
     * @instance
     */
    WheelOfFortureRandPlayer.prototype.Type = 0;

    /**
     * Creates a new WheelOfFortureRandPlayer instance using the specified properties.
     * @function create
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {IWheelOfFortureRandPlayer=} [properties] Properties to set
     * @returns {WheelOfFortureRandPlayer} WheelOfFortureRandPlayer instance
     */
    WheelOfFortureRandPlayer.create = function create(properties) {
        return new WheelOfFortureRandPlayer(properties);
    };

    /**
     * Encodes the specified WheelOfFortureRandPlayer message. Does not implicitly {@link WheelOfFortureRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {IWheelOfFortureRandPlayer} message WheelOfFortureRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.NickName != null && Object.hasOwnProperty.call(message, "NickName"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.NickName);
        if (message.HeaderURL != null && Object.hasOwnProperty.call(message, "HeaderURL"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.HeaderURL);
        if (message.GoldCoin != null && Object.hasOwnProperty.call(message, "GoldCoin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.GoldCoin);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified WheelOfFortureRandPlayer message, length delimited. Does not implicitly {@link WheelOfFortureRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {IWheelOfFortureRandPlayer} message WheelOfFortureRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WheelOfFortureRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WheelOfFortureRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WheelOfFortureRandPlayer} WheelOfFortureRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WheelOfFortureRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.NickName = reader.bytes();
                    break;
                }
            case 3: {
                    message.HeaderURL = reader.string();
                    break;
                }
            case 4: {
                    message.GoldCoin = reader.string();
                    break;
                }
            case 5: {
                    message.Type = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WheelOfFortureRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WheelOfFortureRandPlayer} WheelOfFortureRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WheelOfFortureRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WheelOfFortureRandPlayer message.
     * @function verify
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WheelOfFortureRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            if (!(message.NickName && typeof message.NickName.length === "number" || $util.isString(message.NickName)))
                return "NickName: buffer expected";
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            if (!$util.isString(message.HeaderURL))
                return "HeaderURL: string expected";
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            if (!$util.isString(message.GoldCoin))
                return "GoldCoin: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            if (!$util.isInteger(message.Type))
                return "Type: integer expected";
        return null;
    };

    /**
     * Creates a WheelOfFortureRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WheelOfFortureRandPlayer} WheelOfFortureRandPlayer
     */
    WheelOfFortureRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.WheelOfFortureRandPlayer)
            return object;
        let message = new $root.WheelOfFortureRandPlayer();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.NickName != null)
            if (typeof object.NickName === "string")
                $util.base64.decode(object.NickName, message.NickName = $util.newBuffer($util.base64.length(object.NickName)), 0);
            else if (object.NickName.length >= 0)
                message.NickName = object.NickName;
        if (object.HeaderURL != null)
            message.HeaderURL = String(object.HeaderURL);
        if (object.GoldCoin != null)
            message.GoldCoin = String(object.GoldCoin);
        if (object.Type != null)
            message.Type = object.Type >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a WheelOfFortureRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {WheelOfFortureRandPlayer} message WheelOfFortureRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WheelOfFortureRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.NickName = "";
            else {
                object.NickName = [];
                if (options.bytes !== Array)
                    object.NickName = $util.newBuffer(object.NickName);
            }
            object.HeaderURL = "";
            object.GoldCoin = "";
            object.Type = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.NickName != null && message.hasOwnProperty("NickName"))
            object.NickName = options.bytes === String ? $util.base64.encode(message.NickName, 0, message.NickName.length) : options.bytes === Array ? Array.prototype.slice.call(message.NickName) : message.NickName;
        if (message.HeaderURL != null && message.hasOwnProperty("HeaderURL"))
            object.HeaderURL = message.HeaderURL;
        if (message.GoldCoin != null && message.hasOwnProperty("GoldCoin"))
            object.GoldCoin = message.GoldCoin;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = message.Type;
        return object;
    };

    /**
     * Converts this WheelOfFortureRandPlayer to JSON.
     * @function toJSON
     * @memberof WheelOfFortureRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WheelOfFortureRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WheelOfFortureRandPlayer
     * @function getTypeUrl
     * @memberof WheelOfFortureRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WheelOfFortureRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WheelOfFortureRandPlayer";
    };

    return WheelOfFortureRandPlayer;
})();

export const Desk2WheelOfFortureSrvPushRandPlayer = $root.Desk2WheelOfFortureSrvPushRandPlayer = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushRandPlayer.
     * @exports IDesk2WheelOfFortureSrvPushRandPlayer
     * @interface IDesk2WheelOfFortureSrvPushRandPlayer
     * @property {Array.<IWheelOfFortureRandPlayer>|null} [RandPlayer] Desk2WheelOfFortureSrvPushRandPlayer RandPlayer
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushRandPlayer.
     * @exports Desk2WheelOfFortureSrvPushRandPlayer
     * @classdesc Represents a Desk2WheelOfFortureSrvPushRandPlayer.
     * @implements IDesk2WheelOfFortureSrvPushRandPlayer
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushRandPlayer=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushRandPlayer(properties) {
        this.RandPlayer = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushRandPlayer RandPlayer.
     * @member {Array.<IWheelOfFortureRandPlayer>} RandPlayer
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @instance
     */
    Desk2WheelOfFortureSrvPushRandPlayer.prototype.RandPlayer = $util.emptyArray;

    /**
     * Creates a new Desk2WheelOfFortureSrvPushRandPlayer instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {IDesk2WheelOfFortureSrvPushRandPlayer=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushRandPlayer} Desk2WheelOfFortureSrvPushRandPlayer instance
     */
    Desk2WheelOfFortureSrvPushRandPlayer.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushRandPlayer(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushRandPlayer message. Does not implicitly {@link Desk2WheelOfFortureSrvPushRandPlayer.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {IDesk2WheelOfFortureSrvPushRandPlayer} message Desk2WheelOfFortureSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushRandPlayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.RandPlayer != null && message.RandPlayer.length)
            for (let i = 0; i < message.RandPlayer.length; ++i)
                $root.WheelOfFortureRandPlayer.encode(message.RandPlayer[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushRandPlayer message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushRandPlayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {IDesk2WheelOfFortureSrvPushRandPlayer} message Desk2WheelOfFortureSrvPushRandPlayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushRandPlayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushRandPlayer message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushRandPlayer} Desk2WheelOfFortureSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushRandPlayer.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushRandPlayer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.RandPlayer && message.RandPlayer.length))
                        message.RandPlayer = [];
                    message.RandPlayer.push($root.WheelOfFortureRandPlayer.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushRandPlayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushRandPlayer} Desk2WheelOfFortureSrvPushRandPlayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushRandPlayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushRandPlayer message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushRandPlayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.RandPlayer != null && message.hasOwnProperty("RandPlayer")) {
            if (!Array.isArray(message.RandPlayer))
                return "RandPlayer: array expected";
            for (let i = 0; i < message.RandPlayer.length; ++i) {
                let error = $root.WheelOfFortureRandPlayer.verify(message.RandPlayer[i]);
                if (error)
                    return "RandPlayer." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushRandPlayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushRandPlayer} Desk2WheelOfFortureSrvPushRandPlayer
     */
    Desk2WheelOfFortureSrvPushRandPlayer.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushRandPlayer)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushRandPlayer();
        if (object.RandPlayer) {
            if (!Array.isArray(object.RandPlayer))
                throw TypeError(".Desk2WheelOfFortureSrvPushRandPlayer.RandPlayer: array expected");
            message.RandPlayer = [];
            for (let i = 0; i < object.RandPlayer.length; ++i) {
                if (typeof object.RandPlayer[i] !== "object")
                    throw TypeError(".Desk2WheelOfFortureSrvPushRandPlayer.RandPlayer: object expected");
                message.RandPlayer[i] = $root.WheelOfFortureRandPlayer.fromObject(object.RandPlayer[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushRandPlayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {Desk2WheelOfFortureSrvPushRandPlayer} message Desk2WheelOfFortureSrvPushRandPlayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushRandPlayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.RandPlayer = [];
        if (message.RandPlayer && message.RandPlayer.length) {
            object.RandPlayer = [];
            for (let j = 0; j < message.RandPlayer.length; ++j)
                object.RandPlayer[j] = $root.WheelOfFortureRandPlayer.toObject(message.RandPlayer[j], options);
        }
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushRandPlayer to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushRandPlayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushRandPlayer
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushRandPlayer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushRandPlayer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushRandPlayer";
    };

    return Desk2WheelOfFortureSrvPushRandPlayer;
})();

export const Desk2WheelOfFortureSrvPushTrend = $root.Desk2WheelOfFortureSrvPushTrend = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushTrend.
     * @exports IDesk2WheelOfFortureSrvPushTrend
     * @interface IDesk2WheelOfFortureSrvPushTrend
     * @property {number|null} [UserID] Desk2WheelOfFortureSrvPushTrend UserID
     * @property {Uint8Array|null} [Trend] Desk2WheelOfFortureSrvPushTrend Trend
     * @property {Uint8Array|null} [Record] Desk2WheelOfFortureSrvPushTrend Record
     * @property {Uint8Array|null} [Forecast1] Desk2WheelOfFortureSrvPushTrend Forecast1
     * @property {Uint8Array|null} [Forecast2] Desk2WheelOfFortureSrvPushTrend Forecast2
     * @property {Uint8Array|null} [Forecast3] Desk2WheelOfFortureSrvPushTrend Forecast3
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushTrend.
     * @exports Desk2WheelOfFortureSrvPushTrend
     * @classdesc Represents a Desk2WheelOfFortureSrvPushTrend.
     * @implements IDesk2WheelOfFortureSrvPushTrend
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushTrend=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushTrend(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushTrend UserID.
     * @member {number} UserID
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.UserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushTrend Trend.
     * @member {Uint8Array} Trend
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.Trend = $util.newBuffer([]);

    /**
     * Desk2WheelOfFortureSrvPushTrend Record.
     * @member {Uint8Array} Record
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.Record = $util.newBuffer([]);

    /**
     * Desk2WheelOfFortureSrvPushTrend Forecast1.
     * @member {Uint8Array} Forecast1
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.Forecast1 = $util.newBuffer([]);

    /**
     * Desk2WheelOfFortureSrvPushTrend Forecast2.
     * @member {Uint8Array} Forecast2
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.Forecast2 = $util.newBuffer([]);

    /**
     * Desk2WheelOfFortureSrvPushTrend Forecast3.
     * @member {Uint8Array} Forecast3
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.Forecast3 = $util.newBuffer([]);

    /**
     * Creates a new Desk2WheelOfFortureSrvPushTrend instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {IDesk2WheelOfFortureSrvPushTrend=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushTrend} Desk2WheelOfFortureSrvPushTrend instance
     */
    Desk2WheelOfFortureSrvPushTrend.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushTrend(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushTrend message. Does not implicitly {@link Desk2WheelOfFortureSrvPushTrend.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {IDesk2WheelOfFortureSrvPushTrend} message Desk2WheelOfFortureSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushTrend.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Trend != null && Object.hasOwnProperty.call(message, "Trend"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Trend);
        if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Record);
        if (message.Forecast1 != null && Object.hasOwnProperty.call(message, "Forecast1"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.Forecast1);
        if (message.Forecast2 != null && Object.hasOwnProperty.call(message, "Forecast2"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.Forecast2);
        if (message.Forecast3 != null && Object.hasOwnProperty.call(message, "Forecast3"))
            writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.Forecast3);
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushTrend message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushTrend.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {IDesk2WheelOfFortureSrvPushTrend} message Desk2WheelOfFortureSrvPushTrend message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushTrend.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushTrend message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushTrend} Desk2WheelOfFortureSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushTrend.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushTrend();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Trend = reader.bytes();
                    break;
                }
            case 3: {
                    message.Record = reader.bytes();
                    break;
                }
            case 4: {
                    message.Forecast1 = reader.bytes();
                    break;
                }
            case 5: {
                    message.Forecast2 = reader.bytes();
                    break;
                }
            case 6: {
                    message.Forecast3 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushTrend message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushTrend} Desk2WheelOfFortureSrvPushTrend
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushTrend.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushTrend message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushTrend.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            if (!(message.Trend && typeof message.Trend.length === "number" || $util.isString(message.Trend)))
                return "Trend: buffer expected";
        if (message.Record != null && message.hasOwnProperty("Record"))
            if (!(message.Record && typeof message.Record.length === "number" || $util.isString(message.Record)))
                return "Record: buffer expected";
        if (message.Forecast1 != null && message.hasOwnProperty("Forecast1"))
            if (!(message.Forecast1 && typeof message.Forecast1.length === "number" || $util.isString(message.Forecast1)))
                return "Forecast1: buffer expected";
        if (message.Forecast2 != null && message.hasOwnProperty("Forecast2"))
            if (!(message.Forecast2 && typeof message.Forecast2.length === "number" || $util.isString(message.Forecast2)))
                return "Forecast2: buffer expected";
        if (message.Forecast3 != null && message.hasOwnProperty("Forecast3"))
            if (!(message.Forecast3 && typeof message.Forecast3.length === "number" || $util.isString(message.Forecast3)))
                return "Forecast3: buffer expected";
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushTrend message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushTrend} Desk2WheelOfFortureSrvPushTrend
     */
    Desk2WheelOfFortureSrvPushTrend.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushTrend)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushTrend();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Trend != null)
            if (typeof object.Trend === "string")
                $util.base64.decode(object.Trend, message.Trend = $util.newBuffer($util.base64.length(object.Trend)), 0);
            else if (object.Trend.length >= 0)
                message.Trend = object.Trend;
        if (object.Record != null)
            if (typeof object.Record === "string")
                $util.base64.decode(object.Record, message.Record = $util.newBuffer($util.base64.length(object.Record)), 0);
            else if (object.Record.length >= 0)
                message.Record = object.Record;
        if (object.Forecast1 != null)
            if (typeof object.Forecast1 === "string")
                $util.base64.decode(object.Forecast1, message.Forecast1 = $util.newBuffer($util.base64.length(object.Forecast1)), 0);
            else if (object.Forecast1.length >= 0)
                message.Forecast1 = object.Forecast1;
        if (object.Forecast2 != null)
            if (typeof object.Forecast2 === "string")
                $util.base64.decode(object.Forecast2, message.Forecast2 = $util.newBuffer($util.base64.length(object.Forecast2)), 0);
            else if (object.Forecast2.length >= 0)
                message.Forecast2 = object.Forecast2;
        if (object.Forecast3 != null)
            if (typeof object.Forecast3 === "string")
                $util.base64.decode(object.Forecast3, message.Forecast3 = $util.newBuffer($util.base64.length(object.Forecast3)), 0);
            else if (object.Forecast3.length >= 0)
                message.Forecast3 = object.Forecast3;
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushTrend message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {Desk2WheelOfFortureSrvPushTrend} message Desk2WheelOfFortureSrvPushTrend
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushTrend.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.UserID = 0;
            if (options.bytes === String)
                object.Trend = "";
            else {
                object.Trend = [];
                if (options.bytes !== Array)
                    object.Trend = $util.newBuffer(object.Trend);
            }
            if (options.bytes === String)
                object.Record = "";
            else {
                object.Record = [];
                if (options.bytes !== Array)
                    object.Record = $util.newBuffer(object.Record);
            }
            if (options.bytes === String)
                object.Forecast1 = "";
            else {
                object.Forecast1 = [];
                if (options.bytes !== Array)
                    object.Forecast1 = $util.newBuffer(object.Forecast1);
            }
            if (options.bytes === String)
                object.Forecast2 = "";
            else {
                object.Forecast2 = [];
                if (options.bytes !== Array)
                    object.Forecast2 = $util.newBuffer(object.Forecast2);
            }
            if (options.bytes === String)
                object.Forecast3 = "";
            else {
                object.Forecast3 = [];
                if (options.bytes !== Array)
                    object.Forecast3 = $util.newBuffer(object.Forecast3);
            }
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Trend != null && message.hasOwnProperty("Trend"))
            object.Trend = options.bytes === String ? $util.base64.encode(message.Trend, 0, message.Trend.length) : options.bytes === Array ? Array.prototype.slice.call(message.Trend) : message.Trend;
        if (message.Record != null && message.hasOwnProperty("Record"))
            object.Record = options.bytes === String ? $util.base64.encode(message.Record, 0, message.Record.length) : options.bytes === Array ? Array.prototype.slice.call(message.Record) : message.Record;
        if (message.Forecast1 != null && message.hasOwnProperty("Forecast1"))
            object.Forecast1 = options.bytes === String ? $util.base64.encode(message.Forecast1, 0, message.Forecast1.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast1) : message.Forecast1;
        if (message.Forecast2 != null && message.hasOwnProperty("Forecast2"))
            object.Forecast2 = options.bytes === String ? $util.base64.encode(message.Forecast2, 0, message.Forecast2.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast2) : message.Forecast2;
        if (message.Forecast3 != null && message.hasOwnProperty("Forecast3"))
            object.Forecast3 = options.bytes === String ? $util.base64.encode(message.Forecast3, 0, message.Forecast3.length) : options.bytes === Array ? Array.prototype.slice.call(message.Forecast3) : message.Forecast3;
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushTrend to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushTrend.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushTrend
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushTrend
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushTrend.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushTrend";
    };

    return Desk2WheelOfFortureSrvPushTrend;
})();

export const Desk2WheelOfFortureSrvPushLuckyStar = $root.Desk2WheelOfFortureSrvPushLuckyStar = (() => {

    /**
     * Properties of a Desk2WheelOfFortureSrvPushLuckyStar.
     * @exports IDesk2WheelOfFortureSrvPushLuckyStar
     * @interface IDesk2WheelOfFortureSrvPushLuckyStar
     * @property {number|null} [UserID] Desk2WheelOfFortureSrvPushLuckyStar UserID
     * @property {number|null} [StarUserID] Desk2WheelOfFortureSrvPushLuckyStar StarUserID
     * @property {Array.<number>|null} [Section] Desk2WheelOfFortureSrvPushLuckyStar Section
     */

    /**
     * Constructs a new Desk2WheelOfFortureSrvPushLuckyStar.
     * @exports Desk2WheelOfFortureSrvPushLuckyStar
     * @classdesc Represents a Desk2WheelOfFortureSrvPushLuckyStar.
     * @implements IDesk2WheelOfFortureSrvPushLuckyStar
     * @constructor
     * @param {IDesk2WheelOfFortureSrvPushLuckyStar=} [properties] Properties to set
     */
    function Desk2WheelOfFortureSrvPushLuckyStar(properties) {
        this.Section = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Desk2WheelOfFortureSrvPushLuckyStar UserID.
     * @member {number} UserID
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @instance
     */
    Desk2WheelOfFortureSrvPushLuckyStar.prototype.UserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushLuckyStar StarUserID.
     * @member {number} StarUserID
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @instance
     */
    Desk2WheelOfFortureSrvPushLuckyStar.prototype.StarUserID = 0;

    /**
     * Desk2WheelOfFortureSrvPushLuckyStar Section.
     * @member {Array.<number>} Section
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @instance
     */
    Desk2WheelOfFortureSrvPushLuckyStar.prototype.Section = $util.emptyArray;

    /**
     * Creates a new Desk2WheelOfFortureSrvPushLuckyStar instance using the specified properties.
     * @function create
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {IDesk2WheelOfFortureSrvPushLuckyStar=} [properties] Properties to set
     * @returns {Desk2WheelOfFortureSrvPushLuckyStar} Desk2WheelOfFortureSrvPushLuckyStar instance
     */
    Desk2WheelOfFortureSrvPushLuckyStar.create = function create(properties) {
        return new Desk2WheelOfFortureSrvPushLuckyStar(properties);
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushLuckyStar message. Does not implicitly {@link Desk2WheelOfFortureSrvPushLuckyStar.verify|verify} messages.
     * @function encode
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {IDesk2WheelOfFortureSrvPushLuckyStar} message Desk2WheelOfFortureSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushLuckyStar.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.StarUserID != null && Object.hasOwnProperty.call(message, "StarUserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.StarUserID);
        if (message.Section != null && message.Section.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.Section.length; ++i)
                writer.uint32(message.Section[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Desk2WheelOfFortureSrvPushLuckyStar message, length delimited. Does not implicitly {@link Desk2WheelOfFortureSrvPushLuckyStar.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {IDesk2WheelOfFortureSrvPushLuckyStar} message Desk2WheelOfFortureSrvPushLuckyStar message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Desk2WheelOfFortureSrvPushLuckyStar.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushLuckyStar message from the specified reader or buffer.
     * @function decode
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Desk2WheelOfFortureSrvPushLuckyStar} Desk2WheelOfFortureSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushLuckyStar.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Desk2WheelOfFortureSrvPushLuckyStar();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.StarUserID = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.Section && message.Section.length))
                        message.Section = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Section.push(reader.uint32());
                    } else
                        message.Section.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Desk2WheelOfFortureSrvPushLuckyStar message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Desk2WheelOfFortureSrvPushLuckyStar} Desk2WheelOfFortureSrvPushLuckyStar
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Desk2WheelOfFortureSrvPushLuckyStar.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Desk2WheelOfFortureSrvPushLuckyStar message.
     * @function verify
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Desk2WheelOfFortureSrvPushLuckyStar.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            if (!$util.isInteger(message.StarUserID))
                return "StarUserID: integer expected";
        if (message.Section != null && message.hasOwnProperty("Section")) {
            if (!Array.isArray(message.Section))
                return "Section: array expected";
            for (let i = 0; i < message.Section.length; ++i)
                if (!$util.isInteger(message.Section[i]))
                    return "Section: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Desk2WheelOfFortureSrvPushLuckyStar message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Desk2WheelOfFortureSrvPushLuckyStar} Desk2WheelOfFortureSrvPushLuckyStar
     */
    Desk2WheelOfFortureSrvPushLuckyStar.fromObject = function fromObject(object) {
        if (object instanceof $root.Desk2WheelOfFortureSrvPushLuckyStar)
            return object;
        let message = new $root.Desk2WheelOfFortureSrvPushLuckyStar();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.StarUserID != null)
            message.StarUserID = object.StarUserID >>> 0;
        if (object.Section) {
            if (!Array.isArray(object.Section))
                throw TypeError(".Desk2WheelOfFortureSrvPushLuckyStar.Section: array expected");
            message.Section = [];
            for (let i = 0; i < object.Section.length; ++i)
                message.Section[i] = object.Section[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Desk2WheelOfFortureSrvPushLuckyStar message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {Desk2WheelOfFortureSrvPushLuckyStar} message Desk2WheelOfFortureSrvPushLuckyStar
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Desk2WheelOfFortureSrvPushLuckyStar.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Section = [];
        if (options.defaults) {
            object.UserID = 0;
            object.StarUserID = 0;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.StarUserID != null && message.hasOwnProperty("StarUserID"))
            object.StarUserID = message.StarUserID;
        if (message.Section && message.Section.length) {
            object.Section = [];
            for (let j = 0; j < message.Section.length; ++j)
                object.Section[j] = message.Section[j];
        }
        return object;
    };

    /**
     * Converts this Desk2WheelOfFortureSrvPushLuckyStar to JSON.
     * @function toJSON
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Desk2WheelOfFortureSrvPushLuckyStar.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Desk2WheelOfFortureSrvPushLuckyStar
     * @function getTypeUrl
     * @memberof Desk2WheelOfFortureSrvPushLuckyStar
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Desk2WheelOfFortureSrvPushLuckyStar.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Desk2WheelOfFortureSrvPushLuckyStar";
    };

    return Desk2WheelOfFortureSrvPushLuckyStar;
})();

export const SuperAceProduct = $root.SuperAceProduct = (() => {

    /**
     * Properties of a SuperAceProduct.
     * @exports ISuperAceProduct
     * @interface ISuperAceProduct
     * @property {number|null} [PID] SuperAceProduct PID
     * @property {number|null} [Mode] SuperAceProduct Mode
     * @property {string|null} [BetList] SuperAceProduct BetList
     * @property {string|null} [AutoBet] SuperAceProduct AutoBet
     * @property {number|null} [FreeGameTime] SuperAceProduct FreeGameTime
     * @property {number|null} [FreeGameMult] SuperAceProduct FreeGameMult
     * @property {number|null} [FreeGameCount1] SuperAceProduct FreeGameCount1
     * @property {number|null} [FreeGameCount2] SuperAceProduct FreeGameCount2
     */

    /**
     * Constructs a new SuperAceProduct.
     * @exports SuperAceProduct
     * @classdesc Represents a SuperAceProduct.
     * @implements ISuperAceProduct
     * @constructor
     * @param {ISuperAceProduct=} [properties] Properties to set
     */
    function SuperAceProduct(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperAceProduct PID.
     * @member {number} PID
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.PID = 0;

    /**
     * SuperAceProduct Mode.
     * @member {number} Mode
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.Mode = 0;

    /**
     * SuperAceProduct BetList.
     * @member {string} BetList
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.BetList = "";

    /**
     * SuperAceProduct AutoBet.
     * @member {string} AutoBet
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.AutoBet = "";

    /**
     * SuperAceProduct FreeGameTime.
     * @member {number} FreeGameTime
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.FreeGameTime = 0;

    /**
     * SuperAceProduct FreeGameMult.
     * @member {number} FreeGameMult
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.FreeGameMult = 0;

    /**
     * SuperAceProduct FreeGameCount1.
     * @member {number} FreeGameCount1
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.FreeGameCount1 = 0;

    /**
     * SuperAceProduct FreeGameCount2.
     * @member {number} FreeGameCount2
     * @memberof SuperAceProduct
     * @instance
     */
    SuperAceProduct.prototype.FreeGameCount2 = 0;

    /**
     * Creates a new SuperAceProduct instance using the specified properties.
     * @function create
     * @memberof SuperAceProduct
     * @static
     * @param {ISuperAceProduct=} [properties] Properties to set
     * @returns {SuperAceProduct} SuperAceProduct instance
     */
    SuperAceProduct.create = function create(properties) {
        return new SuperAceProduct(properties);
    };

    /**
     * Encodes the specified SuperAceProduct message. Does not implicitly {@link SuperAceProduct.verify|verify} messages.
     * @function encode
     * @memberof SuperAceProduct
     * @static
     * @param {ISuperAceProduct} message SuperAceProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceProduct.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PID != null && Object.hasOwnProperty.call(message, "PID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.PID);
        if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Mode);
        if (message.BetList != null && Object.hasOwnProperty.call(message, "BetList"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.BetList);
        if (message.AutoBet != null && Object.hasOwnProperty.call(message, "AutoBet"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.AutoBet);
        if (message.FreeGameTime != null && Object.hasOwnProperty.call(message, "FreeGameTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.FreeGameTime);
        if (message.FreeGameMult != null && Object.hasOwnProperty.call(message, "FreeGameMult"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.FreeGameMult);
        if (message.FreeGameCount1 != null && Object.hasOwnProperty.call(message, "FreeGameCount1"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.FreeGameCount1);
        if (message.FreeGameCount2 != null && Object.hasOwnProperty.call(message, "FreeGameCount2"))
            writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.FreeGameCount2);
        return writer;
    };

    /**
     * Encodes the specified SuperAceProduct message, length delimited. Does not implicitly {@link SuperAceProduct.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperAceProduct
     * @static
     * @param {ISuperAceProduct} message SuperAceProduct message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceProduct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperAceProduct message from the specified reader or buffer.
     * @function decode
     * @memberof SuperAceProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperAceProduct} SuperAceProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceProduct.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperAceProduct();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Mode = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetList = reader.string();
                    break;
                }
            case 4: {
                    message.AutoBet = reader.string();
                    break;
                }
            case 5: {
                    message.FreeGameTime = reader.uint32();
                    break;
                }
            case 6: {
                    message.FreeGameMult = reader.uint32();
                    break;
                }
            case 7: {
                    message.FreeGameCount1 = reader.uint32();
                    break;
                }
            case 8: {
                    message.FreeGameCount2 = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperAceProduct message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperAceProduct
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperAceProduct} SuperAceProduct
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceProduct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperAceProduct message.
     * @function verify
     * @memberof SuperAceProduct
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperAceProduct.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PID != null && message.hasOwnProperty("PID"))
            if (!$util.isInteger(message.PID))
                return "PID: integer expected";
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            if (!$util.isInteger(message.Mode))
                return "Mode: integer expected";
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            if (!$util.isString(message.BetList))
                return "BetList: string expected";
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            if (!$util.isString(message.AutoBet))
                return "AutoBet: string expected";
        if (message.FreeGameTime != null && message.hasOwnProperty("FreeGameTime"))
            if (!$util.isInteger(message.FreeGameTime))
                return "FreeGameTime: integer expected";
        if (message.FreeGameMult != null && message.hasOwnProperty("FreeGameMult"))
            if (!$util.isInteger(message.FreeGameMult))
                return "FreeGameMult: integer expected";
        if (message.FreeGameCount1 != null && message.hasOwnProperty("FreeGameCount1"))
            if (!$util.isInteger(message.FreeGameCount1))
                return "FreeGameCount1: integer expected";
        if (message.FreeGameCount2 != null && message.hasOwnProperty("FreeGameCount2"))
            if (!$util.isInteger(message.FreeGameCount2))
                return "FreeGameCount2: integer expected";
        return null;
    };

    /**
     * Creates a SuperAceProduct message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperAceProduct
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperAceProduct} SuperAceProduct
     */
    SuperAceProduct.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperAceProduct)
            return object;
        let message = new $root.SuperAceProduct();
        if (object.PID != null)
            message.PID = object.PID >>> 0;
        if (object.Mode != null)
            message.Mode = object.Mode >>> 0;
        if (object.BetList != null)
            message.BetList = String(object.BetList);
        if (object.AutoBet != null)
            message.AutoBet = String(object.AutoBet);
        if (object.FreeGameTime != null)
            message.FreeGameTime = object.FreeGameTime >>> 0;
        if (object.FreeGameMult != null)
            message.FreeGameMult = object.FreeGameMult >>> 0;
        if (object.FreeGameCount1 != null)
            message.FreeGameCount1 = object.FreeGameCount1 >>> 0;
        if (object.FreeGameCount2 != null)
            message.FreeGameCount2 = object.FreeGameCount2 >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a SuperAceProduct message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperAceProduct
     * @static
     * @param {SuperAceProduct} message SuperAceProduct
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperAceProduct.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.PID = 0;
            object.Mode = 0;
            object.BetList = "";
            object.AutoBet = "";
            object.FreeGameTime = 0;
            object.FreeGameMult = 0;
            object.FreeGameCount1 = 0;
            object.FreeGameCount2 = 0;
        }
        if (message.PID != null && message.hasOwnProperty("PID"))
            object.PID = message.PID;
        if (message.Mode != null && message.hasOwnProperty("Mode"))
            object.Mode = message.Mode;
        if (message.BetList != null && message.hasOwnProperty("BetList"))
            object.BetList = message.BetList;
        if (message.AutoBet != null && message.hasOwnProperty("AutoBet"))
            object.AutoBet = message.AutoBet;
        if (message.FreeGameTime != null && message.hasOwnProperty("FreeGameTime"))
            object.FreeGameTime = message.FreeGameTime;
        if (message.FreeGameMult != null && message.hasOwnProperty("FreeGameMult"))
            object.FreeGameMult = message.FreeGameMult;
        if (message.FreeGameCount1 != null && message.hasOwnProperty("FreeGameCount1"))
            object.FreeGameCount1 = message.FreeGameCount1;
        if (message.FreeGameCount2 != null && message.hasOwnProperty("FreeGameCount2"))
            object.FreeGameCount2 = message.FreeGameCount2;
        return object;
    };

    /**
     * Converts this SuperAceProduct to JSON.
     * @function toJSON
     * @memberof SuperAceProduct
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperAceProduct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SuperAceProduct
     * @function getTypeUrl
     * @memberof SuperAceProduct
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SuperAceProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SuperAceProduct";
    };

    return SuperAceProduct;
})();

export const SuperAceAxleMult = $root.SuperAceAxleMult = (() => {

    /**
     * Properties of a SuperAceAxleMult.
     * @exports ISuperAceAxleMult
     * @interface ISuperAceAxleMult
     * @property {number|null} [CardSymbol] SuperAceAxleMult CardSymbol
     * @property {number|null} [Axle3] SuperAceAxleMult Axle3
     * @property {number|null} [Axle4] SuperAceAxleMult Axle4
     * @property {number|null} [Axle5] SuperAceAxleMult Axle5
     */

    /**
     * Constructs a new SuperAceAxleMult.
     * @exports SuperAceAxleMult
     * @classdesc Represents a SuperAceAxleMult.
     * @implements ISuperAceAxleMult
     * @constructor
     * @param {ISuperAceAxleMult=} [properties] Properties to set
     */
    function SuperAceAxleMult(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperAceAxleMult CardSymbol.
     * @member {number} CardSymbol
     * @memberof SuperAceAxleMult
     * @instance
     */
    SuperAceAxleMult.prototype.CardSymbol = 0;

    /**
     * SuperAceAxleMult Axle3.
     * @member {number} Axle3
     * @memberof SuperAceAxleMult
     * @instance
     */
    SuperAceAxleMult.prototype.Axle3 = 0;

    /**
     * SuperAceAxleMult Axle4.
     * @member {number} Axle4
     * @memberof SuperAceAxleMult
     * @instance
     */
    SuperAceAxleMult.prototype.Axle4 = 0;

    /**
     * SuperAceAxleMult Axle5.
     * @member {number} Axle5
     * @memberof SuperAceAxleMult
     * @instance
     */
    SuperAceAxleMult.prototype.Axle5 = 0;

    /**
     * Creates a new SuperAceAxleMult instance using the specified properties.
     * @function create
     * @memberof SuperAceAxleMult
     * @static
     * @param {ISuperAceAxleMult=} [properties] Properties to set
     * @returns {SuperAceAxleMult} SuperAceAxleMult instance
     */
    SuperAceAxleMult.create = function create(properties) {
        return new SuperAceAxleMult(properties);
    };

    /**
     * Encodes the specified SuperAceAxleMult message. Does not implicitly {@link SuperAceAxleMult.verify|verify} messages.
     * @function encode
     * @memberof SuperAceAxleMult
     * @static
     * @param {ISuperAceAxleMult} message SuperAceAxleMult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceAxleMult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CardSymbol != null && Object.hasOwnProperty.call(message, "CardSymbol"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.CardSymbol);
        if (message.Axle3 != null && Object.hasOwnProperty.call(message, "Axle3"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Axle3);
        if (message.Axle4 != null && Object.hasOwnProperty.call(message, "Axle4"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Axle4);
        if (message.Axle5 != null && Object.hasOwnProperty.call(message, "Axle5"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Axle5);
        return writer;
    };

    /**
     * Encodes the specified SuperAceAxleMult message, length delimited. Does not implicitly {@link SuperAceAxleMult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperAceAxleMult
     * @static
     * @param {ISuperAceAxleMult} message SuperAceAxleMult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceAxleMult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperAceAxleMult message from the specified reader or buffer.
     * @function decode
     * @memberof SuperAceAxleMult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperAceAxleMult} SuperAceAxleMult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceAxleMult.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperAceAxleMult();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.CardSymbol = reader.uint32();
                    break;
                }
            case 2: {
                    message.Axle3 = reader.uint32();
                    break;
                }
            case 3: {
                    message.Axle4 = reader.uint32();
                    break;
                }
            case 4: {
                    message.Axle5 = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperAceAxleMult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperAceAxleMult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperAceAxleMult} SuperAceAxleMult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceAxleMult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperAceAxleMult message.
     * @function verify
     * @memberof SuperAceAxleMult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperAceAxleMult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CardSymbol != null && message.hasOwnProperty("CardSymbol"))
            if (!$util.isInteger(message.CardSymbol))
                return "CardSymbol: integer expected";
        if (message.Axle3 != null && message.hasOwnProperty("Axle3"))
            if (!$util.isInteger(message.Axle3))
                return "Axle3: integer expected";
        if (message.Axle4 != null && message.hasOwnProperty("Axle4"))
            if (!$util.isInteger(message.Axle4))
                return "Axle4: integer expected";
        if (message.Axle5 != null && message.hasOwnProperty("Axle5"))
            if (!$util.isInteger(message.Axle5))
                return "Axle5: integer expected";
        return null;
    };

    /**
     * Creates a SuperAceAxleMult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperAceAxleMult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperAceAxleMult} SuperAceAxleMult
     */
    SuperAceAxleMult.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperAceAxleMult)
            return object;
        let message = new $root.SuperAceAxleMult();
        if (object.CardSymbol != null)
            message.CardSymbol = object.CardSymbol >>> 0;
        if (object.Axle3 != null)
            message.Axle3 = object.Axle3 >>> 0;
        if (object.Axle4 != null)
            message.Axle4 = object.Axle4 >>> 0;
        if (object.Axle5 != null)
            message.Axle5 = object.Axle5 >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a SuperAceAxleMult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperAceAxleMult
     * @static
     * @param {SuperAceAxleMult} message SuperAceAxleMult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperAceAxleMult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.CardSymbol = 0;
            object.Axle3 = 0;
            object.Axle4 = 0;
            object.Axle5 = 0;
        }
        if (message.CardSymbol != null && message.hasOwnProperty("CardSymbol"))
            object.CardSymbol = message.CardSymbol;
        if (message.Axle3 != null && message.hasOwnProperty("Axle3"))
            object.Axle3 = message.Axle3;
        if (message.Axle4 != null && message.hasOwnProperty("Axle4"))
            object.Axle4 = message.Axle4;
        if (message.Axle5 != null && message.hasOwnProperty("Axle5"))
            object.Axle5 = message.Axle5;
        return object;
    };

    /**
     * Converts this SuperAceAxleMult to JSON.
     * @function toJSON
     * @memberof SuperAceAxleMult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperAceAxleMult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SuperAceAxleMult
     * @function getTypeUrl
     * @memberof SuperAceAxleMult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SuperAceAxleMult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SuperAceAxleMult";
    };

    return SuperAceAxleMult;
})();

export const SuperAceSrvToDeskPushDeskInfo = $root.SuperAceSrvToDeskPushDeskInfo = (() => {

    /**
     * Properties of a SuperAceSrvToDeskPushDeskInfo.
     * @exports ISuperAceSrvToDeskPushDeskInfo
     * @interface ISuperAceSrvToDeskPushDeskInfo
     * @property {number|null} [UserID] SuperAceSrvToDeskPushDeskInfo UserID
     * @property {number|Long|null} [Gold] SuperAceSrvToDeskPushDeskInfo Gold
     * @property {ISuperAceProduct|null} [Product] SuperAceSrvToDeskPushDeskInfo Product
     * @property {Array.<ISuperAceAxleMult>|null} [AxleMult] SuperAceSrvToDeskPushDeskInfo AxleMult
     */

    /**
     * Constructs a new SuperAceSrvToDeskPushDeskInfo.
     * @exports SuperAceSrvToDeskPushDeskInfo
     * @classdesc Represents a SuperAceSrvToDeskPushDeskInfo.
     * @implements ISuperAceSrvToDeskPushDeskInfo
     * @constructor
     * @param {ISuperAceSrvToDeskPushDeskInfo=} [properties] Properties to set
     */
    function SuperAceSrvToDeskPushDeskInfo(properties) {
        this.AxleMult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperAceSrvToDeskPushDeskInfo UserID.
     * @member {number} UserID
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @instance
     */
    SuperAceSrvToDeskPushDeskInfo.prototype.UserID = 0;

    /**
     * SuperAceSrvToDeskPushDeskInfo Gold.
     * @member {number|Long} Gold
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @instance
     */
    SuperAceSrvToDeskPushDeskInfo.prototype.Gold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * SuperAceSrvToDeskPushDeskInfo Product.
     * @member {ISuperAceProduct|null|undefined} Product
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @instance
     */
    SuperAceSrvToDeskPushDeskInfo.prototype.Product = null;

    /**
     * SuperAceSrvToDeskPushDeskInfo AxleMult.
     * @member {Array.<ISuperAceAxleMult>} AxleMult
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @instance
     */
    SuperAceSrvToDeskPushDeskInfo.prototype.AxleMult = $util.emptyArray;

    /**
     * Creates a new SuperAceSrvToDeskPushDeskInfo instance using the specified properties.
     * @function create
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {ISuperAceSrvToDeskPushDeskInfo=} [properties] Properties to set
     * @returns {SuperAceSrvToDeskPushDeskInfo} SuperAceSrvToDeskPushDeskInfo instance
     */
    SuperAceSrvToDeskPushDeskInfo.create = function create(properties) {
        return new SuperAceSrvToDeskPushDeskInfo(properties);
    };

    /**
     * Encodes the specified SuperAceSrvToDeskPushDeskInfo message. Does not implicitly {@link SuperAceSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encode
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {ISuperAceSrvToDeskPushDeskInfo} message SuperAceSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceSrvToDeskPushDeskInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.UserID);
        if (message.Gold != null && Object.hasOwnProperty.call(message, "Gold"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.Gold);
        if (message.Product != null && Object.hasOwnProperty.call(message, "Product"))
            $root.SuperAceProduct.encode(message.Product, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.AxleMult != null && message.AxleMult.length)
            for (let i = 0; i < message.AxleMult.length; ++i)
                $root.SuperAceAxleMult.encode(message.AxleMult[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SuperAceSrvToDeskPushDeskInfo message, length delimited. Does not implicitly {@link SuperAceSrvToDeskPushDeskInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {ISuperAceSrvToDeskPushDeskInfo} message SuperAceSrvToDeskPushDeskInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAceSrvToDeskPushDeskInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperAceSrvToDeskPushDeskInfo message from the specified reader or buffer.
     * @function decode
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperAceSrvToDeskPushDeskInfo} SuperAceSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceSrvToDeskPushDeskInfo.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperAceSrvToDeskPushDeskInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 2: {
                    message.Gold = reader.uint64();
                    break;
                }
            case 3: {
                    message.Product = $root.SuperAceProduct.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.AxleMult && message.AxleMult.length))
                        message.AxleMult = [];
                    message.AxleMult.push($root.SuperAceAxleMult.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperAceSrvToDeskPushDeskInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperAceSrvToDeskPushDeskInfo} SuperAceSrvToDeskPushDeskInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAceSrvToDeskPushDeskInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperAceSrvToDeskPushDeskInfo message.
     * @function verify
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperAceSrvToDeskPushDeskInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (!$util.isInteger(message.Gold) && !(message.Gold && $util.isInteger(message.Gold.low) && $util.isInteger(message.Gold.high)))
                return "Gold: integer|Long expected";
        if (message.Product != null && message.hasOwnProperty("Product")) {
            let error = $root.SuperAceProduct.verify(message.Product);
            if (error)
                return "Product." + error;
        }
        if (message.AxleMult != null && message.hasOwnProperty("AxleMult")) {
            if (!Array.isArray(message.AxleMult))
                return "AxleMult: array expected";
            for (let i = 0; i < message.AxleMult.length; ++i) {
                let error = $root.SuperAceAxleMult.verify(message.AxleMult[i]);
                if (error)
                    return "AxleMult." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SuperAceSrvToDeskPushDeskInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperAceSrvToDeskPushDeskInfo} SuperAceSrvToDeskPushDeskInfo
     */
    SuperAceSrvToDeskPushDeskInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperAceSrvToDeskPushDeskInfo)
            return object;
        let message = new $root.SuperAceSrvToDeskPushDeskInfo();
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.Gold != null)
            if ($util.Long)
                (message.Gold = $util.Long.fromValue(object.Gold)).unsigned = true;
            else if (typeof object.Gold === "string")
                message.Gold = parseInt(object.Gold, 10);
            else if (typeof object.Gold === "number")
                message.Gold = object.Gold;
            else if (typeof object.Gold === "object")
                message.Gold = new $util.LongBits(object.Gold.low >>> 0, object.Gold.high >>> 0).toNumber(true);
        if (object.Product != null) {
            if (typeof object.Product !== "object")
                throw TypeError(".SuperAceSrvToDeskPushDeskInfo.Product: object expected");
            message.Product = $root.SuperAceProduct.fromObject(object.Product);
        }
        if (object.AxleMult) {
            if (!Array.isArray(object.AxleMult))
                throw TypeError(".SuperAceSrvToDeskPushDeskInfo.AxleMult: array expected");
            message.AxleMult = [];
            for (let i = 0; i < object.AxleMult.length; ++i) {
                if (typeof object.AxleMult[i] !== "object")
                    throw TypeError(".SuperAceSrvToDeskPushDeskInfo.AxleMult: object expected");
                message.AxleMult[i] = $root.SuperAceAxleMult.fromObject(object.AxleMult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SuperAceSrvToDeskPushDeskInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {SuperAceSrvToDeskPushDeskInfo} message SuperAceSrvToDeskPushDeskInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperAceSrvToDeskPushDeskInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.AxleMult = [];
        if (options.defaults) {
            object.UserID = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.Gold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Gold = options.longs === String ? "0" : 0;
            object.Product = null;
        }
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.Gold != null && message.hasOwnProperty("Gold"))
            if (typeof message.Gold === "number")
                object.Gold = options.longs === String ? String(message.Gold) : message.Gold;
            else
                object.Gold = options.longs === String ? $util.Long.prototype.toString.call(message.Gold) : options.longs === Number ? new $util.LongBits(message.Gold.low >>> 0, message.Gold.high >>> 0).toNumber(true) : message.Gold;
        if (message.Product != null && message.hasOwnProperty("Product"))
            object.Product = $root.SuperAceProduct.toObject(message.Product, options);
        if (message.AxleMult && message.AxleMult.length) {
            object.AxleMult = [];
            for (let j = 0; j < message.AxleMult.length; ++j)
                object.AxleMult[j] = $root.SuperAceAxleMult.toObject(message.AxleMult[j], options);
        }
        return object;
    };

    /**
     * Converts this SuperAceSrvToDeskPushDeskInfo to JSON.
     * @function toJSON
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperAceSrvToDeskPushDeskInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SuperAceSrvToDeskPushDeskInfo
     * @function getTypeUrl
     * @memberof SuperAceSrvToDeskPushDeskInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SuperAceSrvToDeskPushDeskInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SuperAceSrvToDeskPushDeskInfo";
    };

    return SuperAceSrvToDeskPushDeskInfo;
})();

export const ClientSuperAceSrvReqBet = $root.ClientSuperAceSrvReqBet = (() => {

    /**
     * Properties of a ClientSuperAceSrvReqBet.
     * @exports IClientSuperAceSrvReqBet
     * @interface IClientSuperAceSrvReqBet
     * @property {number|null} [DeskNo] ClientSuperAceSrvReqBet DeskNo
     * @property {number|null} [UserID] ClientSuperAceSrvReqBet UserID
     * @property {number|null} [SeatNo] ClientSuperAceSrvReqBet SeatNo
     * @property {number|null} [BetType] ClientSuperAceSrvReqBet BetType
     * @property {number|null} [BetGold] ClientSuperAceSrvReqBet BetGold
     */

    /**
     * Constructs a new ClientSuperAceSrvReqBet.
     * @exports ClientSuperAceSrvReqBet
     * @classdesc Represents a ClientSuperAceSrvReqBet.
     * @implements IClientSuperAceSrvReqBet
     * @constructor
     * @param {IClientSuperAceSrvReqBet=} [properties] Properties to set
     */
    function ClientSuperAceSrvReqBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSuperAceSrvReqBet DeskNo.
     * @member {number} DeskNo
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     */
    ClientSuperAceSrvReqBet.prototype.DeskNo = 0;

    /**
     * ClientSuperAceSrvReqBet UserID.
     * @member {number} UserID
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     */
    ClientSuperAceSrvReqBet.prototype.UserID = 0;

    /**
     * ClientSuperAceSrvReqBet SeatNo.
     * @member {number} SeatNo
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     */
    ClientSuperAceSrvReqBet.prototype.SeatNo = 0;

    /**
     * ClientSuperAceSrvReqBet BetType.
     * @member {number} BetType
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     */
    ClientSuperAceSrvReqBet.prototype.BetType = 0;

    /**
     * ClientSuperAceSrvReqBet BetGold.
     * @member {number} BetGold
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     */
    ClientSuperAceSrvReqBet.prototype.BetGold = 0;

    /**
     * Creates a new ClientSuperAceSrvReqBet instance using the specified properties.
     * @function create
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {IClientSuperAceSrvReqBet=} [properties] Properties to set
     * @returns {ClientSuperAceSrvReqBet} ClientSuperAceSrvReqBet instance
     */
    ClientSuperAceSrvReqBet.create = function create(properties) {
        return new ClientSuperAceSrvReqBet(properties);
    };

    /**
     * Encodes the specified ClientSuperAceSrvReqBet message. Does not implicitly {@link ClientSuperAceSrvReqBet.verify|verify} messages.
     * @function encode
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {IClientSuperAceSrvReqBet} message ClientSuperAceSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAceSrvReqBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.SeatNo != null && Object.hasOwnProperty.call(message, "SeatNo"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.SeatNo);
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.BetType);
        if (message.BetGold != null && Object.hasOwnProperty.call(message, "BetGold"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.BetGold);
        return writer;
    };

    /**
     * Encodes the specified ClientSuperAceSrvReqBet message, length delimited. Does not implicitly {@link ClientSuperAceSrvReqBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {IClientSuperAceSrvReqBet} message ClientSuperAceSrvReqBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAceSrvReqBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSuperAceSrvReqBet message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSuperAceSrvReqBet} ClientSuperAceSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAceSrvReqBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSuperAceSrvReqBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.SeatNo = reader.int32();
                    break;
                }
            case 4: {
                    message.BetType = reader.uint32();
                    break;
                }
            case 5: {
                    message.BetGold = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSuperAceSrvReqBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSuperAceSrvReqBet} ClientSuperAceSrvReqBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAceSrvReqBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSuperAceSrvReqBet message.
     * @function verify
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSuperAceSrvReqBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            if (!$util.isInteger(message.SeatNo))
                return "SeatNo: integer expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            if (!$util.isInteger(message.BetGold))
                return "BetGold: integer expected";
        return null;
    };

    /**
     * Creates a ClientSuperAceSrvReqBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSuperAceSrvReqBet} ClientSuperAceSrvReqBet
     */
    ClientSuperAceSrvReqBet.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSuperAceSrvReqBet)
            return object;
        let message = new $root.ClientSuperAceSrvReqBet();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.SeatNo != null)
            message.SeatNo = object.SeatNo | 0;
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        if (object.BetGold != null)
            message.BetGold = object.BetGold >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSuperAceSrvReqBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {ClientSuperAceSrvReqBet} message ClientSuperAceSrvReqBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSuperAceSrvReqBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
            object.SeatNo = 0;
            object.BetType = 0;
            object.BetGold = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.SeatNo != null && message.hasOwnProperty("SeatNo"))
            object.SeatNo = message.SeatNo;
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        if (message.BetGold != null && message.hasOwnProperty("BetGold"))
            object.BetGold = message.BetGold;
        return object;
    };

    /**
     * Converts this ClientSuperAceSrvReqBet to JSON.
     * @function toJSON
     * @memberof ClientSuperAceSrvReqBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSuperAceSrvReqBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSuperAceSrvReqBet
     * @function getTypeUrl
     * @memberof ClientSuperAceSrvReqBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSuperAceSrvReqBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSuperAceSrvReqBet";
    };

    return ClientSuperAceSrvReqBet;
})();

export const ClientSuperAceSrvAckBet = $root.ClientSuperAceSrvAckBet = (() => {

    /**
     * Properties of a ClientSuperAceSrvAckBet.
     * @exports IClientSuperAceSrvAckBet
     * @interface IClientSuperAceSrvAckBet
     * @property {number|null} [Res] ClientSuperAceSrvAckBet Res
     * @property {number|null} [UserID] ClientSuperAceSrvAckBet UserID
     * @property {number|null} [BetType] ClientSuperAceSrvAckBet BetType
     */

    /**
     * Constructs a new ClientSuperAceSrvAckBet.
     * @exports ClientSuperAceSrvAckBet
     * @classdesc Represents a ClientSuperAceSrvAckBet.
     * @implements IClientSuperAceSrvAckBet
     * @constructor
     * @param {IClientSuperAceSrvAckBet=} [properties] Properties to set
     */
    function ClientSuperAceSrvAckBet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSuperAceSrvAckBet Res.
     * @member {number} Res
     * @memberof ClientSuperAceSrvAckBet
     * @instance
     */
    ClientSuperAceSrvAckBet.prototype.Res = 0;

    /**
     * ClientSuperAceSrvAckBet UserID.
     * @member {number} UserID
     * @memberof ClientSuperAceSrvAckBet
     * @instance
     */
    ClientSuperAceSrvAckBet.prototype.UserID = 0;

    /**
     * ClientSuperAceSrvAckBet BetType.
     * @member {number} BetType
     * @memberof ClientSuperAceSrvAckBet
     * @instance
     */
    ClientSuperAceSrvAckBet.prototype.BetType = 0;

    /**
     * Creates a new ClientSuperAceSrvAckBet instance using the specified properties.
     * @function create
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {IClientSuperAceSrvAckBet=} [properties] Properties to set
     * @returns {ClientSuperAceSrvAckBet} ClientSuperAceSrvAckBet instance
     */
    ClientSuperAceSrvAckBet.create = function create(properties) {
        return new ClientSuperAceSrvAckBet(properties);
    };

    /**
     * Encodes the specified ClientSuperAceSrvAckBet message. Does not implicitly {@link ClientSuperAceSrvAckBet.verify|verify} messages.
     * @function encode
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {IClientSuperAceSrvAckBet} message ClientSuperAceSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAceSrvAckBet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Res != null && Object.hasOwnProperty.call(message, "Res"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Res);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        if (message.BetType != null && Object.hasOwnProperty.call(message, "BetType"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.BetType);
        return writer;
    };

    /**
     * Encodes the specified ClientSuperAceSrvAckBet message, length delimited. Does not implicitly {@link ClientSuperAceSrvAckBet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {IClientSuperAceSrvAckBet} message ClientSuperAceSrvAckBet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAceSrvAckBet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSuperAceSrvAckBet message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSuperAceSrvAckBet} ClientSuperAceSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAceSrvAckBet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSuperAceSrvAckBet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.Res = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            case 3: {
                    message.BetType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSuperAceSrvAckBet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSuperAceSrvAckBet} ClientSuperAceSrvAckBet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAceSrvAckBet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSuperAceSrvAckBet message.
     * @function verify
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSuperAceSrvAckBet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Res != null && message.hasOwnProperty("Res"))
            if (!$util.isInteger(message.Res))
                return "Res: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            if (!$util.isInteger(message.BetType))
                return "BetType: integer expected";
        return null;
    };

    /**
     * Creates a ClientSuperAceSrvAckBet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSuperAceSrvAckBet} ClientSuperAceSrvAckBet
     */
    ClientSuperAceSrvAckBet.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSuperAceSrvAckBet)
            return object;
        let message = new $root.ClientSuperAceSrvAckBet();
        if (object.Res != null)
            message.Res = object.Res >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        if (object.BetType != null)
            message.BetType = object.BetType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSuperAceSrvAckBet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {ClientSuperAceSrvAckBet} message ClientSuperAceSrvAckBet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSuperAceSrvAckBet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.Res = 0;
            object.UserID = 0;
            object.BetType = 0;
        }
        if (message.Res != null && message.hasOwnProperty("Res"))
            object.Res = message.Res;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        if (message.BetType != null && message.hasOwnProperty("BetType"))
            object.BetType = message.BetType;
        return object;
    };

    /**
     * Converts this ClientSuperAceSrvAckBet to JSON.
     * @function toJSON
     * @memberof ClientSuperAceSrvAckBet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSuperAceSrvAckBet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSuperAceSrvAckBet
     * @function getTypeUrl
     * @memberof ClientSuperAceSrvAckBet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSuperAceSrvAckBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSuperAceSrvAckBet";
    };

    return ClientSuperAceSrvAckBet;
})();

export const GameResultData = $root.GameResultData = (() => {

    /**
     * Properties of a GameResultData.
     * @exports IGameResultData
     * @interface IGameResultData
     * @property {boolean|null} [IsPrize] GameResultData IsPrize
     * @property {boolean|null} [IsFreeGame] GameResultData IsFreeGame
     * @property {number|Long|null} [PrizeGold] GameResultData PrizeGold
     * @property {Array.<number>|null} [Symbol] GameResultData Symbol
     */

    /**
     * Constructs a new GameResultData.
     * @exports GameResultData
     * @classdesc Represents a GameResultData.
     * @implements IGameResultData
     * @constructor
     * @param {IGameResultData=} [properties] Properties to set
     */
    function GameResultData(properties) {
        this.Symbol = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameResultData IsPrize.
     * @member {boolean} IsPrize
     * @memberof GameResultData
     * @instance
     */
    GameResultData.prototype.IsPrize = false;

    /**
     * GameResultData IsFreeGame.
     * @member {boolean} IsFreeGame
     * @memberof GameResultData
     * @instance
     */
    GameResultData.prototype.IsFreeGame = false;

    /**
     * GameResultData PrizeGold.
     * @member {number|Long} PrizeGold
     * @memberof GameResultData
     * @instance
     */
    GameResultData.prototype.PrizeGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * GameResultData Symbol.
     * @member {Array.<number>} Symbol
     * @memberof GameResultData
     * @instance
     */
    GameResultData.prototype.Symbol = $util.emptyArray;

    /**
     * Creates a new GameResultData instance using the specified properties.
     * @function create
     * @memberof GameResultData
     * @static
     * @param {IGameResultData=} [properties] Properties to set
     * @returns {GameResultData} GameResultData instance
     */
    GameResultData.create = function create(properties) {
        return new GameResultData(properties);
    };

    /**
     * Encodes the specified GameResultData message. Does not implicitly {@link GameResultData.verify|verify} messages.
     * @function encode
     * @memberof GameResultData
     * @static
     * @param {IGameResultData} message GameResultData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameResultData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.IsPrize != null && Object.hasOwnProperty.call(message, "IsPrize"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.IsPrize);
        if (message.IsFreeGame != null && Object.hasOwnProperty.call(message, "IsFreeGame"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsFreeGame);
        if (message.PrizeGold != null && Object.hasOwnProperty.call(message, "PrizeGold"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.PrizeGold);
        if (message.Symbol != null && message.Symbol.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.Symbol.length; ++i)
                writer.uint32(message.Symbol[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified GameResultData message, length delimited. Does not implicitly {@link GameResultData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameResultData
     * @static
     * @param {IGameResultData} message GameResultData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameResultData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameResultData message from the specified reader or buffer.
     * @function decode
     * @memberof GameResultData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameResultData} GameResultData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameResultData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameResultData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.IsPrize = reader.bool();
                    break;
                }
            case 2: {
                    message.IsFreeGame = reader.bool();
                    break;
                }
            case 3: {
                    message.PrizeGold = reader.uint64();
                    break;
                }
            case 4: {
                    if (!(message.Symbol && message.Symbol.length))
                        message.Symbol = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Symbol.push(reader.uint32());
                    } else
                        message.Symbol.push(reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameResultData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameResultData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameResultData} GameResultData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameResultData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameResultData message.
     * @function verify
     * @memberof GameResultData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameResultData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.IsPrize != null && message.hasOwnProperty("IsPrize"))
            if (typeof message.IsPrize !== "boolean")
                return "IsPrize: boolean expected";
        if (message.IsFreeGame != null && message.hasOwnProperty("IsFreeGame"))
            if (typeof message.IsFreeGame !== "boolean")
                return "IsFreeGame: boolean expected";
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (!$util.isInteger(message.PrizeGold) && !(message.PrizeGold && $util.isInteger(message.PrizeGold.low) && $util.isInteger(message.PrizeGold.high)))
                return "PrizeGold: integer|Long expected";
        if (message.Symbol != null && message.hasOwnProperty("Symbol")) {
            if (!Array.isArray(message.Symbol))
                return "Symbol: array expected";
            for (let i = 0; i < message.Symbol.length; ++i)
                if (!$util.isInteger(message.Symbol[i]))
                    return "Symbol: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a GameResultData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameResultData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameResultData} GameResultData
     */
    GameResultData.fromObject = function fromObject(object) {
        if (object instanceof $root.GameResultData)
            return object;
        let message = new $root.GameResultData();
        if (object.IsPrize != null)
            message.IsPrize = Boolean(object.IsPrize);
        if (object.IsFreeGame != null)
            message.IsFreeGame = Boolean(object.IsFreeGame);
        if (object.PrizeGold != null)
            if ($util.Long)
                (message.PrizeGold = $util.Long.fromValue(object.PrizeGold)).unsigned = true;
            else if (typeof object.PrizeGold === "string")
                message.PrizeGold = parseInt(object.PrizeGold, 10);
            else if (typeof object.PrizeGold === "number")
                message.PrizeGold = object.PrizeGold;
            else if (typeof object.PrizeGold === "object")
                message.PrizeGold = new $util.LongBits(object.PrizeGold.low >>> 0, object.PrizeGold.high >>> 0).toNumber(true);
        if (object.Symbol) {
            if (!Array.isArray(object.Symbol))
                throw TypeError(".GameResultData.Symbol: array expected");
            message.Symbol = [];
            for (let i = 0; i < object.Symbol.length; ++i)
                message.Symbol[i] = object.Symbol[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a GameResultData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameResultData
     * @static
     * @param {GameResultData} message GameResultData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameResultData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.Symbol = [];
        if (options.defaults) {
            object.IsPrize = false;
            object.IsFreeGame = false;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PrizeGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PrizeGold = options.longs === String ? "0" : 0;
        }
        if (message.IsPrize != null && message.hasOwnProperty("IsPrize"))
            object.IsPrize = message.IsPrize;
        if (message.IsFreeGame != null && message.hasOwnProperty("IsFreeGame"))
            object.IsFreeGame = message.IsFreeGame;
        if (message.PrizeGold != null && message.hasOwnProperty("PrizeGold"))
            if (typeof message.PrizeGold === "number")
                object.PrizeGold = options.longs === String ? String(message.PrizeGold) : message.PrizeGold;
            else
                object.PrizeGold = options.longs === String ? $util.Long.prototype.toString.call(message.PrizeGold) : options.longs === Number ? new $util.LongBits(message.PrizeGold.low >>> 0, message.PrizeGold.high >>> 0).toNumber(true) : message.PrizeGold;
        if (message.Symbol && message.Symbol.length) {
            object.Symbol = [];
            for (let j = 0; j < message.Symbol.length; ++j)
                object.Symbol[j] = message.Symbol[j];
        }
        return object;
    };

    /**
     * Converts this GameResultData to JSON.
     * @function toJSON
     * @memberof GameResultData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameResultData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GameResultData
     * @function getTypeUrl
     * @memberof GameResultData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GameResultData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GameResultData";
    };

    return GameResultData;
})();

export const ClientSuperAcePushBetDate = $root.ClientSuperAcePushBetDate = (() => {

    /**
     * Properties of a ClientSuperAcePushBetDate.
     * @exports IClientSuperAcePushBetDate
     * @interface IClientSuperAcePushBetDate
     * @property {number|null} [gamedatasize] ClientSuperAcePushBetDate gamedatasize
     * @property {boolean|null} [IsPushFinish] ClientSuperAcePushBetDate IsPushFinish
     * @property {Array.<IGameResultData>|null} [gamedata] ClientSuperAcePushBetDate gamedata
     */

    /**
     * Constructs a new ClientSuperAcePushBetDate.
     * @exports ClientSuperAcePushBetDate
     * @classdesc Represents a ClientSuperAcePushBetDate.
     * @implements IClientSuperAcePushBetDate
     * @constructor
     * @param {IClientSuperAcePushBetDate=} [properties] Properties to set
     */
    function ClientSuperAcePushBetDate(properties) {
        this.gamedata = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSuperAcePushBetDate gamedatasize.
     * @member {number} gamedatasize
     * @memberof ClientSuperAcePushBetDate
     * @instance
     */
    ClientSuperAcePushBetDate.prototype.gamedatasize = 0;

    /**
     * ClientSuperAcePushBetDate IsPushFinish.
     * @member {boolean} IsPushFinish
     * @memberof ClientSuperAcePushBetDate
     * @instance
     */
    ClientSuperAcePushBetDate.prototype.IsPushFinish = false;

    /**
     * ClientSuperAcePushBetDate gamedata.
     * @member {Array.<IGameResultData>} gamedata
     * @memberof ClientSuperAcePushBetDate
     * @instance
     */
    ClientSuperAcePushBetDate.prototype.gamedata = $util.emptyArray;

    /**
     * Creates a new ClientSuperAcePushBetDate instance using the specified properties.
     * @function create
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {IClientSuperAcePushBetDate=} [properties] Properties to set
     * @returns {ClientSuperAcePushBetDate} ClientSuperAcePushBetDate instance
     */
    ClientSuperAcePushBetDate.create = function create(properties) {
        return new ClientSuperAcePushBetDate(properties);
    };

    /**
     * Encodes the specified ClientSuperAcePushBetDate message. Does not implicitly {@link ClientSuperAcePushBetDate.verify|verify} messages.
     * @function encode
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {IClientSuperAcePushBetDate} message ClientSuperAcePushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcePushBetDate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.gamedatasize != null && Object.hasOwnProperty.call(message, "gamedatasize"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.gamedatasize);
        if (message.IsPushFinish != null && Object.hasOwnProperty.call(message, "IsPushFinish"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsPushFinish);
        if (message.gamedata != null && message.gamedata.length)
            for (let i = 0; i < message.gamedata.length; ++i)
                $root.GameResultData.encode(message.gamedata[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientSuperAcePushBetDate message, length delimited. Does not implicitly {@link ClientSuperAcePushBetDate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {IClientSuperAcePushBetDate} message ClientSuperAcePushBetDate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcePushBetDate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSuperAcePushBetDate message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSuperAcePushBetDate} ClientSuperAcePushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcePushBetDate.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSuperAcePushBetDate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.gamedatasize = reader.uint32();
                    break;
                }
            case 2: {
                    message.IsPushFinish = reader.bool();
                    break;
                }
            case 3: {
                    if (!(message.gamedata && message.gamedata.length))
                        message.gamedata = [];
                    message.gamedata.push($root.GameResultData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSuperAcePushBetDate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSuperAcePushBetDate} ClientSuperAcePushBetDate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcePushBetDate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSuperAcePushBetDate message.
     * @function verify
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSuperAcePushBetDate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.gamedatasize != null && message.hasOwnProperty("gamedatasize"))
            if (!$util.isInteger(message.gamedatasize))
                return "gamedatasize: integer expected";
        if (message.IsPushFinish != null && message.hasOwnProperty("IsPushFinish"))
            if (typeof message.IsPushFinish !== "boolean")
                return "IsPushFinish: boolean expected";
        if (message.gamedata != null && message.hasOwnProperty("gamedata")) {
            if (!Array.isArray(message.gamedata))
                return "gamedata: array expected";
            for (let i = 0; i < message.gamedata.length; ++i) {
                let error = $root.GameResultData.verify(message.gamedata[i]);
                if (error)
                    return "gamedata." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientSuperAcePushBetDate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSuperAcePushBetDate} ClientSuperAcePushBetDate
     */
    ClientSuperAcePushBetDate.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSuperAcePushBetDate)
            return object;
        let message = new $root.ClientSuperAcePushBetDate();
        if (object.gamedatasize != null)
            message.gamedatasize = object.gamedatasize >>> 0;
        if (object.IsPushFinish != null)
            message.IsPushFinish = Boolean(object.IsPushFinish);
        if (object.gamedata) {
            if (!Array.isArray(object.gamedata))
                throw TypeError(".ClientSuperAcePushBetDate.gamedata: array expected");
            message.gamedata = [];
            for (let i = 0; i < object.gamedata.length; ++i) {
                if (typeof object.gamedata[i] !== "object")
                    throw TypeError(".ClientSuperAcePushBetDate.gamedata: object expected");
                message.gamedata[i] = $root.GameResultData.fromObject(object.gamedata[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientSuperAcePushBetDate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {ClientSuperAcePushBetDate} message ClientSuperAcePushBetDate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSuperAcePushBetDate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.gamedata = [];
        if (options.defaults) {
            object.gamedatasize = 0;
            object.IsPushFinish = false;
        }
        if (message.gamedatasize != null && message.hasOwnProperty("gamedatasize"))
            object.gamedatasize = message.gamedatasize;
        if (message.IsPushFinish != null && message.hasOwnProperty("IsPushFinish"))
            object.IsPushFinish = message.IsPushFinish;
        if (message.gamedata && message.gamedata.length) {
            object.gamedata = [];
            for (let j = 0; j < message.gamedata.length; ++j)
                object.gamedata[j] = $root.GameResultData.toObject(message.gamedata[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientSuperAcePushBetDate to JSON.
     * @function toJSON
     * @memberof ClientSuperAcePushBetDate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSuperAcePushBetDate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSuperAcePushBetDate
     * @function getTypeUrl
     * @memberof ClientSuperAcePushBetDate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSuperAcePushBetDate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSuperAcePushBetDate";
    };

    return ClientSuperAcePushBetDate;
})();

export const ClientSuperAcecCartoonReq = $root.ClientSuperAcecCartoonReq = (() => {

    /**
     * Properties of a ClientSuperAcecCartoonReq.
     * @exports IClientSuperAcecCartoonReq
     * @interface IClientSuperAcecCartoonReq
     * @property {number|null} [DeskNo] ClientSuperAcecCartoonReq DeskNo
     * @property {number|null} [UserID] ClientSuperAcecCartoonReq UserID
     */

    /**
     * Constructs a new ClientSuperAcecCartoonReq.
     * @exports ClientSuperAcecCartoonReq
     * @classdesc Represents a ClientSuperAcecCartoonReq.
     * @implements IClientSuperAcecCartoonReq
     * @constructor
     * @param {IClientSuperAcecCartoonReq=} [properties] Properties to set
     */
    function ClientSuperAcecCartoonReq(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSuperAcecCartoonReq DeskNo.
     * @member {number} DeskNo
     * @memberof ClientSuperAcecCartoonReq
     * @instance
     */
    ClientSuperAcecCartoonReq.prototype.DeskNo = 0;

    /**
     * ClientSuperAcecCartoonReq UserID.
     * @member {number} UserID
     * @memberof ClientSuperAcecCartoonReq
     * @instance
     */
    ClientSuperAcecCartoonReq.prototype.UserID = 0;

    /**
     * Creates a new ClientSuperAcecCartoonReq instance using the specified properties.
     * @function create
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {IClientSuperAcecCartoonReq=} [properties] Properties to set
     * @returns {ClientSuperAcecCartoonReq} ClientSuperAcecCartoonReq instance
     */
    ClientSuperAcecCartoonReq.create = function create(properties) {
        return new ClientSuperAcecCartoonReq(properties);
    };

    /**
     * Encodes the specified ClientSuperAcecCartoonReq message. Does not implicitly {@link ClientSuperAcecCartoonReq.verify|verify} messages.
     * @function encode
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {IClientSuperAcecCartoonReq} message ClientSuperAcecCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcecCartoonReq.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.DeskNo != null && Object.hasOwnProperty.call(message, "DeskNo"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.DeskNo);
        if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.UserID);
        return writer;
    };

    /**
     * Encodes the specified ClientSuperAcecCartoonReq message, length delimited. Does not implicitly {@link ClientSuperAcecCartoonReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {IClientSuperAcecCartoonReq} message ClientSuperAcecCartoonReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcecCartoonReq.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSuperAcecCartoonReq message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSuperAcecCartoonReq} ClientSuperAcecCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcecCartoonReq.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSuperAcecCartoonReq();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.DeskNo = reader.uint32();
                    break;
                }
            case 2: {
                    message.UserID = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSuperAcecCartoonReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSuperAcecCartoonReq} ClientSuperAcecCartoonReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcecCartoonReq.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSuperAcecCartoonReq message.
     * @function verify
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSuperAcecCartoonReq.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            if (!$util.isInteger(message.DeskNo))
                return "DeskNo: integer expected";
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            if (!$util.isInteger(message.UserID))
                return "UserID: integer expected";
        return null;
    };

    /**
     * Creates a ClientSuperAcecCartoonReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSuperAcecCartoonReq} ClientSuperAcecCartoonReq
     */
    ClientSuperAcecCartoonReq.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSuperAcecCartoonReq)
            return object;
        let message = new $root.ClientSuperAcecCartoonReq();
        if (object.DeskNo != null)
            message.DeskNo = object.DeskNo >>> 0;
        if (object.UserID != null)
            message.UserID = object.UserID >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ClientSuperAcecCartoonReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {ClientSuperAcecCartoonReq} message ClientSuperAcecCartoonReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSuperAcecCartoonReq.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.DeskNo = 0;
            object.UserID = 0;
        }
        if (message.DeskNo != null && message.hasOwnProperty("DeskNo"))
            object.DeskNo = message.DeskNo;
        if (message.UserID != null && message.hasOwnProperty("UserID"))
            object.UserID = message.UserID;
        return object;
    };

    /**
     * Converts this ClientSuperAcecCartoonReq to JSON.
     * @function toJSON
     * @memberof ClientSuperAcecCartoonReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSuperAcecCartoonReq.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSuperAcecCartoonReq
     * @function getTypeUrl
     * @memberof ClientSuperAcecCartoonReq
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSuperAcecCartoonReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSuperAcecCartoonReq";
    };

    return ClientSuperAcecCartoonReq;
})();

export const ClientSuperAcePushGameEndData = $root.ClientSuperAcePushGameEndData = (() => {

    /**
     * Properties of a ClientSuperAcePushGameEndData.
     * @exports IClientSuperAcePushGameEndData
     * @interface IClientSuperAcePushGameEndData
     * @property {number|Long|null} [PlayerGold] ClientSuperAcePushGameEndData PlayerGold
     */

    /**
     * Constructs a new ClientSuperAcePushGameEndData.
     * @exports ClientSuperAcePushGameEndData
     * @classdesc Represents a ClientSuperAcePushGameEndData.
     * @implements IClientSuperAcePushGameEndData
     * @constructor
     * @param {IClientSuperAcePushGameEndData=} [properties] Properties to set
     */
    function ClientSuperAcePushGameEndData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientSuperAcePushGameEndData PlayerGold.
     * @member {number|Long} PlayerGold
     * @memberof ClientSuperAcePushGameEndData
     * @instance
     */
    ClientSuperAcePushGameEndData.prototype.PlayerGold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new ClientSuperAcePushGameEndData instance using the specified properties.
     * @function create
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {IClientSuperAcePushGameEndData=} [properties] Properties to set
     * @returns {ClientSuperAcePushGameEndData} ClientSuperAcePushGameEndData instance
     */
    ClientSuperAcePushGameEndData.create = function create(properties) {
        return new ClientSuperAcePushGameEndData(properties);
    };

    /**
     * Encodes the specified ClientSuperAcePushGameEndData message. Does not implicitly {@link ClientSuperAcePushGameEndData.verify|verify} messages.
     * @function encode
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {IClientSuperAcePushGameEndData} message ClientSuperAcePushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcePushGameEndData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.PlayerGold != null && Object.hasOwnProperty.call(message, "PlayerGold"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.PlayerGold);
        return writer;
    };

    /**
     * Encodes the specified ClientSuperAcePushGameEndData message, length delimited. Does not implicitly {@link ClientSuperAcePushGameEndData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {IClientSuperAcePushGameEndData} message ClientSuperAcePushGameEndData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientSuperAcePushGameEndData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientSuperAcePushGameEndData message from the specified reader or buffer.
     * @function decode
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientSuperAcePushGameEndData} ClientSuperAcePushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcePushGameEndData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientSuperAcePushGameEndData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.PlayerGold = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientSuperAcePushGameEndData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientSuperAcePushGameEndData} ClientSuperAcePushGameEndData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientSuperAcePushGameEndData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientSuperAcePushGameEndData message.
     * @function verify
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientSuperAcePushGameEndData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (!$util.isInteger(message.PlayerGold) && !(message.PlayerGold && $util.isInteger(message.PlayerGold.low) && $util.isInteger(message.PlayerGold.high)))
                return "PlayerGold: integer|Long expected";
        return null;
    };

    /**
     * Creates a ClientSuperAcePushGameEndData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientSuperAcePushGameEndData} ClientSuperAcePushGameEndData
     */
    ClientSuperAcePushGameEndData.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientSuperAcePushGameEndData)
            return object;
        let message = new $root.ClientSuperAcePushGameEndData();
        if (object.PlayerGold != null)
            if ($util.Long)
                (message.PlayerGold = $util.Long.fromValue(object.PlayerGold)).unsigned = true;
            else if (typeof object.PlayerGold === "string")
                message.PlayerGold = parseInt(object.PlayerGold, 10);
            else if (typeof object.PlayerGold === "number")
                message.PlayerGold = object.PlayerGold;
            else if (typeof object.PlayerGold === "object")
                message.PlayerGold = new $util.LongBits(object.PlayerGold.low >>> 0, object.PlayerGold.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a ClientSuperAcePushGameEndData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {ClientSuperAcePushGameEndData} message ClientSuperAcePushGameEndData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientSuperAcePushGameEndData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.PlayerGold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.PlayerGold = options.longs === String ? "0" : 0;
        if (message.PlayerGold != null && message.hasOwnProperty("PlayerGold"))
            if (typeof message.PlayerGold === "number")
                object.PlayerGold = options.longs === String ? String(message.PlayerGold) : message.PlayerGold;
            else
                object.PlayerGold = options.longs === String ? $util.Long.prototype.toString.call(message.PlayerGold) : options.longs === Number ? new $util.LongBits(message.PlayerGold.low >>> 0, message.PlayerGold.high >>> 0).toNumber(true) : message.PlayerGold;
        return object;
    };

    /**
     * Converts this ClientSuperAcePushGameEndData to JSON.
     * @function toJSON
     * @memberof ClientSuperAcePushGameEndData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientSuperAcePushGameEndData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientSuperAcePushGameEndData
     * @function getTypeUrl
     * @memberof ClientSuperAcePushGameEndData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientSuperAcePushGameEndData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientSuperAcePushGameEndData";
    };

    return ClientSuperAcePushGameEndData;
})();

/**
 * MessageID enum.
 * @exports MessageID
 * @enum {number}
 * @property {number} MSG_BEGIN=0 MSG_BEGIN value
 * @property {number} MSG_WATCH_HEART_BEAT_REQ=368 MSG_WATCH_HEART_BEAT_REQ value
 * @property {number} MSG_WATCH_HEART_BEAT_ACK=369 MSG_WATCH_HEART_BEAT_ACK value
 * @property {number} MSG_SERVER_HEART_BEAT_REQ=370 MSG_SERVER_HEART_BEAT_REQ value
 * @property {number} MSG_SERVER_HEART_BEAT_ACK=371 MSG_SERVER_HEART_BEAT_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_MSGID_BEGIN=1000000 MSGID_CIENT_PROXY_SVR_MSGID_BEGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_LOGIN=1000001 MSGID_CIENT_PROXY_SVR_REQ_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_LOGIN=1000002 MSGID_CIENT_PROXY_SVR_ACK_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_HEART_BEAT_REQ=1000003 MSGID_CIENT_PROXY_HEART_BEAT_REQ value
 * @property {number} MSGID_CIENT_PROXY_HEART_BEAT_ACK=1000004 MSGID_CIENT_PROXY_HEART_BEAT_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_LOGOUT=1000005 MSGID_CIENT_PROXY_SVR_REQ_LOGOUT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_LOGOUT=1000006 MSGID_CIENT_PROXY_SVR_ACK_LOGOUT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_POKER_PRODUCT=1000007 MSGID_CIENT_PROXY_SVR_REQ_POKER_PRODUCT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_POKER_PRODUCT=1000008 MSGID_CIENT_PROXY_SVR_ACK_POKER_PRODUCT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_ENTER_GAME=1000009 MSGID_CIENT_PROXY_SVR_REQ_ENTER_GAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_ENTER_GAME=1000010 MSGID_CIENT_PROXY_SVR_ACK_ENTER_GAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MOBILE_REGISTER=1000011 MSGID_CIENT_PROXY_SVR_REQ_MOBILE_REGISTER value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MOBILE_REGISTER=1000012 MSGID_CIENT_PROXY_SVR_ACK_MOBILE_REGISTER value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MOBILE_SMS_CODE=1000013 MSGID_CIENT_PROXY_SVR_REQ_MOBILE_SMS_CODE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MOBILE_SMS_CODE=1000014 MSGID_CIENT_PROXY_SVR_ACK_MOBILE_SMS_CODE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MOBILE_RESET_PWD=1000015 MSGID_CIENT_PROXY_SVR_REQ_MOBILE_RESET_PWD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MOBILE_RESET_PWD=1000016 MSGID_CIENT_PROXY_SVR_ACK_MOBILE_RESET_PWD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_LEAVE_GAME=1000017 MSGID_CIENT_PROXY_SVR_REQ_LEAVE_GAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_LEAVE_GAME=1000018 MSGID_CIENT_PROXY_SVR_ACK_LEAVE_GAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_ARRIVE=1000019 MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_ARRIVE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_SITDOWN=1000020 MSGID_CIENT_PROXY_SVR_REQ_SITDOWN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_SITDOWN=1000021 MSGID_CIENT_PROXY_SVR_ACK_SITDOWN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_STANDUP=1000022 MSGID_CIENT_PROXY_SVR_REQ_STANDUP value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_STANDUP=1000023 MSGID_CIENT_PROXY_SVR_ACK_STANDUP value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_GOLDCHANGE=1000024 MSGID_CIENT_PROXY_SVR_PUSH_GOLDCHANGE value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_LIGHT=1000025 MSGID_CIENT_PROXY_SVR_PUSH_LIGHT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_SWITCH_TABLE=1000026 MSGID_CIENT_PROXY_SVR_REQ_SWITCH_TABLE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_SWITCH_TABLE=1000027 MSGID_CIENT_PROXY_SVR_ACK_SWITCH_TABLE value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_PAY_NOTIY=1000028 MSGID_CIENT_PROXY_SVR_PUSH_PAY_NOTIY value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_WITH_DRAW=1000029 MSGID_CIENT_PROXY_SVR_REQ_WITH_DRAW value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_WITH_DRAW=1000030 MSGID_CIENT_PROXY_SVR_ACK_WITH_DRAW value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_TOKEN=1000031 MSGID_CIENT_PROXY_SVR_REQ_TOKEN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_TOKEN=1000032 MSGID_CIENT_PROXY_SVR_ACK_TOKEN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_BALANCE=1000033 MSGID_CIENT_PROXY_SVR_REQ_GET_BALANCE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_BALANCE=1000034 MSGID_CIENT_PROXY_SVR_ACK_GET_BALANCE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_WITH_DARAW_RECORD=1000035 MSGID_CIENT_PROXY_SVR_REQ_WITH_DARAW_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_WITH_DARAW_RECORD=1000036 MSGID_CIENT_PROXY_SVR_ACK_WITH_DARAW_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_KICKOUT_USER=1000037 MSGID_CIENT_PROXY_SVR_KICKOUT_USER value
 * @property {number} MSGID_CIENT_PROXY_SVR_USER_BREAK=1000038 MSGID_CIENT_PROXY_SVR_USER_BREAK value
 * @property {number} MSGID_CIENT_PROXY_SVR_USER_RESUME=1000039 MSGID_CIENT_PROXY_SVR_USER_RESUME value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_TEEN_PATTI_PRODUCT=1000040 MSGID_CIENT_PROXY_SVR_ACK_TEEN_PATTI_PRODUCT value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_SYS_MSG=1000041 MSGID_CIENT_PROXY_SVR_PUSH_SYS_MSG value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_CHECK_MOBILE_USED=1000042 MSGID_CIENT_PROXY_SVR_REQ_CHECK_MOBILE_USED value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_CHECK_MOBILE_USED=1000043 MSGID_CIENT_PROXY_SVR_ACK_CHECK_MOBILE_USED value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_PRODUCT_LIST=1000044 MSGID_CIENT_PROXY_SVR_REQ_GET_PRODUCT_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_PRODUCT_LIST=1000045 MSGID_CIENT_PROXY_SVR_ACK_GET_PRODUCT_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MODIFY_NICKNAME=1000046 MSGID_CIENT_PROXY_SVR_REQ_MODIFY_NICKNAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MODIFY_NICKNAME=1000047 MSGID_CIENT_PROXY_SVR_ACK_MODIFY_NICKNAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_MODIFY_HEAD=1000048 MSGID_CIENT_PROXY_SVR_PUSH_MODIFY_HEAD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MOBILE_LOGIN=1000049 MSGID_CIENT_PROXY_SVR_REQ_MOBILE_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MOBILE_LOGIN=1000050 MSGID_CIENT_PROXY_SVR_ACK_MOBILE_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_TOKEN_LOGIN=1000051 MSGID_CIENT_PROXY_SVR_REQ_TOKEN_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_TOKEN_LOGIN=1000052 MSGID_CIENT_PROXY_SVR_ACK_TOKEN_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_REBATE_RECORD=1000053 MSGID_CIENT_PROXY_SVR_REQ_REBATE_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_REBATE_RECORD=1000054 MSGID_CIENT_PROXY_SVR_ACK_REBATE_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_SET_AGENT=1000055 MSGID_CIENT_PROXY_SVR_REQ_SET_AGENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_SET_AGENT=1000056 MSGID_CIENT_PROXY_SVR_ACK_SET_AGENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_SYS_MAIN=1000057 MSGID_CIENT_PROXY_SVR_PUSH_SYS_MAIN value
 * @property {number} MSGID_CLIENT_PROXY_SVR_REQ_REBATE_INFO=1000058 MSGID_CLIENT_PROXY_SVR_REQ_REBATE_INFO value
 * @property {number} MSGID_CLIENT_PROXY_SVR_ACK_REBATE_INFO=1000059 MSGID_CLIENT_PROXY_SVR_ACK_REBATE_INFO value
 * @property {number} MSGID_CLIENT_PROXY_SVR_REQ_TIME=1000060 MSGID_CLIENT_PROXY_SVR_REQ_TIME value
 * @property {number} MSGID_CLIENT_PROXY_SVR_ACK_TIME=1000061 MSGID_CLIENT_PROXY_SVR_ACK_TIME value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_SIMULATOR=1000062 MSGID_CIENT_PROXY_SVR_PUSH_SIMULATOR value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_INGAME=1000063 MSGID_CIENT_PROXY_SVR_PUSH_INGAME value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_LBS=1000064 MSGID_CIENT_PROXY_SVR_PUSH_LBS value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_STATEMENT=1000065 MSGID_CIENT_PROXY_SVR_REQ_STATEMENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_STATEMENT=1000066 MSGID_CIENT_PROXY_SVR_ACK_STATEMENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_CHECK_ISPAY=1000067 MSGID_CIENT_PROXY_SVR_REQ_CHECK_ISPAY value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_CHECK_ISPAY=1000068 MSGID_CIENT_PROXY_SVR_ACK_CHECK_ISPAY value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_TRANS_MSG=1000069 MSGID_CIENT_PROXY_SVR_PUSH_TRANS_MSG value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_KYC=1000070 MSGID_CIENT_PROXY_SVR_REQ_GET_KYC value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_KYC=1000071 MSGID_CIENT_PROXY_SVR_ACK_GET_KYC value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_CHECK_KYCINFO=1000072 MSGID_CIENT_PROXY_SVR_REQ_CHECK_KYCINFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_CHECK_KYCINFO=1000073 MSGID_CIENT_PROXY_SVR_ACK_CHECK_KYCINFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_CHECK_SMS=1000074 MSGID_CIENT_PROXY_SVR_REQ_CHECK_SMS value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_CHECK_SMS=1000075 MSGID_CIENT_PROXY_SVR_ACK_CHECK_SMS value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_GAMECOUNT=1000076 MSGID_CIENT_PROXY_SVR_REQ_GET_GAMECOUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_GAMECOUNT=1000077 MSGID_CIENT_PROXY_SVR_ACK_GET_GAMECOUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_PAY_RECORD=1000078 MSGID_CIENT_PROXY_SVR_REQ_GET_PAY_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_PAY_RECORD=1000079 MSGID_CIENT_PROXY_SVR_ACK_GET_PAY_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_PID_PLAYER_COUNT=1000080 MSGID_CIENT_PROXY_SVR_REQ_PID_PLAYER_COUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_PID_PLAYER_COUNT=1000081 MSGID_CIENT_PROXY_SVR_ACK_PID_PLAYER_COUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN_CONFIG=1000082 MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN_CONFIG value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN_CONFIG=1000083 MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN_CONFIG value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN=1000084 MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN=1000085 MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_CUMULATIVE_DAYS=1000086 MSGID_CIENT_PROXY_SVR_REQ_GET_CUMULATIVE_DAYS value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_CUMULATIVE_DAYS=1000087 MSGID_CIENT_PROXY_SVR_ACK_GET_CUMULATIVE_DAYS value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_PAYMENT=1000088 MSGID_CIENT_PROXY_SVR_REQ_PAYMENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_PAYMENT=1000089 MSGID_CIENT_PROXY_SVR_ACK_PAYMENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_KEY=1000090 MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_KEY value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_KEY=1000091 MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_KEY value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_ORDERID=1000092 MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_ORDERID value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_ORDERID=1000093 MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_ORDERID value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_COUNT=1000094 MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_COUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_COUNT=1000095 MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_COUNT value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_LIST=1000096 MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_LIST=1000097 MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_CONTENT=1000098 MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_CONTENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_CONTENT=1000099 MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_CONTENT value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_UPDATE=1000100 MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_UPDATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_CHECK_CASHINFO=1000101 MSGID_CIENT_PROXY_SVR_REQ_CHECK_CASHINFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_CHECK_CASHINFO=1000102 MSGID_CIENT_PROXY_SVR_ACK_CHECK_CASHINFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MODIFY_PLAYHEAD=1000103 MSGID_CIENT_PROXY_SVR_REQ_MODIFY_PLAYHEAD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MODIFY_PLAYHEAD=1000104 MSGID_CIENT_PROXY_SVR_ACK_MODIFY_PLAYHEAD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_AFSIGN_MESSAGE=1000107 MSGID_CIENT_PROXY_SVR_REQ_AFSIGN_MESSAGE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_AFSIGN_MESSAGE=1000108 MSGID_CIENT_PROXY_SVR_ACK_AFSIGN_MESSAGE value
 * @property {number} MSGTD_WEH_PROXY_SVR_TRA_CLIENT_SEALUSER=1000200 MSGTD_WEH_PROXY_SVR_TRA_CLIENT_SEALUSER value
 * @property {number} MSGTD_WEB_PROXY_SVR_TRA_ALLGAME_SEALUSER=1000201 MSGTD_WEB_PROXY_SVR_TRA_ALLGAME_SEALUSER value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_TOURNEY=1000300 MSGID_CIENT_PROXY_SVR_REQ_GET_TOURNEY value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_TOURNEY=1000301 MSGID_CIENT_PROXY_SVR_ACK_GET_TOURNEY value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_GAME_LIST=1000302 MSGID_CIENT_PROXY_SVR_REQ_GET_GAME_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_GAME_LIST=1000303 MSGID_CIENT_PROXY_SVR_ACK_GET_GAME_LIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_CASH_MARK=1000304 MSGID_CIENT_PROXY_SVR_REQ_GET_CASH_MARK value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_CASH_MARK=1000305 MSGID_CIENT_PROXY_SVR_ACK_GET_CASH_MARK value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_APPLE_LOGIN=1000306 MSGID_CIENT_PROXY_SVR_REQ_APPLE_LOGIN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_RECORD=1000307 MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_RECORD=1000308 MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_RECORD value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_BALANCE_DETAIL=1000309 MSGID_CIENT_PROXY_SVR_REQ_BALANCE_DETAIL value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_BALANCE_DETAIL=1000310 MSGID_CIENT_PROXY_SVR_ACK_BALANCE_DETAIL value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_ACTIVITY_DETAIL=1000311 MSGID_CIENT_PROXY_SVR_REQ_ACTIVITY_DETAIL value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_ACTIVITY_DETAIL=1000312 MSGID_CIENT_PROXY_SVR_ACK_ACTIVITY_DETAIL value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_APPLE_CANCEL=1000313 MSGID_CIENT_PROXY_SVR_REQ_APPLE_CANCEL value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_APPLE_CANCEL=1000314 MSGID_CIENT_PROXY_SVR_ACK_APPLE_CANCEL value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_AGENT_REBATE=1000315 MSGID_CIENT_PROXY_SVR_REQ_AGENT_REBATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_AGENT_REBATE=1000316 MSGID_CIENT_PROXY_SVR_ACK_AGENT_REBATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_REBATE_INFO=1000317 MSGID_CIENT_PROXY_SVR_REQ_REBATE_INFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_REBATE_INFO=1000318 MSGID_CIENT_PROXY_SVR_ACK_REBATE_INFO value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_GET_REBATE=1000319 MSGID_CIENT_PROXY_SVR_REQ_GET_REBATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_GET_REBATE=1000320 MSGID_CIENT_PROXY_SVR_ACK_GET_REBATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_UPDATE=1000321 MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_UPDATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_UPDATE=1000322 MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_UPDATE value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MATCHLIST=1000323 MSGID_CIENT_PROXY_SVR_REQ_MATCHLIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MATCHLIST=1000324 MSGID_CIENT_PROXY_SVR_ACK_MATCHLIST value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN=1000325 MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN=1000326 MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN_CANCEL=1000327 MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN_CANCEL value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN_CANCEL=1000328 MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN_CANCEL value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQ_MATCH_SCHEDULE=1000329 MSGID_CIENT_PROXY_SVR_REQ_MATCH_SCHEDULE value
 * @property {number} MSGID_CIENT_PROXY_SVR_ACK_MATCH_SCHEDULE=1000330 MSGID_CIENT_PROXY_SVR_ACK_MATCH_SCHEDULE value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_MATCH_RESULT=1000331 MSGID_CIENT_PROXY_SVR_PUSH_MATCH_RESULT value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_MATCH_SCHEDULE=1000332 MSGID_CIENT_PROXY_SVR_PUSH_MATCH_SCHEDULE value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_STATUS=1000333 MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_STATUS value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_ACTIVITY_STATUS=1000334 MSGID_CIENT_PROXY_SVR_PUSH_ACTIVITY_STATUS value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_BROKEDATA_STATUS=1000335 MSGID_CIENT_PROXY_SVR_PUSH_BROKEDATA_STATUS value
 * @property {number} MSGID_CIENT_PROXY_SVR_PUSH_GAME_JACKPOT=1000336 MSGID_CIENT_PROXY_SVR_PUSH_GAME_JACKPOT value
 * @property {number} MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_REQ=1000337 MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_ACK=1000338 MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_REQ=1000339 MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_ACK=1000340 MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_ACK value
 * @property {number} MSGID_CIENT_ROUTE_SVR_PROXY_PLAYER_STATUS=1000341 MSGID_CIENT_ROUTE_SVR_PROXY_PLAYER_STATUS value
 * @property {number} MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_REQ=1000342 MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_ACK=1000343 MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_REQ=1000344 MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_ACK=1000345 MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_DRAWNUM_REQ=1000346 MSGID_CIENT_BOUNS_SVR_DRAWNUM_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_DRAWNUM_ACK=1000347 MSGID_CIENT_BOUNS_SVR_DRAWNUM_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE_REQ=1000348 MSGID_CIENT_BOUNS_SVR_TURNTABLE_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE_ACK=1000349 MSGID_CIENT_BOUNS_SVR_TURNTABLE_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGDATA_REQ=1000350 MSGID_CIENT_HALL_SVR_RANKINGDATA_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGDATA_ACK=1000351 MSGID_CIENT_HALL_SVR_RANKINGDATA_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_REQ=1000352 MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_ACK=1000353 MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_REQ=1000354 MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_ACK=1000355 MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_REQ=1000356 MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_ACK=1000357 MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_CP2D_BET_REQ=1000358 MSGID_CIENT_HALL_SVR_CP2D_BET_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_CP2D_BET_ACK=1000359 MSGID_CIENT_HALL_SVR_CP2D_BET_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE2_REQ=1000360 MSGID_CIENT_BOUNS_SVR_TURNTABLE2_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE2_ACK=1000361 MSGID_CIENT_BOUNS_SVR_TURNTABLE2_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_REQ=1000362 MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_ACK=1000363 MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_REQ=1000364 MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_ACK=1000365 MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_CP3D_BET_REQ=1000366 MSGID_CIENT_HALL_SVR_CP3D_BET_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_CP3D_BET_ACK=1000367 MSGID_CIENT_HALL_SVR_CP3D_BET_ACK value
 * @property {number} MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_REQ=1000368 MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_REQ value
 * @property {number} MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_ACK=1000369 MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_REQ=1000370 MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_ACK=1000371 MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_REQ=1000372 MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_ACK=1000373 MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_REQ=1000374 MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_ACK=1000375 MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_REQ=1000376 MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_ACK=1000377 MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_REQ=1000378 MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_ACK=1000379 MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_ACK value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_REQ=1000380 MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_REQ value
 * @property {number} MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_ACK=1000381 MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQISTER_REQ=1000382 MSGID_CIENT_PROXY_SVR_REQISTER_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_REQISTER_ACK=1000383 MSGID_CIENT_PROXY_SVR_REQISTER_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_LOGGING_REQ=1000384 MSGID_CIENT_PROXY_SVR_LOGGING_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_LOGGING_ACK=1000385 MSGID_CIENT_PROXY_SVR_LOGGING_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_REQ=1000386 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_ACK=1000387 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_REQ=1000388 MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_ACK=1000389 MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_REQ=1000390 MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_ACK=1000391 MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_REQ=1000392 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_ACK=1000393 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_REQ=1000394 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_ACK=1000395 MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_REQ=1000396 MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_ACK=1000397 MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_REQ=1000398 MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_ACK=1000399 MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_REQ=1000400 MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_ACK=1000401 MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOXACT_REQ=1000402 MSGID_CIENT_PROXY_SVR_BOXACT_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOXACT_ACK=1000403 MSGID_CIENT_PROXY_SVR_BOXACT_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOXACT_GET_REQ=1000404 MSGID_CIENT_PROXY_SVR_BOXACT_GET_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_BOXACT_GET_ACK=1000405 MSGID_CIENT_PROXY_SVR_BOXACT_GET_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_ACT_REQ=1000406 MSGID_CIENT_PROXY_SVR_GEM_ACT_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_ACT_ACK=1000407 MSGID_CIENT_PROXY_SVR_GEM_ACT_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_DATA_REQ=1000408 MSGID_CIENT_PROXY_SVR_GEM_DATA_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_DATA_ACK=1000409 MSGID_CIENT_PROXY_SVR_GEM_DATA_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_GET_REQ=1000410 MSGID_CIENT_PROXY_SVR_GEM_GET_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_GET_ACK=1000411 MSGID_CIENT_PROXY_SVR_GEM_GET_ACK value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_PRIZE_REQ=1000412 MSGID_CIENT_PROXY_SVR_GEM_PRIZE_REQ value
 * @property {number} MSGID_CIENT_PROXY_SVR_GEM_PRIZE_ACK=1000413 MSGID_CIENT_PROXY_SVR_GEM_PRIZE_ACK value
 * @property {number} MSGID_CLIENT_GATE_SVR_BEGIN=1009900 MSGID_CLIENT_GATE_SVR_BEGIN value
 * @property {number} MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_REQ=1009901 MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_REQ value
 * @property {number} MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_ACK=1009902 MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_ACK value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_MSGID_BEGIN=1010000 MSGID_CIENT_PROXY_GAME_SVR_MSGID_BEGIN value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_REQ_TEST=1010001 MSGID_CIENT_PROXY_GAME_SVR_REQ_TEST value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_ACK_TEST=1010002 MSGID_CIENT_PROXY_GAME_SVR_ACK_TEST value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_REQ_EMOJI=1010003 MSGID_CIENT_PROXY_GAME_SVR_REQ_EMOJI value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_ACK_EMOJI=1010004 MSGID_CIENT_PROXY_GAME_SVR_ACK_EMOJI value
 * @property {number} MSGID_CIENT_PROXY_GAME_SVR_MSGID_END=1020000 MSGID_CIENT_PROXY_GAME_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_MSGID_BEGIN=3000000 MSGID_PROXY_ACCOUNT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_CheckClient_Mark=3000001 MSGID_PROXY_ACCOUNT_REQ_CheckClient_Mark value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_CheckClient_Mark=3000002 MSGID_PROXY_ACCOUNT_ACK_CheckClient_Mark value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MOBILE_SMS_CODE=3000003 MSGID_PROXY_ACCOUNT_REQ_MOBILE_SMS_CODE value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MOBILE_SMS_CODE=3000004 MSGID_PROXY_ACCOUNT_ACK_MOBILE_SMS_CODE value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MOBILE_REGISTER=3000005 MSGID_PROXY_ACCOUNT_REQ_MOBILE_REGISTER value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MOBILE_REGISTER=3000006 MSGID_PROXY_ACCOUNT_ACK_MOBILE_REGISTER value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MOBILE_LOGIN=3000007 MSGID_PROXY_ACCOUNT_REQ_MOBILE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MOBILE_LOGIN=3000008 MSGID_PROXY_ACCOUNT_ACK_MOBILE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_FACEBOOK_LOGIN=3000009 MSGID_PROXY_ACCOUNT_REQ_FACEBOOK_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_FACEBOOK_LOGIN=3000010 MSGID_PROXY_ACCOUNT_ACK_FACEBOOK_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MOBILE_RESET_PWD=3000011 MSGID_PROXY_ACCOUNT_REQ_MOBILE_RESET_PWD value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MOBILE_RESET_PWD=3000012 MSGID_PROXY_ACCOUNT_ACK_MOBILE_RESET_PWD value
 * @property {number} MSGID_PROXY_ACCOUNT_PUSH_LOGIN_SUCCESS=3000013 MSGID_PROXY_ACCOUNT_PUSH_LOGIN_SUCCESS value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_WITH_DRAW=3000014 MSGID_PROXY_ACCOUNT_REQ_WITH_DRAW value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_WITH_DRAW=3000015 MSGID_PROXY_ACCOUNT_ACK_WITH_DRAW value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_GET_BALANCE=3000016 MSGID_PROXY_ACCOUNT_REQ_GET_BALANCE value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_GET_BALANCE=3000017 MSGID_PROXY_ACCOUNT_ACK_GET_BALANCE value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_WITH_DARAW_RECORD=3000018 MSGID_PROXY_ACCOUNT_REQ_WITH_DARAW_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_WITH_DARAW_RECORD=3000019 MSGID_PROXY_ACCOUNT_ACK_WITH_DARAW_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_GET_SYS_MSG=3000020 MSGID_PROXY_ACCOUNT_REQ_GET_SYS_MSG value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_GET_SYS_MSG=3000021 MSGID_PROXY_ACCOUNT_ACK_GET_SYS_MSG value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_CHECK_MOBLIE_USED=3000022 MSGID_PROXY_ACCOUNT_REQ_CHECK_MOBLIE_USED value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_CHECK_MOBLIE_USED=3000023 MSGID_PROXY_ACCOUNT_ACK_CHECK_MOBLIE_USED value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MODIFY_NICKNAME=3000024 MSGID_PROXY_ACCOUNT_REQ_MODIFY_NICKNAME value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MODIFY_NICKNAME=3000025 MSGID_PROXY_ACCOUNT_ACK_MODIFY_NICKNAME value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_GET_TOKEN=3000026 MSGID_PROXY_ACCOUNT_REQ_GET_TOKEN value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_GET_TOKEN=3000027 MSGID_PROXY_ACCOUNT_ACK_GET_TOKEN value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_NEW_MOBILE_LOGIN=3000028 MSGID_PROXY_ACCOUNT_REQ_NEW_MOBILE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_NEW_MOBILE_LOGIN=3000029 MSGID_PROXY_ACCOUNT_ACK_NEW_MOBILE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_TOKEN_LOGIN=3000030 MSGID_PROXY_ACCOUNT_REQ_TOKEN_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_TOKEN_LOGIN=3000031 MSGID_PROXY_ACCOUNT_ACK_TOKEN_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_PUSH_SIMULATOR=3000032 MSGID_PROXY_ACCOUNT_SVR_PUSH_SIMULATOR value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_STATEMENT=3000033 MSGID_PROXY_ACCOUNT_SVR_REQ_STATEMENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_STATEMENT=3000034 MSGID_PROXY_ACCOUNT_SVR_ACK_STATEMENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_ISPAY=3000035 MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_ISPAY value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_ISPAY=3000036 MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_ISPAY value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_GET_KYC=3000037 MSGID_PROXY_ACCOUNT_SVR_REQ_GET_KYC value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_GET_KYC=3000038 MSGID_PROXY_ACCOUNT_SVR_ACK_GET_KYC value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_CHECK_KYCINFO=3000039 MSGID_PROXY_ACCOUNT_REQ_CHECK_KYCINFO value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_CHECK_KYCINFO=3000040 MSGID_PROXY_ACCOUNT_ACK_CHECK_KYCINFO value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_SMS=3000041 MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_SMS value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_SMS=3000042 MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_SMS value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_GET_GAMECOUNT=3000043 MSGID_PROXY_ACCOUNT_REQ_GET_GAMECOUNT value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_GET_GAMECOUNT=3000044 MSGID_PROXY_ACCOUNT_ACK_GET_GAMECOUNT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_RECORD=3000045 MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_RECORD=3000046 MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_PAYMENT=3000047 MSGID_PROXY_ACCOUNT_SVR_REQ_PAYMENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_PAYMENT=3000048 MSGID_PROXY_ACCOUNT_SVR_ACK_PAYMENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_KEY=3000049 MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_KEY value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_KEY=3000050 MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_KEY value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_ORDERID=3000051 MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_ORDERID value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_ORDERID=3000052 MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_ORDERID value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_COUNT=3000053 MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_COUNT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_COUNT=3000054 MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_COUNT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_LIST=3000055 MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_LIST value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_LIST=3000056 MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_LIST value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_CONTENT=3000057 MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_CONTENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_CONTENT=3000058 MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_CONTENT value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_PUSH_MAIL_UPDATE=3000059 MSGID_PROXY_ACCOUNT_SVR_PUSH_MAIL_UPDATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_GET_GAME_LIST=3000060 MSGID_PROXY_ACCOUNT_SVR_REQ_GET_GAME_LIST value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_GET_GAME_LIST=3000061 MSGID_PROXY_ACCOUNT_SVR_ACK_GET_GAME_LIST value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_LOGIN=3000062 MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_LOGIN=3000063 MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_LOGIN value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_NEW_PAY_RECORD=3000064 MSGID_PROXY_ACCOUNT_SVR_REQ_NEW_PAY_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_NEW_PAY_RECORD=3000065 MSGID_PROXY_ACCOUNT_SVR_ACK_NEW_PAY_RECORD value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_BALANCE_DETAIL=3000066 MSGID_PROXY_ACCOUNT_SVR_REQ_BALANCE_DETAIL value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_BALANCE_DETAIL=3000067 MSGID_PROXY_ACCOUNT_SVR_ACK_BALANCE_DETAIL value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_CHECK_CASHINFO=3000068 MSGID_PROXY_ACCOUNT_REQ_CHECK_CASHINFO value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_CHECK_CASHINFO=3000069 MSGID_PROXY_ACCOUNT_ACK_CHECK_CASHINFO value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_ACTIVITY_DETAIL=3000070 MSGID_PROXY_ACCOUNT_SVR_REQ_ACTIVITY_DETAIL value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_ACTIVITY_DETAIL=3000071 MSGID_PROXY_ACCOUNT_SVR_ACK_ACTIVITY_DETAIL value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_CANCEL=3000072 MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_CANCEL value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_CANCEL=3000073 MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_CANCEL value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_AGENT_REBATE=3000074 MSGID_PROXY_ACCOUNT_SVR_REQ_AGENT_REBATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_AGENT_REBATE=3000075 MSGID_PROXY_ACCOUNT_SVR_ACK_AGENT_REBATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_REBATE_INFO=3000076 MSGID_PROXY_ACCOUNT_SVR_REQ_REBATE_INFO value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_REBATE_INFO=3000077 MSGID_PROXY_ACCOUNT_SVR_ACK_REBATE_INFO value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_GET_REBATE=3000078 MSGID_PROXY_ACCOUNT_SVR_REQ_GET_REBATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_GET_REBATE=3000079 MSGID_PROXY_ACCOUNT_SVR_ACK_GET_REBATE value
 * @property {number} MSGID_PROXY_ACCOUNT_REQ_MODIFY_PLAYHEAD=3000080 MSGID_PROXY_ACCOUNT_REQ_MODIFY_PLAYHEAD value
 * @property {number} MSGID_PROXY_ACCOUNT_ACK_MODIFY_PLAYHEAD=3000081 MSGID_PROXY_ACCOUNT_ACK_MODIFY_PLAYHEAD value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_UPDATE=3000082 MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_UPDATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_UPDATE=3000083 MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_UPDATE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_SEALUSER=3000086 MSGID_PROXY_ACCOUNT_SVR_ACK_SEALUSER value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REQ_AFSIGN_MESSAGE=3000087 MSGID_PROXY_ACCOUNT_SVR_REQ_AFSIGN_MESSAGE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_AFSIGN_MESSAGE=3000088 MSGID_PROXY_ACCOUNT_SVR_ACK_AFSIGN_MESSAGE value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_ACK_WEB_WITHDRAW=3000089 MSGID_PROXY_ACCOUNT_SVR_ACK_WEB_WITHDRAW value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REGISTER_REQ=3000090 MSGID_PROXY_ACCOUNT_SVR_REGISTER_REQ value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_REGISTER_ACK=3000091 MSGID_PROXY_ACCOUNT_SVR_REGISTER_ACK value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_LOGGING_REQ=3000092 MSGID_PROXY_ACCOUNT_SVR_LOGGING_REQ value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_LOGGING_ACK=3000093 MSGID_PROXY_ACCOUNT_SVR_LOGGING_ACK value
 * @property {number} MSGID_PROXY_ACCOUNT_SVR_MSGID_END=3001000 MSGID_PROXY_ACCOUNT_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_ONLINE_SVR_MSGID_BEGIN=3001001 MSGID_PROXY_ONLINE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_ONLINE_REQ_CHECKUSER_ONLINE=3001002 MSGID_PROXY_ONLINE_REQ_CHECKUSER_ONLINE value
 * @property {number} MSGID_PROXY_ONLINE_ACK_CHECKUSER_ONLINE=3001003 MSGID_PROXY_ONLINE_ACK_CHECKUSER_ONLINE value
 * @property {number} MSGID_PROXY_ONLINE_REQ_USER_LEAVE=3001004 MSGID_PROXY_ONLINE_REQ_USER_LEAVE value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_GOLD_CHANGE=3001005 MSGID_PROXY_ONLINE_PUSH_GOLD_CHANGE value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_LIGHT=3001006 MSGID_PROXY_ONLINE_PUSH_LIGHT value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_USER_PAY=3001007 MSGID_PROXY_ONLINE_PUSH_USER_PAY value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_SYS_MSG=3001008 MSGID_PROXY_ONLINE_PUSH_SYS_MSG value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_MODIFY_HEAD=3001009 MSGID_PROXY_ONLINE_PUSH_MODIFY_HEAD value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_SYNC_REBATE=3001010 MSGID_PROXY_ONLINE_PUSH_SYNC_REBATE value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_USER_LBS=3001011 MSGID_PROXY_ONLINE_PUSH_USER_LBS value
 * @property {number} MSGID_PROXY_ONLINE_PUSH_TRANS_MSG=3001012 MSGID_PROXY_ONLINE_PUSH_TRANS_MSG value
 * @property {number} MSGID_PROXY_ONLINE_SVR_PUSH_PLAYER_POS=3001015 MSGID_PROXY_ONLINE_SVR_PUSH_PLAYER_POS value
 * @property {number} MSGID_PROXY_ONLINE_SVR_PUSH_MAIL_UPDATE=3001016 MSGID_PROXY_ONLINE_SVR_PUSH_MAIL_UPDATE value
 * @property {number} MSGID_PROXY_ONLINE_SVR_MSGID_END=3002000 MSGID_PROXY_ONLINE_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_DESK_SVR_MSGID_BEGIN=3002001 MSGID_PROXY_DESK_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_DESK_REQ_POKER_PRODUCT=3002002 MSGID_PROXY_DESK_REQ_POKER_PRODUCT value
 * @property {number} MSGID_PROXY_DESK_ACK_POKER_PRODUCT=3002003 MSGID_PROXY_DESK_ACK_POKER_PRODUCT value
 * @property {number} MSGID_PROXY_DESK_REQ_ENTER_GAME=3002004 MSGID_PROXY_DESK_REQ_ENTER_GAME value
 * @property {number} MSGID_PROXY_DESK_ACK_ENTER_GAME=3002005 MSGID_PROXY_DESK_ACK_ENTER_GAME value
 * @property {number} MSGID_PROXY_DESK_REQ_REGISTER_SVRID=3002006 MSGID_PROXY_DESK_REQ_REGISTER_SVRID value
 * @property {number} MSGID_PROXY_DESK_ACK_REGISTER_SVRID=3002007 MSGID_PROXY_DESK_ACK_REGISTER_SVRID value
 * @property {number} MSGID_PROXY_DESK_REQ_PLAYER_BREAK=3002008 MSGID_PROXY_DESK_REQ_PLAYER_BREAK value
 * @property {number} MSGID_PROXY_DESK_REQ_PLAYER_LEAVE=3002009 MSGID_PROXY_DESK_REQ_PLAYER_LEAVE value
 * @property {number} MSGID_PROXY_DESK_ACK_PLAYER_LEAVE=3002010 MSGID_PROXY_DESK_ACK_PLAYER_LEAVE value
 * @property {number} MSGID_PROXY_DESK_PUSH_PLAYER_ARRIVE=3002011 MSGID_PROXY_DESK_PUSH_PLAYER_ARRIVE value
 * @property {number} MSGID_PROXY_DESK_REQ_SITDOWN=3002013 MSGID_PROXY_DESK_REQ_SITDOWN value
 * @property {number} MSGID_PROXY_DESK_ACK_SITDOWN=3002014 MSGID_PROXY_DESK_ACK_SITDOWN value
 * @property {number} MSGID_PROXY_DESK_REQ_STANDUP=3002015 MSGID_PROXY_DESK_REQ_STANDUP value
 * @property {number} MSGID_PROXY_DESK_ACK_STANDUP=3002016 MSGID_PROXY_DESK_ACK_STANDUP value
 * @property {number} MSGID_PROXY_DESK_REQ_SWITCH_TABLE=3002017 MSGID_PROXY_DESK_REQ_SWITCH_TABLE value
 * @property {number} MSGID_PROXY_DESK_ACK_SWITCH_TABLE=3002018 MSGID_PROXY_DESK_ACK_SWITCH_TABLE value
 * @property {number} MSGID_PROXY_DESK_PUSH_PLAYER_BREAK=3002019 MSGID_PROXY_DESK_PUSH_PLAYER_BREAK value
 * @property {number} MSGID_PROXY_DESK_PUSH_PLAYER_RESUME=3002020 MSGID_PROXY_DESK_PUSH_PLAYER_RESUME value
 * @property {number} MSGID_PROXY_DESK_ACK_TEENPATTI_PRODUCT=3002021 MSGID_PROXY_DESK_ACK_TEENPATTI_PRODUCT value
 * @property {number} MSGID_PROXY_DESK_REQ_GET_PRODUCT_LIST=3002022 MSGID_PROXY_DESK_REQ_GET_PRODUCT_LIST value
 * @property {number} MSGID_PROXY_DESK_ACK_GET_PRODUCT_LIST=3002023 MSGID_PROXY_DESK_ACK_GET_PRODUCT_LIST value
 * @property {number} MSGID_PROXY_DESK_ACK_RUMMY_PRODUCT=3002024 MSGID_PROXY_DESK_ACK_RUMMY_PRODUCT value
 * @property {number} MSGID_PROXY_DESK_PLAYER_PAY=3002025 MSGID_PROXY_DESK_PLAYER_PAY value
 * @property {number} MSGID_PROXY_DESK_PUSH_SYS_MAIN=3002026 MSGID_PROXY_DESK_PUSH_SYS_MAIN value
 * @property {number} MSGID_PROXY_DESK_REQ_PID_PLAYER_COUNT=3002027 MSGID_PROXY_DESK_REQ_PID_PLAYER_COUNT value
 * @property {number} MSGID_PROXY_DESK_ACK_PID_PLAYER_COUNT=3002028 MSGID_PROXY_DESK_ACK_PID_PLAYER_COUNT value
 * @property {number} MSGID_PROXY_DESK_REQ_MATCHLIST=3002029 MSGID_PROXY_DESK_REQ_MATCHLIST value
 * @property {number} MSGID_PROXY_DESK_ACK_MATCHLIST=3002030 MSGID_PROXY_DESK_ACK_MATCHLIST value
 * @property {number} MSGID_PROXY_DESK_REQ_MATCH_SIGN=3002031 MSGID_PROXY_DESK_REQ_MATCH_SIGN value
 * @property {number} MSGID_PROXY_DESK_ACK_MATCH_SIGN=3002032 MSGID_PROXY_DESK_ACK_MATCH_SIGN value
 * @property {number} MSGID_PROXY_DESK_REQ_MATCH_SIGN_CANCEL=3002033 MSGID_PROXY_DESK_REQ_MATCH_SIGN_CANCEL value
 * @property {number} MSGID_PROXY_DESK_ACK_MATCH_SIGN_CANCEL=3002034 MSGID_PROXY_DESK_ACK_MATCH_SIGN_CANCEL value
 * @property {number} MSGID_PROXY_DESK_REQ_MATCH_SCHEDULE=3002035 MSGID_PROXY_DESK_REQ_MATCH_SCHEDULE value
 * @property {number} MSGID_PROXY_DESK_ACK_MATCH_SCHEDULE=3002036 MSGID_PROXY_DESK_ACK_MATCH_SCHEDULE value
 * @property {number} MSGID_PROXY_DESK_PUSH_MATCH_RESULT=3002037 MSGID_PROXY_DESK_PUSH_MATCH_RESULT value
 * @property {number} MSGID_PROXY_DESK_PUSH_MATCH_SCHEDULE=3002038 MSGID_PROXY_DESK_PUSH_MATCH_SCHEDULE value
 * @property {number} MSGID_PROXY_DESK_SVR_MSGID_END=3003000 MSGID_PROXY_DESK_SVR_MSGID_END value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_MSGID_BEGIN=3003001 MSGID_WEB_ACCOUNT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_GM_COMMAND=3003002 MSGID_WEB_ACCOUNT_SVR_GM_COMMAND value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_USER_PAY=3003003 MSGID_WEB_ACCOUNT_SVR_USER_PAY value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_SYS_MSG=3003004 MSGID_WEB_ACCOUNT_SVR_SYS_MSG value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_MODIFY_HEAD=3003005 MSGID_WEB_ACCOUNT_SVR_MODIFY_HEAD value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_NEW_USER_GIFT=3003006 MSGID_WEB_ACCOUNT_SVR_NEW_USER_GIFT value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_MAIL_UPDATE=3003007 MSGID_WEB_ACCOUNT_SVR_MAIL_UPDATE value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_NEW_USER_PAY=3003008 MSGID_WEB_ACCOUNT_SVR_NEW_USER_PAY value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_SEAL_NUMBER=3003009 MSGID_WEB_ACCOUNT_SVR_SEAL_NUMBER value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_WITHDRAW_RESULT=3003010 MSGID_WEB_ACCOUNT_SVR_WITHDRAW_RESULT value
 * @property {number} MSGID_WEB_ACCOUNT_SVR_MSGID_END=3004000 MSGID_WEB_ACCOUNT_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_POSTION_SVR_MSGID_BEGIN=3004001 MSGID_PROXY_POSTION_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_POSTION_SVR_PUSH_PLAYER_POS=3004004 MSGID_PROXY_POSTION_SVR_PUSH_PLAYER_POS value
 * @property {number} MSGID_WEB_POSTION_SVR_CLEAR_PLAYER_POS=3004005 MSGID_WEB_POSTION_SVR_CLEAR_PLAYER_POS value
 * @property {number} MSGID_PROXY_POSTION_SVR_MSGID_END=3005000 MSGID_PROXY_POSTION_SVR_MSGID_END value
 * @property {number} MSGID_GAME_SVR_MSGID_BEGIN=3005001 MSGID_GAME_SVR_MSGID_BEGIN value
 * @property {number} MSGID_GAME_SVR_REQ_REGISTER=3005002 MSGID_GAME_SVR_REQ_REGISTER value
 * @property {number} MSGID_GAME_SVR_ACK_REGISTER=3005003 MSGID_GAME_SVR_ACK_REGISTER value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_CREATEDESK=3005004 MSGID_DESK_GAME_SVR_REQ_CREATEDESK value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_CREATEDESK=3005005 MSGID_DESK_GAME_SVR_ACK_CREATEDESK value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_PLAYERARRIVE=3005006 MSGID_DESK_GAME_SVR_REQ_PLAYERARRIVE value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_PLAYERARRIVE=3005007 MSGID_DESK_GAME_SVR_ACK_PLAYERARRIVE value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_PLAYERLEAVE=3005008 MSGID_DESK_GAME_SVR_REQ_PLAYERLEAVE value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_PLAYERLEAVE=3005009 MSGID_DESK_GAME_SVR_ACK_PLAYERLEAVE value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_SITDOWN=3005010 MSGID_DESK_GAME_SVR_REQ_SITDOWN value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_SITDOWN=3005011 MSGID_DESK_GAME_SVR_ACK_SITDOWN value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_STANDUP=3005012 MSGID_DESK_GAME_SVR_REQ_STANDUP value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_STANDUP=3005013 MSGID_DESK_GAME_SVR_ACK_STANDUP value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_TIMER=3005014 MSGID_DESK_GAME_SVR_PUSH_TIMER value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_STARTGAME=3005015 MSGID_DESK_GAME_SVR_PUSH_STARTGAME value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_COMMAND=3005016 MSGID_DESK_GAME_SVR_PUSH_COMMAND value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_PLAYINGINFO=3005017 MSGID_DESK_GAME_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_DEALCARD=3005018 MSGID_DESK_GAME_SVR_PUSH_DEALCARD value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_COMMAND=3005019 MSGID_DESK_GAME_SVR_REQ_COMMAND value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_COMMAND=3005020 MSGID_DESK_GAME_SVR_ACK_COMMAND value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_SHOWCARD=3005021 MSGID_DESK_GAME_SVR_REQ_SHOWCARD value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_SHOWCARD=3005022 MSGID_DESK_GAME_SVR_ACK_SHOWCARD value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_GAMERESULT=3005023 MSGID_DESK_GAME_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_KICKOUT=3005024 MSGID_DESK_GAME_SVR_PUSH_KICKOUT value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_RESUME=3005025 MSGID_DESK_GAME_SVR_REQ_RESUME value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_BREAK=3005026 MSGID_DESK_GAME_SVR_REQ_BREAK value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_STATE_MACHINE=3005027 MSGID_DESK_GAME_SVR_PUSH_STATE_MACHINE value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_ASEET_INFO=3005028 MSGID_DESK_GAME_SVR_PUSH_ASEET_INFO value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_PAY=3005029 MSGID_DESK_GAME_SVR_PUSH_PAY value
 * @property {number} MSGID_DESK_GAME_SVR_REQ_SWTICHTABLE=3005030 MSGID_DESK_GAME_SVR_REQ_SWTICHTABLE value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_SWTICHTABLE=3005031 MSGID_DESK_GAME_SVR_ACK_SWTICHTABLE value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_DESK_STATUS=3005032 MSGID_DESK_GAME_SVR_PUSH_DESK_STATUS value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_SYS_MAIN=3005033 MSGID_DESK_GAME_SVR_PUSH_SYS_MAIN value
 * @property {number} MSGID_DESK_GAME_SVR_RECYCLE_DESK=3005034 MSGID_DESK_GAME_SVR_RECYCLE_DESK value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_STANDUPEX=3005035 MSGID_DESK_GAME_SVR_ACK_STANDUPEX value
 * @property {number} MSGID_DESK_GAME_SVR_ACK_SITDOWNEX=3005036 MSGID_DESK_GAME_SVR_ACK_SITDOWNEX value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_BOT_PREINFO=3005037 MSGID_DESK_GAME_SVR_PUSH_BOT_PREINFO value
 * @property {number} MSGID_DESK_GAME_SVR_PUSH_SCORE_CHANGE=3005038 MSGID_DESK_GAME_SVR_PUSH_SCORE_CHANGE value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE=3005300 MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE=3005301 MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_PUSH_LIGHT=3005302 MSGID_GAME_ACCOUNT_SVR_PUSH_LIGHT value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_REQ_USER_CASHGOLD=3005303 MSGID_GAME_ACCOUNT_SVR_REQ_USER_CASHGOLD value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_ACK_USER_CASHGOLD=3005304 MSGID_GAME_ACCOUNT_SVR_ACK_USER_CASHGOLD value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE_EX=3005305 MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE_EX value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE_EX=3005306 MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE_EX value
 * @property {number} MSGID_BIG_BATTLE_GAME_DATA_SVR_REQ_STOCK_CHANGE=3005307 MSGID_BIG_BATTLE_GAME_DATA_SVR_REQ_STOCK_CHANGE value
 * @property {number} MSGID_BIG_BATTLE_GAME_DATA_SVR_ACK_STOCK_CHANGE=3005308 MSGID_BIG_BATTLE_GAME_DATA_SVR_ACK_STOCK_CHANGE value
 * @property {number} MSGID_POKER_WAR_GAME_DATA_SVR_REQ_STOCK_CHANGE=3005309 MSGID_POKER_WAR_GAME_DATA_SVR_REQ_STOCK_CHANGE value
 * @property {number} MSGID_POKER_WAR_GAME_DATA_SVR_ACK_STOCK_CHANGE=3005310 MSGID_POKER_WAR_GAME_DATA_SVR_ACK_STOCK_CHANGE value
 * @property {number} MSGID_RUMMY_GAME_PLAY_RECORD_DATA_ACCOUNT=3005311 MSGID_RUMMY_GAME_PLAY_RECORD_DATA_ACCOUNT value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_REQ_MATCH_GOLD_CHANGE=3005312 MSGID_GAME_ACCOUNT_SVR_REQ_MATCH_GOLD_CHANGE value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_ACK_MATCH_GOLD_CHANGE=3005313 MSGID_GAME_ACCOUNT_SVR_ACK_MATCH_GOLD_CHANGE value
 * @property {number} MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_NEWCHANGE=3005314 MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_NEWCHANGE value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_ROUND_INFO=3005400 MSGID_GAME_STAT_SVR_PUSH_ROUND_INFO value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_TAX_INFO=3005401 MSGID_GAME_STAT_SVR_PUSH_TAX_INFO value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_ROBOT_GOLD_TAX_CHANGE=3005402 MSGID_GAME_STAT_SVR_PUSH_ROBOT_GOLD_TAX_CHANGE value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_ONLINE_STATISTICS=3005403 MSGID_GAME_STAT_SVR_PUSH_ONLINE_STATISTICS value
 * @property {number} MSGID_GAME_STAT_SVR_REQ_CHECK_NEWPLAYER=3005404 MSGID_GAME_STAT_SVR_REQ_CHECK_NEWPLAYER value
 * @property {number} MSGID_GAME_STATT_SVR_ACK_CHECK_NEWPLAYER=3005405 MSGID_GAME_STATT_SVR_ACK_CHECK_NEWPLAYER value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_BIG_POKER_WAR_LOG=3005406 MSGID_GAME_STAT_SVR_PUSH_BIG_POKER_WAR_LOG value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_BIG_BATTLE_LOG=3005407 MSGID_GAME_STAT_SVR_PUSH_BIG_BATTLE_LOG value
 * @property {number} MSGID_GAME_SVR_MSGID_END=3006000 MSGID_GAME_SVR_MSGID_END value
 * @property {number} MSGID_DESK_BOTCENTER_SVR_MSGID_BEGIN=3006001 MSGID_DESK_BOTCENTER_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_BOTCENTER_SVR_REQ_GET_ROBOT=3006002 MSGID_DESK_BOTCENTER_SVR_REQ_GET_ROBOT value
 * @property {number} MSGID_DESK_BOTCENTER_SVR_ACK_GET_ROBOT=3006003 MSGID_DESK_BOTCENTER_SVR_ACK_GET_ROBOT value
 * @property {number} MSGID_DESK_BOTCENTER_SVR_REQ_ROBOT_RECYCLE=3006004 MSGID_DESK_BOTCENTER_SVR_REQ_ROBOT_RECYCLE value
 * @property {number} MSGID_DESK_BOTCENTER_MSGID_END=3006100 MSGID_DESK_BOTCENTER_MSGID_END value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_MSGID_BEGIN=3006101 MSGID_ACCOUNT_ONLINE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_GOLD_CHANGE=3006102 MSGID_ACCOUNT_ONLINE_SVR_PUSH_GOLD_CHANGE value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_LIGHT=3006103 MSGID_ACCOUNT_ONLINE_SVR_PUSH_LIGHT value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_USER_PAY=3006104 MSGID_ACCOUNT_ONLINE_SVR_PUSH_USER_PAY value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYS_MGS=3006105 MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYS_MGS value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_MODIFY_HEAD=3006106 MSGID_ACCOUNT_ONLINE_SVR_PUSH_MODIFY_HEAD value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYNC_REBATE=3006107 MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYNC_REBATE value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_TRANS_MSG=3006108 MSGID_ACCOUNT_ONLINE_SVR_PUSH_TRANS_MSG value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_PUSH_MAIL_UPDATE_MSG=3006109 MSGID_ACCOUNT_ONLINE_SVR_PUSH_MAIL_UPDATE_MSG value
 * @property {number} MSGID_ACCOUNT_ONLINE_SVR_MSGID_END=3006300 MSGID_ACCOUNT_ONLINE_SVR_MSGID_END value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_MSGID_BEGIN=3007000 MSGID_DESK_TEEN_PATTI_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_ASEETINFO=3007001 MSGID_DESK_TEEN_PATTI_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_STARTGAME=3007002 MSGID_DESK_TEEN_PATTI_SVR_PUSH_STARTGAME value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_OPER_TIPS=3007003 MSGID_DESK_TEEN_PATTI_SVR_PUSH_OPER_TIPS value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_CMD=3007004 MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_CMD value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_ACK_OPER_CMD=3007005 MSGID_DESK_TEEN_PATTI_SVR_ACK_OPER_CMD value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_COMP_RESULT=3007006 MSGID_DESK_TEEN_PATTI_SVR_PUSH_COMP_RESULT value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAMERESULT=3007007 MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_LACK_ASEET=3007008 MSGID_DESK_TEEN_PATTI_SVR_PUSH_LACK_ASEET value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_REQ_WAIT_CHARGE=3007009 MSGID_DESK_TEEN_PATTI_SVR_REQ_WAIT_CHARGE value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_PLAYINGINFO=3007010 MSGID_DESK_TEEN_PATTI_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_COMPARE=3007011 MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_COMPARE value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAME_RULE=3007012 MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_HANDCARDINFO=3007013 MSGID_DESK_TEEN_PATTI_SVR_PUSH_HANDCARDINFO value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_REQ_RECORD_CMD=3007014 MSGID_DESK_TEEN_PATTI_SVR_REQ_RECORD_CMD value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_ACK_RECORD_CMD=3007015 MSGID_DESK_TEEN_PATTI_SVR_ACK_RECORD_CMD value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_REQ_CANCEL_CHARGE=3007016 MSGID_DESK_TEEN_PATTI_SVR_REQ_CANCEL_CHARGE value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_AIDATA=3007017 MSGID_DESK_TEEN_PATTI_SVR_PUSH_AIDATA value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_PUSH_CHARGE=3007018 MSGID_DESK_TEEN_PATTI_SVR_PUSH_CHARGE value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_TEST_REQ=3007049 MSGID_DESK_TEEN_PATTI_SVR_TEST_REQ value
 * @property {number} MSGID_DESK_TEEN_PATTI_SVR_MSGID_END=3007050 MSGID_DESK_TEEN_PATTI_SVR_MSGID_END value
 * @property {number} MSGID_DESK_RUMMY_SVR_MSGID_BEGIN=3007051 MSGID_DESK_RUMMY_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_DEALCARD=3007052 MSGID_DESK_RUMMY_SVR_PUSH_DEALCARD value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_PUBLIC_CARD=3007053 MSGID_DESK_RUMMY_SVR_PUSH_PUBLIC_CARD value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_MAGIC_CARD=3007054 MSGID_DESK_RUMMY_SVR_PUSH_MAGIC_CARD value
 * @property {number} MSGID_DESK_RUMMY_SVR__REQ_COMMAND=3007055 MSGID_DESK_RUMMY_SVR__REQ_COMMAND value
 * @property {number} MSGID_DESK_RUMMY_SVR__ACK_COMMAND=3007056 MSGID_DESK_RUMMY_SVR__ACK_COMMAND value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_STARTGAME=3007057 MSGID_DESK_RUMMY_SVR_PUSH_STARTGAME value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_COMMAND=3007058 MSGID_DESK_RUMMY_SVR_PUSH_COMMAND value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_PLAYINGINFO=3007059 MSGID_DESK_RUMMY_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_GAMERESULT=3007060 MSGID_DESK_RUMMY_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_CUR_USER=3007061 MSGID_DESK_RUMMY_SVR_PUSH_CUR_USER value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_ASEET_INFO=3007062 MSGID_DESK_RUMMY_SVR_PUSH_ASEET_INFO value
 * @property {number} MSGID_DESK_RUMMY_POOL_SVR_PUSH_ASEET_INFO=3007063 MSGID_DESK_RUMMY_POOL_SVR_PUSH_ASEET_INFO value
 * @property {number} MSGID_DESK_RUMMY_POOL_SVR_PUSH_RULE_INFO=3007064 MSGID_DESK_RUMMY_POOL_SVR_PUSH_RULE_INFO value
 * @property {number} MSGID_DESK_RUMMY_POOL_SVR_PUSH_ROUND_INFO=3007065 MSGID_DESK_RUMMY_POOL_SVR_PUSH_ROUND_INFO value
 * @property {number} MSGID_DESK_RUMMY_POOL_SVR__REQ_ROUND_INFO=3007066 MSGID_DESK_RUMMY_POOL_SVR__REQ_ROUND_INFO value
 * @property {number} MSGID_DESK_RUMMY_POOL_SVR_PUSH_PLAYER_GAME_END=3007067 MSGID_DESK_RUMMY_POOL_SVR_PUSH_PLAYER_GAME_END value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR_PUSH_DEALER_CARD=3007068 MSGID_DESK_RUMMY_DEALES_SVR_PUSH_DEALER_CARD value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR_REQ_RESULT=3007069 MSGID_DESK_RUMMY_DEALES_SVR_REQ_RESULT value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR_ACK_RESULT=3007070 MSGID_DESK_RUMMY_DEALES_SVR_ACK_RESULT value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR_PUSH_PLAYER_CNT=3007071 MSGID_DESK_RUMMY_DEALES_SVR_PUSH_PLAYER_CNT value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR_PUSH_GAME_END=3007072 MSGID_DESK_RUMMY_DEALES_SVR_PUSH_GAME_END value
 * @property {number} MSGID_DESK_RUMMY_DEALES_SVR__REQ_GAME_END=3007073 MSGID_DESK_RUMMY_DEALES_SVR__REQ_GAME_END value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_SHUFFLE_CARDS=3007074 MSGID_DESK_RUMMY_SVR_PUSH_SHUFFLE_CARDS value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_NEW_SEAT=3007075 MSGID_DESK_RUMMY_SVR_PUSH_NEW_SEAT value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_NEW_SHOWCARD=3007076 MSGID_DESK_RUMMY_SVR_PUSH_NEW_SHOWCARD value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_MATCH_PARAM=3007077 MSGID_DESK_RUMMY_SVR_PUSH_MATCH_PARAM value
 * @property {number} MSGID_DESK_RUMMY_SVR_PUSH_HANDDATA=3007078 MSGID_DESK_RUMMY_SVR_PUSH_HANDDATA value
 * @property {number} MSGID_DESK_RUMMY_SVR_SUPERDATA_REQ=3007098 MSGID_DESK_RUMMY_SVR_SUPERDATA_REQ value
 * @property {number} MSGID_DESK_RUMMY_SVR_SUPERDATA_ACK=3007099 MSGID_DESK_RUMMY_SVR_SUPERDATA_ACK value
 * @property {number} MSGID_DESK_rummy_SVR_MSGID_END=3007100 MSGID_DESK_rummy_SVR_MSGID_END value
 * @property {number} MSGID_Account_Agent_SVR_MSGID_BEGIN=3007101 MSGID_Account_Agent_SVR_MSGID_BEGIN value
 * @property {number} MSGID_ACC_AGENT_SVR_PUSH_REBATE=3007102 MSGID_ACC_AGENT_SVR_PUSH_REBATE value
 * @property {number} MSGID_DESK_Agent_SVR_MSGID_END=3007200 MSGID_DESK_Agent_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_AGENT_SVR_MSGID_BEGIN=3007201 MSGID_PROXY_AGENT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_AGENT_SVR_REQ_REBATE_RECORD=3007202 MSGID_PROXY_AGENT_SVR_REQ_REBATE_RECORD value
 * @property {number} MSGID_PROXY_AGENT_SVR_ACK_REBATE_RECORD=3007203 MSGID_PROXY_AGENT_SVR_ACK_REBATE_RECORD value
 * @property {number} MSGID_PROXY_AGENT_SVR_REQ_SET_AGENT=3007204 MSGID_PROXY_AGENT_SVR_REQ_SET_AGENT value
 * @property {number} MSGID_PROXY_AGENT_SVR_ACK_SET_AGENT=3007205 MSGID_PROXY_AGENT_SVR_ACK_SET_AGENT value
 * @property {number} MSGID_PROXY_AGENT_SVR_REQ_REBATE_BASIC_INFO=3007206 MSGID_PROXY_AGENT_SVR_REQ_REBATE_BASIC_INFO value
 * @property {number} MSGID_PROXY_AGENT_SVR_ACK_REBATE_BASIC_INFO=3007207 MSGID_PROXY_AGENT_SVR_ACK_REBATE_BASIC_INFO value
 * @property {number} MSGID_PROXY_AGENT_SVR_PUSH_PLAYER_LOGIN=3007208 MSGID_PROXY_AGENT_SVR_PUSH_PLAYER_LOGIN value
 * @property {number} MSGID_PROXY_AGENT_SVR_MSGID_END=3007300 MSGID_PROXY_AGENT_SVR_MSGID_END value
 * @property {number} MSGID_WEB_ONLINE_SVR_MSGID_BEGIN=3007301 MSGID_WEB_ONLINE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_WEB_ONLINE_PUSH_SYS_MAIN=3007302 MSGID_WEB_ONLINE_PUSH_SYS_MAIN value
 * @property {number} MSGID_WEB_ONLINE_PUSH_TRANS_MSG=3007303 MSGID_WEB_ONLINE_PUSH_TRANS_MSG value
 * @property {number} MSGID_WEB_ONLINE_PUSH_TRANS_USER_MSG=3007304 MSGID_WEB_ONLINE_PUSH_TRANS_USER_MSG value
 * @property {number} MSGID_WEB_ONLINE_SVR_MSGID_END=3007400 MSGID_WEB_ONLINE_SVR_MSGID_END value
 * @property {number} MSGID_SRV_BASE_MSGID_BEGIN=3007401 MSGID_SRV_BASE_MSGID_BEGIN value
 * @property {number} MSGID_SRV_TO_SRV_REGISTER=3007402 MSGID_SRV_TO_SRV_REGISTER value
 * @property {number} MSGID_SRV_BASE_MSGID_END=3007500 MSGID_SRV_BASE_MSGID_END value
 * @property {number} MSGID_PROXY_MATCH_SVR_MSGID_BEGIN=3007501 MSGID_PROXY_MATCH_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_MATCH_REQ_GET_TOURNEY=3007502 MSGID_PROXY_MATCH_REQ_GET_TOURNEY value
 * @property {number} MSGID_PROXY_MATCH_ACK_GET_TOURNEY=3007503 MSGID_PROXY_MATCH_ACK_GET_TOURNEY value
 * @property {number} MSGID_PROXY_MATCH_SVR_MSGID_END=3007700 MSGID_PROXY_MATCH_SVR_MSGID_END value
 * @property {number} MSGID_ACCOUNT_STATEMENT_SVR_MSGID_BEGIN=3007701 MSGID_ACCOUNT_STATEMENT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_ACCOUNT_STATEMENT_PUSH_GOLD_CHANGE=3007702 MSGID_ACCOUNT_STATEMENT_PUSH_GOLD_CHANGE value
 * @property {number} MSGID_ACCOUNT_STATEMENT_LOGIN_SUCCESS=3007703 MSGID_ACCOUNT_STATEMENT_LOGIN_SUCCESS value
 * @property {number} MSGID_ACCOUNT_STATEMENT_REQ_GAME_RECORD=3007704 MSGID_ACCOUNT_STATEMENT_REQ_GAME_RECORD value
 * @property {number} MSGID_ACCOUNT_STATEMENT_ACK_GAME_RECORD=3007705 MSGID_ACCOUNT_STATEMENT_ACK_GAME_RECORD value
 * @property {number} MSGID_ACCOUNT_STATEMENT_SVR_MSGID_END=3007799 MSGID_ACCOUNT_STATEMENT_SVR_MSGID_END value
 * @property {number} MSGID_DESK_TREASURE_SVR_MSGID_BEGIN=3007800 MSGID_DESK_TREASURE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_TREASURE_SVR_PARTICIPATION_REQ=3007801 MSGID_DESK_TREASURE_SVR_PARTICIPATION_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_PARTICIPATION_ACK=3007802 MSGID_DESK_TREASURE_SVR_PARTICIPATION_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_REQ=3007803 MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_ACK=3007804 MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_REQ=3007805 MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_ACK=3007806 MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_REQ=3007807 MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_ACK=3007808 MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_REQ=3007809 MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_ACK=3007810 MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_BUY_TICKET_REQ=3007811 MSGID_DESK_TREASURE_SVR_BUY_TICKET_REQ value
 * @property {number} MSGID_DESK_TREASURE_SVR_BUY_TICKET_ACK=3007812 MSGID_DESK_TREASURE_SVR_BUY_TICKET_ACK value
 * @property {number} MSGID_DESK_TREASURE_SVR_PUSH_RESULT_TIMEOUT=3007813 MSGID_DESK_TREASURE_SVR_PUSH_RESULT_TIMEOUT value
 * @property {number} MSGID_DESK_TREASURE_SVR_PUSH_RESULT=3007814 MSGID_DESK_TREASURE_SVR_PUSH_RESULT value
 * @property {number} MSGID_DESK_TREASURE_SVR_PUSH_ALL_TYPE=3007815 MSGID_DESK_TREASURE_SVR_PUSH_ALL_TYPE value
 * @property {number} MSGID_DESK_TREASURE_SVR_MSGID_END=3007900 MSGID_DESK_TREASURE_SVR_MSGID_END value
 * @property {number} MSGID_GATE_PROXY_SVR_BEGIN=3007901 MSGID_GATE_PROXY_SVR_BEGIN value
 * @property {number} MSGID_GATE_PROXY_SVR_REGISTER=3007902 MSGID_GATE_PROXY_SVR_REGISTER value
 * @property {number} MSGID_GATE_PROXY_SVR_UPDATE_INFO=3007903 MSGID_GATE_PROXY_SVR_UPDATE_INFO value
 * @property {number} MSGID_GATE_PROXY_SVR_PUSH_SYS_MAIN=3007904 MSGID_GATE_PROXY_SVR_PUSH_SYS_MAIN value
 * @property {number} MSGID_GATE_PROXY_SVR_END=3007930 MSGID_GATE_PROXY_SVR_END value
 * @property {number} MSGID_ONLINE_STAT_SVR_MSGID_BEGIN=3007931 MSGID_ONLINE_STAT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_ONLINE_STAT_SVR_PUSH_ONLINE_PLAYER=3007932 MSGID_ONLINE_STAT_SVR_PUSH_ONLINE_PLAYER value
 * @property {number} MSGID_ONLINE_STAT_SVR_MSGID_END=3007960 MSGID_ONLINE_STAT_SVR_MSGID_END value
 * @property {number} MSGID_PROXY_BONUS_SVR_MSGID_BEGIN=3007961 MSGID_PROXY_BONUS_SVR_MSGID_BEGIN value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN_CONFIG=3007962 MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN_CONFIG value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN_CONFIG=3007963 MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN_CONFIG value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN=3007964 MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN=3007965 MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_GET_CUMULATIVE_DAYS=3007966 MSGID_PROXY_BONUS_SVR_REQ_GET_CUMULATIVE_DAYS value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_GET_CUMULATIVE_DAYS=3007967 MSGID_PROXY_BONUS_SVR_ACK_GET_CUMULATIVE_DAYS value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_INVITE_DATA=3007968 MSGID_PROXY_BONUS_SVR_REQ_INVITE_DATA value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_INVITE_DATA=3007969 MSGID_PROXY_BONUS_SVR_ACK_INVITE_DATA value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_INVITE_GOLD=3007970 MSGID_PROXY_BONUS_SVR_REQ_INVITE_GOLD value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_INVITE_GOLD=3007971 MSGID_PROXY_BONUS_SVR_ACK_INVITE_GOLD value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_INVITE_TASKSTATUS=3007972 MSGID_PROXY_BONUS_SVR_REQ_INVITE_TASKSTATUS value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_INVITE_TASKSTATUS=3007973 MSGID_PROXY_BONUS_SVR_ACK_INVITE_TASKSTATUS value
 * @property {number} MSGID_PROXY_BONUS_SVR_REQ_INVITE_ADDGOLD=3007974 MSGID_PROXY_BONUS_SVR_REQ_INVITE_ADDGOLD value
 * @property {number} MSGID_PROXY_BONUS_SVR_ACK_INVITE_ADDGOLD=3007975 MSGID_PROXY_BONUS_SVR_ACK_INVITE_ADDGOLD value
 * @property {number} MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_REQ=3007976 MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_REQ value
 * @property {number} MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_ACK=3007977 MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_ACK value
 * @property {number} MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_REQ=3007978 MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_REQ value
 * @property {number} MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_ACK=3007979 MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_ACK value
 * @property {number} MSGID_PROXY_BONUS_SVR_MSGID_END=3008000 MSGID_PROXY_BONUS_SVR_MSGID_END value
 * @property {number} MSGID_BONUS_ACCOUNT_SVR_MSGID_BEGIN=3008001 MSGID_BONUS_ACCOUNT_SVR_MSGID_BEGIN value
 * @property {number} MSGID_BONUS_ACCOUNT_PUSH_BONUS=3008002 MSGID_BONUS_ACCOUNT_PUSH_BONUS value
 * @property {number} MSGID_BONUS_ACCOUNT_SVR_MSGID_END=3008100 MSGID_BONUS_ACCOUNT_SVR_MSGID_END value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_MSGID_BEGIN=3008101 MSGID_DESK_BIGBATTLE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_ASEETINFO=3008102 MSGID_DESK_BIGBATTLE_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_RULE=3008103 MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYINGINFO=3008104 MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_CLIENT_BIGBATTLE_SVR_REQ_BET=3008105 MSGID_CLIENT_BIGBATTLE_SVR_REQ_BET value
 * @property {number} MSGID_CLIENT_BIGBATTLE_SVR_ACK_BET=3008106 MSGID_CLIENT_BIGBATTLE_SVR_ACK_BET value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_CARD=3008107 MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_CARD value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_GAMERESULT=3008108 MSGID_DESK_BIGBATTLE_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYER_RAND=3008109 MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYER_RAND value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_TREND=3008110 MSGID_DESK_BIGBATTLE_SVR_PUSH_TREND value
 * @property {number} MSGID_BOT_BIGBATTLE_SVR_PUSH_BET_TIPS=3008111 MSGID_BOT_BIGBATTLE_SVR_PUSH_BET_TIPS value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_PUSH_LUCKY_STAR=3008112 MSGID_DESK_BIGBATTLE_SVR_PUSH_LUCKY_STAR value
 * @property {number} MSGID_DESK_BIGBATTLE_SVR_MSGID_END=3008200 MSGID_DESK_BIGBATTLE_SVR_MSGID_END value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_MSGID_BEGIN=3008201 MSGID_DESK_POKER_WAR_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_ASEETINFO=3008202 MSGID_DESK_POKER_WAR_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_RULE=3008203 MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYINGINFO=3008204 MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_CLIENT_POKER_WAR_SVR_REQ_BET=3008205 MSGID_CLIENT_POKER_WAR_SVR_REQ_BET value
 * @property {number} MSGID_CLIENT_POKER_WAR_SVR_ACK_BET=3008206 MSGID_CLIENT_POKER_WAR_SVR_ACK_BET value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_CARD=3008207 MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_CARD value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_GAMERESULT=3008208 MSGID_DESK_POKER_WAR_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYER_RAND=3008209 MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYER_RAND value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_TREND=3008210 MSGID_DESK_POKER_WAR_SVR_PUSH_TREND value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_PUSH_LUCKY_STAR=3008211 MSGID_DESK_POKER_WAR_SVR_PUSH_LUCKY_STAR value
 * @property {number} MSGID_BOT_POKER_WAR_SVR_PUSH_BET_TIPS=3008212 MSGID_BOT_POKER_WAR_SVR_PUSH_BET_TIPS value
 * @property {number} MSGID_DESK_POKER_WAR_SVR_MSGID_END=3008250 MSGID_DESK_POKER_WAR_SVR_MSGID_END value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_MSGID_BEGIN=3014101 MSGID_DESK_MINESWEEPER_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_PUSH_ASEETINFO=3014102 MSGID_DESK_MINESWEEPER_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_PUSH_GAME_RULE=3014103 MSGID_DESK_MINESWEEPER_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_PUSH_PLAYINGINFO=3014104 MSGID_DESK_MINESWEEPER_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_REQ_BET=3014105 MSGID_CLIENT_MINESWEEPER_SVR_REQ_BET value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_ACK_BET=3014106 MSGID_CLIENT_MINESWEEPER_SVR_ACK_BET value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_REQ_FLOP=3014107 MSGID_CLIENT_MINESWEEPER_SVR_REQ_FLOP value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_ACK_FLOP=3014108 MSGID_CLIENT_MINESWEEPER_SVR_ACK_FLOP value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_PUSH_GAMERESULT=3014109 MSGID_DESK_MINESWEEPER_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_REQ_ENDFLOP=3014110 MSGID_CLIENT_MINESWEEPER_SVR_REQ_ENDFLOP value
 * @property {number} MSGID_CLIENT_MINESWEEPER_SVR_ACK_ENDFLOP=3014111 MSGID_CLIENT_MINESWEEPER_SVR_ACK_ENDFLOP value
 * @property {number} MSGID_DESK_MINESWEEPER_SVR_MSGID_END=3014200 MSGID_DESK_MINESWEEPER_SVR_MSGID_END value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_BEGIN=3016101 MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_ASEETINFO=3016102 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_RULE=3016103 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYINGINFO=3016104 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_CLIENT_WHEELOFFORTURE_SVR_REQ_BET=3016105 MSGID_CLIENT_WHEELOFFORTURE_SVR_REQ_BET value
 * @property {number} MSGID_CLIENT_WHEELOFFORTURE_SVR_ACK_BET=3016106 MSGID_CLIENT_WHEELOFFORTURE_SVR_ACK_BET value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_CARD=3016107 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_CARD value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAMERESULT=3016108 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYER_RAND=3016109 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYER_RAND value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_TREND=3016110 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_TREND value
 * @property {number} MSGID_BOT_WHEELOFFORTURE_SVR_PUSH_BET_TIPS=3016111 MSGID_BOT_WHEELOFFORTURE_SVR_PUSH_BET_TIPS value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_LUCKY_STAR=3016112 MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_LUCKY_STAR value
 * @property {number} MSGID_WHEELOFFORTURE_GAME_DATA_SVR_REQ_STOCK_CHANGE=3016130 MSGID_WHEELOFFORTURE_GAME_DATA_SVR_REQ_STOCK_CHANGE value
 * @property {number} MSGID_WHEELOFFORTURE_GAME_DATA_SVR_ACK_STOCK_CHANGE=3016131 MSGID_WHEELOFFORTURE_GAME_DATA_SVR_ACK_STOCK_CHANGE value
 * @property {number} MSGID_GAME_STAT_SVR_PUSH_WHEELOFFORTURE_LOG=3016132 MSGID_GAME_STAT_SVR_PUSH_WHEELOFFORTURE_LOG value
 * @property {number} MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_END=3016200 MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_END value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_BEGIN=3018101 MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_BEGIN value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_ASEETINFO=3018102 MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_ASEETINFO value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAME_RULE=3018103 MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAME_RULE value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_PLAYINGINFO=3018104 MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_PLAYINGINFO value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAMERESULT=3018105 MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAMERESULT value
 * @property {number} MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_REQ_BET=3018106 MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_REQ_BET value
 * @property {number} MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_ACK_BET=3018107 MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_ACK_BET value
 * @property {number} MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_END=3018200 MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_END value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_PUSH_BEGIN=3018201 MSGID_DESK_SUPER_ACE_SVR_PUSH_BEGIN value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMERULE=3018202 MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMERULE value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_REQ_PLAYBET=3018203 MSGID_DESK_SUPER_ACE_SVR_REQ_PLAYBET value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_ACK_PLAYBET=3018204 MSGID_DESK_SUPER_ACE_SVR_ACK_PLAYBET value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_PUSH_BETDATA=3018205 MSGID_DESK_SUPER_ACE_SVR_PUSH_BETDATA value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_REQ_CARTOON=3018206 MSGID_DESK_SUPER_ACE_SVR_REQ_CARTOON value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMEEND=3018207 MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMEEND value
 * @property {number} MSGID_DESK_SUPER_ACE_SVR_PUSH_END=3018300 MSGID_DESK_SUPER_ACE_SVR_PUSH_END value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_PUSH_BEGIN=3018301 MSGID_DESK_CASH_WHEEL_SVR_PUSH_BEGIN value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMERULE=3018302 MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMERULE value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_REQ_PLAYBET=3018303 MSGID_DESK_CASH_WHEEL_SVR_REQ_PLAYBET value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_ACK_PLAYBET=3018304 MSGID_DESK_CASH_WHEEL_SVR_ACK_PLAYBET value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_PUSH_BETDATA=3018305 MSGID_DESK_CASH_WHEEL_SVR_PUSH_BETDATA value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_REQ_CARTOON=3018306 MSGID_DESK_CASH_WHEEL_SVR_REQ_CARTOON value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMEEND=3018307 MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMEEND value
 * @property {number} MSGID_DESK_CASH_WHEEL_SVR_PUSH_END=3018400 MSGID_DESK_CASH_WHEEL_SVR_PUSH_END value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BEGIN=3018401 MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BEGIN value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMERULE=3018402 MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMERULE value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_REQ_PLAYBET=3018403 MSGID_DESK_FORTUNE_TIGER_SVR_REQ_PLAYBET value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_ACK_PLAYBET=3018404 MSGID_DESK_FORTUNE_TIGER_SVR_ACK_PLAYBET value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BETDATA=3018405 MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BETDATA value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_REQ_CARTOON=3018406 MSGID_DESK_FORTUNE_TIGER_SVR_REQ_CARTOON value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMEEND=3018407 MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMEEND value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_REQ_JACKPOT=3018408 MSGID_DESK_FORTUNE_TIGER_SVR_REQ_JACKPOT value
 * @property {number} MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_END=3018500 MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_END value
 * @property {number} MSGID_DESK_THUNDER_SVR_PUSH_BEGIN=3018501 MSGID_DESK_THUNDER_SVR_PUSH_BEGIN value
 * @property {number} MSGID_DESK_THUNDER_SVR_PUSH_GAMERULE=3018502 MSGID_DESK_THUNDER_SVR_PUSH_GAMERULE value
 * @property {number} MSGID_DESK_THUNDER_SVR_REQ_PLAYBET=3018503 MSGID_DESK_THUNDER_SVR_REQ_PLAYBET value
 * @property {number} MSGID_DESK_THUNDER_SVR_ACK_PLAYBET=3018504 MSGID_DESK_THUNDER_SVR_ACK_PLAYBET value
 * @property {number} MSGID_DESK_THUNDE_SVR_PUSH_BETDATA=3018505 MSGID_DESK_THUNDE_SVR_PUSH_BETDATA value
 * @property {number} MSGID_DESK_THUNDER_SVR_REQ_CARTOON=3018506 MSGID_DESK_THUNDER_SVR_REQ_CARTOON value
 * @property {number} MSGID_DESK_THUNDER_SVR_PUSH_GAMEEND=3018507 MSGID_DESK_THUNDER_SVR_PUSH_GAMEEND value
 * @property {number} MSGID_DESK_THUNDER_SVR_REQ_JACKPOT=3018508 MSGID_DESK_THUNDER_SVR_REQ_JACKPOT value
 * @property {number} MSGID_DESK_THUNDER_SVR_ACK_JACKPOT=3018509 MSGID_DESK_THUNDER_SVR_ACK_JACKPOT value
 * @property {number} MSGID_DESK_THUNDER_SVR_PUSH_END=3018600 MSGID_DESK_THUNDER_SVR_PUSH_END value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BEGIN=3018601 MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BEGIN value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMERULE=3018602 MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMERULE value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_REQ_PLAYBET=3018603 MSGID_DESK_FORTUNEGEMS3_SVR_REQ_PLAYBET value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_ACK_PLAYBET=3018604 MSGID_DESK_FORTUNEGEMS3_SVR_ACK_PLAYBET value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BETDATA=3018605 MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BETDATA value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_REQ_CARTOON=3018606 MSGID_DESK_FORTUNEGEMS3_SVR_REQ_CARTOON value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMEEND=3018607 MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMEEND value
 * @property {number} MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_END=3018700 MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_END value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_BEGIN=2000000 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_PLAYGAMEDATA_INF=2000003 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_PLAYGAMEDATA_INF value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_NOCHARGEPLAY_INF=2000004 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_NOCHARGEPLAY_INF value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_CHARGEPLAY_INF=2000005 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_CHARGEPLAY_INF value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_LINELIGHTDATA_INF=2000008 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_LINELIGHTDATA_INF value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_REQ=2000009 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_REQ value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_ACK=2000010 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_ACK value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_RECORD_INF=2000011 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_RECORD_INF value
 * @property {number} MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_END=2000999 MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_BEGIN=2001000 MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_END=2001999 MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_BEGIN=2002000 MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_END=2002999 MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_PROXY_ROUTE_GAMEDATA_BEGIN=2003000 MSGID_OTHER_PROXY_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_PROXY_ROUTE_GAMEDATA_END=2003999 MSGID_OTHER_PROXY_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_BEGIN=2004000 MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_END=2004999 MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_BEGIN=2081000 MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_EVENTMUNBER_INF=2081002 MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_EVENTMUNBER_INF value
 * @property {number} MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_END=2081999 MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_BEGIN=2082000 MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_EVENTMUNBER_INF=2082001 MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_EVENTMUNBER_INF value
 * @property {number} MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_END=2082999 MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_BEGIN=2083000 MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_END=2083999 MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_BEGIN=2084000 MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_END=2084999 MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_BEGIN=2085000 MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_EVENTMUNBER_INF=2085002 MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_EVENTMUNBER_INF value
 * @property {number} MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_END=2085999 MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_POKER_ROUTE_GAMEDATA_BEGIN=2086000 MSGID_OTHER_POKER_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_POKER_ROUTE_GAMEDATA_END=2086999 MSGID_OTHER_POKER_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_WEB_ROUTE_GAMEDATA_BEGIN=2087000 MSGID_OTHER_WEB_ROUTE_GAMEDATA_BEGIN value
 * @property {number} MSGID_OTHER_WEB_ROUTE_GAMEDATA_REDCHERRYPLAN_INF=2087001 MSGID_OTHER_WEB_ROUTE_GAMEDATA_REDCHERRYPLAN_INF value
 * @property {number} MSGID_OTHER_WEB_ROUTE_GAMEDATA_THREETERMINAL_INF=2087002 MSGID_OTHER_WEB_ROUTE_GAMEDATA_THREETERMINAL_INF value
 * @property {number} MSGID_OTHER_WEB_ROUTE_GAMEDATA_END=2087999 MSGID_OTHER_WEB_ROUTE_GAMEDATA_END value
 * @property {number} MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BEGIN=2088000 MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BEGIN value
 * @property {number} MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_ACTIVITY=2088001 MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_ACTIVITY value
 * @property {number} MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BROKEDATA=2088002 MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BROKEDATA value
 * @property {number} MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_END=2088999 MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_END value
 */
export const MessageID = $root.MessageID = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MSG_BEGIN"] = 0;
    values[valuesById[368] = "MSG_WATCH_HEART_BEAT_REQ"] = 368;
    values[valuesById[369] = "MSG_WATCH_HEART_BEAT_ACK"] = 369;
    values[valuesById[370] = "MSG_SERVER_HEART_BEAT_REQ"] = 370;
    values[valuesById[371] = "MSG_SERVER_HEART_BEAT_ACK"] = 371;
    values[valuesById[1000000] = "MSGID_CIENT_PROXY_SVR_MSGID_BEGIN"] = 1000000;
    values[valuesById[1000001] = "MSGID_CIENT_PROXY_SVR_REQ_LOGIN"] = 1000001;
    values[valuesById[1000002] = "MSGID_CIENT_PROXY_SVR_ACK_LOGIN"] = 1000002;
    values[valuesById[1000003] = "MSGID_CIENT_PROXY_HEART_BEAT_REQ"] = 1000003;
    values[valuesById[1000004] = "MSGID_CIENT_PROXY_HEART_BEAT_ACK"] = 1000004;
    values[valuesById[1000005] = "MSGID_CIENT_PROXY_SVR_REQ_LOGOUT"] = 1000005;
    values[valuesById[1000006] = "MSGID_CIENT_PROXY_SVR_ACK_LOGOUT"] = 1000006;
    values[valuesById[1000007] = "MSGID_CIENT_PROXY_SVR_REQ_POKER_PRODUCT"] = 1000007;
    values[valuesById[1000008] = "MSGID_CIENT_PROXY_SVR_ACK_POKER_PRODUCT"] = 1000008;
    values[valuesById[1000009] = "MSGID_CIENT_PROXY_SVR_REQ_ENTER_GAME"] = 1000009;
    values[valuesById[1000010] = "MSGID_CIENT_PROXY_SVR_ACK_ENTER_GAME"] = 1000010;
    values[valuesById[1000011] = "MSGID_CIENT_PROXY_SVR_REQ_MOBILE_REGISTER"] = 1000011;
    values[valuesById[1000012] = "MSGID_CIENT_PROXY_SVR_ACK_MOBILE_REGISTER"] = 1000012;
    values[valuesById[1000013] = "MSGID_CIENT_PROXY_SVR_REQ_MOBILE_SMS_CODE"] = 1000013;
    values[valuesById[1000014] = "MSGID_CIENT_PROXY_SVR_ACK_MOBILE_SMS_CODE"] = 1000014;
    values[valuesById[1000015] = "MSGID_CIENT_PROXY_SVR_REQ_MOBILE_RESET_PWD"] = 1000015;
    values[valuesById[1000016] = "MSGID_CIENT_PROXY_SVR_ACK_MOBILE_RESET_PWD"] = 1000016;
    values[valuesById[1000017] = "MSGID_CIENT_PROXY_SVR_REQ_LEAVE_GAME"] = 1000017;
    values[valuesById[1000018] = "MSGID_CIENT_PROXY_SVR_ACK_LEAVE_GAME"] = 1000018;
    values[valuesById[1000019] = "MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_ARRIVE"] = 1000019;
    values[valuesById[1000020] = "MSGID_CIENT_PROXY_SVR_REQ_SITDOWN"] = 1000020;
    values[valuesById[1000021] = "MSGID_CIENT_PROXY_SVR_ACK_SITDOWN"] = 1000021;
    values[valuesById[1000022] = "MSGID_CIENT_PROXY_SVR_REQ_STANDUP"] = 1000022;
    values[valuesById[1000023] = "MSGID_CIENT_PROXY_SVR_ACK_STANDUP"] = 1000023;
    values[valuesById[1000024] = "MSGID_CIENT_PROXY_SVR_PUSH_GOLDCHANGE"] = 1000024;
    values[valuesById[1000025] = "MSGID_CIENT_PROXY_SVR_PUSH_LIGHT"] = 1000025;
    values[valuesById[1000026] = "MSGID_CIENT_PROXY_SVR_REQ_SWITCH_TABLE"] = 1000026;
    values[valuesById[1000027] = "MSGID_CIENT_PROXY_SVR_ACK_SWITCH_TABLE"] = 1000027;
    values[valuesById[1000028] = "MSGID_CIENT_PROXY_SVR_PUSH_PAY_NOTIY"] = 1000028;
    values[valuesById[1000029] = "MSGID_CIENT_PROXY_SVR_REQ_WITH_DRAW"] = 1000029;
    values[valuesById[1000030] = "MSGID_CIENT_PROXY_SVR_ACK_WITH_DRAW"] = 1000030;
    values[valuesById[1000031] = "MSGID_CIENT_PROXY_SVR_REQ_TOKEN"] = 1000031;
    values[valuesById[1000032] = "MSGID_CIENT_PROXY_SVR_ACK_TOKEN"] = 1000032;
    values[valuesById[1000033] = "MSGID_CIENT_PROXY_SVR_REQ_GET_BALANCE"] = 1000033;
    values[valuesById[1000034] = "MSGID_CIENT_PROXY_SVR_ACK_GET_BALANCE"] = 1000034;
    values[valuesById[1000035] = "MSGID_CIENT_PROXY_SVR_REQ_WITH_DARAW_RECORD"] = 1000035;
    values[valuesById[1000036] = "MSGID_CIENT_PROXY_SVR_ACK_WITH_DARAW_RECORD"] = 1000036;
    values[valuesById[1000037] = "MSGID_CIENT_PROXY_SVR_KICKOUT_USER"] = 1000037;
    values[valuesById[1000038] = "MSGID_CIENT_PROXY_SVR_USER_BREAK"] = 1000038;
    values[valuesById[1000039] = "MSGID_CIENT_PROXY_SVR_USER_RESUME"] = 1000039;
    values[valuesById[1000040] = "MSGID_CIENT_PROXY_SVR_ACK_TEEN_PATTI_PRODUCT"] = 1000040;
    values[valuesById[1000041] = "MSGID_CIENT_PROXY_SVR_PUSH_SYS_MSG"] = 1000041;
    values[valuesById[1000042] = "MSGID_CIENT_PROXY_SVR_REQ_CHECK_MOBILE_USED"] = 1000042;
    values[valuesById[1000043] = "MSGID_CIENT_PROXY_SVR_ACK_CHECK_MOBILE_USED"] = 1000043;
    values[valuesById[1000044] = "MSGID_CIENT_PROXY_SVR_REQ_GET_PRODUCT_LIST"] = 1000044;
    values[valuesById[1000045] = "MSGID_CIENT_PROXY_SVR_ACK_GET_PRODUCT_LIST"] = 1000045;
    values[valuesById[1000046] = "MSGID_CIENT_PROXY_SVR_REQ_MODIFY_NICKNAME"] = 1000046;
    values[valuesById[1000047] = "MSGID_CIENT_PROXY_SVR_ACK_MODIFY_NICKNAME"] = 1000047;
    values[valuesById[1000048] = "MSGID_CIENT_PROXY_SVR_PUSH_MODIFY_HEAD"] = 1000048;
    values[valuesById[1000049] = "MSGID_CIENT_PROXY_SVR_REQ_MOBILE_LOGIN"] = 1000049;
    values[valuesById[1000050] = "MSGID_CIENT_PROXY_SVR_ACK_MOBILE_LOGIN"] = 1000050;
    values[valuesById[1000051] = "MSGID_CIENT_PROXY_SVR_REQ_TOKEN_LOGIN"] = 1000051;
    values[valuesById[1000052] = "MSGID_CIENT_PROXY_SVR_ACK_TOKEN_LOGIN"] = 1000052;
    values[valuesById[1000053] = "MSGID_CIENT_PROXY_SVR_REQ_REBATE_RECORD"] = 1000053;
    values[valuesById[1000054] = "MSGID_CIENT_PROXY_SVR_ACK_REBATE_RECORD"] = 1000054;
    values[valuesById[1000055] = "MSGID_CIENT_PROXY_SVR_REQ_SET_AGENT"] = 1000055;
    values[valuesById[1000056] = "MSGID_CIENT_PROXY_SVR_ACK_SET_AGENT"] = 1000056;
    values[valuesById[1000057] = "MSGID_CIENT_PROXY_SVR_PUSH_SYS_MAIN"] = 1000057;
    values[valuesById[1000058] = "MSGID_CLIENT_PROXY_SVR_REQ_REBATE_INFO"] = 1000058;
    values[valuesById[1000059] = "MSGID_CLIENT_PROXY_SVR_ACK_REBATE_INFO"] = 1000059;
    values[valuesById[1000060] = "MSGID_CLIENT_PROXY_SVR_REQ_TIME"] = 1000060;
    values[valuesById[1000061] = "MSGID_CLIENT_PROXY_SVR_ACK_TIME"] = 1000061;
    values[valuesById[1000062] = "MSGID_CIENT_PROXY_SVR_PUSH_SIMULATOR"] = 1000062;
    values[valuesById[1000063] = "MSGID_CIENT_PROXY_SVR_PUSH_INGAME"] = 1000063;
    values[valuesById[1000064] = "MSGID_CIENT_PROXY_SVR_PUSH_LBS"] = 1000064;
    values[valuesById[1000065] = "MSGID_CIENT_PROXY_SVR_REQ_STATEMENT"] = 1000065;
    values[valuesById[1000066] = "MSGID_CIENT_PROXY_SVR_ACK_STATEMENT"] = 1000066;
    values[valuesById[1000067] = "MSGID_CIENT_PROXY_SVR_REQ_CHECK_ISPAY"] = 1000067;
    values[valuesById[1000068] = "MSGID_CIENT_PROXY_SVR_ACK_CHECK_ISPAY"] = 1000068;
    values[valuesById[1000069] = "MSGID_CIENT_PROXY_SVR_PUSH_TRANS_MSG"] = 1000069;
    values[valuesById[1000070] = "MSGID_CIENT_PROXY_SVR_REQ_GET_KYC"] = 1000070;
    values[valuesById[1000071] = "MSGID_CIENT_PROXY_SVR_ACK_GET_KYC"] = 1000071;
    values[valuesById[1000072] = "MSGID_CIENT_PROXY_SVR_REQ_CHECK_KYCINFO"] = 1000072;
    values[valuesById[1000073] = "MSGID_CIENT_PROXY_SVR_ACK_CHECK_KYCINFO"] = 1000073;
    values[valuesById[1000074] = "MSGID_CIENT_PROXY_SVR_REQ_CHECK_SMS"] = 1000074;
    values[valuesById[1000075] = "MSGID_CIENT_PROXY_SVR_ACK_CHECK_SMS"] = 1000075;
    values[valuesById[1000076] = "MSGID_CIENT_PROXY_SVR_REQ_GET_GAMECOUNT"] = 1000076;
    values[valuesById[1000077] = "MSGID_CIENT_PROXY_SVR_ACK_GET_GAMECOUNT"] = 1000077;
    values[valuesById[1000078] = "MSGID_CIENT_PROXY_SVR_REQ_GET_PAY_RECORD"] = 1000078;
    values[valuesById[1000079] = "MSGID_CIENT_PROXY_SVR_ACK_GET_PAY_RECORD"] = 1000079;
    values[valuesById[1000080] = "MSGID_CIENT_PROXY_SVR_REQ_PID_PLAYER_COUNT"] = 1000080;
    values[valuesById[1000081] = "MSGID_CIENT_PROXY_SVR_ACK_PID_PLAYER_COUNT"] = 1000081;
    values[valuesById[1000082] = "MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN_CONFIG"] = 1000082;
    values[valuesById[1000083] = "MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN_CONFIG"] = 1000083;
    values[valuesById[1000084] = "MSGID_CIENT_PROXY_SVR_REQ_DAILY_CHECKIN"] = 1000084;
    values[valuesById[1000085] = "MSGID_CIENT_PROXY_SVR_ACK_DAILY_CHECKIN"] = 1000085;
    values[valuesById[1000086] = "MSGID_CIENT_PROXY_SVR_REQ_GET_CUMULATIVE_DAYS"] = 1000086;
    values[valuesById[1000087] = "MSGID_CIENT_PROXY_SVR_ACK_GET_CUMULATIVE_DAYS"] = 1000087;
    values[valuesById[1000088] = "MSGID_CIENT_PROXY_SVR_REQ_PAYMENT"] = 1000088;
    values[valuesById[1000089] = "MSGID_CIENT_PROXY_SVR_ACK_PAYMENT"] = 1000089;
    values[valuesById[1000090] = "MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_KEY"] = 1000090;
    values[valuesById[1000091] = "MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_KEY"] = 1000091;
    values[valuesById[1000092] = "MSGID_CIENT_PROXY_SVR_REQ_RAZORPAY_ORDERID"] = 1000092;
    values[valuesById[1000093] = "MSGID_CIENT_PROXY_SVR_ACK_RAZORPAY_ORDERID"] = 1000093;
    values[valuesById[1000094] = "MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_COUNT"] = 1000094;
    values[valuesById[1000095] = "MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_COUNT"] = 1000095;
    values[valuesById[1000096] = "MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_LIST"] = 1000096;
    values[valuesById[1000097] = "MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_LIST"] = 1000097;
    values[valuesById[1000098] = "MSGID_CIENT_PROXY_SVR_REQ_GET_MAIL_CONTENT"] = 1000098;
    values[valuesById[1000099] = "MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_CONTENT"] = 1000099;
    values[valuesById[1000100] = "MSGID_CIENT_PROXY_SVR_ACK_GET_MAIL_UPDATE"] = 1000100;
    values[valuesById[1000101] = "MSGID_CIENT_PROXY_SVR_REQ_CHECK_CASHINFO"] = 1000101;
    values[valuesById[1000102] = "MSGID_CIENT_PROXY_SVR_ACK_CHECK_CASHINFO"] = 1000102;
    values[valuesById[1000103] = "MSGID_CIENT_PROXY_SVR_REQ_MODIFY_PLAYHEAD"] = 1000103;
    values[valuesById[1000104] = "MSGID_CIENT_PROXY_SVR_ACK_MODIFY_PLAYHEAD"] = 1000104;
    values[valuesById[1000107] = "MSGID_CIENT_PROXY_SVR_REQ_AFSIGN_MESSAGE"] = 1000107;
    values[valuesById[1000108] = "MSGID_CIENT_PROXY_SVR_ACK_AFSIGN_MESSAGE"] = 1000108;
    values[valuesById[1000200] = "MSGTD_WEH_PROXY_SVR_TRA_CLIENT_SEALUSER"] = 1000200;
    values[valuesById[1000201] = "MSGTD_WEB_PROXY_SVR_TRA_ALLGAME_SEALUSER"] = 1000201;
    values[valuesById[1000300] = "MSGID_CIENT_PROXY_SVR_REQ_GET_TOURNEY"] = 1000300;
    values[valuesById[1000301] = "MSGID_CIENT_PROXY_SVR_ACK_GET_TOURNEY"] = 1000301;
    values[valuesById[1000302] = "MSGID_CIENT_PROXY_SVR_REQ_GET_GAME_LIST"] = 1000302;
    values[valuesById[1000303] = "MSGID_CIENT_PROXY_SVR_ACK_GET_GAME_LIST"] = 1000303;
    values[valuesById[1000304] = "MSGID_CIENT_PROXY_SVR_REQ_GET_CASH_MARK"] = 1000304;
    values[valuesById[1000305] = "MSGID_CIENT_PROXY_SVR_ACK_GET_CASH_MARK"] = 1000305;
    values[valuesById[1000306] = "MSGID_CIENT_PROXY_SVR_REQ_APPLE_LOGIN"] = 1000306;
    values[valuesById[1000307] = "MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_RECORD"] = 1000307;
    values[valuesById[1000308] = "MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_RECORD"] = 1000308;
    values[valuesById[1000309] = "MSGID_CIENT_PROXY_SVR_REQ_BALANCE_DETAIL"] = 1000309;
    values[valuesById[1000310] = "MSGID_CIENT_PROXY_SVR_ACK_BALANCE_DETAIL"] = 1000310;
    values[valuesById[1000311] = "MSGID_CIENT_PROXY_SVR_REQ_ACTIVITY_DETAIL"] = 1000311;
    values[valuesById[1000312] = "MSGID_CIENT_PROXY_SVR_ACK_ACTIVITY_DETAIL"] = 1000312;
    values[valuesById[1000313] = "MSGID_CIENT_PROXY_SVR_REQ_APPLE_CANCEL"] = 1000313;
    values[valuesById[1000314] = "MSGID_CIENT_PROXY_SVR_ACK_APPLE_CANCEL"] = 1000314;
    values[valuesById[1000315] = "MSGID_CIENT_PROXY_SVR_REQ_AGENT_REBATE"] = 1000315;
    values[valuesById[1000316] = "MSGID_CIENT_PROXY_SVR_ACK_AGENT_REBATE"] = 1000316;
    values[valuesById[1000317] = "MSGID_CIENT_PROXY_SVR_REQ_REBATE_INFO"] = 1000317;
    values[valuesById[1000318] = "MSGID_CIENT_PROXY_SVR_ACK_REBATE_INFO"] = 1000318;
    values[valuesById[1000319] = "MSGID_CIENT_PROXY_SVR_REQ_GET_REBATE"] = 1000319;
    values[valuesById[1000320] = "MSGID_CIENT_PROXY_SVR_ACK_GET_REBATE"] = 1000320;
    values[valuesById[1000321] = "MSGID_CIENT_PROXY_SVR_REQ_NEW_PAY_UPDATE"] = 1000321;
    values[valuesById[1000322] = "MSGID_CIENT_PROXY_SVR_ACK_NEW_PAY_UPDATE"] = 1000322;
    values[valuesById[1000323] = "MSGID_CIENT_PROXY_SVR_REQ_MATCHLIST"] = 1000323;
    values[valuesById[1000324] = "MSGID_CIENT_PROXY_SVR_ACK_MATCHLIST"] = 1000324;
    values[valuesById[1000325] = "MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN"] = 1000325;
    values[valuesById[1000326] = "MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN"] = 1000326;
    values[valuesById[1000327] = "MSGID_CIENT_PROXY_SVR_REQ_MATCH_SIGN_CANCEL"] = 1000327;
    values[valuesById[1000328] = "MSGID_CIENT_PROXY_SVR_ACK_MATCH_SIGN_CANCEL"] = 1000328;
    values[valuesById[1000329] = "MSGID_CIENT_PROXY_SVR_REQ_MATCH_SCHEDULE"] = 1000329;
    values[valuesById[1000330] = "MSGID_CIENT_PROXY_SVR_ACK_MATCH_SCHEDULE"] = 1000330;
    values[valuesById[1000331] = "MSGID_CIENT_PROXY_SVR_PUSH_MATCH_RESULT"] = 1000331;
    values[valuesById[1000332] = "MSGID_CIENT_PROXY_SVR_PUSH_MATCH_SCHEDULE"] = 1000332;
    values[valuesById[1000333] = "MSGID_CIENT_PROXY_SVR_PUSH_PLAYER_STATUS"] = 1000333;
    values[valuesById[1000334] = "MSGID_CIENT_PROXY_SVR_PUSH_ACTIVITY_STATUS"] = 1000334;
    values[valuesById[1000335] = "MSGID_CIENT_PROXY_SVR_PUSH_BROKEDATA_STATUS"] = 1000335;
    values[valuesById[1000336] = "MSGID_CIENT_PROXY_SVR_PUSH_GAME_JACKPOT"] = 1000336;
    values[valuesById[1000337] = "MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_REQ"] = 1000337;
    values[valuesById[1000338] = "MSGID_CIENT_PROXY_SVR_JACKPOT_DATA_ACK"] = 1000338;
    values[valuesById[1000339] = "MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_REQ"] = 1000339;
    values[valuesById[1000340] = "MSGID_CIENT_PROXY_SVR_BOTGAME_SUPERDATA_ACK"] = 1000340;
    values[valuesById[1000341] = "MSGID_CIENT_ROUTE_SVR_PROXY_PLAYER_STATUS"] = 1000341;
    values[valuesById[1000342] = "MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_REQ"] = 1000342;
    values[valuesById[1000343] = "MSGID_CIENT_BOUNS_SVR_SIGNINGCONFIG_ACK"] = 1000343;
    values[valuesById[1000344] = "MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_REQ"] = 1000344;
    values[valuesById[1000345] = "MSGID_CIENT_BOUNS_SVR_SIGNINGGOLD_ACK"] = 1000345;
    values[valuesById[1000346] = "MSGID_CIENT_BOUNS_SVR_DRAWNUM_REQ"] = 1000346;
    values[valuesById[1000347] = "MSGID_CIENT_BOUNS_SVR_DRAWNUM_ACK"] = 1000347;
    values[valuesById[1000348] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE_REQ"] = 1000348;
    values[valuesById[1000349] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE_ACK"] = 1000349;
    values[valuesById[1000350] = "MSGID_CIENT_HALL_SVR_RANKINGDATA_REQ"] = 1000350;
    values[valuesById[1000351] = "MSGID_CIENT_HALL_SVR_RANKINGDATA_ACK"] = 1000351;
    values[valuesById[1000352] = "MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_REQ"] = 1000352;
    values[valuesById[1000353] = "MSGID_CIENT_HALL_SVR_RANKINGJACKPOT_ACK"] = 1000353;
    values[valuesById[1000354] = "MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_REQ"] = 1000354;
    values[valuesById[1000355] = "MSGID_CIENT_HALL_SVR_RANKINGPRIZEGOLD_ACK"] = 1000355;
    values[valuesById[1000356] = "MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_REQ"] = 1000356;
    values[valuesById[1000357] = "MSGID_CIENT_HALL_SVR_RANKINGGETPRIZE_ACK"] = 1000357;
    values[valuesById[1000358] = "MSGID_CIENT_HALL_SVR_CP2D_BET_REQ"] = 1000358;
    values[valuesById[1000359] = "MSGID_CIENT_HALL_SVR_CP2D_BET_ACK"] = 1000359;
    values[valuesById[1000360] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE2_REQ"] = 1000360;
    values[valuesById[1000361] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE2_ACK"] = 1000361;
    values[valuesById[1000362] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_REQ"] = 1000362;
    values[valuesById[1000363] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE2GOLD_ACK"] = 1000363;
    values[valuesById[1000364] = "MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_REQ"] = 1000364;
    values[valuesById[1000365] = "MSGID_CIENT_HALL_SVR_CP2D_NUM_RECORD_ACK"] = 1000365;
    values[valuesById[1000366] = "MSGID_CIENT_HALL_SVR_CP3D_BET_REQ"] = 1000366;
    values[valuesById[1000367] = "MSGID_CIENT_HALL_SVR_CP3D_BET_ACK"] = 1000367;
    values[valuesById[1000368] = "MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_REQ"] = 1000368;
    values[valuesById[1000369] = "MSGID_CIENT_HALL_SVR_CP3D_NUM_RECORD_ACK"] = 1000369;
    values[valuesById[1000370] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_REQ"] = 1000370;
    values[valuesById[1000371] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFT_ACK"] = 1000371;
    values[valuesById[1000372] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_REQ"] = 1000372;
    values[valuesById[1000373] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3PLAYDATA_ACK"] = 1000373;
    values[valuesById[1000374] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_REQ"] = 1000374;
    values[valuesById[1000375] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3SPIN_ACK"] = 1000375;
    values[valuesById[1000376] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_REQ"] = 1000376;
    values[valuesById[1000377] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3PRIZE_ACK"] = 1000377;
    values[valuesById[1000378] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_REQ"] = 1000378;
    values[valuesById[1000379] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3WINRECORD_ACK"] = 1000379;
    values[valuesById[1000380] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_REQ"] = 1000380;
    values[valuesById[1000381] = "MSGID_CIENT_BOUNS_SVR_TURNTABLE3GIFTGET_ACK"] = 1000381;
    values[valuesById[1000382] = "MSGID_CIENT_PROXY_SVR_REQISTER_REQ"] = 1000382;
    values[valuesById[1000383] = "MSGID_CIENT_PROXY_SVR_REQISTER_ACK"] = 1000383;
    values[valuesById[1000384] = "MSGID_CIENT_PROXY_SVR_LOGGING_REQ"] = 1000384;
    values[valuesById[1000385] = "MSGID_CIENT_PROXY_SVR_LOGGING_ACK"] = 1000385;
    values[valuesById[1000386] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_REQ"] = 1000386;
    values[valuesById[1000387] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_ACK"] = 1000387;
    values[valuesById[1000388] = "MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_REQ"] = 1000388;
    values[valuesById[1000389] = "MSGID_CIENT_PROXY_SVR_LUCKYSPINGET_ACK"] = 1000389;
    values[valuesById[1000390] = "MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_REQ"] = 1000390;
    values[valuesById[1000391] = "MSGID_CIENT_PROXY_SVR_LUCKYSPINPLAY_ACK"] = 1000391;
    values[valuesById[1000392] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_REQ"] = 1000392;
    values[valuesById[1000393] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_AGG_ACK"] = 1000393;
    values[valuesById[1000394] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_REQ"] = 1000394;
    values[valuesById[1000395] = "MSGID_CIENT_PROXY_SVR_SIGN_ACTIVITY_IN_ACK"] = 1000395;
    values[valuesById[1000396] = "MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_REQ"] = 1000396;
    values[valuesById[1000397] = "MSGID_CIENT_PROXY_SVR_SIGN_FREE_SPIN_ACK"] = 1000397;
    values[valuesById[1000398] = "MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_REQ"] = 1000398;
    values[valuesById[1000399] = "MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_ACK"] = 1000399;
    values[valuesById[1000400] = "MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_REQ"] = 1000400;
    values[valuesById[1000401] = "MSGID_CIENT_PROXY_SVR_SIGN_EVERYDAY_GOLD_ACK"] = 1000401;
    values[valuesById[1000402] = "MSGID_CIENT_PROXY_SVR_BOXACT_REQ"] = 1000402;
    values[valuesById[1000403] = "MSGID_CIENT_PROXY_SVR_BOXACT_ACK"] = 1000403;
    values[valuesById[1000404] = "MSGID_CIENT_PROXY_SVR_BOXACT_GET_REQ"] = 1000404;
    values[valuesById[1000405] = "MSGID_CIENT_PROXY_SVR_BOXACT_GET_ACK"] = 1000405;
    values[valuesById[1000406] = "MSGID_CIENT_PROXY_SVR_GEM_ACT_REQ"] = 1000406;
    values[valuesById[1000407] = "MSGID_CIENT_PROXY_SVR_GEM_ACT_ACK"] = 1000407;
    values[valuesById[1000408] = "MSGID_CIENT_PROXY_SVR_GEM_DATA_REQ"] = 1000408;
    values[valuesById[1000409] = "MSGID_CIENT_PROXY_SVR_GEM_DATA_ACK"] = 1000409;
    values[valuesById[1000410] = "MSGID_CIENT_PROXY_SVR_GEM_GET_REQ"] = 1000410;
    values[valuesById[1000411] = "MSGID_CIENT_PROXY_SVR_GEM_GET_ACK"] = 1000411;
    values[valuesById[1000412] = "MSGID_CIENT_PROXY_SVR_GEM_PRIZE_REQ"] = 1000412;
    values[valuesById[1000413] = "MSGID_CIENT_PROXY_SVR_GEM_PRIZE_ACK"] = 1000413;
    values[valuesById[1009900] = "MSGID_CLIENT_GATE_SVR_BEGIN"] = 1009900;
    values[valuesById[1009901] = "MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_REQ"] = 1009901;
    values[valuesById[1009902] = "MSGID_CLIENT_GATE_SVR_QUERY_ADDRESS_ACK"] = 1009902;
    values[valuesById[1010000] = "MSGID_CIENT_PROXY_GAME_SVR_MSGID_BEGIN"] = 1010000;
    values[valuesById[1010001] = "MSGID_CIENT_PROXY_GAME_SVR_REQ_TEST"] = 1010001;
    values[valuesById[1010002] = "MSGID_CIENT_PROXY_GAME_SVR_ACK_TEST"] = 1010002;
    values[valuesById[1010003] = "MSGID_CIENT_PROXY_GAME_SVR_REQ_EMOJI"] = 1010003;
    values[valuesById[1010004] = "MSGID_CIENT_PROXY_GAME_SVR_ACK_EMOJI"] = 1010004;
    values[valuesById[1020000] = "MSGID_CIENT_PROXY_GAME_SVR_MSGID_END"] = 1020000;
    values[valuesById[3000000] = "MSGID_PROXY_ACCOUNT_SVR_MSGID_BEGIN"] = 3000000;
    values[valuesById[3000001] = "MSGID_PROXY_ACCOUNT_REQ_CheckClient_Mark"] = 3000001;
    values[valuesById[3000002] = "MSGID_PROXY_ACCOUNT_ACK_CheckClient_Mark"] = 3000002;
    values[valuesById[3000003] = "MSGID_PROXY_ACCOUNT_REQ_MOBILE_SMS_CODE"] = 3000003;
    values[valuesById[3000004] = "MSGID_PROXY_ACCOUNT_ACK_MOBILE_SMS_CODE"] = 3000004;
    values[valuesById[3000005] = "MSGID_PROXY_ACCOUNT_REQ_MOBILE_REGISTER"] = 3000005;
    values[valuesById[3000006] = "MSGID_PROXY_ACCOUNT_ACK_MOBILE_REGISTER"] = 3000006;
    values[valuesById[3000007] = "MSGID_PROXY_ACCOUNT_REQ_MOBILE_LOGIN"] = 3000007;
    values[valuesById[3000008] = "MSGID_PROXY_ACCOUNT_ACK_MOBILE_LOGIN"] = 3000008;
    values[valuesById[3000009] = "MSGID_PROXY_ACCOUNT_REQ_FACEBOOK_LOGIN"] = 3000009;
    values[valuesById[3000010] = "MSGID_PROXY_ACCOUNT_ACK_FACEBOOK_LOGIN"] = 3000010;
    values[valuesById[3000011] = "MSGID_PROXY_ACCOUNT_REQ_MOBILE_RESET_PWD"] = 3000011;
    values[valuesById[3000012] = "MSGID_PROXY_ACCOUNT_ACK_MOBILE_RESET_PWD"] = 3000012;
    values[valuesById[3000013] = "MSGID_PROXY_ACCOUNT_PUSH_LOGIN_SUCCESS"] = 3000013;
    values[valuesById[3000014] = "MSGID_PROXY_ACCOUNT_REQ_WITH_DRAW"] = 3000014;
    values[valuesById[3000015] = "MSGID_PROXY_ACCOUNT_ACK_WITH_DRAW"] = 3000015;
    values[valuesById[3000016] = "MSGID_PROXY_ACCOUNT_REQ_GET_BALANCE"] = 3000016;
    values[valuesById[3000017] = "MSGID_PROXY_ACCOUNT_ACK_GET_BALANCE"] = 3000017;
    values[valuesById[3000018] = "MSGID_PROXY_ACCOUNT_REQ_WITH_DARAW_RECORD"] = 3000018;
    values[valuesById[3000019] = "MSGID_PROXY_ACCOUNT_ACK_WITH_DARAW_RECORD"] = 3000019;
    values[valuesById[3000020] = "MSGID_PROXY_ACCOUNT_REQ_GET_SYS_MSG"] = 3000020;
    values[valuesById[3000021] = "MSGID_PROXY_ACCOUNT_ACK_GET_SYS_MSG"] = 3000021;
    values[valuesById[3000022] = "MSGID_PROXY_ACCOUNT_REQ_CHECK_MOBLIE_USED"] = 3000022;
    values[valuesById[3000023] = "MSGID_PROXY_ACCOUNT_ACK_CHECK_MOBLIE_USED"] = 3000023;
    values[valuesById[3000024] = "MSGID_PROXY_ACCOUNT_REQ_MODIFY_NICKNAME"] = 3000024;
    values[valuesById[3000025] = "MSGID_PROXY_ACCOUNT_ACK_MODIFY_NICKNAME"] = 3000025;
    values[valuesById[3000026] = "MSGID_PROXY_ACCOUNT_REQ_GET_TOKEN"] = 3000026;
    values[valuesById[3000027] = "MSGID_PROXY_ACCOUNT_ACK_GET_TOKEN"] = 3000027;
    values[valuesById[3000028] = "MSGID_PROXY_ACCOUNT_REQ_NEW_MOBILE_LOGIN"] = 3000028;
    values[valuesById[3000029] = "MSGID_PROXY_ACCOUNT_ACK_NEW_MOBILE_LOGIN"] = 3000029;
    values[valuesById[3000030] = "MSGID_PROXY_ACCOUNT_REQ_TOKEN_LOGIN"] = 3000030;
    values[valuesById[3000031] = "MSGID_PROXY_ACCOUNT_ACK_TOKEN_LOGIN"] = 3000031;
    values[valuesById[3000032] = "MSGID_PROXY_ACCOUNT_SVR_PUSH_SIMULATOR"] = 3000032;
    values[valuesById[3000033] = "MSGID_PROXY_ACCOUNT_SVR_REQ_STATEMENT"] = 3000033;
    values[valuesById[3000034] = "MSGID_PROXY_ACCOUNT_SVR_ACK_STATEMENT"] = 3000034;
    values[valuesById[3000035] = "MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_ISPAY"] = 3000035;
    values[valuesById[3000036] = "MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_ISPAY"] = 3000036;
    values[valuesById[3000037] = "MSGID_PROXY_ACCOUNT_SVR_REQ_GET_KYC"] = 3000037;
    values[valuesById[3000038] = "MSGID_PROXY_ACCOUNT_SVR_ACK_GET_KYC"] = 3000038;
    values[valuesById[3000039] = "MSGID_PROXY_ACCOUNT_REQ_CHECK_KYCINFO"] = 3000039;
    values[valuesById[3000040] = "MSGID_PROXY_ACCOUNT_ACK_CHECK_KYCINFO"] = 3000040;
    values[valuesById[3000041] = "MSGID_PROXY_ACCOUNT_SVR_REQ_CHECK_SMS"] = 3000041;
    values[valuesById[3000042] = "MSGID_PROXY_ACCOUNT_SVR_ACK_CHECK_SMS"] = 3000042;
    values[valuesById[3000043] = "MSGID_PROXY_ACCOUNT_REQ_GET_GAMECOUNT"] = 3000043;
    values[valuesById[3000044] = "MSGID_PROXY_ACCOUNT_ACK_GET_GAMECOUNT"] = 3000044;
    values[valuesById[3000045] = "MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_RECORD"] = 3000045;
    values[valuesById[3000046] = "MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_RECORD"] = 3000046;
    values[valuesById[3000047] = "MSGID_PROXY_ACCOUNT_SVR_REQ_PAYMENT"] = 3000047;
    values[valuesById[3000048] = "MSGID_PROXY_ACCOUNT_SVR_ACK_PAYMENT"] = 3000048;
    values[valuesById[3000049] = "MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_KEY"] = 3000049;
    values[valuesById[3000050] = "MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_KEY"] = 3000050;
    values[valuesById[3000051] = "MSGID_PROXY_ACCOUNT_SVR_REQ_RAZORPAY_ORDERID"] = 3000051;
    values[valuesById[3000052] = "MSGID_PROXY_ACCOUNT_SVR_ACK_RAZORPAY_ORDERID"] = 3000052;
    values[valuesById[3000053] = "MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_COUNT"] = 3000053;
    values[valuesById[3000054] = "MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_COUNT"] = 3000054;
    values[valuesById[3000055] = "MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_LIST"] = 3000055;
    values[valuesById[3000056] = "MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_LIST"] = 3000056;
    values[valuesById[3000057] = "MSGID_PROXY_ACCOUNT_SVR_REQ_MAIL_CONTENT"] = 3000057;
    values[valuesById[3000058] = "MSGID_PROXY_ACCOUNT_SVR_ACK_MAIL_CONTENT"] = 3000058;
    values[valuesById[3000059] = "MSGID_PROXY_ACCOUNT_SVR_PUSH_MAIL_UPDATE"] = 3000059;
    values[valuesById[3000060] = "MSGID_PROXY_ACCOUNT_SVR_REQ_GET_GAME_LIST"] = 3000060;
    values[valuesById[3000061] = "MSGID_PROXY_ACCOUNT_SVR_ACK_GET_GAME_LIST"] = 3000061;
    values[valuesById[3000062] = "MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_LOGIN"] = 3000062;
    values[valuesById[3000063] = "MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_LOGIN"] = 3000063;
    values[valuesById[3000064] = "MSGID_PROXY_ACCOUNT_SVR_REQ_NEW_PAY_RECORD"] = 3000064;
    values[valuesById[3000065] = "MSGID_PROXY_ACCOUNT_SVR_ACK_NEW_PAY_RECORD"] = 3000065;
    values[valuesById[3000066] = "MSGID_PROXY_ACCOUNT_SVR_REQ_BALANCE_DETAIL"] = 3000066;
    values[valuesById[3000067] = "MSGID_PROXY_ACCOUNT_SVR_ACK_BALANCE_DETAIL"] = 3000067;
    values[valuesById[3000068] = "MSGID_PROXY_ACCOUNT_REQ_CHECK_CASHINFO"] = 3000068;
    values[valuesById[3000069] = "MSGID_PROXY_ACCOUNT_ACK_CHECK_CASHINFO"] = 3000069;
    values[valuesById[3000070] = "MSGID_PROXY_ACCOUNT_SVR_REQ_ACTIVITY_DETAIL"] = 3000070;
    values[valuesById[3000071] = "MSGID_PROXY_ACCOUNT_SVR_ACK_ACTIVITY_DETAIL"] = 3000071;
    values[valuesById[3000072] = "MSGID_PROXY_ACCOUNT_SVR_REQ_APPLE_CANCEL"] = 3000072;
    values[valuesById[3000073] = "MSGID_PROXY_ACCOUNT_SVR_ACK_APPLE_CANCEL"] = 3000073;
    values[valuesById[3000074] = "MSGID_PROXY_ACCOUNT_SVR_REQ_AGENT_REBATE"] = 3000074;
    values[valuesById[3000075] = "MSGID_PROXY_ACCOUNT_SVR_ACK_AGENT_REBATE"] = 3000075;
    values[valuesById[3000076] = "MSGID_PROXY_ACCOUNT_SVR_REQ_REBATE_INFO"] = 3000076;
    values[valuesById[3000077] = "MSGID_PROXY_ACCOUNT_SVR_ACK_REBATE_INFO"] = 3000077;
    values[valuesById[3000078] = "MSGID_PROXY_ACCOUNT_SVR_REQ_GET_REBATE"] = 3000078;
    values[valuesById[3000079] = "MSGID_PROXY_ACCOUNT_SVR_ACK_GET_REBATE"] = 3000079;
    values[valuesById[3000080] = "MSGID_PROXY_ACCOUNT_REQ_MODIFY_PLAYHEAD"] = 3000080;
    values[valuesById[3000081] = "MSGID_PROXY_ACCOUNT_ACK_MODIFY_PLAYHEAD"] = 3000081;
    values[valuesById[3000082] = "MSGID_PROXY_ACCOUNT_SVR_REQ_GET_PAY_UPDATE"] = 3000082;
    values[valuesById[3000083] = "MSGID_PROXY_ACCOUNT_SVR_ACK_GET_PAY_UPDATE"] = 3000083;
    values[valuesById[3000086] = "MSGID_PROXY_ACCOUNT_SVR_ACK_SEALUSER"] = 3000086;
    values[valuesById[3000087] = "MSGID_PROXY_ACCOUNT_SVR_REQ_AFSIGN_MESSAGE"] = 3000087;
    values[valuesById[3000088] = "MSGID_PROXY_ACCOUNT_SVR_ACK_AFSIGN_MESSAGE"] = 3000088;
    values[valuesById[3000089] = "MSGID_PROXY_ACCOUNT_SVR_ACK_WEB_WITHDRAW"] = 3000089;
    values[valuesById[3000090] = "MSGID_PROXY_ACCOUNT_SVR_REGISTER_REQ"] = 3000090;
    values[valuesById[3000091] = "MSGID_PROXY_ACCOUNT_SVR_REGISTER_ACK"] = 3000091;
    values[valuesById[3000092] = "MSGID_PROXY_ACCOUNT_SVR_LOGGING_REQ"] = 3000092;
    values[valuesById[3000093] = "MSGID_PROXY_ACCOUNT_SVR_LOGGING_ACK"] = 3000093;
    values[valuesById[3001000] = "MSGID_PROXY_ACCOUNT_SVR_MSGID_END"] = 3001000;
    values[valuesById[3001001] = "MSGID_PROXY_ONLINE_SVR_MSGID_BEGIN"] = 3001001;
    values[valuesById[3001002] = "MSGID_PROXY_ONLINE_REQ_CHECKUSER_ONLINE"] = 3001002;
    values[valuesById[3001003] = "MSGID_PROXY_ONLINE_ACK_CHECKUSER_ONLINE"] = 3001003;
    values[valuesById[3001004] = "MSGID_PROXY_ONLINE_REQ_USER_LEAVE"] = 3001004;
    values[valuesById[3001005] = "MSGID_PROXY_ONLINE_PUSH_GOLD_CHANGE"] = 3001005;
    values[valuesById[3001006] = "MSGID_PROXY_ONLINE_PUSH_LIGHT"] = 3001006;
    values[valuesById[3001007] = "MSGID_PROXY_ONLINE_PUSH_USER_PAY"] = 3001007;
    values[valuesById[3001008] = "MSGID_PROXY_ONLINE_PUSH_SYS_MSG"] = 3001008;
    values[valuesById[3001009] = "MSGID_PROXY_ONLINE_PUSH_MODIFY_HEAD"] = 3001009;
    values[valuesById[3001010] = "MSGID_PROXY_ONLINE_PUSH_SYNC_REBATE"] = 3001010;
    values[valuesById[3001011] = "MSGID_PROXY_ONLINE_PUSH_USER_LBS"] = 3001011;
    values[valuesById[3001012] = "MSGID_PROXY_ONLINE_PUSH_TRANS_MSG"] = 3001012;
    values[valuesById[3001015] = "MSGID_PROXY_ONLINE_SVR_PUSH_PLAYER_POS"] = 3001015;
    values[valuesById[3001016] = "MSGID_PROXY_ONLINE_SVR_PUSH_MAIL_UPDATE"] = 3001016;
    values[valuesById[3002000] = "MSGID_PROXY_ONLINE_SVR_MSGID_END"] = 3002000;
    values[valuesById[3002001] = "MSGID_PROXY_DESK_SVR_MSGID_BEGIN"] = 3002001;
    values[valuesById[3002002] = "MSGID_PROXY_DESK_REQ_POKER_PRODUCT"] = 3002002;
    values[valuesById[3002003] = "MSGID_PROXY_DESK_ACK_POKER_PRODUCT"] = 3002003;
    values[valuesById[3002004] = "MSGID_PROXY_DESK_REQ_ENTER_GAME"] = 3002004;
    values[valuesById[3002005] = "MSGID_PROXY_DESK_ACK_ENTER_GAME"] = 3002005;
    values[valuesById[3002006] = "MSGID_PROXY_DESK_REQ_REGISTER_SVRID"] = 3002006;
    values[valuesById[3002007] = "MSGID_PROXY_DESK_ACK_REGISTER_SVRID"] = 3002007;
    values[valuesById[3002008] = "MSGID_PROXY_DESK_REQ_PLAYER_BREAK"] = 3002008;
    values[valuesById[3002009] = "MSGID_PROXY_DESK_REQ_PLAYER_LEAVE"] = 3002009;
    values[valuesById[3002010] = "MSGID_PROXY_DESK_ACK_PLAYER_LEAVE"] = 3002010;
    values[valuesById[3002011] = "MSGID_PROXY_DESK_PUSH_PLAYER_ARRIVE"] = 3002011;
    values[valuesById[3002013] = "MSGID_PROXY_DESK_REQ_SITDOWN"] = 3002013;
    values[valuesById[3002014] = "MSGID_PROXY_DESK_ACK_SITDOWN"] = 3002014;
    values[valuesById[3002015] = "MSGID_PROXY_DESK_REQ_STANDUP"] = 3002015;
    values[valuesById[3002016] = "MSGID_PROXY_DESK_ACK_STANDUP"] = 3002016;
    values[valuesById[3002017] = "MSGID_PROXY_DESK_REQ_SWITCH_TABLE"] = 3002017;
    values[valuesById[3002018] = "MSGID_PROXY_DESK_ACK_SWITCH_TABLE"] = 3002018;
    values[valuesById[3002019] = "MSGID_PROXY_DESK_PUSH_PLAYER_BREAK"] = 3002019;
    values[valuesById[3002020] = "MSGID_PROXY_DESK_PUSH_PLAYER_RESUME"] = 3002020;
    values[valuesById[3002021] = "MSGID_PROXY_DESK_ACK_TEENPATTI_PRODUCT"] = 3002021;
    values[valuesById[3002022] = "MSGID_PROXY_DESK_REQ_GET_PRODUCT_LIST"] = 3002022;
    values[valuesById[3002023] = "MSGID_PROXY_DESK_ACK_GET_PRODUCT_LIST"] = 3002023;
    values[valuesById[3002024] = "MSGID_PROXY_DESK_ACK_RUMMY_PRODUCT"] = 3002024;
    values[valuesById[3002025] = "MSGID_PROXY_DESK_PLAYER_PAY"] = 3002025;
    values[valuesById[3002026] = "MSGID_PROXY_DESK_PUSH_SYS_MAIN"] = 3002026;
    values[valuesById[3002027] = "MSGID_PROXY_DESK_REQ_PID_PLAYER_COUNT"] = 3002027;
    values[valuesById[3002028] = "MSGID_PROXY_DESK_ACK_PID_PLAYER_COUNT"] = 3002028;
    values[valuesById[3002029] = "MSGID_PROXY_DESK_REQ_MATCHLIST"] = 3002029;
    values[valuesById[3002030] = "MSGID_PROXY_DESK_ACK_MATCHLIST"] = 3002030;
    values[valuesById[3002031] = "MSGID_PROXY_DESK_REQ_MATCH_SIGN"] = 3002031;
    values[valuesById[3002032] = "MSGID_PROXY_DESK_ACK_MATCH_SIGN"] = 3002032;
    values[valuesById[3002033] = "MSGID_PROXY_DESK_REQ_MATCH_SIGN_CANCEL"] = 3002033;
    values[valuesById[3002034] = "MSGID_PROXY_DESK_ACK_MATCH_SIGN_CANCEL"] = 3002034;
    values[valuesById[3002035] = "MSGID_PROXY_DESK_REQ_MATCH_SCHEDULE"] = 3002035;
    values[valuesById[3002036] = "MSGID_PROXY_DESK_ACK_MATCH_SCHEDULE"] = 3002036;
    values[valuesById[3002037] = "MSGID_PROXY_DESK_PUSH_MATCH_RESULT"] = 3002037;
    values[valuesById[3002038] = "MSGID_PROXY_DESK_PUSH_MATCH_SCHEDULE"] = 3002038;
    values[valuesById[3003000] = "MSGID_PROXY_DESK_SVR_MSGID_END"] = 3003000;
    values[valuesById[3003001] = "MSGID_WEB_ACCOUNT_SVR_MSGID_BEGIN"] = 3003001;
    values[valuesById[3003002] = "MSGID_WEB_ACCOUNT_SVR_GM_COMMAND"] = 3003002;
    values[valuesById[3003003] = "MSGID_WEB_ACCOUNT_SVR_USER_PAY"] = 3003003;
    values[valuesById[3003004] = "MSGID_WEB_ACCOUNT_SVR_SYS_MSG"] = 3003004;
    values[valuesById[3003005] = "MSGID_WEB_ACCOUNT_SVR_MODIFY_HEAD"] = 3003005;
    values[valuesById[3003006] = "MSGID_WEB_ACCOUNT_SVR_NEW_USER_GIFT"] = 3003006;
    values[valuesById[3003007] = "MSGID_WEB_ACCOUNT_SVR_MAIL_UPDATE"] = 3003007;
    values[valuesById[3003008] = "MSGID_WEB_ACCOUNT_SVR_NEW_USER_PAY"] = 3003008;
    values[valuesById[3003009] = "MSGID_WEB_ACCOUNT_SVR_SEAL_NUMBER"] = 3003009;
    values[valuesById[3003010] = "MSGID_WEB_ACCOUNT_SVR_WITHDRAW_RESULT"] = 3003010;
    values[valuesById[3004000] = "MSGID_WEB_ACCOUNT_SVR_MSGID_END"] = 3004000;
    values[valuesById[3004001] = "MSGID_PROXY_POSTION_SVR_MSGID_BEGIN"] = 3004001;
    values[valuesById[3004004] = "MSGID_PROXY_POSTION_SVR_PUSH_PLAYER_POS"] = 3004004;
    values[valuesById[3004005] = "MSGID_WEB_POSTION_SVR_CLEAR_PLAYER_POS"] = 3004005;
    values[valuesById[3005000] = "MSGID_PROXY_POSTION_SVR_MSGID_END"] = 3005000;
    values[valuesById[3005001] = "MSGID_GAME_SVR_MSGID_BEGIN"] = 3005001;
    values[valuesById[3005002] = "MSGID_GAME_SVR_REQ_REGISTER"] = 3005002;
    values[valuesById[3005003] = "MSGID_GAME_SVR_ACK_REGISTER"] = 3005003;
    values[valuesById[3005004] = "MSGID_DESK_GAME_SVR_REQ_CREATEDESK"] = 3005004;
    values[valuesById[3005005] = "MSGID_DESK_GAME_SVR_ACK_CREATEDESK"] = 3005005;
    values[valuesById[3005006] = "MSGID_DESK_GAME_SVR_REQ_PLAYERARRIVE"] = 3005006;
    values[valuesById[3005007] = "MSGID_DESK_GAME_SVR_ACK_PLAYERARRIVE"] = 3005007;
    values[valuesById[3005008] = "MSGID_DESK_GAME_SVR_REQ_PLAYERLEAVE"] = 3005008;
    values[valuesById[3005009] = "MSGID_DESK_GAME_SVR_ACK_PLAYERLEAVE"] = 3005009;
    values[valuesById[3005010] = "MSGID_DESK_GAME_SVR_REQ_SITDOWN"] = 3005010;
    values[valuesById[3005011] = "MSGID_DESK_GAME_SVR_ACK_SITDOWN"] = 3005011;
    values[valuesById[3005012] = "MSGID_DESK_GAME_SVR_REQ_STANDUP"] = 3005012;
    values[valuesById[3005013] = "MSGID_DESK_GAME_SVR_ACK_STANDUP"] = 3005013;
    values[valuesById[3005014] = "MSGID_DESK_GAME_SVR_PUSH_TIMER"] = 3005014;
    values[valuesById[3005015] = "MSGID_DESK_GAME_SVR_PUSH_STARTGAME"] = 3005015;
    values[valuesById[3005016] = "MSGID_DESK_GAME_SVR_PUSH_COMMAND"] = 3005016;
    values[valuesById[3005017] = "MSGID_DESK_GAME_SVR_PUSH_PLAYINGINFO"] = 3005017;
    values[valuesById[3005018] = "MSGID_DESK_GAME_SVR_PUSH_DEALCARD"] = 3005018;
    values[valuesById[3005019] = "MSGID_DESK_GAME_SVR_REQ_COMMAND"] = 3005019;
    values[valuesById[3005020] = "MSGID_DESK_GAME_SVR_ACK_COMMAND"] = 3005020;
    values[valuesById[3005021] = "MSGID_DESK_GAME_SVR_REQ_SHOWCARD"] = 3005021;
    values[valuesById[3005022] = "MSGID_DESK_GAME_SVR_ACK_SHOWCARD"] = 3005022;
    values[valuesById[3005023] = "MSGID_DESK_GAME_SVR_PUSH_GAMERESULT"] = 3005023;
    values[valuesById[3005024] = "MSGID_DESK_GAME_SVR_PUSH_KICKOUT"] = 3005024;
    values[valuesById[3005025] = "MSGID_DESK_GAME_SVR_REQ_RESUME"] = 3005025;
    values[valuesById[3005026] = "MSGID_DESK_GAME_SVR_REQ_BREAK"] = 3005026;
    values[valuesById[3005027] = "MSGID_DESK_GAME_SVR_PUSH_STATE_MACHINE"] = 3005027;
    values[valuesById[3005028] = "MSGID_DESK_GAME_SVR_PUSH_ASEET_INFO"] = 3005028;
    values[valuesById[3005029] = "MSGID_DESK_GAME_SVR_PUSH_PAY"] = 3005029;
    values[valuesById[3005030] = "MSGID_DESK_GAME_SVR_REQ_SWTICHTABLE"] = 3005030;
    values[valuesById[3005031] = "MSGID_DESK_GAME_SVR_ACK_SWTICHTABLE"] = 3005031;
    values[valuesById[3005032] = "MSGID_DESK_GAME_SVR_PUSH_DESK_STATUS"] = 3005032;
    values[valuesById[3005033] = "MSGID_DESK_GAME_SVR_PUSH_SYS_MAIN"] = 3005033;
    values[valuesById[3005034] = "MSGID_DESK_GAME_SVR_RECYCLE_DESK"] = 3005034;
    values[valuesById[3005035] = "MSGID_DESK_GAME_SVR_ACK_STANDUPEX"] = 3005035;
    values[valuesById[3005036] = "MSGID_DESK_GAME_SVR_ACK_SITDOWNEX"] = 3005036;
    values[valuesById[3005037] = "MSGID_DESK_GAME_SVR_PUSH_BOT_PREINFO"] = 3005037;
    values[valuesById[3005038] = "MSGID_DESK_GAME_SVR_PUSH_SCORE_CHANGE"] = 3005038;
    values[valuesById[3005300] = "MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE"] = 3005300;
    values[valuesById[3005301] = "MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE"] = 3005301;
    values[valuesById[3005302] = "MSGID_GAME_ACCOUNT_SVR_PUSH_LIGHT"] = 3005302;
    values[valuesById[3005303] = "MSGID_GAME_ACCOUNT_SVR_REQ_USER_CASHGOLD"] = 3005303;
    values[valuesById[3005304] = "MSGID_GAME_ACCOUNT_SVR_ACK_USER_CASHGOLD"] = 3005304;
    values[valuesById[3005305] = "MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_CHANGE_EX"] = 3005305;
    values[valuesById[3005306] = "MSGID_GAME_ACCOUNT_SVR_ACK_GOLD_CHANGE_EX"] = 3005306;
    values[valuesById[3005307] = "MSGID_BIG_BATTLE_GAME_DATA_SVR_REQ_STOCK_CHANGE"] = 3005307;
    values[valuesById[3005308] = "MSGID_BIG_BATTLE_GAME_DATA_SVR_ACK_STOCK_CHANGE"] = 3005308;
    values[valuesById[3005309] = "MSGID_POKER_WAR_GAME_DATA_SVR_REQ_STOCK_CHANGE"] = 3005309;
    values[valuesById[3005310] = "MSGID_POKER_WAR_GAME_DATA_SVR_ACK_STOCK_CHANGE"] = 3005310;
    values[valuesById[3005311] = "MSGID_RUMMY_GAME_PLAY_RECORD_DATA_ACCOUNT"] = 3005311;
    values[valuesById[3005312] = "MSGID_GAME_ACCOUNT_SVR_REQ_MATCH_GOLD_CHANGE"] = 3005312;
    values[valuesById[3005313] = "MSGID_GAME_ACCOUNT_SVR_ACK_MATCH_GOLD_CHANGE"] = 3005313;
    values[valuesById[3005314] = "MSGID_GAME_ACCOUNT_SVR_REQ_GOLD_NEWCHANGE"] = 3005314;
    values[valuesById[3005400] = "MSGID_GAME_STAT_SVR_PUSH_ROUND_INFO"] = 3005400;
    values[valuesById[3005401] = "MSGID_GAME_STAT_SVR_PUSH_TAX_INFO"] = 3005401;
    values[valuesById[3005402] = "MSGID_GAME_STAT_SVR_PUSH_ROBOT_GOLD_TAX_CHANGE"] = 3005402;
    values[valuesById[3005403] = "MSGID_GAME_STAT_SVR_PUSH_ONLINE_STATISTICS"] = 3005403;
    values[valuesById[3005404] = "MSGID_GAME_STAT_SVR_REQ_CHECK_NEWPLAYER"] = 3005404;
    values[valuesById[3005405] = "MSGID_GAME_STATT_SVR_ACK_CHECK_NEWPLAYER"] = 3005405;
    values[valuesById[3005406] = "MSGID_GAME_STAT_SVR_PUSH_BIG_POKER_WAR_LOG"] = 3005406;
    values[valuesById[3005407] = "MSGID_GAME_STAT_SVR_PUSH_BIG_BATTLE_LOG"] = 3005407;
    values[valuesById[3006000] = "MSGID_GAME_SVR_MSGID_END"] = 3006000;
    values[valuesById[3006001] = "MSGID_DESK_BOTCENTER_SVR_MSGID_BEGIN"] = 3006001;
    values[valuesById[3006002] = "MSGID_DESK_BOTCENTER_SVR_REQ_GET_ROBOT"] = 3006002;
    values[valuesById[3006003] = "MSGID_DESK_BOTCENTER_SVR_ACK_GET_ROBOT"] = 3006003;
    values[valuesById[3006004] = "MSGID_DESK_BOTCENTER_SVR_REQ_ROBOT_RECYCLE"] = 3006004;
    values[valuesById[3006100] = "MSGID_DESK_BOTCENTER_MSGID_END"] = 3006100;
    values[valuesById[3006101] = "MSGID_ACCOUNT_ONLINE_SVR_MSGID_BEGIN"] = 3006101;
    values[valuesById[3006102] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_GOLD_CHANGE"] = 3006102;
    values[valuesById[3006103] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_LIGHT"] = 3006103;
    values[valuesById[3006104] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_USER_PAY"] = 3006104;
    values[valuesById[3006105] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYS_MGS"] = 3006105;
    values[valuesById[3006106] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_MODIFY_HEAD"] = 3006106;
    values[valuesById[3006107] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_SYNC_REBATE"] = 3006107;
    values[valuesById[3006108] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_TRANS_MSG"] = 3006108;
    values[valuesById[3006109] = "MSGID_ACCOUNT_ONLINE_SVR_PUSH_MAIL_UPDATE_MSG"] = 3006109;
    values[valuesById[3006300] = "MSGID_ACCOUNT_ONLINE_SVR_MSGID_END"] = 3006300;
    values[valuesById[3007000] = "MSGID_DESK_TEEN_PATTI_SVR_MSGID_BEGIN"] = 3007000;
    values[valuesById[3007001] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_ASEETINFO"] = 3007001;
    values[valuesById[3007002] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_STARTGAME"] = 3007002;
    values[valuesById[3007003] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_OPER_TIPS"] = 3007003;
    values[valuesById[3007004] = "MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_CMD"] = 3007004;
    values[valuesById[3007005] = "MSGID_DESK_TEEN_PATTI_SVR_ACK_OPER_CMD"] = 3007005;
    values[valuesById[3007006] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_COMP_RESULT"] = 3007006;
    values[valuesById[3007007] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAMERESULT"] = 3007007;
    values[valuesById[3007008] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_LACK_ASEET"] = 3007008;
    values[valuesById[3007009] = "MSGID_DESK_TEEN_PATTI_SVR_REQ_WAIT_CHARGE"] = 3007009;
    values[valuesById[3007010] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_PLAYINGINFO"] = 3007010;
    values[valuesById[3007011] = "MSGID_DESK_TEEN_PATTI_SVR_REQ_OPER_COMPARE"] = 3007011;
    values[valuesById[3007012] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_GAME_RULE"] = 3007012;
    values[valuesById[3007013] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_HANDCARDINFO"] = 3007013;
    values[valuesById[3007014] = "MSGID_DESK_TEEN_PATTI_SVR_REQ_RECORD_CMD"] = 3007014;
    values[valuesById[3007015] = "MSGID_DESK_TEEN_PATTI_SVR_ACK_RECORD_CMD"] = 3007015;
    values[valuesById[3007016] = "MSGID_DESK_TEEN_PATTI_SVR_REQ_CANCEL_CHARGE"] = 3007016;
    values[valuesById[3007017] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_AIDATA"] = 3007017;
    values[valuesById[3007018] = "MSGID_DESK_TEEN_PATTI_SVR_PUSH_CHARGE"] = 3007018;
    values[valuesById[3007049] = "MSGID_DESK_TEEN_PATTI_SVR_TEST_REQ"] = 3007049;
    values[valuesById[3007050] = "MSGID_DESK_TEEN_PATTI_SVR_MSGID_END"] = 3007050;
    values[valuesById[3007051] = "MSGID_DESK_RUMMY_SVR_MSGID_BEGIN"] = 3007051;
    values[valuesById[3007052] = "MSGID_DESK_RUMMY_SVR_PUSH_DEALCARD"] = 3007052;
    values[valuesById[3007053] = "MSGID_DESK_RUMMY_SVR_PUSH_PUBLIC_CARD"] = 3007053;
    values[valuesById[3007054] = "MSGID_DESK_RUMMY_SVR_PUSH_MAGIC_CARD"] = 3007054;
    values[valuesById[3007055] = "MSGID_DESK_RUMMY_SVR__REQ_COMMAND"] = 3007055;
    values[valuesById[3007056] = "MSGID_DESK_RUMMY_SVR__ACK_COMMAND"] = 3007056;
    values[valuesById[3007057] = "MSGID_DESK_RUMMY_SVR_PUSH_STARTGAME"] = 3007057;
    values[valuesById[3007058] = "MSGID_DESK_RUMMY_SVR_PUSH_COMMAND"] = 3007058;
    values[valuesById[3007059] = "MSGID_DESK_RUMMY_SVR_PUSH_PLAYINGINFO"] = 3007059;
    values[valuesById[3007060] = "MSGID_DESK_RUMMY_SVR_PUSH_GAMERESULT"] = 3007060;
    values[valuesById[3007061] = "MSGID_DESK_RUMMY_SVR_PUSH_CUR_USER"] = 3007061;
    values[valuesById[3007062] = "MSGID_DESK_RUMMY_SVR_PUSH_ASEET_INFO"] = 3007062;
    values[valuesById[3007063] = "MSGID_DESK_RUMMY_POOL_SVR_PUSH_ASEET_INFO"] = 3007063;
    values[valuesById[3007064] = "MSGID_DESK_RUMMY_POOL_SVR_PUSH_RULE_INFO"] = 3007064;
    values[valuesById[3007065] = "MSGID_DESK_RUMMY_POOL_SVR_PUSH_ROUND_INFO"] = 3007065;
    values[valuesById[3007066] = "MSGID_DESK_RUMMY_POOL_SVR__REQ_ROUND_INFO"] = 3007066;
    values[valuesById[3007067] = "MSGID_DESK_RUMMY_POOL_SVR_PUSH_PLAYER_GAME_END"] = 3007067;
    values[valuesById[3007068] = "MSGID_DESK_RUMMY_DEALES_SVR_PUSH_DEALER_CARD"] = 3007068;
    values[valuesById[3007069] = "MSGID_DESK_RUMMY_DEALES_SVR_REQ_RESULT"] = 3007069;
    values[valuesById[3007070] = "MSGID_DESK_RUMMY_DEALES_SVR_ACK_RESULT"] = 3007070;
    values[valuesById[3007071] = "MSGID_DESK_RUMMY_DEALES_SVR_PUSH_PLAYER_CNT"] = 3007071;
    values[valuesById[3007072] = "MSGID_DESK_RUMMY_DEALES_SVR_PUSH_GAME_END"] = 3007072;
    values[valuesById[3007073] = "MSGID_DESK_RUMMY_DEALES_SVR__REQ_GAME_END"] = 3007073;
    values[valuesById[3007074] = "MSGID_DESK_RUMMY_SVR_PUSH_SHUFFLE_CARDS"] = 3007074;
    values[valuesById[3007075] = "MSGID_DESK_RUMMY_SVR_PUSH_NEW_SEAT"] = 3007075;
    values[valuesById[3007076] = "MSGID_DESK_RUMMY_SVR_PUSH_NEW_SHOWCARD"] = 3007076;
    values[valuesById[3007077] = "MSGID_DESK_RUMMY_SVR_PUSH_MATCH_PARAM"] = 3007077;
    values[valuesById[3007078] = "MSGID_DESK_RUMMY_SVR_PUSH_HANDDATA"] = 3007078;
    values[valuesById[3007098] = "MSGID_DESK_RUMMY_SVR_SUPERDATA_REQ"] = 3007098;
    values[valuesById[3007099] = "MSGID_DESK_RUMMY_SVR_SUPERDATA_ACK"] = 3007099;
    values[valuesById[3007100] = "MSGID_DESK_rummy_SVR_MSGID_END"] = 3007100;
    values[valuesById[3007101] = "MSGID_Account_Agent_SVR_MSGID_BEGIN"] = 3007101;
    values[valuesById[3007102] = "MSGID_ACC_AGENT_SVR_PUSH_REBATE"] = 3007102;
    values[valuesById[3007200] = "MSGID_DESK_Agent_SVR_MSGID_END"] = 3007200;
    values[valuesById[3007201] = "MSGID_PROXY_AGENT_SVR_MSGID_BEGIN"] = 3007201;
    values[valuesById[3007202] = "MSGID_PROXY_AGENT_SVR_REQ_REBATE_RECORD"] = 3007202;
    values[valuesById[3007203] = "MSGID_PROXY_AGENT_SVR_ACK_REBATE_RECORD"] = 3007203;
    values[valuesById[3007204] = "MSGID_PROXY_AGENT_SVR_REQ_SET_AGENT"] = 3007204;
    values[valuesById[3007205] = "MSGID_PROXY_AGENT_SVR_ACK_SET_AGENT"] = 3007205;
    values[valuesById[3007206] = "MSGID_PROXY_AGENT_SVR_REQ_REBATE_BASIC_INFO"] = 3007206;
    values[valuesById[3007207] = "MSGID_PROXY_AGENT_SVR_ACK_REBATE_BASIC_INFO"] = 3007207;
    values[valuesById[3007208] = "MSGID_PROXY_AGENT_SVR_PUSH_PLAYER_LOGIN"] = 3007208;
    values[valuesById[3007300] = "MSGID_PROXY_AGENT_SVR_MSGID_END"] = 3007300;
    values[valuesById[3007301] = "MSGID_WEB_ONLINE_SVR_MSGID_BEGIN"] = 3007301;
    values[valuesById[3007302] = "MSGID_WEB_ONLINE_PUSH_SYS_MAIN"] = 3007302;
    values[valuesById[3007303] = "MSGID_WEB_ONLINE_PUSH_TRANS_MSG"] = 3007303;
    values[valuesById[3007304] = "MSGID_WEB_ONLINE_PUSH_TRANS_USER_MSG"] = 3007304;
    values[valuesById[3007400] = "MSGID_WEB_ONLINE_SVR_MSGID_END"] = 3007400;
    values[valuesById[3007401] = "MSGID_SRV_BASE_MSGID_BEGIN"] = 3007401;
    values[valuesById[3007402] = "MSGID_SRV_TO_SRV_REGISTER"] = 3007402;
    values[valuesById[3007500] = "MSGID_SRV_BASE_MSGID_END"] = 3007500;
    values[valuesById[3007501] = "MSGID_PROXY_MATCH_SVR_MSGID_BEGIN"] = 3007501;
    values[valuesById[3007502] = "MSGID_PROXY_MATCH_REQ_GET_TOURNEY"] = 3007502;
    values[valuesById[3007503] = "MSGID_PROXY_MATCH_ACK_GET_TOURNEY"] = 3007503;
    values[valuesById[3007700] = "MSGID_PROXY_MATCH_SVR_MSGID_END"] = 3007700;
    values[valuesById[3007701] = "MSGID_ACCOUNT_STATEMENT_SVR_MSGID_BEGIN"] = 3007701;
    values[valuesById[3007702] = "MSGID_ACCOUNT_STATEMENT_PUSH_GOLD_CHANGE"] = 3007702;
    values[valuesById[3007703] = "MSGID_ACCOUNT_STATEMENT_LOGIN_SUCCESS"] = 3007703;
    values[valuesById[3007704] = "MSGID_ACCOUNT_STATEMENT_REQ_GAME_RECORD"] = 3007704;
    values[valuesById[3007705] = "MSGID_ACCOUNT_STATEMENT_ACK_GAME_RECORD"] = 3007705;
    values[valuesById[3007799] = "MSGID_ACCOUNT_STATEMENT_SVR_MSGID_END"] = 3007799;
    values[valuesById[3007800] = "MSGID_DESK_TREASURE_SVR_MSGID_BEGIN"] = 3007800;
    values[valuesById[3007801] = "MSGID_DESK_TREASURE_SVR_PARTICIPATION_REQ"] = 3007801;
    values[valuesById[3007802] = "MSGID_DESK_TREASURE_SVR_PARTICIPATION_ACK"] = 3007802;
    values[valuesById[3007803] = "MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_REQ"] = 3007803;
    values[valuesById[3007804] = "MSGID_DESK_TREASURE_SVR_PLAYER_PARTICIPATION_ACK"] = 3007804;
    values[valuesById[3007805] = "MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_REQ"] = 3007805;
    values[valuesById[3007806] = "MSGID_DESK_TREASURE_SVR_PAST_PARTICIPATION_ACK"] = 3007806;
    values[valuesById[3007807] = "MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_REQ"] = 3007807;
    values[valuesById[3007808] = "MSGID_DESK_TREASURE_SVR_QUERY_NUMBER_ACK"] = 3007808;
    values[valuesById[3007809] = "MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_REQ"] = 3007809;
    values[valuesById[3007810] = "MSGID_DESK_TREASURE_SVR_QUERY_LOTTERY_INFO_ACK"] = 3007810;
    values[valuesById[3007811] = "MSGID_DESK_TREASURE_SVR_BUY_TICKET_REQ"] = 3007811;
    values[valuesById[3007812] = "MSGID_DESK_TREASURE_SVR_BUY_TICKET_ACK"] = 3007812;
    values[valuesById[3007813] = "MSGID_DESK_TREASURE_SVR_PUSH_RESULT_TIMEOUT"] = 3007813;
    values[valuesById[3007814] = "MSGID_DESK_TREASURE_SVR_PUSH_RESULT"] = 3007814;
    values[valuesById[3007815] = "MSGID_DESK_TREASURE_SVR_PUSH_ALL_TYPE"] = 3007815;
    values[valuesById[3007900] = "MSGID_DESK_TREASURE_SVR_MSGID_END"] = 3007900;
    values[valuesById[3007901] = "MSGID_GATE_PROXY_SVR_BEGIN"] = 3007901;
    values[valuesById[3007902] = "MSGID_GATE_PROXY_SVR_REGISTER"] = 3007902;
    values[valuesById[3007903] = "MSGID_GATE_PROXY_SVR_UPDATE_INFO"] = 3007903;
    values[valuesById[3007904] = "MSGID_GATE_PROXY_SVR_PUSH_SYS_MAIN"] = 3007904;
    values[valuesById[3007930] = "MSGID_GATE_PROXY_SVR_END"] = 3007930;
    values[valuesById[3007931] = "MSGID_ONLINE_STAT_SVR_MSGID_BEGIN"] = 3007931;
    values[valuesById[3007932] = "MSGID_ONLINE_STAT_SVR_PUSH_ONLINE_PLAYER"] = 3007932;
    values[valuesById[3007960] = "MSGID_ONLINE_STAT_SVR_MSGID_END"] = 3007960;
    values[valuesById[3007961] = "MSGID_PROXY_BONUS_SVR_MSGID_BEGIN"] = 3007961;
    values[valuesById[3007962] = "MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN_CONFIG"] = 3007962;
    values[valuesById[3007963] = "MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN_CONFIG"] = 3007963;
    values[valuesById[3007964] = "MSGID_PROXY_BONUS_SVR_REQ_DAILY_CHECKIN"] = 3007964;
    values[valuesById[3007965] = "MSGID_PROXY_BONUS_SVR_ACK_DAILY_CHECKIN"] = 3007965;
    values[valuesById[3007966] = "MSGID_PROXY_BONUS_SVR_REQ_GET_CUMULATIVE_DAYS"] = 3007966;
    values[valuesById[3007967] = "MSGID_PROXY_BONUS_SVR_ACK_GET_CUMULATIVE_DAYS"] = 3007967;
    values[valuesById[3007968] = "MSGID_PROXY_BONUS_SVR_REQ_INVITE_DATA"] = 3007968;
    values[valuesById[3007969] = "MSGID_PROXY_BONUS_SVR_ACK_INVITE_DATA"] = 3007969;
    values[valuesById[3007970] = "MSGID_PROXY_BONUS_SVR_REQ_INVITE_GOLD"] = 3007970;
    values[valuesById[3007971] = "MSGID_PROXY_BONUS_SVR_ACK_INVITE_GOLD"] = 3007971;
    values[valuesById[3007972] = "MSGID_PROXY_BONUS_SVR_REQ_INVITE_TASKSTATUS"] = 3007972;
    values[valuesById[3007973] = "MSGID_PROXY_BONUS_SVR_ACK_INVITE_TASKSTATUS"] = 3007973;
    values[valuesById[3007974] = "MSGID_PROXY_BONUS_SVR_REQ_INVITE_ADDGOLD"] = 3007974;
    values[valuesById[3007975] = "MSGID_PROXY_BONUS_SVR_ACK_INVITE_ADDGOLD"] = 3007975;
    values[valuesById[3007976] = "MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_REQ"] = 3007976;
    values[valuesById[3007977] = "MSGID_PROXY_BONUS_SVR_LUCKYSPINGET_ACK"] = 3007977;
    values[valuesById[3007978] = "MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_REQ"] = 3007978;
    values[valuesById[3007979] = "MSGID_PROXY_BONUS_SVR_LUCKYSPINPLAY_ACK"] = 3007979;
    values[valuesById[3008000] = "MSGID_PROXY_BONUS_SVR_MSGID_END"] = 3008000;
    values[valuesById[3008001] = "MSGID_BONUS_ACCOUNT_SVR_MSGID_BEGIN"] = 3008001;
    values[valuesById[3008002] = "MSGID_BONUS_ACCOUNT_PUSH_BONUS"] = 3008002;
    values[valuesById[3008100] = "MSGID_BONUS_ACCOUNT_SVR_MSGID_END"] = 3008100;
    values[valuesById[3008101] = "MSGID_DESK_BIGBATTLE_SVR_MSGID_BEGIN"] = 3008101;
    values[valuesById[3008102] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_ASEETINFO"] = 3008102;
    values[valuesById[3008103] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_RULE"] = 3008103;
    values[valuesById[3008104] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYINGINFO"] = 3008104;
    values[valuesById[3008105] = "MSGID_CLIENT_BIGBATTLE_SVR_REQ_BET"] = 3008105;
    values[valuesById[3008106] = "MSGID_CLIENT_BIGBATTLE_SVR_ACK_BET"] = 3008106;
    values[valuesById[3008107] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_GAME_CARD"] = 3008107;
    values[valuesById[3008108] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_GAMERESULT"] = 3008108;
    values[valuesById[3008109] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_PLAYER_RAND"] = 3008109;
    values[valuesById[3008110] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_TREND"] = 3008110;
    values[valuesById[3008111] = "MSGID_BOT_BIGBATTLE_SVR_PUSH_BET_TIPS"] = 3008111;
    values[valuesById[3008112] = "MSGID_DESK_BIGBATTLE_SVR_PUSH_LUCKY_STAR"] = 3008112;
    values[valuesById[3008200] = "MSGID_DESK_BIGBATTLE_SVR_MSGID_END"] = 3008200;
    values[valuesById[3008201] = "MSGID_DESK_POKER_WAR_SVR_MSGID_BEGIN"] = 3008201;
    values[valuesById[3008202] = "MSGID_DESK_POKER_WAR_SVR_PUSH_ASEETINFO"] = 3008202;
    values[valuesById[3008203] = "MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_RULE"] = 3008203;
    values[valuesById[3008204] = "MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYINGINFO"] = 3008204;
    values[valuesById[3008205] = "MSGID_CLIENT_POKER_WAR_SVR_REQ_BET"] = 3008205;
    values[valuesById[3008206] = "MSGID_CLIENT_POKER_WAR_SVR_ACK_BET"] = 3008206;
    values[valuesById[3008207] = "MSGID_DESK_POKER_WAR_SVR_PUSH_GAME_CARD"] = 3008207;
    values[valuesById[3008208] = "MSGID_DESK_POKER_WAR_SVR_PUSH_GAMERESULT"] = 3008208;
    values[valuesById[3008209] = "MSGID_DESK_POKER_WAR_SVR_PUSH_PLAYER_RAND"] = 3008209;
    values[valuesById[3008210] = "MSGID_DESK_POKER_WAR_SVR_PUSH_TREND"] = 3008210;
    values[valuesById[3008211] = "MSGID_DESK_POKER_WAR_SVR_PUSH_LUCKY_STAR"] = 3008211;
    values[valuesById[3008212] = "MSGID_BOT_POKER_WAR_SVR_PUSH_BET_TIPS"] = 3008212;
    values[valuesById[3008250] = "MSGID_DESK_POKER_WAR_SVR_MSGID_END"] = 3008250;
    values[valuesById[3014101] = "MSGID_DESK_MINESWEEPER_SVR_MSGID_BEGIN"] = 3014101;
    values[valuesById[3014102] = "MSGID_DESK_MINESWEEPER_SVR_PUSH_ASEETINFO"] = 3014102;
    values[valuesById[3014103] = "MSGID_DESK_MINESWEEPER_SVR_PUSH_GAME_RULE"] = 3014103;
    values[valuesById[3014104] = "MSGID_DESK_MINESWEEPER_SVR_PUSH_PLAYINGINFO"] = 3014104;
    values[valuesById[3014105] = "MSGID_CLIENT_MINESWEEPER_SVR_REQ_BET"] = 3014105;
    values[valuesById[3014106] = "MSGID_CLIENT_MINESWEEPER_SVR_ACK_BET"] = 3014106;
    values[valuesById[3014107] = "MSGID_CLIENT_MINESWEEPER_SVR_REQ_FLOP"] = 3014107;
    values[valuesById[3014108] = "MSGID_CLIENT_MINESWEEPER_SVR_ACK_FLOP"] = 3014108;
    values[valuesById[3014109] = "MSGID_DESK_MINESWEEPER_SVR_PUSH_GAMERESULT"] = 3014109;
    values[valuesById[3014110] = "MSGID_CLIENT_MINESWEEPER_SVR_REQ_ENDFLOP"] = 3014110;
    values[valuesById[3014111] = "MSGID_CLIENT_MINESWEEPER_SVR_ACK_ENDFLOP"] = 3014111;
    values[valuesById[3014200] = "MSGID_DESK_MINESWEEPER_SVR_MSGID_END"] = 3014200;
    values[valuesById[3016101] = "MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_BEGIN"] = 3016101;
    values[valuesById[3016102] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_ASEETINFO"] = 3016102;
    values[valuesById[3016103] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_RULE"] = 3016103;
    values[valuesById[3016104] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYINGINFO"] = 3016104;
    values[valuesById[3016105] = "MSGID_CLIENT_WHEELOFFORTURE_SVR_REQ_BET"] = 3016105;
    values[valuesById[3016106] = "MSGID_CLIENT_WHEELOFFORTURE_SVR_ACK_BET"] = 3016106;
    values[valuesById[3016107] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAME_CARD"] = 3016107;
    values[valuesById[3016108] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_GAMERESULT"] = 3016108;
    values[valuesById[3016109] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_PLAYER_RAND"] = 3016109;
    values[valuesById[3016110] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_TREND"] = 3016110;
    values[valuesById[3016111] = "MSGID_BOT_WHEELOFFORTURE_SVR_PUSH_BET_TIPS"] = 3016111;
    values[valuesById[3016112] = "MSGID_DESK_WHEELOFFORTURE_SVR_PUSH_LUCKY_STAR"] = 3016112;
    values[valuesById[3016130] = "MSGID_WHEELOFFORTURE_GAME_DATA_SVR_REQ_STOCK_CHANGE"] = 3016130;
    values[valuesById[3016131] = "MSGID_WHEELOFFORTURE_GAME_DATA_SVR_ACK_STOCK_CHANGE"] = 3016131;
    values[valuesById[3016132] = "MSGID_GAME_STAT_SVR_PUSH_WHEELOFFORTURE_LOG"] = 3016132;
    values[valuesById[3016200] = "MSGID_DESK_WHEELOFFORTURE_SVR_MSGID_END"] = 3016200;
    values[valuesById[3018101] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_BEGIN"] = 3018101;
    values[valuesById[3018102] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_ASEETINFO"] = 3018102;
    values[valuesById[3018103] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAME_RULE"] = 3018103;
    values[valuesById[3018104] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_PLAYINGINFO"] = 3018104;
    values[valuesById[3018105] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_PUSH_GAMERESULT"] = 3018105;
    values[valuesById[3018106] = "MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_REQ_BET"] = 3018106;
    values[valuesById[3018107] = "MSGID_CLIENT_GATES_OF_OLYMPUS_SVR_ACK_BET"] = 3018107;
    values[valuesById[3018200] = "MSGID_DESK_GATES_OF_OLYMPUS_SVR_MSGID_END"] = 3018200;
    values[valuesById[3018201] = "MSGID_DESK_SUPER_ACE_SVR_PUSH_BEGIN"] = 3018201;
    values[valuesById[3018202] = "MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMERULE"] = 3018202;
    values[valuesById[3018203] = "MSGID_DESK_SUPER_ACE_SVR_REQ_PLAYBET"] = 3018203;
    values[valuesById[3018204] = "MSGID_DESK_SUPER_ACE_SVR_ACK_PLAYBET"] = 3018204;
    values[valuesById[3018205] = "MSGID_DESK_SUPER_ACE_SVR_PUSH_BETDATA"] = 3018205;
    values[valuesById[3018206] = "MSGID_DESK_SUPER_ACE_SVR_REQ_CARTOON"] = 3018206;
    values[valuesById[3018207] = "MSGID_DESK_SUPER_ACE_SVR_PUSH_GAMEEND"] = 3018207;
    values[valuesById[3018300] = "MSGID_DESK_SUPER_ACE_SVR_PUSH_END"] = 3018300;
    values[valuesById[3018301] = "MSGID_DESK_CASH_WHEEL_SVR_PUSH_BEGIN"] = 3018301;
    values[valuesById[3018302] = "MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMERULE"] = 3018302;
    values[valuesById[3018303] = "MSGID_DESK_CASH_WHEEL_SVR_REQ_PLAYBET"] = 3018303;
    values[valuesById[3018304] = "MSGID_DESK_CASH_WHEEL_SVR_ACK_PLAYBET"] = 3018304;
    values[valuesById[3018305] = "MSGID_DESK_CASH_WHEEL_SVR_PUSH_BETDATA"] = 3018305;
    values[valuesById[3018306] = "MSGID_DESK_CASH_WHEEL_SVR_REQ_CARTOON"] = 3018306;
    values[valuesById[3018307] = "MSGID_DESK_CASH_WHEEL_SVR_PUSH_GAMEEND"] = 3018307;
    values[valuesById[3018400] = "MSGID_DESK_CASH_WHEEL_SVR_PUSH_END"] = 3018400;
    values[valuesById[3018401] = "MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BEGIN"] = 3018401;
    values[valuesById[3018402] = "MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMERULE"] = 3018402;
    values[valuesById[3018403] = "MSGID_DESK_FORTUNE_TIGER_SVR_REQ_PLAYBET"] = 3018403;
    values[valuesById[3018404] = "MSGID_DESK_FORTUNE_TIGER_SVR_ACK_PLAYBET"] = 3018404;
    values[valuesById[3018405] = "MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_BETDATA"] = 3018405;
    values[valuesById[3018406] = "MSGID_DESK_FORTUNE_TIGER_SVR_REQ_CARTOON"] = 3018406;
    values[valuesById[3018407] = "MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_GAMEEND"] = 3018407;
    values[valuesById[3018408] = "MSGID_DESK_FORTUNE_TIGER_SVR_REQ_JACKPOT"] = 3018408;
    values[valuesById[3018500] = "MSGID_DESK_FORTUNE_TIGER_SVR_PUSH_END"] = 3018500;
    values[valuesById[3018501] = "MSGID_DESK_THUNDER_SVR_PUSH_BEGIN"] = 3018501;
    values[valuesById[3018502] = "MSGID_DESK_THUNDER_SVR_PUSH_GAMERULE"] = 3018502;
    values[valuesById[3018503] = "MSGID_DESK_THUNDER_SVR_REQ_PLAYBET"] = 3018503;
    values[valuesById[3018504] = "MSGID_DESK_THUNDER_SVR_ACK_PLAYBET"] = 3018504;
    values[valuesById[3018505] = "MSGID_DESK_THUNDE_SVR_PUSH_BETDATA"] = 3018505;
    values[valuesById[3018506] = "MSGID_DESK_THUNDER_SVR_REQ_CARTOON"] = 3018506;
    values[valuesById[3018507] = "MSGID_DESK_THUNDER_SVR_PUSH_GAMEEND"] = 3018507;
    values[valuesById[3018508] = "MSGID_DESK_THUNDER_SVR_REQ_JACKPOT"] = 3018508;
    values[valuesById[3018509] = "MSGID_DESK_THUNDER_SVR_ACK_JACKPOT"] = 3018509;
    values[valuesById[3018600] = "MSGID_DESK_THUNDER_SVR_PUSH_END"] = 3018600;
    values[valuesById[3018601] = "MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BEGIN"] = 3018601;
    values[valuesById[3018602] = "MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMERULE"] = 3018602;
    values[valuesById[3018603] = "MSGID_DESK_FORTUNEGEMS3_SVR_REQ_PLAYBET"] = 3018603;
    values[valuesById[3018604] = "MSGID_DESK_FORTUNEGEMS3_SVR_ACK_PLAYBET"] = 3018604;
    values[valuesById[3018605] = "MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_BETDATA"] = 3018605;
    values[valuesById[3018606] = "MSGID_DESK_FORTUNEGEMS3_SVR_REQ_CARTOON"] = 3018606;
    values[valuesById[3018607] = "MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_GAMEEND"] = 3018607;
    values[valuesById[3018700] = "MSGID_DESK_FORTUNEGEMS3_SVR_PUSH_END"] = 3018700;
    values[valuesById[2000000] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_BEGIN"] = 2000000;
    values[valuesById[2000003] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_PLAYGAMEDATA_INF"] = 2000003;
    values[valuesById[2000004] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_NOCHARGEPLAY_INF"] = 2000004;
    values[valuesById[2000005] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_CHARGEPLAY_INF"] = 2000005;
    values[valuesById[2000008] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_LINELIGHTDATA_INF"] = 2000008;
    values[valuesById[2000009] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_REQ"] = 2000009;
    values[valuesById[2000010] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_DATA_ACK"] = 2000010;
    values[valuesById[2000011] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_JACKPOT_RECORD_INF"] = 2000011;
    values[valuesById[2000999] = "MSGID_OTHER_PUBLIC_ROUTE_GAMEDATA_END"] = 2000999;
    values[valuesById[2001000] = "MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_BEGIN"] = 2001000;
    values[valuesById[2001999] = "MSGID_OTHER_FBLOGIN_ROUTE_GAMEDATA_END"] = 2001999;
    values[valuesById[2002000] = "MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_BEGIN"] = 2002000;
    values[valuesById[2002999] = "MSGID_OTHER_ACCOUNT_ROUTE_GAMEDATA_END"] = 2002999;
    values[valuesById[2003000] = "MSGID_OTHER_PROXY_ROUTE_GAMEDATA_BEGIN"] = 2003000;
    values[valuesById[2003999] = "MSGID_OTHER_PROXY_ROUTE_GAMEDATA_END"] = 2003999;
    values[valuesById[2004000] = "MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_BEGIN"] = 2004000;
    values[valuesById[2004999] = "MSGID_OTHER_SMSLOGIN_ROUTE_GAMEDATA_END"] = 2004999;
    values[valuesById[2081000] = "MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_BEGIN"] = 2081000;
    values[valuesById[2081002] = "MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_EVENTMUNBER_INF"] = 2081002;
    values[valuesById[2081999] = "MSGID_OTHER_RUMMYPOINT_ROUTE_GAMEDATA_END"] = 2081999;
    values[valuesById[2082000] = "MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_BEGIN"] = 2082000;
    values[valuesById[2082001] = "MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_EVENTMUNBER_INF"] = 2082001;
    values[valuesById[2082999] = "MSGID_OTHER_RUMMYPOOL_ROUTE_GAMEDATA_END"] = 2082999;
    values[valuesById[2083000] = "MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_BEGIN"] = 2083000;
    values[valuesById[2083999] = "MSGID_OTHER_RUMMYDEALES_ROUTE_GAMEDATA_END"] = 2083999;
    values[valuesById[2084000] = "MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_BEGIN"] = 2084000;
    values[valuesById[2084999] = "MSGID_OTHER_RUMMYTEN_ROUTE_GAMEDATA_END"] = 2084999;
    values[valuesById[2085000] = "MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_BEGIN"] = 2085000;
    values[valuesById[2085002] = "MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_EVENTMUNBER_INF"] = 2085002;
    values[valuesById[2085999] = "MSGID_OTHER_TEENPATTI_ROUTE_GAMEDATA_END"] = 2085999;
    values[valuesById[2086000] = "MSGID_OTHER_POKER_ROUTE_GAMEDATA_BEGIN"] = 2086000;
    values[valuesById[2086999] = "MSGID_OTHER_POKER_ROUTE_GAMEDATA_END"] = 2086999;
    values[valuesById[2087000] = "MSGID_OTHER_WEB_ROUTE_GAMEDATA_BEGIN"] = 2087000;
    values[valuesById[2087001] = "MSGID_OTHER_WEB_ROUTE_GAMEDATA_REDCHERRYPLAN_INF"] = 2087001;
    values[valuesById[2087002] = "MSGID_OTHER_WEB_ROUTE_GAMEDATA_THREETERMINAL_INF"] = 2087002;
    values[valuesById[2087999] = "MSGID_OTHER_WEB_ROUTE_GAMEDATA_END"] = 2087999;
    values[valuesById[2088000] = "MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BEGIN"] = 2088000;
    values[valuesById[2088001] = "MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_ACTIVITY"] = 2088001;
    values[valuesById[2088002] = "MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_BROKEDATA"] = 2088002;
    values[valuesById[2088999] = "MSGID_OTHER_GAMESVR_ROUTE_PROXYSVR_END"] = 2088999;
    return values;
})();

export { $root as default };
